import { jsxs as s, jsx as h } from "react/jsx-runtime";
const e = (c) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 148 36",
    ...c,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "url(#realforce_advertising_svg__a)",
          d: "M0 13.5C0 6.044 6.044 0 13.5 0h9C29.956 0 36 6.044 36 13.5v9C36 29.956 29.956 36 22.5 36h-9C6.044 36 0 29.956 0 22.5z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "url(#realforce_advertising_svg__b)",
          fillRule: "evenodd",
          d: "M11.189 7.297a3.892 3.892 0 0 0-3.892 3.892v3.892c0 1.075.871 1.946 1.946 1.946H18a1.946 1.946 0 0 0 1.946-1.946V9.243A1.946 1.946 0 0 0 18 7.297h-6.811M9.243 18.973a1.946 1.946 0 0 0-1.946 1.946v3.892a3.892 3.892 0 0 0 3.892 3.892h.973a1.946 1.946 0 0 0 1.946-1.946v-5.838a1.946 1.946 0 0 0-1.946-1.946h-2.92m6.81 1.946c0-1.075.872-1.946 1.947-1.946h8.756c1.075 0 1.946.871 1.946 1.946v3.892a3.892 3.892 0 0 1-3.892 3.892H18a1.946 1.946 0 0 1-1.946-1.946v-5.838m7.785-13.622a1.946 1.946 0 0 0-1.946 1.946v5.838c0 1.075.871 1.946 1.946 1.946h2.919a1.946 1.946 0 0 0 1.946-1.946V11.19a3.892 3.892 0 0 0-3.892-3.892h-.973",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ h("g", { fill: "#A1AAC7", clipPath: "url(#realforce_advertising_svg__c)", children: /* @__PURE__ */ h("path", { d: "M62.978 4.287a3.195 3.195 0 0 0-1.246-1.305c-.542-.327-1.21-.49-2.003-.49a3.68 3.68 0 0 0-3.25 1.87c-.333.578-.497 1.23-.497 1.98 0 .72.156 1.365.475 1.951A3.638 3.638 0 0 0 57.8 9.695c.311.186.653.327 1.016.408.32.074.668.111 1.031.111.364 0 .705-.037 1.032-.11.348-.082.675-.208.971-.387.572-.333.972-.771 1.195-1.305l-1.632-.772a1.61 1.61 0 0 1-.601.601c-.26.149-.572.215-.935.215-.497 0-.905-.14-1.224-.422-.319-.282-.505-.653-.556-1.106h5.2c.037-.096.06-.222.074-.363.015-.141.022-.282.022-.43a3.805 3.805 0 0 0-.415-1.848m-4.83 1.232c.097-.423.29-.75.564-.972a1.571 1.571 0 0 1 1.017-.341c.415 0 .764.126 1.03.37.275.245.431.564.476.943h-3.087M70.01 3.76a2.57 2.57 0 0 0-1.097-.934c-.475-.23-1.009-.342-1.625-.342-.764 0-1.446.186-2.025.535a2.738 2.738 0 0 0-1.187 1.454l1.595.779c.126-.327.326-.587.594-.78.274-.2.586-.296.934-.296.371 0 .66.096.883.282a.904.904 0 0 1 .327.697v.23l-1.966.326c-.868.149-1.514.416-1.937.824-.422.408-.638.92-.638 1.536 0 .667.23 1.186.683 1.565.208.17.438.304.705.393.334.119.712.178 1.135.178.4 0 .779-.06 1.12-.178.4-.141.764-.37 1.046-.675v.66h1.84V5.155a2.452 2.452 0 0 0-.386-1.395M68.409 7.1c0 .445-.155.83-.452 1.15-.312.319-.712.467-1.21.467-.251 0-.46-.067-.63-.193a.624.624 0 0 1-.26-.527c0-.244.075-.423.23-.556.156-.134.379-.223.66-.282l1.67-.297V7.1h-.007M71.494.207v9.792h1.928V.207h-1.928ZM77.095 1.624c.252-.185.586-.282.979-.282.052 0 .126 0 .222.008.097.007.186.014.238.03V.28c-.082-.015-.186-.037-.297-.044a2.744 2.744 0 0 0-1.588.267 2.323 2.323 0 0 0-.905.83c-.222.372-.34.81-.34 1.343v.475h-.876v1.18h.875v5.675h1.313V4.332h1.751v-1.18h-1.75v-.571c0-.445.125-.771.378-.957M85.93 4.369a3.711 3.711 0 0 0-1.38-1.373 3.87 3.87 0 0 0-1.959-.504c-.734 0-1.387.17-1.973.504a3.606 3.606 0 0 0-1.38 1.373 3.87 3.87 0 0 0-.511 1.973c0 .735.17 1.402.519 1.988a3.807 3.807 0 0 0 1.387 1.38c.275.156.564.275.868.364.341.096.712.14 1.09.14.371 0 .742-.044 1.076-.14.297-.082.586-.2.853-.357a3.75 3.75 0 0 0 1.395-1.372c.349-.579.527-1.254.527-1.995 0-.742-.178-1.41-.512-1.981m-1.195 3.323c-.215.4-.519.705-.89.935-.37.23-.794.349-1.254.349-.467 0-.897-.119-1.268-.349a2.585 2.585 0 0 1-.898-.935 2.72 2.72 0 0 1-.334-1.35c0-.504.112-.95.334-1.343.223-.393.527-.697.898-.927.37-.23.801-.341 1.269-.341.46 0 .882.111 1.253.341.371.23.675.542.89.927.216.394.327.839.327 1.343 0 .497-.111.957-.327 1.35M90.463 2.588c-.43 0-.787.075-1.09.216a1.7 1.7 0 0 0-.728.645v-.794H87.28V10h1.365V5.578c0-.579.156-1.031.468-1.343.319-.319.727-.474 1.239-.474h.638V2.58l-.527.007M92.963 9.725a3.584 3.584 0 0 1-1.335-1.387 4.077 4.077 0 0 1-.482-1.981c0-.742.163-1.402.482-1.988a3.544 3.544 0 0 1 1.335-1.373c.564-.333 1.217-.504 1.944-.504.49 0 .95.082 1.372.252.423.17.801.408 1.12.712a3.1 3.1 0 0 1 .72 1.024l-1.15.55a2.14 2.14 0 0 0-.808-.936c-.356-.244-.78-.363-1.247-.363-.452 0-.868.119-1.231.341-.364.23-.653.542-.868.927-.215.394-.32.846-.32 1.358 0 .497.105.935.32 1.335.208.4.497.712.868.935.363.23.779.341 1.231.341.475 0 .905-.118 1.254-.363a2.36 2.36 0 0 0 .801-.965l1.15.579c-.156.378-.393.72-.712 1.016a3.422 3.422 0 0 1-1.12.72c-.43.178-.89.26-1.38.26-.727.007-1.373-.156-1.944-.49M100.552 9.718a3.547 3.547 0 0 1-1.32-1.388c-.32-.586-.483-1.246-.483-1.988s.156-1.402.475-1.98a3.572 3.572 0 0 1 1.291-1.365c.541-.334 1.157-.498 1.854-.498.735 0 1.365.171 1.892.512.519.342.92.772 1.194 1.313a3.754 3.754 0 0 1 .349 2.411h-5.705c.015.475.141.883.364 1.232.222.349.512.616.868.801a2.44 2.44 0 0 0 1.15.282c.497 0 .912-.111 1.253-.341.342-.23.616-.527.831-.876l1.076.55c-.23.511-.623.941-1.187 1.305-.564.356-1.224.534-1.996.534-.697 0-1.335-.17-1.906-.504m.349-5.49c-.423.356-.683.846-.772 1.469h4.34a1.973 1.973 0 0 0-.304-1.039 1.97 1.97 0 0 0-.757-.705 2.05 2.05 0 0 0-1.031-.26 2.23 2.23 0 0 0-1.476.535M50.077 4.918h2.077a1.424 1.424 0 0 0 1.068-.475 1.334 1.334 0 0 0-.059-1.847 1.362 1.362 0 0 0-.964-.4h-2.122v2.722L48 7.15V.207h4.384a3.417 3.417 0 0 1 2.293 5.838c-.305.304-.66.542-1.061.72l2.1 3.234h-2.352l-3.287-5.081" }) }),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "#fff",
          d: "m48 31.833 4.626-13.41h3.168l4.626 13.41h-2.664l-.954-2.88h-5.184l-.972 2.88zm4.32-5.04h3.78l-2.232-6.678h.684zM65.917 32.049c-.948 0-1.794-.222-2.538-.666a4.942 4.942 0 0 1-1.764-1.854c-.432-.78-.648-1.644-.648-2.592 0-.96.216-1.824.648-2.592a4.981 4.981 0 0 1 1.764-1.836 4.785 4.785 0 0 1 2.52-.684c.744 0 1.404.15 1.98.45.588.288 1.05.696 1.386 1.224l-.36.486v-5.778h2.358v13.626H69.03v-1.89l.252.468a3.329 3.329 0 0 1-1.404 1.224c-.6.276-1.254.414-1.962.414m.252-2.16c.54 0 1.014-.126 1.422-.378.408-.252.726-.6.954-1.044.24-.444.36-.954.36-1.53 0-.564-.12-1.068-.36-1.512a2.564 2.564 0 0 0-.954-1.062c-.408-.252-.882-.378-1.422-.378-.528 0-1.002.132-1.422.396-.42.252-.75.6-.99 1.044-.228.432-.342.936-.342 1.512s.114 1.086.342 1.53c.24.444.57.792.99 1.044.42.252.894.378 1.422.378M76.409 31.833l-3.852-9.792h2.574l2.79 7.704h-.954l2.808-7.704h2.574l-3.852 9.792h-2.088M88.12 32.049c-1.008 0-1.89-.228-2.646-.684a4.764 4.764 0 0 1-1.764-1.854c-.42-.78-.63-1.644-.63-2.592 0-.984.21-1.854.63-2.61a4.887 4.887 0 0 1 1.746-1.818 4.755 4.755 0 0 1 2.484-.666c.768 0 1.44.126 2.016.378.588.252 1.086.6 1.494 1.044.408.444.72.954.936 1.53.216.564.324 1.176.324 1.836 0 .168-.012.342-.036.522-.012.18-.042.336-.09.468h-7.56v-1.8h6.228l-1.116.846c.108-.552.078-1.044-.09-1.476a2.046 2.046 0 0 0-.792-1.026c-.36-.252-.798-.378-1.314-.378-.492 0-.93.126-1.314.378-.384.24-.678.6-.882 1.08-.192.468-.264 1.038-.216 1.71-.048.6.03 1.134.234 1.602.216.456.528.81.936 1.062.42.252.9.378 1.44.378.54 0 .996-.114 1.368-.342.384-.228.684-.534.9-.918l1.908.936a3.335 3.335 0 0 1-.9 1.242 4.48 4.48 0 0 1-1.458.846 5.262 5.262 0 0 1-1.836.306M94.498 31.833v-9.792h2.214v2.178l-.18-.324c.228-.732.582-1.242 1.062-1.53.492-.288 1.08-.432 1.764-.432h.576v2.088h-.846c-.672 0-1.212.21-1.62.63-.408.408-.612.984-.612 1.728v5.454h-2.358M105.958 31.941c-1.104 0-1.962-.3-2.574-.9-.6-.612-.9-1.47-.9-2.574v-4.32h-1.692v-2.106h.18c.48 0 .852-.126 1.116-.378.264-.252.396-.618.396-1.098v-.756h2.358v2.232h2.25v2.106h-2.25v4.194c0 .324.054.6.162.828.12.228.3.402.54.522.252.12.57.18.954.18.084 0 .18-.006.288-.018l.342-.036v2.016c-.168.024-.36.048-.576.072a5.412 5.412 0 0 1-.594.036M108.929 31.833v-9.792h2.358v9.792zm0-10.89v-2.52h2.358v2.52zM117.19 32.049c-1.044 0-1.956-.246-2.736-.738a3.85 3.85 0 0 1-1.584-2.034l1.764-.846c.252.552.6.984 1.044 1.296.456.312.96.468 1.512.468.432 0 .774-.096 1.026-.288a.906.906 0 0 0 .378-.756.673.673 0 0 0-.162-.468 1.043 1.043 0 0 0-.414-.324 2.597 2.597 0 0 0-.558-.234l-1.602-.45c-.828-.24-1.458-.606-1.89-1.098a2.603 2.603 0 0 1-.63-1.746c0-.6.15-1.122.45-1.566.312-.456.738-.81 1.278-1.062.552-.252 1.182-.378 1.89-.378.924 0 1.74.222 2.448.666a3.652 3.652 0 0 1 1.512 1.872l-1.8.846a2.17 2.17 0 0 0-.846-1.062 2.348 2.348 0 0 0-1.332-.396c-.396 0-.708.09-.936.27a.853.853 0 0 0-.342.702c0 .18.048.336.144.468.096.132.228.24.396.324.18.084.384.162.612.234l1.566.468c.804.24 1.422.6 1.854 1.08.444.48.666 1.068.666 1.764 0 .588-.156 1.11-.468 1.566-.312.444-.744.792-1.296 1.044s-1.2.378-1.944.378M122.711 31.833v-9.792h2.358v9.792zm0-10.89v-2.52h2.358v2.52zM127.246 31.833v-9.792h2.214v1.926l-.18-.342c.228-.588.6-1.032 1.116-1.332.528-.312 1.14-.468 1.836-.468.72 0 1.356.156 1.908.468.564.312 1.002.75 1.314 1.314.312.552.468 1.194.468 1.926v6.3h-2.358v-5.742c0-.432-.084-.804-.252-1.116a1.765 1.765 0 0 0-.702-.72c-.288-.18-.63-.27-1.026-.27-.384 0-.726.09-1.026.27-.3.168-.534.408-.702.72-.168.312-.252.684-.252 1.116v5.742zM142.668 35.793c-.732 0-1.41-.12-2.034-.36a4.866 4.866 0 0 1-1.62-1.008 3.753 3.753 0 0 1-.972-1.494l2.196-.828c.144.456.426.822.846 1.098.432.288.96.432 1.584.432.48 0 .9-.09 1.26-.27.372-.18.66-.444.864-.792.204-.336.306-.744.306-1.224v-2.232l.45.54a3.351 3.351 0 0 1-1.35 1.332c-.564.3-1.206.45-1.926.45-.912 0-1.728-.21-2.448-.63a4.502 4.502 0 0 1-1.692-1.728c-.408-.732-.612-1.554-.612-2.466 0-.924.204-1.746.612-2.466a4.445 4.445 0 0 1 1.674-1.692c.708-.42 1.512-.63 2.412-.63.732 0 1.374.156 1.926.468.564.3 1.032.738 1.404 1.314l-.324.594v-2.16h2.232v9.306c0 .852-.21 1.614-.63 2.286a4.307 4.307 0 0 1-1.692 1.584c-.708.384-1.53.576-2.466.576m-.108-6.534c.504 0 .942-.108 1.314-.324a2.41 2.41 0 0 0 .9-.936c.216-.396.324-.852.324-1.368 0-.504-.114-.954-.342-1.35a2.38 2.38 0 0 0-.9-.954c-.372-.228-.804-.342-1.296-.342s-.936.114-1.332.342a2.467 2.467 0 0 0-.936.954 2.773 2.773 0 0 0-.324 1.35c0 .504.108.954.324 1.35.228.396.534.708.918.936.396.228.846.342 1.35.342"
        }
      ),
      /* @__PURE__ */ s("defs", { children: [
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "realforce_advertising_svg__a",
            x1: -0.112,
            x2: 36.112,
            y1: 0.113,
            y2: 35.887,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { stopColor: "#8839F6" }),
              /* @__PURE__ */ h("stop", { offset: 1, stopColor: "#2552EC" })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "realforce_advertising_svg__b",
            x1: 28.452,
            x2: 12.564,
            y1: 7.242,
            y2: 31.957,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { offset: 0.089, stopColor: "#fff" }),
              /* @__PURE__ */ h("stop", { offset: 1, stopColor: "#A3ACFF" })
            ]
          }
        ),
        /* @__PURE__ */ h("clipPath", { id: "realforce_advertising_svg__c", children: /* @__PURE__ */ h("path", { fill: "#fff", d: "M48 .207h57.871v10H48z" }) })
      ] })
    ]
  }
), l = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96v320a160.019 160.019 0 0 0 113.138-46.862 160.019 160.019 0 0 0 34.683-174.367 160.006 160.006 0 0 0-86.591-86.592A160.019 160.019 0 0 0 320 96M0 256l160.002 160 160.001-160L160.002 96zm480 0a160 160 0 0 0 160 160V96a160.002 160.002 0 0 0-160 160" })
  }
), t = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6" })
  }
), w = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M423.9 255.8 411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7m-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3" })
  }
), g = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z" })
  }
), i = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m248 167.5 64.9 98.8H183.1zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248m-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7z" })
  }
), m = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1m-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z" })
  }
), a = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25" })
  }
), o = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64m47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z" })
  }
), n = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0C116.1 0 2 112.7 0 252.1c-2 141.5 112.9 258.7 254.5 259.5 43.7.3 85.9-10.4 123.3-30.7 3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3-26.1 11.1-54.5 16.8-83.7 16.4-114.4-1.5-206.9-96.6-205.1-211C50.1 139.5 142.6 48.2 256 48.2h207.7v369L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3-18.9 25-49.7 40.6-83.9 38.2-47.5-3.3-85.9-41.5-89.5-88.9-4.2-56.6 40.6-103.9 96.3-103.9 50.4 0 91.9 38.8 96.2 88 .4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4 2.2-11.8 3-24.2 2.1-36.8-4.9-72-63.3-130-135.4-134.4-82.7-5.1-151.8 59.5-154 140.6-2.1 78.9 62.6 147 141.6 148.7 33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z" })
  }
), r = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32M47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z" })
  }
), d = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1m259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z" })
  }
), S = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12m39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1" })
  }
), z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z" })
  }
), p = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M420.55 301.93a24 24 0 1 1 24-24 24 24 0 0 1-24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24m273.7-144.48 47.94-83a10 10 0 1 0-17.27-10l-48.54 84.07a301.25 301.25 0 0 0-246.56 0l-48.54-84.07a10 10 0 1 0-17.27 10l47.94 83C64.53 202.22 8.24 285.55 0 384h576c-8.24-98.45-64.54-181.78-146.85-226.55" })
  }
), M = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z" })
  }
), x = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m640 238.2-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8m56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8 5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4m135.4-45-7.9-37.8-15.8 39.3 23.7-1.5m-170.1-74.6-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2 23.8-1.6-8.3-37.6-15.5 39.2" })
  }
), H = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M185.7 268.1h76.2l-38.1-91.6zM223.8 32 16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z" })
  }
), V = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z" })
  }
), C = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m255.9 120.9 9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216" })
  }
), L = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7m57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7m53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z" })
  }
), B = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42m8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z" })
  }
), u = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" })
  }
), R = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m2 377.4 43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350 335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1M275 304.5l-115.5-200L44 304.5z" })
  }
), $ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8m-187.6 80.5-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z" })
  }
), k = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z" })
  }
), P = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 199.9v54l-320 200L0 254v-54l320 200zm-194.5 72 47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3m-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7" })
  }
), F = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m318.4 16-161 480h77.5l25.4-81.4h119.5L405 496h77.5zm-40.3 341.9 41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5zm-462.1-47L10 373.7 0 405l158.5 9.4z" })
  }
), T = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z" })
  }
), A = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m107.2 283.5-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4zm-45-98.1-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4-62.2-131.4h17.1l45.1 96 45.1-96h17zm80.6-4.3V156.4H271v127.1zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6 19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z" })
  }
), D = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02" })
  }
), y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m48.2 326.1h-181L207.9 178h181Z" })
  }
), b = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5M216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43m27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111m-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57m-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8" })
  }
), f = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2M390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8z" })
  }
), U = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488.6 104.1c16.7 18.1 24.4 39.7 23.3 65.7v202.4c-.4 26.4-9.2 48.1-26.5 65.1-17.2 17-39.1 25.9-65.5 26.7H92.02c-26.45-.8-48.21-9.8-65.28-27.2C9.682 419.4.767 396.5 0 368.2V169.8c.767-26 9.682-47.6 26.74-65.7C43.81 87.75 65.57 78.77 92.02 78h29.38L96.05 52.19c-5.75-5.73-8.63-13-8.63-21.79 0-8.8 2.88-16.06 8.63-21.797C101.8 2.868 109.1 0 117.9 0s16.1 2.868 21.9 8.603L213.1 78h88l74.5-69.397C381.7 2.868 389.2 0 398 0c8.8 0 16.1 2.868 21.9 8.603 5.7 5.737 8.6 12.997 8.6 21.797 0 8.79-2.9 16.06-8.6 21.79L394.6 78h29.3c26.4.77 48 9.75 64.7 26.1m-38.8 69.7c-.4-9.6-3.7-17.4-10.7-23.5-5.2-6.1-14-9.4-22.7-9.8H96.05c-9.59.4-17.45 3.7-23.58 9.8-6.14 6.1-9.4 13.9-9.78 23.5v194.4c0 9.2 3.26 17 9.78 23.5s14.38 9.8 23.58 9.8H416.4c9.2 0 17-3.3 23.3-9.8 6.3-6.5 9.7-14.3 10.1-23.5zm-264.3 42.7c6.3 6.3 9.7 14.1 10.1 23.2V273c-.4 9.2-3.7 16.9-9.8 23.2-6.2 6.3-14 9.5-23.6 9.5-9.6 0-17.5-3.2-23.6-9.5-6.1-6.3-9.4-14-9.8-23.2v-33.3c.4-9.1 3.8-16.9 10.1-23.2 6.3-6.3 13.2-9.6 23.3-10 9.2.4 17 3.7 23.3 10m191.5 0c6.3 6.3 9.7 14.1 10.1 23.2V273c-.4 9.2-3.7 16.9-9.8 23.2-6.1 6.3-14 9.5-23.6 9.5-9.6 0-17.4-3.2-23.6-9.5-7-6.3-9.4-14-9.7-23.2v-33.3c.3-9.1 3.7-16.9 10-23.2 6.3-6.3 14.1-9.6 23.3-10 9.2.4 17 3.7 23.3 10" })
  }
), G = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32m-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7" })
  }
), q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147" })
  }
), W = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248m-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956m8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035" })
  }
), E = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7m-62.9-79 .2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8m71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0" })
  }
), O = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2z" })
  }
), I = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7m126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7M88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7m189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7m-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7" })
  }
), N = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z" })
  }
), X = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5m-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z" })
  }
), K = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m196.48 260.023 92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644zm40.86-102.996-49.977 49.978-.338-100.295 50.315 50.317M187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z" })
  }
), Q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M292.6 171.1 249.7 214l-.3-86 43.2 43.1m-43.2 219.8 43.1-43.1-42.9-42.9zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4m-158.5 0 79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5z" })
  }
), Z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M333.5 201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5c32.8-.1 50.9-13.3 50.9-36.9M517 188.6c-9.5-30.9-10.9-68.8-9.8-98.1C508.3 60 484.5 32 452.5 32H123.7C91.6 32 67.9 60.1 69 90.5c1 29.3-.3 67.2-9.8 98.1-9.6 31-25.7 50.6-52.2 53.1v28.5c26.4 2.5 42.6 22.1 52.2 53.1 9.5 30.9 10.9 68.8 9.8 98.1-1.1 30.5 22.7 58.5 54.7 58.5h328.7c32.1 0 55.8-28.1 54.7-58.5-1-29.3.3-67.2 9.8-98.1 9.6-31 25.7-50.6 52.1-53.1v-28.5c-26.3-2.5-42.5-22.1-52-53.1M300.2 375.1h-97.9V136.8h97.4c43.3 0 71.7 23.4 71.7 59.4 0 25.3-19.1 47.9-43.5 51.8v1.3c33.2 3.6 55.5 26.6 55.5 58.3 0 42.1-31.3 67.5-83.2 67.5m-10-108.7h-50.1v78.4h52.3c34.2 0 52.3-13.7 52.3-39.5 0-25.7-18.6-38.9-54.5-38.9" })
  }
), J = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M86.344 197.834a51.767 51.767 0 0 0-41.57 20.058v-61.874a8.19 8.19 0 0 0-8.19-8.19H8.19a8.19 8.19 0 0 0-8.19 8.19v177.533a8.189 8.189 0 0 0 8.19 8.189h28.394a8.189 8.189 0 0 0 8.19-8.189v-8.088c11.628 13.373 25.874 19.769 41.573 19.769 34.6 0 61.922-26.164 61.922-73.843-.003-45.937-27.04-73.555-61.925-73.555M71.516 305.691c-9.593 0-21.221-4.942-26.745-12.5v-43.027c5.528-7.558 17.152-12.791 26.745-12.791 17.734 0 31.107 13.082 31.107 34.013 0 21.223-13.373 34.305-31.107 34.305m156.372-59.032a17.4 17.4 0 1 0 17.4 17.4 17.4 17.4 0 0 0-17.4-17.4Zm46.068-89.959v-44.661a13.308 13.308 0 1 0-10.237 0V156.7a107.49 107.49 0 1 0 10.237 0m85.993 107.367c0 30.531-40.792 55.281-91.112 55.281s-91.111-24.75-91.111-55.281 40.792-55.281 91.111-55.281 91.112 24.746 91.112 55.276Zm-50.163 17.4a17.4 17.4 0 1 0-17.4-17.4 17.4 17.4 0 0 0 17.4 17.399ZM580.7 250.455c-14.828-2.617-22.387-3.78-22.387-9.885 0-5.523 7.268-9.884 17.735-9.884a65.56 65.56 0 0 1 34.484 10.1 8.171 8.171 0 0 0 11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2 8.2 0 0 0-2.867-11.123 99.863 99.863 0 0 0-52.014-14.138c-38.956 0-60.179 21.514-60.179 46.225 0 36.342 33.725 41.864 57.563 45.642 13.373 2.326 24.13 4.361 24.13 11.048 0 6.4-5.523 10.757-18.9 10.757-13.552 0-30.994-6.222-42.623-13.579a8.206 8.206 0 0 0-11.335 2.491 2.76 2.76 0 0 0-.1.164l-10.2 16.891a8.222 8.222 0 0 0 2.491 11.066c15.224 10.3 37.663 16.692 59.441 16.692 40.409 0 63.957-19.769 63.957-46.515.005-38.09-35.458-43.904-59.295-48.265m-95.928 60.787a8.211 8.211 0 0 0-9.521-5.938 23.168 23.168 0 0 1-4.155.387c-7.849 0-12.5-6.106-12.5-14.245V240.28h20.349a8.143 8.143 0 0 0 8.141-8.143v-22.671a8.143 8.143 0 0 0-8.141-8.143h-20.351v-30.232a8.143 8.143 0 0 0-8.143-8.143h-28.194a8.143 8.143 0 0 0-8.143 8.143v30.232H399a8.143 8.143 0 0 0-8.143 8.143v22.671A8.143 8.143 0 0 0 399 240.28h15.115v63.667c0 27.037 15.408 41.282 43.9 41.282 12.183 0 21.383-2.2 27.6-5.446a8.161 8.161 0 0 0 4.145-9.278Z" })
  }
), j = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253" })
  }
), Y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m427.84 380.67-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24m0-136.53-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74" })
  }
), _ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v128h128V32zm120 120H8V40h112zm40-120v128h128V32zm120 120H168V40h112zm40-120v128h128V32zm120 120H328V40h112zM0 192v128h128V192zm120 120H8V200h112zm40-120v128h128V192zm120 120H168V200h112zm40-120v128h128V192zm120 120H328V200h112zM0 352v128h128V352zm120 120H8V360h112zm40-120v128h128V352zm120 120H168V360h112zm40-120v128h128V352z" })
  }
), h1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32m-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52M358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170" })
  }
), c1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 150.7 42.9 160.7h-85.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-65.3 325.3-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z" })
  }
), s1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z" })
  }
), v1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48m-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z" })
  }
), e1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 480c-26.51 0-48-21.5-48-48V80c0-26.51 21.49-48 48-48h480c26.5 0 48 21.49 48 48v2.43h-75.5l-17 47.57-16.9-47.57h-97.2v63.17l-28.1-63.17h-78.6L181 267.1h65.8v163.8h203.7l31.9-35.1 31.9 35.1H576v1.1c0 26.5-21.5 48-48 48zm434.6-116-42.2 46.3h-49.9l67.5-71.7-67.5-72.5h51.4l41.5 46.7 42-46.7H576l-68 72.1 68 72.1h-51.4zm93.4-67.1v83.3l-39.3-41.9zm-268.4 80.2h83v33.2h-122V267.1h122v33.1h-83v22.4h80.9v32.3h-80.9v22.3zm229.7-231.4-36.9 100.6H466L429.2 146v100.3h-38.7V103h61.2l31.9 89.3 32.2-89.3H576v143.3h-38.7zm-202.8 71.9h-65.9l-11.9 28.7h-43L276.1 103h51.2l63.3 143.3h-44.1zm-33-79.1L282 185.4h38.9z" })
  }
), l1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4M576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48M127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21m135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8z" })
  }
), t1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9m79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2" })
  }
), w1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48m-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0 21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6m-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z" })
  }
), g1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3m42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17M576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48M182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2m178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z" })
  }
), i1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7m-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7m117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7m107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7m105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1m-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48M64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2m224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5m-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6m66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7m7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4m3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z" })
  }
), m1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5M80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48M128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9m40.5 97.9 63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8m84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5" })
  }
), a1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7M375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z" })
  }
), o1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48M152.5 331.2 215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53M528 331.4 495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3z" })
  }
), n1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6m-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8m179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2" })
  }
), r1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289.6 97.5 31.6 31.7-76.3 76.5V97.5zm-162.4 31.7 76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6 90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z" })
  }
), d1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0-46.6 12.47-90.4 34.27-128.9L144.1 318.3C166 357.5 207.9 384 256 384c14.3 0 27.1-2.3 40.8-6.6l-76.3 132.2C95.9 492.3 0 385.3 0 256m365.1 65.6c12.3-19.2 18.9-42.5 18.9-65.6 0-38.2-16.8-72.5-43.3-96h152.7c12 29.6 18.6 62.1 18.6 96 0 141.4-114.6 255.1-256 256zM477.8 128H256c-62.9 0-113.7 44.1-125.5 102.7L54.19 98.47C101 38.53 174 0 256 0c94.8 0 177.5 51.48 221.8 128M168 256c0-48.6 39.4-88 88-88s88 39.4 88 88-39.4 88-88 88-88-39.4-88-88" })
  }
), S1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M447.8 64H64c-23.6 0-42.7 19.1-42.7 42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6 0 42.7-19.1 42.7-42.7V106.7c0-23.6-19.3-42.7-42.9-42.7M21.3 383.6zv63.9h63.9c0-35.3-28.6-63.9-63.9-63.9zm0-85V341c58.9 0 106.6 48.1 106.6 107h42.7c.1-82.4-66.9-149.3-149.3-149.4zM213.4 448h42.7c-.5-129.5-105.3-234.3-234.8-234.6v42.4c106-.2 192 86.2 192.1 192.2" })
  }
), z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m407.906 319.913-230.8-2.928a4.58 4.58 0 0 1-3.632-1.926 4.648 4.648 0 0 1-.494-4.147 6.143 6.143 0 0 1 5.361-4.076l232.94-2.936c27.631-1.26 57.546-23.574 68.022-50.784l13.286-34.542a7.944 7.944 0 0 0 .524-2.936 7.735 7.735 0 0 0-.164-1.631A151.91 151.91 0 0 0 201.257 198.4 68.12 68.12 0 0 0 94.2 269.59C41.924 271.106 0 313.728 0 366.12a96.054 96.054 0 0 0 1.029 13.958 4.508 4.508 0 0 0 4.445 3.871l426.1.051c.043 0 .08-.019.122-.02a5.606 5.606 0 0 0 5.271-4l3.273-11.265c3.9-13.4 2.448-25.8-4.1-34.9-6.016-8.392-16.05-13.328-28.234-13.902m105.95-98.813c-2.141 0-4.271.062-6.391.164a3.771 3.771 0 0 0-3.324 2.653l-9.077 31.193c-3.9 13.4-2.449 25.786 4.1 34.89 6.02 8.4 16.054 13.323 28.238 13.9l49.2 2.939a4.491 4.491 0 0 1 3.51 1.894 4.64 4.64 0 0 1 .514 4.169 6.153 6.153 0 0 1-5.351 4.075l-51.125 2.939c-27.754 1.27-57.669 23.574-68.145 50.784l-3.695 9.606a2.716 2.716 0 0 0 2.427 3.68c.046 0 .088.017.136.017h175.91a4.69 4.69 0 0 0 4.539-3.37 124.807 124.807 0 0 0 4.682-34C640 277.3 583.524 221.1 513.856 221.1" })
  }
), p1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m318.1 154-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2M224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32m0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160" })
  }
), M1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 227.6v56.9L284.4 512h-56.8L0 284.4v-56.8L227.6 0h56.9zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1" })
  }
), x1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3M56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5" })
  }
), H1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M226.119 388.165a3.816 3.816 0 0 0-2.294-3.5 3.946 3.946 0 0 0-1.629-.385L72.6 384.3a19.243 19.243 0 0 1-17.924-26.025l26.909-102.583a35.72 35.72 0 0 1 32.373-26h148.567a7.07 7.07 0 0 0 6.392-5.194l10.769-41.131a3.849 3.849 0 0 0-2.237-4.937 3.755 3.755 0 0 0-1.377-.261c-.063 0-.126 0-.189.005H127.38a106.8 106.8 0 0 0-96.99 77.1L3.483 358.824A57.469 57.469 0 0 0 57.314 436q1.43 0 2.86-.072h148.568a7.131 7.131 0 0 0 6.391-5.193l10.706-41.135a3.82 3.82 0 0 0 .28-1.435M306.658 81.2a3.861 3.861 0 0 0 .251-1.367 3.813 3.813 0 0 0-3.83-3.833h-41.192a7.034 7.034 0 0 0-6.387 5.2l-21.347 80.915h51.131ZM180.364 368.249H231.5l31.952-122.559h-51.131ZM511.853 79.723a3.809 3.809 0 0 0-3.8-3.661c-.058 0-.137 0-.23.007h-41a7.1 7.1 0 0 0-6.584 5.129L368.91 430.634a3.54 3.54 0 0 0-.262 1.335 3.873 3.873 0 0 0 3.864 3.863h41.169a7.068 7.068 0 0 0 6.392-5.193L511.533 81.2a3.624 3.624 0 0 0 .32-1.477ZM324.649 384.47h-41a7.2 7.2 0 0 0-6.392 5.194L266.52 430.8a3.662 3.662 0 0 0-.268 1.374 3.783 3.783 0 0 0 3.771 3.826c.06 0 .166 0 .3-.012h40.905a7.036 7.036 0 0 0 6.391-5.193l10.769-41.131a3.75 3.75 0 0 0-3.445-5.208c-.108 0-.217 0-.326.014Zm311.324-308.4h-41a7.066 7.066 0 0 0-6.392 5.129l-91.46 349.436a4.073 4.073 0 0 0-.229 1.347 3.872 3.872 0 0 0 3.863 3.851h41.137a7.1 7.1 0 0 0 6.392-5.193L639.68 81.2a3.624 3.624 0 0 0 .32-1.475 3.841 3.841 0 0 0-3.821-3.564c-.068 0-.137 0-.206.006ZM371.562 225.236l10.8-41.1a4.369 4.369 0 0 0 .227-1.388 3.869 3.869 0 0 0-3.861-3.842h-41.269a7.292 7.292 0 0 0-6.391 5.226l-10.834 41.1a4.417 4.417 0 0 0-.26 1.493v.206a3.776 3.776 0 0 0 3.757 3.507c.076 0 .18 0 .3-.012h41.129a7.034 7.034 0 0 0 6.402-5.19" })
  }
), V1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m502.285 159.704-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703zm-44 0v102.572l-95.429 63.715-76.857-51.429zM44 219.132l55.143 36.857L44 292.846zm190 229.715L61.714 333.989l76.857-51.429L234 346.275zm22-140.858-77.715-52 77.715-52 77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429zm190-156.001-55.143-36.857L468 219.132z" })
  }
), C1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 472 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8zm-38.5 12.5-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4" })
  }
), L1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z" })
  }
), B1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m550.5 241-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803m0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624m0-62.411-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053m0-80.625-43.66 15.804 43.66-75.536v59.732m326.519 39.108.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268M291.75 355.107l11.518 11.786H280.5zm-.268-11.25-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893 79.286-82.232 67.5 71.25-5.892 28.125H313.714zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25zm-116.249 5.625 1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286 60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304m0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858 42.053-44.464 82.768 85.982-17.143 17.678H161.572zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339m129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821zm120-11.786-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232 12.858-60.803h21.964l-34.822 60.803m34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75" })
  }
), u1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4M478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34" })
  }
), R1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z" })
  }
), $1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3m-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3m-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z" })
  }
), k1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z" })
  }
), P1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8m.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6-.5-.4.9.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z" })
  }
), F1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8m.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z" })
  }
), T1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8M55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z" })
  }
), A1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197zm0 79.8v42.5H162.1v-42.5z" })
  }
), D1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8m.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6m.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9M203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5m-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z" })
  }
), y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8m0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8m194.2-150-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z" })
  }
), b1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7 4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4m7.5-57.6 39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4z" })
  }
), f1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z" })
  }
), U1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5" })
  }
), G1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z" })
  }
), q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5z" })
  }
), W1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8m.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4z" })
  }
), E1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m245.83 214.87-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248m.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z" })
  }
), O1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65m105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z" })
  }
), I1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 32 34.9 395.8L192 480l157.1-52.2L384 32zm313.1 80-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112z" })
  }
), N1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m480 32-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z" })
  }
), X1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8" })
  }
), K1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27M301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5m-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3m38.9 3.7-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3 23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3m-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3m-91.3-8.3 44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6 7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z" })
  }
), Q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3" })
  }
), Z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M298.93 267a48.4 48.4 0 0 0-24.36-6.21q-19.83 0-33.44 13.27t-13.61 33.42q0 21.16 13.28 34.6t33.43 13.44q20.5 0 34.11-13.78T322 307.47a47.13 47.13 0 0 0-6.1-23.47 44.13 44.13 0 0 0-16.97-17M0 32v448h448V32Zm374.71 373.26h-53.1v-23.89h-.67q-15.79 26.2-55.78 26.2-27.56 0-48.89-13.1a88.29 88.29 0 0 1-32.94-35.77q-11.6-22.68-11.59-50.89 0-27.56 11.76-50.22a89.9 89.9 0 0 1 32.93-35.78q21.18-13.09 47.72-13.1a80.87 80.87 0 0 1 29.74 5.21q13.28 5.21 25 17V153l55.79-12.09Z" })
  }
), J1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z" })
  }
), j1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248.2.9c-4 .2-8.1.4-11.4 1.6l-3.4-.5c5.4-.7 10.9-1.1 16.4-1.5l7.2-.6c-2.7.6-5.7.8-8.8.9zm132 244.7c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4-30-13.8-76.1-16.2-97.3-5.8 1.3-1.1 4.2-2 6.8-2.7 3.4-1 6.3-1.8 4.3-3-19.2 1.9-24.9 5.5-31.1 9.4-4.6 2.9-9.5 6-20.3 8.7-3.5 3.4 1.7 2 5.8.9s7.2-1.9-.1 2.4c-3.6 1-6.7 1.3-9.7 1.6-8.3.8-15.8 1.6-30.7 17 .8 1.3 3.5-.3 5.4-1.4 2.3-1.4 3.4-2-1.7 4.4-19.1-2.4-60.3 43.7-69.1 59l4.6.8c-3.2 8-6.8 14.8-10 20.8-4.3 8.1-7.9 14.9-8.7 21.3-.4 5.9-1.2 12.9-2 20.3-3 27.4-6.8 61.3 3.8 73.6l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5 1.2 2.5 2.3 5 3.9 7.4l-3 .2c7 22.2 10.8 22.5 15.1 22.9 4.4.4 9.3.9 18.7 24.2-2.7-.9-5.5-1.9-9.4-7.2-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c3.2 5.8 6.1 8.1 8.6 10 .8.6 1.5 1.1 2.1 1.7-11.9-6.5 3.2 13.7 11.9 25.2 2.5 3.4 4.5 6 5.1 7l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2 2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7 5.2 5.6 9.9 10.7 19.8 15.4 11.2 3.9 17.1 4.8 23.6 5.9 5.4.8 11.2 1.8 20.8 4.5-2.2-.1-4.4-.1-6.7-.2-16.3-.4-34-.8-46.4-5.2-96.7-25.8-185-139.1-178.5-255.7-.6-9.9-.3-20.9 0-30.7.4-13.5.7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2v-.1c.4.4 3.4 3.4 8.8-5.8 1.3-2.9 2.5-5.8 3.8-8.8 2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2 6.1-5.5 11.6-10.4 14.7-14.1l.7 4.4c17.1-16 45-27.7 66.1-36.6 4.8-2 9.3-3.9 13.3-5.7-3.4 3.8 2.2 2.7 10 1 4.8-1 10.4-2.1 15.3-2.4l-3.9 2.1c-2.7 1.4-5.4 2.8-8 4.6 8.3-2 11.9-1.4 16-.8 3.5.6 7.3 1.2 14.6.2-5.6.8-12.3 3-11.2 3.8 7.9.9 12.8-.1 17.2-1 5.6-1.1 10.4-2.1 19.5.9l-1-4.8c7.5 2.7 13.1 4.4 18 5.9 10 3 17.6 5.3 34.2 14.1 3.2.2 5.3-.5 7.4-1.2 3.6-1.1 7-2.2 15.3 1.2.5.8.7 1.5 1 2.1 1 2.6 1.7 4.6 14.6 12.2 1.8-.7-3.1-5.1-7-8.7l-.2-.1c32.3 17.3 67.5 54.1 78.2 93.6-6-11.1-5.2-5.5-4.3.5.6 4 1.2 8.1-.2 7.5 4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9c-3.3-11.8-9.6-34.5-20-49.6-.4 4.4-2.9 3.9-5.3 3.5-3.3-.6-6.3-1.2-1.9 12.6 2.6 3.8 3.1 2.4 3.5 1.1.5-1.5.9-2.8 4.7 5.2.1 4.3 1.1 8.5 2.2 13.3.7 3 1.5 6.2 2.1 9.8-1.1-.2-2.3-2.2-3.4-4.2-1.4-2.4-2.8-4.7-3.7-3.2 2.4 11.5 6.5 17.4 8 18.3-.3.6-.6.7-1.1.7-.8 0-1.8.1-1.9 5.3.7 13.7 3.3 12.5 5.3 11.6.6-.3 1.2-.6 1.7-.4-.6 2.5-1.6 5.1-2.7 7.9-2.8 7.1-6 15.4-3.4 26.1-.8-3.1-2.1-6.3-3.3-9.3-.5-1.3-1.1-2.6-1.5-3.8-.6 4.8-.3 8.2-.1 11.3.4 5.3.7 10-3 19.9 4.3-14.2 3.8-26.9-.2-20.8 1 11-3.8 20.5-8.1 29.1-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.6 11-7 13.3-6.5 15.6.5 1.9 1 3.8-3.4 10.8 1.7-2.9 1.3-3.6 1-4.2-.4-.8-.7-1.5 1.7-5.1-1.6.1-5.5 3.9-10.1 8.5-3.9 3.9-8.5 8.4-12.8 11.8-37.5 30.1-82.3 34-125.6 17.8.2-1-.2-2.1-3.1-4.1-36.8-28.2-58.5-52.1-50.9-107.5 2.2-1.7 3.7-6.2 5.6-11.6 2.9-8.4 6.5-18.9 14.3-23.9 7.8-17.3 31.3-33.3 56.4-33.7 25.6-1.4 47.2 13.7 58.1 27.9-19.8-18.4-52.1-24-79.7-10.4-28.2 12.7-45 43.8-42.5 74.7.3-.5.7-.7 1-.9.6-.5 1.2-.9 1.5-3.4-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7 2.2-2.1 4.7-4.5 9-7.4-.3.7-1.3 1.7-2.4 2.7-2.2 2.1-4.6 4.5-1.6 4.6 5.3-1.4 20.1-14.8 30.2-23.8 1.6-1.4 3-2.7 4.3-3.9 2-4.3 1.6-5.7 1.3-7.1-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c1-2.8 2-5.4 2.9-7.8zm-147.1 76.3a.9.9 0 1 0-1.7 0 .9.9 0 1 0 1.7 0m-.2.5-.2.4c-.3.7-.6 1.4-.3 2.4-12.2-5.7-23.4-14.3-32.6-24.9 4.9 7.1 10.1 14.1 17 19.5-6.9-2.3-15.2-11.9-21.7-19.4-4.3-5-7.9-9.1-9.7-9.5 19.8 35.5 80.5 62.3 112.3 49-14.7.5-33.4.3-49.9-5.8-6.3-3.2-14.6-9.6-14.9-11.8zM237.5 7c3.8.6 7.3 1.2 6.7 2.1 5-1.1 6.1-2.1-9-2.5.8.1 1.6.3 2.4.4zm92.2 208.4c-1 3.9-1.8 1.4-2.7-1.2-.5-1.5-1.1-3.1-1.7-3.4 1.4-5.8 5.4-10.7 4.4 4.6m-6.8 21.2c-1.3 7.9-5 15.5-10.1 22.5.2-2-1.2-2.4-2.6-2.8-2.9-.8-5.9-1.6 5.6-16.1-.5 2-2.3 4.9-4 7.7-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8zm-42.9 40c-11.1-1.7-21.2-6-12.7-6.1 7.1.6 14.1.6 21-1.1-2.5 2.4-5.2 4.8-8.3 7.2zM244.2 9.1l-.2.4-3 .3 3.2-.7zm-69.5 273c3.7 7.2 6.5 11.7 9.1 15.9 2.3 3.7 4.4 7.1 6.8 11.7-5.2-4.3-8.9-9.8-12.8-15.5-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9zm7.3-10c1.7 3.4 3.3 6.7 5.9 9.5l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7zm239.1-41.2c-2.3 17.4-7.7 34.6-16 50.3 7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.4 109.6c0 .3 0 .5.1.7 0-.2 0-.5-.1-.7m.1.7c.3 1.2 1.4.9 2.4.6 1.9-.5 3.6-.9-.1 7.6-2.4 1.7-3.8 2.8-4.6 3.4-.6.4-.8.6-.8.6s.1-.2.3-.5c.8-1.4 3.4-5.5 2.9-11.7zm-10.2 42c-.7 3.7-1.5 7.9-3.4 13.9.2-1.9 0-3.5-.2-4.9-.4-3.4-.8-6.3 4.3-12.9-.3 1.2-.5 2.5-.7 3.8z" })
  }
), Y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M451.46 244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0 275.06H576V273.2H451.46ZM0 447.09h124.54v-72.67H0Zm150.47 0H275v-72.67H150.47Zm150.52 0h124.54v-72.67H301Zm150.47 0H576v-72.67H451.46ZM301 345.88h124.53V273.2H301Zm-150.52 0H275V273.2H150.47Zm0-101.17H275V172H150.47Z" })
  }
), _1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12M416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z" })
  }
), h2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32zm0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64" })
  }
), c2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m205.9 512 31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2m-132.5 56 64 29.3c13.3-45.5-42.2-71.7-64-29.3" })
  }
), s2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z" })
  }
), v2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 93.2-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z" })
  }
), e2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M238 301.2h58.7L319 271h-58.7zM0 282.9v6.4h81.8l4.7-6.4zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9 39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2m222 .1h95v-6.4h-90.3zm22.3-30.3-4.7 6.4H640V271zm-13.5 18.3H640v-6.4h-81.5zm-164.2-78.6-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3z" })
  }
), l2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z" })
  }
), t2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3m297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3zm81.8 133.4h-30.8v-92.3h30.8v92.3m-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4m51.2-133.3h30.8v92.3h-30.8v-92.3M153.3 96h51.3v51h-51.3zm0 76.3h51.3v174.4h-51.3z" })
  }
), w2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z" })
  }
), g2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M524.531 69.836a1.5 1.5 0 0 0-.764-.7A485.065 485.065 0 0 0 404.081 32.03a1.816 1.816 0 0 0-1.923.91 337.461 337.461 0 0 0-14.9 30.6 447.848 447.848 0 0 0-134.426 0 309.541 309.541 0 0 0-15.135-30.6 1.89 1.89 0 0 0-1.924-.91 483.689 483.689 0 0 0-119.688 37.107 1.712 1.712 0 0 0-.788.676C39.068 183.651 18.186 294.69 28.43 404.354a2.016 2.016 0 0 0 .765 1.375 487.666 487.666 0 0 0 146.825 74.189 1.9 1.9 0 0 0 2.063-.676A348.2 348.2 0 0 0 208.12 430.4a1.86 1.86 0 0 0-1.019-2.588 321.173 321.173 0 0 1-45.868-21.853 1.885 1.885 0 0 1-.185-3.126 251.047 251.047 0 0 0 9.109-7.137 1.819 1.819 0 0 1 1.9-.256c96.229 43.917 200.41 43.917 295.5 0a1.812 1.812 0 0 1 1.924.233 234.533 234.533 0 0 0 9.132 7.16 1.884 1.884 0 0 1-.162 3.126 301.407 301.407 0 0 1-45.89 21.83 1.875 1.875 0 0 0-1 2.611 391.055 391.055 0 0 0 30.014 48.815 1.864 1.864 0 0 0 2.063.7A486.048 486.048 0 0 0 610.7 405.729a1.882 1.882 0 0 0 .765-1.352c12.264-126.783-20.532-236.912-86.934-334.541ZM222.491 337.58c-28.972 0-52.844-26.587-52.844-59.239s23.409-59.241 52.844-59.241c29.665 0 53.306 26.82 52.843 59.239 0 32.654-23.41 59.241-52.843 59.241Zm195.38 0c-28.971 0-52.843-26.587-52.843-59.239s23.409-59.241 52.843-59.241c29.667 0 53.307 26.82 52.844 59.239 0 32.654-23.177 59.241-52.844 59.241" })
  }
), i2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32M224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128" })
  }
), m2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M397.9 160H256V19.6zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192z" })
  }
), a2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349.9 236.3h-66.1v-59.4h66.1zm0-204.3h-66.1v60.7h66.1zm78.2 144.8H362v59.4h66.1zm-156.3-72.1h-66.1v60.1h66.1v-60.1m78.1 0h-66.1v60.1h66.1v-60.1m276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4m78.1 0h-66.1v59.4h66.1zm-78.1-72.1h-66.1v60.1h66.1v-60.1" })
  }
), o2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m480 398.1-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4M82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z" })
  }
), n2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8m163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62M44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323m81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978" })
  }
), r2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 528 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m264.4 116.3-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6 132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3z" })
  }
), d2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.973 108.136C268.2 72.459 234.187 38.35 224.047 0c-9.957 38.35-44.25 72.459-80.019 108.136-53.561 53.564-114.312 114.22-114.312 205.3-2.337 107.3 82.752 196.18 190.053 198.517S415.948 429.2 418.285 321.9q.091-4.231 0-8.464c0-91.08-60.751-151.736-114.312-205.3m-174.326 223a130.282 130.282 0 0 0-15.211 24.153 4.978 4.978 0 0 1-3.319 2.766h-1.659c-4.333 0-9.219-8.481-9.219-8.481-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318a160.585 160.585 0 0 1 23.231-49.873 290.8 290.8 0 0 1 21.022-27.657l9.219 9.219 43.512 44.434a4.979 4.979 0 0 1 0 6.638L145.78 312.33Zm96.612 127.311a67.2 67.2 0 0 1-49.781-111.915c14.2-16.871 31.528-33.464 50.334-55.313 22.309 23.785 36.875 40.1 51.164 57.986a28.413 28.413 0 0 1 2.95 4.425 65.905 65.905 0 0 1 11.984 37.981 66.651 66.651 0 0 1-66.466 66.836ZM352.371 351.6a7.743 7.743 0 0 1-6.176 5.347H344.9a11.249 11.249 0 0 1-6.269-5.07 348.21 348.21 0 0 0-39.456-48.952l-17.788-18.435-59.087-61.305a497.888 497.888 0 0 1-35.4-36.322 12.033 12.033 0 0 0-.922-1.382 35.4 35.4 0 0 1-4.7-9.219v-1.752a31.346 31.346 0 0 1 9.218-27.656c11.432-11.431 22.955-22.954 33.833-34.939 11.984 13.275 24.8 26 37.428 38.627a530.991 530.991 0 0 1 69.6 79.1 147.494 147.494 0 0 1 27.011 83.8 134.109 134.109 0 0 1-5.997 38.158" })
  }
), S2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32z" })
  }
), z2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5m-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16m-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16m318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2m135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3" })
  }
), p2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m606 189.5-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8m200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z" })
  }
), M2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m25.71 228.16.35-.48c0 .16 0 .32-.07.48Zm460.58 15.51c0-44-7.76-84.46-28.81-122.4C416.5 47.88 343.91 8 258.89 8 119 7.72 40.62 113.21 26.06 227.68c42.42-61.31 117.07-121.38 220.37-125 0 0 109.67 0 99.42 105H170c6.37-37.39 18.55-59 34.34-78.93-75.05 34.9-121.85 96.1-120.75 188.32.83 71.45 50.13 144.84 120.75 172 83.35 31.84 192.77 7.2 240.13-21.33V363.31c-80.87 56.49-270.87 60.92-272.26-67.57h314.08z" })
  }
), x2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120.1 37.44C161.1 12.23 207.7-.775 255 .002 423 .002 512 123.8 512 219.5c-.1 32.7-13 63.9-35.9 87.2-22.9 23.2-54 36.5-86.7 37-75.2 0-91.5-23.1-91.5-32 0-3.8 1.2-6.2 4.8-9.4l1-1.2.4-1.6c10.5-11.5 15.9-26.2 15.9-41.6 0-78.7-82.2-142.7-184-142.7-37.54-.3-74.54 8.9-107.52 26.9 27-57.52 82.72-97.6 91.32-103.82.8-.55.3-.84.3-.84m15.6 318.06c-1.4 30 4.6 60 16.4 87.2 13.6 26.4 32.7 51 56.5 69.3-59.5-11.5-111.49-43.9-149.4-89.3C21.12 376.3 0 318.4 0 257.9c0-51.2 62.4-94.4 136-94.4 36.6-.6 72.4 10.9 101.8 32.7l-3.6 1.2c-51.5 17.6-98.5 90.7-98.5 158.1M469.8 400l-.7.1c-11.8 18.8-25.9 35.1-42.2 49.5-30.8 28-68.1 45.5-108.8 49.9-18.6.3-36.8-3.2-53.8-11.4-25.6-10.3-47.1-30-61.6-53-14.4-23.9-21.1-51.7-19-79.6-.6-20.1 5.4-40.3 15-58.2 13.9 33.1 37.5 61.3 67.6 80.8 30.1 19.5 65.5 29.5 101.4 28.6 31 .3 62.1-6.7 90.2-20.5l1.9-.9c3.9-2.3 7.7-3.9 11.6 0 4.5 4.9 1.8 9.2-1.2 14-.2.2-.3.5-.4.7" })
  }
), H2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.361 256C.361 397 114 511 255 511c142 0 256-114 256-255C511 116 397 2.05 255 2.05 114 2.05.361 116 .361 256zM192 150v213h-43V150zm42 0h128v43H234zm128 85v43H234v-43zm-128 85h128v43H234z" })
  }
), V2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8m143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z" })
  }
), C2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7m22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5m84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z" })
  }
), L2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248m-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256m-39-106.6-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z" })
  }
), B2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32m79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z" })
  }
), u2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9m238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z" })
  }
), R2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311.9 260.8 160 353.6 8 260.8 160 0zM160 383.4 8 290.6 160 512l152-221.4-152 92.8z" })
  }
), $2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z" })
  }
), k2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z" })
  }
), P2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4m141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8m0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3" })
  }
), F2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m279.14 288 14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" })
  }
), T2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8m149.24 185.13-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z" })
  }
), A2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256" })
  }
), D2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32.86 32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5M256 0 0 256l256 256 256-256zM16 256 256 16l240 240-240 240z" })
  }
), y2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m586 284.5 53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8m167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1m138.6 10.3-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z" })
  }
), b2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.041 255.8C.121 132.2 100.3 32 224 32s224 100.3 224 224-100.2 223.9-223.9 224H50.93C22.84 480 .083 457.3.042 429.2H0V255.8h.041M342.6 192.7c0-39.7-35.6-68.5-73.2-68.5-34.9 0-65.8 26.3-70.1 59.9-.2 3.8-.4 5-.4 8.5-.1 21.1 0 42.8-.8 64.4.9 26.1 1 52.1 0 76.6 0 27.1-19.4 45.5-44.7 45.5-25.3 0-45.8-20.2-45.8-45.5.5-27.7 22.6-45.3 48.5-46.1h.2l26.3-.2V250l-26.3.2c-47.1-.4-84.58 36.5-85.94 83.4 0 45.6 37.54 82.9 83.04 82.9 43 0 78.7-33.6 82.6-75.6l.2-53.5 32.6-.3c25.3.2 25-37.8-.2-37.3l-32.4.3c0-6.4.1-12.8.1-19.2.1-12.7.1-25.4-.1-38.2.1-16.5 15.8-31.2 33.2-31.2 17.5 0 35.9 8.7 35.9 31.2 0 3.2-.1 5.1-.3 6.3-1.9 10.5 5.2 20.4 15.7 21.9 10.6 1.5 20.2-6.1 21.2-16.6.6-4.2.7-7.9.7-11.6" })
  }
), f2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14 95.792C14 42.888 56.888 0 109.793 0h164.368c52.905 0 95.793 42.888 95.793 95.792 0 33.5-17.196 62.984-43.243 80.105 26.047 17.122 43.243 46.605 43.243 80.105 0 52.905-42.888 95.793-95.793 95.793h-2.08c-24.802 0-47.403-9.426-64.415-24.891v88.263c0 53.61-44.009 96.833-97.357 96.833C57.536 512 14 469.243 14 416.207c0-33.498 17.195-62.98 43.24-80.102C31.194 318.983 14 289.5 14 256.002c0-33.5 17.196-62.983 43.243-80.105C31.196 158.776 14 129.292 14 95.792m162.288 95.795h-66.495c-35.576 0-64.415 28.84-64.415 64.415 0 35.438 28.617 64.192 64.003 64.414l.412-.001h66.495zm31.378 64.415c0 35.575 28.839 64.415 64.415 64.415h2.08c35.576 0 64.415-28.84 64.415-64.415s-28.839-64.415-64.415-64.415h-2.08c-35.576 0-64.415 28.84-64.415 64.415m-97.873 95.793-.412-.001c-35.386.221-64.003 28.975-64.003 64.413 0 35.445 29.225 64.415 64.931 64.415 36.282 0 65.979-29.436 65.979-65.455v-63.372zm0-320.417c-35.576 0-64.415 28.84-64.415 64.414 0 35.576 28.84 64.415 64.415 64.415h66.495V31.377h-66.495Zm97.873 128.829h66.495c35.576 0 64.415-28.839 64.415-64.415 0-35.575-28.839-64.414-64.415-64.414h-66.495z" })
  }
), U2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M130.22 127.548c.16.01.08.01 0 0m351.42 45.35c-10.61-25.5-32.08-53-48.94-61.73 13.72 26.89 21.67 53.88 24.7 74 .005.138.022.275.05.41-27.58-68.75-74.352-96.47-112.55-156.83-14.992-23.69-10.924-25.23-13.08-24.66l-.12.07c-46.71 25.953-75.335 78.37-82.58 122.74a127.253 127.253 0 0 0-47.93 12.137 6.524 6.524 0 0 0-3.684 7.288 6.157 6.157 0 0 0 3.006 3.995 6.163 6.163 0 0 0 4.979.45l.52-.21a118.728 118.728 0 0 1 49.53-11.32c62.828-.569 97.157 44.024 107.62 62.29-13-9.15-36.35-18.19-58.82-14.28 87.74 43.86 64.2 194.536-57.39 189.2-59.464-2.61-97.07-50.981-100.53-90.8 0 0 11.25-41.95 80.62-41.95 7.5 0 28.93-20.92 29.33-27-.09-2-42.535-18.876-59.09-35.18-8.847-8.713-13.052-12.907-16.77-16.06a70.09 70.09 0 0 0-6.31-4.77 113.05 113.05 0 0 1-.691-59.63c-25.06 11.41-44.55 29.45-58.71 45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.228 3.668-8.15 4.31a168.316 168.316 0 0 0-23.84 20.43c-16.291 16.6-44.132 50.154-55.5 101.23-4.536 20.383-6.76 44.421-6.76 52.3 0 134.7 109.21 243.89 243.92 243.89 120.64 0 223.019-87.227 240.43-202.62 11.572-76.696-14.71-131.068-14.71-131.99" })
  }
), G2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M503.52 241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86 245.86 0 0 0-7.32-41.15c0-.12 0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27 8.27 0 0 0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48 0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07 18.07 0 0 0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63 15.63 0 0 0-1.2-1.8L463.2 119a15.63 15.63 0 0 0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76 248.76 0 0 0-23.51-26.64A186.82 186.82 0 0 0 412 62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49 162.49 0 0 0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254 254 0 0 0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35 236.35 0 0 0-38-4h-10.63a234.62 234.62 0 0 0-45.48 5c-33.59 7.08-63.23 21.24-82.91 39-1.08 1-1.92 1.68-2.4 2.16l-.48.48h.13l-.12.12.12-.12a.12.12 0 0 0 .12-.12l-.12.12a.42.42 0 0 1 .24-.12c14.64-8.76 34.92-16 49.44-19.56l5.88-1.44c.36-.12.84-.12 1.2-.24 1.68-.36 3.36-.72 5.16-1.08.24 0 .6-.12.84-.12C250.94 20.94 319.34 40.14 367 85.61a171.49 171.49 0 0 1 26.88 32.76c30.36 49.2 27.48 111.11 3.84 147.59-34.44 53-111.35 71.27-159 24.84a84.19 84.19 0 0 1-25.56-59 74.05 74.05 0 0 1 6.24-31c1.68-3.84 13.08-25.67 18.24-24.59-13.08-2.76-37.55 2.64-54.71 28.19-15.36 22.92-14.52 58.2-5 83.28a132.85 132.85 0 0 1-12.12-39.24c-12.24-82.55 43.31-153 94.31-170.51-27.48-24-96.47-22.31-147.71 15.36-29.88 22-51.23 53.16-62.51 90.36 1.68-20.88 9.6-52.08 25.8-83.88-17.16 8.88-39 37-49.8 62.88-15.6 37.43-21 82.19-16.08 124.79.36 3.24.72 6.36 1.08 9.6 19.92 117.11 122 206.38 244.78 206.38C392.77 503.42 504 392.19 504 255c-.12-4.52-.24-9.08-.48-13.52" })
  }
), q2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8m0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21m0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51m186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z" })
  }
), W2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7M443.4 128v256L224 512 4.6 384V128L224 0zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1m0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z" })
  }
), E2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4zm25.6 192h-89.6V512H320v-64h64zM0 0v384h128V256h128V128h128V0z" })
  }
), O2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5m159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5" })
  }
), I2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z" })
  }
), N2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153" })
  }
), X2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 48v336c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8v-64c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29v307c0 18-14 32-32 32S0 466 0 448V64c0-18 14-32 32-32s32 14 32 32v13c40-8 64-29 115-29 63 0 87 32 150 32 37 0 56-9 119-32" })
  }
), K2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6zm-30-347.2 12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2z" })
  }
), Q2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23m74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5 9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z" })
  }
), Z2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z" })
  }
), J2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64m146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6z" })
  }
), j2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7m15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8m29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7" })
  }
), Y2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3m-16.3 73.8-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z" })
  }
), _2 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M97.22 96.21c10.36-10.65 16-17.12 16-21.9 0-2.76-1.92-5.51-3.83-7.42a14.81 14.81 0 0 0-8.39-2.84c-8.48 0-20.92 8.79-35.84 25.69C23.68 137 2.51 182.81 3.37 250.34s17.47 117 54.06 161.87C76.22 435.86 90.62 448 100.9 448a13.55 13.55 0 0 0 8.37-3.84c1.91-2.76 3.81-5.63 3.81-8.38 0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165-.15-61.43 21.6-112.4 64.82-154.02Zm142.25 323.86c.58.37.91.55.91.55Zm93.79.55.17-.13c-.19.13-.26.18-.17.13m3.13-158.18c-16.24-4.15 50.41-82.89-68.05-177.17 0 0 15.54 49.38-62.83 159.57-74.27 104.35 23.46 168.73 34 175.23-6.73-4.35-47.4-35.7 9.55-128.64 11-18.3 25.53-34.87 43.5-72.16 0 0 15.91 22.45 7.6 71.13C287.7 364 354 342.91 355 343.94c22.75 26.78-17.72 73.51-21.58 76.55 5.49-3.65 117.71-78 33-188.1-5.99 6.01-13.8 34.2-30.03 30.05M510.88 89.69C496 72.79 483.52 64 475 64a14.81 14.81 0 0 0-8.39 2.84c-1.91 1.91-3.83 4.66-3.83 7.42 0 4.78 5.6 11.26 16 21.9 43.23 41.61 65 92.59 64.82 154.06-.16 68-23 122.63-67.48 165-9.34 8.35-13.18 14.92-13.2 20.55 0 2.75 1.9 5.62 3.81 8.38a13.61 13.61 0 0 0 8.37 3.85c10.28 0 24.68-12.13 43.47-35.79 36.59-44.85 53.14-94.38 54.06-161.87S552.32 137 510.88 89.69" })
  }
), h4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z" })
  }
), c4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m95.75 164.14-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14 35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z" })
  }
), s4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248m0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8m-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58zm183.24 30.72-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03m-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62M136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08" })
  }
), v4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6m0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82m-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z" })
  }
), e4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z" })
  }
), l4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8m-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255z" })
  }
), t4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m179.2 230.4 102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8 230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z" })
  }
), w4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.55 236.05 244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z" })
  }
), g4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11m-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16m133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61M512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z" })
  }
), i4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1" })
  }
), m4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6m-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3m44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9M244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8M97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1m-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7m32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1m-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2" })
  }
), a4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4M365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7m-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7" })
  }
), o4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m503.5 204.6-.7-1.8-69.7-181.78c-1.4-3.57-3.9-6.59-7.2-8.64-2.4-1.55-5.1-2.515-8-2.81-2.9-.295-5.7.083-8.4 1.11-2.7 1.02-5.1 2.66-7.1 4.78-1.9 2.12-3.3 4.67-4.1 7.44l-47 144H160.8l-47.1-144c-.8-2.77-2.2-5.31-4.1-7.43-2-2.12-4.4-3.75-7.1-4.77a18.1 18.1 0 0 0-8.38-1.113 18.4 18.4 0 0 0-8.04 2.793 18.09 18.09 0 0 0-7.16 8.64L9.267 202.8l-.724 1.8a129.57 129.57 0 0 0-3.52 82c7.747 26.9 24.047 50.7 46.447 67.6l.27.2.59.4 105.97 79.5 52.6 39.7 32 24.2c3.7 1.9 8.3 4.3 13 4.3 4.7 0 9.3-2.4 13-4.3l32-24.2 52.6-39.7 106.7-79.9.3-.3c22.4-16.9 38.7-40.6 45.6-67.5 8.6-27 7.4-55.8-2.6-82" })
  }
), n4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M66.4 322.5H16V0h50.4zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368z" })
  }
), r4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z" })
  }
), d4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z" })
  }
), S4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7m-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2" })
  }
), z4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400.1 194.8c-10.9 2.8-19.9 4.3-29.1 7.6-7.3 1.9-14.7 3.9-23.2 6.1l-.6.1c-4.2 1.2-4.6 1.3-8.5-3.2-4.7-5.3-8.1-8.7-14.6-11.9-19.7-9.6-38.7-6.8-56.4 4.7-21.2 13.7-32.1 34-31.8 59.2.3 25 17.4 45.5 41.2 48.9 22 2.8 39.8-4.6 53.8-20.5 2.1-2.6 4-5.3 6.1-8.3.8-1 1.5-2.1 2.3-3.3h-60.1c-6.5 0-8.1-4-5.9-9.3 4-9.7 11.5-25.9 15.9-34 .9-1.8 3.1-5.8 6.9-5.8h101.1c4.5-13.4 11.8-26.9 21.6-39.7 22.7-29.9 49.3-45.5 87.2-52 31.8-5.6 61.7-2.5 88.9 15.9 24.6 16.8 39.8 39.6 43.9 69.5 5.3 42.1-6.9 76.3-36.7 105.6-19.7 20.9-44.9 34-73.9 39.9-5.6 1-11.1 1.5-16.5 2-2.9.2-5.7.5-8.5.8-28.3-.6-54.2-8.7-76-27.4-15.3-13.3-25.9-29.6-31.1-48.5-3.7 7.3-8 14.4-14 21.1-21.6 29.6-50.9 48-87.9 52.9-30.6 4.1-58.9-1.8-83.9-20.5-23-17.5-36.1-40.5-39.5-69.2-4.1-34 5.9-65.4 26.4-91.3 22.2-29 51.5-47.4 87.3-53.9 29.3-6.2 57.3-1.9 82.6 15.3 16.5 10.9 28.3 25.8 36.1 43.9 1.9 2.8.6 4.4-3.1 5.3m-351.8 5.6c-1.25 0-1.56-.6-.94-1.6l6.55-8.4c.62-.9 2.18-1.5 3.43-1.5H168.6c1.2 0 1.5.9.9 1.8l-5.3 8.1c-.6 1-2.2 1.9-3.1 1.9zM1.246 229.1c-1.246 0-1.558-.7-.934-1.6l6.543-8.4c.624-.9 2.182-1.6 3.425-1.6H152.4c1.2 0 1.8 1 1.5 1.9l-2.5 7.5c-.3 1.2-1.5 1.9-2.8 1.9l-147.354.3zm74.474 26.8c-.62.9-.31 1.8.93 1.8l67.95.3c.9 0 2.2-.9 2.2-2.1l.6-7.5c0-1.3-.6-2.2-1.9-2.2H83.2c-1.25 0-2.49.9-3.12 1.9zm501.48-18c-.2-2.6-.3-4.8-.7-7-5.6-30.8-34-48.3-63.6-41.4-29 6.5-47.7 24.9-54.5 54.2-5.6 24.3 6.2 48.9 28.6 58.9 17.2 7.5 34.3 6.6 50.8-1.9 24.6-13.6 38-32.7 39.6-59.5-.1-1.2-.1-2.3-.2-3.3" })
  }
), p4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z" })
  }
), M4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3M448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56M330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3" })
  }
), x4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M339 314.9 175.4 32h161.2l163.6 282.9zm-137.5 23.6L120.9 480h310.5L512 338.5zM154.1 67.4 0 338.5 80.6 480 237 208.8z" })
  }
), H4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.72 215v41.25h57.1a49.66 49.66 0 0 1-21.14 32.6c-9.54 6.55-21.72 10.28-36 10.28-27.6 0-50.93-18.91-59.3-44.22a65.61 65.61 0 0 1 0-41c8.37-25.46 31.7-44.37 59.3-44.37a56.43 56.43 0 0 1 40.51 16.08L176.47 155a101.24 101.24 0 0 0-70.75-27.84 105.55 105.55 0 0 0-94.38 59.11 107.64 107.64 0 0 0 0 96.18v.15a105.41 105.41 0 0 0 94.38 59c28.47 0 52.55-9.53 70-25.91 20-18.61 31.41-46.15 31.41-78.91a133.76 133.76 0 0 0-1.75-21.78Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46 0-39.34 8.34-50.5 24.86l20.85 13.26q11.45-17 31.26-17a34.05 34.05 0 0 1 22.75 8.79 28.14 28.14 0 0 1 9.69 21.23v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44 0-29.65 3.88-39.49 11.77s-14.82 18.31-14.82 31.56a39.74 39.74 0 0 0 13.94 31.27c9.25 8.34 21 12.51 34.79 12.51 16.29 0 29.21-7.3 39-21.89h1v17.72h22.61V250c.07-16.55-4.92-29.66-15.05-39m-19.23 89.3a37.32 37.32 0 0 1-26.57 11.16 28.61 28.61 0 0 1-18.33-6.25 19.41 19.41 0 0 1-7.77-15.63c0-7 3.22-12.81 9.54-17.42s14.53-7 24.07-7c13.16-.16 23.46 2.84 30.8 8.78 0 10.13-3.96 18.91-11.74 26.36m-93.65-142a55.71 55.71 0 0 0-40.51-16.3h-62.67v186.74h23.63V253.1h39c16 0 29.5-5.36 40.51-15.93.88-.89 1.76-1.79 2.65-2.68a54.45 54.45 0 0 0-2.61-76.23Zm-16.58 62.23a30.65 30.65 0 0 1-23.34 9.68H302.7V165h39.63a32 32 0 0 1 22.6 9.23 33.18 33.18 0 0 1 .74 46.26ZM614.31 201l-36.54 91.7h-.45L539.9 201h-25.69L566 320.55l-29.35 64.32H561L640 201Z" })
  }
), V4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M325.3 234.3 104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256zm425.2 225.6-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1z" })
  }
), C4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z" })
  }
), L4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119.1 8 8 119.1 8 256s111.1 248 248 248 248-111.1 248-248S392.9 8 256 8m-70.7 372a124 124 0 0 1 0-248c31.3 0 60.1 11 83 32.3l-33.6 32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9 0-77.2 35.5-77.2 78.1s34.2 78.1 77.2 78.1c32.6 0 64.9-19.1 70.1-53.3h-70.1v-42.6h116.9a109.2 109.2 0 0 1 1.9 20.7c0 70.8-47.5 121.2-118.8 121.2Zm230.2-106.2v35.5H380v-35.5h-35.5v-35.5H380v-35.5h35.5v35.5h35.2v35.5Z" })
  }
), B4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z" })
  }
), u4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4" })
  }
), R4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8m114.6 226.4-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z" })
  }
), $4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0m-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0m72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248m-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z" })
  }
), k4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z" })
  }
), P4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3m142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37M160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5M192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z" })
  }
), F4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M443.427 64H4.571c0 103.26 22.192 180.06 43.418 222.358C112.046 414.135 224 448 225.256 448a312.824 312.824 0 0 0 140.55-103.477c25.907-33.923 53.1-87.19 65.916-145.761H171.833c4.14 36.429 22.177 67.946 45.1 86.944h88.589c-17.012 28.213-48.186 54.4-80.456 69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883h336.147A625.91 625.91 0 0 0 443.427 64" })
  }
), T4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m209.8 391.1-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3 13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6m-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z" })
  }
), A4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4m218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320z" })
  }
), D4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256M316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z" })
  }
), y4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M35.19 171.1c-46.91 46-46.91 122.9 0 169.8L171.1 476.8c46 46.9 122.9 46.9 169.8 0l135.9-135.9c46.9-46.9 46.9-123.8 0-169.8L340.9 35.19c-46.9-46.91-123.8-46.91-169.8 0zM315.5 315.5c-32.9 32.8-86.1 32.8-118.9 0-32.9-32.9-32.9-86.1 0-118.9 32.8-32.9 86-32.9 118.9 0 32.8 32.8 32.8 86 0 118.9" })
  }
), b4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3m478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2M228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z" })
  }
), f4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z" })
  }
), U4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M260.353 254.878 131.538 33.1a2.208 2.208 0 0 0-3.829.009L.3 254.887a2.234 2.234 0 0 0 0 2.235L129.116 478.9a2.208 2.208 0 0 0 3.83-.009l127.412-221.778a2.239 2.239 0 0 0-.005-2.235m39.078-25.713a2.19 2.19 0 0 0 1.9 1.111h66.509a2.226 2.226 0 0 0 1.9-3.341L259.115 33.111a2.187 2.187 0 0 0-1.9-1.111h-66.508a2.226 2.226 0 0 0-1.9 3.341ZM511.7 254.886 384.9 33.112A2.2 2.2 0 0 0 382.99 32h-66.6a2.226 2.226 0 0 0-1.906 3.34L440.652 256 314.481 476.66a2.226 2.226 0 0 0 1.906 3.34h66.6a2.2 2.2 0 0 0 1.906-1.112L511.7 257.114a2.243 2.243 0 0 0 0-2.228m-145.684 30.031h-66.508a2.187 2.187 0 0 0-1.9 1.111l-108.8 190.631a2.226 2.226 0 0 0 1.9 3.341h66.509a2.187 2.187 0 0 0 1.9-1.111l108.8-190.631a2.226 2.226 0 0 0-1.901-3.341" })
  }
), G4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144.5 352 38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3m408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9m-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6m-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z" })
  }
), q4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z" })
  }
), W4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 0c0 131.6-80.7 176.8-140.2 209.4-.6.3-1.1.6-1.6.9-53.8 30.2-88.7 49.8-89.6 122H32c0-131.5 80.7-176.7 140.2-209.3C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4" })
  }
), E4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z" })
  }
), O4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 32 34.9 395.8L191.5 480l157.6-52.2L384 32zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z" })
  }
), I4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69" })
  }
), N4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M125.61 165.48a49.07 49.07 0 1 0 49.06 49.06 49.08 49.08 0 0 0-49.06-49.06M86.15 425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53h-14.05v45.79h14.05c9.75 0 18.74-2.81 18.74-23.26Zm201.69 46v-91.31h22.75v68.57h33.69C486.5 113.08 388.61 86.19 299.67 86.19h-94.83V169h14c25.6 0 41.5 17.35 41.5 45.26 0 28.81-15.52 46-41.5 46h-14v165.62h94.83c144.61 0 194.94-67.16 196.72-165.64Zm-109.75 0H273.3V169h54.43v22.73H296v10.58h30V225h-30v12.5h33.51Zm74.66 0-5.16-17.67h-29.74l-5.18 17.67h-23.66L368 168.92h32.35l27.53 91.34ZM299.65 32H32v448h267.65c161.85 0 251-79.73 251-224.52C550.62 172 518 32 299.65 32m0 426.92H53.07V53.07h246.58c142.1 0 229.9 64.61 229.9 202.41 0 134.09-81 203.44-229.9 203.44m83.86-264.85L376 219.88h16.4l-7.52-25.81Z" })
  }
), X4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M89.5 323.6H53.93V186.2H89.5zm66.6-73.1 9.1-64.3h46.3v137.4h-31v-92.7l-13.4 92.7h-21.3l-13-90.7-.1 90.7h-31.2V186.2h46.1c.5 8.3 2.8 18.1 4.3 29.4zm67.6 73.1V186.2h26.6c17 0 27 .9 33 2.4 6.1 1.7 10.7 4.2 13.9 7.9 3.1 3.3 5.1 6.6 5.8 12 .9 4.4 1.4 13.1 1.4 26.2v48.2c0 12.3-.7 20.5-1.9 24.7-1.1 4.1-3.1 7.4-6 9.7-2.8 2.4-6.4 4.1-10.7 5-4.2.8-10.6 1.3-19.1 1.3zm35.5-113.9v89.4c5.1 0 8.3-1 9.4-2.3 1.1-2 1.8-7.6 1.8-16.7v-53.3c0-6.2-.1-10.2-.7-12-.3-1.8-1.2-3-2.6-4.7-1.4 0-4.1-.4-7.9-.4m57.3 113.9V186.2h34.1v43.9c2.9-2.4 6.1-4.9 9.5-6.6 3.6-1.5 8.8-2.4 12.8-2.4 4.8 0 8.9.8 12.3 2.2 3.4 1.5 6 3.5 8 6.2 1.7 2.6 2.7 5.3 3.1 7.8.4 2.6-.2 8-.2 16.2v38.6c0 8.2.2 14.3-.8 18.4-1.1 4-3.8 7.6-7.8 9.6-4.1 3.9-8.9 5.3-14.6 5.3-4 0-9.2-.9-12.7-2.5-3.5-1.8-6.7-4.5-9.6-8l-2.1 8.7zm45.1-20.7c.7-1.8 1-6 1-12.5V255c0-5.6-.3-9.5-1.1-11.2-.7-1.9-3.7-2.7-5.8-2.7-2 0-3.4.8-4.1 2.3-.6 1.5-1 5.4-1 11.6v36.4c0 6.1.4 10 1.2 11.6.6 1.7 2.1 2.5 4.1 2.5 2.2 0 4.2-.8 5.7-2.6m56.8-270.86c15.7 1.23 28.7 15.24 28.7 31.88V448.1c0 16.4-11.9 30.4-28.2 31-.3 0-.5.9-.8.9H29.88c-.28 0-.56-.9-.84-.1C13.31 478.5 1.093 466.1 0 449.7L.019 61.78C1.08 45.88 13.82 33.09 30.26 31.1H417.7c.2 0 .5.91.7.94M30.27 41.26C19 42.01 10.02 51.01 9.257 62.4v387.3c.373 5.4 2.653 10.5 6.443 14.3 3.78 3.9 8.81 6.3 14.19 6.7H418.1c11.5-1 20.6-11.6 20.6-22.6V63.91c0-5.74-2.1-11.26-6-15.46-3.9-4.21-9.3-6.78-15-7.19H30.27" })
  }
), K4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141m0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8m76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1" })
  }
), Q4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M153.384 480h233.729l115.441-204.235-298.325 57.446Zm351.342-239.922L387.113 32H155.669L360.23 267.9ZM124.386 48.809 7.274 256l115.962 205.154 102.391-295.593Z" })
  }
), Z4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56m-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1M59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3" })
  }
), J4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z" })
  }
), j4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52" })
  }
), Y4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24m-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48m-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24" })
  }
), _4 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z" })
  }
), h3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z" })
  }
), c3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32M223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444" })
  }
), s3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1m-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4M124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8" })
  }
), v3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z" })
  }
), e3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2M226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4M57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5m7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1M222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3m299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6m-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z" })
  }
), l3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90-76-75.7 76-75.7 76 75.7z" })
  }
), t3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9m183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z" })
  }
), w3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4 44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z" })
  }
), g3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z" })
  }
), i3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z" })
  }
), m3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304.2 501.5 158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z" })
  }
), a3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18m111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92M142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17m148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18" })
  }
), o3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m63.8 409.3 60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8M256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3M256 160" })
  }
), n3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185z" })
  }
), r3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48M199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z" })
  }
), d3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34M87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z" })
  }
), S3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504.4 115.83a5.72 5.72 0 0 0-.28-.68 8.52 8.52 0 0 0-.53-1.25 6 6 0 0 0-.54-.71 9.36 9.36 0 0 0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84 8.84 0 0 0-.9-.68L404.4 55.55a8 8 0 0 0-8 0L300.12 111a8.07 8.07 0 0 0-.88.69 7.68 7.68 0 0 0-.78.6 8.23 8.23 0 0 0-.72.93c-.17.24-.39.45-.54.71a9.7 9.7 0 0 0-.52 1.25c-.08.23-.21.44-.28.68a8.08 8.08 0 0 0-.28 2.08v105.24l-80.22 46.19V63.44a7.8 7.8 0 0 0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35 8.35 0 0 0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36 9.36 0 0 0-.72-.94 9.46 9.46 0 0 0-.78-.6 9.8 9.8 0 0 0-.88-.68L115.61 1.07a8 8 0 0 0-8 0L11.34 56.49a6.52 6.52 0 0 0-.88.69 7.81 7.81 0 0 0-.79.6 8.15 8.15 0 0 0-.71.93c-.18.25-.4.46-.55.72a7.88 7.88 0 0 0-.51 1.24 6.46 6.46 0 0 0-.29.67 8.18 8.18 0 0 0-.28 2.1v329.7a8 8 0 0 0 4 6.95l192.5 110.84a8.83 8.83 0 0 0 1.33.54c.21.08.41.2.63.26a7.92 7.92 0 0 0 4.1 0c.2-.05.37-.16.55-.22a8.6 8.6 0 0 0 1.4-.58L404.4 400.09a8 8 0 0 0 4-6.95V287.88l92.24-53.11a8 8 0 0 0 4-7V117.92a8.63 8.63 0 0 0-.24-2.09M111.6 17.28l80.19 46.15-80.2 46.18-80.18-46.17Zm88.25 60V278.6l-46.53 26.79-33.69 19.4V123.5l46.53-26.79Zm0 412.78L23.37 388.5V77.32L57.06 96.7l46.52 26.8v215.18a6.94 6.94 0 0 0 .12.9 8 8 0 0 0 .16 1.18 5.92 5.92 0 0 0 .38.9 6.38 6.38 0 0 0 .42 1 8.54 8.54 0 0 0 .6.78 7.62 7.62 0 0 0 .66.84c.23.22.52.38.77.58a8.93 8.93 0 0 0 .86.66l92.19 52.18Zm8-106.17-80.06-45.32 84.09-48.41 92.26-53.11 80.13 46.13-58.8 33.56Zm184.52 4.57L215.88 490.11V397.8l130.72-74.6 45.77-26.15Zm0-119.13L358.68 250l-46.53-26.79v-91.42l33.69 19.4L392.37 178Zm8-105.28-80.2-46.17 80.2-46.16 80.18 46.15Zm8 105.28V178L455 151.19l33.68-19.4v91.39Z" })
  }
), z3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m225.8 367.1-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z" })
  }
), p3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m386.539 111.485 15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859zm-43.368-44.741-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486" })
  }
), M3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8" })
  }
), x3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5L254 230v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7v-81.3c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4.6 3 1.6l37.3 50.3v-48.2c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7v-81.3c0-1.9-1.6-3.7-3.7-3.7m-31.4 68.1h-35.6v-64.4c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5.7.6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1h-52.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344v-13.6h35.5c2.1 0 3.7-1.6 3.7-3.7v-13.1c0-2.1-1.6-3.7-3.7-3.7H344v-13.7h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4v326c-.1 51.2-42.1 92.7-93.4 92.6h-326C41.4 511.9-.1 469.8 0 418.6v-326C.1 41.4 42.2-.1 93.4 0h326c51.2.1 92.7 42.1 92.6 93.4m-70.4 140.1c0-83.4-83.7-151.3-186.4-151.3S68.8 150.1 68.8 233.5c0 74.7 66.3 137.4 155.9 149.3 21.8 4.7 19.3 12.7 14.4 42.1-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z" })
  }
), H3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" })
  }
), V3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" })
  }
), C3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m366.036 186.867-59.5 36.871-.838 36.871-29.329-19.273-39.384 24.3c2.238 55.211 2.483 59.271 2.51 59.5l-97.2 65.359-15.081-104.747 108.1-62.01-40.224-25.977-75.417 38.547-20.95-143.293 129.048-49.441L136.432 0 10.737 39.385 38.39 174.3l41.9 32.681-31.845 15.081 20.949 101.395 29.329 27.653-20.949 12.569 16.76 78.769L160.733 512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57 15.083-10.894 15.083-10.894l.838 24.3 33.519 28.491-.838-77.093 46.927-33.519 26.815-18.435-2.514 36.033 25.139 17.6 6.7-74.579 58.657-43.575Z" })
  }
), L3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7M223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8M183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6M173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z" })
  }
), B3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1z" })
  }
), u3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0zM255.6 420.5 224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z" })
  }
), R3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4M323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z" })
  }
), $3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z" })
  }
), k3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z" })
  }
), P3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5m-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z" })
  }
), F3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z" })
  }
), T3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.37 160.41 7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z" })
  }
), A3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1" })
  }
), D3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.5 74.262C80.813 74.262 0 155.633 0 256s80.819 181.738 180.5 181.738S361 356.373 361 256 280.191 74.262 180.5 74.262m288.25 10.646c-49.845 0-90.245 76.619-90.245 171.095s40.406 171.1 90.251 171.1 90.251-76.619 90.251-171.1H559c0-94.503-40.4-171.095-90.248-171.095Zm139.506 17.821c-17.526 0-31.735 68.628-31.735 153.274s14.2 153.274 31.735 153.274S640 340.631 640 256c0-84.649-14.215-153.271-31.742-153.271Z" })
  }
), y3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" })
  }
), b3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8m143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2m272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4m-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3m372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9m39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6M447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2m-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6" })
  }
), f3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8m145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z" })
  }
), U3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3m-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8" })
  }
), G3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 317.9c0 91.3-39.4 148.5-110.3 148.5-62.6 0-95.8-34.6-156.9-136.6l-31.4-52.6c-8.3-12.5-14.5-24.2-21.2-35-20.1 33.8-47.1 83-47.1 83-67 116.6-104.6 141.2-156.9 141.2C43.42 466.4 0 409.1 0 320.5c0-143 79.78-278.1 183.9-278.1 50.2 0 93.8 24.68 144.8 89.5 37.1-50.1 78.1-89.5 130.6-89.5 99.1 0 180.7 125.7 180.7 275.5M287.4 192.2c-42.9-62.1-70.9-80.5-104.4-80.5-61.9 0-113.78 106.1-113.78 210 0 48.5 18.48 75.7 49.58 75.7 30.2 0 49-19 103.2-103.8 0 0 24.7-39.1 65.4-101.4m243.8 205.2c32.2 0 46.9-27.5 46.9-74.9 0-124.2-54.3-225.42-123.2-225.42-33.2 0-61.1 25.92-94.9 78.02 9.4 13.8 19.1 29 29.3 45.4l37.5 62.4c58.7 94.1 73.5 114.5 104.4 114.5" })
  }
), q3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M399.36 362.23c29.49-34.69 47.1-78.34 47.1-125.79C446.46 123.49 346.86 32 224 32S1.54 123.49 1.54 236.44 101.14 440.87 224 440.87a239.28 239.28 0 0 0 79.44-13.44 7.18 7.18 0 0 1 8.12 2.56c18.58 25.09 47.61 42.74 79.89 49.92a4.42 4.42 0 0 0 5.22-3.43 4.37 4.37 0 0 0-.85-3.62 87 87 0 0 1 3.69-110.69ZM329.52 212.4l-57.3 43.49L293 324.75a6.5 6.5 0 0 1-9.94 7.22L224 290.92 164.94 332a6.51 6.51 0 0 1-9.95-7.22l20.79-68.86-57.3-43.49a6.5 6.5 0 0 1 3.8-11.68l71.88-1.51 23.66-67.92a6.5 6.5 0 0 1 12.28 0l23.66 67.92 71.88 1.51a6.5 6.5 0 0 1 3.88 11.68Z" })
  }
), W3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h214.6v214.6H0zm233.4 0H448v214.6H233.4zM0 265.4h214.6V480H0zm233.4 0H448V480H233.4z" })
  }
), E3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64z" })
  }
), O3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M212.98 346.566h-33.191V195.114l6.184-21.644h-10.711l-38.135 173.096h-61.02L37.732 173.47H27.276l5.915 21.644v151.452H0V165h65.65l36.598 173.096h8.499L147.329 165h65.651zm331.479-62.977-86.025 62.066v-38.121l72.895-51.758-72.895-51.759v-38.121l86.025 62.335h9.262L640 165.896v38.121l-73.134 51.759L640 307.549v38.106l-86.279-62.066zm-114.302-11.278H248.113v-33.056h182.044z" })
  }
), I3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M114.57 76.07a45.71 45.71 0 0 0-67.51-6.41c-17.58 16.18-19 43.52-4.75 62.77l91.78 123-92.33 124.15c-14.23 19.25-13.11 46.59 4.74 62.77a45.71 45.71 0 0 0 67.5-6.41L242.89 262.7a12.14 12.14 0 0 0 0-14.23Zm355.67 303.51-92.33-124.13 91.78-123c14.22-19.25 12.83-46.59-4.75-62.77a45.71 45.71 0 0 0-67.51 6.41l-128 172.12a12.14 12.14 0 0 0 0 14.23L398 435.94a45.71 45.71 0 0 0 67.51 6.41c17.84-16.18 18.96-43.52 4.73-62.77" })
  }
), N3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8m-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40z" })
  }
), X3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m356 241.8 36.7 23.7V480l-133-83.8zM440 75H226.3l-23 37.8 153.5 96.5zm-89 142.8L55.2 32v214.5l46 29zM97 294.2 8 437h213.7l125-200.5z" })
  }
), K3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80z" })
  }
), Q3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4m-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4m169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z" })
  }
), Z3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61 80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53z" })
  }
), J3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M211.8 488.6c1.6 2.5 2.1 5.6 1.4 8.5-.6 2.9-2.4 5.5-4.9 7.1-2.6 1.6-5.6 2.1-8.6 1.5-61.4-13.9-115.6-49.9-152.17-101.2C10.97 353.2-5.395 290.3 1.57 227.7 8.536 165 38.34 107.2 85.29 65.21 132.2 23.2 193-.013 256 0c1.5 0 2.1.293 4.3.863 1.4.569 1.8 1.404 3.7 2.456 1.1 1.052 1.9 2.3 2.5 3.674.5 1.374.8 2.846.8 4.327V112.3l24.5-25.91c1-1.08 2.2-1.95 3.6-2.55 1.3-.61 2.8-.94 4.3-.98 1.5-.05 2.9.2 4.3.73s2.7 1.33 3.8 2.35c1 1.02 1.9 2.24 2.5 3.6.6 1.35 1 2.81 1 4.3 0 1.48-.2 2.96-.7 4.34-.6 1.39-1.4 2.62-2.4 3.72l-44 46.6c-1.1 1.1-2.3 2-3.7 2.6-1.5.6-3 .9-5.4.9-.6 0-2.2-.3-3.6-.9-1.4-.6-2.7-1.5-3.7-2.6l-44.1-46.6c-2-2.16-3.1-5.07-3-8.06 0-3 1.3-6.74 3.5-7.9 2.2-2.06 5.1-3.17 8.1-3.08 3 .08 5.8 1.35 7.9 3.53l24.5 26.01V22.89c-56.4 2.75-109.8 25.84-150.47 64.98C53.58 127 28.49 179.6 23.61 235.8a233.509 233.509 0 0 0 44.07 157.9c32.42 45.5 82.02 77.5 137.02 89.9 2.9.7 5.5 2.5 7.1 5m-40.4-362.5c-.8 1.3-1.9 2.4-3.1 3.2-20.5 13.9-37.2 32.6-48.8 54.5-11.6 21.9-17.7 46.3-17.7 71.1 0 24.8 6.1 49.2 17.7 70.2 11.6 22.8 28.3 41.5 48.8 55.4 2.5 1.7 4.2 4.3 4.7 7.3.6 2.9-.9 6-1.7 8.4-1.7 2.5-5.2 4.2-7.3 3.9-2.9 1.4-6 .8-8.4-.9-23.6-16-42.8-37.5-56.14-62.7-13.31-25.1-20.27-53.1-20.27-81.6 0-28.4 6.96-56.5 20.27-81.6 13.34-25.2 32.54-46.7 56.14-62.7 1.2-.8 2.6-1.4 4-1.8 1.5-.3 3-.3 4.5 0 1.4.2 2.8.8 4.1 1.6 1.3.8 2.3 1.9 3.2 3.1.8 1.2 1.4 2.6 1.7 4.1.3 1.5.3 3 0 4.4-.3 1.5-.8 2.9-1.7 4.1m169.5 257.4c.8-1.2 1.9-2.3 2.2-3.1v-.1c21.3-14 38-32.7 49.6-54.6 11.5-21.8 17.5-46.2 17.5-70.9 0-24.7-6-49.1-17.5-71-11.6-22.7-28.3-40.5-49.6-54.5-.3-.8-1.4-1.9-2.2-3.1-.8-1.3-1.4-2.7-1.6-4.1-1.2-1.5-.3-3 0-4.4.3-1.5.9-2.9 1.7-4.1.9-1.2 1.1-2.3 3.2-3.1 1.2-.8 2.6-1.3 4.1-1.6 1.5-.3 2.9-.3 4.4 0 1.5.3 2.8.9 4.1 1.8 23.4 16 42.7 37.5 55.9 62.6 13.3 25.1 19.4 53.1 19.4 81.5 0 28.5-6.1 56.5-19.4 81.6-13.2 25.1-32.5 46.6-55.9 62.6-1.3.9-2.6 1.5-4.1 1.8-1.5.3-2.9.3-4.4 0-1.5-.3-2.9-1.7-4.1-1.6-2.1-.8-2.3-1.9-3.2-3.1-.8-1.2-1.4-2.6-1.7-4.1-.3-1.4-1.2-2.9 0-4.4.2-1.4.8-2.8 1.6-4.1M312.3 6.307C368.5 19.04 418.7 50.28 455 95.01 485.4 132.6 504.6 178 510.3 226c5.6 48-2.4 96.7-23.2 140.3-20.9 43.6-53.6 80.5-94.5 106.3C351.7 498.3 304.4 512 256 512c-1.5 0-2.9-.3-4.3-.9-1.4-.5-2.6-1.4-3.7-2.4-1.9-1.1-1.9-2.3-2.4-3.7-.6-1.4-.9-2.8-.9-4.3v-99.2l-24.5 26c-2.1 2.2-4.9 2.6-7.9 3.6-3 .1-5.9-1.1-8.1-4-2.2-1.2-3.5-4-3.5-7-.1-3 1-5.9 3-8.1l44.1-46.6c1.3-2.2 5.1-3.4 7.3-3.4 4 0 6.9 1.2 9.1 3.4l44 46.6c2.1 2.2 3.2 5.1 3.1 8.1-.1 3-1.4 5.8-3.5 7-2.2 2.9-5.1 4.1-8.1 4-3-1-5.9-1.4-7.9-3.6l-24.5-25.9v87.5c56.4-2.8 109.8-25.8 150.5-65 40.7-40 65.8-91.7 70.7-147.9 4.8-57.1-10.8-112.3-44.1-157.9-33.3-45.55-82-77.51-137-89.94-1.5-.33-2.8-.94-4.1-1.79-1.2-.86-2.2-1.94-3-3.2-.8-1.25-2.2-2.65-1.6-4.11-.2-1.46-.2-2.96.1-4.41.4-1.44 1-2.81 1.8-4.03.9-1.21 2-2.243 3.2-3.036 1.3-.794 2.7-1.333 4.1-1.586 1.5-.253 3-.216 4.4.109M353.1 256.1c0 31.4-17.5 61.1-49.3 83.5-2.1 1.5-4.8 2.3-7.4 2-2.7-.2-5.2-1.3-7-3.2l-70.1-69.8c-2.2-2.1-4.2-5-3.4-8 0-3 1.2-5.9 3.3-8 2.2-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3l63.1 62.8c20.8-17.1 32.2-37.9 32.2-59.3 0-23.9-14.1-47-39.7-65.1-2.5-1.7-4.1-4.3-4.6-7.3-.5-2.9.1-6 1.9-8.4 1.7-2.5 4.3-4.1 7.3-4.6 2.9-.5 6 .1 8.4 1.9 31.8 22.4 49.3 52.1 49.3 83.5m-136.4 85.4c-3 .5-6-.2-8.5-1.9-31.7-22.4-50.1-52.1-50.1-83.5s18.4-61.1 50.1-83.5c2.2-1.6 4.9-2.3 7.5-2.1 2.7.3 5.1 1.4 7 3.3l70.1 69.8c2.1 2.1 3.3 5 3.3 8s-2 5.8-3.3 8c-2.1 2.1-5 3.3-7.9 3.3-3 0-6.8-1.2-8-3.3l-63.1-62.9c-20.9 17.3-32.2 38-32.2 59.4 0 23 14.1 47 39.7 65 2.4 1.8 4.1 4.4 4.6 7.4.5 2.9-.2 5.9-1.9 8.4-1.7 2.4-4.4 4.1-7.3 4.6" })
  }
), j3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392.9 32.43c7.7-1.33 15.7.46 21.2 4.98C498.2 96.14 544 173.7 544 255.1c0 83.1-45.8 160.8-129.9 219.5-4.8 4-11.7 5.9-18.6 5.3-7-.6-13.5-3.6-18.4-8.5L193.7 288.7c-5.6-5.5-8.7-13-9.6-20.9 0-7.8 4-15.3 9.5-20.9 5.6-5.5 13.1-8.7 20.9-8.7 7.9 0 15.4 3.1 20.9 8.6l165.1 164.4c54.6-44.7 84.3-99.2 84.3-156.1 0-61.6-36.9-122.2-103.9-169.34-6.4-4.52-10.8-11.41-12.1-19.14-1.4-7.73.4-15.68 5-22.09 4.5-6.41 11.4-10.76 19.1-12.1m-206 447.17c-7.7 1.3-15.6-.5-22.1-5C81.67 415.9 35.84 338.2 35.84 255.1c0-81.4 45.83-158.96 128.96-217.69 5.7-4.01 12.6-5.88 19.6-5.29 6.9.59 13.4 3.6 18.3 8.51L386.1 223.3c5.6 5.5 8.7 13 8.7 20.9.1 6.9-3 15.3-8.6 20.9-5.5 5.5-13 8.7-20.9 8.7-7.8 0-16.2-3.1-20.9-8.6L179.3 100.7c-54.6 45.2-84.27 99.2-84.27 154.4 0 63.4 36.87 124 103.07 171.1 7.3 4.6 11.6 11.4 13 19.2 1.3 7.7-.5 15.7-5 22.1-4.5 6.4-11.4 10.7-19.2 12.1" })
  }
), Y3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27M113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159m0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z" })
  }
), _3 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2m149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z" })
  }
), h0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1m-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4m-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7m-74.3-124.9-.8.5h1.1l-.3-.5zm76.2 130.2-.4-.7v.9l.4-.2" })
  }
), c0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 288h-32v-64h32zm288-128v192H288v32H160v-32H0V160zm-416 32H32v128h64v-96h32v96h32zm160 0H192v160h64v-32h64zm224 0H352v128h64v-96h32v96h32v-96h32v96h32z" })
  }
), s0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104.324 269.172h26.067v-26.178h-26.067Zm52.466-26.178-.055-26.178v-.941a39.325 39.325 0 0 0-78.644.941v.166h26.4v-.166a12.98 12.98 0 0 1 25.956 0v26.178Zm52.356 25.846a91.1 91.1 0 0 1-91.1 91.1h-.609a91.1 91.1 0 0 1-91.1-91.1H0v.166A117.33 117.33 0 0 0 117.44 386.28h.775A117.331 117.331 0 0 0 235.49 268.84v-26.012h-26.344Zm-157.233 0a65.362 65.362 0 0 0 130.723 0h-26.344a39.023 39.023 0 0 1-78.035 0v-25.957H51.968v-26.62A65.42 65.42 0 0 1 182.8 217.48v25.293h26.344V217.48a91.761 91.761 0 0 0-183.522 0v25.4h26.291Zm418.4-71.173c13.67 0 24.573 6.642 30.052 18.264l.719 1.549 23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134 0-43.611 11.4-50.972 28.447-.123 26.876-.158 23.9 0 24.85 4.7 11.013 14.555 19.37 28.668 24.241a102.033 102.033 0 0 0 19.813 3.984c5.479.72 10.626 1.384 15.829 3.1 6.364 2.1 10.46 5.257 12.84 9.851v9.851c-3.708 7.527-13.781 12.342-25.791 12.342-14.334 0-25.956-6.918-31.933-19.039l-.72-1.494-23.021 11.507.553 1.439c7.915 19.426 29.609 32.044 55.289 32.044 23.632 0 44.608-11.4 52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777 83.777 0 0 1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412c3.377-7.357 12.896-12.117 24.242-12.117ZM287.568 311.344h26.067v-68.4h-26.067Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99 37.99 0 0 0 637.4 226l.166-25.347-.166-.664c-7.362-15.989-26.733-26.729-48.15-26.729S548.461 184 541.1 199.992l-.166 25.347.166.664a39.643 39.643 0 0 0 13.006 15.331c-7.2 4.7-12.508 10.46-15.441 16.714l-.166 28.889.166.72c7.582 15.994 27.893 26.731 50.585 26.731s43.057-10.737 50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31 12.563-10.516 22.58-10.516s19.038 4.206 22.636 10.516v13.725c-3.542 6.2-12.563 10.349-22.636 10.349s-19.094-4.15-22.58-10.349Zm47.319 72.169c-3.764 6.641-13.338 10.9-24.683 10.9-11.125 0-20.976-4.372-24.684-10.9V263.25c3.708-6.309 13.5-10.515 24.684-10.515 11.345 0 20.919 4.15 24.683 10.515ZM376.4 265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539 94.085H402.3V176.249h-25.9Z" })
  }
), v0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28M192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28M264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28M336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28m24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8" })
  }
), e0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M455.6 349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16 134.04 415.967 34.14 329.93 8.3 237.04-19.6 134.252 24.341 99.677 117.147a180.862 180.862 0 0 0-10.988 73.544c1.733 29.543 14.717 52.97 24.09 80.3 17.2 50.161-28.1 92.743-66.662 117.582-46.806 30.2-36.319 39.857-8.428 41.858 23.378 1.68 44.478-4.548 65.265-15.045 9.2-4.647 40.687-18.931 45.13-28.588-12.184 26.59-36.962 72.702-21.463 102.102 19.1 36.229 67.112-31.77 76.709-45.812 8.591-12.572 42.963-81.279 63.627-46.926 18.865 31.361 8.6 76.391 35.738 104.622 32.854 34.2 51.155-18.312 51.412-44.221.163-16.411-6.1-95.852 29.9-59.944 21.421 21.381 52.905 71.181 88.561 67.023 38.736-4.516-22.123-67.967-28.262-78.695 5.393 4.279 53.665 34.128 53.818 9.52.11-18.789-30.085-34.667-42.524-45.267" })
  }
), l0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1M30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z" })
  }
), t0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M406.7 463c-42.3 30.8-94.4 49-150.7 49-111.1 0-205.7-70.8-241.1-169.8 2.4 1.7 5.9 3.6 7.9 4.4 16.3 7.4 40.1-5.4 62.9-28.7 6.9-6.9 14.4-12.4 22.8-17.3 18.3-11.9 37.6-20.8 58.4-27.2 0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1-11-.5-70-3-56 51.1 14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4.8 4.6 1.1 9.9 1.4 15.5 1.1 21.2 2.3 45.6 35.3 46.4 5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5 1-2.5 3-3.5 5-3s3.5 3 3 5-2.5 3.5-5 3m-207-95.6c1.5-.5 3.5 1 4 3 0 2-1 4-3 4-1.5.5-3.5-1-4-3-.5-1.5 1-3.5 3-4M451.8 421c37.5-44.6 60.2-102.2 60.2-165 0-67.5-26.1-128.9-68.8-174.7-.1 23.5-6.1 48.2-16.8 69.2-11.9 20.3-49 58.9-69.8 78.7-.7.3-1.1.9-1.5 1.4-.2.2-.3.4-.5.6-5 6.9-4 16.8 3 21.8 21.3 15.8 56.4 45.6 59.4 72.8 3.5 34.9 27.9 75.6 34.2 86.2.8 1.3 1.3 2.1 1.4 2.4 0 2.2-.4 4.3-.8 6.5zm-61.1-170c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3M395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4-.3 1.4-.7 2.8-1 4.2-9.5 38.5-30.6 37.6-41.7 37.2-1.1 0-2-.1-2.9-.1-5.1 0-6-4-8.9-17.1-2.6-12.1-6.9-32-17.9-63.6-22.7-65.8-82.7-49.4-128.2-22.2-55.3 33.1-34.4 101.9-19.8 149.4.7 2.2 1.4 4.4 2 6.6-4 4-13.8 7.5-26 11.9-12.1 4.3-26.6 9.5-40.3 16.9-33.9 18-70.3 49-79.8 62.6C.7 277.8 0 267 0 256 0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4 4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4M327.3 64.9c2-1.5 5-.5 6.4 1.5 1.5 2.5 1 5.4-1.5 6.4-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4M95.1 105c-.5 1.5.5 3 2 3 1.5.5 3-.5 3-2 .5-1.5-.5-3-2-3s-3 .5-3 2m84.7-.5c-3.5-43.1 37.1-54 37.1-54 44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5 2-6.9 1-14.4-2-20.8-1.5-2-4-3.5-6.4-2.5-3 1-4.5 4-3.5 6.9 2 4.5 3 9.9 1.5 14.9-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3.3-.2.1-.4.2-.6.2z" })
  }
), w0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z" })
  }
), g0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8m-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z" })
  }
), i0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m271.5 432-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8z" })
  }
), m0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364" })
  }
), a0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7m9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1m-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7m-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53m10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5M372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5M74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8M68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z" })
  }
), o0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57M300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369" })
  }
), n0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z" })
  }
), r0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m297.9 0 .1.001c7.6.107 14.4 4.719 17.5 11.779l132 308.52.3-.1.2.4-2.8 10-42.9 158c-3.7 16.2-19.7 26.3-35.8 22.6l-68.4-15.6-68.5 15.6c-16.1 3.7-32.1-6.4-35.8-22.6l-42.9-158-2.7-10 .1-.4L280.4 11.78c3-6.983 9.9-11.596 17.5-11.78zM160.1 322.1l131 39.1 6.9 122.5 7.9-121.5 130.6-39.3.2-.1-131 25.1-8.6-320.18-5.2 320.18zM426 222.6l94.4-41h73.8l-157 247.6 31.6-109zm171.5-41.2 41.4 76.2c4 7.5-3.9 15.9-11.6 12.2l-47.6-22.7zM127.3 318.5 158.7 430 1.61 154.5c-5.902-10.4 5.518-22 15.94-16.2l151.85 84.2z" })
  }
), d0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248zm0-143.6V146.8L98.6 360.4zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7zm57.4-138.2-21.2 8.4 21.2 8.3zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256M360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9m-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z" })
  }
), S0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z" })
  }
), z0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1" })
  }
), p0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8M0 501.5h90v-491H0z" })
  }
), M0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z" })
  }
), x0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M305.314 284.578H246.6V383.3h58.711q24.423 0 38.193-13.77t13.77-36.11q0-21.826-14.032-35.335t-37.928-13.507M149.435 128.7H90.724v98.723h58.711q24.42 0 38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435 128.7M366.647 32H81.353A81.445 81.445 0 0 0 0 113.352v285.295A81.445 81.445 0 0 0 81.353 480h285.294A81.445 81.445 0 0 0 448 398.647V113.352A81.445 81.445 0 0 0 366.647 32m63.635 366.647a63.706 63.706 0 0 1-63.635 63.635H81.353a63.706 63.706 0 0 1-63.635-63.635V113.352a63.706 63.706 0 0 1 63.635-63.634h285.294a63.706 63.706 0 0 1 63.635 63.634ZM305.314 128.7H246.6v98.723h58.711q24.423 0 38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314 128.7" })
  }
), H0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4" })
  }
), V0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m323 262.1-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z" })
  }
), C0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z" })
  }
), L0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7" })
  }
), B0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3M97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z" })
  }
), u0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1M340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9m-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4 24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9 2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z" })
  }
), R0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z" })
  }
), $0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48M185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8m158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6" })
  }
), k0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M455.93 23.2c-26.7 6.8-68.14 28.49-114.58 67.46A206 206 0 0 0 240 64C125.13 64 32 157.12 32 272s93.13 208 208 208 208-93.13 208-208a207.25 207.25 0 0 0-58.75-144.81 155.35 155.35 0 0 0-17 27.4A176.16 176.16 0 0 1 417.1 272c0 97.66-79.44 177.11-177.09 177.11a175.81 175.81 0 0 1-87.63-23.4c82.94-107.33 150.79-37.77 184.31-226.65 5.79-32.62 28-94.26 126.23-160.18 8.08-5.43 2.43-18.08-6.99-15.68M125 406.4A176.66 176.66 0 0 1 62.9 272c0-97.66 79.45-177.1 177.1-177.1a174 174 0 0 1 76.63 17.75C250.64 174.76 189.77 265.52 125 406.4" })
  }
), P0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5" })
  }
), F0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248" })
  }
), T0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M242.4 292.5c5.4-5.4 14.7-5.4 20.1 0l77 77c14.2 14.2 33.1 22 53.1 22h15.1l-97.1 97.1c-30.3 29.5-79.5 29.5-109.8 0l-97.5-97.4h9.3c20 0 38.9-7.8 53.1-22zm20.1-73.6c-6.4 5.5-14.6 5.6-20.1 0l-76.7-76.7c-14.2-15.1-33.1-22-53.1-22h-9.3l97.4-97.44c30.4-30.346 79.6-30.346 109.9 0l97.2 97.14h-15.2c-20 0-38.9 7.8-53.1 22zm-149.9-76.2c13.8 0 26.5 5.6 37.1 15.4l76.7 76.7c7.2 6.3 16.6 10.8 26.1 10.8 9.4 0 18.8-4.5 26-10.8l77-77c9.8-9.7 23.3-15.3 37.1-15.3h37.7l58.3 58.3c30.3 30.3 30.3 79.5 0 109.8l-58.3 58.3h-37.7c-13.8 0-27.3-5.6-37.1-15.4l-77-77c-13.9-13.9-38.2-13.9-52.1.1l-76.7 76.6c-10.6 9.8-23.3 15.4-37.1 15.4H80.78l-58.02-58c-30.346-30.3-30.346-79.5 0-109.8l58.02-58.1z" })
  }
), A0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9m-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z" })
  }
), D0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248m-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8" })
  }
), y0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m407 111.9-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9M136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1m272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z" })
  }
), b0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3M167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4m-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z" })
  }
), f0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704" })
  }
), U0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2" })
  }
), G0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3M297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5" })
  }
), q0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3m-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z" })
  }
), W0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 407 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m372 232.5-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80M238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8m-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9M38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3m91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3m22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3" })
  }
), E0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M498.252 234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306 310.306 0 0 0-9.622-36.6 184.068 184.068 0 0 0-30.874-57.5 251.154 251.154 0 0 0-18.818-21.689 237.362 237.362 0 0 0-47.113-36.116 240.8 240.8 0 0 0-56.723-24.668c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236 1.15a179.331 179.331 0 0 0-34.256 7.1 221.5 221.5 0 0 0-39.768 16.355 281.385 281.385 0 0 0-38.08 24.158c-6.167 4.61-12.268 9.36-17.974 14.518-10.173 9.207-20.372 18.433-29.927 28.268a243.878 243.878 0 0 0-33.648 43.95 206.488 206.488 0 0 0-20.494 44.6 198.2 198.2 0 0 0-7.691 34.759 201.13 201.13 0 0 0-1.552 35.521 299.716 299.716 0 0 0 4.425 40.24 226.865 226.865 0 0 0 16.73 53.3 210.543 210.543 0 0 0 24 39.528 213.589 213.589 0 0 0 26.358 28.416 251.313 251.313 0 0 0 41.787 30.586 287.831 287.831 0 0 0 55.9 25.277 269.5 269.5 0 0 0 40.641 9.835c6.071 1.01 12.275 1.253 18.412 1.873a4.149 4.149 0 0 1 1.19.56h32.289c2.507-.389 5-.937 7.527-1.143 16.336-1.332 32.107-5.335 47.489-10.717a219.992 219.992 0 0 0 48.952-23.818c9.749-6.447 19.395-13.077 28.737-20.1 5.785-4.348 10.988-9.5 16.3-14.457 3.964-3.7 7.764-7.578 11.51-11.5a232.162 232.162 0 0 0 31.427-41.639c9.542-16.045 17.355-32.905 22.3-50.926 2.859-10.413 4.947-21.045 7.017-31.652 1.032-5.279 1.251-10.723 1.87-16.087.036-.317.358-.6.552-.9v-37.056a9.757 9.757 0 0 1-.561-1.782m-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2 0-33.57 14.9-33.57 37.04V360.8h-73.513V170.062H275.1v31.931c8.924-26.822 26.771-36.189 62.04-36.189Z" })
  }
), O0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6m27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6m180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6m14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8M140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9m24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4m-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8" })
  }
), I0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m250.6 211.74 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76m-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3 4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1m10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123m9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z" })
  }
), N0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z" })
  }
), X0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504" })
  }
), K0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9" })
  }
), Q0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2m214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7m-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2" })
  }
), Z0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248m-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0m7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z" })
  }
), J0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24" })
  }
), j0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504m190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9" })
  }
), Y0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128M193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8m79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6m0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6" })
  }
), _0 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h448V32zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6" })
  }
), h6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8M38.3 388.6 0 256.8c0 48.5 14.3 93.4 38.3 131.8z" })
  }
), c6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56m139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16z" })
  }
), s6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M284.046 224.8a34.114 34.114 0 1 0 34.317 34.113 34.217 34.217 0 0 0-34.317-34.113m-110.45 0a34.114 34.114 0 1 0 34.317 34.113A34.217 34.217 0 0 0 173.6 224.8Zm220.923 0a34.114 34.114 0 1 0 34.317 34.113 34.215 34.215 0 0 0-34.317-34.113m153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975 405.975 0 0 0-72.032 6.357 238.524 238.524 0 0 0-49.51-36.588C99.684-11.7 40.859.711 11.135 11.421A14.291 14.291 0 0 0 5.58 34.782C26.542 56.458 61.222 99.3 52.7 138.252c-33.142 33.9-51.112 74.776-51.112 117.337 0 43.372 17.97 84.248 51.112 118.148 8.526 38.956-26.154 81.816-47.116 103.491a14.284 14.284 0 0 0 5.555 23.34c29.724 10.709 88.549 23.147 155.324-10.2a238.679 238.679 0 0 0 49.51-36.589A405.972 405.972 0 0 0 288 460.14c73.313 0 142.8-19.159 195.667-53.975 27.371-18.049 49.145-39.426 64.679-63.619 17.309-26.923 26.07-55.916 26.07-86.125-.022-31.021-8.782-59.991-26.09-86.936ZM284.987 409.9a345.65 345.65 0 0 1-89.446-11.5l-20.129 19.393a184.366 184.366 0 0 1-37.138 27.585 145.767 145.767 0 0 1-52.522 14.87c.983-1.771 1.881-3.563 2.842-5.356q30.258-55.68 16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4 0-83.1 104.254-150.469 232.846-150.469s232.867 67.373 232.867 150.469c0 83.111-104.254 150.486-232.867 150.486" })
  }
), v6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8m157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2z" })
  }
), e6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m508.52 249.75-21.82-13.51c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35 7.35 0 0 0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35 7.35 0 0 0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35 7.35 0 0 0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439 81.84a7.36 7.36 0 0 0-8.84-8.84L405 78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35 7.35 0 0 0-10.39-7L367.7 53.23c-1.7-.94-3.43-1.84-5.15-2.73l-4.15-25.42a7.35 7.35 0 0 0-11.54-4.79L326 35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35 7.35 0 0 0-12.25-2.44l-17.5 18.72c-1.95-.21-3.91-.38-5.88-.55L262.25 3.48a7.35 7.35 0 0 0-12.5 0L236.24 25.3c-2 .17-3.93.34-5.88.55l-17.5-18.72a7.35 7.35 0 0 0-12.25 2.44l-9 24c-1.89.55-3.79 1.08-5.66 1.68l-20.82-15a7.35 7.35 0 0 0-11.54 4.79l-4.15 25.41c-1.73.9-3.45 1.79-5.16 2.73l-23.4-10.63a7.35 7.35 0 0 0-10.39 7l.92 25.81c-1.49 1.19-3 2.39-4.42 3.61L81.84 73A7.36 7.36 0 0 0 73 81.84L78.93 107c-1.23 1.45-2.43 2.93-3.62 4.41l-25.81-.91a7.42 7.42 0 0 0-6.37 3.26 7.35 7.35 0 0 0-.57 7.13l10.66 23.41c-.94 1.7-1.83 3.43-2.73 5.16l-25.41 4.14a7.35 7.35 0 0 0-4.79 11.54l15 20.82c-.59 1.87-1.13 3.77-1.68 5.66l-24 9a7.35 7.35 0 0 0-2.44 12.25l18.72 17.5c-.21 1.95-.38 3.91-.55 5.88l-21.86 13.5a7.35 7.35 0 0 0 0 12.5l21.82 13.51c.17 2 .34 3.92.55 5.87l-18.72 17.5a7.35 7.35 0 0 0 2.44 12.25l24 9c.55 1.89 1.08 3.78 1.68 5.65l-15 20.83a7.35 7.35 0 0 0 4.79 11.54l25.42 4.15c.9 1.72 1.79 3.45 2.73 5.14l-10.63 23.43a7.35 7.35 0 0 0 .57 7.13 7.13 7.13 0 0 0 6.37 3.26l25.83-.91q1.77 2.22 3.6 4.4L73 430.16a7.36 7.36 0 0 0 8.84 8.84l25.16-5.93q2.18 1.83 4.41 3.61l-.92 25.82a7.35 7.35 0 0 0 10.39 6.95l23.43-10.68c1.69.94 3.42 1.83 5.14 2.73l4.15 25.42a7.34 7.34 0 0 0 11.54 4.78l20.83-15c1.86.6 3.76 1.13 5.65 1.68l9 24a7.36 7.36 0 0 0 12.25 2.44l17.5-18.72c1.95.21 3.92.38 5.88.55l13.51 21.82a7.35 7.35 0 0 0 12.5 0l13.51-21.82c2-.17 3.93-.34 5.88-.56l17.5 18.73a7.36 7.36 0 0 0 12.25-2.44l9-24c1.89-.55 3.78-1.08 5.65-1.68l20.82 15a7.34 7.34 0 0 0 11.54-4.78l4.15-25.42c1.72-.9 3.45-1.79 5.15-2.73l23.42 10.68a7.35 7.35 0 0 0 10.39-6.95l-.91-25.82q2.22-1.79 4.4-3.61l25.15 5.93a7.36 7.36 0 0 0 8.84-8.84L433.07 405q1.83-2.17 3.61-4.4l25.82.91a7.23 7.23 0 0 0 6.37-3.26 7.35 7.35 0 0 0 .58-7.13l-10.68-23.42c.94-1.7 1.83-3.43 2.73-5.15l25.42-4.15a7.35 7.35 0 0 0 4.79-11.54l-15-20.83c.59-1.87 1.13-3.76 1.67-5.65l24-9a7.35 7.35 0 0 0 2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35 7.35 0 0 0 0-12.5Zm-151 129.08A13.91 13.91 0 0 0 341 389.51l-7.64 35.67a187.51 187.51 0 0 1-156.36-.74l-7.64-35.66a13.87 13.87 0 0 0-16.46-10.68l-31.51 6.76a187.38 187.38 0 0 1-16.26-19.21H258.3c1.72 0 2.89-.29 2.89-1.91v-54.19c0-1.57-1.17-1.91-2.89-1.91h-44.83l.05-34.35H262c4.41 0 23.66 1.28 29.79 25.87 1.91 7.55 6.17 32.14 9.06 40 2.89 8.82 14.6 26.46 27.1 26.46H407a187.3 187.3 0 0 1-17.34 20.09Zm25.77 34.49A15.24 15.24 0 1 1 368 398.08h.44a15.23 15.23 0 0 1 14.8 15.24Zm-225.62-.68a15.24 15.24 0 1 1-15.25-15.25h.45a15.25 15.25 0 0 1 14.75 15.25Zm-88.1-178.49 32.83-14.6a13.88 13.88 0 0 0 7.06-18.33L102.69 186h26.56v119.73h-53.6a187.65 187.65 0 0 1-6.08-71.58m-11.26-36.06a15.24 15.24 0 0 1 15.23-15.25H74a15.24 15.24 0 1 1-15.67 15.24Zm155.16 24.49.05-35.32h63.26c3.28 0 23.07 3.77 23.07 18.62 0 12.29-15.19 16.7-27.68 16.7ZM399 306.71c-9.8 1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4 18.86-11.95 38.46-29.64 38.46-53.26 0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23h-198.9a187.49 187.49 0 0 1 104.89-59.19l23.47 24.6a13.82 13.82 0 0 0 19.6.44l26.26-25a187.51 187.51 0 0 1 128.37 91.43l-18 40.57a14 14 0 0 0 7.09 18.33l34.59 15.33a187.12 187.12 0 0 1 .4 32.54h-19.28c-1.91 0-2.69 1.27-2.69 3.13v8.82C421 301 409.31 305.58 399 306.71M240 60.21A15.24 15.24 0 0 1 255.21 45h.45A15.24 15.24 0 1 1 240 60.21ZM436.84 214a15.24 15.24 0 1 1 0-30.48h.44a15.24 15.24 0 0 1-.44 30.48" })
  }
), l6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m274.69 274.69-37.38-37.38L166 346ZM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m155.85 174.79 14.78-6.13a8 8 0 0 1 10.45 4.34 8 8 0 0 1-4.33 10.46L418 197.57a8 8 0 0 1-10.45-4.33 8 8 0 0 1 4.3-10.45M314.43 94l6.12-14.78a8 8 0 0 1 10.45-4.3 8 8 0 0 1 4.33 10.45l-6.13 14.78a8 8 0 0 1-10.45 4.33A8 8 0 0 1 314.43 94M256 60a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8 8 8 0 0 1-8-8V68a8 8 0 0 1 8-8m-75 14.92a8 8 0 0 1 10.46 4.33L197.57 94a8 8 0 1 1-14.78 6.12l-6.13-14.78A8 8 0 0 1 181 74.92m-63.58 42.49a8 8 0 0 1 11.31 0L140 128.72a8 8 0 0 1 0 11.28 8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 .03-11.28ZM60 256a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8 8 8 0 0 1-8 8H68a8 8 0 0 1-8-8m40.15 73.21-14.78 6.13A8 8 0 0 1 74.92 331a8 8 0 0 1 4.33-10.46L94 314.43a8 8 0 0 1 10.45 4.33 8 8 0 0 1-4.3 10.45m4.33-136A8 8 0 0 1 94 197.57l-14.78-6.12a8 8 0 0 1-4.3-10.45 8 8 0 0 1 10.45-4.33l14.78 6.13a8 8 0 0 1 4.33 10.44ZM197.57 418l-6.12 14.78a8 8 0 0 1-14.79-6.12l6.13-14.78a8 8 0 1 1 14.78 6.12M264 444a8 8 0 0 1-8 8 8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8 8 8 0 0 1 8 8Zm67-6.92a8 8 0 0 1-10.46-4.33L314.43 418a8 8 0 0 1 4.33-10.45 8 8 0 0 1 10.45 4.33l6.13 14.78a8 8 0 0 1-4.34 10.42m63.58-42.49a8 8 0 0 1-11.31 0L372 383.28a8 8 0 0 1 0-11.28 8 8 0 0 1 11.31 0l11.31 11.31a8 8 0 0 1-.03 11.28ZM286.25 286.25 110.34 401.66l115.41-175.91 175.91-115.41ZM437.08 331a8 8 0 0 1-10.45 4.33l-14.78-6.13a8 8 0 0 1-4.33-10.45 8 8 0 0 1 10.48-4.32l14.78 6.12a8 8 0 0 1 4.3 10.45m6.92-67h-16a8 8 0 0 1-8-8 8 8 0 0 1 8-8h16a8 8 0 0 1 8 8 8 8 0 0 1-8 8" })
  }
), t6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20m-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232m-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z" })
  }
), w6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.84 378.92c-.3.6-.6 1.08 0 0m249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2m111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z" })
  }
), g6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m350.5 157.7-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6 31.9-22.1L176 135l-36.7 22.5zm-23.3 88.2-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7 23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7zm-30.6 16.6 20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8zm59.1 59.3-28.3 8.3-1.6-46.8 25.1-10.7zM99 263.2l-31.1 13-5.2-40.8L90.1 221zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8zm28.5-139.9 21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7 42.2-22.4 28 45.9-50.8 21.3-19.4-44.8m41 94.9 61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6 67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z" })
  }
), i6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233.5 22.49C233.5 10.07 243.6 0 256 0s22.5 10.07 22.5 22.49c0 12.42-10.1 22.49-22.5 22.49s-22.5-10.07-22.5-22.49M313.4 259c0 31.7-25.7 57.4-57.4 57.4s-57.4-25.7-57.4-57.4 25.7-57.4 57.4-57.4 57.4 25.7 57.4 57.4m23.8 91c22.3-19.9 36.5-47.3 39.9-77h119.5c-3.5 61.4-30.4 119.2-75.2 161.4-44.7 42.2-103.9 65.8-165.4 65.8s-120.7-23.6-165.44-65.8c-44.73-42.2-71.62-100-75.17-161.4H135.1c3.4 29.7 17.6 57.1 39.9 77 22.3 19.9 51.2 30.9 81.1 30.9 29 0 58.7-11 81.1-30.9M73.14 140.3c.4 12.4-9.33 22.8-21.75 23.2-12.42.4-22.8-9.3-23.21-21.7-.4-12.5 9.34-22.9 21.76-23.3 12.41-.4 22.8 9.4 23.2 21.8zm365.76.7c0-12.4 10-22.5 22.5-22.5 12.4 0 22.4 10.1 22.4 22.5 0 12.5-10 22.5-22.4 22.5-12.5 0-22.5-10-22.5-22.5m-121-45.73c-17.3 13.83-39.2 22.83-61.9 22.83-22.7 0-44.6-9-61.9-22.83-17.3-14.72-28.8-35.09-32.4-57.49 15.1-6.41 30.8-11.26 46.9-14.47 0 12.57 5 24.62 13.9 33.51 8.9 8.88 20.9 13.88 33.5 13.88 12.6 0 24.6-5 33.5-13.88 8.9-8.89 13.9-20.94 13.9-33.51 16.1 3.21 31.8 8.06 46.9 14.47-3.6 22.4-15.1 42.77-32.4 57.49M82.78 231c-21.36 7.6-44.72 7.4-65.92-.6 1.96-16.3 5.6-32.3 10.85-47.9 5.39 3.1 11.34 5.1 17.51 6 6.17.8 12.45.4 18.46-1.2 6.01-1.7 11.65-4.4 16.59-8.2 4.94-3.8 9.09-8.5 12.2-13.9 3.11-5.4 5.14-11.4 5.95-17.5.81-6.2.41-12.5-1.2-18.5-1.61-6-4.39-11.6-8.18-16.6-3.79-4.9-8.51-9.1-13.9-12.2a242.136 242.136 0 0 1 35.96-33.33c17.6 14.35 29.5 34.53 33.6 56.83 4.1 22.3.1 45.4-11.2 65-11.4 19.6-29.4 34.5-50.72 42.1m346.42.1c-21.3-7.6-39.3-22.6-50.7-42.2-11.3-19.6-15.2-42.7-11.1-65 4.1-22.2 16-42.36 33.5-56.71 13.1 9.85 25.2 21.02 36 33.31-10.7 6.4-18.4 16.7-21.5 28.8-3.2 12-2.3 24.8 4.8 35.6 6.2 10.8 16.4 18.7 28.4 22 12 3.3 24.9 1.7 35.7-4.3 5.3 15.5 8.9 31.6 10.9 47.8-22.1 8.1-44.6 8.3-66 .7" })
  }
), m6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z" })
  }
), a6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m220.6 130.3-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8" })
  }
), o6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5m21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z" })
  }
), n6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458m89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714m87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613" })
  }
), r6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232m32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64" })
  }
), d6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m100 410.3 30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5 30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14 4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8 91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5 4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5 4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2 4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z" })
  }
), S6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M404.9 331c2.2-1.1 4.4-2.3 6.5-3.7l8.3-4.8c1.5-1.1 4.4-3.4 8.7-6.7l.5-.5c3.4-3.4 7.2-5 11.3-4.9 1.8 0 3.9.5 6.4 1.5l31-27.5c.9-.7 1.7-1.3 2.6-1.8h.2c3.3-1.9 6-1.8 8.2.4 3.9 2.1 4.2 5.6.9 10.6L456.9 322c.2.5.4 1 .4 1.5.5 2.2.3 4.4-.5 6.6-.7 1.5-1.8 2.9-3.1 4.2-1.4 1.4-2.7 2.8-4.2 4.2l-18.8 13.7c-1.7 1.2-3.4 2.3-5.1 3.3-2.1 1.3-4.3 2.5-6.6 3.6-1 .4-1.9.9-2.9 1.3-5.9 2.5-11.9 4.2-18.2 5-2.9 24.5-11.3 47.1-25.1 67.8-17.5 25.7-41.4 45.4-71.8 58.8-30.2 13.5-63 20.2-98.2 20.2-48.6-.5-88-11.4-118.2-32.8-35.1-25-52.6-57.9-52.6-99.1v-5.6c1.2-28.1 9.5-54.6 24.8-79.8 15.1-24.9 37.1-41.7 66.1-50.5 14.9-4.4 29.9-6.6 45-6.6 15.5 0 31.6 2.9 48.1 8.6s35.2 15.5 55.9 29.5l54.1 36.3c15.1 9.8 28.8 16.5 41.2 20-2.6-25.1-11.7-46.6-27.3-64.5-15.7-18.1-35.6-31.3-59.9-39.7l-23.3-8c-21.4-7.5-37.3-14.9-47.7-22.2-28.2-19.1-43.8-45.2-47-78.5l-.5-9.8c0-32.1 13-58.9 39-80.5 23-19.3 50.6-29 82.5-29 24 0 45.6 6.9 64.7 20.8 19.2 14 30.1 33.8 32.6 59.4l.5 10c0 18.6-4.8 34.5-14.4 47.7-9.8 13.2-18.5 19.9-26 19.9-1.6-.1-3.1-.3-4.5-.6l-34 32c-5.5 3-9.2 2.5-11.1-1.6-1.9-2.2-1.8-4.9.5-8.2l.2-.2c.5-.7 1.2-1.5 2-2.4l31.6-30c-.4-1.5-.6-3.1-.6-4.8 0-4.1 1.6-7.6 4.9-10.4 13.8-12.4 20.8-26.7 20.8-42.8 0-16-6.1-29.5-18.2-40.4s-28.7-16.5-49.7-16.8c-26.2 0-47.8 7.9-64.7 23.7s-25.3 34.6-25.3 56.7c0 17.8 6.9 33.9 20.6 48.3 13.6 14.2 34.6 25.4 63 33.5 39.8 11.5 70.2 31 91.3 58.3 18.7 24.2 29.1 51.3 31.3 81.4 2.2-.7 4.3-1.5 6.5-2.6zM294.1 178.7c0 1.1.6 1.6 1.8 1.6.1 0 9.7-8.9 28.8-26.6 0-2.4-5.1.9-15.3 10-10.2 9.2-15.3 14.2-15.3 14.9zm8 6.4c0-1-.5-1.5-1.5-1.5-1.1 0-2.1.5-2.9 1.6-1.9-.1-3.3.1-4.2.7-.4.2-.5.5-.5.7 0 .7.5 1.3 1.5 1.6h3.3c2.9-1.1 4.4-2.2 4.4-3.3zm22.6-19.9c0-2.8-1.6-2.8-4.9 0-1.6 1.5-3.6 3.5-6 6.2-.8.6-2.6 2.2-5.3 4.9-2.8 2.9-4.2 4.7-4.2 5.3l.2 1.3c.7.2 1.2.4 1.5.4.1 0 3.3-2.9 9.5-8.7s9.3-8.9 9.3-9.3zm159.7 120-30.6 27c1.8 1 3.2 2.4 4 4.2l30.2-27c.2-1.2.1-2.2-.5-2.9-.6-.5-1.6-.9-3.1-1.3zm-1.6-.9-.7-.7-27 21.9 1.6 2 26-23.1zm-116.2 79.6c-8-2.1-15.4-4.6-22.2-7.5-15.3-6.2-34.3-17-57-32.4L250 298.7c-15.8-10.1-30.2-17.6-43.2-22.6-13.1-4.9-26-7.3-38.6-7.3h-5.5c-32.2 1.7-57.2 13.8-75 36.2-16.6 20.8-25 45.3-25 73.6 0 31.8 12.8 56.7 38.2 74.7 25.4 18.1 60.2 27.1 104.4 27.1 34.7 0 64-6.2 87.8-18.6 23.7-12.4 42.1-28.8 55.2-49.2 9.8-15.5 15.9-31.8 18.2-48.8z" })
  }
), z6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M388.32 104.1a4.66 4.66 0 0 0-4.4-4c-2 0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76 472s-54.04-365.5-54.44-367.9Zm-99.67-33.63a116.67 116.67 0 0 0-7.21-17.61C271 32.85 255.42 22 237 22a15 15 0 0 0-4 .4c-.4-.8-1.2-1.2-1.6-2-8-8.77-18.4-12.77-30.82-12.4-24 .8-48 18-67.25 48.83-13.61 21.62-24 48.84-26.82 70.06-27.62 8.4-46.83 14.41-47.23 14.81-14 4.4-14.41 4.8-16 18-1.2 10-38 291.82-38 291.82L307.86 504V65.67a41.66 41.66 0 0 0-4.4.4s-5.6 1.6-14.81 4.4m-55.24 17.22c-16 4.8-33.63 10.4-50.84 15.61 4.8-18.82 14.41-37.63 25.62-50 4.4-4.4 10.41-9.61 17.21-12.81 6.81 14.37 8.41 33.99 8.01 47.2m-32.83-63.25A27.49 27.49 0 0 1 215 28c-6.4 3.2-12.81 8.41-18.81 14.41-15.21 16.42-26.82 42-31.62 66.45-14.42 4.41-28.83 8.81-42 12.81 8.76-38.39 41.18-96.43 78.01-97.23m-46.43 220.17c1.6 25.61 69.25 31.22 73.25 91.66 2.8 47.64-25.22 80.06-65.65 82.47-48.83 3.2-75.65-25.62-75.65-25.62l10.4-44s26.82 20.42 48.44 18.82c14-.8 19.22-12.41 18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44 27.22-93.27 94.47-97.68 26-1.6 39.23 4.81 39.23 4.81l-15.21 57.6s-17.21-8-37.63-6.4c-29.62 2.01-30.02 20.81-29.62 25.62m95.27-161.73c0-12-1.6-29.22-7.21-43.63 18.42 3.6 27.22 24 31.23 36.43q-10.81 3-24.02 7.2" })
  }
), p6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09" })
  }
), M6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z" })
  }
), x6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 449 301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z" })
  }
), H6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 32 69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z" })
  }
), V6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M212.439.008V0H448v128H64C64 57.6 141.755.475 212.439.008ZM237.256 192v.007C307.135 192.475 384 249.6 384 320H210.809v-.005C140.915 319.563 64 262.424 64 192zm-1.691 319.993C306.251 511.521 384 454.399 384 384H0v128h235.565z" })
  }
), C6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M27.5 162.2 9 187.1h90.5l6.9-130.7zM396.3 45.7 267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69 406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z" })
  }
), L6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z" })
  }
), B6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z" })
  }
), u6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1" })
  }
), R6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7m143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7m156.6 90-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8m-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z" })
  }
), $6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496.926 366.6c-3.373-9.176-9.8-14.086-17.112-18.153a42.714 42.714 0 0 0-3.72-1.947c-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889 102.889 0 0 1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221 10.221 0 0 1 2.914-3.038c3.918-2.591 7.96-5.22 10.7-6.993 4.885-3.162 8.754-5.667 11.246-7.44 9.362-6.547 15.909-13.5 20-21.278a42.371 42.371 0 0 0 2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543 55.543 0 0 0-11.718 1.24 79.072 79.072 0 0 0-3.063.72c.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167 130.167 0 0 0 332.1 36.443C309.515 23.547 283.91 17 256 17s-53.4 6.547-76 19.443a129.735 129.735 0 0 0-33.281 26.783c-14.88 17.038-29.152 38.44-32.673 79.161-.992 11.594-1.24 23.435-1.079 34.533-1-.26-2.021-.5-3.051-.719a55.461 55.461 0 0 0-11.717-1.24c-18.687 0-34.125 10.131-40.3 26.449a42.423 42.423 0 0 0 2.046 35.228c4.105 7.774 10.652 14.731 20.014 21.278 2.48 1.736 6.361 4.24 11.246 7.44 2.641 1.711 6.5 4.216 10.28 6.72a11.054 11.054 0 0 1 3.3 3.311c.794 1.624.818 3.373-.36 6.6a102.02 102.02 0 0 1-8.94 15.785c-12.077 17.669-29.363 32.648-51.434 44.639C32.355 348.608 20.2 352.75 15.069 366.7c-3.868 10.528-1.339 22.506 8.494 32.6a49.137 49.137 0 0 0 12.4 9.387 134.337 134.337 0 0 0 30.342 12.139 20.024 20.024 0 0 1 6.126 2.741c3.583 3.137 3.075 7.861 7.849 14.78a34.468 34.468 0 0 0 8.977 9.127c10.019 6.919 21.278 7.353 33.207 7.811 10.776.41 22.989.881 36.939 5.481 5.778 1.91 11.78 5.605 18.736 9.92C194.842 480.951 217.707 495 255.973 495s61.292-14.123 78.118-24.428c6.907-4.24 12.872-7.9 18.489-9.758 13.949-4.613 26.163-5.072 36.939-5.481 11.928-.459 23.187-.893 33.206-7.812a34.584 34.584 0 0 0 10.218-11.16c3.434-5.84 3.348-9.919 6.572-12.771a18.971 18.971 0 0 1 5.753-2.629 134.893 134.893 0 0 0 30.752-12.251 48.344 48.344 0 0 0 13.019-10.193l.124-.149c9.226-9.868 11.545-21.501 7.763-31.768m-34.013 18.277c-20.745 11.458-34.533 10.23-45.259 17.137-9.114 5.865-3.72 18.513-10.342 23.076-8.134 5.617-32.177-.4-63.239 9.858-25.618 8.469-41.961 32.822-88.038 32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937 75.143-36.381 87.133-92.552 87.666-96.719.645-5.046 1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638 2.48-6.485 8.531-8.928 14.879-8.928a27.643 27.643 0 0 1 5.965.67c12 2.6 23.659 8.617 30.392 10.242a10.749 10.749 0 0 0 2.48.335c3.6 0 4.86-1.811 4.612-5.927-.768-13.132-2.628-38.725-.558-62.644 2.84-32.909 13.442-49.215 26.04-63.636 6.051-6.932 34.484-36.976 88.857-36.976s82.88 29.92 88.931 36.827c12.611 14.421 23.225 30.727 26.04 63.636 2.071 23.919.285 49.525-.558 62.644-.285 4.327 1.017 5.927 4.613 5.927a10.648 10.648 0 0 0 2.48-.335c6.745-1.624 18.4-7.638 30.4-10.242a27.641 27.641 0 0 1 5.964-.67c6.386 0 12.4 2.48 14.88 8.928 3.546 9.374-1.24 17-12.189 24.639-6.609 4.612-30.429 19.343-35.8 24.315-5.568 5.134-4.836 9.1-4.191 14.149.533 4.228 12.511 60.4 87.666 96.718 4.446 2.22 11.936 6.733-1.27 14.086" })
  }
), k6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111.4 256.3 5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2m21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5m25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3M7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3m25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6m241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1m376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8m-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z" })
  }
), P6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203m-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0" })
  }
), F6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 256h32v256H0V352h32v-32h32v-32h32zm416 96v160H384V256h32v32h32v32h32v32zM320 64h32v384h-32v-32H192v32h-32V64h32V32h32V0h64v32h32zm-32 64h-64v64h64z" })
  }
), T6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6 38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z" })
  }
), A6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40M298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z" })
  }
), D6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8m100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z" })
  }
), y6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48M271.7 185h77.8v-18.9h-77.8zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2" })
  }
), b6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4M140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6m98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160" })
  }
), f6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48" })
  }
), U6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 .8.1 1.6.2 2.4.1.4.1.8.2 1.2 1.6 7.1 8 12.4 15.6 12.4s14-5.3 15.6-12.4c.1-.4.2-.8.2-1.2.1-.8.2-1.6.2-2.4V198.4c4-.8 7.7-1.8 11.2-3 14.3-4.7 26-11.4 46.4-11.4 31.4 0 43.2 16 74.6 16 8.9 0 15.9-1.1 24.2-3.5 1.2-.3 2.4-.7 3.6-1.1v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16-10.2 0-18.2 1.8-25.6 4v32c7.4-2.4 15.4-4 25.6-4 31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.4-16-74.6-16M384 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64m32 384c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V96c0-17.6 14.4-32 32-32h320c17.6 0 32 14.4 32 32z" })
  }
), G6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384.5 32.5h-320c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-320c0-35.3-28.7-64-64-64m-48 280c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16-10.2 0-18.2 1.6-25.6 4v-32c7.4-2.2 15.4-4 25.6-4 31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4v153.6c0 8.8-7.2 16-16 16s-16-7.2-16-16v-192c0-8.8 7.2-16 16-16s16 7.2 16 16v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16z" })
  }
), q6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48m-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31M199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z" })
  }
), W6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3m-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3m-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4m-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4m-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1m-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5m-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6" })
  }
), E6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m334.1 192.9-44.6-116.4c-.9-2.3-2.6-4.3-4.6-5.6-1.6-1-3.4-1.6-5.2-1.8-1.8-.2-3.7.1-5.4.7-1.7.7-3.3 1.7-4.5 3.1-1.2 1.4-2.1 3-2.6 4.8L285 201.9H162.1l-29.2-92.2c-.5-1.8-1.5-3.4-2.7-4.8-2.1-1.3-2.8-2.4-4.5-3-2.6-.7-3.6-1.8-5.4-.8-1.8.2-3.6.8-5.2 1.8-2 1.3-3.6 3.3-4.5 5.6L65.94 224.9l-.47 1.2a82.94 82.94 0 0 0-2.25 52.5c4.96 17.3 15.4 32.5 29.75 43.3l.17.1.38.3 67.88 50.9 54.2 40.9c1.5 1 5.3 2.8 8.3 2.8 3 0 6-1.8 8.4-2.8l54.1-40.9 68.4-51.2.2-.1c14.4-10.9 24.8-26.1 29.8-43.3 4.9-17.3 3.3-35.7-2.3-52.5z" })
  }
), O6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29z" })
  }
), I6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320z" })
  }
), N6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 202.66A53.34 53.34 0 1 0 277.36 256 53.38 53.38 0 0 0 224 202.66m124.71-41a54 54 0 0 0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31 6.43a54 54 0 0 0-30.41 30.41c-8.28 21-6.43 71.05-6.43 94.33s-1.85 73.27 6.47 94.34a54 54 0 0 0 30.41 30.41c21 8.29 71 6.43 94.31 6.43s73.24 1.93 94.3-6.43a54 54 0 0 0 30.41-30.41c8.35-21 6.43-71.05 6.43-94.33s1.92-73.26-6.43-94.33ZM224 338a82 82 0 1 1 82-82 81.9 81.9 0 0 1-82 82m85.38-148.3a19.14 19.14 0 1 1 19.13-19.14 19.1 19.1 0 0 1-19.09 19.18ZM400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48m-17.12 290c-1.29 25.63-7.14 48.34-25.85 67s-41.4 24.63-67 25.85c-26.41 1.49-105.59 1.49-132 0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61 0-132 1.29-25.63 7.07-48.34 25.85-67s41.47-24.56 67-25.78c26.41-1.49 105.59-1.49 132 0 25.63 1.29 48.33 7.15 67 25.85s24.63 41.42 25.85 67.05c1.49 26.32 1.49 105.44 0 131.88" })
  }
), X6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z" })
  }
), K6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48m-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z" })
  }
), Q6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1m174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37" })
  }
), Z6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 419 0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8" })
  }
), J6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48" })
  }
), j6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0m-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5m90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z" })
  }
), Y6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32H64A64 64 0 0 0 0 96v320a64 64 0 0 0 64 64h320a64 64 0 0 0 64-64V96a64 64 0 0 0-64-64m-3.907 319.309-.083.1a32.364 32.364 0 0 1-8.717 6.823 90.26 90.26 0 0 1-20.586 8.2 12.694 12.694 0 0 0-3.852 1.76c-2.158 1.909-2.1 4.64-4.4 8.55a23.137 23.137 0 0 1-6.84 7.471c-6.707 4.632-14.244 4.923-22.23 5.23-7.214.274-15.39.581-24.729 3.669-3.761 1.245-7.753 3.694-12.377 6.533-11.265 6.9-26.68 16.353-52.3 16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085 23.085 0 0 1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428 13.428 0 0 0-4.1-1.834 89.986 89.986 0 0 1-20.313-8.127 32.905 32.905 0 0 1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824 3.436-9.338 11.571-12.111 19.4-16.262 14.776-8.027 26.348-18.055 34.433-29.884a68.236 68.236 0 0 0 5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386 7.386 0 0 0-2.208-2.217 888.502 888.502 0 0 0-6.882-4.5c-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4 28.4 0 0 1-1.369-23.584c4.134-10.924 14.469-17.706 26.978-17.706a37.141 37.141 0 0 1 7.845.83c.689.15 1.37.307 2.042.482-.108-7.43.058-15.357.722-23.119 2.358-27.261 11.912-41.589 21.874-52.994a86.836 86.836 0 0 1 22.28-17.931C188.254 100.383 205.312 96 224 96s35.828 4.383 50.944 13.016a87.169 87.169 0 0 1 22.239 17.9c9.961 11.406 19.516 25.709 21.874 52.995a231.194 231.194 0 0 1 .713 23.118 52.851 52.851 0 0 1 2.051-.481 37.131 37.131 0 0 1 7.844-.83c12.5 0 22.82 6.782 26.971 17.706a28.37 28.37 0 0 1-1.4 23.559c-2.74 5.2-7.123 9.861-13.39 14.244-1.668 1.187-4.258 2.864-7.529 4.981a877.422 877.422 0 0 0-7.164 4.682 6.856 6.856 0 0 0-1.951 2.034c-.506 1.046-.539 2.191.166 4.208a69.015 69.015 0 0 0 6.085 10.792c8.268 12.1 20.188 22.313 35.454 30.407 1.486.772 2.98 1.5 4.441 2.258.722.332 1.569.763 2.491 1.3 4.9 2.723 9.2 6.01 11.455 12.153 2.527 6.873.975 14.658-5.201 21.267m-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035 2.806-9.472 3.594-3.328 19.541-13.19 23.965-16.278 7.33-5.114 10.534-10.219 8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5 18.5 0 0 0-3.993.448c-8.035 1.743-15.838 5.769-20.354 6.857a7.1 7.1 0 0 1-1.66.224c-2.408 0-3.279-1.071-3.088-3.968.564-8.783 1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53 134.359 164.479 139c-8.434 9.654-15.531 20.57-17.432 42.6-1.386 16.013-.141 33.147.373 41.937.166 2.756-.68 3.968-3.088 3.968a7.1 7.1 0 0 1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494 18.494 0 0 0-3.993-.449c-4.25 0-8.3 1.636-9.961 5.977-2.374 6.276.847 11.381 8.168 16.494 4.425 3.088 20.371 12.958 23.966 16.279 3.719 3.437 3.237 6.093 2.805 9.471-.356 2.79-8.384 40.394-58.689 64.749-2.946 1.428-7.96 4.45.88 9.331 13.88 7.628 23.111 6.807 30.3 11.43 6.093 3.927 2.5 12.394 6.923 15.449 5.454 3.76 21.583-.266 42.335 6.6 17.433 5.744 28.116 22.015 58.963 22.015s41.788-16.3 58.938-21.973c20.795-6.865 36.89-2.839 42.336-6.6 4.433-3.055.822-11.522 6.923-15.448 7.181-4.624 16.411-3.8 30.3-11.472 8.84-4.923 3.826-7.945.854-9.43" })
  }
), _6 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48m-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3m.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z" })
  }
), h8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm230.2 212.3c19.5 9.3 33.7 23.5 41.2 40.9 10.4 24.3 11.4 63.9-20.2 95.4-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8-21.5-27.3-32.6-65.4-33-113.1v-.2c.4-47.7 11.5-85.7 33-113.1 24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9.3 83.3 16 108.2 46.6 12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6-19.4-23.9-48.7-36.1-87-36.4-38 .3-66.8 12.5-85.5 36.2-17.5 22.3-26.6 54.4-26.9 95.5.3 41.1 9.4 73.3 26.9 95.5 18.7 23.8 47.4 36 85.5 36.2 34.3-.3 56.9-8.4 75.8-27.3 21.5-21.5 21.1-47.9 14.2-64-4-9.4-11.4-17.3-21.3-23.3-2.4 18-7.9 32.2-16.5 43.2-11.4 14.5-27.7 22.4-48.4 23.5-15.7.9-30.8-2.9-42.6-10.7-13.9-9.2-22-23.2-22.9-39.5-1.7-32.2 23.8-55.3 63.5-57.6 14.1-.8 27.3-.2 39.5 1.9-1.6-9.9-4.9-17.7-9.8-23.4-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8.3 66.6 26.3 69.1 71.8 1.4.6 2.8 1.2 4.2 1.9l.1.5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8-8.8-1.9-18.6-2.9-29-2.9-3.2 0-6.4.1-9.6.3-28.6 1.6-38.1 15.5-37.4 27.9.9 16.7 19 24.5 36.4 23.6l-.1-.1" })
  }
), c8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48m-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z" })
  }
), s8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm287.3 167.3c0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34 .2 2.8.2 5.7.2 8.5" })
  }
), v8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z" })
  }
), e8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48m-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z" })
  }
), l8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7m77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5" })
  }
), t8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm297.1 84L257.3 234.6 379.4 396h-95.6L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5 78.2-89.5zm-37.8 251.6L153.4 142.9h-28.3l171.8 224.7h26.3z" })
  }
), w8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48M140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z" })
  }
), g8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m186.8 202.1 95.2 54.1-95.2 54.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48m-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z" })
  }
), i8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33 157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z" })
  }
), m8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0" })
  }
), a8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.7 311 95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z" })
  }
), o8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98M448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325 347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z" })
  }
), n8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m382.7 292.5 2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z" })
  }
), r8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61m52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7M203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5m207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2" })
  }
), d8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256M155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8" })
  }
), S8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M561.7 199.6c-1.3.3.3 0 0 0m-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z" })
  }
), z8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M158.4 0 7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z" })
  }
), p8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z" })
  }
), M8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m165 144.7-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1m92.3-72.3-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8m-126.7 33.7h44.6V183.2h-44.6z" })
  }
), x8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m136.5 294.2 58.8 22.9c9.1-36.8 25.4-61.1 55-61.1 49.4 0 71.4 63.6 142.4 63.6 15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56-41.8-56L41.8 88 0 32h335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6-49.6 0-71.6-63.5-142.4-63.5-35.9 0-95.2 14.6-114.1 101.6z" })
  }
), H8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m480.3 187.7 4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z" })
  }
), V8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6m167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z" })
  }
), C8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72zm-224.7-58.2 34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7z" })
  }
), L8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z" })
  }
), B8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72m15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z" })
  }
), u8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2m4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z" })
  }
), R8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2h199.79c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z" })
  }
), $8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13" })
  }
), k8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5 0 .2-.1.3-.1.5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5 15.7-41.8 40.4-79.6 72.3-110.7 1.8-1.6 4-2.6 6.3-3.1 37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3 40.7 4.2 81.4 2.1 120.1-12.5 94-35.5 149.3-102.3 162.9-202.5 4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zm156.6 396.7c-2.1 11.5-4.2 21.9-14.6 31.3 53.2-1 123.2-29.2 161.8-97.1 39.7-69.9 37.6-139.9-6.3-207.8-36.5-55.3-89.8-82.4-156.6-86.6 1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5 2.1 15.7-1 30.3-13.6 41.8-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7 29.3 54.3c5.2 11.5 4.2 19.8-6.3 28.2-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7-2.5 2.4-3.8 5.9-3.1 9.4 2.1 11.5-2.1 19.8-12.5 25.1-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1 24 5.2 41.8-6.3 44.9-30.3 1-8.4 5.2-14.6 12.5-17.7 7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5-1.4-3-2.4-6.2-3.1-9.4-3.1-14.6-2.1-15.7 11.5-18.8 8.4-3.1 15.7-6.3 21.9-12.5 3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7-6.4-11.7-13-23.6-15.7-37.1-2.1-9.4-1-17.7 8.4-24 5.2-4.2 8.4-9.4 8.4-16.7-.4-10.1-1.5-20.3-3.1-30.3-6.3-37.6-23-68.9-51.2-95-5.2-4.2-9.4-6.3-16.7-4.2l-35.6 12.7 6 3.6c6.3 3.7 12.2 7.3 17 12.1 30.3 26.1 41.8 61.6 45.9 100.2 1 8.4 0 16.7-7.3 21.9-8.4 5.2-10.4 12.5-7.3 20.9 4.9 13.2 10.4 26 16.7 38.6l16.7 29.2c-6.3 8.4-13.6 11.5-21.9 14.6-12.5 3.1-14.6 7.3-10.4 20.9.6 1.5 1.4 2.8 2.1 4.2 2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4-7.3 4.2-11.5 9.4-11.5 17.7 0 12.5-7.3 19.8-18.8 24-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z" })
  }
), P8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.033 8 0 119.033 0 256s111.033 248 248 248 248-111.033 248-248S384.967 8 248 8m114.952 168.66c-3.732 39.215-19.881 134.378-28.1 178.3-3.476 18.584-10.322 24.816-16.948 25.425-14.4 1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25 5.342-39.5 3.652-3.793 67.107-61.51 68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608 69.142-14.845 10.194-26.894 9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7 18.45-13.7 108.446-47.248 144.628-62.3c68.872-28.647 83.183-33.623 92.511-33.789 2.052-.034 6.639.474 9.61 2.885a10.452 10.452 0 0 1 3.53 6.716 43.765 43.765 0 0 1 .417 9.769" })
  }
), F8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z" })
  }
), T8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m488.23 241.7 20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z" })
  }
), A8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86" })
  }
), D8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286m304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286M188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857M237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z" })
  }
), y8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m465.4 409.4 87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z" })
  }
), b8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M331.5 235.7c2.2.9 4.2 1.9 6.3 2.8 29.2 14.1 50.6 35.2 61.8 61.4 15.7 36.5 17.2 95.8-30.3 143.2-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2-32.3-41-48.9-98.1-49.5-169.6v-.5c.5-71.5 17.1-128.6 49.4-169.6 36.3-46.1 90.3-69.7 160.5-70.2h.3c70.3.5 124.9 24 162.3 69.9 18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4-29.2-35.8-73-54.2-130.5-54.6-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3 28 35.6 71.2 53.9 128.2 54.4 51.4-.4 85.4-12.6 113.7-40.9 32.3-32.2 31.7-71.8 21.4-95.9-6.1-14.2-17.1-26-31.9-34.9-3.7 26.9-11.8 48.3-24.7 64.8-17.1 21.8-41.4 33.6-72.7 35.3-23.6 1.3-46.3-4.4-63.9-16-20.8-13.8-33-34.8-34.3-59.3-2.5-48.3 35.7-83 95.2-86.4 21.1-1.2 40.9-.3 59.2 2.8-2.4-14.8-7.3-26.6-14.6-35.2-10-11.7-25.6-17.7-46.2-17.8h-.7c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6.4 99.9 39.5 103.7 107.7l-.2.2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3 25.6-1.4 54.6-11.4 59.5-73.2-13.2-2.9-27.8-4.4-43.4-4.4-4.8 0-9.6.1-14.4.4-42.9 2.4-57.2 23.2-56.2 41.8l-.1.1z" })
  }
), f8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 209.91a210.06 210.06 0 0 1-122.77-39.25v178.72A162.55 162.55 0 1 1 185 188.31v89.89a74.62 74.62 0 1 0 52.23 71.18V0h88a121.18 121.18 0 0 0 1.86 22.17A122.18 122.18 0 0 0 381 102.39a121.43 121.43 0 0 0 67 20.14Z" })
  }
), U8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6m155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7 9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9M342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2m0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z" })
  }
), G8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z" })
  }
), q8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5" })
  }
), W8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M391.17 103.47h-38.63v109.7h38.63ZM285 103h-38.63v109.75H285ZM120.83 0 24.31 91.42v329.16h115.83V512l96.53-91.42h77.25L487.69 256V0Zm328.24 237.75-77.22 73.12h-77.24l-67.6 64v-64h-86.87V36.58h308.93Z" })
  }
), E8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" })
  }
), O8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5" })
  }
), I8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32M237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z" })
  }
), N8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8m52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6M87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9m28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79m228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6m.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6" })
  }
), X8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1zM308.6 49.1 223.8 0l-88.6 54.8 86 47.3 87.4-53" })
  }
), K8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8m145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z" })
  }
), Q8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M171.73 232.813a5.381 5.381 0 0 0 4.97-3.313 48.081 48.081 0 0 1 14.9-25.256c1.243-.828 1.657-2.484 1.657-4.141a4.22 4.22 0 0 0-2.071-3.312L74.429 128.473 148.958 85a9.941 9.941 0 0 0 4.968-8.281 9.108 9.108 0 0 0-4.968-8.281L126.6 55.6a9.748 9.748 0 0 0-9.523 0l-100.2 57.966a9.943 9.943 0 0 0-4.969 8.281v115.107a9.109 9.109 0 0 0 4.969 8.281l22.358 12.835a8.829 8.829 0 0 0 4.968 1.242 9.4 9.4 0 0 0 6.625-2.484 10.8 10.8 0 0 0 2.9-7.039V164.5l115.932 67.9a4.5 4.5 0 0 0 2.07.413M323.272 377.73a12.478 12.478 0 0 0-4.969 1.242l-74.528 43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036 53.036 0 0 1-28.984.414 4.86 4.86 0 0 0-6.21 4.555v133.323l-74.529-43.061a8.83 8.83 0 0 0-4.969-1.242 9.631 9.631 0 0 0-9.523 9.523v26.085a9.107 9.107 0 0 0 4.969 8.281l100.2 57.553a8.829 8.829 0 0 0 4.968 1.242 11.027 11.027 0 0 0 4.969-1.242l100.2-57.553a9.941 9.941 0 0 0 4.968-8.281v-26.085c-.823-4.554-5.383-9.109-10.351-9.109M286.007 78a23 23 0 1 0-23-23 23 23 0 0 0 23 23m63.627-10.086a23 23 0 1 0 23 23 23 23 0 0 0-23-23m63.182 83.686a23 23 0 1 0-23-23 23 23 0 0 0 23 23m-63.182-9.2a23 23 0 1 0 23 23 23 23 0 0 0-23-23Zm-63.627 83.244a23 23 0 1 0-23-23 23 23 0 0 0 23 23.004Zm-62.074 36.358a23 23 0 1 0-23-23 23 23 0 0 0 23 23.004Zm188.883-82.358a23 23 0 1 0 23 23 23 23 0 0 0-23-22.996Zm0 72.272a23 23 0 1 0 23 23 23 23 0 0 0-23-22.996Z" })
  }
), Z8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480m-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8m-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3m-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3m12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z" })
  }
), J8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m243.583 91.603 80.112 46.781c2.88 1.642 2.985 6.199 0 7.841l-95.192 55.629a8.747 8.747 0 0 1-8.954 0l-95.192-55.629c-2.932-1.589-2.984-6.252 0-7.841l80.06-46.781V0L0 119.417v238.835l78.384-45.775v-93.563c-.052-3.338 3.823-5.722 6.703-3.921l95.192 55.629a9.092 9.092 0 0 1 4.503 7.842v111.205c.052 3.338-3.823 5.722-6.703 3.92l-80.112-46.781-78.384 45.775L224 512l204.417-119.417-78.384-45.775-80.112 46.781c-2.828 1.749-6.807-.529-6.703-3.92V278.464c0-3.338 1.833-6.305 4.503-7.842l95.193-55.629c2.827-1.748 6.806.477 6.702 3.921v93.563L448 358.252V119.417L243.583 0v91.603" })
  }
), j8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 230.17V480H0V230.17h141.13v124.92h165.74V230.17ZM306.87 32H141.13v124.91h165.74Z" })
  }
), Y8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4M620 406.7 471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z" })
  }
), _8 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0m358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6m32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51m79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z" })
  }
), h5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2" })
  }
), c5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z" })
  }
), s5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0 216.5 216.5 0 1 0-432.9 0m385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9-5.5-4.3-8.2-12.3-8.2-23.8v-96.5c0-6.5-5.2-20.2-15.7-41.2 7 0 17-9.1 30-27.2v147.8c0 11 2.4 19.4 7 25.3 3.7 4.7 10.1 8.9 19 12.6 1.2.4 2.6.9 4.1 1.4 2.9.9 6.3 2.1 10.3 3.5-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4H53.6c3.3-5.3 4.9-8.8 4.9-10.8s-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4 0-7.4 2.1-13.9 6.3-19.3l20-25.6-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7 0 4.2 2.8 13.3 8.3 27.3l16.2 40.7h17.7c2.8.4 7.7 5 14.6 13.9 1.8 2.4 4.3 5.8 7.7 10.2 1.4 1.9 2.9 3.9 4.6 6.1 1.3-2.3 2-4.6 2-7.1 0-2-1.3-6.6-4-13.4l-5.2-13.7c-4-10.6-6.1-17.7-6.1-21.3 0-6.3 1.9-12.3 5.8-17.9.5-.6 1-1.3 1.5-1.9 4.4-5.6 8.8-11.1 13.3-16.5-1.1 4.6-1.7 8.7-1.7 12 0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3H218.4l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4l-6.1-15.8c-1.5-3.9-4-7-7.7-9.3l15.7-20.1 17.3 45.2h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20 22.4 58.7H328.8c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3v-93.5c0-6.5-4.5-20.3-13.7-41.2 5.4 0 14.1-9.1 26.2-27.2v163.5c0 7.2.6 12 1.7 14.6 1.6 3.4 5.3 6.2 11.1 8.2-3.9 5.6-8.7 8.5-14.5 8.5H191.5zm-98-44c-2.7-6.7-4-11.7-4-15-.6 1.2-2.4 3.7-5.4 7.6-1.4 1.9-2.2 3.7-2.2 5.3 0 2.6.8 5.7 2.2 9.3l5.6 13.9c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9-3.5-1.9-5.3-4.3-5.3-7.4 0-2.4 4.6-8.6 14-18.3.2 3.8 1.9 7.6 4.9 11.2 3.1 3.6 4.6 7 4.6 10.1 0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9-3.5-1.9-5.3-4.3-5.3-7.4 0-2.4 4.6-8.6 14-18.3.2 3.8 1.9 7.6 4.9 11.2 3.1 3.6 4.6 7 4.6 10.1 0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9-3.5-1.9-5.3-4.3-5.3-7.4 0-2.4 4.6-8.6 14-18.3.2 3.8 1.9 7.6 4.9 11.2 3.1 3.6 4.6 7 4.6 10.1 0 2.6-2.1 8-6.2 16.3z" })
  }
), v5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z" })
  }
), e5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48zM192 336l-27-64h54z" })
  }
), l5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5m32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6" })
  }
), t5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2m20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6" })
  }
), w5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z" })
  }
), g5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7" })
  }
), i5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z" })
  }
), m5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M31.49 63.49C0 94.982 0 145.672 0 247.04v17.92c0 101.369 0 152.059 31.49 183.549C62.982 480 113.672 480 215.04 480h17.92c101.369 0 152.059 0 183.549-31.491C448 417.019 448 366.329 448 264.96v-17.92c0-101.369 0-152.059-31.491-183.55C385.019 32 334.329 32 232.96 32h-17.92C113.671 32 62.981 32 31.49 63.49ZM75.6 168.268h51.147c1.68 85.493 39.386 121.706 69.253 129.173V168.267h48.16V242c29.493-3.173 60.48-36.773 70.933-73.733h48.16a142.258 142.258 0 0 1-65.52 92.96 147.348 147.348 0 0 1 76.72 93.52H321.44a92.154 92.154 0 0 0-77.28-66.64v66.64h-5.787c-102.106 0-160.346-70-162.773-186.48" })
  }
), a5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z" })
  }
), o5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z" })
  }
), n5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 16C123.452 16 16 123.452 16 256s107.452 240 240 240 240-107.452 240-240S388.548 16 256 16M121.69 429.122C70.056 388.972 36.741 326.322 36.741 256a218.519 218.519 0 0 1 9.587-64.122l102.9-17.895-.121 10.967-13.943 2.013s-.144 12.5-.144 19.549a12.778 12.778 0 0 0 4.887 10.349l9.468 7.4Zm105.692-283.27 8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46 0 0 0-32.342 30.474-39.529 34.5-7.078 3.964-.144 9.344-.144 9.344l8.481 7.618-.048 4.369-73.507-19.176c39.644-56.938 105.532-94.3 180.018-94.3a218.754 218.754 0 0 1 164.934 75.025l-193.512 37.7Zm34.063 329.269-33.9-250.857 9.467-7.4a12.778 12.778 0 0 0 4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474 241.711 31.391a218.872 218.872 0 0 1 5.851 50.13c0 119.074-95.428 216.212-213.814 219.121Z" })
  }
), r5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42M205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0m116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0m-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z" })
  }
), d5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z" })
  }
), S5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116M347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3m-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5m-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34m32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z" })
  }
), z5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4m-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2M563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4m-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6m107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6" })
  }
), p5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6" })
  }
), M5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8m72.3 16.4 46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z" })
  }
), x5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m640 51.2-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1z" })
  }
), H5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 93.7 183.6-25.3v177.4H0V93.7zm0 324.6 183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32z" })
  }
), V5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50.772 479.812h83.36V367.847l-83.36 47.01Zm329.046 0h82.35v-64.956l-82.35-47.009Zm.006-448v219.756l-123.648-72.382-121.672 72.382V31.812H50.772v360.794l205.404-122.287 205.993 122.287V31.812Z" })
  }
), C5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63m-115.8 35.54-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27m115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21z" })
  }
), L5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08m336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46m-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32m-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16m2.09-136.43 9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52m42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64m143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55m211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36m-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z" })
  }
), B5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M178.414 339.706H141.1l-28.934-116.231h-.478l-28.46 116.231H45.2L0 168.946h37.548l27.026 116.231h.478l29.655-116.231h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05.002-39.463 25.114-65.291 63.855-65.291m0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7.002 19.61 6.937 39.462 29.894 39.462m163.684 6.456h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24v-62.183h33.96v170.76h-32.287zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94 0-20.087-7.174-39.223-29.178-39.223M592.96 339.706h-32.287v-17.219h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941v-76.052h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393v-64.818h33.961zm9.493-36.83H640v36.83h-37.547z" })
  }
), u5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m267.73 471.53 10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52 181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z" })
  }
), R5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8M33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256m223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2 68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z" })
  }
), $5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m61.7 169.4 101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7m-139.9 29.3-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2m183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248m-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6" })
  }
), k5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374m-339.647-82.972h41.529v-58.075h-41.529v58.075m217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913m-150.753-86.072h166.058v-58.075H189.579v58.075" })
  }
), P5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256m-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224M160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9m110 169.1 46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3zm-11.8-116.3 68.6 29.4-29.4 68.3L230 246zm80.3 42.9 54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z" })
  }
), F5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2m-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37zm0 74.4v37.3H76.7v-37.3zm11.1-147.3 54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196m0 74.4v37.3h-196v-37.3h196m-84.6-147.3 64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z" })
  }
), T5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8m171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z" })
  }
), A5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8l164.9-188.5L26.8 48h145.6l100.5 132.9zm-24.8 373.8h39.1L151.1 88h-42z" })
  }
), D5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2" })
  }
), y5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z" })
  }
), b5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32v448H0V32zM236 287.5 313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236z" })
  }
), f5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M223.69 141.06 167 284.23l-56-143.17H14.93l105.83 249.13L82.19 480h94.17l140.91-338.94Zm105.4 135.79a58.22 58.22 0 1 0 58.22 58.22 58.22 58.22 0 0 0-58.22-58.22ZM394.65 32l-93 223.47h104.79L499.07 32Z" })
  }
), U5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M500.676 159.486a12.779 12.779 0 0 0-6.4-8.282 13.954 13.954 0 0 0-10.078-1.125L457.8 156.7l-.043-.2-22.3 5.785-1.243.333-.608-2.17A369.037 369.037 0 0 0 347.538 4.289a14.1 14.1 0 0 0-19.784-.463l-102.9 102.747H24.947A24.9 24.9 0 0 0 0 131.417V380.38a24.963 24.963 0 0 0 24.918 24.9h200.068L328.072 508a13.667 13.667 0 0 0 19.327 0c.126-.126.249-.255.37-.385a368.025 368.025 0 0 0 69.577-107.374 403.45 403.45 0 0 0 17.3-50.8v-.028l20.406 5.336.029-.073L483.345 362a20.253 20.253 0 0 0 2.619.5 13.359 13.359 0 0 0 4.139-.072 13.5 13.5 0 0 0 10.515-9.924 415.855 415.855 0 0 0 .058-193.013ZM337.125 24.65l.013.014h-.013Zm-110.2 165.161L174.311 281.1a11.338 11.338 0 0 0-1.489 5.655v46.189a22.04 22.04 0 0 1-22.041 22h-3.4a22.068 22.068 0 0 1-22.081-21.982v-45.668a11.532 11.532 0 0 0-1.388-5.51l-51.6-92.2a21.988 21.988 0 0 1 19.264-32.726h3.268a22.059 22.059 0 0 1 19.611 11.916l36.357 70.281 37.515-70.512a22.066 22.066 0 0 1 38.556-.695 21.7 21.7 0 0 1 0 21.967Zm110.22-165.138a348.147 348.147 0 0 1 75.8 141.335l.564 1.952-114.134 29.6v-66.143a25.006 25.006 0 0 0-24.947-24.9h-19.361Zm60.5 367.305v-.043l-.014.014a347.19 347.19 0 0 1-60.177 95.227l-82.2-81.893h19.177a24.978 24.978 0 0 0 24.947-24.9v-66.2l114.6 29.862a385.191 385.191 0 0 1-16.33 47.933Zm84-52.45.015.014-50.618-13.131L299.379 292.1v-72.528l119.746-30.99 4.468-1.157 39.54-10.253 18.511-4.816a393 393 0 0 1 0 167.172Z" })
  }
), G5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512z" })
  }
), q5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M153.1 315.8 65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5" })
  }
), W5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248m-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z" })
  }
), E5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m42.9 240.32 99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92 58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91m148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z" })
  }
), O5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76m229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5" })
  }
), I5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205z" })
  }
), N5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31m-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78z" })
  }
), X5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160v128c0 88.4-71.6 160-160 160S0 408.4 0 320zM160 80C98.1 80 48 130.1 48 192v128c0 61.9 50.1 112 112 112s112-50.1 112-112V192c0-61.9-50.1-112-112-112" })
  }
), K5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 32C64.5 32 0 96.5 0 176v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144M48 176c0-53 43-96 96-96s96 43 96 96v160c0 53-43 96-96 96s-96-43-96-96zM496 32c-79.5 0-144 64.5-144 144v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144m-96 144c0-53 43-96 96-96s96 43 96 96v160c0 53-43 96-96 96s-96-43-96-96z" })
  }
), Q5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112.7 32H152v400h104v48H0v-48h104V95.5L13.3 156 0 164.8v-57.6L106.7 36z" })
  }
), Z5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.5 32c-39.4 0-77.1 15.6-105 43.5L18.7 99.4l-17 17 33.9 33.9 17-17 23.9-23.9c18.9-18.8 44.4-29.4 71-29.4h7.3c51.5 0 93.2 41.7 93.2 93.2 0 25.8-10.7 50.4-29.5 68L7.6 438.5 0 445.6V480h320v-48H84.8l166.5-155.7c28.5-26.7 44.7-64 44.7-103.1C296 95.2 232.8 32 154.8 32z" })
  }
), J5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 32H0v48h220.3L71.4 222.7l-7.4 7.1V264h124c46.4 0 84 37.6 84 84s-37.6 84-84 84H97.4c-21.2 0-40.6-12-50.1-31l-1.9-3.8-42.9 21.5 1.9 3.8C22 457.7 58.1 480 97.4 480H188c72.9 0 132-59.1 132-132s-59.1-132-132-132h-40.3L296.6 73.3l7.4-7.1z" })
  }
), j5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M496 400c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 17.7-14.3 32-32 32m0-336c-44.2 0-80 35.8-80 80v224c0 44.2 35.8 80 80 80s80-35.8 80-80V144c0-44.2-35.8-80-80-80M24 64H0v48h110l-73.2 97.6L32 216v40h56c30.9 0 56 25.1 56 56v40c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3H0v3c0 53 43 96 96 96s96-43 96-96v-40c0-54.2-41.4-98.7-94.3-103.6l73.5-98 4.8-6.4V64h-24zm299.2 24-11.3-21.2-.1.1-.3.1-.9.5c-.7.4-1.7 1-2.9 1.7-2.4 1.4-5.7 3.5-9.7 6.1-7.9 5.3-18.4 13.1-29 23.3-20.7 19.8-45 51.7-45 93.3v176c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80-11.4 0-22.2 2.4-32 6.7V192c0-22.3 13.3-42.5 30.2-58.7 8.2-7.8 16.4-14 22.7-18.2 3.1-2.1 5.6-3.7 7.3-4.7.9-.5 1.5-.9 1.9-1.1l.4-.2 21.1-11.2-22.5-42.4-21.2 11.3zM272 272c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-80z" })
  }
), Y5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152.8 32h53l-.1.2L77.8 304H272V128h48v176h64v48h-64v128h-48V352H2.2l16.1-34.2z" })
  }
), _5 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M34.9 32H288v48H77.1L59.3 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H92.5c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2 42.9-21.5 4.1 8.2c8.2 16.3 24.8 26.6 43 26.6H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H4.7l3.5-27.1 24-184z" })
  }
), h7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 320c0-61.9-50.1-112-112-112-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3c-16.2 19.8-25 44.6-25 70.1 0 61.9 50.1 112 112 112s112-50.1 112-112M145.7 160.6c4.7-.4 9.5-.6 14.3-.6 88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L188.6 32h61.9z" })
  }
), c7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32H0v48h253.6l-240 400h56l247-411.7 3.4-5.7z" })
  }
), s7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 156c0-68.5-55.5-124-124-124h-40C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124h72c68.5 0 124-55.5 124-124 0-44.8-23.7-84-59.3-105.8 26.5-22.8 43.3-56.5 43.3-94.2M180.1 280H196c42 0 76 34 76 76s-34 76-76 76h-72c-42 0-76-34-76-76s34-76 76-76h56zm0-48H140c-42 0-76-34-76-76s34-76 76-76h40c42 0 76 34 76 76s-34 76-76 76z" })
  }
), v7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 192c0 61.9 50.1 112 112 112 32.3 0 61.5-13.7 81.9-35.6l5.1-6.3c16.2-19.8 25-44.6 25-70.1 0-61.9-50.1-112-112-112S48 130.1 48 192m126.3 159.4c-4.7.4-9.5.6-14.3.6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L131.4 480H69.5z" })
  }
), e7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175.5 32h33l5.9 15.4L380.7 480h-51.4l-36.9-96H91.6l-36.9 96H3.3L169.6 47.4zm16.5 90.9L110.1 336h163.8z" })
  }
), l7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v128h-80v-32h32v-48h-32V80zm-112 48h-32v48h32v32H288v-32h32v-48h-32V80h128zm-160 0h-32v48h32v32h-96v-32h32v-48h-32V80h96zm-128 0H96v48h32v32H48V80h80zM48 432V240h80v24H96v48h32v24H96v48h32v48zm112-48h32v-48h-32v-24h32v-48h-32v-24h96v24h-32v48h32v24h-32v48h32v48h-96zm128-72h32v-48h-32v-24h128v96h-32v48h32v48H288v-48h32v-48h-32zm160 72h32v-48h-32v-96h80v192h-80zM48 32H0v448h576V32h-48z" })
  }
), t7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m80 74.9 45.2 76.8L110.4 48H80zM152 0l25.1 176 6.9 48h-72L32 88V0h48z" })
  }
), w7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m259.7 48.4 13.7-19.7-39.5-27.3-13.6 19.7c-9 12.9-15.1 27.6-18.1 42.9H96c-53 0-96 43-96 96v48h448v-48c0-53-43-96-96-96H251.8c1.9-5.5 4.6-10.7 8-15.6zM352 112c26.5 0 48 21.5 48 48H48c0-26.5 21.5-48 48-48zM48.4 240c4.2 80.1 40.9 195.1 175.6 240 134.7-44.9 171.4-159.9 175.6-240h-48.1C347.7 305.6 319 390 224 428.8 129 390 100.3 305.6 96.5 240z" })
  }
), g7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v416H80V48zM80 0H32v512h416V0h-48zm160 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128M128 384h224l-32-96H160zM512 80V64h-32v96h32v-16zm0 112h-32v96h32v-80zm0 144v-16h-32v96h32v-16z" })
  }
), i7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm160 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128M96 384h224l-32-96H128zm280-240h-24v48h128v-48h-24zm0 96h-24v48h128v-48h-24z" })
  }
), m7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v160h480V48zM0 0h576v256H0V48zm120 128h360v48H96v-48zm248 160v104c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7l24.1-41.5C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288zM208 424V288h48v136c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2l24.1 41.5c-12 7-20 19.9-20 34.7 0 22.1 17.9 40 40 40s40-17.9 40-40" })
  }
), a7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h480v288H424.7l44.7 40.2 8.7 7.8H576V32H0v384h97.9l8.7-7.8 44.7-40.2H48zm80 400h320v-48L288 288 128 432zm160-127.4 88.2 79.4H199.8z" })
  }
), o7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352m0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17 33.9-34-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17 34 33.9 17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM280 184v-24h-48v137.9l7 7 48 48 17 17 33.9-33.9-17-17-41-41v-94z" })
  }
), n7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352m0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17 33.9-34-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17 34 33.9 17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM280 160h-48v160h48V184zm-48 248h48v-48h-48z" })
  }
), r7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352m0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17 33.9-34-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17 34 33.9 17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM280 176h-48v88h-88v48h88v88h48v-88h88v-48h-88v-64z" })
  }
), d7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352m0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17 33.9-34-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17 34 33.9 17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM200 192h-24v48h79.2L195 348.3 175.2 384H336v-48h-79.2L317 227.7l19.8-35.7H296z" })
  }
), S7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v114.9c10.4-1.9 21.1-2.9 32-2.9 5.4 0 10.7.2 16 .7V32H0v448h296.2c-11.8-14.3-21.4-30.5-28.2-48H48zm176 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1-1.4-9.1-2.2-18.4-2.2-27.9 0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112m-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0m240 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h64v32h-64v64h-32v-64h-64v-32h64v-64h32z" })
  }
), z7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v114.9c10.4-1.9 21.1-2.9 32-2.9 5.4 0 10.7.2 16 .7V32H0v448h296.2c-11.8-14.3-21.4-30.5-28.2-48H48zm176 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1-1.4-9.1-2.2-18.4-2.2-27.9 0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112m-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0m384 112a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-63.3 77.7c-20.4 21.2-49 34.3-80.7 34.3s-60.3-13.2-80.7-34.3L376 416h112zM384 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), p7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0v48h448V0H56zm288 368c0-40.2 13.4-77.2 36.1-106.8C330.2 243.1 294.9 232 256 232c-79.5 0-144 46.6-144 104s64.5 104 144 104c26.9 0 52-5.3 73.6-14.6-6.2-18-9.6-37.3-9.6-57.4M53.8 208h368.8c22.3-10.3 47.2-16 73.4-16 4.1 0 8.2.1 12.3.4L512 160H0l5.5 48L40 512h354.8c-18.3-12.9-34.1-29.2-46.3-48H82.9zM40 80H16v48h480V80h-24zm216 288c-17.7 0-32-10.7-32-24s14.3-24 32-24 32 10.7 32 24-14.3 24-32 24m240 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h64v32h-64v64h-32v-64h-64v-32h64v-64h32z" })
  }
), M7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0v48h448V0H56zm288 368c0-40.2 13.4-77.2 36.1-106.8C330.2 243.1 294.9 232 256 232c-79.5 0-144 46.6-144 104s64.5 104 144 104c26.9 0 52-5.3 73.6-14.6-6.2-18-9.6-37.3-9.6-57.4M53.8 208h368.8c22.3-10.3 47.2-16 73.4-16 4.1 0 8.2.1 12.3.4L512 160H0l5.5 48L40 512h354.8c-18.3-12.9-34.1-29.2-46.3-48H82.9zM40 80H16v48h480V80h-24zm216 288c-17.7 0-32-10.7-32-24s14.3-24 32-24 32 10.7 32 24-14.3 24-32 24m384 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-63.3 77.7c-20.4 21.2-49 34.3-80.7 34.3s-60.3-13.2-80.7-34.3L440 416h112zM448 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), x7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0h448v48H32zm368 336c0 57.4-64.5 104-144 104s-144-46.6-144-104 64.5-104 144-104 144 46.6 144 104M40 80h456v48H16V80zm42.9 384h346.2l29.1-256H53.8zM472 512H40L5.5 208 0 160h512l-5.5 48zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24" })
  }
), H7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm80 224a144 144 0 1 1 288 0 144 144 0 1 1-288 0m176 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), V7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M84.1 160.1c7-10.1 15.6-18.9 25.5-26.2 5.6 16.6 12.6 31.8 20.6 45.5C119 191 112 206.8 112 224.2c0 8.2 1.6 16.3 4.6 23.9l25.3 63.3 3.5 8.6-3.3 8.7-20.6 54.8-2.7 7.3 2.1 7.5 18.2 65.7h49.8l-17.6-63.4-2.1-7.5 2.7-7.3 15.8-42.1c2.8-7.5 4.3-15.4 4.3-23.5v-1.3l-.7-32.7 31.4 9.2 88 25.7c2.1.6 4.2 1.1 6.3 1.6l19 4V464h48V308.1l7.3-7.1c15.1-14.8 24.7-35.3 24.7-58.8 0-11.2-2.2-21.7-6.2-31.4l-1.8-4.4V160h41.9l7 7 28.3 28.3 42.7-19v-61L483.2 48H440c-53 0-96.8 39.7-103.2 91l-2.6 21h-45l-5.8-3.5-102.1-62.4c9.5 38.9 30.2 66.9 51.1 86.4 14.3 13.4 28.6 22.8 39.4 28.8 5.3 3 9.7 5.1 12.7 6.5 1.5.7 2.6 1.1 3.3 1.4l.7.3-8.4 22.5c-8.4 22.5-8.4 22.5-8.5 22.5h-.1l-.2-.1-.5-.2c-.4-.1-.8-.3-1.4-.6-1.2-.5-2.8-1.2-4.9-2.1-4-1.8-9.7-4.6-16.3-8.3-13.3-7.5-30.9-19.1-48.6-35.7C163.9 182 128 128 128 48V5.2l36.5 22.3 130.2 79.6C313.9 45.1 371.7 0 440 0h120v48h-19.2l10.7 16H640v16l-64 21.3v106.3l-14.3 6.3-72 32-15.1 6.7-10.6-10.7v.3c0 33.2-12.2 62.9-32 85.5V512H288V364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-13 34.8 24 86.3 8.5 30.4H102.6l-4.9-17.6-23.1-83.2-4.2-15.1-2.1-7.5 2.7-7.3 5.5-14.6 17.3-46.1L72 265.9c-5.3-13.3-8-27.4-8-41.7 0-2.9.1-5.7.3-8.5A40.1 40.1 0 0 0 48 248v88H0v-88c0-47.3 37.3-85.9 84.1-87.9M448 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), C7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32v24h48v72h192V56h48V32h48v72h-48v56h48v80h48V128h48v160h-64v96h-64v96H352v-48h80v-48H208v48h80v48H160v-96H96v-96H32V128h48v112h48v-80h48v-56h-48V32zm48 144v32h-48v80h-32v48h352v-48h-32v-80h-48v-32zm0 48h64v80h-64zm192 0v80h-64v-80z" })
  }
), L7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c-97.2 0-176 78.8-176 176 0 67.2 43.3 127.2 96 174.2 25.5 22.8 51.2 40.7 70.6 53 3.3 2.1 6.5 4 9.4 5.8 2.9-1.8 6-3.7 9.4-5.8 19.4-12.3 45.1-30.2 70.6-53 52.7-47 96-106.9 96-174.2 0-97.2-78.8-176-176-176M0 224C0 100.3 100.3 0 224 0s224 100.3 224 224c0 176-224 288-224 288S0 400 0 224m240 80c0-44.2 35.8-80 80-80h48v16c0 44.2-35.8 80-80 80h-48zm-112-80c44.2 0 80 35.8 80 80v16h-48c-44.2 0-80-35.8-80-80v-16z" })
  }
), B7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 40H96v48h256V40h-24zM24 168H0v48h448v-48h-24zm72 128v48h256v-48H120zM24 424H0v48h448v-48h-24z" })
  }
), u7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 40H0v48h448V40h-24zm0 128H0v48h448v-48h-24zM0 296v48h448v-48H24zm24 128H0v48h448v-48h-24z" })
  }
), R7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 40H0v48h288V40h-24zm0 128H0v48h448v-48h-24zM0 296v48h288v-48H24zm24 128H0v48h448v-48h-24z" })
  }
), $7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 40h24v48H160V40h24zm0 128h24v48H0v-48h24zm24 128v48H160v-48h264zm-24 128h24v48H0v-48h24z" })
  }
), k7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L472.4 344H544v-48H410.6l-103-80H544v-48H245.7l-103-80H544V40H96v11.8l-47.6-37zM314.8 344l-60.9-48H96v48h24zM152.3 216 96 171.6V216h24zm324.9 256-60.9-48H96v48h24z" })
  }
), P7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 64h-11l-7.2 8.4L165 400H0v48h187l7.2-8.4L475 112h165V64h-24zm-24 336h-24v48h224v-48h-24z" })
  }
), F7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-48.9 0-92.5 28.8-121.6 53.8-10.7 9.2-20 18.3-27.5 26.2H0v432h512V80H405.1c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0m0 48c26.4 0 53.6 13.8 77.7 32H178.3c24.1-18.2 51.4-32 77.7-32m208 224v192H48V272zm0-48H48v-96h416zm-352-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-56 128v32h32v-32zm-32 48v32h32v-32zm64 48h-32v32h32zm-128-48v32h32v-32zm64-16v-32h-32v32zm-32 96h32v-32h-32zm-64-80h-32v32h32zm0-48v32h32v-32zm32 96h-32v32h32zm-128-48v32h32v-32zm64-48h-32v32h32zm-32 96v32h32v-32zm-64-48H80v32h32zm0-48v32h32v-32zm32 96h-32v32h32zm256-48v32h32v-32z" })
  }
), T7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 32H80v98c0 25.2 9.1 49.5 25.7 68.5l39.9 45.5-69.2 48.5C48.6 311.9 32 343.7 32 377.7V480h237l7.1-10.9 28.4-43.4 47.4 54.3h63.8l-2.4-2.8-81.5-93.2 80.3-122.9-40.2-26.3-73 111.6-82-93.8 58.7-41.1c27.8-19.5 44.4-51.3 44.4-85.2V32h-24zm144.1 140.2-63 44.1-43.3-49.5c-8.9-10.2-13.8-23.3-13.8-36.8V80h144v46.3c0 18.3-8.9 35.4-23.9 45.9M103.9 331.8l73.5-51.4 94.3 107.8L243 432H80v-54.3c0-18.3 8.9-35.4 23.9-45.9" })
  }
), A7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0M288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-72v48h72v224H120V352h72l-96-96-96 96h72v160h322.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h63.2c2.8-2.7 5.8-5.3 8.8-7.8V192h-72v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80m352 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), D7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0M288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-72v48h72v224H120V352h72l-96-96-96 96h72v160h322.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h63.2c2.8-2.7 5.8-5.3 8.8-7.8V192h-72v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80m208 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-64h-32v-32h32zm0-176v112h-32V272z" })
  }
), y7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0M288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-72v48h72v224H120V352h72l-96-96-96 96h72v160h322.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h63.2c2.8-2.7 5.8-5.3 8.8-7.8V192h-72v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80m208 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), b7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0M288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-72v48h72v224H120V352h72l-96-96-96 96h72v160h312v-48h-72V240h72v-48h-72v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80m144-112c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), f7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0M288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-72v48h72v224H120V352h72l-96-96-96 96h72v160h432V352h72l-96-96-96 96h72v112H312V240h72v-48h-72v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80" })
  }
), U7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64.2v-.4c0-.1-.1-.3-.2-.6-.3-.6-.9-1.8-2.3-3.5-2.9-3.5-8.4-7.9-17.3-12.4C346.4 38.4 319.5 32 288 32s-58.4 6.4-76.2 15.4c-8.9 4.5-14.4 8.9-17.3 12.4-1.4 1.7-2 2.8-2.3 3.5-.1.3-.2.5-.2.6v.4c0 .1.1.3.2.6.3.6.9 1.8 2.3 3.5s3.4 3.6 6.2 5.6c-6.7 8.3-12.2 17.6-16.3 27.7C169 91 160 78 160 64c0-35.3 57.3-64 128-64s128 28.7 128 64c0 14-9 27-24.3 37.5-4.1-10-9.6-19.3-16.3-27.7 2.7-2 4.8-4 6.2-5.6 1.4-1.7 2-2.8 2.3-3.5.1-.3.2-.5.2-.6zM288 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160M87.9 325.4l14.9 22.4-11.2 24.3L49.2 464H120l89.4-178.7-77.3-77.3H48v57.5zM248 256h80l96-96h152v120l-48 72 48 104v56H0v-56l48-104-48-72V160h152zm118.6 29.3L456 464h70.8l-42.4-91.9-11.3-24.4 14.9-22.4 40-59.8V208h-84.1l-77.3 77.3zM402.3 464l-80-160h-68.6l-80 160z" })
  }
), G7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h448v-48H48zm48 41.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6m115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z" })
  }
), q7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 353.9 17-17L401 177l17-17-34-33.9-17 17-143 143L81 143l-17-17-33.9 34 17 17L207 337l17 17z" })
  }
), W7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m30.1 256 17-17L207 79l17-17 33.9 34-17 17-143 143L241 399l17 17-34 33.9-17-17L47 273l-17-17z" })
  }
), E7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289.9 256-17 17L113 433l-17 17-33.9-34 17-17 143-143L79 113 62 96l34-33.9 17 17L273 239l17 17z" })
  }
), O7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 126.1 17 17L401 303l17 17-34 33.9-17-17-143-143L81 337l-17 17-33.9-34 17-17L207 143l17-17z" })
  }
), I7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 480v-29.9l2.7-5.2 208-400 11.1-21.3 42.6 22.1-11.1 21.4L63.5 432H448v48H24zm311.5-232.6L270.7 273c-14.8-20.1-32-38.3-51.3-54.1l22.6-43.4c26.5 20.4 49.9 44.7 69.5 71.9m-15.6 66.4 40.8-25.6c16.8 32 28.7 66.9 34.7 103.8h-48.7c-5.3-27.6-14.4-53.9-26.8-78.2" })
  }
), N7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 273-17 17-17-17L47 113 30 96l34-33.9L81 79l143 143L367 79l17-17 33.9 34-17 17zm0 192-17 17-17-17L47 305l-17-17 34-33.9 17 17 143 143L367 271l17-17 33.9 34-17 17z" })
  }
), X7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47 239-17 17 17 17 160 160 17 17 33.9-34-17-17-143-143L241 113l17-17-34-33.9L207 79zm192 0-17 17 17 17 160 160 17 17 33.9-34-17-17-143-143L433 113l17-17-34-33.9L399 79z" })
  }
), K7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m273 273 17-17-17-17L113 79 96 62 62.1 96l17 17 143 143L79 399l-17 17 34 33.9 17-17zm192 0 17-17-17-17L305 79l-17-17-33.9 34 17 17 143 143L271 399l-17 17 34 33.9 17-17z" })
  }
), Q7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m239 498.7 160-128 18.7-15-30-37.5-18.7 15-145 116L79 333.3l-18.7-15-30 37.5 18.7 15 160 128 15 12 15-12zm0-485.5-15-12-15 12L49 141.3l-18.7 15 30 37.5 18.7-15 145-116 145 116 18.7 15 30-37.5-18.7-15-160-128z" })
  }
), Z7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 47-17-17-17 17L47 207l-17 17 34 33.9 17-17 143-143L367 241l17 17 33.9-34-17-17zm0 192-17-17-17 17L47 399l-17 17 34 33.9 17-17 143-143L367 433l17 17 33.9-34-17-17z" })
  }
), J7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 128c0 42.7 23 81.6 51.4 112.6 9.9 10.8 19.9 20.1 28.6 27.4 8.7-7.4 18.7-16.6 28.6-27.4C217 209.6 240 170.7 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80m15.1 144C63.4 237.1 32 187.4 32 128 32 57.3 89.3 0 160 0s128 57.3 128 128c0 59.4-31.4 109.1-63.1 144H320v48H184v192h-48V320H0v-48h24z" })
  }
), j7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192h-48V0H128v96H0v416h576V192h-48zM320 384h-64v80H48V144h128V48h224v192h128v224H320zm-16-48h64v-64h-64zm192 96v-64h-64v64zM80 336h64v-64H80zm64 96v-64H80v64zm64-96h64v-64h-64zM368 80h-64v64h64zm-160 0v64h64V80zm160 160v-64h-64v64zm64 96h64v-64h-64zm-288-96v-64H80v64zm64 0h64v-64h-64z" })
  }
), Y7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M404.7 401.5 348.4 304 323 348l-67 116c58.2 0 110.9-23.9 148.7-62.5m31.5-41.5c17.7-30.6 27.8-66.1 27.8-104 0-19.4-2.7-38.2-7.6-56H343.8l25.4 44zm0-208c-27.6-47.8-73.7-83.5-128.5-97.5L251.4 152h50.8zM256 48c-58.2 0-110.9 23.9-148.7 62.5l56.3 97.5 25.4-44zM75.8 152C58.1 182.6 48 218.1 48 256c0 19.4 2.7 38.2 7.6 56h112.6l-25.4-44-67-116zm0 208c27.6 47.8 73.7 83.5 128.5 97.5l56.3-97.5H75.8M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m223.7-56-32.3 56 32.3 56h64.7l32.3-56-32.3-56z" })
  }
), _7 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 352c66.3 0 120-53.7 120-120V32H0v192h144v8c0 39.8-32.2 72-72 72H32v48h24zm72-176H48V80h96v48z" })
  }
), h9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 96V80c0-44.2 35.8-80 80-80h32v32c0 44.2-35.8 80-80 80h-32zm-96 32 112 32 112-32c6.7 0 13 .6 19.1 1.9 18.4 3.7 33.9 12.7 46.7 25.4-13.7 8.7-26.1 19.2-36.9 31.2C305 217.7 288 258.9 288 304c0 53.7 24.1 101.8 62 134.1 4.8 4.1 9.7 7.9 14.9 11.4-10.3 13.5-21.8 25.2-34.1 34.7-23.1 17.8-49 27.8-74.8 27.8l-64-16-64 16c-25.8 0-51.7-10-74.8-27.9-12.2-9.5-23.7-21.1-34.1-34.7 5.2-3.5 10.2-7.3 14.9-11.4 37.9-32.2 62-80.3 62-134 0-45.1-17-86.3-44.9-117.5-10.8-12-23.2-22.6-36.9-31.2 12.8-12.7 28.4-21.7 46.7-25.4C67 128.6 73.3 128 80 128m125.2 78.2-13.2 3.7-13.2-3.8-67.9-19.4C131.9 220.8 144 261 144 304c0 56.2-20.7 107.6-54.9 146.9 12 7.8 23.6 11.9 33.9 12.9l57.3-14.3 11.6-2.9 11.6 2.9 57.3 14.3c10.3-1 22-5 33.9-12.9-34-39.3-54.7-90.7-54.7-146.9 0-43 12.1-83.2 33.1-117.3l-67.9 19.4z" })
  }
), c9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96V80c0-44.2 35.8-80 80-80h32v32c0 44.2-35.8 80-80 80h-32zm-96 32 112 32 112-32c76.3 0 112 83.7 112 160 0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288c0-76.3 35.7-160 112-160m125.2 78.2-13.2 3.7-13.2-3.8-104.4-29.8c-14.8 1.7-27.2 10.2-37.9 28C55.6 225.5 48 256.3 48 288c0 54.2 17 100 40.4 131.2 22.1 29.5 46.9 42.7 66.7 44.6l57.3-14.3 11.6-2.9 11.6 2.9 57.3 14.3c19.7-1.9 44.5-15.1 66.7-44.6C383 388 400 342.2 400 288c0-31.7-7.6-62.5-20.4-83.7-10.7-17.7-23.1-26.3-37.9-28z" })
  }
), s9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h504v48h-24v352h32v48H336V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v144H0v-48h32V80H0zm80 48v32h352V80zm0 80v272h48v-96c0-70.7 57.3-128 128-128s128 57.3 128 128v96h48V160z" })
  }
), v9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM360 32h96v144h48v48H360v-48h48V80h-48zm24 312a40 40 0 1 0 80 0 40 40 0 1 0-80 0m128 0c0 20.6-6.4 40.7-18.4 57.5L437.5 480h-59l10-13.9 24.8-34.7C369.7 426.1 336 389 336 344c0-48.6 39.4-88 88-88s88 39.4 88 88" })
  }
), e9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM360 288h96v144h48v48H360v-48h48v-96h-48zm24-168a40 40 0 1 0 80 0 40 40 0 1 0-80 0m128 0c0 20.6-6.4 40.7-18.4 57.5L437.5 256h-59l10-13.9 24.8-34.7C369.7 202.1 336 165 336 120c0-48.6 39.4-88 88-88s88 39.4 88 88" })
  }
), l9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM328 288h176v41.9l-7 7-95 95h102v48H328v-41.8l7-7 95-95H328zm72.6-256h30.8l6.4 14 89.3 194h-52.9l-14.8-32.2c-1.1.2-2.2.2-3.4.2h-83.5l-14.7 32h-52.9l89.3-194 6.4-14zm15.4 81.4L394.6 160h42.8z" })
  }
), t9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111 461.8-96-96-17-17 34-33.9 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17-17-17zM367 50.2l17-17 17 17 96 96 17 17-34 33.9-17-17-55-55V480h-48V125.1l-55 55-17 17-33.9-33.9 17-17 96-96z" })
  }
), w9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM432 432v-64h-64v64zm-64 48h-48V320h160v160h-48zm0-272h128V80H368zm-48 48V32h224v224H368z" })
  }
), g9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m134.4 381.1-16.3-17.6 35.2-32.7 16.3 17.6 62.4 67.2V159.9h48v255.7l62.4-67.2 16.3-17.6 35.2 32.7-16.3 17.6-104 112L256 512l-17.6-18.9zM256 47.9c-114.9 0-208 93.1-208 208H0C0 114.5 114.6-.1 256-.1s256 114.6 256 256v24h-48v-24c0-114.9-93.1-208-208-208" })
  }
), i9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M241.3 461.5 224 479.4l-17.3-17.9-128-132.8-16.6-17.3 34.6-33.3 16.7 17.3 86.7 90V160h48v225.3l86.7-90 16.7-17.3 34.6 33.3-16.7 17.3-128 132.8zM64 96H0V32h64zm96 0H96V32h64zm32-64h64v64h-64zm160 64h-64V32h64zm32 0V32h64v64z" })
  }
), m9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.3 461.5 192 479.4l-17.3-17.9-128-132.8-16.6-17.3 34.6-33.3 16.7 17.3 86.7 90V160h48v225.3l86.7-90 16.7-17.3 34.6 33.3-16.7 17.3-128 132.8zM24 80H0V32h384v48h-24z" })
  }
), a9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m489 57 17-17-34-33.9L455 23 320 158V48h-48v192h192v-48H353.9zM23 455 6 472l34 33.9 17-17 135-135V464h48V272H48v48h110.1z" })
  }
), o9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 416H32V128h48v206.1L303 111l17-17 33.9 34-17 17-223 223H320v48h-24z" })
  }
), n9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m175 495 17 17 17-17 136-136 17-17-34-33.9-17 17-95 95V0h-48v420.1l-95-95-17-17-33.9 34 17 17z" })
  }
), r9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 416h24V128h-48v206.1L81 111 64 94l-33.9 34 17 17 223 223H64v48h24z" })
  }
), d9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111 461.8 17 17 17-17 96-96 17-17-34-33.9-17 17-55 55V32h-48v354.9l-55-55-17-17-33.9 33.9 17 17 96 96zM312 48h-24v48h96V48h-24zm0 128h-24v48h160v-48h-24zm0 128h-24v48h224v-48h-24zm0 128h-24v48h288v-48h-24z" })
  }
), S9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM432 80h-64v64h64zm-64-48h112v160H320V32zm0 400h128V304H368zm-48-176h224v224H320V304z" })
  }
), z9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zm136 1.3 27.7-48 64.6-112 27.7-48 27.7 48 64.6 112 27.7 48H351.4zm156.9-48L416 368.1 379.1 432h73.8zM368 80v96h96V80zm-48-48h192v192H320V80z" })
  }
), p9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m377.6 232.3-104 112-17.6 19-17.6-18.9-104-112-16.3-17.6 35.2-32.7 16.3 17.6 62.4 67.2V0h48v266.9l62.4-67.2 16.3-17.6 35.2 32.7-16.3 17.6zM256 464c114.9 0 208-93.1 208-208v-24h48v24c0 141.4-114.6 256-256 256S0 397.4 0 256h48c0 114.9 93.1 208 208 208" })
  }
), M9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 345-17 17-17-17L79 217l-17-17 34-33.9 17 17 87 87V0h48v270.1l87-87 17-17 33.9 33.9-17 17zm-193-1v120h352V320h48v192H0V320h48z" })
  }
), x9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 416v64H0v-64zm96 0v64H96v-64zm32 0h64v64h-64zm160 0v64h-64v-64zm32 0h64v64h-64zm-142.5-55.6L224 379l-17.5-18.6-128-136L62.1 207l35-32.9 16.4 17.5 86.5 91.9V48h48v235.5l86.5-91.9 16.5-17.5 35 32.9-16.4 17.5-128 136z" })
  }
), H9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 480H0v-48h384v48h-24zm185.5-135.6L192 363l-17.5-18.6-128-136L30.1 191l35-32.9 16.4 17.5 86.5 91.9V32h48v235.5l86.5-91.9 16.5-17.5 35 32.9-16.4 17.5-128 136z" })
  }
), V9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.7 353.2 112-108.8 17.2-16.7-33.4-34.4-17.2 16.7-71.3 69.2v-284h-48v284L160.7 210l-17.2-16.7-33.4 34.4 17.2 16.7 112 108.8 16.7 16.3 16.7-16.2zM24 32H0v480h512V32H368v48h96v384H48V80h96V32h-24z" })
  }
), C9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM296 224l30-48 61.7-98.7L416 32l28.3 45.3L506 176l30 48H352.6zm86.6-48h66.8L416 122.6zM368 432h96v-96h-96zm-48-144h192v192H320V336z" })
  }
), L9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 505.9 17-17 96-96 17-17-34-33.8-17 17-55 55V280h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H440V97.9l55 55 17 17 33.9-33.9-17-17L433 23 416 6l-17 17-96 96-17 17 34 33.9 17-17 55-55V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112v134.1L81 359l-17-17-33.9 34 17 17 96 96 17 17zM136 56v136h48V32h-48zm256 264v160h48V320z" })
  }
), B9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m128 505.9 17-17 88-88 17-17-34-33.8-17 17-47 47V280h264v-8c0-14.1 2.6-27.6 7.4-40H344V97.9l47 47 17 17 33.9-33.9-17-17L337 23 320 6l-17 17-88 88-17 17 34 33.9 17-17 47-47V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v134.1L57 367l-17-17-33.9 34 17 17 88 88 17 17zM104 192h48V32h-48v24zm192 128v160h48V320zm232-80c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), u9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111 461.8 17 17 17-17 96-96 17-17-34-33.9-17 17-55 55V32h-48v354.9l-55-55-17-17-33.9 33.9 17 17 96 96zM312 480h72v-48h-96v48zm0-128h136v-48H288v48zm0-128h200v-48H288v48zm0-128h264V48H288v48z" })
  }
), R9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 478.7-17-17-96-96-17-17 34-33.8 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM328 32h176v41.9l-7 7-95 95h102v48H328v-41.8l7-7 95-95H328zm72.6 240h30.8l6.4 14 89.3 194h-52.9l-14.8-32.2c-1.1.2-2.2.2-3.4.2h-83.5l-14.7 32h-52.9l89.3-194 6.4-14zm15.4 81.4L394.6 400h42.8z" })
  }
), $9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m175 461.8 17 17 17-17 153.6-153.6 17-17-33.9-33.9-17 17L216 386.9V32h-48v354.8L55.4 274.2l-17-17-33.9 34 17 17z" })
  }
), k9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m130.9 134.4 17.6-16.4 32.7 35.2-17.6 16.3L96.4 232H352v48H96.4l67.2 62.4 17.6 16.3-32.7 35.2-17.6-16.3-112-104L0 256l18.9-17.6zM464 256c0-114.9-93.1-208-208-208h-24V0h24c141.4 0 256 114.6 256 256S397.4 512 256 512h-24v-48h24c114.9 0 208-93.1 208-208" })
  }
), P9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 88V64h48v384h-48v-24zM18.8 273.5.2 256l18.6-17.5 136-128 17.5-16.4 32.9 35-17.5 16.4-92 86.5H320v48H95.7l91.9 86.5 17.5 16.5-32.9 35-17.5-16.5-136-128z" })
  }
), F9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88v360h48V64H0zm128 168 17 17 136 136 17 17 33.9-34-17-17-95-95H640v-48H219.9l95-95 17-17-34-33.9-17 17L145 239z" })
  }
), T9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17 239 0 256l17 17 136 136 17 17 33.9-34-17-17-95-95H512v-48H91.9l95-95 17-17-34-33.9-17 17z" })
  }
), A9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m279.7 134.4-112 104-19 17.6 18.9 17.6 112 104 17.6 16.3 32.7-35.2-17.6-16.3-67.2-62.4H512v-48H245.1l67.2-62.4 17.6-16.3-32.7-35.2-17.6 16.3zM48 256c0-114.9 93.1-208 208-208h24V0h-24C114.6 0 0 114.6 0 256s114.6 256 256 256h24v-48h-24c-114.9 0-208-93.1-208-208" })
  }
), D9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88V64h48v384H0v-24zm135.6 185.5L117 256l18.6-17.5 136-128L289 94.1l32.9 35-17.5 16.4-91.9 86.5H448v48H212.5l91.9 86.5 17.5 16.5-32.9 35-17.5-16.4-136-128z" })
  }
), y9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m18.2 273-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232H448v48H93.1l112.7 112.6 17 17-33.9 33.9-17-17L18.2 273z" })
  }
), b9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M170.5 320H320l-.1-42-7-6L32 32 0 46.9V432l29 31.8 30.8-37.5 68.4-83.4 53.7 115.3 10.1 21.7 43.5-20.3-10.1-21.8zm-60.7-30.4L48 364.9V108.8L239 272H124.2z" })
  }
), f9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 88v40h24l72-64-72-64h-24v40H0v240h464v144h-48v-40H288v128h128v-40h96V232H48V88zm-96 296v40h-32v-40H0v128h128v-40h32v40h24l72-64-72-64zM424 40h48v48h-48zM384 0v128h128V0h-88zM88 424v48H40v-48zm240 0h48v48h-48z" })
  }
), U9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m18.2 402.9 92.8 92.8 17 17 33.9-33.9-17-17-51.8-51.9H448v-48H93.1l55-55 17-17-33.9-33.9-17 17-96 96-17 17 17 17zm411.5-256 17-17-17-17-96-96-17-17-33.8 34 17 17 55 55H0v48h354.9l-55 55-17 17 33.9 33.9 17-17 96-96z" })
  }
), G9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M381.1 134.4 363.5 118l-32.7 35.2 17.6 16.3 67.2 62.5H160v48h255.7l-67.2 62.4-17.6 16.3 32.7 35.2 17.6-16.3 112-104L512 256l-18.9-17.6zM48 256c0-114.9 93.1-208 208-208h24V0h-24C114.6 0 0 114.6 0 256s114.6 256 256 256h24v-48h-24c-114.9 0-208-93.2-208-208" })
  }
), q9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 80h24V32H0v448h192v-48H48V80zm325.8 193 17-17-17-17-128-128-17-17-33.9 34 17 17 87 87H160v48h258.9l-87 87-17 17 33.9 33.9 17-17 128-128z" })
  }
), W9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48v-24zm381.2 185.5 18.6-17.5-18.6-17.5-136-128-17.4-16.4-32.9 35 17.5 16.4 91.9 86.5H128v48h224.3l-91.9 86.5-17.5 16.5 32.9 35 17.5-16.5 136-128z" })
  }
), E9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 88v360h-48V64h48zM512 256l-17 17-136 136-17 17-33.9-34 17-17 95-95H0v-48h420.1l-95-95-17-17L342 86.1l17 17L495 239z" })
  }
), O9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m495 273 17-17-17-17-136-136-17-17-33.9 34 17 17 95 95H0v48h420.1l-95 95-17 17 33.9 33.9 17-17z" })
  }
), I9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m232.3 134.4 112 104 19 17.6-18.9 17.6-112 104-17.6 16.3-32.7-35.2 17.6-16.3 67.2-62.4H0v-48h266.9l-67.2-62.4-17.6-16.3 32.7-35.2 17.6 16.3zM464 256c0-114.9-93.1-208-208-208h-24V0h24c141.4 0 256 114.6 256 256S397.4 512 256 512h-24v-48h24c114.9 0 208-93.1 208-208" })
  }
), N9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 80h120v352H320v48h192V32H320v48zm1 193 17-17-17-17-128-128-17-17-33.9 34 17 17 87 87H0v48h270.1l-87 87-17 17 33.9 33.9 17-17z" })
  }
), X9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0h-24v512h48V48h128v192h128v272h48V192h-48V96h-48v96h-32V0h-24zm56 80v64h64V80zm64 96h-64v64h64zm-64 96v64h64v-64zm192 0h-64v64h64zm-64 96v64h64v-64zM144.1 158.2l-17.8-16.1-32.2 35.5 17.8 16.1 42 38.3H0v48h153.9l-42.1 38.2-17.7 16.2 32.3 35.5 17.8-16.1 88-80 19.5-17.8-19.5-17.8-88-80z" })
  }
), K9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 88V64h-48v384h48v-24zM312.4 273.5 331 256l-18.6-17.5-136-128L159 94.1l-32.9 35 17.5 16.4 91.9 86.5H0v48h235.5l-91.9 86.5-17.5 16.5 32.9 35 17.5-16.4 136-128z" })
  }
), Q9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m429.8 273 17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232H0v48h354.8L242.2 392.6l-17 17 33.9 33.9 17-17z" })
  }
), Z9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 224H16V32h48v104.1l20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224S379.7 480 256 480c-50.4 0-97-16.7-134.4-44.8l28.8-38.4C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176S353.2 80 256 80c-54.3 0-102.9 24.6-135.2 63.4l-.1.2L93.1 176H208v48h-24z" })
  }
), J9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 224h24V32h-48v104.1l-20-23.5C387 63.4 325.1 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8l-28.8-38.4C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176S158.8 80 256 80c54.3 0 102.9 24.6 135.2 63.4l.1.2 27.6 32.4H304v48h24z" })
  }
), j9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 416h224V192h-48v142.1L337 143l-17-17-17 17-111 111L52.2 114.2l-17-17-33.9 34 17 17L175 305l17 17 17-17 111-111 174.1 174H352z" })
  }
), Y9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 96h224v224h-48V177.9L337 369l-17 17-17-17-111-111L52.2 397.8l-17 17-33.9-34 17-17L175 207l17-17 17 17 111 111 174.1-174H352z" })
  }
), _9 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 56V32h48v280H93.1l79 79 17 17-33.9 33.9-17-17L18.2 305l-17-17 17-17 120-120 17-17 33.9 34-17 17-79 79H464z" })
  }
), hh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v280h418.9l-79 79-17 17 33.9 33.9 17-17 120-120 17-17-17-17-120-120-17-17-33.9 34.1 17 17 79 79H48z" })
  }
), ch = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 48H0V0h216v418.9l79-79 17-17 33.9 33.9-17 17-113 113v1.3h-1.3l-5.8 5.8-17 17-17-17-5.8-5.8h-1.3v-1.3L55 373.8l-17-17 34-33.9 17 17 79 79V48z" })
  }
), sh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 464H0v48h216V93.1l79 79 17 17 33.9-33.9-17-17L216 25.3V24h-1.3l-5.7-5.8-17-17-17 17-5.7 5.8H168v1.3L55 138.2l-17 17 34 33.9 17-17 79-79V464z" })
  }
), vh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 32v48h48v96h-48v48h144v-48h-48V32h-72zm-200 1.3-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM464 344a40 40 0 1 1-80 0 40 40 0 1 1 80 0m48 0c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 45 33.7 82.1 77.3 87.4l-24.8 34.7-10 13.9h59l56.1-78.5c12-16.8 18.4-36.9 18.4-57.5z" })
  }
), eh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 120a40 40 0 1 1-80 0 40 40 0 1 1 80 0m48 0c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 45 33.7 82.1 77.3 87.4l-24.8 34.7-10 13.9h59l56.1-78.5c12-16.8 18.4-36.9 18.4-57.5M160 33.3l-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM360 288v48h48v96h-48v48h144v-48h-48V288h-72z" })
  }
), lh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m431.4 32 6.4 14 89.3 194h-52.9l-14.8-32.2c-1.1.2-2.2.2-3.4.2h-83.5l-14.7 32h-52.9l89.3-194 6.4-14zm6 128L416 113.4 394.6 160h42.8zM143 50.2l17-17 17 17 96 96 17 17-34 33.9-17-17-55-55V480h-48V125.1l-55 55-17 17-33.9-33.9 17-17 96-96zM352 288h152v41.9l-7 7-95 95h102v48H328v-41.8l7-7 95-95H328V288z" })
  }
), th = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m433 461.8-17 17-17-17-96-96-17-17 34-33.9 17 17 55 55V32h48v354.9l55-55 17-17 33.9 33.9-17 17-96 96zM177 50.2l96 96 17 17-34 33.9-17-17-55-55V480h-48V125.1l-55 55-17 17-33.9-33.9 17-17 96-96 17-17 17 17z" })
  }
), wh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 208V80h128v128zm-48 48h224V32H320v176zM160 33.3l-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM432 432h-64v-64h64zm-64 48h112V320H320v160z" })
  }
), gh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m134.4 130.9-16.3 17.6 35.2 32.7 16.3-17.6L232 96.3V352h48V96.3l62.4 67.2 16.3 17.6 35.2-32.7-16.3-17.6-104-112L256-.1l-17.6 19zM256 464c-114.9 0-208-93.1-208-208H0c0 141.4 114.6 256 256 256s256-114.6 256-256v-24h-48v24c0 114.9-93.1 208-208 208" })
  }
), ih = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 18.2-17-17-17 17-128 128-17 17 34 33.9 17-17 87-87V352h48V93.1l87 87 17 17 33.9-33.9-17-17L241 18.2zM48 344v-24H0v192h448V320h-48v144H48z" })
  }
), mh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M241.3 50.5 224 32.6l-17.3 17.9-128 132.8-16.6 17.3 34.6 33.3 16.7-17.3 86.7-90V352h48V126.7l86.7 90 16.7 17.3 34.6-33.3-16.7-17.3zM64 416H0v64h64zm96 0H96v64h64zm32 64h64v-64h-64zm160-64h-64v64h64zm32 0v64h64v-64z" })
  }
), ah = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288-1.9 17 17 80 80 17 17-34 33.8-17-17-39-39V352h-48V89.9l-39 39-17 17-33.9-33.9 17-17 80-80 17-17zM48 192h144v48H48v161c-2.4 1.3-4.8 2.5-7.3 3.7C27.6 410.7 13 415 0 415V192zm528 223c-13 0-27.6-4.3-40.7-10.3-2.5-1.1-4.9-2.4-7.3-3.7V240H384v-48h192v48zM79 488.9C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), oh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.3 50.5 192 32.6l-17.3 17.9-128 132.8-16.6 17.3 34.6 33.3 16.7-17.3 86.7-90V352h48V126.7l86.7 90 16.7 17.3 34.6-33.3-16.7-17.3zM24 432H0v48h384v-48h-24z" })
  }
), nh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272.7 18 256 1.7 239.3 18l-112 108.8-17.2 16.7 33.4 34.4 17.2-16.7L232 92v284h48V92l71.3 69.2 17.2 16.7 33.4-34.4-17.2-16.7zM24 32H0v480h512V32H392v48h72v384H48V80h72V32H96z" })
  }
), rh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M561.9 112 545 95l-80-80-17-17-17 17-80 80-17 17 34 33.9 17-17 39-39V256H288V0H64v256H0v159c13 0 27.6-4.3 40.7-10.3 2.5-1.1 4.9-2.4 7.3-3.7v-97h480v97c2.4 1.3 4.8 2.5 7.3 3.7 13.1 6 27.7 10.3 40.7 10.3V256H472V89.9l39 39 17 17zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.4 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1" })
  }
), dh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v208h48V81.9L295 329l17 17 33.9-34-17-17-247-247H208V0h-24zm264 112c97.2 0 176 78.8 176 176s-78.8 176-176 176-176-78.8-176-176H64c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z" })
  }
), Sh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 96H32v288h48V177.9L303 401l17 17 33.9-34-17-17-223-223H320V96h-24z" })
  }
), zh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209 17 192 0l-17 17L39 153l-17 17 34 33.9 17-17 95-95V512h48V91.9l95 95 17 17 33.9-33.9-17-17z" })
  }
), ph = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m295 183-17 17 34 33.9 17-17 135-135V192h48V0H320v48h110.1zm-78 146 17-17-34-33.9-17 17-135 135V320H0v192h192v-48H81.9z" })
  }
), Mh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v48h110.1L23 263 6 280l34 33.9 17-17 215-215V192h48V0h-24zm424 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0M448 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m128 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-304-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-176 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96m432-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), xh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 0h-24v48h126.1L207 271l-17 17 34 33.9 17-17 223-223V208h48V0h-24zM24 32H0v480h480V288h-48v176H48V80h176V32h-24z" })
  }
), Hh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 96h24v288h-48V177.9L81 401l-17 17-33.9-34 17-17 223-223H64V96h24z" })
  }
), Vh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111 50.2 17-17 17 17 96 96 17 17-34 33.9-17-17-55-55V480h-48V125.1l-55 55-17 17-33.9-33.9 17-17 96-96zM312 48h72v48h-96V48zm0 128h136v48H288v-48zm0 128h200v48H288v-48zm0 128h264v48H288v-48z" })
  }
), Ch = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 80v64h-64V80zm-64-48h-48v160h160V32h-48zm-208 1.3-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM368 432V304h128v128zm-48-176v224h224V256H368z" })
  }
), Lh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 80h96v96h-96zm-48-48v192h192V32H368zm-160 1.3-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM296 480h240l-27.7-48-64.6-112-27.7-48-27.7 48-64.6 112zm156.9-48h-73.8l36.9-63.9z" })
  }
), Bh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256v24H0v-24C0 114.6 114.6 0 256 0s256 114.6 256 256h-48c0-114.9-93.1-208-208-208M134.4 279.7l104-112 17.6-19 17.6 18.9 104 112 16.3 17.6-35.2 32.7-16.3-17.6-62.4-67.2V512h-48V245.1l-62.4 67.2-16.3 17.6-35.2-32.7 16.3-17.6z" })
  }
), uh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96V32H0v64zm96 0V32H96v64zm32 0h64V32h-64zm160 0V32h-64v64zm32 0h64V32h-64zm-142.5 55.6L224 133l-17.5 18.6-128 136L62.1 305l35 32.9 16.4-17.5 86.5-91.9V464h48V228.5l86.5 91.9 16.5 17.5 35-32.9-16.4-17.5-128-136z" })
  }
), Rh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h384V32h-24zm185.5 135.6L192 149l-17.5 18.6-128 136L30.1 321l35 32.9 16.4-17.5 86.5-91.9V480h48V244.5l86.5 91.9 16.5 17.5 35-32.9-16.4-17.5-128-136z" })
  }
), $h = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296 224h240l-30-48-61.7-98.7L416 32l-28.3 45.3L326 176zm86.6-48 33.4-53.4 33.4 53.4zM160 33.3l-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM368 432v-96h96v96zm-48-144v192h192V288H368z" })
  }
), kh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m111 50.2 17-17 17 17 96 96 17 17-34 33.9-17-17-55-55V480h-48V125.1l-55 55-17 17-33.9-33.9 17-17 96-96zM312 480h-24v-48h96v48h-24zm0-128h-24v-48h160v48h-24zm0-128h-24v-48h224v48h-24zm0-128h-24V48h288v48h-24z" })
  }
), Ph = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 32v48h102.1l-95 95-7 7v42H504v-48H401.9l95-95 7-7V32H352zm-168 1.3-17 17-96 96-17 17 34 33.8 17-17 55-55V480h48V125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM400.6 272l-6.4 14-89.3 194h52.8l14.7-32H456c1.2 0 2.3-.1 3.4-.2l14.8 32.2H527l-89.2-194-6.4-14zm15.4 81.4 21.4 46.6h-42.8z" })
  }
), Fh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m209 50.2-17-17-17 17L21.4 203.8l-17 17 33.9 33.9 17-17L168 125.1V480h48V125.1l112.6 112.7 17 17 33.9-33.9-17-17L209 50.2z" })
  }
), Th = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 32h-24v48h110.1L18.2 427.8l-17 17 33.9 33.9 17-17L400 113.9V224h48V32h-24zM52.2 50.2l-17-17-33.9 34 17 17 147 147 34.3-33.6L52.2 50.2zM366.1 432H256v48h192V288h-48v110.1L278.7 276.8l-34.3 33.6z" })
  }
), Ah = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M552 432H0v48h576v-48zm-16-193.9-17 17-47 47V32h-48v270.1l-47-47-17-17-33.9 33.9 17 17 88 88 17 17 17-17 88-88 17-17zm-320 0-17 17-47 47V32h-48v270.1L57 255l-17-17-33.9 34 17 17 88 88 17 17 17-17 88-88 17-17z" })
  }
), Dh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 0v142.1l23-23 17-17 33.9 33.9-17 17-64 64-17 17-17-17L63 153l-17-17 34-33.9 17 17 23 23V0zm112 200a40 40 0 1 1 80 0 40 40 0 1 1-80 0m-22.3 56h124.6l6.8 12.6L434 352h124.1l6.9 12.3 56 100.8 11.7 21-42 23.3-11.7-21-19-34.2V512H432v-57.8l-19 34.2-11.7 21-42-23.3 11.7-21 35.3-63.4-3.4-6.3-18.9-35V432H256v-71.7l-18.9 35-3.4 6.3 35.3 63.5 11.7 21-42 23.3-11.7-21-19-34.2V512H80v-57.8l-19 34.3-11.7 21-42-23.3 11.7-21 56-100.9 6.9-12.3H206l44.9-83.4zm46.3 48v80h32v-80zm152-8a40 40 0 1 1 80 0 40 40 0 1 1-80 0m-312-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-16 208h32v-64h-32zM520 24v118.1l23-23 17-17 33.9 33.9-17 17-64 64-17 17-17-17-64-64-17-17 34.1-33.9 17 17 23 23V0h48zm-40 376v64h32v-64z" })
  }
), yh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 18.2-17-17-17 17-64 64-17 17 34 33.9 17-17 23-23V192h48V93.1l23 23 17 17 33.9-33.9-17-17-64-64zm7 325.8v-24h-48v98.9l-23-23-17-17-33.9 33.9 17 17 64 64 17 17 17-17 64-64 17-17-34.1-33.9-17 17-23 23zM64 224H0v64h64zm96 0H96v64h64zm32 64h64v-64h-64zm160-64h-64v64h64zm32 0v64h64v-64z" })
  }
), bh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 18.2-17-17-17 17-64 64-17 17 34 33.9 17-17 23-23V192h48V93.1l23 23 17 17 33.9-33.9-17-17-64-64zm7 325.8v-24h-48v98.9l-23-23-17-17-33.9 33.9 17 17 64 64 17 17 17-17 64-64 17-17-34.1-33.9-17 17-23 23zM24 232H0v48h448v-48h-24z" })
  }
), fh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 64v384H0V64zm209.9 88-17 17-63 63H462l-63-63-17-17 34-33.9 17 17L537 239l17 17-17 17-104 104-17 17-33.9-34 17-17 63-63H178l63 63 17 17-34 33.9-17-17L103 273l-17-17 17-17 104-104 17-17zM640 88v360h-48V64h48z" })
  }
), Uh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m493.8 273 17-17-17-17-96-96-17-17-33.9 34 17 17 55 55H93.1l55-55 17-17-33.9-33.9-17 17-96 96-17 17 17 17 96 96 17 17 33.9-34.1-17-17-55-55h325.7l-55 55-17 17 33.9 33.9 17-17 96-96z" })
  }
), Gh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 32h-24v48h94.1L256 222.1 113.9 80H208V32H32v176h48v-94.1L222.1 256 80 398.1V304H32v176h176v-48h-94.1L256 289.9 398.1 432H304v48h176V304h-48v94.1L289.9 256 432 113.9V208h48V32h-24z" })
  }
), qh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 14.1 65 31l111 111V32h48v192H32v-48h110.1L31 65 14 48l34-33.9zM497.9 48 481 65 370 176h110v48H288V32h48v110.1L447 31l17-17zM32 288h192v192h-48V369.9L65 481l-17 17-33.9-34 17-17 111-111H32zm256 0h192v48H369.9L481 447l17 17-34 33.9-17-17-111-111V480h-48V312z" })
  }
), Wh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 280V104h370.7l-50.8-46.2-17.8-16.2 32.3-35.5 17.8 16.1 88 80 7.9 7.1V152H48v128zm512-48v176H141.3l50.9 46.2 17.8 16.1-32.3 35.5-17.8-16.1-88-80-7.9-7.1V360h400V232zm-272-40h48v128h-48v-80h-24v-48z" })
  }
), Eh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256v24h48V152h318.1l-47 47-17 17 33.9 33.9 17-17 88-88 17-17-17-17L353 23 336 6l-33.9 34 17 17 47 47H0v24zm504 0v-24h-48v128H145.9l47-47 17-17-33.9-33.9-17 17L71 367l-17 17 17 17 88 88 17 17 33.9-34-17-17-47-47H504v-24z" })
  }
), Oh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m145 82.2-17-17-17 17-88 88-17 17 34 33.9 17-17 47-47V416h248v-48H152V157.1l47 47 17 17 33.9-33.9-17-17-88-88zM312 96h-24v48h200v210.9l-47-47-17-17-33.9 33.9 17 17 88 88 17 17 17-17 88-88 17-17-34.1-33.9-17 17-47 47V96h-24z" })
  }
), Ih = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 224H304v-48h110.1L362 123.9C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1l-44.2-18.8C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9l52.1 52.2V32h48v168zM16 288h192v48H97.9l52.1 52.1c28.2 28.1 66.3 43.9 106 43.9 72.6 0 135-43.9 161.9-106.8l44.1 18.9C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V480H16V312z" })
  }
), Nh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3V42.1c10.8-1.7 21.9-2.5 33.1-2.5 55.4 0 105.9 20.9 144.2 55.2L448 48l16 16v128H336l-16-16 47.3-47.3c-29.5-25.6-68-41.2-110.2-41.2zm-216 168c0-55.2 20.7-105.5 54.7-143.7L48 64l16-16h128v128l-16 16-46.1-46.1c-25.4 29.4-40.7 67.8-40.7 109.7 0 11.1 1.1 22 3.1 32.5H43.6c-1.6-10.6-2.4-21.4-2.4-32.5zm71.1 160.2L64 464l-16-16V320h128l16 16-45.7 45.7c29.6 26 68.4 41.8 110.9 41.8 10.5 0 20.9-1 30.9-2.8v48.6c-10.1 1.4-20.4 2.2-30.9 2.2-55.7 0-106.6-21.1-144.9-55.8zM336 320l46.9 46.9c26.3-29.6 42.2-68.7 42.2-111.4 0-10.8-1-21.3-3-31.5h48.7c1.5 10.3 2.3 20.8 2.3 31.5 0 56-21.3 107-56.2 145.4L464 448l-16 16H320V336z" })
  }
), Xh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 148.2-17 17-33.9-33.9 17-17 89-89V24h1.3l5.8-5.8 17-17 17 17L343 24h1v1.3l89 89 17 17-34 33.8-17-17-55-55V464h168v48H296V312H93.1l55 55 17 17-33.9 33.9-17-17-89-89H24v-1.3l-5.8-5.6-17-17 17-17 5.8-5.8V264h1.3l89-89 17-17 33.8 34-17 17-55 55H296V93.1l-55 55z" })
  }
), Kh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m52.2 18.2-17-17-33.9 34 17 17L126.1 160H64v48h144V64h-48v62.1L52.2 18.2zm569.6 34 17-17-34-33.9-17 17L480 126.1V64h-48v144h144v-48h-62.1zM126.1 352 18.2 459.8l-17 17 33.9 33.9 17-17L160 385.9V448h48V304H64v48h24zM480 385.9l107.8 107.9 17 17 33.9-33.9-17-17L513.9 352H576v-48H432v144h48v-24zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), Qh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v110.1L201 79l-17-17-33.9 34 17 17 72 72 17 17 17-17 72-72 17-17L328 62.1 311 79l-31 31zm136 337.9 33.9-33.9-17-17-31-31H512v-48H401.9l31-31 17-17-33.9-33.9-17 17-72 72-17 17 17 17 72 72 17 17zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-175-89-17-17-33.9 34 17 17 31 31H0v48h110.1L79 311l-17 17 34 33.9 17-17 72-72 17-17-17-17-72-72zm37.1 249 33.9 33.9 17-17 31-31V512h48V401.9l31 31 17 17 33.9-33.9-17-17-72-72-17-17-17 17-72 72-17 17z" })
  }
), Zh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 201.9 17-17 72-72 17-17-34-33.8L279 79l-31 31V0h-48v110.1L169 79l-17-17-33.9 34 17 17 72 72 17 17zM0 224v64h64v-64zm96 0v64h64v-64zm96 0v64h64v-64zm96 0v64h64v-64zm160 0h-64v64h64zM241 327l-17-17-17 17-72 72-17 17 34 33.9 17-17 31-31V512h48V401.9l31 31 17 17 33.9-33.9-17-17-72-72z" })
  }
), Jh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m52.2 18.2-17-17-33.9 34 17 17L78.1 112H16v48h144V16h-48v62.1L52.2 18.2zm172.4 292.6c-19-17.6-33.5-37.9-43.1-54.8 9.6-16.9 24.1-37.2 43.1-54.8 26.3-24.5 58.1-41.2 95.4-41.2s69.1 16.7 95.4 41.2c19 17.6 33.5 37.9 43.1 54.8-9.6 16.9-24.1 37.2-43.1 54.8-26.3 24.5-58.1 41.2-95.4 41.2s-69.1-16.7-95.4-41.2zM320 400c105.6 0 172-96 192-144-20-48-86.4-144-192-144s-172 96-192 144c20 48 86.4 144 192 144M604.8 1.3l-17 17L528 78.1V16h-48v144h144v-48h-62.1l59.8-59.8 17-17-33.9-33.9zM52.2 493.8l59.8-59.9V496h48V352H16v48h62.1l-59.9 59.8-17 17 33.9 33.9 17-17zm552.6 17 33.9-33.9-17-17-59.8-59.9H624v-48H480v144h48v-62.1l59.8 59.8 17 17zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), jh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 201.9 17-17 72-72 17-17-34-33.8L279 79l-31 31V0h-48v110.1L169 79l-17-17-33.9 34 17 17 72 72 17 17zM0 232v48h448v-48H24zm241 95-17-17-17 17-72 72-17 17 34 33.9 17-17 31-31V512h48V401.9l31 31 17 17 33.9-33.9-17-17-72-72z" })
  }
), Yh = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M315.3 6.1 333 22.3l89.1 81.7h1.9v1.7l5 4.6 19.3 17.7-19.3 17.7-5 4.6v1.7h-1.9L333 233.7l-17.7 16.2-32.4-35.4 17.7-16.2 50.5-46.3H48v136H0V104h351.1l-50.5-46.3-17.7-16.2 32.4-35.4zm-84.8 256 17.7 16.2 96 88 19.3 17.7-19.3 17.7-96 88-17.7 16.2-32.4-35.4 17.7-16.2 50.5-46.3H48v104H0V360h266.3l-50.5-46.3-17.7-16.2 32.4-35.4z" })
  }
), _h = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m255 31-80 80-17 17 17 17 80 80 17 17 33.9-34-17-17-39-39H464v104h48V104H249.9l39-39 17-17L272 14.1zm2 256-17-17-33.9 34 17 17 39 39H0v152h48V408h214.1l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80zm255 97a64 64 0 1 0-128 0 64 64 0 1 0 128 0M64 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128" })
  }
), hc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m273 18.2-17-17-17 17-72 72-17 17 34 33.9 17-17 31-31V232H93.1l31-31 17-17-33.9-33.9-17 17-72 72-17 17 17 17 72 72 17 17 33.9-34.1-17-17-31-31H232v140.2l-30.7-32-16.6-17.3-34.7 33.2 16.6 17.3 72 75.2 17.4 18.1 17.3-18.1 72-75.2 16.6-17.3-34.7-33.2-16.6 17.3-30.7 32V280h139l-31 31-17 17 33.9 33.9 17-17 72-72 17-17-17-17-72-72-17-17-33.9 34.1 17 17 31 31H280V93.1l31 31 17 17 33.9-33.9-17-17-72-72z" })
  }
), cc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m177 18.2-17-17-17 17-96 96-17 17 34 33.9 17-17 55-55v325.8l-55-55-17-17-33.9 33.9 17 17 96 96 17 17 17-17 96-96 17-17-34.1-33.9-17 17-55 55V93.1l55 55 17 17 33.9-33.9-17-17-96-96z" })
  }
), sc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 80h552V32H0v48zm16 193.9 17-17 47-47V480h48V209.9l47 47 17 17 33.9-33.9-17-17-88-88-17-17-17 17L23 223 6 240zm320 0 17-17 47-47V480h48V209.9l47 47 17 17 33.9-33.9-17-17-88-88-17-17-17 17-88 88-17 17z" })
  }
), vc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 32v180.9l131.4-81.3 25.3 40.8L237.6 256l135 83.6-25.3 40.8L216 299.1V480h-48V299.1L36.6 380.4l-25.2-40.8 135-83.6-135-83.6 25.3-40.8L168 212.9V32z" })
  }
), ec = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208h32v48h-32C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v120h-72c-36.9 0-69.6-17.8-90-45.4-22 27.6-55.9 45.4-94 45.4-66.3 0-120-53.7-120-120s53.7-120 120-120c27 0 51.9 8.9 72 24v-8h48v112c0 35.3 28.7 64 64 64h24v-72c0-114.9-93.1-208-208-208m72 208a72 72 0 1 0-144 0 72 72 0 1 0 144 0" })
  }
), lc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M89.6 422.4c7.9 7.9 31.4 16.9 80.4.6 13.2-4.4 27.2-10.4 41.6-17.9-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8C99.4 314.8 93.4 328.8 89 342c-16.3 49-7.3 72.5.6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3S338.1 484.4 256 435.2c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256m30.2-44.4c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9-49-16.3-72.5-7.3-80.4.6S72.8 121 89.1 170c4.4 13.2 10.4 27.2 17.9 41.6M256 134c-22.1 15.5-44.5 34.1-66.2 55.8S149.5 233.9 134 256c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2S278.1 149.5 256 134m149 77.7c7.5-14.4 13.5-28.4 17.9-41.6 16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9 18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9 49 16.3 72.5 7.3 80.4-.6s16.9-31.4.6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM256 296l-40-40 40-40 40 40z" })
  }
), tc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4-17.1 7.5-34 13.6-50.3 18.4 18.4 38.3 37.4 46.8 50.3 46.8s31.9-8.5 50.3-46.8M293 325.7c14.8-8.9 28.7-18.1 41.4-27.6 1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6-12.5-7.5-24.9-14.2-37-20.2-12.1 6-24.5 12.7-37 20.2-14.8 8.9-28.7 18.1-41.4 27.6-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6 12.5 7.5 24.9 14.2 37 20.2 12.1-6 24.5-12.7 37-20.2m120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9-2.4 20.1-5.8 39.2-10.3 57 37.2 2.2 51.9-9.1 57.8-19.7 6.5-11.7 8.2-32.8-14.1-67.2M469.6 128c20.7 37.1 9.4 82.8-23.6 128 33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128 20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7-4.5-17.8-7.9-36.9-10.3-57-12-9.7-23.2-19.8-33.4-29.9-22.3 34.3-20.7 55.5-14.1 67.2zm14.1-142.2c10.2-10.2 21.3-20.2 33.4-29.9 2.4-20.1 5.8-39.2 10.3-57-37.2-2.3-51.9 9.1-57.8 19.7-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9 22.3-34.3 20.6-55.5 14.1-67.2-5.9-10.6-20.6-22-57.8-19.7 4.5 17.8 7.9 36.9 10.3 57M216 256l40-40 40 40-40 40z" })
  }
), wc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-12.9-10V32H70.5zm84 65.2H560v332l-94.8-73.6c28-16.7 46.8-47.4 46.8-82.4 0-53-43-96-96-96h-80v78.1l-93.9-72.9-2.2-5.2h-4.4l-103-80zm288.2 223.8L384 275.4V208h32c26.5 0 48 21.5 48 48 0 25-19 45.5-43.4 47.8M32 432v48h455.4l-60.9-48H80V159l-48-37.8zm94.4-80h52.2l10.3-24.2h70.4l10.2 24.2h52.2l-1.7-3.9-78.5-61.9.7 1.6h-36.3l9.5-22.2-39.1-30.8z" })
  }
), gc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm328 128h56c53 0 96 43 96 96s-43 96-96 96h-80V160zm24 144h32c26.5 0 48-21.5 48-48s-21.5-48-48-48h-32zm-178.1-16.2h36.3L192 245.2zm-17 40L146.5 352H94.4L170 174.6l6.2-14.6h31.7l6.2 14.6L289.6 352h-52.1l-10.3-24.2h-70.4z" })
  }
), ic = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M199.7 32H248.3l6 15.2L324.4 224H448v48H343.4l19 48H448v48h-66.6l40.9 103.2 3.5 8.8h-51.6l-44.4-112H118.2L73.8 480H22.2l3.5-8.8L66.6 368H0v-48h85.6l19-48H0v-48h123.6l70.1-176.8 6-15.2zm24.3 69-48.8 123h97.5zm-86.8 219h173.6l-19-48H156.2z" })
  }
), mc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m382 265.7 53.9-53.9c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-53.9 54-14.5 14.5-20.5-.4c-42.1-.9-84.4 14.7-116.5 46.8-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c32.1-32.1 47.7-74.3 46.8-116.5l-.4-20.5zm87.8-19.9L416 299.7c1.1 54.7-19.2 109.7-60.9 151.4-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c41.7-41.7 96.7-62 151.4-60.9l53.9-53.9c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6zM283.2 347.2c-41.7 41.7-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8 102.1-49.1 134.8-16.4 25.3 93-16.4 134.8z" })
  }
), ac = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M236.2 26.9 192 0l-44.2 26.9L96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2-1.2 51.8 45.4 24.8L96 358.3l3.5-.1 48.3-1.1L192 384l44.2-26.9 48.3 1.1 3.5.1 24.8-45.4 45.5-24.9-1.2-51.8L384 192l-26.9-44.2 1.2-51.8-45.5-24.8L288 25.7l-51.8 1.2zm23.7 47.5 10.8 19.8 6.8 12.4 12.4 6.8 19.8 10.8-.5 22.5-.3 14.1 7.3 12 11.6 19.2-11.7 19.3-7.3 12 .3 14.1.5 22.5-19.8 10.8-12.4 6.8-6.8 12.4-10.8 19.8-22.5-.5-14.1-.3-12 7.3-19.2 11.6-19.3-11.7-12-7.3-14.1.3-22.5.5-10.8-19.8-6.8-12.4-12.4-6.8-19.7-10.7.5-22.5.3-14.1-7.3-12L56.2 192l11.7-19.3 7.3-12-.3-14.1-.5-22.5 19.8-10.8 12.4-6.8 6.8-12.4 10.8-19.8 22.5.5 14.1.3 12-7.3L192 56.2l19.3 11.7 12 7.3 14.1-.3zM256 192a64 64 0 1 0-128 0 64 64 0 1 0 128 0M64 512l128-48 128 48-28.1-121.6-4.7-.1-42.4-1-36.2 22.1-16.6 10.1-16.6-10.1-36.2-22.1-42.4 1-4.7.1z" })
  }
), oc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M236.2 26.9 192 0l-44.2 26.9L96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2-1.2 51.8 45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4 45.5-24.9-1.2-51.8L384 192l-26.9-44.2 1.2-51.8-45.5-24.8L288 25.7l-51.8 1.2zm23.7 47.5 10.8 19.8 6.8 12.4 12.4 6.8 19.8 10.8-.5 22.5-.3 14.1 7.3 12 11.6 19.2-11.7 19.3-7.3 12 .3 14.1.5 22.5-19.8 10.8-12.4 6.8-6.8 12.4-10.8 19.8-22.5-.5-14.1-.3-12 7.3-19.2 11.6-19.3-11.7-12-7.3-14.1.3-22.5.5-10.8-19.8-6.8-12.4-12.4-6.8-19.7-10.7.5-22.5.3-14.1-7.3-12L56.2 192l11.7-19.3 7.3-12-.3-14.1-.5-22.5 19.8-10.8 12.4-6.8 6.8-12.4 10.8-19.8 22.5.5 14.1.3 12-7.3L192 56.2l19.3 11.7 12 7.3 14.1-.3zM256 192a64 64 0 1 0-128 0 64 64 0 1 0 128 0M0 456h75.8l52.2 56 43.4-103.1-32.3-19.7-42.4 1-19.5.5-9.3-17.1-18.7-34.3zm256 56 52.2-56H384l-49.1-116.7-18.8 34.3-9.3 17.1-19.5-.5-42.4-1-32.3 19.7z" })
  }
), nc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511 215c-5.1 59.5-29 103.2-50.5 131.3C441.3 371.4 424 384 424 384s-6.3-20.1-21.8-44.4c-17.3-26.9-46-59-90.2-74.4V215c52 13.6 88.9 44.8 113.3 74.7 3 3.7 5.8 7.4 8.5 11 11-17.8 21.3-40.6 26.6-68.5l-6.3-6.3-34-33.9 33.9-33.9 6.3-6.3c-5.3-28-15.6-50.8-26.6-68.5-2.6 3.6-5.5 7.3-8.5 11C400.9 124.2 364 155.4 312 169v-50.2c44.2-15.4 72.9-47.5 90.2-74.4C417.7 20.1 424 0 424 0s17.3 12.6 36.5 37.7C482 65.7 506 109.5 511 169l-23 23zM109.8 44.4c17.3 26.9 46 59 90.2 74.4V169c-52-13.6-88.9-44.8-113.3-74.7-3-3.7-5.8-7.4-8.5-11C62.5 108.8 48 144.8 48 192s14.5 83.2 30.3 108.7c2.6-3.6 5.5-7.3 8.5-11C111.1 259.8 148 228.6 200 215v50.2c-44.2 15.4-72.9 47.5-90.2 74.4C94.3 363.9 88 384 88 384s-17.3-12.6-36.5-37.7C27.3 314.8 0 263.3 0 192S27.3 69.2 51.5 37.7C70.7 12.6 88 0 88 0s6.3 20.1 21.8 44.4zM280 56v456h-48V32h48z" })
  }
), rc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 448 64 64 249.4-249.4-64-64zM400 48l-14.1-14.1L352 0l-33.9 33.9-60.2 60.2L224 128l33.9 33.9L384 288v128h32c5.4 0 10.7-.2 16-.6C543 407.6 631.6 319 639.4 208c.4-5.3.6-10.6.6-16v-32H512l-48-48 48-48-64-64zm112 160h79.3c-7.6 84.4-74.8 151.7-159.3 159.3V268.1L417.9 254l-126-126L352 67.9l126.1 126 14 14.1z" })
  }
), dc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h196c68.5 0 124-55.5 124-124 0-48.2-27.5-90-67.8-110.5 22.1-21.8 35.8-52 35.8-85.5v-8c0-66.3-53.7-120-120-120zm144 200H48V80h120c39.8 0 72 32.2 72 72v8c0 39.8-32.2 72-72 72M48 280h148c42 0 76 34 76 76s-34 76-76 76H48z" })
  }
), Sc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m123 0 133 192h144V96h112v48h-64v80c0 28-6.1 55.6-17.7 81.1-11.6 25.5-28.6 48.4-49.5 67.5-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3-51.5-25-72.5-44.1-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224v-32h.1C3.1 108 52.3 35.8 123 0M80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96m240 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M56.1 272c1.5 4.5 3.3 8.9 5.3 13.2 8.8 19.4 21.8 37 38.2 51.9s35.7 26.6 57.1 34.7 44.2 12.2 67.4 12.2 46-4.1 67.4-12.2 40.8-19.8 57.1-34.7 29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2 3.6-10.4 6-21.1 7.2-32H48.9c1.2 10.9 3.6 21.6 7.2 32z" })
  }
), zc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160M96 101.5l17 17 28.3 28.3 45.2 45.2h75l45.3-45.3 28.2-28.2 17-17 17 17 56.5 56.5 17 17-17 17-28.3 28.3-61.2 61.2v1.3l44.4 63.5 11.8 16.9 7.1 10.2-4.2 11.7-7 19.5-24 67.2-8.1 22.6-22.6-8.1-75.3-26.9-22.6-8.1 8.1-22.6 12.9-36.1-6.7-9.6h-51.7l-6.7 9.6 12.9 36.1 8.1 22.6-22.6 8.1-75.3 26.9-22.6 8.1-8.1-22.6-24-67.2-7-19.5-4.2-11.7 7.1-10.2 11.9-16.9 44.4-63.5v-1.3l-61.3-61.2L22.5 209l-17-17 17-17L79 118.5zM84.7 203.3l64 64 4.3 4.3 7 7v9.4h128v-9.4l7-7 4.3-4.3 64-64 11.3-11.3-22.6-22.6-11.3 11.3-52.3 52.3-7 7H166.7l-7-7-52.3-52.3L96 169.4 73.4 192zm221.1 137.1-24.2 21.2.4.6 21 30 7.1 10.2-4.1 11.7-9 25.1 30.1 10.8 15.9-44.6 2.8-7.8-4.7-6.8zm-139.4 21.2-24.2-21.2-35.3 50.4-4.7 6.8 2.8 7.8 15.9 44.6 30.1-10.8-9-25.1-4.2-11.7 7.1-10.2 21-30 .4-.6z" })
  }
), pc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h176v80h8c70.7 0 128 57.3 128 128v304H0V208C0 137.3 57.3 80 128 80h8V24zm-8 464h192v-64H128zm240 0h32V208c0-44.2-35.8-80-80-80H128c-44.2 0-80 35.8-80 80v256h32V240h288v136zM264 48h-80v32h80zM144 160h184v48H120v-48zm176 192v-64H128v64z" })
  }
), Mc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64v158.1L240 97.9 288 64v158.2L464 97.9 512 64v384l-48-33.9-176-124.2V448l-48-33.9L64 289.9V448H16V64zm176 192v-99.4L99.2 256 240 355.4zm83.2 0L464 355.4V156.6z" })
  }
), xc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 88V64H32v384h48V309.6l176 108.8 48 29.6V64l-48 29.6L80 202.4zm4.5 168L256 150.1v211.8z" })
  }
), Hc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M43.3 284.8 0 256l43.3-28.8L240 96l48-32v134.4L464 92.8 512 64v384l-48-28.8-176-105.6V448l-48-32L43.3 284.8zM288 257.6l176 105.6V148.8L288 254.4zm-48 100.7V153.7L86.5 256z" })
  }
), Vc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 352c16.2-7.3 31-14.3 44.6-21.1 118.5-59 141.5-98.6 166.2-141C239.1 141.4 269.6 89.2 448 0l97.4 121.7L576 160c-15.6 7.8-30 15.3-43.4 22.5C392.3 258.3 364.7 305.7 338.8 350c-27.5 47.2-53 91-210.8 162L30.9 390.7zm100.4 48.7c49.3-26.4 81.3-50 104.7-72 24.3-23 39.9-44.8 56.9-68.5l1.9-2.6c17.7-24.8 37-51.3 68.5-80.6 28.9-27 67.8-56 124.8-88.9l-22.1-27.4c-64.8 34.5-103.6 61.8-128.5 84.1-27.9 25-40 45-53.1 67.4l-1.5 2.5c-13.9 23.8-30.2 51.9-64.8 82.3-26 22.9-61.2 46.3-112 72.2l25.2 31.4zm20.3 25.4 21.2 26.5c56.7-27.5 89.3-49.4 109.9-67.6 22.8-20.1 32.6-36.9 46.1-60l.7-1.2c14.9-25.5 32.9-55.6 71.9-90.6 29.9-26.8 71.3-55.7 131.6-88.8l-24.9-31.1c-57.8 32.9-95.7 61.4-123.2 87-29 27.1-46.8 51.4-64.3 75.8l-2.2 3.1c-16.8 23.5-33.9 47.5-60.6 72.7-25 23.6-57.9 47.8-106.3 74.1z" })
  }
), Cc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m323.9 17.2-7.5 16.3-.3.6c14.6 7.9 26.9 20.2 34.7 35.5l10.2-2.9 17.3-4.9 9.9 34.6-17.3 4.9-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8 12.7 12.8-25.4 25.5-12.7-12.7-8-8c-7.9 5.1-16.8 8.9-26.4 11.1-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6 4.9 17.3-34.6 9.9-4.9-17.3-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6 16.5 7.1-14.2 33.1-16.5-7.1-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7-1.4 13.3-6 25.6-12.7 36.2l8 8 12.7 12.6-25.5 25.5-12.7-12.7-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11-4.9 17.3-34.6-9.9 4.8-17.4 2.9-10.3c-15.1-7.8-27.5-19.9-35.5-34.7l-.6.3-16.3 7.5-15.1-32.6 16.3-7.5 5.7-2.6c-.2-4.2-.2-8.4.2-12.6 1.1-12.1 3.8-24.2 7-35.9.2-.8.4-1.5.7-2.3l-8.7-3.5L6.6 220 20 186.6l16.7 6.7 7.4 3c4.6-10.7 10.3-22.2 17.4-34 1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9-14.1-11.2 22.5-28.1 14.1 11.2 10 8.1c10.2-12.2 22-24.1 35.5-35.3L117 82l-10-15 30-20 10 15 4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5-7.1-16.5 33.1-14.1 7.1 16.5 4.4 10.3c8.4-2.6 17.1-4.9 26.2-7 8-1.9 16.1-2.5 23.9-2l2.6-5.7 7.5-16.3 32.7 15.1zM143.8 279.9l.3-2.1c3.2-20.9 11.7-39.5 20.3-53.8 18-30 52.2-65.4 119.7-80.9 19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1-13.3 22.1-20.8 42.9-25 58.3-2.8 10-4.7 19.2-5.5 27.6-1.8 19.8 12.8 37.2 32.6 39 19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8-18 30-52.2 65.4-119.7 80.9-19.4 4.5-31.4 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1 13.3-22.1 20.8-42.9 25-58.3 2.8-10 4.7-19.2 5.5-27.6 1.8-19.8-12.8-37.2-32.6-39-19.6-1.8-36.9 12.5-39 31.9zm39.3-80 3.1-11 4.9-17.3 34.6 9.9-4.9 17.3-2.9 10.3c15.1 7.8 27.5 19.9 35.5 34.7l.6-.3 16.3-7.5 15.1 32.7-16.3 7.5-5.7 2.6c.2 4.2.2 8.4-.2 12.6-1.1 12.1-3.8 24.2-7 35.9-.2.8-.4 1.5-.7 2.3l8.7 3.5 16.7 6.7-13.3 33.4-16.7-6.7-7.4-3c-4.6 10.7-10.3 22.2-17.4 34-1.4 2.4-3 4.8-4.5 7.3l11.2 9 14.1 11.2-22.5 28.1-14.1-11.2-10-8.1c-10.2 12.2-22 24.1-35.5 35.3l5.8 8.7 10 15-30 20-10-15-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5 7.1 16.5-33.1 14.2-7.1-16.5-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7-8 1.9-16.1 2.5-23.9 2l-2.6 5.7-7.5 16.3-32.7-15.1 7.5-16.3.3-.6c-14.6-7.9-26.9-20.2-34.7-35.5l-10.3 2.9-17.3 4.9-9.9-34.6 17.3-4.9 11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8-12.7-12.8 25.5-25.5 12.7 12.7 8 8c7.9-5.1 16.8-8.9 26.4-11.1 5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6-4.9-17.3 34.6-9.9 4.9 17.3 1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6-16.5-7.1 14.2-33.1 16.5 7.1 9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7 1.4-13.3 5.9-25.6 12.7-36.2l-8-8-12.7-12.6 25.5-25.5 12.7 12.7 8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32M96 240a16 16 0 1 1 32 0 16 16 0 1 1-32 0m304 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Lc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m422.3 40.9 8.9-22.3L386.6.8l-8.9 22.3-3.6 9.1c-10.3-.6-20.8.3-31.3 2.7-12.1 2.8-23.7 5.9-34.9 9.4L302 30.6l-9.4-22.1-44.1 18.9 9.5 22.1 4.9 11.3c-22 9.4-42 20.1-60.2 31.8l-6.7-9.9-13.3-20-40 26.6 13.3 20 7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3l-18.7-15-30 37.5 18.7 15 15 12c-2.1 3.2-4.1 6.5-6 9.7-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9-22.3-8.9-17.8 44.5 22.3 8.9 11.4 4.5c-4.8 16.8-8.2 34-10 51-.5 5-.6 10-.4 14.9l-14.7 4.2-23.1 6.6 13.2 46.2 23.1-6.6 13.8-3.9c10.4 20.2 26.8 37 47 47.8l-1.7 4.2-8.9 22.3 44.6 17.8 8.9-22.3 3.6-9.1c24.3 1.3 47.3-5.2 66.5-17.5L215 473l17 17 33.9-34-17-17-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5 22.1 9.5 18.9-44.1-22.1-9.5-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5 6.6 23.1 46.2-13.2-6.6-23.1-4-14.3c6.9-2.2 14.3-4.3 22.2-6.1 12.9-3 24.7-8 35.2-14.8L439 249l17 17 33.9-34-17-17-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2 23.1-6.6-13.2-46.2-23.1 6.6-13.7 3.9c-10.6-20.7-27.2-37.2-47.1-47.7l1.7-4.2zm-214.4 332-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8-35.1-3.2-61-34.2-58-69.2 4.4-41 20.4-84 42.9-121.4 38-63.4 107.9-131.1 230.5-159.4 34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8c-85.4 19.5-127.5 63.7-149.5 100.3-10.8 18-21.1 40.8-25 66M192 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0m48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Bc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5l9.3 17.6 19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7l-17.6 9.2 5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5C301 450.5 280 464 255.9 464s-45.1-13.5-55.7-33.5l-9.2-17.6-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7s-22.3-41.4-15.7-63l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7l17.6-9.3-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1s41.4-22.3 63-15.7l19 5.8zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0m113 209 17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), uc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5l9.3 17.6 19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7l-17.6 9.2 5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5C301 450.5 280 464 255.9 464s-45.1-13.5-55.7-33.5l-9.2-17.6-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7s-22.3-41.4-15.7-63l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7l17.6-9.3-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1s41.4-22.3 63-15.7l19 5.8zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0m20.9 149.3v-20h-40v28.5c-6.7 1.3-13.1 3.2-19.1 5.9-16.1 7.3-29.9 20.8-33.3 40.2-1.9 10.9-.9 21.4 3.6 30.9 4.4 9.3 11.3 15.9 18.5 20.8 12.6 8.5 29.3 13.6 42.4 17.5l2.3.7c15.4 4.6 26.3 8.3 33.2 13.3 3 2.2 4.3 4 4.9 5.4.6 1.3 1.2 3.9.4 8.7-.8 4.7-3.5 8.6-10.2 11.4-7.3 3.1-18.7 4.5-33.2 2.3-6.9-1.1-19-5.3-29.6-8.9-2.4-.8-4.7-1.6-6.9-2.3l-19-6.3-12.6 38 19 6.3c1.4.5 3.1 1 5 1.7 9.3 3.2 24 8.2 34.6 10.4v28.9h40v-28c6.5-1.1 12.7-2.8 18.5-5.3 16.9-7.2 30.3-21.1 33.8-41.4 1.9-11.2 1.1-21.8-3.1-31.4-4.2-9.6-10.9-16.6-18.1-21.8-13.2-9.6-30.8-14.9-44.4-19l-.8-.2c-15.6-4.7-26.7-8.2-33.8-13-3.1-2.1-4.3-3.7-4.8-4.8-.4-.9-1.1-2.8-.3-6.9.5-3.1 2.9-7.2 10.4-10.6 7.6-3.4 19.1-5.2 33.1-3 4.9.8 20 3.7 24.3 4.9l19.3 5.1 10.3-38.7-19.3-5.3c-5.3-1.4-18-3.9-25.1-5.2z" })
  }
), Rc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5l9.3 17.6 19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7l-17.6 9.2 5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5C301 450.5 280 464 255.9 464s-45.1-13.5-55.7-33.5l-9.2-17.6-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7s-22.3-41.4-15.7-63l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7l17.6-9.3-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1s41.4-22.3 63-15.7l19 5.8zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0m-64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-15-111 17-17-34-33.9-17 17L175 303l-17 17 34 33.9 17-17z" })
  }
), $c = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M253.6 66.9C260.1 59.8 264 50.3 264 40c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 10.3 3.9 19.8 10.4 26.9l-40 68.6-77.8.3C70.3 121.8 56.3 112 40 112c-22.1 0-40 17.9-40 40s17.9 40 40 40c2.7 0 5.2-.3 7.8-.8l37 64.8-37 64.8c-2.5-.5-5.1-.8-7.8-.8-22.1 0-40 17.9-40 40s17.9 40 40 40c16.3 0 30.3-9.8 36.6-23.8l77.8.3 40 68.6C188 452.2 184 461.6 184 472c0 22.1 17.9 40 40 40s40-17.9 40-40c0-10.3-3.9-19.8-10.4-26.9l40-68.6 77.8-.3c6.2 14 20.3 23.8 36.6 23.8 22.1 0 40-17.9 40-40s-17.9-40-40-40c-2.7 0-5.2.3-7.8.8l-37-64.8 37-64.8c2.5.5 5.1.8 7.8.8 22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.3 0-30.3 9.8-36.6 23.8l-77.8-.3-40-68.6zM224 312l56-56-56-56-56 56zm69.4-128.6 55.9.2-27.7 48.5-13.7 23.9 13.6 23.8 27.7 48.5-55.9.2-27.5.1-13.8 23.7-28 48.4-28.1-48.3-13.9-23.7-27.5-.1-55.9-.2 27.7-48.5 13.8-23.9-13.6-23.8-27.8-48.5 55.9-.2 27.5-.1 13.8-23.7 28.1-48.4 28.1 48.3 13.9 23.7 27.5.1z" })
  }
), kc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48c-24.1 0-45.1 13.5-55.7 33.5L191 99.1l-19-5.8c-21.6-6.6-46.1-1.4-63.1 15.7s-22.3 41.4-15.7 63l5.8 19-17.5 9.3C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7l17.6 9.3-5.8 19c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7l19-5.8 9.3 17.5c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5l9.3-17.5 19 5.8c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1l-5.8-19 17.5-9.3c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7l-17.7-9.3 5.8-19c6.6-21.6 1.4-46.1-15.7-63.1s-41.4-22.3-63-15.7L321 99l-9.3-17.5C301.1 61.5 280.1 48 256 48m-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93c26.3 20.2 43.3 52.1 43.3 88s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6S39 377 43.3 344C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z" })
  }
), Pc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M426.3 64h75l4.8 2.3 120 56 13.8 6.5V201.9l-7 7-32 32-7 7H590l-30 48-26.4-42.2c-39 8.7-74.8 26.4-103.4 45.6L455.7 452l4.7 27.9H315.7l-3.3-20.1L294.3 352h-73.9l-10.9 25.4 21.5 71.7 9.3 30.9H94.1L89 462.9l-24-80-2-6.7 1.9-6.8 8.5-29.6c-9.1-4.3-17.6-9.6-25.4-15.9V352H0V224C0 153.3 57.3 96 128 96h234.3l58.9-29.5zM48 224c0 37.4 25.7 68.9 60.4 77.6l24 6-6.8 23.8-12.6 44.4 16.9 56.2h45.9L161 382.9l-2.5-8.3 3.4-8 20.6-48 6.2-14.5H335l3.3 20.1 18 107.9h47.3l-23.2-139.8-2.4-14.5 11.9-8.7c44.1-32.5 110-66 184-68.9l18.1-18.1V176h-80.4c-1.9 9.1-9.9 16-19.6 16s-17.7-6.9-19.6-16h-52l-156.2 93.7-3.8 2.3H224c-69.3 0-127.2-49-140.9-114.2C61.9 172.2 48 196.5 48 224m65.3-78.7C121.7 199 168 240 224 240h27.6l156.2-93.7 3.8-2.3h147.6l-68.6-32h-53l-58.9 29.5-5.1 2.5H128c-5 0-9.9.5-14.7 1.3" })
  }
), Fc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6 48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9m-34-34C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-70.3 70.3-178.8 90.2-252.3 36.2L161 385l23 23-33.9 33.9L114 478l-34 34-33.9-33.9-12.2-12.2L0 432l33.9-33.9L70 362l34-34 23 23 31.8-31.8C137.9 290.5 128 256 128 221c0-54.2 23.4-110.5 66.9-154zM116.1 408 104 395.9 67.9 432 80 444.1zM512 352c26.5 0 48 21.5 48 48v32h-96v-32c0-26.5 21.5-48 48-48m-48.5 96h97.1l11.1 39 4.4 15.4-30.8 8.8-4.4-15.4-12.9-45.2V512h-32v-61.4l-12.9 45.2-4.4 15.4-30.7-8.8 4.4-15.4z" })
  }
), Tc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M91.9 150.1C84 181.9 80 214.4 80 247.2v17.7c0 32.7 4 65.3 11.9 97l5.6 22.1h317l5.5-22.1c7.9-31.7 11.9-64.3 11.9-97v-17.7c0-32.7-4-65.3-11.9-97l-5.5-22.2h-317L92 150.1zM417.5 48h-323l8.5 32h306zm-316 384-8 32h325l-8-32zM44.8 48 32 0h448l-12.8 48-12 44.9 11.4 45.6c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416l12 48 12 48H32l12-48 12-48-10.6-42.5C36.5 338 32 301.5 32 264.8v-17.6c0-36.6 4.5-73.1 13.4-108.7l11.4-45.6zM160 160c40.7 0 76.4 21.8 96 54.3 19.6-32.5 55.3-54.3 96-54.3h32v16c0 59.2-45.9 107.6-104 111.7V352h-48v-64.3c-58.1-4.1-104-52.6-104-111.7v-16z" })
  }
), Ac = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 112v48h128v-48c0-35.3-28.7-64-64-64s-64 28.7-64 64m-48 96H48v256h352V208h-64v80h-48v-80H160v80h-48v-24zm0-48v-48C112 50.1 162.1 0 224 0s112 50.1 112 112v48h112v352H0V160h48z" })
  }
), Dc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 208c0 114.9-93.1 208-208 208-3.9 0-7.7-.1-11.5-.3 5.7-10.8 10.6-22.1 14.6-33.8l43.7-29.9 56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4-44.9-34.6-19-53.4-56.7-1.6L432 32l-46.8 32-56.7 1.6-9.2 25.7c-14.4-7.6-29.7-13.7-45.7-18.3 38.2-44.6 95-73 158.4-73 114.9 0 208 93.1 208 208m-144 0c0 30.6-21.5 56.3-50.3 62.5-6-43.3-23.6-82.9-49.5-115.6 10.2-6.9 22.6-11 35.9-11 35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0 160 160 0 1 0-320 0m-48 0a208 208 0 1 1 416 0 208 208 0 1 1-416 0m136-96 24-24 24 24-24 24zm-40 88-24-24 24-24 24 24zm32 112-24-24 24-24 24 24zm176-144-24-24 24-24 24 24zm-88 152 24-24 24 24-24 24zm88-8-24-24 24-24 24 24zM192 304a16 16 0 1 0 32 0 16 16 0 1 0-32 0m16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128" })
  }
), yc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64h-96zm-48 64H0v320h160v-48H48V208h352v16h48v-64H320V96c0-53-43-96-96-96s-96 43-96 96zm448 96H192v256h384zm-256 80v16c0 35.3 28.7 64 64 64s64-28.7 64-64v-32h32v32c0 53-43 96-96 96s-96-43-96-96v-32h32z" })
  }
), bc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2L398 107.9l35 35.1 17 17-34 33.9-17-17-41.9-41.9-74.5 49.6L321 223l17 17-34 33.9-17-17-45.1-45.1-74.5 49.6L209 303l17 17-34 33.9-17-17-48.3-48.3-43.1 28.8c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57" })
  }
), fc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m318.8 109.3-10-35.5L288 0l-20.8 73.8-10 35.5-11.4 40.6-34.9-23.6-31-21-64.2-43.5 32.6 70.4 15.1 32.6 17.8 38.5-42.2 4-36.6 3.5-78.4 7.3 71.2 33.4 32.9 15.5 38.5 18-30 30.1-25.4 25.4-55.4 55.4 75.8-19.3 36.1-9.2 41-10.4-3.4 42.1-2.9 36.2-6.1 76.7 45.1-62.3 21.9-30.2 24.7-34.1 24.7 34.1 21.9 30.2 45.1 62.3-6.1-76.7-2.9-36.2-3.4-42.1 41 10.4 36.1 9.2 75.8 19.3-55.3-55.4-25.4-25.4-30-30.1 38.4-18 32.8-15.4 71.3-33.5-78.3-7.4-36.7-3.5-42.2-4 17.8-38.5 15.1-32.6 32.6-70.4-64.2 43.5-31 21-34.9 23.6-11.4-40.6zm44.8 66.3-5 10.8-23.8 51.3 56.3 5.3 11.4 1.1-10 4.7-51.6 24.2 40.2 40.3 7.9 7.9-11.9-3-54.2-13.8 4.5 55.8 1 12.8-8-11.1-32.4-44.7-32.4 44.7-8 11.1 1-12.8 4.5-55.8-54.2 13.8-11.9 3 7.9-7.9 40.2-40.3-51.5-24.2-10-4.7L185 243l56.3-5.3-23.8-51.3-5-10.8 10.9 7.4 45.9 31.1 15-53.4 3.7-13 3.7 13 15 53.4 45.9-31.1 10.9-7.4z" })
  }
), Uc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-48v64H0v384h112v64h48v-64h52c59.6 0 108-48.4 108-108 0-42.1-24.1-78.5-59.2-96.4 16.9-19 27.2-44.1 27.2-71.6 0-59.6-48.4-108-108-108h-20zm-48 112v120H48V112zm48 120V112h20c33.1 0 60 26.9 60 60s-26.9 60-60 60zm-48 48v120H48V280zm48 120V280h52c33.1 0 60 26.9 60 60s-26.9 60-60 60z" })
  }
), Gc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48 0c0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96 0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96s-96-43-96-96 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3-17.7-17.4-28.6-41.6-28.6-68.3 0-53 43-96 96-96 9.9 0 19.5 1.5 28.6 4.3C234.9 146.9 224 122.7 224 96c0-53 43-96 96-96s96 43 96 96m-96 96c-9.9 0-19.5-1.5-28.6-4.3 17.7 17.4 28.6 41.6 28.6 68.3 0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3m0 64c0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C330.9 306.9 320 282.7 320 256M176 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96m144 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96m144 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), qc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m196.6 392.6 1-.7c.9-.7 2.4-1.8 4.3-3.2 3.9-2.9 9.5-7.3 16.4-13 13.8-11.5 32.1-28 50.2-47.9 38.1-42 67.5-90.5 67.5-135.8 0-79.5-64.5-144-144-144S48 112.5 48 192c0 45.3 29.4 93.8 67.5 135.7 18.1 19.9 36.4 36.4 50.2 47.9 6.9 5.7 12.5 10.1 16.4 13 1.9 1.5 3.4 2.5 4.3 3.2l1 .7.1.1 4.4 3.1 4.4-3.1.1-.1zM384 192c0 128-160 240-160 240l12.8 32 19.2 48H128l19.2-48 12.8-32S0 320 0 192C0 86 86 0 192 0s192 86 192 192m-256 8v8H80v-8c0-66.3 53.7-120 120-120h8v48h-8c-39.8 0-72 32.2-72 72" })
  }
), Wc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m163.2 329.6.7-.6c.7-.5 1.8-1.4 3.3-2.6 3-2.4 7.4-6.1 12.7-10.9 10.8-9.7 25.1-23.6 39.3-40.4C249.1 239.7 272 198.7 272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 38.7 22.9 79.7 52.7 115.1 14.2 16.9 28.5 30.8 39.3 40.4 5.4 4.8 9.8 8.5 12.7 10.9 1.5 1.2 2.6 2.1 3.3 2.6l.7.6 3.3 2.4 3.1-2.3zM128 368S0 272 0 160C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 208-128 208l12.8 32 19.2 48H96l19.2-48zm48-232c-22.1 0-40 17.9-40 40H88c0-48.6 39.4-88 88-88zm176 24c0-9.9-.7-19.6-2.2-29 29-40.5 76.5-67 130.2-67 88.4 0 160 71.6 160 160 0 112-128 208-128 208l12.8 32 19.2 48H416l19.2-48 12.8-32s-100.3-75.2-123.3-170.1C340.6 231.6 352 197 352 160m131.2 233.6.7-.6c.7-.5 1.8-1.4 3.3-2.6 3-2.4 7.4-6.1 12.7-10.9 10.8-9.7 25.1-23.6 39.3-40.4C569.1 303.7 592 262.7 592 224c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 38.7 22.9 79.7 52.7 115.1 14.2 16.9 28.5 30.8 39.3 40.4 5.4 4.8 9.8 8.5 12.7 10.9 1.5 1.2 2.6 2.1 3.3 2.6l.7.6 3.3 2.4 3.1-2.3zM456 240h-48c0-48.6 39.4-88 88-88v48c-22.1 0-40 17.9-40 40" })
  }
), Ec = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v416H48V48zM48 0H0v512h448V0h-48zm32 96v64h64V96zm64 320v-64H80v64zm32-312v48h192v-48H200zm32 128v48h160v-48H232zm-32 128v48h192v-48H200zm-4.7-116.7 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-12.7-12.7L88 233.4 65.4 256l11.3 11.3 24 24 11.3 11.3 11.3-11.3z" })
  }
), Oc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v416H48V48zM48 0H0v512h448V0h-48zm32 96v64h64V96zm64 128H80v64h64zM80 352v64h64v-64zm120-248h-24v48h192v-48h-24zm0 128h-24v48h192v-48h-24zm0 128h-24v48h192v-48h-24z" })
  }
), Ic = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c-114.9 0-208-93.1-208-208 0-48.8 16.8-93.7 44.9-129.1l292.2 292.2C349.7 447.2 304.8 464 256 464m80-161.9V298l28.9 5.8 15.7 3.1 6.3-31.4-15.7-3.1-35.1-7v-18.7l35.1-7 15.7-3.1-6.3-31.4-15.7 3.1-28.9 5.8v-30.6l16.2-9.7 13.7-8.2-16.4-27.6-13.7 8.2-18.4 11.1L288 128h-64l-31 31-66.1-66.1C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208 0 48.8-16.8 93.7-44.9 129.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M140.9 272.3l-15.7 3.1 6.3 31.4 15.7-3.1 28.9-5.8v30.6l-16.2 9.7-13.9 8.3 16.5 27.5 13.7-8.2 18.4-11.1L224 384h64l2.7-2.7L175 265.5z" })
  }
), Nc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.1 419.1 92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208 48.8 0 93.7-16.8 129.1-44.9m33.9-33.9c28.2-35.5 45-80.4 45-129.2 0-114.9-93.1-208-208-208-48.8 0-93.7 16.8-129.1 44.9l35 35.1H280c53 0 96 43 96 96 0 32.1-15.8 60.6-40 78l83.1 83.1zM216 176v6.1l85.1 85.1C317 259.3 328 242.9 328 224c0-26.5-21.5-48-48-48zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m216.4 64h-.4v64h-48V271.6z" })
  }
), Xc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m92.9 126.9 292.2 292.2C349.7 447.2 304.8 464 256 464c-114.9 0-208-93.1-208-208 0-48.8 16.8-93.7 44.9-129.1m165 97.1-131-131.1C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208 0 48.8-16.8 93.7-44.9 129.1L353.9 320H416v-96h-16zm32 32H384v32h-62.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-416h-32v16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v16h32v-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16zM112 224H96v96h144.8l-96-96z" })
  }
), Kc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.1 419.1 92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208 48.8 0 93.7-16.8 129.1-44.9m33.9-33.9c28.2-35.5 45-80.4 45-129.2 0-114.9-93.1-208-208-208-48.8 0-93.7 16.8-129.1 44.9l292.2 292.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Qc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288.1 55c10.3 27.7 15.9 57.7 15.9 89 0 39.6-9 77.1-25 110.6l41.4 24.6C340.6 238.4 352 192.5 352 144c0-23.8-2.7-47-7.9-69.2l2.5-1.7C380 114.3 400 166.8 400 224c0 16-1.6 31.7-4.6 46.9l50.3-10.6c1.5-11.9 2.3-24 2.3-36.3 0-84.7-36.6-160.9-94.8-213.6zm132.2 292.4 43.9-9.2L535 409l17 17 33.9-34-17-17-80-80-9.2-9.2-12.7 2.7-27.7 5.8-115.1 24.3-60.9-36.1-39.1-23.2-11.5-6.8-11.8 6.2-92 48-21.3 11.1 22.2 42.6 21.3-11.1 80.2-41.8 22.1 13.1C186.7 369.5 120.9 400 48 400H0v112h160c107 0 200.4-58.4 250.1-145 .7-1.2 1.3-2.3 2-3.5 2.9-5.3 5.7-10.6 8.3-16z" })
  }
), Zc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 144v224h144V144zM192 96h448v320H0V96h48zm0 272V144H48v224zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0M272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Jc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M-2 80h42c22.1 0 40 17.9 40 40v56H0v48h80v168c0 48.6 39.4 88 88 88h32c101.6 0 184-82.4 184-184v-32c0-48.6-39.4-88-88-88h-40v48h40c22.1 0 40 17.9 40 40v32c0 75.1-60.9 136-136 136h-32c-22.1 0-40-17.9-40-40V224h64v-48h-64v-56c0-48.6-39.4-88-88-88H-2z" })
  }
), jc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M363.3 114.7 376 64l72-64 64 64-64 72-50.7 12.7-52.5 52.5-17 17-1.2 1.2c16.5 22 27.7 48.2 31.7 76.6H384v48h-25.7c-4.1 28.5-15.3 54.6-31.7 76.6l1.2 1.2 17 17-33.9 33.9-17-17-1.2-1.2c-22 16.5-48.2 27.7-76.6 31.7V512H168v-25.7c-28.5-4.1-54.6-15.3-76.6-31.7l-1.2 1.2-17 17-33.9-34 17-17 1.2-1.2c-16.5-22-27.7-48.1-31.8-76.6H0v-48h25.7c4.1-28.5 15.3-54.6 31.7-76.6l-1.2-1.2-17-17 33.9-33.9 17 17 1.2 1.2c22-16.5 48.2-27.7 76.6-31.7V128h48v25.7c28.5 4.1 54.6 15.3 76.6 31.7l1.2-1.2 17-17 52.5-52.5zM192 448a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-39-137 48 48 17 17-34 33.9-17-17-48-48-17-17 34-33.8 17 17z" })
  }
), Yc = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h160v48H48v112H0V24zm144 128v256H96V128zm32 0h32v256h-32zm272 0h32v256h-32zm-208 0h48v256h-48zm176 0v256h-48V128zM552 0h24v160h-48V48H416V0h24zM0 512V352h48v112h112v48H24zm552 0H416v-48h112V352h48v160z" })
  }
), _c = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 32H64v160h48zM64 480h48V320H64zm96 0h32V320h-32zm64 0h48V320h-48zm0-288h48V32h-48zm112 288h48V320h-48zm0-288h48V32h-48zm128 288h32V320h-32zm0-288h32V32h-32zm64 288h48V320h-48zm0-288h48V32h-48zm-368 0h32V32h-32zM0 232v48h640v-48z" })
  }
), hs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32H0v448h48zm80 0H96v448h32zm80 0h-48v448h48zm112 0h-48v448h48zm144 0v448h48V32zm-64 0v448h32V32z" })
  }
), cs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h448v48H0zm64 160h320v48H64zm224 160v48H160v-48z" })
  }
), ss = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 112v64H320v-64zM48 64H0v160h512V64h-48zm416 272v64H192v-64zM48 288H0v160h512V288h-48z" })
  }
), vs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h448v48H0zm0 160h320v48H0zm192 160v48H0v-48z" })
  }
), es = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h448v48H0zm64 160h448v48H64zm384 160v48H0v-48z" })
  }
), ls = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h448v48H0zm0 160h448v48H0zm448 160v48H0v-48z" })
  }
), ts = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m390.8.1 16.6 16.6 88 88 16.6 16.6-16.1 17-158.5 166.2-2.4 2.5-3 1.7-149.3 86.5-54.2 54.2c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l54.2-54.2L203.2 180l1.7-3 2.5-2.4L373.9 16.2l17-16.1zM305 269l139.9-147L390 67.1 243 207l-71.1 122.9 10.2 10.2zm159 163a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0M50.9 401l60.2 60.2 17 17-34 33.8-17-17L17 434.9l-17-17L33.9 384z" })
  }
), ws = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 463.8c0-12.2 1-24.2 3-35.8l47.3 7.9c-1.3 7.9-2.1 15.9-2.3 24.2C378.8 444 444 378.8 460.2 296c-8.2.2-16.3 1-24.2 2.3l-8-47.3c11.7-2 23.6-3 35.8-3C459.7 139.5 372.5 52.3 264 48.2c0 12.2-1 24.2-3 35.8l-47.3-8c1.3-7.9 2.1-15.9 2.3-24.2C133.2 68 68 133.2 51.9 216c8.2-.2 16.3-1 24.2-2.3L84 261c-11.7 2-23.6 3-35.8 3 4.1 108.5 91.3 195.7 199.8 199.8M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m206.4-152 45.3 16c-21.2 60.1-68.2 107.9-127.7 130.3l-16.9-44.9c46.3-17.4 82.9-54.6 99.4-101.3zm99.1 304-45.3-16c21.2-60.1 68.2-107.9 127.7-130.3l16.9 44.9c-46.3 17.4-82.9 54.6-99.4 101.3z" })
  }
), gs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256.4 29.8-11.1 21.3L171.8 192h232.4L330.7 51.1l-11.1-21.3 42.6-22.2 11.1 21.3L458.4 192H576v48h-44l-68 272H112L44 240H0v-48h117.6l85.1-163.1 11.1-21.3 42.6 22.2zM482.5 240h-389l56 224h277zM144 296a24 24 0 1 1 48 0 24 24 0 1 1-48 0m264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), is = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256.4 29.8-11.1 21.3L171.8 192h232.4L330.7 51.1l-11.1-21.3 42.6-22.2 11.1 21.3L458.4 192H576v48h-44l-68 272H112L44 240H0v-48h117.6l85.1-163.1 11.1-21.3 42.6 22.2zM93.5 240l56 224h277l56-224zM224 312v104h-48V288h48zm88-24v128h-48V288zm88 24v104h-48V288h48z" })
  }
), ms = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M75.9 96.9c-31 29.7-58 64.9-75.9 104.2v171.7l134.3 58.4-8-55.8L48 341.3V212c14.8-29.2 36.1-56.5 61.1-80.4C152.8 89.7 221 48 320 48s167.2 41.7 210.9 83.6c25 23.9 46.3 51.2 61.1 80.4v129.3l-78.3 34.1-8 55.8L640 372.8V201.1c-17.8-39.2-44.8-74.5-75.9-104.2C513.6 48.5 434 0 320 0S126.4 48.5 75.9 96.9M184 128h-24v80h48v-32h224v32h48v-80h-24zm328 112H112v48h34.1l7.2 50.3 22.9 160 2 13.7h29l4.8-5.3 44.2-49.5 43.8 49.4 4.8 5.4h30.4l4.8-5.4 43.9-49.4 44.2 49.5 4.8 5.3h29l2-13.7 22.9-160L494 288h34v-48zm-328.3 84.6-5.3-36.6H227.7zm92.9-35.6 1.2-1h84.4l1.2 1-43.4 48.6zm179.7 35.6-44-36.6H461.6l-5.2 36.6zm-19.8 25.2-52.7 59.3-42.4-47.5 46.6-52.2 48.5 40.3zm-31.3 83.4 42.3-47.6-11.7 81.9zm-42.9 0L320.8 480h-1.6l-41.6-46.8 42.4-47.6 42.4 47.5zm-106.1-24.1-52.7-59.3 48.5-40.4 46.6 52.2-42.4 47.5zm-63.8-23.6 42.3 47.6-30.6 34.3z" })
  }
), as = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 458.4V456c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4m-47.8 5.6h-.2c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7.1 5.3.2 8m76.4-165.4L289.9 256l129.2-129.1C447.2 162.3 464 207.2 464 256v.2c-2.7-.1-5.3-.2-8-.2-46.6 0-89.4 15.9-123.4 42.6m125.8 5.4c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9h2.4zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8h.2c48.8 0 93.7 16.8 129.1 44.9zm-76.9-76.9-52.2-52.3c23.5-18.6 51-32.2 81.1-39.4v2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208h-2.4c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7.1 5.3.2 8 .2 46.6 0 89.4-15.9 123.4-42.6l42.7 42.6L92.9 385.1C64.8 349.7 48 304.8 48 256zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), os = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m267.3 128-11.1-6.3-1-.6-9 35.9-14.2 56.9-53-25.2-68.7-32.7c-34 49.1-54.8 106.1-60.6 165.5l24.9-12.4 39.8-19.9 22.9 38.1 16.4 27.3 20.5-20.5 38.7-38.7 33.1 43.3 42 54.5 42-54.5 33.3-43.3 38.7 38.7 20.5 20.5 16.4-27.3 22.9-38.1 39.8 19.9 24.9 12.4c-5.8-59.4-26.7-116.4-60.6-165.5L397 188.7l-53 25.2-14.2-56.9-9-35.9-1 .6-11.1 6.3H280zm41.5-55.3L352 48l12.1 48.4.4 1.5 11.9 47.5 44.2-21.1L480 96c59.9 69.9 93.8 158.4 95.9 250.3.1 3.1.1 6.2.1 9.2V400l-48-24-48-24-22.5 37.6L432 432l-29.8-29.8-5.2-5.2-29-29-29.5 38.4-20.2 26.3L288 472l-30.3-39.4-20.2-26.3L208 368l-29 29-5.2 5.2L144 432l-25.5-42.4L96 352l-48 24-48 24v-44.5c0-3.1 0-6.2.1-9.2C2.2 254.4 36.1 165.9 96 96l59.4 28.3 44.2 21.1 11.9-47.5.4-1.5L224 48l43.3 24.7L280 80h16l12.7-7.3z" })
  }
), ns = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0h97.9l7 7 18 18c11.1-5.8 23.7-9.1 37-9.1 23.6 0 44.9 10.2 59.5 26.5L264 30.1 297.9 64 281 81 177 185l-17 17-33.9-34 12.5-12.5C122.2 140.9 112 119.6 112 96c0-13.4 3.3-25.9 9.1-37l-11-11H80v208h432v48H0v-48h32V24zm0 336h48v32c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48v-32h48v32c0 28.4-12.4 54-32 71.6V512h-48v-49.3c-5.2.9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V512H64v-72.4C44.4 422 32 396.4 32 368zM192 64c-17.7 0-32 14.3-32 32 0 10.4 4.9 19.6 12.6 25.5l44.8-44.8c-5.8-7.8-15-12.7-25.4-12.7" })
  }
), rs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 368h136.5l-15 48H0V96h307.5l-63.2 48H48zm188.5 48 63.2-48H496V144H359.5l15-48H544v96h32v128h-32v96h-48zM208 400l40-128h-88v-24l176-136-40 128h88v24z" })
  }
), ds = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 144v224h448V144zM0 96h544v96h32v128h-32v96H0V144z" })
  }
), Ss = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 96H0v320h208v-48H48V144h160V96zm448 272H336v48h208v-96h32V192h-32V96H336v48h160zM296 96h-48v240h48V120zm-48 272v48h48v-48z" })
  }
), zs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 144v224H48V144zM48 96H0v320h544v-96h32V192h-32V96h-48zm400 96H96v128h352z" })
  }
), ps = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 144v224H48V144zM48 96H0v320h544v-96h32V192h-32V96h-48zm240 96H96v128h192z" })
  }
), Ms = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 144v224H48V144zM48 96H0v320h544v-96h32V192h-32V96h-48zm112 96H96v128h64z" })
  }
), xs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 144v224H48V144zM48 96H0v320h544v-96h32V192h-32V96h-48zm144 96H96v128h96z" })
  }
), Hs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-55.7-43.3H576v-96h32V192h-32V96H153L48.4 14.8zM214.8 144H528v224h-24.7zm130.4 224H80V159l-48-37.8V416h374.2l-60.9-48z" })
  }
), Vs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 144v224H48V144zM48 96H0v320h544v-96h32V192h-32V96h-48zm304 96H96v128h256z" })
  }
), Cs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0v160h208V0h200c66.3 0 120 53.7 120 120v392h-48v-48.3H48V512H0V0zm208 415.7V256h272v-48H48v207.7zM528 160v-40c0-39.8-32.2-72-72-72H304v112zm0 144H304v111.7h224zM96 328a56 56 0 1 1 112 0 56 56 0 1 1-112 0m56-312a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), Ls = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h48v-96h544v104h48V160H48zm544 280H48V208h544z" })
  }
), Bs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32v160h48v-64h160v64h32v-64h160v64h48V32zm-8 192H0v256h48v-64h416v64h48V224h-24zm440 144H48v-96h416z" })
  }
), us = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 0h30.8l6.6 13.3L534.8 64H640v48H505.2l-6.6-13.3-18.2-36.2-50.7 107.7-6.5 13.8h-46.8l-6.3-14.3-25.7-57.7H192V64h183.6l6.3 14.3 18.5 41.5 49.9-106L456.8 0zM312 160h18.7l10.1 22.7 11.3 25.3H336v160h256v-88c0-39.8-32.2-72-72-72h-72.7l11.4-24.2 11.2-23.8H520c66.3 0 120 53.7 120 120v240h-48V416H48v96H0V64h48v304h240V160zm-104 88a40 40 0 1 0-80 0 40 40 0 1 0 80 0m-128 0a88 88 0 1 1 176 0 88 88 0 1 1-176 0" })
  }
), Rs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h48v-96h544v104h48V248c0-66.3-53.7-120-120-120H288v208H48zm544 192v88H336V176h184c39.8 0 72 32.2 72 72m-464-32a40 40 0 1 1 80 0 40 40 0 1 1-80 0m128 0a88 88 0 1 0-176 0 88 88 0 1 0 176 0" })
  }
), $s = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m216 1.4 11.3 11.3 26.8 26.8c10.3-4.8 21.8-7.5 33.9-7.5s23.6 2.7 33.9 7.5l26.8-26.8L360 1.4 382.6 24l-11.3 11.3-23.5 23.5C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112 0 61.9-53.6 104.9-112.9 111.2.6-5.1.9-10.2.9-15.2 0-11.2-1-22.2-3.1-32.8 40.5-5.1 67.1-34 67.1-63.2 0-32.2-32.3-64-80-64-37.3 0-65.2 19.5-75.6 43.3C408.5 213.5 432 256 432 304c0 96-144 208-144 208S144 400 144 304c0-48 23.5-90.5 59.6-116.7-10.4-23.8-38.3-43.3-75.6-43.3-47.7 0-80 31.8-80 64 0 29.2 26.5 58.1 67.1 63.2-2 10.6-3.1 21.6-3.1 32.8 0 5 .3 10.1.9 15.2C53.6 312.9 0 269.9 0 208 0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9-.3-2.9-.5-5.9-.5-8.9 0-20.4 7.6-39 20.2-53.2l-23.5-23.5L193.4 24 216 1.4zM384 304H192c0 8.7 2.4 19.4 7.7 32h176.6c5.3-12.6 7.7-23.3 7.7-32M251.7 411.9c12.6 14.1 25.4 26.6 36.3 36.7 10.9-10.1 23.7-22.7 36.3-36.7 8.1-9 15.9-18.4 23.1-27.9H228.6c7.2 9.5 15 18.9 23.1 27.9M288 208c-35.5 0-66.6 19.3-83.2 48h166.4c-16.6-28.7-47.6-48-83.2-48" })
  }
), ks = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 80H80v352h256v-64.5zm48 303.7V480H32V32h352v64h128v231.7l-14.4 6.3zm0-239.7v187.3l80-35V144zm-224-16v256h-32V128zm64 0v256h-32V128zm64 0v256h-32V128z" })
  }
), Ps = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168.1 69.4 160.9 80h-35.5l-7-6.9C112.6 67.5 104.7 64 96 64c-17.7 0-32 14.3-32 32s14.3 32 32 32c8.7 0 16.6-3.5 22.4-9.1l7-6.9h35.5l7.1 10.6c8.7 12.9 23.3 21.4 39.9 21.4s31.3-8.4 39.9-21.4l7.1-10.6h35l7.1 7.3c6 6.2 14.3 10 23.5 10 18 0 32.6-14.6 32.6-32.6s-14.6-32.6-32.6-32.6c-8.8 0-16.8 3.5-22.7 9.2l-7 6.8h-35.7L248 69.5C239.3 56.4 224.6 48 208 48s-31.3 8.4-39.9 21.4M208 0c27 0 51.3 11.1 68.7 29 12.6-8.2 27.7-13 43.9-13 44.5 0 80.6 36.1 80.6 80.6s-36.1 80.6-80.6 80.6c-16.5 0-31.9-5-44.7-13.5-17.4 17.4-41.4 28.2-68 28.2-26.9 0-51.2-11.1-68.6-28.8C126.9 171.3 112 176 96 176c-44.2 0-80-35.8-80-80s35.8-80 80-80c16 0 30.9 4.7 43.4 12.8C156.8 11.1 181.1 0 208 0M80 206.9V464h256V208.2c32.3-4.4 60.2-22.5 77.8-48.2H512v231.7l-14.4 6.3L384 447.7V512H32V187.9c14 9.8 30.3 16.4 48 18.9zM320.2 97.1l-.4-.5.5-.4c.1-.1.2-.1.2-.2h.4l.2.2c.1.1.1.2.2.2v.4l-.2.2c-.1.1-.2.1-.2.2h-.4l-.2-.2zM464 208h-80v187.3l80-35zm-304 32v176h-32V224h32zm64 0v176h-32V224h32zm64 0v176h-32V224h32z" })
  }
), Fs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 64h-24v48h40v33.3C119.6 157.2 32 252.4 32 368h48c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h40V64h-64zM24 400H0v48h512v-48h-24z" })
  }
), Ts = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-64v51.2C119 66 64 130.6 64 208v88L0 368v48h448v-48l-64-72v-88c0-77.4-55-142-128-156.8zm80 314.2 12.1 13.6 35.7 40.2H64.2l35.7-40.1 12.1-13.7V208c0-61.9 50.1-112 112-112s112 50.1 112 112v88zM288 448H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448m-40-320h-48v128h48V152zm0 168h-48v48h48z" })
  }
), As = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0h-64v51.2C215 66 160 130.6 160 208v88l-64 72v48h448v-48l-64-72v-88c0-77.4-55-142-128-156.8zm80 314.2 12.1 13.6 35.7 40.2H160.2l35.7-40.1 12.1-13.7V208c0-61.9 50.1-112 112-112s112 50.1 112 112v88zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448M0 176v48h128v-48H24zm536 0h-24v48h128v-48h-24zm72.2-125.3L586.7 7.8l-21.4 10.7-64 32-21.5 10.8 21.5 42.9 21.5-10.7 64-32 21.5-10.7zM53.3 61.5l64 32 21.5 10.7 21.5-42.9-21.6-10.8-64-32L53.3 7.8 31.8 50.7z" })
  }
), Ds = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-64v51.2C119 66 64 130.6 64 208v88L0 368v48h448v-48l-64-72v-88c0-77.4-55-142-128-156.8zm80 314.2 12.1 13.6 35.7 40.2H64.2l35.7-40.1 12.1-13.7V208c0-61.9 50.1-112 112-112s112 50.1 112 112v88zM288 448H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448m-40-296h-48v64h-64v48h64v64h48v-64h64v-48h-64v-40z" })
  }
), ys = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M331 356.8c-18.3 7.2-38.2 11.2-59 11.2-88.4 0-160-71.6-160-160 0-7.6.5-15.2 1.6-22.5l-42-33.1c-5 17.7-7.6 36.3-7.6 55.6 0 59 24.6 112.2 64 150.1V512h400l-60.9-48H416v-40.2zm76.3-63.3-51-39.6c7.4-13.6 11.7-29.3 11.7-45.9 0-53-43-96-96-96-25.2 0-48.2 9.7-65.3 25.7l-51-39.6C184.9 67.3 226.2 48 272 48c88.4 0 160 71.6 160 160 0 31.4-9.1 60.7-24.7 85.4zm38.1 29.5c21.8-33 34.6-72.5 34.6-115C480 93.1 386.9 0 272 0c-61.2 0-116.3 26.5-154.3 68.6L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-49.6-38.5c3-6.3 4.7-13.3 4.7-20.8 0-26.5-21.5-48-48-48-11.7 0-22.5 4.2-30.8 11.2zm-128-99.3L245.6 168c7.6-5 16.6-7.9 26.4-7.9 26.5 0 48 21.5 48 48 0 5.5-.9 10.7-2.6 15.6zM336 464H176v-71.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V464z" })
  }
), bs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m144 310.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1V512h424v-70.4c14.3-8.3 24-23.8 24-41.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6V464h-88zM304 464H112v-71.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4zm-96-304a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192" })
  }
), fs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 399.6V368l-64-72v-88c0-77.4-55-142-128-156.8V0h-64v51.2c-42.9 8.7-79.5 34.5-102.5 70.1L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM223.6 150.9C243.2 118 279 96 320 96c61.9 0 112 50.1 112 112v104.6zM406.2 416l-60.9-48h-185l35.7-40.1 12-13.7v-54.3l-48-37.8V296l-64 72v48h48zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448" })
  }
), Us = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-64v51.2C119 66 64 130.6 64 208v88L0 368v48h448v-48l-64-72v-88c0-77.4-55-142-128-156.8zm80 314.2 12.1 13.6 35.7 40.2H64.2l35.7-40.1 12.1-13.7V208c0-61.9 50.1-112 112-112s112 50.1 112 112v88zM288 448H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448" })
  }
), Gs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m217.9 251.6 35.3 97.1-11.3 44.4L0 305l12.9-35.6 67.2-48 36.4-100c25.7-70.5 103.6-106.8 174-81.2.9.3 1.7.6 2.5 1-71.1 42-104.5 130-75.2 210.4zm-120.4 123 117.9 42.9c-11.3 18.3-31.5 30.4-54.5 30.4-35.4 0-64.1-28.7-64.1-64 0-3.2.2-6.3.7-9.3zm497.4-20.5-6.2 2.3-56 20.4L416.5 419l-56 20.4-81.7 29.7-13.7-37.6 2.4-9.3 19.2-75.2L248 240.6c-27-74.2 11.2-156.2 85.4-183.2s156.3 11.3 183.3 85.5l38.7 106.4 63 45.3 7.8 5.6 13.8 37.5-45.1 16.4zM545.2 416c0 2.5-.1 5-.4 7.5-3.7 31.8-30.8 56.5-63.6 56.5-17 0-32.5-6.6-43.9-17.4-3.1-2.9-5.9-6.2-8.4-9.7l52.4-19 49-17.9 14.7-5.4c.1 1.8.2 3.6.2 5.4m18.6-101.6-36.4-26.1-12-8.6-5.1-13.9-38.7-106.5c-17.9-49.3-72.5-74.7-121.8-56.8s-74.7 72.4-56.8 121.7l38.7 106.4 5.1 13.9-3.7 14.4-11.1 43.4 241.7-88z" })
  }
), qs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m554.8 132.7 23.9 17.3c8.2 5.9 13.3 15.3 13.3 26v32H432v-32c0-10.6 5.1-20.1 13.3-26l23.9-17.3-4.6-29.1c-.4-2.5-.6-5-.6-7.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 2.6-.2 5.2-.6 7.6zm-137.6-21.6C397.1 125.7 384 149.3 384 176v80h104v256h48V256h104v-80c0-26.7-13.1-50.3-33.2-64.9.8-4.9 1.2-10 1.2-15.1 0-53-43-96-96-96s-96 43-96 96c0 5.1.4 10.2 1.2 15.1M80 240h224v32H80zm-48-48v128h24v32H0v48h32v112h48V400h224v112h48V400h32v-48h-56v-32h24V192H80zm72 128h176v32H104z" })
  }
), Ws = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 80v64h-64V80zm-64-48h-48v56H123.3C113.9 64.5 90.9 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40h79C138.2 173.8 93.9 241.5 88.5 320H32v160h160V320h-55.3c5.7-66.1 46.3-122.2 103.3-149.7V192h160v-21.7c57 27.6 97.6 83.7 103.3 149.7H448v160h160V320h-56.5c-5.3-78.5-49.7-146.2-113.8-184h79c9.5 23.5 32.5 40 59.3 40 35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H400V32h-48zM48 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0m512 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0M144 368v64H80v-64zm352 0h64v64h-64z" })
  }
), Es = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32h-24v48h49.7l34.6 64H222.9l-27.4-38-7.2-10H96v48h67.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h62.7l7-11.8 84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L373.1 44.6 366.3 32H352zm142.6 264.3 36.3 67.1 11.4 21.1 42.2-22.8-11.4-21.1-36.3-67.1c4.9-.9 10-1.4 15.2-1.4 44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zm-317.7-23.8-30.4 60.8L128 368h78.4c-7.4 36.5-39.7 64-78.4 64-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9.5zm29.9 47.5 50.7-101.3 72.9 101.2-.1.1zm90.6-128h108.5L317 274.8z" })
  }
), Os = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440 24V0h-48v32H248V0h-48v32H32v320H0v48h296v112h48V400h296v-48h-32V32H440zM200 128h-32v48h112v-48h-32V80h144v48h-32v48h112v-48h-32V80h120v272H80V80h120z" })
  }
), Is = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0v32h16v32H112V32h16V0zM32 144l96-48h128l63.6 31.8L352 144v48h32v-67.8l-17.7-8.8-44.5-22.3 61.8-29V0h128v64.1l64 30V192H640v48h-32l-32 272H64L32 240H0v-48h32zm501.3 320 26.4-224H80.3l26.4 224zM304 272h40.6l4.7 7.2 26.3 40-27.1 17-21.1-32.2h-14.8l-20.3 30.5-27.1-17 25.6-38.4 4.8-7.1zm89.3 73.9 19.3 29.3 2.6 4V432h-77.5v-32h45.5v-11.2l-17.1-25.9 27.1-17zM305.7 432H224v-52.8l2.7-4 20.6-31 27.1 17-18.4 27.6V400h49.7z" })
  }
), Ns = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0v32h16v32H112V32h16V0zM32 144l96-48h128l63.6 31.8L352 144v48h32v-67.8l-17.7-8.8-44.5-22.3 61.8-29V0h128v64.1l64 30V192H640v48h-32l-32 272H64L32 240H0v-48h32zm527.7 96H80.3l26.4 224h426.6l26.4-224z" })
  }
), Xs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h576v48h-35.4L512 480H64L35.4 80H0zm83.6 48 25.1 352h358.6l25.1-352H83.6zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-33.8 48.3-40.8-25.5 35.2-50.3c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l35.2 50.3-40.8 25.5-33.8-48.3c-1.3-1.8-3.3-2.9-5.5-2.9zm-107.6 65 40.8 25.5-36 51.4c-.8 1.1-1.2 2.4-1.2 3.7 0 3.5 2.9 6.4 6.4 6.4H264v48h-73.6c-30.1 0-54.4-24.4-54.4-54.4 0-11.2 3.4-22.1 9.8-31.2zM312 376v-48h73.6c3.5 0 6.4-2.9 6.4-6.4 0-1.3-.4-2.6-1.2-3.7l-36-51.4 40.8-25.5 34.5 49.3c6.4 9.1 9.8 20 9.8 31.2 0 30.1-24.4 54.4-54.4 54.4H312z" })
  }
), Ks = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h104v176h56v48H224v-48h56V48h-56zM0 288h104v176h56v48H0v-48h56V336H0zM24 0h168v224H0V0zm24 176h96V48H48zm144 112h147.2c-7.6 14.9-13.2 31-16.3 48H240v128h108.5c9.8 15 21.8 28.4 35.5 39.8v8.2H192V312zm160 80a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), Qs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0v48h56v128h-56v48h160v-48h-56V0h-80zM0 288v48h56v128H0v48h160v-48h-56V288H24zM24 0H0v224h192V0h-24zm24 176V48h96v128zm144 112v224h192V288H216zm48 48h96v128h-96zm288-96c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), Zs = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h104v176h56v48h-66.1l303 235.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38l18.2-23.4L0 0h192v126.3l64 49.7h24V48h-56zm-80 89V48H91.2zm-96 44.8V176h48v48H0V96zM243.7 288l60.9 48H240v128h96V360.7l48 37.8V512H192V288h24zM0 288h104v176h56v48H0v-48h56V336H0z" })
  }
), Js = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0h80v176h56v48H224v-48h56V48h-56V0zM24 288h80v176h56v48H0v-48h56V336H0v-48zM0 0h192v224H0V24zm48 48v128h96V48zm168 240h168v224H192V288zm24 176h96V336h-96z" })
  }
), js = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32h96v48H96zm-28 80h156v48h64v-48h156l3.6 19.7 15.2 83.7 45.8 76.2 3.4 5.7V480H288V288h-64v192H0V297.4l3.4-5.7 45.7-76.2 15.2-83.7zm40 48-12.4 68.3-.8 4.3-2.3 3.8L48 310.6V432h128V160zm296 0h-68v272h128V310.6l-44.6-74.3-2.2-3.8-.8-4.3zm12-128v48h-96V32z" })
  }
), Ys = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M167.2 3.2C138 33.4 120 74.6 120 120c0 26.1 6 50.8 16.6 72.9-22.4 2.3-44.6 9-65.3 20.6-33.7 18.8-58 47.3-71.3 79.7 57.1-48 153.9-53.7 204.4 30.8s-2.9 162.6-74.6 186.3c35.7 5.1 73.5-.9 107.2-19.7 20.6-11.5 37.7-26.6 50.9-44 13.2 17.4 30.3 32.6 50.9 44 33.7 18.8 71.5 24.8 107.2 19.7-71.5-23.7-125-101.7-74.4-186.3S519 245.2 576 293.2c-13.3-32.4-37.6-60.9-71.3-79.7-20.7-11.5-43-18.3-65.3-20.6C450 170.8 456 146.1 456 120c0-45.4-18-86.6-47.2-116.8C433.9 77.9 393.6 176 288 176S142.1 77.9 167.2 3.2zM240 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0m48-208c-32.2 0-62.6 7.3-89.8 20.3 2.1 5.9 4.8 11.6 7.9 16.9 5.1 8.6 11.7 16.5 20 23.1 19-8 40-12.4 61.9-12.4s42.9 4.4 61.9 12.4c8.3-6.6 14.9-14.5 20-23.1 3.2-5.3 5.8-11 7.9-16.9C350.6 71.3 320.2 64 288 64m-96.2 335.9c-32.3-24.3-55.1-60.6-61.8-102.3-9.2-3.9-18.6-6-28.1-6.8-7-.6-14.1-.4-21.1.5 5.9 63.9 40.7 119.5 91.2 153.5 4.8-5.8 8.9-12.1 12.1-18.7 3.9-8 6.6-16.8 7.7-26.2zm303.3-108.6c-7-.9-14.1-1-21.1-.5-9.4.8-18.9 3-28.1 6.8-6.7 41.7-29.5 77.9-61.8 102.3 1.1 9.4 3.8 18.1 7.7 26.2 3.2 6.6 7.3 12.9 12.1 18.7 50.5-34 85.3-89.5 91.2-153.5z" })
  }
), _s = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208H48.7c8.1 89.7 83.5 160 175.3 160 97.2 0 176-78.8 176-176v-80c0-35.3-28.7-64-64-64s-64 28.7-64 64v96zm0 208h-3l50.8 96h-54.2l-55.5-104.6C73.4 381.9 7.3 303.2.6 208c-.4-5.3-.6-10.6-.6-16v-32h224v-48C224 50.1 274.1 0 336 0c51.7 0 95.3 35.1 108.1 82.8L512 128l-64 42.7V192c0 93.9-57.7 174.3-139.7 207.6L367.9 512h-54.3l-52.4-99.1C249 415 236.6 416 224 416M336 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), hv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h48v64h32V0h48v64.7c54 6 96 51.8 96 107.3 0 27.5-10.3 52.6-27.2 71.6 35.1 17.9 59.2 54.3 59.2 96.4 0 59.6-48.4 108-108 108h-20v64h-48v-64h-32v64H64v-64H0V64h64zM48 112v120h132c33.1 0 60-26.9 60-60s-26.9-60-60-60zm132 168H48v120h164c33.1 0 60-26.9 60-60s-26.9-60-60-60z" })
  }
), cv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v448h313.6c-8.6-14.9-15.2-31-19.6-48H48V272h262.1c9-16.9 20-33 31.6-48H48V48h352v112.5c15.4-14.4 31.5-28.1 48-41.5V0h-24zm264 352.2c0-13.7 2.1-27.1 5.8-40.2H96v48h192.2c-.1-2.6-.2-5.2-.2-7.8m225-128c-32.3-37.5-65-64-65-64s-128 103.6-128 192 71.6 160 160 160 160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), sv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h448v-48H48V304h352v40H96v48h352V32h-24zm376 224H48V80h352z" })
  }
), vv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M153.6 44.8 84.9 0 72.4 12.8c-96.6 99-96.6 259.4 0 358.4L84.9 384l68.7-44.8-25-89.6-58.9 6.7c-12.6-41.8-12.6-86.8 0-128.6l58.9 6.7 25-89.6zM272 48h242.5l-12 48H352v32h142.5l-16 64H352v32h118.5l-28 112H272zm220 288 52-208 20-80 12-48H224v336h-32v176h352V336h-48zm-252 48h256v80H240zm152 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), ev = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h512l-12 48-20 80-52 208h52v176H96V336h60l-6.7-80H0V24zm406.5 224H288v-32h126.5l16-64H288V96h150.5l12-48H180.2l24 288h174.3zM144 384v80h288v-80H160zM48 48v160h97.3L132 48zm240 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), lv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h144v196.1c-28 9.9-48 36.6-48 67.9 0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9V48h320V0h-24zm120 312a24 24 0 1 1 48 0 24 24 0 1 1-48 0M0 464v48h512v-48H24zm64.3-144H0v48h80.3c-9-14.1-14.7-30.4-16-48m191.3 48H512v-48H271.7c-1.3 17.6-7 33.9-16 48zM24 160H0v48h112v-48zm200 48h288v-48H224z" })
  }
), tv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v48h20l-8 32-12 48h112V80H61.5l8-32H144v324.1c-28 9.9-48 36.5-48 67.9 0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9V48h250.5l8 32H224v48h288l-12-48-8-32h20V0H24zm144 440a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-32-232H63l13.2-48H26.5l-13.3 48L0 256h112zm112 48h288l-13.2-48-13.2-48h-49.9l13.3 48H224z" })
  }
), wv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h512v48h-13.3l5.3 32 8 48H224V80h231.3L450 48H192v116.1c28 9.9 48 36.6 48 67.9 0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9V48H62l-5.3 32H112v48H0l8-48 5.3-32H0zm66.8 208c-1.8 7.7-2.8 15.7-2.8 24s1 16.3 2.8 24H0l8-48 8-48h48.7l-8 48zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24h186.1l-8-48H496l8 48 8 48h-48.7zM168 336h287.3l-8-48H496l8 48 8 48H0l8-48 8-48h48.7l-8 48zM16 416h48.7l-8 48h398.6l-8-48H496l8 48 8 48H0l8-48zm152-160a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), gv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 80v48h160V80zm-48 48V80H80v48zm-48 48v56h152v-56zm0 160h48v-56H80zm0 48v48h152v-48H128zm96-48h113c-.6 5.3-1 10.7-1 16.2 0 10.9.9 21.5 2.6 31.8H280v48h25.3c8.1 17.6 18.7 33.8 31.4 48H32V32h448v113.8c-10.4-9.2-21.2-18-32-26.8-22.3 18.1-43.9 36.7-64 57H280v56h55.7c-11.2 15.1-21.5 31.1-29.6 48H176zm256-208V80h-48v48zm81 96.1c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160 128-192 128-192 32.6 26.4 65 64zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), iv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v48h160V80zm-48 48V80H48v48zm-48 48v56h152v-56zm0 160h48v-56H48zm0 48v48h152v-48H96zm96-48h160v-56H144zm208 0h48v-56h-48zm48 48H248v48h152zm0-208H248v56h152zm0-48V80h-48v48zM0 32h448v448H0V80z" })
  }
), mv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v352h352V80zM96 32h448v448H96V80zm136 152c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L344 264.4V296h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H288c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48zM160 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0m296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48M160 392a24 24 0 1 1 48 0 24 24 0 1 1-48 0m296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), av = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 72H0v48h448V72h-24zm128 160h-24v48h320v-48h-24zm-24 160v48h320v-48H152zM0 424v24h48V224H0v24z" })
  }
), ov = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 80v352H144V80zM144 32H96v448h448V32h-48zm64 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0m248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48M208 392a24 24 0 1 0-48 0 24 24 0 1 0 48 0m248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), nv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 320C512 143.3 368.7 0 192 0v48c150.2 0 272 121.8 272 272zm-96 0c0-123.7-100.3-224-224-224v48c97.2 0 176 78.8 176 176zM48 120V96H0v272c0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144h-32v48h32c53 0 96 43 96 96s-43 96-96 96-96-43-96-96z" })
  }
), rv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 176C512 78.8 433.2 0 336 0c-80.6 0-148.6 54.2-169.4 128.2 3.1-.1 6.3-.2 9.4-.2 114.9 0 208 93.1 208 208 0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176M384 64v32h48v32h-48v48h-32v-48h-48V96h48V48h32zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352m0-256v-16h-32v48H96v32h48v48h32v-48h48v-32h-48z" })
  }
), dv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m168 0 38.4 28.8 128 96 23.7 17.8-22.3 19.5L228.4 256l107.4 93.9 22.3 19.5-23.7 17.8-128 96L168 512V308.9l-88.2 77.2-18.1 15.8-31.6-36.2 18.1-15.8L155.6 256 48.2 162.1l-18.1-15.8 31.6-36.1L79.8 126l88.2 77.1V48zm48 308.9V416l65.9-49.4zm0-105.8 65.9-57.7L216 96z" })
  }
), Sv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h212c68.5 0 124 55.5 124 124 0 34.7-14.3 66.2-37.3 88.7 41 20.2 69.3 62.4 69.3 111.3 0 68.5-55.5 124-124 124H0v-48h48V80H0zm96 400h148c42 0 76-34 76-76s-34-76-76-76H96zm0-200h116c42 0 76-34 76-76s-34-76-76-76H96z" })
  }
), zv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m333.5 73.8-22 87.8-11.7 46.9 47.9 6.4L416 224v48L156.9 466.3 96 512l18.5-73.8 22-87.8 11.7-46.9-47.9-6.4L32 288v-48L291.1 45.7 352 0zm-40 182.2-53.2-7 13-52.1 19.3-77.4-172.2 129.2 54.1 7.2 53.3 7.1-13 52.1-19.3 77.4 172.1-129.2-54.1-7.2zm186.3 32 6.2 14.6L575.6 512h-52.2l-17.1-40h-84.6l-17.1 40h-52.2l89.5-209.4 6.2-14.6h31.7zm5.9 136L464 373.1 442.2 424z" })
  }
), pv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m234.7 96 10.7-48L256 0H32L5.3 240 0 288h176l-10.3 48-16.3 76L128 512l65.8-78.2L384 208v-64H224zm100.1 96L215.3 333.9l7.7-35.8 12.4-58.1H53.6L75 48h121.2l-19 85.6-13 58.4h170.5z" })
  }
), Mv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M460.4 334.7 544 272v-48l-68.2-9.1-47.9-6.4 11.7-46.9 21.9-87.8L480 0l-60.9 45.7-168.3 126.2L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM290.1 202.4l110.6-82.9-19.3 77.4-13 52.1 53.3 7.1 54.1 7.2-54.5 40.9-131-101.7zm89.7 192.8-39-30.7-37.4 28 12-48-41.4-32.6-9.6 38.4-22 87.8L224 512l60.9-45.7 94.8-71.1zM171.7 231.3 160 240v48l68.2 9.1 32.5 4.3-89.1-70.2z" })
  }
), xv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m311.6 161.7 22-87.8L352 0l-60.9 45.7L32 240v48l68.2 9.1 47.9 6.4-11.7 46.9-22 87.8L96 512l60.9-45.7L416 272v-48l-68.2-9.1-47.9-6.4 11.7-46.9zm36 101.7L175.4 392.5l19.3-77.4 13-52.1-53.3-7.1-54.1-7.2 172.3-129.2-19.3 77.4-13 52.1 53.3 7.1 54.1 7.2z" })
  }
), Hv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m432 0 26.7 53.3L512 80l-53.3 26.7L432 160l-26.7-53.3L352 80l53.3-26.7zM290.9 163.7l-28.7-10.3c-16.9-6.1-35.1-9.4-54.2-9.4-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2l-10.3-28.7 13.1-13.1-57.4-57.4zm47-47 57.4 57.4 11.3 11.3 22.7 22.6-22.6 22.6-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7l22.6 22.6 11.3 11.3zM208 224c-44.2 0-80 35.8-80 80H80c0-70.7 57.3-128 128-128z" })
  }
), Vv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 32V8h-48v120h48v-24zM201 71l-17-17-33.9 34 17 17 48 48 17 17 33.8-34-17-17zm272 34 17-17-34-33.9L439 71l-48 48-17 17 34 33.9 17-17 48-48zM292.6 240.3l-119.7 20.9c-11.8-43.1-55-70.9-100.2-63-47.8 8.4-79.8 53.6-71.3 101.1 2.1 12 6.7 23 13 32.6 9 13.6 21.6 24.4 36.3 31.2-11.5 11.4-19.6 25.9-23.4 41.7-2.6 11.2-3.1 23.1-1 35.1 8.4 47.5 54.1 79.1 101.9 70.8 45.2-7.9 76.2-48.7 72.4-93.2L320 396.6l119.3 20.9c-3.8 44.5 27.2 85.3 72.4 93.2 47.9 8.4 93.5-23.3 101.9-70.8 2.1-12 1.7-23.9-1-35.1-3.8-15.8-11.9-30.3-23.4-41.7 14.7-6.8 27.3-17.6 36.3-31.2 6.3-9.6 10.9-20.6 13-32.6 8.4-47.5-23.5-92.7-71.4-101.1-45.2-7.9-88.4 19.9-100.2 63l-119.5-20.9-6.7 47.1L502 315.6l11.5-42c5.3-19.5 25-32.2 45.5-28.6 21.8 3.8 36.3 24.4 32.4 45.9-2.3 13.2-10.9 23.7-22.5 29l-16.6 7.7-10 56.1 12.9 12.9c9 8.9 13.4 21.7 11.1 34.9-3.8 21.6-24.6 36-46.3 32.2-20.5-3.6-34.7-22.1-32.9-42.3l3.7-43.3L320 348.3l-170.8 29.8 3.7 43.3c1.7 20.2-12.4 38.7-32.9 42.3-21.8 3.8-42.5-10.6-46.3-32.2-2.3-13.2 2.1-26 11.1-34.9l12.9-12.9-10-56.1-16.6-7.7c-11.5-5.4-20.1-15.9-22.5-29-3.8-21.6 10.7-42.1 32.4-45.9 20.5-3.6 40.2 9.1 45.5 28.6l11.5 42 161.3-28.2-6.7-47.1z" })
  }
), Cv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m131.8 224-3.9-43.7C126 160 108.8 144 88 144c-22.1 0-40 17.9-40 40 0 13.5 6.6 25.4 17 32.8l15 10.5v57.4l-15 10.5c-10.4 7.3-17 19.3-17 32.8 0 22.1 17.9 40 40 40 20.8 0 38-16 39.8-36.3l3.9-43.7H444.3l3.9 43.7C450 352 467.2 368 488 368c22.1 0 40-17.9 40-40 0-13.5-6.6-25.4-17-32.8l-15-10.5v-57.4l15-10.5c10.4-7.3 17-19.3 17-32.8 0-22.1-17.9-40-40-40-20.8 0-38 16-39.8 36.3l-4 43.7H175.6zm268.6-48c4-44.9 41.7-80 87.6-80 48.6 0 88 39.4 88 88 0 12.3-2.5 24-7.1 34.7-6.5 15.1-17 28-30.3 37.3 13.3 9.3 23.8 22.2 30.3 37.3 4.6 10.6 7.1 22.4 7.1 34.7 0 48.6-39.4 88-88 88-45.9 0-83.6-35.1-87.6-80H175.6c-4 44.9-41.7 80-87.6 80-48.6 0-88-39.4-88-88 0-12.3 2.5-24 7.1-34.7 6.5-15.1 17-28 30.3-37.3-13.3-9.3-23.8-22.2-30.3-37.3C2.5 208 0 196.3 0 184c0-48.6 39.4-88 88-88 45.9 0 83.6 35.1 87.6 80z" })
  }
), Lv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 259.2c-24.5 14.2-44.4 35.4-57 60.8h258c-12.6-25.4-32.5-46.6-57.1-60.8l-24-13.9V48H144V245.4l-24 13.9zM288 48v169.7c14.2 8.2 27.2 18.2 38.8 29.6l39.3-39.3-7-7-17-17 33.9-33.9 17 17 24 24 24 24 17 17-34 33.8-17-17-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 49.2-18.5 94-48.9 128H48.9C18.5 478 0 433.2 0 384c0-71.1 38.6-133.1 96-166.3V48H64V0h256v48h-24z" })
  }
), Bv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h368v-48h-32v-64h32V288h-48v64H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v80h48V0h-24zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32zm169-289-17-17-33.9 34 17 17 39 39H256v48h286.1l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z" })
  }
), uv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h96v-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-48H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v304h-96v48h64v64h-64v48h144v-48h-32v-64h32V0h-24zm55 215-17 17 34 33.9 17-17 39-39V512h48V209.9l39 39 17 17 33.9-33.9-17-17-80-80-17-17-17 17-80 80z" })
  }
), Rv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM176.5 216h-31c4.8 26.1 21.1 48.2 43.5 60.8-6.6-16.9-11-37.8-12.5-60.8m0-32c1.4-22.9 5.9-43.8 12.5-60.8-22.4 12.6-38.7 34.7-43.5 60.8zM112 200a120 120 0 1 1 240 0 120 120 0 1 1-240 0m206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8 22.4-12.6 38.7-34.7 43.5-60.8M275 123.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8M255.4 216h-46.8c1.6 22.6 6.5 41.8 12.8 55.3 4.7 10.1 8.6 14.2 10.6 15.8 2-1.6 5.9-5.7 10.6-15.8 6.3-13.5 11.2-32.7 12.8-55.3m-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3-4.7-10.1-8.6-14.2-10.6-15.8-2 1.6-5.9 5.7-10.6 15.8-6.3 13.5-11.2 32.7-12.8 55.3z" })
  }
), $v = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h368v-48h-32v-64h32V0h-24zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v304zM208 80v64h-64v64h64v112h64V208h64v-64h-64V80z" })
  }
), kv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h368v-48h-32v-64h32V0h-24zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v304z" })
  }
), Pv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48h-48v192l-80-64-80 64V48H88c-22.1 0-40 17.9-40 40z" })
  }
), Fv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h314.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h242.9c-1.9-10.4-2.9-21.1-2.9-32 0-5.4.2-10.7.7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v172.5c14.6-9.5 30.8-17 48-21.8V0h-24zm552 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-136-78.6 11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6 11.3-11.3 28.7-28.7H416v-32h105.4l-28.7-28.7-11.3-11.3z" })
  }
), Tv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h314.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h242.9c-1.9-10.4-2.9-21.1-2.9-32 0-5.4.2-10.7.7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h312v172.5c14.6-9.5 30.8-17 48-21.8V0h-24zm408 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288m-78.6 136 11.3-11.3 56-56 11.3-11.3 11.3 11.3 56 56 11.3 11.3-22.6 22.6-11.3-11.3-28.7-28.7V448h-32V342.6l-28.7 28.7-11.3 11.3z" })
  }
), Av = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 88c0-48.6 39.4-88 88-88h296v304h-32v64h32v48H272c-44.2 0-80-35.8-80-80zm336-40H280c-22.1 0-40 17.9-40 40v174.7c9.8-4.3 20.6-6.7 32-6.7h256V136zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32h224v-64zM160 96v48H88c-22.1 0-40 17.9-40 40v174.7c9.8-4.3 20.6-6.7 32-6.7h81.1c2.5 17.7 9.2 34 18.9 48H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h224v-16h48v16h32v48H80c-44.2 0-80-35.8-80-80V184c0-48.6 39.4-88 88-88z" })
  }
), Dv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM255.3 80l6.4 13.9L359.2 304h-52.9L284 256h-88l-22.3 48h-52.9l97.4-210.1 6.5-13.9h30.7zm6.4 128L240 161.1 218.2 208z" })
  }
), yv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zm80-187.5c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L251 293.5l-11 10.6-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z" })
  }
), bv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zm77.6-191.3 23.2 23.2 12.3-12.3-28.8-28.9c10.9-22.7 28.7-41.5 50.6-53.8-18.6 29.6-12 68.5 15.3 90.2-15.4 16.1-20.9 39.2-14.3 60.3 6.4 21.2 24 37.3 45.7 41.8l1.5-35.8-10.5 7.8-6.3-5.9 8.6-15.6-19.7-4.1v-8.6l19.7-4.1-9.4-15.6 6.3-5.9 13.1 8.9 5-125h8.7l5.2 126.6 15.4-10.5 6.1 5.9-9.3 15.6 19.7 4.1v8.6l-19.7 4 9.3 15.7-6.1 5.9-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.8 6.6-21.2 1.1-44.4-14.3-60.3 27.3-21.7 33.8-60.6 15.3-90.2 22.1 12.3 39.7 31.1 50.6 53.8l-28.8 28.9 12.3 12.3 23.2-23.2c3.3 11.1 5.6 22.5 5.6 34.5 0 .3 0 .5-.1.8s-.1.5-.1.8L323.9 239l11.5 13.1 25.8-22.5c-12.7 54.2-60.9 94.6-118.9 94.6s-106.2-40.4-118.9-94.6l25.8 22.5 11.5-13.1-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5" })
  }
), fv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM208 96h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), Uv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 337.2V55.6L344 80.2V373zM296 373V80.2L128 55.6v281.6zM80 0l48 7 192 28.2L512 7l48-7v376l-226.6 48.4c-8.8 1.9-17.9 1.9-26.7 0L80 376V48.5zM48 25.6l.5.1c-.3 2.7-.5 5.4-.5 8.1v374.8L320 463l272-54.4V33.8c0-2.8-.2-5.5-.5-8.1l.5-.1 48-9.6v432l-320 64L0 448V16z" })
  }
), Gv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192m0 48s-53.2-39.9-208-46.9c-15-.7-31-1.1-48-1.1v272c160 0 256 48 256 48s96-48 256-48V192c-17 0-33 .4-48 1.1-154.8 7-208 46.9-208 46.9m208 1.1v176.3c-62.8 3.6-114.4 13.9-152.6 24.3-11.7 3.2-22.2 6.4-31.4 9.5V282l4-3 .3-.2c.9-.6 2.9-1.7 6.1-3.3 6.4-3.2 17.9-8.2 35.3-13.5 28.4-8.5 73-17.7 138.2-20.9zm-232 210c-9.2-3-19.6-6.3-31.4-9.5-38.2-10.3-89.8-20.6-152.6-24.2V241.1c65.2 3.1 109.8 12.3 138.2 20.9 17.5 5.2 28.9 10.2 35.3 13.5 3.2 1.6 5.2 2.8 6.1 3.3l.3.2 4 3v169.2z" })
  }
), qv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 480s-64.7-38.8-144-40c-28.7-.4-66.4 6-96 12.4C20.5 458.2 0 464 0 464V72s64-40 160-40c72 0 128 24 128 24s64-24 128-24c96 0 160 40 160 40v392s-20.5-5.8-48-11.6c-29.6-6.3-67.3-12.8-96-12.4-79.3 1.2-144 40-144 40m240-76.7V101.9c-3.7-1.5-7.7-3.1-12.1-4.7C491.8 88.6 457.4 80 416 80c-26.6 0-54.3 5.1-76.4 10.6-10.8 2.7-19.8 5.4-26 7.4-.6.2-1.2.4-1.7.5V416c.4-.2.9-.3 1.3-.5 29.3-11.1 71-22.8 118-23.5 31-.5 68 5.5 96.7 11.3zM264 416V98.2c-.6-.2-1.2-.4-1.9-.7-5.3-1.9-13.2-4.5-23.3-7.1-20.1-5.2-48-10.4-78.8-10.4-41.4 0-75.8 8.6-99.9 17.2-4.4 1.6-8.5 3.2-12.1 4.7v301.4c28.8-5.8 65.8-11.8 96.7-11.3 47 .7 88.6 12.5 118 23.5.4.2.9.3 1.3.5z" })
  }
), Wv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 0c48.6 0 88 39.4 88 88v336h-.4c.3 2.6.4 5.3.4 8 0 44.2-35.8 80-80 80H0v-48h32v-64H0V0h24zM80 400v64h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm288-48c11.4 0 22.2 2.4 32 6.7V88c0-22.1-17.9-40-40-40H48v304zm-80-208 14.8 35.6 38.4 3.1-29.2 25.1 8.9 37.5-32.9-20.1-32.9 20.1 8.9-37.5-29.3-25.1 38.4-3.1zm-104 56c0 48.4 39.1 87.7 87.5 88-16.1 10.1-35.1 16-55.5 16-57.4 0-104-46.6-104-104S158.6 96 216 96c20.4 0 39.4 5.9 55.5 16-48.3.3-87.5 39.6-87.5 88" })
  }
), Ev = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM231.7 248l-7-1.8c-20.7-5.5-63.7-17-55.7-58.8 2-10.5 7.5-19.2 15.6-25.8-11.5-8.8-19.4-21.7-15.6-41.7 5.7-29.8 37.9-45 82-38.7 7.8 1.1 16.8 3.3 28.3 6.9l-8.9 28.6c-9.9-3.1-17.5-4.9-23.6-5.8-26.1-3.8-46 2.3-48.4 14.7-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c28.2 7.3 70.9 18.3 62.8 60.6-2 10.5-7.5 19.2-15.6 25.9 11.8 8.9 19.4 21.7 15.6 41.6-4.8 25.3-28.9 40.2-63.1 40.2-6 0-12.3-.5-18.9-1.4-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8 9.1-28.6 5.5 1.8c10.1 3.3 21.5 7 31 8.3 26.3 3.7 46.1-2.3 48.4-14.7 2.3-11.9-5.4-16.8-40.9-26zm0-67.5s-8.8-2.3-9.7-2.6c-8.1 1.1-21.6 4.5-23.6 15.1-1.7 8.7-.2 15.1 34 24.1 0 0 13.2 3.5 16.6 4.4 8.2-1.1 21.6-4.5 23.6-15 2.3-11.9-5.4-16.8-40.9-26z" })
  }
), Ov = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm48 344c0 17.7 14.3 32 32 32h288v-64H80c-17.7 0-32 14.3-32 32m0-73.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zm240-163.5V224h-96v-28.8c-19.4-11.7-32-30.3-32-51.2 0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2M224 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-138.1 59.8 15.2 5.1 90.9 30.2 90.9-30.3 15.2-5.1 10.1 30.4-15.2 5.1-50.4 16.8 50.5 16.8 15.2 5.1-10.1 30.4-15.2-5.1-91-30.3-90.9 30.3-15.2 5.1-10.1-30.4 15.2-5.1 50.4-16.8-50.5-16.8-15.2-5.1 10.1-30.4z" })
  }
), Iv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm48 344c0 17.7 14.3 32 32 32h288v-64H80c-17.7 0-32 14.3-32 32m0-73.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM160 112l16-32 16 32 32 16-32 16-16 32-16-32-32-16zm104 104 24-56 24 56 56 24-56 24-24 56-24-56-56-24z" })
  }
), Nv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 88c0-48.6-39.4-88-88-88H0v400h32v64H0v48h368c44.2 0 80-35.8 80-80 0-2.7-.1-5.4-.4-8h.4zm-80 312c17.7 0 32 14.3 32 32s-14.3 32-32 32H80v-64zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7H48V48h312c22.1 0 40 17.9 40 40zM216 56l-13.9 24-27.7 48H91.3l13.9 24 27.7 48-27.7 48-13.9 24h83.1l27.7 48 13.9 24 13.9-24 27.7-48h83.1l-13.9-24-27.7-48 27.7-48 13.9-24h-83.1l-27.7-48zm-69.3 120-13.9-24h27.7l-13.9 24zm41.6-24h55.4l27.7 48-27.7 48h-55.4l-27.7-48zm-55.4 96 13.9-24 13.9 24zm83.1 48-13.9-24h27.7zm83.1-48h-27.7l13.9-24 13.9 24zm0-96-13.9 24-13.9-24H299zm-97-24 13.9-24 13.9 24z" })
  }
), Xv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h48l32-96h160l32 96h48V48H88c-22.1 0-40 17.9-40 40zM176 160a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), Kv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88C0 39.4 39.4 0 88 0h360v400h-32v64h32v48H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h320V48H88c-22.1 0-40 17.9-40 40zM152 112h200v48H128v-48zm0 80h200v48H128v-48z" })
  }
), Qv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 374.7 108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L128 76.6V0h384v48zM176 113.9l288 223.6V48H176zm336 385.5V512l-48-28-144-84-144 84-48 28V196.8l48 37.8v193.8l119.8-69.9 21.5-12.5z" })
  }
), Zv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 344.4 24.2 14.1L336 428.4V48H48v380.4l119.8-69.9zM48 484 0 512V0h384v512l-48-28-144-84z" })
  }
), Jv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 416v48h64v-48zm64 96H64V384h112v-64h48v48h64V144h-64v48h-48v-64H64V0h272v30.1l11.2-3 54.9-14.7L448.4 0l12.4 46.4 11 41.2 6.2 23.2 6.2 23.2L539 338.6l6.2 23.2 6.2 23.2 11 41.2 12.6 46.2-46.4 12.4-54.9 14.7-46.3 12.5-12.4-46.4-11-41.2-6.2-23.2-6.2-23.2-54.9-204.5-.7-2.5v341H224zm48-48h64v-48h-64zM176 48h-64v48h64zm48 48h64V48h-64zm237.3 357.2 54.9-14.7-11-41.2-54.9 14.7zm-23.5-87.5 55-14.7L438 146.3 383 161l54.8 204.6zm-67.3-251 55-14.7-11-41.2-54.9 14.7 11 41.2zM64 160h64v64h64v64h-64v64H64v-64H0v-64h64z" })
  }
), jv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 416v48h64v-48zm64 96H0V0h272v30.1l11.2-3 54.9-14.7L384.4 0l12.4 46.4 11 41.2 6.2 23.2 6.2 23.2L475 338.6l6.2 23.2 6.2 23.2 11 41.2 12.6 46.2-46.4 12.4-54.9 14.7-46.3 12.5-12.4-46.4-11-41.2-6.2-23.2-6.2-23.2-54.9-204.5-.7-2.5v341H160zm48-48h64v-48h-64zM112 48H48v48h64zm0 96H48v224h64zm48-48h64V48h-64zm64 272V144h-64v224zm173.3 85.2 54.9-14.7-11-41.2-54.9 14.7zm-23.5-87.5 55-14.7L374 146.3 319 161l54.8 204.6zm-67.2-251 54.9-14.7-11-41.2-54.9 14.7z" })
  }
), Yv = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0h544v160h48v352H0V160h48V24zm496 48H96v112h96v-32h64v32h32v-32h64v32h32v-32h64v32h96zm48 160H48v256h544zm-416 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192m48 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0m144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0m96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), _v = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48v240l208 96v80h32v48H272l-96-32-48-16v48H0V384l24-128L0 64V0h272zM143.2 418.5 279.8 464H432v-49.3l-180.1-83.1-27.9-12.9V48h-80v208H96V48H48v13l23.6 189 .9 7.4-1.4 7.4L48 388.5V416h79.8c5.2 0 10.3.8 15.4 2.5" })
  }
), he = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 0H0v128h384zM0 464v16l32 32h64l32-32 32 32h64l32-32 32 32h64l32-32 32 32h64l32-32V288l-160-48v-80h-48v32h-80v32h80v32h-80v32h121l119 35.7V416H48V160H0v288z" })
  }
), ce = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0H68.2 68 73.2 73 77.2 77 95.2 95 99.2 99 144.3v48H99.8h.2H94.8h.2H90.8h.2H72.8h.2H68.8h.2H63.8h.2H48v464H0V24zm416 0h96v512h-48v-52.1c-7.5 2.7-15.6 4.1-24 4.1-18.4 0-35.3-6.9-48-18.3-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3-39.8 0-72-32.2-72-72V0h199.8zm-48 48h-48v344c0 13.3 10.7 24 24 24s24-10.7 24-24zm96 344V48h-48v344c0 13.3 10.7 24 24 24s24-10.7 24-24M224 48v344c0 13.3 10.7 24 24 24s24-10.7 24-24V48z" })
  }
), se = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v152H248V80zm0 200v152H248V280zm-200-48H48V80h152zM48 280h152v152H48zm0-248H0v448h448V32h-48z" })
  }
), ve = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 56V32h-48v400H0v48h448v-24zm-96 40V32h-64v64zm-192 0V32H96v64zm96-64h-64v64h64zM64 96V32H0v64zm0 128H0v64h64zm0-32v-64H0v64zm0 128H0v64h64z" })
  }
), ee = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H0v-48h448zm0-96h-64v-64h64zM0 384v-64h64v64zm256 0h-64v-64h64zm128-192v-64h64v64zm-320 0H0v-64h64zm128 0v-64h64v64zm256 96h-64v-64h64zM0 288v-64h64v64zm256 0h-64v-64h64zM384 96V32h64v64zM64 96H0V32h64zm128 0V32h64v64zm160 192h-64v-64h64zM288 96V32h64v64zm-128 0H96V32h64zM96 288v-64h64v64z" })
  }
), le = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 480h64v-64H0zm96 0h64v-64H96zm0-384h64V32H96zm192 320v64h64v-64zm0-320h64V32h-64zm-96 320v64h64v-64zm0-320h64V32h-64zm192 320v64h64v-64zm0-384v64h64V32zM0 96h64V32H0zm192 224v64h64v-64zm192 64h64v-64h-64zM0 320v64h64v-64zm384-128h64v-64h-64zM0 128v64h64v-64zm192 64h64v-64h-64zM24 232H0v48h448v-48h-24z" })
  }
), te = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480v-64h-64v64zm0-96v-64h-64v64zm-384 0v-64H0v64zm320-192h64v-64h-64zm-320 0v-64H0v64zm320 96h64v-64h-64zm-320 0v-64H0v64zM384 96h64V32h-64zM0 96h64V32H0zm64 384v-64H0v64zm224-192h64v-64h-64zm64-192V32h-64v64zm-64 384h64v-64h-64zM160 96V32H96v64zM96 480h64v-64H96zm64-192v-64H96v64zm40 168v24h48V32h-48v24z" })
  }
), we = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480v-64h64v64zm0-96v-64h64v64zM0 384v-64h64v64zm448-192h-64v-64h64zM0 192v-64h64v64zm448-96h-64V32h64zM64 96H0V32h64zM0 480v-64h64v64zM352 96h-64V32h64zm-64 384v-64h64v64zM160 96H96V32h64zM96 480v-64h64v64zm104 0V280H0v-48h200V32h48v200h200v48H248v200z" })
  }
), ge = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 480V32h48v448zm96 0v-64h64v64zm0-448h64v64H96zm0 256v-64h64v64zm192 128h64v64h-64zm0-320V32h64v64zm0 128h64v64h-64zm-96 256v-64h64v64zm0-448h64v64h-64zm0 256v-64h64v64zm192 128h64v64h-64zm0-320V32h64v64zm0 128h64v64h-64zM192 384v-64h64v64zm192-64h64v64h-64zm0-128v-64h64v64zm-192-64h64v64h-64z" })
  }
), ie = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416v64h64v-64zm96 64h64v-64H96zm0-384h64V32H96zm0 128v64h64v-64zm192 256h64v-64h-64zm0-448v64h64V32zm0 256h64v-64h-64zm-96 128v64h64v-64zm0-320h64V32h-64zm0 128v64h64v-64zm192 256h64v-64h-64zm0-384h64V32h-64zM0 32v64h64V32zm384 256h64v-64h-64zM0 224v64h64v-64zm192 160h64v-64h-64zm192-64v64h64v-64zM0 384h64v-64H0zm384-256v64h64v-64zM0 192h64v-64H0zm192-64v64h64v-64z" })
  }
), me = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm256 96v64h-64v-64zM96 224h64v64H96zm160 0v64h-64v-64zm32 0h64v64h-64zm-32 96v64h-64v-64z" })
  }
), ae = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32v448h-48V32zm-96 0v64h-64V32zm0 448h-64v-64h64zm0-256v64h-64v-64zM160 96H96V32h64zm0 320v64H96v-64zm0-128H96v-64h64zm96-256v64h-64V32zm0 448h-64v-64h64zm0-256v64h-64v-64zM64 96H0V32h64zm0 320v64H0v-64zm0-128H0v-64h64zm192-160v64h-64v-64zM64 192H0v-64h64zm0 128v64H0v-64zm192 64h-64v-64h64z" })
  }
), oe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 456v24h48V80h400V32H0v24zm96-40v64h64v-64zm192 0v64h64v-64zm-96 64h64v-64h-64zm192-64v64h64v-64zm0-128h64v-64h-64zm0 32v64h64v-64zm0-128h64v-64h-64z" })
  }
), ne = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h448v48H0zm0 96h64v64H0zm448 0v64h-64v-64zm-256 0h64v64h-64zM64 320v64H0v-64zm320 0h64v64h-64zm-128 0v64h-64v-64zM0 224h64v64H0zm448 0v64h-64v-64zm-256 0h64v64h-64zM64 416v64H0v-64zm320 0h64v64h-64zm-128 0v64h-64v-64zM96 224h64v64H96zm64 192v64H96v-64zm128 0h64v64h-64zm64-192v64h-64v-64z" })
  }
), re = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24v204.7c23.5 9.5 40 32.5 40 59.3 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V0h48zm-40 264a16 16 0 1 0 32 0 16 16 0 1 0-32 0m224-112h-64v112c0 79.5-64.5 144-144 144s-144-64.5-144-144V176H48v288h416zm-352-48h48v160c0 53 43 96 96 96s96-43 96-96V128h160v384H0V128h48z" })
  }
), de = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h192v48h-16v104.2C278.6 178 304 222 304 272v240H16V272c0-49.9 25.4-93.9 64-119.8V48H64zm128 48h-64v129.8l-21.3 14.3C80.9 209.4 64 238.8 64 272v192h192V272c0-33.2-16.9-62.6-42.7-79.9L192 177.9v-25.7zm-32 336c-26.5 0-48-21.5-48-48 0-32 48-80 48-80s48 48 48 80-21.5 48-48 48" })
  }
), Se = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0H96v78c-10.7 3.7-20.9 9.2-30 16.2l29.2 38.1L66 94.2l-6 4.6c-22.7 17.4-36 44.4-36 73.1 0 12.5 2.5 24.4 7 35.3-4.5 10-7 21.1-7 32.8 0 11.4 2.4 22.2 6.7 32-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32c-4.3 9.8-6.7 20.6-6.7 32v80h272v-80c0-11.4-2.4-22.2-6.7-32 4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32 0-11.7-2.5-22.8-7-32.8 4.5-10.9 7-22.8 7-35.3 0-28.6-13.3-55.6-36-73.1l-29.2 38.1L260 98.8l-6-4.6c-9.1-7-19.3-12.5-30-16.2zm6.7 136.9c9.5 7.3 15.5 18 16.9 29.7.2 1.8.3 3.5.3 5.3 0 14.9-7.4 28.1-18.8 36.1H90.8C79.4 200 72 186.8 72 171.9c0-1.8.1-3.6.3-5.3 1.4-11.7 7.5-22.4 16.9-29.7l6-4.6c10.4-8 23.1-12.3 36.2-12.3h57.2c13.1 0 25.8 4.3 36.2 12.3l6 4.6zM72 368c0-3.5.6-6.9 1.6-10 4.2-12.8 16.2-22 30.4-22h112c14.2 0 26.2 9.2 30.4 22 1 3.2 1.6 6.5 1.6 10s-.6 6.9-1.6 10c-4.2 12.8-16.2 22-30.4 22 11.8 0 22.2 6.4 27.7 16 2.7 4.7 4.3 10.2 4.3 16v32H72v-32c0-5.8 1.6-11.3 4.3-16 5.5-9.6 15.9-16 27.7-16-14.2 0-26.2-9.2-30.4-22-1-3.2-1.6-6.5-1.6-10" })
  }
), ze = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0 352 32l47 47-249.1 249.2L96 312l-57.5 57.4L0 408l52.2 15.7L80 432l8.3 27.8L104 512l38.5-38.6L200 416l-16.2-53.9L433 113l47 47zM109.7 366.2l22 6.6c.9 1.5 2 2.9 3.3 4.1s2.7 2.4 4.1 3.3l6.6 22-18.9 18.9-.9-3-7.4-24.8-24.7-7.3-3-.9 18.9-18.9zm-57-251.5-.5-.5-17-17-33.9 34 17 17 133.1 133.2 33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9 133.2 133.4 17 17 33.9-33.9-17-17-.5-.5c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z" })
  }
), pe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128V96l128-24V32h48v192h32V16h48v208h256l-2.8 48-.8 13.2c-4.9 82.9-54.4 153-124.4 187.7V512H128v-39.1C58 438.2 8.5 368.1 3.6 285.2L2.8 272 0 224h128v-48H0v-32l128-4v-32zm288-45V42L512 0v48zm0 52 224-7v48H288zM176 464h160v-20.9l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5l26.7 13.2z" })
  }
), Me = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128V96L512 0v48zm0 16 512-16v48H0zm176 320h160v-20.9l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5l26.7 13.2zM3.6 285.2 2.8 272 0 224h512l-2.8 48-.8 13.2c-4.9 82.9-54.4 153-124.4 187.7V512H128v-39.1C58 438.2 8.5 368.1 3.6 285.2" })
  }
), xe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192c0-35.3 28.7-64 64-64h1.6C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64h1.6c35.3 0 64 28.7 64 64 0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192m144 239.8v.2h224v-30.5l27.4-13c33.7-16 58.6-47.1 66.2-84.5H50.4c7.6 37.4 32.5 68.5 66.2 84.5l27.4 13v30.3zm-48 0C46.1 408.1 9.8 360.6 1.7 304 .6 296.2 0 288.1 0 280v-24h512v24c0 8.1-.6 16.2-1.7 24-8.1 56.6-44.4 104.1-94.3 127.8V480H96v-48z" })
  }
), He = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 24c0 26.5 10.5 38.7 25.9 56.1l.4.4C218.8 99 240 122.9 240 168v24h-48v-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C149.2 93 128 69.1 128 24V0h48zm128 0c0 26.5 10.5 38.7 25.9 56.1l.4.4C346.8 99 368 122.9 368 168v24h-48v-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C277.2 93 256 69.1 256 24V0h48zM176 464h160v-20.9l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5l26.7 13.2zM3.6 285.2 2.8 272 0 224h512l-2.8 48-.8 13.2c-4.9 82.9-54.4 153-124.4 187.7V512H128v-39.1C58 438.2 8.5 368.1 3.6 285.2" })
  }
), Ve = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 32h40v48h-64V32zm-24 72h64v48h-64zM56 176h40v48H32v-48zm192 0h40v48h-64v-48zm-96 0h40v48h-64v-48zm-72-72h64v48H80zm264 72h40v48h-64v-48zm-72-72h64v48h-64zm168 72h40v48h-64v-48zm-72-72h64v48h-64zm-96-72h64v48h-64zM144 431.8v.2h224v-30.5l27.4-13c33.7-16 58.6-47.1 66.2-84.5H50.4c7.6 37.4 32.5 68.5 66.2 84.5l27.4 13v30.3zm-48 0C46.1 408.1 9.8 360.6 1.7 304 .6 296.2 0 288.1 0 280v-24h512v24c0 8.1-.6 16.2-1.7 24-8.1 56.6-44.4 104.1-94.3 127.8V480H96v-48z" })
  }
), Ce = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224c0-106 86-192 192-192s192 86 192 192zm411.2 80C436 361.5 391.1 406.3 335 414.6c-6.2.9-12.4 1.4-18.8 1.4H272l42.7 48 21.3 24v24H112v-24l21.3-24 42.7-48h-44.2c-6.4 0-12.7-.5-18.8-1.4C56.9 406.3 12.1 361.5 4.8 304c-.1-1.1-.3-2.2-.4-3.3L0 256h448l-4.5 44.7c-.1 1.1-.2 2.2-.4 3.3zm-207 143.9L224 434.2l-12.1 13.6-14.3 16.2h52.9zM176 368h140.2c38.4 0 70.9-27.1 78.4-64H53.4c7.5 36.9 40 64 78.4 64h33.3z" })
  }
), Le = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208c0-22.7 6.7-43.8 18.3-61.4 19.8-30.2 53.8-50.2 92.6-50.6h1.1c61.9 0 112 50.1 112 112 0 5.4-.4 10.8-1.1 16H225.1c-.7-5.2-1.1-10.6-1.1-16M0 208C0 146.1 50.1 96 112 96h1.1c38.7.4 72.7 20.4 92.6 50.6C196.9 165.2 192 186 192 208c0 5.4.3 10.7.9 16H1.1C.4 218.8 0 213.4 0 208M325.4 64.4c-40.9 3-77.1 23-101.4 53.1-24.3-30.1-60.5-50.1-101.4-53.1C140.5 26.3 179.2 0 224 0s83.5 26.3 101.4 64.4M443.2 304C436 361.5 391.1 406.3 335 414.6c-6.2.9-12.4 1.4-18.8 1.4H272l42.7 48 21.3 24v24H112v-24l21.3-24 42.7-48h-44.2c-6.4 0-12.7-.5-18.8-1.4C56.9 406.3 12.1 361.5 4.8 304c-.1-1.1-.3-2.2-.4-3.3L0 256h448l-4.5 44.7c-.1 1.1-.2 2.2-.4 3.3zm-207 143.9L224 434.2l-12.1 13.6-14.3 16.2h52.9zM176 368h140.2c38.4 0 70.9-27.1 78.4-64H53.4c7.5 36.9 40 64 78.4 64h33.3z" })
  }
), Be = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-44.8L236 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H172c-42 0-76 34-76 76 0 4.9.5 9.8 1.4 14.5C50.8 164.8 16 206.3 16 256v96h32.3c4.1 53.7 49 96 103.7 96h32l-24 64h192l-24-64h32c54.7 0 99.6-42.3 103.7-96H496v-96c0-49.9-35.2-91.6-82.1-101.7 1.4-5.9 2.1-12 2.1-18.3C416 60.9 355.1 0 280 0zm40 57.3c0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16H256v48h136c30.9 0 56 25.1 56 56v48H64v-48c0-30.9 25.1-56 56-56h72v-48h-45.3c-1.7-3.6-2.7-7.7-2.7-12 0-15.5 12.5-28 28-28h69.3c30.2 0 54.7-24.5 54.7-54.7" })
  }
), ue = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48h64v96zm0-144C50.1 0 0 43 0 96s50.1 96 112 96h112v-72h288V72H224V0h-48zm64 443.1-26.7-13.2c-55.1-27.3-93.9-82.4-97.8-147.5l-.6-10.4h410.2l-.6 10.3c-3.8 65.1-42.7 120.3-97.8 147.5L336 443.1V464H176zM2.8 272l.8 13.2C8.5 368.1 58 438.2 128 472.9V512h256v-39.1c70-34.6 119.5-104.8 124.4-187.7l.8-13.2 2.8-48H0z" })
  }
), Re = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m436 228.8 5.4-20.8h45.3l40.9 159.2-27.7 96.8h-71.8l-11.7-40.9c-10 17.5-22.2 33.7-36.2 48l11.7 40.9h144.2l41.2-144.1L528 176c1.6-7.1 3.3-13.6 4.8-19.9 6.1-24.9 11.2-45.3 11.2-74.1v-2c0-44.2-35.8-80-80-80s-80 35.8-80 80v2c0 27.6 4.6 47.5 10.4 70.8 18.2 22.4 32.4 48.1 41.6 76m50.7-86.5c-1.3 5.4-2.7 11.2-4.3 17.7h-36.8c-1.5-6.5-3-12.4-4.3-17.7-5.8-23.6-9.3-37.7-9.3-60.3v-2c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3M208 144a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368a208 208 0 1 0 0-416 208 208 0 1 0 0 416m16-316a28 28 0 1 0-56 0 28 28 0 1 0 56 0m0 88a28 28 0 1 0-56 0 28 28 0 1 0 56 0m-100-12a28 28 0 1 0 0-56 28 28 0 1 0 0 56" })
  }
), $e = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), ke = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 176 14.7 367.9 55.9 512h144.2l41.2-144.1L192 176c1.6-7.1 3.3-13.6 4.8-19.9 6.1-24.9 11.2-45.3 11.2-74.1v-2c0-44.2-35.8-80-80-80S48 35.8 48 80v2c0 28.9 5.1 49.3 11.2 74.1 1.6 6.3 3.2 12.9 4.8 19.9m127.6 191.2L163.9 464H92.1l-27.7-96.8L105.3 208h45.3l40.9 159.2zm-40.8-225c-1.3 5.4-2.7 11.2-4.3 17.7h-36.9c-1.5-6.5-3-12.4-4.3-17.7C99.5 118.7 96 104.6 96 82v-2c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3zM320 176l-49.3 191.9L311.9 512h144.2l41.2-144.1L448 176c1.6-7.1 3.3-13.6 4.8-19.9 6.1-24.9 11.2-45.3 11.2-74.1v-2c0-44.2-35.8-80-80-80s-80 35.8-80 80v2c0 28.9 5.1 49.3 11.2 74.1 1.6 6.3 3.2 12.9 4.8 19.9m127.6 191.2L419.9 464h-71.8l-27.6-96.8L361.3 208h45.3l40.9 159.2zm-40.8-225c-1.3 5.4-2.7 11.2-4.3 17.7h-36.9c-1.5-6.5-3-12.4-4.3-17.7-5.8-23.6-9.3-37.7-9.3-60.3V80c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3z" })
  }
), Pe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 80H48v48h416zm16 96H0V32h512v144zm-320 48h192v48H160zm272-16h48v272H32V208h48v224h352z" })
  }
), Fe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 48v160h224V48zM128 0h320v256H128V48zM48 160h48v48H48v112h480V208h-48v-48h96v352H0V160zm480 208H48v96h480z" })
  }
), Te = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 160V80H95.2l-35.6 80zm188.4 0-35.6-80H248v80zM48 208v224h352V208zM64 32h320l64 144v304H0V176zm273 233L209 393l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47L303 231l17-17 33.9 34-17 17z" })
  }
), Ae = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m59.6 160 35.6-80H200v80H59.6zm188.4 0V80h104.8l35.6 80zM48 208h310.6c22.3-10.3 47.2-16 73.4-16 5.4 0 10.7.2 16 .7V176L384 32H64L0 176v304h296.2c-11.8-14.3-21.4-30.5-28.2-48H48zm528 160a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), De = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 160V80H95.2l-35.6 80zm188.4 0-35.6-80H248v80zM244 208v22.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3-12.2-1.9-22.2-.3-28.6 2.6-6.3 2.9-7.9 6.2-8.2 8.1-.6 3.4 0 4.7.1 5 .3.5 1 1.8 3.6 3.5 6.1 4.2 15.7 7.2 29.9 11.4l.8.2c12.1 3.7 28.3 8.5 40.4 17.4 6.7 4.9 13 11.4 16.9 20.5 4 9.1 4.8 19.1 3 29.4-3.3 19-15.9 32-31.6 38.7-4.9 2.1-10.1 3.6-15.4 4.6V432h156V208zm-40 0H48v224h156v-22.4c-9.5-2.2-22-6.4-29.9-9.1-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.2 9.5 3.2 20.2 6.9 26.2 7.9 12.8 2 22.7.7 28.8-1.9 5.5-2.3 7.4-5.3 8-8.8.7-4 .1-5.9-.2-6.7-.4-.9-1.3-2.2-3.7-4-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16-6.6-4.5-13.2-10.7-17.3-19.5-4.2-9-5.2-18.8-3.4-29 3.2-18.3 16.2-30.9 31.1-37.7 5-2.3 10.4-4 16-5.1v-22zM64 32h320l64 144v304H0V176z" })
  }
), ye = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 160V80H95.2l-35.6 80zm188.4 0-35.6-80H248v80zM48 208v224h352V208zM64 32h320l64 144v304H0V176zm160 368-84.8-74c-22.1-19.3-23.3-53.3-2.5-74.1 19.8-19.8 51.9-19.8 71.8 0l15.5 15.5 15.5-15.5c19.8-19.8 51.9-19.8 71.8 0 20.8 20.8 19.6 54.8-2.5 74.1z" })
  }
), be = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m312.8 157.6 7.2.9 167.3-20.9 44.1-93-86.8-41.1-60.6 128V128C384 57.3 326.7 0 256 0S128 57.3 128 128c0 2.2.1 4.3.2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7 0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6M64 160 0 288l224 64 96-160zm512 179.6-48 13.7v57.2l-184 46V288h-48v168.5l-184-46v-57.2l-48-13.7V448l256 64 256-64zm64-51.6-64-128-256 32 96 160z" })
  }
), fe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 160 224 64 96-160L64 32zm320-96 96 160 224-64-64-128zm-1.1 64h2.2zM528 225.3v153.2l-184 46V192h-48v232.5l-184-46V225.3l-48-13.7V416l256 64 256-64V211.6l-48 13.7z" })
  }
), Ue = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 160 26.7-80H95.2l-35.6 80zm0 48H48v224h352V208H288v80H160zm128-48h100.4l-35.6-80h-91.5zM64 32h320l64 144v304H0V176z" })
  }
), Ge = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h144c40 0 52 24 64 48s24 48 64 48h112l-16 48-21.3 64-16 48-10.7 32h32v48H96v-48h32l-7.1-32-10.7-48L74.7 48zm113.2 288h156.2l48-144H336c-31.1 0-56.2-9.9-75.5-28.2-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8c-6.8-13.4-9.3-17.4-11.6-19.6-.5-.5-.8-.6-1.3-.8-.7-.3-3-1-8.2-1h-84.2l53.3 240zM464 256h-35.6l16-48H512v304H0V208h77.4l10.7 48H48v112h416zM48 416v48h416v-48z" })
  }
), qe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m59.6 160 35.6-80H200v80H59.6zm188.4 0V80h104.8l35.6 80zm152 48v224H48V208zM384 32H64L0 176v304h448V176z" })
  }
), We = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 48H304v80h-48V0h384v512H384v-48h208zm-95 199 64 64-34 34-23-23v94h-48v-94.1l-23 23-34-33.9 64-64 17-17zm-161-39H48v48h288zM0 304V160h384v144h-32v208H32V304zm80 160h224V304H80zm176-128v48H128v-48z" })
  }
), Ee = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v144h48V0H128v192h48V48h72v80h80V48zm-48 464h224V224H352v48h24v80h80v-80h72v192H352zm-80-240v192H48V272h72v80h80v-80zM48 224H0v288h320V224h-48z" })
  }
), Oe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h392v128h56v169.9l-7 7-89 89V512H32V392.4L5.3 359 0 352.4V24zm392 176H272v80h64v48H224v-72H118.1l-7-7L79 193l34-34 25 25h86v-56h120V48H48v287.6L74.7 369l5.3 6.6V464h224v-89.9l7-7 89-89V176zM152.9 346.7l39.1 26.1 39.1-26.1 13.3-8.9 8.9 13.3 8.9 13.3-13.3 8.9-28 18.7 28 18.7 13.3 8.9-8.9 13.3-8.9 13.3-13.3-8.9-39.1-26.1-39.1 26.1-13.3 8.9-8.9-13.3-8.9-13.3 13.3-8.9 28-18.7-28-18.7-13.3-8.9 8.9-13.3 8.9-13.3z" })
  }
), Ie = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 32h24v150.1l57 57 7 7V266l-7 7-57 57v150H32v-48h112V310.1l7-7 47-47-47-47-7-7V80H32V32h24z" })
  }
), Ne = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 32H64v150.1L7 239l-7 7v19.9l7 7 57 57V480h160v-48H112V310.1l-7-7-47-47 47-47 7-7V80h112V32h-24z" })
  }
), Xe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m23.1 64.3 20.6 12.3C76.7 96.3 144 160.7 144 256S76.7 415.7 43.7 435.4l-20.6 12.3 24.6 41.2 20.6-12.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4L47.7 23.1z" })
  }
), Ke = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m168.9 64.3-20.6 12.3C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4l20.6 12.3-24.6 41.2-20.6-12.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4l20.6-12.3 24.6 41.2z" })
  }
), Qe = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32H48v48h96v352H48v48h144V56z" })
  }
), Ze = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h144v48H48v352h96v48H0V56z" })
  }
), Je = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32h160v48H112v121.9l-7 7-47 47 47 47 7 7V432h112v48H64V329.9L7 273l-7-7v-19.9l7-7 57-57V56zm448 0v150.1l57 57 7 7V266l-7 7-57 57v150H352v-48h112V310.1l7-7 47-47-47-47-7-7V80H352V32h136z" })
  }
), je = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M123.7 35.4C82 60.2 0 138 0 256s82 195.8 123.7 220.6l24.6-41.2C115.3 415.7 48 351.3 48 256S115.3 96.3 148.3 76.6zm264.6 0-24.6 41.2C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4l24.6 41.2C430 451.8 512 374.1 512 256S430 60.2 388.3 35.4z" })
  }
), Ye = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h144v-48H48V80h96V32h-24zm400 0H304v48h96v352h-96v48h144V32z" })
  }
), _e = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96m224 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128M88 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m248 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0M64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128M224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128m128 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m248 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128m24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-96-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128m24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), hl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.6 464H280V48h40c2.7 0 5.4.3 8 .8 18.3 3.7 32 19.8 32 39.2v.7c20.7 3.5 36.9 20.1 39.6 41 .3 2.1.4 4.2.4 6.3 0 5.7-1 11.2-2.8 16.3 7.8.8 15.1 3.5 21.3 7.7 11.5 7.6 19.6 20.1 21.2 34.6.2 1.8.3 3.6.3 5.5 0 14.5-6.5 27.6-16.7 36.4 15.5 6.1 28.1 18 34.9 33.1.4.8.7 1.7 1.1 2.5H480V161.6c-7.1-16.3-18.7-30.3-33.1-40.3-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0H192c-36.3 0-67.5 22-80.9 53.4-24.2 14.3-41.5 38.9-46 67.8C40.3 138.6 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.6 12.2 58.2 32 78.4v1.6c0 47.3 34.1 86.5 79.1 94.5 16.4 25 44.7 41.5 76.9 41.5h136c7 0 13.9-.8 20.5-2.3-11.1-11.3-22.9-26.6-30.9-45.7M152 88.7V88c0-19.4 13.7-35.5 32-39.2 2.6-.5 5.3-.8 8-.8h40v416h-44c-1.3 0-2.7-.1-4-.2-12.6-1.1-23.7-7.6-31-17.1-5.4-7.1-8.7-15.9-9-25.4-5 1.8-10.4 2.7-16 2.7-4.7 0-9.2-.7-13.4-1.9-20-5.8-34.6-24.3-34.6-46.1 0-6.5 1.3-12.6 3.6-18.3.5-1.2 1.1-2.4 1.7-3.6-1.6-.7-3.2-1.5-4.7-2.4A63.718 63.718 0 0 1 48 296c0-9.5 2.1-18.4 5.7-26.5 6.9-15.1 19.4-27 34.9-33.1C78.5 227.6 72 214.5 72 200c0-1.8.1-3.7.3-5.5 1.6-14.4 9.7-26.9 21.2-34.6 6.2-4.1 13.5-6.8 21.3-7.7-1.8-5.1-2.8-10.6-2.8-16.3 0-2.1.1-4.2.4-6.3 2.7-20.9 18.9-37.6 39.6-41zM528 240h-16v64h-64c-61.9 0-112 50.1-112 112 0 64 64 96 64 96v-48c0-35.3 28.7-64 64-64h48v64h16l112-112z" })
  }
), cl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 0h88c36.3 0 67.5 22 80.9 53.4 24.2 14.3 41.5 38.9 45.9 67.8 24.9 17.4 41.2 46.2 41.2 78.8 0 8-1 15.8-2.8 23.3 16.7 19.5 26.8 44.9 26.8 72.7 0 30.6-12.2 58.2-32 78.4V376.1c0 47.3-34.1 86.5-79.1 94.5-16.4 25-44.7 41.5-76.9 41.5H188c-32.2 0-60.5-16.5-76.9-41.5-45-8-79.1-47.3-79.1-94.5v-1.6C12.2 354.2 0 326.6 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.4 41.1-78.8 4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0zm-80 88.7c-20.7 3.5-36.9 20.1-39.6 41-.3 2.1-.4 4.2-.4 6.3 0 5.7 1 11.2 2.8 16.3-7.8.8-15.1 3.5-21.3 7.7-11.5 7.6-19.6 20.1-21.2 34.6-.2 1.8-.3 3.6-.3 5.5 0 14.5 6.5 27.6 16.7 36.4-15.5 6.1-28.1 18-34.9 33.1-3.7 8-5.8 16.9-5.8 26.4 0 23.9 13.1 44.8 32.6 55.8 1.5.9 3.1 1.7 4.7 2.4-.6 1.2-1.2 2.4-1.7 3.6-2.3 5.6-3.6 11.7-3.6 18.2 0 21.8 14.6 40.3 34.6 46.1 4.3 1.2 8.8 1.9 13.4 1.9 5.6 0 11-1 16-2.7.3 9.5 3.6 18.3 9 25.4 7.3 9.5 18.4 16 31 17.1 1.3.1 2.7.2 4 .2h44V288h-56v27.3c14.1 6.2 24 20.3 24 36.7 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-16.4 9.9-30.5 24-36.7V256h88v-96h-19.3c-6.2 14.1-20.3 24-36.7 24-22.1 0-40-17.9-40-40s17.9-40 40-40c16.4 0 30.5 9.9 36.7 24H232V48h-40c-2.7 0-5.4.3-8 .8-18.3 3.7-32 19.8-32 39.2zm24 39.3a16 16 0 1 0 0 32 16 16 0 1 0 0-32m183 318.7c5.4-7.1 8.7-15.9 9-25.4 5 1.8 10.4 2.7 16 2.7 4.7 0 9.2-.7 13.4-1.9 20-5.8 34.6-24.2 34.6-46.1 0-6.5-1.3-12.6-3.6-18.3-.5-1.2-1.1-2.4-1.7-3.6 1.6-.7 3.2-1.5 4.7-2.4 19.4-11 32.6-31.8 32.6-55.8 0-9.5-2.1-18.4-5.7-26.5-6.9-15.1-19.4-27-34.9-33.1 10.2-8.8 16.7-21.8 16.7-36.4 0-1.8-.1-3.7-.3-5.5-1.6-14.4-9.7-26.9-21.2-34.6-6.2-4.1-13.5-6.8-21.3-7.7 1.8-5.1 2.8-10.6 2.8-16.3 0-2.1-.1-4.2-.4-6.3-2.7-20.9-18.9-37.6-39.6-41v-.7c0-19.4-13.7-35.5-32-39.2-2.6-.5-5.3-.8-8-.8H280V128h88v59.3c14.1 6.2 24 20.3 24 36.7 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-16.4 9.9-30.5 24-36.7V160h-56v160h51.3c6.2-14.1 20.3-24 36.7-24 22.1 0 40 17.9 40 40s-17.9 40-40 40c-16.4 0-30.5-9.9-36.7-24H280v112h44c1.3 0 2.7-.1 4-.2 12.6-1.1 23.7-7.6 31-17.1M176 352a16 16 0 1 0-32 0 16 16 0 1 0 32 0m176-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32m32 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), sl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 464V48h40c2.7 0 5.4.3 8 .8 18.3 3.7 32 19.8 32 39.2v.7c20.7 3.5 36.9 20.1 39.6 41 .3 2.1.4 4.2.4 6.3 0 5.7-1 11.2-2.8 16.3 7.8.8 15.1 3.5 21.3 7.7 11.5 7.6 19.6 20.1 21.2 34.6.2 1.8.3 3.6.3 5.5 0 14.5-6.5 27.6-16.7 36.4 15.5 6.1 28.1 18 34.9 33.1 3.7 8.1 5.7 17.1 5.7 26.5 0 23.9-13.1 44.8-32.6 55.8-1.5.9-3.1 1.7-4.7 2.4.6 1.2 1.2 2.4 1.7 3.6 2.3 5.6 3.6 11.8 3.6 18.3 0 21.8-14.6 40.3-34.6 46.1-4.3 1.2-8.8 1.9-13.4 1.9-5.6 0-11-1-16-2.7-.3 9.5-3.6 18.3-9 25.4-7.3 9.5-18.4 16-31 17.1-1.3.1-2.7.2-4 .2H280zm-92 48h136c32.2 0 60.5-16.5 76.9-41.5 45-8 79.1-47.3 79.1-94.5v-1.6c19.8-20.2 32-47.8 32-78.4 0-27.8-10.1-53.2-26.8-72.7 1.8-7.5 2.8-15.3 2.8-23.3 0-32.6-16.3-61.4-41.1-78.8-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0H192c-36.3 0-67.5 22-80.9 53.4-24.2 14.3-41.5 38.9-46 67.8C40.3 138.6 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.6 12.2 58.2 32 78.4v1.6c0 47.3 34.1 86.5 79.1 94.5 16.4 25 44.7 41.5 76.9 41.5m-75.6-382.3c2.7-20.9 18.9-37.6 39.6-41V88c0-19.4 13.7-35.5 32-39.2 2.6-.5 5.3-.8 8-.8h40v416h-44c-1.3 0-2.7-.1-4-.2-12.6-1.1-23.7-7.6-31-17.1-5.4-7.1-8.7-15.9-9-25.4-5 1.8-10.4 2.7-16 2.7-4.7 0-9.2-.7-13.4-1.9-20-5.8-34.6-24.3-34.6-46.1 0-6.5 1.3-12.6 3.6-18.3.5-1.2 1.1-2.4 1.7-3.6-1.6-.7-3.2-1.5-4.7-2.4A63.718 63.718 0 0 1 48 296c0-9.5 2.1-18.4 5.7-26.5 6.9-15.1 19.4-27 34.9-33.1C78.5 227.6 72 214.5 72 200c0-1.8.1-3.7.3-5.5 1.6-14.4 9.7-26.9 21.2-34.6 6.2-4.1 13.5-6.8 21.3-7.7-1.8-5.1-2.8-10.6-2.8-16.3 0-2.1.1-4.2.4-6.3z" })
  }
), vl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352m0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448M104.1 88.8l-40.4-26-13 20.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173l13 20.2 40.4-26-13-20.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147zm472.2-26-40.4 26 13 20.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147l-13 20.2 40.4 26 13-20.2c32.1-49.9 50.7-109.3 50.7-173s-18.6-123.1-50.7-173zM344 128h-48v160h48V152zm-48 240h48v-48h-48z" })
  }
), el = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 24V0h-48v65.2c-49.8 7.7-88 50.8-88 102.8 0 43.7 27.4 82.8 68.4 97.7l70.7 25.7c22.1 8 36.8 29.1 36.8 52.6 0 30.9-25.1 56-56 56h-6.6c-17.7 0-35.2-4.6-50.6-13.4l-27-15.4-23.8 41.7 27 15.4c15.2 8.7 31.8 14.6 48.9 17.6V512h48v-65.2c49.8-7.7 88-50.8 88-102.8 0-43.7-27.4-82.8-68.4-97.7l-70.7-25.7c-22.1-8-36.8-29.1-36.8-52.6 0-30.9 25.1-56 56-56h12.3c15.3 0 30.4 2.9 44.6 8.6l14.3 5.7 17.8-44.6-14.2-5.7c-13.7-5.5-28.1-9.1-42.7-10.8zM0 32v448h48V304h59.9l56.3 176h50.4l-57.9-181C214 283 256 230.4 256 168c0-75.1-60.9-136-136-136H24zm48 224V80h72c48.6 0 88 39.4 88 88s-39.4 88-88 88z" })
  }
), ll = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 208H64c-8.8 0-16-7.2-16-16 0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6c44.5 20.5 68.1 47.7 68.1 84.4 0 8.8-7.2 16-16 16h-48v224H112V256zm304 48h112v176H416V304zm152-48h-90c1.3-5.1 2-10.5 2-16 0-51.1-28-86.9-65.8-111.5 28.7 2 72.2 9.7 109.7 27 44.5 20.6 68.1 47.8 68.1 84.5 0 8.8-7.2 16-16 16zM112 480h464V256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v224z" })
  }
), tl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 256v-48H64c-8.8 0-16-7.2-16-16 0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1c50.3 21.6 74.9 49.4 74.9 83.9 0 8.8-7.2 16-16 16h-48v224H112zm336 224V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v224h336zM256 376l88-88-88-88-88 88z" })
  }
), wl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 208v224h288V208h48c8.8 0 16-7.2 16-16 0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16zm336 224v48H64V256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v48z" })
  }
), gl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H32v48h72v64H32v48h576v-48h-72V80h64V32h-24zm282 258.3c7.4-15 16.9-28.9 28.1-41.1-14.2-5.9-29.8-9.2-46.1-9.2-66.3 0-120 53.7-120 120v72h-48v-96c0-53-43-96-96-96H32v48h24c26.5 0 48 21.5 48 48v144h144V360c0-39.8 32.2-72 72-72 6.2 0 12.3.8 18 2.3M488 80v64h-80V80zm-128 0v64h-80V80zm-128 0v64h-80V80zm408 288a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), il = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H32v48h72v64H32v48h576v-48h-72V80h64V32h-24zm282 258.3c7.4-15 16.9-28.9 28.1-41.1-14.2-5.9-29.8-9.2-46.1-9.2-66.3 0-120 53.7-120 120v72h-48v-96c0-53-43-96-96-96H32v48h24c26.5 0 48 21.5 48 48v144h144V360c0-39.8 32.2-72 72-72 6.2 0 12.3.8 18 2.3M488 80v64h-80V80zm-128 0v64h-80V80zm-128 0v64h-80V80zm264 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-240v112h-32V272zm0 176h-32v-32h32z" })
  }
), ml = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H32v48h72v64H32v48h576v-48h-72V80h64V32h-24zm282 258.3c7.4-15 16.9-28.9 28.1-41.1-14.2-5.9-29.8-9.2-46.1-9.2-66.3 0-120 53.7-120 120v72h-48v-96c0-53-43-96-96-96H32v48h24c26.5 0 48 21.5 48 48v144h144V360c0-39.8 32.2-72 72-72 6.2 0 12.3.8 18 2.3M488 80v64h-80V80zm-128 0v64h-80V80zm-128 0v64h-80V80zm264 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), al = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32h568v48h-64v64h72v48h-1.6c-20.2-19.8-47.9-32-78.4-32s-58.2 12.2-78.4 32H32v-48h72V80H32zm352 226.5V327c-12-23.2-36.1-39-64-39-39.8 0-72 32.2-72 72v120H104V336c0-26.5-21.5-48-48-48H32v-48h24c53 0 96 43 96 96v96h48v-72c0-66.3 53.7-120 120-120 23.5 0 45.5 6.8 64 18.5M408 80v64h80V80zm-48 64V80h-80v64zM152 80v64h80V80zm376 160c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H416V320h32z" })
  }
), ol = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 8h-14.8l-6.7 13.3c-21.1 42.2-56.8 71.4-96 97.9L29.4 159C54.5 142 81 122.2 104 97v143H0v48h640v-48H536V96.9c22.9 25.3 49.4 45 74.6 62l26.9-39.8c-39.2-26.5-74.9-55.7-96-97.9L534.8 8h-44.7l-6.9 12.1C447.6 82.4 389.4 120 320 120S192.4 82.4 156.8 20.1L149.9 8H136zm368 86.2V240h-48V133.9c17.5-11 33.6-24.3 48-39.8zm-96 62.4V240h-48v-73.2c16.7-1.7 32.7-5.2 48-10.2zm-96 10.2V240h-48v-83.5c15.3 5.1 31.3 8.5 48 10.3zm-96-32.9V240h-48V94.2c14.4 15.4 30.5 28.8 48 39.8zM0 336v48h96v128h144V384h160v128h144V384h96v-48H496v128h-48V336H192v128h-48V336H24z" })
  }
), nl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 208V64H0v144c44.2 0 80 35.8 80 80v59.5L96 336l18.6 13.4 1.1.8c4.4 3.2 8.5 6.1 12.3 8.7V288c0-53.7-33.1-99.7-80-118.7V112h480v57.3c-46.9 19-80 65-80 118.7v70.9c3.8-2.6 7.8-5.5 12.3-8.7L480 336l16 11.5V288c0-44.2 35.8-80 80-80m-224 64v104.3c10.7 4 21.8 6.7 32 6.7 5.2 0 10.5-.7 16-1.9V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v109.1c5.5 1.2 10.8 1.9 16 1.9 10.2 0 21.3-2.7 32-6.7V272c0-35.3 28.7-64 64-64s64 28.7 64 64M79 456.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.4 424.2 19.7 432 0 432v48c31.5 0 59.7-12.2 79-23.1" })
  }
), rl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h72v64H0v48h576v-48h-72V80h64V32h-24zm432 48v64h-80V80zm-128 0v64h-80V80zm-128 0v64h-80V80zM24 240H0v48h24c26.5 0 48 21.5 48 48v144h144V360c0-39.8 32.2-72 72-72s72 32.2 72 72v120h144V336c0-26.5 21.5-48 48-48h24v-48h-24c-53 0-96 43-96 96v96h-48v-72c0-66.3-53.7-120-120-120s-120 53.7-120 120v72h-48v-96c0-53-43-96-96-96" })
  }
), dl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h256v96h128v384H0V96h128V24zm208 48H176v48h160zM48 144v288h416V144H152zm257 55 72 72 17 17-17 17-72 72-17 17-33.9-34 17-17 31-31H128v-48h174.1l-31-31-17-17 33.9-33.9 17 17z" })
  }
), Sl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v96H0v384h512V96H384V0h-24zm184 96H176V48h160zm-184 48h312v288H48V144z" })
  }
), zl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h256v96h128v384H0V96h128V24zm208 48H176v48h160zM48 144v288h416V144H152zm176 48h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), pl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v96H0v384h512V96H384V0h-24zm312 256H48V144h416zm-144 48h144v128H48V304h144v48h128zm16-208H176V48h160z" })
  }
), Ml = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48v64h64V48zm32 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192m-82.7-224L128 82.7 82.7 128l45.3 45.3zM48 288h64v-64H48zm80 141.3 45.3-45.3-45.3-45.3L82.7 384zM288 400h-64v64h64zm96-61.3L338.7 384l45.3 45.3 45.3-45.3zM400 224v64h64v-64zm-16-50.7 45.3-45.3L384 82.7 338.7 128z" })
  }
), xl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 88v24h48V0h-48v24zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192M0 232v48h112v-48H24zm424 0h-24v48h112v-48h-24zM232 512h48V400h-48v88zM92 58 58 92l17 17 45.3 45.3 17 17 33.9-33.9-17-17L108.9 75zm299.8 299.8-17-17-33.9 33.9 17 17 45.2 45.3 17 17 33.9-34-17-17-45.3-45.3zM58 420l34 34 17-17 45.3-45.3 17-17-33.9-33.9-17 17L75 403.1zm299.8-299.8-17 17 33.9 33.9 17-17 45.3-45.2 17-17L420 58l-17 17-45.3 45.3z" })
  }
), Hl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 464h256V208h-80v-48h128v352H160V384h48zM0 352V0h352v352z" })
  }
), Vl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h160v16h48V0H0v256h128v-48H48zm336 416v48h256V256H512v48h80v160H432v-16h-48zm96-368H160v320h320z" })
  }
), Cl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-37.2 0-69.5 21.2-85.4 52.1-8.4-2.7-17.3-4.1-26.6-4.1-48.6 0-88 39.4-88 88v32.7C23 183.9 0 217.2 0 256c0 53 43 96 96 96h320c53 0 96-43 96-96 0-39.2-23.4-72.8-57-87.8l1-31.5v-.7c0-48.6-39.4-88-88-88-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0m-47.6 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7l5.6 42.9 33.4-27.5c6.9-5.7 15.7-9.1 25.4-9.1 22 0 39.8 17.7 40 39.7l-1.6 49-.7 20.3 19.9 4c21.9 4.4 38.4 23.8 38.4 47 0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48 0-22.8 15.9-42 37.3-46.8L104 205v-69c0-22.1 17.9-40 40-40 9.7 0 18.5 3.4 25.4 9.1l33.4 27.5 5.6-42.9zM200 512h112c18.4-55.3 44.9-100.1 63.9-128H280l-24 48-24-48h-95.9c19.1 27.9 45.5 72.7 63.9 128" })
  }
), Ll = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 0 336 208l-34.1-34.1-1.1-1.1L288 160h-32l-21.6 75.5-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5-16.7 16.7-29 37.1-36.1 59.2-1.9 6-3.5 12.2-4.6 18.4-1.6 8.7-2.4 17.6-2.4 26.6v2.9h32l-32 32-16 16-32 32-16 16v32h194.9c39.1 0 76.6-15.5 104.2-43.2 33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6L416 320v-32l-12.8-12.8-1.1-1.1L368 240 576 32zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-42.5 29.5 55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4-18.6 18.6-43.9 29.1-70.3 29.1h-111l46.1-46.1 81.9-81.9h-89.1c4.7-9.2 10.9-17.8 18.3-25.2 22.4-22.4 54.1-32.8 85.4-28zM464 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), Bl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 144 480 0l32 32-144 144 48 48-150.3 245.9L240 512l-34.9-34.9L34.9 306.9 0 272l42.1-25.7L288 96zM77 281.2l25.9 25.8 57.1-19-19 57.1 89.8 89.9 89.6-146.6-96.8-96.8z" })
  }
), ul = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 208 544 0l32 32-208 208 34.1 34.1 1.1 1.1L416 288v32l-75.5 21.6.1.6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512H0v-32l16-16 32-32 16-16 32-32H64v-2.9c0-9 .8-17.9 2.4-26.6 1.1-6.2 2.7-12.4 4.6-18.4 7.1-22.1 19.4-42.4 36.1-59.2 33.2-33.2 80.2-48.6 126.7-41.5l.6.1L256 160h32l12.8 12.8 1.1 1.1zm-49.1 18.7-8 28.1 42.3 42.3 28.1-8-62.4-62.4zm4.8 113-55.4-55.4-9.8-1.5c-31.3-4.8-63 5.6-85.4 28-7.5 7.5-13.6 16-18.3 25.2h89.1L130 417.9 83.9 464H195c26.4 0 51.7-10.5 70.3-29.1 22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8z" })
  }
), Rl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 432V160H48v272zm48-272v320H0V32h512v64z" })
  }
), $l = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 368V128h384v240zm0-368H96v416h480V0h-48zM48 120V96H0v416h480v-48H48z" })
  }
), kl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 288V48h48v112h32V48h64v80h32V48h112v240zM0 384h128v128h128V384h128V0H0v336zm192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Pl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M75.5 0h297l3.2 20.3L397.8 160h-48.6L331.5 48h-215L98.8 160H50.2L72.3 20.3zM0 192h448v48h-36.8L384 512H64L36.8 240H0zm85 48 22.4 224h233.2L363 240z" })
  }
), Fl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M477.6 348c1.6-9.1 2.4-18.4 2.4-28v-8h96v-48h-96v-70.1l57-57 17-17-34-33.8-17 17-57 57H235.4L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM297.2 208H432v104.6zM344 367l-48-37.8v100.2c-50.3-11-88-55.8-88-109.4v-60.1l-48-37.8V264H64v48h96v8c0 27.2 6.8 52.8 18.8 75.3l-64.6 64.6-17 17 33.9 33.9 17-17 59.7-59.7C236.7 462.5 276.3 480 320 480c43 0 82.1-17 110.8-44.6l-38.2-30.1c-13.7 11.7-30.3 20.1-48.6 24.1zM224 96v32h192V96c0-53-43-96-96-96s-96 43-96 96" })
  }
), Tl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-53 0-96 43-96 96v32h192V96c0-53-43-96-96-96M73 103 56 86l-33.9 34 17 17 57 57v70H0v48h96v8c0 27.2 6.8 52.8 18.8 75.3l-64.6 64.5-17 17 33.9 33.9 17-17 59.7-59.7c28.9 28.5 68.5 46 112.2 46s83.3-17.5 112.2-45.9l59.7 59.7 17 17 33.9-33.9-17-17-64.6-64.6c12-22.4 18.8-48.1 18.8-75.3v-8h96v-48h-96v-70.1l57-57 17-17-34-33.8-17 17-57 57H129.9zm159 326.4c-50.3-11-88-55.8-88-109.4V208h224v112c0 53.6-37.7 98.4-88 109.4V256h-48v24z" })
  }
), Al = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m194.2 41.9-29.7 65.5c10.2 7.1 18.2 17 22.9 28.6h15.4l2.3-18.9 2.9-23.8 47.5 5.7-2.9 23.8-4.8 40-2.5 21.2H192v23.3l37.8 9.5 16.1 4 1.9 16.5 6.4 56 2.7 23.8-47.7 5.4-2.7-23.8-4.5-39.4-17.9-4.5C173.2 274.6 152.2 288 128 288s-45.3-13.4-56.1-33.2L54 259.3l-4.5 39.5-2.7 23.8-47.8-5.5 2.7-23.8 6.4-56 1.9-16.5 16.1-4 37.9-9.5V184H10.5l-2.4-21.3-4.5-40L1 98.8l47.7-5.3 2.7 23.9 2.1 18.6h15.2c4.7-11.6 12.7-21.5 22.9-28.6L61.8 41.9l-9.9-21.8L95.6.2l9.9 21.9L128 71.7l22.5-49.6L160.4.2 204.1 20l-9.9 21.9zm359.4 197.6-65.6 47c5.3 11.2 7.2 23.8 5.5 36.2l14.7 8.5 13.9-15.9 15.8-18L574 329l-15.8 18-26.9 30.6-13 14.8-17-9.8-27.7-16-11.6 20.1 28 27.1 11 10.7-5.2 14.5-17.2 49-8 22.6-45.3-15.9 8-22.6 12.1-34.4-14.2-13.7c-19.3 11.7-44.3 12.8-65.2.7s-32.5-34.3-32-56.8l-18.2-5.2-25 31.8-14.8 18.9-37.8-29.6 14.8-18.9 35-44.7 10-12.7 15.5 4.4 37.5 10.8 11.6-20.1-27.7-16-17-9.8 6.3-18.6 13.1-38.6 7.7-22.7 45.5 15.4-7.7 22.7-6.8 20 14.7 8.5c9.9-7.7 21.8-12.3 34.1-13.3l7.8-80.3 2.3-23.9 47.8 4.7-2.3 23.9-6.2 62.9 51.4-36.8 19.5-14 27.9 39-19.5 14zM144 224v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16m267.9 153.2 32-55.4c4.4-7.7 1.8-17.4-5.9-21.9s-17.4-1.8-21.9 5.9l-32 55.4c-4.4 7.7-1.8 17.4 5.9 21.9s17.4 1.8 21.9-5.9" })
  }
), Dl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v246.6c11.1-24.3 27.7-45.5 48-62.3V0H0v512h384v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464h-96V352h-96v112H48zm40 40v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm208 0h-80v80h80zm344 152a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-136-78.6 11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6 11.3-11.3 28.7-28.7H416v-32h105.4l-28.7-28.7-11.3-11.3z" })
  }
), yl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v246.6c11.1-24.3 27.7-45.5 48-62.3V0H0v512h384v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464h-96V352h-96v112H48zm40 40v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm208 0h-80v80h80zm344 152a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), bl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v246.6c11.1-24.3 27.7-45.5 48-62.3V0H0v512h384v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464h-96V352h-96v112H48zm40 40v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm208 0h-80v80h80zm200 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-64h-32v-32h32zm0-176v112h-32V272z" })
  }
), fl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v246.6c11.1-24.3 27.7-45.5 48-62.3V0H0v512h384v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464h-96V352h-96v112H48zm40 40v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm208 0h-80v80h80zm200 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), Ul = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 192H0v-48L256 0l256 144v48h-48zm366.1-48L256 55.1 97.9 144h130.4c-2.7-4.7-4.3-10.2-4.3-16 0-17.7 14.3-32 32-32s32 14.3 32 32c0 5.8-1.6 11.3-4.3 16zM64 224h48v160h64V224h48v160h64V224h48v160h64V224h48v160h32v48H32v-48h32zM24 464h488v48H0v-48z" })
  }
), Gl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h96V352h96v112h96V48zM0 0h384v512H0V48zm88 88h80v80H88zm208 0v80h-80V88zM88 216h80v80H88zm208 0v80h-80v-80zM480 0v32h160v160H480v320h-64V0z" })
  }
), ql = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v240h16v-16c0-30.5 12.2-58.2 32-78.4V0H0v512h320v-48h-80V352h-96v112H48zm40 40v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm208 0h-80v80h80zm168 24c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), Wl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48H0V0h384v48zm0 192h48v272H0V240h48v224h96V352h96v112h96zM32 80h33.9l4.4 8.8L96 140.2V80h32v128H94.1l-4.4-8.8L64 147.8V208H32V96zm136 0h64v32h-48v64h16v-32h32v64h-80V80zm120 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16m16-48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48M168 248v80H88v-80zm128 80h-80v-80h80z" })
  }
), El = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v178.9l48-18.6V0H0v512h362.1c-19.2-13.7-35.7-30-49.5-48H240V352h-96v112H48zm248 168h-80v80h40v-38.2l40-15.5zM88 88v80h80V88zm208 0h-80v80h80zM88 216v80h80v-80zm439.3 96.4c-5.2 61-38.8 121.7-95.3 148V275.5zM432 512c96-32 144-130.2 144-216v-16.2L432 224l-144 55.8V296c0 85.8 48 184 144 216" })
  }
), Ol = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h96V352h96v112h96V48zM0 0h384v512H0V48zm168 328H88v-80h80zm48-80h80v80h-80zM112 96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32v80c0 26.5-21.5 48-48 48s-48-21.5-48-48V80h32zm112-16h17.9l4.4 8.8 25.7 51.4V80h32v128h-33.9l-4.4-8.8-25.7-51.4V208h-32V80z" })
  }
), Il = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h96V352h96v112h96V48zM0 0h384v359l-66.9 153H0V48zm88 88h80v80H88zm208 0v80h-80V88zM88 216h80v80H88zm208 0v80h-80v-80zm120 56a80 80 0 1 1 160 0 80 80 0 1 1-160 0m168 112 56 128H352l56-128z" })
  }
), Nl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v416h-96V352h-96v112H48V48zM48 0H0v512h384V0h-48zm120 88H88v80h80zm48 0v80h80V88zm-48 128H88v80h80zm48 0v80h80v-80zm424-24h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm0 128v-16h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80m0 112v-16h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80m-128 64c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80h16zm0-96v-16c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80zm0-128c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80h16zm40-240h-48v152h48V56zm72 64V72h-48v80h48v-24zM480 72h-48v80h48V96z" })
  }
), Xl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h96V352h96v112h96V48zM0 0h384v512H0V48zm88 88h80v80H88zm208 0v80h-80V88zM88 216h80v80H88zm208 0v80h-80v-80z" })
  }
), Kl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48v416H272V48zM272 0h-48v512h288V0h-48zm-80 128H0v384h192v-48H48V176h144zm-32 192H96v64h64zm176 32h64v-64h-64zM160 224H96v64h64zM336 96v64h64V96zm64 160v-64h-64v64z" })
  }
), Ql = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.1 0H480v179.6c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4V480h-41.9l-7-7-43.6-43.6c-47.8-47.8-112-75.4-179.4-77.2V512H64V352H0V128h200.7c70 0 137.2-27.8 186.7-77.3L431 7l7-7zm-16.8 395.4 10.7 10.7V73.9l-10.7 10.7C364.5 141.4 288.1 174 208 175.9v128.2c80.1 1.9 156.5 34.5 213.3 91.3zM48 176v128h112V176zm64 176v112h48V352z" })
  }
), Zl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6 0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6zm97.4-8.1c3.3 14.7 5 30 5 45.7 0 114.9-93.1 208-208 208S48 370.9 48 256 141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zM365 180.9l67 11.1 80-80-80-32-32-80-80 80 11.2 66.9L231 247l34 34 100.1-100.2z" })
  }
), Jl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 5.5.2 10.9.6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4.4 10.8.6 16.3.6zm-2.4-48 14.3-48.6c56.3-6 100.1-53.6 100.1-111.4 0-61.9-50.1-112-112-112-57.8 0-105.4 43.8-111.4 100.1L96 258.4V256c0-88.4 71.6-160 160-160s160 71.6 160 160-71.6 160-160 160zM0 320l272-80-80 272-48-96-1.4-1.4-96 96-45.2-45.2 96-96L96 368z" })
  }
), jl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 112a112 112 0 1 0 0-224 112 112 0 1 0 0 224m0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), Yl = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264 0h48v64h67.8l3.8 19.4 60.5 310.2c-6.5 4.4-12.6 8-19.4 11.1-8.2 3.8-17.1 6.9-25.7 8.7L383.9 336H192.1L177 413.3c-8.6-1.8-17.4-4.9-25.7-8.7-6.8-3.1-12.9-6.7-19.4-11.1l60.5-310.1 3.8-19.4H264zm-62.6 288h173.2l-34.4-176H235.8zM79 488.9C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), _l = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 0H160v48h36.1l-53.9 256H48v97c8.9-4.9 17.3-10.9 28.3-18.8l1.1-.8L96 368v-16h384v16l19.7 14.2c11 7.9 19.3 13.9 28.3 18.8v-97h-94.2L379.9 48H416zm-85.2 48 11.9 56.6-54.7 63.9-54.8-63.9 12-56.6h85.7zm-110 115.8 35.6 41.5-58.8 68.6 23.2-110.1zm67.2 78.4 53 61.8H235zm90.4 31.7-58.8-68.6 35.6-41.5zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1" })
  }
), ht = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224v-32s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H80zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5h346.6c-2.6-10.3-7.5-23.4-16.6-36.5-8.4-12-22-26.2-44.8-37.7.1.7.2 1.5.2 2.2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6-19.2-6-42.8-10.2-72.1-11.2 1.3 2.3 2 4.9 2 7.8 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.5 2-7.8-29.3 1-52.9 5.2-72.1 11.2 3.7 2.9 6.1 7.5 6.1 12.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7.1-1.5.1-2.2-22.8 11.5-36.4 25.7-44.8 37.7zM80 432h352v-32H80zm-48-80h448v128H32v-80zm208-96 80 40 80-40h96v64H16v-64h176z" })
  }
), ct = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m97.4 221.4 20.3 50.6H128V90.7L112 0 64 32zM59.7 192 41.8 90.5 0 80l18.7 112zM368 175.5 384 80l-41.3 10.3L325.8 192h7.3c10.4-6.1 22-11.7 35-16.5zm-78.3 37.9L320 32l-64 16v224h4c2.2-5.2 4.7-10.3 7.6-15.3 3.1-5.3 7-11.3 11.9-17.7l10.2-25.5zM96 304l-32-80H0l10.7 48L64 512h192v-48H102.5L77.6 352H256v-48zm128-32V32L160 0v272zm112 29.1c.7-1.3 1.6-3.1 2.8-5.1 3.5-5.8 9.3-13.8 18.5-22 3.1-2.8 6.7-5.7 10.8-8.5.7 8.2 7.6 14.6 15.9 14.6 8.8 0 16-7.2 16-16 0-4.9-2.2-9.4-5.8-12.3 14.7-5.7 33-10 55.7-11.3-1.2 2.3-1.9 4.9-1.9 7.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6 22.7 1.3 41 5.6 55.7 11.3-3.5 2.9-5.8 7.4-5.8 12.3 0 8.8 7.2 16 16 16 8.3 0 15.2-6.4 15.9-14.6 4.1 2.8 7.7 5.7 10.8 8.5 9.2 8.2 15 16.2 18.5 22 1.2 2 2.1 3.7 2.8 5.1v35H336zm0 115h256v48H336zm-48-40v136h352v-220l-1.3-3.8-22.7 7.8 22.7-7.8v-.1l-.1-.2-.2-.4c-.1-.3-.3-.7-.5-1.2-.4-.9-.9-2.2-1.6-3.6-1.3-3-3.3-6.9-6.1-11.5-5.6-9.2-14.4-21.2-27.6-33-27-24.1-70.7-46.1-138.7-46.1s-111.7 22-138.7 46.1c-13.3 11.8-22.1 23.8-27.6 33-2.8 4.6-4.8 8.6-6.1 11.5-.7 1.5-1.2 2.7-1.6 3.6-.2.5-.3.9-.5 1.2l-.2.4-.1.2v.1l22.7 7.8-22.7-7.8-1.3 3.8v84z" })
  }
), st = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64.4 208 20 256H256v48H40L3.8 48 0 0H384l-3.8 48-9.9 126.7c-24.6 8.7-44.5 20.5-60.4 33.3zm-3.7-48h262.7l8.7-112H51.9l8.8 112zM336 301.1v35h256v-35c-.7-1.3-1.6-3.1-2.8-5.1-3.5-5.8-9.3-13.8-18.5-22-3.1-2.8-6.7-5.7-10.8-8.5-.7 8.2-7.6 14.6-15.9 14.6-8.8 0-16-7.2-16-16 0-4.9 2.2-9.4 5.8-12.3-14.7-5.7-33-10-55.7-11.3 1.2 2.3 1.9 4.9 1.9 7.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.3 1.9-7.6-22.7 1.3-41 5.6-55.7 11.3 3.5 2.9 5.8 7.4 5.8 12.3 0 8.8-7.2 16-16 16-8.3 0-15.2-6.4-15.9-14.6-4.1 2.8-7.7 5.7-10.8 8.5-9.2 8.2-15 16.2-18.5 22-1.2 2-2.1 3.7-2.8 5.1zm0 115v48h256v-48zm-48-40v-84l1.3-3.8 22.7 7.8-22.7-7.8v-.1l.1-.2.2-.4c.1-.3.3-.7.5-1.2.4-.9.9-2.2 1.6-3.6 1.3-3 3.3-6.9 6.1-11.5 5.6-9.2 14.4-21.2 27.6-33 27-24.1 70.7-46.1 138.7-46.1s111.7 22 138.7 46.1c13.3 11.8 22.1 23.8 27.6 33 2.8 4.6 4.8 8.6 6.1 11.5.7 1.5 1.2 2.7 1.6 3.6.2.5.3.9.5 1.2l.2.4.1.2v.1l-22.7 7.8 22.7-7.8 1.3 3.8v220H288v-128z" })
  }
), vt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224v-32s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H80zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5h346.6c-2.6-10.3-7.5-23.4-16.6-36.5-8.4-12-22-26.2-44.8-37.7.1.7.2 1.5.2 2.2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6-19.2-6-42.8-10.2-72.1-11.2 1.3 2.3 2 4.9 2 7.8 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.5 2-7.8-29.3 1-52.9 5.2-72.1 11.2 3.7 2.9 6.1 7.5 6.1 12.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7.1-1.5.1-2.2-22.8 11.5-36.4 25.7-44.8 37.7zM80 432h352v-32H80zm-48-80h448v128H32v-80zm144.2-102.6 79.8 29 79.8-29 8.2-3 8.2 3 79.7 29 55.7-20.9 16.9 44.9-64 24-8.3 3.1-8.3-3-79.8-29-79.8 29-8.2 3-8.2-3-79.8-29-79.8 29-8.3 3-8.3-3.1-64-24 16.9-44.9 55.7 20.9 79.7-29 8.2-3 8.2 3z" })
  }
), et = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h-19l-4.4 18.5L174.9 128H0v48H366.8c5.5-2 11.2-3.9 17.2-5.6V128H224.2L243 48h61V0h-24zm32 464H108.2L86.8 208H38.7L64 512h192zm80-162.9c.7-1.3 1.6-3.1 2.8-5.1 3.5-5.8 9.3-13.8 18.5-22 3.1-2.8 6.7-5.7 10.8-8.5.7 8.2 7.6 14.6 15.9 14.6 8.8 0 16-7.2 16-16 0-4.9-2.2-9.4-5.8-12.3 14.7-5.7 33-10 55.7-11.3-1.2 2.3-1.9 4.9-1.9 7.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6 22.7 1.3 41 5.6 55.7 11.3-3.5 2.9-5.8 7.4-5.8 12.3 0 8.8 7.2 16 16 16 8.3 0 15.2-6.4 15.9-14.6 4.1 2.8 7.7 5.7 10.8 8.5 9.2 8.2 15 16.2 18.5 22 1.2 2 2.1 3.7 2.8 5.1v35H336zm0 115h256v48H336zm-48-40v136h352v-220l-1.3-3.8-22.7 7.8 22.7-7.8v-.1l-.1-.2-.2-.4c-.1-.3-.3-.7-.5-1.2-.4-.9-.9-2.2-1.6-3.6-1.3-3-3.3-6.9-6.1-11.5-5.6-9.2-14.4-21.2-27.6-33-27-24.1-70.7-46.1-138.7-46.1s-111.7 22-138.7 46.1c-13.3 11.8-22.1 23.8-27.6 33-2.8 4.6-4.8 8.6-6.1 11.5-.7 1.5-1.2 2.7-1.6 3.6-.2.5-.3.9-.5 1.2l-.2.4-.1.2v.1l22.7 7.8-22.7-7.8-1.3 3.8v84z" })
  }
), lt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224v-32s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H80zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5h346.6c-2.6-10.3-7.5-23.4-16.6-36.5-8.4-12-22-26.2-44.8-37.7.1.7.2 1.5.2 2.2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6-19.2-6-42.8-10.2-72.1-11.2 1.3 2.3 2 4.9 2 7.8 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.5 2-7.8-29.3 1-52.9 5.2-72.1 11.2 3.7 2.9 6.1 7.5 6.1 12.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7.1-1.5.1-2.2-22.8 11.5-36.4 25.7-44.8 37.7zM80 432h352v-32H80zm-48-80h448v128H32v-80zm464-96v64H16v-64z" })
  }
), tt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M242 62c8.2-35.5 40-62 78-62 11.4 0 22.2 2.4 32 6.7 9.8-4.3 20.6-6.7 32-6.7 34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32 2.7 6.1 4.6 12.7 5.7 19.6 6.6 41.7-20.4 81-61 90.4L208 512h-96L0 400v-96zM54.1 317.8c18 6.6 37.5 10.2 57.9 10.2 75.6 0 139.5-49.9 160.6-118.6 4.8-15.6 7.4-32.2 7.4-49.4 0-20.3-3.6-39.8-10.2-57.9L54.1 317.8M48 380.1l83.9 83.9h56.2l221.8-221.8c-18-6.6-37.5-10.2-57.9-10.2-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-22.3 0-43.8-3.4-64-9.6v13.8z" })
  }
), wt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m312.8 118.8-30.2-63.2L256 0l-26.6 55.6-9.4 19.7-20.8 43.5-41.4-24.7-71-42.4L0 0l51.8 86.8 42.4 71 24.7 41.4L75.3 220l-19.7 9.4L0 256l55.6 26.6 63.2 30.2-23.3 66L75 437l58.1-20.5 66-23.3 30.2 63.2L256 512l26.6-55.6 30.2-63.2 66 23.3L437 437l-20.5-58.2-23.3-66 63.2-30.2L512 256l-55.6-26.6-63.2-30.2 23.3-66L437 75l-58.1 20.5-66 23.3zm45.5 34.8-10.4 29.5-14.4 40.7 38.9 18.6 28.3 13.6-28.3 13.5-38.9 18.6 14.4 40.7 10.4 29.5-29.5-10.4-40.7-14.4-18.6 38.9-13.5 28.3-13.5-28.3-18.6-38.9-40.7 14.4-29.5 10.4 10.4-29.5 14.4-40.7-38.9-18.6-28.3-13.5 28.3-13.5 47.4-22.7-27-45.2-21.5-36 36 21.5 45.2 27 22.7-47.5 13.6-28.3 13.5 28.3 18.6 38.9 40.7-14.4 29.5-10.4z" })
  }
), gt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96h80V80h160v16h80v-2c-11.6-14.2-51.7-46-160-46-55.9 0-95.6 9.9-122 21.5-21.1 9.2-32.7 19-38 24.8zm0 48v80h136v-80zm320 80v-80H280v80zm48-137.4V128h48v128h-16v192h-48v64h-48v-64H112v64H64v-64H16V256H0V128h48V80.4l3.1-5.5c9.4-16.7 31.2-35.2 63.7-49.4C148 10.9 194.5 0 256 0c130.6 0 187.3 43.4 204.9 74.9l3.1 5.5v6.3zM64 400h384V272H64zm48-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), it = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 272h352v128H48zm0-48v-80h352v80zm3.5-128c6.9-6.7 19.2-15.8 39-24.5C119.5 58.8 163 48 224 48c111.7 0 157.4 31 173.1 48zM24 448h8v64h48v-64h288v64h48v-64h32V85.8l-3.1-5.5C426.3 47 365.6 0 224 0 157.4 0 107.2 11.9 71.3 27.5 36.2 42.9 12.9 62.7 3.1 80.4L0 85.8V448zm88-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), mt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 272h352v128H112zm0-48v-80h152v80zm352 0H312v-80h152zM368 96V80H208v16h-92.5c6.9-6.7 19.2-15.8 39-24.5C183.5 58.8 227 48 288 48c111.7 0 157.4 31 173.1 48zM88 448h8v64h48v-64h288v64h48v-64h32V256h32V128h-32V85.8l-3.1-5.5C490.3 47 429.6 0 288 0c-66.6 0-116.8 11.9-152.7 27.5-35.1 15.4-58.4 35.2-68.2 52.9L64 85.8V128H32v128h32v192zm88-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), at = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v96H0v384h360.2c-11.8-14.3-21.4-30.5-28.2-48H48V304h144v48h128.7c3.3-36.3 17.6-69.4 39.5-96H48V144h416v50.9c10.4-1.9 21.1-2.9 32-2.9 5.4 0 10.7.2 16 .7V96H384V0h-24zm184 96H176V48h160zm304 272a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-128-80v64h48v32h-80v-96z" })
  }
), ot = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 112v176h-48V112H112v176H64V64h512v224h-48V112zM0 320h640v48h-32v80H32v-80H0z" })
  }
), nt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7 177.5 68.7 245.2 0l33.7 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317 226.3-87.5 312.6 0l-33.7 34.2z" })
  }
), rt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 58.2 427.3 176H84.7zM432 121 256 0 0 176v48h512v-48l-32-22V32h-48zM32 272v48h160v-48zm0 192v48h160v-48zm160-96H32v48h160zm128-96v48h160v-48zm160 192H320v48h160zm-160-96v48h160v-48zm-64-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), dt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 232V48H48v184zM0 464V0h448v512H0zm48-184v184h352V280zm88-184h200v80h-48v-32H160v32h-48V96zm0 240h200v80h-48v-32H160v32h-48v-80z" })
  }
), St = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-64-8a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-64 216v80H80v-80zm48 0h96v80h-96zm144 0h80v80h-80zm80 128v64H80v-64h248zM80 224H32v288h448V224H280v-76.6l205-43.9 23.5-5-10.1-47-23.5 5-224 48-224 48-23.5 5 10.1 46.9 23.5-5 195-41.8V224z" })
  }
), zt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 464h-96V96c0-26.5 21.5-48 48-48s48 21.5 48 48zM48 320h112v192h192v-64h160V224h-96v128h-64V96c0-53-43-96-96-96s-96 43-96 96v128H96V96H0v224zm208-176a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), pt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.9 44.9C58.8 52.1 56 60.8 56 69.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.4c0-8.8-2.8-17.5-7.9-24.6L96 0zM120 168v-24H72v80H0v288h448V224h-72v-80h-48v80h-80v-80h-48v80h-80zM48 340.3V272h352v68.3l-37.7-17.9-10.6-5-10.5 5.2-53.2 26.6-53.3-26.6-10.7-5.4-10.7 5.4-53.3 26.6-53.3-26.6-10.5-5.2-10.6 5zm0 53.2 47.7-22.7 53.5 26.8 10.7 5.4 10.7-5.4 53.4-26.8 53.3 26.6 10.7 5.4 10.7-5.4 53.5-26.8 47.8 22.8V464H48v-70.6zM224 0l-32.1 44.9c-5.1 7.2-7.9 15.8-7.9 24.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.4c0-8.8-2.8-17.5-7.9-24.6zm95.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.4c0-8.8-2.8-17.5-7.9-24.6L352 0z" })
  }
), Mt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 304V351.7H48V304zM48 432v-48h416V431.8H48zm464 0V256c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32h-11.1l-8.7 6.9-264 208L0 256.5V480h512V446.7v.3V436.6v.4V432z" })
  }
), xt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v232h232v48H280v232h-48V280H0v-48h232V0zm120 32h24v56h56v48h-56v56h-48v-56h-56V88h56V32zM72.4 326.5l17 17 22.6 22.6 22.6-22.6 17-17 33.9 33.9-17 17-22.6 22.6 22.6 22.6 17 17-33.9 33.9-17-17-22.6-22.6-22.6 22.7-17 17-33.9-34 17-17L78.1 400l-22.7-22.6-17-17 33.9-33.9zM64 88h120v48H40V88zm288 248h120v48H328v-48zm0 80h120v48H328v-48z" })
  }
), Ht = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 176H48v288h288zm0-48V48H48v80zm48 0v384H0V0h384v48zM80 208h48v48H80zm48 88v48H80v-48zm-48 88h136v48H80zm136-176v48h-48v-48zm-48 88h48v48h-48zm136-88v48h-48v-48zm-48 88h48v48h-48zm48 88v48h-48v-48z" })
  }
), Vt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zm-152 56v102.1l39-39 17-17 33.9 33.9-17 17-80 80-17 17-17-17-80-80-17-17 34.1-33.9 17 17 39 39V224h48z" })
  }
), Ct = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zM248 408v24h-48V305.9l-39 39-17 17-33.9-33.9 17-17 80-80 17-17 17 17 80 80 17 17-34.1 33.9-17-17-39-39z" })
  }
), Lt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zm-71 105L217 409l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47 95-95 17-17 33.9 33.9-17 17z" })
  }
), Bt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h236.5c12.3 18.8 28 35.1 46.3 48H0V64h104V0zm280 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), ut = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h236.5c12.3 18.8 28 35.1 46.3 48H0V64h104V0zm136 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 16v-32H352v32h144z" })
  }
), Rt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h236.5c12.3 18.8 28 35.1 46.3 48H0V64h104V0zm280 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), $t = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h236.5c12.3 18.8 28 35.1 46.3 48H0V64h104V0zm136 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224.7 77.7L488 416H376l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3M480 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), kt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h236.5c12.3 18.8 28 35.1 46.3 48H0V64h104V0zm136 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m160-80h-32v96h80v-32h-48v-48z" })
  }
), Pt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zm-176 64v128H96V256z" })
  }
), Ft = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 24V0h-48v64H0v448h448V64H344V0h-48v64H152zM48 192h80v56H48zm0 104h80v64H48zm128 0h96v64h-96zm144 0h80v64h-80zm80-48h-80v-56h80zm0 160v56h-80v-56zm-128 0v56h-96v-56zm-144 0v56H48v-56zm144-160h-96v-56h96z" })
  }
), Tt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 24V0h-48v64H0v448h448V64H344V0h-48v64H152zM48 192h352v272H48zm200 32h-48v128h48V248zm0 160h-48v48h48z" })
  }
), At = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zM112 299.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L235 421.5l-11 10.6-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z" })
  }
), Dt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 24V0h-48v64H0v448h448V64H344V0h-48v64H152zM48 192h352v272H48zm112 120L80 416h288L256 240l-72 104zm-32-24a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), yt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v128H48v272h212.3l-6.9 48H0V64h104V0zm168 256v48H96v-48zM96 352h160v48H96zm409-128.2 71 71-41.3 41.3-71-71zm-63.9 63.9 71 71L370.9 500 288 511.9l11.9-82.9 141.2-141.2z" })
  }
), bt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 24V0h-48v64H0v448h448V64H344V0h-48v64H152zM48 192h352v272H48zm48 88c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24m24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), ft = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0v64h144V0h48v64h104v448H32V64h104V0zm248 192H80v272h352zM328 352H160v-48h192v48z" })
  }
), Ut = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0v64h144V0h48v64h104v448H32V64h104V0zm248 192H80v272h352zM224 424l-64 8 8-64 88.7-88.7 56 56zm111.3-111.3-56-56L312 224l56 56z" })
  }
), Gt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 24V0h-48v64H32v448h448V64H376V0h-48v64H184zM80 192h352v272H80zm200 40h-48v72h-72v48h72v72h48v-72h72v-48h-72v-48z" })
  }
), qt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 24V0h-48v64H32v448h448V64H376V0h-48v64H184zM80 192h352v272H80zm48 64v64h64v-64zm192 96v64h64v-64zm-96-88v48h160v-48zm-96 96v48h160v-48z" })
  }
), Wt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0v64h144V0h48v64h104v448H32V64h104V0zm248 192H80v272h352zM285.6 295.2l76.9 6.2-58.6 50.2 17.9 75-65.8-40.2-65.8 40.2 17.9-75-58.6-50.2 76.9-6.2L256 224z" })
  }
), Et = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0v64h144V0h48v64h104v128H96V64h104V0zm12.8 512L244 464h152l-16.8 48zM112 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160m112 288H0l32-96h160zm224-208a80 80 0 1 1 160 0 80 80 0 1 1-160 0m160 112 32 96H416l32-96z" })
  }
), Ot = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0v64h144V0h48v64h104v448H0V64h104V0zm248 192H48v272h352zm-48 64v96H96v-96z" })
  }
), It = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0v64h144V0h48v64h104v448H32V64h104V0zm248 192H80v272h352zm-95 89-47 47 47 47 17 17-34 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17 33.9 33.9-17 17z" })
  }
), Nt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 24V0h-48v64H0v448h448V64H344V0h-48v64H152zM48 192h352v272H48z" })
  }
), Xt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0v64h112V0h48v64h104v352H96V64h104V0zM144 192v176h320V192zm-96-8v280h368v48H0V160h48z" })
  }
), Kt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 32H48v128H0v320h384V160H96V80h224V32h-24zM48 208h288v224H48zm480 251.7 48 20.3V160l-48 20.3-112 47.4v52.1l112-47.4v175.2l-112-47.4v52.1zM80 240v48h224v-48H104z" })
  }
), Qt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 224 24-42.1L128 0l394.1 154.8L576 176l-47.7 32.8-34 23.4L381 310.1 320 352l-90.1-36-47.5 124.5-5.9 15.5H48v56H0V352h48v56h95.5l41.9-109.9L45 242zm314 73.9 160.3-110.3L149.1 59.9 69 199.9l244.9 98zM520 400l-132.3-55.7 142.6-98.1L576 264z" })
  }
), Zt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 120a72 72 0 1 0-144 0 72 72 0 1 0 144 0m120 120H152c-66.3 0-120-53.7-120-120S85.7 0 152 0c39.3 0 74.1 18.8 96 48 21.9-29.1 56.7-48 96-48 66.3 0 120 53.7 120 120s-53.7 120-120 120m-72-120a72 72 0 1 0 144 0 72 72 0 1 0-144 0M168 320h-56v144h256V320zm0-48h248v240H64V320H0v-48h144zm280 195.7v-50.8l80 27.7V323.4l-80 27.7v-50.8l80-27.7 48-16.6v256l-48-16.6z" })
  }
), Jt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 270.5V80H112v190.5l-8.1 12.1L68.4 336h439.2L472 282.6zM528 384H48v48h480zm48-32v128H0V352l64-96V32h448v224zM432 112v48h-48v-48zm-144 16a80 80 0 1 1 0 160 80 80 0 1 1 0-160m32 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), jt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 112H48v80h108.1c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48H464V80H267.3l-53.9 26.9c-6.7 3.3-14 5.1-21.5 5.1zM48 240v192h416V240h-84c2.6 10.2 4 21 4 32 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32zM192 64l64-32h256v448H0V64h64V32h96v32zm144 208a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), Yt = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M437.3 96 416 32H224l-21.3 64H64v384h512V96h-48zm90.7 48v288H112V144H237.3l10.9-32.8L258.6 80h122.8l10.4 31.2 10.9 32.8h34.6zM208 384l16 16 23.9-23.9c20.7 15.4 46 23.9 72.1 23.9 32 0 62.6-12.7 85.3-35.3L425 345l-34-34-19.7 19.7C357.7 344.4 339.2 352 320 352c-13.3 0-26.3-3.7-37.5-10.5L304 320l-16-16h-80zm224-112v-80l-16-16-23.9 23.9c-20.7-15.4-46-23.9-72.1-23.9-32 0-62.6 12.7-85.3 35.3L215 231l34 34 19.7-19.7c13.6-13.7 32.1-21.3 51.3-21.3 13.3 0 26.3 3.7 37.5 10.5L336 256l16 16z" })
  }
), _t = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v320H48V48zm-53.3 368H448V0H0v416h101.3l-26.6 48L48 512H400l-26.7-48-26.7-48zm-54.9 0 26.7 48H129.6l26.7-48zM336 208a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-112-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), hw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-44.9-34.9V96H437.3L416 32H224l-21.3 64H153L48.4 14.8zM214.8 144h22.5l10.9-32.8L258.6 80h122.8l10.4 31.2 10.9 32.8H528v243.2l-98.3-76.3c1.5-7.4 2.3-15 2.3-22.8 0-61.9-50.1-112-112-112-17.7 0-34.4 4.1-49.3 11.4zm167.7 130.2L317.9 224h2.1c30.6 0 56.2 21.5 62.5 50.2M370.6 388l-45.9-36.1c-1.6.1-3.1.2-4.7.2-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8 0 61.9 50.1 112 112 112 18.2 0 35.4-4.3 50.6-12M112 432V184.2l-48-37.8V480h423.4l-60.9-48z" })
  }
), cw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v160h48V48h112V0H24zm200 96h-15.8l-6.2 14.5-7.5 17.5H96v256h320V128h-74.5l-7.5-17.5-6.2-14.5H312zm8.3 65.5 7.5-17.5h80.3l7.5 17.5 6.2 14.5H368v160H144V176H202.1zM256 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112M488 0H352v48h112v112h48V0zM0 512h160v-48H48V352H0v136zm488 0h24V352h-48v112H352v48h24z" })
  }
), sw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M359.6 379.3c-12.7 3.1-25.9 4.7-39.6 4.7-92.8 0-168-75.2-168-168v-.2l-45.1-35.5c-1.9 11.6-2.9 23.5-2.9 35.7 0 75.6 38.8 142.1 97.7 180.7L149.3 464 112 512h416l-60.9-48h-257l35.2-45.3c23.3 8.6 48.4 13.3 74.7 13.3 28.9 0 56.5-5.7 81.7-16h4.4l-46.6-36.7zm88.3-54.3-38-29.5c18.7-21.2 30.1-49 30.1-79.5 0-66.3-53.7-120-120-120-41.3 0-77.7 20.8-99.3 52.6l-38-29.5C213.2 76.1 263.3 48 320 48c92.8 0 168 75.2 168 168 0 41.6-15.1 79.6-40.1 109m37.9 29.5C517.2 316.9 536 268.7 536 216 536 96.7 439.3 0 320 0c-72.1 0-136 35.3-175.2 89.6L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-135.1-104.9zm-114-88.5-113-87.9c12.7-20.5 35.3-34.1 61.2-34.1 39.8 0 72 32.2 72 72 0 19.4-7.7 37-20.1 49.9z" })
  }
), vw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a168 168 0 1 1 0 336 168 168 0 1 1 0-336m118.3 348.7C401.2 358.1 440 291.6 440 216 440 96.7 343.3 0 224 0S8 96.7 8 216c0 75.6 38.8 142.1 97.7 180.7L53.3 464 16 512h416l-37.3-48-52.3-67.3zm-193 22c23.3 8.6 48.4 13.3 74.7 13.3s51.4-4.7 74.7-13.3l35.2 45.3H114.1zM224 144a72 72 0 1 1 0 144 72 72 0 1 1 0-144m0 192a120 120 0 1 0 0-240 120 120 0 1 0 0 240" })
  }
), ew = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m352 32 21.3 64H512v384H0V96h138.7L160 32zm21.3 112h-34.6l-10.9-32.8L317.4 80H194.6l-10.4 31.2-10.9 32.8H48v288h416V144zM256 176a112 112 0 1 1 0 224 112 112 0 1 1 0-224m64 112a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), lw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M285.7 58.3C256.6 24.2 227.2.1 227.2.1S112 94.3 112 174.6s64.5 145.5 144 145.5S400 255 400 174.6c0-66.9-86.4-145.5-86.4-145.5s-12.5 11.3-27.9 29.1zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6-40.5 0-72.9-26.4-72.9-70.9 0-21.8 13.5-40.9 40.5-74.5 3.6 4.5 55.8 71.8 55.8 71.8l32.4-38.2c2.7 3.6 4.5 7.3 6.3 10.9 16.2 30 9 68.2-18 87.3M40.1 297.4l-22.6-8.1-16.2 45.2 22.6 8.1L184.6 400 23.9 457.4l-22.6 8.1 16.1 45.2 22.6-8.1 216-77.1 215.9 77.1 22.6 8.1 16.1-45.2-22.6-8.1L327.4 400l160.7-57.4 22.6-8.1-16.1-45.2-22.6 8.1-216 77.1-215.9-77.1z" })
  }
), tw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.8 30.5 370.4 49l-51.1 61.2L562.4 401l5.6 6.7V512H430.1l-2.2 1.7-1.3-1.7H149.4l-1.3 1.7-2.2-1.7H8V407.7l5.6-6.7 243.1-290.9L205.6 49l-15.4-18.5L227-.2l15.4 18.4L288 72.7l45.6-54.5L349-.2l36.8 30.8zM187 464h202L288 334.9zm263 0h70v-38.9L288 147.5 56 425.1V464h70l143.1-182.8 18.9-24.1 18.9 24.2z" })
  }
), ww = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2V289.4c13.8 6 30 11 48 14.7V368h160v-63.9c18-3.8 34.2-8.8 48-14.7zm48 5.7V72c0-39.8-78.8-72-176-72S16 32.2 16 72v368c0 39.8 78.8 72 176 72s176-32.2 176-72M304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24 112 10.7 112 24m-80 248h-64v-64h64z" })
  }
), gw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 144c17.7 0 32-14.3 32-32v-.1c-.1-.6-.9-4.9-5.9-13.4-5.2-8.9-12.9-18.6-21.6-28.3-1.5-1.6-3-3.3-4.5-4.8l-4.5 4.8c-8.8 9.7-16.4 19.4-21.6 28.3-5 8.5-5.7 12.7-5.9 13.4v.1c0 17.7 14.3 32 32 32m0-144s80 64 80 112c0 44.2-35.8 80-80 80s-80-35.8-80-80C80 64 160 0 160 0M0 464h48V224h224v240h36.1c-2.7-7.5-4.1-15.6-4.1-24 0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72H0zm224-192h-48v80h-48v-80H96v192h128zm152 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), iw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 320v-96h128v96zm0 128v-96h128v96zm288 0H160v-96h128v-32H160v-96h128v-32H160V64h480v384H336zm48-336v288h256V112zM33.1 192C47.3 177.6 56 157.8 56 136c0-6.2-.7-12.2-2-18 5.8 1.3 11.8 2 18 2 21.8 0 41.6-8.7 56-22.9V192H33.1z" })
  }
), mw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m343 82.3-10.2-30.4c9.1-2.6 18.6-3.9 28.1-3.9 22.7 0 43.6 7.3 60.7 19.7l-23 23C387.7 83.9 374.8 80 361 80c-6.1 0-12.1.8-18 2.3m78.3 31.1 23-23c12.4 17 19.7 38 19.7 60.7v5.6c0 7-.7 13.8-1.9 20.5L431.4 167c.5-3.4.7-6.8.7-10.3V151c0-13.8-3.9-26.7-10.8-37.6m30.2 93.9c-8.8 16.7-22 31.1-38.5 41.4l-38 23.8-30.2-18.9 51.2-32c10.1-6.3 18.4-14.8 24.5-24.6l30.9 10.3zm-106.6 84-77 48.1-30.2-18.9 77-48.1zm-107.2 67-73 45.6-30.2-18.9 73-45.6zm-103.3 64.6-36.8 23-17-27.1 23.6-14.8zM303.6 65.4 314 96.6l-30.5 19.1-17-27.1 37-23.1zm5.4 91 39.8-24.9c3.7-2.3 7.9-3.5 12.2-3.5 12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L55.2 378l-40.7 25.5L40 444.2l17 27.1L82.4 512l40.7-25.4 315.3-197.1c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23l-39.8 24.8-40.7 25.5 25.5 40.7 17 27.1 25.4 40.7z" })
  }
), aw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32v96l128 288h64l128-288V32S608 0 480 0 320 32 320 32m272 29.3V109c-25.4-4.7-75.8-13-112-13s-86.6 8.3-112 12.9V61.3c18.2-6 52.8-13.3 112-13.3s93.8 7.3 112 13.3M479.2 368l-37.6-84.5c12.2-1.8 26.6-3.5 38.4-3.5s26.2 1.7 38.4 3.5L480.8 368zM0 330.9l67.9 67.9L362 511.9l45.3-45.3-113.1-294.1-67.9-67.9s-45.3 0-135.8 90.5S0 330.9 0 330.9m213-171.6 33.7 33.7c-21.2 14.7-62.7 44.4-88.3 70.1s-55.4 67.1-70.1 88.3l-33.7-33.7c8.7-17.1 27.9-46.7 69.8-88.6s71.5-61.1 88.6-69.8m137.2 296.6-86.3-33.2c7.3-9.9 16.3-21.3 24.7-29.6s19.7-17.3 29.6-24.7l33.2 86.3-1.1 1.1z" })
  }
), ow = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M309 399.6 198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6M233.3 141 360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4m97.7-28.6 110.5 220.9C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6m173.6 196.5C481.7 389.2 407.7 448 320 448s-161.7-58.8-184.6-139.1L35.2 365.2 7 327l35.6-35.6L0 279v-46l42.6-12.5L7 185l28.2-38.2 100.1 56.3C158.3 122.8 232.3 64 320 64s161.7 58.8 184.6 139.1l100.1-56.3L633 185l-35.6 35.6L640 233v46l-42.6 12.5L633 327l-28.2 38.2z" })
  }
), nw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 320v192h-48V320zm-56.3-23.8-15.4 11.5-66-66c-6.1-6.1-17-13.2-33.2-20.3-14.8-6.5-31.7-12-48.3-16.5 9.3 29.7 23.7 60.1 44.9 81.4l41.1 41.1-48.4 32.3-14 9.3c18.3 8.9 38.8 15.3 59.6 15.3h47.7v29.2c8.1-3.9 16.5-8.2 24.8-13l34.7 34.7C204.3 465.1 152 480 152 480s-3.3-6.6-5.7-19.8c-1.3-7.2-2.3-16.4-2.3-27.6v-.6c-41.1 0-77.9-16.9-104.1-33.3C15.1 383.1 0 368 0 368l31.7-21.1 9.2-6.2L72 320c-11.4-11.4-21-24.3-29.1-37.9-17.9-29.7-28.5-62.5-34.6-88.6C1.5 164.7 0 144 0 144s20.9 2.6 49 8.9c24.4 5.5 54.3 13.7 80.5 25.4 18.2 8.1 34.7 17.9 46.4 29.7 0-19.9 1.9-38.7 5.2-56.2 9.1-48.6 28.5-87.2 45.3-113.4C242.4 13.6 256 0 256 0s13.6 13.6 29.5 38.4c16.8 26.2 36.2 64.8 45.3 113.4 3.3 17.5 5.2 36.2 5.2 56.2 11.7-11.7 28.2-21.5 46.4-29.7 26.2-11.7 56.1-20 80.5-25.4 28.1-6.3 49-8.9 49-8.9s-1.5 20.7-8.3 49.5c-6.2 26.1-16.7 58.9-34.6 88.6-8 13.6-17.6 26.5-29 37.9l31 20.7 9.2 6.2L512 368s-15.1 15.1-39.9 30.7c-26.2 16.4-63 33.3-104.1 33.3v.6c0 11.2-1 20.4-2.3 27.6-2.4 13.2-5.7 19.8-5.7 19.8s-52.3-14.9-99.2-44.8l34.7-34.7c8.3 4.8 16.7 9.2 24.8 13v-29.2H368c20.8 0 41.3-6.4 59.6-15.3l-14-9.3-48.4-32.3 41.1-41.1c21.2-21.2 35.7-51.7 44.9-81.4-16.6 4.5-33.4 10-48.3 16.5-16.2 7.1-27.2 14.3-33.2 20.3l-66 66-15.4-11.5V208c0-52.1-15.8-95.1-32.3-125.8-16.6 30.7-32.3 73.6-32.3 125.8v88.2z" })
  }
), rw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64v112H48zm-48 0v224c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8l128.5 187.3c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3c-35.5-51.8-105.4-64.3-156-28.1-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144m283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93 28.5-20.4 68-13.7 88.5 16.2l66.9 97.5-106.1 74.2-65.1-94.9z" })
  }
), dw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 64h128v32h96V64h128v32h80v352H0V96h80zm-32 80v256h416V144zm336 32v48h48v32h-48v48h-32v-48h-48v-32h48v-48zM96 224h112v32H80v-32z" })
  }
), Sw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 32h-17l-5.7 16.1L52.6 176H0v304h48v-80h416v80h48V176h-52.6L414.7 48.1 409 32h-17zm288.6 144H384v48h80v128H48V224h80v-48h-24.6L137 80h238zM112 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64m320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-272-64h88l-24 96 128-128h-88l24-96z" })
  }
), zw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h256v80h48V0H0v480h192v-48H48zm208 144h-64v47.7l56.7.4h1.8l5.5-15.9zm-96-96H96v64h64zm32 0v64h64V96zm-32 96H96v64h64zm0 96H96v64h64zm151.1-128-5.7 15.9-34.3 96.1H224v240h48v-64h320v64h48V272h-47.1l-34.3-96.1-5.7-15.9H328zm265.5 160H592v80H272v-80h304.5zm-57.5-112 22.9 64H322.1l22.9-64zM336 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48m216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), pw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M69.5 79.4 85.9 75 338.7 7.3l16-4.3 9.7 13.4 73.1 100.8 2.5-.7 46.4-12.4 12.4 46.4 31 115.5 12.4 46.4 19.9 74.4-44.6 12-19.9-74.4-1.7.5-383.3 102.5-1.7.5 19.9 74.4-44.6 12-20-74.5-6.2-23.3-6.2-23.1L22.9 278l-12.5-46.4 46.4-12.4 1.7-.5 9.7-122.4zm265.7-21.5L114.7 117l-7 88.6 280.1-75.1-52.6-72.6zm-266 207.7 30.9 115.5 383.3-102.7-31-115.5L69.2 265.6m43.5 50.2a30.8 30.8 0 1 1 59.5-15.9 30.8 30.8 0 1 1-59.5 15.9m289.5-109.4a30.8 30.8 0 1 1 15.9 59.5 30.8 30.8 0 1 1-15.9-59.5zM510.9 416c56.4 0 103.1 41.7 110.9 96H400c7.8-54.3 54.4-96 110.9-96" })
  }
), Mw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M204.5 44.7 176 0l-28.5 44.7-19.8 31.1-36.6-3.9-52.7-5.6 17.2 50.1 12 34.9-26 26.2-37.2 37.7L54.3 233 89 245.4l4.4 36.6 6.2 52.6 35.7-22.1 18.1-67.7-2.7 1.7-12.3 7.6-1.7-14.4-3.5-29.5-28-10-13.6-4.9 10.1-10.3 20.9-21.2-9.6-28.1-4.7-13.7 14.4 1.5 29.6 3.2 16-25.1 7.7-12.2 7.8 12.2 5.6 8.9.1-.2 30.9 8.3 15.9 4.3 2.6-.3 35.5-52.1-13.5 1.4-36.7 3.9zm380.8 73.6-16.4-4.4L344 53.6l-16.4-4.4-9.6 14.1-66 96.8-39.9-10.7-12.4 46.4-24.7 92.4-12.4 46.4-17.7 66.1 39.7 10.6 17.7-66.1 6.7 1.8 330.3 88.5 6.7 1.8-17.7 66.1 39.6 10.6 23.3-86.8 6.9-25.7 24.7-92.4 12.4-46.4-39.9-10.7-8.8-116.8-1.3-17zm-237.2-13.9L540 155.8l6.2 83.1-245-65.7 46.9-68.8zm228.3 192.3-24.7 92.4-330.4-88.5 24.7-92.4 330.3 88.5zm-85 26.7a27.4 27.4 0 1 0 52.9 14.2 27.4 27.4 0 1 0-52.9-14.2m-218.6-30.2a27.4 27.4 0 1 0 14.2-52.9 27.4 27.4 0 1 0-14.2 52.9" })
  }
), xw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 128v80h120v-80zm0 128v120h144v48H80v56H32v-56H0V82.3l2.5-5.1C11 60.4 31 41.2 61.3 26.4 92.2 11.3 135.2 0 192 0c120.9 0 173.4 45.2 189.5 77.3l2.5 5.1V128H216v80h45.6l-11.1 32.1h-1.8l-56.7-.4V256zM321.4 80C301.9 65.2 263.6 48 192 48c-50.4 0-86.1 10-109.7 21.6-7.1 3.5-13 7-17.9 10.4H192zM104 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48m207.1-128h241.8l5.7 15.9 34.3 96.1H640v240h-48v-64H272v64h-48V272h47.1l34.3-96.1zm265.5 160H272v80h320v-80zm-57.5-112H344.9L322 272h219.9L519 208zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48m168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Hw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 32h-17l-5.7 16.1L52.6 176H0v304h48v-80h274.9c-1.9-10.4-2.9-21.1-2.9-32 0-5.4.2-10.7.7-16H48V224h346.8c28.6-20.2 63.5-32 101.2-32 5.4 0 10.7.2 16 .7V176h-52.6L414.7 48.1 409 32h-17zm288.6 144H103.4L137 80h238zM112 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64m384 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288m32-224-16 64h64l-112 96 16-64h-64z" })
  }
), Vw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m331 10.7 280 144 21.3 11-22 42.7-21.3-11L320 59 51 197.3l-21.3 11-22-42.7 21.3-11 280-144L320 5l11 5.6zM199.1 160h241.8l5.7 15.9 34.3 96.1H528v240h-48v-64H160v64h-48V272h47.1l34.3-96.1 5.7-15.9zm208 48H232.9L210 272h219.9L407 208zM480 320H160v80h320zm-272 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48m200 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Cw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 32h-17.3l-5.5 16.4L86.7 176H0v48h32v256h48v-80h416v80h48V224h32v-48h-86.7L446.8 48.4 441.3 32H424zm328 192h16v128H80V224h16zm-41.3-48H137.3l32-96h237.4zM176 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Lw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24v104h-48V0h48zM135.1 160h241.8l5.7 15.9 34.3 96.1H464v240h-48v-64H96v64H48V272h47.1l34.3-96.1 5.7-15.9zm208 48H168.9L146 272h219.9L343 208zM416 320H96v80h320zm-272 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48m200 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M56 22.1 73 39l48 48 17 17-34 33.9L87 121 39 73 22 56zM439 39l17-17 33.9 34L473 73l-48 48-17 17-33.9-34 17-17 48-48z" })
  }
), Bw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M102.7 32h306.6l5.5 16.4L457.3 176H512v224h-32v80h-48v-80H80v80H32v-80H0V176h54.7L97.2 48.4zm272 48H137.3l-32 96h301.4zM48 224v32h80v48H48v48h144v-64h128v64h144v-48h-80v-48h80v-32z" })
  }
), uw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h-16.2l-6 15.1-58 144.9H0v208h65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H640V192H523.5L402.7 41l-7.2-9H384zm306.7 336a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64h-139c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H48V240h80v-48H99.4l44.8-112h228.3l89.6 112H432v48h160v112zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96m32-112h88l-24 96 128-128h-88l24-96z" })
  }
), Rw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M111.8 32h283.7l7.2 9 120.8 151H640v208h-65.3c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H0V192h47.8l58-144.9 6-15.1zm277.7 320c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592V240H48v112h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zm45.3 48a48 48 0 1 0 90.5-32 48 48 0 1 0-90.5 32zM208 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0M99.4 192H224V80h-79.8zm172.6 0h190.1L372.5 80H272v96z" })
  }
), $w = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M69.5 79.4 85.9 75 338.7 7.3l16-4.3 9.7 13.4 73.1 100.8 2.5-.7 46.4-12.4 12.4 46.4 31 115.5 12.4 46.4 19.9 74.4-44.6 12-19.9-74.4-1.7.5-383.3 102.5-1.7.5 9.7 36.1H640v48H94.4l-8.2 2.2-.6-2.2H0v-48h72.7l-6.5-24.2-6.2-23.3-6.2-23.1L22.9 278l-12.5-46.4 46.4-12.4 1.7-.5 9.7-122.4zm265.7-21.5L114.7 117l-7 88.6 280.1-75.1-52.6-72.6zm-266 207.7 30.9 115.5 383.3-102.7-31-115.5L69.2 265.6m43.5 50.2a30.8 30.8 0 1 1 59.5-15.9 30.8 30.8 0 1 1-59.5 15.9m289.5-109.4a30.8 30.8 0 1 1 15.9 59.5 30.8 30.8 0 1 1-15.9-59.5z" })
  }
), kw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256v256H0V256C0 114.6 114.6 0 256 0s256 114.6 256 256v256h-48V256c0-114.9-93.1-208-208-208m-80.9 176H354.3l5.4 16.6 25.7 79.4H416v192h-48v-32H144v32H96V320h30.5l25.7-79.4 5.4-16.6zM368 432v-64H144v64zm-33-112-15.6-48H192.6L177 320zm-175 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0m168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Pw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 128c-26.5 0-48-21.5-48-48 0-32 48-80 48-80s48 48 48 80-21.5 48-48 48m-120.9 32h241.8l5.7 15.9 34.3 96.1H432v240h-48v-64H64v64H16V272h47.1l34.3-96.1 5.7-15.9zm265.5 160H64v80h320v-80zm-57.5-112H136.9L114 272h219.9L311 208zM112 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48m200 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M112 80c0 32-21.5 48-48 48s-48-21.5-48-48C16 48 64 0 64 0s48 48 48 80m272 48c-26.5 0-48-21.5-48-48 0-32 48-80 48-80s48 48 48 80-21.5 48-48 48" })
  }
), Fw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 0c32.8 0 61 19.7 73.3 48h205.4C371 19.7 399.2 0 432 0c12.5 0 24.4 2.9 34.9 8 19.6 9.5 34.8 26.9 41.4 48H432v48h76.3c-6.6 21.1-21.8 38.5-41.4 48-10.6 5.1-22.4 8-34.9 8-32.8 0-61-19.7-73.3-48H153.3c-12.3 28.3-40.5 48-73.3 48-12.5 0-24.4-2.9-34.9-8-19.6-9.5-34.8-26.9-41.4-48H80V56H3.7c6.6-21.1 21.7-38.5 41.4-48C55.6 2.9 67.5 0 80 0m55.1 160h241.8l5.7 15.9 34.3 96.1H464v240h-48v-64H96v64H48V272h47.1l34.3-96.1 5.7-15.9zm265.5 160H96v80h320v-80zm-57.5-112H168.9L146 272h219.9L343 208zM160 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48m168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Tw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 32h-17.3l-5.5 16.4L54.7 176H0v304h48v-80h416v80h48V176h-54.7L414.8 48.4 409.3 32H392zm286.7 144H105.3l32-96h237.4zm57.3 48v128H48V224zm-320 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Aw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v288h60.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H528V192c0-61.9-50.1-112-112-112zm48 336H0V32h416c88.4 0 160 71.6 160 160v176h64v48H288c0 53-43 96-96 96s-96-43-96-96m0-288h192v128H96zm352 0v128H320V128zM240 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Dw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 80c61.9 0 112 50.1 112 112v176h-48V128H320v240h-44.8c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48V80zM48 416h48c0 53 43 96 96 96s96-43 96-96h352v-48h-64V192c0-88.4-71.6-160-160-160H0v384zm384-192h-40v48h40v96h-64V176h64zm-144-96H96v128h192zm-96 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), yw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm256 192c0 5.6-.7 11.1-2.1 16.3 28.2 2.9 50.1 26.8 50.1 55.7 0 30.9-25.1 56-56 56-15.7 0-29.8-6.4-40-16.8V336h32v32h-96v-32h32v-32.8c-10.2 10.4-24.3 16.8-40 16.8-30.9 0-56-25.1-56-56 0-28.9 21.9-52.7 50.1-55.7-1.4-5.2-2.1-10.7-2.1-16.3 0-35.3 28.7-64 64-64s64 28.7 64 64" })
  }
), bw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm80 256 112-112 112 112-112 112z" })
  }
), fw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm80 219.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L203 341.5l-11 10.6-11.1-10.7-82.7-79.6A58.999 58.999 0 0 1 80 219.2" })
  }
), Uw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm192 120.8 39.6 39.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-8.4-8.4V336h32v32h-96v-32h32v-40.8l-8.4 8.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64z" })
  }
), Gw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m399.4 347.8-170.9 98.6L65.6 164.2l170.8-98.6 163 282.2zM210.9 512l41.6-24 170.9-98.7 41.6-24-24-41.6L278 41.6 254 0l-41.6 24L0 146.7l186.9 323.7zM320 486v26h320V64H327.9l164.8 285.4 16 27.7-27.7 16z" })
  }
), qw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m228.5 446.4 170.9-98.6-163-282.2-170.8 98.6zm24 41.6-41.6 24-24-41.6L0 146.7 212.4 24 254 0l24 41.6 162.9 282.2 24 41.6-41.6 24zm67.5-2 160.9-92.9 27.7-16-16-27.7L327.9 64H640v448H320zm153.9-298.4 54.1 55.8 54-55.8c14-14.5 13.2-38.5-2.2-51.9-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2-15.7 13.5-16.5 37.5-2.5 51.9zm-314.4 92.1 27.2-101.6 101.6 27.2c21.4 5.7 34.2 27.8 28.4 49.2S289 288.8 267.5 283l-8.2-2.2 14.7 25.4 19.9-11.5 11.5 19.9-59.7 34.5-11.5-19.9 19.9-11.5-14.7-25.4-2.2 8.2c-5.7 21.5-27.8 34.2-49.2 28.5s-34.2-27.8-28.4-49.2z" })
  }
), Ww = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 192h48v48L160 384 0 240v-48h48zM71.8 240l88.2 79.4 88.2-79.4H71.8" })
  }
), Ew = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 144V96h-48L0 256l144 160h48v-48zm-48 200.2L64.6 256l79.4-88.2v176.5z" })
  }
), Ow = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 144V96h48l144 160-144 160H64v-48zm48 200.2 79.4-88.2-79.4-88.2v176.5z" })
  }
), Iw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 320H0v-48l160-144 160 144v48h-48zm200.2-48L160 192.6 71.8 272z" })
  }
), Nw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80c0 40 7.3 55.3 32 80s40 32 80 32 80-40 80-40-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80s-40 40-40 80M28.1 447.5 0 512l64.5-28.1 157.1-68.3 2.3 2.3 5.9-5.9 62.6-27.2c45.9-19.9 75.5-65.2 75.5-115.2.1-69.4-56.1-125.6-125.5-125.6-50 0-95.3 29.7-115.2 75.5l-99.1 228zm204.4-88.9L209 335l-17-17-33.9 34 17 17 10.2 10.2-92.7 40.2 78.6-180.7c.2-.4.3-.7.5-1.1L207 273l17 17 33.9-34-17-17-36.9-36.9c11.5-6.5 24.6-10.1 38.3-10.1 42.9 0 77.6 34.8 77.6 77.6 0 30.9-18.3 58.9-46.7 71.2l-40.8 17.7z" })
  }
), Xw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M87.1 0h241.8l5.7 15.9 40 112v.1h-51l-28.5-80H120.9l-28.6 80h231.4-34.5l-7.4 21.6-9.2 26.4H48v80h144v48H48v64H0V128h41.4v-.1l40-112zM112 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48m193.4-16.1 5.7-15.9h241.8l5.7 15.9 34.3 96.1H640v240h-48v-64H272v64h-48V272h47.1l34.3-96.1zM576.6 320H272v80h320v-80zM344.9 208 322 272h219.9L519 208zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48m168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Kw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h115.9l3.7 19.5 42 220.5h300.6l63-208h50.2L503 271l-5.2 17H170.7l9.1 48H512v48H140.1l-3.7-19.5L76.1 48H0zm128 464a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M344 24v86.1l23-23 17-17 33.9 33.9-17 17-64 64-17 17-17-17-64-64-17-17L256 70.1l17 17 23 23V0h48z" })
  }
), Qw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h115.9l3.7 19.5 42 220.5h300.6l63-208h50.2L503 271l-5.2 17H170.7l9.1 48H512v48H140.1l-3.7-19.5L76.1 48H0zm128 464a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M296 184V97.9l-23 23-17 17-33.9-33.9 17-17 64-64 17-17 17 17 64 64 17 17-34.1 33.9-17-17-23-23V208h-48z" })
  }
), Zw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m78.6-136-11.3 11.3-56 56-11.3 11.3-11.3-11.3-56-56-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7V288h32v105.4l28.7-28.7 11.3-11.3z" })
  }
), Jw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320-288a144 144 0 1 0 0 288 144 144 0 1 0 0-288m-78.6 136 11.3-11.3 56-56 11.3-11.3 11.3 11.3 56 56 11.3 11.3-22.6 22.6-11.3-11.3-28.7-28.7V448h-32V342.6l-28.7 28.7-11.3 11.3z" })
  }
), jw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m464-144a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), Yw = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-64h-32v-32h32zm0-176v112h-32V272z" })
  }
), _w = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m176-144a144 144 0 1 0 288 0 144 144 0 1 0-288 0m208 16h-48v64h-32v-64h-64v-32h64v-64h32v64h64v32z" })
  }
), hg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5h180.6c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h379.6l-35.4 113.2c6.8-.8 13.7-1.2 20.7-1.2 10 0 19.7.8 29.2 2.4L561 80l15-48H122l-2.4-12.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), cg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h80v416h80c0 26.5 21.5 48 48 48s48-21.5 48-48h192c0 26.5 21.5 48 48 48s48-21.5 48-48h96v-48H128V0h-24zm216 80h128v224H240zm-48-48v320h224V32H240zm304 48h64v64h-64zm-48-48v160h160V32H496zm144 240v32h-96v-32zm-96-48h-48v128h192V224h-48z" })
  }
), sg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h128v416h512v48h-96c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H80V48H0z" })
  }
), vg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h128v416h512v48h-96c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H80V48H0zm304 0h192v96h112v256H192V96h112V24zm48 96h96V48h-96zm-112 48v160h48V144zm96 0v160h128V144zm224 160V144h-48v160z" })
  }
), eg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h80v416h80c0 26.5 21.5 48 48 48s48-21.5 48-48h192c0 26.5 21.5 48 48 48s48-21.5 48-48h96v-48H128V0h-24zm536 80v224H240V80h96v112l64-48 64 48V80zm0-48H192v320h416V32z" })
  }
), lg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h115.9l3.7 19.5 42 220.5h300.6l63-208h50.2L503 271l-5.2 17H170.7l9.1 48H512v48H140.1l-3.7-19.5L76.1 48H0zm128 464a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M256 96h152v48H232V96z" })
  }
), tg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5H512v-48H179.9l-9.1-48h327l5.2-17 72.4-239h-50.2l-63 208H161.6l-42-220.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M232 88v48h64v64h48v-64h64V88h-64V24h-48v64h-40z" })
  }
), wg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h115.9l3.7 19.5L186 32h454l-15 48-65 208H234.7l9.1 48H576v48H204.1l-3.7-19.5L140.1 48H64zm131.1 80 30.5 160h299.1l50-160H195.1zM192 464a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M24 96h104v48H0V96zm0 80h120v48H0v-48zm0 80h136v48H0v-48z" })
  }
), gg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5H512v-48H179.9l-9.1-48H496l65-208 15-48H122l-2.4-12.5L115.9 0H96zm137.6 240L131.1 80h379.6l-50 160H161.6zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), ig = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h76.1l60.3 316.5 3.7 19.5H512v-48H179.9l-9.1-48h327l5.2-17 72.4-239h-50.2l-63 208H161.6l-42-220.5L115.9 0H96zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M274.7 48.8l-33.9 33.9 17 17 28.3 28.3-28.3 28.3-17 17 33.9 33.9 17-17 28.3-28.3 28.3 28.3 17 17 33.9-33.9-17-17-28.3-28.3 28.3-28.3 17-17-33.9-33.9-17 17L320 94.1l-28.3-28.3z" })
  }
), mg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0h288v128H208v32h272l32 224v128H0V384l32-224h112v-32H32zm48 48v32h192V48H96zm384 416v-32H48v32zm-25.6-256H73.6L48.5 384h415zM136 232v48H88v-48zm96 0v48h-48v-48zm-48 80v48h-48v-48zm96-80h48v48h-48zm0 128h-48v-48h48zm96-128h48v48h-48zm0 80v48h-48v-48z" })
  }
), ag = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V160h480v272zm0-400H0v448h576V32h-48zm320 224h80v80h-80zm-48-48v176h176V208H368zm-136 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112m0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208m0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), og = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352h-56l-33.8-81.2L432 336H144l-6.2 14.8L104 432H48V80zM420 432H156l20-48h224zM48 32H0v448h576V32h-48zm128 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 16c0-5.5-.7-10.9-2-16h100c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16H238c1.3-5.1 2-10.5 2-16m224 0c0-35.3-28.7-64-64-64H176c-35.3 0-64 28.7-64 64s28.7 64 64 64h224c35.3 0 64-28.7 64-64m-80 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), ng = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V160h480v272zm0-400H0v448h576V32h-48zm304 304H224v-80h128zm-208-40c0-19.4 13.7-35.5 32-39.2v78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2v-78.4c18.3 3.7 32 19.8 32 39.2m-336 0c0 48.6 39.4 88 88 88h208c48.6 0 88-39.4 88-88s-39.4-88-88-88H184c-48.6 0-88 39.4-88 88" })
  }
), rg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 24V0h-48v224H48v-64H0v352h640V160h-48v64h-80V0h-48v64h-64V0h-48v64h-64V0h-48v64h-64zm0 88h288v112H176zM48 272h544v192H384v-80c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H48z" })
  }
), dg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.4 44.6 296 64l-52.6 19.4L224 136l-19.4-52.6L152 64l52.6-19.4L224-8zM144 279c34.5-46.4 85.2-80.1 144.3-92.7-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176c0 68.4-39 127.7-96 156.8V512H416V403.8l-80 32.9V464h48v48H96V184c0-22.1-17.9-40-40-40H32V96h24c48.6 0 88 39.4 88 88zm0 144.9V464h144v-64c0-17.7-14.3-32-32-32h-32v-48h32c39.2 0 71.8 28.2 78.7 65.4l91.2-37.6c-60-13.3-108.5-57.1-128.3-114.4C209 252.6 144 331.2 144 423.9M464 368v96h32V349.1c-10.4 1.9-21.1 2.9-32 2.9zm0-64c70.7 0 128-57.3 128-128 0-32.5-12.1-62.1-32-84.7V176c0 53-43 96-96 96s-96-43-96-96V91.3c-19.9 22.6-32 52.2-32 84.7 0 70.7 57.3 128 128 128M397.8 66.4 432 112h64l34.2-45.6C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4M432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), Sg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 0h33.9l7 7 41 41H470l41-41 7-7h58v160c0 70.7-57.3 128-128 128s-128-57.3-128-128V0zm24 160c0 44.2 35.8 80 80 80s80-35.8 80-80V57.9L497 89l-7 7h-83.9l-7-7-31-31v102zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-179 38 4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9V464h144v-64c0-17.7-14.3-32-32-32h-32v-48h32c39.2 0 71.8 28.2 78.7 65.4l96.2-39.6 33.1-13.6V464h32V319.2c16.9-1.7 33.1-6 48-12.5V512H384V403.8l-80 32.9V464h48v48H64V184c0-22.1-17.9-40-40-40H0V96h24c48.6 0 88 39.4 88 88v95c40-53.7 101.7-90.5 173-97" })
  }
), zg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96M74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5h242.4c8.5 11.4 19 26.9 28.6 44.5 15.9 29.2 26.2 58.5 26.2 81.9 0 39.2-18.3 70-49.4 92.5-32.3 23.3-78 37.1-126.6 37.1s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5V512h48v-39c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v39h48v-82.1c20.1-26.1 32-58.1 32-95.5 0-43.6-22.5-91-44.6-126.4H448v-48H0v48z" })
  }
), pg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0v72.5c37.9 2.5 73 15.5 101.9 35.9l-27.7 39.2c-20.9-14.8-46.3-24.5-74.1-27v270.8c27.8-2.5 53.2-12.2 74.1-27l27.7 39.2C313 424 277.9 437 240 439.5V512h-48v-74.8C102 422 32 347.7 32 256S102 90 192 74.8V0zM80 256c0 63.2 47 117.9 112 132.3V123.7C127 138.1 80 192.8 80 256" })
  }
), Mg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0v72.5c37.9 2.5 73 15.5 101.9 35.9l-27.7 39.2c-24.5-17.3-55-27.6-88.2-27.6-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6l27.7 39.2C313 424 277.9 437 240 439.5V512h-48v-74.8C102 422 32 347.7 32 256S102 90 192 74.8V0z" })
  }
), xg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M226.5 32.7 256 57.2l29.5-24.6L324.6 0l17.6 47.9 13.2 36 37.8-6.6 50.2-8.7-8.7 50.2-6.6 37.8 36 13.2 47.9 17.6-32.7 39.1-24.5 29.5 24.6 29.5 32.6 39.1-47.9 17.6-36 13.2 6.6 37.8 8.7 50.2-50.2-8.7-37.8-6.6-13.2 36-17.6 47.9-39.1-32.7-29.5-24.5-29.5 24.6-39.1 32.6-17.6-47.9-13.2-36-37.8 6.6-50.2 8.7 8.7-50.2 6.6-37.8-36-13.2L0 324.6l32.7-39.1L57.2 256l-24.5-29.5L0 187.4l47.9-17.6 36-13.2-6.6-37.8-8.7-50.2 50.2 8.7 37.8 6.6 13.2-36L187.4 0zM209 80.5l-7.3 19.9-13.8 37.6-39.5-6.8-20.9-3.6 3.6 20.9 6.8 39.5-37.6 13.8-19.8 7.2 13.6 16.3 25.6 30.7-25.6 30.7L80.5 303l19.9 7.3 37.6 13.8-6.8 39.5-3.6 20.9 20.9-3.6 39.5-6.8 13.8 37.6 7.3 19.9 16.3-13.6 30.6-25.7 30.7 25.7 16.3 13.5 7.3-19.9 13.8-37.6 39.5 6.8 20.9 3.6-3.6-20.9-6.9-39.4 37.6-13.8 19.9-7.3-13.6-16.3-25.6-30.7 25.7-30.7 13.5-16.3-19.9-7.3-37.6-13.8 6.8-39.5 3.6-20.9-20.9 3.6-39.4 6.9-13.8-37.6-7.3-19.9-16.3 13.6-30.7 25.6-30.7-25.6z" })
  }
), Hg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48v176h48V0H96v224h48V48zM64 152v-24H16v96h48v-24zm368 0v-24h-48v96h48v-24zM248 400h168v-32l-6.9-16-41.1-96H80l-41.1 96-6.9 16v32h168v64h-72v48h192v-48h-72zm-136.3-96h224.6l20.6 48H91.1l20.6-48" })
  }
), Vg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296 48v176h-48V48h-48v176h-48V48h-40v176H64V0h320v224h-48V48zM0 368l6.9-16L48 256h352l41.1 96 6.9 16v32h-32v112h-48V400H80v112H32V400H0zm79.7-64-20.6 48h329.8l-20.6-48H79.7z" })
  }
), Cg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 48H208v57.3c-14.8-6-31-9.3-48-9.3V0h480v416H324.6l-14.4-48H368v-96h176v96h48zm-96 320v-48h-80v48zM208 224a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0m.5 240h191l-19.2-64H83.7zM48 352h224l33.6 112 14.4 48H0l14.4-48z" })
  }
), Lg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H32v368h48V80h416v320h48V32h-24zm168 320v80H0v48h576v-48H416v-80H248zm144 48v32h-96v-32z" })
  }
), Bg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88.4 176h143.2l5.4 39.8c6.4 46.7-29.9 88.2-77 88.2s-83.3-41.5-77-88.2zm6.6-48 10.9-80h108.2l10.9 80zM64 0 35.5 209.3C26.3 276.6 72 337.4 136 349.7V464H48v48h224v-48h-88V349.7c64-12.3 109.7-73.1 100.5-140.4L256 0z" })
  }
), ug = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M129.5 194.9c-19.2 36.5-1.8 81.5 36.9 95.6s81-9.2 89.7-49.5l7.6-34.9-117.5-42.8-16.6 31.6zM274 158.8l14.6-67.4-87.8-32-32.1 61zM87 172.6 177.9 0 320 51.7 462.1 0 553 172.6c28.9 54.9 9.2 121.2-41.3 152.5l35.6 97.7 53.7-19.5 22.6-8.2 16.4 45.1-22.6 8.2-76.3 27.8-76.3 27.8-22.6 8.2-16.4-45.2 22.6-8.2 53.8-19.6-35.6-97.7c-58.8 8.4-116.5-29.7-129.7-90.3l-16.9-78-16.9 77.9c-13.2 60.7-70.9 98.8-129.7 90.3l-35.6 97.7 53.8 19.6 22.6 8.2-16.4 45.1-22.6-8.2-76.3-27.7-76.3-27.7L0 440.2 16.4 395l22.6 8.3 53.8 19.6 35.6-97.7C77.9 293.8 58.1 227.5 87 172.6M510.4 195l-16.6-31.6-117.6 42.7 7.6 34.9c8.7 40.3 51 63.6 89.7 49.5s56.1-59.1 36.9-95.6zM366 158.8l105.3-38.3-32.1-61-87.8 32z" })
  }
), Rg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48v416h192V48zM32 464V0h288v256h8c48.6 0 88 39.4 88 88v28c0 15.5 12.5 28 28 28s28-12.5 28-28V268.3c-32.5-10.2-56-40.5-56-76.3v-64h32V64h32v64h32V64h32v64h32v64c0 35.8-23.5 66.1-56 76.3V372c0 42-34 76-76 76s-76-34-76-76v-28c0-22.1-17.9-40-40-40h-8v160h32v48H0v-48zm432-272c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h-64zM96 224l128-112-22.9 80H256L128 304l22.9-80z" })
  }
), $g = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm209.9 73.9L224 96l-33.9 33.9L96 224v160h384V240l-64.7-75.4L384 128l-30.1 30.1-4 4-30 30-33.9-33.9-28.1-28.1zm96 96 27.3-27.3 50.8 59.2V336H144v-92.1l80-80 62.1 62.1 33.9 33.9 33.9-33.9z" })
  }
), kg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v400h464v48H0V32zm80 80h256v48H128zm24 96h168v48H128v-48zm0 96h296v48H128v-48z" })
  }
), Pg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32v32h224v160H288v32h-48v-32H0V64h240V32zm-128 80v64h80v-64zm128 0v64h176v-64zm-176 0H48v64h64zm272 144v32h128v160H384v32h-48v-32H0V288h336v-32zm-160 80v64h112v-64zm160 0v64h80v-64zm-208 0H48v64h128z" })
  }
), Fg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm272-8V32h-32v64h-32v160h32v64h32v-64h32V96h-32zm64 144v128h32v64h32v-64h32V192h-32v-64h-32v64zm-160-64h-32V64h-32v64h-32v192h32v64h32v-64h32z" })
  }
), Tg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v400h464v48H0V32zm144 192v128h-48V224zm96-72v200h-48V128h48zm96 40v160h-48V192zm96-104v264h-48V64h48z" })
  }
), Ag = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v400h464v48H0V32zm80 80h160v48H128zm88 96h168v48H192v-48zm160 96h104v48H352v-48z" })
  }
), Dg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm296 264h136V160h-48v78.1L321 127l-17-17-17 17-79 79-63-63-17-17-33.9 34 17 17 80 80 17 17 17-17 79-79 94 94H320v48z" })
  }
), yg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm296 264h136V160h-48v78.1L321 127l-17-17-17 17-79 79-63-63-17-17-33.9 34 17 17 80 80 17 17 17-17 79-79 94 94H320v48z" })
  }
), bg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm296 72h-24v48h78.1L304 270.1l-79-79-17-17-17 17-80 80-17 17 34 33.8 17-17 63-63 79 79 17 17 17-17 111-111V288h48V128h-24z" })
  }
), fg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm425 113 17-17-34-33.9-17 17-119 119-79-79-17-17-17 17-96 96-17 17 34 33.8 17-17 79-79 79 79 17 17 17-17z" })
  }
), Ug = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 0h160v160h-48V81.9l-1 .8-160 128-15.1 12.1-15-12.2-113.6-92.3-137 101-19.4 14.3-28.5-38.7 19.3-14.2 152-112 15-11 14.4 11.7 113 91.8L461.6 48H384zM200 264h-16v176h16zm-16-40h56v256h-96V224zM72 360H56v80h16zm-16-40h56v160H16V320zm232 48a144 144 0 1 1 288 0 144 144 0 1 1-288 0m118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7m60.7 83.4 25.3 25.3 22.6-22.6-25.2-25.4c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6-25.4 25.3c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6 25.3 25.4c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6 25.4-25.3c21.6 13.2 49.1 13.2 70.7 0z" })
  }
), Gg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 0h160v160h-48V81.9l-1 .8-160 128-15.1 12.1-15-12.2-113.6-92.3-137 101-19.4 14.3-28.5-38.7 19.3-14.2 152-112 15-11 14.4 11.7 113 91.8L461.6 48H384zM200 264h-16v176h16zm-16-40h56v256h-96V224zM72 360H56v80h16zm-16-40h56v160H16V320zm232 48a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1-15.4-3.9c-5.6-1.4-11.6-2.7-17.9-3.7V272h-32v25.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8-9.6 30.8 15.3 4.8c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v27.4h32v-26.9c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z" })
  }
), qg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m495 82.7 18.7-15-30-37.5L465 45.3 320.1 161.2l-113-91.8-14.4-11.7-15 11-152 112-19.3 14.2 28.5 38.6 19.3-14.2 137-101 113.6 92.3 15 12.2 15.2-12.1 160-128zM200 264v176h-16V264zm-16-40h-40v256h96V224h-40zM72 360v80H56v-80zm-16-40H16v160h96V320H72zm256 8h16v112h-16zm-40-40v192h96V288h-56zm184-24v176h-16V264zm-16-40h-40v256h96V224h-40z" })
  }
), Wg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0H160v128h79.8l21.2 53.1c-34.9 21.3-60 57.1-67 98.9h-66v-40H0v128h128v-40h66c11.4 68.1 70.7 120 142 120 43.8 0 83-19.5 109.4-50.4l66.6 40V512h128V384H516l-45.8-27.5c6.4-16.3 9.9-34 9.9-52.5 0-23.2-5.5-45.2-15.3-64.6l64.5-47.4H640V64H512v81.2l-75.7 55.5C410.4 175.5 375 160 336 160c-10.5 0-20.6 1.1-30.5 3.2L288 119.4zm48 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), Eg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c-46.8 0-89.3 18.2-120.8 48H272V.6c5.3-.4 10.6-.6 16-.6 113 0 206.5 83.7 221.8 192.5-4.6-.4-9.2-.5-13.8-.5m-224 96h67.2c-7.6 14.9-13.2 31-16.3 48H176V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192 34.5 0 66.9-9.1 94.9-25 6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512 107.5 512 0 404.6 0 272 0 161.6 74.5 68.6 176 40.6c15.4-4.3 31.5-7 48-8.1V288zm80 80a144 144 0 1 1 288 0 144 144 0 1 1-288 0m118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7zm60.7 83.4 25.3 25.3 22.6-22.6-25.2-25.4c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6-25.4 25.3c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6 25.3 25.4c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6 25.4-25.3c21.6 13.2 49.1 13.2 70.7 0z" })
  }
), Og = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c-46.8 0-89.3 18.2-120.8 48H272V.6c5.3-.4 10.6-.6 16-.6 113 0 206.5 83.7 221.8 192.5-4.6-.4-9.2-.5-13.8-.5m-224 96h67.2c-7.6 14.9-13.2 31-16.3 48H176V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192 34.5 0 66.9-9.1 94.9-25 6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512 107.5 512 0 404.6 0 272 0 161.6 74.5 68.6 176 40.6c15.4-4.3 31.5-7 48-8.1V288zm80 80a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1-15.4-3.9c-5.6-1.4-11.6-2.7-17.9-3.7V272h-32v25.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8-9.6 30.8 15.3 4.8c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v27.4h32v-26.9c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z" })
  }
), Ig = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511.4 240c.4-5.3.6-10.6.6-16C512 100.3 411.7 0 288 0c-5.4 0-10.7.2-16 .6V240zM176 288v48h245.1c-26.4 74.6-97.5 128-181.1 128-106 0-192-86-192-192 0-83.6 53.4-154.7 128-181.1zm303.5 0H224V32.5c-16.5 1.1-32.6 3.8-48 8.1C74.5 68.6 0 161.6 0 272c0 132.6 107.5 240 240 240 110.4 0 203.4-74.5 231.4-176 4.3-15.4 7-31.5 8.1-48" })
  }
), Ng = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M541.7 192c.8 5.3 1.3 10.6 1.7 16 .4 5.3.6 10.6.6 16s-.2 10.7-.6 16H304V.6c5.3-.4 10.6-.6 16-.6s10.7.2 16 .6c5.4.4 10.7 1 16 1.7 98.1 14 175.7 91.6 189.7 189.7zM352 50.9V192h141.1C480 120.5 423.5 64 352 50.9m-144 257v-217C133.4 117.3 80 188.4 80 272c0 106 86 192 192 192 27.2 0 53-5.6 76.4-15.8L222.1 321.9zm182.8 114.9L425 457c-12.5 10.4-26.2 19.5-40.7 27.2C350.8 501.9 312.6 512 272 512 139.5 512 32 404.6 32 272c0-110.4 74.5-203.4 176-231.4 15.4-4.3 31.5-7 48-8.1V288zM320 288h255.5c-4.5 67.9-37.2 128.1-86.5 169z" })
  }
), Xg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M27.4 432 0 480h512l-27.4-48-201-351.6L256 32l-27.6 48.4L27.4 432zm273.9-224h-90.6l45.3-79.3zm27.4 48 36.6 64H146.7l36.6-64zm64 112 36.6 64H82.7l36.6-64h273.4z" })
  }
), Kg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.9 432h200.2l100.6-176L356.1 80H155.9L55.3 256zM0 256 128 32h256l128 224-128 224H128zm290.2-75.2 40.2 100.6C347.5 286 360 301.5 360 320c0 22.1-17.9 40-40 40-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2 0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2z" })
  }
), Qg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32H0v64h64zm216 24V32h-48v244.7L51.9 426.3l-18.5 15.4 30.7 36.9 18.5-15.3L256 319.2l173.5 144.1 18.5 15.3 30.7-36.9-18.5-15.3L280 276.7zM0 224v64h64v-64zm160-96H96v64h64zm192-96v64h64V32zm160 96h-64v64h64zm-160 96v64h64v-64zm-64 192h-64v64h64z" })
  }
), Zg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v400h464v48H0V32zm128 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96m200 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-48-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96m168 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), Jg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h512v-48H48zm176 72h-64v64h64zm-32 160h-64v64h64zm128-64h-64v64h64zm32 128h64v-64h-64zm96-256h-64v64h64z" })
  }
), jg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 240H48v32h352zm48 32v48H0V192h448v48zM208 400H48v32h160zm48 32v48H0V352h256v48zm80-320V80H48v32zm48 48H0V32h384v80z" })
  }
), Yg = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 80v352h-32V80zm-32-48h-48v448h128V32h-48zM80 272v160H48V272zm-32-48H0v256h128V224H80zm320-80h32v288h-32zm-48-48v384h128V96h-80z" })
  }
), _g = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 80v112H48V80zM48 32H0v208h224V32h-48zm128 288v112H48V320zM48 272H0v208h224V272h-48zM304 80h160v32H304zm-48-48v128h256V32H304zm208 208v32H304v-32zm-160-48h-48v128h256V192h-48zm0 208h160v32H304zm-48-48v128h256V352H304z" })
  }
), hi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48h384v320H310.2l14.4 48H640V0H160v96c17 0 33.2 3.3 48 9.3zm304 192 16-16V112H416l-16 16 39 39-55 55-47-47-17-17-33.9 34 17 17 64 64 17 17 17-17 72-72 39 39zm-352-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192m-76.3 80h152.6l19.2 64h-191zM272 352H48L14.4 464 0 512H320l-14.4-48z" })
  }
), ci = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v400h464v48H0V32zm144 192v128h-48V224zm96-72v104h-48V128h48zm96-88v128h-48V64zm96 24v264h-48V64h48z" })
  }
), si = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m337 81 17-17-34-33.9L303 47 160 190l-63-63-17-17-33.9 34 17 17 80 80 17 17 17-17zm94 130 17-17-33.9-34-17 16.9-236.5 235.4L50.8 303.1l-17-16.9-33.8 34 17 16.9 126.7 126.1 16.9 16.9 16.9-16.9z" })
  }
), vi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v280h288V80zM96 360V32h384v328h24v48H72v-48zm-32-72v48H48v96h480v-96h-16v-48h64v192H0V288h48zm321-108.4L278.3 286.3l-17 17-17-17L191 233l-17-17 34-33.9 17 17 36.4 36.4 89.6-89.8 17-17 33.9 33.9-17 17z" })
  }
), ei = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 130-17 17-253.5 252.2-16.9 16.9-16.9-16.9L17 273.1 0 256.2l33.9-34 17 16.9 109.7 109.2 236.5-235.4 17-16.9z" })
  }
), li = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V304h284.2c8.8 9.8 21.6 16 35.8 16s27-6.2 35.8-16H464v128zm320-208c-20.9 0-38.7 13.4-45.3 32H78.2l118.2-91.9C204 180.6 220.7 192 240 192c26.5 0 48-21.5 48-48 0-15.1-7-28.5-17.8-37.3l33.4-26C393.5 88.6 464 164.1 464 256h-50.7c-6.6-18.6-24.4-32-45.3-32M288 32 0 256v224h512V256c0-123.7-100.3-224-224-224M176 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), ti = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 304v128h416V304zm416-48c0-91.9-70.5-167.4-160.4-175.3L78.2 256zM0 256 288 32c123.7 0 224 100.3 224 224v224H0v-48z" })
  }
), wi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 40 12.5-20.5L269.1.3l-4.9 36.5v.1l-.1.8c-.1.7-.3 1.9-.6 3.5-.6 3.1-1.5 7.9-2.9 13.9-2.8 12.2-7.5 29.7-15.2 50.7-13.9 38.3-37.3 87.6-76 136.4-17.1-8.7-42.8-18.2-73.4-18.2 0 0-96 0-96 112 0 144 144 176 192 176s192-16 192-176c0-112-96-112-96-112-20.2 0-38.2 4.1-53.1 9.5 26.5-40.4 44.1-79.4 55.7-111.2 5.7-15.6 9.9-29.6 13.1-41.3 11.9 9.5 26.3 22.2 41 37.6 29.1 30.7 58.2 71.2 72.2 119.6-12-5.3-27-10.3-44.1-12.7 16.3 14.8 30.1 35.3 37.4 63 1.8 1 3.3 2 4.6 2.8 1.5 1 2.6 1.8 3.2 2.2l.4.3 29.6 23.7 29.7-23.7.4-.3c.6-.4 1.6-1.2 3.2-2.2 3.1-2 8-4.9 14.2-7.8 12.6-5.9 29.3-11.3 48-11.4h.7c1.1.1 3.1.3 5.7.8 5.3 1 11.9 3 18 6.6 9.1 5.3 24.2 17.4 24.2 56.5 0 62-26.1 90.5-53.8 106.3-31.5 18-69.7 21.7-90.2 21.7-12.3 0-36.6-3.4-61.7-13.4-9.2 14.8-20.2 27.5-32.3 38.2 36.3 17.5 73.6 23.2 93.9 23.2 48 0 192-16 192-176 0-112-96-112-96-112-32.3 0-59.3 10.6-76.3 19.6-14.3-67.2-52.9-120.9-88.3-158.2-20.1-21-39.6-37.4-54.1-48.5-7.3-5.6-13.3-9.8-17.6-12.7-2.2-1.5-3.9-2.6-5.1-3.4-.6-.4-1.1-.7-1.4-.9l-.4-.3-.1-.1L288.2 40zm-.6 232c.2 0 .4 0 .7.1 1.1.1 3.1.3 5.7.8 5.3 1 11.9 3 18 6.6 9.1 5.3 24.2 17.4 24.2 56.5 0 62-26.1 90.5-53.8 106.3-31.5 18-69.7 21.7-90.2 21.7-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5 6.1-3.6 12.7-5.6 18-6.6 2.6-.5 4.6-.7 5.7-.8.3 0 .6 0 .7-.1 18.7.1 35.4 5.5 48 11.4 6.2 2.9 11.1 5.8 14.2 7.8 1.5 1 2.6 1.8 3.2 2.2l.4.3 29.6 23.8 29.7-23.7.4-.3c.6-.4 1.6-1.2 3.2-2.2 3.1-2 8-4.9 14.2-7.8 12.6-5.9 29.3-11.3 48-11.4z" })
  }
), gi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32h128v48h-20.8c6.1 6.4 13.1 14.3 20 23.6C210.8 129.8 232 168.8 232 216c0 15.8-3.7 29-9.2 40h1.2v48h-18.3l4.8 48h-48.2l-4.8-48h-59l-4.8 48H45.5l4.8-48H32v-48h1.2c-5.5-11-9.2-24.2-9.2-40 0-47.2 21.2-86.2 40.8-112.4 7-9.3 13.9-17.2 20-23.6H64zm93.3 224 7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9 0-13.8-2.6-26.9-6.9-39.2L161 193l-17 17-33.9-34 17-17 26.1-26.1c-.1-.2-.2-.3-.4-.5-8.1-10.8-16.2-19.3-22.2-25.1-.9-.9-1.8-1.7-2.6-2.5-.8.8-1.7 1.6-2.6 2.5-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1h58.7zM71.5 432l-17.7 32h148.4l-17.8-32zm141.2-48 43.3 77.9V512H0v-50.1L43.3 384z" })
  }
), ii = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48h17.2c-7.6 7.8-15.6 16.6-23.7 26.2C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352h48v-41.7l-13-6.7c-18-9.3-35-24.7-35-52.7 0-55.5 29.8-106.8 62.4-145.9 16-19.2 32.1-34.8 44.2-45.5 1.9-1.7 3.7-3.2 5.3-4.6 1.7 1.4 3.4 3 5.3 4.6 12.1 10.7 28.2 26.3 44.2 45.5 5.3 6.3 10.5 13 15.5 20L159 191l-17 17 34 33.9 17-17 57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8 0 28-17 43.4-35 52.7l-13 6.7V352h48v-13.3c23.4-15.6 48-42.9 48-87.8 0-72.1-38.2-134.2-73.6-176.7-8-9.6-16-18.4-23.7-26.2H240V0H80zM69.2 432h181.6l16.6 32H52.7l16.6-32zM320 464v-2.7L280 384H40L0 461.3V512h320z" })
  }
), mi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 64v64h64V96h64v64h64V96h64v64h-64v64h64v64h-64v64h64v64h-64v-64h-64v64h-64v-64h-64v64H64v-64h64v-64H64v-64h64v-64H64V96zm64 128h64v-64h-64zm0 64v-64h-64v64zm64 0h-64v64h64zm0 0h64v-64h-64z" })
  }
), ai = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32h160v48h-56v32h152v368H0V112h96V80h160v32h184V80h-56zM48 160v272h544V160zm392 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208m16 48v-16h-32v80h32v-16zm-329.5-17.5a104 104 0 1 1 147 147 104 104 0 1 1-147-147m135.8 33.9-22.6-22.6-11.3 11.3-34.1 33.9-11.3 11.3 22.7 22.7 11.3-11.3 33.9-33.9 11.3-11.3z" })
  }
), oi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32H96v48h56v32H0v368h640V112h-96V80H384v32H200V80h56zm336 128v272H48V160zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208m-16-160v-16h32v80h-32v-16zm329.5 129.5a104 104 0 1 0-147-147 104 104 0 1 0 147 147m-11.3-113.1-11.3 11.3-33.9 34-11.3 11.3-22.7-22.7 11.3-11.3 33.9-33.9 11.3-11.3 22.6 22.6z" })
  }
), ni = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 16V0h-32v32H80v32h32v32H24v40l3.1 8 24.6 64H32v48h29.8l-13.1 96h48.5l13.1-96h35.5l13.1 96h48.4l-13.1-96H224v-48h-19.7l24.6-64 3.1-8V96h-88V64h32V32h-32zm8.9 192h-49.8l-24.6-64h99zM53.8 464l17.8-32h112.9l17.8 32H53.8zm202.2-2.1L212.7 384H43.3L0 461.9V512h256v-48z" })
  }
), ri = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 24V0h-48v56h-56v48h56v40H0v72l59.1 136h52.3L48 206v-14h352v14l-63.5 146h52.3L448 216v-72H248v-40h56V56h-56zM84.7 464l16.6-32h245.5l16.6 32H84.7m331.3-2.7L376 384H72l-40 77.3V512h384v-48z" })
  }
), di = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M53.9 112h94.8c68.1 0 123.3 55.2 123.3 123.3 0 11.3-1.6 22.5-4.6 33.4L244 352h49.9l19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64H.4v59.7l5.9 6.8 3.9 4.4-2.8 2.8-7 7v9.9l-.4 101v9.4l6.4 7 25.5 27.5.1 12.7.3 39.8h48l-.2-25.7 91.3-49.1 21.1-11.4-22.8-42.3-21.1 11.4-74.1 39.9-26.4-28.5.3-81.6L60 153l15.9-15.9-14.8-16.9zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32M69.2 432h181.6l16.6 32H52.7l16.6-32zM320 464v-2.7L280 384H40L0 461.3V512h320z" })
  }
), Si = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0H64v68l9.6 7.2L80 80l-6.4 4.8L64 92v12l-.4 151.6V268l10.1 7.2L93 289l-17.5 10.5-11.5 7V352h48v-18.5l124.5-75.9 20.5-12.5-25-41-20.5 12.5-74 45.1-25.9-18.5.4-127.2 22.4-16.8L160 80l-25.6-19.2L117.3 48h109.3C304.7 48 368 111.3 368 189.4c0 8.3-.7 16.6-2.2 24.8L341.3 352h48.8l23-129.4c1.9-10.9 2.9-22 2.9-33.2C416 84.8 331.2 0 226.6 0zM68.7 464l16.6-32h277.5l16.6 32H68.7zm363.3-2.7L392 384H56l-40 77.3V512h416v-48zM172 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40" })
  }
), zi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96m73.4 144H224v-48h-12.8c8.2-14.1 12.8-30.5 12.8-48 0-53-43-96-96-96s-96 43-96 96c0 17.5 4.7 33.9 12.8 48H32v48h22.6L51 352h48.1l3.6-64h50.6l3.6 64H205zM53.8 464l17.8-32h112.9l17.8 32H53.8zm202.2-2.1L212.7 384H43.3L0 461.9V512h256v-48z" })
  }
), pi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 152a72 72 0 1 0-144 0 72 72 0 1 0 144 0m24 120h-12.6l10.7 80h-48.4L195 272h-70l-10.7 80H65.9l10.7-80H40v-48h24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72h24v48zM69.2 432l-16.5 32h214.6l-16.6-32H69.2zM320 464v48H0v-50.7L40 384h240l40 77.3z" })
  }
), Mi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48M40 208H16v48h38.7l-4 96h48l4-96h50.6l4 96h48l-4-96H240v-48h-32.9l32.9-74.4 14.1-31.8 1.9-4.4-24-16.7c-1.4 1.5-2.9 2.9-4.4 4.1-7.3 6-15.3 9.3-22.5 9.1-3.6-.1-7-1-10-2.9-6.6-4-11.1-12.8-11.1-27h-32c0 11.4-5.9 18.8-13.6 22.1-6.5 2.8-14.2 2.8-20.7 0C109.9 82.8 104 75.4 104 64H72c0 14.2-4.5 23-11 27.1-3 1.9-6.4 2.8-10 2.9-7.2.1-15.3-3.1-22.5-9.1-1.5-1.3-3-2.6-4.4-4.1L0 97.4l1.9 4.4L16 133.6 48.9 208zm116.1-3.4-1.5 3.4h-53.2l-1.5-3.4-29-65.6c8-2.5 15.4-6.4 21.9-11.6 11.3 6.2 23.7 8.9 35.3 8.9s24-2.7 35.3-8.9c6.5 5.2 13.8 9.1 21.9 11.6l-29 65.6zM53.8 464l17.8-32h112.9l17.8 32H53.8zm202.2-2.1L212.7 384H43.3L0 461.9V512h256v-48z" })
  }
), xi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-105.4-8h-20l-3.6 19.7c-5.4 29.8-31.6 52.4-63 52.4-10.1 0-19.6-2.3-28.1-6.5L24 147.8l-11.3 6.9-1.3.8-19.8 12.3L3.2 188l94.4 164H153L70 207.9c40.5-2.2 75.3-25.9 93.1-59.8 22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l94.4-164 11.6-20.2-19.9-12.2-1.3-.8-11.2-7-11.9 5.8c-8.5 4.1-18 6.5-28.1 6.5-31.4 0-57.5-22.6-63-52.4L381.4 88h-53.5l-6.4 14c-11.4 24.8-36.5 42-65.5 42s-54.1-17.2-65.5-42l-6.4-14h-15.4zm-33.9 376 16.6-32h245.5l16.6 32H116.7zm331.3-2.7L408 384H104l-40 77.3V512h384v-48z" })
  }
), Hi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 96h288v136.7l-5.6 6.7-33.9 40.7 4.2 71.9h-48l-4.7-78.6-.6-9.5 6.1-7.3 34.5-41.3V144h-40v32h-32v-32h-48v32h-32v-32H64v71.3l34.4 41.3 6.1 7.3-.6 9.5-4.6 78.6h-48l4.2-71.9-33.9-40.7-5.6-6.7V120zm120 152c0-13.3 10.7-24 24-24s24 10.7 24 24v40h-48zM53.8 464h212.4l-17.8-32H71.5zm266.2-2.1V512H0v-50.1L43.3 384h233.4z" })
  }
), Vi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32h384v188l-9.6 7.2-53 39.8 9.4 85h-48.3l-10.4-93.3-1.5-13.7 11-8.2L368 196V80h-64v48h-48V80h-64v48h-48V80H80v116l54.4 40.8 11 8.2-1.5 13.6-10.4 93.4H85.2l9.4-85-53-39.8L32 220V56zm69.2 400-16.5 32h278.6l-16.6-32H101.2zM416 464v48H32v-50.7L72 384h304l40 77.3zM192 288v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64z" })
  }
), Ci = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0v32h32v32h-32v32h88v24l-8 24-21.3 64H224v48h-29.8l13.1 96h-48.5l-13.1-96h-35.4l-13.1 96H48.7l13.1-96H32v-48h21.3L32 144l-8-24V96h88V64H80V32h32V0zm-40.1 208H152l21.3-64H82.6l21.3 64zM71.5 432l-17.7 32h148.4l-17.8-32zm141.2-48 43.3 77.9 43.3-77.9h169.4l43.3 77.9V512H0v-50.1L43.3 384zM280 160h232v104.7l-5.6 6.7-34.4 41.3V352h-48v-56.7l5.6-6.7 34.4-41.3V208h-32v32h-32v-32h-32v32h-32v-32h-32v39.3l34.4 41.3 5.6 6.7V352h-48v-39.3l-34.4-41.3-5.6-6.7V160zm29.8 304h148.4l-17.8-32H327.5l-17.8 32z" })
  }
), Li = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 384v12.1L83.9 432h280.2l35.9-35.9V384zm351.4-48c-5.2-68.4-43.7-119.9-90-162.8-19.9-18.4-39.7-33.9-58.6-48.7-5-3.9-10-7.8-14.9-11.7-4-3.2-8-6.4-11.9-9.6-3.9 3.3-8 6.5-11.9 9.6-4.9 3.9-9.8 7.7-14.9 11.7-18.8 14.7-38.7 30.2-58.6 48.7-46.3 42.8-84.8 94.3-90 162.8zm-231-249.8c7.7-6 15-11.7 21.6-17.1 17.7-14.5 30.5-26.6 34-37.1 3.5 10.5 16.3 22.6 34.1 37.1 6.6 5.3 13.8 11 21.6 17.1C346.3 138.2 448 217.7 448 352v64l-64 64H64L0 416v-64C0 217.7 101.7 138.2 168.4 86.2" })
  }
), Bi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 417.9 17-17L465 209l17-17-34-33.9-17 17-175 175L81 175l-17-17-33.9 34 17 17L239 401l17 17z" })
  }
), ui = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m-1.9 256 17-17L207 47l17-17 33.9 34L241 81 65.9 256 241 431l17 17-34 33.9-17-17L15 273l-17-17z" })
  }
), Ri = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m321.9 256-17 17L113 465l-17 17-33.9-34 17-17 175-175L79 81 62 64l34-33.9 17 17L305 239l17 17z" })
  }
), $i = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 94.1 17 17L465 303l17 17-34 33.9-17-17-175-175L81 337l-17 17-33.9-34 17-17L239 111l17-17z" })
  }
), ki = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m239 273 17 17 17-17L465 81l17-17-34-33.9L431 47 256 222 81 47 64 30 30.1 64 47 81zm0 192 17 17 17-17 192-192 17-17-34-33.9-17 17-175 175L81 239l-17-17-33.9 34 17 17z" })
  }
), Pi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47 239-17 17 17 17 192 192 17 17 33.9-34-17-17-175-175L273 81l17-17-34-33.9L239 47zm192 0-17 17 17 17 192 192 17 17 33.9-34-17-17-175-175L465 81l17-17-34-33.9L431 47z" })
  }
), Fi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m273 239 17 17-17 17L81 465l-17 17-33.9-34 17-17 175-175L47 81 30 64l34-33.9L81 47zm192 0 17 17-17 17-192 192-17 17-33.9-34 17-17 175-175L239 81l-17-17 34-33.9 17 17z" })
  }
), Ti = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m273 47-17-17-17 17L47 239l-17 17 34 33.9 17-17 175-175L431 273l17 17 33.9-34-17-17zm0 192-17-17-17 17L47 431l-17 17 34 33.9 17-17 175-175L431 465l17 17 33.9-34-17-17z" })
  }
), Ai = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 56V32h-48v448h48V272h128v208h48V32h-48v192H240zm232-24h-24v448h48V272h112v-48H496V80h144V32h-24zM88 40C43.8 40 8 75.8 8 120v288c0 44.2 35.8 80 80 80s80-35.8 80-80v-16h-48v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V120c0-17.7 14.3-32 32-32s32 14.3 32 32v16h48v-16c0-44.2-35.8-80-80-80" })
  }
), Di = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-105.5 96h-14.1l-6.9 12.3-62.5 112-11.7 21 41.9 23.4 11.7-21 19-34.1V512h48V384h32v128h48V273.6l19 34.1 11.7 21 41.9-23.4-11.7-21-62.5-112-6.7-12.3h-14.1zM192 336h-32V208h32zM416 0h-16v32h16v96h-16v64h-48v192h64v128h96l-12-48-16-64h60v-48h-64v-26.7l64-21.3V192h-48v72l-16 5.3V128h-16V0h-16zm16 336h-32v-96h32z" })
  }
), yi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0m96 0a72 72 0 1 0-144 0 72 72 0 1 0 144 0m-115.1 88h-11.4l-7.2 8.8-97.7 120 37.2 30.3 47.1-57.9-35.7 107.2L38.7 400H96v112h48V400h32v112h48V400h57.3l-10.5-31.6-35.7-107.1 47.1 57.9 37.2-30.3-97.7-120-7.2-8.8h-97.6zm-11.6 192 48-144h13.4l48 144z" })
  }
), bi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144m-95.5 80H112v288h48V384h64v128h48V224h13.8l6.9-11.9 56-96 12.1-20.7-41.4-24.2-12.1 20.7-49.1 84.1H124.5L76.9 92.2 65 71.3 23.3 95l11.8 20.9 54.5 96zM224 336h-64V224h64z" })
  }
), fi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-96a72 72 0 1 1 0 144 72 72 0 1 1 0-144M88.9 160h140.5l7 11.4 68.8 112 12.6 20.4-40.9 25.2-12.6-20.4-24.3-39.7V512h-48V384h-64v128H80V268l-24.2 40.4-12.4 20.5-41.1-24.7 12.4-20.6 67.3-112 7-11.6zM128 336h64V208h-64z" })
  }
), Ui = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-96a72 72 0 1 1 0 144 72 72 0 1 1 0-144m-55.3 160h110.6l7.2 9.9 81.7 112 14.1 19.4-38.8 28.3-14.1-19.4-40.6-55.7 38 113.9 10.5 31.6H224v112h-48V400h-32v112H96V400H46.7l10.5-31.6 38-113.9-40.6 55.6-14.2 19.4-38.7-28.3 14.1-19.4 81.7-112 7.2-9.9zm8.6 192h93.4L160 211.9zM504 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0m30.5 88h96.3l7.1 11.2 70.5 112 12.8 20.3-40.6 25.6-12.8-20.3-27.7-44V512H496V384h-32v128h-48V264.8l-27.7 44-12.8 20.3-40.6-25.6 12.8-20.3 70.5-112 7.1-11.2h13.3zM496 336V208h-32v128z" })
  }
), Gi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v96h352V80zM0 32h448v192h-32v264h-48V384h-80v104h-48V384H80v104H32V224H0V80zm80 192v112h80V224zm128 0v112h160V224z" })
  }
), qi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M347.9 16.3 328 .6l-14.6 20.9L15.5 447.8l-13 18.6 17.8 14 21.4 16.8 17.8 14 15-17 343.9-390.3 16.8-19.1-20-15.7-67.3-52.8zM160.7 323.9 338.3 69.8l27.3 21.5zM568.4 74l-16.5-19.3-18.3 17.6L149.8 439l-16.4 15.7 14.8 17.3 17.5 20.4 14.8 17.3 18-13.8 421.2-323.2 20.1-15.4-16.5-19.3zm2 76.1L323.5 339.5l225-215 21.8 25.5z" })
  }
), Wi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24V0h-48v48h-56v48h56v26.9l-125 81-11 7.1v253H48V357.1l80-51.8v-57.2L11 323.9l-11 7V512h640V330.9l-11-7.1-117-75.7v57.2l80 51.8V464H480V210.9l-11-7.1-125-80.9V96h56V48h-56zM208 237.1l112-72.5 112 72.5V464h-64v-96c0-26.5-21.5-48-48-48s-48 21.5-48 48v96h-64z" })
  }
), Ei = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96v-64c0-53-43-96-96-96m-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48z" })
  }
), Oi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-14.2-384-5.4 3-60.4 33.5v54.9l11.7-6.5 44.3-24.6V336h-56v48h160v-48h-56V128h-32z" })
  }
), Ii = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-62.3-365.5-16.2 12.3-19.1 14.5 29.1 38.2 19-14.5 16.2-12.3c7.2-5.5 16.1-8.4 25.3-8.3l3.4.1c20.3.3 36.6 16.8 36.6 37.1 0 10.3-4.2 20.1-11.7 27.1L167.6 342.5l-7.6 7.1V384h192v-48H244.7l64.4-60.4c17.2-16.1 26.9-38.6 26.9-62.1 0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1z" })
  }
), Ni = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56-384H160v48h90.3l-50.5 46.3-7.8 7.1v34.7l24.1-.1 51.5-.3c20.1-.1 36.4 16.1 36.4 36.2 0 20-16.2 36.2-36.2 36.2h-25.1c-14 0-26.8-7.9-33-20.4l-4.2-8.3-42.9 21.5 4.2 8.3c14.4 28.8 43.8 47 76 47H268c46.5 0 84.2-37.7 84.2-84.2 0-43.3-32.6-78.9-74.6-83.6l50.8-46.5 7.8-7.1V128z" })
  }
), Xi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320-64v80h32v48h-32v64h-48v-64H144.4l8.5-30.4L197.8 128h49.8l-40 144H272v-80z" })
  }
), Ki = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-384h-21.9l-2 21.8-8 88-2.1 23.3 23.2 2.8 79.1 9.5c15.8 1.9 27.7 15.3 27.7 31.2 0 17.4-14.1 31.5-31.5 31.5h-33c-12.1 0-23.2-6.7-29-17.3l-5.4-10-42.3 22.7 5.4 10c14.1 26.2 41.5 42.6 71.2 42.6h33c43.9 0 79.5-35.6 79.5-79.5 0-40.2-30.1-74.1-70-78.9l-56-6.7 3.9-42.9H336V128h-24z" })
  }
), Qi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-96-48c0-31.7 11.9-62.3 33.3-85.7l68.1-74.3h65.1l-14.9 16.2-44.4 48.4C315 198.2 352 238.8 352 288c0 53-43 96-96 96s-96-43-96-96" })
  }
), Zi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m72-384H160v48h130.2l-93.9 199.8-3.9 8.2h53l104.3-221.8 2.3-4.9V128z" })
  }
), Ji = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m264-128c39.8 0 72 32.2 72 72 0 15.7-5 30.1-13.5 42 18 14.7 29.5 37 29.5 62 0 44.2-35.8 80-80 80h-32c-44.2 0-80-35.8-80-80 0-25 11.5-47.4 29.5-62-8.5-11.9-13.5-26.3-13.5-42 0-39.8 32.2-72 72-72zm-16 96h16c13.2 0 24-10.8 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24m16 48h-24c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), ji = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96m96 48c0 31.7-11.9 62.3-33.3 85.7L250.6 384h-65.2l14.9-16.2 44.4-48.4C197 313.8 160 273.2 160 224c0-53 43-96 96-96s96 43 96 96" })
  }
), Yi = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-15.2-400-6.5 13.8L120.6 368h53l22.5-48h119.7l22.5 48h53L277.7 125.8l-6.5-13.8zm15.2 80.5 37.3 79.5h-74.6z" })
  }
), _i = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-88-384v60.7c0 18.6 7.2 36.4 20 49.8l7.3 7.7-21.9 16.1a72 72 0 0 0-29.4 58.1V384h140.6l7.2-10.3 10.8-15.6 24.8 25.9h66.1c-.7-.9-1.4-1.8-2.2-2.6l-60.9-63.6 33.3-48.1 13.7-19.7-39.5-27.3-13.7 19.7-27.7 40.1-28.6-29.9 18-13.2c16.4-12.1 26.2-31.2 26.2-51.6V128H192zm66.4 89.6-11.7-12.2c-4.3-4.5-6.7-10.4-6.7-16.6V176h48v11.7c0 5.1-2.4 9.9-6.5 12.9l-23.1 16.9zm-5.6 63.6 39.8 41.5-9.2 13.3H192v-15.7c0-7.6 3.6-14.8 9.8-19.4l27-19.8z" })
  }
), hm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512m-88-144h-24V160h48v126.1L327 151l17-17 33.9 34-17 17-135 135H344v48h-24z" })
  }
), cm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416m0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512m88 368h24V160h-48v126.1L185 151l-17-17-33.9 34 17 17 135 135H168v48h24z" })
  }
), sm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416m0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-17 377 17 17 17-17 88-88 17-17-34-33.9-17 17-47 47V128h-48v174.1l-47-47-17-17-33.9 33.9 17 17 88 88z" })
  }
), vm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0m-377-17-17 17 17 17 88 88 17 17 33.9-34-17-17-47-47H384v-48H209.9l47-47 17-17-33.9-33.9-17 17-88 88z" })
  }
), em = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m377 17 17-17-17-17-88-88-17-17-33.9 34 17 17 47 47H128v48h174.1l-47 47-17 17 33.9 33.9 17-17 88-88z" })
  }
), lm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-88-368h-24v208h48V225.9L327 361l17 17 33.9-34-17-17-135-135H344v-48h-24z" })
  }
), tm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m88 144h24v208h-48V225.9L185 361l-17 17-33.9-34 17-17 135-135H168v-48h24z" })
  }
), wm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m17-377-17-17-17 17-88 88-17 17 34 33.9 17-17 47-47V384h48V209.9l47 47 17 17 33.9-33.9-17-17-88-88z" })
  }
), gm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-384v256h132c42 0 76-34 76-76 0-24.6-11.7-46.4-29.8-60.3 8.7-12.4 13.8-27.4 13.8-43.7 0-42-34-76-76-76h-92zm144 76c0 15.5-12.5 28-28 28h-68v-56h68c15.5 0 28 12.5 28 28m-96 132v-56h84c15.5 0 28 12.5 28 28s-12.5 28-28 28z" })
  }
), im = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m232 16h-88v-24l176-136-40 128h88v24L192 400z" })
  }
), mm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-176c27.8 0 56 16 56 16V176s-28.2-16-56-16-56 16-56 16v176s28.2-16 56-16m144 0c27.8 0 56 16 56 16V176s-28.2-16-56-16-56 16-56 16v176s28.2-16 56-16" })
  }
), am = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-128 96-64 96 64V128H160z" })
  }
), om = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256c0-44.2 35.8-80 80-80 28.7 0 53.8 15.1 68 37.8l40.8-25.4C342.2 152.2 301.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c45.9 0 86.2-24.2 108.7-60.5L324 298.2C309.8 321 284.7 336 256 336c-44.2 0-80-35.8-80-80" })
  }
), nm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m224-144v32h64v-32h32v32h64v224H128V144h64v-32zm-48 112v96h160v-96z" })
  }
), rm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m196-96 12-32h96l12 32h68v192H128V160zm108 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), dm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512M128 240v-32h256v32L256 368z" })
  }
), Sm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M272 384h32V128h-32L144 256z" })
  }
), zm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m240-128h-32v256h32l128-128z" })
  }
), pm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 272v32h256v-32L256 144z" })
  }
), Mm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m113-303 17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), xm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416m0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-17 345 17 17 17-17 104-104 17-17-34-33.9-17 17-87 87-87-87-17-17-33.9 33.9 17 17z" })
  }
), Hm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0m-345-17-17 17 17 17 104 104 17 17 33.9-34-17-17-87-87 87-87 17-17-33.9-33.9-17 17z" })
  }
), Vm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m345 17 17-17-17-17-104-104-17-17-33.9 34 17 17 87 87-87 87-17 17 33.9 33.9 17-17z" })
  }
), Cm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m17-345-17-17-17 17-104 104-17 17 34 33.9 17-17 87-87 87 87 17 17 33.9-33.9-17-17z" })
  }
), Lm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h-24v256h96c70.7 0 128-57.3 128-128s-57.3-128-128-128zm72 208h-48V176h48c44.2 0 80 35.8 80 80s-35.8 80-80 80" })
  }
), Bm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M1.1 232h48.3c4.5-39.5 20.1-75.6 43.6-105.1L58.8 92.7C26.9 131.3 6 179.3 1.1 232zM126.9 92.9c29.6-23.4 65.7-39 105.1-43.6V1.1C179.3 6 131.3 26.9 92.7 58.8l34.1 34.1zM280 462.6v48.3c52.7-4.9 100.7-25.8 139.3-57.7l-34.1-34.1c-29.6 23.4-65.7 39-105.1 43.6zm139.1-77.5 34.1 34.1c31.9-38.5 52.8-86.6 57.7-139.3h-48.3c-4.5 39.5-20.1 75.6-43.6 105.1zM92.7 453.2c38.5 31.9 86.6 52.8 139.3 57.7v-48.3c-39.5-4.5-75.6-20.1-105.1-43.6zm-33.9-33.9 34.1-34.1c-23.4-29.6-39-65.7-43.6-105.1H1.1C6 332.7 26.9 380.7 58.8 419.3M419.3 58.8C380.7 26.9 332.7 6 280 1.1v48.3c39.5 4.5 75.6 20.1 105.1 43.6l34.1-34.1zm-.2 68.1c23.4 29.6 39 65.7 43.6 105.1H511c-4.9-52.7-25.8-100.7-57.7-139.3l-34.1 34.1z" })
  }
), um = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-320v-64h-64v64zm-120 40h-24v48h224v-48h-24zm56 152h64v-64h-64z" })
  }
), Rm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368a208 208 0 1 0 0-416 208 208 0 1 0 0 416M64 352H0v160h512V352h-64c-13.6 18.2-29.8 34.3-48 48h64v64H48v-64h64c-18.2-13.7-34.3-29.8-48-48m212-240V92h-40v26c-5.6 1.2-11 2.9-16 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 7 29.9 9.1V324h40v-25.5c5.4-1 10.6-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V112z" })
  }
), $m = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m276.2-106.6c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6-16.4-2.4-30.1-.5-39.3 3.5-11 4.7-18 16.2-6.3 23.7 8.5 5.4 21.5 9.2 39.4 14.3l.8.2c15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2V400H233v-38.9c-11.7-2.6-26.7-7.4-36.6-10.6-6.6-2.1-13.1-4.2-19.7-6.2-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2 6.6 2.1 21.9 6.9c12.1 3.9 26.4 8.4 34.5 9.7 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 3.9-21.5 19.9-35.8 37.8-43.5 5.8-2.5 12.1-4.4 18.6-5.7V112h43.2v37.4z" })
  }
), km = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), Pm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512m-96-320 24-24 52 52 76-76 56 56-76 76 52 52-24 24H160z" })
  }
), Fm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416m0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512m96 192-24-24-52 52-76-76-56 56 76 76-52 52 24 24h160z" })
  }
), Tm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416m0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512m112 288v-32h-64V128h-96v128h-64v32l112 96z" })
  }
), Am = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h-24v256h192v-48H208v-56h112v-48H208v-56h144v-48h-24z" })
  }
), Dm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m224 64h64v64h-64zm0-192h64v64h-64zm0 160v-64h64v64z" })
  }
), ym = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-64 224v64h-64v-64zm192 0v64h-64v-64zm-160 0h64v64h-64z" })
  }
), bm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 188.2l128 67.2 128-67.2V160H128zm135.4 99.5-7.4 3.9-7.4-3.9L128 224.3V352h256V224.3l-120.6 63.3z" })
  }
), fm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m144 16c-.6-5-.9-10.1-.9-15.2 0-5.7.4-11.3 1.1-16.8H112v-32h40.7c19.2-46.9 65.4-80 119.2-80H337v48h-65.1c-26.3 0-49.6 12.6-64.4 32H304v32H192.9c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H304v32h-97.6c14.7 20.3 38.5 33.5 65.5 33.5H337v48h-65.1c-54.4 0-101-33.8-119.8-81.5H112v-32z" })
  }
), Um = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208 84.1 0 156.7 50 189.4 121.9l43.7-19.9C448.8 61.6 359.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c72.9 0 138.8-30.5 185.4-79.4l-34.8-33.1C368.7 439.2 315.3 464 256 464c-114.9 0-208-93.1-208-208m232-104v-24h-48v160h48v-24zm0 216v-48h-48v48zm353.9-176L600 158.1l-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17L617 209l17-17z" })
  }
), Gm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-384h-48v160h48V152zm-48 240h48v-48h-48z" })
  }
), qm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h-24v256h48v-96h112v-48H208v-64h144v-48h-24z" })
  }
), Wm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256c0-44.2 35.8-80 80-80 20.5 0 39.2 7.7 53.3 20.4l32-35.8C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128v-24H256v48h76.3c-10.2 32.5-40.5 56-76.3 56-44.2 0-80-35.8-80-80" })
  }
), Em = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m112-360v-24h-48v104H192V128h-48v256h48V280h128v104h48V256z" })
  }
), Om = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208v416c114.9 0 208-93.1 208-208M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Im = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 53.6v404.8C116.3 436.8 48 354.4 48 256S116.3 75.2 208 53.6zm0-49.1C89.6 27 0 131 0 256s89.6 229 208 251.5c15.5 3 31.6 4.5 48 4.5V0c-16.4 0-32.5 1.5-48 4.5" })
  }
), Nm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M135.2 287.1l24.8 24.8 96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56v-3.6c0-41.8-33.9-75.6-75.6-75.6-23 0-44.7 10.4-59.1 28.4l-9.3 11.6-9.3-11.6c-14.4-17.9-36.1-28.4-59.1-28.4-41.8 0-75.6 33.9-75.6 75.6v3.6c0 21 8.3 41.1 23.2 56" })
  }
), Xm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h-24v48h72v160h-72v48h192v-48h-72V176h72v-48h-96z" })
  }
), Km = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-40-176h-24v48h128v-48h-32V224h-96v48h48v64zm72-144v-64h-64v64z" })
  }
), Qm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m80-360v-24h-48v160c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32h-48v32c0 53 43 96 96 96s96-43 96-96z" })
  }
), Zm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m113.1-384h-64.5l-82.5 92-14.1 15.8V128h-48v256h48v-76.3l29.1-32.5L309.2 384h57.6l-4.8-7.3-91.7-138.4 97.9-109.1 1-1.1z" })
  }
), Jm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-360v-24h-48v256h192v-48H208z" })
  }
), jm = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M224 368h32v-64h128v-96H256v-64h-32l-96 112z" })
  }
), Ym = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m233.4 22.6L86.3 244.7l282.8-101.8-101.8 282.8z" })
  }
), _m = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 152v232h48V226.2l60.5 83.8 19.5 27 19.5-26.9 60.5-83.9V384h48V128h-36.3l-7.2 9.9L256 255l-84.5-117.1-7.2-9.9H128z" })
  }
), ha = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M208 96v160c0 26.5 21.5 48 48 48s48-21.5 48-48h-40v-32h40v-32h-40v-32h40V96zm-32 160v-24h-48v24c0 62.5 44.8 114.5 104 125.8V416h48v-34.2c59.2-11.2 104-63.3 104-125.8v-24h-48v24c0 44.2-35.8 80-80 80s-80-35.8-80-80" })
  }
), ca = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m208 0V96h96v160c0 26.5-21.5 48-48 48s-48-21.5-48-48m-32-24v24c0 44.2 35.8 80 80 80s80-35.8 80-80v-24h48v24c0 62.5-44.8 114.5-104 125.8V416h-48v-34.2c-59.2-11.3-104-63.3-104-125.8v-24z" })
  }
), sa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-280h-24v48h192v-48h-24z" })
  }
), va = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m48-384v155.2L203.7 138.3l-7.1-10.3H160v256h48V228.8l100.3 144.9 7.2 10.3H352V128z" })
  }
), ea = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1l-141-123.5c4.3-9.9 6.7-20.7 6.7-32.2 0-2-.1-4.1-.2-6.1l178.3-71.3zm71.9 28.8c39.5-4.9 70-38.6 70-79.4 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1.2 6.1l-178.3 71.3C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7l141.1 123.5c-4.3 9.9-6.7 20.7-6.7 32.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8zM304 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0M80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), la = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M198.6 56C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200l13.2-46.1C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9z" })
  }
), ta = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m80-256a80 80 0 1 1-160 0 80 80 0 1 1 160 0m-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256" })
  }
), wa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h-24v256h48v-72h68c50.8 0 92-41.2 92-92s-41.2-92-92-92zm92 136h-68v-88h68c24.3 0 44 19.7 44 44s-19.7 44-44 44" })
  }
), ga = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m192-128h88c53 0 96 43 96 96s-43 96-96 96h-64v64h-48V128zm88 144c26.5 0 48-21.5 48-48s-21.5-48-48-48h-64v96z" })
  }
), ia = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m224-72v168h-48V160h48zm112 0v168h-48V160h48z" })
  }
), ma = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m56 128 72 16v16c0 123.7-100.3 224-224 224h-16l-16-72 72-40 33.5 41.9c34.2-18.1 62.3-46.2 80.4-80.4L272 200z" })
  }
), aa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m122.7-208 37.3-57.2-10.7-10.4c-82.5-80.5-216.2-80.5-298.7 0L96 246.8l37.3 57.2 74.7-20.8-5.6-49.1c34.9-10.5 72.3-10.5 107.2 0l-5.6 49.1z" })
  }
), oa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-56-384-72 16v16c0 123.7 100.3 224 224 224h16l16-72-72-40-33.5 41.9c-34.2-18.1-62.3-46.2-80.4-80.4L240 200z" })
  }
), na = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m384 0L176 384V128z" })
  }
), ra = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-24-144h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), da = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-336c44.2 0 80 35.8 80 80 0 12.7-3 24.7-8.2 35.3L299.5 256h-61.4l56.2 70.3c-11.4 6.2-24.4 9.7-38.3 9.7-44.2 0-80-35.8-80-80s35.8-80 80-80m0 208c25.2 0 48.7-7.3 68.6-19.9l15.9 19.9H402l-42.3-52.9C375 310 384 284.1 384 256c0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128" })
  }
), Sa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208v208H48c0 114.9 93.1 208 208 208s208-93.1 208-208M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), za = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M53.6 208c18-76.3 78.1-136.4 154.4-154.4V208H53.6zm-49.1 0c-3 15.5-4.5 31.6-4.5 48h256V0c-16.4 0-32.5 1.5-48 4.5C105.1 24 24 105.1 4.5 208" })
  }
), pa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M108.9 403.1 256 256l147.1 147.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Ma = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m168-72c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4V296h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H224c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48z" })
  }
), xa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-384v256h48v-96h42.9l61.3 96h57l-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80H160zm48 112v-64h80c17.7 0 32 14.3 32 32s-14.3 32-32 32h-24z" })
  }
), Ha = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-56-256c0-20.7 11.3-38.8 28-48.5l-52-90.1c-47.8 27.7-80 79.4-80 138.6zm28 48.5-52 90.1c23.5 13.6 50.9 21.4 80 21.4s56.5-7.8 80-21.4l-52-90.1c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5m84-48.5h104c0-59.2-32.2-110.9-80-138.6l-52 90.1c16.7 9.7 28 27.8 28 48.5m-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Va = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m288-112h-32v64H128v96h128v64h32l96-112z" })
  }
), Ca = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48.4-315.8c1.1-6.2 5-11.8 15.4-15.8 11-4.3 27.6-6 47.8-2.9 6 .9 20.6 4 27.3 5.7l23.3 6 11.9-46.5-23.3-6c-7.7-2-23.9-5.5-32-6.7-25.6-3.9-51.3-2.6-72.6 5.7-21.9 8.6-40.3 25.7-45 52-2.6 14.4-1.3 28 4.4 40.3 5.6 12.1 14.7 20.8 24.1 27.2 17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4 4.5 3 6.5 5.6 7.4 7.7.9 1.9 1.8 5.2.6 11.6-1.1 6.2-5 11.8-15.4 15.8-11 4.3-27.5 6-47.7 2.9-12.2-1.9-36.1-8.9-50-13.4l-22.9-7.3-14.7 45.7 22.9 7.3c13.6 4.4 40.9 12.5 57.3 15.1h.1c25.6 3.9 51.3 2.6 72.6-5.7 21.9-8.6 40.3-25.7 45-52 2.6-14.4 1.4-28-4.4-40.3-5.6-12.1-14.7-20.8-24.1-27.2-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4-4.5-3-6.5-5.6-7.4-7.7-.9-1.9-1.8-5.2-.6-11.6z" })
  }
), La = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224m0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320" })
  }
), Ba = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0m-368 64 112 96 112-96v-32H144zm0-96h224v-32L256 96l-112 96zm112-85.9 62.8 53.9H193.2z" })
  }
), ua = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m144-64 112-96 112 96v32H144zm0 96h224v32l-112 96-112-96zm112 85.9 62.8-53.9H193.2z" })
  }
), Ra = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m144-64 112-96 112 96v32H144zm112 224-112-96v-32h224v32z" })
  }
), $a = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m42.3-314.2L256 112l-42.3 85.8-94.7 13.7 68.5 66.7-16.2 94.2L256 328l84.6 44.5-16.2-94.2 68.6-66.8-94.6-13.8z" })
  }
), ka = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H288v32h-56.3l.3 41.2v5.9l-2.7 5.3-6 11.6H352v48H144.7l18-35 21.3-41.4-.3-35.6H160v-32h23.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9 10 0 19.8 1.9 29.1 5.6l30.3 12.1 22.3 8.9-17.8 44.6-22.3-8.9-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z" })
  }
), Pa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m352-96v192H160V160z" })
  }
), Fa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M152 144h-24v48h104v192h48V192h104v-48H256z" })
  }
), Ta = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M460.2 296H216V51.8C120.3 70.5 48 154.8 48 256c0 114.9 93.1 208 208 208 101.2 0 185.5-72.3 204.2-168m3.7-48C459.7 139.5 372.5 52.3 264 48.2V248h199.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Aa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 304V53.6C116.3 75.2 48 157.6 48 256c0 114.9 93.1 208 208 208 98.4 0 180.8-68.3 202.4-160H256zm299.5 0C485 422.4 381 512 256 512 114.6 512 0 397.4 0 256 0 131 89.6 27 208 4.5c15.5-3 31.6-4.5 48-4.5v256h256c0 16.4-1.5 32.5-4.5 48" })
  }
), Da = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m160-128h41.4l11.3-11.3 4.7-4.7H294.6l4.7 4.7 11.3 11.3H368v32H144v-32zm0 64h192l-16 192H176z" })
  }
), ya = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-64-344v-24h-48v144c0 61.9 50.1 112 112 112s112-50.1 112-112V144h-48v144c0 35.3-28.7 64-64 64s-64-28.7-64-64z" })
  }
), ba = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-192 24 24 52-52 76 76 56-56-76-76 52-52-24-24H160z" })
  }
), fa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m96 320-24 24-52-52-76 76-56-56 76-76-52-52 24-24h160z" })
  }
), Ua = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M144 224v32h64v128h96V256h64v-32l-112-96z" })
  }
), Ga = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 60.2 25.6 114.5 66.5 152.5L144 320h224l29.5 88.5c40.9-38 66.5-92.2 66.5-152.5M333.4 368H178.6l-23.3 70c29.8 16.6 64.2 26 100.7 26s70.9-9.4 100.7-26zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m216-56a40 40 0 1 0 80 0 40 40 0 1 0-80 0m40 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176" })
  }
), qa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m127.9-368h-52.4L256 316.2 180.5 144h-52.4L234 385.6l6.3 14.4h31.4l6.3-14.4z" })
  }
), Wa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M144 176v160h144V176zm176 112 64 48V176l-64 48z" })
  }
), Ea = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m153.5-360h-50l-40.7 141.5-39.9-124.8-5.4-16.7h-35l-5.3 16.7-40 124.8L152.5 152h-50l66.4 230.6 5 17.4h35.6l5.3-16.7L256 254.7l41.1 128.6 5.3 16.7H338l5-17.4z" })
  }
), Oa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-368v-24h-48v272h48v-24zm80 56v-24h-48v160h48v-24zm-160 16v-24h-48v128h48v-24zm240 24v-24h-48v80h48v-24z" })
  }
), Ia = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m125.1-384h-59.8L256 215.8 190.7 128h-59.8l95.2 128-95.2 128h59.8l65.3-87.8 65.3 87.8h59.8l-95.2-128 95.2-128z" })
  }
), Na = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m97.9-320L320 158.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), Xa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-24-216.1V400h48V295.9L391.4 144h-59.6L256 247.4 180.2 144h-59.6z" })
  }
), Ka = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m137.5-112h61l57.5 73.2 57.5-73.2h61l-11.7 14.8-76.3 97.2H336v32h-56v32h56v32h-56v49h-48v-49h-56v-32h56v-32h-56v-32h49.5l-76.3-97.2z" })
  }
), Qa = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m96-352.5V128H160v48h122.2L164.3 346.3l-4.3 6.2V384h192v-48H229.8l117.9-170.3z" })
  }
), Za = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), Ja = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 288c0 40.8 10.9 79 30 112-96.3-1.1-174-79.5-174-176 0-97.2 78.8-176 176-176 38.9 0 74.8 12.6 104 34-80 34.2-136 113.5-136 206m32 160c11.2 0 22.1-.8 32.8-2.4 40.6 41 96.9 66.4 159.2 66.4 123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1.8-32.8 2.4C342.6 25.4 286.3 0 224 0 100.3 0 0 100.3 0 224s100.3 224 224 224m192 16c-38.9 0-74.8-12.6-104-34 80-34.2 136-113.5 136-206 0-40.8-10.9-79-30-112 96.3 1.1 174 79.5 174 176 0 97.2-78.8 176-176 176" })
  }
), ja = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 208c0 141.4-114.6 256-256 256-49.2 0-95.2-13.9-134.2-37.9l27.2-27.2c33.3 21 72.7 33.1 115 33.1 119.3 0 216-96.7 216-216 0-42.3-12.1-81.7-33.1-115l27.2-27.2c24.1 39 37.9 85 37.9 134.2zM63.3 368.7l-28.1 28.1-34 34c11.8 11 24.5 21 37.9 30C87.4 493.1 145.5 512 208 512c167.9 0 304-136.1 304-304 0-62.5-18.9-120.6-51.2-168.9-9-13.4-19-26.1-30-37.9l-34 34-28.1 28.1-33.9 33.9L240 192l-48 48-94.8 94.8zM224 288c11.3 0 22.5-3 32.5-8.9l66.4 66.4c-27.1 22.4-61.4 36.5-98.9 38.2V288zm55.1-31.5c5.9-10 8.9-21.3 8.9-32.5h95.8c-1.8 37.5-15.8 71.8-38.2 98.9l-66.4-66.4zm-143 107.3 55.9-55.9v74.4c-20-2.9-38.9-9.2-55.9-18.5zM307.9 192l55.9-55.9c9.3 17.1 15.6 35.9 18.5 55.9z" })
  }
), Ya = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 112v16h96c53 0 96-43 96-96V0h-96c-31 0-58.7 14.7-76.2 37.6-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240 240-107.5 240-240c0-49.5-15-95.5-40.7-133.7-13.5 9.1-28.8 15.7-45.3 19.1 23.9 32 38 71.7 38 114.6 0 106-86 192-192 192S64 378 64 272 150 80 256 80c11.2 0 22.2 1 32.9 2.8-.6 4.3-.9 8.7-.9 13.2z" })
  }
), _a = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0v64h48V0h48v112H48v352h176v48H0V64h80V0zm384 112v48h128v352H256V0h256v48zm-48-64H304v416h288V208H464v-48zM352 352v-64h64v64zm64-256v64h-64V96zm-64 160v-64h64v64zm192 96v64h-64v-64zM96 320v-64h64v64zm0 96v-64h64v64zm64-256v64H96v-64zm320 160v-64h64v64z" })
  }
), ho = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V208h416v224zm288-272 80-80h48v16l-64 64zm-96 0h-64l80-80h64zm-160 0H48v-32l48-48h64zm432 24V32H0v448h512V208zM344 320l-136-88v176z" })
  }
), co = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 208v224h416V208zm352-48 64-64V80h-48l-80 80zm-80-80h-64l-80 80h64zm-160 0H96l-48 48v32h32zm352 80v320H0V32h512v48z" })
  }
), so = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96h288v32h-32v32h57.8l66.6-37 35.6-19.8v305.6L604.3 389l-66.6-37H100.5l-3.4-1-80-24L0 321.9V190.1l17.1-5.1 80-24 3.4-1H256v-32h-32zm64 64h64v-32h-64zm96 0h64v-32h-64zm-136 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m115.7-51-5.4 3H107.5L48 225.9v60.3l59.5 17.8h442.7l5.4 3 36.4 20.2V184.8z" })
  }
), vo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m67.2 1.3 17 17L193 127l7 7v50h49.9l7 7L385 319l7 7v50h49.9l7 7 76.8 76.8 17 17-33.9 33.9-17-17-69.7-69.7H344v-78.1L230.1 232H152v-78.1L50.2 52.2l-17-17 34-33.9zm0 224 17 17L161 319l7 7v50h49.9l7 7 76.8 76.8 17 17-33.9 33.9-17-17-69.7-69.7H120v-78.1l-69.8-69.7-17-17 33.9-33.9zm241-207L321 31l7 7v50h49.9l7 7 64 64 7 7v50h49.9l7 7 12.8 12.8 17 17-33.9 33.9-17-17-5.8-5.8H408v-78L358.1 136H280V57.9l-5.8-5.8-17-17 34-33.8 17 17z" })
  }
), eo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m121 187.6 17-17-34-33.9-17 17-89.7 89.7L129 287l-17-17-33.9 34 17 17 53.3 53.3 17 17 17-17z" })
  }
), lo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m3.3 155.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-12.7-12.7L88 225.4 65.4 248l11.3 11.3 24 24 11.3 11.3 11.3-11.3zM192 256v32h112v-32h-96zm-16 96h-16v32h144v-32h-16zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), to = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-56 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48m64-136h-16v32h128v-32h-16zm0 96h-16v32h128v-32h-16zm-64-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), wo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-8 208H96v64h64v64h64v-64h64v-64h-64v-64h-64z" })
  }
), go = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-64 124H84v184h40v-64h35.7l52 52-25.9 25.9-14.1 14.1 28.3 28.3 14.1-14.1 25.9-25.9 25.9 25.9 14.1 14.1 28.3-28.3-14.1-14.1-25.9-25.9 25.9-25.9 14.1-14.1-28.3-28.3-14.1 14.1-25.9 25.9-32.6-32.6c17.2-10.5 28.6-29.5 28.6-51.1 0-33.1-26.9-60-60-60zm72 80h-52v-40h52c11 0 20 9 20 20s-9 20-20 20" })
  }
), io = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-64 168v6.5h48V248c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4-12.1 7V360h48v-31.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1H160c-30.9 0-56 25.1-56 56zm64 152v48h48v-48z" })
  }
), mo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h-65.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H0v448h384V64zM80 112v48h224v-48h32v352h-37.3L272 384H112l-26.7 80H48V112zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m88 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), ao = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 64h80v448H0V64h113.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM48 112v352h288V112h-32v48H80v-48zm144-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), oo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 224a176 176 0 1 0-352 0 176 176 0 1 0 352 0M224 0c123.7 0 224 100.3 224 224v288H0V224C0 100.3 100.3 0 224 0m24 96v118.1l41 41 17 17-34 33.8-17-17-48-48-7-7V96z" })
  }
), no = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0m464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0M232 392v-91.2L173.3 340l-20 13.3-26.6-39.9 20-13.3 96-64 37.3-24.9V416h-48z" })
  }
), ro = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v148.8l-10.7 7.2-96 64-20 13.3-26.6-39.9 20-13.3 85.3-56.9V96h48z" })
  }
), So = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0m464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0M232 392V263.3l-60-90-13.3-20 39.9-26.6 13.3 20 64 96 4 6V416H232z" })
  }
), zo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m232-136v56.7l-20-30-13.3-20-39.9 26.6 13.3 20 64 96L280 256V96h-48z" })
  }
), po = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392v-56.7l20 30 13.3 20 39.9-26.6-13.3-20-64-96L232 256v160h48z" })
  }
), Mo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v128.7l60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6V96h48v24z" })
  }
), xo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392v-91.2l58.7 39.2 20 13.3 26.6-39.9-20-13.3-96-64-37.3-24.9V416h48z" })
  }
), Ho = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392V232H128v48h104v136h48z" })
  }
), Vo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v160H128v-48h104V96h48z" })
  }
), Co = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392V263.3l60-90 13.3-20-39.9-26.6-13.3 20-64 96-4 6V416h48v-24z" })
  }
), Lo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v56.7l20-30 13.3-20 39.9 26.6-13.3 20-64 96L232 256V96h48z" })
  }
), Bo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 106.7V32H0v160h160v-48H80.7c37-57.8 101.7-96 175.3-96 114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5l-20-13.3-26.5 40 20 13.3c40.4 26.9 89 42.5 141.2 42.5 141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7M280 128h-48v137.9l7 7 72 72 17 17 33.9-33.9-17-17-65-65V128z" })
  }
), uo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0m464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0M232 392v-56.7l-20 30-13.3 20-39.9-26.6 13.3-20 64-96L280 256v160h-48z" })
  }
), Ro = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m232-136v128.7l-60 90-13.3 20 39.9 26.6 13.3-20 64-96 4-6V96H232z" })
  }
), $o = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392V232h-48v184h48z" })
  }
), ko = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v264h-48V96h48z" })
  }
), Po = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0M280 392V243.2l-10.7-7.2-96-64-20-13.3-26.6 39.9 20 13.3 85.3 56.9V416h48z" })
  }
), Fo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m232-136v91.2L173.3 172l-20-13.3-26.6 39.9 20 13.3 96 64 37.3 24.9V96h-48z" })
  }
), To = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0m464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0M232 392V232h152v48H280v136h-48z" })
  }
), Ao = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m232-136v160h152v-48H280V96h-48z" })
  }
), Do = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-104v264h-48V128h48z" })
  }
), yo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v160h-48V96h48z" })
  }
), bo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0m464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0M232 392V243.2l10.7-7.1 96-64 20-13.3 26.6 39.9-20 13.3-85.3 56.8V416h-48z" })
  }
), fo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m280-136v91.2l58.7-39.2 20-13.3 26.6 39.9-20 13.3-96 64-37.3 24.9V96h48z" })
  }
), Uo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m232-136v148.8l10.7 7.1 96 64 20 13.3 26.6-39.9-20-13.3-85.3-56.8V96h-48z" })
  }
), Go = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h256v-80h48v128H0V160h128v48H48zm160-160h256V48H208zm-48 48V0h352v352H208z" })
  }
), qo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-12.9-10V32H70.5zm84 65.2H560v332l-91.4-71c14.9-7.8 27.5-19.5 36.5-33.6l-40.5-25.7C456 295.1 441 304 424 304c-1.1 0-2.2 0-3.2-.1L378.4 271c-1.6-4.7-2.4-9.8-2.4-15 0-26.5 21.5-48 48-48 17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6-45.4 0-83.4 31.5-93.4 73.9L302 211.7l11.1-7.1c-16.4-25.8-44.9-43.4-77.6-44.6zM32 432v48h455.4l-60.9-48H80V159l-48-37.8zm104-176c0 53 43 96 96 96 24.1 0 46.2-8.9 63-23.6l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4-26.5 0-48-21.5-48-48 0-4.7.7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256" })
  }
), Wo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm152 176c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C232 295.1 217 304 200 304c-26.5 0-48-21.5-48-48s21.5-48 48-48m144 48c0-26.5 21.5-48 48-48 17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-47-44.6-81.1-44.6-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C424 295.1 409 304 392 304c-26.5 0-48-21.5-48-48" })
  }
), Eo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M211.4 91.3C221 38.4 267 0 320.8 0 382.2 0 432 49.8 432 111.2v2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9 267.6 180.8 10.6 7.1V512H0V411.3l10.6-7.1 295.6-199.9 50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5v-2.9c0-34.8-28.3-63.1-63.2-63.1-30.6 0-56.7 21.8-62.2 51.9l-3 16.4-4.3 23.6-47.2-8.6 4.3-23.6 3-16.4zM320 253 48 436.7V464h544v-27.3z" })
  }
), Oo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zm-369-39-17-17 34-33.9 17 17 39 39V160h48v158.1l39-39 17-17 33.9 33.9-17 17-80 80-17 17-17-17-80-80z" })
  }
), Io = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zm-369-97 80-80 17-17 17 17 80 80 17 17-34 33.9-17-17-39-39V408h-48V249.9l-39 39-17 17-33.9-33.9 17-17z" })
  }
), No = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM176 176h96v96h-96v-80zm32 32v32h32v-32zm80-32h48v96h-32v-64h-16zm96 0h80v96h-96v-96zm16 64h32v-32h-32zm-208 64h48v96h-32v-64h-16zm80 0h96v96h-96v-80zm32 32v32h32v-32zm96-32h32v96h-32v-64h-16v-32z" })
  }
), Xo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M572.7 178.3c-16.6 38.9-51.7 67.8-94.2 75.6-6-36.9-30-67.8-62.7-83.2-2.1-46.3-32.5-85.3-74.2-100.2C362.5 28.7 405.7 0 455.5 0c12.2 0 24 1.7 35.1 4.9C459 20.6 437.2 53.3 437.2 91c0 53 42.8 96 95.6 96 14.2 0 27.7-3.1 39.9-8.7zM176.6 112c-26.5 0-48 21.5-48 48v48h-32c-26.5 0-48 21.5-48 48v48h68.5L64 344.3v7.7H.6v-96c0-47.6 34.6-87 80-94.7V160c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.7-14.4 45.8-14.4 44.2 0 80 35.8 80 80v17.6c36.5 7.4 64 39.7 64 78.4v80H352v-48h48.6v-32c0-17.7-14.3-32-32-32h-32v-64c0-17.7-14.3-32-32-32-17.3 0-31.4 13.7-32 30.8l-48-.9V160c0-26.5-21.5-48-48-48M144 512l40-128H96v-24l176-136-40 128h88v24z" })
  }
), Ko = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.3 0 208 60.7 294.7 0l13.2 79c-20.5 10.9-37.7 27.3-49.6 47.2-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2v97.8L121.3 416 104 312 0 294.7 60.7 208 0 121.3 104 104zm173.4 416-.1-.1h.2v.1zm-52.6-247.6c-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.7-20.3-28.3-20.3-46.8 0-35.3 28.7-64 64-64 13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6zM368.6 144c-26.5 0-48 21.5-48 48v48H288c-26.5 0-48 21.5-48 48v48h16v48h-64v-96c0-47.8 34.9-87.4 80.6-94.8V192c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.7-14.4 45.8-14.4 44.2 0 80 35.8 80 80v17.7c36.2 7.6 63.4 39.8 63.4 78.3v80h-96v-48h48v-32c0-17.7-14.3-32-32-32h-31.4v-64c0-17.7-14.3-32-32-32-11.8 0-22.2 6.4-27.7 16h-52.3c0-26.5-21.5-48-48-48M336 512l40-128h-88v-24l176-136-40 128h88v24z" })
  }
), Qo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 176v-48c0-26.5-21.5-48-48-48-9.7 0-18.7 2.8-26.2 7.7L255 113l-26.6-37.8C216.7 58.7 197.6 48 176 48c-35.3 0-64 28.7-64 64v55.4l-32 11.3c-18.7 6.6-32 24.5-32 45.3v48h159.2L144 320H0v-96c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96 53 0 96 43 96 96v96H323.5l15-48H464v-48c0-26.5-21.5-48-48-48zM232 384h-88v-24l176-136-40 128h88v24L192 512z" })
  }
), Zo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM433 241 305 369l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47L399 207l17-17 33.9 34-17 17z" })
  }
), Jo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm88 56v-24H40v96h48v-24zm96 64v-24h-48v96h48v-24zm192-24h-48v96h48v-72zm-96-40v-24h-48v96h48v-24zm192-24h-48v96h48v-72z" })
  }
), jo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM344 160v160h-48V160zm-48 192h48v48h-48z" })
  }
), Yo = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 128v48h48c26.5 0 48 21.5 48 48v48H112v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM64 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0c-61.9 0-112 50.1-112 112v21.5c-37.3 13.1-64 48.7-64 90.5v48zM0 368v48h576v-48H24zm64 96v48h160v-48H88zm208 0v48h368v-48H296z" })
  }
), _o = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm104 32H48l-28.8 64h56zm120 0h-56L96 512h56zm56 0-28.8 64h56l28.8-64zm176 0h-56l-72 160h56zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), hn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M96 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), cn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M266.3 48.1C246 18.9 213.1 0 176 0 114.1 0 64 52.7 64 117.6v22.5C26.7 154 0 191.3 0 235.2V336h133.6l-2.9-14.4 12.1-12.1 21.6-21.5H48v-52.8c0-24.4 14.7-43.4 32.7-50.1l31.3-11.6v-55.9c0-40.7 30.8-69.6 64-69.6 20.6 0 39.6 10.6 51.8 28.7l27 40.2 40-27.4c7.5-5.1 16.1-7.9 25.3-7.9 24.3 0 48 21.4 48 52.8v48h48c24.3 0 48 21.4 48 52.8V288H347.6l21.5 21.5 12.1 12.1-2.8 14.4H512V235.2c0-55.7-43-100.8-96-100.8 0-55.7-43-100.8-96-100.8-18.7 0-36.1 5.6-50.9 15.3-.5.3-1 .7-1.5 1-.4-.6-.8-1.2-1.3-1.8zm-94.2 386.6-6.6 33.1 22.6 22.6 33.1-6.6L240 512h32l18.7-28.1 33.1 6.6 22.6-22.6-6.6-33.1L368 416v-32l-28.1-18.7 6.6-33.1-22.6-22.6-33.1 6.6L272 288h-32l-18.7 28.1-33.1-6.6-22.6 22.6 6.6 33.1L144 384v32zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), sn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zm-344-88h168v48H224v-48z" })
  }
), vn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M429.2 107.1c0 53 42.8 96 95.6 96 18.8 0 36.4-5.5 51.2-14.9-20.7 39-60.9 65.9-107.5 67.8-11-23.3-29.9-42.2-53.1-53.2-2.2-47.4-33.7-87.1-76.7-101.2C350.9 43.5 402.1 0 463.5 0c18.8 0 36.7 4.1 52.8 11.5-48.8 4.4-87 45.5-87 95.6zM64 416h56l-64 96H0zm96 0h56l-64 96H96zm152 0-64 96h-56l64-96zm40 0h56l-64 96h-56zM176.6 144c-26.5 0-48 21.5-48 48v48H96c-26.5 0-48 21.5-48 48v48h352v-32c0-17.7-14.3-32-32-32h-31.4v-64c0-17.7-14.3-32-32-32-14.9 0-27.5 10.2-31 24h-49v-8c0-26.5-21.5-48-48-48zm208 240H0v-96c0-47.8 34.9-87.4 80.6-94.8V192c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.7-14.4 45.8-14.4 44.2 0 80 35.8 80 80v17.7c36.2 7.6 63.4 39.8 63.4 78.3v80h-24z" })
  }
), en = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M550.4 24.7C533.2 19 514.8 16 495.8 16 398.7 16 320 94.9 320 192.2c0 11.4 1.1 22.6 3.2 33.4 51 8.8 90.2 52.1 92.6 105.1 16.3 7.7 30.4 19.2 41.2 33.4 12.5 2.8 25.5 4.3 38.8 4.3 56.6 0 106.9-26.8 139.1-68.4-14.6 5-30.3 7.7-46.7 7.7-79.5 0-144-64.5-144-144 0-66.5 45-122.4 106.2-139zM128.6 320c0-26.5 21.5-48 48-48s48 21.5 48 48v13.9l48 .9c.6-17.1 14.7-30.8 32-30.8 17.7 0 32 14.3 32 32v64h32c17.7 0 32 14.3 32 32v32h-352v-48c0-26.5 21.5-48 48-48h32v-24zm256 192h64v-80c0-38.7-27.5-71-64-78.4V336c0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.8-27.8-47.4-46.4-82.2-46.4-53 0-96 43-96 96v1.3C35.2 328.9.6 368.4.6 416v96h360z" })
  }
), ln = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM416 184v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V376c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V220.9l10.4-3.9 128-48 21.6-8.1z" })
  }
), tn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zm-296 48v-88h-88v-48h88v-88h48v88h88v48h-88v88z" })
  }
), wn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM232 216c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L344 296.4V328h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H288c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48z" })
  }
), gn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm96 48-40.9 68.1c-4.7 7.8-7.1 16.7-7.1 25.8v2.1c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8zm160 0-40.9 68.1c-4.7 7.8-7.1 16.7-7.1 25.8v2.1c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8zm119.1 68.1c-4.7 7.8-7.1 16.7-7.1 25.8v2.1c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8L416 368z" })
  }
), mn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M317.5 192C371.1 105.6 466.8 48 576 48V0C440.1 0 322.3 77 263.6 189.7c4.2 3.2 8.2 6.6 11.9 10.2 13.1-4.9 27.2-7.6 41.9-7.9zm91.5 36c37.9-51 98.6-84 167-84V96c-85.2 0-160.7 41.6-207.2 105.6 15.1 6.2 28.7 15.2 40.2 26.4m35.8 63.2c10.8 2.5 21.1 6.3 30.7 11.4C493.7 265.5 531.9 240 576 240v-48c-58.7 0-110 31.6-137.8 78.7 2.7 6.6 5 13.4 6.6 20.5M368 320v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V304c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 512h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5-20.3-28.7-53.7-47.5-91.6-47.5-61.9 0-112 50.1-112 112v21.5C26.7 338.6 0 374.2 0 416v48z" })
  }
), an = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm0 192h48l72-160H72zm192-160-72 160h48l72-160zm160 0h-48l-72 160h48zm72 0-72 160h48l72-160z" })
  }
), on = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 48c-33.9 0-61.7 26.4-63.9 59.8l-1.4 22.5H152c-22.1 0-40 17.9-40 40V192h352v-21.7c0-22.1-17.9-40-40-40h-20.8l-4.1-18.9c-3.9-18-20-31.4-39.1-31.4-8.4 0-16.2 2.6-22.6 7l-21.2 14.6-13.1-22.1C291.9 60.6 271.4 48 248 48M139.8 83.1C152.5 35.3 196.1 0 248 0c33 0 62.6 14.3 83.1 36.9 9.1-3.2 18.8-4.9 28.9-4.9 35.7 0 66.4 21.2 80.2 51.8 40.9 7.6 71.8 43.4 71.8 86.5V240H64v-69.7c0-44.4 33-81.2 75.8-87.2zM95 272h48L80 384H32zm112 0h48l-63 112h-48zm112 0h48l-63 112h-48zm112 0h48l-63 112h-48zM79 488.9C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.8 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), nn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm136 32H88v128h48V376zm192 0h-48v128h48V376zm-96 56v-24h-48v128h48v-24zm192-24h-48v128h48V408z" })
  }
), rn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 24.7-31.9h4.8V352c0-59.6-40.8-109.8-96-124v-20c0-70.7-57.3-128-128-128-13.9 0-27.3 2.2-39.9 6.3C346.8 53 303.9 32 256 32c-46.8 0-89 20.1-118.2 52.2L48.4 14.8zm127.5 99C196.2 92.9 224.6 80 256 80c33.5 0 63.5 14.6 84.1 38l20.9 23.8 30.1-9.8c7.8-2.5 16.1-3.9 24.9-3.9 44.2 0 80 35.8 80 80v57.2l36 9.3c34.5 8.9 60 40.3 60 77.5v80h-6.2L175.9 113.8zM144 234.1v-24.6l-46.8-36.9C96.4 179 96 185.5 96 192v8.2C40.1 220 0 273.3 0 336v144h487.4l-60.9-48H48v-96c0-41.7 26.6-77.3 64-90.6z" })
  }
), dn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm216 32h-48v40h-40v48h40v40h48v-40h40v-48h-40v-16zm256 0h-48v40h-40v48h40v40h48v-40h40v-48h-40v-16zm-352 0H72L0 512h48zm256 0h-48l-72 160h48z" })
  }
), Sn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128v48h48c26.5 0 48 21.5 48 48v48H48v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V112c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM0 320h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48zm88 32H40v40H0v48h40v40h48v-40h40v-48H88v-16zm192 32h-48v40h-40v48h40v40h48v-40h40v-48h-40v-16zm192-8v-24h-48v40h-40v48h40v40h48v-40h40v-48h-40z" })
  }
), zn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.3 0 104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 38.7-27.1v-97.7c-28.7-16.6-48-47.6-48-83.2 0-53 43-96 96-96 18.4 0 35.6 5.2 50.2 14.1 11.9-19.9 29.1-36.2 49.6-47.2L294.7 0 208 60.7zm173.2 415.9.1.1H248l-64 96h56l64-96h-9.3v-.1zm-52.4-247.5c.8-4.3 1.8-8.5 3-12.6-10.4-7.4-23.3-11.8-37.1-11.8-35.3 0-64 28.7-64 64 0 18.5 7.8 35.1 20.3 46.8 10.6-39.7 39.9-71.8 77.8-86.4zm78.5 23.6c0-26.5 21.5-48 48-48s48 21.5 48 48v13.9l48 .9c.6-17.1 14.7-30.8 32-30.8 17.7 0 32 14.3 32 32v64H560c17.7 0 32 14.3 32 32v32H240v-48c0-26.5 21.5-48 48-48h32.6v-24zm256 192H640v-80c0-38.5-27.2-70.7-63.4-78.3V208c0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C434 114.6 403.4 96 368.6 96c-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v96h360.6zM344 416l-64 96h56l64-96zm152 0h-56l-64 96h56zm40 0-64 96h56l64-96z" })
  }
), pn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.3 0 104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4-7.5 1.9-15.3 2.9-23.4 2.9-53 0-96-43-96-96s43-96 96-96 96 43 96 96v1.1c18.4-10.7 39.8-16.8 62.5-17.1l49.6-70.8L312 104 294.7 0 208 60.7zM272 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0m96.6 64c26.5 0 48 21.5 48 48v8h49c3.5-13.8 16.1-24 31-24 17.7 0 32 14.3 32 32v64H560c17.7 0 32 14.3 32 32v32H240v-48c0-26.5 21.5-48 48-48h32.6v-48c0-26.5 21.5-48 48-48m208 240H640v-80c0-38.5-27.2-70.7-63.4-78.3V336c0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.8-27.8-47.4-46.4-82.2-46.4-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v96h360.6z" })
  }
), Mn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zm-448-64h208v32H128v-32zm112 64v32H128v-32h112zm256 0v32H288v-32h208zm-128-64h128v32H384z" })
  }
), xn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160 47.9 0 90.8 21 120.1 54.3 12.6-4.1 26-6.3 39.9-6.3 70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v128H0v-48zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V208c0-44.2-35.8-80-80-80-8.8 0-17.1 1.4-24.9 3.9l-30.1 9.9-20.9-23.8c-20.6-23.4-50.6-38-84.1-38-61.9 0-112 50.1-112 112V234.1l-32 11.3c-37.4 13.3-64 48.9-64 90.6v96h544zM417.9 224l-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), Hn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 200.2C40.1 220 0 273.3 0 336v144h640V352c0-59.6-40.8-109.8-96-124v-20c0-70.7-57.3-128-128-128-13.9 0-27.3 2.2-39.9 6.3C346.8 53 303.9 32 256 32c-88.4 0-160 71.6-160 160zM592 432H48v-96c0-41.7 26.6-77.3 64-90.5l32-11.3V192c0-61.9 50.1-112 112-112 33.5 0 63.5 14.6 84.1 38l20.9 23.8 30.1-9.8c7.8-2.5 16.1-3.9 24.9-3.9 44.2 0 80 35.8 80 80v57.2l36 9.3c34.5 8.9 60 40.3 60 77.5v80z" })
  }
), Vn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 140c0-67.7 51-123.5 116.7-131.1C548.2 3.1 530.5 0 512 0c-88.4 0-160 71.6-160 160 0 11.5 1.2 22.7 3.5 33.5 53.7 8.2 96.5 49.8 106.4 103 14.2 5.4 27.1 13.3 38.4 23.1 3.9.3 7.8.4 11.8.4 51.2 0 96.7-24 126-61.4-17.5 8.6-37.2 13.4-58 13.4-72.9 0-132-59.1-132-132zM335.3 272c26.5 0 48 21.5 48 48v48h32c26.5 0 48 21.5 48 48v48h-352v-32c0-17.7 14.3-32 32-32h32v-64c0-17.7 14.3-32 32-32 17.3 0 31.4 13.7 32 30.8l48-.9V320c0-26.5 21.5-48 48-48m-208 240h384v-96c0-47.6-34.6-87-80-94.7V320c0-53-43-96-96-96-34.9 0-65.4 18.6-82.2 46.4-13-9.1-28.7-14.4-45.8-14.4-44.2 0-80 35.8-80 80v17.6c-36.5 7.4-64 39.7-64 78.4v80h64m106-335.8H256c8.8 0 16 7.2 16 16v17.1c14.4-8.4 30.7-14 48-16.2v-.9c0-35.3-28.6-64-64-64h-22.6c-12.3-28.2-40.5-48-73.3-48-38.7 0-71 27.5-78.4 64h-9.6c-39.8 0-72 32.2-72 72v72h106.7c9.4-19.9 24.6-36.6 43.4-48H48v-24c0-13.2 10.7-24 24-24H120.8l7.8-38.5c3-14.6 15.9-25.5 31.3-25.5 13 0 24.4 7.8 29.3 19.2l12.8 28.7h31.4z" })
  }
), Cn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.3 0 104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4-7.5 1.9-15.3 2.9-23.4 2.9-53 0-96-43-96-96s43-96 96-96c36.6 0 68.4 20.5 84.6 50.6 7.5-23.3 23.6-42.6 44.5-54.4l-25-4.3L294.7 0 208 60.7zM272 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0m134.6-32H438l12.6-28.8c5-11.4 16.3-19.2 29.3-19.2 15.4 0 28.4 11 31.3 25.5L519 192H567.8c13.2 0 24 10.7 24 24v24h-38.1c18.8 11.3 33.9 28.1 43.4 48h42.8v-72c0-39.8-32.2-72-72-72h-9.6c-7.4-36.5-39.7-64-78.4-64-32.8 0-61 19.7-73.3 48H384c-35.3 0-64 28.6-64 64 0 3 .2 6 .6 8.9 14.6-5.8 30.6-9 47.3-9h.1c.1-8.8 7.2-15.9 16-15.9h22.6zm-38 96c26.5 0 48 21.5 48 48v8h49c3.5-13.8 16.1-24 31-24 17.7 0 32 14.3 32 32v64H560c17.7 0 32 14.3 32 32v32H240v-48c0-26.5 21.5-48 48-48h32.6v-48c0-26.5 21.5-48 48-48m208 240H640v-80c0-38.5-27.2-70.7-63.4-78.3V336c0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.8-27.8-47.4-46.4-82.2-46.4-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v96h360.6z" })
  }
), Ln = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M390.4 188.8c4.6 3.5 9 7.2 13.1 11.1 12.2-4.5 25.3-7.2 39-7.8 3.6-10 5.5-20.9 5.5-32.1 0-53-43-96-96-96h-42.8C291.2 26.2 252.7 0 208 0 151.6 0 104.9 41.7 97.1 96H96c-53 0-96 43-96 96v96h160.9c1.9-17.1 6.8-33.3 14.1-48H48v-48c0-26.5 21.4-47.9 47.9-48h1l41.9.2 5.9-41.5C149.1 71.8 175.8 48 208 48c25.5 0 47.5 14.9 57.9 36.6l13 27.4H352c26.5 0 48 21.5 48 48 0 10.8-3.6 20.8-9.6 28.8M496 320v48h48c26.5 0 48 21.5 48 48v48H176v-48c0-20.8 13.3-38.7 32-45.3l32-11.3V304c0-35.3 28.7-64 64-64 21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7 26.5 0 48 21.5 48 48zM128 512h512v-96c0-53-43-96-96-96 0-53-43-96-96-96-19.3 0-37.3 5.7-52.4 15.5-20.3-28.7-53.7-47.5-91.6-47.5-61.9 0-112 50.1-112 112v21.5c-37.3 13.2-64 48.7-64 90.5v48z" })
  }
), Bn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M277.2 32h-31.1l-7 7-15 15L209 39l-7-7h-31.2C129.5 32 96 65.5 96 106.8c0 8.8 1.6 17.5 4.6 25.7-8.2-3-16.9-4.6-25.7-4.6C33.5 128 0 161.5 0 202.8v31.1l7 7 15 15L7 271l-7 7v31.2C0 350.5 33.5 384 74.8 384c8.8 0 17.5-1.6 25.7-4.6-3 8.2-4.6 16.9-4.6 25.7 0 41.3 33.5 74.8 74.8 74.8H201.9l7-7 15-15 15 15 7 7H277.2c41.3 0 74.8-33.5 74.8-74.8 0-8.8-1.6-17.5-4.6-25.7 8.2 3 16.9 4.6 25.7 4.6 41.3 0 74.8-33.5 74.8-74.8v-31.1l-7-7-15-15 15-15 7-7V202.8c0-41.3-33.5-74.8-74.8-74.8-8.8 0-17.5 1.6-25.7 4.6 3-8.2 4.6-16.9 4.6-25.7 0-41.4-33.5-74.9-74.8-74.9M241 105l25-25h11.2C292 80 304 92 304 106.8c0 4.6-1.2 9-3.4 13L267 180.3l-13.8 24.9 21.6 21.6 24.9-13.8 60.5-33.6c4-2.2 8.5-3.4 13-3.4 14.8 0 26.8 12 26.8 26.8V214l-25 25-17 17 17 17 25 25v11.2c0 14.8-12 26.8-26.8 26.8-4.6 0-9-1.2-13-3.4L299.7 299l-24.9-13.8-21.6 21.6 13.8 24.9 33.6 60.5c2.2 4 3.4 8.5 3.4 13 0 14.8-12 26.8-26.8 26.8h-11.3l-25-25-17-17-17 17-25 25h-11.1c-14.8 0-26.8-12-26.8-26.8 0-4.6 1.2-9 3.4-13l33.6-60.5 13.8-24.9-21.6-21.6-24.9 13.8-60.4 33.6c-4 2.2-8.5 3.4-13 3.4C60 336 48 324 48 309.2v-11.3l25-25 17-17L73 239l-25-25v-11.2C48 188 60 176 74.8 176c4.6 0 9 1.2 13 3.4l60.5 33.6 24.9 13.8 21.6-21.6-13.8-24.9-33.6-60.5c-2.2-4-3.4-8.5-3.4-13C144 92 156 80 170.8 80H182l25 25 17 17z" })
  }
), un = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m351.7 136.8 2.5 34 32.9 8.8C431.4 191.5 464 232 464 280c0 57.4-46.6 104-104 104-27.5 0-52.5-10.6-71.2-28.1L256 325l-32.8 30.8C204.5 373.4 179.5 384 152 384c-57.4 0-104-46.6-104-104 0-48 32.6-88.5 76.9-100.4l32.9-8.8 2.5-34C163.9 87.1 205.4 48 256 48s92.1 39.1 95.7 88.8m47.9-3.5C394.1 58.7 331.9 0 256 0S117.9 58.7 112.4 133.2C47.7 150.6 0 209.8 0 280c0 83.9 68.1 152 152 152 29.4 0 56.8-8.3 80-22.7V464h-72v48h192v-48h-72v-54.7c23.2 14.4 50.6 22.7 80 22.7 83.9 0 152-68.1 152-152 0-70.2-47.7-129.4-112.4-146.8z" })
  }
), Rn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zm120.7-26.4C361.5-4.8 309.6-5.7 260.4 9.5 210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512c10.6 0 21-.6 31.2-1.9l3.8 3.8 5-5C404 491.7 491.7 404 508.9 293l5-5-3.8-3.8c1.2-10.2 1.9-20.7 1.9-31.2 0-68.7-27.3-134.6-75.9-183.2zM265 423l-17-17-33.9 34 17 17 6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9 12.1-1.5 24.2-4.3 36.3-8 50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3 23.7 32 37.9 70.2 40.9 110.1L457 231l-17-17-33.9 34 17 17 35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343l-17-17-33.9 34 17 17 41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4zm-9-167c62.5-62.5 92.9-133.4 67.9-158.4S228 103 165.5 165.5 72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z" })
  }
), $n = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v64h64V48zM0 0h160v160h-56v96c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72h-56V0h160v160h-56c0 66.3-53.7 120-120 120h-96c-39.8 0-72 32.2-72 72h56v160H0V352h56V160H0V48zm112 400H48v64h64zM400 48h-64v64h64z" })
  }
), kn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 160v192h192V160zm-48-48h288v120h176v48H464v120H176V280H0v-48h176v-72z" })
  }
), Pn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 416 96-96h32v72h16c39.8 0 72-32.2 72-72V160h-56V0h160v160h-56v160c0 66.3-53.7 120-120 120h-16v72h-32zM400 48v64h64V48zm-80 48-96 96h-32v-72h-16c-39.8 0-72 32.2-72 72v160h56v160H0V352h56V192c0-66.3 53.7-120 120-120h16V0h32zM48 400v64h64v-64z" })
  }
), Fn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48v64H48V48zM48 0H0v160h56v32c0 48.6 39.4 88 88 88h56v72h-56v160h160V352h-56v-72h56c48.6 0 88-39.4 88-88v-32h56V0H288v160h56v32c0 22.1-17.9 40-40 40H144c-22.1 0-40-17.9-40-40v-32h56V0h-48zm352 48v64h-64V48zM192 400h64v64h-64z" })
  }
), Tn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v64h64V48zM0 0h160v160h-54.8c7.7 49.8 50.8 88 102.8 88h80v-56h160v160H288v-56h-80c-40.2 0-76.8-15.6-104-41.1V352h56v160H0V352h56V160H0V48zm48 400v64h64v-64zm352-160h-64v64h64z" })
  }
), An = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48v64h64V48zM32 0h160v160h-56v192h56v160H32V352h56V160H32V48zm345 23 23 23 23-23 17-17 33.9 34L457 57l-23 23 23 23 17 17-34 33.9-17-17-23-23-23 23-17 17-33.9-33.9 17-17 23-23L343 57l-17-17 34-33.9 17 17zm47 177v152h56v160H320V352h56V200zM80 400v64h64v-64zm288 0v64h64v-64z" })
  }
), Dn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v64h64V48zM0 0h160v160h-56v192h56v160H0V352h56V160H0V48zm48 400v64h64v-64zm352 0h-64v64h64zm-64-48h112v160H288V352zm-16-160h96v96h-96zm96-160v96h-96V32z" })
  }
), yn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48H48v64h64zM48 0h112v160h-56v192h56v160H0V352h56V160H0V0zm0 400v64h64v-64zm352 0v64h64v-64zm-48-48h56V192c0-39.8-32.2-72-72-72h-16v72h-32l-96-96 96-96h32v72h16c66.3 0 120 53.7 120 120v160h56v160H352V400z" })
  }
), bn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m367 114.8-16.9-17 34-33.8L401 81l157 158.1 16.8 16.9-16.8 16.9L401 431l-16.9 17-34.1-33.8 16.9-17L507.2 256 367 114.8zm-173.1-.9L67.2 256l126.7 142.2 16 17.9-35.8 31.9-16-17.9L17.1 272 2.9 256l14.2-16 141-158.1 16-17.9 35.8 32z" })
  }
), fn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m376.5 1.8-7.3 22.8-144 448-7.3 22.8 45.7 14.7 7.3-22.8 144-448 7.3-22.8-45.7-14.7zm61.6 135.3 17.5 16.4L564.9 256 455.6 358.5l-17.5 16.4 32.8 35 17.5-16.4 128-120 18.7-17.5-18.7-17.5-128-120-17.5-16.4-32.8 35zm-269-35-17.5 16.4-128 120L4.9 256l18.7 17.5 128 120 17.5 16.4 32.8-35-17.5-16.4L75.1 256l109.3-102.5 17.5-16.4-32.8-35z" })
  }
), Un = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m380.3 125.1-38.8 77.6-2.9 5.7-5.3 3.5-187.1 124.8-44.3 80.5c22 11.1 49.7 15.2 81.3 10.7 45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c5.1-36-1-66.9-15.7-90.1zm-36.8-33.9c-22.3-11.8-50.7-16.4-83.4-11.7-45.5 6.5-96.1 30.9-138.9 73.8S54 246.7 47.5 292.2c-5.3 37.4 1.4 69.3 17.4 92.8l42.1-76.6 2.8-5.1 4.9-3.3 186.7-124.4 42.2-84.3zm57.4-16.7c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8-54.2-214.6 44.8-313.6S326.7.3 400.9 74.5z" })
  }
), Gn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8 210.6 173 273.1 235.4 426.8 308 476.8 258m-77.9-76.1 32.3 50.8c-28.8 16-79.8 13.1-124.1-31.3-33.5-33.5-43.4-70.8-39.3-99.5l29.3 46 101.8 33.9zm21.3-93.6c33.5 33.5 43.4 70.8 39.3 99.5l-29.3-46-101.8-34L296.1 57c28.8-16 79.7-13 124.1 31.3zM126.7 403.1l-13.1 58.8C82 452.8 48 414.7 48 352c0-47.4 19.4-80.7 42.6-98.1l-10 44.9-1.8 8.3 3.8 7.6 44.2 88.4zM208 352c0 47.4-19.4 80.8-42.6 98.1l10-44.9 1.8-8.3-3.8-7.6-44.2-88.4 13.1-58.8C174 251.2 208 289.3 208 352m-80 160c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160" })
  }
), qn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h480l-17.5 48-35.2 96.8C478.4 211.3 512 269.7 512 336v8c0 80-72 136-72 136H136s-72-56-72-136v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H48v144H0V56zm191.2 128h191.2l29.1-80H155.6zm-78.3 160h350.2c-5.4-48.9-35.3-90.4-77.1-112H190c-41.8 21.6-71.7 63.1-77.1 112m308.5 112H154.6z" })
  }
), Wn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M52.8 154.3 135.5 48h113l82.7 106.3L243.7 464H140.3zM104 512h176l104-368L272 0H112L0 144zm112-392V96h-48v64H96v48h72v144h48V208h72v-48h-72z" })
  }
), En = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.3 464h103.4l87.5-309.7L248.5 48h-113L52.8 154.3zM280 512H104L0 144 112 0h160l112 144z" })
  }
), On = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 304c64 0 119.6-14.7 157.5-36 39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60c-37.9-21.3-93.5-36-157.5-36s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36M0 208C0 128.5 114.6 64 256 64s256 64.5 256 144v112c0 70.7-114.6 128-256 128S0 390.7 0 320v-64zm256 144c-13.6 0-27-.6-40-1.7v48a471.705 471.705 0 0 0 80 0v-48c-13 1.1-26.4 1.7-40 1.7m-136-22v47.7c18.7 7 40.3 12.7 64 16.6v-48.1c-22.8-3.8-44.3-9.2-64-16.2m-32-13.3C73 309.3 59.6 301 48 292v28c0 6.8 6.2 24.2 40 43.1v-46.5zm240 29.6v48.1c23.7-3.9 45.3-9.6 64-16.6v-47.7c-19.7 7-41.2 12.5-64 16.2M464 320v-28c-11.6 9.1-25 17.4-40 24.7v46.5c33.8-18.9 40-36.3 40-43.1z" })
  }
), In = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352m24-248v-24h-48v192h48v-24z" })
  }
), Nn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256S62.7 136.4 84 98.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5M0 256c0 141.4 64.5 256 144 256h112c70.7 0 128-114.6 128-256S326.7 0 256 0H144C64.5 0 0 114.6 0 256m286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40h48a471.705 471.705 0 0 1 0 80zm-4 32h48.1c-3.9 23.7-9.6 45.3-16.6 64H266c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40h46.5c-18.9 33.8-36.3 40-43.1 40zm102.3-280h-48.1c-3.8-22.8-9.2-44.3-16.2-64h47.7c7 18.7 12.7 40.3 16.6 64m-31.2-96h-46.4C245.3 73 237 59.6 228 48h28c6.8 0 24.2 6.2 43.1 40M120 256c0-40.2 5.2-75.7 12.9-100.3 3.7-11.8 7.7-19.9 11.1-24.7 3.4 4.8 7.3 12.9 11.1 24.7 7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7-3.4-4.8-7.3-12.9-11.1-24.7-7.8-24.6-12.9-60-12.9-100.3m27.4-128.8a.2.2 0 1 0 .1.4.2.2 0 1 0-.1-.4m-6.6.1a.2.2 0 1 0-.5.1.2.2 0 1 0 .5-.1m-.2 257.4a.2.2 0 1 0-.1-.4.2.2 0 1 0 .1.4m6.6-.1a.2.2 0 1 0 .5-.1.2.2 0 1 0-.5.1M144 80c-17.7 0-30.3 11.3-37.9 21.6-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7 7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7 9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80" })
  }
), Xn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60c-37.9 21.3-93.5 36-157.5 36s-119.6-14.7-157.5-36M256 64C114.6 64 0 128.5 0 208v112c0 70.7 114.6 128 256 128s256-57.3 256-128V208c0-79.5-114.6-144-256-144m-40 286.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7v48a471.705 471.705 0 0 1-80 0zm-32-4v48.1c-23.7-3.9-45.3-9.6-64-16.6v-47.7c19.7 7 41.2 12.5 64 16.2M48 292c11.6 9.1 25 17.4 40 24.7v46.5c-33.8-19-40-36.4-40-43.2zm280 102.3v-48.1c22.8-3.8 44.3-9.2 64-16.2v47.7c-18.7 7-40.3 12.7-64 16.6m96-31.2v-46.5c15-7.3 28.4-15.6 40-24.7v28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9 11.8 3.7 19.9 7.7 24.7 11.1-4.8 3.4-12.9 7.3-24.7 11.1-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1 4.8-3.4 12.9-7.3 24.7-11.1 24.6-7.8 60-12.9 100.3-12.9m128.8 27.4a.2.2 0 1 0-.4.1.2.2 0 1 0 .4-.1m-.1-6.6a.2.2 0 1 0-.1-.5.2.2 0 1 0 .1.5m-257.4-.2a.2.2 0 1 0 .4-.1.2.2 0 1 0-.4.1m.1 6.6a.2.2 0 1 0 .1.5.2.2 0 1 0-.1-.5M432 208c0-17.7-11.3-30.3-21.6-37.9-10.7-8-24.6-14.2-39.7-18.9-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9 30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9 10.3-7.7 21.6-20.2 21.6-37.9" })
  }
), Kn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 88c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5.4.3.8.7 1.2 1-18.7.4-36.9 1.7-54.4 4.1V88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88v208c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6v-49.6c5.1-1.5 9.8-3.1 14.2-4.8 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.6-1.1.6-1.5.6-1.5v-43.7c-5.3 2.6-10.9 5-16.7 7.2-9.6 3.7-20.1 6.9-31.3 9.6v-49.6c5.1-1.5 9.8-3.1 14.2-4.8 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5v-43.7c-5.3 2.6-10.9 5-16.7 7.2-13.7 5.2-29.4 9.6-46.3 12.9-5.1-7.5-11-13.9-16.8-19.1-10.1-9.1-21.8-16.5-34-22.6 31.7-2.3 59.3-8.2 80-16.1 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5 0 0 0-.5-.6-1.5-.6-1.2-2-3.1-4.7-5.5-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7-2.7 2.4-4.1 4.3-4.7 5.5-.6 1.1-.6 1.5-.6 1.5zM48 216c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5 0 0 0-.5-.6-1.5-.6-1.2-2-3.1-4.7-5.5-5.5-5-14.9-10.6-28.5-15.7-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7-2.7 2.4-4.1 4.3-4.7 5.5-.6 1.1-.6 1.5-.6 1.5zm-48 0c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216v208c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424V320zm336 104v-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2V320c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5M64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2V424s0 .5.6 1.5c.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.6-1.1.6-1.5.6-1.5v-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z" })
  }
), Qn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m113.4 413-16.7 69.4 46.7 11.3 13.9-57.6c9.2 3.4 18.8 6.2 28.7 8.1l-9.2 38.2 46.7 11.3 11.1-45.9c58.5-3.1 110.1-32.5 143.2-76.5l-38.4-28.8c-22.1 29.4-55 50-92.9 55.9l62.4-258.7c11.6 8.4 21.8 18.6 30.4 30l38.4-28.8c-15.3-20.4-34.7-37.7-56.9-50.7l14.6-60.5-46.7-11.3-12.8 52.7c-9.5-2.7-19.2-4.6-29.2-5.8l8.6-35.7-46.6-11.2-11.5 47.5C103.9 78.9 32 159.1 32 256c0 64.9 32.2 122.2 81.4 157m55.2-24 66.7-276.5c10.1.8 19.9 2.6 29.3 5.4l-67.4 279.6c-9.9-1.9-19.5-4.8-28.6-8.5zm16.2-271.5-58.9 244C97.6 335.1 80 297.6 80 256c0-65.9 44.3-121.5 104.8-138.6z" })
  }
), Zn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 112v48h48v-48zM24 64h144v144H24v-96zm48 288v48h48v-48zm-48-48h144v144H24v-96z" })
  }
), Jn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 80v352h144V80zm-48 0H240v352h160zM192 432V80H48v352zM0 32h640v448H0V80z" })
  }
), jn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m304 16-50.4 29.2-152.3 88.2C38.6 169.7 0 236.6 0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3l88.2-152.3L496 208l-7.5.6-50.5 3.9-1.9.1 17.7-49.5 37.3-104.7L512 0l-58.4 20.9-104.7 37.4-49.5 17.6.1-1.9 3.9-50.5zM125.3 174.9l123.8-71.7-3.2 42.8 69.7-24.9 117.1-41.8-41.8 117.2-24.9 69.6 42.8-3.3-71.7 123.9C309.4 434.5 258.3 464 203 464c-85.6 0-155-69.4-155-155 0-55.3 29.5-106.4 77.3-134.1zm117.3 91L208 196.8l-34.6 69.1L96 277l56 53.8-13.2 76 69.2-35.9 69.2 35.9-13.2-76 56-53.8z" })
  }
), Yn = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112 362.9-45.2 76.9L81.6 336H112zM40 288 14.9 464 8 512h72l80-136v-88h-48z" })
  }
), _n = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h184v136h144V0h184v192H376v128h136v192H328V376H184v136H0V320h136V192H0V24zm136 144V48H48v96zm48 176v8h144V184H184v8zm-48 48H48v96h88v-88zm240 8v88h88v-96h-88zm0-232h88V48h-88v88z" })
  }
), hr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm264-328v-24h-48v134.1l-31-31-17-17-33.9 33.9 17 17 72 72 17 17 17-17 72-72 17-17-34.1-33.9-17 17-31 31z" })
  }
), cr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm184-328h-24v48h78.1l-87 87-17 17 33.9 33.9 17-17 87-87V312h48V152h-24z" })
  }
), sr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm264-152V217.9l31 31 17 17 33.9-33.9-17-17-72-72-17-17-17 17-72 72-17 17 34.1 33.9 17-17 31-31V352h48z" })
  }
), vr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm104-288H96v48h192v-48h-24zm224 0h-24v48h96v-48h-24zm-208 80h-24v48h80v-48h-24zm112 0h-24v48h176v-48h-24z" })
  }
), er = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm353-287 17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), lr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm201-287 17-17-34-33.9-17 17-64 64-17 17 17 17 64 64 17 17 33.9-34.1-17-17-47-47 47-47zm112-34-17-17-33.9 34 17 17 47 47-47 47-17 17 33.9 33.9 17-17 64-64 17-17-17-17-64-64z" })
  }
), tr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm260-336v-20h-40v26c-5.6 1.2-11 2.9-16 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 7 29.9 9.1V356h40v-25.5c5.4-1 10.6-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V144z" })
  }
), wr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm128-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64m144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), gr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm264-368h-48v160h48V136zm-48 240h48v-48h-48z" })
  }
), ir = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm128-260.8c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6 11 10.6 11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7 0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z" })
  }
), mr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112.7 358.8-10.8 28.9-7 18.5 57.6-17.3 13.9-4.2 13.9 4.2c23.3 7.1 48.8 11 75.7 11 124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 35.1 15 68.9 42.9 96.9l21.8 21.9zm-39 103.9L16 480l21.2-56.5L57 370.8C21.3 335.1 0 289.6 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1l-92.6 27.8zM144 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 144v16H144v-16l64-80 22 27.4 66-91.4z" })
  }
), ar = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm136-304h-24v48h256v-48h-24zm0 96h-24v48h160v-48h-24z" })
  }
), or = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm208-272h-64v64h64v64h64v-64h64v-64h-64v-64h-64z" })
  }
), nr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.2 145.4 279.4 128 256 90.6 232.6 128l-10.8 17.3-20 4.2C106.3 169.6 48 236.6 48 304c0 79.5 83.3 160 208 160s208-80.5 208-160c0-67.4-58.3-134.4-153.7-154.4l-20-4.2zM227.7 45.3 256 0l28.3 45.3 35.8 57.3C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4z" })
  }
), rr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.2 366.6 279.4 384 256 421.4 232.6 384l-10.8-17.3-20-4.2C106.3 342.4 48 275.4 48 208c0-79.5 83.3-160 208-160s208 80.5 208 160c0 67.4-58.3 134.4-153.7 154.4l-20 4.2zm-62.5 100.1L256 512l28.3-45.3 35.8-57.3C430.5 386.3 512 304.9 512 208 512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4z" })
  }
), dr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm168-264h-24v48h192v-48h-24z" })
  }
), Sr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm336-352v-23.1l-21.6 8.1-128 48-10.4 3.9v124.9c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V219.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V160z" })
  }
), zr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm288.8-336-29.1 29.1 47.3 47.3 29.1-29.1zm-51.7 51.7-85.2 85.2-7.9 55.2 55.3-7.9 85.1-85.2-47.3-47.3z" })
  }
), pr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm216-128h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), Mr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm152-312v6.5h48V168c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4-12.1 7V280h48v-31.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1H224c-30.9 0-56 25.1-56 56zm64 152v48h48v-48z" })
  }
), xr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm224-336H128v112h64v32h-48v48h96V184zm144 0H272v112h64v32h-48v48h96V184z" })
  }
), Hr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L513.7 376c38.8-36.5 62.3-84 62.3-136 0-114.9-114.6-208-256-208-68.2 0-130.2 21.7-176 57L48.4 14.8zm135 104.8C218.6 95.5 265.3 80 320 80c124.7 0 208 80.5 208 160 0 38.1-19.2 76.5-52.9 106.1L183.4 119.6zM112 240c0-16.2 3.4-32.4 10-47.9l-39-30.8c-12.3 24.3-19 50.9-19 78.7 0 49.6 21.3 95.1 56.9 130.8l-19.8 52.7L80 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 37 0 72.3-6.4 104-17.9l-46-36.3c-18.1 4-37.5 6.2-58 6.2-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.3 7-18.5 10.8-28.9-21.8-21.9c-28-28-42.9-61.8-42.9-96.9z" })
  }
), Vr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm176-272a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-151.6 46.1-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z" })
  }
), Cr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm180-300v120h24v-79l25.8 41.3 10.2 16.3 10.2-16.3L292 221v79h24V180h-26.7l-3.5 5.6-29.8 47.8-29.8-47.7-3.5-5.6H196zm-79.8 32.8c.3-1.8 1.7-4.3 6.2-6.4 4.6-2.1 11.5-3.1 19.9-1.8 2.9.5 12 2.2 14.6 2.9l11.6 3.1 6.2-23.2-11.6-3.1c-3.8-1-13.8-2.9-17.1-3.4-12-1.9-23.8-.7-33.5 3.7s-18 12.5-20 24.2c-1.1 6.6-.5 12.8 2.2 18.5 2.6 5.6 6.8 9.6 11.1 12.5 7.6 5.1 17.6 8.1 25.4 10.5l1.4.4c9.2 2.8 15.8 5 19.9 8 1.8 1.3 2.6 2.4 2.9 3.3.3.8.8 2.3.2 5.2-.5 2.9-2.1 5.2-6.1 6.9-4.4 1.9-11.2 2.7-20 1.4-4.1-.7-11.4-3.2-17.8-5.3-1.5-.5-2.9-1-4.2-1.4L96.1 265l-7.6 22.8 11.4 3.8c.8.3 1.8.6 3 1 6.2 2.1 16.3 5.6 22.7 6.6h.1c11.7 1.8 23.4 1.2 33.2-3 10.1-4.3 18.2-12.7 20.3-24.8 1.2-6.7.6-13.1-1.9-18.9-2.5-5.7-6.5-10-10.8-13.1-7.9-5.8-18.5-9-26.7-11.4l-.5-.1c-9.4-2.8-16-4.9-20.3-7.8-1.9-1.3-2.6-2.3-2.9-2.9-.2-.5-.6-1.7-.2-4.2zm240 0c.3-1.8 1.7-4.3 6.2-6.4 4.6-2.1 11.5-3.1 19.9-1.8 2.9.5 12 2.2 14.6 2.9l11.6 3.1 6.2-23.2-11.6-3.1c-3.8-1-13.8-2.9-17.1-3.4-12-1.9-23.8-.7-33.5 3.7s-18 12.5-20 24.2c-1.1 6.6-.5 12.8 2.2 18.5 2.6 5.6 6.8 9.6 11.1 12.5 7.6 5.1 17.6 8.1 25.4 10.5l1.4.4c9.2 2.8 15.8 5 19.9 8 1.8 1.3 2.6 2.4 2.9 3.3.3.8.8 2.3.2 5.2-.5 2.9-2.1 5.2-6.1 6.9-4.4 1.9-11.2 2.7-20 1.4-4.1-.7-11.4-3.2-17.8-5.3-1.5-.5-2.9-1-4.2-1.4l-11.4-3.8-7.6 22.8 11.4 3.8c.8.3 1.9.6 3 1 6.2 2.1 16.3 5.6 22.7 6.6h.1c11.7 1.8 23.4 1.2 33.2-3 10.1-4.3 18.2-12.7 20.3-24.8 1.2-6.7.6-13.1-1.9-18.9-2.5-5.7-6.5-10-10.8-13.1-7.9-5.8-18.5-9-26.7-11.4l-.5-.1c-9.4-2.8-16-4.9-20.3-7.8-1.9-1.3-2.6-2.3-2.9-2.9-.2-.5-.6-1.7-.2-4.2z" })
  }
), Lr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm168-320h-24v48h72v128h48V208h72v-48h-96z" })
  }
), Br = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.9 387.7 10.8-28.9-21.8-21.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.2zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8l-19.7 52.7zm337.9-304L320 142.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), ur = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112.7 358.8-10.8 28.9-7 18.5 57.6-17.3 13.9-4.2 13.9 4.2c23.3 7.1 48.8 11 75.7 11 124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 35.1 15 68.9 42.9 96.9l21.8 21.9zm-39 103.9L16 480l21.2-56.5L57 370.8C21.3 335.1 0 289.6 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1l-92.6 27.8z" })
  }
), Rr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96.7 271.5-11 27.4-7.1 17.6 70-16.2 10.1-2.3 10.2 2.1c12.4 2.5 25.5 3.9 39 3.9 96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 26.5 10.2 51.8 29.2 73.4l19.5 22.2zM57 370.9 0 384l21.7-54.3 19.4-48.6C15.3 251.8 0 215.4 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8zm188.2 10.6c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.5 0 26.6-1.3 39-3.9l10.2-2.1 10.1 2.3 70.1 16.2-7.1-17.6-11-27.4 19.5-22.2c19-21.5 29.2-46.9 29.2-73.4 0-59.9-56.8-120.7-144-127.4v-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l19.4 48.6L640 512l-57-13.1-102.5-23.7c-15.6 3.1-31.8 4.8-48.5 4.8-82 0-153-40.2-186.8-98.5M224 90.7v7c5.8 1 16.2 3 20.5 4.2L260 106l-8.1 30.9-15.5-4.1c-3.6-.9-15.8-3.3-19.8-3.9-11.3-1.8-20.8-.3-27 2.5-6.2 2.8-8.1 6.1-8.5 8.5-.6 3.3 0 4.8.3 5.4.4.8 1.3 2.1 3.9 3.9 5.8 3.9 14.9 6.7 27.5 10.4l.6.2c11 3.3 25.2 7.5 35.9 15.2 5.8 4.2 11.2 9.8 14.6 17.4 3.4 7.8 4.1 16.3 2.6 25.3-2.9 16.3-13.8 27.3-27.4 33.1-4.7 2-9.8 3.4-15.1 4.2v22.4h-32v-23.1c-8.6-1.7-20.5-5.8-28.1-8.4-1.6-.5-2.9-1-4.1-1.4l-15.2-5 10-30.4 15.2 5c1.8.6 3.7 1.2 5.6 1.9 8.6 2.9 18.5 6.2 24.1 7.1 11.8 1.8 21.1.7 27.1-1.8 5.5-2.3 7.6-5.4 8.3-9.1.7-3.8.1-5.8-.3-6.8-.5-1.1-1.5-2.6-4-4.3-5.6-4-14.5-7-27-10.7l-1.9-.6c-10.6-3.2-24.1-7.2-34.3-14-5.8-3.9-11.4-9.2-14.9-16.6-3.6-7.6-4.5-16-2.9-24.8 2.7-15.6 13.9-26.4 26.9-32.2 4.8-2.1 10-3.7 15.5-4.7V74.7h32v16z" })
  }
), $r = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m85.7 298.9 11-27.4-19.5-22.1C58.2 227.8 48 202.5 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128-63.8 128-160 128c-13.5 0-26.6-1.3-39-3.9l-10.2-2.1-10.1 2.3-70 16.2 7.1-17.6zM0 384l57-13.1 102.6-23.7c15.6 3.1 31.8 4.8 48.5 4.8 114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1l-19.5 48.6zm432 96c16.7 0 32.9-1.7 48.5-4.8L583 498.9l57 13.1-21.7-54.3-19.4-48.6C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8 4.1 15.2 6.2 31.2 6.2 47.8v.6c87.2 6.7 144 67.5 144 127.4 0 26.5-10.2 51.8-29.2 73.4l-19.5 22.2 11 27.4 7.1 17.6-70.1-16.2-10.1-2.3-10.2 2c-12.4 2.5-25.5 3.9-39 3.9-61.7 0-110-26.5-136.8-62.3-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480M185.3 86.3c-21.4 0-38.7 17.3-38.7 38.7v4.6h32V125c0-3.7 3-6.7 6.7-6.7h40.3c6.5 0 11.7 5.3 11.7 11.7 0 4.2-2.2 8.1-5.9 10.2l-31.4 18-8 4.6v40.5h32v-21.9l23.4-13.4c13.6-7.8 22-22.3 22-37.9 0-24.2-19.6-43.7-43.7-43.7h-40.4zM225 232.7h-34v34h34zm314.3 56 11.3-11.3-22.6-22.7-11.3 11.3-74 74-31.4-31.4-11.3-11.2-22.6 22.6 11.3 11.3 42.7 42.7 11.3 11.3L454 374z" })
  }
), kr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96.7 271.5-11 27.4-7.1 17.6 70-16.2 10.1-2.3 10.2 2.1c12.4 2.5 25.5 3.9 39 3.9 96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 26.5 10.2 51.8 29.2 73.4l19.5 22.2zM57 370.9 0 384l21.7-54.3 19.4-48.6C15.3 251.8 0 215.4 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8zm188.2 10.6c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.5 0 26.6-1.3 39-3.9l10.2-2.1 10.1 2.3 70.1 16.2-7.1-17.6-11-27.4 19.5-22.2c19-21.5 29.2-46.9 29.2-73.4 0-59.9-56.8-120.7-144-127.4v-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l19.4 48.6L640 512l-57-13.1-102.5-23.7c-15.6 3.1-31.8 4.8-48.5 4.8-82 0-153-40.2-186.8-98.5M146.7 125c0-21.4 17.3-38.7 38.7-38.7h40.3c24.2 0 43.7 19.6 43.7 43.7 0 15.7-8.4 30.1-22 37.9L224 181.4v21.9h-32v-40.5l8-4.6 31.4-18c3.6-2.1 5.9-6 5.9-10.2 0-6.5-5.3-11.7-11.7-11.7h-40.3c-3.7 0-6.7 3-6.7 6.7v4.6h-32V125zM191 232.7h34v34h-34z" })
  }
), Pr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m85.7 298.9 11-27.4-19.5-22.1C58.2 227.8 48 202.5 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128-63.8 128-160 128c-13.5 0-26.6-1.3-39-3.9l-10.2-2.1-10.1 2.3-70 16.2 7.1-17.6zM0 384l57-13.1 102.6-23.7c15.6 3.1 31.8 4.8 48.5 4.8 114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1l-19.5 48.6zm432 96c16.7 0 32.9-1.7 48.5-4.8L583 498.9l57 13.1-21.7-54.3-19.4-48.6C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8 4.1 15.2 6.2 31.2 6.2 47.8v.6c87.2 6.7 144 67.5 144 127.4 0 26.5-10.2 51.8-29.2 73.4l-19.5 22.2 11 27.4 7.1 17.6-70.1-16.2-10.1-2.3-10.2 2c-12.4 2.5-25.5 3.9-39 3.9-61.7 0-110-26.5-136.8-62.3-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480" })
  }
), Fr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384V96c-88.4 0-160 71.6-160 160h32c0-70.7 57.3-128 128-128m96 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-120 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Tr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3l-69.5 118.7C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116l41.5 24C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L50.2 490.7l-12.1 20.7-41.4-24.2 12.1-20.7 83.8-143.1c-32.2-23.2-59.2-53-79.1-87.4L55 212c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zm218.7 278.7 12.1 20.7-41.4 24.2-12.1-20.7-67.3-114.9c14.4-7.1 28.2-15.4 41.2-24.6l67.5 115.3z" })
  }
), Ar = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m536 393.4 84.9 65.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 85 66C180.1 31.1 246.4 0 320 0c141.4 0 256 114.6 256 256 0 50.6-14.7 97.7-40 137.4m-38.1-29.6C517 332.4 528 295.5 528 256c0-114.9-93.1-208-208-208-58.2 0-110.8 23.9-148.5 62.4l98.9 76.8L448 128l-52.2 156.5zM320 464c39.7 0 76.8-11.1 108.4-30.5l39.7 31.3C426.3 494.5 375.2 512 320 512 178.6 512 64 397.4 64 256c0-33.6 6.5-65.8 18.3-95.2l39.7 31.3c-6.5 20.1-10 41.6-10 63.9 0 114.9 93.1 208 208 208m-6.1-120.6L192 384l36.1-108.3 85.8 67.6z" })
  }
), Dr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m128 128 64-192 192-64-64 192zm160-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), yr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 88V64h-48v112H0v48h160v-24zM24 288H0v48h112v112h48V288h-24zM400 88V64h-48v160h160v-48H400zm-24 200h-24v160h48V336h112v-48h-24z" })
  }
), br = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 56V32h-48v112H0v48h160v-24zM24 320H0v48h112v112h48V320h-24zM336 56V32h-48v160h160v-48H336zm-24 264h-24v160h48V368h112v-48h-24z" })
  }
), fr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v336H48V48zM48 0H0v432h32v80h384v-80h32V0h-48zm32 432h288v32H80zm0-352v160h288V80zm128 224v32h160v-32H224zm-88 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Ur = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 464c61.9 0 112-50.1 112-112V48H48v304c0 61.9 50.1 112 112 112zM0 0h384v352c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V48zm224 96v96h-64V96z" })
  }
), Gr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 224H48v128c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112V224zm192-48v176c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V0h384v48zM336 48H216v128h120zm-168 0H48v128h120z" })
  }
), qr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 480v-48H96v48h24zM48 32H0v352h288v-48H48V80h240V32zm544 48v352H368V80zM368 32h-48v448h320V32h-48zm112 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), Wr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v256H48V80zM48 384h102.7l-16 48H64v48h320v-48h-70.7l-16-48H448V32H0v352zm137.3 48 16-48h45.4l16 48zM528 80h64v32h-64zm0 80h64v32h-64zm64 80v192h-64V240zM480 32v448h160V32H528zm80 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Er = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h32v352H0v48h640v-48h-32V80h32V32H32zm56 400V80h480v352zm96-280v-24h-48v256h48v-24zm112 0v-24h-48v256h48v-24zm112 0v-24h-48v256h48v-24zm112 0v-24h-48v256h48v-24z" })
  }
), Or = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h224v48h-93l-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5 12.8 1.7V208h-32v-41.9l-186-24.8c-8.8 11.4-22.6 18.7-38 18.7-26.5 0-48-21.5-48-48 0-20.6 13-38.1 31.2-45l3.2-19H128zm96 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32m192 112h96v48h16c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9V240h96v48h64v-48h96v48h64zM48 400c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64s-28.7-64-64-64H112c-35.3 0-64 28.7-64 64m80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ir = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48v160H144V48zM144 0H96v256h256V0h-48zm384 112v96h-96v-96zm-96-48h-48v192h192V64h-48zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm-416-48C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112zm48 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Nr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64h416c35.3 0 64-28.7 64-64s-28.7-64-64-64zM0 400c0-61.9 50.1-112 112-112h416c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Xr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48v160H176V48h80v96l64-48 64 48V48zm0-48H128v256h384V0zm128 400c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h416c35.3 0 64 28.7 64 64M112 288C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112zm48 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Kr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118 121.7 218.5 68c19 52.5 62.4 93.4 116.4 109.1 15.4 53.2 55.2 95.9 106.5 115.5L394 390.3l-104.7 56L172 429.7l-85.4-82.9L66 229.1zm371.9 133.5c-61.5-6.7-109.9-57.1-113.7-119.5-62.4-3.7-112.7-52.1-119.4-113.6L213.9 16 81.7 86.7 16 222.1l26 148.3L149.8 475l148.3 21 132.3-70.7L496 289.9zM160 224l32-32-32-32-32 32zm96 32 32 32 32-32-32-32zm-96 96 32 32 32-32-32-32zm160 0 32 32 32-32-32-32z" })
  }
), Qr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118 121.7 66 229.1l20.6 117.7 85.4 82.9 117.3 16.6 104.7-56 52-107.4-20.6-117.7L340 82.3 222.7 65.7zM213.9 16l148.3 21L470 141.6l26 148.3-65.7 135.4L298.1 496l-148.3-21L42 370.4 16 222.1 81.7 86.7 213.9 16zM320 160l-32-32 32-32 32 32zm-192 32 32-32 32 32-32 32zm160 96-32-32 32-32 32 32zm-96 96-32-32 32-32 32 32zm128-32 32-32 32 32-32 32z" })
  }
), Zr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 336H176V48h156.1l67.9 67.9zm48-240L352 0H128v384h320v-48zM48 128H0v384h320v-96h-48v48H48V176h48v-48z" })
  }
), Jr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256c0-44.2 35.8-80 80-80 28.7 0 53.8 15.1 68 37.8l40.8-25.4C342.2 152.2 301.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c45.9 0 86.2-24.2 108.7-60.5L324 298.2C309.8 321 284.7 336 256 336c-44.2 0-80-35.8-80-80" })
  }
), jr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M441 292c9.4-12.2 15-27.4 15-44v-2.3c14.7-13.2 24-32.3 24-53.7v-2.3c14.7-13.2 24-32.3 24-53.7 0-8.4-1.4-16.5-4.1-24A72.01 72.01 0 0 0 512 72c0-39.8-32.2-72-72-72-14.8 0-28.5 4.5-40 12.1-7.5-2.7-15.6-4.1-24-4.1-21.4 0-40.5 9.3-53.7 24H320c-21.4 0-40.5 9.3-53.7 24H264c-18.1 0-34.6 6.6-47.2 17.6l9.3 9.3c8.3 8.3 15.7 17.3 22.2 26.9 4.2-3.6 9.7-5.8 15.7-5.8 2.4 0 4.6.3 6.7.9l18.9 5.5 9.1-17.4c4-7.8 12.1-13 21.3-13 2.4 0 4.6.3 6.7.9l18.9 5.5 9.1-17.4c4-7.8 12.1-13 21.3-13 5.2 0 9.9 1.6 13.8 4.3l17.8 12.5 14.2-16.5c4.4-5.2 10.9-8.4 18.2-8.4 13.3 0 24 10.7 24 24 0 7.3-3.2 13.8-8.4 18.2l-16.5 14.2 12.5 17.8c2.7 3.9 4.3 8.6 4.3 13.8 0 9.2-5.2 17.3-13 21.3l-17.5 9.1 5.5 18.9c.6 2.1.9 4.3.9 6.7 0 9.2-5.2 17.3-13 21.3l-17.5 9.1 5.5 18.9c.6 2.1.9 4.3.9 6.7 0 5.3-1.7 10.1-4.6 14.1 10.4 6.7 20.2 14.3 29.5 22.6zM169 71l-30-30-10.3 41.2-22.4 89.6L7 271l-7 7v115.4l6.4 6.9 96 104 7.1 7.7h124.4l7-7L341 405l90.6-30.2 39.1-13-30.6-27.6-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9.6-26.8 1.8V213c0-40.3-16-79-44.5-107.5zm31 142v57.1c-25.9 10.2-49.7 25.7-69.8 45.7l-70.9 71L48 374.6v-76.7l97-97 4.7-4.7 1.6-6.4 13.7-54.9 4.5 4.5C189 159 200 185.4 200 213m-69.5 251-38.7-41.9 72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8 37.7 0 74.1 13.6 102.5 38.3l-56.9 19-5.3 1.7-4 4-97 97z" })
  }
), Yr = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 160h448v224h-48V208H0z" })
  }
), _r = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80H112v112H64V32h512v160h-48zM48 272v160h48V272zM0 224h144v64h352v-64h144v256H496v-32H144v32H0V272zm144 176h352v-64H144zm448-128h-48v160h48z" })
  }
), hd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 184c0-23 10.7-43.4 27.5-56.6-2.3 7.8-3.5 16.1-3.5 24.6v296h128v-69.4c2.5.6 5.2 1.2 8 1.7V408h32v-24.1c2.6.1 5.3.1 8 .1s5.4 0 8-.1V408h32v-27.6c2.8-.5 5.5-1.1 8-1.7V448h128V267.7l16 20.6V343l3.8 5.9 56 88 7.1 11.1H640V255.8l-5-6.5-11-14.2V144h-48v29l-48.2-62.4C505.1 81.2 470 64 432.9 64H144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v32h8c35.3 0 64-28.7 64-64v-32zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4c21.7 21.7 51.2 33.9 81.9 33.9s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6h50.5c22.3 0 43.3 10.3 57 28L592 272.2V400h-34.8L512 329v-57.2l-5.1-6.5-56-72-7.2-9.3H400v216h-32v-64c0-53-43-96-96-96s-96 43-96 96v64h-32V152c0-14.5 7.7-27.1 19.2-34.1m62.4 211.4-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1.4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), cd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h192v96h64l19.7 98.3c-16.2 2.6-31.7 7.5-46.1 14.2l-13-64.5H103.4L58.6 368H256c0 16.6 2.3 32.7 6.6 48H0l9.6-48L64 96h64V24zm157.5 465.6c-7.6 26.8-32.3 46.4-61.5 46.4-35.3 0-64-28.7-64-64h115.2c3.1 6.1 6.6 12 10.3 17.6M272 48h-96v48h96zm160 176a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), sd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h192v96h64l54.4 272 9.6 48H0l9.6-48L64 96h64V24zm144 48h-96v48h96zm-168.6 96L58.6 368h330.8l-44.8-224zM288 448c0 35.3-28.7 64-64 64s-64-28.7-64-64z" })
  }
), vd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C57.3 0 0 57.3 0 128v79.4l13.9 6.4 85 39.2c-2.2 3.6-4.2 7.2-6 11H61.7l-27-13.5-21.4-10.7-21.5 42.9 21.5 10.7 32 16 5.1 2.5H80.2c-.2 2.6-.2 5.3-.2 8v1.4l-23.6 7.9L51 331l-4 4-32 32-17 17 34 33.9 17-17 28-28 30-10 18 18.1-36.6 12.2L83 395l-4 4-32 32-17 17 34 33.9 17-17 28-28 54-18 2.2 2.2-24.9 13.9-12.3 6.9V512h48v-41.9l38.1-21.1-.5-1h85l-.5 1 37.9 21.1V512h48v-70.1l-12.3-6.9-24.9-13.8 2.2-2.2 54 18 28 28 17 17 33.9-34-17-17-32-32-4-4-5.4-1.8L387 381l18-18 30 10 28 28 17 17 33.9-34-17-17-32-32-4-4-5.4-1.8-23.5-7.8V320c0-2.7-.1-5.4-.2-8h29.9l5.1-2.5 32-16 21.5-10.7-21.5-42.9-21.5 10.7-27 13.4h-31.2c-1.8-3.8-3.9-7.4-6-11l85-39.2 13.9-6.4V128C512 57.3 454.7 0 384 0h-64l64 64h-64c0 35.3 28.7 64 64 64h80v48.6L378.7 216c-16.9-12.2-37-20.3-58.7-23v-65h-48v64h-32v-64h-48v65c-21.7 2.7-41.7 10.9-58.7 23L48 176.6V128h80c35.3 0 64-28.7 64-64h-64l64-64zm144 240h32c42.9 0 77.9 33.8 79.9 76.2L300.1 400h-88.2l-83.8-83.8c2-42.4 37-76.2 79.9-76.2h32z" })
  }
), ed = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 54.9V64h9.1C199.4 64 224 39.4 224 9.1V0h-9.1C184.6 0 160 24.6 160 54.9m192 0V64h9.1C391.4 64 416 39.4 416 9.1V0h-9.1C376.6 0 352 24.6 352 54.9M160 98.3 96 80c-43.6 0-64 47.8-64 91.4 0 7 .4 13.9 1.2 20.6h48.5c-1.1-6.5-1.7-13.3-1.7-20.6 0-15.3 3.8-29 8.7-37.2 1.8-2.9 3.3-4.5 4.2-5.2l53.9 15.4 13.2 3.8 13.2-3.8 53.9-15.4c.9.8 2.4 2.3 4.2 5.2 4.9 8.2 8.7 21.9 8.7 37.2 0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6 0-43.6-20.4-91.4-64-91.4zm320 73.1c0-43.6-20.4-91.4-64-91.4l-64 18.3L291.4 81c3 3.8 5.8 7.7 8.3 11.8 8.4 13.8 13.9 29.5 17 45.4l22.1 6.3 13.2 3.8 13.2-3.8 53.9-15.5c.9.8 2.4 2.3 4.2 5.2 4.9 8.2 8.7 21.9 8.7 37.2 0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6M464 272v72H48v-72zM48 464v-72h416v72zm0-240H0v288h512V224h-48zm368 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0M96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), ld = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 272v72h416v-72zm0 120v72h416v-72zM0 224h512v288H0V272zm400 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32M80 304a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), td = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm96 304h96v48H96zm128 0h160v48H224z" })
  }
), wd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm96 304h96v48H96zm128 0h160v48H224zM96 256h384v48H96zm384-128v96H352v-96z" })
  }
), gd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v48H48V80zm0 144v208H48V224zM48 32H0v448h576V32h-48zm144 304H96v48h96zm192 0H224v48h160z" })
  }
), id = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m493.8 52.2 17-17-34-33.9-17 17L328 150.1 297.9 120 264 86.1 230.1 120 .2 349.8C-.2 367.1.6 384 3.8 401c4 21.4 13.1 51.4 35.2 71.9 20.6 22.1 50.6 31.2 71.9 35.2 17 3.2 34 4 51.2 3.6L392 281.9l33.9-33.9-33.9-33.9-30.1-30.1L493.8 52.2zM294.1 184l33.9 33.9 30.1 30.1-40 40H224v-94.1l40-40zM176 241.9V336h94.1L142.5 463.6c-7.9-.4-15.4-1.2-22.6-2.6-18.4-3.5-35.8-10.1-45.7-20.7L73 439l-1.3-1.2c-10.6-9.9-17.3-27.3-20.7-45.7-1.4-7.3-2.2-14.7-2.6-22.6zM400 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), md = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M61.2 169c24.1-46 61.9-83.7 107.9-107.8l110 202.2-15.6 15.6L61.2 169zM190.4 0C100.9 30.3 30.2 100.9 0 190.4l14.3 7.8C5 226.4 0 256.6 0 288c0 49.4 12.4 95.9 34.3 136.5 7.6 14.1 16.3 27.5 26.1 40l.2.3 23.8-18.5c26.9 29 60.5 51.7 98.2 65.7l41.4-32-16-96v-33.8l35.3-27.5 28.7 15.7 66.4-66.4-15.6-28.7 27.4-35.3H384l96 16 32-41.3c-14.1-37.8-36.8-71.3-65.7-98.2l18.5-23.8-.3-.2c-12.6-9.7-25.9-18.5-40-26.1C383.9 12.4 337.4 0 288 0c-31.4 0-61.6 5-89.8 14.3zm226.3 122.6c14.6 14.2 27.2 30.5 37.2 48.4l-62-10.3-3.9-.7h-.4l29.1-37.4zM160 387.6v.4l.7 3.9 10.3 62c-17.9-10-34.3-22.6-48.4-37.2zM48 288c0-23 3.2-45.3 9.3-66.4l140 76.2-124.4 96.7C56.9 362.4 48 326.3 48 288M394.5 72.9l-96.8 124.4-76.1-140C242.7 51.2 265 48 288 48c38.3 0 74.4 8.9 106.5 24.9" })
  }
), ad = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 24V0H80v80H0v48h80v304h272v-48H128zm256 464v24h48v-80h80v-48h-80V80H160v48h224z" })
  }
), od = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0v350.1L350.1 128H160V80h238.1l57-57 17-17 33.8 34L489 57l-57 57v270h80v48h-80v80h-48V161.9L161.9 384H352v48H80V128H0V80h80V0z" })
  }
), nd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h-24v112H0v160h112v240h160V272h112V112H272V0h-24zm24 136V48h64v112h112v64H224v240h-64V224H48v-64h112z" })
  }
), rd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M462.6 232H368v48h94.6c-11 95.7-86.9 171.6-182.6 182.6V368h-48v94.6c-95.7-11-171.6-86.9-182.6-182.6H144v-48H49.4c11-95.7 86.9-171.6 182.6-182.6V144h48V49.4c95.7 11 171.6 86.9 182.6 182.6M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), dd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v41.3C380.1 52.4 459.6 131.9 470.7 232H512v48h-41.3C459.6 380.1 380.1 459.6 280 470.7V512h-48v-41.3C131.9 459.6 52.4 380.1 41.3 280H0v-48h41.3C52.4 131.9 131.9 52.4 232 41.3V0zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3V368h48v54.3c73.6-10.5 131.8-68.7 142.3-142.3H368v-48h54.3C411.8 158.4 353.6 100.2 280 89.7V144h-48V89.7C158.4 100.2 100.2 158.4 89.7 232H144v48h-24zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Sd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112.3 384 69 419.4l-18.6 15.2-18.6 15.2-30.4-37.2L20 397.4l18.6-15.2 43.3-35.4L95.2 336 336 139.2V104C336 46.6 382.6 0 440 0c29.5 0 56.1 12.3 75 32h77l48 32v32l-96 24v72c0 88-59.1 162.1-139.8 184.8L459.8 512h-51.9l-52.7-128h-44.1l52.7 128h-51.9l-52.7-128H112.3zm116.8-75.9c53-11.6 93-53.1 104-104.5L196.4 315.2l32.6-7.1zM384 152v23.2c0 68.1-37.4 129-94.5 160.8H352c79.5 0 144-64.5 144-144v-88c0-30.9-25.1-56-56-56s-56 25.1-56 56V152zm32-48a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), zd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M309 106c11.4-7 19-19.7 19-34 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6-47.2 94.5-22 43.9-38.3-30.7-64.6-51.6L72 160c5-6.7 8-15 8-24 0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40h.7l4.4 23.9L96 480h384l50.9-280.1 4.4-23.9h.7c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-64.6 51.7L384 256l-22-43.9-47.2-94.4zm-74.1 171.5L288 171.3l53.1 106.1 26.6 53.1 46.3-37 59.8-47.9L439.9 432H136.1l-33.9-186.4 59.8 47.9 46.4 37.1 26.6-53.1z" })
  }
), pd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m340.2 18.2 153.6 153.6 17 17-33.9 33.9-17-17L306.2 52.2l-17-17 34-33.9 17 17zM151 215 287.4 78.6l33.9 33.9-71.4 71.5 78.1 78.1 71.4-71.4 33.9 33.9L297 361l-4.9 4.9-6.8 1.5L148 397.9l-95.8 95.9-17 17-33.9-34 17-17 95.8-95.8 30.5-137.2 1.5-6.8zm143 81-78-78.1-26.1 26.1-22.3 100.4L268 322.1l26.1-26.1z" })
  }
), Md = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m374.8 408.7 85 85 17 17 33.9-33.9-17-17-63.4-63.4-55.5 12.3zM56 201.9l151.4 151.5 5.4-5.4 10.4-46.6L89.9 168 168 89.9l95.4 95.4 33.9-33.9L201.9 56l3.8-3.8 17-17-33.9-33.9-17 17L18.2 171.8l-17 17 33.9 33.9 17-17 3.8-3.8zM451.2 1.3l-33.9 33.9 17 17 153.5 153.6 17 17 33.9-33.9-17-17L468.2 18.2l-17-17zm-35.8 77.3L279 215l-4.9 4.9-1.5 6.8L242.1 364l-95.9 95.9-17 17 33.9 33.9 17-17 95.9-95.9 137.2-30.5 6.8-1.5 5-4.9 136.4-136.4-33.9-33.9-71.5 71.4-78.1-78.1 71.4-71.4zM344 217.9l78.1 78.1-26.1 26.1-100.4 22.3L317.9 244z" })
  }
), xd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 256c0-97 79.3-176 177.6-176 45.6 0 87 17 118.5 44.9L407.9 89C368 53.5 315.3 32 257.6 32 133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57L376 387.1C344.6 415 303.2 432 257.6 432c-5.9 0-11.8-.3-17.6-.9V318.2c0-21.1 17.1-38.2 38.2-38.2 10.1 0 19.9 4 27 11.2l5.8 5.8 34-34-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3-13.7 0-26.7 3.2-38.2 8.9V224h-48v195.6C126.3 393.7 80 330.1 80 256" })
  }
), Hd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176m-222.7-97.3L160 80l-17.3 46.7L96 144l46.7 17.3L160 208l17.3-46.7L224 144zM288 128l-25.9 70.1L192 224l70.1 25.9L288 320l25.9-70.1L384 224l-70.1-25.9zM0 512h448l-64-96H64z" })
  }
), Vd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 6.3 8.5 3.2 232 88 15.5 5.9V400l-14.8 6.1-232 96-9.2 3.9-9.2-3.8-232-96L0 400V103.4l15.5-5.9 232-88zM48 368l184 76.1V240.4L48 168.1zm232 76.1L464 368V168.1l-184 72.3zM256 57.7l-182 69 182 71.5 182-71.5-182-69" })
  }
), Cd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 80h-32v32h32zm-32-48h80v128H192V32zM120.5 240.5l16 27.7 27.7-16-16-27.7-27.7 16zM55 223l41.6-24 27.7-16 41.6-24 24 41.6 16 27.7 24 41.6-41.6 24-27.7 16-41.6 24-24-41.7-16-27.7zm281 17h-32v32h32zm-80-48h128v128H256v-80zm112 240h32v-32h-32zm-48-80h128v128H320v-80zm-80 48h-32v32h32zm-32-48h80v128H160V352zM48 400v32h32v-32zM0 352h128v128H0v-80z" })
  }
), Ld = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 4.4 8.1 2.9 136 48.5 15.9 5.7v146l112.5 42.7 15.5 5.9V442.5l-14.3 6.3-128 56.2-9.4 4.1-9.5-3.9L288 452.7l-126.8 52.5-9.5 3.9-9.4-4.1-128-56.3L0 442.4V256.1l15.5-5.9L128 207.5v-146l15.9-5.7 136-48.5zm112 113.5-88 33.7v86.9l88-31.4zm-136 33.8L176 118v89.3l88 31.4zm48 259.1 88 36.4v-93.3l-88-33.7v90.6zm136 35.5 80-35.2v-87.9l-80 30.7v92.4zM264 320.2l-88 33.7v93.3l88-36.4zM48 411.1l80 35.2v-92.4l-80-30.7zM288 55.4l-73.1 26.1 73.1 28 73.1-28zM152.3 249.7l-81.5 30.9 81.2 31.1 83.9-32.1-83.6-29.8zm352.9 30.9-81.4-30.9-83.6 29.8 83.8 32.2 81.2-31.1" })
  }
), Bd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1L385.1 240H336v49.1L184.6 440.6c-31.2 31.2-81.9 31.2-113.1 0zm-33.9 33.9c47.8 47.8 123.9 49.9 174.2 6.4l20.3 20.4 45.3-45.3-20.1-20.1 178.7-178.8 20.1 20.2 45.3-45.3-20.4-20.4c43.5-50.3 41.4-126.4-6.4-174.2-50-50-131-50-181 0L172.1 158.9 152 138.7 106.7 184l20.1 20.1-89.3 89.4c-50 50-50 131 0 181M184 296h-48v48h48zm192-192h-48v48h48z" })
  }
), ud = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h80v48h-61l-18.8 80H384v48H0v-48h174.9l25.7-109.5L205 0zM64 512 38.7 208h48.1l12.9 154.4c15.7-3.1 27.5-7.3 36.9-11.9 19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7 16-8.6 35.4-15.1 59.8-18.9l3-36h48.2L320 512zm226-218.5c-14.1 3.1-24.6 7.1-32.9 11.6-17.2 9.3-26.9 21.2-39.9 37.2l-.7.8c-13.3 16.4-29.5 35.9-58.7 50.4-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5h167.7z" })
  }
), Rd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m205 0-4.4 18.5L174.9 128H0v48H384v-48H224.2L243 48h61V0h-80zM38.7 208 64 512h256l25.3-304h-48.1l-21.4 256H108.2L86.8 208z" })
  }
), $d = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m72.8 0-6.5 13.7L34.8 80H0v48h448V80h-33.2l-33.3-66.7L374.8 0H88zM88 80l15.2-32h242l16 32zm-40.6 80L80 512h288l32.6-352h-48.2l-5.9 64h-245l-5.9-64zm68.9 224h215.3l-7.4 80H123.8l-7.4-80z" })
  }
), kd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h-44.8L204 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H148c-45 0-81.8 35.4-83.9 79.9C26.5 159.6 0 196.7 0 240v80h448v-80c0-43.3-26.4-80.4-64-96C382.5 64.2 317.4 0 237.3 0zm40 57.3c0-1.9-.1-3.8-.3-5.7 41.7 11.5 72.3 49.7 72.3 95.1 0 3.1-.4 6.1-1.1 8.9l-6.1 24.8 25.1 4.5c26.2 4.7 46 27.6 46 55.1v32H48v-32c0-27.4 19.7-50.3 45.8-55.1l24.6-4.5-5.5-24.4c-.6-2.6-.9-5.2-.9-8 0-19.9 16.1-36 36-36h61.3c30.2 0 54.7-24.5 54.7-54.7M96 512h51.9l-20-160H69.3zm84.1 0h87.8l20-160H160.1zm120 0H352l26.7-160h-58.6z" })
  }
), Pd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32h240v48H224v64h256v64h32l64 64v144l-64 64H64L0 416V272l64-64h32v-64h80V56zM48 312v8h480v-28.1L492.1 256H83.9L48 291.9zm0 56v28.1L83.9 432h408.2l35.9-35.9V368z" })
  }
), Fd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M134.6 239.1 103.1 368H53.7L128 64h320l74.3 304h-49.4l-31.5-128.9L385 225l-89.4 29.8-7.6 2.5-7.6-2.5L191 225zm12.9-52.7 38.7-9.7 6.8-1.7 6.6 2.2 88.4 29.5 88.4-29.5 6.6-2.2 6.8 1.7 38.7 9.7-18.2-74.4H165.7zM0 400h576v48H0z" })
  }
), Td = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h160c123.7 0 224 100.3 224 224S283.7 480 160 480H0V56zm48 48v352h112c97.2 0 176-78.8 176-176S257.2 80 160 80z" })
  }
), Ad = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0v128h168v48c0 26.5-21.5 48-48 48s-48-21.5-48-48H96c0 26.5-21.5 48-48 48S0 202.5 0 176v-48h168V0zm-56 398.6 32 38.4 32-38.4V208h48v208l-48.8 58.5L192 512l-31.2-37.5L112 416V208h48z" })
  }
), Dd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 232h512v48H0z" })
  }
), yd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 206v71.4l93.8 58.6h164.4l93.8-58.6V206l-80 50H128zM0 176V80L128 0h192l128 80v352l-128 80H128L0 432V256zm400-48v-21.4L306.2 48H141.8L48 106.6v42.8l93.8 58.6h164.4l93.8-58.6zM48 405.4l93.8 58.6h164.4l93.8-58.6V334l-80 50H128l-80-50z" })
  }
), bd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V0h32v40c0 8.6-1.9 16.7-5.4 24H416c13.3 0 24-10.7 24-24V0h32v40c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2 22.1 0 40 17.9 40 40s-17.9 40-40 40v64H409.3l-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6V512H264V376h-51.9l-3.7-1.2-16.4-5.5v10.2l-9 7.2-26.6 21.3 26.1 71.8 11.8 32.2H63.2l-5.7-15.8-32-88-2.9-7.9 2.6-7.9L40 348.1v-18.2l-8-8V336H0v-64c0-28.5 12.5-54.2 32.2-71.8C49.8 180.5 75.5 168 104 168h191l7.2-24H256v-32l60.3-15.1.3-.9H280c-30.9 0-56-25.1-56-56V0zM144 336v-33.3l31.6 10.5 44.3 14.8H312v136h32V311.8c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6 5.5-16.4H472v-29.4L398.7 112h-36.8l-26 86.9-5.1 17.1H104c-26.5 0-48 21.5-48 48v14.1l25 25 7 7v45.8l-1.2 3.7-13.4 40.1L96.8 464h28.9l-20.3-55.8-5.8-16.2 13.4-10.7 31-24.8zm256-192a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), fd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 16V0h-32v40c0 30.9 25.1 56 56 56h36.6l-.3.9L256 112v32h46.2l-7.2 24H104c-28.5 0-54.2 12.5-71.8 32.2C12.5 217.8 0 243.5 0 272v64h32v-14.1l8 8v18.2l-14.8 44.3-2.6 7.9 2.9 7.9 32 88 5.7 15.8h131.1l-11.7-32.2-26.2-71.8 26.6-21.3 9-7.2v-10.2l16.4 5.5 3.7 1.2H264v136h128V311.8c0-2.6.4-5.1 1.2-7.6l16.1-48.2H520v-98.6l-7.9-7.1-68-61.8C460.8 78.7 472 60.7 472 40V0h-32v40c0 13.3-10.7 24-24 24h-69.4c3.5-7.3 5.4-15.4 5.4-24V0h-32v40c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zM144 356.5l-31 24.8L99.6 392l5.9 16.2 20.2 55.8H96.8l-23.4-64.3 13.4-40.1 1.2-3.7v-45.8l-7-7-25-25V264c0-26.5 21.5-48 48-48h226.8l5.1-17.1 26-86.9h36.8l73.3 66.6V208h-97.3l-5.5 16.4-21.5 64.6c-2.4 7.3-3.7 15-3.7 22.8V464h-32V328h-92.1l-44.3-14.8-31.6-10.5V336zM416 160a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), Ud = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 448H176L0 256 176 64h400v336zM65.1 256l132 144H528V112H197.1zM254 192l34-33.9 17 17 47 47 47-47 17-17 33.9 33.9-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17z" })
  }
), Gd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 448h400l176-192L400 64H0v336zm510.9-192-132 144H48V112h330.9zm-189-64L288 158.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), qd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0S96 12.1 96 32c0 11.8 4.4 21.5 9.9 28.9L13.8 168.4l-13 15.1L13.3 199l64 80L90 294.8l17.7-9.8 49.3-27.5 35 75.7V512h144v-80h96v80h144V205.4l32.1 28.5L640 198l-72-64-6.8-6.1H288.3l-78.4-61.8c7.3-8 14.1-19.3 14.1-34.1 0-19.9-16-32-16-32l-48 45.7zm128 464V352h288v112h-48v-80H288v80zm288-288v128H231.4l-41.6-90.1-10.8-23.4-22.7 12.5-54.3 30.2-38.8-48.7 76.1-88.8 29.8-.7 96 75.8 6.5 5.2h8.4zm-142 53.4L375.5 208 365 229.4l-24.2 3.1 17.7 16.3L354 272l21.4-11.3 21.5 11.3-4.4-23.3 17.7-16.3zM279.5 208 269 229.4l-24.2 3.1 17.7 16.3L258 272l21.4-11.3 21.5 11.3-4.4-23.3 17.7-16.3-24.2-3zM474 229.4 463.5 208 453 229.4l-24.2 3.1 17.7 16.3L442 272l21.4-11.3 21.5 11.3-4.4-23.3 17.7-16.3z" })
  }
), Wd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0h176v48H48v208h480V48H352V0h224v416H364.3l8 48H448v48H128v-48h75.7l8-48H0V0zm0 304v64h480v-64zm204.3 160h71.3l-8-48h-55.3zM312 24v110.1l39-39 17-17 33.9 33.9-17 17-80 80-17 17-17-17-80-80-17-17L208 78.1l17 17 39 39V0h48z" })
  }
), Ed = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48H48v208h480zm48 208v160H364.3l8 48H448v48H128v-48h75.7l8-48H0V0h576v48zM48 304v64h480v-64zm212.3 112-8 48h71.3l-8-48z" })
  }
), Od = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m232 0 1.3 33.1c-44.8 4.5-85.7 22.2-118.8 49.2L92 58 58 92l24.3 22.5c-27 33.1-44.7 74-49.2 118.8L0 232v48l33.1-1.3c4.5 44.8 22.2 85.7 49.2 118.8L58 420l34 34 22.5-24.3c33.1 27 74 44.7 118.8 49.2L232 512h48l-1.3-33.1c44.8-4.5 85.7-22.2 118.8-49.2L420 454l34-34-24.3-22.5c27-33.1 44.7-74 49.2-118.8L512 280v-48l-33.1 1.3c-4.5-44.8-22.2-85.7-49.2-118.8L454 92l-34-34-22.5 24.4c-33.1-27-74-44.7-118.8-49.2L280 0zm-84.8 394.3 54.7-59c10.7 7.4 23.1 12.6 36.4 15.1l-3.1 80.4c-33-3.9-63.1-16.9-87.9-36.4zm29.5-84.2-59.1 54.7c-19.5-24.8-32.5-55-36.4-87.9l80.4-3.1c2.5 13.3 7.7 25.6 15.1 36.4zm-95.5-75c3.9-33 16.9-63.1 36.4-87.9l59.1 54.7c-7.4 10.7-12.6 23.1-15.1 36.4l-80.4-3.1zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-54.1-31.3-54.7-59.1c24.8-19.5 55-32.5 87.9-36.4l3.1 80.4c-13.3 2.5-25.6 7.7-36.4 15.1zm75-95.5c33 3.9 63.1 16.9 87.9 36.4l-54.7 59.1c-10.7-7.4-23.1-12.6-36.4-15.1l3.1-80.4zm87.9 313.1c-24.8 19.5-55 32.5-87.9 36.4l-3.1-80.4c13.3-2.5 25.6-7.7 36.4-15.1l54.7 59zm29.5-29.5-59-54.7c7.4-10.7 12.6-23.1 15.1-36.4l80.4 3.1c-3.9 33-16.9 63.1-36.4 87.9zm0-217.6c19.5 24.8 32.5 55 36.4 87.9l-80.4 3.1c-2.5-13.3-7.7-25.6-15.1-36.4l59-54.7z" })
  }
), Id = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 224V32H0v192zm-48 112v96H48v-96zm48 96V288H0v192h512z" })
  }
), Nd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 80v216h80V80zm-48 0h-64v88h64zm-112 0h-64v216h64zm-112 0h-64v88h64zm-112 0H48v216h80zM48 344v88h248v-88zm296 88h248v-88H344zM0 32h640v448H0V80zm240 264v-80h-64v80zm224-80h-64v80h64z" })
  }
), Xd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v96H48V80zM48 32H0v192h72v184h184v72h192V288H256v72H120V224h72V32h-48zm352 304v96h-96v-96z" })
  }
), Kd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 224V32H0v192h232v86.1l-23-23-17-17-33.9 33.9 17 17 64 64 17 17 17-17 64-64 17-17-34.1-33.9-17 17-23 23V224zM48 288H0v192h512V288H383.2l16 16-32 32H464v96H48v-96h96.8l-32-32 16-16z" })
  }
), Qd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m369 119-17-17-33.9 34 17 17 64 64 17 17 17-17 64-64 17-17-34.1-33.9-17 17-23 23V32H0v192h288V80h104v62.1l-23-23zm95 313H48v-96h416zm48 48V288H0v192h464z" })
  }
), Zd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 336H48v96h416zm48-48v192H0V288h232v-86.1l-23 23-17 17-33.9-33.9 17-17 64-64 17-17 17 17 64 64 17 17-34.1 33.9-17-17-23-23V288h184zM96.8 224H0V32h512v192h-96.8l-39.6-39.6-80-80L256 64.8l-39.6 39.6-80 80z" })
  }
), Jd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v96H48V80zM48 32H0v192h154l70 93.3V480h192V288H262l-70-93.3V152h192v72h192V32H384v72H192V32h-48zm320 304v96h-96v-96zm64-256h96v96h-96z" })
  }
), jd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M298.5 32H576v48H325.5l-81 132.5-7 11.5H0v-48h210.5l81-132.5zM150.6 320H0v-48h576v48H205.9l64 112H576v48H242.1l-6.9-12.1z" })
  }
), Yd = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h512v192H152v136h72v-72h288v192H224v-72H104V224H0zm464 304H272v96h192z" })
  }
), _d = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m369 119-17-17-33.9 34 17 17 64 64 17 17 17-17 64-64 17-17-34.1-33.9-17 17-23 23V32H0v192h288V80h104v62.1l-23-23zm143 169H0v192h512zM240 176H48V80h192z" })
  }
), hS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1-97.2 0-176 78.8-176 176s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1M252 320h136c5.9-15.1 9.8-31.2 11.3-48H240.7c1.5 16.8 5.4 32.9 11.3 48m16.5 32c13.4 20.6 31 38.1 51.5 51.5 20.6-13.4 38.1-31 51.5-51.5zM252 192c-5.9 15.1-9.8 31.2-11.3 48h158.6c-1.5-16.8-5.4-32.9-11.3-48zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5-20.6 13.4-38.1 31-51.5 51.5zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224S539.7 480 416 480c-34.4 0-66.9-7.7-96-21.6" })
  }
), cS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm288 56h109.4c-11 50.3-55.8 88-109.4 88-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88H264v48zm160-24a160 160 0 1 0-320 0 160 160 0 1 0 320 0" })
  }
), sS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm288 144c-53.6 0-98.4-37.7-109.4-88H312v-48H178.6c11-50.3 55.8-88 109.4-88 61.9 0 112 50.1 112 112s-50.1 112-112 112M128 288a160 160 0 1 0 320 0 160 160 0 1 0-320 0" })
  }
), vS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm271 49 77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271l-17-17-33.9 34 17 17zm130.1 96.2a160 160 0 1 0-226.2-226.3 160 160 0 1 0 226.2 226.2z" })
  }
), eS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm208.8 111.2c-37.9-37.9-43-96.2-15.1-139.6L271 305l17 17 33.9-34-17-17-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1 43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zm-33.9-192.3a160 160 0 1 0 226.2 226.2 160 160 0 1 0-226.2-226.2" })
  }
), lS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm176 32c0-53.6 37.7-98.4 88-109.4V312h48V178.6c50.3 11 88 55.8 88 109.4 0 61.9-50.1 112-112 112s-112-50.1-112-112m112-160a160 160 0 1 0 0 320 160 160 0 1 0 0-320" })
  }
), tS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm271 15-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6 43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305l17-17-34-33.9-17 17zm-96.1 130.1a160 160 0 1 0 226.2-226.2 160 160 0 1 0-226.2 226.2" })
  }
), wS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm264 32v109.4c-50.3-11-88-55.8-88-109.4 0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4V264h-48zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320" })
  }
), gS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h-64v64h64zM128 64H64v64h64zm384 0h-64v64h64zm0 192v64h64v-64zm0 192h-64v64h64zm-448 0v64h64v-64zM0 256v64h64v-64zm208.8-47.2c37.9-37.9 96.2-43 139.6-15.1L271 271l-17 17 34 33.9 17-17 77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9a160 160 0 1 0-226.2 226.2 160 160 0 1 0 226.2-226.2" })
  }
), iS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.9 289.9 0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9 188.2 188.2L512 256l-33.9 33.9-188.2 188.2L256 512l-33.9-33.9L33.9 289.9zm34-33.9L256 444.1 444.1 256 256 67.9zM232 152v-8h48v144h-48v-24zm48 216h-48v-48h48z" })
  }
), mS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.9 289.9 0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9 188.2 188.2L512 256l-33.9 33.9-188.2 188.2L256 512l-33.9-33.9L33.9 289.9zM256 67.9v376.2L444.1 256z" })
  }
), aS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M222.1 33.9 256 0v512l-33.9-33.9L208 464 33.9 289.9 0 256l33.9-33.9L208 48zm-14.1 82L67.9 256 208 396.1V115.9z" })
  }
), oS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.9 289.9 0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9 188.2 188.2L512 256l-33.9 33.9-188.2 188.2L256 512l-33.9-33.9L33.9 289.9zm34-33.9L256 444.1 444.1 256 256 67.9zM304 144l80 80-80 80h-16v-56h-64v72h-48V200h112v-56z" })
  }
), nS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 256 33.9 33.9 188.2 188.2L256 512l33.9-33.9 188.2-188.2L512 256l-33.9-33.9L289.9 33.9 256 0l-33.9 33.9L33.9 222.1zm256 188.1L67.9 256 256 67.9 444.1 256z" })
  }
), rS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m232 491 24 21 24-21 195.9-171.4 13.2-11.5L512 288l-26.1-29.4-5.7-6.5L297.4 46.6l-9.3-10.4-13.8-15.6L256 0l-18.3 20.6-13.8 15.5-9.3 10.4L31.9 252.1l-5.7 6.5L0 288l22.9 20.1 13.2 11.5zM82.8 296.7l79.5-15.1 69.7 50.6v95L82.8 296.7M196.5 247 256 73.8 315.5 247 256 290.3zm141.4-82.7 70.7 79.5-46.4-8.8zm91.3 132.3L280 427.2v-95l69.7-50.7zM174.1 164.4 149.8 235l-46.4 8.8 70.7-79.5z" })
  }
), dS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 187.4v137.2l68.6 118.8 88 50.8 30.8 17.8h137.2l30.8-17.8 88-50.8L512 324.6V187.4L443.4 68.6l-28.1-16.3L324.6 0H187.4L96.7 52.3 68.6 68.6zm103.2-82.7L232 145.6v96.1l-99.1 53.1L48 203.7v-3.4l55.2-95.5zM280 145.6l128.8-40.8 55.2 95.5v3.4l-84.9 91-99.1-53.1zM353.3 72 256 102.8 158.7 72l41.5-24h111.5l41.5 24zM464 274v37.7l-55.7 96.5-31.4 18.1 28.3-89.3zM315.3 462l-3.5 2H200.3l-3.5-2-39.9-125.7 99.1-53.1 99.1 53.1zm-180.2-35.6-31.3-18.1L48 311.7V274l58.8 63z" })
  }
), SS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m232 498.3 24 13.7 24-13.7 186.2-106.4L480 384V128l-22.9-13.1-173.4-99.1-13.8-7.9L256 0l-13.9 7.9-13.8 7.9-173.4 99.1L32 128v256l13.8 7.9zm-74.4-97.8 74.4 5.7V443zm122.4 5.7 74.4-5.7L280 443zM432 268l-32-53.4 32-22.9zm-56.5-94.8-43.4-74.5 82 46.9zM179.9 98.7l-43.4 74.4-38.6-27.5 82-46.9zm-67.9 116L80 268v-76.2l32 22.9zM88.6 347l56-93.4L210 356.4zm213.4 9.4 65.4-102.7 56 93.4zm-46-17.1L187.7 232h136.6zM185.8 184 256 63.6 326.2 184z" })
  }
), zS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M225.3 38.4 30 282.5 0 320l38.4 28.8L232 494l24 18 24-18 193.6-145.2L512 320l-30-37.5L286.7 38.4 280 30 256 0l-24 30zm6.7 68.4V434L68.4 311.3 232 106.8M280 434V106.8l163.6 204.5z" })
  }
), pS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m200 498.3 24 13.7 24-13.7L448 384V121.4l-24.5-13.3L224 0 24.3 111.4 0 125v259zM48 356.1V180.8l152 88.9V443zm24.4-216.6 151.9-84.7 151.4 82.1-151.9 91.2zM400 178.3v177.8L248 443V269.6z" })
  }
), MS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m232 488 24 24 24-24 9.9-9.9 183.4-183.4 4.7-4.7 34-34-18.9-18.9L478 222 289.9 33.9 280 24 256 0l-24 24-9.9 9.9L33.9 222.1l-15 15L0 256l33.9 33.9 4.7 4.7 183.5 183.5zm0-67.9-89.9-89.9 89.9 30.9zM69.4 254.5 232 91.9v218.5zM280 91.9l162.6 162.6L280 310.4zm0 269.2 89.9-30.9-89.9 89.9z" })
  }
), xS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), HS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m0 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-224a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), VS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), CS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m0 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), LS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), BS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm304 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), uS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.9 257.9 0 224l33.9-33.9L190.1 33.9 224 0l33.9 33.9 156.2 156.2L448 224l-33.9 33.9-156.2 156.2L224 448l-33.9-33.9L33.9 257.9zm34-33.9L224 380.1 380.1 224 224 67.9zM320 512V397.3l150.6-150.7 22.7-22.6-22.6-22.6-9.4-9.4H640v320zm160-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48M224 160a24 24 0 1 1 0-48 24 24 0 1 1 0 48m-88 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48m88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0 136a24 24 0 1 1 0-48 24 24 0 1 1 0 48m88-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), RS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 0h-8.9l-6.7 5.8-56 48L352 61v60.9l7 7 24 24 7 7h82c13.3 0 24 10.7 24 24v40h-40.7L420.9 201c-40.2-26.7-87.4-41-135.7-41-60.8 0-119.5 22.7-164.5 63.6L7.9 326.2 0 333.4V512h320V389.3l-21.2-2.5L160 370.6V352h-48v61.4l21.2 2.5L272 432v32H48V354.6l105.1-95.5c36.2-32.9 83.3-51.1 132.2-51.1 38.8 0 76.7 11.5 109 33l40.5 27 6 4H544v-88c0-39.8-32.2-72-72-72h-62.1l-9.9-9.9V83l40.9-35h22.3C534.3 48 592 105.7 592 176.8V195c0 72.1-32 140.4-87.4 186.5l-8.6 7.2v75.2h-64v-67.3l-32.8 13.1h-.1c-.2.1-.5.2-.9.3-.9.3-2.4.8-4.6 1.5-4.2 1.3-10.8 3.1-19.5 5-6.2 1.3-13.6 2.6-22.1 3.8v48.4c12.3-1.5 23-3.4 31.9-5.2h.1V512h160V411c61-55 96-133.4 96-215.9v-18.3C640 79.2 560.8 0 463.2 0zm48 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), $S = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 144v-31.5c.3-18 14.9-32.5 33-32.5 9.5 0 18.6 4.1 24.8 11.3L312 144h-72zm120 0 46.1-52.7C380.4 84.1 389.5 80 399 80h1c17.7 0 32 14.3 32 32v32h-32zm152 48h112v84.7l-42.7 85.5-165.3-31V192h48zm-96 188 192 36 64-128V144H480v-31c0-44.7-36.3-81-81-81-23.4 0-45.6 10.1-61 27.7l-18 20.6-18-20.6A81.011 81.011 0 0 0 241 32c-44.7 0-81 36.3-81 81v31H0v144l64 128 192-36v100l64-40 64 40zm-128-48.8-165.3 31L48 276.7V192h208z" })
  }
), kS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H32v400H0v48h512v-48h-32V32h-24zm376 48v352H80V80zm-32 176a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-176 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), PS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m276.4 88-9.4 14.1c-31.8 47.7-88.6 72.3-145.1 62.9l-59.6-10c-7.4-1.2-14.2 4.5-14.2 12 0 3.2 1.3 6.3 3.6 8.6l-34 34A60.101 60.101 0 0 1 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3 0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8v25.2c0 32.7-26.5 59.3-59.3 59.3-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8.9-23.6 2.6l-62.2 13.8c-36 8-70.1-19.4-70.1-56.2 0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42 0-15.6-6.2-30.5-17.2-41.5l-29.2-29.1 33.9-33.9 29.2 29.2c20 20 31.2 47.1 31.2 75.4 0 28.7-11.6 56.2-32.1 76.3l-13 12.8c-1.8 1.8-2.9 4.3-2.9 6.8 0 6.1 5.7 10.7 11.6 9.3l62.3-13.8c11.2-2.5 22.6-3.7 34-3.7h10c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5 6.2 0 11.3-5 11.3-11.3v-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6 0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4L308.8 94c-1.8-8.2-9.1-14-17.5-14-6 0-11.6 3-14.9 8zM120 224l40-40 40 40-40 40zm128 96 40-40 40 40-40 40zm56-88-24-24 24-24 24 24z" })
  }
), FS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0h176v48H48v320h480V48H352V0h224v416H364.3l8 48H448v48H128v-48h75.7l8-48H0V0zm275.7 464-8-48h-55.4l-8 48h71.3zM312 24v174.1l39-39 17-17 33.9 33.9-17 17-80 80-17 17-17-17-80-80-17-17 34.1-33.9 17 17 39 39V0h48z" })
  }
), TS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h480v146.9c17 3.1 33.1 8.7 48 16.3V0H0v416h211.7l-8 48H128v48h266.8c-18.3-12.9-34.1-29.2-46.3-48h-96.2l8-48h66.4c-4.3-15.3-6.6-31.4-6.6-48H48zm432 72V96H352v48h46.1L304 238.1l-63-63-17-17-17 17L103 279l34 34 87-87 63 63 17 17 17-17 111-111v26c15.1-5.9 31.2-9.8 48-11.3zm160 248a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-118.6 25.4a35.9 35.9 0 1 0-50.7-50.7 35.9 35.9 0 1 0 50.7 50.7m10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-25.3 25.3-22.6-22.6 25.2-25.4c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6 25.4 25.3c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6-25.3 25.4c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6-25.4-25.3z" })
  }
), AS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h480v146.9c17 3.1 33.1 8.7 48 16.3V0H0v416h211.7l-8 48H128v48h266.8c-18.3-12.9-34.1-29.2-46.3-48h-96.2l8-48h66.4c-4.3-15.3-6.6-31.4-6.6-48H48zm432 72V96H352v48h46.1L304 238.1l-63-63-17-17-17 17L103 279l34 34 87-87 63 63 17 17 17-17 111-111v26c15.1-5.9 31.2-9.8 48-11.3zm160 248a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-167.2-32.6c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v26.8H480v-27.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6l-15.3-4.7 9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V272h32v25.4c6.3.9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z" })
  }
), DS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48H48v320h480zM48 416H0V0h576v416H364.3l8 48H448v48H128v-48h75.7l8-48zm212.3 0-8 48h71.3l-8-48zM376 96h104v128h-48v-46.1L321 289l-17 17-17-17-63-63-87 87-34-34 104-104 17-17 17 17 63 63 94.1-94H352V96z" })
  }
), yS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48H48v320h480zM48 416H0V0h576v416H364.3l8 48H448v48H128v-48h75.7l8-48zm212.3 0-8 48h71.3l-8-48zM249 177l-31 31 31 31 17 17-34 33.9-17-17-48-48-17-17 17-17 48-48 17-17 33.9 34.1-17 17zm112-34 48 48 17 17-17 17-48 48-17 17-33.9-34 17-17 31-31-31-31-17-17 33.9-33.9 17 17z" })
  }
), bS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48H48v320h480zM48 416H0V0h576v416H364.3l8 48H448v48H128v-48h75.7l8-48zm212.3 0-8 48h71.3l-8-48zM256 112h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), fS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m91.2 48 412.1 320H560V48H91.2zM32 2.1V0h576v416h-42.8l55.8 43.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l2.6 2M80 368h265l61 48h-9.6l8 48h62.5l13.1 10.3V512H160v-48h75.7l8-48H32V121.4l48 37.8zm267.7 48h-55.4l-8 48h71.3l-8-48z" })
  }
), US = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h480v320H48zM0 416h211.7l-8 48H128v48h320v-48h-75.7l-8-48H576V0H0v368zm315.7 0 8 48h-71.4l8-48h55.3z" })
  }
), GS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 0h-48v512h48zM304 368h-96V144h96zm48-224V96H160v320h192v-48zM80 512V0H32v512z" })
  }
), qS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v48h512V32zm368 176v96H144v-96zm-224-48H96v192h320V160h-48zm368 272H0v48h512z" })
  }
), WS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 252 48 108V80h48v28zm72-220H0v80l32 192h80l32-192V80zm104 220-24-144V80h48v28zm72-220H176v80l32 192h80l32-192V80z" })
  }
), ES = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64v64h-64V64zm176 216H16v-48h416zM192 384h64v64h-64z" })
  }
), OS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 24V0h-48v24c0 2.7-.1 5.4-.2 8H80.2c-.2-2.6-.2-5.3-.2-8V0H32v24c0 55.6 24.5 101.9 58.1 141.9 27.2 32.4 61.5 62 95.8 90.1-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488v24h48v-24c0-2.7.1-5.4.2-8h287.6c.2 2.6.2 5.3.2 8v24h48v-24c0-55.6-24.5-101.9-58.1-141.9-20.6-24.5-45.2-47.3-70.8-69.2-8.7 7.1-17.3 14.1-25.7 20.9l-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1 11.2 9.4 22.1 18.8 32.3 28.3h-115c22-20.4 46.7-40.4 72.2-61 .3-.2.5-.4.8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24M121.1 384h205.8c12.4 15.7 22.4 31.6 29.4 48H91.7c7-16.4 17-32.3 29.4-48zM91.7 80h264.6c-7 16.4-17 32.3-29.4 48H121.1c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1-20.3-16.5-39.7-32.7-57.5-49.1z" })
  }
), IS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m416-48v96H96v-96z" })
  }
), NS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 319.8V464h48V274.3L302.2 224H288v106.5l48-10.6zm-96 15.9V224H112.1l-.1.9V464h48V319.8l58.4 12.9c7 1.5 14.2 2.6 21.6 3m97.1-146.6 52 32L394 192h86c26.5 0 48-21.5 48-48v-32h-51.9l-14-14.1-18-17.9h-88.8L338 183.9zm-272.9 31c-1.1-.3-2.2-.7-3.3-1.1-17.3-6-32.2-17.3-42.8-32.2-6.1-8.6-10.8-18.6-13.5-29.4L.7 141.8l46.6-11.6 3.9 15.5C55.6 163.5 71.6 176 90 176h140.9L88.7 58.5 70.2 43.2l30.6-37 18.5 15.3 173.3 143.1 20.9-125.3 3.1-18.7L320 0h24l3.4 4.6 16.7 22.3L368 32h96l32 32h80v80c0 53-43 96-96 96h-45.3l-2.7 16v256H288V379.6c-10.4 2.3-21.1 3.7-32 4.2-2.7.1-5.3.2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2V512H64V224c0-1.3.1-2.6.2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), XS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 319.8V464h48V274.3L302.2 224H112.1l-.1.9V464h48V319.8l58.4 12.9c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2zm1.1-130.7 52 32L394 192h86c26.5 0 48-21.5 48-48v-32h-51.9l-14-14.1-18-17.9h-88.8L338 183.9zm-272.9 31c-1.1-.3-2.2-.7-3.3-1.1-17.3-6-32.2-17.3-42.8-32.2-6.1-8.6-10.8-18.6-13.5-29.4L.7 141.8l46.6-11.6 3.9 15.5C55.6 163.5 71.6 176 90 176h200.7l22.8-136.7 3.1-18.7L320 0h24l3.4 4.6 16.8 22.3L368 32h96l32 32h80v80c0 53-43 96-96 96h-45.3l-2.7 16v256H288V379.6c-10.4 2.3-21.1 3.7-32 4.2-2.7.1-5.3.2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2V512H64V224c0-1.3.1-2.6.2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), KS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 24V0h-48v71.7c-3.1.1-6.2.3-9.3.6-23.2 1.9-47.2 7.4-67.2 20.1-20.8 13.2-36 33.6-41.5 61.8-3.9 20.3-2 38.8 6.1 55.2 8 16 20.9 27.6 34.8 36.2 26.2 16.2 61.9 25.3 92.9 33.2l2.3.6c33.9 8.6 62.6 16.1 81.7 28 9 5.6 14.3 11.2 17.1 16.9 2.7 5.3 4.2 12.8 2 24.5-2.9 14.7-13.4 26.9-34.5 34.9-21.6 8.2-52 10.9-87.6 5.9-22.6-3.3-61.8-12.7-83-22.1l-21.9-9.7-19.6 43.7 21.9 9.7c26.8 12 70.9 22.2 95.8 25.8h.1c3.3.5 6.6.9 9.9 1.2V512h48v-72.6c19.3-1.3 37.4-4.9 53.5-11 31.9-12.1 57.7-35.2 64.5-70.6 3.9-20.3 2-38.8-6.1-55.2-8-16-20.9-27.6-34.8-36.2-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28-9-5.6-14.3-11.2-17.1-16.9-2.7-5.3-4.2-12.8-2-24.5 2.9-14.8 10.1-24 20.2-30.4 10.9-6.9 26.3-11.2 45.3-12.7 38.3-3.1 83.1 5.3 113.9 12.5l23.4 5.5 11-46.7-23.4-5.4c-18.7-4.4-44.2-9.7-71.5-12.5z" })
  }
), QS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h128c10.4 0 19.6 6.7 22.8 16.6L250 320.2c2-.1 4-.2 6-.2 33.2 0 62.5 16.9 79.8 42.5L544 289.4l22.6-8 15.9 45.3-22.6 8-208.2 73.1c.2 2.7.3 5.4.3 8.2 0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L110.6 48H0zm304 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), ZS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h110.6l93.7 287.1C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6l22.6-8-15.9-45.3-22.6 8-208.3 73.2C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L150.8 16.6C147.6 6.7 138.4 0 128 0zm232 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96M446.5 87.7l-8.2-22.2-22.3 7.9-191.1 67.1 14.9 45.6 57.5-20.2 24.1 66.3 8.2 22.6 45.1-16.4-8.2-22.6-23.9-65.8 67-23.5 57.3 156 45.3-15.9-65.7-178.9" })
  }
), JS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 352h-88l32 80-32 80h88l32-80zm-56-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48m-96.1 69.9 12.3 20.6 16.9-10.1-6.7-18.5-22.6 8.1zm-24.4 14.7L27.2 200zM24 229.9l-12.3-20.6-11.7 7v13.6zm0 66.1H0v24h24zm224.9 0 16.8-17.2-7-6.8h-9.8v24zm49.1 48-16.8 17.2 7 6.8h9.8zm30 0v24h24v-24zm0-48v-24h-24v24zm92.5-183.3-21.1-11.4-8 14.8 11.2 12.6 17.9-16zM464 32l21.1 11.4L496 23.2l-19.7-11.8zm-8-4.8 12.3-20.6-8.9-5.3-10 2.8zM350.3 56.8l-11.6 21 8.6 4.7 9.4-2.6-6.5-23.1zM192 48h30.3V0H192zM80 160c0-61.9 50.1-112 112-112V0C103.6 0 32 71.6 32 160zm6.5 37.8C82.3 186 80 173.3 80 160H32c0 18.9 3.3 37.1 9.4 54l45.2-16.2zm-34.6 43.3 24.4-14.6-24.7-41.2L27.2 200l24.7 41.2zm-15.5 9.3 15.5-9.3L27.2 200l-15.5 9.3 24.7 41.2zM48 248v-18.1H0V248zm0 16v-16H0v16zm0 32v-32H0v32zm8-24H24v48h32zm136 0H56v48h136zm24 0h-24v48h24zm32.9 0H216v48h32.9zm65.9 54.8-49.1-48-33.6 34.3 49.1 48zM328 320h-30v48h30zm-24-24v48h48v-48zm40-24h-16v48h16zm88 88c0-48.6-39.4-88-88-88v48c22.1 0 40 17.9 40 40zm0 8v-8h-48v8zm-88 88c48.6 0 88-39.4 88-88h-48c0 22.1-17.9 40-40 40zm1.7-48H344v48h1.7zM464 289.7C464 355 411 408 345.7 408v48c91.8 0 166.3-74.5 166.3-166.3zm-61.4-161c38.2 42.8 61.4 99.1 61.4 160.9h48c0-74.1-27.8-141.7-73.6-192.9l-35.8 32zm40.3-108.1-43.5 80.7 42.3 22.8 43.5-80.7zm.8 27.2 8 4.8 24.7-41.2-8-4.8zm-86.9 32.1 105.7-29.6-13-46.2-105.7 29.6 12.9 46.2zM222.3 48c42.2 0 81.9 10.8 116.4 29.8l23.2-42C320.5 13 272.9 0 222.3 0zM344 408H216v48h128z" })
  }
), jS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32h-48v32h-80v48h80v76.1c-21.9-17.6-49.7-28.1-80-28.1-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1V416h48V112h32V64h-32zM112 288a80 80 0 1 1 160 0 80 80 0 1 1-160 0m272 208v-48H0v48z" })
  }
), YS = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 294.1 7.2 3.6 2.3 1.2 1.8 1.8 44 44 74.3 7.4 1.5.2 1.5.4 75.4 22.6 75.4-22.6 1.5-.4 1.5-.2 74.3-7.4 44-44 1.8-1.8 2.3-1.2 7.2-3.6v9.9c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160v-96c0-88.4-114.6-160-256-160m38.6 48-11.3 11.3-16 16-11.3 11.3-22.6-22.6 11.3-11.3 16-16L272 73.4zm-112 16-11.3 11.3-32 32-11.3 11.3-22.6-22.6 11.3-11.3 32-32L160 89.4zm201.4 9.4 11.3 11.3 32 32 11.3 11.3-22.6 22.6-11.3-11.3-32-32-11.3-11.3zM48 192h64v32H48zm336 25.4 11.3 11.3 32 32 11.3 11.3-22.6 22.6-11.3-11.3-32-32-11.3-11.3zm-240 16 11.3 11.3 32 32 11.3 11.3-22.6 22.6-11.3-11.3-32-32-11.3-11.3zM342.6 272l-11.3 11.3-32 32-11.3 11.3-22.6-22.6 11.3-11.3 32-32 11.3-11.3zM256 224c-35.3 0-64-14.3-64-32s28.7-32 64-32 64 14.3 64 32-28.7 32-64 32" })
  }
), _S = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 48v416H144V48zm48 416V0H96v464H0v48h576v-48h-24zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64" })
  }
), hz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 0-48 12L64 64v400H0v48h320V49.5zm-48 61.5V464H112V101.5zM224 288c13.2 0 24-14.4 24-32s-10.8-32-24-32-24 14.4-24 32 10.7 32 24 32m128-176h112v400h112v-48h-64V64H352z" })
  }
), cz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-.9.8-2 1.7-3.2 2.8-13.7 11.8-45.7 39.4-68.6 82.1 25.6 37.5 65.2 61.6 103.8 75.8v-.7c0-11.9 1.6-23.5 4.7-34.4C236.6 90.6 220.9 48.5 224 0m16 188.8c-46.8-18.1-96.6-50.4-124.9-103.2-5.3-10-9.9-20.7-13.6-32.2-2.2-6.8-4-14-5.5-21.4-1.7 2.6-4.5 6.1-8.1 10.4-7.4 9.1-17.8 22.1-27.7 38.4C45.5 105.3 32 137.4 32 176c0 54.4 17.4 97.3 39.8 129.8 10.4 15.1 21.9 28 33.3 38.8L56 363l-10.5 3.9L0 384l24.1 42.2L64 496l128 16 73.1-64H320c88.4 0 160-71.6 160-160V120l4.6-8L512 64H384c-51 0-92.7 39.7-95.8 89.9-.1 2-.2 4.1-.2 6.1v43.1c-14.9-3.2-31.2-7.9-48-14.4zM432 112v176c0 61.9-50.1 112-112 112h-72.9l-13.6 11.9-56.9 49.8-82.8-10.4-24.1-42.2 52.3-19.6 71.9-27-55.8-52.8C109 282.2 80 239.1 80 176c0-15.6 3.1-30 7.9-42.9 50.9 72.2 134.6 105.1 190 117l58 12.4V160c0-26.5 21.5-48 48-48h48zm-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), sz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 256v48h76.1L224 412.1 115.9 304H192V176h64zm1.9 190.1L384 320v-64h-80V128H144v128H64v64l126.1 126.1L224 480zM64 96V32H0v64zm96 0V32H96v64zm32-64v64h64V32zm160 64V32h-64v64zm32 0h64V32h-64z" })
  }
), vz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256v48h76.1L192 412.1 83.9 304H160V176h64zm1.9 190.1L352 320v-64h-80V128H112v128H32v64l126.1 126.1L192 480zM24 80h360V32H0v48z" })
  }
), ez = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M478.1 129.9 474 134l-34 34 6.1 6.1L474 202l6 6-33.9 33.9L432 256H256V80l14.1-14.1L304 32l6.1 6.1L338 66l6 6 33.9-33.9L382 34l34-34 33.9 33.9L478 62l34 34zM256 256v176l-14.1 14.1L208 480l-6.1-6.1L174 446l-6-6-33.9 33.9-4.1 4.1-34 34-33.9-33.9-28.2-28.2L0 416l33.9-33.9L38 378l34-34-6.1-6.1-27.8-27.8L32 304l33.9-33.9L80 256h128zm150.1-54.1-34-33.9 33.9-33.9L444.1 96 416 67.9 377.9 106 344 139.9 310.1 106l-6.1-6.1V208h108.1l-6.1-6.1zM105.9 310.1l34 33.9-33.9 33.9L67.9 416 96 444.1l38.1-38.1 33.9-33.9 33.9 33.9 6.1 6.1V304H99.9l6.1 6.1z" })
  }
), lz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m136 267.9 33.9-33.9L272 131.9l44.1 44.1-102 102.1-34 33.9 33.9 33.9 38.1 38.1H64V195.9l38.1 38.1zm-38.1-106L64 128l-33.9 33.9L16 176v256h256l14.1-14.1L320 384l-33.9-33.9-4.1-4.1-34-34 33.9-33.9L350 210l34-34-33.9-33.9-44.2-44.2L272 64l-33.9 33.9L170 166l-34 34-33.9-33.9L98 162z" })
  }
), tz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 352V48h-64v304H67.9l92.1 92.1 92.1-92.1H240zm1.9 126.1L160 512l-33.9-33.9L0 352v-48h80V0h160v304h80v48z" })
  }
), wz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 267.9 214.1 234 112 131.9 67.9 176l102 102.1 34 33.9-33.9 33.9-38.1 38.1H320V195.9L281.9 234zM286.1 162l33.9-34 33.9 33.9L368 176v256H112l-14.1-14.1L64 384l33.9-33.9 4.1-4.1 34-34-33.9-33.9-68.2-68.2L0 176l33.9-33.9 44.2-44.2L112 64l33.9 33.9L214 166l34 34 33.9-33.9 4.1-4.1z" })
  }
), gz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 128v48h76.1L224 284.1 115.9 176H192V48h64zm1.9 190.1L384 192v-64h-80V0H144v128H64v64l126.1 126.1L224 352zM48 344v-24H0v192h448V320h-48v144H48z" })
  }
), iz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480v-64H0v64zm96 0v-64H96v64zm32 0h64v-64h-64zm160 0v-64h-64v64zm32 0h64v-64h-64zM256 160v48h76.1L224 316.1 115.9 208H192V80h64zm1.9 190.1L384 224v-64h-80V32H144v128H64v64l126.1 126.1L224 384z" })
  }
), mz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 160v48h76.1L192 316.1 83.9 208H160V80h64zm1.9 190.1L352 224v-64h-80V32H112v128H32v64l126.1 126.1L192 384zM24 432H0v48h384v-48h-24z" })
  }
), az = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 272V80h-64v192H51.9L192 412.1 332.1 272H272zm112-48h48v64L225.9 446.1 192 480l-33.9-33.9L0 288v-64h112V32h160v192h48z" })
  }
), oz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v294.1l-95-95-17-17L86.1 216l17 17L239 369l17 17 17-17 136-136 17-17-34-33.9-17 17-95 95zM128.8 304H0v208h512V304H383.2l-48 48H464v112H48V352h128.8zM432 408a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), nz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0h259l7.2 8.4 96 112 5.8 6.7V224H510.1l-7-7-23-23v18l131.2 98.4 19.2 14.4 9.5 7.2v180H0V400h53.4l343-32.4-45.7-49.8-8.4-9.2-6.3-6.9V156l-49.7-22.1-14.3-6.3V88.4l14.3-6.3 28-12.5-30-16.6-12.3-6.9V24zm152 48h-49.8l5.4 3 42.1 23.4-44 19.5-31.6 14.1 23.7 10.5 14.3 6.3v15.6L384 248v35.1l2.1 2.3 78.3 85.4 32.6 35.6-48.1 4.5-392.2 37-1.1.1H48v16h544V356l-9.6-7.2-140.8-105.6-9.6-7.2v-92h65.9l7 7 25 25H592v-31.1L509 48h-61zm94.7 39.7c-1.8 5.3-5.5 10.1-10.8 13.1-11.5 6.6-26.2 2.7-32.8-8.8-2.9-5-3.8-10.6-2.9-15.9l46.4 11.6zm1.3-8.1v.9-.9M160 96l144 86.4v131.8l5.3 5.8H96l80-80L0 256z" })
  }
), rz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32m54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1 18.5 11.2 30.9 31.6 30.9 54.8s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1 11.2-18.5 31.6-30.9 54.8-30.9s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1-18.5-11.2-30.9-31.6-30.9-54.8s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1c-69.2-20.8-123.8-75.4-144.6-144.6C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3c20.8-69.2 75.4-123.8 144.6-144.6C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6M256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32M80 256a16 16 0 1 0-32 0 16 16 0 1 0 32 0m368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), dz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0m8 59.3v201.4c16 6.5 28.9 19.3 35.3 35.3h201.4c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2.5-6.6.8-10 .8-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7.3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5H123.3c-6.5 16-19.3 28.9-35.3 35.3zm286.1 197.5c3.2-.5 6.6-.8 9.9-.8 35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40H123.3c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64 0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96c0-35.3 28.7-64 64-64 26.9 0 49.9 16.5 59.3 40h201.4c9.5-23.5 32.5-40 59.3-40 35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0M64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32m336-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0M288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Sz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a16 16 0 1 1-32 0 16 16 0 1 1 32 0M64 32C28.7 32 0 60.7 0 96c0 26.9 16.5 49.9 40 59.3v201.4C16.5 366.1 0 389.1 0 416c0 35.3 28.7 64 64 64 26.9 0 49.9-16.5 59.3-40h201.4c9.5 23.5 32.5 40 59.3 40 35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3V155.3c23.5-9.5 40-32.5 40-59.3 0-35.3-28.7-64-64-64-26.9 0-49.9 16.5-59.3 40H123.3C113.9 48.5 90.9 32 64 32m296 324.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V155.3c16-6.5 28.9-19.3 35.3-35.3h201.4c6.5 16 19.3 28.9 35.3 35.3zM64 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32M400 96a16 16 0 1 1-32 0 16 16 0 1 1 32 0m-16 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), zz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m446.7 67.2-17 17-102.1 102.1 67.7 67.7 11.3 11.3 22.7 22.7-22.6 22.6-11.3 11.3-148.8 148.7-9.4 9.4H0V242.7l9.4-9.4L158.1 84.7l11.3-11.3L192 50.7l22.6 22.6 11.3 11.3 67.7 67.7L395.8 50.2l17-17 33.9 33.9zM48 262.6V432h169.4l58.3-58.3-169.4-169.4zm92.3-92.3 169.4 169.4 51.7-51.7L192 118.6z" })
  }
), pz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96v16h128v48H0v-48h112V96zm368 64H352v-48h128V96h48v16h112v48h-24zm-416 96v-64h48v49.6l10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7V192h48v78.4l-12.8 6.8-51.6 27.3 26.8 32.1 5.6 6.7V416H448v-55.3l-27.7-33.2-41.1 21.7-5.2 2.8H266l-5.3-2.8-41.1-21.7-27.6 33.2V416h-48v-72.7l5.6-6.7 26.8-32.1-51.6-27.3-12.8-6.8zm307.3 17.7-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304h84l57.2-30.3z" })
  }
), Mz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1l-38.5-51.4C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64 27.1 0 50.3 16.9 59.6 40.7l51.4 38.5c.7-5 1-10.1 1-15.2m-10.7 47.9L173.5 130 128 96l-32 32 34.1 45.4 29.9 39.8.1.1v85.3l-.1.1-29.9 39.8L96 384l32 32 45.4-34.1 39.8-29.9.1-.1h85.3l.1.1 39.8 29.9L384 416l32-32-34.1-45.4-29.9-39.8-.1-.1v-85.4l.1-.1 29.9-39.8L416 128l-32-32-45.4 34.1-39.8 29.9-.1.1h-85.4l-.1-.1zm9.7 224.9-51.3 38.5c-9.4 23.8-32.6 40.7-59.7 40.7-35.3 0-64-28.7-64-64 0-27.1 16.9-50.3 40.7-59.6l38.5-51.4c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112c0-5.2-.3-10.2-1-15.2M288 112c0 5.2.3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64 0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1 61.9 0 112-50.1 112-112S461.9 0 400 0 288 50.1 288 112m1 272.8c-.7 5-1 10.1-1 15.2 0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-5.2 0-10.2.3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6 0 35.3-28.7 64-64 64-27.1 0-50.3-16.9-59.6-40.7zM304 208v96h-96v-96z" })
  }
), xz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 320c0-14.5-7.4-39.2-24.7-72.8-16.5-32-39-66.6-62.3-99-20.2-28.1-40.5-53.9-57-74.1-16.5 20.2-36.8 46-57 74.1-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144M0 320c0-78.8 106.1-217.2 160.5-283.1C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320m464-208a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0" })
  }
), Hz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 320c0-14.5-7.4-39.2-24.7-72.8-16.5-32-39-66.6-62.3-99-20.2-28.1-40.5-53.9-57-74.1-16.5 20.2-36.8 46-57 74.1-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144M0 320c0-78.8 106.1-217.2 160.5-283.1C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320m278.6-64-11.3 11.3-128 128-11.3 11.3-22.6-22.6 11.3-11.3 128-128 11.3-11.3zM136 240a24 24 0 1 1 0 48 24 24 0 1 1 0-48m112 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Vz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m505.5 369.7 115.4 89.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 161.5 125.4c27.8-40.3 57.2-77.4 78.6-103.3C307.3 14.1 320 0 320 0s12.7 14.1 31.5 36.9C405.9 102.8 512 241.2 512 320c0 17.2-2.3 33.8-6.5 49.7m-257.6-200 215.1 167c.6-5.5 1-11.1 1-16.7 0-14.5-7.4-39.2-24.7-72.8-16.5-32-39-66.6-62.3-99-20.2-28.1-40.5-53.9-57-74.1-16.5 20.2-36.8 46-57 74.1-5.1 7.1-10.1 14.2-15.1 21.4zm208.2 285.7c-34.7 35-82.9 56.6-136.1 56.6-106 0-192-86-192-192 0-27.4 12.8-61.9 31.8-98.1l38.4 30.3c-15.5 31-22.2 54-22.2 67.8 0 79.5 64.5 144 144 144 37.9 0 72.4-14.6 98.1-38.6zM328 368v48c-57.4 0-104-46.6-104-104h48c0 30.9 25.1 56 56 56" })
  }
), Cz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 320c0-14.5-7.4-39.2-24.7-72.8-16.5-32-39-66.6-62.3-99-20.2-28.1-40.5-53.9-57-74.1-16.5 20.2-36.8 46-57 74.1-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144M0 320c0-78.8 106.1-217.2 160.5-283.1C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320m200 48v48c-57.4 0-104-46.6-104-104h48c0 30.9 25.1 56 56 56" })
  }
), Lz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 160c0-9.9-8-29.9-55-49.8-19.3-8.2-42.6-15-69-20l-11.1 66.5 31.2 68.7c18.2-4.4 34.6-9.7 48.9-15.7 47.1-19.9 55-39.9 55-49.8zm48 0v192c0 24.3-11.3 44.9-28.1 61-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352V160C0 80 128.9 32 288 32s288 48 288 128m-48 74.9C476.4 269 388.2 288 288 288S99.6 269 48 234.9V352c0 8.2 3.5 16.9 13.3 26.3 10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6 9.9-9.4 13.3-18.2 13.3-26.3zM48 160c0 9.9 8 29.9 55 49.8 14.3 6 30.7 11.3 48.9 15.7l31.2-68.7L172 90.2c-26.4 5.1-49.7 11.9-69 20-47 19.9-55 39.9-55 49.8m308.4-76.7C334.9 81.2 312 80 288 80s-46.9 1.2-68.4 3.3l6.8 41L288 150l61.6-25.7 6.8-41zm19 151.1-26.3-57.9-51.9 21.6-9.2 3.9-9.2-3.8-51.9-21.6-26.3 57.9c26.9 3.6 56.3 5.6 87.5 5.6s60.6-2 87.5-5.6z" })
  }
), Bz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m501.2 76.1 20.1-13.2-26.4-40.1-20.1 13.1-104.6 68.6C335.8 98.7 297 96 256 96 114.6 96 0 128 0 208v160c0 24.9 14.9 44.5 33.2 58.7 18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9 18.3-14.1 33.2-33.7 33.2-58.6V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zm-193.8 69.5-64.6 42.3-20.1 13.2 26.3 40.2 20.1-13.2 111.1-72.8c14.7 3.2 27.9 7 39.4 11.5 38.8 15 44.4 30.6 44.4 41.2 0 .8-2.7 17.2-46 35.9-38.9 16.8-96 28.1-162 28.1s-123.1-11.3-162-28.1c-43.3-18.7-46-35.1-46-35.9 0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1.5 51.4 1.6M424 293.2c15-5.6 28.4-12 40-19V368c0 4.1-2.3 11.2-14.5 20.7-6.5 5-15 10-25.5 14.6zm-144 26.3c34.4-1.3 66.9-5.6 96-12.2v111.8c-27.9 6.7-60.5 11.1-96 12.5v-112zm-144-12.1c29.1 6.6 61.6 10.8 96 12.2v112c-35.5-1.4-68.1-5.8-96-12.5zm-88-33.2c11.6 7 25 13.4 40 19v110.1c-10.4-4.7-18.9-9.6-25.5-14.6C50.3 379.2 48 372.1 48 368z" })
  }
), uz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m233.5 352-58.4 58.3c10.5 10.8 16.9 25.5 16.9 41.7 0 33.1-26.9 60-60 60s-60-26.9-60-60v-12H60c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8l58.4-58.3V176C160 78.8 238.8 0 336 0c76.3 0 141.3 48.6 165.7 116.5 6.1 17 9.7 35.3 10.2 54.3-14.5-6.9-30.8-10.8-47.9-10.8h-1c-61.4.5-111 50.5-111 112 0 10.5 1.5 20.8 4.2 30.4 4.7 16.5 13 31.5 24.1 44-14.1 3.7-29 5.6-44.3 5.6h-80zM208 270.1l33.9 33.9h65.3c-2.1-10.3-3.2-21-3.2-32 0-82.7 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128v80z" })
  }
), Rz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m233.5 352-58.4 58.3c10.5 10.8 16.9 25.5 16.9 41.7 0 33.1-26.9 60-60 60s-60-26.9-60-60v-12H60c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8l58.4-58.3V176C160 78.8 238.8 0 336 0s176 78.8 176 176-78.8 176-176 176h-80zm22.5-48h80c70.7 0 128-57.3 128-128S406.7 48 336 48s-128 57.3-128 128v94.1l33.9 33.9z" })
  }
), $z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h352V48zM0 0h448v512H0V48zm104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48m56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M80 288a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120-70.6-12.7-12.7-22.6 22.6 12.7 12.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7 22.6-22.6-12.7-12.7c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6m80 0-12.7-12.7-22.6 22.6 12.7 12.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7 22.6-22.6-12.7-12.7c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6" })
  }
), kz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v416H48V48zM48 0H0v512h448V0h-48zm80 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m40 256c-44.7 0-82.3-30.6-93-72h77v-48h-77c10.7-41.4 48.2-72 93-72 53 0 96 43 96 96s-43 96-96 96m0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288" })
  }
), Pz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m250.8 272.4-146.5 52.8-17.8 6.4-17.4-7.4-18.3-7.9C63.9 382.3 122.1 432 192 432h120c44.2 0 80-35.8 80-80v-12.8c0-22.4-9.2-42.8-24.4-57.5L352 266.6v-42.2l19.8-15.2C389 195.9 400 175.3 400 152c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 17.1 5.9 32.8 15.9 45.1l16.1 20V259zM32 256l16 6.9L88 280l99.5-35.8 47-16.9c-10.1-12.5-17.7-27.1-22.1-43-2.9-10.3-4.4-21.1-4.4-32.3 0-66.3 53.7-120 120-120 60.8 0 111 45.2 118.9 103.9l1.1.1 64-8v8c0 52.5-42.2 95.2-94.5 96-5 5.6-10.5 10.7-16.4 15.3 9 8.7 16.8 18.8 22.9 29.8 10.3 18.5 16.1 39.7 16.1 62.2V352c0 70.7-57.3 128-128 128H192C91.3 480 8.8 402.6.7 304c-.4-5.3-.7-10.6-.7-16v-32zm312-128a24 24 0 1 1 0 48 24 24 0 1 1 0-48M231.5 353.7c22.7-5.7 38.1-24 40.8-44l47.6 6.3c-5.3 39.8-35.2 73.9-76.7 84.2-34.1 8.5-68.6-.8-92.8-22.3l31.9-35.9c12.5 11.1 30.7 16.2 49.3 11.6z" })
  }
), Fz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h128v200h128V32h128v72h80v128h48v48h-48v128h-80v72H384V280H256v200H128v-72H48V280H0v-48h48V104h80V56zm48 72v328h32V80h-32zm-48 48H96v208h32zm336 232V80h-32v352h32v-24zm80-24V152h-32v208z" })
  }
), Tz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32 0 160h114.9l25.6-128zm240 128V32h-98.9l-25.6 128zm32 0h64.8c15.8-17.2 32.5-33.2 50-48.5L402.9 32H304zm240-42.9c9.5 8.5 18.7 17 27.7 25.7L544 32H435.5l11.2 56 1.3-1c22.7 18.4 44.8 37.2 65.3 58.2 7.6-7.5 15.6-14.6 23.5-21.7 2.4-2.1 4.8-4.3 7.2-6.4zM80.4 192H32l4 32H0v48h42l22 176v32h48v-32h224.8c-12.7-14.2-23.4-30.4-31.4-48h-199l-20-160h223.7c9-16.9 20-33 31.6-48H80.4m432.6.1c-32.3-37.5-65-64-65-64s-128 103.6-128 192 71.6 160 160 160 160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32zM530 401c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), Az = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32 0 160h114.9l25.6-128zm240 128V32h-98.9l-25.6 128zm32 0h124.5L402.9 32H304zm157.1 0H576L544 32H435.5zM86.4 240h403.2l-20 160H106.4l-20-160M42 272l22 176v32h48v-32h352v32h48v-32l22-176h42v-48h-36l4-32H32l4 32H0v48h24z" })
  }
), Dz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256C0 114.6 114.6 0 256 0s256 114.6 256 256v256H0zm320-113c15.1 7.5 28.7 17.6 40.2 29.6l62.2-41.5c-19.3-25.6-44.3-46.7-73.2-61.2zm-.4-85.1c-20-6.4-41.4-9.9-63.6-9.9s-43.6 3.5-63.6 9.9L222 132a146.492 146.492 0 0 1 68 0l29.6-74.1m-230 73.3 62.2 41.5c11.5-12.1 25.1-22.1 40.2-29.6L162.8 70c-28.9 14.5-53.9 35.5-73.2 61.2zm290 67c10.4 17.2 17.2 36.8 19.5 57.8H464c0-35.4-8.8-68.7-24.4-97.8zm-307.2-40C56.8 187.3 48 220.6 48 256h64.9c2.3-21 9.1-40.6 19.5-57.9l-60-40zM112 288H48v72h64zm288 0v72h64v-72zM48 392v72h64v-72zm352 0v72h64v-72zM272 192v-16h-32v288h32v-16zm-64 32v-16h-32v256h32v-16zm128 0v-16h-32v256h32v-16z" })
  }
), yz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h320v-48H48V272h208v-48H48V80h272V32h-24z" })
  }
), bz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m489 57-48 48-17 17-33.9-34 17-17 48-48 17-17 33.8 34zM185 361 57 489l-17 17-33.9-34 17-17L151 327l17-17 33.9 34-17 17zm55-249c-70.7 0-128 57.3-128 128v24H64v-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 50.8-21.6 96.6-56 128.7v7.3c0 75.1-60.9 136-136 136h-24v-48h24c48.6 0 88-39.4 88-88v-29.5l8.8-7.2C349.7 315.7 368 280 368 240c0-70.7-57.3-128-128-128m0 88c-22.1 0-40 17.9-40 40v24h-48v-24c0-48.6 39.4-88 88-88s88 39.4 88 88v24h-48v-24c0-22.1-17.9-40-40-40" })
  }
), fz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m508 177.6 3.5 17.7-47.1 9.4-3.5-17.7c-11.8-58.9-47.1-110.5-97.8-142.7l25.8-40.5C450.6 43 493.6 105.8 508 177.6zM240 112c-70.7 0-128 57.3-128 128v24H64v-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 50.8-21.6 96.6-56 128.7v7.3c0 75.1-60.9 136-136 136h-24v-48h24c48.6 0 88-39.4 88-88v-29.5l8.8-7.2C349.7 315.7 368 280 368 240c0-70.7-57.3-128-128-128m0 88c-22.1 0-40 17.9-40 40v24h-48v-24c0-48.6 39.4-88 88-88s88 39.4 88 88v24h-48v-24c0-22.1-17.9-40-40-40m-72 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48M24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48m57-97 64 64 17 17-34 33.9-17-17L47 401l-17-17 34-33.9 17 17z" })
  }
), Uz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0h416v201.6c-12-6.1-25.6-9.6-40-9.6-2.7 0-5.4.1-8 .4V48H160v144.4c-2.6-.2-5.3-.4-8-.4-14.4 0-28 3.5-40 9.6V24zm368 224.6c2.6-.4 5.3-.6 8-.6 12 0 23.2 3.8 32.3 10.2 5-1.5 10.3-2.2 15.7-2.2 19.9 0 37.5 10.4 47.4 26.1 23.4 6.7 40.6 28.3 40.6 53.9 0 5.1-.7 10.1-2 14.9 11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9 0 25.6-17.2 47.2-40.6 53.9-9.9 15.7-27.5 26.1-47.4 26.1-5.5 0-10.7-.8-15.7-2.2-9.1 6.4-20.3 10.2-32.3 10.2-30.9 0-56-25.1-56-56 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-11.9 3.7-22.9 10-32-6.3-9.1-10-20.1-10-32 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-28.2 20.9-51.6 48-55.4m-328-.6c2.7 0 5.4.2 8 .6 27.1 3.9 48 27.2 48 55.4 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 11.9-3.7 22.9-10 32 6.3 9.1 10 20.1 10 32 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 30.9-25.1 56-56 56-12 0-23.2-3.8-32.3-10.2-5 1.5-10.3 2.2-15.7 2.2-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1.7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9 0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7.8 15.7 2.2 9.1-6.4 20.3-10.2 32.3-10.2m-6.9 84 13.9-24c.7-1.1 1-2.4 1-4 0-4.4-3.6-8-8-8-1.8 0-3.3.5-4.6 1.4l-18.9 13.4-22.2-6.5c-.7-.2-1.4-.3-2.3-.3-2.8 0-5.3 1.4-6.8 3.8l-9.8 15.5-17.6 5c-3.4 1-5.8 4.1-5.8 7.7 0 .8.1 1.5.3 2.2l7.7 28.1-21.4 19.8c-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9L72 393.7l-7.7 28.1c-.2.6-.3 1.3-.3 2.2 0 3.6 2.4 6.7 5.8 7.7l17.6 5 9.8 15.5c1.5 2.4 4 3.8 6.8 3.8.9 0 1.6-.1 2.3-.3l22.2-6.5 18.9 13.4c1.3.9 2.8 1.4 4.6 1.4 4.4 0 8-3.6 8-8 0-1.5-.4-2.8-1-4l-13.9-24 13.9-24c.7-1.1 1-2.4 1-4 0-1.8-.5-3.3-1.4-4.5L139.4 368l19.2-27.5c.9-1.3 1.4-2.8 1.4-4.5 0-1.5-.4-2.8-1-4zm336-24 13.9 24-14 24c-.7 1.1-1 2.4-1 4 0 1.8.5 3.3 1.4 4.5l19.2 27.5-19.2 27.5c-.9 1.3-1.4 2.8-1.4 4.5 0 1.5.4 2.8 1 4l13.9 24-13.9 24c-.7 1.1-1 2.4-1 4 0 4.4 3.6 8 8 8 1.8 0 3.3-.5 4.6-1.4l18.9-13.4 22.2 6.5c.7.2 1.4.3 2.3.3 2.8 0 5.3-1.4 6.8-3.8l9.8-15.5 17.6-5c3.4-1 5.8-4.1 5.8-7.7 0-.8-.1-1.5-.3-2.2l-7.7-28.1 21.4-19.8c1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9L568 342.3l7.7-28.1c.2-.6.3-1.3.3-2.2 0-3.6-2.4-6.7-5.8-7.7l-17.6-5-9.8-15.5c-1.5-2.4-4-3.8-6.8-3.8-.9 0-1.6.1-2.3.3l-22.2 6.5-18.9-13.4c-1.3-.9-2.8-1.4-4.6-1.4-4.4 0-8 3.6-8 8 0 1.5.4 2.8 1 4z" })
  }
), Gz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m263.7 316.9-25.9 14.9 1.9 29.8c.1 2.1.2 4.2.2 6.4 0 53-43 96-96 96s-96-43-96-96V192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 53.3-29 100-72.3 124.9zM288 368c0-3.2-.1-6.4-.3-9.5C345.3 325.3 384 263.2 384 192 384 86 298 0 192 0S0 86 0 192v176c0 79.5 64.5 144 144 144s144-64.5 144-144M128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v32h48v-32c0-61.9-50.1-112-112-112S80 130.1 80 192v54.8l13.3 6.6 34.7 17.4v5.9l-39.4 32.9-18.4 15.3 30.7 36.9 18.4-15.4 48-40 8.6-7.2v-58l-13.3-6.6-34.6-17.4z" })
  }
), qz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-22.3-3.5-43.8-10-64H352v32l32 32v64h-32v48l-48 48h-48v-96h-96v-88l40-40h88l64-64h-96l-32 32h-32V58C108.4 85 48 163.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Wz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M437.6 154.4 400 192v80h63.4c-8.2 107.4-97.9 192-207.4 192-114.9 0-208-93.1-208-208 0-19.5 2.7-38.4 7.7-56.3L96 240h48l48 48v64l32 32v48h64v-32l64-64v-80H224l-32-32v-32h80v-32l-32-32v-16l32-32V48.6c71.2 5.4 132.4 46.7 165.6 105.8M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), Ez = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M367.6 431.6 352 416h-64v-64l64-64h64v32h38c6.5-20.2 10-41.7 10-64 0-98.4-68.3-180.8-160-202.4V112l-32 32v80h-48v96h-64l-32-32H50.4C65.8 387.7 152 464 256 464c41.1 0 79.3-11.9 111.6-32.4M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m192 128h-64v-32h64zm160-256v64h-32v-64zm-96 128h32v64h-32z" })
  }
), Oz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 463.4V432h-64l-48-48V272h144l48 48h32l32 32h24.6c5.3-10.2 9.8-20.9 13.4-32h-22l-48-48v-80h32v-32h-64v48h-96v32h-64v-32l80-80v-16h-48V80l32-32C141.1 48 48 141.1 48 256s93.1 208 208 208c5.4 0 10.7-.2 16-.6M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m187.3-132.7-32 32-11.3 11.3-22.6-22.6 11.3-11.3 32-32L176 89.4l22.6 22.6-11.3 11.3z" })
  }
), Iz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m387.3 123.3-24 24-11.3 11.3-22.6-22.6 11.3-11.3 24-24 11.3-11.3 22.6 22.6zM288 400v32h-64v-32zm128-144v64h-32v-64zm-224-96v-32h96v64h-64zM96 336v-48l64-64h32v32h32v-32h32l64 64v80h-96l-32-32z" })
  }
), Nz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M193.1 23.2 256 57.1l62.9-33.9L362 0l14.1 46.9 5.4 18.1c-15.3 6.6-29.6 15-42.7 24.8L333 70.2l-54.2 29.2-22.8 12.2-22.8-12.2L179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2 12.2 22.8-12.2 22.8L70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2 22.7-12.3 22.8 12.3 54.2 29.1 5.9-19.7c13.1 9.9 27.4 18.3 42.7 24.8l-5.4 18L362 512l-43.1-23.2-62.9-33.9-62.9 33.9L150 512l-14.1-46.9-20.5-68.4-68.5-20.6L0 362l23.2-43.1L57.1 256l-33.9-62.9L0 150l46.9-14.1 68.4-20.5L135.8 47 150 0zM256 144c10.4 0 20.6 1.4 30.1 4.1-8.4 13.9-15.3 28.9-20.3 44.6-3.2-.5-6.5-.7-9.8-.7-35.3 0-64 28.7-64 64s28.7 64 64 64c3.3 0 6.6-.3 9.8-.7 5 15.8 11.9 30.7 20.3 44.6-9.6 2.7-19.7 4.1-30.1 4.1-61.9 0-112-50.1-112-112s50.1-112 112-112zm336 112a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-304 0a176 176 0 1 1 352 0 176 176 0 1 1-352 0" })
  }
), Xz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2-14.5 14-22.6 32-24.3 50.6-4.6 52.6-19.6 123.5-49.3 175-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7 23.3-14.3 50.6-25.3 77.1-29 12.7-1.8 25.3-6.7 36.4-15 35.5-26.3 42.9-76.4 16.6-111.9-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7 27.5 7 52.8 23.2 71 47.8 42.1 56.8 30.2 137-26.6 179.1-17.8 13.2-37.9 21.1-58.4 24-37.2 5.2-84.5 32.7-103.3 65.2-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1-224 0m104-48v-32c-39.8 0-72 32.2-72 72h32c0-22.1 17.9-40 40-40" })
  }
), Kz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 448c-74.7 0-144-75.4-144-160 0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160M0 288c0 106 86 208 192 208s192-102 192-208c0-112-64-272-192-272S0 176 0 288m112 0c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2l-21.6-23.6c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288v16h32z" })
  }
), Qz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511.4 34.6 480 65.9V224l-48-16-16-48-48-16-16-48-48-16-16-48h158.1L477.4.6l33.9 33.9zM169.9 139.3c35.4-17.2 71.1-34.5 101.1-57l2.6 7.8 5.1 15.2 15.2 5.1 13.6 4.5c-15.9 12.7-32.7 23.4-49.3 32.9-21.5 12.3-47 24.8-70.4 36.2-13.9 6.8-27 13.2-38 18.9-33.6 17.6-59 34.3-76.1 54.5-15.7 18.5-26.2 42-25.6 77.9 1 70 59 128.7 128.5 128.7 59 .1 115.4-40.1 163.9-107 27.7-38.3 50.3-82 66.9-123.6l14.7 4.9 30.9 10.3C404.3 372 306.9 512.2 176.4 512 79.9 511.9 1.4 431.3 0 336c-1.6-113.5 83.4-154.7 169.9-196.7z" })
  }
), Zz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 134.3 65.7 304h316.6zM0 304 191.2 99.2 224 64l32.8 35.2L448 304v48H0zm24 96h424v48H0v-48z" })
  }
), Jz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h103.7c31.4 0 60.1 12.1 81.6 32h6.7c88.4 0 160 71.6 160 160v116.9c-11.2 6.2-24.6 9.9-39.3 9.9-3 0-5.9-.2-8.7-.4V192c0-53-36.8-97.3-86.2-109 2.8 8.6 4.6 17.7 5.4 27l.7 8-47.8 4-.7-8c-3.1-37.3-34.3-66-71.8-66H240v64c0 35.3 28.7 64 64 64h32v48h-32c-61.9 0-112-50.1-112-112V89.6c-65.2 23-112 85.3-112 158.4v44.6l-1.7 4.3-32 80-44.6-17.8L32 283.4V248c0-99.9 67.9-184 160-208.7V24zm336 381v18.7c0 17.8 14.5 32.3 32.3 32.3 15.8 0 29.3-11.4 31.9-27l.2-1 47.3 7.9-.2 1c-6.5 38.7-40 67.1-79.2 67.1-44.3 0-80.3-36-80.3-80.3v-18.8c-23.9-3.8-45.9-13.1-64-27V512H272V411.7c-21.2 2.8-42.8 2.8-64 0V512H64V384h48v80h48V356.3l27.4 3.9 24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5 27.4-3.9V464h48V304h48v4.6c18.6 25.7 50.9 42.2 88.7 42.2 30.1 0 57.1-11.4 76.3-29.6l22 23.3c-19.9 18.9-46 31.9-75 36.5m-96-189a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), jz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 80v16h160V80L144 0zm400 96v288H48V176zM48 128H0v384h512V128h-48zm320-32 80-80V0H288v16zM216 352H104l-24 80h160zm216 80-24-80H296l-24 80zM208 272a48 48 0 1 0-96 0 48 48 0 1 0 96 0m144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Yz = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 72v48H72V72zM72 32H32v128h128V32h-40zm48 200v48H72v-48zm-48-40H32v128h128V192h-40zm0 200h48v48H72zm-40-40v128h128V352H72z" })
  }
), _z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 232h48v48H72zm-40 48v40h128V192H32v40zm200-48h48v48h-48zm-40 48v40h128V192H192v40zm200 0v-48h48v48zm-40 40h128V192H352v88z" })
  }
), hp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 56h80v80H24zm0 160h80v80H24zm80 160v80H24v-80z" })
  }
), cp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 296v-80h80v80zm160 0v-80h80v80zm160-80h80v80h-80z" })
  }
), sp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M430.5 115.5 505 41 471 7l-74.5 74.5C358.1 50.6 309.2 32 256 32 132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471l34 34 74.5-74.5c38.4 31 87.3 49.5 140.5 49.5 123.7 0 224-100.3 224-224 0-53.2-18.6-102.1-49.5-140.5m-68.1.2L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176 39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3l246.6-246.6C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176-39.9 0-76.8-13.3-106.3-35.7" })
  }
), vp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 112h-96v32h88l96 64v240H224l-51.2-64H80V280H48v96H0V136h48v96h32v-88h200v-32h-96V64h240zM210.3 354l36.8 46H464V233.7L401.5 192H128v144h67.9zM544 192h96v256h-96zm-220 20v96h-40v-96zm-44 116h48v48h-48z" })
  }
), ep = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 112h-96v32h88l96 64v240H224l-51.2-64H80V280H48v96H0V136h48v96h32v-88h200v-32h-96V64h240zM210.3 354l36.8 46H464V233.7L401.5 192H128v144h67.9zM544 192h96v256h-96zm-320 96h-64v-64h64zm32-64h64v64h-64zm160 0v64h-64v-64z" })
  }
), lp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 150.8 208 143 108.2-74.4c-21.3 24-36.1 53.9-41.7 86.9L256 352 48 209v191h284c6.9 17.5 16.4 33.7 28.2 48H0V64h512v96.7c-5.3-.5-10.6-.7-16-.7-21.6 0-42.4 3.9-61.5 11.1l29.5-20.3V112H48zM352 336a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 281.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), tp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160m16 240V190.9c-5.2.7-10.6 1.1-16 1.1-23.5 0-45.4-7.3-63.4-19.7L256 293.8l-208-143V112h340.6c-3-10.1-4.6-20.9-4.6-32 0-5.4.4-10.8 1.1-16H0v384h512zm-48-191v191H48V209l208 143z" })
  }
), wp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48v167.6L64 183V0h384v183l-48 32.6V48zm144 362-27-18.3L48 268.9V464h416V268.9L283 391.7zm208-199.1 48-32.6V512H0V178.3l48 32.6L256 352zM276 96v6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3-12.2-1.9-22.2-.3-28.6 2.6-6.3 2.9-7.9 6.2-8.2 8.1-.6 3.4 0 4.7.1 5 .3.5 1 1.8 3.6 3.5 6.1 4.2 15.7 7.2 29.9 11.4l.8.2c12.1 3.7 28.3 8.5 40.4 17.4 6.7 4.9 13 11.4 16.9 20.5 4 9.1 4.8 19.1 3 29.4-3.3 19-15.9 32-31.6 38.7-4.9 2.1-10.1 3.6-15.4 4.6V308h-40v-26.4c-9.5-2.2-22-6.4-29.9-9.1-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1 9.5 3.2 20.2 6.9 26.2 7.9 12.8 2 22.7.7 28.8-1.9 5.5-2.3 7.4-5.3 8-8.8.7-4 .1-5.9-.2-6.7-.4-.9-1.3-2.2-3.7-4-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16-6.6-4.5-13.2-10.7-17.3-19.5-4.2-9-5.2-18.8-3.4-29 3.2-18.3 16.2-30.9 31.1-37.7 5-2.3 10.4-4 16-5.1V76h40v20z" })
  }
), gp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48v167.6L64 183V0h384v183l-48 32.6V48zm144 362-27-18.3L48 268.9V464h416V268.9L283 391.7zm208-199.1 48-32.6V512H0V178.3l48 32.6L256 352zM184 96h168v48H160V96zm0 80h168v48H160v-48z" })
  }
), ip = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 271.9V464h416V271.9l-194.5 132L256 413l-13.5-9.1zm414.5-57L256 60 49.5 214.9 256 355zM0 192 256 0l256 192v320H0v-48z" })
  }
), mp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 150.8 208 143 208-143V112H48zM464 209 256 352 48 209v191h416zM0 400V64h512v384H0z" })
  }
), ap = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48h320v48h48V0H64v192h48zM48 272h288v3.6L192 378.5 48 275.6zm0 62.6 130.1 92.9 13.9 10 13.9-10 130-92.9V464H48zM0 224v288h384V224H48zm272-32v-16h320v192H416v48h224V128H224v64zm288 16h-64v64h64z" })
  }
), op = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80H144v25.4l192 137.1 192-137.1zm0 84.4L349.9 291.5l-13.9 10-13.9-10L144 164.4V336h384zM144 32h432v352H96V32zM48 96v336h432v48H0V96z" })
  }
), np = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 144H16v48h416v-48h-24zm0 176H16v48h416v-48h-24z" })
  }
), rp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 480h384v-48H368l158.1-158.1L560 240l-33.9-33.9L369.9 49.9 336 16l-33.9 33.9L49.9 302.1 16 336l33.9 33.9zm140.1-48H179.9l-96-96 134-134.1 156.2 156.2z" })
  }
), dp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m206.9 64H640v176H481.1L249.9 490.2 231.8 506l-6.8 5.9H0V336h158.9l231.2-202.2 18.1-15.8 6.8-5.9zm18 48-11.3 9.9-237.8 208.2-6.8 5.9H48v80h159l11.3-9.9 237.9-208.2 6.8-5.9h129v-80H433zM320 128v24.5l-128 112V128z" })
  }
), Sp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 320v80h48v-80h48v80h48v-80h48v80h48v-80h48v80h40V240h-64v-64h-64v-64H176v64h-64v64H48v160h40v-80zM48 448H0V192h64v-64h64V64h256v64h64v64h64v256H88z" })
  }
), zp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7.6 16H0v48h57.3C84.8 412.5 170.5 480 272 480h48v-48h-48c-74.6 0-138.4-46.4-164-112h180v-48H96.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H288v-48H108c25.6-65.6 89.4-112 164-112h48V32h-48C170.5 32 84.8 99.5 57.3 192H0v48z" })
  }
), pp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 56V32H8v336h48v-24zm8 360H0v64h64z" })
  }
), Mp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 64h24v48H48v112H0V64h24zM0 312v-24h48v112h112v48H0v-24zM488 64h24v160h-48V112H352V64h24zm-24 248v-24h48v160H352v-48h112z" })
  }
), xp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 32h24v48H48v112H0V32h24zM0 344v-24h48v112h112v48H0v-24zM424 32h24v160h-48V80H288V32h24zm-24 312v-24h48v160H288v-48h112z" })
  }
), Hp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 24V0h-48v96h48V72zM24 464H0v48h576v-48H389.2c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80zm213.4 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32zM32 336l29.5 48L91 432h56.4l-29.5-48h63.7l-5.9-53.3-4.9-43.8 27.2 17.5 54 34.6 18-61.5 17.6-59.9 10.2 35.6 24.9 87.3 58.1-69.7 54.6-65.5-33.6 117.5-17.4 61.2h73.7l-29.5 48H485l29.5-48 29.5-48h-96l13.7-48 49.7-173.9L544 0l-76 91.2-86.8 104.2L344 240l-16-55.8-16-56.2h-48l-25.9 88-14.1 48-42.1-27-17.9-11.6-52-33.4 6.8 61.5 3.8 34.5 5.3 48H79.7z" })
  }
), Vp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233 135 338.2 29.8c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72L377 279l8 8 17 17-34 33.9-17-17L191 161l-17-17 34-33.9 17 17 8 8zm110 110.1 105.2-105.2c10.1-10.1 15.8-23.8 15.8-38.1 0-29.7-24.1-53.8-53.8-53.8-14.3 0-28 5.7-38.1 15.8L266.9 169zm-162.6-49.5 136 136L168 480H80l-40 32-40-40 32-40v-88z" })
  }
), Cp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m208 177.9-9-9-8-8-17-17 34-33.8 17 17 8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8 17 17-34 33.9-17-17-8-8-9-9-25-25-76-76zM372.1 63.8 266.9 169l76.1 76.1 105.2-105.2c10.1-10.1 15.8-23.8 15.8-38.1 0-29.7-24.1-53.8-53.8-53.8-14.3 0-28 5.7-38.1 15.8zM180.4 195.6l33.9 33.9-90.4 90.5h136.2l22.3-22.3 33.9 33.9L168 480H80l-40 32-40-40 32-40v-88z" })
  }
), Lp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m377 279 1-1 104.2-104.2c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8L233.9 134.1l-1 1-8-8-17-17-33.8 33.9 17 17L351 321l17 17 33.9-34-17-17-8-8zm-94.5 18.6L148.1 432H80v-68.1l134.3-134.4-33.9-33.9L32 344v88L0 472l40 40 40-32h88l148.4-148.4-33.9-33.9zm165.7-157.7L344 244.1 267.9 168 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8 0 14.3-5.7 28-15.8 38.1" })
  }
), Bp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m285.3 130 10.3-14.2L320 82l24.4 33.8 10.3 14.2 17 4.2c13.5 3.4 26.1 8 37.7 13.6l14.2 6.9 15.5-2.9 25.2-4.6-12.6 25.4 16.5 23.4c4.7 6.7 8.7 13.7 11.7 20.8l6.9 16.2 15.7 7.9 30.2 15.1-30.1 15.1-15.7 7.9-6.9 16.2c-3 7.1-7 14.1-11.7 20.8l-16.5 23.4 12.6 25.4-25.2-4.6-15.5-2.9-14.2 6.9c-11.6 5.6-24.3 10.3-37.7 13.6l-17 4.2-10.3 14.2L320 430l-24.4-33.8-10.3-14.2-17-4.2c-13.5-3.4-26.1-8-37.7-13.6l-14.2-6.9-15.5 2.9-25.2 4.6 12.6-25.4-16.5-23.4c-4.8-6.7-8.7-13.7-11.7-20.8l-6.9-16.2-15.7-7.9-30.2-15.1 30.1-15.1 15.7-7.9 6.9-16.2c3-7.1 7-14.1 11.7-20.8l16.5-23.4-12.6-25.4 25.2 4.6 15.5 2.9 14.2-6.9c11.6-5.6 24.3-10.3 37.7-13.6l17-4.2zm5.1-89-33.7 46.7c-16.6 4.2-32.4 9.9-47.1 17L149 93.5 90 82.7l26.7 53.7 15.9 32c-6.6 9.4-12.2 19.3-16.6 29.6l-62.3 31.2L0 256l53.7 26.8L116 314c4.4 10.3 10 20.2 16.6 29.6l-15.9 32L90 429.3l59-10.9 60.6-11.2c14.7 7.1 30.4 12.9 47.1 17l33.7 46.8 29.6 41 29.6-41 33.7-46.7c16.6-4.2 32.4-9.9 47.1-17l60.6 11.2 59 10.9-26.7-53.7-15.9-32c6.6-9.4 12.2-19.3 16.6-29.6l62.3-31.2L640 256l-53.7-26.8L524 198c-4.4-10.3-10-20.2-16.6-29.6l15.9-32L550 82.7l-59 10.8-60.6 11.2c-14.7-7.1-30.4-12.9-47.1-17L349.6 41 320 0zM256 245.5c12.3 4.1 25.1 7.1 38.3 8.8C303.7 276 320 288 320 288s16.3-12 25.6-33.6c13.2-1.7 26-4.7 38.3-8.8v2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.5zM217.9 228c-1.3 6.5-1.9 13.1-1.9 20 0 57.4 46.6 104 104 104s104-46.6 104-104c0-6.8-.7-13.5-1.9-20-2.5-12.7-7.3-24.6-13.9-35.2-.5-.8-1-1.5-1.5-2.3-25 16.1-54.7 25.5-86.7 25.5s-61.7-9.4-86.7-25.5c-.5.8-1 1.5-1.5 2.3-6.6 10.6-11.4 22.5-13.9 35.2z" })
  }
), up = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-96.9-75.2c41.9-44 70.2-93.9 84-128.1-30-74.7-129.6-224-288-224-66.9 0-123.2 26.6-168.3 63L48.4 14.8zm142.4 110.6C227.6 98 270.8 80 320 80c63 0 116.2 29.5 158.9 70.6 35.6 34.3 61.5 74.5 76.6 105.4-14.1 28.9-37.6 65.8-69.6 98.5L434 314.2c8.9-17.5 14-37.2 14-58.2 0-70.7-57.3-128-128-128-8.6 0-17 .8-25.1 2.5-22.5 4.5-42.9 14.9-59.5 29.5l-44.6-34.6zM395 283.9l-82.2-63.8-8.5-42.6c5.1-1 10.3-1.5 15.7-1.5 44.2 0 80 35.8 80 80 0 9.8-1.8 19.2-5 27.9M85.7 163.5c-10.9 14.3-20.4 28.6-28.5 42.2L393.1 469c18.3-5.7 35.6-13.3 51.8-22.4L85.7 163.5M320 480c3.1 0 6.1-.1 9.2-.2l-75.6-59.2c-34.9-12.2-65.7-33.4-92.4-59.2-14.3-13.7-27-28.4-38-43.1l-88.3-69.1c-1 2.3-2 4.6-2.9 6.8 30 74.7 129.6 224 288 224" })
  }
), Rp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-96.9-75.2c41.9-44 70.2-93.9 84-128.1-30-74.7-129.6-224-288-224-66.9 0-123.2 26.6-168.3 63L48.4 14.8zm142.4 110.6C227.6 98 270.8 80 320 80c63 0 116.2 29.5 158.9 70.6 35.6 34.3 61.5 74.5 76.6 105.4-14.1 28.9-37.6 65.8-69.6 98.5L434 314.2c8.9-17.5 14-37.2 14-58.2 0-70.7-57.3-128-128-128-8.6 0-17 .8-25.1 2.5-22.5 4.5-42.9 14.9-59.5 29.5l-44.6-34.6zM395 283.9l-82.2-63.8-8.5-42.6c5.1-1 10.3-1.5 15.7-1.5 44.2 0 80 35.8 80 80 0 9.8-1.8 19.2-5 27.9m49.9 162.7-41.6-32.7C377.9 425.3 350.1 432 320 432c-63.1 0-116.2-29.5-158.9-70.6-35.5-34.2-61.4-74.5-76.6-105.4 9.1-18.7 22.2-40.7 38.9-62.8l-37.7-29.7C60.2 197.1 42.1 230.8 32 256c30 74.7 129.6 224 288 224 46.9 0 88.6-13.1 124.9-33.4zm-86.7-68.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5 0 70.7 57.3 128 128 128 13.3 0 26.1-2 38.2-5.8z" })
  }
), $p = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M129.1 361.4C93.6 327.2 67.7 286.9 52.5 256c15.1-30.9 41-71.2 76.6-105.4C171.8 109.5 224.9 80 288 80s116.2 29.5 158.9 70.6c35.6 34.3 61.5 74.5 76.6 105.4-15.1 30.9-41 71.2-76.6 105.4C404.2 402.5 351.1 432 288 432s-116.2-29.5-158.9-70.6M288 480c158.4 0 258-149.3 288-224-30-74.7-129.6-224-288-224S30 181.3 0 256c30 74.7 129.6 224 288 224m0-144c-44.2 0-80-35.8-80-80 0-5.4.5-10.6 1.5-15.7L288 256l-15.7-78.5c5.1-1 10.3-1.5 15.7-1.5 44.2 0 80 35.8 80 80s-35.8 80-80 80m-128-80c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-8.6 0-17 .8-25.1 2.5-50.3 10-90 49.5-100.3 99.7l-.1.7c-1.6 8.1-2.5 16.5-2.5 25.1z" })
  }
), kp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2 9.2 5.1 19.8 8 31.1 8 35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4 2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2M320 141.8C290 76.1 235 32 172 32 77 32 0 132.3 0 256s77 224 172 224c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224S563 32 468 32c-63 0-118 44.1-148 109.8m42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6 35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5 3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z" })
  }
), Pp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h48V272h208v-48H48V80h272V32h-24z" })
  }
), Fp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M171.3 47.6C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6C582.9 42.8 640 0 640 0c0 80.1-55.6 160.1-74.1 184.5 6.6 22.7 10.1 46.7 10.1 71.5 0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.8 3.5-48.8 10.1-71.5C55.6 160.1 0 80.1 0 0c0 0 57.1 42.8 171.3 47.6M320 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m-47.6-208c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6L187 223.2l-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5.3 2.9.3 4.4zm128 32c-17.7 0-32-14.3-32-32 0-1.6.1-3.2.3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8 0 17.7-14.3 32-32 32zm-41.9 120.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5z" })
  }
), Tp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m54.8-102.1 35.1-32.7-16.4-17.5C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6l-16.4 17.5 35.1 32.7 16.4-17.5c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4l16.4 17.5zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), Ap = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 64c44.2 0 80 35.8 80 80v16H176v-16c0-44.2 35.8-80 80-80m-111.6-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 144c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9-21.8-23.4 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1h16v32zm141 .9c-4.3-.6-8.6-.9-13-.9h-16v-32h16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), Dp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 114.9-93.1 208-208 208-65.5 0-124-30.3-162.1-77.7-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256l16-21.3 25.6 34.1 7.7 10.2c-.8-7.6-1.3-15.2-1.3-23 0-114.9 93.1-208 208-208s208 93.1 208 208M36.4 303.5 9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48 12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288zM208 400v16h160v-16c0-44.2-35.8-80-80-80s-80 35.8-80 80m159.6-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-192-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m51.7-100.7 11.3-11.3-22.6-22.6-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zM337.4 160l11.3 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4-11.3-11.3z" })
  }
), yp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48m-111.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 144c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9-21.8-23.4 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1h16v32zm141 .9c-4.3-.6-8.6-.9-13-.9h-16v-32h16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), bp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m192-32v-24c0-2-.1-3.9-.4-5.8-4.2 3.6-9.6 5.8-15.6 5.8-13.3 0-24-10.7-24-24 0-6 2.2-11.4 5.8-15.6-1.9-.3-3.8-.4-5.8-.4-22.1 0-40 17.9-40 40v24zm-40-96c39.8 0 72 32.2 72 72v56H80v-56c0-39.8 32.2-72 72-72m216 72c-13.3 0-24-10.7-24-24 0-5.4 1.8-10.3 4.7-14.3-4.1-1.1-8.3-1.7-12.7-1.7-26.5 0-48 21.5-48 48v16h96v-16c0-4.4-.6-8.7-1.7-12.7-4 3-8.9 4.7-14.3 4.7m-32-72c44.2 0 80 35.8 80 80v48H256v-48c0-44.2 35.8-80 80-80M100.2 307 96 288h320l-4.2 19-.1.4-.1.3c-3.9 17.4-10.6 33.6-19.5 48.2l-.1-.1c-28.2 45.9-78.6 75.7-134.9 76.1H256c-29.6 0-57.6-8.1-81.7-22.5-36.6-21.8-64.1-57.9-73.9-101.6l-.2-.9zm263.9 33.1c-8.1-2.7-16.8-4.1-25.8-4.1-39.2 0-71.9 27.3-80.2 64 44.1-.7 83.6-24 106.1-59.8z" })
  }
), fp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3 22.7-22.6-15-15c41.3-38 67.1-92.5 67.1-153 0-114.9-93.1-208-208-208m-38.4 180.8-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm-75 67.2-11.3 11.3-56 56 9.4 9.4 72-72 11.3-11.3 22.6 22.6-11.3 11.3-72 72 9.4 9.4 56-56 11.3-11.3 22.6 22.6-11.3 11.3-56 56 9.4 9.4 24-24 11.3-11.3 22.6 22.6-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-82.4h40v35l84.7-84.7 11.3-11.3z" })
  }
), Up = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c23.7 0 44.4 12.9 55.4 32H224c35.3 0 64 28.7 64 64v64H0V96c0-35.3 28.7-64 64-64h8.6c11-19.1 31.7-32 55.4-32m84.7 192H268.1c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16zm94.7-143.6C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7 141.4 0 256 114.6 256 256 0 14.8-1.3 29.3-3.7 43.5-12.5-10.8-28.3-17.8-45.7-19.2.9-8 1.4-16.1 1.4-24.3 0-114.9-93.1-208-208-208-4.2 0-8.4.1-12.6.4zM72.1 192h50c-6.5 20.2-10 41.7-10 64 0 81 46.3 151.2 114 185.6-1.3 7.3-2 14.8-2 22.4v29.4c-93.8-38-160-130-160-237.4 0-22.1 2.8-43.5 8.1-64zM640 512H256v-48c0-3.3.2-6.6.5-9.9 4.4-43.1 37.3-77.7 79.5-84.8V368c0-44.2 35.8-80 80-80 29.3 0 54.9 15.8 68.9 39.3 8.8-9.4 21.3-15.3 35.1-15.3 26.5 0 48 21.5 48 48v11c41.4 10.7 72 48.2 72 93zM400.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Gp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m231 77.3 25 20 25-20 13.7-11 14.6 9.7 31.6 21.1L351 343l17-17 33.9 34-17 17-24 24-13.9 13.9-16.3-10.9-33.4-22.3-26.3 21-15 12-15-12-26.3-21-33.4 22.3-16.4 10.9L151 401l-24-24-17-17 34-33.9 17 17 10.1 10.1 31.6-21.2 14.6-9.7 13.7 11zM112 176l118.9 64L112 304l45.7-64zm169.1 64L400 176l-45.7 64 45.7 64z" })
  }
), qp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m203.2 129.6-12.8 9.6-19.2 14.4-28.8-38.4 19.2-14.4 12.8-9.6c37.4-28 82.9-43.2 129.6-43.2h64v48h-64c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Wp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 0-55.4 110.8C100.1 99.7 67.7 83.7 41.3 64L24 81.3C51.2 163.5 144.8 224 256 224s204.8-60.5 232-142.7L470.7 64c-26.4 19.7-58.8 35.7-95.3 46.8L320 0l-64 32zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104-12.8 9.3-26.6 17.5-41.2 24.6 13.4 23.4 21 50.5 21 79.3 0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3-14.6-7.1-28.4-15.4-41.2-24.6zm300.6 139.1c-34.6 13.8-75.9 21.7-120.2 21.7s-85.6-8-120.2-21.7c12.2 55.4 61.4 96.9 120.2 96.9s108-41.5 120.2-96.9M192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48m152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Ep = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m358.1 79.2-184 48-23.2 6.1-12.1-46.4 23.2-6.1 184-48 23.2-6.1 12.1 46.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Op = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m294.5 152.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM222.6 256l-11.3 11.3-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4 11.3-11.3zm78.1 11.3L289.4 256l22.6-22.6 11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z" })
  }
), Ip = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48H72c0 49.4 37.4 90.1 85.4 95.4l-4.5 2.3-8.8 4.4v51.8l8.8 4.4 14.3 7.1-19.7 24.6-10 12.5 25 20 10-12.5 23.9-29.9 7.3 3.6-10.5 26.3-5.9 14.9 29.7 11.9 5.9-14.9 9.5-23.9 7.6 3.8V448h32v-38.1l7.6-3.8 9.5 23.9 5.9 14.9 29.7-11.9-5.9-14.9-10.5-26.3 7.3-3.6 23.9 29.8 10 12.5 25-20-10-12.5-19.6-24.5 14.3-7.1 8.8-4.4v-51.9l-8.8-4.4-4.5-2.3c48-5.3 85.4-46 85.4-95.4h18.4c3.6 15.4 5.6 31.5 5.6 48zm-233.3-35.2-29.6 42.3-.2-.4c-2.9 1.8-5.4 3.2-6.8 3.8-7.9 3.5-16.8 5.5-26.1 5.5-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8zM280 208c0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5-1.4-.6-3.9-2-6.8-3.8l-.2.4-29.6-42.3c-.8-4.1-1.3-8.4-1.3-12.8zm219.3-32C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176H0v32h4.5c-3 15.5-4.5 31.6-4.5 48 0 141.4 114.6 256 256 256s256-114.6 256-256c0-16.4-1.5-32.5-4.5-48h4.5v-32zm-435.4 0c6.2-14.8 14-28.7 23.2-41.5l5.6 13.9c-6.5 8.2-11.7 17.5-15.2 27.6zm384.1 0h-13.5c-3.6-10.1-8.8-19.4-15.3-27.6l5.6-13.9c9.2 12.8 17 26.7 23.2 41.5m-315.4-57.2-6.3-15.7-2.9-7.3C159.4 65.9 205.6 48 256 48s96.6 17.9 132.6 47.8l-2.9 7.3-6.3 15.7c-1.1-.5-2.3-.9-3.4-1.3V88h-48v25.3c-1.4.2-2.8.5-4.1.8l-9.2-18.3-42.9 21.5 9.2 18.3c-10.6 9.3-19.2 20.9-25 34-5.7-13.1-14.3-24.7-25-34l9.2-18.3-42.9-21.5-9.2 18.3c-1.4-.3-2.7-.6-4.1-.8V88h-48v29.5c-1.2.4-2.3.8-3.4 1.3zM256 240.5l50.9 72.7 2.3 3.3 3.6 1.8 23.2 11.6v12.2l-80 40-80-40v-12.2l23.2-11.6 3.6-1.8 2.3-3.3zm-88-.5a24 24 0 1 0 0-48 24 24 0 1 0 0 48m200-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Np = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128M120 118.1l17 17 23 23 23-23 17-17 33.9 33.9-17 17-23 23 23 23 17 17-33.9 33.9-17-17-23-23-23 23-17 17L86.1 232l17-17 23-23-23-23-17-17zm192 0 17 17 23 23 23-23 17-17 33.9 33.9-17 17-23 23 23 23 17 17-33.9 33.9-17-17-23-23-23 23-17 17-33.9-33.9 17-17 23-23-23-23-17-17z" })
  }
), Xp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-13.6 0-27 1.1-40 3.1l-23.7 3.7 7.5 47.4 23.7-3.7C234 48.9 244.9 48 256 48s22 .9 32.6 2.5l23.7 3.7 7.5-47.4L296 3.1c-13-2-26.4-3.1-40-3.1M133.7 87.7l19.4-14.1-28.2-38.8-19.4 14.1c-21.7 15.8-40.8 34.9-56.6 56.6l-14.1 19.4 38.8 28.2 14.1-19.4c12.8-17.6 28.4-33.2 46.1-46.1zm272.8-38.8-19.4-14.1-28.3 38.8 19.4 14.1c17.6 12.8 33.2 28.4 46 46.1l14.1 19.4 38.8-28.2-14.1-19.4c-15.8-21.7-34.9-40.8-56.6-56.6zm-356 174.5 3.7-23.7-47.4-7.4L3.1 216c-2 13-3.1 26.4-3.1 40s1.1 27 3.1 40l3.7 23.7 47.4-7.5-3.7-23.7C48.9 278 48 267.1 48 256s.9-22 2.5-32.6m458.4-7.4-3.7-23.7-47.4 7.5 3.7 23.7c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6l-3.7 23.7 47.4 7.5 3.7-23.7c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3l-14.1-19.5-38.8 28.3 14.1 19.4c15.8 21.7 34.9 40.8 56.6 56.6l19.4 14.1 28.2-38.8-19.4-14.1c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2 14.1-19.4-38.8-28.2-14.1 19.4c-12.8 17.6-28.4 33.2-46 46l-19.4 14.1 28.2 38.8 19.4-14.1c21.7-15.8 40.8-34.9 56.6-56.6m-239.7 55-23.7-3.7-7.5 47.4 23.7 3.7c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1l23.7-3.7-7.5-47.4-23.7 3.7c-10.4 1.6-21.3 2.5-32.4 2.5s-22-.9-32.6-2.5zm-47-221.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M184 328h-24v48h192v-48h-24z" })
  }
), Kp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M116.6 41.2C156.7 15.2 204.6 0 256 0c141.4 0 256 114.6 256 256S397.4 512 256 512 0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8 8.6 3.1 17.8 4.8 27.4 4.8 8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48c-48.7 0-93.4 16.7-128.9 44.7.6-3.8.9-7.7.9-11.7 0-11.4-3.8-22.4-7.1-30.5-1.3-3.1-2.7-6.2-4.3-9.3zM96 80.6v.4c0 26-21.5 47-48 47-4.4 0-8.7-.6-12.8-1.7C14.9 120.7 0 102.1 0 80c0-10.4 3.4-20.5 9.6-28.8L48 0l38.4 51.2C92.6 59.5 96 69.6 96 80zM96 256h128v32H96zm208 0h112v32H288v-32zM201.2 425.9l-35.1-32.7 16.4-17.5c14.2-15.4 38.9-31.7 73.5-31.7s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4L201 425.8z" })
  }
), Qp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0 114.9 93.1 208 208 208v48C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 80.8-37.5 152.9-96 199.9v-67c30-36 48-82.4 48-132.9 0-114.9-93.1-208-208-208S48 141.1 48 256m110.8-32.4-7.6 22.8-45.5-15.2 7.6-22.8c3.8-11.3 12.2-26.8 25.8-39.8 14.1-13.4 34.4-24.6 60.9-24.6h24v48h-24c-11.9 0-20.9 4.8-27.9 11.4-7.4 7-11.8 15.5-13.4 20.2zm-11 70.7 15 18.7c18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47l15-18.7 37.5 30-15 18.7-2.7 3.3V512H352V376.4c-9.5 7-20.2 13.3-32 18.5V480h-32v-75.1c-10 2-20.7 3.1-32 3.1-62.6 0-106.2-34.3-130.7-65l-15-18.7zm192.1-90.9c-7-6.6-16-11.4-27.9-11.4h-24v-48h24c26.5 0 46.8 11.2 60.9 24.6 13.7 13 22.1 28.5 25.8 39.8l7.6 22.8-45.5 15.2-7.6-22.8c-1.6-4.7-6-13.2-13.4-20.2z" })
  }
), Zp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 7-.3 13.9-1 20.7 11.6-8 25.6-12.7 40.8-12.7 2.7 0 5.4.2 8.1.5.1-2.8.1-5.6.1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c55.8 0 107.4-17.9 149.5-48.2-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39-114.9 0-208-93.1-208-208m71.7-18.3-32.2 23.8c36 48.7 108.2 48.7 144.2 0l-32.2-23.8c-20 27.1-59.8 27.1-79.8 0m271.8 0c-20 27.1-59.8 27.1-79.8 0l-32.2 23.8c36 48.7 108.2 48.7 144.2 0zM296 384a40 40 0 1 0-80 0 40 40 0 1 0 80 0m247.4-45.5c.1-.8.1-1.7.1-2.5 0-22.1-17.9-40-39.9-40-16.9 0-31.4 10.5-37.2 25.4-3.3-.9-6.9-1.4-10.5-1.4-22.1 0-39.9 17.9-39.9 40l-80 24 80.6 24.2c-.5 2.5-.8 5.1-.8 7.8 0 22.1 17.9 40 39.9 40 4.9 0 9.6-.9 14-2.5 7.1 11.1 19.5 18.5 33.7 18.5 22.1 0 39.9-17.9 39.9-40 0-.8 0-1.7-.1-2.5 19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z" })
  }
), Jp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8 7.5-3.7 15.9-5.8 24.8-5.8 30.9 0 56 25.1 56 56s-25.1 56-56 56h-72v56l38.4 24 51.2-32 51.2 32 2.5-1 46.3-17.8c1.5 11.4 2.3 23 2.3 34.8 0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9.5 271.9C.2 266.7 0 261.3 0 256c0-11.8.8-23.4 2.3-34.8L48.7 239l2.5 1 51.2-32 51.2 32 38.4-24v-56h-32zm341 131.3-5.3 2.1-20.3-12.7-25.8-16.1-25.8 16.1-25.4 15.9-25.4-15.9-25.8-16.1-25.8 16.1-25.4 15.9-25.4-15.9-25.8-16.1-25.8 16.1-25.4 15.9-25.4-15.9-25.8-16.1-25.8 16.1-20.3 12.7-5.3-2.1C67.8 389.4 153.2 464 256 464s188.2-74.6 205-172.7M176.4 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M256 368c26.5 0 48 21.5 48 48v16h-96v-16c0-26.5 21.5-48 48-48" })
  }
), jp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m160 72h216v48H136v-48zm-32-136h96v32h-96zm176 0h80v32h-96v-32z" })
  }
), Yp = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m137-121 23 23 23-23 17-17 33.9 34-17 17-23 23 23 23 17 17-33.9 33.9-17-17-23-23-23 23-17 17L86.1 232l17-17 23-23-23-23-17-17 33.9-33.9 17 17zm192 0 23 23 23-23 17-17 33.9 34-17 17-23 23 23 23 17 17-33.9 33.9-17-17-23-23-23 23-17 17-33.9-33.9 17-17 23-23-23-23-17-17 33.9-33.9 17 17zm-73 169c44.2 0 80 35.8 80 80v16H176v-16c0-44.2 35.8-80 80-80" })
  }
), _p = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-43.5-13.3-83.9-36.2-117.2l-11.1 11.8-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9H320V80h16c5.8 0 11.6.4 17.2 1.1 8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2 5.6-.7 11.4-1.1 17.2-1.1h16v32h-16c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.8-11-11.8C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 64c44.2 0 80 35.8 80 80v16H176v-16c0-44.2 35.8-80 80-80m-119.6-96a24 24 0 1 1 48 0 24 24 0 1 1-48 0m216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48M160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96m80 48a80 80 0 1 1-160 0 80 80 0 1 1 160 0m64 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0m48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160" })
  }
), hM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-95.6 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48m216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0M192 336h-24v48h176v-48h-24zm-32-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160m144-80a48 48 0 1 1 96 0 48 48 0 1 1-96 0m128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), cM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-48.8 160c-38.7 0-74.5 11.4-103.6 30.6 4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6c-29.1-19.2-64.9-30.6-103.6-30.6" })
  }
), sM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m388 114.7-40 26.6c-12-18.1-47.9-45.3-92-45.3s-80 27.2-92 45.3l-40-26.6c19.9-29.9 70-66.7 132-66.7s112 36.8 132 66.7M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), vM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m174.6 128.1-45.2-16.3C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9l-45.2 16.3c-9.2-25.7-40.2-48.2-81.4-48.2s-72.2 22.5-81.4 48.1M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), eM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c-114.9 0-208-93.1-208-208 0-22.3 3.5-43.8 10-64h6v112h176V192h32v112h176V192h6c6.5 20.2 10 41.7 10 64 0 114.9-93.1 208-208 208m0-464C148.6 0 56.6 66.2 18.6 160H0v32h8.1C2.8 212.5 0 233.9 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64h8.1v-32h-18.6C455.4 66.2 363.4 0 256 0m-16 160v-16H80.7c37-57.7 101.7-96 175.3-96s138.3 38.3 175.3 96H272v16zm16 256c61.9 0 112-36.8 132-66.7l-40-26.6c-12 18.1-47.9 45.3-92 45.3s-80-27.2-92-45.3l-40 26.6c19.9 29.9 70 66.7 132 66.7m48-144v-96h112v96zM96 176h112v96H96zm96.4 48a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), lM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0m-368 64v48h32v-48zm64 0v48h32v-48zm96 48v-48h-32v48zm32 0h32v-48h-32zm-192-80h256v112H112V288zm.4-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), tM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M476.8 126.3c20.3-5.5 35.2-23.6 35.2-45.3 0-18-28.3-55.2-43.5-75.1-1.7-2.2-3.2-4.2-4.5-5.9-1.1 1.5-2.4 3.1-3.7 4.9-10.7 14-28.7 37.4-38.1 56.4-.1.1-.1.3-.2.4-3.7 7.4-6 14.2-6 19.3 0 26 21.5 47 48 47 4.4 0 8.7-.6 12.8-1.7m-80.6-84.5C356 15.4 307.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8-8.6 3.1-17.8 4.8-27.4 4.8-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256 141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7-.6-3.8-.9-7.7-.9-11.7 0-12.6 5-24.6 8.8-32.6 1.1-2.2 2.2-4.4 3.4-6.6m-3.8 253.6c-39.3 14.9-86.2 23.5-136.5 23.5s-97.2-8.6-136.5-23.5C133.2 355.2 189.1 400 255.9 400s122.7-44.8 136.5-104.6M120 232s28-32 56-32 56 32 56 32c0-40-28-80-56-80s-56 40-56 80m216-80c-28 0-56 40-56 80 0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80" })
  }
), wM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM176 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32" })
  }
), gM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zm-40.6-181.7c17.8 4.8 28.4 23.1 23.6 40.8l-21.6 80.5-80.6-21.6c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6 4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-80.6 21.6-21.5-80.5c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z" })
  }
), iM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M442.3 98.6c-.4.1-.8.2-1.3.2-13.2 2.4-25.4 4.1-33.1 5.1 1-7.2 2.6-18.6 4.9-30.9.1-.7.3-1.4.4-2.1.8-4.4 1.7-8.9 2.7-13.3.1-.4.2-.9.3-1.3 4.1-18.5 9.6-36.2 16.6-43.1 17.9-17.9 47.1-17.6 65.3.7s18.6 47.6.7 65.6c-6.9 6.9-24.5 12.4-43 16.4m0 0c-4.5 1-9 1.9-13.5 2.7l13.5-2.7m-52.7 307.2c73.3-73.3 80.5-187.8 21.4-269.1 10.8-1.6 24.8-3.9 38.5-6.9 4.1-.9 8.3-1.9 12.5-3 59.2 98.4 46.4 228-38.5 312.9-84.9 84.9-214.7 97.7-313.2 38.3 1.1-4.1 2.1-8.2 3-12.2 3.1-13.7 5.4-27.8 7.1-38.6 81.3 59.1 195.8 52 269.1-21.4zM75 75c84.9-85 214.7-97.7 313.1-38.3-1.1 4.1-2.1 8.2-3 12.2-3.1 13.7-5.4 27.8-7.1 38.6-81.3-59.1-195.8-52-269.1 21.4C35.6 182.2 28.5 296.7 87.5 378c-10.8 1.6-24.8 3.9-38.5 6.9-4.1.9-8.3 1.9-12.5 3C-22.7 289.5-9.9 159.9 75 75m23.7 366.1c-.9 4.8-1.9 9.7-3 14.6-4.1 18.5-9.6 36.2-16.6 43.1-17.9 17.9-47.1 17.6-65.3-.7s-18.6-47.6-.7-65.6c8-8 30.1-14 51.4-18.1l6.3-1.2c13.2-2.4 25.5-4.1 33.1-5.1-1.1 7.6-2.8 19.9-5.3 33.1zm201.7-140.6c35.6-35.6 62.6-74.8 79.9-113.1 32.5 52.1 24.7 123.3-22.6 170.5S239.3 413 187.2 380.5c38.3-17.3 77.5-44.3 113.1-79.9zM75 278.6l129.3-38.8-38.8 129.3-12.9-77.6zm164.9-74.3L278.6 75l12.9 77.6 77.6 12.9-129.3 38.8z" })
  }
), mM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM112 144l118.9 64L112 272l45.7-64zm169.1 64L400 144l-45.7 64 45.7 64z" })
  }
), aM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-73.3-380.4-6.7-10-6.7 10-20.5 31-35.8 10-11.6 3.2 7.5 9.4 23.1 29.1-1.6 37.1-.5 12 11.3-4.2 34.8-13 34.8 13 11.3 4.2-.5-12-1.6-37.1 23.1-29.1 7.5-9.4-11.6-3.3-35.8-10-20.5-31zm160 0-6.7-10-6.7 10-20.5 31-35.8 10-11.6 3.2 7.5 9.4 23.1 29.1-1.6 37.1-.5 12 11.3-4.2 34.8-13 34.8 13 11.3 4.2-.5-12-1.6-37.1 23.1-29.1 7.5-9.4-11.6-3.3-35.8-10-20.5-31zm-86.8 187.2c-50.3 0-97.2-8.6-136.5-23.5C133.2 355.2 189.1 400 255.9 400s122.7-44.8 136.5-104.6c-39.3 14.9-86.2 23.5-136.5 23.5z" })
  }
), oM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M517.7 320.9c1.2 4 2.4 8 3.8 11.8 3 8.2 8 20 16.6 28.7 3.4 3.4 7.1 6.5 10.9 9.1C507 454.4 420.2 512 320 512S133 454.4 90.9 370.5c3.8-2.6 7.5-5.7 10.9-9.1 8.7-8.7 13.7-20.5 16.6-28.7 1.4-3.8 2.7-7.8 3.8-11.8C149.6 404 227.8 464 320 464s170.4-60 197.7-143.1m6.1-106.9C504.3 119.3 420.5 48 320 48s-184.3 71.3-203.8 166l-16.6 2.3h-.1c-7.4 1-19.7 2.7-33.2 5.1C83.2 96.4 190.3 0 320 0s236.8 96.4 253.7 221.5c-13.5-2.4-25.8-4.1-33.2-5.1h-.1zm52.2 40.5c21.1 4.2 42.9 10.1 50.8 18 17.9 18 17.5 47.3-.7 65.6-17.8 17.9-46.2 18.6-64.2 1.8l-1.1-1.1c-8.7-8.8-15.2-34.6-19.5-57.7-2.5-13.2-4.2-25.4-5.3-33.1 7.6 1.1 19.9 2.8 33.1 5.1 2.3.4 4.6.9 6.9 1.3zM98.7 281.1c-4.3 23.1-10.8 48.9-19.5 57.7l-1.1 1.1c-17.9 16.8-46.4 16.1-64.2-1.8-18.2-18.3-18.6-47.6-.7-65.6 7.9-7.9 29.7-13.9 50.8-18 2.3-.5 4.6-.9 6.9-1.3 13.2-2.4 25.5-4.1 33.1-5.1-1.1 7.6-2.8 19.9-5.3 33.1zm221.2 37.8c50.3 0 97.2-8.6 136.5-23.5C442.6 355.2 386.7 400 319.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM240 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32" })
  }
), nM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4-2.4-8.4-3.7-17.3-3.7-26.4v-23.3c-31.9-23.3-55.2-57.8-64-97.9 46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m230.9-48L112 272l45.7-64-45.7-64zM400 144l-45.7 64 45.7 64-118.9-64zM256 480c35.3 0 64-28.7 64-64v-48h-48v24h-32v-24h-48v48c0 35.3 28.7 64 64 64" })
  }
), rM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4v-52.5c8.8-8 16.6-17.1 23-27 10.4-16.1-6.8-32.5-25.5-28.1-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1 6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96.4-292c10.6 0 19.9 3.8 25.4 9.7 7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160M320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64v-64h48v24h32v-24h48z" })
  }
), dM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4-2.4-8.4-3.7-17.3-3.7-26.4v-52.4c-8.9-8-16.7-17.1-23.1-27.1-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M320 416v-64h-48v24h-32v-24h-48v64c0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), SM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64m96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64" })
  }
), zM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m151.3 26.3-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0" })
  }
), pM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), MM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3 22.7-22.6-15-15c41.3-38 67.1-92.5 67.1-153 0-114.9-93.1-208-208-208M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-33.8 120-11.3 11.3-56 56 9.4 9.4 72-72 11.3-11.3 22.6 22.6-11.3 11.3-72 72 9.4 9.4 56-56 11.3-11.3 22.6 22.6-11.3 11.3-56 56 9.4 9.4 24-24 11.3-11.3 22.6 22.6-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-82.4h40v35l84.7-84.7 11.3-11.3z" })
  }
), xM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 464c58.5 0 111.4-24.2 149.2-63.1h51.6c3.5 0 7.1-.1 10.6-.4C485.3 467.8 407.8 512 320 512c-105.9 0-196.8-64.3-235.7-156 11.3 3.2 23 4.9 34.9 4.9h21.2c36 61.7 103 103.1 179.6 103.1m128-95.1v-32h32V328h-72v-32h72v-8h-72v-32H491.3v-12.2l-12.1-8.7-4.9-3.5-10.6-7.6-17-12.1-32-22.8 8.3-11.6 10.3-14.5 37.2 25.6 2.9 2 52.5 36.1 7.9 5.4 11.6 8v-19.7l-8.2-8.2-19-19-3.6-3.6 1.8-1.8 3.8-3.8 17-17 5.7-5.7 22.6 22.6.1.1 22.4 22.4.8.8c36.4 37.2 36.1 96.9-.8 133.8a95.311 95.311 0 0 1-35.7 22.5c-9.4 3.3-19.4 5.2-29.6 5.4h-28zm-40.7-224.5L390.4 168c-30.2.9-54.4 25.6-54.4 56 0 25.4 16.9 46.8 40 53.7v32.8c-41-7.5-72-43.4-72-86.5 0-48.6 39.4-88 88-88 6.8 0 13.3.8 19.7 2.2l-4.4 6.2zM320 48c-60.3 0-114.5 25.6-152.5 66.6l-3.6-3.6-28.3-28.3-2.1-2.1C180.2 31 246.5 0 320 0c92 0 172.6 48.5 217.7 121.3l-17.4 17.4-17.7 17.7C467.4 91.8 398.8 48 320 48M71 315.8c-6.9-4.1-13.4-9-19.1-14.8-36.9-36.9-37.2-96.6-.8-133.8l.8-.8 61.1-61.1 5.6 5.6 17 17 5.7 5.7-10.5 10.4-12.2 12.2-6.1 6.1L98.8 176H240v32h-80v8h80v32h-80v8h80l.3 32H160v8.9h32v32H119.2c-17.1 0-33.7-4.6-48.2-13.1zM384 400c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48 64 21.5 64 48m32.4-176c0 6.1-2.3 11.8-6.1 16h-35.8c-3.8-4.2-6.1-9.9-6.1-16 0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), HM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 60.5-25.8 115-67.1 153l15 15-22.6 22.6-52.3 52.3C438.7 465.1 512 369.1 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4-9.8-18-15.3-38.6-15.3-60.5v-10.8C72.6 368.2 48 315 48 256m208-48c-52.5 0-95.1 42.1-96 94.4h45.7l51.7-51.7 22.6-22.6 22.6 22.6 9.4 9.4 16-16 10.1 10.1C321.3 226.5 290.8 208 256 208m-14.3-84.3-30-37.5-18.7 15-80 64-18.7 15 30 37.5 18.7-15 80-64 18.7-15zm47.3 15 80 64 18.7 15 30-37.5-18.7-15-80-64-18.7-15-30 37.5zM302.6 296 280 273.4l-11.3 11.3-84.7 84.7v-35h-40V416.8c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l48.8-48.8 11.3-11.3-22.6-22.6-11.3 11.3-24 24-9.4-9.4 56-56 11.3-11.3-22.6-22.6-11.3 11.3-56 56-9.4-9.4 72-72 11.3-11.3-22.6-22.6-11.3 11.3-72 72-9.4-9.4 56-56z" })
  }
), VM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208 0-13.2-1.2-26.2-3.6-38.7 11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4 0 141.4-114.6 256-256 256-99.5 0-185.8-56.8-228.2-139.8 2.5-3.8 4.8-7.5 6.7-10.7 1.9-3.1 3.5-5.7 4.7-7.5zm147.2-144.4c12.7 4.2 21.9 16.2 21.9 30.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4M368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1-13.9 3.4-27.2 8.2-39.8 14.2-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9l-22.9 7.2-14.4-45.8 22.9-7.2c14.2-4.5 30-7.1 47.2-7.1 46.5 0 81.4 19.3 104.2 39.9l17.8 16.2-32.3 35.5-17.8-16.1zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1-64 0M300.6 64.1c38.3-13 78.3-22.2 119.5-27.4 20.8 12.6 39.7 28 56.1 45.7-56.9-11.3-115.6-17.5-175.6-18.3M406 103.4c34 4.3 67.3 10.5 100.1 18.3 14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1.5-51 1.5-47.8 2.8-94.6 9.4-140 19.7-19.6 4.4-39 9.5-58.1 15.3 6.4-26.8 17-51.9 31-74.7 48.4-11.6 98.2-19.5 149.3-23.2 22.7-1.8 45.7-2.6 68.8-2.6 40 0 79.3 2.5 118 7.4m-355.7 123c41-12.2 83.3-21.3 126.6-27.1-51.6 37.5-96.5 83.8-132.2 136.7-8.2-25.1-12.7-52-12.7-80 0-3 .1-6.1.2-9.1 5.9-7 12-13.8 18.2-20.5z" })
  }
), CM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m208-16a48 48 0 1 0-96 0 48 48 0 1 0 96 0m32 32v48h-32v-16c-13.4 10-30 16-48 16-11.4 0-22.2-2.4-32-6.7V336H96v-48c-10-13.4-16-30-16-48 0-19 6.6-36.5 17.7-50.2L94 160.1l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2 30.8 8.8-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96m64 0v48h-32v-22.7c-9.8 4.3-20.6 6.7-32 6.7-44.2 0-80-35.8-80-80 0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2 30.8-8.8 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4-3.7 29.7C425.4 203.5 432 221 432 240c0 18-6 34.6-16 48m-56 93.3c-16 23.9-55.3 52.7-104 52.7s-88-28.8-104-52.7l40-26.6c8.1 12.1 33.2 31.3 64 31.3s56-19.2 64-31.3zM128 240c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32m224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32" })
  }
), LM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9-21.8-23.4 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1h16v32h-16c-4.4 0-8.8.3-13 .9zm141-.9h-16v-32h16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9zm-64 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), BM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 1.5.1 3 .4 4.5L488 512l23.6-251.5c.3-1.5.4-3 .4-4.5C512 114.6 397.4 0 256 0S0 114.6 0 256c0 2.1.3 4 .7 6L24 448l23.3-186c.5-1.9.7-3.9.7-6m96 98.7V320h32v48h-18.7zm64 13.3v-48h32v48zm64 0v-48h32v48zm82.7 0H336v-48h32v34.7zm45.3-48v-32H112v80l32 32h140.7l14 48 16-48h33.6l14.4 80 19.3-93.9 18-18.1zm-223.6-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M256 512c23.8 0 46.9-3.3 68.8-9.4l-2-19.4-.3-3.3H271l-4.1-16.3c-3.6.2-7.3.3-10.9.3-79.8 0-149.1-44.9-184-110.9l-6.2 74.3c46.9 52 114.7 84.7 190.2 84.7m151.3-49.5c12.8-9.4 24.7-20 35.6-31.6l-4.7-74.6c-6.7 12.2-14.6 23.6-23.5 34.1l-7.4 72z" })
  }
), uM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3l-3.9-15 .2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1v-14l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1 3.9-15c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM176 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32" })
  }
), RM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3l-3.9-15 .2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1v-14l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1 3.9-15c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-89.1-63.4c-20-27.1-59.8-27.1-79.8 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8zm80.2 0-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0" })
  }
), $M = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1 3.1 4.5 5.7 9.4 7.8 14.6 12.7-1.6 25.1.4 36.2 5 9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c33.5 0 65.6-6.4 94.9-18.2l-1.5-5.9zM296 316c0-6.9-3.1-13.2-7.3-18.3-4.3-5.2-10.1-9.7-16.7-13.4-13.3-7.4-30.6-12.3-48-12.3l-3.9 15 .2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1v14l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1 3.9 15c17.4 0 34.7-4.9 47.9-12.3 6.6-3.7 12.5-8.2 16.7-13.4 4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4-2.7-1.5-5.7-3-8.7-4.3 3.1-1.3 6-2.7 8.7-4.3 6.6-3.7 12.5-8.2 16.7-13.4 4.3-5.1 7.3-11.4 7.3-18.3zm-119.6-76a32 32 0 1 0 0-64 32 32 0 1 0 0 64m199.2-5.7 32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0m58.4 118c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l27 105.1 100.7-28.2c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z" })
  }
), kM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3l-3.9-15 .2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1V329l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1 3.9-15c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), PM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m258.2 152c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120M176 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32" })
  }
), FM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m258.2 152c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120M112 128l118.9 64L112 256l45.7-64zm169.1 64L400 128l-45.7 64 45.7 64z" })
  }
), TM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m258.2 152c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120M144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m151.3 26.3-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0" })
  }
), AM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m258.2 152c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120M144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), DM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M431.3 368H328v-48h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H264v-48h176c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96m67.4-30.3C464.6 439 368.8 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 8.8-.4 17.6-1.3 26.2.9 4.5 1.3 9.1 1.3 13.8 0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0M195.2 390.4l-14.4 19.2-38.4-28.8 14.4-19.2C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7l22 9.6-19.2 44-22-9.6c-6.8-3-14.4-4.6-22.4-4.6-18.3 0-34.6 8.8-44.8 22.4z" })
  }
), yM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 388.9c-29.1-35-46.9-79.7-48-128.5l48 19.2zM36.4 208.5l-13.3-5.3-11.9 29.7 14.9 5.9 6.4 2.5c-.3 4.8-.4 9.7-.4 14.6 0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.9-.1-9.8-.4-14.6l6.4-2.5 14.9-5.9-11.9-29.7-13.3 5.3C517.3 89.8 413.2 0 288 0S58.7 89.8 36.4 208.5M82 226.8C96.2 125.7 183 48 288 48s191.8 77.7 206 178.8L441 248H135.1zm414 33.7c-1 48.8-18.9 93.5-48 128.5V279.6l48-19.2zm-325.6-53.1c4.8-5.7 26.7-23.4 61.6-23.4h24v-48h-24c-50.4 0-85.4 25-98.4 40.6L118.2 195l36.9 30.7 15.4-18.4zM400 352v32H176v-32zm0-56v24H176v-24zM203.2 440l-20-24h209.6l-20 24H288zM344 184c36.4 0 58.7 15.3 63 19.6l17 17 33.9-33.9-17-17c-13.5-13.5-48.1-33.7-97-33.7H320v48z" })
  }
), bM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0m-367.6-48a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-79.6 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M184 328h-24v48h192v-48h-24z" })
  }
), UM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93 16.7 33.4 12.5 72.2-.1 100.7-2.1 4.7-4.6 9.5-7.6 14.4h357.9c-2.7-7.5-4.1-15.6-4.1-24 0-32.6 21.6-60.1 51.3-69-10.9-20.5-14.2-44.9-9.1-66.1 3.8-15.6 5.8-32 5.8-48.9zm0 184c0 13.3 10.7 24 24 24h56v48H0v-48h46.6c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256 64 114.6 178.6 0 320 0s256 114.6 256 256c0 20.7-2.5 40.8-7.1 60.1-6 24.8 11.1 51.8 36.5 51.9H640v48h-88c-13.3 0-24 10.7-24 24M263.8 158.1a32 32 0 1 1-16.6 61.8 32 32 0 1 1 16.6-61.8m115.4 64a32 32 0 1 1 61.8 16.6 32 32 0 1 1-61.8-16.6zm-201.9 78.7 43.2-21c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1l26.9 39.8c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86z" })
  }
), GM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 336.1V224c0-61.9-50.1-112-112-112s-112 50.1-112 112 50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v86.5c-38.1 45.9-95.6 75.1-160 75.1-114.9 0-208-93.1-208-208S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5l-12.5 10 20 25 12.5-10 23.2-18.6c8-6.4 18-9.9 28.2-9.9 8.9 0 17.6 2.6 25.1 7.6l8.6 5.7 13.3 8.9 5.7-8.5C433.6 131.8 464 190.4 464 256c0 28.4-5.7 55.5-16 80.1m5.7 82.5C490.1 374.4 512 317.7 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c67.1 0 128.2-25.8 173.9-68.1 10.4 20.4 26.2 38 46.3 50.6l11.4 7.1 17-27.1-11.4-7.1c-18.5-11.5-32.2-28.8-39.4-48.7zM256 224a80 80 0 1 1 160 0 80 80 0 1 1-160 0m-79.6-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64M144 336v32h16c14.3 0 37.9 2.9 60.6 11.7 22.8 8.8 42.7 22.7 53.1 43.4l7.2 14.3 28.6-14.3-7.2-14.3c-15.3-30.5-43.3-48.6-70.1-59-26.9-10.3-54.5-13.8-72.2-13.8z" })
  }
), qM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-19.7-77.3a159.96 159.96 0 0 1-86.8 44.7l-2.5.4-5.3-31.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4 22.6 22.6-7.4 7.4m128.7-7.4 22.6-22.6 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4-5.3 31.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4M148 308.8l24-41.5c17 9.7 30 25.7 36 44.7h96.2c6.1-18.8 19-34.5 35.8-44.2l24 41.5c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2l-24 41.5c-17.1-9.9-30.2-26-36.2-45.3H208c-6 19-19.1 35-36 44.8l-24-41.5c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2" })
  }
), WM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c-21.6 0-42.4-3.3-61.9-9.4-3.1 8.6-8.1 16.7-15 23.6-1.3 1.3-2.6 2.5-4 3.7-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4-1.6-5.1-2.6-10.5-2.9-15.8-1.4-1.2-2.7-2.4-4-3.7-7-7-12-15.2-15.1-23.9-19 5.7-39.2 8.8-60 8.8zm97.8-7.5c4.7 4.7 10.4 7.6 16.4 8.8-2.1 4.3-3.1 9-3.1 13.7 0 .7 0 1.3.1 2 .4 7.6 3.5 15 9.3 20.8 12.5 12.5 32.8 12.5 45.3 0 2.1-2.1 3.8-4.3 5.2-6.7 18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2 12.5-12.5 12.5-32.8 0-45.3-4.3-4.3-9.5-7.1-15-8.5-1.9-.5-3.8-.8-5.8-.9-5.4-.3-10.8.7-15.7 3.1-1-5.2-3.3-10.1-6.9-14.4-.6-.7-1.2-1.4-1.8-2-3.6-3.6-7.9-6.2-12.5-7.7-11.1-3.7-23.9-1.1-32.8 7.7-4.4 4.4-7.2 9.7-8.5 15.3l-82-49 49.1 81.8c-5.6 1.3-10.9 4.2-15.3 8.5-12.5 12.5-12.5 32.8 0 45.3M464 256c0 21.3-3.2 41.8-9.1 61.1 8.5 3.1 16.5 8.1 23.4 14.9 1.3 1.3 2.5 2.6 3.7 4 5.5.3 11 1.3 16.3 3.1 8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8 4.9-1.5 9.9-2.4 15-2.7 1.2-1.4 2.4-2.7 3.7-4 7.2-7.2 15.7-12.3 24.7-15.4C51 296.8 48 276.8 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208M143 481.4c0-.5.1-.9.1-1.4.1-2 0-4.1-.2-6.1-.4-3.3-1.4-6.5-2.9-9.6 6-1.2 11.7-4.1 16.4-8.8 12.5-12.5 12.5-32.8 0-45.3-4.4-4.4-9.7-7.2-15.3-8.5l49.1-81.7-81.8 49.1c-1.3-5.6-4.2-10.9-8.5-15.3-8.6-8.6-20.8-11.3-31.6-8.1-5 1.5-9.7 4.2-13.6 8.1-.7.6-1.3 1.3-1.9 2-3.6 4.3-5.9 9.2-6.9 14.4-4.9-2.4-10.3-3.4-15.7-3.1-1.5.1-3.1.3-4.6.6-5.9 1.2-11.6 4.1-16.2 8.7-12.5 12.5-12.5 32.8 0 45.3 2.1 2.1 4.3 3.8 6.7 5.2-14.4 18.7-13.1 45.8 4.2 63s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7 12.5 12.5 32.8 12.5 45.3 0 5.4-5.4 8.5-12.3 9.2-19.4zm172.3-294.1c9.3-9.3 38.2-32.3 73.7-44.1l-10.1-30.4c-41.3 13.8-74.2 39.9-86.3 51.9l22.6 22.6zM112 224H96v32h128v-32h-16zm192 0h-16v32h128v-32h-16zm-181.1-80.8c35.5 11.8 64.4 34.8 73.7 44.1l22.6-22.6c-12-12-45-38.1-86.3-51.9l-10.1 30.4z" })
  }
), EM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M35 93.5c14.7-25.7 32.7-49.2 53.5-69.9l45.8 12.2c-34.6 29.3-62.2 66.5-80 108.9zM20.9 55.6 0 0l53.3 14.2C41.5 27.2 30.7 41 20.9 55.6zM320 464c59 0 112.2-24.6 150.1-64h61.6C485.6 467.6 408 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0c113.4 0 209.7 73.8 243.3 176H512.1C480.7 100.8 406.5 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208M196.8 237.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zm160 0-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3-.5.6-1 1.1-1.5 1.7H608v-96h-64v32h48v32h-80v-96h128v160H407.2c.5.6 1 1.1 1.5 1.7 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3l-3.9-15 .2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1v-14l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1 3.9-15c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3zm-32.8 36c.3.1.5.2.8.3v-.7c-.3.1-.5.2-.8.3z" })
  }
), OM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m208 112h120v48H184v-48zm183.5-98.3 32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8c20 27.1 59.8 27.1 79.8 0m-271.8 0c20 27.1 59.8 27.1 79.8 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0zm-45.2-68.9 14.3-7.2 22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18 10-12.5 25 20-10 12.5-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4-14.3 7.2zm348.6-7.2 14.3 7.2-14.3 28.6-14.3-7.2-22.8-11.3c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18-10-12.5 25-20 10 12.5 14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z" })
  }
), IM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m294.5 152.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM222.6 112l-11.3 11.3-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4zm78.1 11.3L289.4 112 312 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM112 208l118.9 64L112 336l45.7-64zm169.1 64L400 208l-45.7 64 45.7 64z" })
  }
), NM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m266.5 156.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4l-16.4 17.5-35.1-32.7 16.4-17.5c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6l16.4 17.5-35.1 32.7-16.4-17.5zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0 32c-44.2 0-80-35.8-80-80 0-19 6.6-36.5 17.7-50.2L94 160.1l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2 30.8 8.8-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6 0 44.2-35.8 80-80 80m240-80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2 30.8-8.8 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4-3.7 29.7C425.4 203.5 432 221 432 240m-304 0c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32m224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32" })
  }
), XM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-104-97.4c29.1-19.3 64.9-30.6 103.6-30.6s74.5 11.4 103.6 30.6c-4.7-53-49.3-94.6-103.6-94.6s-98.8 41.6-103.6 94.6M176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), KM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416m256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0m-367.6-16a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M160 328h192v48H160zm168.8-186.2-29.5 29.5-11.3 11.3-22.6-22.6 11.3-11.3 29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4 8.9 13.3-26.6 17.8-8.9-13.3-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144h80v32h-96v-32z" })
  }
), QM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25l17-17 33.9 34-17 17c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39l-17-17 34.1-33.9 17 17zm198.5-105.3 32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8c20 27.1 59.8 27.1 79.8 0m-271.8 0c20 27.1 59.8 27.1 79.8 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0zm92.5-115.6-15.2 5.1-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5-8.9 13.3-26.6-17.8 8.9-13.3 7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1 15.2-5.1zm102.7 5.1-15.2-5.1 10.1-30.4 15.2 5.1 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5 8.9 13.3-26.6 17.8-8.9-13.3-7.6-11.5c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z" })
  }
), ZM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-88-160v48h176v-48H192zm-8-80c-26.5 0-48-21.5-48-48 0-14.3 6.3-27.2 16.2-36-.2 1.3-.2 2.6-.2 4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4 10 8.8 16.2 21.7 16.2 36 0 26.5-21.5 48-48 48m0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160m192-32c-26.5 0-48-21.5-48-48 0-14.3 6.3-27.2 16.2-36-.2 1.3-.2 2.6-.2 4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4 10 8.8 16.2 21.7 16.2 36 0 26.5-21.5 48-48 48m0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), JM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 406.1V264h-48v176.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V264h-48v142.1C72.6 368.2 48 315 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 59-24.6 112.2-64 150.1m0 61.6C467.6 421.6 512 344 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 88 44.4 165.6 112 211.7v4.3h6.5c39.7 25.3 86.9 40 137.5 40s97.8-14.7 137.5-40h6.5zM199.5 234.3l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0m112.2 0c20-27.1 59.8-27.1 79.8 0l32.2-23.8c-36-48.7-108.2-48.7-144.2 0zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), jM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 114.9-93.1 208-208 208-65.5 0-124-30.3-162.1-77.7-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256l16-21.3 25.6 34.1 7.7 10.2c-.8-7.6-1.3-15.2-1.3-23 0-114.9 93.1-208 208-208s208 93.1 208 208M36.4 303.5 9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48 12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288zm306.4 122.4 35.1-32.7-16.4-17.5C347.3 360.3 322.6 344 288 344s-59.3 16.3-73.5 31.6l-16.4 17.5 35.1 32.7 16.4-17.5c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4l16.4 17.5zM367.6 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-192-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m51.7-100.7 11.3-11.3-22.6-22.6-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zM337.4 160l11.3 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4-11.3-11.3z" })
  }
), YM = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m137.6 83.2c-6.2 8.3-9.6 18.4-9.6 28.8 0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L176 288zM256 352c30.7 0 58.7 11.5 80 30.6l17.9 16 32-35.8-17.9-16c-29.7-26.6-69-42.8-112-42.8zm47.6-144a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), _M = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m169.9 155.4-9.9 7.2-14.2 10.4-17.8 12.8v-39l27.3-18.5 26.5-18 26.5-18 30.9-21 26.5-18-18-26.5-2.5-3.6L229.7.4l-26.5 18L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5 11.1-2.2 21.9-6.8 31.6-13.8l15.4-11.3 66.8-48.6 25.9-18.8-37.6-51.8-25.9 18.9-3.3 2.4zm-23 135.4c-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-26.5 0-52.1 4-76.1 11.5l16.2 23.9 12.3 18.1c15.3-3.6 31.2-5.5 47.6-5.5 114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2m97.6-67.1c5.5 9.8 15.9 16.4 27.9 16.4 17.7 0 32-14.3 32-32 0-9.5-4.1-17.9-10.6-23.8l-49.3 39.4zm29.6 166.1c21.7 7.7 48.4 13.3 77.9 13.3s56.2-5.5 77.9-13.3c21.3-7.6 39.3-17.7 50.5-28.2l-32.8-35c-4.8 4.5-16.3 11.8-33.7 18-17 6-38.3 10.5-61.9 10.5s-44.8-4.5-61.9-10.5c-17.5-6.2-28.9-13.5-33.7-18l-32.8 35c11.2 10.5 29.2 20.7 50.5 28.2M464.4 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), hx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M523.5 299.4c3-14 4.5-28.5 4.5-43.4 0-114.9-93.1-208-208-208s-208 93.1-208 208c0 14.9 1.6 29.4 4.5 43.4L102.9 288l-20.6 18-11.3 9.9c-4.6-19.2-7-39.3-7-59.9C64 114.6 178.6 0 320 0s256 114.6 256 256c0 20.6-2.4 40.6-7 59.8l-11.3-9.8-20.6-18-13.7 11.4zM433 430.7c-6.9 20.3-11.7 41.1-14.8 61.8C388 505.1 354.8 512 320 512c-34.8 0-67.9-6.9-98.1-19.5-3.1-20.7-7.9-41.5-14.8-61.8C239.6 451.8 278.4 464 320 464c41.7 0 80.5-12.2 113-33.3m-249.7-148c-27.3-14.9-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8 31.1 56.9 8.7 93.7-62.8 54.7-90.1 39.8zm273.4 0c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7 67.6 2.9 90.1 39.8 18.6 78.8-8.7 93.7M320 304c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48M192 512H82.3c.4-50.5-16.7-85.7-43.2-125.7l64.3-56.2C157.2 375 185 443.6 192 512m365.7 0H448c7-68.5 34.8-137 88.6-181.9l64.3 56.2c-26.4 40-43.6 75.3-43.2 125.7z" })
  }
), cx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 57.2-23.1 109-60.5 146.6l38.7 29C485.5 385.8 512 324 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 101.2 58.7 188.7 144 230.3v-55c-57.7-37-96-101.7-96-175.3 0-114.9 93.1-208 208-208s208 93.1 208 208M208.4 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M176 217.4 153.4 240l11.3 11.3c8.7 8.7 20.5 17.7 35.3 24.6v-36.7c-4.9-3.4-9.2-7-12.7-10.5zm136 58.5c14.8-6.9 26.6-15.9 35.3-24.6l11.3-11.3-22.6-22.6-11.3 11.3c-3.5 3.5-7.7 7.1-12.7 10.5v8.8zM280 248v-24h-48v96h48zm-80 104h-24v160h155.2l7.2-8.6 40-48 15.4-18.4-36.9-30.7-15.4 18.4-32.7 39.3h-21.2L224 419.5V400h48v32h48v-80h-72z" })
  }
), sx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208 30.7 0 59.9 6.7 86.1 18.6L362 22.9C329.6 8.2 293.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9L445.4 170c11.9 26.1 18.6 55.3 18.6 86 0 114.9-93.1 208-208 208S48 370.9 48 256m208 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80m135.5-186.3c-20 27.1-59.8 27.1-79.8 0l-32.2 23.8c36 48.7 108.2 48.7 144.2 0zm-271.8 0-32.2 23.8c36 48.7 108.2 48.7 144.2 0l-32.2-23.8c-20 27.1-59.8 27.1-79.8 0zM288 96v32h42.7l-36.3 27.2-6.4 4.8v32h96v-32h-42.7l36.3-27.2 6.4-4.8V96h-80zM432 0h-16v32h42.7l-36.3 27.2L416 64v32h96V64h-42.7l36.3-27.2L512 32V0h-16z" })
  }
), vx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c47 0 90.4-15.6 125.2-41.9 2.7 14.8 2.8 29.6 2.8 41.9 0 4.5.4 8.9 1.1 13.1-37.9 22.2-82 34.9-129.1 34.9C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 37-7.8 72.1-22 103.9-7.4-6.2-15.1-11.8-22.7-16.7-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208m-80-74.5c15.1-24.7 45.3-41.5 80-41.5s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zm150.2-139.2c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C391.7 293.2 371 300 351.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9zM159.6 260c10.6 0 19.9-3.8 25.4-9.7 7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C199.7 293.2 179 300 159.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9c5.5 5.8 14.8 9.7 25.4 9.7zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-21.7 0-61.1-20-92.1l20-20c47 20.3 96 59.2 96 112.1" })
  }
), ex = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m124 77.3 40-26.6c12 18.1 47.9 45.3 92 45.3s80-27.2 92-45.3l40 26.6c-20 29.9-70.1 66.7-132 66.7s-112-36.8-132-66.7M176 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32" })
  }
), lx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 80c0-44.2-114.6-80-256-80S0 35.8 0 80s114.6 80 256 80 256-35.8 256-80m-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32 192 14.3 192 32M45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5-14 5.8-29.6 11.1-46.4 15.6 17.8 29.1 28 63.3 28 99.9 0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9-16.9-4.6-32.4-9.8-46.4-15.6zm172 128.3c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm-73.9 47.9c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4c-15 16.4-41 33.9-78.2 33.9s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm233.9-47.9c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z" })
  }
), tx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M519.2 376c-10.1-.1-20.2 3.7-27.8 11.4-7.6 7.7-11.4 17.8-11.4 27.9v.3c0 10.5 4.2 20.6 11.6 28L560 512l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28 0-21.9-17.7-39.6-39.6-39.6-10.5 0-20.6 4.2-28 11.6L560 400l-12.4-12.4c-7.4-7.4-17.5-11.6-28-11.6zm37.1-21.3C569 324.3 576 291 576 256c0-24.5-3.4-48.2-9.9-70.6l-6.6-23.1-46.1 13.2 6.6 23.1c5.2 18.2 8 37.4 8 57.4 0 31.8-7.1 61.9-19.9 88.8 16.4-2.5 33.6.8 48.1 9.9zm-108.1 65.1C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1c44.2 36 100.5 57.6 161.8 57.6 55.2 0 106.4-17.5 148.2-47.2-12.3-12.6-19-28.6-20-44.9zm-326.1-99.7c-6.6-20.2-10.1-41.7-10.1-64.1 0-114.9 93.1-208 208-208 30.7 0 59.9 6.7 86.1 18.6l21.8 9.9 19.9-43.7-21.8-9.9C393.6 8.2 357.7 0 320 0 178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8 1.8 1.1 3.5 2.2 5.2 3.4 12.5-9 27.3-13.4 42-13.2zM320 400c61.9 0 112-36.8 132-66.7l-40-26.6c-12 18.1-47.9 45.3-92 45.3s-80-27.2-92-45.3l-40 26.6c19.9 29.9 70 66.7 132 66.7M199.7 234.3c20-27.1 59.8-27.1 79.8 0l32.2-23.8c-36-48.7-108.2-48.7-144.2 0zm239.8 0 32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0M80 376l-12.4-12.4c-7.4-7.4-17.5-11.6-28-11.6C17.7 352 0 369.7 0 391.6c0 10.5 4.2 20.6 11.6 28L80 488l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28 0-21.9-17.7-39.6-39.6-39.6-10.5 0-20.6 4.2-28 11.6zM547.6 11.6C540.2 4.2 530.1 0 519.6 0 497.7 0 480 17.7 480 39.6c0 10.5 4.2 20.6 11.6 28L560 136l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28C640 17.7 622.3 0 600.4 0c-10.5 0-20.6 4.2-28 11.6L560 24z" })
  }
), wx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M171.3 47.6C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6C582.9 42.8 640 0 640 0c0 80.1-55.6 160.1-74.1 184.5 6.6 22.7 10.1 46.7 10.1 71.5 0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.8 3.5-48.8 10.1-71.5C55.6 160.1 0 80.1 0 0c0 0 57.1 42.8 171.3 47.6M320 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m-47.6-208c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6L187 223.2l-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5.3 2.9.3 4.4zm128 32c-17.7 0-32-14.3-32-32 0-1.6.1-3.2.3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8 0 17.7-14.3 32-32 32zM188 349.3l40-26.6c12 18.1 47.9 45.3 92 45.3s80-27.2 92-45.3l40 26.6c-20 29.9-70.1 66.7-132 66.7s-112-36.8-132-66.7" })
  }
), gx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M568 0v72h72v48h-72v72h-48v-72h-72V72h72V0zM400 288a176 176 0 1 0-352 0 176 176 0 1 0 352 0M0 288a224 224 0 1 1 448 0 224 224 0 1 1-448 0m144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M224 368c31.1 0 58.9-13.6 78-35.2l36 31.8c-27.8 31.5-68.6 51.4-114 51.4s-86.2-19.9-114-51.5l36-31.8c19.1 21.6 46.9 35.2 78 35.2z" })
  }
), ix = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m124 77.3 40-26.6c12 18.1 47.9 45.3 92 45.3s80-27.2 92-45.3l40 26.6c-20 29.9-70.1 66.7-132 66.7s-112-36.8-132-66.7m91.5-99c-20-27.1-59.8-27.1-79.8 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0zm80.2 0-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0" })
  }
), mx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1 4.3.7 8.8 1.1 13.3 1.1 43.4 0 80-34.6 80-79v-2c20.3-32.1 32-70.2 32-111M280 408h-24c-58 0-98.8-29.4-122.1-56.3l-15.7-18.1 36.3-31.4 15.7 18.1C187 339.8 215.5 360 256 360h16.7c-.5 2.9-.7 6-.7 9 0 12.5 2.9 24.2 8 34.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m352 32 38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zm-207.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), ax = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 27.2-4.2 53.4-12.1 77.9 9.1 23.9 7.8 51.5-6 75.4-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4-70.4 0-130.1-43.8-157.5-105.5l-9.7-21.9 43.9-19.4 9.7 21.9c20.4 46.1 64.1 76.9 113.6 76.9 56.5 0 105.6-40.3 120.8-97.4L385 243l27.3 16.5 49 29.5c1.7-10.7 2.6-21.7 2.6-33 0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8M120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32m278.5 167.6c18.8 11 42.9 4.7 53.8-14.2 11-19.1 4.5-43.6-14.6-54.6l-.4-.2-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zM336 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80" })
  }
), ox = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0m464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0m-388-77.3 40 26.6c12-18.1 47.9-45.3 92-45.3s80 27.2 92 45.3l40-26.6c-20-29.9-70.1-66.7-132-66.7s-112 36.8-132 66.7M208.4 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64" })
  }
), nx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m124 77.3 40-26.6c12 18.1 47.9 45.3 92 45.3s80-27.2 92-45.3l40 26.6c-20 29.9-70.1 66.7-132 66.7s-112-36.8-132-66.7M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m151.3 26.3-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0" })
  }
), rx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m124 77.3 40-26.6c12 18.1 47.9 45.3 92 45.3s80-27.2 92-45.3l40 26.6c-20 29.9-70.1 66.7-132 66.7s-112-36.8-132-66.7M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), dx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m529.4 250.7-1.4 1.4C525.9 139.1 433.6 48 320 48s-205.9 91.1-208 204.2l-1.4-1.4L88 228.1l-22.6 22.6-1.4 1.4C66.1 112.5 179.9 0 320 0s253.9 112.5 256 252.1l-1.3-1.3-22.7-22.7zM256 334.4v-1.9c16.8 10.8 39.1 19.5 64 19.5s47.2-8.7 64-19.5V386.7c-19 8.1-40.7 13.3-64 13.3s-45-5.2-64-13.3zm-27.1 160.9c9.9-12.6 17.5-27.2 22.1-43 21.6 7.6 44.8 11.7 69 11.7s47.4-4.1 69-11.7c4.6 15.8 12.2 30.4 22.1 43-28.3 10.8-59 16.7-91.1 16.7s-62.8-5.9-91.1-16.7M240 152c28 0 56 40 56 80 0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80m104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32M76.7 307.3 65.4 296 88 273.4l11.3 11.3 84.7 84.7v-35h40V416.8c0 52.6-42.6 95.2-95.2 95.2-25.2 0-49.5-10-67.3-27.9l-48.8-48.8L1.4 424 24 401.4l11.3 11.3 24 24 9.4-9.4-56-56L1.4 360 24 337.4l11.3 11.3 56 56 9.4-9.4-72-72L17.4 312 40 289.4l11.3 11.3 72 72 9.4-9.4-56-56m486.6 0-56 56 9.4 9.4 72-72 11.3-11.3 22.6 22.6-11.3 11.3-72 72 9.4 9.4 56-56 11.3-11.3 22.6 22.6-11.3 11.3-56 56 9.4 9.4 24-24 11.3-11.3 22.6 22.6-11.3 11.3-48.8 48.8C560.7 502 536.4 512 511.2 512c-52.6 0-95.2-42.6-95.2-95.2v-82.4h40v35l84.7-84.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), Sx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m382.3 88.9-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3H160v-48h146.1c13.1 0 24.9-8 29.7-20.1l1.9-4.8 8.9-22.3 44.6 17.8zM208 224c0 17.7-14.3 32-32 32s-32-14.3-32-32H96v-32h80c17.7 0 32 14.3 32 32m192 0c0 17.7-14.3 32-32 32s-32-14.3-32-32h-48v-32h80c17.7 0 32 14.3 32 32" })
  }
), zx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-114.9-93.1-208-208-208-71 0-133.6 35.5-171.1 89.8 18.5-21.6 45.8-36.5 76.6-37.7l12-.5 1 24-12 .5c-46.9 1.9-82.2 45-78.1 84.3v.6c2 40.2 40.8 70.7 76.2 66.7h.6c36.3-2 62.1-35.7 58.4-64.5v-.6c-2.1-29.8-31.3-51-56-47.5h-.6c-25.7 2.2-42 26.2-38.9 44.5l.1.4v.4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1h.3c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2l-.1-.1.5 5.8c1 11.1-8.8 15.8-14.1 16.4-6.6.8-13.4-2.2-17.6-8.5-5-6.8-4.4-15.6-1.8-21.8 2.9-7 8.9-13.2 17.8-16 9.2-3.3 19.4-1.3 27.5 3.3 8.3 4.9 15.5 13.4 17.9 24.8 5.8 22.8-11.9 49.5-39.5 53.6-27.7 5.3-59.8-16.2-63.6-49.2-5.4-33 21.9-68.7 60.3-72.1 38.2-5.2 79.6 25.8 82.9 69.3 5.4 43.3-31.5 88.2-80.6 91.2-48.8 5.3-99.6-35.2-102.5-89.1-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m337.6 36.5 12-.5c46.9-1.9 82.2-45 78.1-84.3v-.6c-2-40.2-40.8-70.7-76.2-66.7h-.6c-36.3 2-62.1 35.7-58.4 64.5v.6c2.1 29.8 31.3 51 56 47.5h.6c25.7-2.2 42-26.2 38.9-44.5l-.1-.4v-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3.1h-.3c-15.2 2.1-21.9 16.3-19.9 24l.1.4.1.4c.9 4.3 3.4 7.4 6.5 9.2l.1.1-.5-5.8c-1-11.1 8.8-15.8 14.1-16.4 6.6-.8 13.4 2.2 17.6 8.5 5 6.8 4.4 15.6 1.8 21.8-2.9 7-8.9 13.2-17.8 16-9.2 3.3-19.4 1.3-27.5-3.3-8.3-4.9-15.5-13.4-17.9-24.8-5.8-22.8 11.9-49.5 39.5-53.6 27.7-5.3 59.8 16.2 63.6 49.2 5.4 33-21.9 68.7-60.3 72.1-38.2 5.2-79.6-25.8-82.9-69.3-5.4-43.3 31.5-88.2 80.6-91.2 48.8-5.3 99.6 35.2 102.5 89.1 5.5 53.8-41.1 108.1-101 110.5l-12 .5-1-24zM281 402.7l-25-20-25 20-13.7 11-14.6-9.7-31.6-21.1L161 393l-17 17-33.9-34 17-17 24-24 13.9-13.9 16.3 10.9 33.4 22.3 26.3-21 15-12 15 12 26.3 21 33.4-22.3 16.4-10.9L361 335l24 24 17 17-34 33.9-17-17-10.1-10.1-31.6 21.2-14.6 9.7z" })
  }
), px = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c-114.9 0-208-93.1-208-208 0-21.8 3.4-42.8 9.6-62.5L80 272h128l22.9-80h50.3l22.8 80h128l22.4-78.5c6.2 19.7 9.6 40.7 9.6 62.5 0 114.9-93.1 208-208 208m-16-320v-16H92c38.1-48.7 97.4-80 164-80s125.9 31.3 164 80H272v16zm16 368a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-96c61.9 0 112-36.8 132-66.7l-40-26.6c-12 18.1-47.9 45.3-92 45.3s-80-27.2-92-45.3l-40 26.6c19.9 29.9 70 66.7 132 66.7" })
  }
), Mx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), xx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48c114.9 0 208 93.1 208 208h48C576 114.6 461.4 0 320 0S64 114.6 64 256h48c0-114.9 93.1-208 208-208m-79.6 176c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32zM0 512h640V288H0zm400-128h-16v32h32v32h-32v32h-32v-32h-32v32h-32v-32h-32v-32h32v-32h-32v-32h32v-32h32v32h32v-32h32v32h32v32zm-80 0v32h32v-32zm262.6-41.7-10.4 12.1-96 112-10.4 12.1-24.3-20.8 10.4-12.1 96-112 10.4-12.1zM448 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0m104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48M224 320v96h-32v-96zm-32 128h32v32h-32zM96.4 335.5V320h32v15.3c5.3.9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7-5.5-.1-12 1.1-16.3 3.5-2 1.1-3 2.1-3.3 2.6-.2.3-.5.9-.5 2.4 0 .3 0 .3.1.4.3.4 1.2 1.3 3.5 2.5 4.9 2.7 11.9 4.6 21.4 7.3l.2.1c8.4 2.4 19.3 5.4 28 10.6 9.6 5.6 18.9 15.2 19.3 30.6.5 17.3-9.2 28.8-20.5 34.9-5 2.7-10.5 4.5-15.8 5.6V480h-32v-14.3c-7.5-1.6-14.5-3.8-20.6-5.8-1.6-.5-3.1-1-4.5-1.4L56 453.7l9.5-30.6 15.3 4.8c1.8.6 3.6 1.1 5.3 1.7 10.4 3.3 18.4 5.8 26.8 6.1 6 .2 12.1-1 16.1-3.1 1.8-1 2.7-1.9 3.1-2.5.3-.5.8-1.4.7-3.3v-.1c0-.6 0-1.7-3.6-3.8-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5c-8-2.3-18.1-5.1-26.3-9.5-9.2-5-19.4-13.8-20.4-29.1-1.2-17.9 9.5-29.4 20.6-35.3 5-2.7 10.4-4.5 15.6-5.6z" })
  }
), Hx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5 1.5-1.3 3-2.6 4.4-4l84.8-80.4C518.8 421 414 512 288 512 146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48m258.8 132.1c19.8 19.8 19.4 52.1-.9 71.4L425.1 366.6c1 1.4 2 2.7 2.9 4.1l-24 16-1 .9-.2-.2-14.8 9.9c-12-18.1-47.9-45.3-92-45.3s-80 27.2-92 45.3l-40-26.6c19.9-29.9 70-66.7 132-66.7 15.6 0 30.5 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8.7M402.9 343.5l26.5-25.2-5.8-5.8-8.6-8.5 17-17 8.5 8.5 6.3 6.3 15.4-14.7-6.6-6.6-8.6-8.5 17-17 8.5 8.5 7 7 15.4-14.7-7.4-7.4-8.5-8.4 17-17 8.5 8.5 7.8 7.8 11.5-11c7.3-6.9 7.4-18.5.3-25.6-6.9-6.9-18-7-25-.3l-126.2 121c11.3 5.9 21.3 12.8 30 20.1zM208.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Vx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 114.9-93.1 208-208 208-3.9 0-7.7-.1-11.6-.3l-10.1 27.7c-2.5 6.8-5.8 13.1-9.8 18.8 10.3 1.3 20.8 1.9 31.4 1.9 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 45 11.6 87.3 32 124v-84h19.8c-2.5-12.9-3.8-26.3-3.8-40 0-57.1 23-108.8 60.2-146.4l13.8 24.2 13.9-7.9 7.1-4c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3 12.1 10.4 20.8-24.3-12.1-10.4-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-5.4 3.1C157.9 66.5 204.8 48 256 48c114.9 0 208 93.1 208 208m-156 34.9-7.5-2.2-136-40-15.3-4.5-9 30.7 15.4 4.5L262 310.7zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-16a32 32 0 1 0-64 0 32 32 0 1 0 64 0M112 328H64v184h128.8l5.7-15.8 31.8-87.5 49.8-18.1 22.6-8.2-16.4-45.1-22.6 8.2L112 400.6V352z" })
  }
), Cx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 112c-41.8 0-80.5 12.2-112 33v-1c0-61.9 50.1-112 112-112s112 50.1 112 112v1c-31.5-20.8-70.2-33-112-33M112 144l118.9 64L112 272l45.7-64zm169.1 64L400 144l-45.7 64 45.7 64z" })
  }
), Lx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 114.9-93.1 208-208 208-13 0-25.6-1.2-37.9-3.4l-8.7 47.2c15.1 2.8 30.7 4.2 46.7 4.2 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 15.9 1.5 31.5 4.2 46.7l47.2-8.7c-2.2-12.4-3.4-25-3.4-38 0-114.9 93.1-208 208-208s208 93.1 208 208M241 386.7l15 12 15-12 26.3-21 33.4 22.3 16.4 10.9L361 385l24-24 17-17-34-33.9-17 17-10.1 10.1-31.6-21.2-14.6-9.7-13.7 11-25 20-13.1-10.5-9.9 53.5 8.1 6.5zM112 128l45.7 64-45.7 64 118.9-64zm169.1 64L400 256l-45.7-64 45.7-64zM216 296 0 336l64 48-32 96 96-32 48 64z" })
  }
), Bx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.3 442.4c2.2-7.7 3.5-15.9 3.7-24.3 30.5-21.1 53.2-52.1 63.3-88.1 3.8-13.7-7.4-26.1-21.6-26.1H118.4c-14.2 0-25.5 12.4-21.6 26.1 10.1 36 32.8 66.9 63.3 88.1.2 8.4 1.5 16.5 3.7 24.3C95.1 408.4 48 337.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4m-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.5-6.2-9.8-13.5-12.6-21.6-2.3-6.5-3.5-13.6-3.5-20.9v-80h128v80c0 7.3-1.2 14.4-3.5 20.9-2.8 8-7.1 15.3-12.6 21.6zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M146.9 135.2c-10.4 6-19.7 17.1-18.7 33.8.9 14.3 9.9 23 18.6 28 7.4 4.3 16.6 7 23.6 9.1l1.5.4c8.3 2.5 13.9 4.4 17.6 6.7 2.6 1.7 2.6 2.4 2.6 3v.1c.1 1.9-.4 2.7-.6 3-.3.4-.8 1.1-2.2 1.9-3 1.7-7.9 2.8-12.7 2.6-7-.2-13.5-2.4-22.7-5.6-1.5-.5-3.1-1-4.7-1.6l-15.2-5.1-10.1 30.4 15.2 5.1c1.2.4 2.5.9 3.9 1.3 5.1 1.8 11.1 3.8 17.6 5.3v18.2h32v-17.6c4.4-1.1 8.8-2.8 12.9-5.2 10.7-6.2 19.1-17.4 18.6-33.5-.4-14.4-8.6-23.7-17.6-29.4-8-5-17.8-8-25.1-10.2l-.3-.1c-8.5-2.6-14.3-4.4-18.3-6.7-1.8-1-2.4-1.7-2.6-1.9v-.2c-.1-1.4.2-1.9.3-2.1.2-.4.8-1.1 2.4-2 3.4-1.9 8.6-3 13-2.9 6.1.1 12.8 1.4 20.1 3.4l15.5 4.1 8.2-30.9-15.5-4.1c-3.6-1-7.6-1.9-11.7-2.7V112h-32v17.8c-4.6 1.1-9.2 2.8-13.6 5.3zm173.1-5.3c-4.4 1.1-9 2.8-13.1 5.2-10.4 6-19.7 17.1-18.7 33.8.9 14.3 9.9 23 18.6 28 7.4 4.3 16.6 7 23.6 9.1l1.5.4c8.3 2.5 13.9 4.4 17.6 6.7 2.6 1.7 2.6 2.4 2.6 3v.1c.1 1.9-.4 2.7-.6 3-.3.4-.8 1.1-2.2 1.9-3 1.7-7.9 2.8-12.7 2.6-7-.2-13.5-2.4-22.7-5.6-1.5-.5-3.1-1-4.7-1.6l-15.2-5.1-10.1 30.4 15.2 5.1c1.2.4 2.5.9 3.9 1.3 5 1.7 10.8 3.7 17.1 5.2V272h32v-17.7c4.5-1.1 9.1-2.8 13.3-5.3 10.6-6.2 19.1-17.4 18.6-33.5-.4-14.4-8.6-23.7-17.5-29.4-8-5-17.8-8-25.1-10.2l-.3-.1c-8.5-2.6-14.3-4.4-18.3-6.7-1.8-1-2.4-1.7-2.6-1.9v-.2c-.1-1.4.2-1.9.3-2.1.2-.4.8-1.1 2.4-2 3.4-1.9 8.6-3 13-2.9 6.1.1 12.8 1.4 20.1 3.4l15.5 4.1 8.2-30.9-15.5-4.1c-3.8-1-7.8-2-12.1-2.8V112H320zm-51.3 229.7V344h-24v15.8c-3.2.8-6.5 1.9-9.6 3.6-7.7 4.1-15.2 12.1-14.4 24.7.7 10.8 7.9 17 14.2 20.4 5.5 3 12.4 4.9 17.7 6.4l1.1.3c6.2 1.8 10.5 3.1 13.4 4.8 1.1.7 1.6 1.1 1.7 1.3v.1c0 1-.2 1.3-.2 1.4-.1.2-.5.6-1.5 1.2-2.3 1.3-6.1 2-9.9 1.9-5.4-.2-10.4-1.8-17.3-3.9-1.1-.4-2.3-.7-3.5-1.1l-11.5-3.6-7.1 22.9 11.5 3.6c.9.3 1.9.6 3 .9 3.7 1.2 8 2.6 12.7 3.6v17h24v-16.6c3.3-.8 6.6-1.9 9.7-3.6 7.9-4.3 14.7-12.3 14.3-24.4-.3-10.8-6.9-17.5-13.5-21.4-5.9-3.5-13.3-5.6-18.8-7.1l-.2-.1c-6.4-1.8-10.8-3.1-13.9-4.7-.9-.5-1.4-.9-1.7-1.1v-.4c.1-.1.5-.6 1.7-1.3 2.6-1.4 6.7-2.2 10.1-2.1 4.7.1 9.8 1 15.3 2.4l11.6 2.9 5.8-23.3-11.6-2.9c-2.8-.7-5.8-1.4-8.9-1.9z" })
  }
), ux = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 81.7-47.1 152.4-115.7 186.4 2.4-8.4 3.7-17.3 3.7-26.4v-15.3c10.2-7.2 16-15.7 16-24.7 0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V416c0 9.2 1.3 18 3.7 26.4-27.2-13.5-51-32.7-69.8-56.1-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256l16-21.3 25.6 34.1 7.7 10.2c-.8-7.6-1.3-15.2-1.3-23 0-114.9 93.1-208 208-208s208 93.1 208 208M96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288l-11.6 15.5-26.8 35.7C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48 12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368m239.6-96a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m31-144L216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm110.1 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4-11.3-11.3-22.6 22.6zM288 480c-35.3 0-64-28.7-64-64v-48h48v24h32v-24h48v48c0 35.3-28.7 64-64 64" })
  }
), Rx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m294.5 136.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM208 224c0 17.7-14.3 32-32 32s-32-14.3-32-32H96v-32h80c17.7 0 32 14.3 32 32m192 0c0 17.7-14.3 32-32 32s-32-14.3-32-32h-48v-32h80c17.7 0 32 14.3 32 32" })
  }
), $x = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v160h48V48h112V0H24zm352 0v48h112v112h48V0H376zM48 352H0v160h160v-48H48v-88zm464 0h-48v112H352v48h160V376zM240 216a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224m0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320m0-112c-21.6 0-39.8-14.2-45.9-33.8l-30.6 9.4C189.6 312.2 220 336 256 336s66.4-23.8 76.5-56.4l-30.6-9.4c-6 19.6-24.3 33.8-45.9 33.8z" })
  }
), kx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 256c0 63.4-28.3 120.1-73 158.3 5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256 544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256c0-114.9 93.1-208 208-208s208 93.1 208 208m-233.1-48L144 144l45.7 64-45.7 64zM432 144l-118.9 64L432 272l-45.7-64zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64m544-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-192-51.9v-58.3c10.8 4.3 18.7 8.5 23.1 11.5l13.3 8.9 17.8-26.6-13.3-8.9C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7l-13.3 8.9 17.8 26.6 13.3-8.9c4.4-3 12.3-7.2 23.1-11.5v58.3c0 31-19.8 58.5-49.2 68.3L96 480v32h384v-32l-46.8-15.6c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32m-80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), Px = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 112c-41.8 0-80.5 12.2-112 33v-1c0-61.9 50.1-112 112-112s112 50.1 112 112v1c-31.5-20.8-70.2-33-112-33m-33.4-192-11.3 11.3-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4 11.3-11.3zm78.1 11.3L289.4 176l22.6-22.6 11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z" })
  }
), Fx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m112-304c0-35.3-14.3-64-32-64s-32 28.7-32 64 14.3 64 32 64 32-28.7 32-64m-154.2 39.3 23.3-5.8-11.6-46.6-23.3 5.8-64 16-23.3 5.8 11.6 46.6 23.3-5.8zm.4-139.7-26.6-17.8-8.9 13.3c-23.2 34.8-58.4 53.2-71.7 57.7l-15.2 5.1 10.1 30.4 15.2-5.1c18.6-6.2 60.3-28.3 88.3-70.3l8.9-13.3zm171.6 252.5 16.1-17.8-35.5-32.3-16.1 17.8-31.3 34.5c-3.3 3.6-7.9 5.7-12.8 5.7-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9-19.3-14.2-28.4 38.7 19.3 14.2 9.4 6.9c24.2 17.8 56 21.2 83.4 9.1 11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5 18.4 0 36-7.8 48.3-21.4l31.3-34.5z" })
  }
), Tx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m255.6 144c-38.7 0-74.5 11.4-103.6 30.6 4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6c-29.1-19.2-64.9-30.6-103.6-30.6M144.4 272a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 160c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9-21.8-23.4 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1h16v32h-16zm141 .9c-4.3-.6-8.6-.9-13-.9h-16v-32h16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), Ax = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6-4.1-10.7-6.4-22.4-6.4-34.6v-12.5c-16-10.5-30.2-24-41.9-40.2l275.8-159.2c29.4 65.1 11.7 141.7-41.9 187.4V416c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152M384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1-7.8 2.1-16 3.2-24.5 3.2-1.9 0-3.7-.1-5.6-.2-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7M296.4 160c-11.1 0-20.4-7.5-23.2-17.7-.8 3.1-1.2 6.4-1.2 9.7 0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40c-3 0-6 .3-8.8 1 9.9 2.9 17.2 12.1 17.2 23 0 13.3-10.7 24-24 24M312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144M176 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m48 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0m144 256c35.3 0 64-28.7 64-64v-48h-48v24h-32v-24h-48v48c0 35.3 28.7 64 64 64" })
  }
), Dx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 32.2-7.3 62.8-20.4 90l42.9 21.5C502.8 333.8 512 296 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c40 0 77.8-9.2 111.5-25.5L346 443.6c-27.2 13.1-57.8 20.4-90 20.4-114.9 0-208-93.1-208-208m304 82.7V320h-32v50.7l9.4-9.4zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M224 336v-16h-32v64h32v-16zm64-16h-32v64h32v-48zm-128 0h-32v64h32v-48zm352 96-128-64-32 32 64 128h32l64-64zm-63.5 16.5-16 16-8.5 8.5-17-17 8.5-8.5 16-16 8.5-8.5 17 17z" })
  }
), yx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.7 120.1 136 152l15.7 31.9-.6 32.4-32.9-8.3-26.9 22.8-34.1 7.3-14.5 32.5-27.6 21.8.6 35.7L0 360l15.7 31.9-.6 35.7 27.6 21.8 14.6 32.5 34.1 7.3 26.8 22.8 33.8-8.6 33.8 8.6 26.9-22.8 34.1-7.3 14.6-32.5 26.7-21 26.7 21 14.6 32.5 34.1 7.3 26.7 22.8 33.8-8.6 33.8 8.6 26.9-22.8 34.1-7.3 14.6-32.5 27.6-21.8-.3-15.1c-17.3 5.4-36.1 3.9-52.1-.5-1.3-.4-2.6-.7-3.9-1.1l-1.1.8-9.2 7.3-4.8 10.7L485 440l-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5L363 440l-4.6-10.3-4.8-10.7-9.2-7.3-8.9-7.1.2-11.9.2-11.6-5.1-10.4-5.3-10.7 5.3-10.8 5.1-10.4-.2-11.6-.2-11.9 8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.4-2.4c-2.6-21.6 1.2-45.4 19.1-63.3 6.3-6.3 13.3-10.8 20.6-14l-.2-14 15.8-32-15.7-31.9.6-35.7-27.6-21.8-14.5-32.5-34.1-7.3L321.8 0 288 8.6 254.2 0l-26.9 22.8-34.1 7.3-14.5 32.5-27.6 21.8.6 35.7zm409.2 176.5c-1.7-2.9-3.5-5.8-5.5-8.6-5.5-8.1-12.1-16.1-19.7-23.7-2.9-2.9-5.9-5.7-8.9-8.3-12.4-10.8-25.5-19-38.3-24.4-1.8-.8-3.6-1.5-5.4-2.2-23-8.4-44.1-7.3-56.6 5.1-7.3 7.3-10.7 17.6-10.6 29.5.3 23.8 14.7 54.1 40.3 79.6 17.8 17.8 37.9 30.2 56.4 36.2 21.5 6.9 40.9 5.3 52.7-6.4 4.5-4.5 7.5-10 9.1-16.4 4.2-16.6-.8-38.6-13.7-60.4zM199.5 107.3l8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.8-2.5 9.2-7.8 8-6.8 9.9 2.5 11.8 3 11.8-3 9.9-2.5 8 6.8 9.2 7.8 11.8 2.5 10.3 2.2 4.6 10.3 4.8 10.8 9.2 7.3 8.9 7.1-.2 11.9-.2 11.6 5.1 10.4 5.3 10.8-5.3 10.8-5.1 10.4.2 11.6.2 11.9-8.9 7.1-9.2 7.3-4.8 10.7-4.6 10.3-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5-10.3-2.2-4.6-10.3-4.8-10.9-9.2-7.3-8.9-7.1.2-11.9.2-11.6-5.1-10.4-5.3-10.7 5.3-10.8 5.1-10.4-.2-11.6-.2-11.9zm-136 208 8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.8-2.5 9.2-7.8 8-6.8 9.9 2.5 11.8 3 11.8-3 9.9-2.5 8 6.8 9.2 7.8 11.8 2.5 10.3 2.2 4.6 10.3 4.8 10.7 9.2 7.3 8.9 7.1-.2 11.9-.2 11.6 5.1 10.4 5.3 10.8-5.3 10.8-5.1 10.4.2 11.6.2 11.9-8.9 7.1-9.2 7.3-4.8 10.7-4.6 10.3-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5-10.3-2.2-4.6-10.3-4.8-10.8-9.2-7.3-8.9-7.1.2-11.9.2-11.6-5.1-10.4-5.3-10.7 5.3-10.8 5.1-10.4-.2-11.6-.2-11.9zM112 352a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0m224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0M224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), bx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m36.2 144L63.6 336H144v48h-32v128H64V384H0l13.7-48L64 160h113.6c-1 5.2-1.6 10.5-1.6 16 0 11.4 2.4 22.2 6.7 32H128zm229.1 0c4.3-9.8 6.7-20.6 6.7-32 0-5.5-.6-10.8-1.6-16H448l50.3 176 13.7 48h-64v128h-48V384h-32v-48h80.4l-36.6-128h-55.6zM320 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96m80 240v48h-32v96h-96v-96h-32V256h160v48zm-112 0h64v-64h-64z" })
  }
), fx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m14 144-4 96h70v48h-32v160H64V352H24l2-48 6-144h145.6c-1 5.2-1.6 10.5-1.6 16 0 11.4 2.4 22.2 6.7 32H128zm258-32c0-5.5-.6-10.8-1.6-16H480l6 144 2 48h-40v160h-48V352h-32v-48h70l-4-96H329.3c4.3-9.8 6.7-20.6 6.7-32M320 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-32 240h64v-64h-64zm112 48h-32v96h-96v-96h-32V256h160v112z" })
  }
), Ux = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M78 208h104.7c-4.3-9.8-6.7-20.6-6.7-32 0-5.5.6-10.8 1.6-16H32l-6 144-2 48h40v160h48V352h32v-48H74zm258-32c0 11.4-2.4 22.2-6.7 32h82.5l36.6 128H368v48h32v128h48V384h64l-13.7-48L448 160H334.4c1 5.2 1.6 10.5 1.6 16M448 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-32 144v-64h64v64zm112 48V256H176v160h32v96h96v-96z" })
  }
), Gx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352m224-176c0 115.6-87.6 210.8-200 222.7V464h136v48H64v-48h136v-17.3C87.6 434.8 0 339.6 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224m-329.6-26.4c-16.6-41 3.2-87.6 44.2-104.1l22.3-9 38.2 94.4c16.7-23.7 45.8-37.5 76.6-33.2 43.8 6.1 74.2 46.6 68.1 90.4l-3.3 23.8-101-14.2c12.2 26.4 9.6 58.4-9.6 82.9-27.2 34.8-77.5 41-112.3 13.8l-18.9-14.8 62.7-80.3c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), qx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m259.1 126.7-6.2 62.4 61.9-10.3c10.5-1.8 22.9-2.8 37.3-2.8h.2c25.4-.1 52.7 14.5 75.5 43.5 10.9 13.9 19.8 29.9 26 46.5l-66.3-6.6-56.7-5.7 4 56.8c.9 12.4 1.4 26.3 1.4 41.6v.2c.1 25.4-14.5 52.7-43.5 75.5-13.9 10.9-29.9 19.8-46.5 26l6.8-68.3 6.2-62.4-61.9 10.3c-10.6 1.6-22.9 2.6-37.3 2.6h-.2c-25.4.1-52.7-14.5-75.5-43.5-10.9-13.9-19.8-29.9-26-46.5l68.3 6.8L189 259l-10.3-61.9c-1.7-10.3-2.7-22.7-2.7-37.1v-.2c-.1-25.4 14.5-52.7 43.5-75.5 13.9-10.9 29.9-19.8 46.5-26l-6.8 68.3zM512 320c0-16.2-2.2-32.7-6.4-48.9-19-73.7-78.4-141.3-150.2-143.1H352c-16.8 0-31.8 1.2-45.2 3.5l4.9-49.2 3.4-34.2L320 0c-16.2 0-32.7 2.2-48.9 6.4C197.4 25.5 129.8 84.8 128 156.6v3.4c0 16.7 1.2 31.7 3.5 45.2l-49.2-4.9-34.2-3.4L0 192c0 16.2 2.2 32.7 6.4 48.9C25.5 314.6 84.8 382.2 156.6 384h3.4c16.8 0 31.8-1.2 45.2-3.5l-4.9 49.2-3.4 34.2L192 512c16.2 0 32.7-2.2 48.9-6.4 73.7-19.1 141.3-78.4 143.1-150.2V352c0-16.3-.5-31.3-1.5-45l48.4 4.8 33 3.3zm-256-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Wx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h80v48H0V112C0 50.1 50.1 0 112 0c54.6 0 100.1 39.1 110 90.8l-4.4 1.9-19.4 8.5-8.9 19.2-26 55.7H48zm128-336v-16c0-35.3-28.7-64-64-64s-64 28.7-64 64v16zm32 336h96v-96h128v96h96V273.5l-44.9-108.9L368 116.1l-115.1 48.5L208 273.5zm-48 0V264l56-136 152-64 152 64 56 136v248H160zm256-240v96h-96v-96z" })
  }
), Ex = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 128h49.9l7 7 25 25H360c83.9 0 152 68.1 152 152v72H352v-56c0-4.4-3.6-8-8-8h-20.1c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48H0v-48h149.4l7.1 11.1c14.3 22.2 39.2 36.9 67.5 36.9s53.2-14.7 67.4-36.9l7.1-11.1H344c30.9 0 56 25.1 56 56v8h64v-24c0-57.4-46.6-104-104-104h-49.9l-7-7-25-25H177.9l-25 25-7 7H0v-48h126.1l25-25 7-7H200V82.4L64 96V32l136 13.6V0h48v45.6L384 32v64L248 82.4zm184 288 27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7z" })
  }
), Ox = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 192h-40v-45.6L384 160V96l-136 13.6V64h-48v45.6L64 96v64l136-13.6V192h-41.9l-7 7-25 25H0v48h145.9l7-7 25-25h100.2l25 25 7 7H360c57.4 0 104 46.6 104 104v24h-64v-8c0-30.9-25.1-56-56-56h-45.5l-7.1 11.1C277.2 369.3 252.3 384 224 384s-53.2-14.7-67.4-36.9l-7.1-11.1H0v48h124.1c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48H344c4.4 0 8 3.6 8 8v56h160v-72c0-83.9-68.1-152-152-152h-30.1l-25-25-7-7z" })
  }
), Ix = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v128H0v384h512V192H176V48h214.1L432 89.9V160h48V70.1l-7-7L417 7l-7-7h-10zm24 240h288v224H176zm-48 224H48V176h80v64zm176-192h-64v64h64zm-64 96v64h64v-64zm160-96h-64v64h64zm-64 96v64h64v-64z" })
  }
), Nx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M171.3 165.6c36.7-36.7 99.8-65.2 169.4-85.2 41-11.8 81.7-20 116.2-25.3-5.4 34.5-13.5 75.3-25.3 116.2-3.6 12.5-7.5 24.8-11.6 36.8h-82.1l7.9-7.9 17-17-33.9-33.9-17 17-188.4 188.2c-12.3-21.8-15.4-48.9-9.8-79.4 7.5-41 30.2-82.1 57.6-109.6zm-48.6 257.7c78 54.7 194.8 14.3 257.7-48.6 76.4-76.4 112.4-229.2 126.1-325.9 2.6-18.6 4.4-35.2 5.5-48.7-13.5 1.1-30.1 2.9-48.7 5.5-96.7 13.6-249.5 49.6-325.9 126C74.5 194.5 34 311.4 88.7 389.3l-70.5 70.5-17 17 33.9 33.9 17-17 70.5-70.5zm34.8-34.8 36.4-36.5H334c-26.6 22.2-61.9 39.8-97.1 46.3-30.6 5.6-57.6 2.5-79.4-9.8zM375.4 304H241.9l48-48h111.2c-7.9 17.4-16.4 33.6-25.7 48z" })
  }
), Xx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311.9 166.1 112 366.1V243.9L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3 0 16.8-4 33.3-11.4 48H337.9l7.9-7.9 17-17-33.9-33.9-17 17zm-22 89.9h122.2l-48 48H241.9zm26.2 96-48 48H145.9l48-48zM64 224v190.1l-45.8 45.7-17 17 33.9 33.9 17-17L97.9 448H288l178.7-178.7c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3z" })
  }
), Kx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 115.9 16-16 16 16V432H48V115.9zm-17.9-50L0 96v384h128v-80h64v80h128v-80h64v80h128V96l-30.1-30.1L448 32l-33.9 33.9L384 96v64h-64V96l-30.1-30.1L256 32l-33.9 33.9L192 96v64h-64V96L97.9 65.9 64 32zM384 352h-64V208h64zm-192 0h-64V208h64zm48-236.1 16-16 16 16V432h-32V115.9zM432 432V115.9l16-16 16 16V432z" })
  }
), Qx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0h96v45.4c18 4.1 35.1 10.4 51.1 18.6H448v92.9c8.2 16 14.6 33.1 18.6 51.1H512v48c0 25.6-20.1 46.5-45.3 47.9-4.1 18-10.4 35.1-18.7 51.1v45c0 25.1-19.2 45.7-43.8 47.8l-32.8-69.7c8.3-7.9 15.9-16.6 22.5-26.1 14.6-21 24.6-45.5 28.4-72h-90c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24h90c-1.2-8.2-2.9-16.2-5.3-24-5.2-17.3-13-33.5-23.2-48-1.1-1.6-2.2-3.1-3.3-4.6L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l63.6-63.6c-1.5-1.1-3.1-2.2-4.6-3.3-14.5-10.1-30.7-18-48-23.2-7.8-2.3-15.8-4.1-24-5.3v90c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7v-90c-8.2 1.2-16.2 2.9-24 5.3-17.3 5.2-33.5 13-48 23.2-1.6 1.1-3.1 2.2-4.6 3.3l63.6 63.6c-14.5 7.6-26.4 19.5-33.9 33.9l-63.6-63.6c-1.1 1.5-2.2 3.1-3.3 4.6-10.1 14.5-18 30.7-23.2 48-2.3 7.8-4.1 15.8-5.3 24h90c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24h-90c3.8 26.5 13.8 51 28.4 72 6.6 9.4 14.1 18.2 22.5 26.1l-32.8 69.7C83.2 445.7 64 425.1 64 400v-44.9c-8.3-16-14.6-33.1-18.7-51.1C20.1 302.5 0 281.6 0 256v-48h45.4c4.1-18 10.4-35.1 18.6-51.1V64h92.9c16-8.3 33.1-14.6 51.1-18.6zm-72.5 464L219 286.6c-6.9-8.3-11-19-11-30.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.6-4.1 22.3-11 30.6L376.5 464l7.5 16v32H128v-32zm53 0h134.9L256 320.7 188.6 464z" })
  }
), Zx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h192v32h104l-20 48h60v231.6l-4.3 6.2-56 80-39.3-27.5 35.1-50.3h-351l35.2 50.2-39.3 27.5-56-80-4.4-6.1V80h60L88 32h104zm288 272V128H96v144h32V160h320v112zm-80 0v-64H176v64zM79 488.9C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), Jx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m414 7.1 19.9 13.5 66.2 44.9L520 79l-13.5 19.8-22.5 33.1L270.3 447c-27.4 40.4-72.9 64.6-121.7 64.7C66.5 512 0 445.2.6 363.1v-2.6c.2-28.8 8.7-56.9 24.4-81L42.4 253l21.9-33.5 13.1-20.1 20.1 13.1 67 43.8 20.1 13.1-13.1 20.1-21.9 33.5-17.3 26.5c-2.3 3.5-3.6 7.7-3.6 11.9v2.6c-.1 10.9 8.7 19.7 19.6 19.7 6.5 0 12.5-3.2 16.1-8.6l213.7-315L400.6 27 414 7.1zm-11.2 159-25.6-19.2-173.1 255.2c-12.5 18.5-33.4 29.6-55.7 29.6-37.6.1-68-30.5-67.8-68.1V361c.1-13.4 4.1-26.6 11.4-37.8l17.3-26.5 8.8-13.4-26.7-17.4-8.8 13.4-17.3 26.5c-10.7 16.4-16.5 35.5-16.6 55.1v2.6c-.4 55.4 44.5 100.5 99.9 100.3 32.9-.1 63.6-16.4 82.1-43.7zM432 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), jx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zm-40 232v-24h-48v126.1l-31-31-17-17L86.1 320l17 17 72 72 17 17 17-17 72-72 17-17-34.1-33.9-17 17-31 31z" })
  }
), Yx = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zm-40 408V305.9l31 31 17 17 33.9-33.9-17-17-72-72-17-17-17 17-72 72-17 17 34.1 33.9 17-17 31-31V432h48z" })
  }
), _x = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zm-29.5 393.7 31.8 36.3c23.4-24.4 37.7-57.5 37.7-94s-14.4-69.6-37.7-94l-31.8 36.3c13.4 15.5 21.5 35.6 21.5 57.7s-8.1 42.2-21.5 57.7M96 376h40l40 40h16V256h-16l-40 40H96z" })
  }
), hH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM96 240H72v176h128V240h-24zm24 128v-80h32v80zm120-128h-24v48h24v80h-24v48h96v-48h-24V240h-24z" })
  }
), cH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 464h240V160H352V48H176v70.2l-1.9-2.4-22.5 9.2-23.6 9.7V0h256l128 128v384H224zM92.3 154.6l5.6 2.3 30.1 12.4 30.1-12.3 5.6-2.3 3.7 4.8 19.9 25.7 32.2 4.4 6 .8.8 6 4.4 32.2 25.7 19.9 4.8 3.7-2.3 5.6-12.2 30.2 12.3 30.1 2.3 5.6-4.8 3.7-25.7 19.9-4.4 32.2-.8 6-6 .8-27.6 3.9V512l-64-40-64 40V390.2l-27.6-3.8-6-.8-.8-6-4.4-32.2-25.7-20-4.8-3.7 2.3-5.6L9.3 288-3 257.9l-2.3-5.6 4.8-3.7 25.7-19.9 4.4-32.2.8-6 6-.8 32.2-4.4 19.9-25.7 3.7-4.8zM192 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), sH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-40 280v-24h-48v176h48v-24zm88 32v-24h-48v144h48v-24zm-176 32v-24H80v112h48v-24z" })
  }
), vH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 464V160H224V48H48v416zM48 0h208l128 128v384H0V0zm128 238.7V336h96.2c-.1 7.8-1.2 15.7-3.3 23.6-13.7 51.2-66.4 81.6-117.6 67.9s-81.6-66.4-67.9-117.6C95 267 133.7 238.8 176 238.7m32-30.7c53 0 96 43 96 96h-96z" })
  }
), eH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm33 267.6 17-17-34-33.9-17 17-89.7 89.7L129 287l-17-17-33.9 34 17 17 53.3 53.3 17 17 17-17z" })
  }
), lH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm240-96a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L488 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), tH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm384-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), wH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm384-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288m15.3 64h-32v32h32zm1.2 64H400v32h16.5v48H400v32h64v-32h-15.5v-64z" })
  }
), gH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm240-96a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 16v-32H352v32h144z" })
  }
), iH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm384-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), mH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm384-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288m-22.4 56c-23 0-41.6 18.6-41.6 41.6v6.4h32v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5V392h32v-13.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5zM448 416h-32v32h32z" })
  }
), aH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h236.5c12.3 18.8 28 35.1 46.3 48H0V0h256l128 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48zm384-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7z" })
  }
), oH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-95 289 17-17-34-33.9-17 17L79 303l-17 17 17 17 48 48 17 17 33.9-34-17-17-31-31 31-31zm96-34-17-17-33.9 34 17 17 31 31-31 31-17 17 33.9 33.9 17-17 48-48 17-17-17-17-48-48z" })
  }
), nH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zM96 96H80v32h112V96h-16zm0 64H80v32h112v-32h-16zm56 144h-11.9l-3.4 11.4-20.6 68.6H80v32h59.9l3.4-11.4L160 349l16.7 55.6 3.4 11.4H209.9l4.4-8.8 11.6-23.2h4.2l11.6 23.2 4.4 8.8H304v-32h-38.1l-11.6-23.2-4.4-8.8h-43.8l-4.4 8.8-3 5.9-15.4-51.4-3.4-11.3H168z" })
  }
), rH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h48v48H0V0h256l128 128v160h-48V160H224V48H48zm152-112h16c22.1 0 40 17.9 40 40v24h-32v-24c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24h32v24c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40m133.1 0H384v32h-50.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H288v-32h58.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1zm114.9 0v77.1l16 42.7 16-42.7V352h32v82.9l-1 2.7-24 64-3.9 10.4h-38.2l-3.9-10.4-24-64-1-2.7V352z" })
  }
), dH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 464H176v-96h-48v144h384V368h-48zm0-304v96h48V128L384 0H128v256h48V48h176v112zM56 288H32v48h160v-48h-24zm224 0h-24v48h128v-48h-24zm192 0h-24v48h160v-48h-24z" })
  }
), SH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h48v48H0V0h256l128 128v160h-48V160H224V48H48zm128-112h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-48V352zm16 128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16zm264-128h16c22.1 0 40 17.9 40 40v24h-32v-24c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24h32v24c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40m-168 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" })
  }
), zH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM97.9 224l65.1 96-65.1 96h58l36.1-53.3 36.1 53.3h58L221 320l65.1-96h-58L192 277.3 155.9 224z" })
  }
), pH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-40 192h-48v160h48V216zm-48 192v48h48v-48z" })
  }
), MH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 368v96H48V48h176v112h112v96h48V128L256 0H0v512h384V368zm145-145-17-17-33.9 34 17 17 31 31H192v48h286.1l-31 31-17 17 33.9 33.9 17-17 72-72 17-17-17-17-72-72z" })
  }
), xH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zM93.7 305.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4 11 10.2 10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8 0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9L192 273l-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8z" })
  }
), HH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zM80 432h224v-32l-88-112-57.7 73.5L136 336l-56 64zm48-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), VH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 464H176v-96h-48v144h384V128L384 0H128v256h48V48h176v112h112zM297 215l-17-17-33.9 34 17 17 39 39H0v48h302.1l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z" })
  }
), CH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 160H224V48H48v416h288zM48 0h208l128 128v384H0V0zm164 222.7v23.4c6.6 1.1 16.3 2.8 20.6 3.8l19.5 4.6-9.2 38.9-19.5-4.6c-3.9-.9-17.5-3.3-21.9-3.9-6.3-.9-35.1-3.2-37.2 8-.2 1.1-.2 1.7-.2 1.9 5.3 7.4 16 9.4 25.6 11.2 3.1.6 6 1.1 8.6 1.8 12.1 3.2 28.1 7.5 40.1 15.3 6.6 4.3 13.2 10.3 17.4 18.9 4.3 8.9 5.2 18.7 3.3 28.7-3.6 18.6-17.2 30.2-32.3 36-4.6 1.8-9.6 3.1-14.7 3.9v22.7H172v-23.5c-9.3-1.9-21.4-5.6-29.2-8-1.7-.5-3.3-1-4.5-1.4l-19.2-5.7 11.4-38.4c4.9 1.4 9.8 3.1 14.9 4.7 12.3 4 24.9 8.1 37.2 9.9 13.1 1.8 23.4.7 29.9-1.8 6.1-2.3 7-4.9 7.3-6.2.6-3.2-.4-4.6-3.2-6.3-10.6-6.8-23.1-9.9-35.6-13-12-2.9-24-5.9-34.5-12.2-6.5-3.9-13.3-9.6-17.8-18-4.7-8.7-5.7-18.5-3.8-28.3 3.5-18 17.5-29.3 31.8-35.1 4.8-1.9 9.9-3.4 15.2-4.4v-23.2h40zM96 96h96v32H80V96zm0 64h96v32H80v-32z" })
  }
), LH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h288V160H224V48H48zM48 0h208l128 128v384H0V0zm32 96h112v32H80zm0 64h112v32H80zm112 224h112v32H192zm112-160v128H80V224z" })
  }
), BH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM120 256H96v48h192v-48h-24zm0 96H96v48h192v-48h-24z" })
  }
), uH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h272v48H0V0h256l128 128v65.6c-19.8 20.2-32 47.9-32 78.4v16h-16V160H224V48H48zm416-224c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H352V320h32z" })
  }
), RH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm16 304c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l38.3 38.3 17 17 33.9-33.9-17-17-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), $H = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-96 224v64H96v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), kH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM120 288H96v48h192v-48h-24z" })
  }
), PH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm48 208v-23.1l-21.6 8.1-128 48-10.4 3.9v124.9c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V299.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V240z" })
  }
), FH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h48v48H0V0h256l128 128v160h-48V160H224V48H48zm128-112h32c30.9 0 56 25.1 56 56s-25.1 56-56 56h-16v48h-32V352zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v48zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-48V352zm32 128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm80-128h80v32h-48v32h48v32h-48v64h-32V368z" })
  }
), TH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h212.3l-6.9 48H0V0h256l128 128v172.4l-48 48V160H224V48H48zm457-240.2 71 71-41.3 41.3-71-71zm-63.9 63.9 71 71L370.9 500 288 511.9l11.9-82.9 141.2-141.2z" })
  }
), AH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-40 200v-24h-48v64h-64v48h64v64h48v-64h64v-48h-64zm-88 184h-24v48h176v-48h-24z" })
  }
), DH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm-40 208h-48v72H96v48h72v72h48v-72h72v-48h-72v-48z" })
  }
), yH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM136 208h-24v208h48v-56h44c42 0 76-34 76-76s-34-76-76-76zm68 104h-44v-56h44c15.5 0 28 12.5 28 28s-12.5 28-28 28" })
  }
), bH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zM104 192H80v192h48v-64h24l-1 1 55 55-23 23-17 17 34 33.9 17-17 23-23 23 23 17 17 33.9-33.9-17-17-23-23 23-23 17-17-33.9-33.9-17 17-23 23-31.1-31.1c18.6-11.3 31.1-31.7 31.1-55 0-35.3-28.7-64-64-64zm72 80h-48v-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16" })
  }
), fH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h264.6c13.9 18 30.4 34.3 49.5 48H0V0h256l128 128v80.3l-48 18.6V160H224V48H48zm479.3-151.6L432 275.5v184.9c56.5-26.3 90.2-87 95.3-148M432 512c-96-32-144-130.1-144-216v-16.3L432 224l144 55.8V296c0 85.9-48 184-144 216" })
  }
), UH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 435.3V464H48V48h176v112h112v84.4l48-48V128L256 0H0v512h384v-85l-1.7 1.7zM152 304h-11.9l-3.4 11.4-20.6 68.6H80v32h59.9l3.4-11.4L160 349l16.7 55.6 3.4 11.4H209.9l4.4-8.8 11.6-23.2h12.2l11.6 23.2 4.4 8.8H288l.1-.1 82.8-11.9 141.2-141.3-71-71L299.9 333l-7.3 51h-18.7l-11.6-23.2-4.4-8.8h-51.8l-4.4 8.8-3 5.9-15.4-51.4-3.4-11.3H168zm424-105.2-71-71-41.3 41.3 71 71z" })
  }
), GH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 464v-2.4l48 37.8V512H128V196.9l48 37.8V464zm48-89.3 108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L128 76.6V0h256l128 128zm-48-37.3V160H352V48H176v65.9l288 223.6z" })
  }
), qH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176v112h112v304H48zM256 0H0v512h384V128zm-80 256v48h-64v-48zm-64 80h64v48h-64zm96 0h64v48h-64zm-16 80h112V224H80v192h96zm16-112v-48h64v48z" })
  }
), WH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M298.7 464 272 384H112l-26.7 80H48V48h176v112h112v304zM256 0H0v512h384V128zm0 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), EH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 464V160H224V48H48v416zM48 0h208l128 128v384H0V0zm32 256h160v48l64-32v128l-64-32v48H80z" })
  }
), OH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 464H112V352H64v160h384V128L320 0H64v240h48V48h176v112h112zM276.8 228.1l-22.2-38.9-20.1 40.1-45.5 91-25-37.6-7.2-10.7H0v48h131.2l40.8 61.3 23 34.4 18.5-37 43.9-87.9 9.8 17.1 6.9 12.1H352v-48h-50.1l-25.1-43.9z" })
  }
), IH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zM114.7 224H65.3l47.5 189.8 4.5 18.2H162.4l4.8-17.7 24.8-92 24.8 92 4.8 17.7H266.7l4.5-18.2L318.7 224h-49.4l-26 104-23.3-86.3-4.8-17.7h-46.4l-4.8 17.7-23.3 86.3-26-104" })
  }
), NH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h176v112h112v304zM256 0H0v512h384V128zm33.9 256L256 222.1l-17 17-47 47-47-47-17-17L94.1 256l17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), XH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h112v48H0V0h256l128 128v160h-48V160H224V48H48zm192-112h80v28.2l-2.1 3.7L263 480h57v32h-96v-28.2l2.1-3.7L281 384h-57v-32zm144 16v144h-32V352h32zm32-16h40c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v48h-32V368zm32 80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z" })
  }
), KH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V48h64v16h64V48h48v112h112v304zM256 0H0v512h384V128zM112 96v32h64V96h-48zm0 64v32h64v-32h-48zM80 416h128v-72l-32-120h-64L80 344zm48-80h48v32h-64v-32z" })
  }
), QH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 464V160H224V48H48v416zM48 0h208l128 128v384H0V0z" })
  }
), ZH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 368H144V48h176v80h80zm48-272L352 0H96v416h352v-48zM48 120V96H0v416h352v-48H48zm197.3 56v53.3H192v53.3h53.3V336h53.3v-53.3H352v-53.4h-53.3V176z" })
  }
), JH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 368h256V128h-80V48H144zM352 0l96 96v320H96V0h48zM48 96v368h304v48H0V96z" })
  }
), jH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 272 33.9 33.9 172.2 172.2L240 512l33.9-33.9 204.2-204.2L512 240l-33.9-33.9L305.9 33.9 272 0l-33.9 33.9L161 111 73 23 56 6.1 22.1 40 39 57l88 88-93.1 93.1zm161-93.1 30 30.1 17 17 33.9-34-17-17-30-30L272 67.9 444.1 240l-48 48H83.9l-16-16zM512 320l-55.7 97.4c-5.5 9.6-8.3 20.4-8.3 31.4 0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2 0-11-2.9-21.8-8.3-31.4z" })
  }
), YH = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.9 305.9 0 272l33.9-33.9L127 145 39 57 22 40 56 6.1 73 23l88 88 77.1-77.1L272 0l33.9 33.9 172.2 172.2L512 240l-33.9 33.9-204.2 204.2L240 512l-33.9-33.9L33.9 305.9zm127-127-93 93.1 16 16h312.2l48-48L272 67.9 194.9 145l30.1 30 17 17-34 33.9-17-17-30-30z" })
  }
), _H = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h160v32h96v48h-32v384h32v48H0v-48h32V80H0V32h96zM80 80v384h192V80zm496 48v192h-64v96H352V128zm-184 40v48h48v-48zm144 0h-48v48h48zM392 328v48h48v-48z" })
  }
), hV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 432h192V80H160v240zM112 80H48v88h64zm0 136H48v80h64zm0 128H48v88h64zM400 80v88h64V80zm64 136h-64v80h64zm0 128h-64v88h64zm0-312h48v448H0V32h48z" })
  }
), cV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m29.4.1 19 14.7L70.5 32H576v392.4l44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1zM176 113.9V80h-43.6zM328.2 232H416V80H224v71.1zM528 387.2V344h-55.6zm-112 36.6 71.4 56.2H64V146.4l88.3 69.6H112v80h64v-61.3l57.5 45.3H224v152h192zM176 344h-64v88h64zM464 80v88h64V80zm64 136h-64v80h64z" })
  }
), sV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 432H160V280h192v40zm0-200H160V80h192v112zM48 80h64v88H48zm0 136h64v80H48zm64 216H48v-88h64zm288-264V80h64v88zm0 48h64v80h-64zm0 128h64v88h-64zM512 32H0v448h512V80z" })
  }
), vV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 264v-32h160v104H256zm0-80V80h160v104zM440 32H96v352h480V32H464zM144 80h64v48h-64zm0 96h64v64h-64zm0 112h64v48h-64zm384 48h-64v-48h64zm0-96h-64v-64h64zm0-112h-64V80h64zm-480-8V96H0v384h480v-48H48z" })
  }
), eV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 254.4v74.5l32.5 26c-.3 4.3-.5 8.7-.5 13.1 0 19.2 3.1 37.7 8.8 55L176 352v-80L0 64V0h544v64L435.7 192H432c-25.8 0-50.2 5.5-72.3 15.5L494.7 48H49.3l163.3 193zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1-15.4-3.9c-5.6-1.4-11.6-2.7-17.9-3.7V272h-32v25.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8-9.6 30.8 15.3 4.8c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v27.4h32v-26.9c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z" })
  }
), lV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 254.4v74.5l32.5 26c-.3 4.3-.5 8.7-.5 13.1 0 19.2 3.1 37.7 8.8 55L176 352v-80L0 64V0h544v64L435.7 192H432c-25.8 0-50.2 5.5-72.3 15.5L494.7 48H49.3l163.3 193zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7z" })
  }
), tV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 232v-19.9L137.9 198l-86-86h248.2L214 198.1l-14 14v150.3l-48-29.3zM0 64v64l104 104v128l96 58.7 48 29.3V232l104-104V64H48zm384 8v48h128V72H408zm-40 160h-24v48h192v-48h-24zm0 160h-24v48h192v-48h-24z" })
  }
), wV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-212.6-165.1L576 96V32H70.5zm84 65.2h394.3L370.3 264.7zM288 360.9v-38l-48-37.8V384l112 89.6 48 38.4V411.2l-48-37.8v38.8L288 361z" })
  }
), gV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 286.4v74.5l64 51.2V286.4l11.4-13.4L462.7 80H49.3l163.3 193zM0 80V32h512v64L336 304v208l-48-38.4L176 384v-80L0 96z" })
  }
), iV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 272v-17.1l-10.9-13.3L240.9 80h350.2L458.9 241.6 448 254.9V380.1l-64-51.2zM192 32v64l144 176v80l112 89.6 48 38.4V272L640 96V32H240zm112 251.4-9.5-11.6-27.6 33.8-10.9 13.3V412.1l-64-51.2v-42l-10.8-13.3L48.9 144h141l-22.7-27.7-7.2-8.8V96H0v64l144 176v48l112 89.6 48 38.4V336z" })
  }
), mV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5l15.6 18.2 36.4-31.3-15.6-18.2C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256v64h48v-24zm458.5-52.9-4.9-23.5-47 9.9 4.9 23.5c2.9 13.9 4.5 28.3 4.5 43.1v64h48V256c0-18.1-1.9-35.8-5.5-52.9M256 80c-32.3 0-62.5 8.7-88.5 23.8l32 37.3c17.1-8.4 36.3-13.1 56.6-13.1 70.7 0 128 57.3 128 128v24.9c0 34.6-2.8 69.1-8.4 103.1h48.6c5.2-34 7.8-68.5 7.8-103.1V256c0-97.2-78.8-176-176-176zm-126.3 53.5C98.9 165.2 80 208.4 80 256v24.9c0 35-5.5 69.8-16.2 103.1h50.1c9.3-33.5 14.1-68.2 14.1-103.1V256c0-33 12.5-63.2 33.1-85.9l-31.4-36.7zM256 160c-53 0-96 43-96 96v24.9c0 46-7.6 91.6-22.5 135.1h46.3c13.4-43.7 20.3-89.2 20.3-135.1V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 45.6-5.5 91-16.4 135.1h45.2c10.1-44.2 15.2-89.5 15.2-135.1V256c0-53-43-96-96-96zm24 96h-48v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3-3.3 8.6h51.4l2.6-6.7A536.19 536.19 0 0 0 280 280.9z" })
  }
), aV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353 64.1c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160S288 .1 288 .1s32.6 26.4 65 64zM370 273c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15M32 256h96v48H80v80h480v-80h-48v-48h96v128h32v128H0V384h32V280zm320 192c0 5.8-1.6 11.3-4.3 16h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16h-72.6c2.7 4.7 4.3 10.2 4.3 16m128 0c0 5.8-1.6 11.3-4.3 16H592v-32H475.7c2.7 4.7 4.3 10.2 4.3 16m-315.7-16H48v32h116.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16m55.4 0c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16z" })
  }
), oV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 0v56h88V32L512 0v160l-224-32v-24h-88v26.6c50.3 11 88 55.8 88 109.4v272H64V240c0-53.6 37.7-98.4 88-109.4v-25.7c-46.9 5.5-86.5 34.8-106.3 75.6l-43.1-21C30.1 102.8 86.1 62.4 152 56.7V0zm-88 464h128v-48H112zm0-224v128h128V240c0-35.3-28.7-64-64-64s-64 28.7-64 64" })
  }
), nV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 192.1C26.9 224.4 0 276.5 0 332.2 0 431.5 80.5 512 179.8 512h21.8C302.3 512 384 430.3 384 329.5c0-67.2-28.4-131.3-78.1-176.5l-82.2-74.7c-5.3-4.8-9.4-10.8-12.1-17.3-2.4-5.7-3.6-11.9-3.6-18.3V0l-29.1 25.9c-5.9 5.2-11.1 10.8-15.9 16.9l-3 3.9c-9.2 12.7-15.9 27-19.9 42.1-2.8 10.5-4.2 21.4-4.2 32.5 0 13.2 2 26.2 6 38.7 3.6 11.3 8.8 22.2 15.5 32.2L168 208l22.7 34.1c6.1 9.1 9.3 19.7 9.3 30.7V288c0 22.1-17.9 40-40 40s-40-17.9-40-40V160l-23.4 15.6-19.9 13.3c-1.6 1.1-3.2 2.2-4.7 3.3zm0 66.7V288c0 48.6 39.4 88 88 88s88-39.4 88-88v-15.3c0-20.4-6-40.3-17.3-57.3l-33.3-49.9c-8.7-13.1-13.4-28.5-13.4-44.2 0-4.6.4-9.2 1.2-13.7 2 2.2 4 4.2 6.2 6.2l82.2 74.7c39.7 36.1 62.4 87.3 62.4 141 0 74.3-60.2 134.5-134.5 134.5h-21.7C107 464 48 405 48 332.2c0-26.8 8.6-52.4 24-73.4z" })
  }
), rV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.9 9.7 192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3 7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM56 274.4c-5.3 14.5-8 30.2-8 45.8C48 398.8 113.3 464 192 464s144-65.2 144-143.8c0-15.6-2.7-31.2-8-45.8-28.9-79.4-75.4-151.1-136-209.7C131.4 123.3 84.9 195 56 274.4M281.7 290a73.3 73.3 0 0 1 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1L192 176l18 15.7c30.3 26.5 54.5 59.3 70.8 96.1l.9 2.1z" })
  }
), dV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.9 9.7 192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3 7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM56 274.4c-5.3 14.5-8 30.2-8 45.8C48 398.8 113.3 464 192 464s144-65.2 144-143.8c0-15.6-2.7-31.2-8-45.8-28.9-79.4-75.4-151.1-136-209.7C131.4 123.3 84.9 195 56 274.4M205.7 160v14.4c0 11.3 4.4 22.2 12.3 30.2l40.3 41.1c19 19.4 29.6 45.5 29.6 72.6v1.7c0 53-43 96-96 96s-96-43-96-96v-4.6c0-22.3 10.3-43.4 27.9-57.1l13.3-10.3v50.3c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7v-1.5c0-10.2-3.9-19.9-11-27.3l-14.2-14.7c-10.2-10.6-16-24.8-16-39.6 0-17 7.6-33 20.6-43.9z" })
  }
), SV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32V0h-64v36c-45 11.6-80.4 47-92 92H32v48h320v-48h-36c-11.6-45-47-80.4-92-92zm-32 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112M56 464H32v48h320v-48h-32v-80h48V256h-48v-48h-48v256H112V208H64v48H16v128h48v80z" })
  }
), zV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353 64.1c17.2-19.5 31-32 31-32s96 86.4 96 160c0 27.9-7.1 54.1-19.7 76.9l-23 6.2c-12.3-13.3-26.9-24.5-43.1-33 8.1-20.4 7.1-44.6-4.2-65.2-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 11.9 2.1 22.7 6 32.1-16.3 8.5-31 19.8-43.3 33.1l-23-6.2c-12.5-22.8-19.7-49-19.7-76.9 0-88.4 128-192 128-192s32.6 26.4 65 64M640 512H0V400c0-9.6 1.2-19.3 3.8-29 16-59.7 77.4-95.2 137.2-79.2l73.5 19.7C237.6 278 276.2 256 320 256s82.4 22 105.5 55.5l73.5-19.7c59.7-16 121.2 19.4 137.2 79.2 2.6 9.7 3.8 19.4 3.8 29zM96 464h495.9v-64c0-5.4-.7-11-2.2-16.6-9.1-34.1-44.2-54.4-78.4-45.3l-73.5 19.7-32.7 8.8-19.1-27.9c-14.5-21.1-38.6-34.7-66-34.7s-51.5 13.7-66 34.7l-19.2 27.9-32.7-8.8-73.5-19.7c-34.1-9.1-69.2 11.1-78.4 45.3C48.7 389 48 394.6 48 400v64z" })
  }
), pV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M227.2 119.4c-9.9-12.4-30-32.8-49.4-51.6l-1.8-1.7c-14.7 14.8-32.7 34.3-50.7 56.6-20.7 25.6-40.5 54.1-55 83C55.8 234.8 48 261.6 48 284.5 48 386.3 125.6 464 224 464c97.2 0 176-77.8 176-179.5 0-41.7-25.6-90.4-58.3-133.7-11.3-14.9-22.6-28.1-32.5-38.9-1.9 1.8-3.4 3.3-4.6 4.6-1.3 1.3-1.8 2-1.9 2.1l-37.3 48.7-38.3-47.9zM0 284.5C0 152 176 0 176 0s29.4 27 55.9 53.8c12.8 12.9 24.9 25.8 32.7 35.6 6.8-8.9 23.5-23.3 35.1-32.9 7.1-5.8 12.3-9.9 12.3-9.9S448 168 448 284.5C448 412.2 348.2 512 224 512 98.4 512 0 412.1 0 284.5M225.7 416C162.6 416 112 375.4 112 306.8c0-33.6 21.1-63 63.2-114.8 5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8 25.3 46.2 14 105-28.1 134.4-21.1 14-43.5 21-68.8 21z" })
  }
), MV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 48v32H48V48zM48 0H0v128h32v384h128V368c0-88.4 71.6-160 160-160s160 71.6 160 160v144h128V128h32V0h-48zm512 128v336h-32v-96c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80V128zM296.6 256.1s-93.1 75.4-93.1 139.6 52.1 116.4 116.4 116.4S436.3 460 436.3 395.7c0-53.6-69.8-116.4-69.8-116.4s-10.1 9.1-22.6 23.2c-23.5-27.3-47.2-46.5-47.2-46.5zm24 209.3c-32.7 0-58.9-21.1-58.9-56.7 0-17.5 10.9-32.7 32.7-59.6 2.9 3.6 45.1 57.5 45.1 57.5l26.2-30.6c2.2 2.9 3.6 5.8 5.1 8.7 13.1 24 7.3 54.5-14.5 69.8-10.9 7.3-22.5 10.9-35.6 10.9z" })
  }
), xV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96 0 128l64 128L0 384l32 32 64-64v-72h40v96h48v-96h48v96h48v-96h48v96h48v-96h40v120h32l16-18 112-126-112-126-16-18h-32v120h-40v-96h-48v96h-48v-96h-48v96h-48v-96h-48v96H96v-72zm432 106.2 47.8 53.8-47.8 53.8z" })
  }
), HV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m101.4 200.4 30.5 15.3 24.4-23.8c46.2-45 110.8-79.9 163.7-79.9 68.9 0 120.8 37.2 157.9 79.6 18.4 21 32.1 42.2 41.2 58.1 1.2 2.2 2.4 4.3 3.5 6.2-1.1 2-2.2 4.1-3.5 6.2-9.1 16-22.8 37.2-41.2 58.1-37.1 42.6-89 79.8-157.9 79.8-56.9 0-126.7-40.3-172.3-88.7l-27.2-28.9L87 303.7l-22.9 14.6 14-49.1 3.8-13.2-3.8-13.2-18-63.1zM320 64c-70.4 0-146.4 44.1-197.1 93.5L48 120 0 96v48l1.9 6.6L32 256 3.1 357.1 0 368v48l48-30.5 64.8-41.2C163.1 397.6 244.7 448 320 448c176 0 256-192 256-192S496 64 320 64m-4.7 107.3 11.3-11.3-22.6-22.6-11.3 11.3-64 64-11.3 11.3 22.6 22.6 11.3-11.3 64-64zm112 16 11.3-11.3-22.6-22.6-11.3 11.3-160 160-11.3 11.3 22.6 22.6 11.3-11.3zm16 112 11.3-11.3-22.6-22.6-11.3 11.3-64 64-11.3 11.3 22.6 22.6 11.3-11.3z" })
  }
), VV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272 32 73.4 64.2C499.1 102.2 576 256 576 256s-76.9 153.8-230.6 159.8L272 480l-48-32v-60.6c-27.5-14.8-50.5-33.7-69.1-52.5L32 384 0 352l48-96-48-96 32-32 118.7 53.4c19.3-20.2 43.7-40.8 73.3-56.8V64zm212.3 268.3c15.7-16 27.7-31.9 36.1-44.3-8.3-12.3-20.4-28.3-36.1-44.3-33.6-34.2-80.4-65.5-140.8-67.9l-16.8-.7-12.7-11-42.3-37v58.1l-25 13.5c-24.2 13-44.7 30.3-61.5 47.8l-23.3 24.3-30.7-13.8-58.6-26.5 18.1 36.1 10.6 21.4-10.7 21.3-19.9 39.9 66.4-26.6 29.3-11.7 22.2 22.5c16.1 16.3 35.5 32 57.9 44.1l25 13.5v58.1l42.3-37 12.7-11.1 16.8-.7c60.4-2.4 107.3-33.7 140.8-67.9zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64m117.4 10.6v.1zm0 42.8v.1z" })
  }
), CV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m132 219.4 31.6 12.6 22.2-25.8c35.7-41.3 85.7-78.6 150.2-78.6 61.2 0 109.3 33.5 144.7 72.4 17.4 19.2 30.7 38.5 39.5 53.1.6 1 1.1 1.9 1.7 2.8-.5.9-1.1 1.8-1.7 2.8-8.9 14.6-22.1 34-39.5 53.1-35.4 38.9-83.6 72.4-144.7 72.4-64.4 0-114.5-37.2-150.2-78.6L163.6 280 132 292.6l-61.3 24.6 19.9-39.8 10.7-21.4-10.7-21.3-19.9-39.9zM336 432c160 0 240-176 240-176S496 80 336 80c-84.3 0-146.4 48.9-186.3 95.1L32 128 0 160l48 96-48 96 32 32 117.7-47.1c39.9 46.2 102 95.1 186.3 95.1m80-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), LV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M284.6 0H376v160h-48V48h-36.6L88 106.1V288h40v224H0V288h40V69.9l17.4-5 224-64 3.2-.9zM80 336H48v128h32zm176 8c0-76.8 64-136 96-152 32 16 96 75.2 96 152 0 32-16 80-64 112l32 40v16H288v-16l32-40c-48-32-64-80-64-112m128-32a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), BV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0v52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0L400 40l48-24v352l-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L48 388v124H0V0zm0 150.7 80-17.4V81.5l-80 20v49.3zm0 49.1v46.9l80-17.4v-46.8l-80 17.4zm0 96v42.7l68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5v-40.3l-80 17.4zm128 18.8c33.1.7 65.9 8.7 96 23.7v-49.8l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v46m144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1V288l-25.7 6c-17.9 4.1-36.1 5.5-54.3 4.3v53.5zm80-113V192l-25.7 6c-17.9 4.1-36.1 5.5-54.3 4.3v47.8c14.5 1.4 29.2.4 43.5-2.9l36.5-8.4zm0-96V92.9c-25.6 10.4-52.8 15.6-80 15.6V154c14.5 1.4 29.2.4 43.5-2.9l36.5-8.4zm-128-39.5c-16.1-3.7-31.9-9.4-47-16.9-15.3-7.7-32.1-11.8-49-12.3v50.6c18.2-1.3 36.5.6 54.1 5.8l41.9 12.2zm0 89.5-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v47.8c18.2-1.3 36.5.6 54.1 5.8l41.9 12.2v-46z" })
  }
), uV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v512h48V350.7l334.9-132.9L448 192l-65.1-25.8L48 33.3zm0 60.9L317.9 192 48 299.1z" })
  }
), RV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v512h48V352h400l-28.8-48L352 192l67.2-112L448 32H48zm0 56h315.2l-52.4 87.3L296 192l14.8 24.7 52.4 87.3H48z" })
  }
), $V = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0v52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0L400 40l48-24v368l-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L48 404v108H0V0zm0 252.9 68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7v-52.8c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2v46.7zm128-179v60.7c18.8.6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4V93c-56.4 22.9-120.2 20.6-175-6.8-15.3-7.7-32.1-11.8-49-12.3m224 231.5c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2v52.4l68.6-17.2c52.2-13.1 107.4-7 155.6 17.1 32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1zM96 104a16 16 0 1 0-32 0 16 16 0 1 0 32 0m32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0m32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), kV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v512h48V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4L448 368V16l-48 24-6.4 3.2c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L48 52zm0 77.5 96.6-24.2c27-6.7 55.5-3.6 80.4 8.8 54.9 27.4 118.7 29.7 175 6.8v241.8l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5z" })
  }
), PV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m413.8 314.4-13-10.4H48v-96h352.8l13-10.4.2-.2c.3-.2.9-.7 1.8-1.3 1.8-1.3 4.6-3.3 8.5-5.8 7.7-5 19.3-11.9 34.1-18.8 15.2-7.1 33.2-14.1 53.6-19.3v207.6c-20.3-5.1-38.4-12.1-53.6-19.3-14.7-6.9-26.3-13.8-34.1-18.8-3.9-2.5-6.7-4.5-8.5-5.8-.9-.6-1.5-1.1-1.8-1.3l-.2-.2zM576 368c-5.4 0-10.8-.2-16-.5v-223c5.2-.3 10.6-.5 16-.5h16v224zm16-272h-16c-112 0-192 64-192 64H0v192h384s80 64 192 64h64V96zM248 232h-24v48h96v-48h-24z" })
  }
), FV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 228.5V48h-96v180.5l-7.1 11.6L100 352h225.5l-35.6 20.5L360 493.8V512H0v-89.1l128-208V48H96V0h256v48h-32v166.9l19 30.9-27.3 47.3-32.6-53zm164-22.1h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497h-88v-42.2c-8-3.4-15.6-7.7-22.5-12.9L378.6 462l-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9v-42.2zm92.1 145.3a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0" })
  }
), TV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 196.5V48h96v148.5l25.8 13.5c51.3 26.7 86.2 80.3 86.2 142 0 43.6-17.4 83.1-45.7 112H109.7C81.4 435.1 64 395.6 64 352c0-61.7 34.9-115.3 86.2-142zm144-29.1V48h32V0H96v48h32v119.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160h265.8c45.9-38.2 75.1-95.7 75.1-160 0-80.2-45.4-149.9-112-184.6M312 328c0-39.8-39.4-72-88-72s-88 32.2-88 72c0 22.4 12.5 42.3 32 55.5V416h112v-32.5c19.5-13.2 32-33.2 32-55.5m-120-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), AV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 196.5V48h96v148.5l25.8 13.5c51.3 26.7 86.2 80.3 86.2 141.9-64.4-.9-94.8-12.3-122.5-22.7-23.8-9-45.7-17.2-85.5-17.2-55.8 0-92.3 16.1-111.5 27.9 4.2-56.5 37.8-104.9 85.7-129.9zm144-29.1V48h32V0H96v48h32v119.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160h265.8c45.9-38.2 75.1-95.7 75.1-160 0-80.2-45.4-149.9-112-184.6" })
  }
), DV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h32v48h-32v261.9l-59.3 96.3-4.7 7.7V442.6c-10 3.5-20.8 5.5-32 5.5-53 0-96-43-96-96V48H0V0h176zm-32 422.9 29-47.2c-.4 1.4-.7 2.8-1.2 4.1L320 217.2V48h-32V0h256v48h-32v169.2l124.4 202.2 3.6 5.8V512H192v-86.8l2.4-3.8c-.8.7-1.6 1.5-2.4 2.2v-.6zM80 48v112h96V48zm0 160v144c0 26.5 21.5 48 48 48s48-21.5 48-48V208zM464 48h-96v182.8l-3.6 5.8-51.3 83.4h205.8l-51.3-83.4-3.6-5.8V48zM240 438.8V464h352v-25.2L548.4 368H283.6z" })
  }
), yV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 214.9V48h-96v180.5l-7.1 11.6-49.2 79.9h208.6l-49.2-79.9-7.1-11.6zM320 48v166.9l128 208V512H0v-89.1l128-208V48H96V0h256v48h-24z" })
  }
), bV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M346.6 53.2 255.9 3.4l-70.8 75.4L83.6 98.9l-5.8 103.3L13 282.9l62 82.8.5 25.5 58.3-58.2c-13.7-19.5-21.8-43.3-21.8-69 0-66.3 53.7-120 120-120 25.7 0 49.5 8.1 69 21.8L422.5 44.2zM232 176c-48.6 0-88 39.4-88 88 0 16.8 4.7 32.5 12.9 45.9l121-121c-13.4-8.2-29.1-12.9-45.9-12.9m228.7-56.8c55.6 86.7 45.5 203.4-30.3 279.2s-192.5 85.9-279.2 30.3l309.5-309.5zm-381 313.1c11.6 11.6 23.9 21.9 36.9 31 106.1 74 253.1 63.7 347.7-31s105-241.7 31-347.7c-9.1-13-19.4-25.3-31-36.9l-33.9 33.9-316.8 316.8zM296 400a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), fV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m177 113-34-34 192-192 34 34zm64-224-96 96-34-34 96-96zm64 256-34-34 96-96 34 34z" })
  }
), UV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 480H0V32h336l112 112v48.7c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9v-31l-80-80V208H80V80H48v352h220c6.9 17.5 16.4 33.7 28.2 48zm176-224c22.1 0 41.6 11.2 53.1 28.3-13.4 24.9-21.1 53.4-21.1 83.7 0 2.5.1 4.9.2 7.4-9.4 5.5-20.4 8.6-32.2 8.6-35.3 0-64-28.7-64-64s28.7-64 64-64M128 80v80h144V80zm160 288a144 144 0 1 1 288 0 144 144 0 1 1-288 0m152-78.6L417.4 312l11.3 11.3 28.7 28.7H352v32h105.4l-28.7 28.7-11.3 11.3 22.6 22.6 11.3-11.3 56-56 11.3-11.3-11.3-11.3-56-56z" })
  }
), GV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 480H0V32h336l112 112v48.7c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9v-31l-80-80V208H80V80H48v352h220c6.9 17.5 16.4 33.7 28.2 48zm176-224c22.1 0 41.6 11.2 53.1 28.3-13.4 24.9-21.1 53.4-21.1 83.7 0 2.5.1 4.9.2 7.4-9.4 5.5-20.4 8.6-32.2 8.6-35.3 0-64-28.7-64-64s28.7-64 64-64M128 80v80h144V80zm304 144a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7z" })
  }
), qV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 480h258l6.9-48H48V80h32v128h240V83.9l80 80v120.5l48-48V144L336 32H0v400zm128-320V80h144v80zm96 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128m281-160-41.3 41.3 71 71 41.3-41.4-71-71zm-63.9 63.9L299.9 429.1 288 512l82.9-11.9 141.2-141.2z" })
  }
), WV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 480H0V32h336l112 112v336h-48zm352-48V163.9l-80-80V208H80V80H48v352zM128 80v80h144V80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), EV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 416h416V112L400 0H96v368zm80-368v96h208V51.9l80 80V368H144V48zm160 0v48H224V48zM48 120V96H0v416h416v-48H48zm320 136a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), OV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224H32v48h127.8l-54 134.9C99.7 422 85 432 68.7 432H0v48h68.7c36 0 68.3-21.9 81.7-55.3l61-152.7H352v-48H230.6l47.5-118.9C284.3 90 299 80 315.3 80H384V32h-24z" })
  }
), IV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 82.4 30.6-25.2c6.9-5.7 15.7-9.1 25.4-9.1 22.1 0 40 17.9 40 40 0 9.7-3.4 18.5-9.1 25.4L317.6 144l25.2 30.6c5.7 6.9 9.1 15.7 9.1 25.4 0 22.1-17.9 40-40 40-9.7 0-18.5-3.4-25.4-9.1L256 205.6l-30.6 25.2c-6.9 5.7-15.7 9.1-25.4 9.1-22.1 0-40-17.9-40-40 0-9.7 3.4-18.5 9.1-25.4l25.3-30.5-25.2-30.6c-5.7-6.9-9.1-15.7-9.1-25.4 0-22.1 17.9-40 40-40 9.7 0 18.5 3.4 25.4 9.1zM379.9 144c12.6-15.2 20.1-34.7 20.1-56 0-48.6-39.4-88-88-88-21.3 0-40.8 7.5-56 20.1C240.8 7.5 221.3 0 200 0c-48.6 0-88 39.4-88 88 0 21.3 7.5 40.8 20.1 56-12.6 15.2-20.1 34.7-20.1 56 0 48.6 39.4 88 88 88 11.3 0 22.1-2.1 32-6v91.4c-41-52-104.6-85.4-176-85.4H0c0 16.5 1.8 32.5 5.2 48C27.1 436.6 116.8 512 224 512h64c107.2 0 196.9-75.4 218.8-176 3.4-15.5 5.2-31.5 5.2-48h-56c-71.4 0-135 33.4-176 85.4V282c9.9 3.9 20.7 6 32 6 48.6 0 88-39.4 88-88 0-21.3-7.5-40.8-20.1-56M225.4 464H224c-80.6 0-148.5-54.1-169.4-128H56c80.6 0 148.5 54.1 169.4 128m61.2 0c20.9-73.9 88.8-128 169.4-128h1.4c-20.9 73.9-88.8 128-169.4 128zM256 184l40-40-40-40-40 40z" })
  }
), NV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M282.5 110 256 76.8 229.5 110 202 144.3l-36.6-24.4-21.4-14.2V160c0 44.2 35.8 80 80 80h64c44.2 0 80-35.8 80-80v-54.3l-21.4 14.2-36.6 24.4zM232 288h-8c-70.7 0-128-57.3-128-128V16l48 32 48 32 33.3-41.6L256 0l30.7 38.4L320 80l48-32 48-32v144c0 70.7-57.3 128-128 128h-8v85.4c41-52 104.6-85.4 176-85.4h56c0 16.5-1.8 32.5-5.2 48C484.9 436.6 395.2 512 288 512h-64C116.8 512 27.1 436.6 5.2 336 1.8 320.5 0 304.5 0 288h56c71.4 0 135 33.4 176 85.4zM56 336h-1.4c20.9 73.9 88.8 128 169.4 128h1.4C204.5 390.1 136.6 336 56 336m400 0c-80.6 0-148.5 54.1-169.4 128h1.4c80.6 0 148.5-54.1 169.4-128z" })
  }
), XV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192.9 100.9C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88 0 21.8 7.8 41.6 20.9 56.9L95.3 256l-26.4 31.1C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88 21.8 0 41.6-7.8 56.9-20.9l31.1-26.4 31.1 26.4c15.3 13.1 35.1 20.9 56.9 20.9 48.6 0 88-39.4 88-88 0-21.8-7.8-41.6-20.9-56.9L352.7 256l26.4-31.1c13.1-15.3 20.9-35.1 20.9-56.9 0-48.6-39.4-88-88-88-21.8 0-41.6 7.8-56.9 20.9L224 127.3zM448 168c0 33.6-12.2 64.3-32.3 88 20.1 23.7 32.3 54.4 32.3 88 0 75.1-60.9 136-136 136-33.6 0-64.3-12.2-88-32.3-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168 0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136M224 352l-33.9-33.9L162 290l-34-34 33.9-33.9L190 194l34-34 33.9 33.9L286 222l34 34-33.9 33.9L258 318zm0-67.9 28.1-28.1-28.1-28.1-28.1 28.1z" })
  }
), KV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 304v-96h448v96zm-48 0H48v-96h48zm24-144H0v192h640V160H144zm200 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), QV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm235.3 221.3c6.6 1.8 13.6 2.7 20.7 2.7 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49L87.4 176l56.6-56.6 28.3 28.3 51.7 51.7 51.7-51.7 28.3-28.3 56.6 56.6-28.3 28.3zm-102.9 15.6c-21.9 14.3-36.4 39-36.4 67.1 0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6V376h-80V272.6l-3.6-3.6zm-25.1-104.2L144 153.4 121.4 176l11.3 11.3 75.3 75.3V352h32v-89.4l75.3-75.3 11.3-11.3-22.6-22.6-11.3 11.3-68.7 68.7z" })
  }
), ZV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M486.4 89.6c7.9 7.9 16.9 31.4.6 80.4-15.3 45.9-49.5 101-100.7 152.2S279.9 407.6 234 422.9c-49 16.3-72.5 7.3-80.4-.6-5.6-5.6-11.8-19.2-9-44.3 19.9 19.2 45.3 20.8 62.5 18.9 18.1-2 36.3-8.8 52.8-17 33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8 1.9-17.2.3-42.6-18.9-62.5 25.1-2.8 38.7 3.3 44.3 9zm-285.2 85.8c-96.9 106.5-133.6 228.8-81.5 280.9 55.3 55.3 189.8 10.5 300.5-100.2S575.6 111 520.3 55.7c-52.1-52.1-174.4-15.4-280.8 81.4-6.6 6-13.2 12.2-19.7 18.7s-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8s11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1 21.4 21.4-12.7 90.1-76.1 153.4S199 364.5 177.7 343.2c-19.4-19.4 6.8-77.7 59.1-135.6z" })
  }
), JV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm8 56v102.1l31-31 17-17 33.9 33.9-17 17-72 72-17 17-17-17-72-72-17-17 34.1-33.9 17 17 31 31V176h48z" })
  }
), jV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm8 232v24h-48V273.9l-31 31-17 17-33.9-33.9 17-17 72-72 17-17 17 17 72 72 17 17-34.1 33.9-17-17-31-31z" })
  }
), YV = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm192 112v176l-80-56-80 56V144h-8l-14.4-19.2L200 80H48v352h416V144z" })
  }
), _V = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v112h416v-48zM48 240v192h416V240z" })
  }
), hC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm12 32v32.8c9.8 3.5 18.8 8.7 26.6 15.4l28.4-16.5 28 48.5-28.4 16.4c.9 5 1.4 10.1 1.4 15.4s-.5 10.4-1.4 15.4l28.4 16.3-28 48.5-28.4-16.4c-7.8 6.6-16.8 11.9-26.6 15.4V400h-56v-32.8c-9.8-3.5-18.8-8.7-26.6-15.4L173 368.2l-28-48.5 28.4-16.4c-.9-5-1.4-10.1-1.4-15.4s.5-10.4 1.4-15.4L145 256.2l28-48.5 28.4 16.4c7.8-6.6 16.8-11.9 26.6-15.4V176zm7 112a35 35 0 1 0-70 0 35 35 0 1 0 70 0" })
  }
), cC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm-96 96v96H80v-96zm32 0h96v96h-96zm224 0v96h-96v-96z" })
  }
), sC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zM144 251.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L267 373.5l-11 10.6-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z" })
  }
), vC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm-144 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M96 384v-32l88-96 37.7 41.1L296 208l120 144v32H176z" })
  }
), eC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm64 128c0 17.8-4.9 34.5-13.3 48.9l38.3 38.3 17 17-34 33.9-17-17-38.4-38.4c-14.2 8.5-30.8 13.3-48.6 13.3-53 0-96-43-96-96s43-96 96-96 96 43 96 96m-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), lC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm-48 48h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), tC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm-88 128h168v48H160v-48z" })
  }
), wC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm80 48v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V384c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V228.9l10.4-3.9 128-48 21.6-8.1z" })
  }
), gC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272 96-64-64H0v448h448l128-256H128L48 384V80h140.1l49.9 49.9 14.1 14.1H432v48h48V96h-48z" })
  }
), iC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm-40 256v-88h-88v-48h88v-88h48v88h88v48h-88v88z" })
  }
), mC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v448h256v-48H48V160h208v-48H48zm364.1 56H528v96H336V48h44.1L398 65.9zM528 32h-96L400 0H288v224h288V32zM412.1 368H528v96H336V336h44.1l17.9 17.9zM528 320h-96l-32-32H288v224h288V320z" })
  }
), aC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h101.3l26.7-80h160l26.7 80H464V144zm-80 112a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), oC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 32 48 64h240v384H0V32h48zm48 112h-24l-14.4-19.2L200 80H48v352h416V144zm81.9 80-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), nC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272 96-48-64H0v448h512V96h-48zm192 48v288H48V80h152l33.6 44.8L248 144h24z" })
  }
), rC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 32H96v352h480V96H368zm64 112h160v192H144V80h140.1l49.9 49.9 14.1 14.1zM48 120V96H0v384h480v-48H48z" })
  }
), dC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m379.6 163.5-19 28.5h-38.5l30.8-46.2-13.3-8.9L430.9 0l53.3 35.5-91.3 136.9-13.3-8.9zM264.5 192h-33l9.2-36.8-15.5-3.9L263 0l62.1 15.5-37.8 151.3-15.5-3.9zM192 272v48h-48v-48h-16v80H80v-80H48v48c0 61.9 50.1 112 112 112h128c61.9 0 112-50.1 112-112v-48h-8zm256 0v48c0 52.3-25.1 98.8-64 128v64h-48v-39.3c-15.2 4.8-31.3 7.3-48 7.3H160c-16.7 0-32.8-2.6-48-7.3V512H64v-64C25.1 418.8 0 372.3 0 320v-96h512v48h-24z" })
  }
), SC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32v41.8c10.6-2.4 19.7-5.6 30.2-9.4 4.2-1.5 8.7-3.1 13.6-4.8 18.1-6.1 38.8-11.6 66.6-11.6 34.2 0 58.1 8.5 79 15.8l.6.2c20.5 7.2 37.9 13.3 63.6 13.3 25.8 0 39.5-4.7 81-19.2 7.6-2.6 16.1-5.6 25.7-8.9L448 38.4v338.8l-16.2 5.5c-8.9 3-17 5.9-24.4 8.5-41.4 14.5-63.4 22.2-97.8 22.2-34.2 0-58.2-8.5-79.1-15.9l-.5-.2c-20.6-7.3-38-13.3-63.6-13.3-12.8 0-23.4 1.5-32.9 3.7l-21.5 5.1v-49.3l10.5-2.5c12.9-3 27.1-5 43.9-5 34.2 0 58.1 8.5 79 15.8l.6.2c20.5 7.2 37.9 13.3 63.6 13.3 25.8 0 39.5-4.8 81-19.2l9.5-3.3V105.7c-36.8 12.8-58.1 19.6-90.5 19.6-34.2 0-58.2-8.5-79.1-15.9l-.5-.2C209.4 102 192 96 166.4 96c-20.8 0-36 3.9-51.2 9.1-3.3 1.1-6.8 2.4-10.4 3.7-12.7 4.6-27.5 9.9-44.2 13.1l-4.5.9V480H8V32z" })
  }
), zC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m153.4 48 5.6-16h34l5.6 16 152 432h-50.8l-39.4-112H91.6L52.2 480H1.3L153.4 48zm-44.9 272h135L176 128.3zM640 184v296h-48v-32.8c-22.1 20.4-51.6 32.8-84 32.8-68.5 0-124-55.5-124-124v-72c0-68.5 55.5-124 124-124 32.4 0 61.9 12.4 84 32.8V160h48zm-132 24c-42 0-76 34-76 76v72c0 42 34 76 76 76s76-34 76-76v-72c0-42-34-76-76-76" })
  }
), pC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m201.8 46.9 6.1-14.9h32.3l6.1 14.9L351.1 304h.9v2.1L403.4 432H448v48H288v-48h63.5l-32.7-80H129.1l-32.6 80H160v48H0v-48h44.6L96 306.1V304h.9L201.8 46.9zM148.7 304h150.6L224 119.5z" })
  }
), MC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m305 249.9-49 6.1 17.3 46.2L280 320h41.7l-13.2-70.6-3.5.4zm189.2-23.7-153.9 19.3 14 74.5H512v176H354.7l-2.4-13.1-13.5-72-11.1-58.9H292l7.7 20.5c2.9 7.6 4.3 15.7 4.3 23.8v1.3c0 36.7-29.7 66.4-66.4 66.4-9 0-17.9-1.8-26.1-5.4L112 416H77.1C39.1 373.5 16 317.5 16 256 16 123.5 123.5 16 256 16c105.7 0 195.4 68.3 227.4 163.2 5 14.9 8.6 30.4 10.6 46.4l.1.6zM100 368h21.9l9.1 3.9 99.5 42.6c2.3 1 4.8 1.5 7.2 1.5 10.1 0 18.4-8.2 18.4-18.4v-1.3c0-2.4-.4-4.7-1.3-6.9l-43.7-116.5-21.4-56.9 60.3-7.5 184.5-23.1C406.4 114.3 337.1 64 256 64 150 64 64 150 64 256c0 41.8 13.3 80.5 36 112m260.3-16 7.5 40H480v-40zM480 424H373.8l7.5 40H480zM176 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), xC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M66 153.6C5.8 251.8 6.9 378.3 24.4 463.1l4.4 21.5 21.6 3.6c103.9 17.4 187 11 252.6-13.3 66-24.5 112.2-66.5 142.9-116.5 60.2-98.2 59.1-224.7 41.6-309.5l-4.4-21.5-21.6-3.6c-103.9-17.4-187-11-252.6 13.3-66 24.5-112.2 66.5-142.9 116.5m376.6-84.2c4.9 27.5 7.8 58.5 7.3 90.6l-98-98c27.6.1 57.8 2.4 90.7 7.4m-217 12.7c18.8-7 39.6-12.3 62.8-15.8l156.1 156.1c-6.4 38.9-18.8 77.2-39.5 110.9-25.4 41.4-63.3 76-118.6 96.5-18.8 7-39.6 12.3-62.8 15.8l-156.1-156c6.4-38.9 18.8-77.2 39.5-110.9 25.4-41.4 63.3-76 118.6-96.5zM62.1 352l98 98c-27.6-.1-57.8-2.4-90.7-7.4-4.9-27.5-7.8-58.5-7.3-90.6M297 151l-17-17-33.9 34 17 17 64 64 17 17 33.8-34-17-17-64-64zm-56 56-17-17-33.9 34 17 17 64 64 17 17 33.8-34-17-17-64-64zm-56 56-17-17-33.9 34 17 17 64 64 17 17 33.8-34-17-17-64-64z" })
  }
), HC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 146.7 40 40v1.3c0 21.8 5 43.2 14.4 62.4l-9.3 9.3-79-79L52.8 75.4C49.9 84 48 93.6 48 104c0 22.5 12.9 51.6 47.7 94.1 25.9 31.6 59.3 65.3 98.6 104.4l-33.9 33.9C68.8 245.4 0 174.2 0 104c0-26 7.5-48 16.3-65 8.4-16 18-27.6 23.7-33.8C43.2 1.8 45.3 0 45.3 0zM489.4 512 316.3 338.9l9.3-9.3C344.8 339 366.2 344 388 344h1.3l134 134.1zm52.3-410.3L576 136l-96.8 129.1c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5-24.5 0-48.1-8.1-67.3-22.8L116.2 493.8l-17 17-33.9-34 17-17 204.5-204.5C272.1 236.1 264 212.5 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9L440 0l34.3 34.3-134.6 100.9c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188c0 16.4 6.4 32.2 17.9 44l14.1 14.1c11.7 11.5 27.5 17.9 44 17.9 16.7 0 32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4l100.9-134.6zM525 85l-4 4-116 116-17 17-33.9-34 17-17L487 55l4-4z" })
  }
), VC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 136-34.3-34.3-100.9 134.6c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264c-16.4 0-32.2-6.4-44-17.9L265.9 232c-11.5-11.7-17.9-27.5-17.9-44 0-16.7 6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4L410.3 34.3 376 0 246.9 96.8c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4 0 24.5 8.1 48.1 22.8 67.3L18.2 459.8l-17 17 33.9 33.9 17-17 204.6-204.5c19.2 14.7 42.8 22.8 67.3 22.8 29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6zm-55-47 4-4-34-34-4 4-116 116-17 17 34 33.9 17-17z" })
  }
), CC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0H96v160H0v256c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V235.3l-1.8-4.4-88-216L320.1 0H304zm120 240-96-68.6V48h143.9l78.2 192zm-15.4 48H368v33.3c-5.2-.9-10.5-1.3-16-1.3-35.5 0-66.6 19.3-83.2 48h-89.6c-16.6-28.7-47.6-48-83.2-48-17.5 0-33.9 4.7-48 12.8V208h64.6l99.5 71.1 12.5 8.9zM96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96m256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M528 24V0h-48v448h160v-48H528z" })
  }
), LC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 112H48v64h128v-64zm56 112v240h64v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V224H224zm304 240h64V224h-64zM144 224H80v240h64zm112 288H32V224H0V0h48v64h40V0h48v64h40V0h48v176h192V0h48v64h40V0h48v64h40V0h48v224h-32v288H384zm336-336v-64H464v64h96z" })
  }
), BC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64v158.1L272 97.9 224 64v158.2L48 97.9 0 64v384l48-33.9 176-124.2V448l48-33.9 176-124.2V448h48V64zM272 256v-99.4L412.8 256 272 355.4zm-83.2 0L48 355.4V156.6z" })
  }
), uC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 88V64h48v384h-48V309.6L64 418.4 16 448V64l48 29.6 176 108.8zm-4.5 168L64 150.1v211.8z" })
  }
), RC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M468.7 284.8 512 256l-43.3-28.8L272 96l-48-32v134.4L48 92.8 0 64v384l48-28.8 176-105.6V448l48-32zM224 257.6 48 363.2V148.8l176 105.6zm48 100.7V153.7L425.5 256z" })
  }
), $C = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 144V96h-64V32h-48v64H112V32H64v64H0v48h64v224H0v48h64v64h48v-64h224v64h48v-64h64v-48h-64V144zM112 368V144h224v224z" })
  }
), kC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 32H48v288H0v48h48v112h48V368h128v-48H96v-80h192v-48H96V80h224V32h-24z" })
  }
), PC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M97.4 221.4 64 32l48-32 16 90.7V272h-10.3zM59.7 192h-41L0 80l41.8 10.5zm305.6 0h-39.5l16.9-101.7L384 80zm-75.6 21.4L266.3 272H256V48l64-16-30.2 181.4zM224 272h-64V0l64 32v208zM64 224l32 80h192l32-80h64l-10.7 48L320 512H64L10.7 272 0 224h49.2zm224 128H77.6l24.9 112h179l24.9-112z" })
  }
), FC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m312.8 142.2-30.6 3.4C150.4 160.5 48 272.3 48 408v24h192l-1-1 56.8-56.8c10.4-10.3 16.2-24.4 16.2-39 0-30.5-24.7-55.2-55.2-55.2-14.6 0-28.7 5.8-39 16.2L169 345l-17 17-33.9-34 17-17 48.8-48.8c19.4-19.4 45.6-30.2 73-30.2 48.4 0 89 33.3 100.2 78.3l5.9-4.8 5.1-5.4.7.7 2.4-1.9c4.6-3.8 9.5-7.3 14.5-10.5L528 197.7v-18.2l-80-24.6-27.3-8.4-5.6-28C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33l-9.6 29.3zM576 224l-134 85.3-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.8 1.9 31 33.4 56.3 60.6H576v48H469.5l-7.1-7.7-7.1-7.7-23.3-25-7-7.6-24.3-26.2-16.7-17.9-3.6-3.9-12.5-13.4-12.5 13.4-20.3 21.8-24.2 26.2H384v48H0v-72C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66 46.5 0 85.3 33.1 94.1 77L576 144zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), TC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 0h152v48H120v144h72v48h-72v240H0v-48h72V240H0v-48h72V24zm200 320c0 57.5 16.4 110.9 44.3 155.2l-40.6 25.6C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8l40.6 25.6C288.4 209.1 272 262.5 272 320m320 0c0-57.5-16.4-110.9-44.3-155.2l40.6-25.6C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8l-40.6-25.6C575.6 430.9 592 377.5 592 320m-199-73 39 39 39-39 17-17 33.9 34-17 17-39 39 39 39 17 17-33.9 33.9-17-17-39-39-39 39-17 17-33.9-33.9 17-17 39-39-39-39-17-17 33.9-33.9 17 17z" })
  }
), AC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m412.4 118.9-34.7 97.6 85.4 58.5c-2.9 31.7-12.9 61.4-28.4 87.4l-103.5-2.8-29.3 99.4c-14.8 3.3-30.2 5.1-45.9 5.1s-31.2-1.8-45.9-5.1l-29.3-99.4-103.6 2.8c-15.5-26-25.5-55.7-28.4-87.4l85.4-58.5-34.6-97.6c20.3-23.1 45.6-41.7 74.3-54.1L256 128l82.1-63.2c28.7 12.3 54 30.9 74.3 54.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-336-76.1 55.3 29.1 89.4h94l29.1-89.4z" })
  }
), DC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152h-173v-48H448v24c0 123.7-100.3 224-224 224S0 379.7 0 256 100.3 32 224 32c66.7 0 126.7 29.2 167.7 75.5l-35.9 31.8C323.5 102.9 276.4 80 224 80" })
  }
), yC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 184c0-63.9 44.1-117.6 103.6-132.1C237.3 82 221 119.6 217 159.4l-5.1 49.9 42-27.3c21.3-14 46.7-22 74.1-22 63.9 0 117.6 44.1 132.1 103.6C430 237.3 392.4 221 352.6 217l-49.9-5.1 27.3 42c14 21.3 22 46.7 22 74.1 0 63.9-44.1 117.6-103.6 132.1C274.7 430 291 392.4 295 352.6l5.1-49.9-42 27.3c-21.4 14-46.7 22-74.1 22-63.9 0-117.6-44.1-132.1-103.6C82 274.7 119.6 291 159.4 295l49.9 5.1-27.3-42c-14-21.3-22-46.7-22-74.1M296 0C194.4 0 112 82.4 112 184c0 17.7 2.5 34.9 7.2 51.2-18-8.1-34.3-19.9-47.9-34.8l-29.5-32.5-41.8-46V216c0 101.6 82.4 184 184 184 17.7 0 34.9-2.5 51.2-7.2-8.1 18-19.9 34.3-34.8 47.9l-32.6 29.6-45.9 41.7H216c101.6 0 184-82.4 184-184 0-17.7-2.5-34.9-7.2-51.2 18 8.1 34.3 19.9 47.9 34.8l29.6 32.6 41.7 45.9V296c0-101.6-82.4-184-184-184-17.7 0-34.9 2.5-51.2 7.2 8.1-18 19.9-34.3 34.8-47.9l32.6-29.6L390.1 0H328zm-40 296 40-40-40-40-40 40z" })
  }
), bC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48v256H48V48zM48 0H0v352h576V0h-48zm48 416H0v96h96zm160 0h-96v96h96zm64 0v96h96v-96zm256 96v-96h-96v96z" })
  }
), fC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm32 80v144h144V112zm144 144v144h144V256z" })
  }
), UC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm256 64h-80v80h-80V96H64v80h80v80H64v80h80v80h80v-80h80v80h80v-80h-80v-80h80v-80h-80zm-80 160v80h-80v-80zm0 0v-80h80v80z" })
  }
), GC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 80v352h352V80zM32 32h448v240h32V144h96v80h-48v96h-80v160H32V80zm352 96v128H128V128zM192 288v32h32v32h-32v32h-32v-32h-32v-32h32v-32zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), qC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm232 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48m24-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-112-24v32h32v32h-32v32h-32v-32H80v-32h32v-32zM288 96v160H96V96z" })
  }
), WC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M591.7 480H440l-16-96H216l-16 96H0l5.4-48L42.8 96 160 32h320l117.2 64 37.5 336 5.4 48zm-423-103.9 6.7-40.1h289.3l6.7 40.1 9.3 55.9h105.7l-34.1-305.8L467.7 80H172.3l-84.6 46.2L53.6 432h105.7l9.3-55.9zM232 168v32h56v48h-56v56h-48v-56h-56v-48h56v-56h48zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64m32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), EC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h544V112zM0 64h640v384H0V112zm232 136v32h56v48h-56v56h-48v-56h-56v-48h56v-56h48zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64m32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), OC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 6.1 9 3.7 296 120 15 6.1V512h-48V168.2L320 57.9 48 168.2V512H0V135.8l15-6.1L311 9.8l9-3.7zM96 192h448v320h-48V240H144v272H96V216zm159.1 80h147l5 17.4 16 56 1.9 6.6h31v160h-48v-32H232v32h-48V352h31.1l1.7-6.3 15.1-56 4.8-17.7zM408 400H232v32h176zm-33-48-9.1-32h-92.4l-8.6 32z" })
  }
), IC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 6.1 9 3.7 296 120 15 6.1V512h-48V168.2L320 57.9 48 168.2V512H0V135.8l15-6.1L311 9.8l9-3.7zM96 192h448v320h-48V320H144v192H96V216zm48 80h352v-32H144zm64 80h248v160h-48v-32H232v32h-48V352zm200 80v-32H232v32z" })
  }
), NC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 6.1 9 3.7 296 120 15 6.1V512h-48V168.2L320 57.9 48 168.2V512H0V135.8l15-6.1L311 9.8l9-3.7zM96 192h448v320h-48V368H144v144H96V216zm48 128h352v-80H144zm136 96h104v48H256v-48z" })
  }
), XC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48v101.1l-3 4.2-57.4 80.4c-12.7 17.8-19.6 39.2-19.6 61.1v9.2c0 53 43 96 96 96s96-43 96-96v-9.2c0-21.9-6.8-43.3-19.6-61.1L283 209.3c-28-39.1-43-86-43-134.1V48zm64 0v27.2c0 41.4 12.9 81.8 37 115.5l17.4 24.4c16.6 23.3 25.5 51.1 25.5 79.7v9.2c0 38.2-16.8 72.5-43.3 96h62.9c51.1 0 92.5-41.4 92.5-92.5 0-28.1-12.8-54.7-34.7-72.2L322 149.5l-18-14.4V48zM139.3 400C112.8 376.5 96 342.2 96 304v-9.2c0-28.6 8.9-56.5 25.6-79.7l18.1-25.4-57 45.6C60.8 252.9 48 279.4 48 307.5c0 50.7 40.8 91.9 91.3 92.5M304 0h48v112l107.3 85.8c33.3 26.7 52.7 67 52.7 109.7 0 77.6-62.9 140.5-140.5 140.5h4.5v64h-48v-64h-16v64h-48v-64h-16v64h-48v-64h-16v64h-48v-64h4.5C62.9 448 0 385.1 0 307.5c0-42.7 19.4-83 52.7-109.7L160 112V0h48z" })
  }
), KC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 48v41l192 149.1V48zm-48 3.8V0h288v275.4l142 110.2c1.3-2.9 2-6.2 2-9.6V222c-27.6-7.1-48-32.2-48-62V97.9L447 65l-17-17 34-33.9 17 17 88 88 7 7V376c0 14.5-4.3 28-11.7 39.3l56.6 43.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7zM144 464h192V360.7l48 37.8V464h32v48H64v-48h32V171.6l48 37.8z" })
  }
), QC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48v144H80V48zm0 192v224H80V240zM32 48v416H0v48h352v-48h-32V304h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V126.1l-7-7L417 31l-17-17-33.9 34 17 17 33 33v62c0 29.8 20.4 54.9 48 62v154c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32c0-48.6-39.4-88-88-88h-8V0H32z" })
  }
), ZC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208m0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V96h48v205.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56M128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288m24 64-104 96h66.7L472 448l104-96h-66.7z" })
  }
), JC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208m0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V96h48v205.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56M128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 208a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 16v-32H416v32h144z" })
  }
), jC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208m0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V96h48v205.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56M128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), YC = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 296c30.9 0 56-25.1 56-56 0-14-5.1-26.8-13.7-36.6L366 161.7l9.7-22-43.9-19.3-9.7 22L254.4 296c-30.2.8-54.4 25.6-54.4 56 0 30.9 25.1 56 56 56m-64-248a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-80 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), _C = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m32 112a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 296c-30.9 0-56-25.1-56-56 0-14 5.1-26.8 13.7-36.6L146 161.7l-9.7-22 43.9-19.3 9.7 22L257.6 296c30.2.8 54.4 25.6 54.4 56 0 30.9-25.1 56-56 56m128-248a32 32 0 1 1-64 0 32 32 0 1 1 64 0m16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-256 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), hL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m32 112a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 296c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4 19.8-13.6 27.1 39.6-19.8 13.6-110.2 75.4c.4 2.9.7 5.8.7 8.8 0 30.9-25.1 56-56 56m128-248a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-272 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m80-64a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), cL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 296c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6l-110.2-75.4-19.9-13.6-27.1 39.7 19.8 13.6 110.2 75.4c-.4 2.9-.7 5.8-.7 8.8 0 30.9 25.1 56 56 56zm-64-248a32 32 0 1 0-64 0 32 32 0 1 0 64 0m208 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), sL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56-160c0-14-5.1-26.8-13.7-36.6L366 161.7l9.7-22-43.9-19.3-9.7 22L254.4 296c-30.2.8-54.4 25.6-54.4 56 0 30.9 25.1 56 56 56s56-25.1 56-56" })
  }
), vL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-56 352c0-14 5.1-26.8 13.7-36.6L146 161.7l-9.7-22 43.9-19.3 9.7 22L257.6 296c30.2.8 54.4 25.6 54.4 56 0 30.9-25.1 56-56 56s-56-25.1-56-56" })
  }
), eL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416m0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-56 352c0-30.9 25.1-56 56-56 10.3 0 19.9 2.8 28.2 7.6l110.2-75.4 19.8-13.6 27.1 39.6-19.8 13.6-110.2 75.4c.4 2.9.7 5.8.7 8.8 0 30.9-25.1 56-56 56s-56-25.1-56-56" })
  }
), lL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56-160c0-30.9-25.1-56-56-56-10.3 0-19.9 2.8-28.2 7.6l-110.2-75.4-19.9-13.6-27.1 39.7 19.8 13.6 110.2 75.4c-.4 2.9-.7 5.8-.7 8.8 0 30.9 25.1 56 56 56s56-25.1 56-56z" })
  }
), tL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56-160c0-22.3-13.1-41.6-32-50.6V96h-48v205.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56" })
  }
), wL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56-160c0-22.3-13.1-41.6-32-50.6V96h-48v205.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56M160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), gL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M271.2 82.7 217.9 136 376 294.1l53.3-53.3L271.2 82.7zM184 169.9l-16 16-33.9-33.9 17-17 16-16 87.2-87.3 13.6-13.6 17-17L318.8 35l-13.6 13.7 158.1 158.1 13.5-13.6 33.9 33.9-17 17-13.5 13.6L393 345l-16 16-17 17-33.9-34 16-16zm-54.1 308.2L96 512l-33.9-33.9-28.2-28.2L0 416l33.9-33.9L110 306l34-34 31 31 48.4-48.4 33.9 33.9L209 337l31 31-33.9 33.9L130 478zM172.1 368 144 339.9 67.9 416 96 444.1z" })
  }
), iL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m328 0 14.6 66.8c11.9 5.5 23.3 12 33.8 19.6l65.2-20.8 72 124.7-50.6 46.1c.6 6.4.9 12.9.9 19.5s-.3 13.1-.9 19.5l50.6 46.1-72 124.7-65.2-20.8c-10.6 7.5-21.9 14.1-33.8 19.6L328 512H184l-14.6-66.8c-11.9-5.5-23.3-12-33.8-19.6l-65.3 20.8-72-124.7 50.6-46.1c-.6-6.4-.9-12.9-.9-19.5s.3-13.1.9-19.5l-50.6-46.2 72-124.7 65.2 20.8c10.6-7.5 21.9-14.1 33.8-19.6L184 0zm63 132.2-22.9 7.3-19.5-13.9c-8.2-5.8-16.9-10.9-26-15.1l-21.8-10-5.1-23.4-6.3-29.1h-66.8l-6.4 29.1-5.1 23.4-21.8 10c-9.2 4.2-17.9 9.3-26 15.1l-19.5 13.9-22.8-7.3-28.4-9-33.4 57.7 22 20.1 17.7 16.1-2.2 23.8c-.5 5-.7 10-.7 15.1s.2 10.1.7 15.1l2.2 23.8L81.2 311l-22 20.1 33.4 57.8 28.4-9 22.9-7.3 19.5 13.9c8.2 5.8 16.9 10.9 26 15.1l21.8 10 5.1 23.4 6.4 29.1h66.7l6.4-29.1 5.1-23.4 21.8-10c9.2-4.2 17.9-9.3 26-15.1l19.5-13.9 22.9 7.3 28.4 9 33.4-57.8-22.1-20.1-17.7-16.1 2.2-23.8c.5-5 .7-10 .7-15.1s-.2-10.1-.7-15.1l-2.2-23.8 17.7-16.1 22.1-20.1-33.4-57.8-28.4 9zm-99.3 31.1-32 192-3.3 19.7-39.4-6.6 3.3-19.7 32-192 3.3-19.7 39.5 6.6-3.3 19.7zm-93.6 66.9L172.3 256l25.9 25.9 14.1 14.1-28.3 28.3-14.1-14.1-40-40-14.2-14.2 14.1-14.1 40-40 14.2-14.2 28.3 28.3-14.1 14.1zm144-28.3 40 40 14.2 14.1-14.1 14.1-40 40-14.2 14.2-28.3-28.3 14.1-14.1 25.9-25.9-25.9-25.9-14.1-14.1 28.3-28.3 14.1 14.1z" })
  }
), mL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-18.9l-4.4 18.4L180 71l-1.1.4-46.1-28.2-16.1-9.9-13.4 13.4-56.6 56.6-13.4 13.3 9.9 16.1 28.2 46.2-.4 1.1-52.6 12.7L0 197.1V314.9l18.4 4.4L71 332l.4 1.1-28.2 46.2-9.9 16.1 13.4 13.4 56.6 56.6 13.4 13.4 16.1-9.9 46.2-28.2 1.1.4 12.7 52.6 4.4 18.4H314.9l4.4-18.4L332 441l1.1-.4 46.2 28.2 16.1 9.9 13.4-13.4 56.6-56.6 13.4-13.4-9.9-16.1-28.2-46.2.4-1.1 52.6-12.7 18.4-4.4V197.1l-18.4-4.4L441 180l-.4-1.1 28.2-46.2 9.9-16.1-13.4-13.4-56.6-56.5-13.3-13.4-16.1 9.9-46.2 28.2-1.1-.4-12.7-52.6L314.9 0H296zm7.6 94.6L234.9 48h42.2l11.3 46.6 3.1 12.9 12.6 4.2c6.8 2.3 13.5 5 19.9 8.2l11.9 6 11.4-6.9 40.9-25 29.8 29.8-25 40.9-7 11.4 6 11.9c3.2 6.4 6 13 8.2 19.9l4.2 12.6 12.9 3.1 46.7 11.3v42.2l-46.6 11.3-12.9 3.1-4.2 12.6c-2.3 6.8-5 13.5-8.2 19.9l-6 11.9 6.9 11.4 25 40.9-29.8 29.8-40.9-25-11.4-7-11.9 6c-6.4 3.2-13 6-19.9 8.2l-12.6 4.2-3.1 12.9-11.3 46.7h-42.2l-11.3-46.6-3.1-12.9-12.6-4.2c-6.8-2.3-13.5-5-19.9-8.2l-11.9-6-11.3 6.9-40.9 25L94 388.2l25-40.9 6.9-11.4L120 324c-3.2-6.4-6-13-8.2-19.9l-4.2-12.6-12.9-3.1L48 277.1v-42.2l46.6-11.3 12.9-3.1 4.2-12.6c2.3-6.8 5-13.5 8.2-19.9l6-11.9-6.9-11.3-25-41L123.8 94l40.9 25 11.4 6.9 11.9-6c6.4-3.2 13-6 19.9-8.2l12.6-4.2zm68.1 68.7 3.3-19.7-39.4-6.6-3.3 19.7-32 192-3.3 19.7 39.5 6.6 3.3-19.7 32-192zm-93.6 66.9 14.2-14.2-28.3-28.3-14.1 14.1-40 40-14.2 14.2 14.1 14.1 40 40 14.2 14.2 28.3-28.3-14.1-14.1-25.9-25.9 25.9-25.9zm144-28.3L328 187.7 299.7 216l14.1 14.1 25.9 25.9-25.9 25.9-14.1 14.1 28.3 28.3 14.1-14.1 40-40 14.2-14.2-14.1-14.1-40-40z" })
  }
), aL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-18.9l-4.4 18.4L180 71l-1.1.4-46.1-28.2-16.1-9.9-13.4 13.4-56.6 56.6-13.4 13.3 9.9 16.1 28.2 46.2-.4 1.1-52.6 12.7L0 197.1V314.9l18.4 4.4L71 332l.4 1.1-28.2 46.2-9.9 16.1 13.4 13.4 56.6 56.6 13.4 13.4 16.1-9.9 46.2-28.2 1.1.4 12.7 52.6 4.4 18.4H314.9l4.4-18.4L332 441l1.1-.4 46.2 28.2 16.1 9.9 13.4-13.4 56.6-56.6 13.4-13.4-9.9-16.1-28.2-46.2.4-1.1 52.6-12.7 18.4-4.4V197.1l-18.4-4.4L441 180l-.4-1.1 28.2-46.2 9.9-16.1-13.4-13.4-56.6-56.5-13.3-13.4-16.1 9.9-46.2 28.2-1.1-.4-12.7-52.6L314.9 0H296zm7.6 94.6L234.9 48h42.2l11.3 46.6 3.1 12.9 12.6 4.2c6.8 2.3 13.5 5 19.9 8.2l11.9 6 11.4-6.9 40.9-25 29.8 29.8-25 40.9-7 11.4 6 11.9c3.2 6.4 6 13 8.2 19.9l4.2 12.6 12.9 3.1 46.7 11.3v42.2l-46.6 11.3-12.9 3.1-4.2 12.6c-2.3 6.8-5 13.5-8.2 19.9l-6 11.9 6.9 11.4 25 40.9-29.8 29.8-40.9-25-11.4-7-11.9 6c-6.4 3.2-13 6-19.9 8.2l-12.6 4.2-3.1 12.9-11.3 46.7h-42.2l-11.3-46.6-3.1-12.9-12.6-4.2c-6.8-2.3-13.5-5-19.9-8.2l-11.9-6-11.3 6.9-40.9 25L94 388.2l25-40.9 6.9-11.4L120 324c-3.2-6.4-6-13-8.2-19.9l-4.2-12.6-12.9-3.1L48 277.1v-42.2l46.6-11.3 12.9-3.1 4.2-12.6c2.3-6.8 5-13.5 8.2-19.9l6-11.9-6.9-11.3-25-41L123.8 94l40.9 25 11.4 6.9 11.9-6c6.4-3.2 13-6 19.9-8.2l12.6-4.2zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0m144 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0" })
  }
), oL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m328 0 14.6 66.8c11.9 5.5 23.3 12 33.8 19.6l65.2-20.8 72 124.7-50.6 46.1c.6 6.4.9 12.9.9 19.5s-.3 13.1-.9 19.5l50.6 46.1-72 124.7-65.2-20.8c-10.6 7.5-21.9 14.1-33.8 19.6L328 512H184l-14.6-66.8c-11.9-5.5-23.3-12-33.8-19.6l-65.3 20.8-72-124.7 50.6-46.1c-.6-6.4-.9-12.9-.9-19.5s.3-13.1.9-19.5l-50.6-46.2 72-124.7 65.2 20.8c10.6-7.5 21.9-14.1 33.8-19.6L184 0zm63 132.2-22.9 7.3-19.5-13.9c-8.2-5.8-16.9-10.9-26-15.1l-21.8-10-5.1-23.4-6.3-29.1h-66.8l-6.4 29.1-5.1 23.4-21.8 10c-9.2 4.2-17.9 9.3-26 15.1l-19.5 13.9-22.8-7.3-28.4-9-33.4 57.7 22 20.1 17.7 16.1-2.2 23.8c-.5 5-.7 10-.7 15.1s.2 10.1.7 15.1l2.2 23.8L81.2 311l-22 20.1 33.4 57.8 28.4-9 22.9-7.3 19.5 13.9c8.2 5.8 16.9 10.9 26 15.1l21.8 10 5.1 23.4 6.4 29.1h66.7l6.4-29.1 5.1-23.4 21.8-10c9.2-4.2 17.9-9.3 26-15.1l19.5-13.9 22.9 7.3 28.4 9 33.4-57.8-22.1-20.1-17.7-16.1 2.2-23.8c.5-5 .7-10 .7-15.1s-.2-10.1-.7-15.1l-2.2-23.8 17.7-16.1 22.1-20.1-33.4-57.8-28.4 9zM304 256a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0" })
  }
), nL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M127.2 12h81.5l4.3 14.4 8.3 28.8c8.7 3.9 17 8.6 24.6 14.2l29.1-7.1 14.6-3.6 7.5 13 25.8 44.6 7.5 13-10.4 10.9-20.8 21.6c.5 4.7.8 9.4.8 14.2s-.3 9.5-.8 14.2l20.8 21.6 10.4 10.8-7.5 13-25.8 44.6-7.5 13-14.6-3.5-29.1-7.2c-7.6 5.6-15.9 10.4-24.6 14.2l-8.3 28.9-4.2 14.4h-81.6l-4.2-14.4-8.4-28.8c-8.7-3.9-17-8.6-24.6-14.2l-29.1 7.2-14.6 3.6-7.5-13-25.7-44.7-7.5-13L16 211.8l20.8-21.6c-.5-4.7-.8-9.4-.8-14.2s.3-9.5.8-14.2L16 140.2 5.6 129.3l7.5-13 25.7-44.6 7.5-13 14.6 3.6L90 69.5c7.6-5.6 15.8-10.4 24.6-14.2l8.4-28.9zm30 40-6.9 23.8-2.9 9.9-9.8 3.4c-11 3.8-21.1 9.7-29.8 17.2l-7.8 6.8-10-2.5-24-5.9-10.8 18.6 17.2 17.9 7.1 7.4-1.9 10.1c-1 5.6-1.6 11.4-1.6 17.3s.6 11.7 1.6 17.3l1.9 10.1-7.1 7.4-17.2 17.9L66 247.3l24-5.9 10-2.5 7.8 6.8c8.7 7.5 18.8 13.4 29.8 17.3l9.8 3.4 2.9 9.9 6.9 23.8h21.5l6.9-23.8 2.9-9.9 9.8-3.4c11-3.8 21.1-9.7 29.8-17.3l7.8-6.8 10 2.5 24.1 5.9 10.7-18.6-17.1-17.9-7.1-7.4 1.9-10.1c1.1-5.6 1.6-11.3 1.6-17.3s-.6-11.7-1.6-17.3l-1.9-10.1 7.1-7.4 17.1-17.9-10.7-18.6-24.1 5.9-10 2.5-7.8-6.8c-8.7-7.5-18.8-13.4-29.8-17.3l-9.8-3.4-2.9-9.9-6.9-23.7h-21.4zM128 176a40 40 0 1 1 80 0 40 40 0 1 1-80 0m500 127.2v81.5l-14.4 4.3-28.8 8.3c-3.9 8.7-8.6 17-14.2 24.6l7.2 29.1 3.6 14.6-13 7.5-44.6 25.8-13 7.5-11-10.4-21.6-20.8c-4.7.5-9.4.8-14.2.8s-9.5-.3-14.2-.8L428.2 496l-10.8 10.4-13-7.5-44.6-25.8-13-7.5 3.6-14.6 7.2-29.1c-5.6-7.6-10.4-15.9-14.2-24.6l-29-8.3-14.4-4.2v-81.6l14.4-4.2 28.8-8.4c3.9-8.7 8.6-17 14.2-24.6l-7.2-29.1-3.6-14.6 13-7.5 44.6-25.8 13-7.5 11 10.5 21.6 20.8c4.7-.5 9.4-.8 14.2-.8s9.5.3 14.2.8l21.6-20.8 10.8-10.4 13 7.5 44.6 25.8 13 7.5-3.6 14.6-7.2 29.1c5.6 7.6 10.4 15.8 14.2 24.6l28.8 8.4 14.4 4.2zm-40 30-23.8-6.9-9.9-2.9-3.4-9.8c-3.8-11-9.7-21.1-17.2-29.8l-6.8-7.8 2.5-10 5.9-24.1-18.6-10.7-17.9 17.2-7.4 7.1-10.1-1.9c-5.6-1.1-11.3-1.6-17.3-1.6s-11.7.6-17.3 1.6l-10.1 1.9-7.4-7.1-17.9-17.2-18.6 10.8 5.9 24.1 2.5 10-6.8 7.8c-7.5 8.7-13.4 18.8-17.3 29.8l-3.4 9.8-9.9 2.9-23.7 6.9v21.5l23.8 6.9 9.9 2.9 3.4 9.8c3.8 11 9.7 21.1 17.3 29.8l6.8 7.8-2.5 10-6 24 18.6 10.7 17.9-17.1 7.4-7.1 10.1 1.9c5.6 1.1 11.3 1.6 17.3 1.6s11.7-.6 17.3-1.6l10.1-1.9 7.4 7.1 17.9 17.1 18.6-10.7-5.9-24.1-2.5-10 6.8-7.8c7.5-8.7 13.4-18.8 17.3-29.8l3.4-9.8 9.9-2.9 23.8-6.9v-21.4zM464 304a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), rL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289 445-33 35-33-35L0 208 112 32h288l112 176zm142-221H81l175 186zm3.7-48L385 97.9 311.5 176zM336 80H176l80 85zM127 97.9 77.3 176h123.2z" })
  }
), dL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352" })
  }
), SL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 426.3V480l-48-24-16-8-24.4 27.9L264 512l-35.9-31.9L192 448l-36.1 32.1L120 512l-31.6-36.1L64 448l-16 8-48 24V192C0 86 86 0 192 0s192 86 192 192zm-48-24V192c0-79.5-64.5-144-144-144S48 112.5 48 192v210.3l27.7-13.8 24.4 27.9 24.2 27.6 35.8-31.9 31.9-28.3 31.9 28.3 35.8 31.9 24.1-27.6 24.4-27.9zM96 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), zL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm272 128h-48v192h48V184zm32 0v192h48v-64h64v-48h-64v-32h88v-48H376zm-224 96c0-26.5 21.5-48 48-48 12.3 0 23.5 4.6 32 12.2l32-35.8c-17-15.2-39.4-24.5-64-24.5-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8L240 329v-73h-48v45.1c-5.3 1.9-10.6 2.9-16 2.9-26.5 0-48-21.5-48-48" })
  }
), pL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.5 68.8 318.7 128H392c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8M288 197.5l-61.6 73.9-15.4 18.4-36.9-30.7 15.4-18.4 53.9-64.7H48v144h480V176H332.6l53.9 64.6 15.4 18.4-36.9 30.7-15.4-18.4zM48 384v80h480v-80zm208-256h1.3l-34.8-59.2C214.9 55.9 201.1 48 186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40zm7.9-83.6 24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0h2.2c48.6 0 88 39.4 88 88 0 14.4-3.5 28-9.6 40H576v384H0V128h105.6c-6.1-12-9.6-25.6-9.6-40 0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4z" })
  }
), ML = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M231.9 44.4C215.7 16.9 186.1 0 154.2 0H152c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40H0v160h32v224h448V288h32V128h-73.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176v64H288v-64h72zm-240 0v64H48v-64h104zm0 112v176H80V288zm64 176V288h144v176zm72-336h-73.3l34.8-59.2c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40s-17.9 40-40 40m-136 0h-72c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8l34.8 59.2z" })
  }
), xL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m200.4 40.6 8.6-22.3L164.3 1l-8.6 22.4-11 28.2-10.1-27.8-8.2-22.6-45.2 16.4 8.2 22.6 7.9 21.6-28.4-18-20.3-12.9-25.7 40.5 20.2 12.8L61.6 96H0v416h192v-48H48V144h208.4c8.1-12.7 18.9-23.5 31.6-31.6V96h-61.6l18.5-11.8 20.2-12.9-25.7-40.4-20.3 12.9-26.4 16.8 7.7-19.9zm163.1 144.9 29.6 38.5H344c-13.3 0-24-10.7-24-24 0-13.1 10.8-24 24.2-24 7.6 0 14.7 3.5 19.3 9.5M272 200c0 8.4 1.4 16.5 4.1 24H224v288h416V224h-52.1c2.7-7.5 4.1-15.6 4.1-24 0-39.9-32.5-72-72.2-72-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2-39.7 0-72.2 32.1-72.2 72zm0 72h136v72H272zm0 120h136v72H272zm320 0v72H456v-72zm-136-48v-72h136v72zm88-144c0 13.3-10.7 24-24 24h-49.1l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5 13.4 0 24.2 10.9 24.2 24" })
  }
), HL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-66.3 0-120 53.7-120 120 0 8.2.8 16.2 2.4 24H0v176h92.1l-54.5 65.5-5.6 6.6V512h129.2l7.2-8.6 52.8-63.4h5.6l52.8 63.4 7.2 8.6H416V392.1l-5.6-6.7-54.5-65.4H448V144H341.6c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0m-72 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 13.2-3.5 25.4-9.6 36l-20.8 36H400v80H296V323.1l5.6 6.7 66.4 79.7V464h-58.7l-52.8-63.4-7.2-8.6H198.7l-7.2 8.6-52.8 63.4H80v-54.5l66.4-79.7 5.6-6.7V272H48v-80h134.4l-20.8-36c-6.1-10.6-9.6-22.8-9.6-36m72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-16-128a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), VL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M372.5 239.9c50.9-2.4 91.5-44.4 91.5-95.9 0-53-43-96-96-96-35.5 0-66.6 19.3-83.2 48h-52.6C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144s-64.5 144-144 144h-.5zM61.6 256h228.8l8.3-80H53.3l8.3 80zm5 48 16.7 160h185.4l16.7-160zM312 512H40L5 176l-5-48h352l-5 48z" })
  }
), CL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M84.4 464h215.2l32.5-416H51.9zM344 512H40L3.8 48 0 0H384l-3.8 48z" })
  }
), LL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M70.6 288h242.8l-13.8 176H84.4zm-3.8-48L51.9 48h280.2l-15 192H66.9zM40 512h304l36.2-464L384 0H0l3.8 48z" })
  }
), BL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M77.4 373.9c29.2 9 61.6 3.3 86.1-16.4 16.7-13.3 40.4-13.3 57 0 24.5 19.6 56.9 25.4 86.1 16.4l-7 90.1H84.4zm-4.3-55L51.9 48h280.2l-21.2 270.9-9.7 5.4c-16.2 9-36.2 7.3-50.7-4.3-34.2-27.4-82.8-27.4-117 0-14.5 11.6-34.5 13.3-50.7 4.3l-9.7-5.4zM40 512h304l36.2-464L384 0H0l3.8 48zm104.1-362.1c-10.4 11.7-16.1 26.7-16.1 42.4 0 35.2 28.8 63.8 64 63.8s64-28.5 64-63.8c0-15.6-5.7-30.7-16.1-42.4L192 96z" })
  }
), uL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.2 192.2c32.5 16.2 71.7 12.2 100.3-10.7 16.7-13.3 40.4-13.3 57 0 28.6 22.9 67.8 26.9 100.3 10.7L299.6 464H84.4zm-4.5-57.3L51.9 48h280.2l-6.8 86.9-24.1 13.4c-16.2 9-36.2 7.3-50.7-4.3-34.2-27.4-82.8-27.4-117 0-14.5 11.6-34.5 13.3-50.7 4.3zM40 512h304l36.2-464L384 0H0l3.8 48z" })
  }
), RL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M61.9 176h260.2l-22.5 288H84.4zm-3.8-48-6.2-80h280.2l-6.2 80H58.1zM40 512h304l36.2-464L384 0H0l3.8 48z" })
  }
), $L = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m61 31.9 21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5-66.9-10c-8.4 34.3-15.4 59.6-22.4 84.6l-.3 1c-5.3 19-10.6 38-16.5 60.9C80.4 217 107.2 208 136 208c55.1 0 102.6 32.8 124 80h56c21.3-47.2 68.8-80 124-80 28.8 0 55.6 9 77.6 24.3-5.9-22.9-11.1-41.9-16.5-60.9l-.3-1c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5L493.2 35l21.8-3.1 5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2.9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V344c0 75.1-60.9 136-136 136-72.4 0-131.6-56.6-135.8-128h-32.3c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344v-74.8l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 344a88 88 0 1 0-176 0 88 88 0 1 0 176 0m-480 0c0 48.6 39.4 88 88 88s88-39.4 88-88-39.4-88-88-88-88 39.4-88 88" })
  }
), kL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m61 31.9 21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5-66.9-10c-8.4 34.3-15.4 59.6-22.4 84.6l-.3 1c-8.1 29-16.1 57.8-26.2 100.6H256v32h64v-32h207.3c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5L493.2 35l21.8-3.1 5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2.9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V480H320V368h-64v112H0V269.2l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 320H368v112h160v-80zM48 352v80h160V320H48z" })
  }
), PL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m246.6 439.7-20.7 70.5c9.9 1.2 19.9 1.8 30.1 1.8 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 10.2.6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3 0-16.5 1.9-32.6 5.6-48h77.8c-1.9 13-3 26.7-3.3 41l48.7-14.3c.7-9.2 1.8-18.1 3.2-26.7H332c2.5 15 4 30.9 4 48s-1.4 33-4 48h-45.5l-14.1 48h46.8c-10.2 27.4-23.8 50-37.5 68.1-8.9 11.8-17.8 21.6-25.7 29.4-3-3-6.1-6.2-9.4-9.8m35.1-347.8c13.6 18 27.3 40.6 37.5 68.1H192.8c10.2-27.4 23.8-50 37.5-68.1 8.9-11.8 17.8-21.6 25.7-29.4 7.9 7.8 16.8 17.6 25.7 29.4M384 256c0-16.9-1.2-32.9-3.4-48h77.8c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48h-77.8c2.2-15.1 3.4-31.1 3.4-48m-14.2-96c-13.4-43.5-34.5-77.9-54.9-103.5 54.6 16.1 99.8 54 125.6 103.5zm-298.4 0C97.2 110.4 142.5 72.6 197 56.5c-20.4 25.6-41.5 60-54.9 103.5zm298.4 192h70.7c-25.8 49.6-71.1 87.4-125.6 103.5 20.4-25.6 41.5-60 54.9-103.5zM0 320l96 48 1.4 1.4-96 96 45.3 45.3 96-96 1.3 1.3 48 96 80-272z" })
  }
), FL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176m-96 32v-16l-80-80-80 80v16h32l-48 48v16h72v64h48v-64h72v-16l-48-48zm-48-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-200-8a24 24 0 1 0-48 0 24 24 0 1 0 48 0M0 512h448l-64-96H64z" })
  }
), TL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M23 359 6 376l34 33.9 17-17 10.5-10.5c34.3 27.7 74.9 43.8 116.5 48.3V464H64v48h288v-48H232v-33.3c49.1-5.3 96.8-26.7 134.4-64.3 81.7-81.7 87.1-211 16.1-298.9L393 57l17-17-34-33.9L359 23l-26.5 26.6-17 17 17 17c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0l-17-17-17 17zm89-151a96 96 0 1 1 192 0 96 96 0 1 1-192 0m240 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0" })
  }
), AL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M197.1 455.5c-54.6-16.1-99.8-54-125.6-103.5h70.7c13.4 43.5 34.5 77.9 54.9 103.5m33.2-35.5c-13.6-18-27.3-40.6-37.5-68.1h126.4c-10.2 27.4-23.8 50-37.5 68.1-8.9 11.8-17.8 21.6-25.7 29.4-7.9-7.8-16.8-17.6-25.7-29.4M176 256c0-17.1 1.4-33 4-48h152c2.5 15 4 30.9 4 48s-1.4 33-4 48H180c-2.5-15-4-30.9-4-48m-44.6-48c-2.2 15.1-3.4 31.1-3.4 48s1.2 32.9 3.4 48H53.6C50 288.6 48 272.5 48 256s1.9-32.6 5.6-48h77.8zm61.4-48c10.2-27.4 23.8-50 37.5-68.1 8.9-11.8 17.8-21.6 25.7-29.4 7.9 7.8 16.8 17.6 25.7 29.4 13.6 18 27.3 40.6 37.5 68.1zm187.8 48h77.8c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48h-77.8c2.2-15.1 3.4-31.1 3.4-48s-1.2-32.9-3.4-48m60-48h-70.8c-13.4-43.5-34.5-77.9-54.9-103.5 54.6 16.1 99.8 54 125.6 103.5zm-298.4 0H71.4C97.2 110.4 142.5 72.6 197 56.5c-20.4 25.6-41.5 60-54.9 103.5zm172.7 295.5c20.4-25.6 41.5-60 54.9-103.5h70.7c-25.8 49.6-71.1 87.4-125.6 103.5M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), DL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h48V80h544v400h48V32h-24zm168 96h-32v64H96v32h64v64H96v32h64v64H96v32h64v64h32v-64h64v64h32v-64h64v64h32v-64h64v64h32v-64h64v-32h-64v-64h64v-32h-64v-64h64v-32h-64v-64h-32v64h-64v-64h-32v64h-64v-64h-32v64h-64zm64 256h-64v-64h64zm96 0h-64v-64h64zm96 0h-64v-64h64zm0-96h-64v-64h64zm-96 0h-64v-64h64zm-96 0h-64v-64h64z" })
  }
), yL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0 55.7-31.7 104.1-78 128h77.1c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128H126c-46.3-23.9-78-72.3-78-128 0-79.5 64.5-144 144-144s144 64.5 144 144m-109.9 56.6c0 18.5-15 33.5-33.5 33.5-4.9 0-9.6-1.1-13.8-3 5.3 11.6 16.9 19.7 30.5 19.7 18.5 0 33.5-15 33.5-33.5 0-13.6-8.1-25.3-19.7-30.5 1.9 4.2 3 8.9 3 13.8zm-52.3-49.3c-4.9 0-9.6-1.1-13.8-3 5.3 11.6 16.9 19.7 30.5 19.7 18.5 0 33.5-15 33.5-33.5 0-13.6-8.1-25.3-19.7-30.5 1.9 4.2 3 8.9 3 13.8 0 18.5-15 33.5-33.5 33.5m113.5-17.5c0 18.5-15 33.5-33.5 33.5-4.9 0-9.6-1.1-13.8-3 5.3 11.6 16.9 19.7 30.5 19.7 18.5 0 33.5-15 33.5-33.5 0-13.6-8.1-25.3-19.7-30.5 1.9 4.2 3 8.9 3 13.8M64 400h96v112h64V400h96v-48H64z" })
  }
), bL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M466.5 13.3 293 360.4 31 281l-31-9.4V512h270.8l6.6-13.3 232-464zM48 336.3 271.2 404l-30 60H48v-16h48v-32H48v-16h48v-32H48z" })
  }
), fL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M161.4 17.9 128 3.8V384c0 .7 0 1.5.1 2.2-.1.6-.1 1.2-.1 1.8 0 19.9 35.8 36 80 36s80-16.1 80-36-35.8-36-80-36c-11.4 0-22.2 1.1-32 3v-28.8c24.6-3.9 51.5-6.2 80-6.2 61.7 0 116.4 10.4 154.9 26.3 19.3 8 33.3 16.9 42.1 25.5 8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3v-51.7c-4.5 1.6-9 3.3-13.2 5.1-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5C40.1 460.8 60 472.6 82.7 482c45.6 18.9 106.9 30 173.3 30s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5 14.8-14.5 25.5-32.9 25.5-54.6s-10.7-40.1-25.4-54.5C472 323.2 452 311.4 429.3 302c-45.6-18.9-106.9-30-173.3-30-27.8 0-54.8 1.9-80 5.6v-45.7l193.4-81.8 52.2-22.1-52.2-22.1-208-88zM176 179.8V76.2L298.4 128z" })
  }
), UL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0v32h48V0h48v32h32V0h48v32h48V0h48v128h32v96h32v112h32v176H0V336h32V224h32v-96h32V0zm0 88v40h224V80H144zm-32 88v48h48v-48h-16zm208 48v-48H192v48h32c0-17.7 14.3-32 32-32s32 14.3 32 32zm32-48v48h48v-48h-32zM80 336h48v-64H80zm80 0h64v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h64v-64H160zm224 0h48v-64h-48zM128 464h80v-16c0-26.5 21.5-48 48-48s48 21.5 48 48v16h80v-80H128zm288 0h48v-80h-48zM48 384v80h48v-80H80z" })
  }
), GL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m640 176-12.8 4.5-14.2 5L320 288l-193.7-67.8L80 263v83.8c15.4 25.1 27.8 68.4 0 133.2L0 464s32.5-46.5 48-96.9V249l5.1-4.8 38.9-36-65.1-22.8-14.2-5L0 176v-32l12.8-4.5 14.2-5L320 32l293.1 102.6 14.2 5L640 144zm-320 61.1L540.4 160 320 82.9 99.6 160l41.9 14.7 172.9-64.8 11.2 30-137 51.4 131.4 46zm-176.4 23 46.6 16.3-13 123.5c4.8 3.5 12.8 8 24.6 12.6C230 423.6 272 432 320 432s90-8.4 118.3-19.4c11.8-4.6 19.8-9.2 24.6-12.6l-13-123.5 46.6-16.3L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8zM467.4 396a.7.7 0 1 0-1.2-.7.7.7 0 1 0 1.2.7m-294.8 0a.7.7 0 1 0 1.2-.6.7.7 0 1 0-1.2.6" })
  }
), qL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m108.8 2.6 40.6 10.2 1.1 3.2v.1l.3.7c.3.7.7 1.7 1.3 3.2 1.2 2.9 3.2 7.3 6 12.8 5.7 11.1 14.8 27 28.2 45.1 26.9 36.2 71.4 81.5 141.3 116.8 17.3 8.7 31.6 22.9 40.1 40.4 5.4 10.9 8.2 23 8.2 35v.6c0 45-36.5 81.4-81.4 81.4H160V304h134c18.7 0 33.9-15.1 34-33.7-.1-5.4-1.5-10.7-4.1-15.6-3.1-4.9-7.7-7.8-12.4-8.6-8.6-1.4-19-2.6-30.9-3h-1.3c-48.2-1.3-121.5 10.4-207.2 71l-42.9-10.7 3.6-13.5 72-272 4-15.3zM135.6 89 94.8 243.4c42.5-23.1 81.9-36 116.7-42.6 1.1-.2 2.2-.4 3.2-.6 8.5-1.5 16.7-2.7 24.6-3.5-41.1-30.1-70.7-62.3-91.5-90.2-4.5-6.1-8.6-11.9-12.3-17.5zM24 464h8v-80h320v80h32v48H0v-48zm280-32H80v32h224z" })
  }
), WL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 0s-40 40-40 80 7.3 55.3 32 80 40 32 80 32 80-40 80-40-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80m48 264c0-44.2-35.8-80-80-80 0-44.2-35.8-80-80-80-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80 0 18 6 34.6 16 48-19.4 14.6-32 37.8-32 64 0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80 32.5 0 60.5-19.4 73-47.2 13.2 9.6 29.4 15.2 47 15.2 26.2 0 49.4-12.6 64-32 13.4 10 30 16 48 16 44.2 0 80-35.8 80-80 0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264M248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-120 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80M72 312a40 40 0 1 1 80 0 40 40 0 1 1-80 0m8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80m80 8a40 40 0 1 1 80 0 40 40 0 1 1-80 0m152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-128-56a40 40 0 1 1 80 0 40 40 0 1 1-80 0m144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), EL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h448v125.9l-48 73.7V80h-56v152h55.8l-56.1 86.1c-15.4 23.7-23.7 51.4-23.7 79.7v2.2c0 29.6 8.9 57.1 24.2 80H0V56zm48 48v152h56V80zm0 352h56V280H48zm152 0V280h-48v152zm96 0V280h-48v152zM248 80v152h48V80zm-48 152V80h-48v152zm264-40 93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3v2.1c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z" })
  }
), OL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h448V32H128zm80 48v152H48V80zM48 280h56v152H48zm104 152V280h48v152zm96 0V280h48v152zm96 0V280h56v152zm56-200h-56V80h56zM296 80v152h-48V80zm-96 0v152h-48V80z" })
  }
), IL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400.4 169.5 32 32.3v51.2L323.2 192 32 300.5v51.2l368.4-137.2 15.6-5.8v-33.4zM424 432H0v48h448v-48z" })
  }
), NL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 64.9 370 169.3 14 6.4v30.8l-14 6.4L0 447.2v-52.8L302.3 256 0 117.6z" })
  }
), XL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 80H80v96h96zM80 32h144v192H32V32zm96 304H80v96h96zm-96-48h144v192H32V288zM336 80v96h96V80zm-48-48h192v192H288V80zm120 240v88h88v48h-88v88h-48v-88h-88v-48h88v-88z" })
  }
), KL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 80v96h96V80zM32 32h192v192H32V80zm48 304v96h96v-96zm-48-48h192v192H32V336zM432 80h-96v96h96zm-96-48h144v192H288V32zm0 304v96h96v-96zm-48-48h192v192H288V336z" })
  }
), QL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h89.6v89.6H0zm0 119.5h89.6v89.6H0zm89.6 119.4v89.6H0v-89.6zM0 390.4h89.6V480H0zM119.5 32h89.6v89.6h-89.6zm0 119.5h89.6v89.6h-89.6zM209.1 271v89.6h-89.6v-89.7h89.6zm-89.6 119.4h89.6V480h-89.6zM328.5 32v89.6h-89.6V32zm0 119.5v89.6h-89.6v-89.6zm-89.6 119.4h89.6v89.6h-89.6zm89.6 119.5V480h-89.6v-89.6zM358.4 32H448v89.6h-89.6zm0 119.5H448v89.6h-89.6zM448 270.9v89.6h-89.6v-89.6zm-89.6 119.5H448V480h-89.6z" })
  }
), ZL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h64v64H0zm0 96h64v64H0zm64 96v64H0v-64zM0 320h64v64H0zm64 96v64H0v-64zM96 32h64v64H96zm64 96v64H96v-64zm-64 96h64v64H96zm64 96v64H96v-64zm-64 96h64v64H96zM256 32v64h-64V32zm-64 96h64v64h-64zm64 96v64h-64v-64zm-64 96h64v64h-64zm64 96v64h-64v-64zm32-384h64v64h-64zm64 96v64h-64v-64zm-64 96h64v64h-64zm64 96v64h-64v-64zm-64 96h64v64h-64zM448 32v64h-64V32zm-64 96h64v64h-64zm64 96v64h-64v-64zm-64 96h64v64h-64zm64 96v64h-64v-64z" })
  }
), JL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h512v48H0zm80 144v32h32v-32zM32 96h128v128H32v-80zm48 336v32h32v-32zm-48-48h128v128H32v-80zm240-240h-32v32h32zm-32-48h80v128H192V96zm0 336v32h32v-32zm-48-48h128v128H192v-80zm240-240h-32v32h32zm-32-48h80v128H352V96zm0 336v32h32v-32zm-48-48h128v128H352v-80zm160-96v48H0v-48z" })
  }
), jL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 168v48h48v-48zM0 128h128v128H0v-88zm40 200v48h48v-48zM0 288h128v128H0v-88zm248-120h-48v48h48zm-48-40h88v128H160V128zm0 200v48h48v-48zm-40-40h128v128H160v-88zm248-120h-48v48h48zm-48-40h88v128H320V128zm0 200v48h48v-48zm-40-40h128v128H320v-88z" })
  }
), YL = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 128a48 48 0 1 0 96 0 48 48 0 1 0-96 0m48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192M80 384a48 48 0 1 0 96 0 48 48 0 1 0-96 0m48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192m256-304a48 48 0 1 0 0-96 48 48 0 1 0 0 96m96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0m-96 144c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24" })
  }
), _L = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0m-96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96m96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0m112-256a48 48 0 1 0 96 0 48 48 0 1 0-96 0m48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192m0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96m96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0" })
  }
), hB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0m44.8 106.7a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6M0 196.3a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0m57.6 119.4a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0m-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6M0 435.2a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0M177.1 76.8a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0M164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm57.6 119.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0M164.3 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm177-358.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0M283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm57.6 119.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0M283.7 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM416 76.8a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0M403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0M416 315.7a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0m-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6m0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6m-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0" })
  }
), cB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m0 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0M32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64M160 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64M352 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), sB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0M64 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128m24 224a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128m0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48M0 416a64 64 0 1 0 128 0 64 64 0 1 0-128 0M248 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128m0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0m88 160a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128M384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0m88 160a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128m0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0" })
  }
), vB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 72v48H40V72zM40 32H0v128h128V32H88zm48 200v48H40v-48zm-48-40H0v128h128V192H88zm0 200h48v48H40zM0 352v128h128V352H40zM248 72v48h-48V72zm-48-40h-40v128h128V32h-40zm0 200h48v48h-48zm-40-40v128h128V192h-88zm88 200v48h-48v-48zm-48-40h-40v128h128V352h-40zM360 72h48v48h-48zm-40-40v128h128V32h-88zm88 200v48h-48v-48zm-48-40h-40v128h128V192h-40zm0 200h48v48h-48zm-40-40v128h128V352h-88z" })
  }
), eB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v16c0 97.2 78.8 176 176 176 7.8 0 15.4-.5 22.9-1.5-8.5 15.8-15.3 32.3-19.2 49.4H224c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h72.8c1.4 16.7 4.9 32.8 10.2 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96V32h448v64c0 24.1-3.8 47.4-10.9 69.1-13-12.4-26.5-24.2-40.3-35.7 2.1-10.8 3.2-22 3.2-33.5zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48m353-215.9c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160 128-192 128-192 32.6 26.4 65 64zM466 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), lB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0v26.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V128h-48v-26.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V0zm112 0v26.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V128h-48v-26.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V0zm144 160h48c0 16.5-1.8 32.5-5.2 48-14.1 64.6-56.1 118.8-112.7 149.3l48 111.9 9.5 22.1-44.1 18.9-9.5-22.1-7-16.1H155.3c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8.3 10.1.8l11.8-27.5C61.3 326.8 19.3 272.6 5.2 208 1.8 192.5 0 176.5 0 160h48zM285.6 375.4c-19.5 5.6-40.2 8.6-61.6 8.6s-42.1-3-61.6-8.6L147.5 410c3.2 4.3 5.8 9 7.8 14h151.2l-20.8-48.6zM224 336c80.6 0 148.5-54.1 169.4-128H54.6c20.9 73.9 88.8 128 169.4 128M120 448a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), tB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v16c0 97.2-78.8 176-176 176S48 193.2 48 96V80zM48 32H0v64c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64h156.7l13.2 30.8 4 9.3 9.5 22.1 44.1-18.9-9.5-22.1-4-9.3L318.8 299C395.1 263.3 448 185.8 448 96V32h-48zm248.2 336H151.8l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4zM96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), wB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), gB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 192a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-160 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0M64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m288 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M32 320a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), iB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32H8v448h48zm128 0h-48v448h48z" })
  }
), mB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 216v-48H0v48zm0 128v-48H0v48z" })
  }
), aB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 440v-48h48v48zM0 480h128V352H0v88zm232-40v-48h48v48zm-40 40h128V352H192v88zM40 232h48v48H40zM0 280v40h128V192H0v40zm232 0v-48h48v48zm-40 40h128V192H192v88zM40 72h48v48H40zM0 120v40h128V32H0v40zm232 0V72h48v48zm-40 40h128V32H192v88z" })
  }
), oB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 376v-48h-48v48zm40 40H320V288h128v88zm-40-232v-48h-48v48zm40 40H320V96h128v88zM200 376h48v-48h-48zm48 40h-88V288h128v128zm0-232v-48h-48v48zm40 40H160V96h128v88zM40 376h48v-48H40zm48 40H0V288h128v128zm0-232v-48H40v48zm40 40H0V96h128v88z" })
  }
), nB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M158.3 81.4c21-11.8 44.3-19.9 69.1-23.4l-6.8-47.5c-32.5 4.6-63 15.6-90.1 31.6C120.5 35.7 108.7 32 96 32c-35.3 0-64 28.7-64 64 0 12.7 3.7 24.5 10.1 34.5-16 27.2-26.9 57.6-31.6 90.1l47.5 6.8c3.5-24.8 11.6-48.1 23.4-69.1 4.7 1.1 9.6 1.7 14.6 1.7 35.3 0 64-28.7 64-64 0-5-.6-9.9-1.7-14.6m272.2 76.9c11.8 21 19.9 44.3 23.4 69.1l47.5-6.8c-4.6-32.5-15.6-63-31.6-90.1 6.4-10 10.1-21.8 10.1-34.5 0-35.3-28.7-64-64-64-12.7 0-24.5 3.7-34.5 10.1-27.2-16-57.6-26.9-90.1-31.6L284.6 58c24.8 3.5 48.1 11.6 69.1 23.4-1.1 4.7-1.7 9.6-1.7 14.6 0 35.3 28.7 64 64 64 5 0 9.9-.6 14.6-1.7zM81.4 353.7c-11.8-21-19.9-44.3-23.4-69.1l-47.5 6.8c4.6 32.5 15.6 63 31.6 90.1-6.4 10-10.1 21.8-10.1 34.5 0 35.3 28.7 64 64 64 12.7 0 24.5-3.7 34.5-10.1 27.2 16 57.6 26.9 90.1 31.6l6.8-47.5c-24.8-3.5-48.1-11.6-69.1-23.4 1.1-4.7 1.7-9.6 1.7-14.6 0-35.3-28.7-64-64-64-5 0-9.9.6-14.6 1.7zm272.2 76.9c-21 11.8-44.3 19.9-69.1 23.4l6.8 47.5c32.5-4.6 63-15.6 90.1-31.6 10 6.4 21.8 10.1 34.5 10.1 35.3 0 64-28.7 64-64 0-12.7-3.7-24.5-10.1-34.5 16-27.2 26.9-57.6 31.6-90.1l-47.4-6.8c-3.5 24.8-11.6 48.1-23.4 69.1-4.7-1.1-9.6-1.7-14.6-1.7-35.3 0-64 28.7-64 64 0 5 .6 9.9 1.7 14.6zM80 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0m0 320a16 16 0 1 1 32 0 16 16 0 1 1-32 0M416 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-16 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0M227.7 313.8c-20.8-10.6-34.9-32.2-34.9-57 0-15.6 5.6-29.9 14.9-41.1l25.9 25.9V160H152l21.7 21.7c-17.9 19.8-28.9 46.2-28.9 75.1 0 43.6 24.9 81.3 61.1 99.8l21.8-42.7zm93.1-58.6c0 15.6-5.6 29.9-14.9 41.1L280 270.4V352h81.6l-21.7-21.7c17.9-19.8 28.9-46.2 28.9-75.1 0-43.6-24.9-81.3-61.1-99.8l-21.8 42.7c20.8 10.6 34.9 32.2 34.9 57z" })
  }
), rB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-48v65.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5V512h48v-65.5c94.7-11.8 168-92.6 168-190.5v-24H216V114c29.7 5 56.2 19 76.8 39.2l33.6-34.3C297.2 90.2 258.8 70.8 216 65.5zm-48 114v284C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142m48 284V280h118c-10.1 60.3-57.7 107.9-118 118" })
  }
), dB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 126.1V64l96-64 39.2 31.4c21.7 17.4 23.5 49.8 3.8 69.5-14.5 14.5-36.6 17.7-54.5 8.5L308.2 237.8c13.5 9.4 24.9 10.7 32.7 10.3 5.5-.3 10-1.6 13-2.8 1.5-.6 2.6-1.1 3.2-1.4l.4-.2 16-10.1 13.5 13.6 15.8 15.8 17 17-17 17-28.8 28.8c-12.3 12.3-27.1 19.6-38.2 25.1l-1.2.6c-12.4 6.2-20.6 10.5-26.9 16.8-10.7 10.7-15 24.8-20.8 46.4l-.5 1.9c-5.2 19.4-12.2 45.4-32.7 66-19.1 19.1-44.1 29-69.1 29.7-26.8.7-53.9-9.2-74.4-29.7l-.1-.1L29.7 401c-39.6-39.6-39.6-103.9 0-143.5 20.4-20.4 46.2-27.4 65.4-32.6l1.8-.5c21.4-5.8 35.4-10.2 46-20.8 6.3-6.3 10.6-14.5 16.8-26.9l.6-1.2c5.5-11.1 12.9-25.9 25.1-38.2l40.7-40.7 17-17 17 17 15.8 15.8 14.4 14.4-11.7 16.4-.1.1c-.1.2-.4.6-.7 1.1-.7 1.1-1.7 2.8-2.8 5.1-2.3 4.6-4.9 11-6.3 18.3-2.1 10.6-1.9 23 5.8 35.8zm-160 128 17 17 32 32 17 17-34 33.8-17-17-32-32-17-17zm-64 64 17 17 32 32 17 17-34 33.8-17-17-32-32-17-17zm91.5-146.9c-6.2 6.2-10.5 14.4-16.7 26.8l-.5 1.1c-5.5 11.1-12.9 26-25.3 38.4-20.4 20.4-46.3 27.5-65.6 32.7l-1.8.5c-21.4 5.8-35.4 10.1-46 20.7-20.9 20.9-20.9 54.8 0 75.6l.1.1 80.4 81.2c10.8 10.8 25 16 39.2 15.6 13.2-.3 26.3-5.6 36.4-15.6 10.7-10.7 15-24.7 20.7-46.3l.5-1.8c5.2-19.4 12.2-45.5 32.7-66.1 12.4-12.4 27.2-19.8 38.4-25.3l1.1-.5c9.3-4.6 16.2-8.2 21.7-12.3-22-.8-47.9-9.6-73.1-34.8L250 249.3c-25.9-25.9-32-54.6-30.1-78.5l-.4.4" })
  }
), SB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M363.3 114.7 376 64l72-64 64 64-64 72-50.7 12.7-43.8 43.8c38.2 50.8 41.4 115.2 4.6 152-12 12-26.8 19.7-43.2 23.4-18.1 4.1-33.5 20.8-34.5 39.4-1.4 27.9-11.7 53.8-31.2 73.4-48.9 48.7-137.2 39.6-197.4-20.5s-69.2-148.5-20.4-197.4c19.6-19.6 45.5-29.8 73.4-31.3 18.5-.9 35.3-16.4 39.4-34.5 3.7-16.4 11.4-31.2 23.4-43.2 36.8-36.8 101.2-33.6 152 4.6l43.8-43.8zm-78.1 78.1c-36-24.5-70.6-18.1-83.8-5-5 5-8.6 11.5-10.5 19.8-8.3 37-41.6 69.7-83.8 71.9-17.6.9-31.7 7.1-41.9 17.3-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9 2.1-42.2 34.9-75.4 71.9-83.8 8.3-1.9 14.8-5.5 19.8-10.5 13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8c1.1 4 1.6 8.1 1.6 12.4 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c4.3 0 8.5.6 12.4 1.6l64.8-64.8z" })
  }
), zB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 178v-44.3l21.5-42.9 2.5-5.1V0H80v85.7l2.5 5.1 21.5 42.9V178c-50.3 8.6-88 43.8-88 86 0 14 4.2 27.3 11.6 39.1 8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104 29.3 0 56.3-8 77.8-21.4-8.4-14.7-13.4-31.7-13.8-49.7-13.1 12.9-34.3 23.2-64 23.2-54 0-80-33.9-80-56 0-9.7 3.7-19.8 12.4-29.3 26.2-29 26.4-71.9 7.8-101.2-3-4.8-4.2-9.2-4.2-13.5 0-9.6 11.2-29.7 40-37.1v109h48V226.9c28.8 7.4 40 27.5 40 37.1 0 4.2-1.2 8.7-4.2 13.5-18.6 29.4-18.4 72.2 7.8 101.2 2.1 2.3 3.9 4.7 5.5 7.1 4.7-13.9 10.4-26.2 15.3-36.6l.8-1.6c2.6-5.5 4.9-10.4 6.8-14.8-2.6-9.9-1.1-21 4.4-29.6 1.2-1.9 2.3-3.8 3.3-5.7-.4-3.5-1.1-6.4-1.8-8.9-1-3.3-2.2-6.8-3.6-10.8l-.4-1.2c-3.3-9.7-8-23.4-9.4-38-.3-2.9-.4-5.9-.4-9v-20c-15.8-15.7-38.2-27.1-64-31.5zm160-66 32 36.6V240c-23.7 0-38.6-8.8-48-19.8-16-18.8-16-44.2-16-44.2h-32v53.5c0 2 .1 4 .3 6 1 10.8 4.7 21.4 8.2 31.9 1.4 4 2.7 7.9 3.9 11.8 2.1 6.8 3.6 15.1 3.6 24.8 0 19.2-8.6 37.5-17.8 57.2-10.7 22.8-22.2 47.3-22.2 77 0 40.8 33 73.8 73.8 73.8h140.4c40.8 0 73.8-33 73.8-73.8 0-29.7-11.5-54.3-22.2-77-9.2-19.7-17.8-38-17.8-57.2 0-9.8 1.5-18 3.6-24.8 1.2-3.9 2.6-7.9 3.9-11.8 2.5-7.3 5-14.6 6.6-22.1.4-1.8.7-3.5 1-5.3.6-3.5.9-7 .9-10.5V192h-32s0 19-16 33.1c-9.4 8.3-24.3 14.9-48 14.9V74.1c9.6-6.4 16-17.3 16-29.7V40c0-22.1-17.9-40-40-40h-32zm0 192c0-7.2-.5-14-1.5-20.4 10.4 2.9 21.6 4.4 33.5 4.4h48c12.1 0 23.2-1.3 33.4-3.6-.9 6.2-1.4 12.7-1.4 19.6 0 30.6 13.4 58.9 22 76.9.9 1.9 1.7 3.6 2.5 5.3 9.9 21.2 15.5 35.9 15.5 52.1 0 14.2-11.6 25.8-25.8 25.8H297.8c-14.2 0-25.8-11.6-25.8-25.8 0-16.2 5.6-30.9 15.5-52.1.8-1.6 1.6-3.4 2.5-5.3 8.6-18 22-46.2 22-76.9m8 80v48h96v-48h-72z" })
  }
), pB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-208.5-161.9 20.5-57.4h49l7-7 25-25H608V64h-48V32h-48v32H111.8L48.4 14.8zM173.6 112H560v48h-65.9l-7 7-25 25H276.6l-103-80zm164.9 128H382l-9.4 26.4-34-26.4zM80 192v-33l-48-37.8V240h92L76 432l-12 48h176l32-128h52.9l-85.5-67.4L202.5 432h-77l48-192h9.3l-60.9-48z" })
  }
), MB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 56V32H80v33.3C34.6 72.9 0 112.4 0 160c0 50.4 38.8 91.7 88.1 95.7L44 432l-12 48h160l26-104h54v40h48V288h-48v40h-42l18-72h296v-64h32v-64h-32V64H128zm82.5 152H96c-26.5 0-48-21.5-48-48s21.5-48 48-48h400v96H260zm-117 224 44-176h61l-44 176zM96 144H80v32h384v-32h-16z" })
  }
), xB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 56V32h-48v32H0v176h92L44 432l-12 48h176l32-128h120.9l5.7-15.9 34.3-96.1h49l7-7 25-25H576V64h-48zM252 304l16-64h81.9L327 304zm-33.5-64-48 192h-77l48-192zm61.5-48H48v-80h480v48h-65.9l-7 7-25 25z" })
  }
), HB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 256v224h48V32h-48v176H48V32H0v448h48V256z" })
  }
), VB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48V272h224v176h48V64h-48v160H48zm336.4 83.1 20.4-12.7 51.3-32V400H384v48h192v-48h-72V64h-38.9l-5.8 3.6-75.3 47v55.8l.4.6z" })
  }
), CB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48V272h224v176h48V64h-48v160H48zm442.7 24h9.2c42.1 0 76.2 34.1 76.2 76.2 0 21.3-8.9 41.5-24.5 56L375.7 406.4l-7.7 7.1V448h272v-48H453.4l130.7-120.6c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4-18.2 15.6 31.2 36.4 18.2-15.6 29.7-25.4C457.9 118 474 112 490.7 112" })
  }
), LB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48V272h224v176h48V64h-48v160H48zm552-24H376v48h166.1L423 231l-7 7v34h112c35.3 0 64 28.7 64 64s-28.7 64-64 64h-70.6c-16.1 0-29.8-12-31.8-28l-1.8-15-47.6 6 1.9 14.9c5 40 39 70.1 79.4 70.1H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-30.1L617 105l7-7V64z" })
  }
), BB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 64v160h224V64h48v384h-48V272H48v176H0V64zm592 0v384h-48V304H362.5l6-28.9 44-211.1h49l-40 192H592V64z" })
  }
), uB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48V272h224v176h48V64h-48v160H48zm392-24h-20.7l-3.1 20.4-24 160-4.1 27.6H528c35.3 0 64 28.7 64 64s-28.7 64-64 64h-61.8c-14.3 0-26.8-9.5-30.8-23.2l-4.4-15.4-46.2 13.2 4.4 15.4c9.8 34.3 41.2 58 76.9 58H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-84.1l16.8-112H608V64h-24z" })
  }
), RB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 88V64H0v384h48V272h224v176h48V64h-48v160H48zm339.2 107.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8 0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144c-6.8 0-13.4.5-20 1.4L553.9 64h-61.4zM400 304a96 96 0 1 1 192 0 96 96 0 1 1-192 0" })
  }
), $B = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m283.9 344.9 3-21.7 47.4 23.7 13.1-26.2 21.1-8 29.9-11.4 22 23.2 24.6 25.9 10.9-34 9.8-30.4 31.8-2.7 35.5-3.1-19.8-29.7-17.8-26.5 17.7-26.6 19.8-29.7-35.5-3.1-31.8-2.7-9.8-30.4-5.4-16.7.5-1.1-1-.5-5-15.7-8.5 8.9L391.5 84l36.6-38.6 37.7-39.8 16.7 52.1 18.9 59.1 61.8 5.3 54.6 4.7-30.3 45.6-34.4 51.6 34.4 51.6 30.3 45.6-54.6 4.7-61.8 5.3-18.9 59.1-16.7 52.1-37.7-39.7-42.7-45-58 22-51.2 19.4 7.6-54.2zM64.4 122.5l234.1 117.1 45.1-90.1L172.7 64h-79zm-21.5 43L0 144l21.5-42.9L64 16h120l181.1 90.5L408 128l-21.5 42.9-45.1 90.1-21.4 43-42.9-21.5-89.2-44.6L64.5 484.7l-43-21.4 123.4-246.8-102-51z" })
  }
), kB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 24V0h-48v58.7L48 32H0v256h48l144-32 144 32h48V32h-48L216 58.7zm0 270.1-24-5.3-24 5.3V512h48v-24zm-34.4-85L48 238.8V81.2l133.6 29.7c6.9 1.5 14 1.5 20.8 0L336 81.2v157.6l-133.6-29.7c-6.9-1.5-14-1.5-20.8 0z" })
  }
), PB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m504 136-33.9-33.9-64.6-64.6C381.5 13.5 348.9 0 315 0h-23.5c-23.2 0-46 6.3-65.9 18.2l-.8.5L176 48l50.9 25.4L272 96v48l78.1 78.1L384 256l16-16 33.9 33.9 4.1 4.1 1 1-4.8 4.8-17 17 33.9 33.9 17-17 89.6-89.6 17-17-33.9-33.9L527 191l-1-1-4.1-4.1L488 152zm-67.9 0-16 16 33.9 33.9 38.1 38.1-20.1 20.1-38.1-38.1-33.9-33.9-16 16-64-64V66.3l-26.5-13.2-9.5-4.8c2.5-.2 4.9-.3 7.4-.3H315c21.2 0 41.6 8.4 56.6 23.4zM264 181.3 0 416l96 96 234.7-264z" })
  }
), FB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0h-24v32H88v224H0v89.9l7 7 95.4 95.4c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6L505 353l7-7v-90h-88V32h-96V0h-24zm120 80h48v224h88v22.1l-88.4 88.4C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5L48 326.1V304h88V80h48v144h48V48h48v176h48v-24zM160 352s48 64 96 64 96-64 96-64-48-64-96-64-96 64-96 64m96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), TB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0H96v124l-54.4 40.8L32 172v61.5c0 51.8 23 100.9 62.8 134 10.3 8.6 21.4 15.9 33.2 21.8V512h48V357.4l-15.3-5.9c-12.7-4.9-24.6-11.9-35.2-20.7C96.7 306.7 80 271.1 80 233.5V196l32-24v52h32V48h32v32h64v32h64v32h64v120c0 .7-.1 1.4-.2 2l-.4 1.5-.2 1.5c-4.1 33-23.6 61.2-51.2 77.2l-12 6.8v159h48V379.9c33.5-23.8 57-61 62.7-103.8.9-3.9 1.3-8 1.3-12.1V96h-64V64h-64V32h-64V0h-24z" })
  }
), AB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 512H80V260.8l-56.1-51-7.9-7.2v-49.1c0-54 28.7-104 75.4-131.3l2.6-1.5C117.3 7.1 143.7 0 170.6 0H296c66.3 0 120 53.7 120 120v168h-64v32h-72v32h-72v160h-24zm128-240h72v-32h64V120c0-39.8-32.2-72-72-72H170.6c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5v27.9l32 29.1V152h32v312h32V304h72v-8z" })
  }
), DB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 136v-24h251.2l51-56.1 7.1-7.9h49.2c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6V328c0 66.3-53.7 120-120 120H224v-64h-32v-72h-32v-72H0v-24zm240 128v72h32v64h120c39.8 0 72-32.2 72-72V202.6c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6h-27.9l-29.1 32H360v32H48v32h160v72h8z" })
  }
), yB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h128v160h72v32h72v32h64v168c0 66.3-53.7 120-120 120H186.6c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5v-49.1l7.9-7.1 56.1-51V176H32l43.6-48L32 80h64V24zm48 176v184h-32v-58.5l-32 29.1v27.9c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2H312c39.8 0 72-32.2 72-72V272h-64v-32h-72v-32h-72v-32zm32-96V48h-32v32z" })
  }
), bB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 136v-24H260.8l-51-56.1-7.2-7.9h-49.1c-54 0-104 28.7-131.3 75.4l-1.5 2.6C7.1 149.3 0 175.7 0 202.6V328c0 66.3 53.7 120 120 120h168v-64h32v-72h32v-72h160v-24zM272 264v72h-32v64H120c-39.8 0-72-32.2-72-72V202.6c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6h27.9l29.1 32H152v32h312v32H304v72h-8z" })
  }
), fB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 0H80v251.2l-56.1 51-7.9 7.2v49.1c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H296c66.3 0 120-53.7 120-120V224h-64v-32h-72v-32h-72V0h-24zm128 240h72v32h64v120c0 39.8-32.2 72-72 72H170.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5c-32-18.6-51.6-52.8-51.6-89.8v-27.9l32-29.1V360h32V48h32v160h72v8z" })
  }
), UB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h128v32h80v64h80v232c0 101.6-82.4 184-184 184h-8.5c-67.9 0-133-27-181-75l-92.6-92.5-6.9-7-7-7V267.9l7-7 35.2-35.2 17-17 17 17 28.3 28.3 7.5 7.5V32h80v-8zm-32 80v233.9l-7 7-7.7 7.7-17 17-17-17-40.8-40.7-11.3-11.3L48 287.8v22.9l92.5 92.5c39 39 91.9 60.9 147.1 60.9h8.4c75.1 0 136-60.9 136-136V144h-32v112h-48V80h-32v176h-48V48h-32v208h-48V80zm80 240a16 16 0 1 1 32 0 16 16 0 1 1-32 0m48 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-48 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-80-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), GB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M197.4 10.3 175.6.2l-10.1 21.7L152 50.8l-4.1-8.8-10.2-21.8L116 30.3 43.5 64.1 21.7 74.3 31.9 96l49.5 106.2L63.8 240H32v104c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V160h-80v-32h-78.8l24.2-52 10.1-21.8-21.6-10.1-72.5-33.8zM114.5 84l11 23.6-17.7 37.9-22.3-48zM152 240h-35.3l82.1-176 29 13.5zm216-32v80h-32v-80zm-56 128h56v8c0 66.3-53.7 120-120 120h-48c-66.3 0-120-53.7-120-120v-56h128v32h-80v48h128v-64h32v32zm-56-160h32v80h-32z" })
  }
), qB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h128v32h80v64h80v160c0 51.2-25.3 96.4-64 123.9V512h-48V353l12-6.9c26.7-15.5 45.9-42.4 50.8-74.1H288v-32h-32v64H128v-48h80v-32H80v32.1c0 48.4 33.2 89.1 78 100.6l18 4.6V512h-48V397.3C74.1 376 35.4 324.7 32.2 264H32v-88h16V32h80v-8zm240 168v-24h-32v80h32v-32zM128 80H96v96h32zm80 96V48h-32v128zm48 16h32V80h-32z" })
  }
), WB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h128v32h80v64h80v232c0 101.6-82.4 184-184 184h-8.5c-67.9 0-133-27-181-75l-92.6-92.5-6.9-7-7-7V267.9l7-7 35.2-35.2 17-17 17 17 28.3 28.3 7.5 7.5V32h80v-8zm-32 80v233.9l-7 7-7.7 7.7-17 17-17-17-40.8-40.7-11.3-11.3L48 287.8v22.9l92.5 92.5c39 39 91.9 60.9 147.1 60.9h8.4c75.1 0 136-60.9 136-136V144h-32v112h-48V80h-32v176h-48V48h-32v208h-48V80zm48 247.5c0-21.8 17.7-39.5 39.5-39.5h1.6c10.6 0 20.8 4.1 28.5 11.5l5.1 4.9 5.1-4.9c7.7-7.4 17.9-11.5 28.5-11.5h1.6c21.8 0 39.5 17.7 39.5 39.5 0 10.7-4.4 21-12.1 28.4L290.1 409l-7.4 7.1-7.4-7.1-55.2-53.1a39.49 39.49 0 0 1-12.1-28.4z" })
  }
), EB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48v80l64-32 64 32V48h80v160H144V48zM144 0H96v256h384V0h-48zm24 304h-7.3l-6 4-90 60H0v48h79.3l6-4 90-60H360v32H232v48h175l5.9-3.7 80.4-51 15 24-91.7 62.7H0v48h431.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13-79.9 50.7V304h-24z" })
  }
), OB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32v2.9c6.4 1.2 14.3 2.8 18.2 3.9l23.2 6.2L341 91.4l-23.2-6.2c-3.7-1-17-3.6-21.3-4.3-11.6-1.8-20.8-.3-26.4 2.3-5.5 2.5-5.9 4.8-5.9 5.1-.3 1.5-.2 2.3-.2 2.7.2.2.7.9 2.2 1.9 5.5 3.7 14.4 6.6 28.8 10.9l1 .3c12 3.6 28.7 8.7 41.4 17.9 7.1 5.2 14 12.3 18.2 22.1 4.3 9.9 5.1 20.7 3.2 31.7-3.6 20.6-17.3 34.5-34 41.7-4.2 1.8-8.5 3.2-13 4.2V248H264v-27.2c-9.3-2.4-20.3-6.1-27.3-8.5-1.7-.6-3.1-1.1-4.2-1.4l-22.8-7.6 15.2-45.5 22.8 7.6c2.1.7 4.3 1.5 6.6 2.2 9.5 3.2 19.7 6.7 25.4 7.6 12.3 1.9 21.4.6 26.6-1.6 4.4-1.9 5.3-3.8 5.6-5.8.3-1.8.3-2.9.2-3.5-.1-.6-.2-.8-.2-.9 0-.1-.4-.9-2.4-2.4-5.2-3.8-14-6.8-28.1-11.1l-2.3-.7c-11.6-3.5-27.5-8.2-39.6-16.5-7-4.8-14.1-11.5-18.7-21.1-4.6-9.8-5.6-20.5-3.7-31.4 3.5-20 17.6-33.5 33.4-40.7 4.3-2 8.9-3.5 13.6-4.7V8h48v24zm-47.9 59.1V91zM160.7 304H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), IB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 0 76.8 102.4C377.3 119 384 139.2 384 160c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6zM160.7 304H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), NB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M149.3 270.2h-6.5l-5.4 3.6-80 53.3H0v42.7h70.5l5.4-3.6 80-53.3H320v28.4H206.2V384h155.5l5.2-3.3 71.5-45.4 13.3 21.3-81.5 55.8H0v42.7H383.5l5.4-3.7 103.8-71.1 16.9-11.6-10.8-17.3-35.6-56.9-11.4-18.2-18.1 11.5-71.1 45.1V270.2h-21.3zm213.3-28.4h6.5l5.4-3.6 80-53.3H512v-42.7h-70.5l-5.4 3.6-80 53.3H192v-28.4h113.8V128H150.2l-5.2 3.3-71.5 45.4-13.3-21.3 81.5-55.8H512V56.9H128.5l-5.4 3.7-103.9 71.1-16.8 11.6 10.8 17.3 35.6 56.9 11.4 18.2 18.1-11.5 71.1-45.1V241.7h213.3z" })
  }
), XB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M167.2 135.1a79.09 79.09 0 0 1-23.2-56v-3.5c0-41.8 33.9-75.7 75.6-75.7 23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6C311.6 10.4 333.4-.1 356.4-.1c41.7 0 75.6 33.9 75.6 75.7v3.6c0 21-8.3 41.1-23.2 56L384 159.9l-96 96-96-96zM160.7 304H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), KB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 76c0 15.5 12.5 28 28 28h108v48H204c-42 0-76-34-76-76s34-76 76-76h124c66.3 0 120 53.7 120 120s-53.7 120-120 120h-48v48h-48v-96h96c39.8 0 72-32.2 72-72s-32.2-72-72-72H204c-15.5 0-28 12.5-28 28m-15.3 228H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), QB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h96v80h80v96h-80v80h-96v-80h-80V80h80zm-63.3 304H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), ZB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 0H80v24c0 83.9 68.1 152 152 152h32v104h48V152C312 68.1 243.9 0 160 0zm128 128c-49.2 0-90.4-34.1-101.2-80H160c49.2 0 90.4 34.1 101.2 80zm-64 176h-7.3l-6 4-90 60H0v48h79.3l6-4 90-60H360v32H232v48h175l5.9-3.7 80.4-51 15 24-91.7 62.7H0v48h431.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13-79.9 50.7V304h-24zm184-128c83.9 0 152-68.1 152-152V0h-80c-44.1 0-83.9 18.8-111.6 48.8 10 14.7 17.9 30.9 23.3 48.3C354 67.6 386.7 48 424 48h29.2c-10.8 45.9-52 80-101.2 80h-9.6c1 7.9 1.6 15.9 1.6 24v24z" })
  }
), JB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 128c0 29.9 20.4 58.1 53.8 71.8l16.7 6.9-2 18-1.7 15.3h58.4l-1.7-15.3-2-18 16.7-6.9c33.4-13.7 53.8-41.9 53.8-71.8 0-41.1-39.6-80-96-80s-96 38.9-96 80M288 0c76.2 0 144 54.2 144 128 0 46.7-27.7 86.1-66.9 108.2l2.8 25.2 3 26.7H205.2l3-26.7 2.8-25.2c-39.3-22.1-67-61.5-67-108.2C144 54.2 211.8 0 288 0m-40 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M160.7 304H408v70.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H0V464h416.6l91.7-62.8-15-24-80.4 51-5.9 3.8H232v-48h128v-32H175.3l-90 60-6 4H0v-48h64.7l90-60z" })
  }
), jB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 304h-7.3l-6 4-90 60H0v48h79.3l6-4 90-60H360v32H232v48h175l5.9-3.7 80.4-51 15 24-91.7 62.7H0v48h431.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13-79.9 50.7V304h-24z" })
  }
), YB = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 0h128v144h80v32h32V64h128v280c0 92.8-75.2 168-168 168h-48C75.2 512 0 436.8 0 344V240h16V24zm32 320v24c0 66.3 53.7 120 120 120h48c66.3 0 120-53.7 120-120V112h-32v256H96v-48h80v-32H48zm128-120v-8h-32v48h32zm-80-32V48H64v192h32zm160 56h-32v96h32v-64z" })
  }
), _B = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h355.7l7.2 9.2 144 184 5.1 6.5V448h-48V280.3L332.3 112H48v48h192c35.3 0 64 28.7 64 64s-28.7 64-64 64H112v48h182.9l5.8 3.6 64 40 11.3 7V448h-48v-34.7L281.1 384H64V240h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V88z" })
  }
), hu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h-24v261.5l-7.5-7.5-28.3-28.3-17-17-17 17L7 260.9l-7 7v62.5l7 7 6.9 6.9 92.6 92.7c48 48 113.1 75 181 75H320v-1.6c90.3-11.8 160-89 160-182.4 0-3.5-.1-6.9-.3-10.3.2-1.9.3-3.8.3-5.7V64H352v112h-32v-32h-80V0h-24zm264 344V112h32v200c0 .4 0 .9-.1 1.3l-.4 2.6.2 2.7c.2 3.1.3 6.3.3 9.4 0 75.1-60.9 136-136 136h-8.8c-55-.1-107.8-22-146.7-60.9L48 310.6v-22.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17 7.7-7.7 7-7V48h32v320h208zm-48-120v96h-32v-96zm-112 96V192h32v128z" })
  }
), cu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0h-24v184H88v74.5l-48.1 43.7-7.9 7.2v49.1c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H312c66.3 0 120-53.7 120-120V224h-72v-32h-72V0h-24zm56 240h72v32h72v120c0 39.8-32.2 72-72 72H186.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5c-32-18.6-51.6-52.8-51.6-89.8v-27.9l24-21.8V360h32V232h72V48h32v168z" })
  }
), su = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.3 3.3 186.5.8 184 24.6 174 119l-26.4-75.2-8-22.6-22.6 8-75.5 26.5-22.6 8 8 22.6 54 153.7H64v104c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V160h-80v-32h-66.2l9.5-90 2.5-23.9-23.9-2.5-79.6-8.3zM288 181.7c2.2-1.6 4.1-3.5 5.7-5.7H320v80h-32zM253.5 128H240v112h-23.4l-5.4-15.3 18-171.2 31.8 3.4zM110.3 82.4 165.7 240h-33.9L80.1 93zM400 256v32h-32v-80h32zm0 80v8c0 66.3-53.7 120-120 120h-48c-66.3 0-120-53.7-120-120v-56h128v32h-80v48h128v-64h32v32h24z" })
  }
), vu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 512H16V272H0V168C0 75.2 75.2 0 168 0h48c92.7 0 167.9 75.1 168 167.9V320h-80v16h-80v32h-80v144h-24zm296-256v-80h-32v96h32zm-6.8-128c-16.5-46.6-61-80-113.2-80h-48c-66.3 0-120 53.7-120 120v56h128v-32H96v-48h160v-16h24zM96 272H64v192h32V344zm80 0h-32v48h32v-8zm48 16h32v-96h-32v56z" })
  }
), eu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 104V80h240V64h104c92.8 0 168 75.2 168 168v48c0 92.7-75.1 167.9-167.9 168H192v-80h-16v-80h-32v-80H0v-24zm256 296h80v-32h-96v32zm128-6.8c46.6-16.5 80-60.9 80-113.2v-48c0-66.3-53.7-120-120-120h-56v128h32v-80h48v160h16v24zM240 160v-32H48v32h120zm0 80v-32h-48v32h8zm-16 48v32h96v-32h-56z" })
  }
), lu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0h128v80h16v64h64v32h80v16h80v152.1c-.1 92.8-75.3 167.9-168 167.9h-48c-92.8 0-168-75.2-168-168V240h16v-64H0l43.6-48L0 80h48V24zm48 176v64h32v-64zm32-96V48H96v32zm240 160h-32v96h32v-80zm-56 144h-24v-16H128v-48h80v-32H80v56c0 66.3 53.7 120 120 120h48c52.2 0 96.7-33.4 113.2-80zM176 192v48h32v-48zm112 32h-32v96h32z" })
  }
), tu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 104V80H272V64H168C75.2 64 0 139.2 0 232v48c0 92.7 75.1 167.9 167.9 168H320v-80h16v-80h32v-80h144v-24zM256 400h-80v-32h96v32zm-128-6.8c-46.6-16.5-80-61-80-113.2v-48c0-66.3 53.7-120 120-120h56v128h-32v-80h-48v160h-16v24zM272 160v-32h192v32H344zm0 80v-32h48v32h-8zm16 48v32h-96v-32h56z" })
  }
), wu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 0H16v240H0v104c0 92.8 75.2 168 168 168h48c92.7 0 167.9-75.1 168-167.9V192h-80v-16h-80v-32h-80V0h-24zm296 256v80h-32v-96h32zm-6.8 128c-16.5 46.6-60.9 80-113.2 80h-48c-66.3 0-120-53.7-120-120v-56h128v32H96v48h160v16h24zM96 240H64V48h32v120zm80 0h-32v-48h32v8zm48-16h32v96h-32v-56z" })
  }
), gu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h-24v260.6l-16.9-25.4-13.3-20-20 13.3-51.1 34.1L0 269.7V323.3l4 6 6.7 10.1 67.5 101.4c29.7 44.5 79.6 71.2 133.1 71.2H328c66.3 0 120-53.7 120-120V216h-64v-24h-72v-32h-72V0h-24zm128 240h72v24h64v128c0 39.8-32.2 72-72 72H211.5c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9l-2.7-4v-13.5l20.4-13.6 8.9 13.3 24.4 36.5 16.2 24.4 20.7-20.7L153 321l7-7V48h32v160h72v8zm-40 64v-16h-32v128h32v-16zm64-16h-32v128h32V304zm64 16v-16h-32v128h32v-16z" })
  }
), iu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m.3 195.6 23.4 5.2 41.5 9.2-38.4 1.3-24 .8.8 24 2.8 80 .8 24 24-.8 160.8-5.7V400h32v64h168c66.3 0 120-53.7 120-120V218.6c0-26.9-7.1-53.3-20.7-76.6l-19.8 11.5 19.8-11.5-1.5-2.6C462.5 92.7 412.5 64 358.5 64h-49.1l-7.1 7.9-45.1 49.6L51.4 75.8 28 70.6 22.8 94 5.5 172.1.3 195.6zM240 352v-68.1l-24.8.9-161.6 5.6-1.1-32 197.7-6.9 13.8-.5v-46.1l-9.7-2.1-196.8-43.7 6.9-31.2 195.9 43.4 2.4.5 85.6 19.7 15.6 3.6 7.2-31.2-15.6-3.6-57-13.2 32-35.2h27.9c37 0 71.2 19.6 89.8 51.6l20.8-12-20.7 12.1 1.5 2.6c9.3 15.9 14.2 34 14.2 52.4V344c0 39.8-32.2 72-72 72H272v-64h-24z" })
  }
), mu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0h-24v32h-80v229.5l-7.5-7.5-28.3-28.3-17-17-17 17L71 260.9l-7 7v62.5l7 7 6.9 6.9 92.6 92.7c48 48 113.1 75 181 75h8.5c46.3 0 88.6-17.1 120.9-45.3l-51.2-21.9C409.4 457 385.5 464 360 464h-8.5c-55.2 0-108.1-21.9-147.1-60.9L112 310.6v-22.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17 7.7-7.7 7-7V80h32v176h48V48h32v208h48V80h32v176h48V144h32v184c0 26.3-7.4 50.8-20.3 71.6l37.2-15.9L544 311V96h-80V32h-80V0h-24zM56 88 0 112l56 24 24 56 24-56 40-17.1v-13.8L104 88 80 32zm248 232-16 32-32 16 32 16 16 32 16-32 32-16-32-16zm232 88-56 24 56 24 24 56 24-56 56-24-56-24-24-56z" })
  }
), au = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m287.8 24.9-6.1-23.2-23.2 6.2-77.3 20.5-23.2 6.2 6.2 23.2 1.7 6.4-11.4 5.1-73 32.7-21.9 9.8 9.8 21.9 16.3 36.5 52.6 117.6-2.9-2.3-31.6-24.6-19-14.7L70 265.1l-49.1 63.2-14.7 18.9L25.1 362l31.6 24.6 92 71.6C193.6 493 248.9 512 305.9 512h39.6c66.1 0 123.7-45 139.7-109.1l56.9-227.4 9.7-38.8 5.8-23.3-23.3-5.8L466 90.5l4-22.7 4.2-23.6-23.6-4.2-78.8-14-23.6-4.2-4.2 23.6-7 39.4-13.3 75.1-25.6-96.3zM387 77.4l31.6 5.6-2.8 15.8-27.2 153-5 28.2H433.5l4.5-18.2 26.4-105.7 3.9-15.5 31 7.8-3.9 15.5-56.7 227.4C428 434 389.6 464 345.5 464H305.9c-46.3 0-91.2-15.4-127.7-43.8l-92-71.6-12.6-9.8 19.6-25.3 12.6 9.8L180 381l39.4-29.5-89.9-201-6.5-14.6 29.2-13.1 6.5 14.6L216 265.8l6.4 14.2h50.4l-8-30.2-44-165.7-4.1-15.5 30.9-8.2 4.1 15.5 49.4 186.3 4.7 17.8H351l3.5-19.8 29.7-167z" })
  }
), ou = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.2 0H320v32h28.2c15.9 0 30.4 9 37.5 23.2l28.6-14.3C401.8 15.8 376.2 0 348.2 0m-191 23.4-17 17L83.7 97l-17 17 17 17 5.7 5.7-39.6 39.5-17 17 17 17 28.3 28.3L38.5 278l-17 17 17 17 141.7 141.7C217.6 491 268.2 512 321 512h9.5C439.8 510.6 528 421.6 528 312V83.9H400V153L269.4 22.5l-17-17-17 17-39.5 39.6-21.7-21.7zm322.1 303.2C472 403.7 407 464 328 464c-2 0-4 0-5.9-.1l-10-.4-.2.2c-36.7-2.2-71.5-17.8-97.7-44L89.4 295l22.6-22.7 5.7 5.7 56.6 56.6 17 17 33.9-33.9-17-17-56.6-56.7-17-17-5.7-5.7-28.3-28.3 22.6-22.6 11.3 11.3 96.3 96.3 17 17 33.9-34-17-17-96.2-96.2-17-17-11.3-11.3-5.7-5.7 22.6-22.6 21.8 21.8 17 17 91.5 91.5 17 17 33.9-33.9-17-17L229.8 96l22.6-22.6L403.1 224H448v-92.1h32v173.7c0 1.8 0 3.7-.1 5.5l-.6 15.5zM63.8 397.7l-2.3-15.8-31.7 4.5 2.3 15.8 1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2 15.8 2.3 4.5-31.7-15.8-2.3-8.5-1.2c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5z" })
  }
), nu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-24v32h-80v229.5l-7.5-7.5-28.3-28.3-17-17-17 17L7 260.9l-7 7v62.5l7 7 6.9 6.9 92.6 92.7c48 48 113.1 75 181 75h8.5c101.6 0 184-82.4 184-184V96h-80V32h-80V0h-24zm-24 80v176h48V48h32v208h48V80h32v176h48V144h32v184c0 75.1-60.9 136-136 136h-8.5c-55.2 0-108.1-21.9-147.1-60.9L48 310.6v-22.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17 7.7-7.7 7-7V80z" })
  }
), ru = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.9 14 298 2.9l11.1 63L246 77.1zM96 160h34.7l29.3-29.3 29.3 29.3H224v45.3c56.5 24.7 96 81.1 96 146.7 0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7zm64 304a112 112 0 1 0 0-224 112 112 0 1 0 0 224m192-112c0-25.9-5.1-50.5-14.4-73.1 16.8-32.7 44.5-58.8 78.4-73.6V160h34.7l29.3-29.3 29.3 29.3H544v45.3c56.5 24.7 96 81.1 96 146.7 0 88.4-71.6 160-160 160-62 0-115.8-35.3-142.4-86.9 9.3-22.5 14.4-47.2 14.4-73.1m240 0a112 112 0 1 0-224 0 112 112 0 1 0 224 0M201.4 43.7l34.9 53.7-53.7 34.9-34.9-53.7 53.7-34.9zm237.2 0 53.7 34.9-34.9 53.7-53.7-34.9 34.9-53.7zM405.1 14 394 77.1 330.9 66 342 2.9 405 14z" })
  }
), du = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m221.3 1.1 16.5 17.4 55.1 58 8.7 9.2 6-1.9 7.2 22.9 11.4 36C354 109.1 394.9 96 432 96h54.1c85 0 154 68.9 154 154 0 15.9-2.5 31.8-7.3 46.9L573 483.5l-7.3 22.9-22.9-7.4-76.2-24.4-7.3-2.3-23.2 22.1-17.4 16.5-16.5-17.4-55.1-58-8.7-9.2-6 1.9-7.2-22.9-11.4-36C286 402.9 245.1 416 208 416h-54C68.9 416 0 347.1 0 262c0-15.9 2.5-31.8 7.3-46.9L67 28.5l7.4-22.9L97.2 13l76.2 24.4 7.3 2.3 23.2-22.1 17.4-16.5zm-85.4 74.6L105.4 66 53 229.7c-3.3 10.4-5 21.3-5 32.3 0 58.5 47.4 106 106 106h54.1c30.8 0 60.2-12.3 76.2-40l8-13.9-23.1-13.4-4.6-2.6-8 13.8c-8.7 15.1-25.6 24-48.5 24-31.1.1-56.1-25-56.1-55.9s25.1-56 56-56c22.9 0 39.8 9 48.5 24l8 13.8 4.6-2.6 23.1-13.4-8-13.8c-3.6-6.2-7.8-11.6-12.4-16.1l-28.3-28 38-12 4.5-1.4-9.7-30.5-34.6 10.9-99.1 31.3 75.4-71.6 23.7-22.5-22-23.2-49.1 46.7-68 64.6 28.6-89.3 4.8-15.1zm368.2 360.6 30.5 9.8L587 282.3c3.3-10.4 5-21.3 5-32.3 0-58.5-47.4-106-106-106h-54c-30.8 0-60.2 12.3-76.2 40l-8 13.8 23.1 13.4 4.6 2.6 8-13.8c8.7-15.1 25.6-24 48.5-24 30.9 0 55.9 25.1 55.9 56s-25.1 56-56 56c-22.9 0-39.8-9-48.5-24l-8-13.8-4.6 2.6-23.1 13.4 8 13.8c3.6 6.2 7.8 11.6 12.4 16.1l28.3 28-38 12-4.5 1.4 9.6 30.5 34.6-10.9 99.1-31.3-75.2 71.6-23.7 22.5 22 23.2 49.1-46.7 68-64.6-28.6 89.3-4.8 15.1zM224 280a16 16 0 1 0-32 0 16 16 0 1 0 32 0m208-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Su = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0H16v265.9l7 7 79 79h-6v48h448V352h-6.1l79-79 7-7V0H480v142.1l-31-31-17-17-17 17-95 95-95-95-17-17-17 17-31 31V24zm184 249.9 88-88 26.1 26.1-51 51-17 17 33.9 33.9 17-17 80-80 7-7V48h48v198.1L474.2 347.8 470 352H344v-8zM296 352H169.9l-12.2-12.2L64 246.1V48h48v137.9l7 7 80 80 17 17 33.9-33.9-17-17-51-51 26.1-26.1 88 88V344zM96 424v48h32v40h48v-40h120v40h48v-40h120v40h48v-40h32v-48H120z" })
  }
), zu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 261.5V83.6h130.6L180.5 0l55.4 32 18.5-32 97 56-15.5 25.7-75.9 35.7 25.9-43.9-13.9-8-37.7 64-2 .9c-26.3 12.4-49.3 29.8-67.8 50.9l-12.3-7.1 59.7-100.6-13.9-8-85.7 145.7-32.3-9.2v-70.5H48v129.9c0 29.9 13.6 57.6 36 75.9-13.7 8.7-25.4 20.3-34.2 33.9C18.7 344.1 0 304.3 0 261.5M312 512c-26.9 0-52.4-6.3-75-17.6 8.9-13.3 15.1-28.5 17.6-45 17 9.3 36.6 14.6 57.3 14.6H464v-16h-96v-48h128v-16H368v-48h160v-16H368v-48h128v-16H316l-9.2-36.8 18.9-8.9 25.1-11.8 14.5-6.8-13.6-29-14.5 6.8-70.9 33.3c-41.6 19.6-69.4 59.6-73.7 104.7l-.1 1.4-.3 1.3c-.1.5-.2 1.1-.2 1.7v18.8c-14.5-6.9-30.8-10.8-48-10.8v-8c0-3.5.3-6.9.9-10.2 6.3-61.4 44.3-115.7 101-142.3l70.9-33.3 36.2-17 21.7-10.2 10.2 21.7L419 193l7 15h118v64h32v112h-32v64h-32v64h-56zM416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m112 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96M144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), pu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 16v80h-32V0h32zm-98.7 7.1 32 48 8.9 13.3-26.6 17.8-8.9-13.3-32-48-8.9-13.3 26.6-17.8 8.9 13.3zm-77.9 71.5 17 15.8 79.6 74.4V144h128v185.6C416 430.3 334.3 512 233.6 512c-22.5 0-44.1-2.1-65.9-10.4-21.8-8.3-42.1-22.1-63.1-43.1L88 441.9 71 425l-16-16-.1-.1L31 385l-17-17 17-17 31-31-31-31-17-17 17-17 31-31-15-15-17-17 17-17 48-48 17-17 17 17 15 15 31-31zM113 207l88 88 17 17-34 33.9-17-17-71-71L81.9 272 96 286.1l17 17 40 40 17 17-34 33.8-17-17-23-23L81.9 368l7 7 16 16 17 17 16.6 16.6c17.4 17.4 32.1 26.8 46.2 32.1 14.2 5.4 29.3 7.2 48.9 7.2 74.2.1 134.4-60.1 134.4-134.3V192h-32v68l-29.8 7.4-10.6-9.9-103-96.2-14.7 14.7 71 71 17 17-33.9 33.9-17-17-88-88-15-15L97.9 192l15 15zm248.6 305c-4.9 0-9.8-.1-14.7-.3 23.2-14.5 43.5-33.3 59.7-55.4 52.1-18.5 89.4-68.2 89.4-126.7V192h-48v-48h96v185.6C544 430.3 462.3 512 361.6 512m82-502.2 26.6 17.8-8.9 13.3-32 48-8.9 13.3-26.6-17.8 8.9-13.3 32-48 8.9-13.3z" })
  }
), Mu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80m-29.5 16h-8.8l-6.7 5.7-50.5 42.7-18.3 15.5 31 36.7 18.3-15.6 19.8-16.7-11.1 88.7-3 23.8 47.6 6 3-23.8 4.4-35h7.6l4.4 35 3 23.8 47.6-6-3-23.8-11.1-88.8 19.8 16.8 18.3 15.5 31-36.7-18.3-15.5-50.5-42.6-6.7-5.7h-8.8zM144 64H0v337.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112h48v209.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16 33.9-33.9-16-16-1-1-16-16-23-23 30.1-30.1 88 88V512h48V393.9l88-88 30.1 30.1-23 23-16 16-17 17 33.9 33.9 17-17 16-16 40-40 17-17 7-7 7-7V112h48v270.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V64H496v238.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88z" })
  }
), xu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256M144 64H0v337.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112h48v209.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16 33.9-33.9-16-16-1-1-16-16-23-23 30.1-30.1 88 88V512h48V393.9l88-88 30.1 30.1-23 23-16 16-17 17 33.9 33.9 17-17 16-16 40-40 17-17 7-7 7-7V112h48v270.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V64H496v238.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88z" })
  }
), Hu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 256 128-128L320 0 192 128zM144 64H0v337.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112h48v209.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16 33.9-33.9-16-16-1-1-16-16-23-23 30.1-30.1 88 88V512h48V393.9l88-88 30.1 30.1-23 23-16 16-17 17 33.9 33.9 17-17 16-16 40-40 17-17 7-7 7-7V112h48v270.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V64H496v238.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88z" })
  }
), Vu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 32V8h-48v26.8c-4.7 1.2-9.3 2.7-13.6 4.7-15.8 7.2-30 20.7-33.4 40.7-1.9 10.9-.9 21.6 3.7 31.4 4.5 9.6 11.6 16.3 18.7 21.1 12.1 8.2 28 13 39.6 16.5l2.3.7c14.1 4.3 22.8 7.3 28.1 11.1 2 1.5 2.4 2.3 2.4 2.4 0 .1.1.3.2.9.1.6.1 1.7-.2 3.5-.3 1.9-1.2 3.9-5.6 5.8-5.2 2.2-14.3 3.5-26.6 1.6-5.7-.9-15.9-4.4-25.4-7.6-2.3-.8-4.5-1.5-6.6-2.2l-22.8-7.6-15.2 45.5 22.8 7.6c1.1.4 2.6.9 4.2 1.4 7 2.4 18 6.2 27.3 8.5V248h48v-26.2c4.5-1 8.9-2.4 13-4.2 16.7-7.2 30.5-21.1 34-41.7 1.9-11 1.1-21.8-3.2-31.7-4.3-9.8-11.1-16.9-18.2-22.1-12.7-9.2-29.4-14.3-41.4-17.9l-1-.3c-14.4-4.3-23.3-7.2-28.8-10.9-1.5-1-2.1-1.7-2.2-1.9-.1-.3-.1-1.1.2-2.7.1-.3.5-2.6 5.9-5.1 5.6-2.5 14.7-4.1 26.4-2.3 4.3.7 17.6 3.3 21.3 4.3l23.1 6.1L385.4 45l-23.2-6.2c-3.9-1-11.8-2.6-18.2-3.9zm-47.9 59.2a.1.1 0 1 0 .1-.1.1.1 0 1 0-.1.1M144 64H0v337.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112h48v209.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16 33.9-33.9-16-16-1-1-16-16-23-23 30.1-30.1 88 88V512h48V393.9l88-88 30.1 30.1-23 23-16 16-17 17 33.9 33.9 17-17 16-16 40-40 17-17 7-7 7-7V112h48v270.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V64H496v238.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88z" })
  }
), Cu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m199.2 135.1 24.8 24.8 96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56v-3.6c0-41.7-33.9-75.6-75.6-75.6-23 0-44.7 10.4-59.1 28.4L320 39.9l-9.3-11.6C296.4 10.4 274.6-.1 251.6-.1 209.9-.1 176 33.8 176 75.5v3.6c0 21 8.3 41.1 23.2 56M144 64H0v337.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112h48v209.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16 33.9-33.9-16-16-1-1-16-16-23-23 30.1-30.1 88 88V512h48V393.9l88-88 30.1 30.1-23 23-16 16-17 17 33.9 33.9 17-17 16-16 40-40 17-17 7-7 7-7V112h48v270.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V64H496v238.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88z" })
  }
), Lu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 64h24v238.1l47-47 17-17 17 17 95 95 95-95 17-17 17 17 47 47V64h144v337.9l-7 7-84.8 84.8-17 17-33.9-33.9 17-17 77.7-77.7V112h-48v209.9l-7 7-7 7-17 17-40 40-16 16-17 17-33.9-33.9 17-17 16-16 23-23-30.1-30.1-88 88V512h-48V393.9l-88-88-30.1 30.1 23 23 16 16 1 1 16 16-33.9 33.9-16-16-1-1-16-16-40-40-17-17-7-7-7-7V112H48v270.1l77.8 77.8 17 17-33.9 33.9-17-17L7 409l-7-7V64h24z" })
  }
), Bu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241.7 7.8 19 11.9 59.3 37 59.3-37 19-11.9 13.2 18.1 128 176 4.6 6.3v93.5l70.3 19.2 23.2 6.3-12.6 46.3-23.2-6.3-88-24-17.8-4.9V223.8L385.7 72.2l-24.6 15.4 67.3 107.6 3.6 5.8v119h-48V216h-40v173.3l269.8 67.5 23.3 5.8-11.6 46.6-23.3-5.8L320 432.7 37.8 503.3l-23.3 5.8-11.6-46.6 23.3-5.8L296 389.3V216h-40v104h-48V201.1l3.6-5.8 67.3-107.7-24.6-15.4L144 223.8v114.5l-17.7 4.8-88 24-23.2 6.3-12.6-46.2 23.2-6.3L96 301.7v-93.5l4.6-6.3 128-176 13.1-18.1zM296 168h58.7L320 112.5 285.3 168z" })
  }
), uu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 261.5V83.6H445.4L395.5 0l-55.4 32-18.5-32-97 56 15.5 25.7 75.9 35.7-25.9-43.8 13.9-8 37.7 64 2 .9c26.3 12.4 49.3 29.8 67.8 50.9l12.3-7.1-59.7-100.7 13.9-8 85.8 145.7 32.3-9.2v-70.5h32v129.9c0 38.5-22.5 73.4-57.5 89.2l-1.1.5-5.7 3.3c-1.1 21.3-5.5 41.7-12.7 60.7 7.7-3 15.2-6.6 22.5-10.9l17.9-10.4C542.9 370 576 318.4 576 261.5M223.1 109.1l-21.8-10.3-10.2 21.7-34.1 72.4-7 15.1H32v64H0v112h32v64h32v64h200c92.8 0 168-75.2 168-168v-32c0-3.5-.3-6.9-.9-10.2-6.3-61.4-44.3-115.7-101-142.3l-70.9-33.3-36.2-17zm2.1 89.4-14.5-6.8 13.6-29 14.5 6.8 70.9 33.3c41.6 19.6 69.4 59.6 73.7 104.7l.1 1.4.3 1.3c.1.5.2 1.1.2 1.7v32c0 66.3-53.7 120-120 120H112V448h96v-48H80v-16h128v-48H48v-16h160v-48H80v-16h180l9.2-36.8-18.9-8.9-25.1-11.8z" })
  }
), Ru = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 320h24v-80h128v64h-32v56h-48v40H230.1l-7 7-52.8 52.8-17 17 33.9 33.9 17-17 45.7-45.7H432v-40h48v-56h32V192H336v-48h-48v128h-48V112h201.9l7-7 52.8-52.8 17-17-33.9-33.9-17 17L422.1 64H192v256h24zm232-137.9V250l77.8-77.8 17-17-33.9-33.9-17 17zM160 128H96v134.1l-77.8 77.7-17 17 33.9 33.9 17-17L137 289l7-7V176h16z" })
  }
), $u = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L503.3 368H608v-48H441.5l-100.4-77.9 35.1-32.4 17.6-16.3-32.6-35.3-17.6 16.3-41 37.9-39.3-30.5 74.2-69.8h77.4l65.2 57.9 6.8 6.1H608v-48H505.1l-65.2-57.9-6.8-6.1H318.5l-6.9 6.5-86.6 81.4-31.8-24.7 16.3-15.2h15.3l48-48h-82.3l-6.9 6.5-28.7 27L48.4 14.8zm336 384.1-38-29.9-37 37-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7H32v48h75l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17 58-58zM101.5 176l-60.9-48H32v48h24z" })
  }
), ku = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272.8 64h-82.3l-6.9 6.5-61.3 57.5H32v48h109.3l6.9-6.5 61.3-57.5h15.3zm55.2 0h-9.5l-6.9 6.5-136 128-17 16 15.5 17.4 64 72 16.2 18.3 18-16.6 67.8-62.6 91.9 91.9v1.8l-49 49-9.7-9.7-17-17-17 17-29.9 30-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7H32v48h75l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17 29.8-29.9 9.7 9.7 17 17 17-17 68.5-68.7H608v-48H485l-1.2-1.2-108.4-108.4.8-.8 17.6-16.3-32.6-35.3-17.6 16.3-86 79.4-32.3-36.3L337.5 112h77.4l65.2 57.9 6.8 6.1H608v-48H505.1l-65.2-57.9-6.8-6.1H424z" })
  }
), Pu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368H544v16h96V128H505.1l-65.2-57.9-6.8-6.1H318.5l-6.9 6.5-86 80.9-31.7-24.8 15.6-14.6h15.3l48-48h-82.3l-6.9 6.5-27.9 26.2L38.8 5.1zm225 176.3 73.7-69.4h77.4l65.2 57.9 6.8 6.1H544v144H440.6l-99.4-77.9 35.1-32.4 17.6-16.3-32.6-35.3-17.6 16.3-40.9 37.7-39.1-30.7zM96 171.6 40.6 128H0v256h96v-32h11l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17 58-58-38-29.9-37 37-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7H96V176zM256.7 320h-4.4l2 2.2zM32 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0m560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Fu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.8 64-48 48h-15.3l-61.2 57.5-6.9 6.5H96v128H126.8l7 7 52 52 7 7 17 17 21.3 21.3 23.4-23.3 17-17 17 17 21 21 29.9-30 17-17 17 17 9.7 9.7 49-49v-1.8l-92-91.9-67.9 62.6-18 16.6-16.2-18.3-64-72-15.5-17.4 17-16 136-128 6.9-6.5H433.1l6.8 6.1 65.2 57.9H640v256h-96v-16h-75.5l-68.6 68.6-17 17-17-17-9.7-9.7-29.9 29.9-17 17-17-17-21-21-23.3 23.3-17 17-17-17-38-38.1-17-17-7-7-45-45H96v32H0V128h122.3l61.2-57.5 6.9-6.5h9.6zM544 320V176h-57.1l-6.8-6.1-65.2-57.9h-77.4L225.4 217.5l32.3 36.3 86-79.4 17.6-16.3 32.6 35.3-17.6 16.3-.8.8 108.3 108.3 1.2 1.2zM64 336a16 16 0 1 0-32 0 16 16 0 1 0 32 0m528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Tu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c.9 1.6 2.3 3.6 3.9 6 7.3 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6M24 48c.9 1.6 2.3 3.6 3.9 6C35.2 65.1 48 84.3 48 104c0 13.3-10.7 24-24 24S0 117.3 0 104c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6m84.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50m67.9-6c.9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6m60.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50M400 48c.9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6m124.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50M464 48c.9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6m148.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50M344 112v224h208c22.1 0 40-17.9 40-40V160h48v136c0 48.6-39.4 88-88 88H344v80h176v48H120v-48h176v-80H88c-48.6 0-88-39.4-88-88V160h48v136c0 22.1 17.9 40 40 40h208V112zm-216 64v128H96V160h32zm64 0v128h-32V160h32zm64 0v128h-32V160h32zm160 0v128h-32V160h32zm64 0v128h-32V160h32zm64 0v128h-32V160h32z" })
  }
), Au = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v176h416V80zm0 224v128h416V304zM0 256V32h512v448H0V304zm280 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Du = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M447.5 136h-95l20.8-104h-49l-20.8 104h-111l20.8-104h-49l-20.8 104h-95l-9.6 48h95l-28.8 144h-95L.5 376h95L74.7 480h49l20.8-104h111l-20.8 104h49l59.2-296h51.8c13.7-10.8 29.9-18.4 47.6-21.9zm-264.6 48h111l-28.8 144h-111l28.8-144zM464 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), yu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M447.5 136h-95l20.8-104h-49l-20.8 104h-111l20.8-104h-49l-20.8 104h-95l-9.6 48h95l-28.8 144h-95L.5 376h95L74.7 480h49l20.8-104h111l-20.8 104h49l20.8-104h95l9.6-48h-95l28.8-144h95zm-264.6 48h111l-28.8 144h-111l28.8-144z" })
  }
), bu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5-1.3-4.2-2-8.7-2-13.2 0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4M320 64c70.2 0 130.8 41.1 159 100.5 6.1-2.9 12.8-4.5 19.7-4.5 25 0 45.3 20.3 45.3 45.3 0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8.8 1.6 1.6 2.3 2.5l91.9 36.8 15.1 6v32c0 17.6-8.9 34.5-25.1 49.8-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4-16.5 17.4C8.9 354.5 0 337.6 0 320v-32l15.1-6 129.2-51.7C149.3 137.6 226.1 64 320 64m109.3 256c-16.7 0-31.3-9-39.1-22.5-21.2 4.1-45 6.5-70.2 6.5-62.4 0-116.5-14.3-142.9-35.2l-.8.3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5 10.3 9.8 27.8 20.8 53.4 31 51 20.3 124.7 34 208.5 34s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31 8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3m34.7-48 32-32-32-32-32 32z" })
  }
), fu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m163.1 118.4-38.3-28.8c-8-6-17.9-9.6-28.8-9.6-26.5 0-48 21.5-48 48v1.4c0 4.9.7 9.8 2.2 14.5L99.5 304h52l-23.3-133.3-2.7-15.7 31.5-5.5 2.7 15.8L183.9 304H240V144h32v160h56.1l24.1-138.7 2.7-15.8 31.5 5.5-2.7 15.8L360.6 304h52l49.3-160.1c1.4-4.7 2.2-9.6 2.2-14.5V128c0-26.5-21.5-48-48-48-10.9 0-20.8 3.5-28.8 9.6l-38.4 28.8L320 80c-14.7-19.5-37.9-32-64-32s-49.3 12.5-64 32l-28.8 38.4zM448 352H64L4.3 158C1.5 148.7 0 139.1 0 129.4V128c0-53 43-96 96-96 21.6 0 41.6 7.1 57.6 19.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12 36-19.2 57.6-19.2 53 0 96 43 96 96v1.4c0 9.7-1.4 19.4-4.3 28.6zM64 384h48v80h288v-80h48v128H64v-48z" })
  }
), Uu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m202.9 121.5-9.6 71.9c31.6 4 61.6 16.8 86.5 37l31.5 25.6h130.9L409.7 87zM560 400c17.7 0 32-14.3 32-32 0-35.1-28.4-66.8-65.6-92.2-12.3-8.4-24.7-15.5-35.6-21.2l28 145.4zM448 32l31.6 164.4h.1c4.5 1.9 10.8 4.6 18.3 8.1 15 7.1 35.2 17.7 55.5 31.6 38.9 26.7 86.5 71 86.5 131.9 0 44.2-35.8 80-80 80H0v-84.4C0 277.9 62.8 207 144.8 194.1L160 80zM48 363.6V400h364.4L249.5 267.7c-22-17.9-49.6-27.7-77.9-27.7C103.3 240 48 295.3 48 363.6" })
  }
), Gu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 80-59.9-27.6L216 32l-13.2 46.8-51.1 181.8c13.9 5 29.2 9.6 46 13.6l49.3-175 52.9 24.4 20.1 9.3 20.1-9.3L393 99.2l49.2 175.1c16.8-4 32.1-8.7 46-13.6l-51-181.9L424 32l-44.1 20.4zM24 224 0 256s96 192 320 192 320-192 320-192l-24-32s-94.5 96-296 96-296-96-296-96" })
  }
), qu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m442 207.8 25.6 7 .2-.3-2.6-19.4-4.4-32.5 30.8-3.4-57.2-67.6c-32-37.8-79-59.6-128.5-59.6-68.8 0-130.7 41.9-156.3 105.8L64 352h51.7l78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6l25.8 30.4-26.9-7.3-23.8-6.5-44 44 10.6 26.6L396.3 352H448l-41.7-104.2L384 192zm108.2-47.2L530 187.1l-33.1 3.7 4.5 33-20.8 26 26.5 20.2 3.7 33.1 33-4.5 26 20.8 20.2-26.5 33.1-3.7-4.5-33 20.8-26-26.5-20.2-3.7-33.1-33 4.5-26-20.8zM0 384v96h512v-96H48z" })
  }
), Wu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M279.3 23.8 256 0l-23.3 23.8-33.3-.4.4 33.3L176 80l23.8 23.3-.4 33.3 33.3-.4L256 160l23.3-23.8 33.3.4-.4-33.3L336 80l-23.8-23.3.4-33.3-33.3.4zM48 416H0v96h512v-96h-48zm119.5-284C43.1 194.8 32 384 32 384h48.1c.1-1.5.3-3.7.6-6.3.7-6.5 2-16 4.2-27.4.4-2 .8-4.1 1.2-6.2l5.8-3.3 44.1-25.2 44.1 25.2 11.2 6.4 11.5-5.7 53.2-26.7 53.3 26.6 11.5 5.7 11.2-6.4 44-25.1 44.1 25.2 5.8 3.3c.4 2.1.8 4.2 1.2 6.2 2.1 11.5 3.4 21 4.2 27.4.3 2.6.5 4.7.6 6.3H480s-11.1-189.2-135.5-252l.1 4.2.4 32.8-32.8-.4-4.3-.1c45.7 16.3 74.6 54.5 94.2 98.9 1.5 3.5 3 6.9 4.4 10.4L388 267.2l-12-6.8-11.9 6.8-44.8 25.6-52.5-26.3-10.8-5.3-10.7 5.4-52.5 26.3-44.8-25.6-12-6.9-11.9 6.8-18.5 10.6c1.4-3.5 2.8-6.9 4.4-10.4 19.6-44.4 48.6-82.5 94.2-98.9l-4.3.1-32.9.4.4-32.8V132z" })
  }
), Eu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 224 26.6-46.6L576 112 448 0 208 128 96 384h52.4l96.9-221.5L441.3 58l73.5 64.3-3.3 5.7H402.3L389 154.5l-16 32-9.2 18.5 7.1 19.4 58 159.6H480l-64-176 16-32h48l2.2 3.3zm-176 80h-96v80h96zM0 416v32l128 64h320l128-64v-32z" })
  }
), Ou = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m368 192 42.5-127.6L432 0l-60.7 30.4L176 128 48 416h52.5l112.4-252.8 136.9-68.4-27.4 82.1-5.8 17.3 7.2 16.8 88 205H464zM237.7 416l10.3-24 56-24-56-24-24-56-24 56-56 24 56 24 10.3 24h27.4zM0 448v64h512v-64H32zm256-192 16-32 32-16-32-16-16-32-16 32-32 16 32 16z" })
  }
), Iu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zM312 192h-40v16c0 22.1-17.9 40-40 40h-8v72h-48v-72h-16c-22.1 0-40-17.9-40-40v-3.3c-14.1-6.2-24-20.3-24-36.7 0-22.1 17.9-40 40-40h.2c2-18 17.2-32 35.8-32 6.2 0 12.1 1.6 17.2 4.3C196 88.2 209.1 80 224 80s28 8.2 34.8 20.3c5.1-2.8 10.9-4.3 17.2-4.3 12.7 0 23.8 6.5 30.2 16.4 1.9-.3 3.8-.4 5.8-.4 22.1 0 40 17.9 40 40s-17.9 40-40 40" })
  }
), Nu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 381.2V512H64V381.2c-41-41.9-64-98.3-64-157 0-38.7 9.8-75.1 27.1-106.9l38.4 30.3C54.3 170.8 48 196.8 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14v19.6zM462.1 336l158.8 123.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 40 31C126 17.1 173 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-48zm-61.8-48H464v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-35.4 0-68.4 10.5-96 28.6zM320 368l19.2-4.8L448 449v47H320v16h-48v-64h128v-33.3l-80-6.7zm272 16a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Xu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 381.2v-19.5l-13.7-14C66.1 314.7 48 270.4 48 224.2 48 127 126.8 48 224 48h32c76.3 0 138.8 59.4 143.7 134.5l1.1 16.5 11 12.3 52.2 58.8V288h-64v60l-80 20v40l80 6.7V448H272v64h48v-16h128V336h64v-84.2l-8.1-9.1-56.3-63.4C441.1 79.2 357.8 0 256 0h-32C100.2 0 0 100.6 0 224.2c0 58.7 23 115.1 64 157V512h48v-64zM368 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m120 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48m152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-40-168a24 24 0 1 0-48 0 24 24 0 1 0 48 0m40-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-40 120a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Ku = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zm144-228.2c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1.1 5.7 1.6 11.6 1.6 17.6s-.5 11.9-1.6 17.5l32.5 18.7-32 55.4-32.5-18.7a97.17 97.17 0 0 1-30.4 17.6V352h-64v-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6l-32.5-18.7 32-55.4 32.5 18.7c8.9-7.6 19.1-13.6 30.4-17.6V96h64zm8 90.5a40 40 0 1 0-80 0 40 40 0 1 0 80 0" })
  }
), Qu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 381.2V512H64V381.2C26.7 343.1 4.3 292.9.6 240h48.1c3.6 40.4 21.1 78.5 49.6 107.7l13.7 14v19.6zM224 48c-37.6 0-72.5 11.8-101.1 32h93.6C234 60.4 259.6 48 288 48h-48zm159 0h129v192H288c-28.4 0-54-12.4-71.6-32H0V80h52.5C93.6 31.1 155.2 0 224 0h32c48.7 0 93.2 18.1 127 48m81 224h48v64h-64v112H320v64h-48V400h128V288h64zM48 128v32h145.3c-.9-5.2-1.3-10.5-1.3-16s.5-10.8 1.3-16zm416-32h-32v96h32zm-80 0h-96c-26.5 0-48 21.5-48 48s21.5 48 48 48h96z" })
  }
), Zu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-24v50.6c50.3 11 88 55.8 88 109.4 0 61.9-50.1 112-112 112S96 269.9 96 208c0-53.6 37.7-98.4 88-109.4v-46C106.1 70.7 48 140.8 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM272 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-96 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Ju = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zm0-174.5c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L235 309.5l-11 10.6-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z" })
  }
), ju = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 361.7V512H96V381.2c-41-41.9-64-98.3-64-157C32 100.6 132.2 0 256 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V320l-64 192H256V316.8L81.6 200.6c-1 7.7-1.6 15.6-1.6 23.7 0 46.1 18.1 90.5 50.3 123.4zM95.4 152.1 275.3 272H496v-1.9l-52.3-58.8-11-12.3-1.1-16.5C426.8 107.4 364.3 48 288 48h-32c-71.5 0-133.1 42.8-160.6 104.1M368 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64m125.4 160H304v144h141.4l8-24H352v-32h112.1l10.7-32H352v-32h133.4z" })
  }
), Yu = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zM192 160V96h64v64h64v64h-64v64h-64v-64h-64v-64z" })
  }
), _u = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zm202.5-250.8 11.3 11.3 11.3 11.3-11.3 11.3C302.5 168.1 319 208 352 208h16v32h-16c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C279.9 302.5 240 319 240 352v16h-32v-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3-11.3-11.3 11.3-11.3C145.5 279.9 129 240 96 240H80v-32h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3 11.3-11.3 11.3 11.3C168.1 145.5 208 129 208 96V80h32v16c0 33 39.9 49.5 63.2 26.2zM200 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48m72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), hR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 361.7V512H64V381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32c101.8 0 185.1 79.2 191.6 179.4l56.3 63.4 8.1 9.1V336h-64v112H320v64h-48V400h128V288h64v-17.9l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48h-32c-97.2 0-176 79-176 176.2 0 46.1 18.1 90.5 50.3 123.4l13.7 14zM336 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), cR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h160v48h-56v144h240V80h-56V32h160v48h-56v352h56v48H288v-48h56V272H104v160h56v48H0v-48h56V80H0z" })
  }
), sR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80C141.1 80 48 173.1 48 288v128H0V288C0 146.6 114.6 32 256 32s256 114.6 256 256v128h-48V288c0-114.9-93.1-208-208-208m-96 240h-32v112h32zm-32-48h80v208H80V272zm256 48h-32v112h32zm48-48v208H304V272h80z" })
  }
), vR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80C152 80 65.8 156.3 50.4 256H128v224H0V288C0 146.6 114.6 32 256 32s256 114.6 256 256v192H384V256h77.6C446.2 156.3 360 80 256 80m208 224h-32v128h32v-64zM48 368v64h32V304H48z" })
  }
), eR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208v184.1l-144-.1v-24h-80c-26.5 0-48 21.5-48 48s21.5 48 48 48h80v-24l168 .1h24V256C512 114.6 397.4 0 256 0S0 114.6 0 256v64h48v-24zm70.1-80-7 7L87 207l-7 7v170h128V176h-80zm9.9 57.9 9.9-9.9H160v112h-32v-56zM384 176h-80v208h128V214.1l-7-7-24-24-7-7h-10zm-9.9 48 9.9 9.9V336h-32V224z" })
  }
), lR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m24 64-104 96h66.7L408 448l104-96h-66.7z" })
  }
), tR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L488 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), wR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), gR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 16v-32H352v32h144z" })
  }
), iR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), mR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4-14.4-6.6-29.8-11.4-45.9-14 2.7-8.5 4.1-17.4 4.1-26.4 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7z" })
  }
), aR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M230.1 137.9 160 208l128 112-64-112 96-80-6.2-21.9.4-.4C330.6 89.3 353 80 376.2 80c48.5 0 87.8 39.3 87.8 87.8 0 23.3-9.2 45.6-25.7 62.1l-24.2 24.2-158.1 158-158.1-158-24.2-24.3c-16.5-16.4-25.7-38.7-25.7-62C48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7l24.2 24.3 8 8zM256 480l33.9-33.9L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.7L256 96l-24.2-24.2c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288l158.1 158.1z" })
  }
), oR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 412.1 158.1-158 24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 289.9 446.1 256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8z" })
  }
), nR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 480V96l-24.2-24.2c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L208 432zm-48-115.9L73.7 229.8C57.2 213.4 48 191 48 167.8 48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7l10.1 10.2z" })
  }
), rR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 163.9 33.9-33.9 24.2-24.2C330.6 89.3 353 80 376.2 80c48.5 0 87.8 39.3 87.8 87.8 0 23.3-9.2 45.6-25.7 62.1l-24.2 24.2-1.9 1.9h-51.6l-27.3-40.9-13.3-20-13.3 20-49.5 74.3-59.3-105.2-14.8-26.3-13.5 27-35.5 71.1H99.9l-1.9-1.9-24.3-24.3c-16.5-16.4-25.7-38.7-25.7-62C48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7l24.2 24.3zm0 248.2L163.9 320H96l126.1 126.1L256 480l33.9-33.9L416 320h-67.9zM343.4 288H448l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.7L256 96l-24.2-24.2c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288h89.9l4.4-8.8 26.5-53L242 327.9l12.8 22.7 14.5-21.7 50.7-76 18.7 28z" })
  }
), dR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 163.9 222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80 87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2 158.1 158 158.1-158 24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1 0-48.5-39.3-87.8-87.8-87.8-23.3 0-45.6 9.2-62.1 25.7L289.9 130zm33.9 282.2L256 480l-33.9-33.9L64 288l-24.2-24.2c-25.5-25.5-39.8-60-39.8-96C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288z" })
  }
), SR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 32v112c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v80h-48v-80c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6c-28-37.4-43.2-82.9-43.2-129.6V32zM48 96v61.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V480H96v-61.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.2A215.76 215.76 0 0 1 0 157.9V96zm304 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V480h-48v-61.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3c-23.7-35.4-36.3-77.1-36.3-119.7V96h48z" })
  }
), zR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M461.6 224H510C495.6 108.2 403.8 16.4 288 2v48.5c89.3 13.7 159.8 84.3 173.6 173.5m48.4 64h-48.4c-13.8 89.3-84.3 159.8-173.6 173.6V510c115.8-14.4 207.6-106.2 222-222M2 288c14.4 115.8 106.2 207.6 222 222v-48.4C134.7 447.8 64.2 377.3 50.4 288zm0-64h48.4C64.2 134.8 134.7 64.2 224 50.5V2C108.2 16.4 16.4 108.2 2 224m190-64v-24h-48v240h48v-96h128v96h48V136h-48v96H192z" })
  }
), pR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h448v48H384v80H443.2c84 0 152 68.1 152 152v120H294.1l-7-7-100.9-100.9-139.9-62.2-11.4-5-2.4-12.2-24-120L2.7 64h80.2l7.2 8.2 48.8 55.8H336V48H128zM77.1 191.1l132.6 59 4.1 1.8 3.2 3.1 97 97h21.2V176H117.1l-7.2-8.2-48.6-55.6 15.8 78.9zM384 352h153.5v-72c0-57.4-46.5-104-104-104H422.5h.5H421.5h.5H420.5h.5H419.5h.5H418.5h.5H417.5h.5H416.5h.5H415.6h.4H414.5h.5H413.5h.5H412.6h.4H411.6h.4H410.6h.4H409.5h.5H408.5h.5H407.5h.5H406.6h.4H405.6h.4H404.6h.4H403.6h.4H402.6h.4H401.5h.5H400.6h.4H399.6h.4H398.6h.4H397.6h.4H396.6h.4H395.6h.4H394.6h.4H393.6h.4-1.3.3H391.6h.4-8zm256 104v56H224v-48h368v-32h48z" })
  }
), MR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256H0v-32L64 0zm32-32C96 80 288 0 288 0s192 80 192 224c0 80 32 192 32 192l-192 96h-64L64 416s32-112 32-192m353 135.9c-8.2-38.8-17-90.8-17-135.9 0-49.6-33.5-93.3-77.8-128.4C333 78.8 311.5 65.8 295.1 57c-2.5-1.4-4.9-2.6-7.1-3.8-2.2 1.2-4.6 2.4-7.1 3.8-16.3 8.8-37.8 21.9-59.1 38.7-44.3 35-77.8 78.7-77.8 128.3 0 45.1-8.9 97.1-17 135.9-2.3 11.1-4.7 21.4-6.8 30.5L264 462.3V288l-88-32v-32h224v32l-88 32v174.3l143.9-71.9c-2.2-9.1-4.5-19.4-6.8-30.5zM512 0l64 224v32h-64z" })
  }
), xR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 32v288h48V80h64v240h48V32H232zM0 384v24s80 72 288 72 288-72 288-72v-24zm32-96v64h48v-64c0-68.4 39-127.7 96-156.8V78.7C91.8 110.9 32 192.5 32 288m464-2.2V352h48v-66.4c-1-94.5-60.5-174.9-144-206.9v52.5c56.4 28.8 95.2 87.2 96 154.6" })
  }
), HR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 48c106 0 192 86 192 192H240.5l-6.4 14.1-37.2 81.9H48v-96c0-106 86-192 192-192m80 372.7-77.7-68.6 29.2-64.1H320zm48 42.4V288h144v-48h-32C480 107.5 372.5 0 240 0S0 107.5 0 240v144h205.9l2.3 2 136 120 6.8 6h129v-48H369.1zM160 112V96h-32v80c0 26.5 21.5 48 48 48s48-21.5 48-48V96h-32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm112-16h-16v128h32v-59.6l31.1 51.8 4.7 7.8H352V96h-32v59.6l-31.1-51.8-4.6-7.8h-9.1z" })
  }
), VR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm241 177 17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), CR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm160 96h-64v64h64zM168 232h-24v48h224v-48h-24zm56 88v64h64v-64z" })
  }
), LR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm152 96h-48v160h48V152zm-48 192v48h48v-48z" })
  }
), BR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m103.3 340-48-84L155.9 80h200.2l100.6 176-39.7 69.6-76.2-91.8-18.5-22.2-18.5 22.2-71.6 86.2-38.9-40.6-17.8-18.6-17.3 19-55 60.2zM128 32 0 256l128 224h256l128-224L384 32zm104 128a40 40 0 1 0-80 0 40 40 0 1 0 80 0" })
  }
), uR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm56 200h-24v48h192v-48h-24z" })
  }
), RR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm104 336h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), $R = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 456.7 176-100.6V155.9L224 55.3 48 155.9v200.2zM0 128 224 0l224 128v256L224 512 0 384zm192-36 31.8-18.2 48.2 27.6v36.9l-48-27.5V240h48v32h-48v166.3L192 420V256zm128 291.4V165.8L296 152v-36.9l47.9 27.4 40.1 22.9v36.8L352 184v181.1l-32 18.3zm-160 .6v17.7L127.2 383 96 266.1v99l-32-18.2V165.1l33.1-18.9L128 261.9V128.6l32-18.3V381.9z" })
  }
), kR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 356.1V155.9L224 55.3 48 155.9v200.2l176 100.6zM0 128 224 0l224 128v256L224 512 0 384zm80 32h19.9l3.4 11.4 24.7 82.3V160h32v192h-35.9l-3.4-11.4L96 258.3V352H64V160zm128 0h64v32h-48v48h48v32h-48v80h-32V160zm96 0h80v32h-32v160h-32V192h-32v-32z" })
  }
), PR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.3 256 155.9 80h200.2l100.6 176-100.6 176H155.9zM128 32 0 256l128 224h256l128-224L384 32zm225.9 160L320 158.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), FR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.9 432h200.3l100.5-176L356.1 80H155.9L55.3 256zM0 256 128 32h256l128 224-128 224H128z" })
  }
), TR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm256 128v192h80c53 0 96-43 96-96s-43-96-96-96h-56zm80 48c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96zm-224-24v-24h-48v192h48v-72h64v72h48V160h-48v72h-64z" })
  }
), AR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m169.9 329.9 14.1-14v-67.3l22.5-16.2 113 113-16.1 22.6h-67.3L222 382.1l-38 38-52.1-52.1 38.1-38.1zm178-24L246 204.1 442.9 62.8l46.4 46.4L347.9 306zM448 0 136 224v72l-72 72 15 15-72 72-7 7v50h129.9l7-7 32-32 14.7 14.7.3.3.2-.2 33.7-33.7L256 416h72l224-312zM135 439l-25 25H65.9l47-47zm145 25h-24v48h320v-48h-24z" })
  }
), DR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 315.9 169.9 330l-38 38 52.1 52.1 38.1-38.1 14-14h67.3l16.2-22.5-113-113-22.6 16.1V296zm62-111.8L347.9 306l141.3-196.9-46.3-46.3L246 204.1zM136 224 448 0l104 104-224 312h-72l-38.1 38.1-33.7 33.7-.2.2-.3-.3L169 473l-32 32-7 7H0v-49.9l7-7 72-72L64 368l72-72zm-23 193-47 47h44.1l25-25z" })
  }
), yR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41 71 0 30.1V512h481.9l-41-41zm7 393V145.9L366.1 464zm503.1-72.9c34.4-34.4 34.4-90.1 0-124.4s-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6-40.9 15.6-56.6 0l-81.7-81.7c22.4-14.2 37.2-39.1 37.2-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6l310.3 310.3c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), bR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 30.1 41 71l400 400 41 41H0V88zm48 115.8V464h318.1L48 145.9zM248 128l36-64h72l36 64-36 64h-72zm200 244v-72l64-36 64 36v72l-64 36zM128 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m418.4 24.6 23.2 27.9c9.6-2.9 19.8-4.5 30.3-4.5h32c13.9 0 27.2 2.7 39.3 7.7l21.2-29.6L603.5 54l-21.1 29.6c16 18.3 25.7 42.2 25.7 68.4v.4c19.6 17.6 32 43.1 32 71.6s-12.4 54-32 71.6V352H544v-32h-64v32h-64v-37.5c-37.3-13.2-64-48.7-64-90.5 0-19.6 5.9-37.9 16-53.1V152c0-9 1.1-17.7 3.3-26l-33.6-14H216c-75.1 0-136 60.9-136 136v44.6l-1.7 4.3-32 80-44.6-17.8L32 283.4V248c0-101.6 82.4-184 184-184h131.3l4.4 1.9 42.1 17.6c1.9-2.2 3.9-4.2 5.9-6.2l-18.1-21.9 36.9-30.7zM544 272c26.5 0 48-21.5 48-48 0-14.2-6.1-26.9-16-35.8l-16-14.3V152c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v33.4l-8 12.1c-5 7.6-8 16.6-8 26.5 0 26.5 21.5 48 48 48zM408 432v-48h48v96H296v-72.4c-26.4 5.4-53.6 5.4-80 0V480H64V368h48v64h56v-88.7l31.2 9.8 11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6 31.2-9.8V432zm40-288a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), UR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 464c82 0 119.4-18.7 140-45.4 23.4-30.3 36-83.6 36-178.6V48H48v192c0 95.1 12.6 148.4 36 178.6 20.6 26.7 58 45.4 140 45.4m0 48C48 512 0 432 0 240V0h448v240c0 192-48 272-224 272m-24-304c0 35.3-28.7 64-64 64s-64-28.7-64-64v-32h128zm112 64c-35.3 0-64-28.7-64-64v-32h128v32c0 35.3-28.7 64-64 64M176 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32m32 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-32 160a16 16 0 1 1 32 0 16 16 0 1 1-32 0m0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0-192a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), GR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M81.8 212.4C111.1 233.1 164.1 256 256 256s144.9-22.9 174.2-43.6c14.8-10.4 24-20.6 29.4-27.8l.5-.6-.5-.6c-5.4-7.2-14.6-17.3-29.4-27.8C400.9 134.9 347.9 112 256 112s-144.9 22.9-174.2 43.6c-14.8 10.4-24 20.6-29.4 27.8l-.4.6.5.6c5.4 7.2 14.6 17.3 29.4 27.8zm428.4-37.6-22.1 9.2 22.2-9.2c1.2 2.9 1.8 6.1 1.8 9.2v148.8l-1.8 4.4L488 328c22.2 9.2 22.2 9.2 22.1 9.2v.1l-.1.2-.2.5c-.2.4-.4.9-.7 1.4-.5 1.1-1.3 2.6-2.3 4.3-2 3.5-4.8 8.2-8.9 13.6-8.1 10.8-20.9 24.7-40.1 38.2C419.3 422.9 356.2 448 256 448S92.7 422.9 54.1 395.6c-19.2-13.6-32-27.4-40.1-38.2-4-5.4-6.9-10.1-8.9-13.6-1-1.7-1.7-3.2-2.3-4.3l-.7-1.4-.2-.5-.1-.2v-.1l22.1-9.2-22.1 9.1-1.8-4.4V184c0-3.1.6-6.3 1.8-9.2L24 184c-22.2-9.2-22.2-9.2-22.1-9.2v-.1l.1-.2.2-.5c.2-.4.4-.9.7-1.4.5-1.1 1.3-2.6 2.3-4.3 2-3.5 4.8-8.1 8.9-13.6 8.1-10.8 20.9-24.7 40.1-38.2C92.7 89.1 155.8 64 256 64s163.3 25.1 201.9 52.4c19.2 13.6 32 27.4 40.1 38.2 4.1 5.4 6.9 10.1 8.9 13.6 1 1.7 1.7 3.2 2.3 4.3l.7 1.4.2.5.1.2v.1zM48 247.1V322c1 1.7 2.5 3.9 4.4 6.5 5.4 7.2 14.6 17.3 29.4 27.8C111.1 377.1 164.1 400 256 400s144.9-22.9 174.2-43.6c14.8-10.4 24-20.6 29.4-27.8 2-2.6 3.4-4.9 4.4-6.5v-75c-2 1.5-4 3-6.1 4.5C419.3 278.9 356.2 304 256 304S92.7 278.9 54.1 251.6c-2.1-1.5-4.1-3-6.1-4.5z" })
  }
), qR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M307.9 320 466.7 13l42.6 22-240 464-6.7 13H0V320h304zM283 368H144v96h89.4zm-235 0v96h48v-96zm384 64v32h160v-32zm-48-48h256v128H384v-80z" })
  }
), WR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M307.9 320 466.7 13l42.6 22-240 464-6.7 13H0V320h304zM283 368H144v96h89.4zm-235 0v96h48v-96zM173.3 13 302 261.7 288.4 288h-26.9L130.7 35zM496 368H373.1l24.8-48H640v192H377.4l-6.7-13-32.7-63.1 27-52.2 41.6 80.3H496zm48 0v96h48v-96z" })
  }
), ER = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-32 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m160 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0M92.6 300.3 8 336.2l30.2 77-5.5 44.8-6.6 54 50.7-19.5 41.7-16 37.7 4.2L204 486l5.2-47.7 3.8-34.6 43-17.7 43.1 17.6 3.8 34.6L308 486l47.7-5.3 37.7-4.2 41.7 16 50.8 19.5-6.6-53.9-5.5-44.8 30.2-77-84.6-35.9-7.4-80.5-88.9 5-45.1-16.4-6.7-2.4.1-6.1-48.4 14.6-34.1 10.3-88.9-5-7.5 80.4zM270 256.7l36.7 13.3 9.3 3.4 9.8-.6 42.7-2.4 3.2 34.3 2.7 28.6 26.4 11.2 41.6 17.6-13.2 33.6-4.5 11.3 1.5 12.1 2.4 19.5-17.9-6.9-10.9-4.2-11.6 1.3-37.7 4.2-3.8-34.5-3-28.5-26.5-10.8-28.5-11.6-19.5-59.3.7-31.5zm-126.5 13.7 42.7 2.4 8.5.5 8.1-2.5 19-5.8-.5 22-.2 8.2 2.6 7.8 12.8 39-41.7 17.1-26.5 10.9-3.1 28.4-3.7 34.6-37.6-4.1-11.6-1.3-10.9 4.2-17.9 6.9 2.4-19.5 1.4-12.2-4.4-11.3-13.2-33.5 41.6-17.6 26.4-11.2 2.7-28.6 3.2-34.3z" })
  }
), OR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 224c0 176-128 256-128 256H128S0 400 0 224c0-57.3 25.1-108.8 65-144H32V32h384v48h-33c39.9 35.2 65 86.7 65 144m-400 0h352c0-79.5-64.5-144-144-144h-64c-5.4 0-10.7.3-16 .9V160h-48V95c-47.4 23.6-80 72.5-80 129m30.6 128c7.4 14 15.5 26.3 23.6 36.9 13.6 17.8 27.1 30.9 37 39.3 1.6 1.4 3.1 2.6 4.5 3.7h160.6c1.4-1.1 2.9-2.4 4.5-3.7 9.9-8.5 23.4-21.5 37-39.3 8.1-10.6 16.2-22.9 23.6-36.9H78.6z" })
  }
), IR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 464 64-80v-96C64 128 160 0 288 0h192l-38.4 38.4L432 48l-24.8 24.8c13.2 9 25.5 19.4 36.7 31.2 41.7 43.8 68.1 106.4 68.1 184v96l64 80v48H0zM288 48c-90.5 0-176 94-176 240v112.8L101.5 414l-40 50H160V336c0-70.7 57.3-128 128-128s128 57.3 128 128v128h98.5l-40-50-10.5-13.2V288c0-83.7-35.5-142.6-83.8-175.5l-47.9-32.6L364.1 48zm-80 416h160V336c0-44.2-35.8-80-80-80s-80 35.8-80 80z" })
  }
), NR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 232h640v48H0z" })
  }
), XR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m455.3 26.2-6.1-24.5L425.1 9 263 58C144.8 93.7 64 202.6 64 326v186h394l-21.3-36.2-59-100.3 28.3 32.3 7.2 8.2H516l7.2-9.6 48-64 7.5-10.1-4-11.9-56-168L515 141l-11.4-3.8-50.6-16.8 5.8-2.9 17.2-8.6-4.7-18.7-16-64zM220.1 330.4c25.4 30.4 63 44.8 99.8 41.6l54.1 92H112V326c0-102.3 67-192.5 164.9-222.1l138-41.7 5.1 20.9-30.7 15.4-13.3 6.7v40.1l16.4 5.5L477 179l48.2 144.7L492 368h-57.1l-48.8-55.8-14.9-17-17.9 13.9-1.2.9c-29.3 22.8-71.3 18.2-95.1-10.3l-22.6-27.1-15.4-18.4-36.9 30.7 15.4 18.4 22.6 27.1zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), KR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440 48h43.2l44.8 67.3v61.1l-42.7 19L457 167l-7-7h-42v46.5l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4 0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1V464h-48V326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6L272 309.8V264h64V145.4l.8-6.5C343.2 87.7 387 48 440 48M224 295.8l-1.3-.4-31.4-9.2.7 32.7v1.3c0 8-1.4 16-4.3 23.5L172 385.8l-2.7 7.3 2.1 7.5 17.5 63.4h-49.8l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9 0-29.9 20.4-55 48-62.2V264h64zM208 160h80v56h-80zm364-65.3L540.8 48H560V0H440c-70.1 0-129.1 47.5-146.7 112H176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v88h48v-88c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-17.3 46.1-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h149.4l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2l51.8 15.2V512h144V327.8c19.8-22.6 32-52.3 32-85.5v-.3l10.7 10.7 15.1-6.7 72-32 14.3-6.3v-107l-4-6zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), QR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m336.8 139-2.6 21h-158c-35.5 0-64.2 28.8-64.2 64.2 0 8.2 1.6 16.3 4.6 23.9l25.3 63.3 3.5 8.6-3.3 8.7-20.6 54.8-2.7 7.3 2.1 7.5 18.2 65.7h49.8l-17.6-63.4-2.1-7.5 2.7-7.3 15.8-42.1c2.8-7.5 4.3-15.4 4.3-23.5v-1.3l-.7-32.7 31.4 9.2 88 25.7c2.1.6 4.2 1.1 6.3 1.6l19 4V464h48V308.1l7.3-7.1c15.1-14.8 24.7-35.3 24.7-58.8 0-11.2-2.2-21.7-6.2-31.4l-1.8-4.4V160h41.9l7 7 28.3 28.3 42.7-19v-61L483.2 48H440c-53 0-96.8 39.7-103.2 91m204-91L572 94.7l4 6V207.6l-14.3 6.3-72 32-15.1 6.7-10.6-10.7v.3c0 33.2-12.2 62.9-32 85.5V512H288V364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-13 34.8 24 86.3 8.5 30.4H102.6l-4.9-17.6-23.1-83.2-4.2-15.1-2.1-7.5 2.7-7.3 5.5-14.6 17.3-46.1L72 265.9c-5.3-13.3-8-27.4-8-41.7 0-2.9.1-5.7.3-8.5A40.1 40.1 0 0 0 48 248v88H0v-88c0-47.3 37.3-85.9 84.1-87.9 20.3-29.1 54-48.1 92.1-48.1H293.3C310.9 47.5 369.9 0 440 0h120v48zM448 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), ZR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5l28.2 38.9C428 494 376.1 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0s256 114.6 256 256v96h40v48h-26.3l-11.4 80H592v32h-80v-32h13.7l-11.4-80H488v-48h40v-96c0-114.9-93.1-208-208-208M208 256a112 112 0 1 0 224 0 112 112 0 1 0-224 0m112 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320m-64-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), JR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 128h48v-26.3l80-11.4V104h32V24h-32v13.7l-80-11.4V0h-48v104zM8 464v48h432v-48H32zm24-80H8v48h432v-48h-24zM8 304v48h432v-48H32zm48-148c0-37.6 30.4-68 68-68h132V40H124C59.9 40 8 91.9 8 156s51.9 116 116 116h316v-48H124c-37.6 0-68-30.4-68-68" })
  }
), jR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v224h112v48H48v48h112v48H48v48h224V48zM0 0h320v359l-66.9 153H0V48zm136 96h48v40h40v48h-40v40h-48v-40H96v-48h40zm216 176a80 80 0 1 1 160 0 80 80 0 1 1-160 0m168 112 56 128H288l56-128z" })
  }
), YR = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0h-24v80H0v432H26.3 26 34.2 34 89.2 89h551V80H480V0h-24zm408 192h-80v48h80v48h-80v48h80v128H480V128h112zm-488 48h24v-48H48v-64h112v336H79.8h.2H48V336h80v-48H48v-48zm104 224V48h224v416h-64V352h-96v112zm88-384v40h-40v48h40v40h48v-40h40v-48h-40V80z" })
  }
), _R = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48h224v208H320v48h208v48H320v48h208v64H320v48h256V0H256v64h48zm104 32v40h-40v48h40v40h48v-40h40v-48h-40V80zm-240 96h-48v40H80v48h40v40h48v-40h40v-48h-40zM48 144h192v208H48zm0 256h192v64H48zM0 96v416h288V96H48z" })
  }
), h$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0m64 160 128 96h256v256H0V160h48zm-16 48H48v48h128zM48 336v128h64V304H48zm184 128V304h-72v160zm120 0V304h-72v160zm48 0h64V304h-64zM272 24c0 26.7 14.3 46.4 35 73.4l1.4 1.9C327.5 124 352 155.8 352 200v24h-48v-24c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C248.5 100 224 68.2 224 24V0h48zm112 0c0 26.7 14.3 46.4 35 73.4l1.4 1.9C439.5 124 464 155.8 464 200v24h-48v-24c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C360.5 100 336 68.2 336 24V0h48z" })
  }
), c$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m449.9 129.9-320 320c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9L382 62c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9m33.9 33.9c37.5-37.5 37.5-98.3 0-135.8S385.5-9.5 348 28L28 348c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0l320-320m-6.5 57.5-256 256L256 512l256-256zM34.7 290.7l256-256L256 0 0 256zm371.8-140 14.6-6.5-13-29.2-14.6 6.5-72 32-4.9 2.2-2.6 4.7-37.6 67.7-59.6 29.8-4.4 2.2-2.4 4.3-37.8 68-68 37.8-14 7.8 15.5 28 14-7.8 72-40 4-2.2 2.2-4 37.6-67.7 59.6-29.8 4.4-2.2 2.4-4.3 37.4-67.3 67.1-29.8z" })
  }
), s$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0H0v48h32v416H0v48h512v-48h-32V48h32zm-80 464H304v-80h48c0-53-43-96-96-96s-96 43-96 96h48v80H80V48h352zM192 96h-64v64h64zm32 0v64h64V96zm160 0h-64v64h64zm-256 96v64h64v-64zm160 0h-64v64h64zm32 0v64h64v-64z" })
  }
), v$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h384v48h-32v81.9l-7 7-119 119 43.8 43.8c-8.8 21-13.7 44-13.7 68.2 0 59.5 29.6 112.1 74.8 144H0V464h32v-81.9l7-7 119-119L39 137l-7-7V48H0zm80 48v62.1L97.9 128h188.2l17.9-17.9V48zm208 320a144 144 0 1 1 288 0 144 144 0 1 1-288 0m160-80h-32v96h80v-32h-48v-48z" })
  }
), e$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h384v48h-32v81.9l-7 7-119 119L345 375l7 7v82h32v48H0v-48h32v-81.9l7-7 119-119L39 137l-7-7V48H0zm80 48v62.1l112 112 112-112V48z" })
  }
), l$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h384v48h-32v81.9l-7 7-119 119L345 375l7 7v82h32v48H0v-48h32v-81.9l7-7 119-119L39 137l-7-7V48H0zm80 48v62.1L97.9 128h188.2l17.9-17.9V48zm17.9 336h188.2L192 289.9z" })
  }
), t$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 512h384v-48h-32v-81.9l-7-7-119-119L345 137l7-7V48h32V0H0v48h32v81.9l7 7 119 119L39 375l-7 7v82H0zm80-48v-62.1l112-112 112 112V464z" })
  }
), w$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h32v81.9l7 7 119 119L39 375l-7 7v82H0v48h384v-48h-32v-81.9l-7-7-119-119L345 137l7-7V48h32V0h-24zm280 48v62.1l-112 112-112-112V48zM192 289.9l112 112V464H80v-62.1z" })
  }
), g$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM464 212.8V464H112V212.8L288 63.5z" })
  }
), i$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48h256v416H416v48h224V0H288v134.3l48 40zm80 208h32v-64h-64v22.3l20.5 17.1L416 241zm0 96h32v-64h-32zm64-160v64h64v-64zm64 96h-64v64h64zM448 96h-64v64h64zm32 0v64h64V96zM48 278.5l144-120 144 120V464H48zM0 256v256h384V256L192 96zm240 16h-96v96h96z" })
  }
), m$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-55.6-47.1V64h-48v85.9L303.5 13.7zM112 464V212.8L288 63.5l176 149.3V464z" })
  }
), a$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L464 149.9V64h48v126.6l55.5 47.1-31.1 36.6-24.4-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zm0 63L112 212.8V464h108.8L192 416l96-80-64-112 160 112-96 80 28.8 48H464V212.8z" })
  }
), o$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L464 149.9V64h48v126.6l55.5 47.1-31.1 36.6-24.4-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zm176 212.3L288 63.5 112 212.8V464h352V216zM235.2 208h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2 0 16.1-6.6 31.5-18.2 42.7L299 389.5l-11 10.6-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7 0-32.7 26.5-59.2 59.2-59.2z" })
  }
), n$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L464 149.9V64h48v126.6l55.5 47.1-31.1 36.6-24.4-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zm0 63L112 212.8V464h352V212.8zM256 192h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), r$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-55.6-47.1V64h-48v85.9L303.5 13.7zM112 464V212.8L288 63.5l176 149.3V464zm176-176a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-80 32-32 96h224l-32-96z" })
  }
), d$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L464 149.9V64h48v120c0 2.1-.3 4.1-.7 6l56.3 47.7-31.1 36.6-24.5-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zM112 212.8V464h352V212.8L288 63.5zM256 288h64v-64h-64zm-48-112h160v160H208V224z" })
  }
), S$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L464 149.9V64h48v126.6l55.5 47.1-31.1 36.6-24.4-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zM112 212.8V464h80V272h192v192h80V212.8L288 63.5zM336 320h-96v144h96z" })
  }
), z$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464h80V272h156.5c-9.5 14.6-17 30.8-21.8 48H240v144h108.5c12.3 18.8 28 35.1 46.3 48H64V253.5l-24.5 20.8-31-36.6 264-224zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), p$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464h80V272h156.5c-9.5 14.6-17 30.8-21.8 48H240v144h108.5c12.3 18.8 28 35.1 46.3 48H64V253.5l-24.5 20.8-31-36.6 264-224zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), M$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464h80V272h156.5c-9.5 14.6-17 30.8-21.8 48H240v144h108.5c12.3 18.8 28 35.1 46.3 48H64V253.5l-24.5 20.8-31-36.6 264-224zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7 36.7-36.7z" })
  }
), x$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM112 464V212.8L288 63.5l176 149.3V464H316.8L288 416l96-80-160-112 64 112-96 80 28.8 48z" })
  }
), H$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 0-40.4 62.4-72.7-15.5 15.6 72.7L0 160l62.4 40.4-15.5 72.7 72.7-15.6 7.9 12.2 21.1-17.2 14.4-11.6c-1 0-2 .1-2.9.1-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 6.6-.8 12.9-2.3 19.1l50.1-40.8-30.3-19.6L273.2 47l-72.8 15.4zm48 160a48 48 0 1 0-96 0 48 48 0 1 0 96 0m207-50.7-15-12-15 12-200 160-18.7 15 30 37.5 18.7-15 9-7.2V512h352V299.5l9 7.2 18.7 15 30-37.5-18.7-15-200-160zm113 151.8V464H272V261.1l128-102.4zM352 288v96h96v-96z" })
  }
), V$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h309.6c-19.3-12.9-36.2-29.2-49.7-48H240V320h51.7c3.8-16.6 10.3-32.7 18.4-48H192v192h-80V212.8L288 63.5l113.1 96c11.8-11 24-21.6 36.5-32L303.5 13.7zM513 224.1c-32.3-37.5-65-64-65-64s-128 103.6-128 192 71.6 160 160 160 160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), C$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 0h-48v512h48V192h144V32H496v-8zm-80 133L286.3 36.7 272 26.1l-14.3 10.6L19.4 213.5.2 227.8l28.6 38.5L48 252.1l16-11.9V512h128v.6h48v-.6h64v.6h48v-.6h64v-48h-64V304H192v160h-80V204.6L272 85.9l144 106.8zM304 352v112h-64V352z" })
  }
), L$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0m152-78.6L129.4 88l11.3 11.3 28.7 28.7H64v32h105.4l-28.7 28.7-11.3 11.3 22.6 22.6 11.3-11.3 56-56 11.3-11.3-11.3-11.3-56-56zM316.7 110c-3.3-16.7-8.9-32.6-16.5-47.2L370 12.5l14-10.1 14 10.1 188.8 136 19.5 14-28.1 38.9-18.2-13V273c-8.9-4.9-17.3-10.9-28.3-18.8L512 240v-86.2L384 61.6zM111 376.9C91.7 387.8 63.5 400 32 400v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7m17 101.3c-4.7 3.3-10.4 7-16.9 10.7C91.7 499.8 63.5 512 32 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7z" })
  }
), B$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.9 12.4 288 2.6l-13.9 9.8-192 136-19.6 13.9 27.7 39.2 19.6-13.9 2.1-1.5v65.4l2.6 1.9 1.1.8c13.9 10 23.6 17 35.5 22.5 2.8 1.3 5.8 2.5 8.7 3.6V152.1L288 61.4l128 90.7v128.2c3-1.1 5.9-2.3 8.7-3.6 12-5.5 21.7-12.5 35.5-22.5l3.7-2.7v-65.4l2.1 1.5 19.6 13.9 27.7-39.2-19.6-13.9-192-136zM96 366.2c4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 344.2 19.7 352 0 352v48c31.5 0 59.7-12.2 79-23.1 6.5-3.7 12.2-7.4 16.9-10.7zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1" })
  }
), u$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM112 464V212.8L288 63.5l176 149.3V464zm64-196.8c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6 11 10.6 11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7 0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z" })
  }
), R$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m240 1.3 15 12 200 160 18.7 15-30 37.5-18.7-15-9-7.2V240h-48v-74.9L240 62.7 112 165.1V368h160v48H64V203.5l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12zM288 192v48h-16v48h-80v-96zm256 128H352v144h192zm-240 0v-48h288v192h48v24l-24 24H280l-24-24v-24h48z" })
  }
), $$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h320V272H192v192h-80V212.8L288 63.5l157.1 133.2c11.2-12.3 25-22.1 40.6-28.5L303.5 13.7zM336 464h-96V320h96zm192-224c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), k$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464h236.5c12.3 18.8 28 35.1 46.3 48H64V253.5l-24.5 20.8-31-36.6 264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm32 112a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), P$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464h236.5c12.3 18.8 28 35.1 46.3 48H64V253.5l-24.5 20.8-31-36.6 264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), F$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h330.8c-18.3-12.9-34.1-29.2-46.3-48H112V212.8L288 63.5l159.5 135.3c15.4-4.4 31.7-6.8 48.5-6.8 6.4 0 12.7.3 18.8 1L303.5 13.7zM326.6 320c6.7-23.8 18.3-45.5 33.6-64H320v-64h-64v64h-64v64h64v64h64v-64zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), T$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 24V0h-48v512h48V192h144V32H496zm-80 109L286.3 36.7 272 26.1l-14.3 10.6L19.4 213.5.2 227.8l28.6 38.5L48 252.1l16-11.9V512h352v-48H112V204.6L272 85.9l144 106.8zm-176 59v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), A$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM112 464V212.8L288 63.5l176 149.3V464zm144-272v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), D$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M146 5.3C135.3 1.8 123.8 0 112 0 50.1 0 0 50.1 0 112s50.1 112 112 112c40.6 0 76.1-21.6 95.8-53.9-9.9 3.8-20.6 5.9-31.8 5.9-48.6 0-88-39.4-88-88 0-38.1 24.2-70.5 58-82.7zM256 0l-21.3 42.7L192 64l42.7 21.3L256 128l21.3-42.7L320 64l-42.7-21.3zM96 320l-21.3 42.7L32 384l42.7 21.3L96 448l21.3-42.7L160 384l-42.7-21.3zm319-210.7-15-12-15 12-200 160-18.7 15 30 37.5 18.7-15 9-7.2V512h352V299.5l9 7.2 18.7 15 30-37.5-18.7-15-200-160zm113 151.8V464H272V261.1l128-102.4zM352 288v96h96v-96z" })
  }
), y$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-77.4 153.5-20.5 47.9-9.5 22.1-44.1-18.9 9.5-22.1 24-56 3.5-8.1 7.9-3.9 80-40 8.2-4.1 8.8 2.4 88 24 13.2 3.6 3.6 13.2 22.3 81.9L633 279l-34 34-40-40-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.7-68-36.3 18.2zm59.2 65.1c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3L513 184.8c.2-.8.5-1.6.9-2.3l-22.1-6-30 90.1zm-66.3 135.9 24.1-60.4 39 31.7-20.4 51.1-1.8 4.6-3.4 3.5-60.8 60.8-17 17-33.9-33.9 17-17 57.3-57.3zM255 13.3l132.8 106.2-47.2 23.6v.1L240 62.7 112 165.1V368h262.9l-6.6 16.5-31.5 31.5H64V203.5l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12 15 12zM160 192h96v96h-96z" })
  }
), b$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 48a48 48 0 1 0 96 0 48 48 0 1 0-96 0m173.4 153.5 20.5 47.9 9.5 22.1 44.1-18.9-9.5-22.1-24-56-3.5-8.1-7.9-3.9-80-40-8.2-4.1-8.8 2.4-88 24-13.2 3.6-3.6 13.2-22.3 81.9L319 287l34 34 48-48 4.5-4.5 1.7-6.1 6.4-23.4 25.7 82.3-54.4 44.2-6.2 5-1.9 7.8-24 96-5.8 23.3 46.6 11.6 5.8-23.3 22.1-88.2 104.6-85c18.1-14.7 25.2-39.1 17.8-61.2l-22.7-68 36.3 18.2zm-59.2 65.1c1.1 3.2 0 6.6-2.5 8.7l-16.3 13.3-32.5-103.8c-.2-.8-.5-1.6-.9-2.3l22.1-6 30 90.1zm66.2 135.9-24.1-60.4-39 31.7 20.4 51.1 1.8 4.6 3.5 3.5 60.8 60.8 17 17 33.9-33.9-17-17-57.3-57.3zM384.6 116.9 255 13.3l-15-12-15 12-200 160-18.7 15 30 37.5 18.7-15 9-7.2V416h272.5l12-48H112V165.1L240 62.7l115.7 92.5 9-32.9 20-5.4zM160 192v96h96v-96z" })
  }
), f$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m336 1.3 15 12 200 160 18.7 15-30 37.5-18.7-15-9-7.2V416H271.6c-5.9-16.8-13.4-32.8-22.1-48H464V165.1L336 62.7 208 165.1v147.7a293.85 293.85 0 0 0-48-40.3v-69l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12zM384 192v96h-96v-96zM0 304v-48c141.4 0 256 114.6 256 256h-48c0-114.9-93.1-208-208-208m32 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m80 64c0-61.9-50.1-112-112-112v-48c88.4 0 160 71.6 160 160z" })
  }
), U$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.2 208h.8v-48L416 0 277 125.1l37.3 31 100-90 93.8 93.9H448v47.1l27.6 32.1 69.2 80.8H480v51.9l30.1 30.1 62 62H416v48h224v-48l-48-48-48-48h64v-48l-54.9-64-41.1-48h16zM48 278.5l144-120 144 120V464H48zM0 256v256h384V256L192 96zm240 16h-96v96h96z" })
  }
), G$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5l15-45.6C256.4 3.8 233.4 0 209.4 0 95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8 12.7 3.4 26 5.2 39.7 5.2.6 0 1.2 0 1.8-.1 1.8 0 3.6.1 5.4.1h.4c31.5 0 59.7-12.2 79-23.1 6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9h-.4c-12.9 0-25.2-1.4-36.7-4.2-43.4-12.7-75-52.6-75-99.8 0-57.4 46.7-104 104.4-104 15.9 0 30.9 3.5 44.3 9.8l20.4-43.5c-19.6-9.2-41.5-14.3-64.6-14.3-58.1 0-108.8 32.5-134.4 80.4m318 108.7V152l79.9-60 79.6 60 .3 120.9c2.5 1.4 5 2.6 7.6 3.8 13.1 6 27.5 10.3 40.5 10.3l-.3-159L448 32l-128 96v134.9c8.1 5.6 15.2 10 23.3 13.7 7.9 3.6 16.4 6.7 24.7 8.5zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1" })
  }
), q$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h352v134.3l-48 40V48h-48v64h-48V48h-64v64H96V48H48v158.9l57.9 65.2 6.1 6.8V512H64V297.1L6.1 231.9 0 225.1V24zm304 216 48-40 96-80 192 160v256H256V256zm-128-72c22.1 0 40 17.9 40 40v56h-80v-56c0-22.1 17.9-40 40-40m128 134.5V464h288V278.5l-144-120zm192-6.5v96h-96v-96z" })
  }
), W$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 .5 15.5 13.2 264 224-31.1 36.6-24.4-20.8V512H64V253.5l-24.5 20.8-31-36.6 264-224zM112 212.8V464h352V212.8L288 63.5zM224 224a64 64 0 1 1 128 0 64 64 0 1 1-128 0m144 96 32 96H176l32-96z" })
  }
), E$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5v137.4c3.8-2.6 7.8-5.5 12.3-8.7l1.1-.8L96 368l16 11.5V212.8L288 63.5l176 149.3v166.7l16-11.5 19.7 14.2c4.4 3.2 8.5 6.1 12.3 8.7V253.5l24.5 20.8 31.1-36.6-264-224zM256 224h64v64h-64zm0-48h-48v160h160V176h-48zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1" })
  }
), O$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM112 464V212.8L288 63.5l176 149.3V464zm144-176v-64h64v64zm-48-112v160h160V176H256z" })
  }
), I$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.5 13.7 288 .5l-15.5 13.2-264 224 31.1 36.6L64 253.5V512h448V253.5l24.5 20.8 31.1-36.6-264-224zM112 464V212.8L288 63.5l176 149.3V464h-80V272H192v192zm128 0V320h96v144z" })
  }
), N$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.7 104.6C125.6 88.7 150.3 80 175.8 80H227c33.7 0 61 27.3 61 61 0 20.7-10.5 39.8-27.5 51H0v48h171l-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2H0v48h53.8C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109h51.2c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2 18.7-15-30-37.5-18.7 15-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6H157c-33.7 0-61-27.3-61-61 0-12.8 4-24.9 11-35h277v-48H183l90-48h111v-48h-60.7c8.2-15.4 12.7-32.9 12.7-51 0-60.2-48.8-109-109-109h-51.2c-36.4 0-71.7 12.4-100.1 35.1L73 69.3l-18.7 15 30 37.5 18.7-15z" })
  }
), X$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m171.2 99.6-12.9 120.6c-4.8 44.8 30.2 83.8 75.2 83.8 38.7 0 71.2-29.2 75.3-67.6l12.9-120.6C326.5 71 291.5 32 246.5 32c-38.7 0-71.2 29.2-75.3 67.6M246.5 80c16.5 0 29.3 14.3 27.5 30.7l-12.9 120.5c-1.5 14.1-13.4 24.8-27.5 24.8-16.5 0-29.3-14.3-27.5-30.7L219 104.7c1.4-14 13.3-24.7 27.5-24.7m109.7 21.5-7.4 88.4c-3.7 44.2 31.2 82.1 75.5 82.1 39.4 0 72.3-30.2 75.6-69.5l7.4-88.4C510.9 69.9 476 32 431.7 32c-39.4 0-72.3 30.2-75.6 69.5zM431.7 80c16.3 0 29.1 13.9 27.7 30.1l-7.4 88.4c-1.2 14.4-13.3 25.5-27.7 25.5-16.3 0-29.1-13.9-27.7-30.1l7.4-88.4c1.2-14.4 13.2-25.5 27.7-25.5M28.1 431.7l464-80-8.2-47.3-464 80 8.2 47.3zm13.3-321.8L75 95 44.4 339.5l49.4-8.5 34-272.4-33.2-24.5-72 32L.5 75.9l18.9 43.8 22.1-9.8zm178.5 369.8 240-40-7.9-47.3-240 40z" })
  }
), K$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 24.7V-1.5L189.9.8C83.5 9.9 0 99.2 0 208c0 101.2 72.3 185.5 168 204.2V513l26.1-2.2C300.5 501.5 384 412.2 384 303.4c0-101.2-72.3-185.5-168-204.2V24.7zM48 208c0-74.5 51-137.2 120-155v89l21.9 1.9C271.8 151 336 219.7 336 303.4c0 74.6-51 137.2-120 155v-89l-21.9-1.9C112.2 360.4 48 291.7 48 208m128 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), Q$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 232h320v48H0z" })
  }
), Z$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48C106.1 18.8 71.3 0 32 0H16v48h16c39.8 0 72 32.2 72 72v112H40v48h64v112c0 39.8-32.2 72-72 72H16v48h16c39.3 0 74.1-18.8 96-48 21.9 29.1 56.7 48 96 48h16v-48h-16c-39.8 0-72-32.2-72-72V280h64v-48h-64V120c0-39.8 32.2-72 72-72h16V0h-16c-39.3 0-74.1 18.8-96 48" })
  }
), J$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h136v352H0v48h320v-48H184V80h136V32H160z" })
  }
), j$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0C140.9 0 72.6 63.3 64.8 144.4 28.4 148 0 178.7 0 216v72h448v-72c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0M112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6l-1.5 25.4H376c13.3 0 24 10.7 24 24v24H48v-24c0-13.3 10.7-24 24-24H113.6l-1.5-25.4c-.1-2.2-.2-4.4-.2-6.6zm112 352 123.4-192H100.6z" })
  }
), Y$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0v182l174.7 51 17.3 5v146H32V93.7l17.6-4.9L272 27.5V0zm-48 128V77.3l-192 53V336h384v-62l-171.4-50H224v-32h48v-32h-48v-32h16zm304 280v104H0v-48h96v-48h48v48h240v-48h48v48h96v-56z" })
  }
), _$ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m389.2 394.3-29.6-130.6L336 160l-25.2 100.9-.6 2.3L288 352l-19.4-64.5L261 262l-21-70-20.9 97.4-2.6 12L192 416l-24.5-114.5-2.6-12L144 192l-21.9 73.1-6.7 22.3L96 352l-23.9-87.5L13.1 48 0 0h512l-9 48-64.7 345.3L416 512zm-99.8-245.9L302.5 96h68.2l12.1 53.4 28.7 126.2L454.2 48H62.8l35.4 129.6 14.9-49.6h66.3l11.6 53.9 1.1 5 1.1-5 11.4-53.9h66.3l12.9 42.9 5.6-22.6z" })
  }
), hk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M125.5 21.5C111.7 7.7 92.8 0 73.3 0 33.2 0 0 32.5 0 72.6c0 20.1 8.3 39.2 22.9 52.9L128 224l105.1-98.5c14.6-13.7 22.9-32.9 22.9-52.9C256 32.5 222.8 0 182.7 0c-19.5 0-38.5 7.7-52.3 21.5L128 24zm2.5 136.7L55.8 90.5c-5-4.6-7.8-11.1-7.8-17.9C48 59.6 59.1 48 73.3 48c7 0 13.7 2.8 18.3 7.5l33.7-33.7-33.7 33.7 2.5 2.5L128 91.9 161.9 58l2.5-2.5c4.6-4.6 11.4-7.5 18.3-7.5 14.2 0 25.3 11.6 25.3 24.6 0 6.8-2.8 13.3-7.8 17.9zM224 288l-16-32H80l-16 32H0v224h288V288h-48zm16 48v128H48V336h45.7l13.3-26.5 2.7-5.5h68.7l2.7 5.5 13.2 26.5H224zm-48 56a48 48 0 1 0-96 0 48 48 0 1 0 96 0m265.1-136L320 400l72.2 10.5L374.9 512 512 368l-72.2-10.5zM288 256c35.3 0 64-21.5 64-48V83.7l112-22.4v68.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48V2.7l-28.7 5.8-160 32-19.3 3.8v117.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48" })
  }
), ck = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48v48h128V48h80v416H48V48zM48 0H0v512h384V0h-48zm144 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128M80 416h224l-32-96H112z" })
  }
), sk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0H224v128h128zM192 64H0v448h576V64H384v48h144v352H48V112h144zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128M176 432h224l-32-96H208z" })
  }
), vk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 160v272H314.7L288 352H128l-26.7 80H48V160zM48 32H0v448h576V32h-48zm224 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0m104-48h-24v48h128v-48h-24zm0 96h-24v48h128v-48h-24z" })
  }
), ek = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 368v64H400v-64zm0-48h-48V192h11.1c23.4 37 36.9 80.9 36.9 128m-96-128v128h-36.6c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80H144V192zM96 320H48c0-47.1 13.5-91 36.9-128H96zM288 80c5.4 0 10.7.2 16 .5V144H124.8C167.7 104.3 225 80 288 80m64 64V88.6c37.6 10.4 71.4 29.6 99.2 55.4zM176 368v64H48v-64zM48 480h528V320c0-159.1-128.9-288-288-288S0 160.9 0 320v160zm240-192c35.3 0 64 28.7 64 64v80H224v-80c0-35.3 28.7-64 64-64" })
  }
), lk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h35.8l80.8-110.2 19.4-26.4 19.4 26.4 29.4 40.2 83.1-127.1 20.1-30.8 20.1 30.7L485 400h43V112zm.6 336H0V64h576v384H96zM160 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), tk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432v-64h352v64zm274-112-18-48H144l-18 48H48V80h352v240zm126 24V32H0v448h448V368zM288 176a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), wk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 368H48v64h352zM75.3 320l57.3-78.2 19.4-26.4 19.4 26.4 16.6 22.6 56-85.6 20-30.7 20.1 30.7L376.4 320H400V80H48v240zm372.7 0v160H0V32h448v48zM80 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), gk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM384 0v512H0V0h336zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0m144 96 32 96H80l32-96z" })
  }
), ik = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-44.9-34.9V32H70.5zm84 65.2H528v307.2l-66.9-51.9-73.7-101.4-19.6-26.9-19.3 27-6.3 8.8L256 176c0-26.5-21.5-48-48-48-4.1 0-8.1.5-11.9 1.5zm355 400L286.1 321.4l-27.8 38.9L225 327l-17.9-17.9-16.9 18.8-72 80-6.2 6.8V184.2l-48-37.8V480h48z" })
  }
), mk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h416V80zM0 32h512v448H0V80zm192 160a64 64 0 1 1 128 0 64 64 0 1 1-128 0m144 96 32 96H144l32-96z" })
  }
), ak = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 80v347.2l-12.6-17.3-128-176-19.6-26.9-19.3 27-90.2 126.3L161 327l-17.9-17.9-16.9 18.8-72 80-6.2 6.9V80zM48 32H0v448h512V32h-48zm144 144a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), ok = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80H144v256h88l24-64h160l24 64h88zM144 32h432v352H96V32zM48 96v336h432v48H0V96zm224 80a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), nk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80h384v256h-37.2L388.1 178.9 368 148.1l-20.1 30.7-52.2 79.8-12.4-16.9-19.3-26.3-19.4 26.4-69 94.2H144zM96 32v352h480V32H144zm-48 88V96H0v384h480v-48H48zm208 24a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), rk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432v-96h81.2l25.4 50.7 6.6 13.3H350.8l6.6-13.3 25.4-50.7H464v96zM402.5 80l52 208H353.2l-6.6 13.3-25.4 50.7H190.8l-25.4-50.7-6.6-13.3H57.5l52-208zM0 320v160h512V320L440 32H72zm184-192h-24v48h192v-48h-24zm-32 80h-24v48h256v-48h-24z" })
  }
), dk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24v206.1l63-63 17-17 33.9 33.9-17 17L273 305l-17 17-17-17-104-104-17-17 34-33.9 17 17 63 63V0h48zM160 320l32 64h128l32-64h160v192H0V320h48zm202.9 85.5L349.7 432H162.3L149 405.5 130.3 368H48v96h416v-96h-82.3L363 405.5z" })
  }
), Sk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 288v24h-48V93.1l-63 63-17 17-33.9-33.9 17-17 104-104 17-17 17 17 104 104 17 17-34.1 33.9-17-17-63-63zm-120 32 32 64h128l32-64h160v192H0V320h48zm202.9 85.5L349.7 432H162.3L149 405.5 130.3 368H48v96h416v-96h-82.3L363 405.5z" })
  }
), zk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 336v96h416v-96h-81.2l-25.4 50.7-6.6 13.3H161.2l-6.6-13.3-25.4-50.7zm406.5-48-52-208h-293l-52 208h101.3l6.6 13.3 25.4 50.7h130.4l25.4-50.7 6.6-13.3H368zM0 432V320L72 32h368l72 288v160H0z" })
  }
), pk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62.5 96H160l32 64h128l32-64h97.5l-40-48h-307zM512 96v192H0V96L80 0h352zm-48 48h-82.3L363 181.5 349.7 208H162.3L149 181.5 130.3 144H48v96h416zM192 384h128l32-64h160v192H0V320h160zm189.7-16L363 405.5 349.7 432H162.3L149 405.5 130.3 368H48v96h416v-96z" })
  }
), Mk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 40v48h448V40H24zm192 128v48h256v-48H216zm24 128h-24v48h256v-48h-24zM0 424v48h448v-48H24zm0-72 128-96L0 160z" })
  }
), xk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h320v48H211.3c17.7 19.8 30.1 44.6 34.7 72h74v48h-74c-11.4 68.1-70.7 120-142 120h-8.4l173.1 107.6 20.4 12.7-25.3 40.8-20.4-12.7L11.3 324.1l-11.3-7V272h104c44.7 0 82.3-30.6 93-72H0v-48h197c-10.7-41.4-48.2-72-93-72H0z" })
  }
), Hk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 80v96l48-21.8 80-36.4L368 96v80l48-21.8 80-36.4L544 96v384H32V32h160zm19.9 139.7L144 250.5V80H80v352h416V170.5l-108.1 49.2-67.9 30.8v-80zM208 296v80h-80v-80zm120 0v80h-80v-80zm40 0h80v80h-80z" })
  }
), Vk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 123.3V32H32v448h512V96l-48 21.8-80 36.4-48 21.8V96l-48 21.8-80 36.4-48 21.8zm128 47.3v79.9l67.9-30.8L496 170.5V432H80V80h64v170.5l67.9-30.8L320 170.5z" })
  }
), Ck = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96h202.4l7.1 7.6L320 221l110.5-117.4 7.1-7.6H640v320H437.6l-7.1-7.6L320 291 209.5 408.4l-7.1 7.6H0V120zm287 160L181.6 144H48v224h133.6zm65.9 0 105.5 112H592V144H458.4L353 256z" })
  }
), Lk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v80H48V32zM16 176h104v288h72v48H0v-48h72V224H16z" })
  }
), Bk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m576 72-47.3 171.4L395.2 110 416 32zM374.1 272H240v160h209.9l33-121.2-94-94-5.3 19.6zm29.2-108.6 133.3 133.2-50 183.4H192V224h145.3l12.5-46.3 14.4-53.5 39.2 39.2zM0 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m0 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64M0 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), uk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 112v288H48V112zM48 64H0v384h640V64h-48zm56 96v48h32v96H96v48h128v-48h-40V160h-56zm213.4 51.8c5.9 6.7 5.7 16.7-.3 23.3L248 309.9V352h128v-48h-57.2l33.6-36.4c22.7-24.6 23.2-62.3 1.2-87.4-26.2-30-73-29.7-98.9.5l-16.9 19.7 36.4 31.2 16.9-19.7c6.9-8.1 19.3-8.1 26.3-.1" })
  }
), Rk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h544V112zM0 64h640v384H0V112zm144 120v168H96V160h48z" })
  }
), $k = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h544V112zM0 64h640v384H0V112zm328 96h52c33.1 0 60 26.9 60 60 0 9.2-2.1 17.9-5.8 25.7 13.3 11 21.8 27.6 21.8 46.3 0 33.1-26.9 60-60 60h-92V160zm24 72h28c6.6 0 12-5.4 12-12s-5.4-12-12-12h-28zm44 72c6.6 0 12-5.4 12-12s-5.4-12-12-12h-44v24zM203.4 160l2.8 7.1 72 180 2 4.9h-51.6l-9.6-24h-70l-9.6 24H87.8l2-4.9 72-180 2.8-7.1h38.9zm-3.7 120L184 240.6 168.2 280z" })
  }
), kk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h160v120h-48V48h-64v464H24V392h48v72h64V24z" })
  }
), Pk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 160c0-44.2 35.8-80 80-80h32c44.2 0 80 35.8 80 80v7.4c0 22.9-10.9 44.5-29.4 58.1L184 256.6V144h-48v224h48v-51.8l71-52c30.8-22.6 49-58.5 49-96.8V160c0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160v16h48zm64 256v64h64v-64z" })
  }
), Fk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 480V224c0-79.5 64.5-144 144-144s144 64.5 144 144v256h48V224c0-106-86-192-192-192S0 118 0 224v256z" })
  }
), Tk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 96H62.2c0-36 38.4-96 128-96 58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c89.6 0 128 60 128 96h-64l-32-32-32 32h-64.6c3.5 15.4 7.2 35.7 9.5 59.7 4.4 45.4 3.7 104.4-13.9 167.1 52.6 11.3 93.3 55 100 109.1.7 5.2 1 10.6 1 16v32H32V480c0-5.4.3-10.8 1-16 7.9-63.1 61.7-112 127-112h24.9c26-56.3 38-110.2 43.3-151.1 1.3-9.9 2.2-19 2.8-27.1l-83.1 83.1c-25.5-25.5-40.7-95 22.6-158.4 1.3-1.3 2.7-2.7 4.1-3.9L144 64zm125.3 256h28.5c18.5-59.2 19.5-115.9 15.3-159.7-.6-6.1-1.3-12-2-17.5-.7 9.6-1.7 20.5-3.3 32.4-5.2 39.6-16 90.6-38.5 144.9zm50.7 48H160c-38.7 0-71 27.5-78.4 64h284.8c-7.4-36.5-39.7-64-78.4-64" })
  }
), Ak = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h256v48h-92.7L144.7 432H256v48H0v-48h92.7L239.3 80H128z" })
  }
), Dk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32v288c0 88.4-71.6 160-160 160S0 408.4 0 320v-64h48v64c0 61.9 50.1 112 112 112s112-50.1 112-112V32z" })
  }
), yk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233.1 109.8 288 0l64 32v83c1.3.8 2.7 1.7 4 2.6 20-13.5 43.1-21.6 68-21.6 45.4 0 84 26.5 110.2 64.2C560.5 198 576 248.9 576 304s-15.5 106-41.8 143.8C508 485.5 469.4 512 424 512c-24.9 0-48-8.1-68-21.6-20 13.6-43.1 21.6-68 21.6s-48-8.1-68-21.6C200 504 176.9 512 152 512c-45.4 0-84-26.5-110.2-64.2C15.5 410 0 359.1 0 304s15.5-106 41.8-143.8C68 122.5 106.6 96 152 96c24.9 0 48 8.1 68 21.6 4.2-2.9 8.6-5.5 13.1-7.9zM48 304c0 46.5 13.2 87.6 33.2 116.4 20.1 28.9 45.5 43.6 70.8 43.6 18 0 35.8-7.4 51.9-21.9l16.1-14.5 16.1 14.5C252.2 456.6 270 464 288 464s35.8-7.4 51.9-21.9l16.1-14.5 16.1 14.5C388.2 456.6 406 464 424 464c25.3 0 50.7-14.7 70.8-43.6 20-28.8 33.2-69.9 33.2-116.4s-13.2-87.6-33.2-116.4C474.7 158.7 449.3 144 424 144c-18 0-35.8 7.4-51.9 21.9L356 180.4l-16.1-14.5C323.8 151.4 306 144 288 144s-35.8 7.4-51.9 21.9L220 180.4l-16.1-14.5C187.8 151.4 170 144 152 144c-25.3 0-50.7 14.7-70.8 43.6C61.2 216.4 48 257.5 48 304m112-16 48-80 48 80zm160 0 48-80 48 80zm160 0s-10.2 54.6-64 92.4V360h-48v44.2c-22.1 7.3-48.5 11.8-80 11.8s-57.9-4.5-80-11.8V360h-48v20.4C106.2 342.6 96 288 96 288s57.8 34.7 144 45.1V360h48v-24c112 0 192-48 192-48" })
  }
), bk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0v48h256V0zm240 128v336H48V128zM48 80H0v432h320V80h-48zm144 240c35.3 0 64-28.7 64-64h-48c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h48zm0-96c35.3 0 64-28.7 64-64h-48c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h48zm0 192c35.3 0 64-28.7 64-64h-48c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h16v32h32v-32z" })
  }
), fk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0v48h256V0zm240 128v96H48v-96zm0 240v96H48v-96zM48 80H0v432h320V80h-48z" })
  }
), Uk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m220.1 252.1 25.1 50.2L192 320l53.2 17.7-25.1 50.2 47.8-23.9-2.2 65.8C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5l17.1-18.2-18.9-16.3c-27.2-23.6-44.4-58.3-44.4-97 0-26.9 8.3-51.9 22.5-72.5l-32-34.3C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272c0-100.1-54.1-187.6-134.6-234.8l-31.9 34.3C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9l-18.9 16.3 17.1 18.2c18.8 20 30.2 46.9 30.2 76.5 0 54.2-38.5 99.4-89.7 109.8l-2.2-65.7 47.7 23.9-25.1-50.2L384 320l-53.2-17.7 25.1-50.2-50.6 25.3L296 0h-16l-9.2 277.4-50.6-25.3zm-156-18.7c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5L96 230.6l22.6-22.6-11.3-11.3-30.8-30.8c8.3-23.7 20.5-45.6 35.8-64.9-.2 3.6-.3 7.3-.3 11 0 44.9 16.8 85.8 44.4 116.9-17.9 25.9-28.4 57.3-28.4 91.1 0 44.5 18.1 84.7 47.4 113.7-54.9-32-94.9-86.6-107.4-151l16.6 16.6L96 310.6l22.6-22.6-11.3-11.3-43.2-43.2zm447.8 0-43.2 43.2-11.3 11.4 22.6 22.6 11.3-11.3 16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151 29.3-29 47.4-69.2 47.4-113.7 0-33.8-10.5-65.2-28.4-91.1 27.6-31.1 44.4-72 44.4-116.9 0-3.7-.1-7.4-.3-11 15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8-11.2 11.3 22.6 22.6 11.3-11.3 17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z" })
  }
), Gk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0h-15.2l-6.5 13.8-64 136-2.3 4.9v47.9L48 272v-48H0v78.1c-5 4.5-8 11-8 17.9v40c0 7.1 3.1 13.5 8 17.9V416h48v-32h106.6l-38.2 54.2-4.4 6.2V512h288v-67.6l-4.4-6.2-38.2-54.2H464v32h48v-38.1c4.9-4.4 8-10.8 8-17.9v-40c0-6.9-3-13.4-8-17.9V224h-48v48l-112-69.4v-48l-2.3-4.9-64-136L279.2 0H264zM48 328.4l112-69.3V336H48zm304-69.3 112 69.3v7.6H352zm-144-93.7 48-102 48 102v226.2l4.4 6.2 43.6 61.8v4.4h-72v-64h-48v64h-72v-4.4l43.6-61.8 4.4-6.2V384z" })
  }
), qk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h160v48h-27.1l11.7 16.1L386 176h105.7l3.5 1.1 128 40 16.8 5.3v67.2l-16.8 5.3-128 40-3.5 1.1H386l-93.1 128H320v48H160v-48h32V336h-14.1l-41 41-7 7H32V280H0v-48h32V128h97.9l7 7 41 41H192V48h-32zm80 176h86.7l-60.9-83.7L240 56.8zM80 280v56h30.1l41-41 7-7h326.2l102.4-32-102.4-32H158.1l-7-7-41-41H80v56h48v48h-24zm160 56v119.2L326.7 336z" })
  }
), Wk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 0h-48v43c0 50.9 20.2 99.8 56.2 135.8l21 21c12 12 18.7 28.3 18.7 45.3v43h48V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C479.2 117.8 464 81.2 464 43zm128 288h48v-43c0-50.9-20.2-99.8-56.2-135.8l-21-21C550.7 76.2 544 60 544 43V0h-48v43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8zM262.6 400.6l52.8 63.4H288c-73.9 0-135.5-15.4-180.3-32 39.6-14.7 92.2-28.4 154.9-31.4M377.9 464l-53.3-64h97.5l53.3 64zm160 0-53.3-64H592v64zM0 432s17 12.1 48.1 26.9C96.9 482.2 180.5 512 288 512h352V352H288c-107.5 0-191.1 29.8-239.9 53.1C17 419.9 0 432 0 432" })
  }
), Ek = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128m24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4V320h48zM128 320H64v32H0v160h448V352H128zm-64 80h336v64H48v-64z" })
  }
), Ok = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h128v48h32v48H64V48h32zm320 512V175.1l32.3-15.1h127.4l64.3 30.1V256l-24 24 24 24v64l-24 24 24 24v64l-32 32zM128 176c-44.2 0-80 35.8-80 80v208h288V176zM0 256c0-70.7 57.3-128 128-128h256v384H0v-48zm288-32v160h-64V224zM448 64h128v64H448z" })
  }
), Ik = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0H96v48H64v48h192V48h-32zm112 176v288H48V256c0-44.2 35.8-80 80-80zm-208-48C57.3 128 0 185.3 0 256v256h384V128h-48zm160 256V224h-64v160z" })
  }
), Nk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M181.9 125.5 80 256.5V288h288v-31.5l-101.9-131-10.1-13V48h-64v64.5zM80 416v48h288v-48zM304 48v48l18.5 23.8C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72 0 27.6-15.6 51.7-38.4 63.7l6.4 8.3v272H32V240L144 96V48h-24V0h208v48zm49.5 111.6 25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9 0-13.3-10.7-24-24-24-10.3 0-19.1 6.5-22.5 15.6z" })
  }
), Xk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 265.2 256.8 32h64.4l-5.4 6-159.5 178.2L319.9 480h-56.5L122.9 253.5 48 337.2V480H0V32h48v24z" })
  }
), Kk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 224 240-80v47.1l-240 80-240-80V144zm-240 .9 234.9 78.3 5.1 1.7 5.1-1.7L528 224.9v38.3l-16 5.3v33.7l16-5.3v84.5l-240 80-240-80v-84.5l16 5.3v-33.7l-16-5.3zm240-51.5L103.8 112 288 50.6 472.2 112zM576 416V96l-12-4-15.9-5.3L288 0 27.9 86.7 12 92 0 96v320l288 96zM96 279.1v33.7l96 32v-33.7zm186.9 96 5.1 1.7 5.1-1.7 58.9-19.6v-33.7l-64 21.3-64-21.3v33.7zM384 344.9l96-32v-33.8l-96 32v33.7z" })
  }
), Qk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 256c0 29.6-8.9 57.1-24.2 80H592V176h-56.2c15.3 22.9 24.2 50.4 24.2 80m32 128H482c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224L0 320V192l224-64h126c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16h158v256zm-361.3-48h65.5c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80h-65.5L48 228.2v55.6zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192m-17.9-142.1 17.9 17.8 17.9-17.9 14.1-14.1 28.3 28.3-14.1 14.1-17.9 17.9 17.9 17.9 14.1 14.1-28.3 28.3-14.1-14.1-17.9-17.9-17.9 17.9-14.1 14.1-28.3-28.3 14.1-14.1 17.9-17.9-17.9-17.9-14.1-14.1 28.3-28.3 14.1 14.1z" })
  }
), Zk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m442.6 41.5 9.5-22L408 .5l-9.5 22-193.1 448-9.5 22 44.1 19 9.5-22zM1.4 96l136.7 305.8 6.4 14.2h31.1l6.4-14.2L318.6 96H266L160 333.2 54 96H1.4zm463.1 0-6.3 14.2L321.4 416H374l28.6-64h154.8l28.6 64h52.6L501.9 110.2 495.6 96h-31.2zm15.5 82.8L536 304H424z" })
  }
), Jk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 128c0-44.2-35.8-80-80-80-44 0-79.7 35.6-80 79.5v1c.3 44 36 79.5 80 79.5 44.2 0 80-35.8 80-80m-205.8-24C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128s-57.3 128-128 128c-62.5 0-114.5-44.8-125.8-104H304v72h-48v-72h-48v72h-48V104h24zM48 384c0 44.2 35.8 80 80 80 44 0 79.7-35.6 80-79.5v-1c-.3-44-36-79.5-80-79.5-44.2 0-80 35.8-80 80m205.8 24c-11.3 59.2-63.3 104-125.8 104C57.3 512 0 454.7 0 384s57.3-128 128-128c62.5 0 114.5 44.8 125.8 104H336v-72h48v72h48v-72h48v120h-24z" })
  }
), jk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0m48 0c0 79.5-64.5 144-144 144-31.1 0-59.9-9.9-83.4-26.6l-87.4 87.4 47 47 17 17-33.9 33.9-17-17-47-47-30.2 30.1 47 47 17 17-33.9 33.9-17-17-64-64-17-17 17-17 168.4-168.3C169.9 203.9 160 175.1 160 144 160 64.5 224.5 0 304 0s144 64.5 144 144" })
  }
), Yk = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m315.7 302.4-24.2-3.8-17.3 17.3-20.1 20.1H176v64h-64v64H48v-78.1l148.1-148.1 17.3-17.3-3.8-24.2c-1-6.6-1.6-13.4-1.6-20.3 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128c-6.9 0-13.7-.5-20.3-1.6M272 384h1.9l7-7 27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2 97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 9.5.7 18.8 2.2 27.9L7 359l-7 7v146h160v-64h64v-64h40zm96-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), _k = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 128h-48v48h48zM112 368H64v48h48zm104 0h-24v48h256v-48h-24zm312 0v48h48v-48zm-44-166-33.9 34 33.9 33.9 34-33.9zm-328 0-34 34 34 33.9 33.9-33.9z" })
  }
), hP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m129 167-17-17-33.9 34 17 17 80 80 17 17 33.8-34-17-17-80-80zm167 33v24h48V64h-48v24zm135 47-17 17 34 33.9 17-17 80-80 17-17-34-33.8-17 17-80 80zM0 368v48h128v-48H24zm216 0h-24v48h256v-48h-24zm320 0h-24v48h128v-48h-24z" })
  }
), cP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v208h480V48zM0 0h576v304H0V48zm209 359 79 79 79-79 17-17 33.9 34-17 17-96 96-17 17-17-17-96-96-17-17 34.1-33.9 17 17zm-49-183h256v48H160zm-8-88v48h-48V88zm32 0h48v48h-48zm128 0v48h-48V88zm32 0h48v48h-48zm128 0v48h-48V88z" })
  }
), sP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 112v288H208V112zM208 64h-48v384h480V64h-48zm96 256v48h192v-48zm80-88h-48v48h48zm-136 0v48h48v-48zm48-80h-48v48h48zm40 0v48h48v-48zm128 0h-48v48h48zm40 0v48h48v-48zm48 80h-48v48h48zm-136 0v48h48v-48zm-298.2-23 17-17-33.9-33.9-17 17-64 64-17 17 17 17 64 64 17 17 33.8-34.1-17-17-47-47 47-47z" })
  }
), vP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h480V112zM0 64h576v384H0V112zm416 256v48H160v-48zm-312-88h48v48h-48zm48-80v48h-48v-48zm32 80h48v48h-48zm48-80v48h-48v-48zm32 80h48v48h-48zm48-80v48h-48v-48zm32 80h48v48h-48zm48-80v48h-48v-48zm32 80h48v48h-48zm48-80v48h-48v-48z" })
  }
), eP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 0H192v24h-8c-48.6 0-88 39.4-88 88v48H64L0 256v96h512v-96l-64-96H144v-48c0-22.1 17.9-40 40-40h8v24h112c26.5 0 48-21.5 48-48S330.5 0 304 0M89.7 208h332.6l41.7 62.5V304H48v-33.5zM128 464v48h256v-48H280v-80h-48v80h-80z" })
  }
), lP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 48 64-48 64 48s-6.6 10.6-14.5 27.5c37 18.3 62.5 56.4 62.5 100.5s-25.5 82.2-62.5 100.5C313.4 293.4 320 304 320 304l-48 36v22.6l34.5-23.7.1-.1C363.8 299.5 416 256 416 180.6c0-23-3.5-48.8-9-72.2-5.9-24.9-14.1-47.1-23-60.4 0 0 28.4 12.1 58.4 37.6C476.2 114.2 512 159.8 512 224c0 96-112 192-112 192l-83.4-45.3-32.4 22.3 46.1 31.7c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7v-28.9L199.8 451c-1.5 11.8-11.6 21-23.8 21-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9.2 5.7.7l46.1-31.7-32.4-22.3L112 416S0 320 0 224c0-64.2 35.8-109.8 69.6-138.4C99.6 60.1 128 48 128 48c-8.9 13.4-17.1 35.6-23 60.4-5.5 23.4-9 49.1-9 72.2 0 75.4 52.2 118.9 109.4 158.2l.1.1 34.5 23.7V340l-48-36s6.6-10.6 14.5-27.5c-37-18.3-62.5-56.4-62.5-100.5s25.5-82.2 62.5-100.5C198.6 58.6 192 48 192 48m0 128c0 23.5 12.7 44.1 31.6 55.2 4.9-17.3 8.4-36.2 8.4-55.2s-3.5-37.9-8.4-55.2C204.7 131.9 192 152.5 192 176m88 0c0 18.9 3.5 37.9 8.4 55.2 18.9-11.1 31.6-31.7 31.6-55.2s-12.7-44.1-31.6-55.2c-4.9 17.3-8.4 36.2-8.4 55.2M40 224c0 34.1 20.8 73 47.6 107.4 11 14.1 22 26.2 31 35.5l32.8-17.8C103.1 311.8 56 261 56 180.6c0-6.2.2-12.5.6-18.9C46.5 179.5 40 200.2 40 224m432 0c0-23.8-6.5-44.5-16.6-62.3.4 6.4.6 12.7.6 18.9 0 80.4-47.1 131.2-95.4 168.5l32.8 17.8c9-9.3 20-21.4 31-35.5C451.2 297 472 258.1 472 224" })
  }
), tP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m167.4 186.6 14-15.7 39.2-44.1c7.4-8.3 11.4-18.9 11.4-30 0-14.9-7.7-29.3-23.5-39.9-6-4-21.8-9.5-44-8.9-33.2.9-61.1 20-82.8 54.7C59.7 138 48 184.2 48 224c0 28.9 6.4 59.7 19.3 81.5 11.6 19.6 26.8 30.5 51 30.5 35.1 0 60.9-30.8 58.4-55.7l-7.3-72.7-2.1-20.9zM118.3 384C29.8 384 0 293 0 224 0 128.4 55 3 163.2 0c28.9-.8 55.4 5.9 71.9 16.9C262.2 35 280 63.5 280 96.7c0 22.8-8.4 44.8-23.5 61.9l-31.2 35.1 65.5 32.8 13.3 6.6V512H256V262.8l-34.5-17.2 3 29.9c5.8 58.1-47.8 108.5-106.2 108.5m300.2-138.4L384 262.8V512h-48V233.2l13.3-6.6 65.5-32.8-31.2-35.1c-15.2-17.1-23.6-39.1-23.6-62 0-33.3 17.8-61.7 44.9-79.8C421.5 5.9 448-.8 476.8 0 585 3 640 128.4 640 224c0 69-29.8 160-118.3 160-58.4 0-112-50.4-106.2-108.5l3-29.9zm40.2-74.7 14 15.7-2.1 20.9-7.3 72.7c-2.5 25 23.3 55.7 58.4 55.7 24.2 0 39.4-10.9 51-30.5 12.9-21.7 19.3-52.5 19.3-81.4 0-39.8-11.7-86-33.7-121.3C536.6 68 508.7 48.9 475.5 48c-22.1-.6-38 4.9-44 8.9-15.8 10.6-23.5 25-23.5 39.8 0 11.1 4.1 21.7 11.4 30l39.2 44.1z" })
  }
), wP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m335.6 82.2 18.2-15.6-31.2-36.4-18.2 15.6L112 210.7V32H64v200H0v48h64v201h48V301.3l192.4 164.9 18.2 15.6 31.2-36.4-18.2-15.6L160.9 280H384v-48H160.9L335.6 82.2z" })
  }
), gP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 432V80h288v352zm-48 0H48V80h48zm24-400H0v448h576V32H144zm408 400h-48V80h48zM256 160v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), iP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0m46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66V80h192v128H352v-40zM80 144a64 64 0 1 1 128 0 64 64 0 1 1-128 0m296 128v-32h48v32h120v48h-32v192H288V320h-32v-48h80zm88 192V320H336v144zM160 320h16c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16v32H32V320h96zm0 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zM0 464h224v48H0zm400-336v32h96v-32z" })
  }
), mP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M285.4 354.6 480 160l112 112v11.3zM480 160 368 48h224zm135.2 167.2 24.8-5.8V0H318.6l-5.8 24.8-79.5 342-.5 2-1.4 5.8-.4.4-89 89h-22V356.7l-24-10-24 10V512h89.9l7-7 96-96 .4-.4 5.8-1.4 2-.5 342-79.5zM0 128v48h72v110L0 256v96l72-30 24-10 24 10 72 30v-96l-72 30V128H24z" })
  }
), aP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m313.7 304-14.3 16c-26.4 29.5-64.7 48-107.3 48-79.5 0-144-64.5-144-144s64.5-144 144-144c42.6 0 80.9 18.5 107.3 48l14.3 16H448c44.2 0 80 35.8 80 80v80H335.1zm21.4-208C300 56.7 248.9 32 192 32 86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V480h48v-70c15.3 3.9 31.4 6 48 6 5.4 0 10.7-.2 16-.7V480h48v-74.9c30.7-10.9 57.8-29.3 79.1-53.1H464l112 128V224c0-70.7-57.3-128-128-128zM472 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), oP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M399.8 265.3C358.7 298.6 295.3 320 224 320S89.3 298.6 48.2 265.3C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7M448 176v80c0 123.7-100.3 224-224 224S0 379.7 0 256v-80C0 96.5 100.3 32 224 32s224 64.5 224 144M224 64h-16v56h32V64zM64 176v16h64v-32H64zm256 0v16h64v-32h-64zm-96 56h-16v56h32v-56zM139.3 92.7 128 81.4 105.4 104l11.3 11.3 8 8 11.3 11.3 22.6-22.6-11.3-11.3-8-8zm192 22.6 11.3-11.3L320 81.4l-11.3 11.3-8 8-11.3 11.3 22.6 22.6 11.3-11.3zm-184 136 11.3-11.3-22.6-22.6-11.3 11.3-8 8-11.3 11.3 22.6 22.6 11.3-11.3zm176-22.6L312 217.4 289.4 240l11.3 11.3 8 8 11.3 11.3 22.6-22.6-11.3-11.3zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24 25.1 24 56 24 56-10.7 56-24" })
  }
), nP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 0 278.6 201.4l113.9 113.8L448 272v-64L568 88zm-64 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0m72-72a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-88 296-34.6-34.6-33.9 33.9c-11.7 10.1-26.1 21.7-42.8 33.2C240.4 434 178.1 464 112 464c-9 0-17.7-.8-25.9-2.2L256 291.9l33.9-33.9-33.9-34-33.9 33.9L35.2 444.8 0 480s18 12 46.6 21.3C64.7 507.2 87.2 512 112 512c110 0 204.9-68.1 253.5-110.6 4.4-3.8 8.4-7.5 12-10.9C392 377 400 368 400 368" })
  }
), rP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M461.8 0H512v83.6c0 65.5-25.9 128.4-72.1 174.9L330 368.9 313 386l-17-17-62.8-62.8L57.3 488.7l-16.7 17.2-34.5-33.3 16.7-17.3 432-448zM266.6 271.6 313 318l92.9-93.4c37.3-37.5 58.2-88.2 58.2-141V66.9z" })
  }
), dP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 32v400h240v48H32V32z" })
  }
), SP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 48h.3c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8v.3c0 37.4-24 70.7-59.5 82.5l-44.1 14.7-4.2 1.4-3.4 2.8-61.9 50.7c-12.6 10.3-28.3 15.9-44.5 15.9-38.8 0-70.3-31.5-70.3-70.3 0-16.2 5.6-32 15.9-44.5l50.7-61.9 2.8-3.4 1.4-4.2 14.7-44.1C273.3 72 306.6 48 344 48m0-48c-58.1 0-109.7 37.2-128.1 92.3l-13.3 39.9-47.9 58.5c-17.3 21.1-26.7 47.6-26.7 74.9 0 24 7.1 46.3 19.4 65L18.2 459.8l-17 17 33.9 33.9 17-17 129.3-129.1c18.6 12.3 41 19.4 65 19.4 27.3 0 53.8-9.4 74.9-26.7l58.5-47.9 39.9-13.3c55.1-18.4 92.3-70 92.3-128.1v-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0zm120 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), zP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m261.5 107.5-14.7 44.1-1.4 4.2-2.8 3.4-50.7 61.9c-10.3 12.6-15.9 28.3-15.9 44.5 0 38.8 31.5 70.3 70.3 70.3 16.2 0 32-5.6 44.5-15.9l61.9-50.7 3.4-2.8 4.2-1.4 44.1-14.7c35.6-11.7 59.6-45 59.6-82.4v-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48h-.3c-37.4 0-70.7 24-82.5 59.5M344 0h.3c40.8 0 82.5 24.8 112.7 55s55 71.9 55 112.7v.3c0 58.1-37.2 109.7-92.3 128.1l-39.9 13.3-58.5 47.9c-21.1 17.3-47.6 26.7-74.9 26.7-24 0-46.3-7.1-65-19.4L52.2 493.8l-17 17-33.9-34 17-17 129.1-129.2c-12.3-18.6-19.4-41-19.4-65 0-27.3 9.5-53.8 26.7-74.9l47.9-58.5 13.3-39.9C234.3 37.2 285.9 0 344 0" })
  }
), pP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h137.4l12.7 24.3L3.1 480h51.5l124.9-319.1 159.2 306.2 6.7 12.9H448v-48h-73.4L173.3 44.9 166.6 32H152z" })
  }
), MP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m347.3 97.9-38-38c-7.7-7.6-18-11.9-28.7-11.9-22.4 0-40.6 18.2-40.6 40.6 0 10.8 4.3 21.1 11.9 28.7l38.1 38.1 14 14v82.8L444.1 112H361.4zm34-33.9H464l14.1 14.1L512 112l-33.9 33.9L432 192l-48 48-46.1 46.1L304 320l-33.9-33.9L256 272v-82.7l-13.7-13.7c-.6.7-1.3 1.4-2 2.1l-93.1 86L204.4 464H384v48H0v-48h154.5L96.9 262.6l-4.1-14.2 10.9-10 104-96c.5-.5 1-.9 1.5-1.3A88.696 88.696 0 0 1 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9zM480 240c0 26.5-21.5 48-48 48-14 0-26.5-6-35.3-15.5l67.8-67.8C474 213.5 480 226 480 240" })
  }
), xP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M177.9 224H128l13.7-48L192 0h256l50.3 176 13.7 48H177.9zm270.4-48L411.8 48H228.2l-36.6 128h256.8zM216 464h80V256h48v208h104v48H192v-48z" })
  }
), HP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 172c0-68.5 55.5-124 124-124 65 0 118.3 50 123.6 113.5-78.5 10-142.2 67.4-161.6 142.5-3.9 15.3-6 31.4-6 48h384c0-16.6-2.1-32.7-6-48-19.4-75.4-83.4-132.9-162.3-142.6C338.2 71.4 263.4 0 172 0 77 0 0 77 0 172v340h48zm272 36c62.7 0 116 40.1 135.8 96H184.2c19.8-55.9 73.1-96 135.8-96m0 240c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64" })
  }
), VP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M51.3 256H0l18-48L96 0h256l78 208 18 48H51.3zm18-48h309.4l-60-160H129.3l-60 160zM144 320v-32h48v51.9l-13.9 13.9c-.1.1-.4.4-.7.8-.8.9-2.1 2.3-3.7 4.3-3.3 4.1-7.9 10.2-12.5 17.8-9.5 15.7-17.2 35.1-17.2 55.3 0 12.2 3.8 23.2 8.5 32h143c4.7-8.8 8.5-19.8 8.5-32 0-18.8-7.6-38.1-17.3-54.7-4.7-7.9-9.4-14.4-12.8-18.7-1.7-2.2-3.1-3.8-3.9-4.7-.4-.5-.7-.8-.8-.9l-.1-.1-13.1-13.7V288h48v32s48 50.5 48 112c0 48-32 80-32 80H128s-32-32-32-80c0-64 48-112 48-112" })
  }
), CP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24v168h-48V0h48zM69.7 132.3l104 72 19.7 13.7-27.3 39.5-19.7-13.7-104-72-19.8-13.7 27.3-39.5 19.7 13.7zm528 39.5-104 72-19.7 13.7-27.3-39.5 19.7-13.7 104-72 19.7-13.7 27.3 39.5zM192 288h256v64h64l44.8 112 19.2 48H64l19.2-48L128 352h64zm-31.5 112-25.6 64h370.2l-25.6-64z" })
  }
), LP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v33.5c89.5 11.1 159.9 83.9 167.3 174.5H480v48H32v-48h32.7C72.1 117.4 142.5 44.6 232 33.5V0zM112.9 208h286.2c-8-72-69-128-143.1-128s-135.2 56-143.1 128m-.9 80v96h64v-96h48v96h64v-96h48v96h64v-96h48v96h32v48H40v-48h24v-96zM8 464h504v48H8z" })
  }
), BP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0h-32v128H24v48h464v-48H272V96h96V0zM112 208H64v176H32v48h448v-48h-32V208h-48v176h-64V208h-48v176h-64V208h-48v176h-64zM0 464v48h512v-48H24z" })
  }
), uP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192h512v-48L256 0 0 144zM256 55.1 414.1 144H97.9L256 55.1M112 224H64v160H32v48h448v-48h-32V224h-48v160h-64V224h-48v160h-64V224h-48v160h-64zM0 464v48h512v-48H24z" })
  }
), RP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 64H0v384h640V64H304zm320 48v288H320V112zm-447.1 48h30.3l3.4 8.6 47.8 119.6.3.9 23.8 59.6 1.4 3.4h-43l-14.4-36h-69l-14.4 36h-43l1.4-3.4L93.3 289c.1-.3.2-.6.4-.9l47.8-119.6 3.4-8.6zm15.1 69.9L141.5 276h36.9zM476 164h-40v24h-72v40h126l-21.6 51.7c-2.6-2.3-5.2-4.8-7.7-7.3l-14.6-14.6-14.1-14.1-28.3 28.3 14.1 14.1 14.4 14.4-23.2 8.8-18.7 7 14 37.5 18.7-7 45.3-17c2.1 1.4 4.3 2.8 6.5 4.1l18.9 11.3 17.2 10.3 20.6-34.3-17.1-10.3-12.4-7.4 31.3-75.5H556v-40h-80v-4z" })
  }
), $P = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32H64v288h48V80h144zm128 48h144v240h48V32H384zm-40-48h-48v206.1l-39-39-17-17-33.9 33.9 17 17 80 80 17 17 17-17 80-80 17-17-34.1-33.9-17 17-39 39V56zM83.9 432l-32-32h536.2l-32 32H83.9M576 480l64-64v-64H0v64l64 64z" })
  }
), kP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 80h416v240h48V32H64v288h48zM51.9 400h536.2l-32 32H83.9l-32-32zM640 416v-64H0v64l64 64h512zM176 128h-16v112h96V128h-16zm16 80v-48h32v48zm112-80h-16v32h16v80h32V128h-16zm80 0v112h96V128h-80zm32 32h32v48h-32zM192 272h-16v32h16v16h32v-48h-16zm256 0h-48v32h16v16h32v-32zm-80 16v-16h-96v48h32v-16h32v16h32z" })
  }
), PP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 80h416v240h48V32H64v288h48zM51.9 400h536.2l-32 32H83.9l-32-32zM640 416v-64H0v64l64 64h512zM281 177l17-17-34-33.9-17 17-48 48-17 17 17 17 48 48 17 17 33.9-34.1-17-17-31-31 31-31zm112-34-17-17-33.9 34 17 17 31 31-31 31-17 17 33.9 33.9 17-17 48-48 17-17-17-17-48-48z" })
  }
), FP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48H112v272h208v64H32L0 352v-32h64V0h448v96h-48zm-64 416h192V256h-80v-80H400zm144-336 96 96v288H352V128h48z" })
  }
), TP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 80h416v240h48V32H64v288h48zM51.9 400h536.2l-32 32H83.9l-32-32zM640 416v-64H0v64l64 64h512zM288 128v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), AP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48h352v48h48V0H64v320H0v32l32 32h320v-64H112zm272 80v384h256V128H432zm48 48h160v288H432z" })
  }
), DP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-13.6-10.6L640 416v-64H482.7L132.4 80H528v240h48V32H70.5zM544.6 400h43.6l-19 19-24.5-19zm-492.7 0h333.8l-60.9-48H0v64l64 64h423.2l-60.9-48H83.9l-32-32zM112 184.4l-48-37.8V320h48z" })
  }
), yP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80H112v240H64V32h512v288h-48zM83.9 432h472.2l32-32H51.9l32 32M576 480H64L0 416v-64h640v64z" })
  }
), bP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 32v65.5c7.9-1 15.9-1.5 24-1.5s16.1.5 24 1.5V32h48v78c70.4 28.5 120 97.5 120 178h-48c0-53.3-29-99.8-72-124.7V288h-48V146c-7.8-1.3-15.8-2-24-2s-16.2.7-24 2v142h-48V163.3C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144h192v48H0v-48h65C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178V32z" })
  }
), fP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M291.3 0H288C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9 0 35.2-28.6 63.8-63.8 63.8H32v48h112.2c61.7 0 111.8-50.1 111.8-111.8 0-17.8-4.2-34.9-11.9-50.2 14.3 1.3 29 2 43.9 2 159.1 0 288-78.8 288-176 0-76.2-79.2-141.1-190.1-165.6l6.5 13.1L449 51.8v29.3c48.5 23.4 79 57.3 79 94.9 0 70.7-107.5 128-240 128S48 246.7 48 176c0-58.1 72.7-107.2 172.2-122.8l59.3-29.7zm178 405.3L416 432l53.3 26.7L496 512l26.7-53.3L576 432l-53.3-26.7L496 352zM336 0l-26.7 53.3L256 80l53.3 26.7L336 160l26.7-53.3L416 80l-53.3-26.7z" })
  }
), UP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 176c0 97.2-128.9 176-288 176-14.9 0-29.6-.7-43.9-2 7.7 15.3 11.9 32.4 11.9 50.2 0 61.7-50.1 111.8-111.8 111.8H32v-48h112.2c35.2 0 63.8-28.6 63.8-63.8 0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176 0 78.8 128.9 0 288 0s288 78.8 288 176M288 304c132.5 0 240-57.3 240-128S420.5 48 288 48 48 105.3 48 176s107.5 128 240 128" })
  }
), GP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 203.5 118.2 128 288 52.5 457.8 128zm228.9-101.8L288 0 59.1 101.7 0 128l59.1 26.3L288 256l228.9-101.7L576 128zm-353.2 134-59.1-26.3-45.5 20.3L0 256l59.1 26.3L288 384l228.9-101.7L576 256l-59.1-26.3-45.5-20.2-59.1 26.3 45.5 20.2L288 331.5 118.2 256l45.5-20.2zm-59.1 101.8-45.5 20.2L0 384l59.1 26.3L288 512l228.9-101.7L576 384l-59.1-26.3-45.5-20.2-59.1 26.3 45.5 20.2L288 459.5 118.2 384l45.5-20.2z" })
  }
), qP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 60h-20v40h152V60h-20zM288 331.5 118.2 256 288 180.5 457.8 256zm228.9-101.8L288 128 59.1 229.7 0 256l59.1 26.3L288 384l228.9-101.7L576 256zm-353.2 134-59.1-26.3-45.5 20.3L0 384l59.1 26.3L288 512l228.9-101.7L576 384l-59.1-26.3-45.5-20.2-59.1 26.3 45.5 20.2L288 459.5 118.2 384l45.5-20.2z" })
  }
), WP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M484 24v36h56v40h-56v56h-40v-56h-56V60h56V4h40zM118.2 256 288 331.5 457.8 256 288 180.5 118.2 256M288 128l228.9 101.7L576 256l-59.1 26.3L288 384 59.1 282.3 0 256l59.1-26.3zM104.6 337.5l59.1 26.3-45.5 20.2L288 459.5 457.8 384l-45.5-20.2 59.1-26.3 45.5 20.2L576 384l-59.1 26.3L288 512 59.1 410.3 0 384l59.1-26.3z" })
  }
), EP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 144h-48c-70.7 0-128 57.3-128 128s57.3 128 127.9 128h1c97.3-.5 191.1-100.3 191.1-243.4 0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144zm130.6-76.5c14.9-13.3 26.2-30.5 32.3-50.1 8.8 19.7 15.9 40.8 20.8 63 5.4 24.3 8.3 49.8 8.3 76.2 0 160.5-106.9 290.7-239 291.4h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v40H0v-40c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96h104c28.7 0 54.8-10.8 74.6-28.5M189.7 241.1c0-28.6 23.2-51.8 51.8-51.8h3.5c14 0 27.5 5.3 37.8 14.9l5.2 4.8 5.2-4.8c10.3-9.6 23.8-14.9 37.8-14.9h3.5c28.6 0 51.8 23.2 51.8 51.8 0 14.3-5.9 28-16.4 37.8L299 345.3l-11 10.2-10.9-10.2-70.9-66.4c-10.5-9.8-16.4-23.5-16.4-37.8z" })
  }
), OP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 144 16.5-57.6L480 32l-54.4 15.5L368 64l-13.2-21.2L328 0l-32.3 38.8-7.1 8.5-37.5 45-2.5 3-.6.7-.1-.5L240 48l-18.3 4.6-28.4 7.1L176 64l-16.4-19.1L128 8 96.4 44.9 80 64l-29.1-2.9L0 56l12.9 49.5L48 240l-12.7 12.7L0 288l43.6 24.2 78.5 43.6-104 104-17 17L35 510.7l17-17 104-104 43.6 78.5L224 512l35.3-35.3L272 464l134.5 35.1L456 512l-5.1-50.9L448 432l19.1-16.4L504 384l-36.9-31.6L448 336l4.3-17.3 7.1-28.4L464 272l-47.5-7.9-.5-.1.7-.6 3-2.5 45-37.5 8.5-7.1L512 184l-42.8-26.8zM191.4 354.5l122.5-122.4 17-17-33.9-33.9-17 17-122.5 122.4-78.6-43.7 3-3 19.4-19.4-6.9-26.6-30.5-117.3 11.4 1.1 24.9 2.5 16.3-19L128 81.8l11.6 13.5 19.3 22.5 28.8-7.2 13.6-3.4L210 160h47.1l27.7-33.3 37.6-45.1 4.9 7.8 19.1 30.6 34.7-9.9 28.9-8.3-8.3 28.9-9.9 34.7 30.6 19.1 7.8 4.9-45.1 37.6-33.1 27.9V302l52.8 8.8-3.4 13.6-7.2 28.8 22.5 19.3 13.5 11.5-13.5 11.6-19 16.3 2.5 24.9 1.1 11.4-117.2-30.6-26.6-6.9-19.4 19.4-3 3-43.6-78.5z" })
  }
), IP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M470.3 258.4 512 248v-72l-48-32 16-64-48-48-64 16-32-48h-72l-10.4 41.7L240 96l-30.1-30.1-9.5-9.5L176 32l-33.9 33.9L128 80l6.9 48.2L144 192l-48-32-4.4 4.4L32 224l48 96v78.1l-61.8 61.7-17 17 33.9 33.9 17-17 61.8-61.7H192l96 48 59.6-59.6 4.4-4.4-32-48 63.8 9.1L432 384l14.1-14.1L480 336l-24.4-24.4-9.5-9.5L416 272zM161.9 384l152-151.9 17-17-33.9-33.9-17 17-152 151.9V308.7l-5.1-10.1-32.5-65.1 11.7-11.7 15.3 10.2 20.8 13.9 54.2-54.2-.9-6.4-11.6-81.4 26.2 26.2 24 24L290 94l11.5-46h8.8l17.8 26.6 18.8 28.1 32.8-8.2 37.6-9.4 9.6 9.6-9.4 37.6-8.2 32.8 28.1 18.8 26.6 17.8v8.8L418 222l-59.9 59.9 24 24 26.2 26.2-81.4-11.6-6.4-.9-54.2 54.2 13.9 20.8 10.2 15.3-11.7 11.7-65.1-32.5-10.3-5.1H192z" })
  }
), NP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 144c-57.6 0-106.3 38.1-122.4 90.4 20.9-6.7 43.2-10.4 66.4-10.4h104v48H216c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h1c97.3-.5 191.1-100.3 191.1-243.4 0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144h-56zM96.4 260.1C102.5 168.5 178.8 96 272 96h104c28.7 0 54.8-10.8 74.6-28.5 14.9-13.3 26.2-30.5 32.3-50.1 8.8 19.7 15.9 40.8 20.8 63 5.4 24.3 8.3 49.8 8.3 76.2 0 160.5-106.9 290.7-239 291.4h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v40H0v-40c0-75.1 38.3-141.2 96.4-179.9" })
  }
), XP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M226.4 37.9c-7.8 12.9-13.4 27.3-16.2 42.7L144 146.7v96l-48 48v98.7l-23.9 24V333l-54.2-54.1v-72.6c-25.3-30.1-23.8-75.1 4.5-103.4 11.9-11.8 26.6-19 41.9-21.5 1.8-20.2 10.4-39.8 25.8-55.3 34.9-34.9 91.5-34.9 126.4 0 3.7 3.7 7 7.6 9.9 11.7zm262.7 143.8 24-28.6C522.4 142 528 127.7 528 112c0-35.3-28.7-64-64-64-15.7 0-29.9 5.6-41.1 14.9l-28.6 24L364 65c-7.9-5.7-17.5-9-28-9-25.1 0-45.7 19.3-47.8 43.8l-1.5 17.4-12.4 12.4-50.3 50.3v96L209.9 290 176 323.9v42.2l96-96V160h48v62.1l7-7L439 103l17-17 33.9 34-17 17-71 71H464v48H353.9l-41 41-103 103h42.2l33.9-33.9 14.1-14.1h96l50.3-50.3 12.4-12.4 17.4-1.5c24.5-2.1 43.8-22.7 43.8-47.8 0-10.5-3.3-20.2-9-28zM416 400h-96l-48 48H161.9l-28.8 28.8-17 17-17 17-33.8-34 17-17 17-17 28.7-28.7V304l48-48v-96l64.4-64.4C244.6 46.5 285.8 8 336 8c21 0 40.3 6.7 56.1 18.1C411.6 9.8 436.6 0 464 0c61.9 0 112 50.1 112 112 0 27.4-9.8 52.4-26.1 71.9C561.3 199.7 568 219 568 240c0 50.2-38.5 91.4-87.6 95.6z" })
  }
), KP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 288h-48v76.1L67.9 256 176 147.9V224h128v64zm-190.1 1.9L160 416h64v-80h128V176H224V96h-64L33.9 222.1 0 256zM400 88v360h48V64h-48z" })
  }
), QP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 88V64h48v384H0v-24zm336 144h-48v-68.1L195.9 256l92.1 92.1V280h304v-48zm-208 24 33.9-33.9L288 96h48v88h304v144H336v88h-48L161.9 289.9z" })
  }
), ZP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 224h304v64H160v60.1L67.9 256l92.1-92.1V176zm-126.1-1.9L0 256l33.9 33.9L160 416h48v-80h304V176H208V96h-48L33.9 222.1" })
  }
), JP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 328h48v56h48l94.1-94.1L512 256l-33.9-33.9L384 128h-48v56H176v-56h-48l-94.1 94.1L0 256l33.9 33.9L128 384h48v-56h48zm-160-11.9L67.9 256l60.1-60.1V232h256v-36.1l60.1 60.1-60.1 60.1V280H128z" })
  }
), jP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 288h-48v76.1L163.9 256 272 147.9V224h128v64zm-190.1 1.9L256 416h64v-80h128V176H320V96h-64L129.9 222.1 96 256zM48 88V64H0v384h48v-24z" })
  }
), YP = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 288h192v-64H208V115.9L67.9 256 208 396.1V336zm48 112v48h-64L33.9 289.9 0 256l33.9-33.9L192 64h64v112h192v160H256v48z" })
  }
), _P = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 80-21.3 63.7c45.1 87.3 14.5 190.7-54.9 260.1s-172.8 100-260.1 54.9L48 480 0 432l21.2-63.8c-45.1-87.2-14.4-190.7 55-260s172.8-100.1 260-55L400 32zM96.6 413.2l19.2-6.4 18 9.3c63.6 32.9 145 12.9 204.1-46.2s79.1-140.5 46.2-204.1l-9.3-18 6.4-19.2L393.1 93l-6-6-35.7 11.8-19.2 6.4-18-9.3C250.6 63 169.2 83 110.1 142.1S31 282.6 63.9 346.2l9.3 18-6.4 19.2L54.9 419l6 6 35.6-11.9zM135 278.7l-46-13.4c19.8-67.7 76.6-124.5 144.3-144.3l13.4 46c-52 15.2-96.5 59.7-111.7 111.7" })
  }
), hF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M47.6 169.5 416 32.3v51.2L124.8 192 416 300.5v51.2L47.6 214.5 32 208.7v-33.4zM24 432h424v48H0v-48z" })
  }
), cF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64.9 14 234.2l-14 6.4v30.8l14 6.4 370 169.4v-52.8L81.7 256 384 117.6z" })
  }
), sF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1.2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81l17-17-34-33.9L431 47l-11.7 11.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47 64 30 30.1 64 47 81l11.8 11.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431l-17 17 34 33.9 17-17 11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465l17 17 33.9-34-17-17-11.8-11.8zm-34.1-34.1-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zm-34-292.3-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3l-80.2-80.4C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8l-80.4 80.3C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), vF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v161.1C117.9 171.7 25.5 257.2 4.5 368c-3 15.5-4.5 31.6-4.5 48h512c0-16.4-1.5-32.5-4.5-48-21-110.8-113.4-196.3-227.5-206.9zm-24 184c98.4 0 180.8 68.3 202.4 160H53.6c21.6-91.7 104-160 202.4-160m0 304c35.3 0 64-28.7 64-64H192c0 35.3 28.7 64 64 64" })
  }
), eF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m69.3 36-20-13.3-26.6 40 20 13.3 48 32 20 13.3 26.6-39.9-20-13.4zm528 40 20-13.3-26.6-40-20 13.3-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM24 192H0v48h96v-48H72zm544 0h-24v48h96v-48h-24zm-120 16v96h48v-96c0-97.2-78.8-176-176-176s-176 78.8-176 176v96h48v-96c0-70.7 57.3-128 128-128s128 57.3 128 128M144 432v-48h352v48zm-48-96v144h448V336H144zm224-192v-32c-53 0-96 43-96 96h32c0-35.3 28.7-64 64-64" })
  }
), lF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 304v-96c0-70.7-57.3-128-128-128S96 137.3 96 208v96H48v-96c0-97.2 78.8-176 176-176s176 78.8 176 176v96zM48 384v48h352v-48zm0-48h400v144H0V336zm112-128h-32c0-53 43-96 96-96v32c-35.3 0-64 28.7-64 64" })
  }
), tF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 464v-16h48v16h120V48H216v16h-48V48H48v416zM48 512H0V0h384v512h-48zm192-256V144h-96v112zm-96 160H96V96h192v320h-48z" })
  }
), wF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 48v16h48V48h120v416H216v-16h-48v16H48V48zM48 0H0v512h384V0h-48zm192 256v112h-96V256zM144 96H96v320h192V96h-48z" })
  }
), gF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 64V48H48v416h120v-16h48v16h120V48H216v16zM0 0h384v512H0V48zm144 368h96v-88h-96zm0-136h96v-88h-96zM96 96h192v320H96V144z" })
  }
), iF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0v48.7l-160 40V39.3L314.2.7c2.1-.5 4.3-.8 6.4-.7h-.6zM160 135.3l320-80v49.5l-320 80zm0 96 320-80v49.5l-320 80zm194.2 47.5L480 247.3v49.5l-96 24V384h32v96h-72v32h-48v-32h-72v-96h32v-81.1l48-12V384h32V283.3zM55.3 16l6 4 24 16 20 13.3-26.6 40-20-13.3-24-16-6-4-20-13.3 26.6-40zm556 40-6 4-24 16-20 13.3-26.6-40 20-13.3 24-16 6-4 20-13.3 26.6 39.9zM24 160h72v48H0v-48zm544 0h72v48h-96v-48zM85.3 332l-24 16-6 4-20 13.3-26.6-39.9 20-13.3 6-4 24-16 20-13.3 26.6 39.9zm496-39.9 24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9z" })
  }
), mF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160.5 0c-2.1 0-4.2.2-6.4.7L0 39.3v49.4l160-40V0zM0 184.7l320-80V55.3l-320 80v49.5zm0 96 320-80v-49.4l-320 80v49.5zm320-33.5-125.8 31.5-18.2 4.6V384h-32v-93.1l-48 12V384H64v96h72v32h48v-32h72v-96h-32v-63.3l96-24v-49.4z" })
  }
), aF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8.1 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128M112 416v96h160v-96zm96.8-304V96h-32v25.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8-9.5 30.6 15.3 4.8c1.6.5 3.3 1 5 1.6 7.1 2.3 15.1 4.9 23.7 6.6v27.4h32v-26.7c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1-15.6-3.9c-5.6-1.4-11.6-2.7-17.9-3.7V112z" })
  }
), oF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M425.2 248.9c14.4-20.6 22.8-45.7 22.8-72.9 0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-48.5c2.6-18.7 7.9-38.6 18.3-57.5 11.5-20.9 26.9-42.1 39.8-59.8 4.7-6.4 9-12.4 12.7-17.7zM240 512v-96h160v96zm96-384v96h-32V112h32zm0 128v32h-32v-32zM87.3 16l6 4 24 16 20 13.3-26.6 40-20-13.3-24-16-6-4-20-13.3 26.6-40zm492 40-6 4-24 16-20 13.3-26.6-40 20-13.3 24-16 6-4 20-13.3 26.6 39.9zM24 160h72v48H0v-48zm544 0h72v48h-96v-48zM117.3 332l-24 16-6 4-20 13.3-26.6-40 20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9 24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9z" })
  }
), nF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8.1 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128M112 416v96h160v-96zm96-304h-32v112h32v-96zm-32 144v32h32v-32z" })
  }
), rF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316.6 205.5c2.2-9.5 3.4-19.4 3.4-29.5 0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0c96.7 0 175.1 77.9 176 174.4h-28V219zM251 416l21 36.3V512H112v-96zM144 176h-32c0-44.2 35.8-80 80-80v32c-26.5 0-48 21.5-48 48m228 30.4h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497h-88v-42.2c-8-3.4-15.6-7.7-22.5-12.9L314.6 462l-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9v-42.2zm92.1 145.3a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0" })
  }
), dF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H403c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7-14.4-20.7-22.8-45.8-22.8-73 0-70.7 57.3-128 128-128s128 57.3 128 128m-176 0c0-26.5 21.5-48 48-48V96c-44.2 0-80 35.8-80 80zm-32 336h160v-96H240zM87.3 16l-20-13.3-26.6 40 20 13.3 6 4 24 16 20 13.3 26.6-39.9-20-13.4-24-16zm492 40 20-13.3-26.6-40-20 13.3-6 4-24 16-20 13.3 26.6 39.9 20-13.3 24-16 6-4zM24 160H0v48h96v-48H72zm544 0h-24v48h96v-48h-24zM117.3 332l20-13.3-26.6-39.9-20 13.2-24 16-6 4-20 13.3 26.6 39.9 20-13.3 6-4 24-16zm432-39.9-20-13.3-26.6 39.9 20 13.3 24 16 6 4 20 13.3 26.6-39.9-20-13.3-6-4z" })
  }
), SF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M425.2 248.9c14.4-20.6 22.8-45.7 22.8-72.9 0-70.7-57.3-128-128-128-55.3 0-102.5 35.1-120.3 84.2l41.2 32c5.7-38.6 39-68.2 79.1-68.2v32c-26.5 0-48 21.5-48 48h-16l142.2 110.4c4.9-6.9 9.7-13.5 14.2-19.7 4.7-6.4 9-12.4 12.7-17.7zm11 66.9 184.7 143.5 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 112 86.9C188.4 41.7 249.3 0 320 0c97.2 0 176 78.8 176 176 0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-4.4 6-8.8 12-13.1 18.1zM400 424.9V512H240v-96h148.7zM152.4 229.8l108.5 85.5c2.3 3.7 4.4 7.5 6.5 11.2 10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4-9.8-14.1-17.6-29.8-23-46.6z" })
  }
), zF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M297.2 248.9c14.4-20.6 22.8-45.7 22.8-72.9 0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-48.5c2.6-18.7 7.9-38.6 18.3-57.5 11.5-20.9 26.9-42.1 39.8-59.8 4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48h-32c0-44.2 35.8-80 80-80zm-80 288h160v96H112z" })
  }
), pF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 160H192v48h23.3l-46.6 256H128v48h384v-48h-40.7l-46.6-256H448v-48h-24zm0-32V96h32V64l-32-16-96-48-96 48-32 16v32h32v32h48V77.7l48-24 48 24V128zm-48 80h7.9l46.5 256H352v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48h-70.5L264 208h103.9zM33.5 1.9 14.6 46.1l112 48 22.1 9.5 18.9-44.1-22.1-9.5-112-48zm134 194.7-18.9-44.1-22.1 9.5-112 48 18.9 44.1 112-48zm327-146.7-22.1 9.5 18.9 44.1 22.1-9.5 112-48-18.8-44.1-112 48zm0 156.1 112 48 18.9-44.1-112-48-22.1-9.5-18.9 44.1z" })
  }
), MF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M12.8 88 2.3 109.6l.1.1.4.2 1.2.6c1 .5 2.5 1.2 4.5 2 3.9 1.7 9.4 4 16.7 6.8 14.5 5.5 35.7 12.8 63 20C142.8 153.7 221.7 168 320 168s177.2-14.3 231.8-28.8c27.3-7.2 48.5-14.5 63-20 7.3-2.8 12.9-5.1 16.7-6.8 1.9-.8 3.4-1.5 4.5-2l1.2-.6.4-.2.1-.1-10.5-21.6-10.5-21.6-.1.1-.8.4c-.7.3-1.9.9-3.5 1.6-3.2 1.4-8.1 3.4-14.6 5.9-13.1 5-32.7 11.7-58.2 18.5C488.4 106.3 413.7 120 320 120s-168.4-13.7-219.4-27.2C75 86 55.4 79.3 42.3 74.3c-6.5-2.5-11.4-4.5-14.6-5.9-1.6-.7-2.8-1.2-3.5-1.6l-.8-.4-.1-.1-10.5 21.6zM116 222.6c-34-1.5-66.5 18.9-78.7 52.6-21.9 60.1 31.4 147.6 31.4 147.6s97.1-32.8 119-92.9c12.3-33.7.5-70.2-26.5-90.9l15.5-42.6c-16.9-2.8-32.8-6-47.7-9.4zm180 37.1c-32.5 10.2-56 40.5-56 76.3 0 64 80 128 80 128s80-64 80-128c0-35.8-23.5-66.1-56-76.3v-52c-7.9.2-15.9.3-24 .3s-16.1-.1-24-.3zM478.9 239c-27 20.7-38.8 57.2-26.5 90.9 21.9 60.1 119 92.9 119 92.9s53.3-87.5 31.4-147.6c-12.3-33.7-44.7-54.1-78.7-52.6L511 187c-14.8 3.4-30.8 6.6-47.7 9.4zM82.4 291.6c6-16.6 24.4-25.2 41-19.1s25.2 24.4 19.1 41c-4.8 13.3-21.5 29.3-46.7 43.9l-4.2 2.4c-.6-1.5-1.1-3-1.7-4.5-9.9-27.4-12.4-50.4-7.5-63.7zM288 336c0-17.7 14.3-32 32-32s32 14.3 32 32c0 14.1-10.2 34.9-28.9 57.3-1 1.3-2.1 2.5-3.1 3.7-1-1.2-2.1-2.4-3.1-3.7-18.7-22.4-28.9-43.2-28.9-57.3m228.6-63.5c16.6-6 35 2.5 41 19.1 4.8 13.3 2.3 36.2-7.5 63.7-.6 1.5-1.1 3-1.7 4.5l-4.2-2.4c-25.2-14.7-41.9-30.7-46.7-43.9-6-16.6 2.5-35 19.1-41z" })
  }
), xF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 40h200v48H0V40zm0 128h200v48H0v-48zM0 296h224v48H0zm24 128h200v48H0v-48zm264-256h224v48H288zm24-128h200v48H288V40zm-24 256h224v48H288zm24 128h200v48H288v-48z" })
  }
), HF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m95.6 33.7 17 16.1 64 60.8 17.4 16.5-33.1 34.8-17.4-16.5-23.5-22.3v263.8l19.8-19.9 17-17 33.9 34-17 17-60.7 60.8-17 17-17-17L18.2 401l-17-17 33.9-33.9 17 17L72 386.9V125.1L52.2 145l-17 17-33.9-34 17-17L79 50.2zM248 72h328v48H224V72zm0 160h328v48H224v-48zm-24 160h352v48H224z" })
  }
), VF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m190.7 63.7 7.7-22.7L153 25.6l-7.7 22.7-136 400L1.6 471 47 486.4l7.7-22.7 136-400zm101.5-26.5-47.1-9.4-4.7 23.5-80 400-4.7 23.5 47.1 9.4 4.7-23.5 80-400 4.7-23.5zM384 32h-48v448h48V56z" })
  }
), CF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-45.3-35.2c38.8-25.8 64.4-69.9 64.4-120 0-75.7-58.7-138.5-134.3-143.5l-8.1-.5-3.2 47.9 8.1.5c50.4 3.4 89.5 45.2 89.5 95.6 0 39.4-23.7 73.2-57.6 87.9l-119.3-92.5c20.6-24.9 32.9-56.9 32.9-91.6C448 128.4 383.6 64 304.1 64H143.9c-9.7 0-19.3 1-28.5 2.8l-67-52zM173.6 112h130.5c52.9 0 95.9 42.9 95.9 95.9 0 23.6-8.6 45.4-22.9 62.2zm273.2 336-60.9-48h-50c-53 0-95.9-42.9-95.9-95.9 0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8.1 79.5 64.5 143.9 144 143.9zM30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1.5 3.2-47.9-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4z" })
  }
), LF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1.5 3.2-47.9-8.1-.5C87.1 300.2 48 258.3 48 207.9 48 155 90.9 112 143.9 112h160.2c52.9 0 95.9 42.9 95.9 95.9 0 50.5-39.1 92.3-89.5 95.6l-8.1.5 3.2 47.9 8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64zm352.2 384c79.5 0 143.9-64.4 143.9-143.9 0-75.7-58.7-138.5-134.3-143.5l-8.1-.5-3.2 47.9 8.1.5c50.4 3.4 89.5 45.2 89.5 95.6 0 52.9-42.9 95.9-95.9 95.9H335.9c-53 0-95.9-42.9-95.9-95.9 0-50.5 39.1-92.3 89.5-95.7l7.1-.5-3.2-47.9-7.1.5C250.7 165.6 192 228.4 192 304.1c0 79.5 64.4 143.9 143.9 143.9z" })
  }
), BF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-87.5-68C578.2 363 608 313 608 256c0-88.4-71.6-160-160-160h-96v48h96c61.9 0 112 50.1 112 112 0 46.3-28.1 86-68.1 103.1L390 280h58v-48H328.2l-113.4-88H288V96h-96c-11.8 0-23.2 1.3-34.3 3.7L48.4 14.8zm22.3 136.9C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h96v-48h-96c-61.9 0-112-50.1-112-112 0-28.6 10.7-54.8 28.4-74.6z" })
  }
), uF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256C0 167.6 71.6 96 160 96h96v48h-96c-61.9 0-112 50.1-112 112s50.1 112 112 112h96v48h-96C71.6 416 0 344.4 0 256m576 0c0 88.4-71.6 160-160 160h-96v-48h96c61.9 0 112-50.1 112-112s-50.1-112-112-112h-96V96h96c88.4 0 160 71.6 160 160m-392-24h232v48H160v-48z" })
  }
), RF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-131-101.7 90.4-90.4c56.2-56.2 56.2-147.3 0-203.5-53.5-53.5-139.4-56.4-196.4-6.5l-6.1 5.4 31.6 36.1 6.1-5.4c38-33.2 95.2-31.3 130.9 4.4 37.4 37.4 37.4 98.1 0 135.6L451.7 328l-45.8-35.6c24-53.2 13.9-117.6-29.4-160.9-52.4-52.4-135.1-55.9-191.6-10.7L48.4 14.8zm176.1 136.7c36.9-22.8 86-18.2 118 13.9 25.9 25.9 34 63.2 23.8 96.2zm182.4 265-54.2-42.7c-20.2-2.7-39.7-11.8-55.2-27.3-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9 38.8 38.8 94.2 50.8 143.4 36zM116.6 187.9l-56.9 56.9C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4-31.6-36.1-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z" })
  }
), $F = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4-31.6-36.1-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0 35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1 36.1 31.6 5.4-6.1c49.9-57 47-142.9-6.5-196.5-56.2-56.2-147.3-56.2-203.5 0zm520.6 22.4c56.2-56.2 56.2-147.3 0-203.5-53.5-53.5-139.4-56.4-196.4-6.5l-6.1 5.4 31.6 36.1 6.1-5.4c38-33.2 95.2-31.3 130.9 4.4 37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4-36.1-31.6-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4 56.2 56.2 147.3 56.2 203.5 0z" })
  }
), kF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m192 64 96 48 96-48 192 160s-80 224-240 224h-96C80 448 0 224 0 224zm117.5 90.9c-13.5 6.8-29.4 6.8-42.9 0l-67.9-34L58.2 238l.2.4c9.2 19.3 22.8 44.7 40.7 69.7C136.4 360.4 183.9 400 240 400h96c56.1 0 103.6-39.6 140.9-91.9 17.9-25.1 31.5-50.5 40.7-69.7l.2-.4-140.4-117-67.9 34zM96 236l123.4-28s41.3 14 68.6 14 68.6-14 68.6-14L480 236s-68.6 84-192 84-192-84-192-84" })
  }
), PF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 158c0-43.1 34.9-78 78-78 9.1 0 18.1 1.6 26.7 4.7l71.1 25.9 22.6 8.2 16.4-45.1-22.6-8.2-71.1-25.9c-13.8-5-28.4-7.6-43.1-7.6-69.6 0-126 56.4-126 126v34H0v48h48v48H0v48h43L1.7 439.1 0 443.4V480h320v-48H56.2l38-95.1.4-.9H256v-48H96v-48h160v-48H96z" })
  }
), FF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m150.9 69.4 13.4-14.9-29.8-26.7-13.4 14.8L63.2 107 38.1 81.9 24 67.7-4.3 96l14.2 14.1 40 40L64.8 165l14.1-15.7 72-80zm0 160 13.4-14.9-29.7-26.8-13.4 14.9-58 64.4-25.1-25.1L24 227.7-4.3 256l14.2 14.1 40 40L64.8 325l14.1-15.7 72-80zM192 72v48h320V72H216zm0 160v48h320v-48H216zm-32 160v48h352v-48H184zm-64 24a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), TF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 192v240h416V192zM0 32h512v448H0V80zm352 64 48 48 48-48zM128 232h280v48H104v-48zm0 96h280v48H104v-48z" })
  }
), AF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 84.7v60.5l80-21.8V62.8zm-48 281.6V48l128-34.9L512 0v160l-128 34.9V432c0 44.2-50.1 80-112 80s-112-35.8-112-80 50.1-80 112-80c23.8 0 45.9 5.3 64 14.3m0 65.7c0-2.6-1.4-9.4-12.7-17.5-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5c-11.3 8.1-12.7 14.9-12.7 17.5s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5M24 48h264v48H0V48zm0 128h264v48H0v-48zm0 128h136v48H0v-48z" })
  }
), DF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 32h48v144h32v48H24v-48h32V80H32V32zm136 40h320v48H192zm0 160h320v48H192zm0 160h320v48H192zM8 352c0-35.3 28.7-64 64-64h17.2c34.7 0 62.8 28.1 62.8 62.8 0 17.7-7.5 34.6-20.5 46.5L93.4 432H152v48H8v-35.2l7.8-7.1 83.3-75.9c3.1-2.8 4.8-6.8 4.8-11 0-8.2-6.6-14.8-14.8-14.8H72c-8.8 0-16 7.2-16 16H8z" })
  }
), yF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128m120 40h-24v48h352V72h-24zm0 160h-24v48h352v-48h-24zm0 160h-24v48h352v-48h-24zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48m0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128M40 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0m88 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), bF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144 96 33.9-33.9L208 32h240v128H208l-30.1-30.1zm256 16V80H227.9l-16 16 16 16zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64M32 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0 33.9-33.9L208 352h240v128H208l-30.1-30.1zm256 16v-32H227.9l-16 16 16 16zM177.9 289.9 144 256l33.9-33.9L208 192h304v128H208zm50-17.9H464v-32H227.9l-16 16z" })
  }
), fF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 48H0v96h24v296h104v24h96v-96h-96v24H72V280h56v24h96v-96h-96v24H72v-88h24zm64 24v48h352V72H184zm128 160v48h224v-48H312zm0 160v48h224v-48H312z" })
  }
), UF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64m120 8h-24v48h352V72h-24zm0 160h-24v48h352v-48h-24zm0 160h-24v48h352v-48h-24zM96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64" })
  }
), GF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48H16v96h96zm72 24h-24v48h352V72h-24zm0 160h-24v48h352v-48h-24zm0 160h-24v48h352v-48h-24zM16 208v96h96v-96zm96 160H16v96h96z" })
  }
), qF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 56V32H64v188.5l-46.2 12.3-23.2 6.2L7 285.4l23.2-6.2 33.8-9V480h320v-48H112V257.4l158.2-42.2 23.2-6.2-12.4-46.4-23.2 6.2L112 207.7z" })
  }
), WF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v128h48v-24zm0 384v-24h-48v128h48v-24zM0 232v48h128v-48H24zm408 0h-24v48h128v-48h-24zm46-140-34-34-17 17-56.6 56.6-17 17 33.9 33.9 17-17 56.7-56.6 17-17zM165.5 380.4l17-17-33.9-33.9-17 17L75 403.1 58 420l34 34 17-17 56.6-56.6zM92 58 58 92l17 17 56.6 56.6 17 17 33.9-33.9-17-17L108.9 75zm288.5 288.5-17-17-33.9 33.9 17 17 56.5 56.6 17 17 33.9-34-17-17-56.6-56.6z" })
  }
), EF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96V2C74.9.7 69.5 0 64 0 28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64h.7l66 44 6 4H176v16h-44.2l-44.6-22.3-14.3-7.2-14.4 28.7 14.3 7.2 48 24 3.4 1.7H176v16h-61.4l-45.5-15.3-15.2-5.1-10.1 30.4 15.2 5.1 48 16 2.5.8H176v16h-19.8l-3.4 1.7-32 16-14.3 7.2 14.3 28.6 14.3-7.2 28.7-14.3H176l24.5 68.5C176.8 461.8 160 485 160 512h192c0-27-16.8-50.2-40.5-59.5L336 384h12.2l28.6 14.3 14.3 7.2 14.3-28.6-14.3-7.2-32-16-3.4-1.7H336v-16h66.6l2.5-.8 48-16 15.2-5.1-10.1-30.4-15.2 5.1-45.6 15.2H336v-16h51.8l3.4-1.7 48-24 14.3-7.2-14.3-28.6-14.3 7.2-44.7 22.3H336v-16h39.3l6-4 66-44h.7c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64-5.5 0-10.9.7-16 2v94l-42.9-57.2c-3.3 7.8-5.1 16.3-5.1 25.2v64c0 14.9 5.1 28.6 13.6 39.4L360.7 192h-25.2c-2.6-22.5-16-42.9-31.5-59.2V53.6l34.6-5.8 15.8-2.6-5.3-31.6-15.8 2.6-48 8-13.3 2.2V105.6c-3.2-2.2-6.3-4.1-9-5.8-4.3-2.6-9.7-2.6-14 0-2.8 1.6-5.8 3.6-9 5.8V26.4l-13.4-2.2-48-8-15.8-2.6-5.3 31.6 15.8 2.6 34.7 5.8v79.2c-15.5 16.3-28.9 36.7-31.5 59.2h-25.2l-36.9-24.6c8.5-10.9 13.6-24.6 13.6-39.4V64c0-8.9-1.8-17.4-5.1-25.2zm208 104v175.7L262.2 448h-12.4L224 375.7V200c0-6.6 3.8-17 15.4-30.3 5.2-6 11-11.4 16.6-16 5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200" })
  }
), OF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 208v133.8l78.7-212.5L138.2 208H224zM0 208 372.7 70 432 48l-22 59.3L272 480h-48V256H0z" })
  }
), IF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-79-23L177 297l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47L271 135l17-17 33.9 34-17 17z" })
  }
), NF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24V0h-48v65.5c-43.4 5.4-82.4 25.3-111.8 54.8L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-135.7-105.4c13.2-22.2 22-47.2 25.3-73.9H576v-48h-65.5C499.7 145.2 430.8 76.3 344 65.5zm102.9 300.2-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1 0-53-43-96-96-96-22.1 0-42.5 7.5-58.7 20.1L222.5 150c25.6-23.6 59.9-38 97.5-38 79.5 0 144 64.5 144 144 0 24.7-6.2 47.9-17.1 68.2m-79.3-61.6-65.7-51c5.6-2.3 11.7-3.6 18.2-3.6 26.5 0 48 21.5 48 48 0 2.2-.2 4.4-.4 6.6zM415 422.9l-41.9-33c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3H64v48h65.5c10.8 86.8 79.7 155.7 166.5 166.5V512h48v-65.5c25.5-3.2 49.5-11.4 70.9-23.6z" })
  }
), XF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v65.5c86.8 10.8 155.7 79.7 166.5 166.5H512v48h-65.5c-10.8 86.8-79.7 155.7-166.5 166.5V512h-48v-65.5C145.2 435.7 76.3 366.8 65.5 280H0v-48h65.5C76.3 145.2 145.2 76.3 232 65.5V0zM112 256a144 144 0 1 0 288 0 144 144 0 1 0-288 0m192 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0" })
  }
), KF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 192c0 16.3-7.7 42-24.7 75.4-5.9 11.6-12.6 23.5-19.9 35.4l-56.1-43.5C385.4 245 400 220.2 400 192c0-44.2-35.8-80-80-80-35.3 0-65.3 22.9-75.9 54.7l-52.2-40.5C215.8 79.8 264.2 48 320 48c79.5 0 144 64.5 144 144M153.5 96.4 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-163.4-126.9c30.8-49.8 54.5-101 54.5-140.4C512 86 426 0 320 0c-71.2 0-133.4 38.8-166.5 96.4m164.3 127.5-28.1-21.8c-1.1-3.2-1.6-6.6-1.6-10.1 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-.8 0-1.5 0-2.2-.1zm-117 43.5c-3.8-7.4-7.1-14.5-10-21.1L128.2 197c4 83.4 106.6 215.3 160.1 278.7C307.2 498.1 320 512 320 512s12.8-13.9 31.8-36.4c14.2-16.8 31.9-38.5 50.3-62.8l-37.7-29.7c-15.9 21.1-31.3 40.2-44.4 55.8-16.5-19.8-36.9-45.2-57.2-73.1-23.2-31.9-45.6-66.2-62.1-98.3z" })
  }
), QF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0" })
  }
), ZF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192M216 96v160h-48V96zm-48 240v-48h48v48z" })
  }
), JF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-264-24h168v48H96v-48z" })
  }
), jF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192M240.8 96l47.3 47.3-29.1 29.1-47.3-47.3zm-51.7 51.7 47.3 47.3-85.2 85.2-55.2 7.9 7.9-55.3 85.2-85.2z" })
  }
), YF = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.2 365.8c2.3-3.1 4.6-6.3 6.8-9.5v79.9c-11.7 14.9-22.7 28.2-32.2 39.4-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0c95.7 0 175 70 189.6 161.5-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48c-79.5 0-144 64.5-144 144 0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1zM224 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0m288 48c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H288V320h32z" })
  }
), _F = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.3 267.4c17-33.4 24.7-59.1 24.7-75.4 0-79.5-64.5-144-144-144-55.8 0-104.2 31.8-128.1 78.2l227.5 176.6c7.2-11.9 13.9-23.8 19.9-35.4zm18.3 65 163.3 126.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 105.1 81.6C186.6 38.8 248.8 0 320 0c106 0 192 86 192 192 0 39.4-23.7 90.6-54.5 140.4zm-266.9-86.1c2.9 6.7 6.2 13.7 10 21.1 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 13-15.6 28.5-34.7 44.4-55.8l37.7 29.7c-18.4 24.3-36.1 46-50.3 62.8-19 22.6-31.8 36.5-31.8 36.5s-12.8-13.9-31.8-36.4c-53.5-63.4-156.1-195.2-160.1-278.7l62.6 49.3z" })
  }
), hT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3-20.3 27.9-40.7 53.3-57.2 73.1-16.5-19.8-36.9-45.2-57.2-73.1-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4m-87.5 208.2C278.4 411 384 275.1 384 192 384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6 19 22.5 31.8 36.4 31.8 36.4s12.8-13.9 31.8-36.4" })
  }
), cT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192M168 304v-88H80v-48h88V80h48v88h88v48h-88v88z" })
  }
), sT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-280-40c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 232.4V264h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H160c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48z" })
  }
), vT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-248-64a24 24 0 1 1 0 48 24 24 0 1 1 0-48m88 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-112.6 99.1 33.3-22.2c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1l33.3 22.2c-9.9 14.6-38.3 40.9-80.8 40.9s-70.9-26.3-80.6-40.9" })
  }
), eT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4 16.4 32.2 38.8 66.4 62.1 98.3 20.3 27.9 40.7 53.3 57.2 73.1 16.5-19.8 36.9-45.2 57.2-73.1 23.2-31.9 45.6-66.2 62.1-98.3 17-33.4 24.7-59.1 24.7-75.4m48 0c0 83.1-105.6 219-160.2 283.6-19 22.5-31.8 36.4-31.8 36.4s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192 0 86 86 0 192 0s192 86 192 192m-94.1-64-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17L94.1 256l17-17 47-47-47-47-17-17L128 94.1l17 17 47 47 47-47 17-17z" })
  }
), lT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c44.2 0 80 35.8 80 80v32H144v-32c0-44.2 35.8-80 80-80M96 128v32H0v352h448V160h-96v-32C352 57.3 294.7 0 224 0S96 57.3 96 128m-48 80h352v256H48zm235.1 232H336l-85.6-185.4-1.8-3.8L240 232h-32l-8.7 18.8-1.8 3.8L112 440h52.9l18.5-40h81.3l18.5 40zM224 311.9l18.5 40.1h-37z" })
  }
), tT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128v32h160v-32c0-44.2-35.8-80-80-80s-80 35.8-80 80m-48 32v-32C96 57.3 153.3 0 224 0s128 57.3 128 128v32h96v352H0V160h48zm0 48H48v256h352V208H144zm112 16v48h32v-48h48v48h48v48h-48v32h48v48h-48v48h-48v-48h-32v48h-48v-48h-48v-48h48v-32h-48v-48h48v-48zm0 128h32v-32h-32z" })
  }
), wT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 48c-44.2 0-80 35.8-80 80v64h96v320H0V192h304v-64C304 57.3 361.3 0 432 0s128 57.3 128 128v96h-48v-96c0-44.2-35.8-80-80-80m-32 192H48v224h352zM256 376h-88v-48h112v48z" })
  }
), gT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c44.2 0 80 35.8 80 80v64H144v-64c0-44.2 35.8-80 80-80M96 128v64H0v320h448V192h-96v-64C352 57.3 294.7 0 224 0S96 57.3 96 128M48 240h352v224H48zm200 80v-24h-48v112h48v-24z" })
  }
), iT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v96h48v-96C560 57.3 502.7 0 432 0S304 57.3 304 128v64H0v320h448V192h-96zM48 240h352v224H48z" })
  }
), mT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128v64h160v-64c0-44.2-35.8-80-80-80s-80 35.8-80 80m-48 64v-64C96 57.3 153.3 0 224 0s128 57.3 128 128v64h96v320H0V192h48zM48 464h352V240H48z" })
  }
), aT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32h-24v48h72c84.6 0 154.7 62.6 166.3 144h-91.7l-45.5-83.5-18-33.1-22.4 30.3-35 47.5-29.4-46.2-19.3-30.2-20.6 29.4-60.2 85.8H32v115.2l54 24.7L4.5 480h58.6l67.2-95.8 28.7 13.1-51.2 78.1-3 4.6h57.4l41.9-64h71L243 472.1l-4.5 7.9h55.3l36.6-64h110.8l32 64h53.7l-1.4-2.7-31.2-62.3c46.2-6.9 81.6-46.6 81.7-94.7V248c0-119.3-96.7-216-216-216zm-7.6 336-1.3-.7-.4.7h-92.2l-52-23.8 50.6-72.2h102.8l.7 1.1 1.8-1.1h91.7l.3.6 1-.6H528v48c0 26.5-21.5 48-48 48zM114 323.9l-34-15.5V272h70.5zM242.8 224l20.2-28.8 18.4 28.8zm102 0 20.2-27.4 15 27.4zM496 320a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), oT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-16h-48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8c-57.4 0-104-46.6-104-104 0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8M0 192c0 106 86 192 192 192 44.4 0 85.2-15 117.7-40.3L479 513l34-34-169.3-169.3C369 277.2 384 236.4 384 192 384 86 298 0 192 0S0 86 0 192" })
  }
), nT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 80h320v112h48V32H48v160h48zm0 192v160H48V272zm-48-48H0v256h144v-32h224v32h144V224H368v64H144v-64H96zm96 112h224v64H144zm272-64h48v160h-48z" })
  }
), rT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 224c0-97.2-78.8-176-176-176S48 126.8 48 224v240h352zM0 224C0 100.3 100.3 0 224 0s224 100.3 224 224v288H0v-48zm128 160c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32m-32 0c0-29.8 20.4-54.9 48-62v-34c-44.2 0-80-35.8-80-80v-48h80c44.2 0 80 35.8 80 80 0-44.2 35.8-80 80-80h80v48c0 44.2-35.8 80-80 80v34c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64m80-80v16h96v-16l-16-16-32-32-32 32zm82.7-80c-1.8 5-2.7 10.4-2.7 16v16h48c20.9 0 38.7-13.4 45.3-32 1.8-5 2.7-10.4 2.7-16v-16h-48c-20.9 0-38.7 13.4-45.3 32M144 192H96v16c0 5.6 1 11 2.7 16 6.6 18.6 24.4 32 45.3 32h48v-16c0-5.6-1-11-2.7-16-6.6-18.6-24.4-32-45.3-32" })
  }
), dT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24v120h-48V0h48zm-88 120v44.1l-26.5-26.5-21.5 21.5V144h-31.7c-20.3 28.4-39.1 57.7-56.4 87.9C82.7 297 48 363.3 48 423c0 22.6 18.3 41 41 41 20.5 0 43.8-4.9 71.1-12.7 8.9-2.6 19.1-5.7 29.9-9l2.6-.8 38.4 38.4c-8 2.4-16.1 4.9-24.3 7.4C167.8 499.4 127.2 512 89 512c-49.1 0-89-39.8-89-89 0-74.6 42.3-152 78.2-214.9 22.3-38.9 46.9-76.3 73.8-112.1h104zm177.3 343.3c-8.2-2.5-16.3-5.1-24.3-7.4l38.5-38.4 2.6.8c10.7 3.3 21 6.5 29.9 9 27.3 7.8 50.6 12.7 71.1 12.7 22.6 0 41-18.3 41-41 0-59.7-34.7-126-71.9-191.1-17.3-30.3-36.1-59.6-56.4-87.9H432v39.1l-21.5-21.5-26.5 26.5V96h104c26.9 35.8 51.5 73.2 73.8 112.1 35.9 63 78.2 140.3 78.2 214.9 0 49.1-39.8 89-89 89-38.2 0-78.8-12.6-117.7-24.7m-22.8-280.4 11.3 11.3 11.3 11.3-11.3 11.3C398.5 264.1 415 304 448 304h16v32h-16c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C375.9 398.5 336 415 336 448v16h-32v-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3-11.3-11.3 11.3-11.3C241.5 375.9 225 336 192 336h-16v-32h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3 11.3-11.3 11.3 11.3C264.1 241.5 304 225 304 192v-16h32v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48m72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), ST = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m344 195.6 40 28.6V96h104c26.9 35.8 51.5 73.2 73.8 112.1 35.9 63 78.2 140.3 78.2 214.9 0 49.1-39.8 89-89 89-38.2 0-78.8-12.6-117.7-24.7-16.8-5.2-33.4-10.3-49.3-14.3V322.5l48 34.3v79.9c6.1 1.8 12.1 3.7 18.1 5.6 10.7 3.3 21 6.5 29.9 9 27.3 7.8 50.6 12.7 71.1 12.7 22.6 0 41-18.3 41-41 0-59.7-34.7-126-71.9-191.1-17.3-30.3-36.1-59.6-56.4-87.9H432v114.5l69.9 50 19.5 13.9-27.9 39.1-19.5-13.9-42.1-30-48-34.3-64-45.7-64 45.7-48 34.3-42.1 30-19.5 13.9-27.9-39.1 19.5-13.9 69.9-50V144h-31.5c-20.3 28.4-39.1 57.7-56.4 87.9C82.7 297 48 363.3 48 423c0 22.6 18.3 41 41 41 20.5 0 43.8-4.9 71.1-12.7 8.9-2.6 19.1-5.7 29.9-9 5.9-1.8 12-3.7 18.1-5.6v-79.9l48-34.3V473c-15.9 4-32.4 9.1-49.3 14.3-39 12.1-79.6 24.7-117.8 24.7-49.1 0-89-39.8-89-89 0-74.6 42.3-152 78.2-214.9 22.3-38.9 46.9-76.3 73.8-112.1h104v128.2l40-28.6V0h48v24z" })
  }
), zT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h48V136.1l156 237 20 30.5 20-30.5 156-237V480h48V32h-36.9L404 42.8 224 316.3 44 42.8 36.9 32z" })
  }
), pT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M417.9 183.7c-13.2-42.7-46.9-76.4-89.6-89.6L288 0l-40.3 94.1c-42.7 13.2-76.4 46.9-89.6 89.6L64 224l94.1 40.3c4.2 13.5 10.4 26.1 18.3 37.4L18.2 459.8l-17 17 33.9 33.9 17-17 158.2-158.1c11.3 7.9 23.9 14.1 37.4 18.3L288 448l40.3-94.1c42.7-13.2 76.4-46.9 89.6-89.6L512 224zM288 136a88 88 0 1 1 0 176 88 88 0 1 1 0-176m32 88a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), MT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h160v224c0 35.3 28.7 64 64 64s64-28.7 64-64V32h160v224c0 123.7-100.3 224-224 224S0 379.7 0 256V56zm48 224c0 97.2 78.8 176 176 176s176-78.8 176-176v-64h-64v64c0 61.9-50.1 112-112 112s-112-50.1-112-112v-64H48z" })
  }
), xT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208m33-289-17-17-33.9 34 17 17 23 23H104v48h126.1l-23 23-17 17 33.9 33.9 17-17 64-64 17-17-17-17-64-64z" })
  }
), HT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208M104 216v72h48v-96h-48zm80-96v168h48V96h-48zm80 64v104h48V160h-48z" })
  }
), VT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208m20.1-304V91.9h-40.2V118c-5.6 1.2-10.9 2.9-15.9 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 6.9 29.8 9.1V324.1H228v-25.6c5.3-1 10.5-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.4-3.2-21-4.4V112z" })
  }
), CT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208m80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 64 80 144 80 144s80-80 80-144m-112 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), LT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208m-72-232h-24v48h192v-48h-24z" })
  }
), BT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17 33.9-34-17-17-124-124c28.2-35.4 45-80.3 45-129.1C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208m-24-96h48v-88h88v-48h-88V96h-48v88H96v48h88v64z" })
  }
), uT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 208a160 160 0 1 0-320 0 160 160 0 1 0 320 0m-30.9 163.1C301.7 399.2 256.8 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1l124 124 17 17-34 33.9-17-17-124-124z" })
  }
), RT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 224V32h112v80h-64v112zM144 112c-53 0-96 43-96 96v192h192V208c0-53-43-96-96-96m107.3 0c22.8 25.5 36.7 59.1 36.7 96v192h240V208c0-28.4-12.4-54-32-71.6V79c47.4 23.6 80 72.5 80 129v240H0V208C0 128.5 64.5 64 144 64h176v48zM104 192h104v48H80v-48z" })
  }
), $T = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 208c0-53 43-96 96-96s96 43 96 96v192H48zm192 240h336V208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208v240h48zm48-240c0-36.9-13.9-70.5-36.7-96H432c53 0 96 43 96 96v192H288zm-184-16H80v48h128v-48h-24zm256 0h-24v48h80v48h64v-96h-40z" })
  }
), kT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 32h-48v65.5C73.3 109.3 0 190.1 0 288v192h48V288c0-71.4 51.9-130.6 120-142v334h48V146c68.1 11.4 120 70.7 120 142v192h48V288c0-97.9-73.3-178.7-168-190.5z" })
  }
), PT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 0-80 48-31 93.1-49 49C206.9 187.4 0 194.5 0 336c0 97.2 78.8 176 176 176 141.5 0 148.6-206.9 145.9-287.9l49-49L464 144l48-80zM168.3 245.3c24.5-4.3 49.3-6.3 71.6-7.1l-51.5 51.5c-4-1.1-8.1-1.6-12.4-1.6-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-4.3-.6-8.5-1.6-12.4l51.5-51.5c-.8 22.3-2.8 47.1-7.1 71.6-6.5 36.9-17.3 68.6-32.8 90.1-14 19.3-31.3 30.2-57.9 30.2-70.7 0-128-57.3-128-128 0-26.6 10.9-43.9 30.2-57.9 21.5-15.6 53.2-26.4 90.1-32.8z" })
  }
), FT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 102.1v-49C385.2 79 414.6 96 448 96h64V72c0-39.8-32.2-72-72-72H320v96c-49.1 0-98.3 18.7-135.8 56.2-45.8 37.3-67.9 78.9-88.4 117.9-19 36-36.8 69.7-71.1 95.4L-1.8 384 0 448l43.9 20.7S144 512 288 512c166.5 0 224-147.4 224-224 0-49.1-18.7-98.3-56.2-135.8-16.6-16.6-35.6-29.6-55.8-38.8v54.8c7.7 5.2 15 11.1 21.8 17.9C450 214.3 464 251.1 464 288c0 28.5-11.3 74.2-39.8 111.7-27 35.6-69.3 64.3-136.2 64.3-67.3 0-124.3-10.1-164.4-20.2-20-5-35.6-10-46.1-13.6-5.2-1.8-9.1-3.3-11.6-4.3-1.2-.5-2-.8-2.5-1l-16.3-7.7-.2-8.7 5.3-3.7.7-.5.7-.5c43.1-32.3 65.5-74.8 83.8-109.5 1.1-2.1 2.2-4.2 3.3-6.2 19.6-37 37.9-69.4 74-98.7l1.9-1.6 1.7-1.7c28.1-28.1 65-42.2 101.8-42.2v48h48V102.1zM416 304h-32c0 44.2-35.8 80-80 80v32c61.9 0 112-50.1 112-112" })
  }
), TT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-128c16.6 0 30.3-12.6 31.8-28.8C361 113.9 416 178.5 416 256s-55 142.1-128.2 156.8c-1.5-16.2-15.2-28.8-31.8-28.8s-30.3 12.6-31.8 28.8C151 398.1 96 333.5 96 256s55-142.1 128.2-156.8c1.6 16.2 15.2 28.8 31.8 28.8zm-80 48v32h32v-32zm0 64v32h32v-32zm32 64h-32v32h32zm64-128h-32v32h32zm-32 64v32h32v-32zm32 64h-32v32h32zm64-128h-32v32h32zm-32 64v32h32v-32zm32 64h-32v32h32z" })
  }
), AT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200s120-130 120-200m-160-8a40 40 0 1 1 80 0 40 40 0 1 1-80 0m125.9 153.1c-7.5 10.2-14.9 19.9-21.9 28.8v158.3l-128-46.5V293.9c-7-8.8-14.4-18.5-21.9-28.8-8.8-12.1-17.8-25.1-26.1-38.6v178.8l-128 41V195l96.6-30.9c-5.2-14.6-8.6-29.6-8.6-44.1v-3.5L0 160v352l48-15.4L200 448l176 64 200-64V96l-48 15.4-90 28.8c-3.6 19-11.5 38.1-20.3 55.2l-1.1 2L528 161.8V413l-128 41V226.5c-8.4 13.4-17.3 26.5-26.1 38.6" })
  }
), DT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200s120-130 120-200m-34.1 145.1c-7.5 10.2-14.9 19.9-21.9 28.8v158.3l-128-46.5V293.9c-7-8.8-14.4-18.5-21.9-28.8-8.8-12.1-17.8-25.1-26.1-38.6v178.8l-128 41V195l96.6-30.9c-5.2-14.6-8.6-29.6-8.6-44.1v-3.5L0 160v352l48-15.4L200 448l176 64 200-64V96l-48 15.4-90 28.8c-3.6 19-11.5 38.1-20.3 55.2l-1.1 2L528 161.8V413l-128 41V226.5c-8.4 13.4-17.3 26.5-26.1 38.6" })
  }
), yT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 144a96 96 0 1 1 192 0 96 96 0 1 1-192 0m120 142c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142v226h48v-24z" })
  }
), bT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m168 373.4-120 40V130.6l120-40zm192 48-144-48V90.6l144 48zm48 0V138.6l120-40v282.8zM0 480l48-16 144-48 192 64 192-64V32l-48 16-144 48-192-64L0 96v333.4z" })
  }
), fT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M10.2 461 0 512l51-10.2L160 480l325.5-325.5c17-17 26.5-40 26.5-64 0-50-40.5-90.5-90.5-90.5-24 0-47 9.5-64 26.5L313 71l-48-48-17-17-17 17-96 96-17 17 34 33.9 17-17 79-79 31 31L32 352zm51-10.2 15-75.1L193 258.9l60.1 60.1-116.8 116.8-75.1 15zM226.9 225 391.4 60.5c8-8 18.8-12.5 30.1-12.5C445 48 464 67 464 90.5c0 11.3-4.5 22.1-12.5 30.1L287 285.1z" })
  }
), UT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m222.7 79-18.8-31.9L176 0l-27.9 47.1L129.3 79l-36.7-5.2-54.2-7.5 19.4 51.2L71 152l-26.9 25.5-39.7 37.7 52.1 16.7 35.2 11.3 3.2 36.8 4.7 54.6 45.6-30.3 30.8-20.6 30.8 20.5 29 19.3c-13.6-22.4-22.8-47.9-26.2-75.1l-6.9-4.6L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22-11.4-29.7-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 5.7-.8c12.9-21.6 29.9-40.4 49.9-55.4l-25.6 3.6zM520 0h-24v48h62.1l-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160 0 80.2 59 146.6 136 158.2V416h-56v48h56v48h48v-48h56v-48h-56v-33.8c77-11.6 136-78 136-158.2 0-31.4-9-60.7-24.7-85.4L592 81.9V136h48V0h-24zm-8 224c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112c28.3 0 54.2 10.5 73.9 27.8l10.3 10.3c17.3 19.7 27.8 45.6 27.8 73.9" })
  }
), GT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M376 0h-24v48h62.1l-42.9 42.9C340.3 64.2 300 48 256 48c-97.2 0-176 78.8-176 176 0 89.1 66.2 162.7 152 174.4V414.4h-48v48h48V486.6h24-24v24h48V488h-24 24V484.7v.3V483.9v.1V473.9v.1V469.6v.4V464h48v-48h-48V398.6c85.8-11.7 152-85.3 152-174.4 0-35.8-10.7-69.2-29.1-97L448 81.9V144h48V0h-24zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256" })
  }
), qT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32h160v160h-48v-78.1l-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80H288zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256m128 36c14.3-11.2 27.1-24.2 38-38.6 8.4 1.7 17.1 2.6 26 2.6 70.7 0 128-57.3 128-128 0-22.5-5.8-43.6-16-62v-83.9L558.1 80H480V32h160v160h-48v-78.1l-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176-22.6 0-44.2-4.3-64-12" })
  }
), WT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 256a128 128 0 1 1 256 0 128 128 0 1 1-256 0m302.4-24C370.7 146.2 297.1 80 208 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152H416v72h48v-72h78.1l-31 31-17 17 33.9 33.9 17-17 72-72 17-17-17-17-72-72-17-17-33.9 34.1 17 17 31 31H464v-72h-48v72z" })
  }
), ET = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175.6 13.8 160 .4l-15.6 13.4-56 48-18.2 15.6 31.2 36.4 18.2-15.6 16.4-14V128H80v48h56v17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2V176h56v-48h-56V84.2l16.4 14 18.2 15.6 31.2-36.4-18.2-15.6-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224" })
  }
), OT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0h160v160h-48V81.9L409.9 136l31 31 17 17-33.9 33.9-17-17-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176S32 401.2 32 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7l27.8-27.7-31-31-17-17L328 54.1l17 17 31 31L430.1 48H352zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256" })
  }
), IT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32h-24v48h78.1l-83.7 83.7C252.8 141.3 215.9 128 176 128 78.8 128 0 206.8 0 304s78.8 176 176 176 176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3l83.7-83.8V192h48V32h-24zM48 304a128 128 0 1 1 256 0 128 128 0 1 1-256 0" })
  }
), NT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 144c0-53-43-96-96-96-35.5 0-66.6 19.3-83.2 48h-52.6C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-28.2 0-54.5-8.1-76.7-22.1l35.3-35.3c12.5 6 26.6 9.4 41.4 9.4 53 0 96-43 96-96zM32 128h384v32l-16 16-158.1 158.1-9.9 9.9v120h88v48H96v-48h88V344l-9.9-9.9L16 176 0 160v-32zm51.9 48L208 300.1 332.1 176z" })
  }
), XT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v48l222.1 222.1 9.9 9.9v184H128v48h256v-48H280V280l9.9-9.9L512 48V0H48zm444.1 48L256 236.1 67.9 48z" })
  }
), KT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v48l222.1 222.1 9.9 9.9v184H128v48h256v-48H280V280l9.9-9.9L512 48V0H48zm316.1 176L256 236.1 195.9 176zm48-48H147.9l-80-80h376.2z" })
  }
), QT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m196.8 176 12.1-8.1 83.9-55.9h54.3l83.9 55.9 12.1 8.1H496v48c0 59.5-29.5 112.1-74.7 143.9l-3.1.8.3 1.2c-28.1 19-62 30.1-98.5 30.1s-70.4-11.1-98.5-30.1l.3-1.2-3.1-.8C173.5 336.1 144 283.5 144 224v-48h38.3zM96 224c0 45.1 13.4 87.2 36.3 122.3l-84.3-21V176h48zM18.2 367.3l180.7 45.2C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l180.7-45.2 18.2-4.5V128H457.7l-87.9-58.6-8.1-5.4h-83.4l-8.1 5.4-87.9 58.6H0v234.7l18.2 4.5zm573.8-42-84.3 21.1c23-35.2 36.3-77.2 36.3-122.3V176h48zM208 192h-16v32h256v-32h-16zm-16 64v32h256v-32H208zm48 64h-16v32h192v-32h-16z" })
  }
), ZT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 32v128h-48V32zm-48 160h48v192c0 70.7-57.3 128-128 128s-128-57.3-128-128v-32h48v32c0 44.2 35.8 80 80 80s80-35.8 80-80zm-264 96-13.2-26.3-13.5-27L232 224h-16l-5.3 10.7-13.5 27L184 288H0V64h448v224h-48zm-90.9-85.5 13.2-26.5h75.4l13.3 26.5 18.7 37.5H400V112H48v128h106.3l18.7-37.5z" })
  }
), JT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.7 374.4c-.5-4.3-.7-8.7-.7-13.1 0-27 9.6-57.1 22.4-83.6 12.9-26.7 30.4-52.4 48.6-70.7l7-7h83.9l7 7c18.3 18.3 35.7 44 48.6 70.7 12.8 26.5 22.4 56.6 22.4 83.6 0 4.3-.2 8.5-.6 12.7 15.7-21.2 24.7-46.6 24.7-73.2 0-41.1-20.6-104.8-55.4-155.2L359.9 80H280l-49 65.6c-34.6 50.3-55 114-55 155.2 0 26.7 8.9 52.3 24.7 73.6m47.3-13.1c0 21.8 9.2 41.2 24 54.5v58.6c-45.3-10.8-84-36.5-109.8-71.1l-144.1-36L0 362.7V128h185.1c2.3-3.5 4.6-7 6.9-10.4L256 32h128l63.6 85.6c2.4 3.4 4.7 6.9 6.9 10.4H640v234.7l-18.2 4.5-144.3 36.2c-26 34.6-64.7 60.2-109.5 71v-58.7c14.7-13.3 24-32.6 24-54.3 0-16.9-6.4-39.5-17.6-62.7-9.3-19.3-21.1-37.2-32.8-50.6h-43.2c-11.7 13.4-23.5 31.3-32.8 50.6-11.2 23.2-17.6 45.8-17.6 62.7zm257.6-14.5 86.4-21.5V176H480.7c19.8 43.2 31.3 88.7 31.3 124.8 0 16-2.2 31.4-6.4 46.1zM159.1 176H48v149.3l86.3 21.6c-4.1-14.7-6.3-30.1-6.3-46 0-36.1 11.4-81.6 31.1-124.8zM296 304h48v208h-48z" })
  }
), jT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M242.3 304h91.4l13.3 26.5 34.7 69.5H400c37.4 0 69.2-12.4 91.2-33 21.5-20.2 36.8-51.1 36.8-95 0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95 22 20.6 53.7 33 91.2 33h18.3l34.7-69.5zM224 448h-48C80 448 0 384 0 272S64 64 288 64s288 96 288 208-80 176-176 176h-48l-37.2-74.3-.2-.3L304 352h-32l-10.7 21.3-.2.3zM96 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0m320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), YT = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169.8 373.5c-49.4-22.2-84.4-52.3-90.8-90.3l-28.7-172c2.4-2.7 5.7-6.1 10.3-9.8 17.1-14 53.5-35 126.1-47.1 40.9-6.8 71.8-7.3 94.7-5 3-1.3 6.2-2.6 9.5-3.8 20.4-7.5 46.6-13.2 80.3-14.5-17.8-14.7-70.7-44.5-192.4-24.1C21 33.3 0 101.7 0 101.7l31.7 189.4c21.1 126.2 221 157.7 221 157.7s.8-.4 2.3-1.3c-14.7-16.6-28.7-35.7-39.4-57-14-4.2-29.9-9.8-45.8-17m29.9-98.4 8.6-51.5c-41.8 8.7-70.2 47.6-66.1 89.8 15.1-17.3 34.7-30.8 57.5-38.3M184 147.2c-9.2 9.5-21.4 16.3-35.4 18.6s-27.8-.1-39.5-6.1c-.6 4.1-.6 8.4.1 12.7 3.6 21.8 24.3 36.5 46.1 32.8s36.5-24.3 32.8-46.1c-.7-4.3-2.1-8.3-4-12zm203.3 364.3s199.9-31.4 221.1-157.7L640 164.4S619 96 461.2 69.6 261.3 101 261.3 101l-31.7 189.4c-21.2 126.3 157.7 221.1 157.7 221.1m-81.6-385.1c3.1-1.8 7.4-3.9 13-5.9 20.7-7.7 62-15.7 134.6-3.5s109 33.2 126.1 47.1c4.6 3.8 7.9 7.1 10.3 9.8l-28.7 172c-6.4 38-41.3 68.1-90.8 90.3-23.1 10.4-46 17.5-63.4 21.9-4.1 1.1-7.8 1.9-11.1 2.7-2.9-1.8-6.1-3.8-9.6-6.2-14.9-9.9-34.3-24-52.8-41.4-39.5-37.1-62.8-77-56.4-115l28.8-171.9zm100.1 117c1.9-3.7 3.3-7.7 4-12 3.6-21.8-11.1-42.4-32.9-46.1s-42.4 11.1-46.1 32.8c-.7 4.3-.7 8.6-.1 12.7 11.8-6 25.5-8.4 39.5-6.1s26.2 9.1 35.4 18.6zM532 264.5c1.9-3.7 3.3-7.7 4-12 3.6-21.8-11.1-42.4-32.8-46.1s-42.4 11.1-46.1 32.8c-.7 4.3-.7 8.6-.1 12.7 11.8-6 25.5-8.4 39.6-6.1s26.2 9.1 35.4 18.6zm3.7 36.6c-34.1 19.6-75 28-116.8 21s-77.7-28.2-103.6-57.9c-5.5 58 34.7 111.2 93 121s113.7-27.5 127.4-84.1" })
  }
), _T = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 112v288H48V112zm48 0h304v288H288zM48 64H0v384h640V64h-48zm32 80v224h128V144z" })
  }
), hA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m72 232 33.9-33.9L135 169l87 87-87 87-29.1-29.1L72 280l-33.9 33.9L32 320v160h160l6.1-6.1L232 440l-33.9-33.9L169 377l87-87 87 87-29.1 29.1L280 440l33.9 33.9 6.1 6.1h160V320l-6.1-6.1L440 280l-33.9 33.9L377 343l-87-87 87-87 29.1 29.1L440 232l33.9-33.9 6.1-6.1V32H320l-6.1 6.1L280 72l33.9 33.9L343 135l-87 87-87-87 29.1-29.1L232 72l-33.9-33.9L192 32H32v160l6.1 6.1zm8-75.9V80h76.1zM156.1 432H80v-76.1zm199.8 0 76.1-76.1V432zm0-352H432v76.1z" })
  }
), cA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M476.3 101.5c-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8v94.5l-26.4 26.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60h12v12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7l26.3-26.3H296c50.9 0 99.8-20.2 135.8-56.2l51.7-51.8.3-.3c23.7-23.7 29.9-54.3 27.8-82.5-.7-9.4-2.3-18.5-4.6-27-5.8-22-16.4-44.1-30.7-64.8zm-13.5 115.1c-2 9.9-6.2 18.6-12.9 25.3l-.2.2c-29 28.7-92.5 11.9-142-37.6-49.7-49.7-66.5-113.4-37.5-142.3 1.8-1.8 3.7-3.4 5.8-4.8.5-.4 1-.7 1.6-1.1 2.9-1.9 6-3.4 9.3-4.6.9-.3 1.9-.7 2.8-1 32.7-10.1 82.4 8.5 122.8 48.9 10.9 10.9 20.2 22.5 27.8 34.3 9.7 15 16.5 30.2 20.3 44.6.4 1.6.8 3.2 1.2 4.9 2.5 11.4 3 22.1 1.3 31.7-.1.5-.2 1-.3 1.6zm-73.9 85.5C363 323.9 330.1 336 296 336H176V216c0-34.1 12.1-67 33.9-92.8.8 5 1.9 9.9 3.1 14.6 9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zm-1.2-122.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5-3.8 28.5 11.5 43.8 34.9 20.4 43.8 11.5z" })
  }
), sA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M227.2 100.7 160 0H0l32 48 87.4 131.1c12.1-10.5 25.3-19.6 39.6-27.2L89.7 48h44.6l59.6 89.4c16.4-5.1 33.7-8.3 51.6-9.2l-18.4-27.5zM480 48l32-48H352l-67.2 100.7-18.4 27.5c17.9.9 35.2 4 51.6 9.2L377.7 48h44.6L353 152c14.3 7.5 27.5 16.7 39.6 27.2zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352m0-272-28.2 57.2-63.1 9.2 45.7 44.5-10.8 62.8L256 384l56.4 29.7-10.8-62.8 45.7-44.5-63.1-9.2z" })
  }
), vA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 32h-48v29.7L48 192.6V160H0v192h48v-32.6l117.6 32.1c-3.6 10.2-5.6 21.1-5.6 32.5 0 53 43 96 96 96 46.9 0 86-33.6 94.3-78.1L528 450.3V480h48V80zm-48 368.6L48 269.7v-27.4l480-130.9zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8-26.5 0-48-21.5-48-48z" })
  }
), eA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368.7 63.3 336 96l-1.2 1.2 1 1c-1.2 15.4-11.2 105.2-71.8 165.8s-150.4 70.6-165.7 71.8c-.4-.3-.7-.7-1-1L96 336l-32.7 32.7-28.1 28.1-34 34c11.8 11 24.5 21 37.9 30C87.4 493.1 145.5 512 208 512c167.9 0 304-136.1 304-304 0-62.5-18.9-120.6-51.2-168.9-9-13.4-19-26.1-30-37.9l-34 34zm5.1 95c6.6 18 10.2 37.5 10.2 57.8 0 92.8-75.2 168-168 168-20.3 0-39.7-3.6-57.8-10.2 3.3-.8 6.7-1.8 10.1-2.8 38-10.9 88.5-32 129.6-73.1s62.2-91.6 73.1-129.6c1-3.4 1.9-6.8 2.8-10.1M101 398.9c33.3 21 72.7 33.1 115 33.1 119.3 0 216-96.7 216-216 0-42.3-12.1-81.7-33.1-115l27.2-27.2c24.1 39 37.9 85 37.9 134.2 0 141.4-114.6 256-256 256-49.2 0-95.2-13.9-134.2-37.9z" })
  }
), lA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-35.6-8.9-69.1-24.7-98.4-5.8 53.3-27.3 124.6-92.2 189.5s-136.2 86.4-189.5 92.2c29.3 15.8 62.8 24.7 98.4 24.7 114.9 0 208-93.1 208-208M79.1 365.5c7.4-59.4 28.3-143.2 85.7-200.6 62.2-62.2 139-83 195-89.1C329.3 58.1 293.8 48 256 48 141.1 48 48 141.1 48 256c0 40.2 11.4 77.7 31.1 109.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m130.7 90c-3.2 17.4-5 33.4-6.1 47.1 9.9 0 21.4-.6 33.9-2.3 44.2-5.8 101.6-24.5 154.7-77.7s71.8-110.5 77.6-154.7c1.8-13.8 2.3-26.3 2.2-36.9-12.3.3-26.9 1.4-42.9 3.9-47.6 7.4-104.8 26.7-151.4 73.4-38.7 38.8-58.6 95.5-68 147.2" })
  }
), tA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v172.5c14.6-9.5 30.8-17 48-21.8V0H0v512h330.8c-18.3-12.9-34.1-29.2-46.3-48H48zm240 176H96v48h188.5c1.1-1.8 2.3-3.5 3.5-5.2zm-168-96H96v48h192v-48h-24zm0 192H96v48h96v-48h-24zm456 48a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), wA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h288v172.5c14.6-9.5 30.8-17 48-21.8V0H0v512h330.8c-18.3-12.9-34.1-29.2-46.3-48H48zm240 176H96v48h188.5c1.1-1.8 2.3-3.5 3.5-5.2zm-168-96H96v48h192v-48h-24zm0 192H96v48h96v-48h-24zm312 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288m15.3-224v32h-32v-32zm1.2 64v80H464v32h-64v-32h16.5v-48H400v-32h32.5z" })
  }
), gA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 128v336H48V128zM48 0H0v512h448V0h-48zm48 176v48h256v-48H120zm0 96v48h256v-48H120zm0 96v48h160v-48H120z" })
  }
), iA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V48zM0 0h384v512H0V48zm120 128h168v48H96v-48zm0 96h168v48H96v-48zm0 96h72v48H96v-48z" })
  }
), mA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112V64h576v98.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3V448H0V253.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3zm48 24.5c19.6 17.5 32 43 32 71.5s-12.4 54-32 71.5V304h480v-24.5c-19.6-17.6-32-43.1-32-71.5s12.4-54 32-71.5V112H48zM528 352H48v48h56v-24h48v24h32v-24h48v24h32v-24h48v24h32v-24h48v24h32v-24h48v24h56zM192 144v128h-48V144zm120 0v128h-48V144zm120 0v128h-48V144z" })
  }
), aA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M4.2 48.7 32 0l27.8 48.7c2.8 4.8 4.2 10.2 4.2 15.7C64 81.8 49.8 96 32.4 96h-.8C14.2 96 0 81.8 0 64.4c0-5.5 1.4-10.9 4.2-15.7m96 0L128 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C110.2 96 96 81.8 96 64.4c0-5.5 1.4-10.9 4.2-15.7M224 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C206.2 96 192 81.8 192 64.4c0-5.5 1.4-10.9 4.2-15.7zm68.2 48.7L320 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C302.2 96 288 81.8 288 64.4c0-5.5 1.4-10.9 4.2-15.7M416 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C398.2 96 384 81.8 384 64.4c0-5.5 1.4-10.9 4.2-15.7zm68.2 48.7L512 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C494.2 96 480 81.8 480 64.4c0-5.5 1.4-10.9 4.2-15.7M608 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C590.2 96 576 81.8 576 64.4c0-5.5 1.4-10.9 4.2-15.7zM48 128v152c0 22.1 17.9 40 40 40h208V128h48v192h208c22.1 0 40-17.9 40-40V128h48v152c0 48.6-39.4 88-88 88H344v96h168v48H128v-48h168v-96H88c-48.6 0-88-39.4-88-88V128zm104 24v136h-48V128h48zm96 0v136h-48V128h48zm192 0v136h-48V128h48zm96 0v136h-48V128h48z" })
  }
), oA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50.6 0C62 28.6 81.7 52.9 106.9 69.9 52.7 99.9 16 157.7 16 224c0 89.1 66.2 162.7 152 174.4V424h-56v48h56v40h48v-40h56v-48h-56v-25.6c85.8-11.7 152-85.3 152-174.4 0-66.3-36.7-124.1-90.9-154.1 25.2-17 44.9-41.3 56.3-69.9h-53.7c-18.5 28.9-50.9 48-87.7 48s-69.2-19.1-87.7-48zM192 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256" })
  }
), nA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64h171.9l7.2 9.5L299.9 232h119l-39-39-17-17 33.9-33.9 17 17 80 80 17 17-17 17-80 80-17 17-33.9-34.1 17-17 39-39h-119L179.1 438.5l-7.2 9.5H0v-48h148.1l109.7-144-109.7-144H0z" })
  }
), rA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM280 120V96h-48v142.1l-31-31-17-17-33.9 33.9 17 17 72 72 17 17 17-17 72-72 17-17-34.1-33.9-17 17-31 31z" })
  }
), dA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM216 128h-24v48h78.1l-87 87-17 17 33.9 33.9 17-17 87-87V288h48V128h-24z" })
  }
), SA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 464v48l48-32 96-64h208V0H0v416h160v38.3zm117.4-87.9L208 422.3V368H48V48h416v320H289.5zM280 296V185.9l31 31 17 17 33.9-33.9-17-17-72-72-17-17-17 17-72 72-17 17 34.1 33.9 17-17 31-31V320h48z" })
  }
), zA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272 480-48 32v-96H96V208H64v16H0v-64h64v16h32V0h448v176h32v-16h64v64h-64v-16h-32v208H368zM144 368h128v54.3l69.4-46.2 12.1-8.1H496V48H144v144zM464 96v192H176V96zM240 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), pA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM120 192H96v48h192v-48h-24zm224 0h-24v48h96v-48h-24zm-224 80H96v48h96v-48h-24zm128 0h-24v48h192v-48h-24z" })
  }
), MA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM369 153l17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), xA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM217 161l17-17-34-33.9-17 17-64 64-17 17 17 17 64 64 17 17 33.9-34.1-17-17-47-47 47-47zm112-34-17-17-33.9 34 17 17 47 47-47 47-17 17 33.9 33.9 17-17 64-64 17-17-17-17-64-64z" })
  }
), HA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM276 112V92h-40v26c-5.6 1.2-11 2.9-16 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 7 29.9 9.1V324h40v-25.5c5.4-1 10.6-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V112z" })
  }
), VA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64m144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), CA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM280 80h-48v160h48V104zm-48 192v48h48v-48z" })
  }
), LA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM144 171.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6 11 10.6 11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7 0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z" })
  }
), BA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m208 480-48 32v-96H0V0h512v416H304zm0-57.7 69.4-46.2 12.1-8.1H464V48H48v320h160v48zM144 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 144v16H144v-16l64-80 22 27.4 66-91.4z" })
  }
), uA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM152 144h-24v48h256v-48h-24zm0 96h-24v48h160v-48h-24z" })
  }
), RA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM224 112v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), $A = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.7 96H0v416h512V96H338.3l-50.7-59.1L256 0l-31.6 36.9zM464 144v320H48V144h147.8l14.4-16.8L256 73.8l45.8 53.5 14.4 16.7h22.1z" })
  }
), kA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.7 416H0V0h512v416H338.3l-50.7 59.1L256 512l-31.6-36.9zM464 368V48H48v320h147.8l14.4 16.8 45.8 53.4 45.8-53.5 14.4-16.7h22.1z" })
  }
), PA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 464v48l48-32 96-64h208V0H0v416h160v38.3zm117.4-87.9L208 422.3V368H48V48h416v320H289.5zM184 184h-24v48h192v-48h-24z" })
  }
), FA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM352 96V72.9L330.4 81l-128 48-10.4 3.9v124.9c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V128z" })
  }
), TA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zm27.4-264-29.1 29.1 47.3 47.2 29.1-29.1-47.3-47.3zm-51.7 51.7L167.9 249l-7.9 55.1 55.3-7.9 85.1-85.2-47.3-47.3z" })
  }
), AA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM232 320h48v-88h88v-48h-88V96h-48v88h-88v48h88v64z" })
  }
), DA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM168 136v6.5h48V136c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4-12.1 7V248h48v-31.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1H224c-30.9 0-56 25.1-56 56zm64 152v48h48v-48z" })
  }
), yA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM240 112H128v112h64v32h-48v48h96V152zm144 0H272v112h64v32h-48v48h96V152z" })
  }
), bA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272 480-48 32v-96H64V146.4l48 37.8V368h160v54.3l69.4-46.2 7.6-5.1 57.1 45H368zM112 64.2 503.3 368H528V48H112zM64 26.9V0h512v416h-10.8l55.8 43.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7z" })
  }
), fA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-151.6 46.1-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z" })
  }
), UA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM196 148v120h24v-79l25.8 41.3 10.2 16.3 10.2-16.3L292 189v79h24V148h-26.7l-3.5 5.6-29.8 47.8-29.8-47.7-3.5-5.6H196zm-87.8 32.8c.3-1.8 1.7-4.3 6.2-6.4 4.6-2.1 11.5-3.1 19.9-1.8 2.9.5 12 2.2 14.6 2.9l11.6 3.1 6.2-23.2-11.6-3.1c-3.8-1-13.8-2.9-17.1-3.4-12-1.9-23.8-.7-33.5 3.7s-18 12.5-20 24.2c-1.1 6.6-.5 12.8 2.2 18.5 2.6 5.6 6.8 9.6 11.1 12.5 7.6 5.1 17.6 8.1 25.4 10.5l1.4.4c9.2 2.8 15.8 5 19.9 8 1.8 1.3 2.6 2.4 2.9 3.3.3.8.8 2.3.2 5.2-.5 2.9-2.1 5.2-6.1 6.9-4.4 1.9-11.2 2.7-20 1.4-4.1-.7-11.4-3.2-17.8-5.3-1.5-.5-2.9-1-4.2-1.4L88.1 233l-7.6 22.8 11.4 3.8c.8.3 1.8.6 3 1 6.2 2.1 16.3 5.6 22.7 6.6h.1c11.7 1.8 23.4 1.2 33.2-3 10.1-4.3 18.2-12.7 20.3-24.8 1.2-6.7.6-13.1-1.9-18.9-2.5-5.7-6.5-10-10.8-13.1-7.9-5.8-18.5-9-26.7-11.4l-.5-.1c-9.4-2.8-16-4.9-20.3-7.8-1.9-1.3-2.6-2.3-2.9-2.9-.2-.5-.6-1.7-.2-4.2zm256 0c.3-1.8 1.7-4.3 6.2-6.4 4.6-2.1 11.5-3.1 19.9-1.8 2.9.5 12 2.2 14.6 2.9l11.6 3.1 6.2-23.2-11.6-3.1c-3.8-1-13.8-2.9-17.1-3.4-12-1.9-23.8-.7-33.5 3.7s-18 12.5-20 24.2c-1.1 6.6-.5 12.8 2.2 18.5 2.6 5.6 6.8 9.6 11.1 12.5 7.6 5.1 17.6 8.1 25.4 10.5l1.4.4c9.2 2.8 15.8 5 19.9 8 1.8 1.3 2.6 2.4 2.9 3.3.4.8.8 2.3.2 5.2-.5 2.9-2.1 5.2-6.1 6.9-4.4 1.9-11.2 2.7-20 1.4-4.1-.7-11.4-3.2-17.8-5.3-1.5-.5-2.9-1-4.2-1.4l-11.4-3.8-7.6 22.8 11.4 3.8c.8.3 1.8.6 3 1 6.2 2.1 16.3 5.6 22.7 6.6h.1c11.7 1.8 23.4 1.2 33.1-3 10.2-4.3 18.2-12.7 20.3-24.8 1.2-6.7.6-13.1-1.9-18.9-2.5-5.7-6.5-10-10.8-13.1-7.9-5.8-18.5-9-26.7-11.4l-.5-.1c-9.4-2.8-16-4.9-20.3-7.8-1.9-1.3-2.6-2.3-2.9-2.9-.2-.5-.6-1.7-.2-4.2z" })
  }
), GA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM168 112h-24v48h88v160h48V160h88v-48H256z" })
  }
), qA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 512 48-32 96-64h208V0H0v416h160v48zm117.4-135.9L208 422.3V368H48V48h416v320H289.5zM353.9 144 320 110.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), WA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m208 480-48 32v-96H0V0h512v416H304zm0-57.7 69.4-46.2 12.1-8.1H464V48H48v320h160v48z" })
  }
), EA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144 360-48 24v-64H0V0h416v320H224zm0-53.7 58.5-29.3 10.1-5.1H368V48H48v224h96zM256 352h48v48h123.3l10.1 5.1 58.6 29.2V400h96V176H448v-48h192v320h-96v64l-48-24-80-40H256v-48zm-70.2-223.2c-.4 2.4 0 3.3.1 3.4.1.3.7 1.2 2.8 2.6 4.9 3.2 12.7 5.6 24 8.9l.6.2c9.7 2.8 22.6 6.6 32.3 13.5 5.3 3.8 10.4 8.9 13.6 16.1 3.2 7.2 3.9 15.2 2.4 23.4-2.7 15.1-13 25.2-25.5 30.4-3.9 1.6-8 2.8-12.2 3.5v19.9H192v-20.5c-7.6-1.7-17.5-5-23.8-7.1-1.4-.5-2.6-.9-3.6-1.2l-15.2-4.9 9.9-30.4 15.2 4.9c1.6.5 3.3 1.1 5.1 1.7 7.6 2.5 16.2 5.4 21.1 6.1 10.3 1.6 18.3.6 23.3-1.5 4.5-1.9 5.8-4.1 6.2-6.5.5-3 .1-4.3-.1-4.7-.2-.6-.9-1.6-2.9-3-4.7-3.3-12.3-5.8-23.5-9.1l-1.7-.5c-9.4-2.7-21.6-6.3-30.8-12.4-5.3-3.5-10.6-8.4-13.9-15.3-3.5-7.1-4.2-15-2.8-23 2.6-14.6 13.2-24.4 25-29.6 4-1.7 8.2-3.1 12.6-4V69.3h32v20.4c5.3.9 13.3 2.5 16.8 3.4l15.5 4-8 31-15.5-4c-3.1-.8-13.9-2.9-17.4-3.4-9.9-1.5-17.9-.3-23.1 2-5.2 2.3-6.2 4.8-6.4 6z" })
  }
), OA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144 360-48 24v-64H0V0h416v320H224zm0-53.7 58.5-29.3 10.1-5.1H368V48H48v224h96zM256 352h48v48h123.3l10.1 5.1 58.6 29.2V400h96V176H448v-48h192v320h-96v64l-48-24-80-40H256v-48zM146.7 109c0-21.4 17.3-38.7 38.7-38.7h40.3c24.2 0 43.7 19.6 43.7 43.7 0 15.7-8.4 30.1-22 37.9L224 165.4v21.9h-32v-40.5l8-4.6 31.4-18c3.6-2.1 5.9-6 5.9-10.2 0-6.5-5.3-11.7-11.7-11.7h-40.3c-3.7 0-6.7 3-6.7 6.7v4.6h-32V109zM191 216.7h34v34h-34z" })
  }
), IA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 384 48-24 80-40h192V0H0v320h96v48zm106.5-106.9L144 306.3V272H48V48h320v224H212.7l-10.1 5.1zM256 400v48h160l80 40 48 24v-64h96V128H448v48h144v224h-96v34.3L437.5 405l-10.2-5H304v-48h-48z" })
  }
), NA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m304 16-50.4 29.2-152.3 88.2C38.6 169.7 0 236.6 0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3l88.2-152.3L496 208l-7.5.6-50.5 3.9-1.9.1 17.7-49.5 37.3-104.7L512 0l-58.4 20.9-104.7 37.4-49.5 17.6.1-1.9 3.9-50.5zM125.3 174.9l123.8-71.7-3.2 42.8 69.7-24.9 117.1-41.8-41.8 117.2-24.9 69.6 42.8-3.3-71.7 123.9C309.4 434.5 258.3 464 203 464c-85.6 0-155-69.4-155-155 0-55.3 29.5-106.4 77.3-134.1zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224m-24-160a24 24 0 1 1 0 48 24 24 0 1 1 0-48m24 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), XA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 9.9-.7 19.6-2 29.1l49.9-37.9C507.2 109.9 394.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c80.8 0 152.9-37.5 199.9-96h-67c-36 30-82.4 48-132.9 48-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208M192 152v-24h-48v96h48v-24zm88 0v-24h-48v96h48v-24zm88 0v-24h-48v96h48v-24zm136 232-40 128 176-136v-24h-88l40-128-176 136v24z" })
  }
), KA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464c48.8 0 93.8-16.8 129.2-45 2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c113.8 0 210.3 74.3 243.6 177l-36.8 56.5C451.6 129.2 363.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208m-64-312v72h-48v-96h48zm88 0v72h-48v-96h48zm88 0v72h-48v-96h48zm160 40 93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3v2.1c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z" })
  }
), QA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48c70.5 0 132.9 35.1 170.5 88.8 7.1-6 14.2-12 21.5-17.9 15 12.2 29.8 24.5 43.9 37.5C453.1 64.5 362.1 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c33.4 0 65.3-6.4 94.6-18a191.34 191.34 0 0 1-32.9-39.3c-19.5 6-40.2 9.3-61.7 9.3-114.9 0-208-93.1-208-208S141.1 48 256 48m112 104v-24h-48v96h21.7c5.9-7.6 12-14.9 18.1-21.9 2.7-3.1 5.4-6.2 8.2-9.2zm-176 0v-24h-48v96h48v-24zm88 0v-24h-48v96h48v-24zm233 72.1c-32.3-37.5-65-64-65-64s-128 103.6-128 192 71.6 160 160 160 160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), ZA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m192-104v72h-48v-96h48zm88 0v72h-48v-96h48zm88 0v72h-48v-96h48z" })
  }
), JA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0v64h48V0h48v64h48V0h48v64h72v72h64v48h-64v48h64v48h-64v48h64v48h-64v72h-72v64h-48v-64h-48v64h-48v-64h-48v64h-48v-64H64v-72H0v-48h64v-48H0v-48h64v-48H0v-48h64V64h72V0zm216 112H112v288h288zm-44 64v160h-40V176zm-124.7 0 3.4 8.8L293.3 336h-42.9l-7.8-20h-53.2l-7.8 20h-42.8l58.6-151.2 3.4-8.8zM216 247.4 204.9 276h22.2z" })
  }
), jA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 24V0h-48v64H64v72H0v48h64v48H0v48h64v48H0v48h64v72h72v64h48v-64h48v64h48v-64h48v64h48v-64h72v-72h64v-48h-64v-48h64v-48h-64v-48h64v-48h-64V64h-72V0h-48v64h-48V0h-48v64h-48zm216 88v288H112V112zm-96 96v96h-96v-96zm-96-48h-48v192h192V160h-48z" })
  }
), YA = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472.4 344c15-25.9 23.6-56 23.6-88v-64h-48v64c0 21-5 40.7-14 58.2l-25.9-20.1c5.1-11.7 7.9-24.6 7.9-38.1V0H224v151.1L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM272 188.4V48h96v48h-48v32h48v32h-48v32h48v64c0 2.2-.2 4.4-.4 6.6zm86.2 189.8c-12.1 3.8-24.9 5.8-38.2 5.8-70.7 0-128-57.3-128-128v-8.7l-48-37.8V256c0 89.1 66.2 162.7 152 174.4V464h-72v48h192v-48h-72v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z" })
  }
), _A = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 48h96v48h-48v32h48v32h-48v32h48v32h-48v32h48c0 26.5-21.5 48-48 48s-48-21.5-48-48zM96 0v256c0 53 43 96 96 96s96-43 96-96V0H144zM64 216v-24H16v64c0 89.1 66.2 162.7 152 174.4V464H96v48h192v-48h-72v-33.6c85.8-11.7 152-85.3 152-174.4v-64h-48v64c0 70.7-57.3 128-128 128S64 326.7 64 256z" })
  }
), hD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472.4 344c15-25.9 23.6-56 23.6-88v-64h-48v64c0 21-5 40.7-14 58.2l-25.9-20.1c5.1-11.7 7.9-24.6 7.9-38.1V0H224v151.1L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM272 188.4V48h96v208c0 2.2-.2 4.4-.4 6.6zm86.2 189.8c-12.1 3.8-24.9 5.8-38.2 5.8-70.7 0-128-57.3-128-128v-8.7l-48-37.8V256c0 89.1 66.2 162.7 152 174.4V464h-72v48h192v-48h-72v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z" })
  }
), cD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m477.8 203.9-1 1-16 16-16 16-1 1c-22 21.5-50.2 32.9-78.7 34.1l-18 15.1-67.1 56.5V512h-48V384L80 512 0 432l225-267.1 15.1-18c1.2-28.6 12.6-56.8 34.1-78.7l.9-1 16-16 16-16 1-.9c46.9-45.9 122.2-45.6 168.7 1s46.9 121.8 1 168.7zm-67.9 0L308.1 102.1a71.726 71.726 0 0 0-19.6 58.4l1.6 1.6L350 222l1.6 1.6c20.7 2.4 42.3-4.1 58.4-19.6zm33-134.8c-27.8-27.8-72.7-28.1-100.8-1l101.8 101.8c27.2-28.2 26.8-73.1-1-100.8zM313.1 253 259 198.9 65.1 429.2l17.7 17.7z" })
  }
), sD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 48h96v208c0 26.5-21.5 48-48 48s-48-21.5-48-48zM96 0v256c0 53 43 96 96 96s96-43 96-96V0H144zM64 216v-24H16v64c0 89.1 66.2 162.7 152 174.4V464H96v48h192v-48h-72v-33.6c85.8-11.7 152-85.3 152-174.4v-64h-48v64c0 70.7-57.3 128-128 128S64 326.7 64 256z" })
  }
), vD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-96v32h-32v288h32v32h96v-32h32V32h-32zm-80 80h64v192h-64zM24 464H0v48h512v-48h-65c39.9-35.2 65-86.7 65-144 0-106-86-192-192-192v48c79.5 0 144 64.5 144 144s-64.5 144-144 144zm72-80v48h224v-48H120z" })
  }
), eD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v320H48V80zM48 32H0v416h64v32h48v-32h352v32h48v-32h64V32h-48zm384 80v256h48V112zm-48 16H96v224h288z" })
  }
), lD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 251.5 73.6 495.3l44.8 17.3L168 384.5V448h48V260.5l44.3-114.4c5-1.4 10.3-2.1 15.7-2.1 33.1 0 60 26.9 60 60v244h48V204c0-58.4-46.4-106-104.4-107.9l30.7-79.4L265.6-.7 222.8 110c-11.8 6.7-22.3 15.6-30.8 26.1-19.8-24.5-50.1-40.1-84-40.1-22.2 0-42.8 6.7-60 18.2V96H0v352h48V204c0-33.1 26.9-60 60-60s60 26.9 60 60z" })
  }
), tD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 6.1 6.1 40 23 57l64 64-29.1 29.1L24 184l33.9 33.9L64 224h160V64l-6.1-6.1L184 24l-33.9 33.9L121 87 57 23 40 6.1zM505.9 40 472 6.1 455 23l-64 64-29.1-29.1L328 24l-33.9 33.9L288 64v160h160l6.1-6.1L488 184l-33.9-33.9L425 121l64-64 17-17zm-448 321.9L87 391l-64 64-17 17 34 33.9 17-17 64-64 29.1 29.1 33.9 34 33.9-33.9 6.1-6.1V288H64l-6.1 6.1L24 328zM425 391l29.1-29.1L488 328l-33.9-33.9-6.1-6.1H288v160l6.1 6.1L328 488l33.9-33.9L391 425l64 64 17 17 33.9-34-17-17-64-64zm-249 21.1L99.9 336H176zm160 0V336h76.1zm0-312.2 76.1 76.1H336zm-160 0V176H99.9z" })
  }
), wD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 280H16v-48h416z" })
  }
), gD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0v86.1l98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7-64.1-64.2V288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8V153.9L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4 17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75 0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98V0h48zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27 30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1 9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27 0-30.9-22-57.5-52.4-63.4l-47.1-9.1zm-179 150.7c-6.2 8.3-9.6 18.4-9.6 28.8 0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), iD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 135.6C0 60.7 60.7 0 135.6 0 194 0 245.8 37.3 264.2 92.7l32.8 98.5 21.2-23.3 16.4-18 17.8 16.7 76.8 72 15.2 14.3-12.1 17.1L352 383.6v.4h-48v-15.6l4.4-6.2 72.7-102.9-43.8-41-32.3 35.5-27.6 30.3-13-38.9-45.7-137.3c-12-35.8-45.4-59.9-83.1-59.9C87.2 48 48 87.2 48 135.6v9.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5.7 2.9v3H55.3l-51-203.7C1.5 168.8 0 157 0 145.1zM384 416v96H32v-96z" })
  }
), mD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48v416h256V48zM16 0h352v512H16V48zm176 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), aD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48v32H128V48H64v416h256V48zM16 0h352v512H16V48z" })
  }
), oD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48v416H48V48zM48 0H0v512h320V0h-48zm32 128v128h160V128zm48-64h-16v32h96V64h-16zM72 304v48h48v-48zm48 80H72v48h48zm16-80v48h48v-48zm48 80h-48v48h48zm16-80v48h48v-48zm48 80h-48v48h48z" })
  }
), nD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 464h256v-96H64zm0-144h256V48H64zM16 0h352v512H16V48zm176 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), rD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 464h256v-96H64zm0-144h256V48H64zM16 0h352v512H16V48zm144 400h80v32h-96v-32z" })
  }
), dD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h176V0H0v512h352V288h-48v176H48zm96 352h-16v32h96v-32h-16zM256 48c114.9 0 208 93.1 208 208h48C512 114.6 397.4 0 256 0zm32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64m80 0h48c0-88.4-71.6-160-160-160v48c61.9 0 112 50.1 112 112" })
  }
), SD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h256v264.8c14.5-15.1 30.6-28.6 48-40.3V0H0v512h224c0-16.4 1.4-32.4 4-48H48zm96 352h-16v32h96v-32h-16zm368-96v-48c-141.4 0-256 114.6-256 256h48c0-114.9 93.1-208 208-208m-32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-80 0c0-61.9 50.1-112 112-112v-48c-88.4 0-160 71.6-160 160z" })
  }
), zD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48v416h256V48zM16 0h352v512H16V48zm144 400h80v32h-96v-32z" })
  }
), pD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m276.1 405.2 5.6-1.4c55.2-14.1 117.5-30 182.8-28.1 4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9-49.9-1.8-103.1 11.1-164.1 26.6l-5.6 1.4c-55.2 14.1-117.5 30-182.8 28.1-4.1 31.5-31 55.8-63.5 55.8v176c35.3 0 63.9 28.6 64 63.9 49.9 1.8 103.1-11.1 164.1-26.6zM0 60.3C16 68.5 32 74.6 48 79c80 22.1 160 1.7 240-18.7 96-24.5 192-48.9 288 0V451.7c-16-8.2-32-14.3-48-18.7-80-22.1-160-1.7-240 18.7-96 24.5-192 48.9-288 0V113.1zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112 43-112 96-112 96 50.1 96 112m-128-64v32h16v64h-24v32h80v-32h-24v-96h-32z" })
  }
), MD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 112c0 35.3-28.7 64-64 64v160c35.3 0 64 28.7 64 64h352c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64zM0 64h576v384H0V112zm176 192a112 112 0 1 1 224 0 112 112 0 1 1-224 0m80-64v32h16v64h-24v32h80v-32h-24v-96h-32z" })
  }
), xD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m276.1 405.2 5.6-1.4c72.9-18.6 158.2-40.4 246.2-20.2V91.8c-69.1-24.1-140.4-7.4-228.1 15l-5.6 1.4c-72.9 18.6-158.1 40.4-246.2 20.2v291.8c69.1 24.1 140.4 7.4 228.1-15zM0 60.3C16 68.5 32 74.6 48 79c80 22.1 160 1.7 240-18.7 96-24.5 192-48.9 288 0V451.7c-16-8.2-32-14.3-48-18.7-80-22.1-160-1.7-240 18.7-96 24.5-192 48.9-288 0V113.1zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96" })
  }
), HD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h480V112zM0 64h576v384H0V112zm288 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), VD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 176v-64H160v16c0 35.3-28.7 64-64 64H80v93.5l-29.3 29.2L32 333.5V64h480V0h24l104 88-104 88zm48 144v-93.5l29.3-29.3 18.7-18.7V448H128v64h-24L0 424l104-88h24v64h352v-16c0-35.3 28.7-64 64-64zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), CD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0v48h78.1L286.7 159.3l-95.1-81.5-15.7-13.5-15.6 13.6-120 104 31.4 36.3 104.4-90.5 96.3 82.5 16.9 14.5L305 209 432 82v78h48V0H344zM103.5 304h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49c28.9-3.6 51.9-26.6 55.5-55.5M48 256H0v256h512V256h-48zm208 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), LD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m276.1 405.2 5.6-1.4c55.2-14.1 117.5-30 182.8-28.1 4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9-49.9-1.8-103.1 11.1-164.1 26.6l-5.6 1.4c-55.2 14.1-117.5 30-182.8 28.1-4.1 31.5-31 55.8-63.5 55.8v176c35.3 0 63.9 28.6 64 63.9 49.9 1.8 103.1-11.1 164.1-26.6zM0 60.3C16 68.5 32 74.6 48 79c80 22.1 160 1.7 240-18.7 96-24.5 192-48.9 288 0V451.7c-16-8.2-32-14.3-48-18.7-80-22.1-160-1.7-240 18.7-96 24.5-192 48.9-288 0V113.1zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96" })
  }
), BD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0h-16v16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80M56 16H32v48h96V16h-24zM24 88H0v48h160V88h-24zm8 72v48h96v-48H56zM272 0v16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80zm128 0h-16v16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80m80 128h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm-128 0c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80v-16zm-96 0h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5zM48 256H0v256h512V256h-48zm208 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), uD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 112c0 35.3-28.7 64-64 64v160c35.3 0 64 28.7 64 64h352c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64zM0 64h576v384H0V112zm288 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), RD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 80v256H144V80zM144 32H96v352h544V32h-48zm304 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0M48 120V96H0v384h544v-48H48z" })
  }
), $D = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80c0 35.3 28.7 64 64 64v128c-35.3 0-64 28.7-64 64H208c0-35.3-28.7-64-64-64V144c35.3 0 64-28.7 64-64zM144 32H96v352h544V32h-48zm304 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0M48 120V96H0v384h544v-48H48z" })
  }
), kD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112h480v108.4l36.4-36.4 11.6-11.6V64H0v384h326.6l4.4-30.6 17.4-17.4H48zm208 160v48h96v-48zm192-96H256v48h192zm-268-36h-40v26c-5.6 1.2-11 2.9-16 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 7 29.9 9.1V372h40v-25.5c5.4-1 10.6-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V140zm389 83.8-41.3 41.3 71 71 41.3-41.3zm-63.9 63.9L363.9 429 352 511.9l82.9-11.9 141.2-141.3z" })
  }
), PD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h480V112zM0 64h576v384H0V112zm480 208v48H256v-48zm-224-96h224v48H256zm-76-16v6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3-12.2-1.9-22.2-.3-28.6 2.6-6.3 2.9-7.9 6.2-8.2 8.1-.6 3.4 0 4.7.1 5 .3.5 1 1.8 3.6 3.5 6.1 4.2 15.7 7.2 29.9 11.4l.8.2c12.1 3.7 28.3 8.5 40.4 17.4 6.7 4.9 13 11.4 16.9 20.5 4 9.1 4.8 19.1 3 29.4-3.3 19-15.9 32-31.6 38.7-4.9 2.1-10.1 3.6-15.4 4.6V372h-40v-26.4c-9.5-2.2-22-6.4-29.9-9.1-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1 9.5 3.2 20.2 6.9 26.2 7.9 12.8 2 22.7.7 28.8-1.9 5.5-2.3 7.4-5.3 8-8.8.7-4 .1-5.9-.2-6.7-.4-.9-1.3-2.2-3.7-4-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16-6.6-4.5-13.2-10.7-17.3-19.5-4.2-9-5.2-18.8-3.4-29 3.2-18.3 16.2-30.9 31.1-37.7 5-2.3 10.4-4 16-5.1V140h40v20z" })
  }
), FD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 112H48v288h300.4L331 417.4l-4.4 30.6H0V64h576v108.4L564.4 184 528 220.4zM352 272v48H96v-48zM96 176h352v48H96zm473 47.8 71 71-41.3 41.3-71-71zm-63.9 63.9 71 71L434.9 500 352 511.9l11.9-82.9 141.2-141.2z" })
  }
), TD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h480V112zM0 64h576v384H0V112zm288 144v48H96v-48zm192 96v48H96v-48zm0-144v96H352v-96z" })
  }
), AD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0h616v192h-48V48H48v144H0V0zm440 400V96h48v416H128V96h48v304c35.3 0 64 28.7 64 64h160c0-35.3 28.7-64 64-64m-144-48c-53 0-96-35.8-96-80s43-80 96-80 96 35.8 96 80-43 80-96 80" })
  }
), DD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0h616v192h-48V48H48v144H0V0zm440 464V96h48v416H128V96h48v368zM320 352c-53 0-96-35.8-96-80s43-80 96-80 96 35.8 96 80-43 80-96 80" })
  }
), yD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v160h141.6l7 11.7 25.5 42.5 60.4-120.9 19.6-39.1 22.5 37.5 41 68.3H448v48H338.4l-7-11.7-25.5-42.5-60.4 120.9-19.6 39.1-22.5-37.5-41-68.3H48v144h480V80zM0 32h576v448H0V80z" })
  }
), bD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 416c0-86.2 48.7-161 120-198.4V274c-43.7 32-72 83.7-72 142v48h192v-24c0-39.8-32.2-72-72-72h-40v-48h40c27 0 51.9 8.9 72 24v-56h49.9L569 407l7 7v98h-48v-78.1l-80-80V464h32v48H152C68.1 512 0 443.9 0 360V0h224v192H96v-48h80V48H48v312c0 57.4 46.6 104 104 104h8zm288-160H312v-64.5c-31.6-3.9-56-30.9-56-63.5 0-35.3 28.6-64 64-64 15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64 0 32.6-24.4 59.6-56 63.5V256zM384 64c-26.5 0-48 21.5-48 48 0 23.8 17.3 43.5 40 47.3V208h80v-48.7c22.7-3.8 40-23.6 40-47.3 0-26.5-21.5-48-48-48h-64zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), fD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M141.2 118.7 95.5 432H47L96 96l62.1-62.1L192 0l33.9 33.9L288 96l49 336h-48.5l-45.7-313.3L192 67.9zM344 512H0v-48h384v48h-24zM144 336v-48h96v48z" })
  }
), UD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.6 41.2c-20.2-6-41.5-9.2-63.6-9.2-10.6 0-21 .7-31.1 2.1-103.9 14.5-185 100.2-192.4 206.2 17.4 1.4 33.6 7.1 47.5 16v-.3c0-61.1 31.1-114.9 78.4-146.5-19.6 34.8-30.7 74.9-30.7 117.7 0 86.2 45.4 161.9 113.6 204.2-44.5-3.7-84.3-24-113.2-54.6v63c36.3 25.3 80.4 40.2 128 40.2 28.3 0 55.3-5.2 80.2-14.8 10.7-4.1 21.1-9 31-14.7 17.9-10.3 34.3-22.9 48.6-37.6-15.5 4.1-31.8 6.2-48.6 6.2-12.6 0-25-1.2-36.9-3.6-88.1-17.3-154.6-95.1-154.6-188.4 0-58.9 26.4-111.6 68.1-146.8 4-3.4 8.1-6.6 12.3-9.6C499.1 57.1 520.6 47 543.8 41zM64 416h256v-64h-.4c.3-2.6.4-5.3.4-8 0-39.8-32.2-72-72-72-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64H64c-35.3 0-64 28.7-64 64v64h64z" })
  }
), GD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 57.1-62.9-33.9L150 0l-14.1 46.9-20.5 68.4-68.5 20.6L0 150l23.2 43.1L57.1 256l-33.9 62.9L0 362l46.9 14.1 68.4 20.5 20.5 68.4 14.2 47 43.1-23.2 62.9-33.9 62.9 33.9L362 512l14.1-46.9 20.5-68.4 68.4-20.5 47-14.2-23.2-43.1-33.9-62.9 33.9-62.9L512 150l-46.9-14.1-68.4-20.5-20.6-68.5L362 0l-43.1 23.2L256 57.1zm77 13.1 17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2-12.3 22.7 12.3 22.8 29.1 54.2-59 17.7-24.8 7.4-7.4 24.8-17.7 59-54.2-29.2-22.7-12.3-22.8 12.3-54.2 29.1-17.7-59-7.4-24.8-24.8-7.4L70.2 333l29.2-54.2 12.2-22.8-12.2-22.8L70.2 179l59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2 22.7 12.3 22.8-12.3zM368 256a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-76.9 53.5c-31.8-10.5-54.7-40.1-54.7-75.1 0-15.4 4.4-29.8 12.1-41.9 2.5-.3 4.9-.4 7.5-.4 35.3 0 64 28.7 64 64 0 22.4-11.5 42.1-28.9 53.5z" })
  }
), qD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 64 48 16-48 16-16 48-16-48-48-16 48-16 16-48zm120 136 72 24-72 24-24 72-24-72-72-24 72-24 24-72zm-248-72c21 0 41.2 3.4 60.2 9.6-21.5 8.3-40.5 21.6-55.6 38.5-22.8 25.4-36.6 59.1-36.6 95.9 0 78 62 141.5 139.4 143.9 1.5 0 3.1.1 4.6.1 22 0 42.9-4.9 61.6-13.8-11.1 23.4-26.8 44.1-45.8 61.1C285.8 493.6 241 512 192 512 86 512 0 426 0 320c0-100.8 77.6-183.4 176.3-191.4 5.2-.4 10.4-.6 15.7-.6M48 320c0 79.5 64.5 144 144 144 18.3 0 35.8-3.4 51.8-9.6C167.3 429.1 112 357 112 272c0-29.4 6.6-57.3 18.4-82.2C81.7 212.9 48 262.5 48 320" })
  }
), WD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M287.6 41.2c-20.2-6-41.5-9.2-63.6-9.2-10.6 0-21 .7-31.1 2.1C83.9 49.3 0 142.9 0 256c0 123.7 100.3 224 224 224 28.3 0 55.3-5.2 80.2-14.8 10.7-4.1 21.1-9 31-14.7 17.9-10.3 34.3-22.9 48.6-37.6-15.5 4.1-31.8 6.2-48.6 6.2-12.6 0-25-1.2-36.9-3.6-88.1-17.3-154.6-95.1-154.6-188.4 0-58.9 26.4-111.6 68.1-146.8 4-3.4 8.1-6.6 12.3-9.6C243 57.1 264.5 47 287.7 41zm-161.2 68.3c-19.6 34.8-30.7 74.9-30.7 117.7 0 86.2 45.4 161.9 113.6 204.2C118.9 423.9 48 348.2 48 256c0-61.1 31.1-114.9 78.4-146.5" })
  }
), ED = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 32h105.1l5.6 16.1 15.6 44.8L512 64h32v96h-32l-41.7-20.8 29.7 85.2c4-.3 8-.4 12-.4 43.7 0 83.3 17.5 112.1 45.8L590.5 304c-20.3-19.8-47.9-32-78.5-32-52.7 0-97 36.5-108.9 85.6-2 8.4-3.1 17.3-3.1 26.4H256c0 53-43 96-96 96s-96-43-96-96H0v-64c0-70.7 57.3-128 128-128h128v144h103.3c14.5-46 49.1-83.1 93.6-100.7L398.9 80H328zm-72 80v48H96v-48zm-48 224v-96h-80c-44.2 0-80 35.8-80 80v16zm-48 96c26.5 0 48-21.5 48-48h-96c0 26.5 21.5 48 48 48m352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), OD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M252.3 160 469.5 0l40.6 47.2L397.3 160zM480 256c0 63.2-25.4 116.1-73.4 150.3-12.6 9-26.7 16.6-42.3 22.9 6.8 10.3 11.6 22.1 14.7 34.8.4 1.6.8 3.2 1.1 4.8 2.8 13.5 4 28 4 43.2H128c0-15.2 1.2-29.7 4-43.2.3-1.6.7-3.2 1.1-4.8 3.1-12.7 7.9-24.5 14.7-34.8-15.6-6.2-29.8-13.9-42.3-22.9C57.4 372.1 32 319.2 32 256v-16H0v-48h512v48h-32zM324.2 455.6l-32.5-49.2 54.8-21.8C402.6 362.2 432 317 432 256v-16H80v16c0 61 29.4 106.2 85.6 128.6l54.8 21.8-32.5 49.2c-1.6 2.4-3.1 5.2-4.4 8.4h145.1c-1.3-3.1-2.8-5.9-4.4-8.4z" })
  }
), ID = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m400 0 19.2 25.6c17.9 23.8 39.8 40.5 66.4 56.3 12.8 7.6 26.4 14.9 41.2 22.8l2 1.1c15.4 8.2 31.9 17.1 48.9 27.3 30.1 18 46.2 50.7 46.2 84 0 20.2-5.8 39-15.9 54.9h32v240H0V148.7C0 104.3 20.5 62.3 55.6 35l25.7-20L96 3.6l14.7 11.5 25.7 20c26.8 20.8 45.1 50.2 52.2 82.7-22.6 19.6-36.9 46.1-42.3 74.3H48V464h112V272h31.9c-10-15.9-15.9-34.7-15.9-54.9 0-33.3 16.1-66 46.2-84 17-10.2 33.5-19 48.9-27.3l2-1.1c14.8-7.9 28.3-15.2 41.2-22.8 26.6-15.8 48.5-32.5 66.4-56.3zM208 464h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48v-50c0-19 8.4-37 23-49.2l25-20.8 25 20.8c14.6 12.2 23 30.2 23 49.2v50h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V320H208zM48.1 144h95.8c-1.4-27.9-14.8-53.9-36.9-71.1l-11-8.5-10.9 8.5c-22.2 17.2-35.6 43.2-37 71.1zM576 217.1c0-18.2-8.8-34.3-22.8-42.8-16-9.5-31.5-17.9-47-26.2l-2.4-1.3c-14.5-7.7-29-15.5-42.8-23.7-21.6-12.9-42.4-27.4-61.1-46.4-18.7 19-39.4 33.5-61.1 46.4-13.8 8.2-28.3 16-42.8 23.7l-2.4 1.3c-15.4 8.2-31 16.6-47 26.2-14.1 8.4-22.8 24.5-22.8 42.8 0 30.3 24.6 54.9 54.9 54.9H521.1c30.3 0 54.9-24.6 54.9-54.9" })
  }
), ND = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 242.2v23.1l-59.3 59.3-4.7 4.7V380.2l-30.3 60.6-7.2 14.3 28.6 14.3 7.2-14.3 32-64 1.7-3.4v-45.1l32-32v82h64v-82l32 32v-45.2l-32-32v-23.2l32 27.9V256h32v-32h163c-11.7-9.9-26.3-16.5-42.4-18.5l-159.9-23.9 49.6-41.3 8.4-7-3.5-10.4-13.8-41.3L414 30.2l7.8-14-28-15.6-7.8 14-32 57.6-3.4 6.2 2.2 6.7 12.5 37.6-45.3 37.8v-54.6h-23.8V55.5h-16.3V105.9h-23.8v54.6l-45.4-37.8 12.5-37.6 2.2-6.7-3.4-6.2-32-57.6-7.8-14-28 15.5 7.8 14 28.6 51.4-13.8 41.3-3.5 10.4 8.4 7 49.6 41.3-159.9 24C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6zM105.2 310C84.1 331.2 48 316.2 48 286.3c0-16.9 12.6-31.1 29.4-33.2.4 0 .8-.1 1.1-.2l111.2-16.6-82 71.4c-.8.7-1.6 1.5-2.4 2.3zM528 256h-32v32h-48v-32h-32v32h-32v32h32v48h-32v32h32v48h-32v32h32v32h32v-32h48v32h32v-32h48v32h32v-32h32v-32h-32v-48h32v-32h-32v-48h32v-32h-32v-32h-32v32h-48v-16zm0 64h48v48h-48zm0 80h48v48h-48zm-80-80h48v48h-48zm0 80h48v48h-48z" })
  }
), XD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 266v.2l-67 87-5 6.5v61.7l-40.4 37.9-17.5 16.4 32.9 35 17.5-16.4 48-45.1 7.6-7.1V376l24-31.2v94.9h64v-95L376 376V442.1l7.6 7.1 48 45.1 17.5 16.4 32.9-35-17.5-16.4-40.5-37.9v-61.7l-5-6.5-67-87v-.2l133.4 121.8c57 59.8 154.6 17.4 154.6-67.2 0-47.9-34-88.3-79.4-94.2l-153-23.9 41.4-41.4 13-13-9.1-15.9-23.4-40.8 36.3-40.1 16.1-17.8-35.6-32.2-16.1 17.8-48 53L370.5 85l8.6 15.1 22.9 40-50 50.2v-70.1h-24V56h-16v64.2h-24v70.1l-50.1-50.1 22.9-40 8.7-15.2-11.7-12.9-48-53-16.1-17.8-35.6 32.2 16.1 17.8 36.3 40.1-23.3 40.8-9.1 15.9 13 13 41.3 41.4-153 23.9C34 232.4 0 272.8 0 320.6c0 84.6 97.6 127 154.6 67.1zm-168.1 88.6c-13.6 14.2-30.4 16-44.9 9.7-14.8-6.4-27-21.4-27-43.7 0-25.5 17.8-44 37.6-46.6.4-.1.8-.1 1.2-.2l146.6-23-111.1 101.5c-.8.7-1.6 1.5-2.4 2.3zm286.7-103.7 146.6 22.9c.4.1.8.1 1.2.2 19.7 2.6 37.6 21.1 37.6 46.6 0 22.3-12.2 37.3-27 43.7-14.5 6.3-31.3 4.5-44.9-9.7-.8-.8-1.6-1.6-2.4-2.3z" })
  }
), KD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M456 32h-8.7l-6.7 5.6-49 41.1-18.5-34.1-6.8-12.6H256v48h81.7l16.4 30.3-95.2 80c-35.8-29-81.3-46.3-130.9-46.3H32v48h96c88.4 0 160 71.6 160 160v32h64v-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6l-55.1-102H512V32h-24zm-63.4 149.6c-32 22.5-57.4 53.7-72.6 90.2-7.1-17-16.4-32.8-27.5-47.2l84.9-71.3 15.3 28.2zM432 352c0-21.7 8.6-41.3 22.6-55.7l36.3 67.1 11.4 21.1 42.2-22.8-11.4-21.1-36.3-67.1c4.9-.9 10-1.4 15.2-1.4 44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80zm-227.7-24h-55.1c-5.6-5-13.1-8-21.2-8-17.7 0-32 14.3-32 32s14.3 32 32 32c8.1 0 15.5-3 21.2-8h55.2c-10.2 32.5-40.5 56-76.3 56-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM128 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256" })
  }
), QD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M491.2 368H84.8l99-165c22-36.6 61.5-59 104.2-59s82.3 22.4 104.2 59zm56 0L433.4 178.3C402.7 127.2 347.6 96 288 96s-114.7 31.2-145.4 82.3L28.8 368 0 416h576z" })
  }
), ZD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0h-24v144.4l48 76.8V48h128v192h128v264h48V192h-48V96h-48v96h-32V0h-24zm120 336v-64h-64v.4l39.7 63.6zM368 80v64h64V80zm64 96h-64v64h64zm128 96h-64v64h64zm-64 96v64h64v-64zm-16 144-30-48-181.7-290.7L240 128l-28.3 45.3L30 464 0 512H423.4zm-86.6-48H86.6l60.8-97.3 25.9 32.3 18.3 22.9 18.8-22.4 39.8-47.5h73.2zM240 218.6l53.4 85.4h-65.6l-7.2 8.6-28.2 33.6-18.1-22.6 65.6-105z" })
  }
), JD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160M48 454.8v9.2h416v-9.2L256 149.3zm179-348.2L256 64l29 42.6 127.5 187.3 38.7-58.4L480 192l28.8 43.5L640 433.7V512H0v-72l227-333.4zM512 440v24h80v-15.8L480 279l-38.3 57.8z" })
  }
), jD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432v-9.2l106.5-156.5 34.5 44.4 19.3 24.8 18.9-25.1L268 256h82.4L464 422.8v9.2zm269.8-224H244l-7.2 9.6-29.1 38.9-24.7-31.8 73-107.4zM256 32l-29 42.6L0 408v72h512v-72L285 74.6z" })
  }
), YD = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432v-9.2l208-305.5 208 305.5v9.2zM256 32l-29 42.6L0 408v72h640v-78.3L480 160l-67.5 101.9L285 74.6z" })
  }
), _D = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.4 50.8c4.5-1.8 9.4-2.8 14.6-2.8 22.1 0 40 17.9 40 40 0 8.1-2.4 15.6-6.5 21.9-10.4-5.3-21.7-9.1-33.6-11.4-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0c-57.4 0-104 46.6-104 104v3.2c0 20.8 6.2 40.6 17.2 57.3C143.1 182 88 248.6 88 328v40H72c-39.8 0-72 32.2-72 72s32.2 72 72 72h408v-48H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h344v-48h-71.8l32-80H512v-63.7c0-32.6-12.2-62.4-32.4-85.1zM292.6 368H136v-40c0-66.3 53.7-120 120-120h24l9.5-46.1-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5V104c0-30.9 25.1-56 56-56s56 25.1 56 56v38.2l22.2 1.7 8 .6c41.7 3.2 73.9 38 73.9 79.8V240H343.8l-6 15.1zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40" })
  }
), hy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v416H48V48zM48 0H0v512h384V0h-48zm144 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192M304 80H80v112h224z" })
  }
), cy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0v24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136v24h-48v-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24V0zM48 240v224h288V240zM0 192h400c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16v96H0V240zm384 176h16c35.3 0 64-28.7 64-64s-28.7-64-64-64h-16zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136v24h-48v-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24V0h48z" })
  }
), sy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m226.7 32-73.4 73.4-22.6 22.6H32V32zM176 128l96-96 96 96zm-24 80v80h-48v-80H48v224h288V208zM0 160h400c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16v96H0V208zm384 176h16c35.3 0 64-28.7 64-64s-28.7-64-64-64h-16z" })
  }
), vy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 80v256H144V80zM144 32H96v352h384v-96h32c70.7 0 128-57.3 128-128S582.7 32 512 32h-80zm368 208h-32V80h32c44.2 0 80 35.8 80 80s-35.8 80-80 80M24 432H0v48h576v-48h-24z" })
  }
), ey = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v256h288V80H248v24l40 40v112H176V144l40-40V80zM96 32h416c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32v96H96V80zm384 208h32c44.2 0 80-35.8 80-80s-35.8-80-80-80h-32zM24 432h552v48H0v-48z" })
  }
), ly = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 112v24l-40 40v112h112V176l-40-40v-24h184v288H80V112zM80 64H32v384h384V320h32c70.7 0 128-57.3 128-128S518.7 64 448 64h-80zm368 208h-32V112h32c44.2 0 80 35.8 80 80s-35.8 80-80 80" })
  }
), ty = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 112v288h288V112zM32 64h416c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32v128H32V112zm384 208h32c44.2 0 80-35.8 80-80s-35.8-80-80-80h-32z" })
  }
), wy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 272C16 139.5 123.5 32 256 32s240 107.5 240 240v48H16v-24zm130.2-157.5C96.5 149.2 64 206.8 64 272h384c0-18.7-2.7-36.8-7.7-53.9-8.5 13.2-23.4 21.9-40.3 21.9-26.5 0-48-21.5-48-48 0-26.2 21-47.5 47.1-48-25-28-58.2-48.6-95.8-58.1.4 3.3.6 6.7.6 10.1 0 44.2-35.8 80-80 80-37.8 0-69.5-26.2-77.8-61.5zM179.7 352h48.6L216 432h80.1l-12.3-80h48.6l12.3 80 7.4 48H160l7.4-48 12.3-80zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), gy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 213.2 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L352 250.5v-53.6L512 160V0l-48 11.1L304 48v160zm48 160.1-48-37.8v30.8c-18.1-9-40.2-14.3-64-14.3-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80zm0-245.3V86.2l112-25.9v61.5l-112 25.9zm-60.7 286.5c11.3 8.1 12.7 14.9 12.7 17.5s-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5c-11.3-8.1-12.7-14.9-12.7-17.5s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5" })
  }
), iy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 128V86.2l112-25.9v61.5l-112 25.9zm-48 80v158.3c-18.1-9-40.2-14.3-64-14.3-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80V196.9L384 160V0l-48 11.1L176 48v110.7zm-12.7 206.5c11.3 8.1 12.7 14.9 12.7 17.5s-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5" })
  }
), my = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 32V-.3L545.1 9l-320 96-17.1 5.1V138.7L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-60.8-47.2c10-12.6 15.9-27.8 15.9-44.1V144zm-54 350.5-57.7-44.8c4.7-1.1 9.9-1.7 15.7-1.7 35.1 0 48 22.1 48 32 0 3.7-1.8 9.2-6 14.5m-100.5-78L332.1 235 528 176.3v122.4c-14.1-6.8-30.5-10.7-48-10.7-22 0-42.2 6.2-58.4 16.5zm-136-105.6L256 176v-30.1l272-81.6v61.9zM256 297.7l-48-37.8v102.8c-14.1-6.8-30.5-10.7-48-10.7-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80zM208 432c0 9.9-12.9 32-48 32s-48-22.2-48-32 12.9-32 48-32 48 22.1 48 32" })
  }
), ay = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512-.3V368c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c17.5 0 33.9 3.9 48 10.7V176.3l-272 81.6V432c0 44.2-43 80-96 80S0 476.2 0 432s43-80 96-80c17.5 0 33.9 3.9 48 10.7V110.1l17.1-5.1 320-96L512-.3zM464 368c0-9.8-12.9-32-48-32s-48 22.2-48 32 12.9 32 48 32 48-22.1 48-32M96 400c-35.1 0-48 22.2-48 32s12.9 32 48 32 48-22.1 48-32c0-9.8-12.9-32-48-32m96-192.3 272-81.6V64.3l-272 81.6v61.9z" })
  }
), oy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.8 112h97.9l6.7 5.6 32.6 27.2 32.6-27.2 6.7-5.6h97.9l6.8 6.2 68.3 61.5 73.7-33.5 34-15.5V202c0 109.4-88.6 198-198 198-42.8 0-84.5-13.9-118.8-39.6L320 358l-3.2 2.4c-34.3 25.7-76 39.6-118.8 39.6C88.6 400 0 311.4 0 202v-71.3l33.9 15.4 73.7 33.5 68.3-61.5 6.8-6.2zm18.4 48L128 225.8l-11.7 10.5-14.3-6.5-54-24.5C49.8 286.6 116.3 352 198 352c32.5 0 64-10.5 90-30l17.6-13.2L320 298l14.4 10.8L352 322c26 19.5 57.5 30 90 30 81.7 0 148.2-65.4 150-146.7l-54 24.6-14.3 6.5-11.7-10.5-73.2-65.9h-62.1l-41.3 34.4-15.4 12.8-15.4-12.8-41.3-34.4z" })
  }
), ny = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 56V32h35.2l7.2 8.6L336 390.1V32h48v448h-35.2l-7.2-8.6L48 121.9V480H0v-24z" })
  }
), ry = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 32H64v224H0v48h64v176h48V304h114.7l107.9 165.1 7.1 10.9H384V304h64v-48h-64V32h-48v224h-83.3L113.4 42.9 106.3 32h-13zm196 272h52v79.5zm-88.7-48H112V128.5z" })
  }
), dy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M587.4 210.5C619.9 242.4 640 286.9 640 336c0 97.2-78.8 176-176 176H232c-54.1 0-102-26.9-130.9-68-15.4-21.9-25.5-47.9-28.3-76-.5-5.3-.8-10.6-.8-16v-92L0 224V96l96 48 96-48v128l-72 36v108l1-.8 47-37 155.2-122.3c39.4-31 88-47.9 138.2-47.9h2.6c16.6 0 32.6 2.3 47.9 6.6L640 0zM232 464h232c70.7 0 128-57.3 128-128s-57.3-128-128-128h-2.6c-39.4 0-77.6 13.2-108.5 37.6L149.7 405.7l-10.8 8.5c20.1 30 54.3 49.8 93.1 49.8m264-184a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Sy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112v112H80zm112-61.1c-11.9 24.4-35.8 41.9-64 44.7-.1 16.5 6.1 33.1 18.7 45.6 25 25 65.5 25 90.5 0 12.6-12.6 18.8-29.1 18.7-45.6-28.2-2.8-52.1-20.3-64-44.7zM288 512s48-80 48-128v-32c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 48 48 128 48 128zm104-160c-2.7 0-5.4-.1-8-.4-.1 20.6 7.7 41.2 23.4 57 31.2 31.2 81.9 31.2 113.1 0 15.7-15.7 23.5-36.4 23.4-57-2.6.3-5.3.4-8 .4-31.7 0-59-18.4-72-45.1-13 26.7-40.3 45.1-72 45.1zM250.7 512H48S0 464 0 384c0-44.4 20.2-84.4 37.9-119.4 1.5-2.9 2.9-5.8 4.3-8.6H336c-10.8 14.3-19.2 30.5-24.7 48H71.9c-14 28.9-23.9 54-23.9 80 0 30.2 9 54.3 18.1 71 1.8 3.3 3.6 6.3 5.3 9h206c-3.7 7.5-7.2 14.2-10.1 19.4-2.1 3.9-3.9 7-5.1 9.1-.6 1-1.1 1.8-1.4 2.4l-.3.6-.1.1z" })
  }
), zy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v96H240V48zM240 0h-48v192h104v40H0v48h136v40H32v192h256V320H184v-40h272v40H352v192h256V320H504v-40h136v-48H344v-40h104V0h-48zM80 368h160v96H80zm480 0v96H400v-96z" })
  }
), py = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0m152 174.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V512h48v-24z" })
  }
), My = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32h416v448H0V88h48v344h48V56zm48 400h320V80H144zm32-320h144v128H176zm200 0h56v48h-80v-48zm0 80h56v48h-80v-48zm-176 80h232v48H176v-48zm0 80h232v48H176v-48z" })
  }
), xy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h272v48H0V32h448v129.1c-17.7 2.5-34 9.2-48 18.9zm-32 56v78.3c-10.2 16.9-16 36.6-16 57.7v16h-32V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V112h168zM128 352h192v48H80V112h80v48h-32zm336-112c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H352V320h32z" })
  }
), Hy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h285.7c29 29.6 69.5 48 114.3 48H0V32h448v128c-16.7 0-32.8 2.6-48 7.3zm-32 56v45.4c-18.7 10.8-35.1 25.4-48 42.6v-64h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V112h168zm-58.6 264H80V112h80v48h-32v192h163.2c3.5 17.2 9.7 33.3 18.2 48m138.6.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426c-20.5 14-45.3 22.1-72 22.1z" })
  }
), Vy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v204.4l48-48V32H0v448h258l6.9-48H48zm320 236.4V112H200v102.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6V160h72v192H128V160h32v-48H80v288h204.4zm137-92.6-41.3 41.3 71 71 41.3-41.3zm-63.9 63.9L299.9 429 288 511.9l82.9-11.9 141.2-141.3z" })
  }
), Cy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h187.3c-4.5 15.5-7.7 31.5-9.5 48H0V32h448v199.1c-16.6 3.8-32.6 9-48 15.5zm-32 56v126.5c-17.2 10-33.3 21.6-48 34.8V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V112h168zM246.6 400H80V112h80v48h-32v192h144.5c-10.1 15.1-18.8 31.1-25.9 48M512 304c-114.9 0-208 93.1-208 208h-48c0-141.4 114.6-256 256-256zm-32 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-80 64h-48c0-88.4 71.6-160 160-160v48c-61.9 0-112 50.1-112 112" })
  }
), Ly = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-76.9-59.7V32H96v19.8l-47.6-37zM144 89v-9h352v282.3l-32-24.8V112H296v95l-60.6-47H256v-48h-80v1.9zm272 211.2-48.4-37.6c.3-2.2.4-4.4.4-6.6 0-17.8-9.7-33.3-24-41.6V160h72zM487.4 480l-60.9-48H144V209.5l-48-37.9V480h48zm-101.6-80-60.9-48H224v-79.5l-48-37.8V400h24z" })
  }
), By = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m141.6 26.4 13 12.1 189.7 176 17.6 16.3-32.6 35.2-17.6-16.3L135.6 86.2C82.7 123.4 48 186.4 48 256c0 75.9 41.3 144 102.3 179.2l-24 41.5C50.6 433 0 349.3 0 256S50.6 79 126.3 35.2l15.3-8.9zM464 256c0-75.9-41.3-143.9-102.3-179.2l24-41.5C461.4 79 512 162.7 512 256s-50.6 177-126.3 220.8l-15.3 8.9-13-12.1-189.7-176-17.6-16.3 32.6-35.2 17.6 16.3 176.1 163.4C429.3 388.6 464 325.6 464 256" })
  }
), uy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h330.2l3.4 48H0V32h448v128h-13.7l-16 32H400zm-48 112v96h15.9l.1 1.1V400H80V112h80v48h-32v192h192V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V112h168v80zm102.1 0H569.9l4.4 8.8 11.6 23.2H640v32H384v-32h54.1l11.6-23.2zM608 512H416l-16-224h224z" })
  }
), Ry = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm224 224c0-17.8-9.7-33.3-24-41.6V160h72v192H128V160h32v-48H80v288h288V112H200v102.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48" })
  }
), $y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M164.8 38.4 400 352v112h-86.1l-17-17-56-56-7-7H192c-35.3 0-64 28.7-64 64s28.7 64 64 64h256V336l-4.8-6.4-240-320zM214.1 432l32 32H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM141 303.5l23.5-5-10.1-46.9-23.5 5-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2 30.7-36.9-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8z" })
  }
), ky = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349.5 32h58l-3.7 5.5L331.4 144H432v48H298.8l-87 128H432v48H179.1l-76.2 112h-58l9.5-14 66.6-98H16v-48h137.7l87-128H16v-48h257.4z" })
  }
), Py = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h384v512H0V24zm48 421.8L162.8 256 48 90.2zM77.2 464h229.6L192 298.2zm144-208L336 421.8V90.2zm85.6-208H77.2L192 213.8z" })
  }
), Fy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v240H288v112H48V80zM48 480h272l128-128V32H0v448zm144-352v64h-64v64h64v64h64v-64h64v-64h-64v-64z" })
  }
), Ty = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h240V320h112V80zm240 400H0V32h448v320L320 480z" })
  }
), Ay = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v240H288v112H48V80zM48 480h272l128-128V32H0v448zm80-352H80v48h48zM80 232v48h48v-48zm48 104H80v48h48z" })
  }
), Dy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 48h192v416H240zm-48 0v416h-80v-48h48v-48h-48v-88h48v-48h-48v-88h48V96h-48V48zM64 416v96h416V0H64v96H0v48h64v88H0v48h64v88H0v48h24z" })
  }
), yy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 416H96V32h384v288l-96 96zm220.1-48 67.9-67.9V80H144v288zM320 128v64h64v64h-64v64h-64v-64h-64v-64h64v-64zm-24 336h24v48H0V128h48v336z" })
  }
), by = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 416H96V32h384v288l-96 96zm288-128V80H144v288h208v-80zM320 464v48H0V128h48v336h248z" })
  }
), fy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352m224 176a224 224 0 1 1-448 0 224 224 0 1 1 448 0" })
  }
), Uy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h256v80h48V0H0v352h128v-48H48zm112 336v128h352V160H384v48h80v256H208v-80zm96-32h96v-64h-48v16h-48zm96-144v-48h-64v48h16v48h48zM224 352v-48h-16v-48h-48v96h48zm-64-144v16h48v-16h48v-48h-96z" })
  }
), Gy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 128h16v256H32v96h96v-16h320v16h96v-96h-16V128h16V32h-96v16H128V32H32v32zm64 288V96h384v320zm32-288v160h192V128zm128 192v64h192V224h-96v96h-32z" })
  }
), qy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 48H48v48H0V0h96zm32 0V0h96v48zM0 128h48v96H0zm352 32v192H160V160h144zM160 416h48v48h48v48h-96v-48zM352 48v48h-48V48h-48V0h96zm64 160v-48h96v96h-48v-48zM96 304v48H0v-96h48v48zm192 160h96v48h-96zm176 48h-48v-48h48v-48h48v96zm48-128h-48v-96h48zM208 208v96h96v-96z" })
  }
), Wy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h48V0H0v96h48zm176 0V0h-96v48zM48 128H0v96h48zm0 128H0v96h96v-48H48zm80 96h96v-48h-96zm32 32v128h352V160H384v48h80v256H208v-80zm192-176v-80h-48v96h48zm0-160V0h-96v48h48v48h48zm-96 256v48h96v-96h-48v48z" })
  }
), Ey = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v32h32V48zM0 0h128v40h192V0h128v128h-40v96h40v128H320v-40H128v40H0V224h40v-96H0V48zm88 128v96h40v40h192v-40h40v-96h-40V88H128v40zm-8 144H48v32h32zM400 48h-32v32h32zm-32 224v32h32v-32zm224 160h-32v32h32zm-40-48v-96h-40v-40h-32v-48h32v-40h128v128h-40v96h40v128H512v-40H320v40H192V384h40v-32h48v32h40v40h192v-40zm8-176v32h32v-32zM272 432h-32v32h32z" })
  }
), Oy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 352h48v160h352V160H352V0H0v352h48zm-64-48V48h256v160h160v256H208V304h-48z" })
  }
), Iy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 512H0v-48h512zM176 336V48h-64v288zm-64 48H64V0h160v384h-48zm288-48V176h-64v160zm-64 48h-48V128h160v256h-48z" })
  }
), Ny = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 176H80v-64h352zm48-64V64H280V0h-48v64H32v160h200v64H96v160h136v64h48v-64h136V288H280v-64h200v-48zM368 400H144v-64h224z" })
  }
), Xy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 80v352h64V80zM64 32h160v200h64V96h160v136h64v48h-64v136H288V280h-64v200H64V280H0v-48h64V80zm272 112v224h64V144z" })
  }
), Ky = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 512V0h48v512zm176-336h288v-64H176zm-48-64V64h384v160H128v-48zm48 288h160v-64H176zm-48-64v-48h256v160H128v-48z" })
  }
), Qy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 512V0h-48v512zM336 176H48v-64h288zm48-64V64H0v160h384v-48zm-48 288H176v-64h160zm48-64v-48H128v160h256v-48z" })
  }
), Zy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0H0v48h512zM176 176v288h-64V176zm-64-48H64v384h160V128h-48zm288 48v160h-64V176zm-64-48h-48v256h160V128h-48z" })
  }
), Jy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v160h96V80zM0 32h192v256H0V80zm304 240v160h96V272zm-48-48h192v256H256V272zM144 368H48v64h96zm-96-48h144v160H0V320zM304 80v64h96V80zm-48-48h192v160H256V80z" })
  }
), jy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm209 209 17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), Yy = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm128 128h-64v64h64zM168 232h-24v48h224v-48h-24zm56 88v64h64v-64z" })
  }
), _y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm120 128h-48v160h48V152zm-48 192v48h48v-48z" })
  }
), hb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm24 232h-24v48h192v-48h-24z" })
  }
), cb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm72 368h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), sb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 332.1V179.9L179.9 48h152.2L464 179.9v152.2L332.1 464H179.9zM160 0 0 160v192l160 160h192l160-160V160L352 0zm193.9 192L320 158.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), vb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M179.9 464h152.2L464 332.1V179.9L332.1 48H179.9L48 179.9v152.2zM0 160 160 0h192l160 160v192L352 512H160L0 352z" })
  }
), eb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 112h-72v48h104l64 32 155.3-31.1 2.6-.5 2-.4 32 32L432 416H96v-69.3L0 304V160h232v-48h-72V64h192zM96 208H48v64.8l48 21.3zm345.3 34.3-14.7-7.4-53.9-26.9H144v160h267.1l136.4-147-90.1 18-16.2 3.2zM592 448c-26.5 0-48-21.5-48-48 0-32 48-96 48-96s48 64 48 96-21.5 48-48 48" })
  }
), lb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 112h72V64H160v48h72v48H0v144l96 42.7V416h336l208-224-32-32-2 .4-2.6.5L448 192l-64-32H280zM48 208h48v86.1l-48-21.3zm378.5 26.9 14.7 7.4 16.2-3.2 90.1-18L411.1 368H144V208h228.7l53.9 26.9z" })
  }
), tb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264 0h120v48h-72v48h72v48h-72v83.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V24zm24 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-151.4-32.9c11.8 6.7 25.8 12.8 40.3 15.4 2.4 18.2 9.1 35 19.1 49.4-1.3 0-2.7.1-4.1.1-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7C59.7 355.8 31.5 368 0 368v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9zM288 416h.2l.5.4c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.8 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.5-.4h.2zm111.1-97.4c14.5-2.7 28.4-8.7 40.3-15.4 15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.8 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1-1.3 0-2.7 0-4-.1 10-14.4 16.7-31.2 19.1-49.4z" })
  }
), wb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-46.4 12.4-12.4-46.4-23.1-86.3-335.3 87V464h44.1L198 294.3l55.6-14.4-24.5 72.1H315l-27.6-80.8 46.6-12.1L404 464h172v48H0v-48h48V160h48v70.9l135.7-35.2 17.6-51.5 5.5-16.2h34.3l5.5 16.2 11 32.3 113.1-29.3-22.3-83.7L384 17.1l46.4-12.4zM353.2 464l-21.9-64H212.7l-21.9 64z" })
  }
), gb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64S48 0 128 0c60.2 0 102.3 36.3 119.4 54.2L357.8 2.3C361 .8 364.5 0 368 0h272v48H373.4l-181.5 85.4C189.1 219.3 118.6 288 32 288H0v-32c0-61.4 34.5-114.6 85.2-141.5C31.2 100.4 0 64 0 64m399.4 363c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37c-19.3 25.7-32.6 63.4-32.6 107s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37M336 512c-79.5 0-144-86-144-192s64.5-192 144-192 144 86 144 192-64.5 192-144 192m129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1 3.6.8 7.1 1.5 10.5 2 31.1 4.6 55-3.6 70.2-19.3 15.4-16 23.9-42.1 19.2-76-4.7-33.8-22.2-71.6-53.2-103.7-18-18.7-37.7-32.5-57.2-41.7-4.9-8.8-10.3-17.2-16.2-25-10.5-14-22.7-26.5-36.2-36.9 48.2 1.6 101.3 25.8 144.2 70.3 75 77.8 90.2 188.1 33.9 246.4-34.1 35.4-86.8 43.5-139.6 27z" })
  }
), ib = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 432c-61.9 0-112-50.1-112-112 0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9 8.5 5.7 15.7 11.4 20.8 15.8 2.5 2.1 4.4 3.9 5.6 5l1.2 1.2.1.1.1.1 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6 4.3 5 10.1 12.2 15.8 20.8 12.3 18.5 19.8 36.7 19.8 50.3 0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432M0 320c0 88.4 71.6 160 160 160 192 0 288-181.9 288-280 0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320m271.1-111.1c30.3 30.3 87.8 21.9 87.8 21.9s8.4-57.5-21.9-87.8-87.8-21.9-87.8-21.9-8.4 57.5 21.9 87.8z" })
  }
), mb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m368 0-32 32 32 32 32-32zm24 200h-9.9l-7 7-57 57h-86.4c10.3-16.2 16.3-35.4 16.3-56 0-57.4-46.6-104-104-104-23.4 0-45 7.7-62.4 20.8l28.8 38.4c9.4-7 21-11.2 33.6-11.2 30.9 0 56 25.1 56 56s-25.1 56-56 56H88l24 48h44c42 0 76 34 76 76 0 41.5-33.2 75.2-74.5 76C47.5 462.6 16 368 16 368S.3 509.6 156 512h4v-.1c66.6-2.1 120-56.8 120-123.9 0-28.6-9.7-55-26-76h83.9l7-7 57-57H424c22.1 0 40 17.9 40 40v112c0 17.7-14.3 32-32 32-64 0-80-48-80-48v48s0 48 80 48c44.2 0 80-35.8 80-80V288c0-48.6-39.4-88-88-88zm88-88V64s-66.5 32-112 32-112-32-112-32 16 80 120 80c72 0 104-32 104-32" })
  }
), ab = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80c-97.2 0-176 78.8-176 176 0 66.6 36.9 124.5 91.5 154.5l12.5 6.8V480H0v-48h85.4C33.4 391 0 327.4 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176H448v48H296v-62.7l12.5-6.8c54.6-30 91.5-87.9 91.5-154.5 0-97.2-78.8-176-176-176" })
  }
), ob = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.5 120.8c-.4.8-.8 1.8-1.4 3-1.5 3.2-3.6 7.9-6.2 13.7-5.1 11.7-12 28.2-18.9 46.9-13.9 38.1-27 83.8-27 119.5 0 32.5 9.2 60.2 18.5 79.8 3.8 8.1 7.6 14.7 10.8 19.7 17.4 5.8 36.1 9.6 55.3 11.4C194.2 389.7 184 354.2 184 312c0-61.9 6.1-128.6 12.1-179.6 1.7-14.3 3.4-27.5 5-38.9l-2.4-4.8c-7.5 11.9-16.1 22.6-25.2 32.2zm55.1 9.3c-.2 2-.5 4-.7 6-6 50.5-11.9 115.8-11.9 175.9 0 37.9 9.4 69.8 18.8 92.2 1.7 4 3.3 7.7 4.9 11 21.3-1.7 41.9-5.9 61-12.4 3.3-4.4 7.1-10.2 11-17.2 9.9-17.9 19.7-43.2 19.7-73.6 0-37.1-15.8-88.6-32.6-132.5-8.3-21.6-16.6-40.7-22.8-54.5-.8-1.8-1.6-3.5-2.3-5.1-8.7-9.4-17-19.7-24.3-31.3l-20.7 41.5zm100.2 38.4c16.8 43.9 34.6 100.1 34.6 143.5 0 25.2-5.5 47.4-12.6 65.7 31.3-22.5 49.2-52.4 49.2-89.7 0-56.7-28-84.2-70.4-118.8-.3-.2-.5-.4-.8-.7M102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5.6-1.5 1.1-3.1 1.7-4.6-.1.1-.2.1-.3.2C76 203.8 48 231.3 48 288c0 37.7 18.2 67.7 50 90.2 1.5 1.1 3.1 2.1 4.6 3.2M276.7 34c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80-57.5 134.7-130.9 160l9.2 23.1 8.9 22.3-44.6 17.8-8.9-22.3-11.6-29.1c-7.3 1.2-14.7 2.2-22.1 2.9V512h-48v-49.3c-7.4-.7-14.8-1.6-22.1-2.9l-11.6 29.1-8.9 22.3-44.6-17.8 8.9-22.3 9.2-23.1C57.5 422.7 0 368 0 288c0-84.5 49-124.3 95.3-162 32.9-26.7 64.4-52.4 76-92 1.6-5.5 2.8-11.3 3.6-17.5.7-5.3 1-10.8 1-16.5H208l13.8 27.7L224 32l2.2-4.3L240 0h32c0 5.8.4 11.3 1 16.5.8 6.1 2 11.9 3.6 17.5z" })
  }
), nb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 64h11l7.2 8.4L475 400h165v48H453l-7.2-8.4L165 112H0V64h24zm440 0h24v48H416V64h24z" })
  }
), rb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64zm-96 32V64c0-35.3 28.7-64 64-64s64 28.7 64 64v32h32v57.7c57.4 33.2 96 95.2 96 166.3 0 106-86 192-192 192S0 426 0 320c0-71.1 38.6-133.1 96-166.3V96zM84.7 224h214.6c-26.3-29.5-64.7-48-107.3-48s-81 18.5-107.3 48m-28.5 48c-5.3 15-8.2 31.2-8.2 48s2.9 33 8.2 48h271.6c5.3-15 8.2-31.2 8.2-48s-2.9-33-8.2-48H56.2zm28.5 144c26.4 29.5 64.7 48 107.3 48s81-18.5 107.3-48H84.7z" })
  }
), db = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m131.6 182.7-3.6-2.4V144h64v36.3l-3.6 2.4-7.5 5 7.9 5.9L208 208h48v-64c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64v64h48l19.2-14.4 7.9-5.9zm118 73.3H192l-32-24-32 24H92.1c9.9 28 36.6 48 67.9 48h88v32h104v-9.9l7-7 15-15h-46c-34.2 0-63.8-19.5-78.4-48zm166.4 0v-80h118.1c-6.4-31-28.9-57-59.8-67.3l-17.9-6 12.5-46.3 16.2 3.4c90.3 19.1 154.9 98.7 154.9 191 0 120.3-92.6 218.9-210.4 228.5-4.5.5-9 .8-13.6.8H257.6C133.5 480 32.9 379.9 32 256H16V144H0V96h26.8c18-37.8 56.5-64 101.2-64h64c44.7 0 83.2 26.2 101.2 64H320v48h-16v32h80v48h-72v28.7c4.9 2.1 10.3 3.3 16 3.3zM99.7 335.8l.1.2h.3l-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5 35.6-4.4 63.1-34.7 63.1-71.5V224h-24v57.9l-7 7-57 57V384H136.2c31.8 29.8 74.5 48 121.4 48H384zM536 360c0 8.2-.8 16.3-2.4 24 35.9-33.1 58.4-80.6 58.4-133.3 0-16.7-2.8-32.8-8-47.9v5.2c0 35.5-19.3 66.6-48 83.2zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32m112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), Sb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 40h448v48H0zm192 128h256v48H192zm24 128h232v48H192v-48zM0 424h448v48H0zm128-72L0 256l128-96z" })
  }
), zb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm80 224c0-77 57.6-112 57.6-112h172.8S368 179 368 256s-57.6 112-57.6 112H137.6S80 333 80 256m96-48v-16h-32v80h32v-16zm128 0v-16h-32v80h32v-16zm-104 88v24h48v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), pb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v112H48V48zm0 160v256H48V208zM48 0H0v512h448V0h-48zm80 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 112H80v192h288zm-224 48h176v32H128v-32z" })
  }
), Mb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h448V32h-24zm200 80c-97.2 0-176 78.8-176 176v16c0 97.2 78.8 176 176 176s176-78.8 176-176v-16c0-97.2-78.8-176-176-176M96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 374.7 96 304z" })
  }
), xb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 288h120c57.4 0 104-46.6 104-104S225.4 80 168 80H48zm0 48v144H0V32h168c83.9 0 152 68.1 152 152s-68.1 152-152 152z" })
  }
), Hb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 131.9V464H48V48h204.1zm48-19.9L272 0H0v512h384v-48zM96 224v32l96 96 96-96v-32z" })
  }
), Vb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 131.9V464H48V48h204.1zm48-19.9L272 0H0v512h384v-48zM96 320h192v-32l-96-96-96 96z" })
  }
), Cb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h288V131.9L252.1 48H48zM272 0l112 112v400H0V0h48z" })
  }
), Lb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h416V112zM0 64h512v384H0V112zm96 96h320v96H96zm96 144v48H96v-48zm32 48v-48h96v48z" })
  }
), Bb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 48H48v96h320zM48 0h368v192H0V0zm200 320h40v192H160V320h40v-88h264V120h-16V72h64v208H248z" })
  }
), ub = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m493.8 18.2-17-17-17 17-255.5 255.5c-6.6-1.1-13.4-1.7-20.3-1.7-66.3 0-120 53.7-120 120v72H0v48h184c66.3 0 120-53.7 120-120 0-6.9-.6-13.7-1.7-20.3l255.5-255.5 17-17-17-17-64-64zM210.5 325l40.5 40.5c3.3 8.2 5 17.2 5 26.5 0 39.8-32.2 72-72 72h-72v-72c0-39.8 32.2-72 72-72 9.4 0 18.3 1.8 26.5 5m125.7-55.3-30.1-30.1L476.8 69.1l30.1 30.1-170.6 170.6z" })
  }
), Rb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m193.9 33.9 94.8 94.8-33.9 33.9-32.8-32.8-60.1 60.1 32.8 32.8-9.2 9.2H184c-14.7 0-28.9 2-42.3 5.7l-75.8-75.7L32 128l33.9-33.9L126 34l34-34zm219.3 287.2 33.9-33.9L512 352l21.8 109 10.2 51-51-10.2L384 480l-45.7-45.7c3.7-13.5 5.7-27.7 5.7-42.3v-1.7l9.1-9.1 54.6 54.6 75.1 15-15-75.1-54.6-54.6zM476.8 1.3l17 17 64 64 17 17-17 17-255.5 255.4c1.1 6.6 1.7 13.4 1.7 20.3 0 66.3-53.7 120-120 120H0v-48h64v-72c0-66.3 53.7-120 120-120 6.9 0 13.7.6 20.3 1.7L459.8 18.2l17-17zM184 320c-39.8 0-72 32.2-72 72v72h72c39.8 0 72-32.2 72-72 0-9.4-1.8-18.3-5-26.5L210.5 325c-8.2-3.3-17.2-5-26.5-5M506.9 99.2l-30.1-30.1-170.6 170.6 30.1 30.1L506.9 99.2" })
  }
), $b = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M274.5 216 505.9 61.8l8.3 8.4L360 301.5zm-75.4 105.6 55.4 55.4c1 4.9 1.6 9.9 1.6 15.1 0 39.8-32.2 72-72 72H112V392c0-39.8 32.2-72 72-72 5.2 0 10.2.5 15.1 1.6M512 0 224 192l-32 80 .3.3c-2.7-.2-5.5-.3-8.3-.3-66.3 0-120 53.7-120 120v72H0v48h184c66.3 0 120-53.7 120-120 0-2.8-.1-5.5-.3-8.3l.3.3 80-32L576 64z" })
  }
), kb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256v16H355.9c-64 0-115.9 51.9-115.9 115.9 0 20.2 5.3 39.9 15.1 57.2l-18.1 18C131 453.5 48 364.5 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208M320 448l-12.1-12.1c-12.7-12.7-19.9-30-19.9-48 0-37.5 30.4-67.9 67.9-67.9H512v-64C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256l30.1-30.1zm-64-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-64 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m224-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Pb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48h-80v96l-64-48-64 48V48h-80v192h288zm0-48h48v288H128V0h256zM0 320h640v48h-64v96h64v48H0v-48h64v-96H0zm112 144h184v-96H112zm232 0h184v-96H344z" })
  }
), Fb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48H112v160h160zM112 0h208v256H64V0zm416 112h-96v96h96zm-96-48h144v192H384V64zM0 320h640v48h-64v96h64v48H0v-48h64v-96H0zm112 144h184v-96H112zm232 0h184v-96H344z" })
  }
), Tb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 320H0v48h64v96H0v48h640v-48h-64v-96h64v-48H64zm88 48h184v96H112zm232 0h184v96H344z" })
  }
), Ab = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512M48 160H0v192h48V184zm592 24v-24h-48v192h48v-24zm-395.7 16L216 171.7l-14.1 14.1-32 32-14.2 14.2 28.3 28.3 14.1-14.1 32-32zm75.7 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-209.4-80 8-8-22.6-22.6-11.3 11.3-8 8-8 8-11.3 11.3 22.6 22.6 8-8 16 16V376c0 30.9 25.1 56 56 56s56-25.1 56-56-25.1-56-56-56h-33.4zM448 192l-96 96 10.6 10.6c13.7 13.7 32.4 21.4 51.8 21.4h4.1c14 0 27.6-4.8 38.5-13.5 14.6-11.7 23.1-29.4 23.1-48.1v-4.8c0-19-7.5-37.2-21-50.6l-11-11zM320 80c-39.8 0-72 32.2-72 72v8h144v-8c0-39.8-32.2-72-72-72" })
  }
), Db = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 224a176 176 0 1 0-352 0 176 176 0 1 0 352 0m-35.2 174.3C326.3 429.4 277.3 448 224 448 100.3 448 0 347.7 0 224S100.3 0 224 0s224 100.3 224 224c0 33.4-7.3 65.1-20.4 93.6l140.3 90.7L487.2 512zM504 424a16 16 0 1 0-32 0 16 16 0 1 0 32 0M254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4a63.69 63.69 0 0 1 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5-8.9 6.6-18.9 10.5-29.2 12-18.6 2.6-42.2 16.3-51.6 32.6-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6 1.3-14.9 7.8-29.4 19.4-40.5 25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), yb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 160c123.7 0 224-28.7 224-64S379.7 32 256 32 32 60.7 32 96c0 17.4 24.4 33.2 64 44.8V288h48V151.4c19.6 3.2 41.2 5.7 64 7.1V240h48v-24zm-64-96h128v32H192zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40 10.9-11.4 16.9-24.7 16.9-40s-6-28.6-16.9-40c10.9-11.4 16.9-24.7 16.9-40s-6-28.6-16.9-40c10.9-11.4 16.9-24.7 16.9-40 0-8.8-2-16.9-5.7-24.3-6.3 12.4-16.9 21.6-26 27.8-15.3 10.2-35.3 18.3-57.1 24.5-8.2 2.3-17 4.5-26.2 6.5-29.9 7.1-67 11.5-109 12.9v48.1c66.1-2.2 124.4-11.4 164.9-28.5 2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4-32.9 11.1-79.2 18-133.7 19.9v.5H176v44.5c25.2 2.3 52.1 3.5 80 3.5 79.2 0 150-9.2 196.9-29 2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4C70.7 325 59 317.9 53 312.2c-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9 1.6.7 3.2 1.3 4.9 2v-53c-4.8-2.8-8.5-5.5-11.1-7.9-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9 1.6.7 3.2 1.3 4.9 2v-49.3zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4C70.7 405 59 397.8 53 392.2c-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9z" })
  }
), bb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v246.7C76.3 307 96 335.2 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h-32v-96h96v96h-32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-14.2-6.2-27-16-35.8V464h416V48zM0 0h512v512H0V48zm112 96h112v32H96V96zm192 0h112v32H288V96zm-192 64h112v32H96v-32zm192 0h112v32H288v-32zm112 96v160H288V256z" })
  }
), fb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h257.3c8.1 17.6 18.7 33.8 31.4 48H0V32h448v87c-16.5 13.4-32.6 27.1-48 41.5zM293.8 312H264v-48h48v4.5c-7.7 13.9-14 28.5-18.2 43.5m48-88H96v-96h256v83.3c-3.5 4.2-6.9 8.4-10.3 12.7zM232 264v48h-48v-48zm-80 0v48h-48v-48zm361-39.9c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160 128-192 128-192 32.6 26.4 65 64zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), Ub = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v448h53.5c84.8-30.3 176.9-40 266.5-40s181.7 9.7 266.5 40H640V32h-53.5c-84.8 30.3-177 40-266.5 40S138.3 62.3 53.5 32H48zm48 48.9c88.7 29.8 182.9 39.1 272 39.1s183.3-9.3 272-39.1v350.2c-21.9-7.4-44.2-13.5-66.7-18.6l-1.7-2.4-136-192-19.6-27.6-19.6 27.6L267 333l-31.7-43.2-19.3-26.4-19.4 26.4-88 120-3.7 5c-19.2 4.6-38.2 10-57 16.3V80.9zM176 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Gb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M137.9 280h218.8L78.3 419.2zm218.7-48H137.9L78.3 92.8 356.7 232zm101.7-2.8L64 32H0l20.6 48L96 256 20.6 432 0 480h64l394.3-197.2L512 256z" })
  }
), qb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 288 55.6 23.8L192 370.3V496l48 16 73.3-89.7 88.9 38.1L448 480l6.6-49.4 49.5-371.1L512 0l-52.4 29.4-406.9 229zm408.8 123-140.4-60.2 176.5-210.6zm-186.5-79.9-114-48.9 293.2-165z" })
  }
), Wb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108v236c0 39.8-32.2 72-72 72s-72-32.2-72-72V128h48v216c0 13.3 10.7 24 24 24s24-10.7 24-24V108c0-33.1-26.9-60-60-60s-60 26.9-60 60v260c0 53 43 96 96 96s96-43 96-96V128h48v240c0 79.5-64.5 144-144 144S48 447.5 48 368z" })
  }
), Eb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M375 73c-26-26-68.1-26-94.1 0L89 265c-43.7 43.6-43.7 114.4 0 158s114.4 43.6 158.1 0L399 271l17-17 33.9 34-17 17L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39c44.7-44.7 117.2-44.7 162 0s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2-23.8-29.8-21.5-72.8 5.5-99.8L271 127l17-17 33.9 34-17 17-151.7 151.7c-9.7 9.7-10.6 25.1-2 35.8 10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z" })
  }
), Ob = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M383.5 192c.3-5.3.5-10.6.5-16 0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4.2 10.7.5 16H232v128h-34.4L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9 0-64 22.2-121.2 57.1-159.3C50.3 53.5 8.3 142.1 0 192h38l122 157.8V512h192V349.8L474 192h38c-8.3-49.9-50.3-138.5-153.1-175.3C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L314.4 320H280V192zM208 368h96v96h-96z" })
  }
), Ib = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48h48V0H144C82.1 0 32 50.1 32 112s50.1 112 112 112h32v96h48V48h32v272h48v-24zm-128 0v128h-32c-35.3 0-64-28.7-64-64s28.7-64 64-64h24zm-54.5 325.2 18-15.9-31.8-36-18 15.9L20.9 398 .6 416 21 434l68.8 60.8 18 15.9 31.8-36-18-15.9-21.4-18.8H384v-48H100.2l21.3-18.8z" })
  }
), Nb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 192c0-88.4 71.6-160 160-160h256v48h-64v400h-48V80h-48v400h-48V352h-48c-88.4 0-160-71.6-160-160m208 112V80h-48c-61.9 0-112 50.1-112 112s50.1 112 112 112z" })
  }
), Xb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M70.3 309.8 309.8 70.3c-67-37.5-153.3-27.7-210.3 29.3S32.8 242.9 70.2 309.9zM65.6 65.6c75.8-75.8 192.5-85.9 279.2-30.3 13.3 8.5 25.9 18.6 37.6 30.3l-33.9 33.9-249 249-33.9 33.9c-11.6-11.7-21.7-24.3-30.3-37.6-55.6-86.7-45.5-203.4 30.3-279.2zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64M96 480a32 32 0 1 1-64 0 32 32 0 1 1 64 0m280-329.9 17 17 8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3-5.3 47.7-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201l-17-17zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4-47.7 5.3-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393l-17-17 34-33.9 17 17zm268.7 144.5-8.5-10a79.026 79.026 0 0 1-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8.2-7.6-2.4-15-7.3-20.7l-8.5-10-15.5-18.3 36.6-31 15.5 18.3 8.5 10c12.5 14.8 19.1 33.7 18.6 53-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8-.2 7.6 2.4 15 7.3 20.7l8.5 10z" })
  }
), Kb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M150.1 136l17-17 8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4 47.7 5.3-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153l-17 17zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3 5.3 47.7-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345l-17 17-33.9-34 17-17zM503.5 42.3l-10 8.5a79.026 79.026 0 0 1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2-7.6-.2-15 2.4-20.7 7.3l-10 8.5-18.3 15.5-31-36.6 18.3-15.5 10-8.5c14.8-12.5 33.7-19.1 53-18.6 16.6.4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2 7.6.2 15-2.4 20.7-7.3l10-8.5 31 36.6zM63.9 448.1l79.4-30.9-48.5-48.5zM234 381.9l-104-104-16.3 41.9 78.4 78.4zm-141-141 19-48.9 37.1 37.1 133.8 133.8L320 400l-48.9 19L32 512 0 480z" })
  }
), Qb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 48v416H48V48zM48 0H0v512h448V0h-48zm48 384v32h256v-32H112zm33.3-160h39.1c1.6 30.4 7.7 53.8 14.6 70.8-27.9-13.2-48.4-39.4-53.7-70.8m94.7 80h-.3c-2.4-3.5-5.7-8.9-9.1-16.5-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5-3.4 7.6-6.7 13-9.1 16.5h-.3zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8 6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32h-39.1c-1.6-30.4-7.7-53.8-14.6-70.8 27.9 13.2 48.4 39.4 53.7 70.8M224 112h.3c2.4 3.5 5.7 8.9 9.1 16.5 6 13.6 12.4 34.3 14.2 63.5h-47.1c1.8-29.2 8.1-49.9 14.2-63.5 3.4-7.6 6.7-13 9.1-16.5h.3zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8-6.8 17.1-12.9 40.4-14.6 70.8zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256" })
  }
), Zb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96v48h80V96h160V48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H0v400h160v-48H48V96zm64-40a16 16 0 1 1 32 0 16 16 0 1 1-32 0m96 408V176h144v80h80v208zm192-336H192v384h320V208z" })
  }
), Jb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h48V112zM0 64h144v384H0V112zm224 48v288h48V112zm-48-48h144v384H176V112z" })
  }
), jb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 0 53.1 58.4c17.3 19 26.9 43.9 26.9 69.6.2 11.3-1.5 23.2-5.5 35.1-14.3 42.9-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8c8.2-24.7 24.2-43.8 42.5-53.6zm-93.5 124.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.1 0-25.7 9.6-50.6 26.9-69.6L184 0v71.2c18.3 9.8 34.3 28.9 42.5 53.6zM100.4 230.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240v-3.2c0-13.5 4.3-26.7 12.2-37.6L64 128v68.8c13.9 6.1 27.1 17.8 36.4 33.7zM256 414.5l11.6 2.9 125.3 31.3c-10.1-42.6-29.8-74.7-51.7-97.7-33.4-35-69.6-47-85.2-47s-51.8 12-85.2 47.1c-21.9 23-41.6 55.1-51.7 97.7l125.3-31.3 11.6-2.9zm-143.8 85.4L64 512c0-17.8 1.3-34.6 3.7-50.4C89.2 320.7 198.5 256 256 256s166.8 64.7 188.3 205.6c2.4 15.8 3.7 32.6 3.7 50.4l-48.2-12.1L256 464l-143.8 35.9m309.6-185.2c-24.5-14-29.1-51.7-10.2-84.1 9.3-15.9 22.4-27.6 36.4-33.7V128l51.8 71.2c8 10.9 12.2 24.1 12.2 37.6v3.2c.1 13.3-3.7 27.8-11.6 41.4-18.9 32.4-54 47.3-78.5 33.3z" })
  }
), Yb = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-52.5 244.5 10.1-18.2 54.6-98.3h39.5l54.6 98.3 10.1 18.2 20.2 5c22.6 5.7 39.3 26.2 39.3 50.5 0 28.7-23.3 52-52 52-12.9 0-24.7-4.7-33.8-12.5L268.7 408h-89.4l-13.5 11.5C156.7 427.3 145 432 132 432c-28.7 0-52-23.3-52-52 0-24.3 16.7-44.8 39.3-50.5zM176 160l-68.3 123C64.2 293.8 32 333.2 32 380c0 55.2 44.8 100 100 100 24.8 0 47.5-9 65-24h54c17.5 15 40.2 24 65 24 55.2 0 100-44.8 100-100 0-46.8-32.2-86.2-75.7-97L272 160zm128-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96m144 64a48 48 0 1 0-96 0 48 48 0 1 0 96 0M48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), _b = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M193.9 189.7c32.3-10.6 46.9-53.9 32.6-96.8s-52.1-69.1-84.4-58.6-46.9 53.9-32.6 96.8 52.1 69.1 84.4 58.5zm217.7 8.9c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3 14.3-70.1-10.2-84.1-59.7.9-78.5 33.3zm-311.3 0c-18.9-32.4-54-47.3-78.5-33.3S-7.3 217 11.6 249.4s54 47.3 78.5 33.3 29.1-51.7 10.2-84.1M277.5 92.9c-14.3 42.9.3 86.2 32.6 96.8s70.1-15.6 84.4-58.5-.3-86.2-32.6-96.8-70.1 15.6-84.4 58.5m-9.9 292.6-11.6-3-11.6 2.9-125.3 31.4c10.1-42.6 29.8-74.7 51.7-97.7C204.2 284 240.4 272 256 272s51.8 12 85.2 47.1c21.9 23 41.6 55.1 51.7 97.7l-125.3-31.4zM64 480l48.2-12.1L256 432l143.8 35.9L448 480c0-17.8-1.3-34.6-3.7-50.4C422.8 288.7 313.5 224 256 224S89.2 288.7 67.7 429.6C65.3 445.4 64 462.2 64 480" })
  }
), hf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 462.6v-156l-120.7 98.8c32 31 74 51.9 120.7 57.2zM80.9 368.3 232 244.6V49.4C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3m319.8 37.1L280 306.6v156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6v195.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), cf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 280c0-66.3-53.7-120-120-120S48 213.7 48 280c0 48.1 42.1 93.7 105 132 29.2 17.8 58.8 31.5 81.3 40.7 8.5 3.5 15.9 6.3 21.7 8.5 5.8-2.1 13.2-5 21.7-8.5 22.5-9.3 52.1-22.9 81.3-40.7 62.9-38.3 105-83.9 105-132 0-66.3-53.7-120-120-120-17.4 0-33.9 3.7-48.8 10.3C320.6 199.7 336 238.1 336 280zM151.6 112.8C118.3 93.4 96 57.3 96 16V0h48c61.9 0 112 50.1 112 112C256 50.1 306.1 0 368 0h48v16c0 41.3-22.3 77.4-55.6 96.8C445.5 121 512 192.7 512 280c0 152-256 232-256 232S0 432 0 280c0-87.3 66.5-159 151.6-167.2" })
  }
), sf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 148c0 40.6-16.4 77.4-42.9 104.2l-.9.9c-14.1 14-30.3 24.6-47.6 31.7-9.5 4-19.6 6.9-30 8.8-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30-7.1 17.1-17.5 33.2-31.3 47.2-.5.6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512H0V364c0-20.1 4-39.2 11.2-56.7 7.2-17.5 17.9-33.8 32.1-48 14.2-14.2 30.6-24.9 48.1-32.1 9.5-4 19.6-6.9 30-8.8 24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30 7.2-17.4 17.8-33.6 31.9-47.8l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0h148v48zM148 464c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4.8-.7 1.1-1.1 9.4-9.5 16.4-20.4 21.1-31.9 2.7-6.4 4.7-13.2 5.9-20.2l.1-.4.1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1.4-.1c7-1.3 13.8-3.3 20.2-5.9 11.6-4.8 22.6-11.9 32.2-21.4l.6-.6c18-18.1 29-42.9 29-70.4V48H364c-13.6 0-26.5 2.7-38.3 7.6-11.7 4.8-22.7 12-32.3 21.6l-.3.3c-9.6 9.6-16.7 20.6-21.5 32.2-2.7 6.4-4.7 13.2-5.9 20.2l-.1.4-.1.4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4.1-.4.1c-7 1.3-13.8 3.3-20.2 5.9-11.8 4.9-22.8 12.1-32.5 21.8-9.7 9.7-16.9 20.7-21.7 32.4-4.9 11.8-7.6 24.7-7.6 38.3v100zm224.8-328a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m83.2-19.2a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4M372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0M200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4" })
  }
), vf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M306.9 139.9c-.9-12.6-4-25.3-9.4-37.5L251.9 0 149.4 45.6c-13.9 6.2-25.9 14.8-35.7 25.2-9.8 10.3-17.8 22.7-23.3 36.9l-.2.4c-5.4 14.1-7.7 28.6-7.3 42.9.2 7.8 1.2 15.7 3.1 23.5 4.2 18.4 6.4 37.9-.4 55.5s-21.4 30.6-36.8 41.5c-6.6 4.5-12.7 9.7-18 15.3-9.9 10.4-17.9 22.8-23.4 37C2 338-.3 352.6 0 366.9c.4 14.3 3.5 28.8 9.7 42.7L55.3 512 96 493.9V364c0-48.6 18.3-92.9 52.7-127.3 26.5-26.5 59-43.2 94.7-49.8 22.9-4.6 39.5-10.9 50-21.5 5.5-5.5 9.7-13.5 13.4-25.6zm290.2 112.3C623.6 225.4 640 188.6 640 148V0H492c-20.1 0-39.2 4-56.7 11.2-17.4 7.2-33.7 17.8-47.8 32l-.4.4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8-17.5 7.2-33.9 17.9-48.1 32.1-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364v148h148c40.5 0 77.1-16.2 103.8-42.5l1.7-1.7c13.8-14 24.2-30.1 31.3-47.2 4-9.5 6.9-19.6 8.8-30 4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8 17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zM176 464V364c0-13.6 2.7-26.5 7.6-38.3 4.9-11.7 12.1-22.8 21.7-32.4 9.7-9.7 20.7-16.9 32.5-21.7 6.4-2.7 13.2-4.7 20.2-5.9l.4-.1.4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4.1-.4c1.3-7 3.3-13.8 5.9-20.2 4.8-11.7 12-22.6 21.5-32.2l.3-.3c9.6-9.6 20.6-16.8 32.3-21.6 11.8-5 24.7-7.7 38.3-7.7h100v100c0 27.5-11 52.3-29 70.4l-.6.6c-9.6 9.5-20.5 16.6-32.2 21.4-6.4 2.7-13.2 4.7-20.2 5.9l-.4.1-.4.1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1.4-.1.4c-1.3 7-3.3 13.8-5.9 20.2-4.8 11.5-11.8 22.3-21.1 31.9l-.7.7-.4.4 32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464zm344-308.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m83.2-19.2a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0M520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4M347.2 328a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0" })
  }
), ef = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 48C212.8 48 48 212.8 48 416v48h48c203.2 0 368-164.8 368-368V48zm0-48h96v96c0 229.8-186.2 416-416 416H0v-96C0 186.2 186.2 0 416 0M256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112M88 368a56 56 0 1 1 112 0 56 56 0 1 1-112 0M368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), lf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m510.7 35.2-17 17L457.9 88c33.9 49.8 28.8 118.3-15.4 162.5l-58.8 58.8c.2 3.5.3 7.1.3 10.7 0 106-86 192-192 192S0 426 0 320s86-192 192-192c3.6 0 7.2.1 10.7.3l58.8-58.8C305.7 25.3 374.1 20.2 424 54.1l35.9-35.9 17-17 33.9 33.9zM367 111l22-22c-30.2-15.7-68.2-10.9-93.6 14.4l-58.8 58.8-15.2 15.2-21.4-1.2c-2.7-.1-5.3-.2-8.1-.2-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-2.7-.1-5.4-.2-8.1l-1.2-21.4 15.2-15.2 58.8-58.8c25.3-25.3 30.1-63.4 14.4-93.6l-22 22-17 17-33.8-33.9 17-17zM256 320h32c0 53-43 96-96 96v-32c35.3 0 64-28.7 64-64" })
  }
), tf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 48H80v384H32V0h384v432h-48zM24 464h424v48H0v-48zm96-352a24 24 0 1 1 48 0 24 24 0 1 1-48 0m184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), wf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v88h48v-88c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-17.3 46.1-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h149.4l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2l51.8 15.2V512h144V327.8c19.8-22.6 32-52.3 32-85.5v-.3l10.7 10.7 15.1-6.7 72-32 14.3-6.3v-107l-4-6L540.8 48H560V0H440c-68.3 0-126.1 45.1-145.3 107.1L164.5 27.5 128 5.2V48c0 80 35.9 134 71.6 167.5 17.7 16.6 35.4 28.2 48.6 35.7 6.7 3.7 12.3 6.5 16.3 8.3 2 .9 3.7 1.6 4.9 2.1.6.2 1.1.4 1.4.6l.5.2.2.1h.1l8.5-22.5c8.5-22.5 8.4-22.5 8.4-22.5l-.7-.3c-.7-.3-1.8-.8-3.3-1.4-3-1.3-7.3-3.5-12.7-6.5-10.7-6-25.1-15.4-39.4-28.8-20.9-19.5-41.6-47.5-51.1-86.4l102.2 62.4 5.8 3.5h44.9l2.6-21C343.2 87.7 387 48 440 48h43.2l44.8 67.3v61.1l-42.7 19L457 167l-7-7h-42v46.5l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4 0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1V464h-48V326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6l-88-25.7-31.4-9.2.7 32.7v1.3c0 8-1.4 16-4.3 23.5l-15.7 42-2.7 7.3 2.1 7.5 17.5 63.4h-49.8l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9 0-17.4 7-33.3 18.2-44.8-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), gf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m144 32 108.7-108.7 80 80L224 368l-96 16zm256-96-44.7 44.7-80-80L320 112z" })
  }
), mf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M409.1 294.9 463 241l34-34 45.1-45.1L576 128l-33.9-33.9-29.7-29.7-.4-.4-.4-.4-29.7-29.7L448 0l-33.9 33.9L369 79l-48-48-17-17-17 17-95.2 95.2L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zm-179-139 73.9-74 31 31-70 70-34.9-27.1zm73.1 56.8 65.8-65.8 60.1 60.1-58.2 58.2-67.7-52.5M340 364l-38-29.9-101.7 101.7-75.1 15 15-75.1 94.6-94.7-38-29.9L96 352 74.2 461 64 512l51-10.2L224 480l116.1-116.1z" })
  }
), af = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M10.2 461 0 512l51-10.2L160 480l239-239 34-34 45.1-45.1L512 128l-33.9-33.9-29.7-29.7-.4-.4-.4-.4-29.7-29.7L384 0l-33.9 33.9L305 79l-48-48-17-17-17 17-120 120-17 17 34 33.9 17-17 103-103 31 31L32 352zM305 146.9l60.1 60.1-228.8 228.8-75.1 15 15-75.1z" })
  }
), of = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m396.5 285.1 144.9-139.8L576 112l-33.9-33.9-44.2-44.2L464 0l-33.3 34.6L277.9 193 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM316 222.6 464.6 68.5l42.9 42.9-149.3 144zM128 272 64 480l32 32 208-64 32.3-80.7-39.3-31-29 72.6-113 34.7 43.7-43.6h1.3c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24v1.3L132.4 421l34.8-113 62.3-24.9-43.5-34.3z" })
  }
), nf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64 272 120-48L366.7 34.6 400 0l33.9 33.9L478 78l34 34-34.6 33.3L288 328l-48 120-208 64-32-32zm158.8-19.1 36.3 36.3 184.4-177.8-42.9-42.9zm-43.3 24.6L103.1 308 68.4 421l43.6-43.7V376c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24h-1.3L91 443.6l113-34.8 30.6-76.4-55-55z" })
  }
), rf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m458 137.9 44.1 44.1-108.4 108.4-50.4 6.3 6.3-50.4zm95 61.1 17-17 36.1-36.1L640 112l-33.9-33.9-44.2-44.2L528 0l-33.9 33.9L458 70l-17 17-17 17-120 120-9.9 78.9L288 352l49.1-6.1L416 336l120-120zm-17-50.9L491.9 104 528 67.9l44.1 44.1zM24 128H0v384h576V288h-48v176H48V176h240v-48h-24zm136 160H96v64h64zm32 0v64h64v-64z" })
  }
), df = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M10.2 461 0 512l51-10.2L160 480l318.1-318.1L512 128l-33.9-33.9-60.2-60.2L384 0l-33.9 33.9L32 352zm51-10.2 15-75.1 245.7-245.8L382 190 136.3 435.8l-75.1 15zM248 464h-24v48h352v-48h-24z" })
  }
), Sf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m446.7 324 174.2 135.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 164.4 127.6L352 96l62.1-62.1L448 0l33.9 33.9L542 94l34 34-33.9 33.9L480 224zM258.4 177.8l148.1 115 28-84 3.6-10.7L378 138l-10.8 3.6zM409 418.2 112 512l-48-48 80.3-254.3 40.3 31.8-58.7 186 102.8-102.8c-3-6.3-4.7-13.3-4.7-20.7 0-9.4 2.7-18.2 7.4-25.7l75 59.1c-8.7 9-20.9 14.6-34.4 14.6-7.4 0-14.4-1.7-20.7-4.7L148.5 450.1l214.9-67.9z" })
  }
), zf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m374.1 198.1-3.6 10.7-56.3 168.8-229.7 72.5 102.8-102.8c6.3 3 13.3 4.7 20.7 4.7 26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L61.9 427.5l72.5-229.7 168.8-56.3 10.7-3.6L374 198zM48 512l304-96 64-192 62.1-62.1L512 128l-33.9-33.9-60.2-60.2L384 0l-33.9 33.9L288 96 96 160 0 464z" })
  }
), pf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M42.2 461 32 512l51-10.2L192 480l318.1-318.1L544 128l-33.9-33.9-60.2-60.2L416 0l-33.9 33.9L64 352zm51-10.2 15-75.1 245.7-245.8L414 190 168.3 435.8l-75.1 15zM392 512h184v-48h-64v-72c0-50.5-31.2-93.7-75.3-111.4l-39.6 39.6C434.5 322.8 464 354 464 392v72h-72c-38.1 0-69.2-29.5-71.8-66.9l-39.6 39.6C298.3 480.8 341.5 512 392 512M116.2 18.2l-17-17-17 17-64 64-17 17 17 17 118.2 118.1 33.9-33.9L69.1 99.2l30.1-30.1 101.2 101.2 33.9-33.9L116.2 18.2z" })
  }
), Mf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m384 512 33.9-33.9L478 418l34-34-33.9-33.9-67.5-67.5-33.9 33.9 18.2 18.2-14.1 14.1-11.4 11.2 22.6 22.6 11.3-11.3 14.1-14.1 26.7 26.8-60.1 60.1-67.5-67.5-33.9 33.9 67.5 67.5zM229.5 101.5l-67.6-67.6L128 0 94.1 33.9 33.9 94.1 0 128l33.9 33.9 67.6 67.6 33.9-33.9L67.9 128 128 67.9l26.7 26.7-14.1 14.1-11.2 11.3 22.6 22.6 11.3-11.3 14.1-14.1 18.2 18.2 33.9-33.9zM10.2 461 0 512l51-10.2L160 480l318.1-318.1L512 128l-33.9-33.9-60.2-60.2L384 0l-33.9 33.9L32 352zm51-10.2 15-75.1 245.7-245.8L382 190 136.3 435.8l-75.1 15z" })
  }
), xf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64 512 51-10.2L224 480l116.1-116.1-38-29.9-101.8 101.8-75.1 15 15-75.1 94.6-94.7-38-29.9L96 352 74.2 461zm239.2-299.4 82.7-82.7L446 190l-75.1 75.1-67.7-52.5m105.9 82.2 133-132.9L576 128l-33.9-33.9-60.2-60.2L448 0l-33.9 33.9L265 183 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-211.8-164.4z" })
  }
), Hf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m330 137.9 44.1 44.1-108.4 108.4-50.4 6.3 6.3-50.4zm95 61.1 17-17 36.1-36.1L512 112l-33.9-33.9-44.2-44.2L400 0l-33.9 33.9L330 70l-17 17-17 17-120 120-9.9 78.9L160 352l49.1-6.1L288 336l120-120zm-17-50.9L363.9 104 400 67.9l44.1 44.1zM324.7 17.6C302.9 11.4 279.8 8 256 8 119 8 8 119 8 256s111 248 248 248h24v-48h-24c-110.5 0-200-89.5-200-200S145.5 56 256 56c9.7 0 19.3.7 28.7 2zm129.4 210.8c1.2 9 1.9 18.2 1.9 27.6 0 57.4-46.6 104-104 104h-24v48h24c83.9 0 152-68.1 152-152 0-23.6-3.3-46.4-9.4-68l-40.4 40.5z" })
  }
), Vf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m330 137.9 44.1 44.1-140.4 140.4-50.4 6.3 6.3-50.4zm95 61.1 17-17 36.1-36.1L512 112l-33.9-33.9-44.2-44.2L400 0l-33.9 33.9L330 70l-17 17-17 17-152 152-9.9 78.9L128 384l49.1-6.1L256 368l152-152zm-17-50.9L363.9 104 400 67.9l44.1 44.1zM24 64H0v448h448V288h-48v176H48V112h176V64h-24z" })
  }
), Cf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 512 10.2-51L32 352 350.1 33.9 384 0l33.9 33.9L478 94l34 34-33.9 33.9L160 480 51 501.8zm136.3-76.2 245.8-245.7L322 130 76.2 375.7l-15 75.1 75.1-15z" })
  }
), Lf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m488 136-16-16 40-40-80-80-40 40-16-16-33.9 33.9L317 83l-52-52-17-17-17 17-128 128-17 17 34 33.9 17-17 111-111 35 35L64 336 32 448 0 480l32 32 32-32 112-32 278.1-278.1zM183 373.1 138.9 329 376 91.9l44.1 44.1zm-34.9 33-59 16.9 16.9-59 42.2 42.2z" })
  }
), Bf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64 512 51-10.2L224 480l19.2-19.2.8.5 2.6-3.8 93.5-93.5-38-29.9-42.2 42.2-48.1-12-12-48.1 35-35.2-38-29.9-78.3 78.3-3.8 2.6.5.8L96 352 74.2 461zm345.1-217.1 133-133L576 128l-33.9-33.9-60.2-60.2L448 0l-33.9 33.9L265 183 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zm-38.2-29.7-67.7-52.5 82.7-82.7 60.1 60.1-75.1 75.1zM140.2 375.7l8.9-8.9 11.9-7.9 7.7 31 3.5 14 14 3.5 31 7.7-7.9 11.9-8.9 8.9-75.1 15 15-75.1z" })
  }
), uf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 512 10.2-51L32 352l19.2-19.2-.5-.8 3.8-2.6L350.1 33.9 384 0l33.9 33.9L478 94l34 34-33.9 33.9-295.6 295.6-2.6 3.8-.8-.5L160 480 51 501.8zm76.2-136.3-15 75.1 75.1-15 8.9-8.9 7.9-11.9-31-7.7-14-3.5-3.5-14-7.7-31-11.9 7.9-8.9 8.9zm305.9-185.6L322 130 135.8 316.1l12 48.1 48.1 12zm-66.7 28.7-96 96-11.4 11.3-22.6-22.6 11.3-11.3 96-96 11.3-11.4 22.6 22.6-11.3 11.3z" })
  }
), Rf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m14 144-4 96h30.8l39.6 39.6 47.6 47.6V512h-48V352h-32v160H64V352H24l2-48 6-144h192l1 23.8-16.6 16.6-29.5 29.5-.9-21.9zm370 280v-96.8l47.6-47.6 39.6-39.6H566l-4-96H462l-.9 21.9-29.5-29.5-16.6-16.6 1-23.8h192l6 144 2 48h-40v160h-48V352h-32v160h-48zm0-424a64 64 0 1 1 128 0 64 64 0 1 1-128 0M265 257l-23 23h156.1l-23-23-17-17 33.9-33.9 17 17 64 64 17 17-17 17-64 64-17 17-33.9-34.1 17-17 23-23H241.9l23 23 17 17-33.9 33.9-17-17-64-64-17-17 17-17 64-64 17-17 33.9 34.1-17 17z" })
  }
), $f = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M72 128H48v144.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L179.2 512h48.5l-19.9-139.4-1.4-9.5-7.6-5.9-30.8-24.3V263l10.8 20.3 2.5 4.7 4.3 3.2 32 24 6.4 4.8h192v-.1l6.3-4.7 32-24 4.3-3.2 2.5-4.7 10.8-20.3v69.9L441 357.1l-7.6 5.9-1.4 9.5L412.2 512h48.5l17.6-123.1 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44V128H489.5l-6.8 12.7-10.3 19.3h-.5v1l-50.7 95-5.2 3.9V128H224v132l-5.3-4-50.7-95v-1h-.5l-10.3-19.3-6.8-12.7H136zm296 144h-96v-96h96zm-248-88v111.2l-20.9-16.5c-1.9-1.5-3.1-3.8-3.1-6.3V176h24zM49.3 341.4 8.8 489.7l-6 22.3h49.7l2.6-9.7 35.2-128.7-41-32.2zM511.9 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m8 199.2V176h24v96.4c0 2.5-1.1 4.8-3.1 6.3zM631 489.7l-40.4-148.3-41 32.2 35.1 128.7 2.6 9.7h49.8z" })
  }
), kf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M63.6 336h128.8l-36.6-128h-55.6zm.4-176h128l50.3 176 13.7 48h-64v128h-48V384h-32v128H64V384H0l13.7-48zm192 224 13.7-48L320 160h128l50.3 176 13.7 48h-64v128h-48V384h-32v128h-48V384h-14.1zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-64.4 336h128.8l-36.6-128h-55.6z" })
  }
), Pf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32H94.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 45.4-82L63 336l-15 48h48v128h48V384h32v128h48V384h48l-15-48-37-118.3 45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.3H128zm4.4 208L160 186.5 206.7 336zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 45.4-82L383 336l-15 48h48v128h48V384h32v128h48V384h48l-15-48-37-118.3 45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.3H448zm51.1 58.5L526.7 336h-93.4z" })
  }
), Ff = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264 88a56 56 0 1 1 112 0 56 56 0 1 1-112 0m-8 156.7-23.1 40.4 23.1 32.3zm0 155.3-80-112 64-112h160l64 112-80 112v80H256v-24zm128-82.6 23.1-32.3-23.1-40.4zM336 224h-32v208h32zm-128-56.5V160H48L0 272l64 112v64h128v-82.5l-48-67.2V400h-32V208h32v71.5zm240 198V448h128v-64l64-112-48-112H432v7.5l64 112V208h32v192h-32V298.3zM128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96M53.5 268.9 64 244.5v42.7zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96m64 159.3v-42.8l10.5 24.4z" })
  }
), Tf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 72a40 40 0 1 1 80 0 40 40 0 1 1-80 0m-22.3 56h124.6l6.8 12.6L434 224h124.1l6.9 12.3 56 100.8 11.7 21-42 23.3-11.7-21-19-34.2V384H432v-57.8l-19 34.2-11.7 21-42-23.3 11.7-21 35.2-63.5-3.4-6.3-18.9-35V304H256v-71.7l-18.9 35-3.4 6.3 35.3 63.5 11.7 21-42 23.3-11.7-21-19-34.2V384H80v-57.8l-19 34.3-11.7 21-42-23.3 11.7-21 56-100.9 6.9-12.3H206l44.9-83.4zm46.3 48v80h32v-80zm192-48a40 40 0 1 1 0 80 40 40 0 1 1 0-80M24 432h616v48H0v-48zm120-304a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-16 208h32v-64h-32zm352 0h32v-64h-32z" })
  }
), Af = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M74 304h108l-4-96H78zm158 48h-40v160h-48V352h-32v160H64V352H24l2-48 6-144h192l6 144zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-54 304h108l-4-96H334zm158 48h-40v160h-48V352h-32v160h-48V352h-40l2-48 6-144h192l6 144z" })
  }
), Df = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32H94.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L96 224.9V512h48V352h32v160h48V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM176 304h-32V176h32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 41.4-74.8V512h48V352h32v160h48V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM496 304h-32V176h32z" })
  }
), yf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m365.5 70.4 8.8 2.4 88 24 13.2 3.6 3.6 13.2 22.3 81.9L577 287l-34 34-48-48-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.7-68-35.7 17.9-20.7 55.2-10 26.6-24.6-14.3L160.7 197l62.7 285.8 6.4 29.1h-49.1l-4.1-18.9-31-141h-30.9l35.1 160h-49.1L48 271.9V352H0V128h137.6l5.6 3.3L281.9 212l15.8-37 3.1-8.3.6-.3 7.9-3.9 80-40 8.2-4.1zm30.3 58-30 90.1c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3L449 184.7c.2-.8.5-1.6.9-2.3l-22.1-6zM76.1 176l28.1 128H135l-28.1-128zM416 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-84.5 354.5 24.1-60.4 39 31.7-20.4 51.1-1.8 4.6-3.4 3.5-60.8 60.8-17 17-33.9-33.9 17-17 57.3-57.3z" })
  }
), bf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M16 128v384h48V352h32v160h48V285.1l-48-69.4V304H64V176h43.4l64.8 93.7 7.2 10.3H264v-48h-59.4l-64.8-93.7-7.2-10.3H40zm384-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-127.4 69.5L277 184h59v328h48V352h32v160h48V184h59l4.4-18.5 32-136-46.7-11L485 136H315L287.4 18.5l-46.7 11 32 136zM416 184v120h-32V184z" })
  }
), ff = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M332.2 11.3 320 4.1l-12.2 7.2L23 179.3 2.3 191.5l24.4 41.3 20.7-12.2L320 59.9l272.6 160.8 20.7 12.2 24.4-41.3-20.7-12.3-284.8-168zM496 336a40 40 0 1 0 0-80 40 40 0 1 0 0 80m-48 16h-14l-44.9-83.4-6.8-12.6H257.7l-6.8 12.6L206 352H81.9L75 364.3 19 465.1l-11.7 21 42 23.3 11.7-21 19-34.2V512h128v-57.8l19 34.2 11.7 21 42-23.3-11.7-21-35.2-63.4 3.4-6.3 18.9-35V432h128v-71.7l18.9 35 3.4 6.3-35.4 63.5-11.7 21 42 23.3 11.7-21 19-34.2V512h128v-57.8l19 34.2 11.7 21 42-23.3-11.7-21-56-100.8-6.9-12.3H544zm32 112v-64h32v64zM360 200a40 40 0 1 0-80 0 40 40 0 1 0 80 0m-56 104h32v80h-32zm-160 32a40 40 0 1 0 0-80 40 40 0 1 0 0 80m-16 128v-64h32v64z" })
  }
), Uf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M74 304h108l-4-96H78zm158 48h-40v160h-48V352h-32v160H64V352H24l2-48 6-144h192l6 144zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-64.4 336h128.8l-36.6-128h-55.6zm.4-176h128l50.3 176 13.7 48h-64v128h-48V384h-32v128h-48V384h-64l13.7-48z" })
  }
), Gf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32H94.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L96 224.9V512h48V352h32v160h48V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM176 304h-32V176h32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 45.4-82L383 336l-15 48h48v128h48V384h32v128h48V384h48l-15-48-37-118.3 45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.3H448zm51.1 58.5L526.7 336h-93.4z" })
  }
), qf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m423.9 44.4-4.9-8.7 42-23.3 4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 33.1-10.1 63.9-27.3 89.4L448 256H336l-16-112-88-9.8C261.3 101 304.2 80 352 80c28.3 0 54.8 7.3 77.8 20.2 5.5-18.2 3.7-38.4-6-55.8zm-251.6 260 84.2-141.8 35 7.8 3.1 22-81.1 136.5c-24.8 41.8-65.7 71.4-113.2 82L48 422.5V464h55.2c133.7 0 254.1-68.7 323.6-176h1.4l23.9 47.8C372.3 443.9 244.3 512 103.2 512H0V384l90-20c34.5-7.7 64.3-29.2 82.3-59.6z" })
  }
), Wf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M277.8 102.3c-4.5-26.6-15.2-49-25.5-65.4-6.8-10.8-13.6-19.4-18.7-25.4-2.6-3-4.8-5.3-6.4-7l-2-2-.6-.6-.2-.2-.1-.1-16.4 17.5-16.4 17.5.2.2 1.1 1.1c1 1 2.6 2.7 4.5 4.9 3.9 4.5 9.1 11.1 14.3 19.4 6.6 10.6 12.9 23.4 16.7 37.9-16.2-5-34-5.8-51.6-1.4-10.5 2.6-20.1 6.9-28.7 12.4-21.5-13.6-48.5-18.9-75.3-12.2C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8 10.5-2.6 20.1-6.9 28.7-12.4 5.7 3.6 11.8 6.7 18.3 9.2 10.6 4 22 6.1 33.7 6.1v-24 24c11.7 0 23.1-2.1 33.7-6.1 6.5-2.4 12.6-5.5 18.3-9.2 8.6 5.5 18.3 9.8 28.7 12.4 51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4-26.8-6.7-53.8-1.4-75.3 12.4-8.6-5.6-18.3-9.8-28.7-12.4-19.8-5-39.7-3.4-57.4 3.4zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4 5.8 23.3 46.6-11.6-5.9-23.3-33.6-134.5c-6.2-25 8.3-50.3 32.7-57.6.7-.2 1.5-.4 2.2-.6 18.7-4.7 37.6 2.3 49 16.4l18.7 23 18.7-23c11.4-14.1 30.3-21.1 49-16.4 9.2 2.3 17 7 23 13.3l17.3 18.2 17.3-18.1c11.6-12.1 29-17.7 46.3-13.4 25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9-9.2-2.3-17-7-23-13.3L308 431.1l-17.3 18.1-.7.7c-4.7 4.7-10.5 8.5-17.1 11-5.3 2-11 3.1-16.8 3.1-5.8 0-11.5-1.1-16.8-3.1-6.6-2.5-12.3-6.2-17-10.9-.2-.2-.5-.5-.7-.8L204 431.1l-17.3 18.1c-6 6.3-13.9 11-23 13.3-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z" })
  }
), Ef = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m369 113 17-17-34-33.9L335 79 15 399l-17 17 34 33.9 17-17zM16 80v96h96V80zm256 256v96h96v-96z" })
  }
), Of = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 392v48H40v-48zm-48-48H-8v144h144V344H88z" })
  }
), If = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 41.4-74.8V464H0v48h640v-48H256V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM208 464h-32V352h32zm0-160h-32V176h32zM472 56v281.7l-47.9-43.5-32.3 35.5 88 80 16.2 14.7 16.1-14.7 88-80-32.3-35.5-47.8 43.5V32h-48z" })
  }
), Nf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 41.4-74.8V464H0v48h640v-48H256V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM208 464h-32V352h32zm0-160h-32V176h32zM512.1 38.2 496 23.6l-16.1 14.6-88 80 32.3 35.5 47.8-43.4V416h48V110.3l47.9 43.5 32.3-35.5-88-80z" })
  }
), Xf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-24.5 59.2 13.4 8.5L423 168h81v48h-95l-5.9-3.8-74.6-47.5-59 40.6c-10 6.9-9 22 1.9 27.5l67.4 33.7 13.3 6.6V440H304V302.8l-54.1-27c-43.6-21.8-47.8-82.4-7.6-110l72.1-49.6 13.1-9zM96 256h64v20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H256v64h-20.6c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512H96v-20.6c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.5-45.2-45.2 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H0v-64h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.5-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256zm96 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0m352-128v20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H640v64h-20.6c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512h-64v-20.6c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.6-45.3-45.3 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H384v-64h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.6-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256zm-32 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128M176 176l-64-80 101.3-76H256l48 60z" })
  }
), Kf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M208 384a80 80 0 1 1-160 0 80 80 0 1 1 160 0m-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256m464 128a80 80 0 1 1-160 0 80 80 0 1 1 160 0m-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256M340.9 115.8l-13.4-8.5-13.1 9-72.1 49.6c-40.2 27.6-36 88.2 7.6 110l54.1 27V440h48V273.2l-13.3-6.6-67.4-33.7c-10.9-5.4-11.9-20.6-1.9-27.5l59-40.6 74.6 47.5 6 3.7h95v-48h-81z" })
  }
), Qf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-24v208h48V48h7.6l78.9 200.8-53.4 167.9-10 31.3H528v64h48V0H228.8zm312 400H328.8l46-144.7 2.6-8.1-3.1-7.9L299.2 48H528zm-336-80v192h48V320zM64 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96M0 160v352h48V355.6l56 68.9V512h48V407.5l-5.4-6.6-26.6-32.8V262.4l13.3 16.6 7.2 9H240v-48h-76.5l-56.8-71-7.2-9H24zm72 149-24-29.5V208h24z" })
  }
), Zf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0M136 192h-12.1l-7.2 9.7-104 140.7-4.7 6.4v81l14.3 6.2 168 73.9 19.4-43.9L56 398.4v-33.8L148.1 240h152.5l87.6 107.7-64 94.8-13.4 19.9 39.8 26.9 13.4-19.9 74-109.6 10-14.8-11.2-13.8-106-130.4-7.2-8.9H136zm56 136v-24h-48v93.2l11.1 7.1 88 56 5.9 3.7h31v-48h-17l-71-45.2zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Jf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m222.7 79-18.8-31.9L176 0l-27.9 47.1L129.3 79l-36.7-5.2-54.2-7.5 19.4 51.2L71 152l-26.9 25.5-39.7 37.7 52.1 16.7 35.2 11.3L95 280l4.7 54.6 45.6-30.3 30.7-20.6 30.8 20.5 45.6 30.3L257 280l3.2-36.9 35.2-11.3 18.1-5.8 15.9-28.2-21.6-20.4L281 152l13.1-34.6 19.4-51.2-54.2 7.6zm17.2 46-3.8 10-11.4 29.9 23.2 22 7.7 7.3-10.1 3.3-30.4 9.8-2.7 31.9-.9 10.6-8.9-5.9L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22-11.4-29.7-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 10.6-1.5zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 41.4-74.8V512h48V352h32v160h48V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM496 304h-32V176h32z" })
  }
), jf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-91.1 32h-14l-6.9 12.2-76.9 136 41.8 23.6 51.1-90.3V512h48V352h32v160h48V214.2l61.6 73.3 15.4 18.4 36.7-30.9-15.4-18.4-100.9-120-7.2-8.6H132.9zm75.1 48v128h-32V176zm152 192c4.4 0 8 3.6 8 8v136h48V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v32h48v-32c0-4.4 3.6-8 8-8" })
  }
), Yf = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M0 488v24h48V378.1L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zm24-360H0v144.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L131.2 512h48.5l-19.9-139.4-1.4-9.5-7.6-5.9-30.8-24.3v-86.7l19.8 30.8 7.1 11H384V96H192v144h-18.9l-64.9-101-7.1-11H88zm216 112v-96h96v96h-80zM72 184v111.2l-20.9-16.5c-1.9-1.5-3.1-3.8-3.1-6.3V176h24z" })
  }
), _f = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14l-6.9 12.2-76.9 136 41.8 23.6 43.1-76.2V512h48V352h32v160h48V176h160v-48h-48V48h224v224H368v-48h-48v96h320V0H320v128h-76.9zM208 304h-32V176h32z" })
  }
), hU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm144 64a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L488 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), cU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), sU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm144 64a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 16v-32H352v32h144z" })
  }
), vU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), eU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288m-22.4 56c-23 0-41.6 18.6-41.6 41.6v6.4h32v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5V392h32v-13.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5zM448 416h-32v32h32z" })
  }
), lU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6-41.5-74.7V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7z" })
  }
), tU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 64a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48 352h-64l-16 48-16 48h320v-48l-98.5-135.4L448 288l-30.1 40.2-17.5 23.3-92.3-38.5-53.6-145.3-3.9-10.5-10.5-3.8-88-32-16.7-6.1-10.7 14.2-61.1 81.7-22.4-9.3-22.2-9.2L.6 236.9l22.2 9.2 347.9 145zM109.3 230.2l43.2-57.6 60.8 22.1 34.3 93.1-138.3-57.6m338.1 138.6 69.2 95.2H376l14.4-19.2zm-366-67.7L55.3 290l-6.6 27.6L1.9 512h49.3l37.5-155.6 87.3 37.1V512h48V361.7l-14.6-6.2z" })
  }
), wU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M0 488v24h48V378.1L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zm24-360H0v144.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L131.2 512h48.5l-19.9-139.4-1.4-9.5-7.6-5.9-30.8-24.3v-98.2l20.8 27.7 7.2 9.6h71.3l31.1 124.3c-16 11.6-26.3 30.5-26.3 51.7 0 35.3 28.7 64 64 64 32.3 0 59.1-24 63.4-55.1l134.4-33.6 23.3-5.8-11.6-46.6-23.3 5.8-134.6 33.6c-10-13.7-25.3-23.3-42.9-25.7l-49.5-198.4-5.8-23.3-46.6 11.6 5.8 23.3 6.5 26.2H172l-64.8-86.4-7.2-9.6H88zm48 56v111.2l-20.9-16.5c-1.9-1.5-3.1-3.8-3.1-6.3V176h24zm200 264a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), gU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M0 340.3c.5.4 1.1.9 1.6 1.3L48 378.1V512H0v-24zM0 128h101.1l7.1 11 64.9 101h38.2l-10.5-42.2-5.8-23.3 46.6-11.6 5.8 23.3L297 384.6c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6 23.3-5.8 11.6 46.6-23.3 5.8-134.4 33.6C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64 0-21.3 10.4-40.1 26.3-51.7l-27-108.3H146.9l-7.1-11-19.8-30.8v86.7l30.8 24.2 7.6 5.9 1.4 9.5L179.7 512h-48.5l-17.6-123.1-92.2-72.4C7.9 305.9 0 289.6 0 272.4V152zm72 167.2V176H48v96.4c0 2.5 1.1 4.8 3.1 6.3zM288 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32m38.4-80L288 230.4 441.6 192 480 345.6z" })
  }
), iU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 128a40 40 0 1 0 0-80 40 40 0 1 0 0 80m0-128a88 88 0 1 1 0 176 88 88 0 1 1 0-176m-85.8 208H373.8l5.1 2.6 172.8 88 21.4 10.9-21.8 42.8-21.4-10.9L400 275.2V432h-48V256H224v176h-48V275.2L46.1 341.4l-21.4 10.9-21.8-42.8 21.4-10.9 172.8-88 5.1-2.6zM0 464h576v48H0zm56-272a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0m200-200a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), mU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m222.7 79-18.8-31.9L176 0l-27.9 47.1L129.3 79l-36.7-5.2-54.2-7.5 19.4 51.2L71 152l-26.9 25.5-39.7 37.7 52.1 16.7 35.2 11.3L95 280l4.7 54.6 45.6-30.3 30.7-20.6 30.8 20.5 45.6 30.3L257 280l3.2-36.9 35.2-11.3 18.1-5.8 15.9-28.2-21.6-20.4L281 152l13.1-34.6 19.4-51.2-54.2 7.6zm17.2 46-3.8 10-11.4 29.9 23.2 22 7.7 7.3-10.1 3.3-30.4 9.8-2.7 31.9-.9 10.6-8.9-5.9L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22-11.4-29.7-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 10.6-1.5zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 45.4-82L383 336l-15 48h48v128h48V384h32v128h48V384h48l-15-48-37-118.3 45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.3H448zm51.1 58.5L526.7 336h-93.4z" })
  }
), aU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-91.8 144h55.6l36.6 128H255.6zm91.8-48H256l-50.3 176-13.7 48h64v128h48V384h32v128h48V384h64l-13.7-48zM34.9 32H0v80c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448v32h48c41.2 0 79.7-12 112-32.7V416h-42.2c-20.9 10.2-44.3 15.9-69.1 16 2.9-29 13.5-55.7 29.7-78l13.6-18.7 13.6-18.7-18.1-14.3-18.1-14.3C81.3 246.9 48 183.4 48 112V80.4c69.6 3.8 131.2 37.6 172.1 88.7l15.5-54.4C184.1 63.6 113.2 32 34.9 32zm492.3 400c-24.7-.1-48.2-5.8-69.1-16H416v31.3C448.3 468 486.8 480 528 480h48v-32c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112V32h-34.9c-78.3 0-149.3 31.6-200.8 82.7l15.5 54.4c41-51.1 102.6-84.9 172.2-88.7V112c0 71.4-33.3 134.9-85.4 176l-18.1 14.3-18.1 14.3 13.6 18.7 13.5 18.7c16.3 22.3 26.9 49 29.7 78" })
  }
), oU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M63.6 336h128.8l-36.6-128h-55.6zm.4-176h128l50.3 176 13.7 48h-64v128h-48V384h-32v128H64V384H0l13.7-48z" })
  }
), nU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21-45.4-82L257 336l15 48h-48v128h-48V384h-32v128H96V384H48l15-48 37-118.3-45.4 81.9-11.6 21-42-23.2 11.6-21 75.3-136zm111.9 208L160 186.5 113.3 336z" })
  }
), rU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32v158.2L336.5 239l177.4-46.3 23.2-6.1 12.1 46.4-23.2 6.2-153.6 40.1-16.4 98.5c-4.3-1.5-8.6-3.2-12.8-5.1-10.8-5-19.8-11.2-31.8-19.7l11.3-67.8-81-24.6-20.9 117c-9.7 3.4-19.8 5.6-29 5.6-6.5 0-13.4-1.1-20.3-2.9l23.9-133.7L145 231l-17-5.2V32zm88 96a56 56 0 1 1 112 0 56 56 0 1 1-112 0M79 456.9C59.7 467.8 31.5 480 0 480v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), dU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m14 144-4 96h108l-4-96zm-54 144 2-48 6-144h192l6 144 2 48h-40v160h-48V352h-32v160h-48V352zm32.3-224h-70.4C141.4 100.3 96.7 83 48 80.4V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3 18.1 14.3-13.6 18.7-13.5 18.7c-16.3 22.3-26.9 49-29.7 78 43.3-.2 82.5-17.6 111.2-45.7v61C191.7 468 153.2 480 112 480H64v-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V32h34.9c84.9 0 161.1 37.1 213.4 96M592 80.4c-48.7 2.7-93.4 20-129.9 47.6h-70.4C444 69.1 520.2 32 605.1 32H640v80c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448v32h-48c-41.2 0-79.7-12-112-32.7v-61c28.7 28.2 67.9 45.5 111.2 45.7-2.9-29-13.5-55.7-29.7-78l-13.6-18.7-13.6-18.7 18.1-14.3 18.2-14.3c52.1-41.1 85.4-104.6 85.4-176z" })
  }
), SU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m510.7 79 36.6-5.1 54.2-7.6-19.4 51.2L569 152l26.8 25.5 39.7 37.7-52.1 16.7-35.2 11.3L545 280l-4.7 54.6-45.6-30.3-30.7-20.6-30.8 20.5-19 12.7-32-45.7-2.4-28-22.2-7.2-8.4-12H320l-27.6-8.8 39.7-37.7L359 152l-13.1-34.6-19.5-51.1 54.2 7.6 36.7 5.1 18.8-31.8L464 0l27.9 47.1zm17.2 46-10.6 1.5-31.7 4.4-16.3-27.5-5.3-9.2-5.4 9.2-16.3 27.5-31.7-4.4-10.5-1.5 3.8 10 11.4 29.9-23.2 22-7.7 7.3 10.1 3.3 30.4 9.8 2.7 31.9.9 10.6 8.9-5.9L464 226l26.6 17.7 8.9 5.9.9-10.6 2.7-31.9 30.4-9.8 10.1-3.3-7.7-7.3-23.2-22 11.4-29.7zM256 0v143.5l-14.1 6.4-59 26.8 53.8 79.3h95.8l7.2 10.2 56 80 13.8 19.7-39.3 27.5-13.8-19.7-48.9-69.7h-49.6c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 77.9 120.4 13 20.1-40.3 26.1-13-20.2L80 247.8V384H32V192.5l14.1-6.4L208 112.5V0zm-82.7 303.6 26-17.3-60.7-89.5-26.6 12.1zM0 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), zU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 24V0h-48v112.5l-161.9 73.6-14.1 6.4V384h48V247.8L307.9 501l40.3-26-84.6-130.7L327 304h46.3l64.8 72.1 16.1 17.8 35.7-32.1-16.1-17.8-72-80-7.2-7.9H300.7l-53.8-79.3 59-26.8 14.1-6.4V24.1zm-56.1 263.2L237.5 304 176 208.9l26.6-12.1 61.3 90.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), pU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72.2 436C58.7 404.6 48 348.4 48 256S58.7 107.4 72.2 76c12.4-28.7 22.4-28.1 23.7-28h.2c1.3-.1 11.3-.7 23.7 28 13.5 31.4 24.2 87.7 24.2 180 0 45.7-2.6 82.6-6.9 112H96v48h136.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368h-13.8c4.2-31.3 6.4-68.4 6.4-112 0-21.1-.5-40.7-1.6-58.8L240 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L311.4 512h50.3L407 367.2l5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H512V240h-78.3l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H224l-6.4 4.8-32.4 24.3C171 38.7 136.4 0 96 0 43 0 0 66.6 0 256s43 256 96 256c28 0 53.2-18.6 70.7-64h-52.8c-9.5 16.5-16.7 16.1-17.8 16h-.2c-1.3.1-11.3.7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-46.6 71.8 27 7.4-38.6 115.5-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5l34.2-102.7z" })
  }
), MU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M154.3.3a48 48 0 1 1 11.3 95.3A48 48 0 1 1 154.3.3zM176 128h49.2l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21-41.4-74.8V512h-48V176zm-81.2 0H144v109.7L113.3 336H144v176H96V384H48l15-48 37-118.3-45.4 81.9-11.6 21-42-23.2 11.6-21 75.3-136z" })
  }
), xU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M44.9 299.8 96 209.5V512h48V352h32v160h48V214.2l61.6 73.3 36.7-30.9-100.9-120-7.2-8.6H86.9L80 140.2l-76.9 136 41.8 23.6zM144 176h32v128h-32zM304 32h-16v32h88V32h-16zm192 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0m16 56h-9.9l-7 7-32 32-7 7v71l-37.7-44.5-39.4 3.8-64 115.2 42 23.3 47.1-84.8 44.9 53.1c13.2 15.6 31.1 26.3 50.7 30.7 5.2 1.5 10.7 2.2 16.3 2.2h4v-.1c31.3-2.1 56-28.1 56-59.9V296h-24zm5.4 167.9c-1.9-.1-3.7-.3-5.6-.7-4.6-1.7-7.8-6.1-7.8-11.2v-90.1l17.9-17.9h6.1v108c0 6.2-4.6 11.2-10.6 11.9M272.8 90.5l-14.3 28.6 14.3 7.2 48 24 14.3 7.2 14.3-28.6-14.3-7.2-48-24z" })
  }
), HU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M144 96H48L0 272l96 16zm240 88v-24h-48v48h-27.2L268 146.7l-5.4-8.1-9.5-2-56-12-23.1-5-5.3 23.1-27.7 121c-4.7 20.4 2.4 41.7 18.4 55.2l80.6 68.2V512h48V364.9l-8.5-7.2-33.1-28 22.4-95.2 7.2 10.9 7.1 10.7H336V512h48v-24zM205.3 294.9l-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l22.4-97.9 21.9 4.7zm-81 32.8L72.3 512h49.9l41.6-147.5-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8z" })
  }
), VU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 16v48h192V0zm48 338.1V272h73.5zM224 272v240h192V324.2l64 111.7 11.9 20.8 41.7-23.9-11.9-20.8-100.8-176-4.8-8.4V224H32v48h24zm144 46.8V384h-58.3zM272 432h96v32h-96zM241.6 96c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h-50.7c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16z" })
  }
), CU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 16v48h192V0zm277.9 24L424 32l-16 27.7 13.9 8L331.6 224H154.1l-6.9 12.1-100.8 176-12 20.8 41.7 23.9L88 435.9l72-125.7V512h192V310.3L424 436l11.9 20.8 41.7-23.9-11.9-20.8-73.8-128.8 53.4-92.5-29.3-16.9L479.4 64l-13.9-8zM304 272v131.6L228.8 272zm-96 192V332.4L283.2 464zm-32-352c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h-50.7c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16h-50.7c-1 5.2-1.6 10.5-1.6 16" })
  }
), LU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 14.1v32h144V0zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128M64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-5.5-.7-10.9-2-16H66c-1.3 5.1-2 10.5-2 16m281.8 176 6-32h64.3l6 32zM312 192l-15 80-9 48h192l-9-48-15-80zM58.7 213.1 32 320h165.8L58.7 213.1m159 81.9L192 192H83.8l134 103zM272 432l96 80h16v-56h128v-48H384v-56h-16zm-144-80v56H0v48h128v56h16l96-80-96-80z" })
  }
), BU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-56 32H0v146c0 15.6 6.5 30.4 17.9 41l94.1 87.5V512h48V381.5l-7.7-7.1-32.3-30v-88l11.2 19.5 6.9 12.1H192v224h48V400h352v112h48V0H480v76.5l1.6 4.2 46.2 118.8L256 248.4V240h-90.1l-57.1-99.9-6.9-12.1H88zm48 48v123.8l-21.4-19.9c-1.6-1.5-2.6-3.6-2.6-5.9v-98zm520 176H240v-51.9l32.1-5.8c0 .6-.1 1.1-.1 1.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7zM48 386.7 0 342.1V512h48v-24zM528 67.5V48h64v139.2l-16.5 2.4z" })
  }
), uU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-64 80h77.4l7 11.4 49.4 80.2 82.7-70 18.3-15.5 31 36.6-18.3 15.5-104 88-21.3 18-14.6-23.8-17.2-27.9-56 134.5 114 68.4 11.7 7V512H32v-48h190.7l-103.5-62.1c-30.6-18.4-43.2-56.5-29.4-89.4l64-153.7zm-7.2 222.1 66.6-159.8-8.8-14.3H192l-57.9 138.9c-4.6 11-.4 23.7 9.8 29.8l8.9 5.3z" })
  }
), RU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M96 384h32v128h48V384h32v128h48V384h96v-64c0-46.8-33.4-85.7-77.7-94.3L256 128H118.5l-6.8 12.7-76.9 144-11.3 21.2 42.3 22.6 11.3-21.2L96 272.1V336zm120-208h.2l11 58.6 6 32.1 32.1 6.2c22.1 4.3 38.8 23.8 38.8 47.1v16H144V176h48z" })
  }
), $U = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-14.1l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21 41.4-74.8V512h48V352h32v160h48V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136-6.9-12.4h-14.1zM272 304h-32V176h32zM57 23 40 6.1 6.1 40 23 57l64 64 17 17 33.9-34L121 87zm432 34 17-17-34-33.9L455 23l-64 64-17 17 34 33.9 17-17 64-64zM121 425l17-17-34-33.9L87 391l-64 64-17 17 34 33.9 17-17 64-64zm304-34-17-17-33.9 34 17 17 64 64 17 17 33.8-34-17-17-64-64z" })
  }
), kU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79v-2c-.5-43.7-36.1-79-80-79m-80 192h-15.9l-6.2 14.6-88 208-9.4 22.1 44.2 18.7 9.4-22.1L152 296.5V512h48V240h72v272h48V192H160zm48-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0M416 0h-16v32h16v96h-16v64h-48v192h64v128h96l-12-48-16-64h60v-48h-64v-26.7l64-21.3V192h-48v72l-16 5.3V128h-16V0h-16zm16 336h-32v-96h32z" })
  }
), PU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M224 112h75.2l3.1.8 88 24 12.7 3.5 3.9 12.6 26.8 87.1H512v48H398.3l-5.2-16.9-12.5-40.8-28.1 84.4 43.4 24.4 16.9 9.5-5.8 18.5L361.6 512h-50.2l43.9-140.6-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l31.8-95.4H240l-57.6 43.2-3.8 2.9-28.8-38.4 3.8-2.9 64-48zm97.4 55.8-34.3 102.7c-1.2 3.6.3 7.6 3.7 9.5l19 10.7 38.5-115.6-27-7.4zM218.5 317.1c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-18 47.9-5.8 15.6H96v-48h103.4zM16 95.8h144v32H0v-32h16m-16 64h96v32H0zm16 64h144v32H0v-32z" })
  }
), FU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M128 112h75.2l3.1.8 88 24 12.7 3.5 3.9 12.6 26.8 87.1H416v48H302.3l-5.2-16.9-12.5-40.8-28.1 84.4 43.4 24.4 16.9 9.5-5.8 18.5L265.6 512h-50.2l43.9-140.6-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l31.8-95.4H144l-57.6 43.2-19.2 14.4-28.8-38.4 19.2-14.4 64-48zm97.4 55.8-34.3 102.7c-1.2 3.6.3 7.6 3.7 9.5l19 10.7 38.5-115.6-27-7.4zM122.5 317.1c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-18 47.9-5.8 15.6H0v-48h103.4z" })
  }
), TU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-16 32h-29.9l6.5 29.2L163 308.1c5.7 25.6 28.4 43.9 54.7 43.9h117.9l42 107.9 7.4 19 20-4.3 44.8-9.6 23.5-5-10.1-46.9-23.5 5-24.8 5.3-40.5-104.1-6-15.3h-85.1l-10.7-48H352v-48h-90.1l-6.5-29.2-4.1-18.8H232zm52.7 48 21.3 96h-16.3c-3.7 0-7-2.6-7.8-6.3l-20-89.7h22.8zM79.6 147.8l-4.2-23.6-47.3 8.3 4.2 23.6 48 272 3.6 19.9H304v-48H124.1z" })
  }
), AU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-32 32H88v144c0 30.9 25.1 56 56 56h115l13.2 99.2L275 480h109v-48h-67l-13.2-99.2L301 312h-93v-56h80v-48h-80v-48h-24zm48 48v104h-16c-4.4 0-8-3.6-8-8v-96zM48 152v-24H0v320h224v-48H48z" })
  }
), DU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 172.1V512H0V144L256 0l256 144v368h-48V172.1l-208-117zM256 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-62.3 96h124.6l6.8 12.6 56 104 11.4 21.1-42.3 22.8-11.4-21.1-18.9-35V512H272v-96h-32v96h-48V328.3l-18.9 35-11.4 21.1-42.3-22.8 11.4-21.1 56-104 6.8-12.6zM240 368h32v-96h-32z" })
  }
), yU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-56 32H72.4l-6.3 14.3-64 144L46 305.8l34-76.7V512h48V352h52.2l27.8 61.2V512h48V402.8l-2.2-4.7-37.8-83.3V210.4l29.3 36.6 4.1 5.2 6.2 2.3 44.5 16.7-11 30.3-8.3 22.5 45.1 16.4 8.2-22.6 45-123.7 35 13 45 16.7 16.1-45.2 36.8-103-79-29.4 10-27.4-45.1-16.4-9.9 27.1-34.2-12.8-45-16.7-16.1 45.2L256 148.4l78.2 29.1-17.7 48.5-37.9-14.2-59.9-74.8-7.2-9H200zm80 176h-40V176h40zM337.7 62l113.2 42.1-20.6 57.9-113.2-42.1z" })
  }
), bU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M74 304h108l-4-96H78zm-10 48H24l2-48 6-144h192l6 144 2 48h-40v160h-48V352h-32v160H64v-24z" })
  }
), fU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M128 96h217.9l7 7 12 12 17 17-17 17-96 96 69.3 60c8.8 7.6 13.8 18.6 13.8 30.2V448h-48V339l-85.4-74c-24.8-21.5-26-59.7-1.9-82.5 11.9-11.2 26.8-25.1 41.6-38.5H128zM79 367l100.4-100.4c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401l-17 17-33.9-34 17-17zm309.3 77.6 31 7.8-3.9 15.5-8 32-3 12.1H272v-32h107.5l5-19.9 3.9-15.5zm-253.1 33.7-32 16-10.3 5.2-8.2-8.2-72-72L1.4 408 24 385.4l11.3 11.3 63.8 63.8 21.7-10.8 14.3-7.2 14.3 28.6-14.3 7.2z" })
  }
), UU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M112 96h207.5l7 7 16 16 18.2 18.2-19.4 16.9L202.4 275l-31.3 109.4 292.9-151V168h48v94.6l-13 6.7L50.5 500.7l-21.3 11L7.1 469l21.3-11 92.4-47.7-6.6-1.9 6.6-23.1 45.7-159.8c2.7-9.4 7.8-18 14.9-24.9 11.1-10.7 36.2-34.6 60.8-56.8H112z" })
  }
), GU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 207.9-32 7.5V0h32zM35.3 168l10.4 21.7L125 355.6l68.7-18.7 23.2-6.3 12.6 46.3-23.2 6.3-88 24-19.3 5.2-8.6-18.1-88-184L-8 188.7zM512 288v64c0 10-6.3 19-15.7 22.5l-344 127.1-22.5 8.4-16.6-45 22.5-8.3L272 406.2V286.3l-93.3 22c-19 4.5-38.4-5.4-46-23.4l-38-90-8.8-20.8 20.2-10 19.2-9.6 23-11.5 9.9 23.7 36.8 88.4 95.5-22.5L320 256v132.5l144-53.2V288zM64 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), qU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-184 64h-8l-6.4 4.8-64 48-19.2 14.4 19.2 25.6L67 464H0v48h576V408h-48v56h-93.4l27.1-176H480v-48h-78.3l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H200zm229.4 176-27.1 176h-57.7l30.3-96.8 5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H429.3zM99.7 464l55.7-264.6L208 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-28.9 92.6H190.7l36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464zm155.4-193.5 34.2-102.7 27 7.4-38.5 115.5-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5z" })
  }
), WU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M13.8 247.6l21.3 11.1L239.8 365l49.6-74.5-84.7-90c-9.2-9.7-14.1-21.6-15-33.7l89.6 42.9 58.2 61.8 13.1 13.9-10.6 15.9-57.3 86 133.5 69.3 37.1-18.5 21.5-10.7 21.5 42.9-21.6 10.7-48 24-10.9 5.5-10.9-5.6-392-203.6-21.3-11.1 22.1-42.6zm326.6-192 9.8 22.9L393 179l65.4 31.3 21.6 10.4-20.7 43.3-21.7-10.4-42.4-20.3-.1.3-14.4-6.9-229.1-110-9.2 18.4-7.2 14.3-28.6-14.3 7.2-14.3 9-18-17.6-8.4-14.5-6.9 13.8-28.8 14.4 6.9 18.1 8.6 8.7-17.4 7.2-14.3 28.6 14.3-7.2 14.3-8.5 16.9 52.4 25.2c1.1-.6 2.2-1.2 3.4-1.7l96.1-45.2 22.5-10.6zM273.9 140l63.1 30.2-21.3-49.9z" })
  }
), EU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-272 96h207.5l7 7 16 16 17.9 17.9-18.8 16.9-87 78.1H376v139.7l64.2 33.3 37.1-18.5 21.5-10.7 21.5 42.9-21.5 10.7-48 24-10.9 5.5-10.9-5.6-416-216-21.4-11 22.1-42.6L35 226.7l124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80H128zm200 184H199.3L328 378.8z" })
  }
), OU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M24 278.1l17 17 28.4 28.4 27 10.4-7.8-18.7 22.2-9.2 81.2-34v-68.2c0-21.2 12-40.6 31-50.1l61.4-30.7-30.8-3.1-12.5-1.2-6.1-11-40-72 42-23.3 33.9 61 67.5 6.8 7.4.7 5.7 4.8 152 128 18.4 15.5-30.9 36.7-18.4-15.5-68.2-57.5-82.3 43.9 52.5 40.2 13.9 10.6-5.9 16.5-40 112-3.8 10.5 97.6 37.4H496v48h-68.4l-4.1-1.6-376-144-4.8-1.8L39 361 7 329l-17-17zm270 131.3 3.4-9.5 34.1-95.5-91.5-70V304l-14.8 6.2-91.2 38 160 61.3zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5z" })
  }
), IU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m120.2 63.1 12.3 20.6 46.8 78.1L576 240v96l-84 56 54 72h4.1l33-33 17-17 33.8 34-17 17-40 40-7 7H416v-48h70l-48-64H313.3c4.3 9.8 6.7 20.6 6.7 32 0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80 0-26.2 12.6-49.4 32-64l8-16 40-80h208l24-32h-44l-7.2-9.6L220 176h-28.4l-25.7 57.7-43.9-19.5 32-72 6.3-14.3H244l7.2 9.6L292 192h56l18.7-24.9-35.3-58.8-12.3-20.5 41.2-24.7zm38.2 141.8-.3.2-71.8 95.7L312 320H109.7l-16 32h371.8l62.5-41.7v-40.6l-129.5-64.8zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), NU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 160a64 64 0 1 0 128 0 64 64 0 1 0-128 0m64 222.2c4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.4 360.2 19.7 368 0 368v48c31.5 0 59.7-12.2 79-23.1 6.5-3.7 12.2-7.4 16.9-10.7zm173-177.3 132.3 111.9c7.9-1.8 15.9-4.7 23.4-8.2 8.4-3.9 15.8-8.5 24.2-14.4L303.1 170.9l26.8-26.9H480V96H310.1l-7 7L167 239l-7 7v66.3c10.7 4 21.8 6.7 32 6.7 5.2 0 10.5-.7 16-1.9v-51.2l61-61z" })
  }
), XU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48v82.8L139.1 235.7l-11.1 7.1V400H48V48zm48 0h240v352h-81.7L499 385.4l-80-104-7.2-9.4H333l-47.4-72.6 55.3-35.2 11.1-7.1V48zm97.7 352h-83.8l32 48H640V0H0v448h303.9l36.2 53.5 39.7-26.9-82.6-122.1 46.4-32.5h44.6l61.5 80zm-178.3 0H176V269.2l4.7-3zm-1.1-87.3-49-72.3 23.9-15.2 47.1 72.2-22 15.4zM192 128a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), KU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-184 64h-8l-6.4 4.8-64 48-19.2 14.4 28.8 38.4 19.2-14.4L144 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L215.4 512h50.3L311 367.2l5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H416V240h-78.3l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H136zm55.1 158.5 34.2-102.7 27 7.4-38.5 115.5-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5zM103.4 368H0v48h136.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM528 48v416h-96V320h-48v192h192V0H384v208h48V48z" })
  }
), QU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-184 64h-8l-6.4 4.8-64 48-19.2 14.4 28.8 38.4 19.2-14.4L144 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L215.4 512h50.3L311 367.2l5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H416V240h-47.9c1.2-82.9 11.4-134.5 24.1-164 12.4-28.7 22.4-28.1 23.7-28h.2c1.3-.1 11.3-.7 23.7 28 13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28h-.2c-1.3.1-11.3.7-23.7-28-10.1-23.4-18.6-60.5-22.2-116h-48.1c8.8 140.7 47.6 192 94.1 192 53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189L311 152.9l-3.9-12.6-12.7-3.5-88-24-3.1-.8H136zm55.1 158.5 34.2-102.7 27 7.4-38.5 115.5-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5zM103.4 368H0v48h136.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6z" })
  }
), ZU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1 4.4 4.7 48 48 34-34-43.5-43.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56-9.5 22.1 44.1 18.9 9.5-22.1zm59.2 65.1 30-90.1 22.1 6c-.3.8-.6 1.5-.9 2.3l-32.3 103.8-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5l-57.3 57.3-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7zM447 449l17 17 33.9-34-17-17-39-39H640V64H320v48h272v216H441.9l39-39 17-17-33.9-33.9-17 17-80 80-17 17 17 17 80 80z" })
  }
), JU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1 4.4 4.7 48 48 34-34-43.5-43.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56-9.5 22.1 44.1 18.9 9.5-22.1zm59.2 65.1 30-90.1 22.1 6c-.3.8-.6 1.5-.9 2.3l-32.3 103.8-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5l-57.3 57.3-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7zM541.8 159l-17-17-33.9 34 17 17 39 39H368v48h178.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z" })
  }
), jU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1 4.4 4.7 48 48 34-34-43.5-43.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56-9.5 22.1 44.1 18.9 9.5-22.1zm59.2 65.1 30-90.1 22.1 6c-.3.8-.6 1.5-.9 2.3l-32.3 103.8-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5l-57.3 57.3-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7zM416 24V0h-48v96h48V72zm125.8 135-17-17-33.9 34 17 17 39 39H368v48h178.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80zM416 128h-48v64h48v-40zm0 216v-24h-48v64h48v-24zm0 72h-48v96h48v-72z" })
  }
), YU = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M306.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1 4.4 4.7 48 48 34-34-43.5-43.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56-9.5 22.1 44.1 18.9 9.5-22.1zm59.2 65.1 30-90.1 22.1 6c-.3.8-.6 1.5-.9 2.3l-32.3 103.8-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm-66.3 135.9-57.3 57.3-17 17 33.9 33.9 17-17L337 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7-24.1 60.4zM134.9 511.9l23.1-40 5.6-9.5 98.2-166.3-27.6-16.3-29.8 50.5-84.4-48.7-96 166.3z" })
  }
), _U = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-56 32h-15.6l-6.3 14.3-64 144L78 305.8l42-94.7v68.7c0 17.8 8.5 34.6 22.9 45.2l97.1 71.2V512h48V371.8l-9.8-7.2-38.2-28V207.3l68 102 13.3 20 39.9-26.6-13.3-20-96-144-7.1-10.7H232zm48 151.8V176h24v125.4l-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1 99.9 144.2 9.1 13.2 26.2-18.3-9.1-13.2-99.1-143.2c-3.2 3.7-7 7.1-11.3 10-5 3.3-10.3 5.7-15.7 7.3zm-215.8 3.6L89.6 512H139l30.7-127.8-42-30.8z" })
  }
), hG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-89.1 183.4-36.3 18.1-20.5 48-9.5 22.1-44.1-19 9.5-22.1 24-56 3.5-8.1 7.9-3.9 80-40 8.2-4.1 8.8 2.4 88 24 13.2 3.6 3.6 13.2 22.3 81.9L313 279l-34 34-40-40-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L114 312.6c-18-14.7-25.1-39.1-17.8-61.2zm52.9-6.9-30 90.1c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.3-.8.5-1.6.9-2.3l-22.1-6zM99.7 342.2l39 31.7-20.4 51.1-1.8 4.6-3.5 3.4-60.8 60.8-17 17-33.9-34 17-17 57.3-57.3 24.1-60.4z" })
  }
), cG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-17.2 80h130.4l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21-41.4-74.8V512h-48V352h-32v160H96V224.9l-41.4 74.7-11.6 21-42-23.2 11.6-21 75.3-136zM144 304h32V176h-32z" })
  }
), sG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 32H48v144H0v48h48v256h48V352h96c77.4 0 142-55 156.8-128H384v-48h-32.8C343.2 95.1 275 32 192 32zm230.9 144H96V80h96c56.4 0 103.1 41.7 110.9 96M96 224h203.4c-13.8 46.3-56.6 80-107.4 80H96z" })
  }
), vG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 32H48v96H0v48h48v48H0v48h48v208h48V368h88c67 0 124.9-39.2 151.8-96H384v-48h-33.7c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24H384v-48h-48.2C308.9 71.2 251 32 184 32zm208 96H96V80h88c39.3 0 74.1 18.9 96 48M96 176h205.6c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24H96zm184 96c-21.9 29.1-56.7 48-96 48H96v-48z" })
  }
), eG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32v32c0 247.4 200.6 448 448 448h32zM489 57l17-17-34-33.9L455 23 336 142V64h-48v160h160v-48h-78.1z" })
  }
), lG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32v32c0 247.4 200.6 448 448 448h32zM413.8 23l-17-17-33.9 34 17 17 39 39H288v48h130.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z" })
  }
), tG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32v32c0 247.4 200.6 448 448 448h32zM303 175l-17 17 34 33.9 17-17 127-127V152h48V0H360v48h70.1z" })
  }
), wG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m207.7 387.5 31.9-18.4c53.8-31 98.6-75.8 129.6-129.6l18.4-31.9-26-26-33.2-33.2L366 54.2 463.9 72c-4.2 214.6-177.3 387.7-391.8 391.9L54.3 366l94.2-37.7 33.2 33.2zM160 272 0 336l32 176h32c247.4 0 448-200.6 448-448V32L336 0l-64 160 55.6 55.6c-26.8 46.5-65.5 85.2-112 112z" })
  }
), gG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 272v96l160 32 64-160C602.7 192 486.4 96 320 96S37.3 192 0 240l64 160 160-32v-96c62.3-20.8 129.7-20.8 192 0m-240 56.6-82.3 16.5-38.1-95.2C99.2 207.1 193.2 144 320 144s220.8 63.1 264.4 105.9l-38.1 95.2-82.3-16.5v-91.2l-32.8-10.9c-72.2-24.1-150.2-24.1-222.4 0L176 237.4V272z" })
  }
), iG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 80v352H48V80zM48 480h464V32H0v448zm128-48V80h288v352zm80-48a48 48 0 1 0 0-96 48 48 0 1 0 0 96m80-96v32h96v-32h-80zm0 64v32h96v-32h-80zm96-240H208v128h224z" })
  }
), mG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0h136v48h-78.1l80 80h108.2L475.8 18.2l17-17 33.9 33.9-17 17L393 169l-7 7H238.1l-7-7-87-87v78H96V0zm296 464v-80c-62.3-20.8-129.7-20.8-192 0v80L64 512 0 352c37.3-48 153.6-144 320-144s282.7 96 320 144l-64 160zm-240-80v-34.6l32.8-10.9c72.2-24.1 150.2-24.1 222.4 0l32.8 10.9v78.9l83.7 25.1 36.6-91.5C540.8 319.1 446.8 256 320 256S99.2 319.1 55.6 361.9l36.6 91.5 83.8-25.1z" })
  }
), aG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 48v320h80V48zM96 0h176v32h304v480H0V32h96zm0 80H48v384h480V192H320V80h-48v336H96v-48zm432 0H368v64h160zM320 240h64v64h-64zm64 96v64h-64v-64zm32-96h64v64h-64zm64 96v64h-64v-64z" })
  }
), oG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m336.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C289.4 459.7 116.3 286.6 112.1 72L210 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM576 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32v32c0 247.4 200.6 448 448 448h32zM456 224h48v-88h88V88h-88V0h-48v88h-88v48h88v64z" })
  }
), nG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208v-80s96-96 256-96 256 96 256 96v80h-96l-32-80s-48-24-128-24-128 24-128 24l-32 80zm256 176a64 64 0 1 0 0-128 64 64 0 1 0 0 128M32 480v-96l128-224h192l128 224v96zm400-48v-35.3L324.1 208H187.9L80 396.7V432z" })
  }
), rG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m368.2 387.5 26-26 33.2-33.2 94.2 37.7-17.8 97.9c-86.4-1.7-166.1-30.8-230.7-79l-38.9 30.6C310.5 476 407 512 511.9 512h32l32-176-159.6-63.8-2.8 2.2-53.2 53.2c-2.7-1.6-5.5-3.2-8.1-4.9L312.4 354c7.8 5.4 15.8 10.4 23.9 15.1l31.9 18.4zm-204-41L19 459.3 0 474l29.4 37.9 19-14.7L620.9 52.7l19-14.7L610.5.1l-19 14.7L278 258.2c-11.1-13.3-21-27.6-29.7-42.6l55.6-55.6-64-160-176 32v32c0 107.1 37.6 205.5 100.3 282.6zm37.9-29.4c-54.8-67-88.3-152.2-90.2-245.1l97.9-17.8 37.7 94.2-33.2 33.2-26 26 18.4 31.9c9.8 17 21 33.1 33.3 48.1L202.1 317z" })
  }
), dG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32v32c0 247.4 200.6 448 448 448h32zM256 48c114.9 0 208 93.1 208 208h48C512 114.6 397.4 0 256 0zm32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64m80 0h48c0-88.4-71.6-160-160-160v48c61.9 0 112 50.1 112 112" })
  }
), SG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m336.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C289.4 459.7 116.3 286.6 112.1 72L210 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM576 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32v32c0 247.4 200.6 448 448 448h32zm-6-296L536 6.1 519 23l-47 47-47-47-17-17-33.9 34 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47 17-17z" })
  }
), zG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m304.3 387.5-31.9-18.4c-53.8-31-98.6-75.8-129.6-129.6l-18.4-31.9 26-26 33.2-33.2L146 54.2 48.1 72C52.3 286.5 225.5 459.6 440 463.9l17.7-97.9-94.2-37.7-33.2 33.2zM352 272l160 64-32 176h-32C200.6 512 0 311.4 0 64V32L176 0l64 160-55.6 55.6c26.8 46.5 65.5 85.2 112 112z" })
  }
), pG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 48H240v224h15.6l69.1-94.2 19.3-26.4 19.4 26.4 10.3 14 63.7-78.9L456 89.8l18.7 23.1 37.6 46.6L368 207.6V320H192V0h448v117l-48 16zM160 400h166c-2.2 1.4-4.4 2.9-6.5 4.5-13.8 10.3-25.3 25.3-29.7 43.5H0V112h160v216zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64M112 208v-48H48v48zm0 192v-48H48v48zm0-96v-48H48v48zm528-152v241.3c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48v150.7c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V232l16.4-5.5 192-64z" })
  }
), MG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 48v256h15.6l69.1-94.2 19.3-26.4 19.4 26.4 16.6 22.6 56-85.6 20-30.7 20.1 30.7L578.8 304H592V48zM192 0h448v352H192V48zm-56 128h24v336h192v-80h48v80h64v-80h48v128H0V128h112zm-24 48H48v64h64zM48 464h64v-64H48zm0-112h64v-64H48zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), xG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 64H0v48h112v249.4l-36.6 61.5 41.2 24.6 40-67.2 3.4-5.7V112h144v336h111.5l6.4-14.2 14.4-32 9.8-21.9-43.8-19.7-9.8 21.9-8 17.8H352V112h96V64h-24z" })
  }
), HG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 224h-80v96h-16v80h96zM400 400v-80h-16v-96h-64v96h-16v80zm-128 0v-80h-16v-96h-64v96h-16v80zm-128 0v-80h-16v-96H48v176zm384-224v-64H48v64h400zm48 0v272H0V64h576v48z" })
  }
), VG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 384v48h-32v-48h-32v48h-32v-48h-96v48h-32v-48h-32v48h-32v-48h-32v48H80v-48H48v80h416v-80zM48 336h416v-18.3l-101.5-50.8-26.5-13.2V192c0-79.5-64.5-144-144-144S48 112.5 48 192zm464-48v224H0V192C0 86 86 0 192 0s192 86 192 192v32z" })
  }
), CG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M332.7 179.3c50 50 88.1 107.3 117.6 169.9 1.5 3.2 3 6.4 4.4 9.6 7.9 17.5 15.2 35.3 21.9 53.5l15.6-38.3c3.7-9.1 6.9-18.4 9.5-27.8 22.6-80.8 6.1-169.5-43.8-236.9L480 88l-56-56-21.3 22.1C335.3 4.2 246.6-12.3 165.8 10.3c-9.4 2.6-18.7 5.8-27.8 9.5L99.6 35.3c18.2 6.7 36.1 14 53.5 21.9 3.2 1.5 6.4 2.9 9.6 4.4 62.6 29.5 119.9 67.6 169.9 117.6zm33.9-33.9c-38.6-38.6-81-70.5-126.3-97 58.3.4 116.2 23.3 158.3 65.5 41.9 42.1 64.6 99.7 65 157.7-26.5-45.2-58.4-87.6-97-126.3zm-32.1 82.8c-7.7-8.8-15.8-17.6-24.5-26.2s-17.4-16.8-26.2-24.5L0 472l40 40 294.6-283.8z" })
  }
), LG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m129.9 369.9 20-20-7.8-27.2-24.2-84.7 19.2-19.2 137.4 137c3.2-17.8 9.3-34.7 17.9-49.9L171 184.9l117-117 156.6 156.6c27.1 2.1 52.3 11 74 24.9l9.4-9.4-33.9-33.9L321.9 33.9 288 0l-33.9 33.9-129 129c-2.1 1.1-4 2.5-5.7 4.3-1.7 1.7-3.1 3.6-4.2 5.7L64 224l32 112-46.1 46.1L16 416l33.9 33.9L78 478l34 34 33.9-33.9L192 432l99.4 28.4c-9.1-16.8-15.3-35.3-18-55.1l-68.2-19.5-27.2-7.7-20 20-46 46L83.9 416l46.1-46.1zM560 384a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-192-16a16 16 0 1 1-32 0 16 16 0 1 1 32 0m48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32m32-96a16 16 0 1 1-32 0 16 16 0 1 1 32 0m64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32m-48-112a16 16 0 1 1-32 0 16 16 0 1 1 32 0" })
  }
), BG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 240h-12.7C497.7 137.8 401.4 64 288 64S78.3 137.8 44.7 240H0v64h41.2l63.9-30.4 6-2.9 6.3 2.3 82.6 30 82.5-30 5.5-2 5.5 2 82.5 30 82.5-30 6.3-2.3 6.1 2.9 63.9 30.4H576v-64zM96 448h384l38.7-116.2-43.6-20.8-29.7 89H130.6l-29.7-89-43.6 20.8zm110.3-296.8-16 32-7.2 14.3-28.6-14.3 7.2-14.3 16-32 7.2-14.3 28.6 14.3zm192-14.3 16 32 7.2 14.3-28.6 14.3-7.2-14.3-16-32-7.2-14.3 28.6-14.3 7.2 14.3M304 144v48h-32v-64h32z" })
  }
), uG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 32h-3l-2.9.7-49 12.3c-21.1 5.3-38.6 18-50.2 35H240c-77.4 0-142 55-156.8 128H47.4c-8.5 0-15.4-6.9-15.4-15.4 0-7.1 4.8-13.3 11.7-15l8.2-2 15.5-3.9-7.8-31-15.5 3.9-8.2 2C14.8 151.8 0 170.8 0 192.6 0 218.8 21.2 240 47.4 240H80v16c0 55.8 31.8 104.2 78.1 128.1l25.9 79.3 5.4 16.6H304v-64h48v64h114.5l5.4-16.6 17.3-53.1c26.1-7.5 49.6-22.2 67.8-42.4h83V192h-56.7c-6.7-4.7-12.5-10.5-17.2-17.3l-.1-.1c21.1-15.2 33.9-39.8 33.9-66.4V80H552v28.2c0 12.5-6.9 23.9-17.8 29.8-4.1-3.8-8.3-7.4-12.7-10.8 4.2-10.3 6.5-21.5 6.5-33.2V32h-24zm-43.2 59.5L475 80h5v14c0 9.4-3.3 18.2-8.9 25.1l-16.9 21 22.8 14.4c19.3 12.2 36.3 28.2 49.7 47.6 9.9 14.2 22.7 26.1 37.7 34.7l5.6 3.2h22v80h-58.1l-7.2 9.5c-14.7 19.4-36.2 32.6-60.3 37l-14.1 2.5-4.5 13.6-16.1 49.4H400v-64H256v64h-31.7l-23.7-72.7-3.4-10.4-10.2-4.3c-34.7-14.5-59-48.8-59-88.6v-16c0-61.9 50.1-112 112-112h156.8l6.2-14.5c4.6-10.7 13.9-19 25.7-21.9zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40" })
  }
), RG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.9 96.5c-17.3 1.3-34 4.8-49.8 10.4C162.8 47.4 211.9 0 272 0c52 0 95.6 35.4 108.3 83.4-6 3.8-11.7 8-17 12.6H334c-7.1-27.6-32.2-48-62-48-30 0-55.2 20.6-62.1 48.5M376.4 176H224c-61.9 0-112 50.1-112 112 0 36.6 17.5 69.1 44.8 89.6L176 392v72h48v-64h144v64h48v-65.1l24-13.9a113.5 113.5 0 0 0 33.7-29.9L488 336h40v-64h-28.7l-12.6-28.8c-6.1-14.1-15.1-26.7-26.2-37.1l-20.6-19.3 6.9-27.4 3.9-15.4H448c-14.2 0-26.9 6.1-35.8 16l-14.3 16h-21.5zM448 96h64l-12 48-6.8 27.1c15.8 14.8 28.7 32.8 37.5 52.9H576v160h-64c-12.9 17.2-29.3 31.8-48 42.6V512H320v-64h-48v64H128v-96c-37-27.8-61.6-71.3-63.8-120.6C28 290.9 0 260 0 222.6c0-27.8 15.7-53.2 40.6-65.7l4.7-2.3 21.5 42.9-4.7 2.3c-8.7 4.3-14.1 13.1-14.1 22.8 0 12.6 9.1 23 21.1 25.1C87 178.8 149.6 128 224 128h152.4c17.6-19.6 43.2-32 71.6-32m-24 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), $G = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64v112H48zm64-112C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112m398.3 348.4L355.6 225.7C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112 0 22.2-6.5 43-17.7 60.4m-33.9 33.9C459 425.5 438.2 432 416 432c-61.9 0-112-50.1-112-112 0-22.2 6.5-43 17.7-60.4zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320" })
  }
), kG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 24V0h-48v48H0v145.3l16.4 5.5L96 225.3V512h160V408h96v104h160V224H272V48zM48 96h176v125.2l-23.3 9.3-25.6-12.8-6.4-3.2-6.7 2.7-18 7.2v-33.7l-16.4-5.5L48 158.7zm157.9 166.9 18.1-7.2V272h240v30.1l-8.8-4.4-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-10.1 4v-42.4l23.3-9.3 25.6 12.8 6.4 3.2 6.7-2.7zM144 335.6l15.3-6.1 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 16.7 8.4v54.5l-18.1-7.2-6.7-2.7-6.4 3.2-25.6 12.8-7.3-2.9V360H208v35.6l-7.3 2.9-25.6-12.8-6.4-3.2-6.7 2.7-18 7.2zm0 91.2 23.3-9.3 25.6 12.8 6.4 3.2 6.7-2.7 2.1-.8v34H144zm296.7-9.3 23.3 9.3V464h-64v-34l2.1.8 6.7 2.7 6.4-3.2 25.6-12.8zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), PG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192M81.1 333.6h.1L312 408 126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8zm-14.8 45.7c-12.1-3.9-22.8-10-32-17.7-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3-29.6 55.7-307.7-99.2zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), FG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 96-40 40 24 24-57.1 22.9 9.1 9.1v128L256 512H128L0 384V256L192 64h128l9.1 9.1L352 16l24 24 40-40 10 30 70-14-14 70zM236.1 464 400 300.1v-88.2L300.1 112h-88.2L48 275.9v88.2l99.9 99.9h88.2M176 201.4l11.3 11.3 20.7 20.7 20.7-20.7 11.3-11.3 22.6 22.6-11.3 11.3-32 32-11.3 11.3-11.3-11.3-32-32-11.3-11.3zm-80 80 11.3 11.3 20.7 20.7 20.7-20.7 11.3-11.3 22.6 22.6-11.3 11.3-32 32-11.3 11.3-11.3-11.3-32-32L73.4 304zm160 0 11.3 11.3 20.7 20.7 20.7-20.7 11.3-11.3 22.6 22.6-11.3 11.3-32 32-11.3 11.3-11.3-11.3-32-32-11.3-11.3zm-80 80 11.3 11.3 20.7 20.7 20.7-20.7 11.3-11.3 22.6 22.6-11.3 11.3-32 32-11.3 11.3-11.3-11.3-32-32-11.3-11.3z" })
  }
), TG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 96v32h416V96h48v96.7c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9V176H48v160h274.9c-1.9 10.4-2.9 21.1-2.9 32 0 5.4.2 10.7.7 16H48v32H0V96zm304 272a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), AG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0m48 0c0 46.4-12.3 89.8-33.9 127.4l33.2 32.1.7 96.5-96.6-.7-32.1-33.2C345.8 499.7 302.4 512 256 512c-46.5 0-90.2-12.4-127.8-34.1l-32.3 33.4H0v-95.9l33.6-32.5C12.2 345.5 0 302.2 0 256c0-46.4 12.3-89.9 33.9-127.4L0 95.9V0h95.9l32.8 33.9C166.1 12.3 209.6 0 256 0c46.2 0 89.5 12.2 126.9 33.6L415.4 0h95.9v95.9l-33.4 32.3C499.6 165.8 512 209.5 512 256m-144 0a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-272 0a160 160 0 1 1 320 0 160 160 0 1 1-320 0M80 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m0 384a16 16 0 1 0-32 0 16 16 0 1 0 32 0m368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16-400a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), DG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 120V96H0v320h48v-32h544v32h48V96h-48v32H48zm0 56h544v160H48z" })
  }
), yG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M501.1 0H640v48H528.2L413.1 238.3l8.7 6.1 19.4 13.6-13.3 19.6-109.2 160.7c-31.3 46.1-83.3 73.7-139 73.7H168C75.2 512 0 436.8 0 344V176h272v65.4l37-48.1 14-18.2 18.8 13.2 6.2 4.3L495 10.2zM48 224v120c0 66.3 53.7 120 120 120h11.7c39.8 0 77-19.7 99.3-52.6l95.9-141.3-41.9-29.3-66 85.8-43-14.6v-88z" })
  }
), bG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 56V32h-48v45.6L96 64v64l136-13.6V192H48v-32H0v320h48v-32h416v32h48V160h-48v32H280v-77.6L416 128V64L280 77.6zM48 400V240h416v160z" })
  }
), fG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 0v512H8V0z" })
  }
), UG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M13.2 459.2 0 512l52.8-13.2L512 384C512 171.9 340.1 0 128 0L13.2 459.2zm407.9-102C402.2 219.1 292.9 109.8 154.8 90.9L165 50c156 17.1 279.9 141 297 297zM374.2 369 66 446l77-308.2C264 152 360 248 374.2 369M192 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-64-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), GG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289.9 222.1 113.2-113.2L437 75c-11.4-11.4-23.8-21.7-37.1-30.7C358.9 16.3 309.3 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c53.3 0 102.9-16.3 143.9-44.2 13.3-9.1 25.8-19.4 37.1-30.7l-33.9-33.9-113.2-113.3L256 256zm-35.7 100c-8.4 3.8-14.2 12.2-14.2 21.9 0 13.3 10.7 24 24 24 9.8 0 18.2-5.8 21.9-14.2l32.2 32.2c-18.8 9-39.8 14-62.1 14-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-96 96-34 34 33.9 33.9 32.1 32.1zm87.6 87.6 23.4 23.4C333.5 452.7 296.1 464 256 464c-114.9 0-208-93.1-208-208S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zm155.3-44.5-23.4-23.4c14.2-25.4 22.3-54.7 22.3-85.8s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256l62.1-62.1c9 18.8 14 39.8 14 62.1m67.8 143.9c27.9-41 44.2-90.5 44.2-143.9s-16.3-102.9-44.2-143.9C522.7 98.8 512.4 86.3 501 75l-33.9 33.9-113.2 113.2L320 256l33.9 33.9 113.2 113.2L501 437c11.4-11.4 21.7-23.8 30.7-37.1zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-40 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), qG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 .1 17.5 18.7 72 76.8 6.5 6.9v83l53 34.3 11 7.1V464h112V357.1l-80-51.8v-57.2l117 75.7 11 7.1V512H0V330.9l11-7.1 117-75.7v57.2l-80 51.8V464h112V226.9l11-7.1 53-34.3v-83l6.5-6.9 72-76.8L320 .1zm-48 121.4V211.7l-11 7.1-53 34.3V464h64v-96c0-26.5 21.5-48 48-48s48 21.5 48 48v96h64V253.1l-53-34.3-11-7.1V121.5l-48-51.2z" })
  }
), WG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0h-32.3l9.3 30.9 37.6 125.2-60.8-16.2-27.5-68.8-4.6-11.4-11.9-3-64-16L0 33.3v170l8.7 7.2 112.7 93.4 4.1 3.4 5.1 1.4L455.1 395c36.1 9.6 74.2 8.5 109.6-3.2 40.2-13.3 51.3-64.8 20.2-93.5L553.1 269c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 276.9 12.2 270 0h-14zm72.9 183.5L216.3 48H242l107.1 190.4 5 8.8 9.8 2.6 113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.8 29.3c4.2 3.9 2.7 10.9-2.7 12.7-26.6 8.8-55.2 9.6-82.2 2.4L148 263.5 48 180.7v-86l22.3 5.6 27.4 68.6 4.5 11.2 11.6 3.1 113.9 30.4 41.5 11.1-12.3-41.2zM24 464H0v48h640v-48h-24zm168-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), EG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l91 52c-16.1 7.9-30.9 18.1-43.8 30.3l-83.1-47.5-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9-8.5 14-13 30.2-13 39.7v79.4l-12.1 6.9L48 285.9v34.3l145.4-41.5L224 270v110.1l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 91.8 28.3c12.5 19.9 29 37.2 48.2 50.7h-46.7l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H112V404l9.6-7.2L176 356v-22.5L30.6 375.1 0 383.8V258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8 29 8.3c-12.5 24.2-19.6 51.7-19.6 80.8 0 16.3 2.2 32 6.3 47l-36.7-27.6-9.6-7.2V269.9l30.6 8.7zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), OG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l91 52c-16.1 7.9-30.9 18.1-43.8 30.3l-83.1-47.5-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9-8.5 14-13 30.2-13 39.7v79.4l-12.1 6.9L48 285.9v34.3l145.4-41.5L224 270v110.1l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 91.8 28.3c12.5 19.9 29 37.2 48.2 50.7h-46.7l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H112V404l9.6-7.2L176 356v-22.5L30.6 375.1 0 383.8V258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8 29 8.3c-12.5 24.2-19.6 51.7-19.6 80.8 0 16.3 2.2 32 6.3 47l-36.7-27.6-9.6-7.2V269.9l30.6 8.7zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), IG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l91 52c-16.1 7.9-30.9 18.1-43.8 30.3l-83.1-47.5-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9-8.5 14-13 30.2-13 39.7v79.4l-12.1 6.9L48 285.9v34.3l145.4-41.5L224 270v110.1l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 91.8 28.3c12.5 19.9 29 37.2 48.2 50.7h-46.7l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H112V404l9.6-7.2L176 356v-22.5L30.6 375.1 0 383.8V258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8 29 8.3c-12.5 24.2-19.6 51.7-19.6 80.8 0 16.3 2.2 32 6.3 47l-36.7-27.6-9.6-7.2V269.9l30.6 8.7zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7 36.7-36.7z" })
  }
), NG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m176 33.4-8.7-3.1-8.5 3.6-96 40L20 91.6l39.2 24.7L192 199.9l-41 21.5-45.5-19.5-11.9-5.1-10.9 7.2-48 32-23.4 15.6 19.1 20.7 96 104 7.1 7.7h128.4l5.2-2.8 257.4-135.1c45.3-23.8 81.5-61.7 103.1-108 19.6-42-11-90.1-57.4-90.1h-50.7c-24.6 0-48.8 6-70.5 17.4L375.1 104 176 33.4zm-52.1 67 44.7-18.6 200.4 71 9.9 3.5 9.3-4.9 83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9h50.8c11.2 0 18.6 11.6 13.9 21.8-17.2 36.8-46 67-81.9 85.8L250.1 336h-95.6l-69.8-75.6 13.8-9.2 44.1 18.9 10.5 4.5 10.1-5.3 88.1-46.2 36.9-19.4-35.3-22.2L124 100.4zM24 464H0v48h640v-48h-24z" })
  }
), XG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 256c0-14.7-6.3-27.2-13.9-36.7-7.6-9.5-17.4-17.3-27.5-23.3-19.6-11.9-44.3-20-64.6-20h-99.5l-27.4-48H368V64h-61.5l-29.7-51.9L269.9 0H144.2l8.7 30.6L194.5 176H164l-40.8-54.4-7.2-9.6H-1.3l10.5 31.6L36.7 226C24.6 230.6 16 242.3 16 256s8.6 25.4 20.7 30L9.2 368.4-1.3 400H116l7.2-9.6L164 336h30.5l-41.6 145.4-8.7 30.6h125.7l6.9-12.1 29.7-51.9H368v-64h-24.9l27.4-48H470c20.2 0 44.9-7.8 64.5-19.6 18.5-11 41.5-31.3 41.5-60.4m-106-32c9.5 0 25.8 4.6 39.7 13 6.7 4.1 11.8 8.4 14.9 12.3 3.1 3.9 3.3 6.1 3.3 6.7 0 2.4-3 10.1-18.1 19.2-13.8 8.4-30 12.8-39.8 12.8H342.6l-6.9 12.1L242.1 464h-34.3l41.5-145.4L258 288H140l-7.2 9.6L92 352H65.3l29.5-88.4 2.5-7.6-2.5-7.6L65.3 160H92l40.8 54.4 7.2 9.6h118.1l-8.7-30.6L207.8 48h34.3l93.7 163.9 6.9 12.1h13.9z" })
  }
), KG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l96.7 55.3c-8.5 13.7-14.1 29.3-16 46.1l-116.6-66.6-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9-8.5 14-13 30.2-13 39.7v79.4l-12.1 6.9L48 285.9v34.3l145.4-41.5L224 270v110.1l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 88.9 27.4V428l-54.4-40.8-9.6-7.2V269.9l30.6 8.7 65.4 18.7v49.9l-48-13.7V356l48 36v120h-27.6l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H112V404l9.6-7.2L176 356v-22.5L30.6 375.1 0 383.8V258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zM528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H416V320h32z" })
  }
), QG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264-8h-21l-2.8 20.8-6.8 51.2H192v64h32.9l-7.1 53.1-76.6 7.5-5.4-39.8L133 128H39.6l-2.8 20.8-8 58.7C11.5 217 0 235.3 0 256s11.5 39 28.8 48.5l8 58.7 2.8 20.8H133l2.8-20.8 5.4-39.8 76.6 7.5 7.1 53.1H192v64h41.4l6.8 51.2L243 520h98l2.8-20.8 6.8-51.2H368v32h32v-48h16v-32h-16v-48h-32v32h-8.9l6.4-48h100.6c20.4 0 46.1-6.9 67-18.5 19.5-10.8 44-30.9 44-61.5 0-30.2-24.7-50.4-43.9-61.1-20.8-11.6-46.5-18.9-67.1-18.9H365.5l-6.4-48h8.9v32h32v-48h16V80h-16V32h-32v32h-17.4l-6.8-51.2L341-8h-21zm53.1 184H269.7l-1.2.1-1.7.2L285 40h14zm0 160L299 472h-14l-18.2-136.3 1.7.2 1.2.1h47.5zM74.4 228.3l7.1-52.3H91l5.7 41.9 3.1 22.9 23-2.3L272 224h194.2c11.1 0 28.9 4.5 43.7 12.8 16.3 9.1 19.3 17 19.3 19.2 0 2.8-3.1 10.6-19.2 19.5-14.7 8.1-32.5 12.5-43.8 12.5H272l-149.2-14.6-23-2.3-3.1 22.9-5.7 42h-9.5l-7.1-52.3-2.4-17.4-17.3-3-.7-.1c-3.5-.6-6-3.6-6-7.1s2.5-6.5 6-7.1l.7-.1 17.3-3 2.4-17.4z" })
  }
), ZG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M594.1 219.3c7.6 9.5 13.9 22 13.9 36.7 0 29.1-23 49.4-41.4 60.4-19.7 11.8-44.4 19.6-64.6 19.6h-39.9l158.8 123.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L218 146.5 184.9 30.6 176.2 0h125.7l6.9 12.1L402.5 176H502c20.3 0 45.1 8.1 64.6 20 10 6.1 19.9 13.8 27.5 23.3m-311.9-23L400.3 288H502c9.7 0 26-4.4 39.8-12.8C557 266.1 560 258.4 560 256c0-.6-.2-2.8-3.3-6.7-3.1-3.9-8.1-8.2-14.9-12.3-14-8.5-30.2-13-39.7-13H374.6l-6.9-12.1L274.1 48h-34.3l41.5 145.4.8 2.9zm26.6 303.6-6.9 12.1H176.2l8.7-30.6L226.5 336H196l-40.8 54.4-7.2 9.6H30.7l10.5-31.6L78.7 256 41.2 143.6l-6.8-20.5 68.6 54.1 23.7 71.2 2.5 7.6-2.5 7.6L97.3 352H124l40.8-54.4 7.2-9.6h71.7l37.9 29.8-.2.7L239.8 464h34.3L334 359.1l38.1 30z" })
  }
), JG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m-8 0 69.5 308.8-43.9 12.1L0 325.7v90.9l15.5 5.9 232 88 4.1 1.6H512V464H260.4L48 383.4v-21.1L259.2 304H512v-48H384L136 0zm224 352h-24v48h192v-48h-24z" })
  }
), jG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M283.3 13.9C292.8 6.3 305.3 0 320 0c29.1 0 49.4 23.1 60.4 41.4C392.2 61.1 400 85.8 400 106v51.5l163.9 93.7 12.1 6.9v125.7l-30.6-8.7-52.2-14.9 127.7 99.1 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 187.1 145.3 4.5-2.6V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zm-6.8 178 115 89.3 136.5 39v-34.3l-163.9-93.6-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C330.1 51 322.4 48 320 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9-8.5 14-13 30.2-13 39.7v79.4zM416 423.8l48 37.8V512h-43.6l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H176V404l9.6-7.2L240 356v-22.5L94.6 375.1 64 383.8V258.1l12.1-6.9 70-40 40.7 32-74.8 42.7v34.3L238.6 284l49.4 38.9V380l-9.6 7.2L224 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 88.9 27.4z" })
  }
), YG = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l163.9 93.7 12.1 6.9v125.7l-30.6-8.7L336 333.5V356l54.4 40.8 9.6 7.2v108h-43.6l-3.4-1.1-97-29.8-96.9 29.8-3.4 1.1H112V404l9.6-7.2L176 356v-22.5L30.6 375.1 0 383.8V258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6 6.1-10 13.8-19.9 23.3-27.5zM237 66.2c-8.5 14-13 30.2-13 39.7v79.4l-12.1 6.9L48 285.9v34.3l145.4-41.5L224 270v110.1l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 88.9 27.4V428l-54.4-40.8-9.6-7.2V269.9l30.6 8.7L464 320.2v-34.3l-163.9-93.6-12.1-6.9V106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8.2-6.7 3.3-3.9 3.1-8.2 8.1-12.3 14.9" })
  }
), _G = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M562.1 219.3c7.6 9.5 13.9 22 13.9 36.7 0 29.1-23 49.4-41.4 60.4-19.7 11.8-44.4 19.6-64.6 19.6h-99.5l-93.7 163.9-6.9 12.1H144.2l8.7-30.6L194.5 336H164l-40.8 54.4-7.2 9.6H-1.3l10.5-31.6L46.7 256 9.2 143.6-1.3 112H116l7.2 9.6L164 176h30.5L152.9 30.6 144.2 0h125.7l6.9 12.1L370.5 176H470c20.3 0 45.1 8.1 64.6 20 10 6.1 19.9 13.8 27.5 23.3M509.8 237c-14-8.5-30.2-13-39.7-13H342.6l-6.9-12.1L242.1 48h-34.3l41.5 145.4L258 224H140l-7.2-9.6L92 160H65.3l29.5 88.4 2.5 7.6-2.5 7.6L65.3 352H92l40.8-54.4 7.2-9.6h118.1l-8.7 30.6L207.8 464h34.3l93.7-163.9 6.9-12.1H470c9.7 0 26-4.4 39.8-12.8C525 266.1 528 258.4 528 256c0-.6-.2-2.8-3.3-6.7-3.1-3.9-8.1-8.2-14.9-12.3z" })
  }
), hq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M224 464c97.2 0 176-78.8 176-176 0-82.2-56.4-151.3-132.6-170.6L176 224l32 32h112v64l-56 104h-40v-72h-32v-64l-64-64H60c-7.7 19.8-12 41.4-12 64 0 97.2 78.8 176 176 176M0 288c0-52.3 17.9-100.5 48-138.6 1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288" })
  }
), cq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 26.4c1.7-12 1.2-18.3 1.2-18.3s-6.3-.4-18.3 1.2c-7.7 1.1-17.7 3-30 6.4-20.3 5.7-46.8 15.7-78.6 32.9 15.2 8.9 29.6 19.5 42.9 32 6.5-3.1 12.7-5.8 18.5-8.2l1.8-.8-.7 1.9c-5.7 14-13.5 30.3-24 48.8C377.3 76.9 320 48 256 48 141.1 48 48 141.1 48 256c0 64 28.9 121.3 74.4 159.4-18.4 10.5-34.8 18.3-48.8 24l-1.9.7.8-1.8c2.4-5.8 5.1-11.9 8.2-18.5-12.5-13.3-23.2-27.7-32-42.9-17.2 31.8-27.1 58.2-32.9 78.6-3.4 12.2-5.4 22.3-6.4 30-1.7 12-1.2 18.3-1.2 18.3s6.3.4 18.3-1.2c7.7-1.1 17.7-3 30-6.4 26.9-7.6 64.5-22.5 111.1-51.9 26.8 12.6 56.8 19.7 88.4 19.7 114.9 0 208-93.1 208-208 0-31.6-7.1-61.6-19.7-88.5 29.3-46.6 44.3-84.2 51.9-111.1 3.4-12.2 5.4-22.3 6.4-30zM388 165.6c-24.3 34.9-57.3 75.2-102.3 120.2s-85.2 78-120.2 102.3C123.6 359.2 96 310.8 96 256c0-88.4 71.6-160 160-160 54.8 0 103.2 27.6 132 69.6M215.8 410.9c31.6-23.8 66.4-53.7 103.9-91.2s67.4-72.3 91.2-103.9c3.3 12.8 5.1 26.3 5.1 40.2 0 88.4-71.6 160-160 160-13.9 0-27.3-1.8-40.2-5.1z" })
  }
), sq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64v18.7c-33.9 8-56 33.6-56 72.4 0 29.3 35.8 79.4 80 116.9 44.2-37.5 80-88 80-116.9 0-38.8-22.1-64.4-56-72.4V112C456 50.1 405.9 0 344 0S232 50.1 232 112v36.1c-18.1-12.7-40.2-20.1-64-20.1-61.9 0-112 50.1-112 112v18.7c-33.9 8-56 33.6-56 72.4 0 29.3 35.8 79.4 80 116.9 44.2-37.5 80-88 80-116.9 0-38.8-22.1-64.4-56-72.4V240c0-35.3 28.7-64 64-64s64 28.7 64 64v272h48V240zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2 1 .1 2 .2 3.1.2s2.1-.1 3.1-.2c12.3.5 19.1 4.3 22.3 7.2 2.9 2.6 6.7 7.9 6.7 19.8 0-.2 0-.1-.2.4-.7 2.2-3.6 11.4-14.7 27.5-4.9 7.1-10.7 14.5-17.1 21.8-6.4-7.3-12.2-14.7-17.1-21.7-11.4-16.4-14.1-25.7-14.7-27.7-.1-.4-.1-.5-.1-.3 0-11.9 3.8-17.1 6.7-19.8zM464 203.1c0-.2 0-.1-.2.4-.7 2.2-3.6 11.4-14.7 27.5-4.9 7.1-10.7 14.5-17.1 21.8-6.4-7.3-12.2-14.7-17.1-21.7-11.4-16.4-14.1-25.7-14.7-27.7-.1-.4-.1-.5-.1-.3 0-11.9 3.8-17.1 6.7-19.8 3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8z" })
  }
), vq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 16v152c0 4.4 3.6 8 8 8h8V16h48v160h8c4.4 0 8-3.6 8-8V16h48v152c0 30.9-25.1 56-56 56h-8v272H64V224h-8c-30.9 0-56-25.1-56-56V16zm592 0v480h-48V320h-80V160c0-74.8 43.7-111.3 80-128.8C617.9 18.8 640 16 640 16m-48 176V87.3c-17.2 13.6-32 35.1-32 72.7v112h32v-56zM336 32c60.2 0 114.9 23.8 155.2 62.4-6.5 17.4-10.6 37.4-11.1 60.4C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2v-63C244.3 46.8 288.4 32 336 32m0 400c61.8 0 116.1-31.8 147.5-80h54.9c-36 75.7-113.1 128-202.4 128-81.5 0-152.8-43.5-192-108.6V252.7c5.7-1.6 11.1-3.8 16.3-6.4-.2 3.2-.3 6.5-.3 9.7 0 97.2 78.8 176 176 176m80-176a80 80 0 1 0-160 0 80 80 0 1 0 160 0m-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0" })
  }
), eq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 32c44.2 0 80 35.8 80 80v32h-16c-44.2 0-80-35.8-80-80V32zM56 64h72v48H32V64zm-32 72h136v48H0v-48zm8 72h96v48H32zM272 32h16c44.2 0 80 35.8 80 80v32h-16c-44.2 0-80-35.8-80-80zm-96 0c44.2 0 80 35.8 80 80v32h-16c-44.2 0-80-35.8-80-80V32zm304 144v32c0 44.2-35.8 80-80 80h-16v-32c0-44.2 35.8-80 80-80zm-128 0h16v32c0 44.2-35.8 80-80 80h-16v-32c0-44.2 35.8-80 80-80m-96 0v32c0 44.2-35.8 80-80 80h-16v-32c0-44.2 35.8-80 80-80zM128 432h256v-25.7l30-12.1c13.6-5.5 25.4-14.6 34-26.2H64c8.7 11.6 20.4 20.7 34 26.2l30 12.1zm-48 6.7c-32.1-13-57.7-38.6-70.7-70.7-6-14.8-9.3-31-9.3-48h512c0 17-3.3 33.2-9.3 48-13 32.1-38.6 57.7-70.7 70.7V480H80z" })
  }
), lq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 448V64l48 36 168 126 40 30-40 30-168 126zm176-192-128-96v192zM432 88v360h-48V64h48zm144 0v360h-48V64h48z" })
  }
), tq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32V480l48-28 288.4-168.2L384 256l-47.6-27.8L48 60zm48 83.6L288.7 256 48 396.4V115.6z" })
  }
), wq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h32v-48H32zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288m24-224-10.7 64H512l-104 96 10.7-64H352z" })
  }
), gq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h32v-48H32zm552 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), iq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h32v-48H32zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-64h-32v-32h32zm0-176v112h-32V272z" })
  }
), mq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h32v-48H32zm552 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-64 16H352v-32h160z" })
  }
), aq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h32v-48H32zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h64v32h-64v64h-32v-64h-64v-32h64v-64h32z" })
  }
), oq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m214.6-48L480 297.4l-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7 36.7-36.7zM120 0v112H72V0zm192 0v112h-48V0zM0 144h384v48h-32v19.2c-18 9.2-34.2 21.4-48 36V192H80v64c0 61.9 50.1 112 112 112 24.3 0 46.9-7.8 65.2-20.9-.8 6.9-1.2 13.9-1.2 20.9 0 11.4 1.1 22.5 3.1 33.3-13.5 6.2-28 10.7-43.1 12.9V512h-48v-97.8C91 402.6 32 336.2 32 256v-64H0z" })
  }
), nq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 24V0H72v112h48zm192 0V0h-48v112h48zM24 144H0v48h32v64c0 80.2 59 146.6 136 158.2V512h48v-97.8c77-11.6 136-78 136-158.2v-64h32v-48H32zm168 224c-61.9 0-112-50.1-112-112v-64h224v64c0 61.9-50.1 112-112 112" })
  }
), rq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488 232h24v48H280v232h-48V280H0v-48h232V0h48v232z" })
  }
), dq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 32V8h-48v144H24v48h144v144h48V200h144v-48H216zM8 464v48h368v-48H32z" })
  }
), Sq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 72V48h-48v184H16v48h184v184h48V280h184v-48H248z" })
  }
), zq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316 374.1c50.4-31 84-86.6 84-150.1 0-97.2-78.8-176-176-176S48 126.8 48 224c0 63.5 33.6 119.1 84 150l8.3 57.8C58 398.6 0 318.1 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224c0 94.1-58 174.6-140.2 207.8l8.3-57.8zm3.3-42.1-6.3-8-23.7-29.6c18.9-17.5 30.7-42.6 30.7-70.4 0-53-43-96-96-96s-96 43-96 96c0 27.8 11.8 52.9 30.7 70.4L135 324l-6.3 7.9C98.8 305.5 80 267 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 43-18.8 81.5-48.7 107.9zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-64 184 32-40h64l32 40-24 168h-80zm77.5 13.8-4.6-5.8h-17.8l-4.6 5.8 13.5 94.8z" })
  }
), pq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0H176v24h-8c-48.6 0-88 39.4-88 88v32H0v48h448v-48H128v-32c0-22.1 17.9-40 40-40h8v24h112c26.5 0 48-21.5 48-48S314.5 0 288 0M47.3 224 80 512h288l32.7-288h-48.3l-27.3 240H122.9L95.6 224zm201.6 85.8L224 256l-24.8 53.8-58.9 7 43.5 40.2-11.6 58.1 51.7-29 51.7 29L264 357l43.5-40.2-58.9-7z" })
  }
), Mq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0h112c26.5 0 48 21.5 48 48s-21.5 48-48 48H176V72h-8c-22.1 0-40 17.9-40 40v32h320v48H0v-48h80v-32c0-48.6 39.4-88 88-88h8zM80 512 47.3 224h48.3l27.3 240h202.2l27.3-240h48.3L368 512z" })
  }
), xq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0v32h112v32h32v400h32v48H0v-48h32V64h32V32h112V0zM80 464h224V112H80zm24-328h32v32h-32zm0 48h32v32h-32zm80-48v32h-32v-32zm-32 48h32v32h-32zm80-48v32h-32v-32zm0 48v32h-32v-32zm16-48h32v32h-32zm32 48v32h-32v-32zm-176 48h80v80h-80z" })
  }
), Hq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m464 32v64H480V80zM272 32h-48v160h416V32h-48zm320 336v64H352v-64zm-320-48h-48v160h416V320h-48zM80 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96M32 128 0 224h160l-32-96zm128 384-32-96H32L0 512z" })
  }
), Vq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254.3 22.9c45.2 31.3 55.3 91.5 37.8 147.5 45.1-35.8 103.7-47.5 148.6-15.3 64.5 45.8 71.6 140 25.7 207.9-79.8 117.7-247.2 178.8-367.8 92.3l13.9-19.3-13.9 19.4C-21.6 369.5-25.7 190 54 72.3l19.8 13.3L54 72.2C100 3.7 189.2-23 254.3 22.9m-27.4 39c-38.1-27-98.4-15-133.3 37l-.1.1c-69.9 103.2-60.2 251.1 32.8 317.6 91.8 65.8 230.5 23 300.4-80.2 35.1-51.8 24.9-115.1-13.7-142.4l-.1-.1c-25.9-18.6-74.1-11.6-112.2 34.5l-14.2 17.2-18.1-13.1-26.2-18.9-17.2-12.3 10.2-18.5c29.2-53 18.4-102.4-8.1-120.7l-.2-.2z" })
  }
), Cq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M161.2 0h33.6c58.8 0 132.5 41.8 140.5 121.2 28.9 14.5 48.7 44.3 48.7 78.8v6.6c37.4 14.4 64 50.7 64 93.2V400H341l11-8.3V352h48v-52.2c0-25.9-19-47.3-43.7-51.2l-20.3-3.2V200c0-18.6-12.7-34.3-30-38.7l-18.7-4.8.7-19.3v-1.5c0-40.2-26.7-68.8-58.4-81 1.3 5.6 2.4 11.6 2.4 16.8 0 37.8-19.4 60.9-38.8 73.5-18.2 11.9-36.2 14.6-37.8 14.8l-1.7.2H152c-22.1 0-40 17.9-40 40v45.4l-20.3 3.2C67 252.5 48 274 48 299.8V352h16v48H0V299.8c0-42.5 26.6-78.8 64-93.2V200c0-47.8 38.1-86.7 85.6-88 2.8-.6 10.2-2.6 17.5-7.3 8.6-5.6 17-14.8 17-33.3 0-.3-.2-1.5-.7-4-.6-2.8-1.5-6.1-2.6-9.9-2.2-7.4-4.9-15.2-7-21.1l-.1-.2v-.1c-.5-1.6-1.1-3.1-1.5-4.3zM184 384H96v-24l176-136-40 128h88v24L144 512z" })
  }
), Lq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 0h-44.8L212 37.3l5.7 8.5 14.3-9.5-14.3 9.5c4.1 6.1 6.3 13.4 6.3 20.7v8.1c0 16.2-13.1 29.3-29.3 29.3h-17.8c-6.1 0-12.1.8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 2 .1 4.1.2 6.1C46.9 226.3 24 260.5 24 300c0 12.2 2.2 23.9 6.2 34.7C11.6 353.5 0 379.4 0 408v104h512V408c0-28.6-11.6-54.5-30.2-73.3 4-10.8 6.2-22.5 6.2-34.7 0-39.5-22.9-73.7-56.2-89.9.1-2 .2-4 .2-6.1 0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0m40 66.6c0-3.7-.2-7.3-.7-10.9 33.3 13.6 58 44 63.5 80.7l2.1 14 13.2 4.9C370 162.6 384 181.7 384 204c0 5.2-.8 10.3-2.2 15l-7.4 24.6 25.1 5.7c23.2 5.2 40.5 26 40.5 50.7 0 10.4-3 20-8.2 28.1l-12.9 20 19.9 13.1c15.2 10 25.2 27.3 25.2 46.8v56H48v-56c0-19.5 10-36.8 25.3-46.8l19.9-13.1-12.9-20C75 320 72 310.4 72 300c0-24.7 17.3-45.5 40.5-50.7l25.1-5.7-7.4-24.6c-1.4-4.7-2.2-9.7-2.2-15 0-25.1 17.8-46 41.4-50.9l.6-.1.6-.2c2-.5 4.1-.8 6.3-.8h17.8c42.7 0 77.3-34.6 77.3-77.3zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 128c64 0 96-64 96-64H160s32 64 96 64" })
  }
), Bq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m120-56a136 136 0 1 1 272 0 136 136 0 1 1-272 0m173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2-11.5 10.3-18.7 25.2-18.7 41.8 0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8M240 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), uq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M187.2 0H232c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 2-.1 4.1-.2 6.1 33.3 16.2 56.2 50.4 56.2 89.9 0 12.2-2.2 23.9-6.2 34.7 18.6 18.8 30.2 44.7 30.2 73.3v104H0V408c0-28.6 11.6-54.5 30.2-73.3-4-10.8-6.2-22.5-6.2-34.7 0-39.5 22.9-73.7 56.2-89.9-.1-2-.2-4-.2-6.1 0-48.1 33.9-88.2 79.1-97.8 5.7-1.4 11.7-2.2 17.8-2.2h17.8c16.2 0 29.3-13.1 29.3-29.3v-8.1c0-7.4-2.2-14.6-6.3-20.7l14.3-9.6-14.3 9.5-5.7-8.5zm84.1 55.7c.5 3.6.7 7.2.7 10.9v8.1c0 42.7-34.6 77.3-77.3 77.3h-17.8c-2.2 0-4.3.3-6.3.8l-.6.2-.6.1C145.8 158 128 178.9 128 204c0 5.2.8 10.3 2.2 15l7.4 24.6-25.1 5.7C89.3 254.5 72 275.3 72 300c0 10.4 3 20 8.2 28.1l12.9 20-19.8 13.1C58 371.2 48 388.5 48 408v56h416v-56c0-19.5-10-36.8-25.3-46.8l-19.9-13.1 12.9-20c5.3-8.1 8.3-17.7 8.3-28.1 0-24.7-17.3-45.5-40.5-50.7l-25.1-5.7 7.4-24.6c1.4-4.7 2.2-9.7 2.2-15 0-22.3-14-41.4-33.8-48.7l-13.2-4.9-2.1-14c-5.5-36.7-30.2-67.1-63.5-80.7z" })
  }
), Rq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 156c0 1.3.1 2.7.2 4h383.6c.1-1.3.2-2.7.2-4 0-20.9-14.5-38.3-34-42.9 1.3-4.2 2-8.6 2-13.1 0-24.3-19.7-44-44-44-1.9 0-3.7.1-5.6.3C329.3 37.7 312.3 24 292 24c-8.5 0-16.5 2.4-23.2 6.6C261.8 12.7 244.4 0 224 0s-37.8 12.7-44.8 30.6c-6.7-4.2-14.7-6.6-23.2-6.6-20.3 0-37.3 13.7-42.4 32.3-1.8-.2-3.7-.3-5.6-.3-24.3 0-44 19.7-44 44 0 4.6.7 9 2 13.1-19.5 4.5-34 22-34 42.9m85.5 308-56-224h39.8l46.1 192h32.9l-46.1-192H208v192h32V240h73.8l-46.1 192h32.9l46.1-192h39.8l-56 224zM224 192H0l12 48 68 272h288l68-272 12-48h-49.5z" })
  }
), $q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160v176h88V160h48v176h88zM136 384H0V160C0 71.6 71.6 0 160 0s160 71.6 160 160v224H184v128h-48v-24z" })
  }
), kq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0H64v24c0 45.1 21.2 69 37.7 87.5l.4.4c15.4 17.4 25.9 29.6 25.9 56.1v24h48v-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24zm112 0h-48v24c0 45.1 21.2 69 37.7 87.5l.4.4c15.4 17.4 25.9 29.6 25.9 56.1v24h48v-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24zm16 464v-20.9l-26.7-13.2c-55.1-27.3-93.9-82.4-97.8-147.5l-.6-10.3h410.2l-.6 10.3c-3.8 65.1-42.7 120.3-97.8 147.5L400 443.1V464zM65.9 256H16v48h53.5c10.7 74.6 57.9 136.9 122.5 168.9V512h256v-39.1c64.6-32 111.8-94.3 122.5-168.9H624v-48h-49.9l1.9-32H64zM432 112c-50.7 0-93.6 33.7-107.4 80h214.8c-13.8-46.3-56.6-80-107.4-80" })
  }
), Pq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m129.9 241.9 4.2-4.2 3-5.1L179 163l69.7-41.8 5.1-3 4.2-4.2 36.9-37c18.6-18.6 43.8-29 70.1-29 54.7 0 99.1 44.4 99.1 99.1 0 26.3-10.4 51.5-29 70.1l-4.9 4.9-4.8 4.8-3.3 5.9L350 362.3l-96.9 41.5-8.5 3.6-6.5 6.5-21 21.1c-18.6 18.6-43.8 29-70.1 29-54.6 0-99-44.4-99-99.1 0-26.3 10.4-51.5 29-70.1l52.9-52.9zM224 80l-80 48-48 80-52.9 52.9C15.5 288.5 0 325.9 0 364.9 0 446.2 65.8 512 147.1 512c39 0 76.4-15.5 104-43.1L272 448l112-48 80-144 4.9-4.9c27.6-27.6 43.1-65 43.1-104C512 65.8 446.2 0 364.9 0c-39 0-76.4 15.5-104 43.1zm152 88h-48v48h48zm-160 64h-48v48h48zm-80 128v48h48v-48z" })
  }
), Fq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v288h48v-24zM56 262c0-63.4 30.7-119.7 78.2-154.7l-28.4-38.6C46.5 112.3 8 182.7 8 262c0 132.6 107.5 240 240 240s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3l-28.5 38.6c47.5 35 78.2 91.2 78.2 154.7 0 106-86 192-192 192S56 368 56 262" })
  }
), Tq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v32H48V48zM48 0H0v128h384V0h-48zM32 160v352h320V160h-48v304H80V160zm133.3 64v53.3H112v53.3h53.3V384h53.3v-53.3H272v-53.4h-53.3V224z" })
  }
), Aq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v32H48V48zM48 0H0v128h384V0h-48zM32 160v352h298.8c-18.3-12.9-34.1-29.2-46.3-48H80v-48h80v-48H80v-48h80v-48H80v-48h80v-48H80v-16zm320 0h-48v87.2c13.8-14.6 30-26.8 48-36zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192m0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288m-32-209.9L366.1 336l17 17 64 64 17 17 33.8-34-17-17-64-64-17-17z" })
  }
), Dq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v32H48V48zM48 0H0v128h384V0h-48zM32 160v352h320V160h-48v304H80v-48h80v-48H80v-48h80v-48H80v-48h80v-48H80v-16z" })
  }
), yq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v320h48v-96h78.1l128 128-107.9 107.8-17 17 33.9 33.9 17-17L288 385.9l107.8 107.9 17 17 33.9-33.9-17-17L321.9 352l107.9-107.8 17-17-33.9-33.9-17 17L288 318.1l-95.3-95.3c53.9-8.1 95.3-54.6 95.3-110.8C288 50.1 237.9 0 176 0zm152 176H48V48h128c35.3 0 64 28.7 64 64s-28.7 64-64 64" })
  }
), bq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h576V0h-24zm8 80v272h232v46.1l-61.8 61.8-17 17 33.9 33.9 17-17 51.9-51.9 51.8 51.8 17 17 33.9-33.9-17-17-61.7-61.7V352h232V80h-48v224H80V80z" })
  }
), fq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2h3.8c42 0 76 34 76 76v5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9-15.6 22-18 25.4-12.9 18.2-4.5 6.3-9.2 13 26.1 18.5 9.2-13.1 9.3-13.2 10.4-14.6 17 5.8c20.3 7 42.2 10.8 65 10.8 11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9.3-7.9.4-11.9.4-9.2 0-18.3-.7-27.2-2.2l-38-6.2 22.2-31.4 23.3-32.9 19.6-27.6 19.6 27.6 11.5 16.3 11.8 16.6 22.2 31.4 16.9 23.8 10.3 14.6 9.3 13.1 9.2 13.1 26.2-18.4-9.3-13.1-4.5-6.3-12.9-18.2 17.3-14.2c44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80H348c-29.3 0-55.8 11.6-75.3 30.6L256 126.8l-16.7-16.3C219.8 91.6 193.3 80 164 80h-3.8C102.7 80 56 126.7 56 184.2M81.2 360C36.1 315.1 8 253 8 184.2 8 100.1 76.1 32 160.2 32h3.8c34.4 0 66.2 11.2 92 30 25.8-18.9 57.6-30 92-30h3.8c84 0 152.2 68.1 152.2 152.2 0 68.7-28.1 130.9-73.2 175.8l15.3 21.6 13.9 19.6-19.7 13.8-65.3 46.2-19.6 13.9-13.9-19.6-1.8-2.6-20.6-29.1c-20.1 5.4-41.3 8.2-63.1 8.2s-43-2.8-63.2-8.1l-22.5 31.7-13.9 19.6-19.6-13.9-65.2-46.2L52 401.2l13.9-19.6 1.9-2.6 13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1V188c0-15.5-12.5-28-28-28h-3.8c-13.4 0-24.2 10.8-24.2 24.2m184 3.8v5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3 0-13.4-10.8-24.2-24.2-24.2H348c-15.5 0-28 12.5-28 28zm28-76h3.8c39.9 0 72.2 32.3 72.2 72.2 0 49.4-21.5 93.9-55.5 124.6l-20.1 18.1-15.6-22-45.9-64.9c-9.7-13.7-14.9-30.1-14.9-46.9V188c0-42 34-76 76-76" })
  }
), Uq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 48v112h-48V0h320l64 64v96h-48V83.9L428.1 48zm119.3 320H192v96h186.2c21.1 10.2 44.8 16 69.8 16 16.7 0 32.8-2.6 48-7.3V512H144V400H64V192h288c-17.2 12.9-31.7 29.3-42.6 48H112v112h32v-32h144c0 16.7 2.6 32.8 7.3 48M448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426c-20.5 14-45.3 22.1-72 22.1z" })
  }
), Gq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M482.7 352H528V240H338.5zM276.6 192H576v208h-31.4l76.4 59.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L128 76.6V0h320l64 64v96h-48V83.9L428.1 48H176v65.9zm-93.9 48H112v112h32v-32h140.3l60.9 48H192v96h256v-15l48 37.8V512H144V400H64V192h57.8z" })
  }
), qq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 160V48h252.1L400 83.9V160h48V64L384 0H64v160zm272 208v96H128v-96zm-256-48H80v32H48V240h416v112h-32v-32h-48zm304 80h80V192H0v208h80v112h352v-48z" })
  }
), Wq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 24V0h-48v128h48v-24zM265 39l-17-17-33.9 34 17 17 56 56 17 17 33.8-34L321 95zm304 34 17-17-34-33.9L535 39l-56 56-17 17 34 33.9 17-17 56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1-224 0m272 0c0-29.1-7.8-56.5-21.4-80H592v160h-53.4c13.6-23.5 21.4-50.9 21.4-80M400 480c36 0 69.3-11.9 96-32h16v64h48v-64h80V192H496c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H0v256h80v64h48v-64h176c26.7 20.1 60 32 96 32M240 320c0 29.1 7.8 56.5 21.4 80H48V240h213.4c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Eq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h136v40h73.9l7 7 56 56 17 17-33.9 33.9-17-17-49-49h-54v40h-48V48h-64v80h-48V0zM80.1 512H32l3.3-48L56 160h272l20.7 304 3.3 48h-48.1zm220.5-48-17.4-256H100.8L83.4 464zM216 296v16h40v48h-40v40h-48v-40h-40v-48h40v-40h48z" })
  }
), Oq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0h160v40h73.9l7 7 56 56 17 17-33.9 33.9-17-17-49-49h-54v40h-48V48h-64v80h-48V24zM80.1 512H32l3.3-48L56 160h272l20.7 304 3.3 48h-48.1zm220.5-48-17.4-256H100.8L83.4 464zM192 272l43.7 54.2c7.9 9.8 12.3 22 12.3 34.7 0 30.5-24.7 55.2-55.2 55.2h-1.7c-30.5 0-55.2-24.7-55.2-55.2 0-12.6 4.3-24.9 12.3-34.7z" })
  }
), Iq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0H64v48h32v160H48v-32H0v256h48v-32h272v-48H48v-96h96V48h96v208h80v-48h-32V48h32V0H120zm312 185.7 62.5-41.7H592v320H462.5L400 422.3zM448 96l-96 64v288l96 64h192V96h-48zm0 112v32h112v-32h-96zm0 80v32h112v-32h-96zm0 80v32h112v-32h-96z" })
  }
), Nq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 118.1V32L288 0l-57.7 115.3c-27.7 11.4-51.4 30.7-68 55.1l39.7 27c18.8-27.4 50.3-45.4 86-45.4s67.2 18 86 45.5l39.7-27C398.3 148 377 129.8 352 118.1m-210.7 26.8c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6 20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6 45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7 17.9 11.6 33.6 26.3 46.4 43.2 21.7 3.5 42.9 17.9 60.1 42.7 20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4c-20 28.9-45.4 43.6-70.7 43.6-18 0-35.8-7.4-51.9-21.9L356 427.6l-16.1 14.5C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9L220 427.6l-16.1 14.5C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z" })
  }
), Xq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 64h192v49.3l-8.2 7.2c-5.4 4.7-7.8 10.3-7.8 15.5 0 9.9 10.7 24 32 24s32-14.1 32-24c0-5.3-2.4-10.8-7.8-15.5l-8.2-7.2V64h192v118.6c10.9-8.9 24.5-14.6 40-14.6 22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.5 0-29.1-5.8-40-14.6V448H336v-49.3l8.2-7.2c5.4-4.7 7.8-10.3 7.8-15.5 0-9.9-10.7-24-32-24s-32 14.1-32 24c0 5.3 2.4 10.8 7.8 15.5l8.2 7.2V448H112V329.4c-10.9 8.8-24.5 14.6-40 14.6-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.5 0 29.1 5.8 40 14.6V88zm48 48v128H95.9l-7-11.6C83.2 218.8 76.5 216 72 216c-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9S68 296 72 296c4.5 0 11.2-2.8 16.9-12.4l7-11.6H160v128h84.5c-2.9-7.4-4.5-15.5-4.5-24 0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H480V272h64.1l7 11.6c5.8 9.6 12.4 12.4 16.9 12.4 4 0 9.5-2.1 14.7-9.1S592 269 592 256s-4-23.8-9.3-30.9S572 216 568 216c-4.5 0-11.2 2.8-16.9 12.4l-7 11.6H480V112h-84.5c2.9 7.4 4.5 15.5 4.5 24 0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24z" })
  }
), Kq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.1 57.3c-7 5.2-9.1 10.7-9.1 14.7 0 4.5 2.8 11.2 12.4 16.9l11.6 7V144H48v60.5c7.4-2.9 15.5-4.5 24-4.5 43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5V464h108.5c-2.9-7.4-4.5-15.5-4.5-24 0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H368V296h48.1l7 11.6c5.8 9.6 12.4 12.4 16.9 12.4 4 0 9.5-2.1 14.7-9.1S464 293 464 280s-4-23.8-9.3-30.9S444 240 440 240c-4.5 0-11.2 2.8-16.9 12.4l-7 11.6H368V144H248V95.9l11.6-7C269.2 83.2 272 76.5 272 72c0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3m-28.8-38.4C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24H416v100.9c7.3-3.1 15.4-4.9 24-4.9 22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9V512H248v-49.3l8.2-7.2c5.4-4.7 7.8-10.3 7.8-15.5 0-9.9-10.7-24-32-24s-32 14.1-32 24c0 5.3 2.4 10.8 7.8 15.5l8.2 7.2V512H0V296h49.3l7.2 8.2c4.7 5.4 10.3 7.8 15.5 7.8 9.9 0 24-10.7 24-32s-14.1-32-24-32c-5.3 0-10.8 2.4-15.5 7.8l-7.2 8.2H0V96h148.9c-3.1-7.3-4.9-15.4-4.9-24 0-22.5 12.2-41 28.3-53.1" })
  }
), Qq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0v208h-80v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16h-64v-64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V0zM0 240V64h224v80h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v80h-64v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H48v176h176v-48h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-64h80v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h80v224H0V288z" })
  }
), Zq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0 97.2 78.8 176 176 176 31 0 60.1-8 85.4-22.1L194.9 256h59.8l93 125.1C380 349.2 400 304.9 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256m290.2 192.7C304.8 468.6 265.7 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 64.7-27.5 123.1-71.4 163.9l68.5 92.1h-59.8l-47-63.3z" })
  }
), Jq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v96h96V80zM0 32h192v192H0V80zm48 304v96h96v-96zM0 288h192v192H0V336zM400 80h-96v96h96zm-96-48h144v192H256V32zm80 416v32h-32v-32zm32 0h32v32h-32zm32-160v128h-96v-32h-32v96h-64V288h96v32h64v-32zM120 104v48H72v-48zM72 360h48v48H72zm304-256v48h-48v-48z" })
  }
), jq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80c-44.2 0-80 35.8-80 80v16H16v-16C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v7.4c0 38.2-18.2 74.2-49 96.8l-71 52V352h-48v-60.2l9.8-7.2 80.8-59.2a72 72 0 0 0 29.4-58.1V160c0-44.2-35.8-80-80-80zm48 336v64h-64v-64z" })
  }
), Yq = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 216C0 149.7 53.7 96 120 96h40v48h-40c-39.8 0-72 32.2-72 72v8h144v192H0V224zm48 56v96h96v-96zm352 0h-96v96h96zm-144 48V216c0-66.3 53.7-120 120-120h40v48h-40c-39.8 0-72 32.2-72 72v8h144v192H256v-48z" })
  }
), _q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 296c0 66.3-53.7 120-120 120h-40v-48h40c39.8 0 72-32.2 72-72v-8H256V96h192v192zm-48-56v-96h-96v96zm-352 0h96v-96H48zm144-48v104c0 66.3-53.7 120-120 120H32v-48h40c39.8 0 72-32.2 72-72v-8H0V96h192v48z" })
  }
), hW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h32v48H96c-26.5 0-48 21.5-48 48h96v144H0v-96zm48 48v48h48v-48zm128-48c0-53 43-96 96-96h32v48h-32c-26.5 0-48 21.5-48 48h96v144H176v-96zm48 72v24h48v-48h-48zm352 248c0 53-43 96-96 96h-32v-48h32c26.5 0 48-21.5 48-48h-96V272h144v96zm-48-48v-48h-48v48zm-128 48c0 53-43 96-96 96h-32v-48h32c26.5 0 48-21.5 48-48h-96V272h144v96zm-48-72v-24h-48v48h48z" })
  }
), cW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h48V304h109.6l106 176h56L211.9 301.1C273.6 288.3 320 233.5 320 168c0-75.1-60.9-136-136-136zm152 224H48V80h136c48.6 0 88 39.4 88 88s-39.4 88-88 88z" })
  }
), sW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m501.8 167.2-21.9-17.8-6.6-5.4h-2c-18.7-50.8-60.9-89.9-113.8-104.4l-12.2-3.3-9.7-2.6-8.7 5-27.6 16L283 64l5.4 18.2 13.8 46.3c1.2 4 2.5 8 4 11.9l-57.1-20.8c-13.8-5-28.4-7.6-43.1-7.6h-12.3c-30.1 0-57.5 11.7-77.9 30.9C103.7 133.5 88.5 128 72 128c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2 6 14.1 14.8 27 26.1 37.8l41.6 39.8-43.7 33.7-31.7 24.4-19 14.6 14.6 19 24.1 31.3 7.2 9.4h86.4l6.5-5 49.2-37.9 21.1 20.2 7 6.7H480V352h96V227.7l-8.8-7.2-41.1-33.5c13.7-52.6-2.2-108.6-41.8-146.2L475 32l-28.5 3.3-3.5 12.2c-1 3.4-1.8 6.9-2.5 10.3 28.6 25.3 49.6 59 59.3 97.3 1 4 1.7 8.1 2 12.1M215.2 403.6l-37 28.4h-46.4l-2.3-2.9 12.7-9.8 49.6-38.1 23.4 22.4zM72 176c6.4 0 12.2 2.5 16.5 6.5-5.1 12.4-8.1 25.9-8.4 40.1-2.5.9-5.2 1.4-8 1.4-13.3 0-24-10.7-24-24s10.7-24 24-24zm270.3-90.8 2.5.7c42 11.5 74.5 44.7 85.1 86.8l3.8 22.1 22.4-2.4.5-.1 71.4 58.2V304H382.1l-7 7-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8-11.6 46.6 23.3 5.8c32.1 8 54.5 36.8 54.5 69.8v37h112v32H297.6L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5 0-36.3 29.4-65.7 65.7-65.7H206c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1 23.3-41.2c-17.6-14.3-30.7-33.7-37.3-55.8l-8.4-28.1 2.5-1.5zM480 256a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), vW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h-20.8l-2.9 20.6-3.8 26.4c-7.8 54.3 8.4 108.9 43.5 150.1v20.6c-66.8 20.7-119.8 73-141.4 139.4-8.3-3.3-17.2-5.1-26.6-5.1-39.8 0-72 32.2-72 72s32.2 72 72 72c5.5 0 10.9-.6 16-1.8V512H509.9L488 475.7l-17.1-28.6L385 304h87V179.7l-8.8-7.2-59.2-48.2c-6.1-4.9-12.5-9.3-19.3-13 10.8-26.9 14.5-56.5 10.3-86L391.4 0h-40l-11.1 11c-5.8 5.7-11.1 11.9-15.8 18.3 14.7 21.4 25.1 45.4 30.7 70.4-8.4-2.1-17-3.4-25.7-3.7-8.2-29.3-23.8-56.6-46.2-78.8L272.9 7l-7-7H256zM88.7 406.7c-.4 5.7-.7 11.4-.7 17.3v17.9c-4.2 3.8-9.9 6.1-16 6.1-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7m231.3 31V464H136v-40c0-80.8 57-148.2 133-164.3l19-4V178.3l-6.6-6.9c-29.6-31.3-43.6-74.6-37.4-117.6l.8-5.8h1.3l3.4 3.4 3.3-3.4-3.3 3.4c20.4 20.2 33.2 46.2 37.2 73.7l3.8 25.9 25.5-6c2.7-.6 5.5-1 8.5-1 17.9 0 35.3 6.2 49.3 17.5l50.3 41V256H336v59.5l3.4 5.7L425.1 464h-37.4l-19.2-32-4-6.6-17.8-29.7-12.2-20.4-14.5-24.2-.9-1.4-21.7 20.6-21.5 20.4-43.7 41.3H320zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), eW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296 0h-81.9l-4.4 8.8-16 32-3 5.9 2.1 6.3L207 95.5l-33.6 41.4-5.4 6.6v66.4l17.1 5.1 76.6 23 45 30 6 4H359.3l6-4 45-30 76.6-23 17.1-5.1V144l-4.8-6.4-33.4-44.5 13.3-40 2.1-6.3-3-5.9-16-32-4.3-8.9H384zm-80 160.5 24.5-30.2 38.8-23.3c14.4-8.6 32.9-.4 36.2 16 1.8 8.9-1.6 18-8.6 23.7l-49.6 39.7-41.3-12.3zm120-67.4c-11.4-14.5-29.5-22.5-47.8-21.4L307.4 48H372l18.4 24.5c-20.6-3.8-41.6 4.4-54.4 20.6m0 69.5c2.6 3.4 5.7 6.5 9.1 9.2l35.4 28.3-20.6 13.8c-1.1-12.3-11.4-21.9-23.9-21.9s-22.8 9.6-23.9 21.9l-20.6-13.8 35.4-28.3c3.4-2.7 6.5-5.8 9.1-9.2m78.8 23.9-49.6-39.7c-7.1-5.7-10.4-14.8-8.6-23.7 3.3-16.4 21.9-24.7 36.2-16l42.9 25.7L456 160v14.1zM144 244.4V32H0v360c0 66.3 53.7 120 120 120h360v-56c0-39.8-32.2-72-72-72h-24v48h24c13.3 0 24 10.7 24 24v8h-80v-8c0-39.8-32.2-72-72-72h-72v48h72c13.3 0 24 10.7 24 24v8H120c-39.8 0-72-32.2-72-72v-32h34.4c-1.6 10.4-2.4 21.1-2.4 32v24h48v-24c0-54.6 27.3-102.8 69.1-131.7l-23.5-7zm-48 67.5-.1.1H48v-48h48zm0-95.9H48v-48h48zm0-96H48V80h48zm236.7 203.6-64-40-20.4-12.7-25.4 40.7 20.4 12.7 64 40 25.4-40.7zm102.6-40-64 40 25.4 40.7 64-40 20.4-12.7-25.4-40.7-20.4 12.7M288 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32m112-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), lW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1-64 64-154.5 68.7-202.7 20.5-21.5-21.5-32.4-50.8-32.4-82.6 0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48m0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 35 9.9 69.5 30.8 98.3L127 351l-23-23-33.9 33.9-36.2 36.2L0 432l33.9 33.9L46 478l34 34 33.9-33.9L150 442l34-34-23-23 31.7-31.7c73.6 54 182.1 34.1 252.3-36.2 43.6-43.6 67-99.8 66.9-154 0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0M80 444.1 67.9 432l36.1-36.1 12.1 12.1z" })
  }
), tW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112h48c0 78.2-56.1 143.3-130.3 157.2-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5 8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2L385.1 93C349.7 64.8 304.8 48 256 48 152.7 48 66.9 123.4 50.7 222.1 39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4 7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256h48c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L455 23l17-17 33.9 34L489 57 315 231c3.3 7.7 5.1 16.1 5.1 25 0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z" })
  }
), wW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.1 177.2c-7.3 9.3-13.3 19.6-17.8 30.8H53.6c9.5-40.2 30.6-75.8 59.7-103.3l41.9 72.5zM176 256c0-29.6 16.1-55.5 40-69.3L152 75.8l-24-41.5c-14 8.1-27.1 17.5-39.3 28C45.9 99.2 15.5 150.2 4.5 208c-3 15.5-4.5 31.6-4.5 48h128zm40 69.3-24 41.6-64 110.8.4.2c13.7 7.9 28.2 14.6 43.4 19.9C198.2 507 226.5 512 256 512s57.8-5 84.2-14.2c15.2-5.3 29.7-11.9 43.4-19.9l.4-.2-64-110.8-24-41.6-.1.1c-11.8 6.7-25.4 10.6-39.9 10.6s-28.1-3.9-39.9-10.6l-.1-.1zM256 464c-20.8 0-40.8-3-59.7-8.7l41.9-72.6c5.8.8 11.7 1.2 17.8 1.2s12-.4 17.8-1.2l41.9 72.6c-18.9 5.7-38.9 8.7-59.7 8.7m251.5-256c-11-57.8-41.4-108.8-84.2-145.8C411.2 51.7 398 42.4 384 34.3l-24 41.5-64 110.9c23.9 13.8 40 39.7 40 69.3h176v-.1c0-16.4-1.5-32.4-4.5-47.9M398.8 104.7c29.1 27.4 50.2 63.1 59.7 103.3h-83.8c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), gW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m485.7 55.3 23.3-5.7L497.6 3l-23.3 5.7-456 112L0 125.2V512h512V128H189.8l296-72.7zM48 272h416v192H48V304zm320 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128M80 320v32h160v-32H96zm16 64v32h128v-32H112z" })
  }
), iW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m485.7 55.3 23.3-5.7L497.6 3l-23.3 5.7-456 112L0 125.2V512h512V128H189.8l296-72.7zM48 176h416v288H48V304zm304 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160M112 240H96v32h128v-32h-16zm-16 64H80v32h160v-32h-16zm16 64H96v32h128v-32h-16z" })
  }
), mW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 88C169.8 88 48 209.8 48 360v120H0V360C0 183.3 143.3 40 320 40s320 143.3 320 320v120h-48V360c0-150.2-121.8-272-272-272m0 224c-26.5 0-48 21.5-48 48v120h-48V360c0-53 43-96 96-96s96 43 96 96v120h-48V360c0-26.5-21.5-48-48-48m-160 48v120h-48V360c0-114.9 93.1-208 208-208s208 93.1 208 208v120h-48V360c0-88.4-71.6-160-160-160s-160 71.6-160 160" })
  }
), aW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.5 122.8 160 32l54.5 90.8c6.2 10.4 9.5 22.3 9.5 34.4v2.8c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4zm-96 192L64 224l54.5 90.8c6.2 10.4 9.5 22.3 9.5 34.4v2.8c0 35.3-28.7 64-64 64S0 387.3 0 352v-2.8c0-12.1 3.3-24 9.5-34.4m244-4.2c-8.8 12.9-13.5 28.2-13.5 43.8 0 42.9 34.8 77.7 77.7 77.7h4.7c42.9 0 77.7-34.8 77.7-77.7 0-15.6-4.7-30.9-13.5-43.8L320 213.2zm-39.6-27.1L291 170.6l29-42.6 29.1 42.6 77.1 112.9c14.2 20.9 21.9 45.6 21.9 70.8C448 423.7 391.7 480 322.3 480h-4.7C248.3 480 192 423.7 192 354.3c0-25.3 7.6-50 21.9-70.8" })
  }
), oW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64v32h48V64c0-8.8 7.2-16 16-16s16 7.2 16 16v32l-10.3 10.3-55.2 23.6-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2V320H576V167.8l14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5-55.1-23.6L544 96V64c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48V64c0-35.3-28.7-64-64-64s-64 28.7-64 64h-32c0-35.3-28.7-64-64-64s-64 28.7-64 64m-32 21.7c-7.7-8.7-17.8-15.4-29.2-18.9-6-1.8-12.3-2.8-18.8-2.8-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5L120 512h88v-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V512h88l22.5-120h1.5c26.9 0 49.9-16.5 59.3-40h-109l-6.8 27.9c-1.7 7-8.1 12.1-15.5 12.1-3.8 0-7.2-1.3-9.9-3.4L298.2 360 268 394.5c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5l-30-34.5-35.9 28.5c-2.7 2.2-6.1 3.4-9.9 3.4-7.5 0-13.8-5.1-15.5-12.1L142 337.1l-43.5 6.7c-.8.1-1.6.2-2.5.2-8.8 0-16-7.2-16-16 0-1.4.2-2.7.5-3.9l9-36.3-33-17.6C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2l33-17.6-9-36.3a16 16 0 0 1-.5-3.9c0-8.8 7.2-16 16-16 .9 0 1.7.1 2.5.2l43.5 6.7 10.4-42.7c1.7-7 8.1-12.1 15.5-12.1 3.8 0 7.2 1.3 9.9 3.5l36 28.4 30.2-34.5c3-3.4 7.3-5.5 12.1-5.5 5.3 0 10 2.5 13 6.7l6.2 8.7 28.7-12.3zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), nW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48h288v264.4l48 88V0H32v400.4l48-88zm64 240h-14.2l-6.8 12.5-96 176L7.6 512H440.4L421 476.5l-96-176-6.8-12.5H304zM88.4 464l69.8-128h131.6l69.8 128H88.4z" })
  }
), rW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m351.8 62.3 69 11-49.4 49.5 10.9 69.2-62.3-31.7-62.3 31.7 10.9-69.1-49.4-49.6 69-11L320 0zM272 304v160h96V304zm-48-48h192v256H224V304zM48 368v96h96v-96zM0 320h192v192H0V368zm592 80h-96v64h96zm-96-48h144v160H448V352z" })
  }
), dW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64h-96L64 0v74.8C26.2 92.8 0 131.3 0 176c0 61.9 50.1 112 112 112L53.5 405.1 32 448l42.9 21.5 42.1 21.1 43 21.4 21.5-42.9L272 288h16v32h48V32h-48v24zm-69.7 224-79.8 159.6-42.1-21.1L165.7 288h52.7zM136 240h-24c-35.3 0-64-28.7-64-64s28.7-64 64-64h176v128h-48zM416 64h-48v224h48v-80h64l96 48V96l-96 48h-64V88zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), SW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m93.5 437.1-20.3-10.2-20.7 9.2-4.5 2V73.9l4.5 2 20.7 9.2 20.3-10.2 41-20.5 33.7 19.3L192 87.3l23.8-13.6 33.7-19.3 41 20.5L310.8 85l20.7-9.2 4.5-2v364.3l-4.5-2-20.7-9.2-20.3 10.1-41 20.5-33.7-19.3-23.8-13.5-23.8 13.6-33.7 19.3zM0 512l48-21.3L72 480l64 32 56-32 56 32 64-32 24 10.7 48 21.3V0l-48 21.3L312 32 248 0l-56 32-56-32-64 32-24-10.7L0 0v459.5zm120-368H96v48h192v-48h-24zM96 320v48h192v-48H120zm24-88H96v48h192v-48h-24z" })
  }
), zW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0m120 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), pW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm192.3 128h35.8l6.1 14.8L307.4 352h-52l-9.9-24h-73.9l-10.4 24h-52.4L186 174.4zm.2 120h33.3l-16.2-39.2-17.2 39.2zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48m24-43.9V160h48v192h-48v-4.1c-7.5 2.7-15.6 4.1-24 4.1-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1" })
  }
), MW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm144 96v256H96V128zm64 0v256h-32V128zm32 0h48v256h-48zm160 0v256h-48V128zm48 0h32v256h-32z" })
  }
), xW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 80v352H48V80zM48 32H0v448h512V32h-48zm222.1 160 17 17 47 47-47 47-17 17 33.9 33.9 17-17 64-64 17-17-17-17-64-64-17-17zM225 209l17-17-34-33.9-17 17-64 64-17 17 17 17 64 64 17 17 33.9-34.1-17-17-47-47 47-47z" })
  }
), HW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h300.5c12.3 18.8 28 35.1 46.3 48H0V160h512v32.7c-5.3-.5-10.6-.7-16-.7-26.2 0-51.1 5.7-73.4 16H48zM464 80v48H48V80zM416 0v48H96V0zm80 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80v-16h-32v64h-64v32h64v64h32v-64h64v-32h-64z" })
  }
), VW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h300.5c12.3 18.8 28 35.1 46.3 48H0V160h512v32.7c-5.3-.5-10.6-.7-16-.7-26.2 0-51.1 5.7-73.4 16H48zM464 80v48H48V80zM416 0v48H96V0zm-64 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224.7 77.7L552 416H440l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3M544 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), CW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 208H48v256h416zm48-48v352H0V160h464zm-48-80v48H48V80zM416 0v48H96V0z" })
  }
), LW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m104-24h272v48H200zm0 96h272v48H200zm0 96h272v48H200zm-72-40a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), BW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h544V80zM0 32h640v448H0V80zm80 128h80c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32v64H80V184zm48 80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm272 8c0-48.6 39.4-88 88-88s88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88zm88-40c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40s40-17.9 40-40v-16c0-22.1-17.9-40-40-40m-224-48h56c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.7 52.7l24.1 38.5 23 36.7h-56.7l-7-11.3-33-52.7H288v64h-48V160zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32z" })
  }
), uW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 80v352H48V80zM48 32H0v448h512V32h-48zm38.1 137.5 17.7 16.2 76.7 70.3-76.7 70.3-17.7 16.2 32.4 35.4 17.7-16.2 96-88 19.3-17.7-19.3-17.7-96-88-17.7-16.2zM248 336h-24v48h192v-48h-24z" })
  }
), RW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 48v416h288V48zM192 0h384v512H192V48zM96 48h48v416H96zM0 96h48v320H0z" })
  }
), $W = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 464H48V48h288zm48-416V0H0v512h384v-48z" })
  }
), kW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 112v288H48V112zM48 64H0v384h640V64h-48z" })
  }
), PW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h416V80zM0 32h512v448H0V80zm353.9 160-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), FW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 112v288H48V112zM48 64H0v384h512V64h-48z" })
  }
), TW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 80v128H48V80zM48 32H0v224h320V32h-48zm480 48v256h-96V80zm-96-48h-48v352h192V32h-48zM112 352h176v80H112zm-48-48v176h272V304H112z" })
  }
), AW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M229.4 48h53.1l73.3 117.3-36.3-12-22.8-7.6-15.1 45.6 22.8 7.6 91.4 30.4 25.6 8.5 5.4-26.4 19.4-94.4 4.8-23.5-47-9.7-4.8 23.5-5.8 27.9L309.1 0H202.8l-58.7 93.9 41.2 24.7zm231.3 194.5-41.2 24.7 41.3 66-36.5 58.8H289.7l21.9-18.5 18.3-15.5-31-36.7-18.3 15.5-72 60.8-21.8 18.4 21.7 18.3 72 60.8 18.3 15.5 31-36.7-18.3-15.5-21.9-18.4H451l66.4-106.9-56.6-90.6zm-466 90.6L61 440h99v-48H87.7l-36.5-58.8 68.7-109.9 7.4 36 4.8 23.5 47-9.7-4.8-23.5-19.4-94.4-5.4-26.4-25.6 8.5-91.5 30.3-22.7 7.5 15.1 45.6 22.8-7.6 27.9-9.2-80.8 129.2z" })
  }
), DW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v48h64v64h320V48h64V0H64zm80 72V48h240v24zM24 464H0v48h448v-48h-64v-64H64v64zm320 0H104v-24h240zM64 176h320v-32H64zm0 64h384v-32H64zm0 64h320v-32H64zm0 64h320v-32H64z" })
  }
), yW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v112h-48V96h-48v64H48V48zm-96 160v160h48V208h48v256H48V208zM48 0H0v512h384V0h-48z" })
  }
), bW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416m0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-384v256h48v-96h42.9l61.3 96h57l-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80H160zm48 112v-64h80c17.7 0 32 14.3 32 32s-14.3 32-32 32h-24z" })
  }
), fW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96 352 0h-32v72H0v208h48V120h272v72h32zM216 240h24v80h48V192h-72zm296 16v-24h-48v160H192v-72h-32l-96 96 96 96h32v-72h320v-24z" })
  }
), UW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 280V72h304V0h48l62.1 62.1L448 96l-33.9 33.9L352 192h-48v-72H48v160zm352-155.9L380.1 96 352 67.9v56.2zM512 232v208H208v72h-48l-62.1-62.1L64 416l33.9-33.9L160 320h48v72h256V232zM160 444.1v-56.2L131.9 416z" })
  }
), GW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M106.4 184.4 224 76.6V32h-32L0 208l192 176h32v-44.6L106.4 231.6 80.6 208l25.7-23.6zM448 480s41.8-15.7 77.7-53c26.9-28 50.3-68.1 50.3-123 0-97.2-78.8-176-176-176h-48V32h-32l-16 14.7-140.5 128.7L128 208l35.5 32.6L304 369.3l16 14.7h32v-96h16c11.1 0 21.9 1.6 32 4.6 46.3 13.8 80 56.6 80 107.4 0 1.4 0 2.9-.1 4.3C478.1 449.9 448 480 448 480m80-176c0 17-3.1 32-8.2 45.4C498.6 285.8 438.7 240 368 240h-64v64.2L199 208l105-96.2V176h96c70.7 0 128 57.3 128 128" })
  }
), qW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 144a144 144 0 1 0-288 0 144 144 0 1 0 288 0M512 64v64h48v32h-80V64zm0 272c0-5.6-.3-11.2-.8-16.6-5 .4-10.1.6-15.2.6-11.4 0-22.6-1.1-33.4-3.2.9 6.3 1.4 12.7 1.4 19.2 0 17-3.1 32-8.2 45.4C434.6 317.8 374.7 272 304 272H176v64.2L71 240l105-96.2V208h156c-5.9-15.1-9.8-31.2-11.3-48H224V64h-32l-16 14.7L35.5 207.4 0 240l35.5 32.6L176 401.3l16 14.7h32v-96h80c61.9 0 112 50.1 112 112 0 1.4 0 2.9-.1 4.3C414.1 481.9 384 512 384 512s41.8-15.7 77.7-53c26.9-28 50.3-68.1 50.3-123" })
  }
), WW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M461.7 427c-35.8 37.4-77.7 53-77.7 53s30.1-30.1 31.9-75.7c.1-1.4.1-2.8.1-4.3 0-61.9-50.1-112-112-112h-80v96h-32l-16-14.7L35.5 240.6 0 208l35.5-32.6L176 46.7 192 32h32v96h112c97.2 0 176 78.8 176 176 0 54.8-23.5 95-50.3 123m-5.8-77.6c5-13.4 8.1-28.4 8.1-45.4 0-70.7-57.3-128-128-128H176v-64.2L71 208l105 96.2V240h128c70.7 0 130.6 45.8 151.8 109.4z" })
  }
), EW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 32C68.1 32 0 100.1 0 184v296h144v-96h160v96h144v-96h48v24c0 39.8 32.2 72 72 72s72-32.2 72-72v-88h-48v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-83.9-68.1-152-152-152zm344 256v48h-96v96h-48v-96H96v96H48V288zm0-48H48v-56c0-57.4 46.6-104 104-104h240c57.4 0 104 46.6 104 104zm-336.4-96-15.7-32-15.7 32-36.3 4.6 26.5 24.4-6.7 35 32.1-16.9L176 208l-6.7-34.9 26.5-24.4zm112.3-32-15.7 32-36.3 4.6 26.5 24.4-6.7 35 32.1-16.9L304 208l-6.7-34.9 26.5-24.4-36.2-4.7-15.7-32m143.7 32-15.7-32-15.7 32-36.3 4.6 26.5 24.4-6.7 35 32.1-16.9L432 208l-6.7-34.9 26.5-24.4z" })
  }
), OW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128M74 304l4-96h100l4 96h-70zm-10 48v160h48V352h32v160h48V352h40l-2-48-6-144H32l-6 144-2 48zM344 0h-48v512h48V24zm232 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-91.8 144h55.6l36.6 128H447.6l36.6-128zm91.8-48H448l-50.3 176-13.7 48h64v128h48V384h32v128h48V384h64l-13.7-48z" })
  }
), IW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-20.4 80h136.8l5.4 16.5 44.9 136 7.5 22.8-45.6 15.1-7.5-22.8-9.1-27.9V512h-48V352h-32v160H64V267.6l-9.2 27.9-7.5 22.8-45.6-15 7.5-22.8 44.9-136zM112 304h32V176h-32zM464 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-20.4 80h136.8l5.4 16.5 44.9 136 7.5 22.8-35.8 11.8L609 336l15 48h-48v128h-48V384h-32v128h-48V384h-48l15-48 6.5-20.9-35.8-11.8 7.5-22.8 44.9-136 5.4-16.5zm68.4 58.5L465.3 336h93.4zM344 24v488h-48V0h48z" })
  }
), NW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208h72v208h248v-48H120V208h72v-48l-62.1-62.1L96 64 62.1 97.9 0 160zm96-76.1 28.1 28.1H67.9zM576 304h-72V96H256v48h200v160h-72v48l62.1 62.1L480 448l33.9-33.9L576 352zm-96 76.1L451.9 352h56.2z" })
  }
), XW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192.1 475.6 224 512l31.9-36.4L448 256 255.9 36.4 224 0l-31.9 36.4L0 256zm31.9-36.5L63.8 256 224 72.9 384.2 256z" })
  }
), KW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m352 142.9-11.8-17.2-16.5 18.4-45.9 51-32.3-35.9L288 112l-64-64-64 64 255.7 284.1L448 432l-39.3 28.1L336 512 48 192v-64L136 0h176l88 128v64l-62.5 69.4-32.3-35.9 46.8-52zM142.8 345.1l-71.1 79L105 448l65.2-72.4 32.3 35.9L112 512l-72.7-51.9L0 432l32.3-35.9 78.2-86.8 32.3 35.9zM96 142.9v30.7L343 448l33.4-23.8-252.1-280.1-16.5-18.4z" })
  }
), QW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 288h48v76.1L444.1 256 336 147.9V224H208v64zm190.1 1.9L352 416h-64v-80H160V176h128V96h64l126.1 126.1L512 256zM168 80H48v352h144v48H0V32h192v48z" })
  }
), ZW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 288h48v76.1L380.1 256 272 147.9V224H144v64zm190.1 1.9L288 416h-64v-80H96V176h128V96h64l126.1 126.1L448 256zM48 88v360H0V64h48z" })
  }
), JW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 504h-10.8l-7.2-8.1-128-144L7.9 336l14.2-15.9 128-144 7.2-8.1H240v64h208v64h13.2l106.7-120L461.2 56H448v64H296V72h104V8h82.8l7.2 8.1 128 144 14.1 15.9-14.2 15.9-128 144-7.2 8.1H400v-64H192v-64h-13.2L72.1 336l106.7 120H192v-64h152v48H240v64h-24z" })
  }
), jW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 128-33.9 33.9L384 256h-48V152H0v-48h336V0h48l94.1 94.1zm-67.9 0L384 67.9v120.2zM488 360h24v48H176v104h-48l-94.1-94.1L0 384l33.9-33.9L128 256h48v104zm-360 84.1V323.9L67.9 384z" })
  }
), YW = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 88V64h-48v384h48v-24zM304 232h48v-68.1l92.1 92.1-92.1 92.1V280H48v-48zm208 24-33.9-33.9L352 96h-48v88H0v144h304v88h48l126.1-126.1z" })
  }
), _W = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 224H48v64h304v60.1l92.1-92.1-92.1-92.1V176zm126.1-1.9L512 256l-33.9 33.9L352 416h-48v-80H0V176h304V96h48z" })
  }
), hE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 224h48v-76.1L284.1 256 176 364.1V288H48v-64zm190.1-1.9L192 96h-64v80H0v160h128v80h64l126.1-126.1L352 256zM344 432h-24v48h192V32H320v48h144v352z" })
  }
), cE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 288h48v76.1L284.1 256 176 147.9V224H48v64zm190.1 1.9L192 416h-64v-80H0V176h128V96h64l126.1 126.1L352 256zM400 88V64h48v384h-48v-24z" })
  }
), sE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 224H48v64h192v108.1L380.1 256 240 115.9V176zm-48-112V64h64l158.1 158.1L448 256l-33.9 33.9L256 448h-64V336H0V176h192v-48z" })
  }
), vE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0h-12.8L124 10.7l-32 48-8.1 12.2L91 83.7l31.8 57.2C51 168.6 0 238.4 0 320c0 106 86 192 192 192s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7l7.1-12.8-8.1-12.2-32-48L252.8 0H240zm68.8 129.1c-6.8-.7-13.8-1.1-20.8-1.1s-14 .4-20.8 1.1l-31.1-56L156.8 48h70.3l16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0 144 144 0 1 1-288 0" })
  }
), eE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224v-64c21.3-32 102.4-96 256-96s234.7 64 256 96v192c-21.3 32-102.4 96-256 96S21.3 384 0 352zm464 43.3c-42.3 27-110.6 52.7-208 52.7S90.3 294.3 48 267.3v67.4C70.8 357 135.3 400 256 400s185.2-43 208-65.3zM396 248c-34-13.4-80.1-24-140-24s-106 10.6-140 24c34 13.4 80.1 24 140 24s106-10.6 140-24m52.5-28.4c6.4-4.7 11.5-9.1 15.4-13V177.3C441.2 155 376.7 112 256 112S70.8 155 48 177.3v29.4c3.9 3.8 9 8.3 15.4 13C106.2 196.2 169.6 176 256 176s149.8 20.2 192.6 43.6z" })
  }
), lE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M172.5 88 152 50.5l1.7-2.5h44.6l1.7 2.5L179.5 88zM96 48l30.1 55.2C53.2 124.7 0 192.1 0 272c0 97.2 78.8 176 176 176 7.8 0 15.5-.5 23-1.5 32.3 39.9 81.6 65.5 137 65.5 97.2 0 176-78.8 176-176 0-91.9-70.4-167.3-160.3-175.3 10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128-32.8 0-62.7-12.3-85.3-32.6-12.3-11-22.5-24.4-29.8-39.5C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105 7 14.8 17.7 27.5 30.8 37 43.7-32 72-83.7 72-142 0-79.9-53.2-147.3-126.1-168.8L256 48 224 0h-96zm165.3 128.6C201.5 204.7 160 265.5 160 336c0 22.6 4.2 44.1 12 63.9-68.9-2.1-124-58.6-124-127.9 0-70.7 57.3-128 128-128 32.8 0 62.7 12.3 85.3 32.6" })
  }
), tE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 56V32H0v448h48V304h544v176h48V32h-48v48H48zm544 72v128h-85.2l64-128zm-277.2 0h74.3l-64 128h-74.3zm138.4 128h-74.4l64-128h74.3l-64 128zm-192-128-64 128h-74.4l64-128h74.3zm-128 0-64 128H48V128z" })
  }
), wE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48V0h320v512H320v-48zm184 416h88V48h-88v80h-48V48h-88v416h88v-80h48v24zm0-272v128h-48V192zM24 96h264v48h-40v64h40v48H0v-48h72v-64H0V96zm248 208h16v48h-16c-30.9 0-56 25.1-56 56v104H72V400c0-26.5-21.5-48-48-48H0v-48h24c53 0 96 43 96 96v64h48v-56c0-57.4 46.6-104 104-104m-72-160h-80v64h80z" })
  }
), gE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.6 432 196.2 80H296v48h48V80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1 10.4 0 20.6.9 30.5 2.6L480 32H160L45.7 432 32 480h328.2c-21.9-26.6-36.2-59.7-39.5-96H296v48zM344 216v-24h-48v128h30.6c4.1-14.4 10-28.1 17.4-40.8zm296 152a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-65.4-32-11.3 11.3-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3z" })
  }
), iE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.6 432 196.2 80H296v48h48V80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1 10.4 0 20.6.9 30.5 2.6L480 32H160L45.7 432 32 480h328.2c-21.9-26.6-36.2-59.7-39.5-96H296v48zM344 216v-24h-48v128h30.6c4.1-14.4 10-28.1 17.4-40.8zm152 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-240v112h-32V272zm0 176h-32v-32h32z" })
  }
), mE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.6 432 196.2 80H296v48h48V80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1 10.4 0 20.6.9 30.5 2.6L480 32H160L45.7 432 32 480h328.2c-21.9-26.6-36.2-59.7-39.5-96H296v48zM344 216v-24h-48v128h30.6c4.1-14.4 10-28.1 17.4-40.8zm152 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3 22.6 22.6-11.3 11.3z" })
  }
), aE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.6 432 196.2 80H296v48h48V80h99.8l27.3 95.5c13.6-8.1 29.1-13.3 45.6-15L480 32H160L45.7 432 32 480h352v-48h-40v-48h-48v48zM344 216v-24h-48v128h48v-24zm184 24c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), oE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 212.2V304h57.4zM64 96l16 25.6 80 128V96h32l16 25.6 80 128V96h32l16 25.6 80 128V96h32l16 25.6L578 304l30 48H32V96zM0 400h640v48H0zm208-96h57.4L208 212.2zm128-91.8V304h57.4zM464 304h57.4L464 212.2z" })
  }
), nE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.6 432H264v-48h48v48h200.4L411.8 80H312v48h-48V80h-99.8L63.6 432zM312 32h136l114.3 400 13.7 48H0l13.7-48L128 32h136zm0 184v104h-48V192h48z" })
  }
), rE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-70.7 0-128 57.3-128 128v16H32v266.3l-29.5 59-2.5 5V512h160v-96.9l22.1 24.8 7.2 8.1h133.5l7.2-8.1 22-24.8V512h160v-37.7l-2.5-5.1-29.5-58.9V144h-96v-16C384 57.3 326.7 0 256 0m-64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32M160 342.9V192h192v150.9L301.2 400h-90.4zM112 192v272H58.8l18.6-37.3 2.5-5.1V192h32zm288 0h32v229.7l2.5 5.1 18.7 37.2H400V352zm-192 32h-16v32h128v-32h-16zm0 64h-16v32h128v-32h-16z" })
  }
), dE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24V0h-48v96H96v416h448V96H344zm-48 120h200v320H144V144zM64 224H0v192h64zm576 0h-64v192h64zM192 384v32h64v-32h-48zm144 0h-48v32h64v-32zm64 0h-16v32h64v-32h-16zM280 256a40 40 0 1 0-80 0 40 40 0 1 0 80 0m120 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), SE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M197.9 253.9c32.2-113.5 86.9-164.1 137-186.9 43.8-20 90.1-21.4 126.8-16.6 4.8 36.6 3.4 82.9-16.6 126.8-22.8 50-73.4 104.8-186.9 137-6.4-12.9-14.8-24.7-25.2-35s-22.2-18.8-35-25.2zM44.4 287.7c1.2.2 2.4.3 3.6.3h90.7c22.6 0 44.3 9 60.3 25s25 37.7 25 60.3V512l160-80V312.1C527.5 223 520.4 80.2 502.7 9.3 431.8-8.4 289-15.5 199.9 128H80L0 287.6l44.4.1zM.5 511.5s116.5 8 166-41.5c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5.5 511.5m64.1-64.1s-2.7-38.7 13.8-55.2c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4c-16.5 16.5-55.2 13.8-55.2 13.8zM408 144a40 40 0 1 0-80 0 40 40 0 1 0 80 0" })
  }
), zE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 391.8c-25.3 11-42.6 17.9-42.6 17.9l-80.8-80.8s6.9-16.5 17.9-41L0 287.6 80 128h119.9c2.5-4 4.9-7.7 7.3-11.3C296.6-15.1 433.7-7.9 502.7 9.3c17.2 68.9 24.5 206-107.4 295.4-3.6 2.4-7.3 4.9-11.3 7.3v120l-160 80zM192.6 353c13.8-5.9 31.3-13.5 50.4-22.2 45-20.5 95.1-45.3 125.3-65.8 91.7-62.1 101.9-152 93.4-214.7C399 41.8 309.1 52 247 143.7c-20.6 30.3-45.9 80.3-66.8 124.9-8.8 18.7-16.5 35.9-22.5 49.5l35 35zM368 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), pE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 91.7c-33.3 17.4-56 52.2-56 92.3v296H0V184C0 100.1 68.1 32 152 32h5.1c49.8 0 96.4 24.4 124.8 65.3L398.4 265c23.9 34.4 63.2 55 105.1 55h8.5c44.2 0 80-35.8 80-80v-8c0-40.3-27.1-74.2-64-84.7v138c-5 1.8-10.4 2.7-16 2.7h-8.5c-8 0-15.9-1-23.5-2.9v-140c-16.2 2.2-31.8 7.6-45.9 16L416 172v62.3l-58-83.5 51.4-30.9c26.1-15.7 56-23.9 86.4-23.9h8.2c75.1 0 136 60.9 136 136v248h-48V339.9c-16 12.8-35.1 21.9-56 25.8V480h-48V367.3c-16.6-1.5-32.7-5.3-48-11.2V480h-48V328.2c-12.5-10.2-23.6-22.2-33.1-35.8L344 270.9V480h-48V201.8l-48-69.1V480h-48V89.3c-13.3-6-27.9-9.3-42.9-9.3H152v400h-48V91.7z" })
  }
), ME = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416.5 176H352v48h144V80h-48v59.3c-22.3-24.3-43.2-46.6-65.1-63.8C348.3 48.3 309.9 32 256 32 157.7 32 71.3 95.5 41.3 184.3l45.5 15.4C110.1 130.4 178.2 80 256 80c42.2 0 70.4 12.1 97.2 33.2 20.7 16.3 39.7 37 63.3 62.8M280 152v-24h-48v160h48v-24zm0 216v-48h-48v48zM16 432h48v-61.8c22.8 25.2 44.1 48.4 66.2 66.2 34 27.3 71.9 43.6 125.8 43.6 98.3 0 184.7-63.5 214.7-152.3l-45.5-15.4C401.9 381.6 333.8 432 256 432c-42.1 0-69.6-12.1-95.8-33.1-19.5-15.7-37.3-35.3-59.4-59.6l-3-3.3H160v-48H16v120z" })
  }
), xE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M139.8 123.8C170.8 96.5 211.5 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2l-28.8 38.4C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.8 0-110.5 21.9-150.2 57.8L89.9 73.9 56 40 22.1 73.9 16 80v144h144l6.1-6.1L200 184l-33.9-33.9-26.3-26.3zM64 115.9l60.1 60.1H64z" })
  }
), HE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M372.2 123.8C341.2 96.5 300.5 80 256 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2l28.8 38.4C353 463.3 306.4 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32c57.8 0 110.5 21.9 150.2 57.8l15.9-15.9L456 40l33.9 33.9L496 80v144H352l-6.1-6.1L312 184l33.9-33.9zm75.8-7.9L387.9 176H448z" })
  }
), VE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l5.1 5.1-21.1 21.1L312 184l33.9 33.9 6.1 6.1h144V80l-6.1-6.1L456 40l-33.9 33.9L401 95l-5.1-5.1C358.8 52.8 308.5 32 256 32 163.4 32 83.9 88.2 49.8 168.3zm323.9 138.1C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L145 383l21.1-21.1L200 328l-33.9-33.9-6.1-6.1H16v144l6.1 6.1L56 472l33.9-33.9L111 417l5.1 5.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9l-44.1-18.9zm-30-149.2 60.1-60.1V176zM124.1 336 64 396.1V336z" })
  }
), CE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M236.3 11.4 224 4l-12.3 7.4-8 4.8c-38.3 23-85.5 25.7-126.2 7.2l-11.6-5.2L46 9.1l-10.9 19-32 56-6.3 11.1 5.7 11.5 16.2 32.5c8.7 17.4 13.2 36.6 13.2 56 0 15.9-3 31.7-9 46.5l-14.2 36C2.9 292 0 307.3 0 322.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5 10.4 5 10.4-5 144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4 0-15.4-2.9-30.7-8.7-45.1L425 241.8c-5.9-14.8-9-30.6-9-46.5 0-19.5 4.5-38.6 13.2-56l16.2-32.5 5.7-11.5-6.4-11.2-32-56-10.7-19-19.9 9.1-11.5 5.2c-40.7 18.5-87.9 15.8-126.2-7.2l-8-4.8zM80 192h288v3.2c0 22 4.2 43.9 12.4 64.4l14.4 35.9c3.5 8.7 5.2 17.9 5.2 27.2 0 28.2-16.2 53.9-41.6 66.1L224 453.4 89.6 388.9C64.2 376.7 48 351 48 322.7c0-9.3 1.8-18.6 5.2-27.2l14.4-35.9c8.2-20.5 12.4-42.3 12.4-64.4z" })
  }
), LE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M268.7 11.6 256 3.7l-12.7 7.9C186.9 46.9 130.2 48 52.7 32.5l-24.6-5-3.8 24.9C8 158.5 11.5 250.1 46.3 326.2c35.2 77 100.6 134.6 200.5 175.9l9.7 4 9.5-4.4c97.3-44.9 162.4-102.3 198-178.1 35.4-75.3 40-165.1 23.6-271.4l-3.8-24.8-24.6 4.9C381.8 48 325.1 46.9 268.7 11.6zM63.7 192h384.1c-2.9 42-11.8 78.7-27.1 111.3-28.4 60.3-80.4 109.5-165.2 150.4-86-37.5-137.7-86.5-165.5-147.4-15.3-33.4-23.8-71.2-26.3-114.3z" })
  }
), BE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M454.1 126.5c-7.3 14.5-17.4 30-28.5 44.7-3.2 4.3-6.4 8.4-9.6 12.4-3.2-3.9-6.4-8.1-9.6-12.4-11-14.7-21.2-30.2-28.5-44.7-7.6-15.3-9.9-25.4-9.9-30.5 0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.1-2.3 15.3-9.9 30.5zm-6 93.6C476 186.4 512 135.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 34.7 28.3 78.9 54.1 112H240v176h224v80H177.8c-2.7 3.8-5.5 7.6-8.2 11.2-10.7 14.2-21.3 26.9-30 36.8H512V336H288v-80h128s14.4-14.4 32.1-35.8zm-314 162.4c-7.3 14.5-17.4 30-28.5 44.7-3.2 4.3-6.4 8.4-9.6 12.4-3.2-3.9-6.4-8.1-9.6-12.4-11-14.7-21.2-30.2-28.5-44.7-7.6-15.2-9.9-25.4-9.9-30.5 0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.1-2.3 15.3-9.9 30.5zm3.8 81.5c25.9-33.1 54.1-77.3 54.1-112 0-53-43-96-96-96S0 299 0 352c0 39.2 36 90.4 63.9 124.2C81.6 497.6 96 512 96 512s4.4-4.4 11.3-11.9c.1-.2.3-.3.4-.5 2.9-3.2 6.3-7 10-11.2.3-.3.6-.7.9-1 3-3.5 6.2-7.2 9.5-11.3 3.2-3.8 6.5-7.9 9.8-12.2z" })
  }
), uE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48c58.8 0 112.5 21.8 153.4 57.9l31.7-36C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9l31.7 36C239.5 69.8 293.2 48 352 48m24 200v-24h-48v80H0v208h576V304H376zM48 352h480v112H48zm160 32h-48v48h48zm-128 0v48h48v-48zm196.5-197.3C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7l30.2-37.3C428.8 126 392 112 352 112s-76.8 14-105.7 37.4z" })
  }
), RE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480C448 232.6 247.4 32 0 32v48c220.9 0 400 179.1 400 400zm-144 0c0-167.9-136.1-304-304-304v48c141.4 0 256 114.6 256 256zM48 416a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), $E = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 32H64v240H0v48h64v48H0v48h64v64h48v-64h208v-48H112v-48h128c79.5 0 144-64.5 144-144S319.5 32 240 32zm152 240H112V80h128c53 0 96 43 96 96s-43 96-96 96" })
  }
), kE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 64H0v48h32v40H0v48h32v32H0v48h32v32H0v48h32v40H0v48h640v-48h-32v-40h32v-48h-32v-32h32v-48h-32v-32h32v-48h-32v-40h32V64H56zm56 48h48v288H80V152zm384 288H176V112h288zm48 0V112h48v288z" })
  }
), PE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m496 80-64-64h-96C159.3 16 16 159.3 16 336v96l64 64h96c176.7 0 320-143.3 320-320zM343.7 64l-108.4 52.4-118.9 118.9L64 343.7c0-67.1 20.4-131.3 64-183 9.8-11.6 20.5-22.3 32-32.1C211.8 84.6 276.3 64 343.7 64M86.2 434.3l-8.6-8.6L156 263.4l107.5-107.3 162.3-78.4 8.6 8.6-78.5 162.2-107.4 107.4-162.3 78.4m82.1 13.7 108.4-52.4 118.9-118.9L448 168.3c0 67.4-20.6 131.9-64.6 183.7-9.6 11.3-20.1 21.8-31.4 31.4-51.8 44-116.3 64.6-183.7 64.6" })
  }
), FE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 272h-48V0H0v512h512V272h-48zm96 48v80h32v-80h48v144H48V48h144v48h-80v32h80v64h-80v32h80v64h-80v32h80v80h32v-80h64v80h32v-80z" })
  }
), TE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 336h544V176h-64v64h-32v-64h-64v64h-32v-64h-64v64h-32v-64h-64v64h-32v-64h-64v64h-32v-64H48zM0 384V128h640v256H48z" })
  }
), AE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464V67.9l66.7 66.7-14.1 14.1L89.4 160l22.6 22.6 11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1-11.3 11.3 22.6 22.6 11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1-11.3 11.3 22.6 22.6 11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1-11.3 11.3 22.6 22.6 11.3-11.3 14.1-14.1 66.7 66.8zM0 0v512h512v-48L48 0zm128 256v128h128z" })
  }
), DE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48v48h-64v32h64v64h-64v32h64v64h-64v32h64v64h-64v32h64v48H48V48zM48 0H0v512h256V0h-48z" })
  }
), yE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512 160-33.9-33.9-92.2-92.2L352 0l-33.9 33.9L33.9 318.1 0 352l33.9 33.9L126 478l34 34 33.9-33.9 284.2-284.2zm-67.9 0L160 444.1 67.9 352l34.7-34.7 30.1 30.1 11.3 11.2 22.6-22.6-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1 11.3 11.3 22.6-22.6-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1 11.3 11.3 22.6-22.6-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1 11.3 11.3 22.6-22.6-11.3-11.3-30.1-30.1L352 67.9z" })
  }
), bE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h120c75.1 0 136 60.9 136 136 0 62.4-42 115-99.3 131l57.9 181h-50.4l-56.3-176H48v176H0V56zm48 224h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8.3c17.4 6.2 40 14.2 56.7 28.5 9 7.7 16.8 17.6 21.5 30.4 4.7 12.7 5.7 26.7 3.5 41.9-3.9 26.6-19.1 46.5-41 57.6-21 10.6-46.4 12.3-71.6 7.6h-.2c-9-1.7-20.2-5.7-29.5-9.2-6.3-2.4-13-5.1-18.5-7.3-2.7-1.1-5.1-2-7-2.8l-22.3-8.8 17.5-44.7 22.3 8.8c2.6 1 5.3 2.1 8.2 3.3 5.1 2.1 10.7 4.3 16.7 6.6 9.4 3.5 17 6 21.5 6.9 18.1 3.3 32.1 1.2 41.2-3.3 8.1-4.1 13.5-10.7 15.1-21.7 1.3-8.8.4-14.5-1-18.3-1.4-3.8-3.8-7.1-7.7-10.5-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2 7.1 1.3 28.4 6.1 36.5 8.7l22.9 7.2-14.4 45.8-22.9-7.2c-5.5-1.7-24.7-6.1-30.8-7.3-36.3-6.7-54.2 10.2-56.4 25z" })
  }
), fE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h120c75.1 0 136 60.9 136 136 0 62.4-42 115-99.3 131l57.9 181h-50.4l-56.3-176H48v176H0V56zm48 224h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48zm264-96h88c61.9 0 112 50.1 112 112s-50.1 112-112 112h-64v128h-48V160zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64h-64v128z" })
  }
), UE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h160v32h224v176h-34.6l57.4 45.1 9.2 7.2V416h-65.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H254.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-6.8.8-13.4 2.4-19.6L95 409 7 321l-7-7V32h224zm208 256h124.8l-61.1-48H432zm-48 112V160h176V80H48v214.1l73.9 73.9h6.1c13.4-10 30-16 48-16s34.6 6 48 16zm-176 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0M288 128v128H96V128z" })
  }
), GE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M91.2 90.6c-24 10.1-37.9 26.2-41.8 48-2.8 16.1-1 27.4 2.8 35.7 3.8 8.5 10.6 16.1 21.1 23.3 22.1 15.1 54.9 24.6 93.2 35.3.8.2 1.6.4 2.4.7 35.3 9.9 75.6 21.2 104.9 41.2 15.6 10.6 29.3 24.5 37.7 43.1 8.5 18.7 10.6 40 6.4 63.9-7.2 40.8-34.4 68.8-70.5 83.9-35.3 14.8-79.6 17.8-125.7 10.7h-.1c-24.5-3.9-64.3-17.2-90.9-26.2-5.3-1.8-10-3.4-14-4.7l-23-7.5 14.9-45.6 22.8 7.4c4.9 1.6 10.5 3.5 16.3 5.4 26.9 9 61.2 20.4 81.3 23.6 40.4 6.2 75.1 2.9 99.8-7.5 24-10.1 37.9-26.2 41.8-48 2.8-16.1 1-27.4-2.8-35.7-3.8-8.5-10.6-16.1-21.1-23.3-22.1-15.1-54.9-24.6-93.2-35.3-.8-.2-1.6-.4-2.4-.7-35.3-9.9-75.6-21.2-104.9-41.2-15.6-10.6-29.3-24.5-37.7-43.1-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2-23.6-4c7.2-40.8 34.4-68.8 70.5-83.9 35.3-14.8 79.6-17.8 125.7-10.7 13.7 2.1 55.1 9.9 69.7 13.8l23.2 6.1-12.1 46.4-23.2-6.1c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7-3.6 23.7c-40.4-6.2-75.2-2.9-99.9 7.5z" })
  }
), qE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360.2 80.9 382.9 48 416 0H96l33.1 48 22.7 32.9 27.2 39.5c-8.2 5.3-17.8 11.7-28.2 19.4C89.4 185.5 0 274.8 0 416v96h512v-96c0-141.2-89.4-230.5-150.8-276.1-10.4-7.7-20-14.2-28.2-19.4L360.3 81zM464 464H48v-48c0-139 102.9-220.6 156.9-255.2l13.8-8.8h74.6l13.8 8.8C361.1 195.4 464 277 464 416zM293.5 93.2 286 104h-60l-7.5-10.8L187.4 48h137.2zM276 224v-20h-40v26c-5.6 1.2-11 2.9-16 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4.1.3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.8-4.4-1.5-6.4-2.2l-19-6.3-12.6 38 19 6.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 7 29.9 9.1V436h40v-25.5c5.4-1 10.6-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V224z" })
  }
), WE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m382.9 48-22.7 32.9-27.2 39.5c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416v96H0v-96c0-141.2 89.4-230.5 150.8-276.1 10.4-7.7 20-14.2 28.2-19.4l-27.2-39.6L129.1 48 96 0h320zM464 416c0-139-102.9-220.6-156.9-255.2l-13.8-8.8h-74.6l-13.8 8.8C150.9 195.4 48 277 48 416v48h416zM286 104l7.5-10.8L324.6 48H187.4l31.1 45.2L226 104zm-77 135 47 47 47-47 17-17 33.9 34-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17z" })
  }
), EE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m382.9 48-22.7 32.9-27.2 39.5c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416v96H0v-96c0-141.2 89.4-230.5 150.8-276.1 10.4-7.7 20-14.2 28.2-19.4l-27.2-39.6L129.1 48 96 0h320zM464 416c0-139-102.9-220.6-156.9-255.2l-13.8-8.8h-74.6l-13.8 8.8C150.9 195.4 48 277 48 416v48h416zM286 104l7.5-10.8L324.6 48H187.4l31.1 45.2L226 104z" })
  }
), OE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 320h272L256 0zM56 352H0l28.8 48L96 512h384l67.2-112 28.8-48h-56zm28.8 48h406.4l-38.4 64H123.2zM224 64 48 320h176z" })
  }
), IE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 96c2.6 0 5.2.1 7.8.2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4-53 0-96 43-96 96s43 96 96 96h73.4l-84.7-84.7L73.4 160 96 137.4l11.3 11.3L208 249.4V96h32v160h52c-2.6-10.2-4-21-4-32 0-70.7 57.3-128 128-128M144 433.5l-27.4-13c-33.7-16-58.6-47.1-66.2-84.5h411.2c-7.6 37.4-32.5 68.5-66.2 84.5l-27.4 13V464H144v-.2zM1.7 336C9.8 392.6 46.1 440.1 96 463.8V512h320v-48.2c49.9-23.7 86.2-71.2 94.3-127.8 1.1-7.8 1.7-15.9 1.7-24v-24H0v24c0 8.1.6 16.2 1.7 24zM464 224c0 12.3-4.6 23.5-12.2 32h54.8c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32h54.8c-7.6-8.5-12.2-19.7-12.2-32 0-26.5 21.5-48 48-48s48 21.5 48 48z" })
  }
), NE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m384 512-7.5-48-55.2-353.3C311.3 47 256.5 0 192 0S72.7 47 62.7 110.7L7.5 464 0 512H335.4zm-56.1-48H56.1l42.5-272h186.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-64 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0m112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), XE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 112v32H48v-32zM48 64H0v128h512V64h-48zm416 336H48v-32h416zM48 320H0v128h512V320h-48zm94.2-103.2-5.8-1.5-5.8 1.3-104 24L3.2 246 14 292.8l23.4-5.4 98.2-22.7 114.2 30.5 6.2 1.6 6.2-1.6 114.2-30.5 98.2 22.7 23.4 5.4 10.8-46.8-23.4-5.4-104-24-5.8-1.3-5.8 1.5L256 247.2z" })
  }
), KE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0v48c150.2 0 272 121.8 272 272h48C512 143.3 368.7 0 192 0m0 104v48c92.8 0 168 75.2 168 168h48c0-119.3-96.7-216-216-216m17 233 56-56-34-34-56 56-95-95-34.2-34.2c-10.3 12.8-19.1 26.8-26.1 41.8C7.1 242.4 0 272.4 0 304c0 114.9 93.1 208 208 208 31.6 0 61.6-7.1 88.4-19.7 15-7.1 29-15.8 41.8-26.1L304 432zM48 304c0-18.1 3-35.4 8.5-51.6l203.1 203.1c-16.2 5.5-33.5 8.5-51.6 8.5-88.4 0-160-71.6-160-160" })
  }
), QE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M401.9 398.1 368 432l-33.9-33.9-35.5-35.5c6 36.5.8 74.5-15.6 108.6-7 14.5-16 28.2-27 40.9l-34-34-77-77L81 465l-34-34 64-64-77-77-34-34c12.6-11 26.4-20.1 40.9-27 34.1-16.4 72.1-21.5 108.6-15.6L114 177.9 80 144l33.9-33.9L190 34l34-34 33.9 33.9L304 80l30.1-30.1L368 16l33.9 33.9L462 110l34 34-33.9 33.9L432 208l46.1 46.1L512 288l-33.9 33.9L402 398zM398 242l-76.1 76.1 46.1 46 76.1-76.1-46.1-46.1zM270 114l-46-46.1-76.1 76.1 46.1 46.1 76.1-76.1zm98-30.1L214.4 237.5c12 7.3 23.3 16.2 33.6 26.5s19.2 21.6 26.5 33.6L428.1 144zM246.2 434.3c15.4-46.6 4.4-99.8-32.2-136.4s-89.8-47.6-136.4-32.2z" })
  }
), ZE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384.7 69.2c-37.6 13-64.7 48.7-64.7 90.8 0 88.4-71.6 160-160 160-42.1 0-77.8 27.1-90.8 64.7L0 360v112l69.2-24.7C82.2 485 117.9 512 160 512c194.4 0 352-157.6 352-352 0-42.1-27.1-77.8-64.7-90.8L472 0H360zM416 112c26.5 0 48 21.5 48 48 0 167.9-136.1 304-304 304-26.5 0-48-21.5-48-48s21.5-48 48-48c114.9 0 208-93.1 208-208 0-26.5 21.5-48 48-48" })
  }
), JE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.1 44.9c12-13.7 21.7-22.4 21.7-22.4S240 83 240 134.5c0 14.7-2.8 28.7-7.9 41.5h-55.3c8.9-15.4 9.3-35.4.2-52.1-1.4-2.8-2.8-5.6-4.9-8.4l-25.2 29.4s-40.6-51.8-43.4-55.3C82.5 115.5 72 130.2 72 147c0 11.2 2.7 21 7.5 29H23.9c-5.1-12.8-7.9-26.8-7.9-41.5C16 72.6 105.6.1 105.6.1s22.8 18.5 45.5 44.8zM0 208h272v48h-23.2l-20.2 55.4 1 .8L318 224l-16-16 34-33.9 16 16 14-14.1-16-16 34-33.9 16 16 14-14.1-16-16 34-33.9 16 16 23-23 7-7h107.9l7 7 40 40 7 7V184H539.1L312.2 449.8c-33.7 39.5-83 62.2-134.9 62.2h-5.5C76.9 512 0 435.1 0 340.2c0-9.5.8-18.9 2.3-28.2l9.3-56H0zm448-46.1L433.9 176 400 209.9 385.9 224 352 257.9 249 360.8l-14.7 14.7-16.6-12.4-32-23.8-14.3-10.7 6.1-16.8 20.2-55.8H60.3l-10.6 63.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464h5.5c37.8 0 73.8-16.6 98.3-45.4l234.1-274.2 7.2-8.4h73.2l-24-24h-68.2l-16 16zM96 312a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), jE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488 32h-9.9l-7 7-23 23-16-16-34 34 16 16-14.1 14-16-16-33.9 34 16 16-14.1 14-16-16-33.9 34 16 16-88.3 88.2-1.2-.9L265 176h23v-48H0v48h26.1L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480h9.1c51.9 0 101.2-22.7 134.9-62.2L539.1 152H640V86.1l-7-7L593 39l-7-7h-10zM75.3 176h138.8l-36.7 104-5.9 16.7 14.2 10.6 32 23.8 16.6 12.4 14.7-14.7 103-102.9 33.9-33.9 14.1-14.1 33.9-33.9 14.1-14.1L481.9 96l16-16H566l24 24h-73.1l-7.2 8.4-234.1 274.2C251 415.4 215.1 432 177.3 432h-9.1C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1zM136 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), YE = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M520 48H393.3C381 19.7 352.8 0 320 0s-61 19.7-73.3 48H96v48h145.6c5.8 28.6 26.9 51.7 54.4 60.3V464H96v48h448v-48H344V156.3c27.5-8.6 48.6-31.7 54.4-60.3H544V48zM97.5 128l-6.7 12.9-88 168-2.8 5.2v47.8l7 7 40 40 7 7h147.9l7-7 40-40 7-7v-47.8l-2.7-5.2-88-168-6.7-12.9H112zm29 48h3l75.4 144H51.1zM496 128h-14.5l-6.7 12.9-88 168-2.7 5.2v47.8l7 7 40 40 7 7h147.8l7-7 40-40 7-7v-47.8l-2.7-5.2-88-168-6.7-12.9H528zm-60.9 192 75.4-144h3l75.4 144zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), _E = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80c0 2.8-.1 5.5-.4 8.3l127.7 40.9 22.9 7.3-14.6 45.7-22.9-7.3-132.3-42.4c-9.6 11-22.1 19.4-36.4 23.8V512H96v-48h200V156.3c-30.1-9.5-52.5-36.2-55.6-68.6L112.7 46.9l14.6-45.8 123.1 39.4C264.2 16.3 290.2 0 320 0c44.2 0 80 35.8 80 80m142.5 144 6.7 12.9 88 168 2.7 5.2v47.8l-7 7-40 40-7 7H438.1l-7-7-40-40-7-7v-47.8l2.7-5.2 88-168 6.7-12.9h61zm-29 48h-3l-75.4 144h153.8zM144 96h14.5l6.7 12.9 88 168 2.7 5.2v47.8l-7 7-40 40-7 7H54.1l-7-7L7 337l-7-7v-47.9l2.7-5.2 88-168L97.5 96H112zm60.9 192-75.4-144h-3L51.1 288zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), hO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 80c0 2.8.1 5.5.4 8.3l-127.7 40.8-22.9 7.3 14.6 45.7 22.9-7.3 132.3-42.3c9.6 11 22.1 19.4 36.4 23.8V512h248v-48H344V156.3c30.1-9.5 52.5-36.2 55.6-68.6l127.7-40.8-14.6-45.8-123.1 39.4C375.8 16.3 349.8 0 320 0c-44.2 0-80 35.8-80 80M97.5 224l-6.7 12.9-88 168-2.8 5.2v47.8l7 7 40 40 7 7h147.9l7-7 40-40 7-7v-47.8l-2.7-5.2-88-168-6.7-12.9H112zm29 48h3l75.4 144H51.1zM496 96h-14.5l-6.7 12.9-88 168-2.7 5.2v47.8l7 7 40 40 7 7h147.8l7-7 40-40 7-7v-47.8l-2.7-5.2-88-168-6.7-12.9H528zm-60.9 192 75.4-144h3l75.4 144zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), cO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M458.8 84.9c3.4-4 5.2-9.1 5.2-14.4v-4.3c0-10.1-8.2-18.2-18.2-18.2-5.2 0-10.2 2.2-13.6 6.1L266.9 240h62.6zl36.9 30.7L352 288H160l42.7-48L396.2 22.2C408.8 8.1 426.8 0 445.8 0 482.3 0 512 29.7 512 66.2v4.2c0 16.5-5.8 32.5-16.3 45.1zM0 512l176-192h112C288 496 0 512 0 512m248-48h72v48h-96v-48zm128 0h72v48h-96v-48zm176 0h24v48h-96v-48h24z" })
  }
), sO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 70.5v-4.3c0-10.1-8.2-18.2-18.2-18.2-5.2 0-10.2 2.2-13.6 6.1L266.9 240h62.6L458.8 84.9l36.9 30.7-36.9-30.7c3.4-4 5.2-9.1 5.2-14.4m31.7 45.1L352 288H160l42.7-48L396.2 22.2C408.8 8.1 426.8 0 445.8 0 482.3 0 512 29.7 512 66.2v4.2c0 16.5-5.8 32.5-16.3 45.1zM176 320h112C288 496 0 512 0 512z" })
  }
), vO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 32H416v48h160zM118 413.7l-53.7-31.6L132.6 256h73.6zM261.2 256H352V32H112C50.1 32 0 82.1 0 144c0 50.9 34 93.9 80.4 107.5L0 400l94.6 55.7L136 480l23.4-41.9zM416 192v48h160v-48zm160 240H416v48h160zM416 128v32h160v-32zm160 160H416v32h160zm-160 64v32h160v-32zM112 80h192v128H112c-35.3 0-64-28.7-64-64s28.7-64 64-64" })
  }
), eO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M66.2 42.3 44.4 32.1 24.1 75.6l21.7 10.1L478.2 288H0v192h576V280.7l-13.8-6.5-496-232zM528 336v96H48v-96zm-376 24v48h48v-48zm-32 0H72v48h48z" })
  }
), lO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0v64h48V0zm176 0v64h48V0zm-48 0h-32v64h32zm128 0v288h32V0zm128 0h-48v288h48zM48 144h256v320H48zm0-48H0v416h352V96h-48zm224 160v-80H80v80zm-112 48H80v48h80zm-80 80v48h80v-48zm192-80h-80v48h80zm-80 80v48h80v-48z" })
  }
), tO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0v64h48V0zm176 0v64h48V0zm-48 0h-32v64h32zm128 0v288h32V0zm128 0h-48v288h48zM48 144h256v320H48zm0-48H0v416h352V96h-48zm224 336V176H80v256z" })
  }
), wO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 160a56 56 0 1 0 0-112 56 56 0 1 0 0 112m0 48c-29.5 0-56.1-12.3-75-32H80v32h82.5l-2.6 26.4-11.4 113.7 15.6-8.9 12.9-7.4 12.3 8.2 34.7 23.2 34.7-23.2 12.3-8.2 12.9 7.4 15.6 8.9-11.4-113.7-2.6-26.4H368v-32h-69c-18.9 19.7-45.6 32-75 32m104-104c0 8.3-1 16.3-2.8 24H432l-16 32 32 32-32 32 16 32h-93.5l13.4 133.6 4.6 46.3-40.4-23.1-43.1-24.6-35.7 23.8-13.3 8.8-13.3-8.8-35.7-23.8-43.1 24.6-40.4 23.1 4.6-46.3L109.5 256H16l16-32-32-32 32-32-16-32h106.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104M200 72a16 16 0 1 1 0 32 16 16 0 1 1 0-32m32 32a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-32 384v-44.7l24 16 24-16V512h-48z" })
  }
), gO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m408.6 222.1 7.4-7.4v-91.4L336.7 0H175.3L96 123.3v91.3l158.1 158.1 22.6 22.6 11.3 11.3 100.7 100.7 22.6-22.6L310.6 384l11.3-11.3 14.1-14.1 100.7 100.7 22.6-22.6L358.6 336l14.1-14.1 11.3-11.3 100.7 100.7 22.6-22.6L406.6 288l-11.3-11.3-20.7-20.7 33.9-33.9zM338.7 288 288 338.7l-144-144v-57.3L201.5 48h109l57.5 89.4v57.3L340.7 222 290 171.3l14-14V128h-96v29.3l98.7 98.7zM4.7 388.7l22.6 22.6 112-112-22.6-22.6-112 112m48 48 22.6 22.6 112-112-22.6-22.6-112 112m48 48 22.6 22.6 112-112-22.6-22.6-112 112" })
  }
), iO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m466.7 144-11.4-6.8L320 56l-135.3 81.2-11.4 6.8H48v320h208v-80c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-4.3 15.2-6.5 31.1-6.5 47.7 0 59.5 29.6 112.2 74.8 144H0V96h160L320 0l160 96h160v170.8c-12.9-18.3-29.2-34.1-48-46.3V144H480zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1-10.3 4.8-21.6 7.4-33.6 7.4-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 12-2.6 23.3-7.3 33.5M160 192v96H96v-96zM96 320h64v96H96zm240-160v-16h-32v64h56v-32h-24zm16 208a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L552 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), mO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m466.7 144-11.4-6.8L320 56l-135.3 81.2-11.4 6.8H48v320h208v-80c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-4.3 15.2-6.5 31.1-6.5 47.7 0 59.5 29.6 112.2 74.8 144H0V96h160L320 0l160 96h160v170.8c-12.9-18.3-29.2-34.1-48-46.3V144H480zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1-10.3 4.8-21.6 7.4-33.6 7.4-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 12-2.6 23.3-7.3 33.5M160 192v96H96v-96zM96 320h64v96H96zm240-160v-16h-32v64h56v-32h-24zm160 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 224v-32h-32v32zm0-176h-32v112h32v-96z" })
  }
), aO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m466.7 144-11.4-6.8L320 56l-135.3 81.2-11.4 6.8H48v320h208v-80c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-4.3 15.2-6.5 31.1-6.5 47.7 0 59.5 29.6 112.2 74.8 144H0V96h160L320 0l160 96h160v170.8c-12.9-18.3-29.2-34.1-48-46.3V144H480zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1-10.3 4.8-21.6 7.4-33.6 7.4-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 12-2.6 23.3-7.3 33.5M160 192v96H96v-96zM96 320h64v96H96zm240-160v-16h-32v64h56v-32h-24zm160 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3 11.3-11.3-22.6-22.6-11.3 11.3-36.7 36.7-36.7-36.7-11.3-11.3-22.6 22.6 11.3 11.3 36.7 36.7-36.7 36.7-11.3 11.3 22.6 22.6 11.3-11.3 36.7-36.7 36.7 36.7 11.3 11.3 22.6-22.6-11.3-11.3-36.7-36.7 36.7-36.7z" })
  }
), oO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0h104v96h-97.9l89.6 64H576v352H0V160h168.3L264 91.6V0h24zm216 464V208H392.3l-6.3-4.5-98.1-70-98.1 70-6.3 4.5H48v256h192v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64zM240 240a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-80 16v64H96v-64zm256 0h64v64h-64zm-256 96v64H96v-64zm320 0v64h-64v-64z" })
  }
), nO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m466.7 144-11.4-6.8L320 56l-135.3 81.2-11.4 6.8H48v320h208v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v128H0V96h160L320 0l160 96h160v176c0-38.1-19-71.7-48-91.9V144H480zM160 192v96H96v-96zm0 128v96H96v-96zm80-128a80 80 0 1 1 160 0 80 80 0 1 1-160 0m96-48h-32v64h56v-32h-24v-16zm192 96c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H416V320h32z" })
  }
), rO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m466.7 144-11.4-6.8L320 56l-135.3 81.2-11.4 6.8H48v320h208v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80h208V144H480zM592 96h48v416H0V96h160L320 0l160 96zm-432 96v96H96v-96zm320 0h64v96h-64zM160 320v96H96v-96zm320 0h64v96h-64zM240 192a80 80 0 1 1 160 0 80 80 0 1 1-160 0m96-48h-32v64h56v-32h-24v-16z" })
  }
), dO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m512.3 413-30.8 36.8-18.5-15.4-150.6-126.2 37.4-31.3 144.1 120.7zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128m0-48c61.9 0 112 50.1 112 112 0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6 491 54.2 521.8 91l-18.4 15.4-291 243.8c7.4 15 11.6 31.9 11.6 49.8 0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8l67.8-56.8-67.8-56.8C163.1 214.7 138.6 224 112 224 50.1 224 0 173.9 0 112S50.1 0 112 0m64 400a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), SO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 320a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0m32 192-32-96H32L0 512zm112-192a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0m32 192-32-96H256l-32 96zm128-208a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128m64 32H480l-32 96h192zM560 48H80v177.3a95.98 95.98 0 0 0-48 23.1V0h576v248.4c-13.2-11.8-29.7-20.1-48-23.1z" })
  }
), zO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80H48v116c-15.6-2.6-31.6-4-48-4V32h576v448H288c0-16.4-1.4-32.4-4-48h244zM0 272v-48c141.4 0 256 114.6 256 256h-48c0-114.9-93.1-208-208-208m32 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m80 64c0-61.9-50.1-112-112-112v-48c88.4 0 160 71.6 160 160z" })
  }
), pO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m33.9 366.1 126.5-126.5 33.9 33.9L67.9 400l44.1 44.1 95.4-95.4 17.9 17.9 16 16-95.4 95.4-33.9 34-33.9-33.9-44.2-44.2L0 400zM224 144.8V80l-7.3-5.5C245.1 29.7 295.1 0 352 0c13.5 0 26.7 1.7 39.3 4.9 17 4.3 33 11.3 47.3 20.6l-35.1 35L352 112v48h48l51.5-51.5 35.1-35.1c9.3 14.4 16.3 30.3 20.6 47.3 3.2 12.6 4.9 25.7 4.9 39.3 0 57.2-30 107.3-75.1 135.6l-35.2-35.2c35.8-17.8 60.8-54.1 62.3-96.5l-30 30-14.2 14.1H304V92.1L318.1 78l30-30C288 50.1 240 99.5 240 160v.8zM287 321 158 192H96L0 64 64 0l128 96v62.1L321 287l31-31 160 160-96 96-160-160z" })
  }
), MO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 120v24h24l56.6-75.5-5.1-5.1zm144-56-96 128h-62.1l-82.3 82.3-33.9-33.9 82.3-82.3V96L448 0zM129.9 478.1 96 512l-33.9-33.9-28.2-28.2L0 416l33.9-33.9 116.2-116.2L184 232l33.9 33.9L246 294l34 34-33.9 33.9zM212.1 328 184 299.9 67.9 416 96 444.1z" })
  }
), xO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.3 21.4C198.3 7.7 218 0 238.4 0h1C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23 0 18 14.6 32.6 32.6 32.6 8.6 0 16.9-3.4 23-9.5l238.9-238.9c15.1-15.1 35.6-23.6 57-23.6 44.5 0 80.6 36.1 80.6 80.6 0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39 0 30.5 24.7 55.2 55.2 55.2h4.4c5.6 0 11.2-.9 16.6-2.7l36.2-12.1 15.2 45.5-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2h-4.4c-57 0-103.2-46.2-103.2-103.2 0-27.4 10.9-53.6 30.2-73l104.3-104.2c6.1-6.1 9.5-14.4 9.5-23 0-18-14.6-32.6-32.6-32.6-8.6 0-16.9 3.4-23 9.5L169.5 424.4a80.607 80.607 0 0 1-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57l206.9-206.8c6.1-6.1 9.5-14.4 9.5-23 0-18-14.6-32.6-32.6-32.6h-1c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7 7.8 182.3 183.3 21.4z" })
  }
), HO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 80c-17.7 0-32 14.3-32 32v48h32v48H0v-96c0-44.2 35.8-80 80-80h320c44.2 0 80 35.8 80 80v160h-96v-32h48v-80h-48v-32h48v-16c0-17.7-14.3-32-32-32H153.3c4.3 9.8 6.7 20.6 6.7 32v112h64v32h-64v144c0 17.7 14.3 32 32 32s32-14.3 32-32v-96H577.4v96c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V112c0-17.7-14.3-32-32-32m185.3 352H496c17.7 0 32-14.3 32-32v-48H400v48h-32v-48H272v48c0 11.4-2.4 22.2-6.7 32" })
  }
), VO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h64V48zm112 416v48H0V0h160v48h320V0h160v512H480v-48zm320-48V96H160v320zm48 48h64V48h-64v368zM187.1 332l10.5-18 33.8-58-33.8-58-10.5-18H275.8l33.9-58 10.3-17.8 10.4 17.8 33.9 58h88.6l-10.5 18-33.8 58 33.8 58 10.5 18H364.2l-33.9 58-10.3 17.8-10.4-17.8-33.9-58H208zM320 360.2l16.4-28.2h-32.8zM289.6 308h60.9l30.3-52-30.3-52h-60.9l-30.3 52zm105.1-28.2L378.2 308h32.9zm16.4-75.8h-32.9l16.4 28.2zM320 151.8 303.6 180h32.9zm-74.7 80.4 16.5-28.2h-32.9zm16.5 75.8-16.4-28.2-16.5 28.2z" })
  }
), CO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32v288c0 44.2 35.8 80 80 80h304c44.2 0 80-35.8 80-80v-96H224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V112c0-11.4-2.4-22.2-6.7-32H400c17.7 0 32 14.3 32 32v160h48V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v96h80v-48H48zm448 320H265.3c4.3-9.8 6.7-20.6 6.7-32v-48H527.6v48c0 17.7-14.3 32-32 32z" })
  }
), LO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), BO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0C161.2 0 64.9 110.2 24.4 176 7.1 204 0 224 0 224h509.4l9.9-48H82.4c7.4-9.9 16.1-20.3 26.1-30.7C154.9 97.2 231 48 352 48h193.8l9.9-48zm285.5 0h-49l-59.6 288H384v48h134.9l-36.4 176h49L568 336v-.2z" })
  }
), uO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v416H48V147.9L147.9 48zM128 0 0 128v384h384V0h-48zm48 96V80h-32v96h32v-16zm64 0V80h-32v96h32v-16zm64 0V80h-32v96h32v-16z" })
  }
), RO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 368V48H227.9L144 131.9V368zM96 112 208 0h240v416H96v-48zM48 96v368h336v48H0V96zm256 0v80h-32V80h32zm64 0v80h-32V80h32z" })
  }
), $O = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289.9 33.9 41 41h106v106l41 41L512 256l-33.9 33.9-41 41v106H331l-41 41-34 34.1-33.9-33.9-41-41H75V331l-41-41-34-34 33.9-33.9 41-41V75h106l41-41L256 0zm41 89h-19.8l-14.1-14-41-41-41 41-14.1 14.1H123v77.9L108.9 215l-41 41 41 41 14.1 14.1V389h77.9l14.1 14.1 41 41 41-41 14.1-14.1H389v-77.9l14.1-14.1 41-41-41-41-14.1-14.1V123h-58zm-51 5V288H232V128h48zM232 320h48v48h-48z" })
  }
), kO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m289.9 33.9 33 33h114v114l41 41L512 256l-33.9 33.9-41 41v114H323l-33 33-34 34.1-33.9-33.9-33-33H75V331l-41-41-34-34 33.9-33.9 41-41V67h114l33-33L256 0zm33 81h-19.8l-14.1-14-33-33-33 33-14.1 14.1H123v85.9L108.9 215l-41 41 41 41 14.1 14.1V397h85.9l14.1 14.1 33 33 33-33 14.1-14.1H389v-85.9l14.1-14.1 41-41-41-41-14.1-14.1V115h-66zM168 184c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4V296h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H224c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48z" })
  }
), PO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m331 75-41-41-34-34-33.9 33.9L181 75H75v106l-41 41-34 34 33.9 33.9 41 41v106h106l41 41L256 512l33.9-33.9 41-41h106V331l41-41 34.1-34-33.9-33.9-41-41V75H389zm58 48v77.9l14.1 14.1 41 41-41 41-14.1 14.1V389h-77.9L297 403.1l-41 41-41-41-14.1-14.1H123v-77.9L108.9 297l-41-41 41-41 14.1-14.1V123h77.9l14.1-14.1 41-41 41 41 14.1 14.1H331z" })
  }
), FO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v165.1l2.1 4.7 104 232 6.4 14.2H216v48H96v48h288v-48H264v-48h120l6.2-14.8 40-96L444 272H100.5l-14.3-32H352v-48H64.6L48 154.9zm95.5 344L122 320h250l-20 48z" })
  }
), TO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6 17.6-7.7 42.8-10.5 73.1-5.6l3.2-20.4-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1l12.7-46.3c-11.5-3.2-43.5-9.5-54.1-11.3C121.8-2.8 86.5-.5 58 12.1 28.6 25.1 6.7 49 1 83.3c-.1.4-.1.8-.2 1.2-2.2 19.5.4 37 7.9 52.3 7.4 15.2 18.8 26.6 31.4 35.3 2.4 1.7 4.9 3.3 7.4 4.8-23.3 12.9-40.7 33.8-45.8 62.5-.1.4-.1.9-.2 1.3-2.3 18.8.4 35.8 8.1 50.7 7.6 14.6 19.1 25.5 31.6 33.7 22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7 7.1 5.1 11.4 10.2 13.7 15.6 2.3 5.3 3.6 12.8 1.6 24.2-2.5 14.2-11.6 25.1-28.5 32.2-17.7 7.4-43.1 9.9-73.3 5.3-14.9-2.4-40.4-10.8-61-17.7-4.5-1.5-8.8-2.9-12.7-4.2l-14.9 45.8c3 1 6.5 2.1 10.5 3.5 20.3 6.7 51.4 17.1 70.6 20.2h.1c36 5.5 70.9 3.3 99.1-8.5 29-12.1 51.4-34.8 57.3-68.1 3.4-19 1.9-36.3-4.8-51.8-6.7-15.3-17.6-26.8-29.8-35.6 17.7-13.5 30.5-32.7 34.7-58 3.3-19.7 1.8-37.5-4.7-53.4-6.5-15.8-17.3-27.9-29.6-37.2-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1-7.7-5.4-12.7-11-15.7-17-2.8-5.8-4.6-13.7-3.4-25.1zm114.8 228.7c-8.6-2.8-17-5.2-25-7.6l-.8-.2c-29.1-8.5-53.2-15.6-69.8-26.5-7.8-5.1-12.6-10.3-15.4-15.7-2.6-5-4.3-11.9-3.2-22.1 2.7-13.9 11.7-24.6 28.4-31.6 13-5.4 30.2-8.3 50.5-7.5 26.9 8.4 48.6 15.8 63.1 26.8 7.1 5.4 11.6 10.9 14.1 17.1 2.5 6.1 3.9 14.7 1.8 27.2-3.3 19.4-17.2 33.8-43.7 40.1z" })
  }
), AO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 32V0h-56c-85.5 0-159.9 48-197.6 118.5 12.1 14.5 22.7 30.2 31.6 47.1C314 97.1 379.3 48 456 48h7.3c-7.5 83.3-73.1 149.9-156 159 4.9 15.1 8.4 30.9 10.5 47.1 104.4-13.9 186.1-99.7 193.6-206 .4-5.3.6-10.6.6-16zM56 112c97.2 0 176 78.8 176 176v16h-8c-97.2 0-176-78.8-176-176v-16zm223.9 168C275.6 160 177 64 56 64H0v64c0 123.7 100.3 224 224 224h8v160h48V280z" })
  }
), DO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 104v48h48v-48zM24 56h144v144H24v-96zm40.5 456H16l6.9-48L48 288h112v96L80 512zm25.1-176-13 90.8 35.4-56.6V336z" })
  }
), yO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48v160H48V48zM48 0H0v256h256V0h-48zm544 304v160H432V304zm-160-48h-48v256h256V256h-48zm-272 32v128h192V224h128V96H288v192h-32z" })
  }
), bO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0H0v352h128V128h224zM208 208h256v256H208zm-48-48v352h352V160H208z" })
  }
), fO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v144c17.2 0 33.5 3.9 48 10.8V32H0v448h224v-48H48zm96 72v-24H96v160h48v-24zm96 0v-24h-48v160h48v-24zm16 280v80h384v-80c0-38.7-27.5-71-64-78.4V344c0-30.9-25.1-56-56-56-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80v17.6c-36.5 7.4-64 39.7-64 78.4" })
  }
), UO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v80.5c15.4-14.4 31.5-28.1 48-41.5V32H0v448h336.8c-12.7-14.2-23.4-30.4-31.4-48H48zm96 72v-24H96v160h48v-24zm96 0v-24h-48v160h48v-24zm273 72.1c-32.3-37.5-65-64-65-64s-128 103.6-128 192 71.6 160 160 160 160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), GO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm96 96H96v160h48V152zm96 0h-48v160h48V152zm357.3-20 20-13.3-26.6-40-20 13.3-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM536 232h-24v48h128v-48h-24zm13.3 140-20-13.3-26.6 39.9 20 13.3 48 32 20 13.3 26.6-39.9-20-13.3z" })
  }
), qO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v101.2l48-88V32H0v448h237l26.2-48H48zm96 72v-24H96v160h48v-24zm96 0v-24h-48v160h48v-24zm208 8L256 512h384zm16 144v80h-32v-96h32zm-32 112h32v32h-32z" })
  }
), WO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm144 120v136H96V128h48zm96 0v136h-48V128h48z" })
  }
), EO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v96h416V80zM0 32h512v192H0V80zm48 304v96h416v-96zM0 288h512v192H0V336zm392 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0m24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-88 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0m24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), OO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 224h256l-27.4-48-73-127.6L288 0l-27.6 48.4-73 127.6zM288 96.7l45.3 79.3h-90.6zM128 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160m0 208a128 128 0 1 0 0-256 128 128 0 1 0 0 256m336-192v128H336V320zm-128-48h-48v224h224V272h-48z" })
  }
), IO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M469.6 184.4 352 76.6V32h32l192 176-192 176h-32v-44.6l117.6-107.8 25.8-23.6-25.7-23.6zM128 480s-41.8-15.7-77.7-53C23.5 399 0 358.8 0 304c0-97.2 78.8-176 176-176h48V32h32l16 14.7 140.5 128.7L448 208l-35.5 32.6L272 369.3 256 384h-32v-96h-16c-11.1 0-21.9 1.6-32 4.6-46.3 13.8-80 56.7-80 107.4 0 1.4 0 2.9.1 4.3C97.9 449.9 128 480 128 480M48 304c0 17 3.1 32 8.2 45.4C77.4 285.8 137.3 240 208 240h64v64.2L377 208l-105-96.2V176h-96c-70.7 0-128 57.3-128 128" })
  }
), NO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 240v-48h-97.5c-54.1 0-100.2 33.9-118.3 81.6-5.2-10.2-8.2-21.3-8.2-33.6 0-61.9 50.1-112 112-112h112V67.9l92.1 92.1-92.1 92.1zm-176 78.5c0-1.2 0-2.3.1-3.4 1.8-41.8 36.2-75.1 78.5-75.1H352v80h48l126.1-126.1L560 160l-33.9-33.9L400 0h-48v80h-64c-88.4 0-160 71.6-160 160 0 44.7 23.3 77.4 50 100.3 35.9 30.8 78 43.7 78 43.7s-32-26.2-32-65.5M24 32H0v480h480V360h-48v104H48V80h112V32h-24z" })
  }
), XO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 128c0 53-43 96-96 96-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1l89.7 44.9c17.6-20.2 43.5-33 72.4-33 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-6.9.7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1 0-53 43-96 96-96s96 43 96 96M96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96m304-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), KO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50.3 427c35.8 37.4 77.7 53 77.7 53s-30.1-30.1-31.9-75.7c-.1-1.4-.1-2.8-.1-4.3 0-61.9 50.1-112 112-112h80v96h32l16-14.7 140.5-128.7L512 208l-35.5-32.6L336 46.7 320 32h-32v96H176C78.8 128 0 206.8 0 304c0 54.8 23.5 95 50.3 123m5.8-77.6C51.1 336 48 321 48 304c0-70.7 57.3-128 128-128h160v-64.2L441 208l-105 96.2V240H208c-70.7 0-130.6 45.8-151.8 109.4z" })
  }
), QO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m576 135.8 14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5-55.1-23.6L512 32h-64l-42.3 42.3-55.2 23.6-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2V288H576zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0M302.3 83.8c-6.5-6.9-14.6-12.3-23.6-15.7C271.6 65.5 264 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5L120 512h88v-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V512h88l22.5-120h1.5c35.3 0 64-28.7 64-64 0-2.7-.2-5.4-.5-8h-49l1 4.1c.3 1.2.5 2.5.5 3.9 0 8.8-7.2 16-16 16-.9 0-1.7-.1-2.5-.2l-43.5-6.7-10.4 42.7c-1.7 7-8.1 12.1-15.5 12.1-3.8 0-7.2-1.3-9.9-3.4l-36-28.5-30.2 34.5c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5l-30-34.5-35.9 28.5c-2.7 2.2-6.1 3.4-9.9 3.4-7.5 0-13.8-5.1-15.5-12.1L142 337.1l-43.5 6.7c-.8.1-1.6.2-2.5.2-8.8 0-16-7.2-16-16 0-1.4.2-2.7.5-3.9l9-36.3-33-17.6C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2l33-17.6-9-36.3a16 16 0 0 1-.5-3.9c0-8.8 7.2-16 16-16 .9 0 1.7.1 2.5.2l43.5 6.7 10.4-42.7c1.7-7 8.1-12.1 15.5-12.1 3.8 0 7.2 1.3 9.9 3.5l36 28.4 30.2-34.5c3-3.4 7.3-5.5 12.1-5.5 5.8 0 10.9 3 13.7 7.8l34.8 57.7 12.7-15.2-30.8-71.7z" })
  }
), ZO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h176V352h112V48zm208 464H0V0h384v384zm-52.7-404.7-96 96L96 214.6 73.4 192l11.3-11.3 96-96L192 73.4 214.6 96l-11.3 11.3zm96 32-160 160-11.3 11.3-22.6-22.6 11.3-11.3 160-160 11.3-11.3 22.6 22.6z" })
  }
), JO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 32H16v448h48V80h120c39.8 0 72 32.2 72 72v208h48V152c0-66.3-53.7-120-120-120zm272 448c66.3 0 120-53.7 120-120V32h-48v328c0 39.8-32.2 72-72 72H192V160h-48v320h24z" })
  }
), jO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24V0H0v512h48v-48h544v48h48V0h-48v160H48zm0 184h544v208H48z" })
  }
), YO = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0v160h544V0h48v512h-48v-48H48v48H0V0zm0 416h544V208H48zM352 0h128v128H352zM224 256v128H96V256zm160 0v128H256V256z" })
  }
), _O = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM224 208l-64-64v128c0 53 43 96 96 96s96-43 96-96V144l-64 64zm-8 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), hI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM369 209l17-17-34-33.9-17 17-111 111-47-47-17-17-33.9 33.9 17 17 64 64 17 17 17-17z" })
  }
), cI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM280 120V96h-48v72H112v48h120v200h48V216h120v-48H280z" })
  }
), sI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM160.9 270.2 144 304l128 64v-64h48c44.2 0 80-35.8 80-80v-48h-80l-16-32h-64v64c0 35.3-28.7 64-64 64-5.2 0-10.3-.6-15.1-1.8zM144 144v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h-8zm112 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), vI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM280 128h-48v160h48V152zm-48 192v48h48v-48z" })
  }
), eI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 60.8v386.6c-66.9-37.8-108.8-94.3-134.1-152.6C71 232.9 63.1 169.5 64.1 126zm48 386.5V60.8L448 126c1 43.5-6.9 106.9-33.8 168.8-25.4 58.3-67.3 114.7-134.2 152.5M495.5 113l-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9z" })
  }
), lI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM144 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6 11 10.6 11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7 0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z" })
  }
), tI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V352h48v-93.4c18.9-9 32-28.3 32-50.6z" })
  }
), wI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM184 232h-24v48h192v-48h-24z" })
  }
), gI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zM232 368h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), iI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 60.8V200H69.9c-4.7-27.7-6.3-53.1-5.8-74zM81 248h151v199.4c-66.9-37.8-108.8-94.3-134.1-152.6-6.8-15.6-12.4-31.3-16.9-46.8m199 199.3V248h151c-4.5 15.5-10.1 31.2-16.9 46.8-25.3 58.3-67.2 114.7-134.1 152.5M442.1 200H280V60.8L448 126c.5 20.9-1.1 46.3-5.8 74zm53.4-87-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9z" })
  }
), mI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m496.8 363 124.1 96.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 77.8 60.4L308.4 4.5 320 0l11.6 4.5L539.1 85l19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-7.2 16.5-15.6 32.9-25.3 49zM170.4 109.5l288.2 223.8c7.4-12.6 13.9-25.5 19.5-38.5C505 232.9 512.9 169.5 512 126L320 51.5zm-8.5 185.2c28.2 64.9 77 127.7 158.1 164.8 30-13.7 55.6-31 77.3-50.5l38.2 30.1c-28.1 26.5-62 49.7-102.8 67.3L320 512l-12.7-5.5c-98.4-42.6-156.7-117.3-189.4-192.6-23.5-54.1-34.1-109-37-154.2l53.3 42c5.2 29.5 13.9 61.5 27.7 93z" })
  }
), aI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zm-149 13.9-11.3 11.3C311.9 161.5 272 145 272 112V96h-32v16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3-11.3 11.3 11.3 11.3C177.5 184.1 161 224 128 224h-16v32h16c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3 11.3 11.3 11.3-11.3C200.1 318.5 240 335 240 368v16h32v-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C334.5 295.9 351 256 384 256h16v-32h-16c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3-11.3-11.3zM232 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), oI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.1 126 256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8-28.3 64.9-77.1 127.6-158.2 164.8-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126m431.4-13-1.2-20.5-19.2-7.5L267.6 4.5 256 0l-11.6 4.5L36.9 85l-19.1 7.5-1.2 20.5c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9zm-141.6 79L320 158.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), nI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 51.5 64.1 126c-1 43.5 6.9 106.9 33.8 168.8 28.2 64.9 77 127.7 158.1 164.8 81.1-37.1 129.9-99.9 158.1-164.8C441 232.9 448.9 169.5 448 126zm238.3 41 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.2-91.1 150-189.4 192.6L256 512l-12.7-5.5C144.9 463.9 86.5 389.2 53.9 313.9c-32.5-74.6-40.3-151-37.3-200.9l1.2-20.5L36.9 85 244.4 4.5 256 0l11.6 4.5L475.1 85l19.2 7.4z" })
  }
), rI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h192v64h96v179l56.9 22.8 30.9 12.4-21.5 25.4-88 104-36.6-31 66.5-78.6L288 217.8 87.8 297.9l66.5 78.6-36.6 31-88-104-21.5-25.4 30.9-12.4L96 243V64h96zm240 223.8V112H144v111.8l135.1-54 8.9-3.6 8.9 3.6zM79 488.9C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), dI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.4 0H264v24c0 30.9 25.1 56 56 56s56-25.1 56-56V0h146.6l6.8 12.4 13.7 24.9 88 160 5.9 10.8 3 5.4V448H496V250.5l-16-29.1V512H160V221.4l-16 29.1V448H0V213.5l3-5.4 5.9-10.8 88-160 13.7-24.9zm28.4 48L139 60.4l-88 160-3 5.4V400h48V238.1l3-5.4 64-116.4 45 11.7v336h224V128l45-11.6 64 116.4 3 5.4V400h48V225.8l-3-5.4-88-160-6.8-12.4h-73c-10.8 45.9-52 80-101.2 80s-90.4-34.1-101.2-80H160z" })
  }
), SI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 152c-44.2 0-80-35.8-80-80V0H64v122.3l-61.5 123-2.5 5V512h384V250.3l-2.5-5.1L320 122.3V0h-48v72c0 44.2-35.8 80-80 80m0 48c36.7 0 69.8-15.4 93.1-40.1l22 43.9c-.4.2-.7.5-1.1.8L48 390.8V261.7l50.9-101.8c23.3 24.7 56.4 40.1 93.1 40.1M48 450l280.8-202.7 7.2 14.4V464H48z" })
  }
), zI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 72c0 44.2 35.8 80 80 80s80-35.8 80-80V0h48v122.3l61.5 122.9 2.5 5.1V512H0V250.3l2.5-5.1L64 122.3V0h48v24zm173.1 87.9C261.8 184.6 228.7 200 192 200s-69.8-15.4-93.1-40.1L48 261.7V464h288V261.7z" })
  }
), pI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M203.7 0H254.3l2 21.8C259.2 54.4 286.6 80 320 80s60.8-25.6 63.7-58.2l2-21.8H436.3l6.7 5.6 8.9 7.4 144 120 25.1 21 18.9 15.7-16.2 18.5-21.6 24.7-56 64-20.6 23.5-15.4 17.6-18-15-12.1-10.1V512H160V292.9L147.9 303l-18 15-15.4-17.6-20.6-23.5-56-64-21.6-24.7L.1 169.7 19 154l25.2-21 144-120 8.8-7.4zm10.7 53.5L74.9 169.9l-6.3 5.2 5.4 6.2 56 64 5.1 5.9 6-5 27.5-22.9 39.4-32.9V464h224V190.4l39.4 32.8 27.5 22.9 6 5 5.1-5.9 56-64 5.4-6.2-6.3-5.2L425.5 53.5C410.1 96.9 368.7 128 320 128s-90.1-31.1-105.5-74.5z" })
  }
), MI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-3 19.1-8.1 26.7l39.9 26.7C506 134.1 512 115.7 512 96c0-53-43-96-96-96s-96 43-96 96c0 17.8 4.9 34.5 13.3 48.8L303 175l-45.1-45.1L224 96l-33.9 33.9L130 190l-2 2-32 32-1.9 1.9-60.2 60.2L0 320l33.9 33.9L79 399 2.2 475.8l33.9 33.9L113 433l45.1 45.1L192 512l33.9-33.9L286 418l2-2 32-32 1.9-1.9L382 322l34-34-33.9-33.9L337 209l45.1-45.1 17-17-17-17c-8.8-8.7-14.1-20.6-14.1-33.9m-80 252.1L163.9 224l60.1-60.1L348.1 288zm-96 96L67.9 320l60.1-60.1L252.1 384z" })
  }
), xI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m331.3 112 10.1 5.1 112.1 56.1L592 138.5V98.6L444.1 49.3 304 72.7V112h16zM304 160h-48V32L448 0l192 64v112l-192 48-128-64zM128 32h96v128h-96zm75.3 368H176v39.3l140.1 23.4L464 413.4v-39.9l-138.4-34.6-112.1 56zM176 352h16l128-64 192 48v112l-192 64-192-32V352zM0 480V352h96v128z" })
  }
), HI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m515.5 48 69.6 127.6c19.1 11.3 34.5 28.2 44.1 48.4H640v-48L544 0H96L0 176v48h64v288h320V224h42.8c9.5-20 24.7-36.7 43.5-48H54.7l69.8-128zM336 224v96H112v-96zM112 464v-96h224v96zm416-224c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), VI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m515.5 48 69.8 128H256L114.6 66.2l9.9-18.2zM76.2 36.4 48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-44.9-34.9V224h64v-48L544 0H96zM528 387.2 317.9 224H528zM54.7 176l14.1-25.8L30.5 120 0 176v48h64v288h320V398.5L284.3 320H112v-96h50.5l-60.9-48zM112 464v-96h224v96z" })
  }
), CI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m515.5 48 69.8 128H54.7l69.8-128zM96 0 0 176v48h64v288h320V224h144v288h48V224h64v-48L544 0zm240 224v96H112v-96zM112 464v-96h224v96z" })
  }
), LI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m400 0-33.9 33.9-6.9 6.9a79.09 79.09 0 0 0-23.2 56c0 13.1 3.2 25.5 8.8 36.4L255 223l-63-63L38.8 274.9 0 304l34.3 34.3 139.4 139.4L208 512l29.1-38.8L352 320l-63-63 89.8-89.8c10.9 5.7 23.3 8.8 36.4 8.8 21 0 41.1-8.3 56-23.2l6.9-6.9L512 112l-33.9-33.9-44.2-44.2zm0 67.9 44.1 44.1-6.9 6.9c-5.8 5.9-13.8 9.1-22.1 9.1-17.1 0-31.1-14-31.1-31.2 0-8.3 3.3-16.2 9.1-22.1l6.9-6.9zM73.1 309.2l114.4-85.8 101.1 101.1-85.8 114.4zm117.1-7.1 14.1-14.1-28.3-28.3-14.1 14.1-32 32-14.2 14.2 28.3 28.3 14.1-14.1 32-32zm48 48 14.1-14.1-28.3-28.3-14.1 14.1-32 32-14.2 14.2 28.3 28.3 14.1-14.1 32-32z" })
  }
), BI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M350.1 33.9 384 0l33.9 33.9L478 94l34 34-33.9 33.9-35.5 35.5c-17 17-40 26.5-64 26.5-16.3 0-31.6-4.3-44.7-11.8L233 313l37.1 37.1L304 384l-33.9 33.9L176 512H0V336l94.1-94.1L128 208l33.9 33.9L199 279l100.8-100.8c-7.5-13.2-11.8-28.4-11.8-44.7 0-24 9.5-47 26.5-64L350 34zm94 94.1L384 67.9l-35.5 35.5c-8 8-12.5 18.8-12.5 30.1 0 23.5 19 42.5 42.5 42.5 11.3 0 22.1-4.5 30.1-12.5zM48 464h108.1l80-80L128 275.9l-80 80z" })
  }
), uI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0v33.8c77 11.6 136 78 136 158.2v16h32v48H0v-48h32v-16c0-80.2 59-146.6 136-158.2V0zm88 192c0-61.9-50.1-112-112-112S80 130.1 80 192v16h224zm-48 224 27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zm36.2-79.3L320 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM128 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6h-.8c-17.4 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zm36.2-79.3L192 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7M64 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.4-14.2 31.6-31.6 31.6h-.8C46.2 384 32 369.8 32 352.4c0-5.5 1.4-10.9 4.2-15.7z" })
  }
), RI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h48V80h62.1l19.6 19.6c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8.8-17 17 34 33.9 17-17L345 121l17-17-34-33.9L311 87l-.8.8-6.8-6.8-.2-.2c-37.9-37.9-96.2-43-139.6-15.1L137 39l-7-7h-10zm245.5 83 6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2.2zM416 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), $I = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 192V48h252.1L400 83.9V192zm352 0h-16V64L384 0H64v192H0v192h512V192zm0 48v96H48v-96zM40 488v24h48v-96H40zm96 0v24h48v-96h-48zm96 0v24h48v-96h-48zm96 0v24h48v-96h-48zm96 0v24h48v-96h-48z" })
  }
), kI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v144h65c9.8 98.8 93.1 176 194.5 176h77.3c17.3 0 31.2 14 31.2 31.2 0 22-22.1 37.1-42.6 29.1l-68.7-26.7-32.7-12.7V480h112c97.2 0 176-78.8 176-176s-78.8-176-176-176H48V80h376V32zm235.5 272c-74.8 0-136.7-55.8-146.2-128H296v128zm84.5.3V176.2c39.7 2.4 74.5 23 96.3 53.5L362 308.1c-5.7-1.9-11.7-3.2-18-3.8m57 32.6 60.1-60.1c1.9 8.8 2.9 17.8 2.9 27.2 0 42-20.2 79.3-51.4 102.6 2.2-7.3 3.4-15.1 3.4-23.4 0-17.3-5.5-33.3-15-46.3M224 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), PI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m429.8 47 57 57h1.2v1.3l5.8 5.8 17 17-17 17-5.8 5.8v1.1h-1.3l-57 57-17 17-33.8-34 17-17 23-23H332l-58 77.3-30-40 56.8-75.7 7.2-9.6h110.9l-23-23-17-17 33.9-33.9 17 17zM204 322.7l-56.8 75.7-7.2 9.6H0v-48h116l58-77.3zm208.8-36.6 17 17 57 57h1.2v1.3l5.8 5.8 17 17-17 17-5.8 5.8v1h-1.3l-57 57-17 17-33.8-34 17-17 23-23H308l-7.2-9.6L116 152H0v-48h140l7.2 9.6L332 360h86.9l-23-23-17-17 33.9-33.9z" })
  }
), FI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h512V32h-24zm-8 96-8 48-8 48h512l-8-48-8-48h-48.7l8 48H56.7l8-48zM8 304l-8 48h512l-8-48-8-48h-48.7l8 48H56.7l8-48H16zm0 128-8 48h512l-8-48-8-48h-48.7l8 48H56.7l8-48H16z" })
  }
), TI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 384H0V128h32V32h160l213.3 128H456c70.4 0 127.6 23.5 171.2 81.6L638 256l-10.8 14.4C583.6 328.5 526.4 352 456 352h-50.7L192 480H32v-48zm280-32H160.9L128 371.4V432h50.7zm0-192L178.7 80H128v60.6l32.9 19.4zM48 184v152h45.5l48.8-28.7 5.6-3.3H456c34.4 0 63.3-6.5 88-21.1v-53.8c-24.7-14.7-53.6-21.1-88-21.1H147.9l-5.6-3.3L93.5 176H48zm432 40v64h-32v-64z" })
  }
), AI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M217 0h111v80h104v104h80v111l-13.5 6.6-251 121.9c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8l121.9-251zm5.4 382.3 80-38.9 48-92.1-81.5 25.7-75.9 76 29.4 29.4zM384 186.8V128h-58.8l-4.4 2.3-28.1 88.9 88.9-28.1 2.3-4.4zm-215.5 22.8-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zm35.2-72.4L280 97.4V48h-33zM188.1 416 96 323.9l-22.7 22.7 92.1 92.1zm-48.4 42.3-86-86c-3.7 8.3-5.7 17.3-5.7 26.6 0 36 29.2 65.1 65.1 65.1 9.2 0 18.3-2 26.6-5.7M414.6 232l-39.7 76.3L464 265v-33z" })
  }
), DI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0 2.3 2.3 4.5 4.7 6.7 7.1-16.4-6-34-9.3-52.5-9.3-83.9 0-152 68.1-152 152 0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zm237.6-34c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5l22.7 22.9 17 17 17-17 37.1-37.1 12.2-12.2-7.6-15.4c-6.9-13.8-10.7-29.4-10.7-45.9 0-57.4 46.6-104 104-104 38.7 0 72.5 21.1 90.5 52.6l44.8-14c-3.9-43.2-22.4-85.3-55.4-118.4zM0 448l64 64 88-88 24 24 48-48-112-112-48 48 24 24z" })
  }
), yI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 80v352H48V80zm224-48H0v448h512V80zm-64 64v48h-96V96zm-96 96h96v48h-96zm96 96v48h-96v-48z" })
  }
), bI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80v352h240V80zM0 32h512v448H0V80zm64 64v48h96V96zm96 96H64v48h96zm-96 96v48h96v-48z" })
  }
), fI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 480h384V352h-48v80H81.9L241 273l17-17-17-17L81.9 80H336v80h48V32H0v33.9l7 7 183 183L7 439l-7 7z" })
  }
), UI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0v64h400v48H112v400H64V112H0V64h64V0zm80 192v144h240V192zm-48-48h336v240H144V192z" })
  }
), GI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 304v160h32V304zm-48-48h128v256H176V304zM80 432v32h32v-32zm-48-48h128v128H32v-80z" })
  }
), qI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 176v288h-32V176zm-32-48h-48v384h128V128h-48zM256 304v160h-32V304zm-32-48h-48v256h128V256h-48zM80 432h32v32H80zm-48-48v128h128V384H80z" })
  }
), WI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 48v364l-32-24.8V48zm48 401.3V0H480v349.9l-24-18.6V128H328v103.9L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zM376 269.1V176h32v118l-32-24.8zm32 148.3V464h-32v-71.8l-48-37.8V512h128v-56.7l-48-37.8zM203.1 256H176v256h128V335.5zm20.9 48h32v160h-32zM112 432v32H80v-32zm-32-48H32v128h128V384h-48z" })
  }
), EI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 432v32H80v-32zm-32-48H32v128h128V384h-48z" })
  }
), OI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48v416h32V48zM480 0h128v512H480V48zM376 176v288h32V176zm-48-48h128v384H328V176zm-72 176h-32v160h32zm-32-48h80v256H176V256zM80 432v32h32v-32zm-48-48h128v128H32v-80z" })
  }
), II = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 288v224h-48V288zM88 384v128H40V384z" })
  }
), NI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 192v320h-48V192zm-128 96v224h-48V288zM88 384v128H40V384z" })
  }
), XI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M552 512h48zm0-106.2V0h48v443l20.9 16.2 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L296 207v-15h48v52.3l80 62.1V96h48v247.7zm-80 62.1V512h-48v-81.9l48 37.8M344 367v145h-48V329.2zm-128-79v224h-48V288zM88 384v128H40V384z" })
  }
), KI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-81.3-63.1C562.8 354.7 576 306.9 576 256c0-67.4-23.2-129.4-61.9-178.5l-37.7 29.7c32.3 41 51.6 92.6 51.6 148.8 0 39.8-9.7 77.3-26.8 110.3l-51.7-40.2c9.4-21.5 14.5-45.2 14.5-70.2 0-41.2-14.2-79.1-37.9-109.1l-37.7 29.7c17.3 22 27.6 49.5 27.6 79.5 0 13.7-2.2 27-6.2 39.4L48.4 14.8zM163.8 225l-40.3-31.7c-7.4 19.5-11.5 40.6-11.5 62.7 0 41.2 14.1 79.1 37.9 109.1l37.7-29.7C170.3 313.5 160 286 160 256c0-10.7 1.3-21.1 3.8-31m-92.3-72.7L33 122C11.9 162 0 207.6 0 256c0 67.4 23.2 129.4 61.9 178.5l37.7-29.7C67.3 363.8 48 312.2 48 256c0-37.1 8.4-72.3 23.5-103.7" })
  }
), QI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-56.2 19.3-107.8 51.6-148.7L61.9 77.5C23.2 126.6 0 188.6 0 256s23.2 129.4 61.9 178.5l37.7-29.7C67.3 363.8 48 312.2 48 256m64 0c0 41.2 14.2 79.1 37.9 109.1l37.7-29.7C170.3 313.5 160 286 160 256s10.3-57.5 27.5-79.3L149.8 147c-23.6 29.9-37.8 67.8-37.8 109m314.1-109.1-37.7 29.7C405.7 198.5 416 226 416 256s-10.3 57.5-27.5 79.3l37.7 29.7c23.7-30 37.9-67.9 37.9-109.1s-14.2-79.1-37.9-109.1zM528 256c0 56.2-19.3 107.8-51.6 148.7l37.7 29.7c38.7-49 61.9-111 61.9-178.4s-23.2-129.4-61.9-178.5l-37.7 29.7c32.3 41 51.6 92.6 51.6 148.8m-240 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), ZI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 96v416h-48V96zm-128 96v320h-48V192zm-128 96v224h-48V288zM88 384v128H40V384z" })
  }
), JI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 384v128H40V384z" })
  }
), jI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M600 0v512h-48V0zM472 96v416h-48V96zm-128 96v320h-48V192zm-128 96v224h-48V288zM88 384v128H40V384z" })
  }
), YI = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 80c-26.5 0-48 21.5-48 48v64H32v-64c0-53 43-96 96-96s96 43 96 96v7.9c0 22.2-1.4 44.4-4.1 66.4l133-41.2 45.8-14.2-16.1 45.2-28.5 79.9H384v48h-98.1l11.5-32.1 23.9-66.8-110.8 34.3-1 4.7c-12.5 56.2-34 110.1-63.6 159.5l-29.3 48.8-7 11.7H0V270.3l16.9-5.2L169 218c4.6-27.1 7-54.6 7-82.1V128c0-26.5-21.5-48-48-48m256 288v48H184.8c8.5-15.6 16.3-31.7 23.3-48zm-226.9-96.1L48 305.7V432h34.4l22.3-37.1c23.1-38.4 40.7-79.8 52.4-123M528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H416V320h32z" })
  }
), _I = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-55.7-43.3H640v-48H503.3l-61.8-48H576v-48H450.1l28.5-79.9 16.1-45.2-45.8 14.2-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96-37.4 0-69.8 21.4-85.7 52.6L48.4 14.8zm129.3 100.4C183.3 94.9 201.9 80 224 80c26.5 0 48 21.5 48 48v7.9c0 16.9-.9 33.7-2.6 50.5zm165.8 128.7 73.7-22.8-22.4 62.7-51.3-39.9zm1.7 124.1h-41.1c-7 16.3-14.8 32.4-23.3 48h125.4l-60.9-48zM112.9 265.1 96 270.3V480h109.6l7-11.7 29.3-48.8c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9L178.4 432H144V305.7l87.7-27.1-45.8-36.1-73 22.6zM64 368H0v48h64z" })
  }
), hN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1l-152.1 47.1-16.9 5.2V480h109.6l7-11.7 29.3-48.8c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7L417.3 221l-23.9 66.8-11.5 32.2H576v-48H450.1l28.5-79.9 16.1-45.2-45.8 14.2-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v64h48v-64zm-32 177.7 109.1-33.8c-11.7 43.2-29.4 84.5-52.4 123L178.4 432H144zM64 368H0v48h64zm216.8 48H640v-48H304.1c-7 16.3-14.8 32.4-23.3 48" })
  }
), cN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 0h48v32h168l64 80-64 80H280v32h200v160H280v128h-48V384H64L0 304l64-80h168v-32H32V32h200zm192.9 80H80v64h344.9l25.6-32zM87.1 272l-25.6 32 25.6 32H432v-64H87.1" })
  }
), sN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h288V147.9L236.1 48zM256 0l128 128v384H0V0h48zM80 240h64v80H80zm0 192v-80h128v80zm224 0h-64v-80h64zm0-192v80H176v-80z" })
  }
), vN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 368h256V131.9L316.1 48H144zm304-256v304H96V0h240zM48 96v368h336v48H0V96zm128 80h96v64h-96zm0 160v-64h64v64zm192 0h-96v-64h96zm0-160v64h-64v-64z" })
  }
), eN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40v48h48V88c0-48.6-39.4-88-88-88s-88 39.4-88 88v200h-72v-80H32v48h80v32H0v48h512v-48H400v-32h88v-48H352v80h-72zM32 368v24c0 66.3 53.7 120 120 120h208c66.3 0 120-53.7 120-120v-24h-48v24c0 39.8-32.2 72-72 72H152c-39.8 0-72-32.2-72-72v-24z" })
  }
), lN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m69.3 36 48 32 20 13.3-26.6 39.9-20-13.2-48-32-20-13.3 26.6-40zm528 40-48 32-20 13.3-26.6-40 20-13.3 48-32 20-13.3 26.6 39.9zM24 192h88v48H0v-48zm528 0h88v48H528v-48zm-62 112h-48.4l-20-160H218.4l-20 160H150l26-208h288zm-246.1 0 12.2-98 1.8-14h32.2l-2.2 18-11.8 94zM496 384H144v48h352zm-352-48h400v144H96V336z" })
  }
), tN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M345.6 304H394L368 96H80L54 304h48.4l20-160h203.2zm-165.5 0 11.8-94 2.2-18h-32.2l-1.8 14-12.2 98h32.2M48 384h352v48H48zM0 336v144h448V336H48z" })
  }
), wN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 80v64h-64V80zm-64-48h-48v160h56v40H56v88H0v160h160V320h-56v-40h160v40h-56v160h160V320h-56v-40h160v40h-56v160h160V320h-56v-88H312v-40h56V32h-48zM48 432v-64h64v64zm208-64h64v64h-64zm208 64v-64h64v64z" })
  }
), gN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24V0h-48v64h-94.2L195 76.5 216 88l-21.1-11.5-.1.1-.2.4-.9 1.6c-.7 1.4-1.8 3.4-3.2 6-2.6 5.4-6.5 12.9-11.1 22.4-9.2 18.9-21.4 45.4-33.7 76.1C121.5 243.6 96 323.2 96 392v88h93.4l4.9-2.3L296 429.8V512h48v-82.2l101.8 47.9 4.9 2.3H544v-88c0-68.8-25.5-148.4-49.7-208.9-12.3-30.7-24.5-57.2-33.7-76.1-4.6-9.5-8.4-17-11.2-22.2-1.4-2.6-2.4-4.6-3.2-6l-.9-1.6-.2-.4-.1-.1-21.1 11.5L445 76.7 438.2 64H344zm-48 88v60.3l-102.4 20.5c10.6-25.9 21-48.4 29-64.8 3.1-6.3 5.7-11.7 8-16zM173.6 245.8 296 221.3V278l-143.3 41.8c5.3-24.7 12.7-49.8 21-74.1zm-28.8 126.3L296 328v48.8L178.6 432H144v-40c0-6.5.3-13.1.8-19.9m199.2 4.7V328l151.2 44.1c.5 6.8.8 13.4.8 19.9v40h-34.6zm143.3-57L344 278v-56.7l122.4 24.5c8.3 24.2 15.6 49.4 21 74.1zm-40.9-127L344 172.3V112h65.5c2.2 4.3 4.9 9.7 8 16 8 16.4 18.4 38.9 29 64.8zM0 64v448h48V221.6l21.7-13c36.1-21.7 58.3-60.7 58.3-102.9V64H24zm48 101.5V112h31.7c-1.9 21.7-13.6 41.4-31.7 53.5M616 64H512v41.6c0 42.2 22.1 81.2 58.3 102.9l21.7 13V512h48V64zm-24 48v53.5c-18.2-12.1-29.8-31.8-31.7-53.5z" })
  }
), iN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v64h168v48H280v48h232v48H280v48h136v48H280v85.7l88-37.7h80v96l-64 64H128l-64-64v-96h80l88 37.7V304H96v-48h136v-48H0v-48h232v-48H64V64h168V0zm-96 440a24 24 0 1 0-48 0 24 24 0 1 0 48 0m192 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), mN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m372.2 0-3.7 19.5L366 32H156.6l-4.1 19-72 336-6.2 29H480V273.7l-12.6-6.8-88.5-47.6 16.7-86.7 10-52 10-52L421.1 0zM262.3 80h94.4l-8.4 43.5-7 36.5H288v32h47.3l-6.2 32H272v32h73.9l86.1 46.3V368H133.7l24-112h68l2.7-12.7zm-32.7 0-30 144h-35.1l30.9-144h34.3zM640 408v-24h-48v80H0v48h640v-24z" })
  }
), aN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m387.7 4.4-4.1 23.7-45 262.4 128.1 64 13.3 6.6V464h32v48H2.6l5.9-28.8 88-432 3.9-19.2h233.9l2.1-12.1 4.1-23.7 47.3 8.1zM182.1 80h-42.5l-39.1 192h43.2zm32.6 0-42.2 211.1-2.6 12.9H94L61.4 464H432v-73.2l-130.7-65.3-11-5.5H208v-32h82.4l11-64H240v-32h66.8L326 80z" })
  }
), oN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 95.5C0 166.1 57.2 224 128 224h16v160h73.6L256 512h128l38.4-128H496V224h16c70.8 0 128-57.9 128-128.5C640 61 621 26.2 600 0l-24 16c1 3.1 2.2 6.4 3.4 9.9 5.8 16.4 12.7 35.8 11.1 51.8-2.8 28.6-26.8 50.3-55.5 50.3h-39V96H144v32h-39c-28.7 0-52.7-21.7-55.6-50.3-1.6-16 5.3-35.5 11.1-51.8 1.3-3.5 2.5-6.8 3.5-9.9L40 0C19 26.2 0 61 0 95.5M253.3 336H192V144h256v192H386.7l-10.3 34.2-28.1 93.8h-56.6l-28.1-93.8zm34.7-80a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), nN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.1 185.8 272 200.3V240h-96v-39.7l-18.1-14.4C138.4 170.4 128 149.5 128 128c0-39 37.5-80 96-80s96 41 96 80c0 21.5-10.4 42.4-29.9 57.8M368 128C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4V288h192v-64.6c29.5-23.4 48-57.5 48-95.4m58.4 128L405 266.7l-181.1 90.5-181.1-90.5L21.3 256-.1 298.9l21.5 10.7L170.2 384 21.3 458.4-.1 469.1 21.4 512l21.5-10.7L224 410.8l181 90.6 21.5 10.7 21.5-42.9-21.5-10.7L277.6 384l148.8-74.4 21.5-10.7zM208 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), rN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 373.9V464h-48v-48h-48v48h-32v-48h-48v48h-48v-90.1l-20.4-14.3C75.9 326.2 48 276.9 48 224c0-91.4 86.9-176 208-176s208 84.6 208 176c0 52.9-27.9 102.2-75.6 135.6zm48 25c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9V512h320v-48zM224 256a56 56 0 1 0-112 0 56 56 0 1 0 112 0m120 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112" })
  }
), dN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9 0h53.3L311 512h-53.3z" })
  }
), SN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311 0h-53.3L9 512h53.3z" })
  }
), zN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m29.4.1 19 14.7 572.5 444.5 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1z" })
  }
), pN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h32v176c0 62.5 44.8 114.5 104 125.8V432H32v48h608V360h-48v72H440v-48.2c67-4.2 120-59.8 120-127.8V144h48V96H416v128h-6.6c-14 0-27.8-1.3-41.4-3.7-64.2-11.6-121.3-49.7-156.6-106C182.5 67.9 133.7 38.1 80 32.8c-2.7-.3-5.3-.5-8-.6V32H32zm368 400H184v-48h208zm40-96H160c-44.2 0-80-35.8-80-80V81.1c37.2 5 70.5 26.3 90.7 58.6C222.2 222 312.3 272 409.4 272H464V144h48v112c0 44.2-35.8 80-80 80" })
  }
), MN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 144v224h-64V144zm-64-48h-48v320h160V280h96v-48h-96V96h-48zM0 280h224v-48H0z" })
  }
), xN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 400h64v-64H48zM0 448V288h160v56h352v48H160v56H48zm24-280H0v-48h352V64h160v160H352v-56zm376-56v64h64v-64z" })
  }
), HN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0H72v80H16v160h56v272h48V240h56V80h-56V24zm8 128v64H64v-64zm160 192v64h-64v-64zm-64-48h-48v160h56v80h48v-80h56V272h56v240h48V272h56V112h-56V0h-48v112h-56v160h-56V0h-48v272zm160-112h64v64h-64z" })
  }
), VN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 392v48h80v56h160v-56h272v-48H240v-56H80v56H24zm0-160v48h272v56h160v-56h80v-48h-80v-56H272v56H24zm112-112v56h160v-56h240V72H272V16H112v56H0v48h24zm208 168v-64h64v64zm-192 96h64v64h-64zm32-256V64h64v64z" })
  }
), CN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 416v48H112v-48zm-288 96h504V217.6c14.3-8.3 24-23.8 24-41.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6V464H448v-48h64V96h-64V0H64v96H0v320h64v96zm0-416V48h288v48zm352 48v224H48V144zm-272 60.2V176H88v48h45.9L95.4 331.9l-1.5 4.1h51l45.7-127.9 1.4-3.9zM312 176H208v48h45.9l-38.5 107.9-1.5 4.1h51l45.7-127.9 1.4-3.9V176zm120 28.2V176H328v48h45.9l-38.5 107.9-1.5 4.1h51l45.7-127.9 1.4-3.9z" })
  }
), LN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m331.1 252-13.6-12H80v-96c0-53 43-96 96-96 23 0 44.1 8.1 60.6 21.5l31.7 25.8 30.6-27.2C313 55.6 331.6 48 352 48c30.6 0 57.3 17.2 70.8 42.7l18.2 34.4 37.4-10.7c5.5-1.6 11.4-2.4 17.6-2.4 35.3 0 64 28.7 64 64v64H450.5l-13.6 12c-14.1 12.5-32.6 20-52.9 20s-38.8-7.5-52.9-20M32 288h267.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H608V176c0-61.9-50.1-112-112-112-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0 96.5 0 32 64.5 32 144v96zm584 80H256v48h384v-48zm-64 96H416v48h160v-48zm-192 0H0v48h384v-48zm-136-96H72v48h152z" })
  }
), BN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 128c0-44.2 35.8-80 80-80 31.1 0 58 17.7 71.3 43.7l12.2 23.8c4.1-2.3 8.4-4.3 12.8-6.2l12-10.2c14-11.9 32-19 51.8-19 24.3 0 46.1 10.8 60.7 27.9 4.9 2 9.7 4.3 14.4 6.8 9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0 89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6 16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128m512 96c0 27.5-13.8 51.7-34.9 66.1 12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128-46.6 0-87.3 24.8-109.7 62-22.2-18.7-51-30-82.3-30-51.6 0-96 30.5-116.3 74.4 10.7 3.9 20.9 8.7 30.5 14.5 7.9-5 16.2-9.4 25-13 14.7-17.1 36.5-27.9 60.8-27.9 24.3 0 46.1 10.8 60.7 27.9 17.7 7.3 33.8 17.6 47.7 30.4l5.1-25.9c7.2-36.7 39.7-64.4 78.5-64.4 44.2 0 80 35.8 80 80M48 368c0-53 43-96 96-96 29.5 0 55.9 13.3 73.5 34.3l19.7 23.5 18-24.8c14.6-20 38.1-33 64.7-33 36.6 0 67.5 24.6 77 58.2l8.4 29.7 26.7-15.4c9.4-5.4 20.2-8.5 31.9-8.5 35.3 0 64 28.7 64 64v64H48zm96-144C64.5 224 0 288.5 0 368v144h576V400c0-61.9-50.1-112-112-112-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3-24.7-20.2-56.4-32.3-90.9-32.3" })
  }
), uN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 0h48v43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v43h-48v-43c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43zm224 288h-48v-43c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V0h48v43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v43zm-80 88v136h-48V352h48zm80 0v136h-48V352h48zm-416 88h208v-64H224zM0 352h480v160H0V400z" })
  }
), RN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m417 202.2 95-42.2V64L368 0l-84 48H168C84.1 48 16 116.1 16 200c0 59.5 34.2 111.1 84 136 20.5 10.2 43.5 16 68 16h152c8.8 0 16 7.2 16 16s-7.2 16-16 16H96l-2.5 1.7-50.2 33.5L0 448l43.3 28.8L96 512h224c79.5 0 144-64.5 144-144 0-44.6-20.3-84.5-52.2-110.9-11.7-9.7-25-17.6-39.4-23.2-2.7-1.1-5.5-2-8.3-2.9-13.9-4.5-28.7-6.9-44.1-6.9H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h116l36 20.6 48 27.3zm-46.2-32-62.9-35.9-11.2-6.3H168c-39.8 0-72 32.2-72 72s32.2 72 72 72h152c53 0 96 43 96 96s-43 96-96 96H110.5l-24-16 24-16H320c35.3 0 64-28.7 64-64s-28.7-64-64-64H168c-57.4 0-104-46.6-104-104S110.6 96 168 96h128.7l11.1-6.3 62.9-35.9L464 95.2v33.6l-93.3 41.5zM384 88a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), $N = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0h-24v48h86.1l-79 79-7 7v42H320v-48h-86.1l79-79 7-7V0H296zm128 224h-24v48h90.1l-84.2 96.2-5.9 6.8v41h160v-48h-90.1l84.2-96.2 5.9-6.8v-41h-24zm-288 0H0v48h156.9L5.1 465.2 0 471.7V512h224v-48H67.1l151.8-193.2 5.1-6.5V224h-24z" })
  }
), kN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 64v49.4l12.7-12.7L224 89.4l22.6 22.6-11.3 11.3-35.3 35.3v55.8l48.3-27.9 12.9-48.2 4.1-15.5 30.9 8.3-4.1 15.5-4.6 17.3 15-8.7 20.8-12 24 41.6-20.8 12-15 8.7 17.3 4.6 15.5 4.1-8.3 31-15.4-4.2-48.2-12.9L224 256l48.3 27.9 48.3-12.9 15.5-4.1 8.3 30.9-15.5 4.1-17.3 4.6 15 8.7 20.8 12-24 41.6-20.8-12-15-8.7 4.6 17.3 4.1 15.5-30.9 8.3-4.1-15.5-12.9-48.2-48.4-27.9v55.8l35.3 35.3 11.3 11.3-22.6 22.6-11.3-11.3-12.7-12.7V448h-48v-49.4l-12.7 12.7-11.3 11.3-22.6-22.6 11.3-11.3 35.3-35.3v-55.8l-48.3 27.9-13 48.2-4.1 15.5-30.9-8.3 4.1-15.5 4.6-17.3-15 8.7-20.8 12-24-41.6 20.8-12 15-8.7-17.3-4.6-15.4-4.2 8.3-30.9 15.4 4.2 48.2 12.9L128 256l-48.3-27.9L31.4 241 16 245.2l-8.3-30.9 15.5-4.1 17.3-4.6-15-8.7-20.8-12 24-41.6 20.8 12 15 8.7-4.6-17.3-4.1-15.5 30.9-8.3 4.1 15.5 12.9 48.2 48.3 27.8v-55.8l-35.3-35.3-11.3-11.3L128 89.4l11.3 11.3 12.7 12.7V64zm280 384v-48h72c22.1 0 40-17.9 40-40s-17.9-40-40-40H384v-48h168c48.6 0 88 39.4 88 88s-39.4 88-88 88h-48zm24-384h48c48.6 0 88 39.4 88 88s-39.4 88-88 88H384v-48h168c22.1 0 40-17.9 40-40s-17.9-40-40-40h-72V64z" })
  }
), PN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24V0h-48v70.1l-16.6-16.7-17-17-33.9 34 17 17 50.5 50.5v76.5l-66.2-38.2-18.5-69.1-6.3-23.2-46.3 12.4 6.2 23.2 6.1 22.7-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1-23.2 6.2 12.4 46.4 23.2-6.2 69.1-18.5L272 256l-66.2 38.2-69.1-18.5-23.2-6.2-11.3 42.3 2.6 5.1 19.5 5.2 22.7 6.1-26 15-2 1.2 22 42.7 4-2.3 26-15-6.1 22.7-6.2 23.2 46.3 12.4 6.2-23.2 18.5-69.1 66.3-38.2v76.5l-50.6 50.6-17 17 33.9 33.9 17-17 16.7-16.7V512h48v-70.1l16.6 16.6 17 17 33.9-33.9-17-17-50.5-50.5v-76.5l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2-6.1-22.7 26 15 4 2.3 22-42.7-2-1.2-26-15 22.7-6.1 19.5-5.2 2.6-5.1-11.3-42.3-23.2 6.2-69.1 18.5L368 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2-22.7-6.1 26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L435 83.9l-6.2 23.2-18.5 69.1-66.3 38.2v-76.5l50.6-50.6 17-17-34-33.8-17 17L344 70.1zm176.3 393.4c-5.5 9.6-8.3 20.4-8.3 31.4 0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2 0-11-2.9-21.8-8.3-31.4L576 320zM64 320 8.3 417.4C2.9 427 0 437.8 0 448.8 0 483.7 28.3 512 63.2 512h1.6c34.9 0 63.2-28.3 63.2-63.2 0-11-2.9-21.8-8.3-31.4z" })
  }
), FN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 24V0h-48v70.1l-16.6-16.7-17-17-33.9 34 17 17 50.5 50.5v76.5l-66.2-38.2-18.5-69.1-6.3-23.2-46.3 12.4 6.2 23.2 6.1 22.7-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1-23.2 6.2 12.4 46.4 23.2-6.2 69.1-18.5L176 256l-66.2 38.2-69.1-18.5-23.2-6.2-12.4 46.4 23.2 6.2 22.7 6.1-26 15-20.8 12 24 41.6 20.8-12 26-15-6.1 22.7-6.2 23.2 46.3 12.4 6.2-23.2 18.5-69.1 66.3-38.2v76.5l-50.6 50.6-17 17 33.9 33.9 17-17 16.7-16.7V512h48v-70.1l16.6 16.6 17 17 33.9-33.9-17-17-50.5-50.5v-76.5l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2-6.1-22.7 26 15 20.8 12 24-41.6-20.8-12-26-15 22.7-6.1 23.2-6.2-12.4-46.4-23.2 6.2-69.1 18.5L272 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2-22.7-6.1 26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L339 83.9l-6.2 23.2-18.5 69.1-66.3 38.2v-76.5l50.6-50.6 17-17-34-33.8-17 17L248 70.1z" })
  }
), TN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 24V0h-48v70.1l-16.6-16.7-17-17-33.9 34 17 17 50.5 50.5v76.5l-66.2-38.2-18.5-69.1-6.2-23.2-46.4 12.4 6.2 23.2 6.1 22.7-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1-23.2 6.2 12.4 46.4 23.2-6.2 69.1-18.5L176 256l-66.2 38.2-69.1-18.5-23.2-6.2-12.4 46.4 23.2 6.2 22.7 6.1-26 15-20.8 12 24 41.6 20.8-12 26-15-6.1 22.7-6.2 23.2 46.4 12.4 6.2-23.2 18.5-69.1 66.2-38.2v76.5l-50.6 50.6-17 17 33.9 33.9 17-17 16.7-16.7V512h48v-70.1l16.6 16.6 17 17 33.9-33.9-17-17-50.5-50.5v-76.5l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2-6.1-22.7 26 15 20.8 12 24-41.6-20.8-12-26-15 22.7-6.1 23.2-6.2-12.4-46.4-23.2 6.2-69.1 18.5L272 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2-22.7-6.1 26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L339 83.9l-6.2 23.2-18.5 69.1-66.3 38.2v-76.5l50.6-50.6 17-17-34-33.8-17 17L248 70.1zm262 40-27.8 27.8 33.9 33.9L544 97.9l27.8 27.8 33.9-33.9L577.9 64l27.8-27.8-33.9-34L544 30.1 516.2 2.2l-34 34L510.1 64zm37.1 129.3-33.9 33.9 17 17 11.9 11.8-11.8 11.8-17 17 33.9 33.9 17-17 11.8-11.8 11.8 11.8 17 17 33.9-33.9-17-17-11.8-11.8 11.8-11.8 17-17-33.9-33.9-17 17-11.8 11.8-11.8-11.8-17-17z" })
  }
), AN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 144v48H112v-48zM64 48v144H0v48h48.7C28 272.3 16 310.8 16 352c0 64.3 29.2 121.8 75.1 160h265.8c45.9-38.2 75.1-95.7 75.1-160 0-41.2-12-79.7-32.7-112H448v-48h-64V0H64zm0 304c0-43.6 17.4-83.1 45.7-112H338.3c28.3 28.9 45.7 68.4 45.7 112 0 43.6-17.4 83.1-45.7 112H109.7C81.4 435.1 64 395.6 64 352m88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48m168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-96 136 27.8-48.7c2.7-4.8 4.2-10.2 4.2-15.7 0-17.5-14.2-31.6-31.6-31.6h-.8c-17.5 0-31.6 14.2-31.6 31.6 0 5.5 1.4 10.9 4.2 15.7z" })
  }
), DN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-66.3 0-120 53.7-120 120 0 19 4.4 37 12.3 53-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2V128H56v43.6l-14.5-6.2-22.1-9.5L.5 200l22.1 9.5 48 20.6 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7 0 12.5 1.7 24.7 4.9 36.3C106.7 318.2 96 349.9 96 384c0 49.1 22.1 93 56.9 122.3l6.7 5.7h192.8l6.7-5.7C393.9 477 416 433.1 416 384c0-34.1-10.7-65.8-28.9-91.7 3.2-11.6 4.9-23.7 4.9-36.3 0-1.6 0-3.1-.1-4.7l49.5-21.2 48-20.6 22.1-9.5-18.9-44.1-22.1 9.5-14.5 6.2V128h-48v64.2l-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6 7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0m-72 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8l-12 16.8 14.8 14.4c16.4 16 26.6 38.3 26.6 63 0 11.3-2.1 22.1-6 32l-5.2 13.2 9.1 10.9c16.3 19.5 26.1 44.5 26.1 71.9 0 31.3-12.8 59.6-33.6 80H177.6c-20.8-20.4-33.6-48.7-33.6-80 0-27.4 9.8-52.4 26.1-71.8l9.1-10.9L174 288c-3.9-9.9-6-20.7-6-32 0-24.7 10.2-47 26.6-63l14.8-14.4-12-16.8C189 150 184 135.6 184 120m88 104h-32v32h32zm0 96v-32h-32v32zm0 32h-32v32h32zm-48-232a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-64 40.3c0 2.9.8 5.8 2.3 8.3L256 176l13.7-23.4c1.5-2.5 2.3-5.4 2.3-8.3v-.3c0-8.8-7.2-16-16-16s-16 7.2-16 16z" })
  }
), yN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0h-24v128H48v180.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-20.4-5.5-39.5-15-56h47v65.3l6.2 6.9 80 88 35.5-32.3-73.7-81.2V249.3l73.8-81.1-35.5-32.3-80 88-6.2 6.9V296H432v-93.4l-2.3-4.9-88-184L335.1 0H320zm245.4 208H219.5l-56.8-71-2.7-3.4V48h144.9zm-248.9-32 56.8 71 7.2 9H384v33.1c-5.2-.7-10.6-1.1-16-1.1H112c-5.4 0-10.8.4-16 1.1V176h16zM112 336h256c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64m32 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), bN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M48 192h161.1c2.5 17.7 9.2 34 18.9 48H48v224h416V240h-52.1c9.8-14 16.4-30.3 18.9-48H512v320H0V192zm80 96h288v128H96V288zm0 96h256v-64H128zm192-176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160m64-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0H128v272l-89.6 67.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2l21.6-16.2c-8-14.8-13.1-31.4-14.7-49l-35.7 26.8c-8.3 6.2-18.4 9.6-28.8 9.6-26.5 0-48-21.5-48-48 0-15.1 7.1-29.3 19.2-38.4l-28.8-38.4 28.8 38.4 89.6-67.2L176 296V144h112V96H176V48h112zm80 144h96v200L316.8 454.4c-8.3 6.2-18.4 9.6-28.8 9.6-26.5 0-48-21.5-48-48 0-15.1 7.1-29.3 19.2-38.4l89.6-67.2L368 296v-24zm-48 128-89.6 67.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2L512 368V0H320v144zm48-176V48h96v48z" })
  }
), UN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h-44.8L172 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H140c-42 0-76 34-76 76v20c-37.6 15.7-64 52.7-64 96v80h48v48h33.8L96 512h192l14.2-128H336v-48h48v-80c0-44.5-28-82.5-67.3-97.3 2.1-7.2 3.3-14.8 3.3-22.7v-8C320 57.3 262.7 0 192 0m144 288H48v-32c0-27.3 19.5-50 45.3-55l5.3-1H136v-48h-24v-12c0-15.5 12.5-28 28-28h37.3c29.7 0 53.9-23.7 54.7-53.3 23.9 13.8 40 39.7 40 69.3v8c0 5.8-1.5 11.3-4.3 16H192v48H280c30.9 0 56 25.1 56 56z" })
  }
), GN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M68.5 0h503l4 19.1 64 304 .5 2.4V384H344v80h104v48H192v-48h104v-80H0v-58.5l.5-2.4 64-304zm5.3 208L48 330.5v5.5h137.5l12.8-128zm10.1-48h119.2l11.2-112H107.5zm162.6 48-12.8 128h172.6l-12.8-128zm142.2-48L377.5 48h-115l-11.2 112zm53 48 12.8 128H592v-5.5L566.2 208zm114.4-48L532.5 48H425.7l11.2 112z" })
  }
), qN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0 42.1-12.5 81.3-34 114.1-4.4-1.3-9.1-2.1-14-2.1-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256 512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4 14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208M256 464c-114.9 0-208-93.1-208-208 0-42.1 12.5-81.3 34-114.1 4.4 1.3 9.1 2.1 14 2.1 26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48c0 3.2.3 6.4.9 9.4C18.2 147.7 0 199.7 0 256c0 141.4 114.6 256 256 256 42.1 0 81.7-10.1 116.8-28.1-14.1-9.1-25.1-22.4-31.3-38.2-26.1 11.8-55 18.3-85.5 18.3m96-264h1c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112c20.4 0 39.5 5.5 56 15v1c0 22.1 17.9 40 40 40m64 56c0-31.8-9.3-61.3-25.2-86.2.8-3.1 1.2-6.4 1.2-9.8 0-22.1-17.9-40-40-40-3.4 0-6.6.4-9.8 1.2-24.9-16-54.4-25.2-86.2-25.2-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160m-160 80 33.9-33.9L302 290l34-34-33.9-33.9L290 210l-34-34-33.9 33.9L210 222l-34 34 33.9 33.9L222 302zm0-67.9L243.9 256l12.1-12.1 12.1 12.1z" })
  }
), WN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 288H0v48l160 144 160-144v-48h-48zm200.2 48L160 415.4 71.8 336z" })
  }
), EN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 224H0v-48L160 32l160 144v48h-48zm200.2-48L160 96.6 71.8 176z" })
  }
), ON = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224h320v-48L160 32 0 176zM160 96.6l88.2 79.4H71.8zM0 288v48l160 144 160-144v-48H48zm160 127.4L71.8 336h176.4z" })
  }
), IN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M221.7 221.4c11.3-38.9 28.1-70.3 44.6-94.3 7.5-11 14.9-20.3 21.7-28.2 6.8 7.8 14.2 17.2 21.7 28.2 16.5 24 33.3 55.4 44.6 94.3 13.2-9.9 27.3-18.8 42-26.6C360.4 86.3 288 32 288 32s-72.4 54.3-108.3 162.8c14.8 7.7 28.8 16.6 42 26.6M4 240c19.3 115.2 107 207.2 220 232.9 17.3 3.9 35.9 7.1 53.7 7.1h20.6c17.8 0 36.4-3.2 53.7-7.1C465 447.2 552.7 355.2 572 240c2.6-15.6 4-31.6 4-48-4.6 0-9.2 0-13.8-.1-11.4-.1-22.8-.2-34.2.3-67.9 2.5-129.4 29.7-176 72.8-26.9 24.9-48.8 55.1-64 89-15.2-33.9-37.1-64.1-64-89-46.6-43.1-108.1-70.3-176-72.8-11.4-.4-22.8-.3-34.2-.3-4.6.1-9.2.1-13.8.1 0 16.4 1.4 32.4 4 48m220 97.8c18.8 27.2 31.8 58.7 37.2 92.7-12.7-1.4-25.1-3.8-37.2-7.1-86.2-23.8-153-94.5-171.1-182.9 71 4.7 133 42.1 171.1 97.3m128 0c38.1-55.2 100.1-92.6 171.1-97.3C505 328.9 438.2 399.6 352 423.4c-12 3.3-24.5 5.7-37.2 7.1 5.4-34 18.4-65.5 37.2-92.7" })
  }
), NN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208.2 53.5c15.3-3.6 31.3-5.5 47.8-5.5 54.9 0 104.8 21.2 142 56h-54v48h105.5l20-37.3C423.7 45.6 345.2 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c81.4 0 153.9-38 200.7-97.1l-37.6-29.8C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3 39.2 12 98.2 25.3 185.3 25.3 116.9 0 183.2-23.9 218.9-36.8 4.8-1.7 9-3.2 12.7-4.5l12-4 3.5-12.2.6-2.1c5.5-19.3 8.3-39.3 8.3-59.3V232h-48v25.1c0 12.3-1.3 24.5-4 36.5l-.8.3C424.3 306.5 364.4 328 256 328S87.7 306.5 52.8 293.9l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9.6 52.5 43.3 94.9 96 94.9 53 0 96-43 96-96 0-41.7-26.6-77.2-63.8-90.5M128 144a48 48 0 1 1 96 0 48 48 0 1 1-96 0m248 40h-24v48h96v-48h-24z" })
  }
), XN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96-52.7 0-95.4-42.4-96-94.9-20.3 32.1-32 70.1-32 110.9 0 12.8 1.1 25.2 3.3 37.4.5.2 1 .3 1.5.5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1c.5-.2 1-.4 1.5-.5 2.2-12.1 3.3-24.6 3.3-37.4 0-114.9-93.1-208-208-208zm185.3 302.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3M512 256a256 256 0 1 1-512 0 256 256 0 1 1 512 0m-336-64a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), KN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M39.8 408.2c50.2 50.1 129.8 52.9 183.2 8.3 3.1-2.6 6.1-5.3 9-8.2V464h-72v48h192v-48h-72v-55.7c2.9 2.9 5.9 5.6 9 8.2 53.4 44.6 133 41.8 183.2-8.4 53.1-53.1 53.1-139.2 0-192.3L256 0 39.8 215.8c-53.1 53.1-53.1 139.2 0 192.3zm33.9-33.9c-34.4-34.4-34.4-90.1 0-124.4L256 67.8l182.2 182c34.4 34.4 34.4 90.1 0 124.4-34.3 34.3-90 34.4-124.3.1l-23.7-24-34.2-34.7-34.2 34.7-23.7 24c-34.4 34.3-90 34.2-124.3-.1z" })
  }
), QN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-10.9 63.8c-1.7.1-3.4.2-5.1.2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5l15.6-31.2c-10-11.2-16-26.1-16-42.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4 7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4 10.7 11.7 16.1 13.4 19.4 13.4 2.5 0 4.3-.6 7.1-3.3 3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7 9.7-9.3 22.9-16.7 40.4-16.7h24v48h-24c-2.5 0-4.3.6-7.1 3.3-3.7 3.5-7.1 8.8-12.5 17.4l-.6.9c-4.6 7.4-11 17.6-19.4 25.7-9.7 9.3-22.9 16.7-40.4 16.7-18.5 0-32.9-8.5-44.3-18.6-3.1 4-6.6 8.3-10.5 12.7 2.4 7.1 4.5 14.1 6.5 20.6l1.3 4.3c3.4 11.2 6.4 20.3 9.8 27.8 3.4 7.5 6.6 11.5 9.4 13.8 2.3 1.8 5.5 3.4 11.7 3.4 8.7 0 16.9-4.2 33.7-13.2 15-8 35.7-18.8 62.3-18.8h24v48H616c-13.4 0-24.7 5.2-39.7 13.2-1 .5-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-16.2 0-30.2-4.8-41.7-13.9-10.9-8.7-18-20.2-23-31.1-5-10.9-8.8-22.9-12.2-34l-.8-2.7c-16.4 12.2-36.1 23.6-58.9 31.3 3.6 10.8 8.4 23.5 14.4 36.2 7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464h24v48h-24c-25.2 0-45-13.5-59.5-28.8-14.5-15.4-25.7-34.9-34.2-53-8-17-14.1-33.8-18.3-46.9-5.2.4-10.6.6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512h-24v-48h24c6.8 0 15-3.5 24.5-13.7 9.5-10.1 18.3-24.6 25.8-40.5 5.9-12.6 10.7-25.4 14.4-36.2-22.8-7.7-42.5-19-58.9-31.3l-.8 2.7c-3.4 11-7.2 23.1-12.2 34-5.1 10.9-12.1 22.4-23 31.1-11.6 9.1-25.6 13.9-41.8 13.9-21.4 0-39.9-10-53.1-17.1-1.1-.6-2.2-1.2-3.2-1.7-15-8-26.3-13.2-39.7-13.2H0v-48h24c26.6 0 47.3 10.8 62.3 18.8 16.8 9 25 13.2 33.7 13.2 6.3 0 9.5-1.6 11.7-3.4 2.8-2.2 6-6.3 9.4-13.8 3.5-7.5 6.4-16.6 9.8-27.8l1.3-4.2c2-6.5 4.1-13.5 6.5-20.6-3.9-4.5-7.4-8.8-10.5-12.7-11.3 10-25.7 18.5-44.2 18.5-17.5 0-30.7-7.4-40.4-16.7-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4-2.8-2.7-4.6-3.3-7.1-3.3H0v-48h24c17.5 0 30.7 7.4 40.4 16.7 8.4 8.1 14.8 18.3 19.4 25.7l.6.9c5.4 8.6 8.8 13.9 12.5 17.4 2.8 2.7 4.6 3.3 7.1 3.3 3.3 0 8.7-1.7 19.4-13.4 5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24 13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2zM182 258.3c6.3 8.8 15.8 20.5 28.3 32.2C235.5 313.8 272 336 320 336s84.5-22.2 109.7-45.6c12.6-11.7 22-23.4 28.3-32.2.5-.7 1-1.3 1.4-2-5.4-6.9-10.8-13.8-16.7-20.7C416.3 204.6 382.4 176 320 176s-96.3 28.6-122.7 59.6c-5.9 6.9-11.3 13.8-16.7 20.7.4.6.9 1.3 1.4 2zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), ZN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m298.7 330.7 95.7-47.8L448 256l-53.7-26.8-95.7-47.8-47.8-95.7L224 32l-26.8 53.7-47.8 95.7-95.7 47.8L0 256l53.7 26.8 95.7 47.8 47.8 95.7L224 480l26.8-53.7 47.8-95.7zm-74.7 42-31.7-63.5-7.2-14.3-14.3-7.2-63.5-31.7 63.5-31.7 14.3-7.2 7.2-14.3 31.7-63.5 31.7 63.5 7.2 14.3 14.3 7.2 63.5 31.7-63.5 31.7-14.3 7.2-7.2 14.3z" })
  }
), JN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m384 64-64 32 64 32 32 64 32-64 64-32-64-32-32-64zM256 320l74.3-37.2L384 256l-53.7-26.8L256 192l-37.2-74.3L192 64l-26.8 53.7L128 192l-74.3 37.2L0 256l53.7 26.8L128 320l37.2 74.3L192 448l26.8-53.7zm-64 20.7-21.1-42.1-7.2-14.3-14.3-7.2-42.1-21.1 42.1-21.1 14.3-7.2 7.2-14.3 21.1-42.1 21.1 42.1 7.2 14.3 14.3 7.2 42.1 21.1-42.1 21.1-14.3 7.2-7.2 14.3zM416 320l-32 64-64 32 64 32 32 64 32-64 64-32-64-32z" })
  }
), jN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 48v416H48V48zM48 0H0v512h384V0h-48zm184 120a40 40 0 1 0-80 0 40 40 0 1 0 80 0m-40 312a104 104 0 1 0 0-208 104 104 0 1 0 0 208m-56-104a56 56 0 1 1 112 0 56 56 0 1 1-112 0" })
  }
), YN = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 232v56.8c-10.2-10.4-24.3-16.8-40-16.8-30.9 0-56 25.1-56 56s25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V424c-12.3 5.1-25.8 8-40 8-57.4 0-104-46.6-104-104s46.6-104 104-104c14.2 0 27.7 2.8 40 8m16-184H48v416h192v48H0V0h240zm-56 32a40 40 0 1 1 0 80 40 40 0 1 1 0-80m136-32v416h272V48zM272 0h368v512H272V48zm184 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80M352 328a104 104 0 1 1 208 0 104 104 0 1 1-208 0m104 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112" })
  }
), _N = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.2 0h33.7l5.7 15.8L221.4 256h-51l-14.5-40H68.1l-14.5 40h-51L89.4 15.8zm43.4 168L112 94.6 85.5 168zM280 0h76c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H256V0zm104 76c0-15.5-12.5-28-28-28h-52v56h52c15.5 0 28-12.5 28-28m-80 132h68c15.5 0 28-12.5 28-28s-12.5-28-28-28h-68zm270.7 83.5-17.1 16.8-188.8 185.6-17 16.7-16.8-16.8-104-104-17-17 34-33.9 17 17 87.1 87.1L524 274.1l17.1-16.8z" })
  }
), hX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 118.7v21.2l1.2 3.7 24 72L29 227l11.4 3.8 75.7 25.2-75.7 25.2L29 285l-3.8 11.4-24 72-1.2 3.7v21.2l39.2 13.1 7.6-22.8L67 323l72.6-24.2c-.8 3.2-1.5 6.4-2 9.7L79 367l-11.3 11.4 6.2 14.8 40 96 9.2 22.2 44.3-18.5-9.2-22.2-33.8-81.2 15.5-15.5c13.3 51.8 60.2 90 116.1 90s102.8-38.2 116.2-89.9l15.5 15.5-33.8 81.2-9.2 22.2 44.3 18.5 9.2-22.2 40-96 6.2-14.8L433 367l-58.6-58.6c-.5-3.3-1.2-6.5-2-9.7L445 323l20.2 60.6 7.6 22.8 39.2-13.1v-21.2l-1.2-3.7-24-72L483 285l-11.4-3.8-75.7-25.2 75.7-25.2L483 227l3.8-11.4 24-72 1.2-3.7v-21.2l-39.2-13.1-7.6 22.8L445 189l-84.2 28.1L433 145l11.4-11.4-6.2-14.8-40-96L388.9.6l-44.3 18.5 9.2 22.2 33.8 81.2-35.6 35.6c-.6-32.8-17.8-61.6-43.3-78.4l-23.3-15.3-11.7 25.3-17.7 38.4-17.7-38.4-11.7-25.3-23.3 15.3c-25.6 16.8-42.7 45.5-43.3 78.4l-35.7-35.7 33.8-81.2 9.2-22.2L123.1.6l-9.2 22.2-40 96-6.2 14.8L79 145l72.1 72.1L67 189l-20.2-60.6-7.6-22.8zM208 160c0-5.5.9-10.8 2.6-15.7l15.6 33.8 6.4 13.9h46.8l6.4-13.9 15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7v88c0 3.4-.4 6.7-1 9.9l-2.6 12.1 8.4 9.1c12 12.9 19.2 30 19.2 48.9v16c0 39.8-32.2 72-72 72s-72-32.2-72-72v-16c0-18.9 7.2-36 19.1-48.9l8.4-9.1-2.5-12.1c-.7-3.2-1-6.5-1-9.9zm8 128v16l24 32-24 32v16h80v-16l-24-32 24-32v-16z" })
  }
), cX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144.6 4.7 19.8 3.7L288 31.6 411.6 8.4l19.8-3.7 7.1 18.9L485 147.8l77.4 92.9 12.8 15.3-12.8 15.4-77.4 92.8-46.5 124.2-7.1 18.9-19.8-3.7L288 480.4l-123.6 23.2-19.8 3.7-7.1-18.9L91 364.2l-77.4-92.8L.8 256l12.8-15.4L91 147.8l46.5-124.2 7.1-18.9zm19.9 83.6-30.1 80.1-1.4 3.8-2.6 3.1L83.2 232h49.9l34.8-39.8 21.4-60.6zm42.1-23.1 24.1 42.1 57.3 16.6 57.4-16.6 24.1-42.1-77 14.4-4.4.8-4.4-.8-77-14.4zm204.9 23.1-24.8 43.3 21.4 60.6 34.8 39.8h49.9l-47.2-56.6-2.6-3.1-1.4-3.8zM492.8 280h-49.9l-34.7 39.6-20.9 61.7 24.2 42.4 30.1-80.1 1.4-3.8 2.6-3.1zM369.4 446.8 347.2 408l-59.7-19.8-56.9 16.5-24.1 42.1 77-14.4 4.4-.8 4.4.8 77 14.4zm-204.9-23.1 24.8-43.3-21.4-60.6-34.8-39.8H83.2l47.2 56.6 2.6 3.1 1.4 3.8 30.1 80.1zM196.9 280l10.2 11.6 3 3.5 1.5 4.4 9.1 25.9 25.9-45.4zm68 64.9 16.5-4.8 7.2-2.1 7.1 2.3 16.1 5.3-23.8-41.2zm90.6-19.2 8.8-26 1.5-4.5 3.1-3.6 10.2-11.6h-49.7zm23.6-93.7-10.2-11.6-3-3.5-1.5-4.4-9.1-25.9-25.9 45.4h49.8zm-68-64.9-16.5 4.8-6.7 1.9-6.7-1.9-16.5-4.8 23.3 40.5zm-90.4 19.5-9.1 25.9-1.5 4.4-3 3.5-10.2 11.6h49.8l-25.9-45.3z" })
  }
), sX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 139.9v-21.2l39.2-13.1 7.6 22.8L67 189l84.2 28.1L79 145l-11.3-11.4 6.2-14.8 40-96L123.1.6l44.3 18.5-9.2 22.2-33.8 81.2 35.6 35.6c.6-32.8 17.8-61.6 43.3-78.4l23.3-15.3 11.7 25.3 17.7 38.4 17.7-38.3 11.7-25.3 23.3 15.3c25.6 16.8 42.7 45.5 43.3 78.4l35.7-35.7-33.9-81.3-9.2-22.2L388.9.6l9.2 22.2 40 96 6.2 14.8L433 145l-72.1 72.1L445 189l20.2-60.6 7.6-22.8 39.2 13.1v21.2l-1.2 3.7-24 72L483 227l-11.4 3.8-75.7 25.2 75.7 25.2L483 285l3.8 11.4 24 72 1.2 3.7v21.2l-39.2 13.1-7.6-22.8L445 323l-72.6-24.2c.8 3.2 1.5 6.4 2 9.7L433 367l11.4 11.4-6.2 14.8-40 96-9.2 22.2-44.3-18.5 9.2-22.2 33.8-81.2-15.5-15.5c-13.4 51.8-60.3 90-116.2 90s-102.8-38.2-116.2-89.9l-15.5 15.5 33.8 81.2 9.2 22.2-44.3 18.5-9.2-22.2-40-96-6.2-14.8L79 367l58.6-58.6c.5-3.3 1.2-6.5 2-9.7L67 323l-20.2 60.6-7.6 22.8L0 393.3v-21.2l1.2-3.7 24-72L29 285l11.4-3.8 75.7-25.2-75.7-25.2L29 227l-3.8-11.4-24-72zm210.6 4.4c-1.7 4.9-2.6 10.2-2.6 15.7v88c0 3.4.4 6.7 1 9.9l2.5 12.1-8.4 9.1C191.2 292 184 309.1 184 328v16c0 39.8 32.2 72 72 72s72-32.2 72-72v-16c0-18.9-7.2-36-19.1-48.9l-8.4-9.1 2.5-12.1c.7-3.2 1-6.5 1-9.9v-88c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8-6.4 13.9h-46.8l-6.4-13.9z" })
  }
), vX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0v48c114.9 0 208 93.1 208 208 0 37.9-10.1 73.4-27.8 104l41.6 24z" })
  }
), eX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0v64h-64V0zm81.1 414.4 45.3-45.3 45.3 45.3-45.3 45.3zM224 448h64v64h-64zM52.4 97.6l45.2-45.2 45.3 45.3-45.3 45.2zM64 224v64H0v-64zM52.4 414.4l45.3-45.3 45.3 45.3-45.4 45.2zM512 224v64h-64v-64z" })
  }
), lX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m412.8 30.1 17 17 57 57h1.2v1.3l5.8 5.8 17 17-17 17-5.8 5.8v1h-1.3l-57 57-17 17-33.8-34 17-17 23-23h-89l-104 104 104 104h88.9l-23-23-17-17 33.9-33.9 17 17 57 57h1.3v1.3l5.8 5.8 17 17-17 17-5.8 5.8v1h-1.3l-57 57-17 17-33.8-34 17-17 23-23H310.1l-7-7-121-121H0v-48h182.1L303 111l7-7h108.9l-23-23-17-17 33.9-33.9z" })
  }
), tX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M187.7 400.2c1.4-.1 2.9-.2 4.3-.2 31.6 0 62.3 10.8 87 30.5l41.8 33.5h25.5l-2.5-22.6c-6.6-59.1 18.6-117.3 66.2-153l54-40.4v-22.7L420.7 209c-47.5-17.8-84.4-56.1-100.4-104.2L301.4 48h-22.9l-20.8 25c-38.8 46.5-99.5 68.6-159.1 57.7L48 121.5v24.2l43.1 65.9c12.7 19.4 19.7 41.9 20.2 65 .7 27.8-8.1 55-24.8 77.3L64 384v27.4zM64 459.6 16 464v-96l32.2-43c10.2-13.6 15.6-30.3 15.2-47.4-.3-14.2-4.6-28-12.4-39.8L0 160V64l48 8.7 59.1 10.8c42.5 7.7 86-8 113.7-41.2L256 0h80l29.9 89.7c11.4 34.4 37.8 61.7 71.7 74.4L512 192v80l-73.2 54.9c-34 25.5-52 67-47.3 109.3l3.1 27.9 5.3 48H304l-55-44c-16.2-12.9-36.3-20-57-20z" })
  }
), wX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 160.2c0-21.1 13.5-48.9 42.7-73.3C343.4 63 380.8 48 416 48c26.5 0 48 21.5 48 48 0 35.2-15 72.6-38.9 101.3-24.4 29.2-52.1 42.7-73.3 42.7h-19.7L318 225.9l-32-32-14-14zm13.1 100.7 27.1 27.1h39.6C432 288 512 192 512 96c0-53-43-96-96-96-96 0-192 80-192 160.2v39.6l27.1 27.1L18.2 459.8l-17 17 33.9 33.9 17-17z" })
  }
), gX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M26.8 249.3c8.2-33.2 20.9-65.8 39.2-95.7 6.7-10.9 14.1-21.4 22.2-31.4 10-12.2 21.1-23.7 33.5-34.4 24.1-20.7 53-38 87.1-50.7 12.8-4.7 26.2-8.8 40.3-12.1 15-3.5 30.9-6.3 47.5-8.1 46.4-5.2 99-3.6 158.6 5.9 2.1.3 4.2.7 6.2 1l12.4 2.1 9.2 1.5 4.4 21.5c17.5 84.8 18.6 211.3-41.6 309.5-30.6 50-76.8 92-142.9 116.5-65.6 24.3-148.7 30.7-252.6 13.3l-12.4-2.1-9.2-1.5-2-9.7-2.4-11.8c-.5-2.6-1.1-5.2-1.6-7.9-8.6-45.4-12.3-101.5-4.9-158.4 2-15.8 5-31.7 8.8-47.4zM65.2 306c-4.5 36.8-3.9 73.6-.1 107l69.8-69.8c-20.5-16.4-44-29.1-69.7-37.2m34.2 140.5c39.9 4.3 75.4 4.5 106.9 1.3-8.1-26-20.9-49.9-37.5-70.6zm154.6-6.8c11.5-2.8 22.3-6.1 32.4-9.9 27.3-10.1 50.3-23.7 69.7-39.8L256 289.9 202.9 343c23.3 27.9 40.9 60.7 51.1 96.7m135.6-84.1c5.6-7.2 10.8-14.6 15.5-22.3 15.1-24.6 25.8-51.8 33-79.8-35.3-10.3-67.5-27.7-94.9-50.6L289.9 256l99.6 99.6zM446.8 206c4.5-36.8 3.9-73.6.1-107l-69.8 69.8c20.5 16.4 44.1 29.1 69.7 37.2M412.6 65.5c-39.9-4.3-75.4-4.5-106.9-1.3 8.1 26 20.9 49.9 37.5 70.6l69.3-69.3zM258 72.3c-11.5 2.8-22.2 6.1-32.4 9.9-27.3 10.1-50.3 23.7-69.7 39.8L256 222.1l53.1-53.1c-23.3-28-40.9-60.8-51.1-96.7m-135.6 84.1c-5.6 7.2-10.8 14.6-15.5 22.3-15.1 24.6-25.8 51.8-33 79.8 35.3 10.3 67.5 27.7 94.9 50.6l53.3-53.1-99.6-99.6z" })
  }
), iX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0v128h128V0zm128 208c26.5 0 48 21.5 48 48v208H48V256c0-26.5 21.5-48 48-48zM96 160c-53 0-96 43-96 96v256h320V256c0-53-43-96-96-96zm304-64-16 32-32 16 32 16 16 32 16-32 32-16-32-16zm-80-64-32 16 32 16 16 32 16-32 32-16-32-16-16-32zM464 0l-16 32-32 16 32 16 16 32 16-32 32-16-32-16zm16 224-16-32-16 32-32 16 32 16 16 32 16-32 32-16zM160 400a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), mX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0H96v128h128zm0 208c26.5 0 48 21.5 48 48v208H48V256c0-26.5 21.5-48 48-48zM96 160c-53 0-96 43-96 96v256h320V256c0-53-43-96-96-96zm128 176a64 64 0 1 0-128 0 64 64 0 1 0 128 0m96-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-128-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), aX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v115.9l19.5 3.7L128 140.2V91.4L48 76.1V0zm256 91.4v48.9l108.5-20.7 19.5-3.7V0h-48v76.1zM160 344a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-48 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m248-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-32 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48M216 56V32h-48v176H64v48h256v-48H216z" })
  }
), oX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0M24 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48M88 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0m40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48m312 80a24 24 0 1 0 48 0 24 24 0 1 0-48 0m24-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48M464 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0m-40 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-24 88a24 24 0 1 0 48 0 24 24 0 1 0-48 0m-40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48M240 362.9l-15.6-14.3-48.6-44.6h160.4l-48.7 44.6-15.5 14.3V464h-32v-80zM232 256H96v40l8.7 8 87.3 80v128h128V384l87.3-80 8.7-8v-40H280V64h-48v24z" })
  }
), nX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm224 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96m-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), rX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm96 304v48h160v-48h-56V128h-38.2l-5.4 3-60.4 33.5v54.9l11.7-6.5 44.3-24.6V336h-32z" })
  }
), dX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm161.7 114.5c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L212.7 336H320v48H128v-34.4l7.6-7.1 108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3L174.5 197l-19.1 14.5-29.1-38.2 19.1-14.5 16.2-12.3z" })
  }
), SX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm280 96h24v34.6l-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2h-25.1c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4h25.2c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3-24.1.1v-34.5l7.8-7.1 50.5-46.3H128v-48h24z" })
  }
), zX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm240 160h-48v80h-64.4l40-144h-49.8l-44.9 161.6-8.5 30.4H240v64h48v-64h32v-48h-32v-56z" })
  }
), pX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm176 96h128v48H197.9l-3.9 42.9 56 6.7c39.9 4.8 70 38.7 70 78.9 0 43.9-35.6 79.5-79.5 79.5h-33c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3h33c17.4 0 31.5-14.1 31.5-31.5 0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5-23.3-2.7 2.1-23.2 8-88 2-21.8H176z" })
  }
), MX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm176 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-96 48c0 53 43 96 96 96s96-43 96-96c0-49.2-37-89.8-84.7-95.3l44.4-48.4 14.9-16.3h-65.2l-68.1 74.3c-21.4 23.4-33.3 54-33.3 85.7" })
  }
), xX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm296 96h24v29.4l-2.3 4.9L213.5 384h-53l3.9-8.2L258.2 176H128v-48h24z" })
  }
), HX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm184 96h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72m-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0 48h24c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), VX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm176 240a48 48 0 1 1 0-96 48 48 0 1 1 0 96m96-48c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3l-44.4 48.4-14.9 16.3h65.1l68.1-74.3c21.4-23.4 33.3-54 33.3-85.7z" })
  }
), CX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v100.1c14-9.8 30.3-16.4 48-18.9V32H0v448h320v-48H48zm197.7 61.8-6.5-13.8h-30.4l-6.5 13.8L88.6 384h53l22.5-48h119.7l22.5 48H320v-83.9zM224 208.5l37.3 79.5h-74.6zM464 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), LX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm208.8 96h30.5l6.5 13.8L359.4 384h-53l-22.5-48H164.2l-22.5 48h-53l113.6-242.2zm15.2 80.5L186.7 288h74.6z" })
  }
), BX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm136 96h144v59.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8.8 1.5 1.7 2.2 2.6h-66L270.6 358l-10.8 15.6-7.2 10.4H112v-63.7c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8V152zm66.4 89.6 23.1-16.9c4.1-3 6.5-7.8 6.5-12.9V176h-48v12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4V336h67.4l9.2-13.3z" })
  }
), uX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V80h352v352zM0 480h448V32H0v400zm136-112h176v-48H193.9L329 185l17-17-34-33.9-17 17-135 135V160h-48v208z" })
  }
), RX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 432V80H48v352zm48 48H0V32h448v400zM312 368H136v-48h118.1L119 185l-17-17 34-33.9 17 17 135 135V160h48v208z" })
  }
), $X = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 432V80H48v352zm48 48H0V32h448v400zM207 377l-88-88-17-17 34-33.9 17 17 47 47V128h48v174.1l47-47 17-17 33.9 33.9-17 17-88 88-17 17-17-17z" })
  }
), kX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 480V32h448v448H48zm103-241 88-88 17-17 33.9 34-17 17-47 47H352v48H177.9l47 47 17 17-33.9 33.9-17-17-88-88-17-17 17-17z" })
  }
), PX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48-48v448H0V32h400zM345 273l-88 88-17 17-33.9-34 17-17 47-47H96v-48h174.1l-47-47-17-17 33.9-33.9 17 17 88 88 17 17-17 17z" })
  }
), FX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm136 112h176v48H193.9L329 327l17 17-34 33.9-17-17-135-135V352h-48V144z" })
  }
), TX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zm48-48H0v448h448V80zM312 144H136v48h118.1L119 327l-17 17 34 33.9 17-17 135-135V352h48V144z" })
  }
), AX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm241 103 88 88 17 17-34 33.9-17-17-47-47V384h-48V209.9l-47 47-17 17-33.9-33.9 17-17 88-88 17-17 17 17z" })
  }
), DX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 96h116c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H128V152zm144 76c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28m-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84z" })
  }
), yX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm200 240h-88v-24l176-136-40 128h88v24L160 400z" })
  }
), bX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm144 224c0 44.2 35.8 80 80 80 28.7 0 53.8-15.1 68-37.8l40.8 25.4C310.2 359.8 269.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L292 213.8C277.8 191 252.7 176 224 176c-44.2 0-80 35.8-80 80" })
  }
), fX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V80h352v352zM0 480h448V32H0v400zm96-256 128 128 128-128v-32H96z" })
  }
), UX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 480V32h448v448H48zm256-96L128 256l128-128h32v256z" })
  }
), GX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48-48v448H0V32h400zm-256 96 128 128-128 128h-32V128z" })
  }
), qX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 256 128-128 128 128v32H96z" })
  }
), WX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm337 177L209 337l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47L303 175l17-17 33.9 34-17 17z" })
  }
), EX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48-48v448H0V32h400zM313 273 209 377l-17 17-33.9-34 17-17 87-87-87-87-17-17 33.9-33.9 17 17L313 239l17 17z" })
  }
), OX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 480V32h448v448H48zm135-241 104-104 17-17 33.9 34-17 17-87 87 87 87 17 17-33.9 33.9-17-17L135 273l-17-17z" })
  }
), IX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48-48v448H0V32h400zM313 273 209 377l-17 17-33.9-34 17-17 87-87-87-87-17-17 33.9-33.9 17 17L313 239l17 17z" })
  }
), NX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm241 135 104 104 17 17-34 33.9-17-17-87-87-87 87-17 17L86.1 288l17-17L207 167l17-17z" })
  }
), XX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm185 177-47 47 47 47 17 17-34 33.9-17-17L87 273l-17-17 17-17 64-64 17-17 33.9 34-17 17zm112-34 64 64 17 17-17 17-64 64-17 17-33.9-34 17-17 47-47-47-47-17-17 33.9-33.9 17 17z" })
  }
), KX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-96V128zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48z" })
  }
), QX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v128h48V80h80V32zM0 192v128h48V192zm0 160v128h128v-48H48v-80zM400 80v112h48V32H320v48zM160 480h96v-48h-96zm0-400h128V32H160zm272 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h64v32h-64v64h-32v-64h-64v-32h64v-64h32z" })
  }
), ZX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32h104v48H48v80H0V32zM0 192h48v128H0zm400 0h48v128h-48zm48-32h-48V80h-80V32h128v24zm0 192v128H320v-48h80v-80zm-400 0v80h80v48H0V352zm240 128H160v-48h128zM160 80V32h128v48z" })
  }
), JX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm256 96v64h-64v-64zM136 232h200v48H112v-48zm56 88h64v64h-64z" })
  }
), jX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm244.2 117.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6-16.4-2.4-30.1-.5-39.3 3.5-11 4.7-18 16.2-6.3 23.7 8.5 5.4 21.5 9.2 39.4 14.3l.8.2c15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2V400H201v-38.9c-11.7-2.6-26.7-7.4-36.6-10.6-6.6-2.1-13.1-4.2-19.7-6.2-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2 6.6 2.1 21.9 6.9c12.1 3.9 26.4 8.4 34.5 9.7 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 3.9-21.5 19.9-35.8 37.8-43.5 5.8-2.5 12.1-4.4 18.6-5.7V112h43.2v37.4z" })
  }
), YX = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V80h352v352zM0 480h448V32H0v400zm128-288v160h160l24-24-52-52 76-76-56-56-76 76-52-52z" })
  }
), _X = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 432V80H48v352zm48 48H0V32h448v400zM320 192v160H160l-24-24 52-52-76-76 56-56 76 76 52-52z" })
  }
), hK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48 400H0V32h448v400zM336 288l-112 96-112-96v-32h64V128h96v128h64z" })
  }
), cK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 96h168v48H176v56h112v48H176v56h144v48H128V128z" })
  }
), sK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm192 288h64v64h-64zm0-32v-64h64v64zm0-160h64v64h-64z" })
  }
), vK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 480V32h448v448H48zm160-256v64H96v-64zm32 0h64v64h-64zm160 0v64h-64v-64z" })
  }
), eK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 128h256v28.2l-128 67.2-128-67.2zm135.4 127.6L352 224.3V352H96V224.3l120.6 63.3 7.4 3.9z" })
  }
), lK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm248 96v160h-48V128zm-48 192h48v48h-48z" })
  }
), tK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 96h168v48H176v64h112v48H176v96h-48V128z" })
  }
), wK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 80h48l32 64-32 32 80 64-32-64 48-32-32-64h80v112c0 47.6-34.6 87.1-80 94.7V368h48v32H160v-32h48v-49.3c-45.4-7.6-80-47.1-80-94.7z" })
  }
), gK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48v416H48V48zM48 0H0v512h512V0h-48z" })
  }
), iK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm144 224c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H224v-48h128v24c0 70.7-57.3 128-128 128S96 326.7 96 256s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80" })
  }
), mK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm336 120v232h-48V280H160v104h-48V128h48v104h128V128h48z" })
  }
), aK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm115.3 239.2c-13.4-13.4-20.9-31.5-20.9-50.4v-3.2c0-37.6 30.5-68.1 68.1-68.1 20.7 0 40.2 9.4 53.2 25.6l8.4 10.4 8.4-10.4c12.9-16.1 32.5-25.6 53.2-25.6 37.6 0 68.1 30.5 68.1 68.1v3.2c0 18.9-7.5 37-20.9 50.4l-22.3 22.3-86.6 86.4-86.4-86.4z" })
  }
), oK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 96h168v48h-72v160h72v48H128v-48h72V176h-72v-48z" })
  }
), nK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm184 304h24v-64h-48v-48h96v112h32v48H160v-48zm72-208v64h-64v-64z" })
  }
), rK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm304 120v136c0 53-43 96-96 96s-96-43-96-96v-32h48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V128h48z" })
  }
), dK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm337.1 96-1 1.1-97.8 109.2L330 376.7l4.8 7.3h-57.6l-72.1-108.8-29.1 32.5V384h-48V128h48v107.8l14.1-15.8 82.5-92z" })
  }
), SK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 256h-48V128h48zm144 64V128h48v224zm-48-96h-48V128h48z" })
  }
), zK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm176 120v184h144v48H128V128h48z" })
  }
), pK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 480V32h448v448H48zm192-112L96 256l96-112h32v64h128v96H224v64z" })
  }
), MK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m104-24h144v48H200zm0 96h144v48H200zm0 96h144v48H200zm-72-40a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), xK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 120v-24h36.3l7.2 9.9L224 255l84.5-117.1 7.2-9.9H352v256h-48V226.2L243.5 310 224 337l-19.5-26.9-60.5-83.9V384H96v-24z" })
  }
), HK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 200h168v48H128v-48z" })
  }
), VK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm288 96h48v256h-35.1l-7.2-8.5-133.7-158V384h-48V128h35.1l7.2 8.5 133.7 158V152z" })
  }
), CK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h352v48h48V32H0v96h48zm0 304H0v96h448v-96h-48v48H48zM32 160v192h48v-89.1l48.4 77.8 7 11.3H176V160h-48v89.1l-48.4-77.8-7-11.3H56zm184 0v192h48v-64h64v-48h-64v-32h64v-48h-88zm200 24v-24h-48v192h48v-24z" })
  }
), LK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm144 224a80 80 0 1 0 160 0 80 80 0 1 0-160 0m80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256" })
  }
), BK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v72h-48V128zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88z" })
  }
), uK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-76.9-59.7V32H96v19.8l-47.6-37zM144 89v-9h352v282.3l-87.1-67.6C428 277.2 440 252 440 224c0-53-43-96-96-96H232v29.3zm225.9 175.4L280 194.6V176h64c26.5 0 48 21.5 48 48 0 17-8.8 31.9-22.1 40.4M280 320v-3.4l-48-37.8V384h48v-32zM144 209.5l-48-37.9V480h391.4l-60.9-48H144z" })
  }
), RK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm160 96h88c53 0 96 43 96 96s-43 96-96 96h-64v64h-48V128zm88 144c26.5 0 48-21.5 48-48s-21.5-48-48-48h-64v96z" })
  }
), $K = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm112 256 108.7-108.7 80 80L192 368l-96 16zm256-96-44.7 44.7-80-80L288 112z" })
  }
), kK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm208 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96m70.1 88H352v148c0 31.8-24.7 57.8-56 59.9v.1h-4c-5.7 0-11.1-.8-16.3-2.2-19.6-4.4-37.5-15.1-50.7-30.7L180.1 322 133 406.9l-42-23.4 64-115.2 39.3-3.8L232 309v-62.9l7-7 32-32 7-7zm15.3 159.9c6-.7 10.6-5.8 10.6-11.9V248h-6.1L280 265.9V348c0 5.2 3.2 9.5 7.8 11.2 1.8.3 3.7.6 5.6.7" })
  }
), PK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zm48-48H0v448h448V80zm-168 96-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L168 272l-72 40 16 72h16c123.7 0 224-100.3 224-224v-16z" })
  }
), FK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm334.4 283.2-67.2-18.7 5-44.2c-31.4-9.5-65.1-9.5-96.5 0l5 44.1-67.2 18.7L80 263.7l9.6-9.4c74.2-72.4 194.6-72.4 268.8 0l9.6 9.4z" })
  }
), TK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm168 96 40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L280 272l72 40-16 72h-16C196.3 384 96 283.7 96 160v-16z" })
  }
), AK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm200 336v-88h-88v-48h88v-88h48v88h88v48h-88v88z" })
  }
), DK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm256 152H96v-48h160zm96 48v48H96v-48zM192 376H96v-48h96z" })
  }
), yK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm152 192v160h-48V224zm48-96h48v256h-48zm144 160v96h-48v-96z" })
  }
), bK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm224 144c-44.2 0-80 35.8-80 80s35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L206.1 256h61.5l28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3 0-44.2-35.8-80-80-80zm0 208c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 28.1-9 54-24.4 75.1l42.3 52.9h-61.4l-15.9-19.9C272.7 376.7 249.2 384 224 384" })
  }
), fK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h448v448H0V80zm48 48 176 176L400 80zm0 352h352L224 256z" })
  }
), UK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm136 152c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L248 264.4V296h-48v-59.4l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1H192c-4.4 0-8 3.6-8 8v6.5h-48zm64 152h48v48h-48z" })
  }
), GK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm160 128H96v112h64v8c0 13.3-10.7 24-24 24h-24v48h24c39.8 0 72-32.2 72-72v-88zm32 0v112h64v8c0 13.3-10.7 24-24 24h-24v48h24c39.8 0 72-32.2 72-72V160z" })
  }
), qK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 96h128c44.2 0 80 35.8 80 80 0 37.8-26.3 69.5-61.6 77.9l62.7 98.1h-57l-61.3-96H176v96h-48V152zm48 112h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80z" })
  }
), WK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80H48v352h352zm48-48v448H0V32h400zM256 144l96 112-96 112h-32v-64H96v-96h128v-64z" })
  }
), EK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm304 224a80 80 0 1 0-160 0 80 80 0 1 0 160 0m-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0" })
  }
), OK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.8 32H576v48H338.2L231.1 462.5l-4.9 17.5h-32.5l-6.8-12.6L81.7 272H0v-48h110.3l6.8 12.6 83.8 155.6 96-342.7zM391 265l34-34 55 55 55-55 34 34-55 55 55 55-34 34-55-55-55 55-34-34 55-55z" })
  }
), IK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32h-18.2l-4.9 17.5-96 342.7-83.8-155.6-6.8-12.6H0v48h81.7l105.2 195.4 6.8 12.6h32.5l4.9-17.5L338.2 80H576V32h-24z" })
  }
), NK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm96 80c150.2 0 272 121.8 272 272h-48c0-123.7-100.3-224-224-224zm0 96c97.2 0 176 78.8 176 176h-48c0-70.7-57.3-128-128-128zm0 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), XK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm175.6 164.2c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23.1 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23.1-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7l23.2 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z" })
  }
), KK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm352 144c0 26.5-21.5 48-48 48-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9 26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48" })
  }
), QK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm120 96h-48v56H80v48h40v152h48V232h40v-48h-40v-32zm160 24v-24h-48v152h-40v48h40v56h48v-56h40v-48h-40z" })
  }
), ZK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h352V80H48zM0 80V32h448v448H0v-48zm96 120v-48h56v-40h48v40h152v48H200v40h-48v-40h-32zm24 160H96v-48h152v-40h48v40h56v48h-56v40h-48v-40z" })
  }
), JK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 144v224H48V144zM48 96H0v320h320V96h-48z" })
  }
), jK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm271 159.3 105.1 15.3-76.1 74.2 18 104.7-94-49.5-94 49.4 18-104.7-76.2-74.1L177 191.3 224 96z" })
  }
), YK = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm120 112h232v48H248v192h-48V192H96v-48z" })
  }
), _K = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48zm38.1 137.5 17.7 16.2 76.7 70.3-76.7 70.3-17.7 16.2 32.4 35.4 17.7-16.2 96-88 19.3-17.7-19.3-17.7-96-88-17.7-16.2zM216 336h-24v48h160v-48h-24z" })
  }
), hQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm352 320v48H96v-48zm-72-32V192h-40v-16l64-64 64 64v16h-40v128zM120 192H80v-16l64-64 64 64v16h-40v128h-48z" })
  }
), cQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm160 128v120c0 35.3 28.7 64 64 64s64-28.7 64-64V136h48v144c0 61.9-50.1 112-112 112s-112-50.1-112-112V136h48z" })
  }
), sQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm128 288V160h160l24 24-52 52 76 76-56 56-76-76-52 52z" })
  }
), vQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zm48-48H0v448h448V80zM320 320V160H160l-24 24 52 52-76 76 56 56 76-76 52 52z" })
  }
), eQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm112 192 112-96 112 96v32h-64v128h-96V256h-64z" })
  }
), lQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352h-26.7L336 320H112L74.7 432H48V80zm-77.3 352H125.3l21.3-64h154.8zM48 32H0v448h448V32h-48zm176 208a40 40 0 1 1 0-80 40 40 0 1 1 0 80m-88-40a88 88 0 1 0 176 0 88 88 0 1 0-176 0" })
  }
), tQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm351.9 104L246 377.6l-6.3 14.4h-31.4l-6.3-14.4L96.1 136h52.4L224 308.2 299.5 136z" })
  }
), wQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm248 346.2v24.2h-48v-24c0-23.8-28.8-35.7-45.6-18.9l-.1.1-16.8 16.8-33.9-33.9 17-17 .2-.2c16.6-16.8 4.7-45.4-19-45.4h-24V232h24c23.7 0 35.6-28.6 19-45.4l-.2-.2-17-17 33.9-33.9 16.8 16.8.1.1c16.8 16.8 45.6 4.9 45.6-18.9v-23.9h48v24.2c.2 23.6 28.6 35.4 45.4 18.8l.1-.1 17-17 16.8 16.8.1.1.1.1 16.8 16.8-16.8 16.8-.1.1c-16.8 16.8-4.9 45.6 18.9 45.6h24v48h-24c-23.8 0-35.7 28.8-18.9 45.6l.1.1 16.8 16.8-16.8 16.8-.1.1-.1.1-16.8 16.8-17-17-.2-.2c-16.8-16.6-45.3-4.7-45.4 18.9zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64m88 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), gQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm377.5 112-66.4 230.6-5 17.4h-35.6l-5.3-16.7L224 246.7l-41.1 128.6-5.4 16.7h-35.6l-5-17.4L70.5 144h50l40.7 141.5 39.9-124.8 5.3-16.7h35l5.3 16.7 39.9 124.8L327.5 144z" })
  }
), iQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm349.1 96-95.2 128 95.2 128h-59.8L224 296.2 158.7 384H98.9l95.2-128-95.2-128h59.8l65.3 87.8 65.3-87.8z" })
  }
), mQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm321.9 160-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), aQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm200 263.9L88.6 144h59.5L224 247.4 299.8 144h59.5L248 295.9V400h-48v-24z" })
  }
), oQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h352V80zM0 32h448v448H0V80zm336 128.8-5.7 6.7L187.7 336H336v48H112v-32.8l5.7-6.7L260.3 176H112v-48h224z" })
  }
), nQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 80v352H48V80zM48 32H0v448h448V32h-48z" })
  }
), rQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0c-43.4 7.2-81.7 16-115.7 26L283.4 8.2l-22.2-3.5 3.9 22.1 8.8 49.7c-81.7 47.1-111.8 102.9-116.4 147.9l-36.3-36.3c-6.2-6.2-6.2-16.4 0-22.6l56.3-56.3c18.9-18.9 18.7-49.6-.4-68.3l-29-28.4-10-9.8-11 8.6-3.7 2.9C86.6 42.9 83.6 95.6 113 128.4l-14.5 14.5c-18.7 18.7-18.7 49.1 0 67.9l45.3 45.2-33.9 33.9-33.4-33.3c-19.1-19.1-50.2-18.7-68.7.9L4.4 261l23.2 22 3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l55.4 55.4c-6.7 1.8-13.2 4.9-19.1 9.4l-26.2 20c-3.5 2.6-7.7 4.1-12 4.1-11 0-19.9-8.9-19.9-19.9V320H0v28.1C0 376.8 23.2 400 51.9 400c11.4 0 22.4-3.7 31.4-10.6l26.2-20c9.2-7 22.2-6.1 30.4 2.1 8.1 8.1 9.1 20.9 2.3 30.1L122.1 429c-6.6 9-10.1 19.8-10.1 30.9 0 28.8 23.3 52.1 52.1 52.1H192v-32h-27.9c-11.1 0-20.1-9-20.1-20.1 0-4.3 1.4-8.5 3.9-11.9l20.1-27.4c4.2-5.7 7.1-11.9 8.8-18.4l56 56c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5 21.3 24 2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8L223 403.1l33.9-33.9 45.3 45.3c18.7 18.7 49.1 18.7 67.9 0l14.5-14.5c32.7 29.2 85.3 26.1 113.6-10.9l2.5-3.3 8.3-10.9-9.5-9.9-27.5-28.6c-18.6-19.4-49.5-19.7-68.6-.7l-56.1 56.1c-6.2 6.2-16.4 6.2-22.6 0l-37.2-37.2c44.9-4.6 100.7-34.4 147.7-115.8l50.8 9 22.1 3.9-3.5-22.1-18.1-115.4C496.3 80.7 504.9 42.7 512 0M184.9 264a16 16 0 1 1 0 32 16 16 0 1 1 0-32m32 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m5.5-112.6c5.9-43 48-118.6 234.2-159.2C416 242.5 340.4 284.6 297.5 290.5l-75-75z" })
  }
), dQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7h36.8v65l-7.2 7.1c-15.6 15.3-25.3 36.6-25.3 60.2V464h64.8c-15.6-20.4-24.8-46-24.8-73.7 0-25 7.7-49.3 22-69.8L304 192V64c20.4 0 38.2 10.9 48 27.1 9.8-16.2 27.6-27.1 48-27.1v32h38.6l5.7 3.4 56 33.4 11.7 7v68.9l-5.6 6.7-40 48-7.2 8.6H432v54c24.3 19 40 48.7 40 82 0 20.6-6 39.8-16.3 56h57.4v48H104V379.7c0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7 0 66.1 66.1 0 147.7 0 207.3 0 258.6 35.3 282 86l-43.6 20c-15.8-34.3-50.5-58-90.6-58zM352 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5.9-16.8 2.6l-14.4-45.8c9.9-3.1 20.4-4.8 31.2-4.8 5.4 0 10.8.4 16 1.2V224h52.8l27.2-32.7V167l-38.6-23H352v63.1l-8.7 12.4-90 128.6c-8.7 12.4-13.3 27.1-13.3 42.2 0 40.7 33 73.7 73.7 73.7zm32-288a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), SQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 511v1h-32v-1l-2-63H96v-48h76.5l-2-64H144c-44.2 0-80-35.8-80-80 0-41.5 31.6-75.6 72-79.6V225c-13.8 3.6-24 16.1-24 31 0 17.7 14.3 32 32 32h25l-6-192h-35.6c.4 2.6.6 5.3.6 8 0 30.9-25.1 56-56 56H0v-48c0-35.3 28.7-64 64-64h97.5L160 0h64l-1.5 48H296c48.6 0 88 39.4 88 88s-39.4 88-88 88h-48v-48h48c22.1 0 40-17.9 40-40s-17.9-40-40-40h-75l-6 192h25c44.2 0 80 35.8 80 80s-35.8 80-80 80v-48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-26.5zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), zQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M282.2 0H512v286.3l-17.4 5-34.8 9.9-13.3 3.8-24.8 44-43.4-24.5-124.6 35.6-98.8 98.8-33.9 34-17 17-17-17L19.1 425l-17-17 17-17L53 357.1l43-42.9V272h42.2l26.9-26.9 8.8-8.8 4.4-4.4 6-1.7 12-3.4L368 177.7V144h-26.2L321 164.9l-17 17-17-17L219.1 97l-17-17 17-17L253 29.1l8-8L275.1 7l7-7zm19.9 48-7 7-8 8-17 17 33.9 33.9 10.9-10.9 7-7H416v117.9l-17.4 5-189.2 54-6 1.7-4.4 4.4L87 391l-17 17 34 33.9 17-17 103.2-103.1 4.4-4.4 6-1.7 212-60.6 17.4-5V48H312z" })
  }
), pQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32h192v48H432v144H304v128H176v128H0v-48h128V304h128V176h128V56z" })
  }
), MQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m292 127.7-12 13.6V304h136c26.5 0 48 21.5 48 48v16H48v-16c0-26.5 21.5-48 48-48h136V141.3l-12-13.6c-7.5-8.5-12-19.5-12-31.7 0-26.5 21.5-48 48-48s48 21.5 48 48c0 12.2-4.5 23.2-12 31.7zM512 416v-64c0-53-43-96-96-96h-88v-96.5c14.9-16.9 24-39.2 24-63.5 0-53-43-96-96-96s-96 43-96 96c0 24.3 9.1 46.6 24 63.5V256H96c-53 0-96 43-96 96v64h464zM32 448v64h448v-64H80z" })
  }
), xQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm256 128v192h80c53 0 96-43 96-96s-43-96-96-96h-56zm48 48h32c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9 7.1-2.3 18.8-2.9 35.5-.6 5.1.7 21 3.3 25.6 4.4l23.4 5.3 10.7-46.8-23.4-5.3c-6.6-1.5-24.1-4.4-29.9-5.2-19-2.5-39.3-3.1-56.7 2.5-19.2 6.2-34.9 20.3-39.6 43.5-.1.4-.2.9-.2 1.3-1.7 11.7-.3 23 5.2 33.2 5.3 9.9 13.3 16.7 21.1 21.3 13.9 8.3 32 12.5 45.5 15.6l1.8.4c16.1 3.8 26.9 6.5 33.6 10.5 1.4.8 2.2 1.5 2.7 2 .5.4.6.7.6.7s.1.1.1.5c.1.4.1 1.4-.1 3.2-.4 2.4-1 3.2-1.3 3.5-.4.5-1.8 1.6-5.1 2.7-7.3 2.3-19.5 2.8-36.2.6-7.2-1-20-4.7-31.1-8-2.6-.7-5-1.5-7.3-2.1l-23.1-6.6-13.2 46.2 23.1 6.6c1.4.4 3.2.9 5.3 1.5 10.8 3.2 28.6 8.4 39.7 9.9h.1c19 2.5 39.6 3.2 57.1-2.4 9.1-2.9 18.2-7.7 25.6-15.6 7.6-8.1 12.1-18.1 13.8-29.3 1.7-11.7.3-23-5.2-33.2-5.3-9.9-13.3-16.7-21.1-21.3-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5-1.4-.8-2.2-1.5-2.7-2-.5-.4-.6-.7-.6-.7s-.1-.1-.1-.5-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z" })
  }
), HQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 384v48H32v48h608V240L255.6 47.8a149.68 149.68 0 0 0-67-15.8c-56.7 0-108.6 32.1-134 82.8L22 180 0 224l47.7 11.9L64 240v144h24zm0-48H112v-84zm96 96h-48V298.5l-36.4-9.1-389.9-97.5 27.8-55.6C114.8 101.8 150 80 188.6 80c15.8 0 31.4 3.7 45.6 10.8L592 269.7V432z" })
  }
), VQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 256c0-110.8 86.6-201.3 195.7-207.6 4.1-.2 8.2-.4 12.3-.4 44.1 0 85 13.7 118.6 37.1-31.4-35-72.3-61.3-118.6-74.9-2.6-.8-5.2-1.5-7.8-2.1C299.7 2.8 278.2 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c22.2 0 43.7-2.8 64.2-8.1l7.8-2.1c46.3-13.6 87.2-39.9 118.6-74.9C413 450.3 372.1 464 328 464c-4.1 0-8.2-.1-12.3-.4C206.6 457.3 120 366.8 120 256m-40 0c0 85.4 43.2 160.8 109 205.4C102.5 433.2 40 351.9 40 256S102.5 78.8 189 50.6C123.2 95.2 80 170.6 80 256m330.8-81.8L384 120l-26.8 54.2-15.6 31.5-34.8 5.1-59.8 8.7 43.3 42.2 25.2 24.5-5.9 34.6-10.2 59.6 53.5-28.1L384 336l31.1 16.4 53.5 28.1-10.2-59.6-5.9-34.6 25.2-24.5 43.3-42.3-59.8-8.7-34.8-5.1-15.6-31.5zm-16.3 75.4 23.4 3.4-16.9 16.5 4 23.3-20.9-11-20.9 11 4-23.3-17-16.5 23.4-3.4 10.4-21.1 10.4 21.2z" })
  }
), CQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m237.5 304.8 18.5 55.4 18.5-55.4 7.6-22.8 22.8-7.6 55.3-18.4-55.4-18.5-22.8-7.6-7.6-22.8-18.4-55.3-18.5 55.4-7.6 22.8-22.8 7.6-55.3 18.4 55.4 18.5 22.8 7.6 7.6 22.8zM192 320 75.9 281.3 0 256l75.9-25.3L192 192l38.7-116.1L256 0l25.3 75.9L320 192l116.1 38.7L512 256l-75.9 25.3L320 320l-38.7 116.1L256 512l-25.3-75.9zM54.1 88 88 54.1l17 17 48 48 17 17-34 33.8-17-17L71 105 54 88zM458 88l-17 17-48 48-17 17-33.9-34 17-17 48-48 17-17 33.8 34zm-17 319 17 17-34 33.9-17-17-48-48-17-17 34-33.8 17 17 48 48zM54.1 424l17-17 48-48 17-17 33.8 34-17 17-48 48-17 17z" })
  }
), LQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M315.2 51.4 374.6 164 500 185.7l57.3 9.9-40.5 41.7-88.8 91.2 18.3 127.4 8.1 56.1-51.8-23-114.5-50.8L173.5 489l-51.8 23 8.1-56.1 18.3-127.4-88.7-91.2-40.5-41.7 57.3-9.9L201.6 164l59.3-112.6L288.1 0l27.1 51.4zm51.2 159.8-23.3-4-11-20.9-44.1-83.5-44 83.6-11 20.9-23.3 4-93 16.1 65.8 67.7L199 312l-3.4 23.4-14 97.6 87-38.6 19.5-8.6 19.5 8.6 87 38.6-14-97.6-3.4-23.4 16.4-16.9 65.8-67.7-93-16.1zM312 176v112h-48V176zm-48 144h48v48h-48z" })
  }
), BQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M347.2 51.4 406.6 164 532 185.7l57.3 9.9-40.5 41.7-88.8 91.2 18.1 125.9 8.3 57.6-52.2-25.7-114.1-56.1-114.2 56.1-52.2 25.7 8.3-57.6 18.1-125.9-88.7-91.2-40.5-41.7 57.3-9.9L233.6 164l59.3-112.6L320.1 0l27.1 51.4zm-27.1 51.4v273.9l21.2 10.4 84.7 41.7-13.4-93.4-3.4-23.4 16.4-16.9 65.8-67.7-93-16.1-23.3-4-11-20.9-44.1-83.5z" })
  }
), uQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m148.1 328.5-18.4 127.8-8 55.7 51.7-22.2 138.7-59.6V0l-48 71.2-62.5 92.8-125.4 21.7-57.3 9.9 40.5 41.7 88.7 91.2zm-31.4-101.1 93-16.1 20.2-3.5 11.4-17 22.7-33.7v241.5l-82.7 35.5 14.2-98.8L199 312l-16.4-16.9-65.8-67.7z" })
  }
), RQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 400h147.3L232 512h48l68.7-112H496v-48l-58.9-96 58.9-96v-48H348.7L280 0h-48l-68.7 112H16v48l58.9 96L16 352zm87.1-98.1 30.7 50.1H72.3zm87 50.1-58.9-96 58.9-96h131.8l58.9 96-58.9 96zm29.5 48h72.8L256 459.3zm158.6-48 30.7-50.1 30.8 50.1zm30.7-141.9L378.2 160h61.5zM292.4 112h-72.8L256 52.7zm-158.6 48L103 210.1 72.3 160z" })
  }
), $Q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 75.9V0H184v131.3l-48-27.7-24.1-14-41.6-24-24 41.6-24 41.6-24 41.6 41.6 24L64 228.3l48 27.7-48 27.7-24.1 13.9-41.6 24 24 41.6 24 41.6 24 41.6 41.6-24 24.1-14 48-27.7V512h144V380.7l48 27.7 24.1 13.9 41.6 24 24-41.6 24-41.6 24-41.6-41.6-24-24.1-13.8-48-27.7 48-27.7 24.1-13.9 41.6-24-24-41.6-24-41.6-24-41.6-41.6 24-24.1 14-48 27.7zm96.1 55.3 24 41.6-72.1 41.6-72 41.6 72 41.6 72.1 41.6-24 41.6-72.1-41.7-72-41.6V464h-48V297.6l-72 41.6-72.1 41.6-24-41.6 72.1-41.6 72-41.6-72-41.6-72.1-41.6 24-41.6 72.1 41.7 72 41.6V48h48V214.4l72-41.6 72.1-41.6z" })
  }
), kQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m313.3 77.7 38.3 117.9h205.7l-66.1 48-100.3 72.8 38.3 117.9 25.2 77.7-66.1-48-100.2-72.9L187.8 464l-66.1 48 25.2-77.7 38.3-117.9-100.3-72.8-66.1-48h205.7l38.3-117.9L288.1 0zm38.3 165.9h-34.9l-10.8-33.2-17.9-55.1-.1.2v176.3h.1l28.2 20.5 46.8 34-17.9-55.1-10.8-33.2 28.2-20.5 46.8-34h-57.7z" })
  }
), PQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m185.2 316.4-40.2 124-23.3 71.6 63.6-40.4 126.8-80.5V0l-48 107.2-39.5 88.3H18.9l66.1 48 100.3 72.9zm-18.6-72.9h89l8.4-18.9v140L208.6 400l22.3-68.7 10.8-33.2-28.2-20.5-46.8-34z" })
  }
), FQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M351.6 195.6 313.3 77.7 288.1 0l-25.3 77.7-38.3 117.9H18.9l66.1 48 100.3 72.9-38.4 117.8-25.2 77.7 66.1-48 100.3-72.9L388.3 464l66.1 48-25.2-77.7-38.3-117.9 100.3-72.9 66.1-48H351.6zm57.9 48-46.8 34-28.2 20.5 10.8 33.2 17.9 55.1-46.8-34-28.2-20.5-28.2 20.5-46.8 34 17.9-55.1 10.8-33.2-28.2-20.5-46.8-34h92.8l10.8-33.2 17.9-55.1 17.9 55.1 10.8 33.2h92.8z" })
  }
), TQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m297 57-32 32-17 17-33.9-34 17-17 32-32 17-17 33.8 34zm192 192-32 32-17 17-33.9-34 17-17 32-32 17-17 33.8 34-17 17zm17-209-17 17-128 128-17 17-33.9-34 17-17L455 23l17-17 33.9 34zM220.2 198.2l33 66.9 73.8 10.7 59.8 8.7-43.3 42.2-53.4 52.1 12.6 73.5L313 512l-53.5-28.1-66-34.7-66 34.7L73.9 512l10.2-59.6 12.6-73.5-53.4-52.1L0 284.6l59.8-8.7 73.8-10.7 33-66.9 26.9-54.3 26.8 54.2zm26.1 114.4-25-3.6-11.2-22.6-16.7-33.9-16.7 33.9-11.1 22.6-25 3.6-37.4 5.4 27.1 26.4 18.1 17.6-4.4 25-6.4 37.3 33.5-17.6 22.3-11.7 22.3 11.7 33.5 17.6-6.3-37.3-4.3-24.9 18.1-17.6 27.1-26.4-37.4-5.4z" })
  }
), AQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.6 164 315.2 51.4 288.1 0l-27.2 51.4L201.5 164 76.2 185.7l-57.3 9.9 40.5 41.7 88.7 91.2L130 454.4l-8.3 57.6 52.2-25.7 114.2-56.1 114.2 56.1 52.1 25.7-8.3-57.6L428 328.5l88.7-91.2 40.5-41.7-57.3-9.9zm84.8 63.4-65.8 67.7-16.4 16.9 3.4 23.4 13.4 93.4-84.7-41.7-21.2-10.4-21.2 10.4-84.7 41.7 13.4-93.4L199 312l-16.4-16.9-65.8-67.7 93-16.1 23.3-4 11-20.9 44.1-83.5 44.1 83.5 11 20.9 23.3 4 93 16.1z" })
  }
), DQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m6.5 127.6 112-120 35.1 32.8L48 153.5V195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195v-41.5L486.5 40.4l35-32.8 112 120 6.5 6.9v243l-6.5 6.9-112 120-35.1-32.7L592 358.5V317l-137.9 26.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317v41.5l105.5 113.1-35.1 32.7-112-120-6.4-6.8v-243zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9v24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22v-24.3l-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1h-32.5c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7v-32.5c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7zm94.9-94.9h-32.5c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1m-32.5-32h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1M336 145.1v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2M352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2h-.5c-8.7.1-16.5 3.6-22.2 9.2l-.3.3c-5.7 5.8-9.2 13.7-9.2 22.5 0 17.7 14.3 32 32 32 8.8 0 16.8-3.6 22.6-9.4s9.4-13.8 9.4-22.6z" })
  }
), yQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v161.7l105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7V32h48v448h-48V318.3l-105.8 24.9C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3V480H0V32zm396.7 256.6L528 269v-26l-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6M48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243zm224 97.9v-32.5c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2m-73.7-43.8 23-23c-5.6-8.4-9.6-17.9-11.7-28.1h-32.5c2.7 19 10.2 36.4 21.2 51.1zM177.1 240h32.5c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1m43.8-73.7 23 23c8.4-5.6 17.9-9.6 28.1-11.7v-32.5c-19 2.7-36.4 10.2-51.1 21.2zm134.2 179.4-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5c19-2.7 36.4-10.2 51.1-21.2m22.6-22.6c11-14.7 18.4-32.1 21.2-51.1h-32.5c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23m.3-45.6c-14.7-11-32.1-18.4-51.1-21.2v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23m-44.4 112.3c5.8-5.8 9.4-13.8 9.4-22.6s-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2h-.5c-8.7.1-16.5 3.6-22.3 9.2l-.3.3c-5.7 5.8-9.2 13.7-9.2 22.5 0 17.7 14.3 32 32 32 8.8 0 16.8-3.6 22.6-9.4z" })
  }
), bQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M258.8 0h122.4l2.6 21 27.4 219H512v112h56V168h-24v-48h24V72h48v48h24v48h-24v304h-48v-26.7L512 464v16h-32v32h-64v-32H224v32h-64v-32h-32v-16l-56-18.7V472H24V168H0v-48h24V72h48v48h24v48H72v184h56V240h100.8l27.4-219zM368 432V281.5L338.8 48h-37.6L272 281.5V432zm48 0h48V288h-48zM224 288h-48v144h48zm96-64c17.7 0 32 14.3 32 32v64h-64v-64c0-17.7 14.3-32 32-32" })
  }
), fQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m356 60 60 20-60 20-20 60-20-60-60-20 60-20 20-60zm108 148 48 16-48 16-16 48-16-48-48-16 48-16 16-48zm-243.8-9.8 33 66.9 73.8 10.7 59.8 8.7-43.3 42.2-53.4 52.1 12.6 73.5L313 512l-53.5-28.1-66-34.7-66 34.7L73.9 512l10.2-59.6 12.6-73.5-53.4-52.1L0 284.6l59.8-8.7 73.8-10.7 33-66.9 26.9-54.3 26.8 54.2zm26.1 114.4-25-3.6-11.2-22.6-16.7-33.9-16.7 33.9-11.1 22.6-25 3.6-37.4 5.4 27.1 26.4 18.1 17.6-4.4 25-6.4 37.3 33.5-17.6 22.3-11.7 22.3 11.7 33.5 17.6-6.3-37.3-4.3-24.9 18.1-17.6 27.1-26.4-37.4-5.4z" })
  }
), UQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7 0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7c12.8-24.4 20.1-52.2 20.1-81.7m40 112h3.6l84.4-32.8V280h-81.3c-3.4 31.8-13.4 61.6-28.7 88zm6.7-136H528v-55.2l-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zM576 368l-64 24.9V512H332.6L311 484l-9.9-12.9C275.9 477 250 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2L576 144v112zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32m16-80a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32m152-80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m77 198.7 7.2 9.3H464v-48h-84.2l-79.1-102.3c-9.7 12.9-22.6 23.3-37.5 30z" })
  }
), GQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h256v128h-91.2l37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4-37.8 26.1H256v128H0V352h80.5l50.1-34.7-45.5-5.5-21.1-2.5V202.7l21.1-2.5 45.5-5.5L80.5 160H0V56zm48 48v32h160V80zm64 165.3v21.4l146.1 17.5c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2zM48 432h160v-32H48zm400-32a144 144 0 1 0 0-288 144 144 0 1 0 0 288m32-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0" })
  }
), qQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3-26.6 26.6-56.8 42.7-81.6 55.3-2.8 1.4-5.5 2.8-8.1 4.1-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360v104h192c70.2 0 140.7-26.7 194-66.3 52.5-39.1 94-95.4 94-157.7 0-48.1-19-95-47-130-27.6-34.5-67.9-62-113-62-27.4 0-49.4 8.6-66.5 24.6M240 512H0V360c0-38.6 17.8-68.3 42.5-88.1 19.6-15.8 41.4-26.8 63.3-37.8 27.3-13.8 54.6-27.6 77.7-50.7 13.8-13.8 19.7-27.9 30-52.9 3.2-7.7 6.8-16.5 11.2-26.6 7.7-17.6 20.6-44.7 44.1-66.5C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80 33.9 42.4 57.5 99.6 57.5 160 0 83.9-55.1 152.8-113.4 196.2-60.5 45-140.9 75.8-222.6 75.8m65.6-352.5c2.5-6 4.8-11.8 7.1-17 6.9-15.7 13.3-27.1 21.5-34.7 7.5-7 17.5-11.7 33.9-11.7 25.4 0 53.3 16.2 75.5 44 22 27.5 36.5 64.1 36.5 100 0 40.8-28.3 84.6-74.7 119.2-46 34.1-106.8 56.7-165.4 56.7H96v-56c0-9 2.6-13.2 6.9-16.9 5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8 28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), WQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 369.1v93.5C133.7 451.3 56.2 371.4 48.6 272h107.8zm48 0 75.6-97.1h107.8c-7.6 99.4-85 179.3-183.4 190.6zM352 224l-16-32H176l-16 32H50.4C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176zm-96 288a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), EQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 158c0-43.1 34.9-78 78-78 9.1 0 18.1 1.6 26.7 4.7l71.1 25.9 22.6 8.2 16.4-45.1-22.6-8.2-71.1-25.9c-13.8-5-28.4-7.6-43.1-7.6-69.6 0-126 56.4-126 126v66H0v48h48v51.4L1.7 439.1 0 443.4V480h320v-48H56.2l38-95.1 1.7-4.3V272H256v-48H96z" })
  }
), OQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m150.9 46-22.5 8.4L80 72.6V200c0 57.4 46.6 104 104 104h16c57.4 0 104-46.6 104-104V72.6l-48.4-18.1-22.5-8.5L250 1.1l22.5 8.4 64 24 15.5 5.9V200c0 78.5-59.5 143.1-135.8 151.1 3.7 63 55.9 112.9 119.8 112.9 66.3 0 120-53.7 120-120v-75.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V344c0 92.8-75.2 168-168 168-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200V39.4l15.6-5.8 64-24L134 1.1zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64" })
  }
), IQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 0v96H64V0zM144 281.7l-21.4 14.2-40.3 26.9C60.9 337.1 48 361.2 48 386.9v2.2c0 41.3 33.5 74.8 74.8 74.8 14.8 0 29.2-4.4 41.5-12.6l139.7-93V128h48v256L190.9 491.4C170.7 504.8 147 512 122.8 512 55 512 0 457 0 389.2V387c0-41.8 20.9-80.9 55.7-104.1L96 256V128h48v128z" })
  }
), NQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 24V0h-48v216h120.2c-.2 2.6-.2 5.3-.2 8v64c0 39.8-32.2 72-72 72H0v152h48v-96h64c9.6 0 19 3.5 30.6 11.1 8.8 5.7 17.1 12.6 26.9 20.7 4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192v-96c0-70.7-57.3-128-128-128-50.6 0-94.4 29.4-115.1 72H184zm18 388.3c-2-1.6-4-3.3-6-4.9 46.2-4.6 84.6-35.4 100.4-77.3 12.2-6.9 22.6-8 32.7-6.6 12.4 1.7 24.9 7.1 41.1 14.4l1.2.6c14.8 6.6 33.1 14.8 53 17.6 11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7-3.5-2.8-7.2-5.8-10.9-8.9zm262-110.7c-12.4 7.1-22.9 8.2-33.1 6.8-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6-10.3-1.4-20.8-1.4-31.6.7V224c0-44.2 35.8-80 80-80s80 35.8 80 80v77.6z" })
  }
), XQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112v288H48V112zM48 64H0v384h384V64h-48z" })
  }
), KQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 0H144v48h56v49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31 17-17-33.9-33.9-17 17-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9V48h56zM64 304a160 160 0 1 1 320 0 160 160 0 1 1-320 0m172-48v80c0 28.7 23.3 52 52 52s52-23.3 52-52v-80c0-28.7-23.3-52-52-52s-52 23.3-52 52m52-12c6.6 0 12 5.4 12 12v80c0 6.6-5.4 12-12 12s-12-5.4-12-12v-80c0-6.6 5.4-12 12-12m-135.7 8.1c2.5-4.9 7.5-8.1 13.1-8.1h.7c7.7 0 13.9 6.2 13.9 13.9 0 3.7-1.5 7.2-4.1 9.9l-35.3 35.3c-15.8 15.8-24.6 37.1-24.6 59.4V388h104v-40h-61.5c2.2-6.2 5.7-11.9 10.4-16.6l35.3-35.3c10.1-10.1 15.8-23.9 15.8-38.2 0-29.8-24.2-53.9-53.9-53.9h-.7c-20.7 0-39.6 11.7-48.8 30.2l-6.4 12.9L146 265l6.4-12.9z" })
  }
), QQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0h160v48h-56v49.4c43.4 5 82.8 23.3 113.8 50.9L391 119l17-17 33.9 34-17 17-31 31c24 33.9 38.1 75.3 38.1 120 0 114.9-93.1 208-208 208S16 418.9 16 304c0-106.8 80.4-194.7 184-206.6V48h-56zm80 464a160 160 0 1 0 0-320 160 160 0 1 0 0 320m24-248v128h-48V192h48z" })
  }
), ZQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M579.6 103.8c14.4 22.8 15.6 49.9 6.7 72.6-13.5-8.3-29-13.8-45.5-15.6.2-.4.3-.8.5-1.2 4.1-9.5 3.6-20.7-2.1-29.9L486 48H154l-53.2 81.7c-5.7 9.1-6.2 20.3-2.1 29.9 3.9 9.3 11 14.8 19.9 16 2 .3 4 .4 5.8.4 11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2s22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2 11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c1.3 1.4 2.6 2.7 4.1 3.9-21.7 7.8-40.2 22.2-53.3 40.7-14.4 10.4-32.1 16.7-51.5 16.7-19.6 0-37.5-6.4-52-17-4.8-3.5-9.2-7.5-13.2-11.9-4 4.4-8.4 8.4-13.2 12-14.4 10.6-32.4 17-52 17s-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9-4 4.4-8.4 8.4-13.2 11.9-14.4 10.6-32.4 17-52 17-4 0-8.1-.3-12.1-.8-55.3-7.4-81.5-72.6-51.9-119.4L128 0h384zM144 336h240v48H144v80h240v48H96V252.6c3.9 1 7.9 1.7 12 2.3h.1c5.3.7 10.7 1.1 16.3 1.1 6.7 0 13.3-.6 19.6-1.6zm384-96c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v192H416V320h32z" })
  }
), JQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M515.4 224c-19.7 0-37.7-6.5-52.2-17.2-4.7-3.5-9.1-7.4-13-11.8-3.9 4.3-8.2 8.2-12.9 11.7-14.5 10.8-32.5 17.3-52.3 17.3-19.6 0-37.5-6.4-52-17-4.8-3.5-9.2-7.5-13.2-11.9-4 4.4-8.4 8.4-13.2 12-1.9 1.4-3.8 2.7-5.7 3.9l161.2 125H496v-81.6c6.3 1 12.8 1.6 19.4 1.6 5.6 0 10.9-.4 16.2-1.1h.1c4.2-.6 8.3-1.3 12.3-2.3v147l76.9 59.7 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 46.4 36.1L128 0h384l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4-4 .5-7.9.8-12.1.8M132.9 80.4l56.2 43.6.5-.6 2.9 3.2L256 176c11.3-.4 21.3-5.4 28.3-13.1l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2 11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c7.4 8.2 18 13.2 29.7 13.2 2 0 3.8-.1 5.8-.4 9-1.2 16.1-6.8 20.1-16 4.1-9.5 3.6-20.7-2.1-29.9L486 48H154zm-84 54.1 106.4 83.9c-9.6 3.6-20 5.6-31 5.6-4.1 0-8.2-.3-12.1-.8-43.9-5.9-69.4-48.1-63.3-88.7zM365.5 384H144v80h323.1l60.9 48h16H96V252.6c3.9 1 7.9 1.7 12 2.3h.1c5.3.7 10.7 1.1 16.3 1.1 6.7 0 13.3-.6 19.6-1.6V336h160.6z" })
  }
), jQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M483.4 224c-19.6 0-37.6-6.5-52.1-17.2-4.7-3.5-9.1-7.4-13-11.8-3.9 4.3-8.2 8.2-12.9 11.7-14.5 10.8-32.5 17.3-52.3 17.3-19.6 0-37.5-6.4-52-17-4.8-3.5-9.2-7.5-13.2-11.9-4 4.4-8.4 8.4-13.2 12-14.4 10.6-32.4 17-52 17s-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9-4 4.4-8.4 8.4-13.2 11.9-14.4 10.6-32.4 17-52 17-4 0-8.1-.3-12.1-.8-55.3-7.4-81.5-72.6-51.9-119.4L96 0h384l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4-4 .5-7.9.8-12.1.8m-391-48c11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2s22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2 11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c7.4 8.2 18 13.2 29.7 13.2 2 0 3.8-.1 5.8-.4 9-1.2 16.1-6.8 20.1-16 4.1-9.5 3.6-20.7-2.1-29.9L454 48H122l-53.2 81.7c-5.7 9.1-6.2 20.3-2.1 29.9 3.9 9.3 11 14.8 19.9 16 2 .3 4 .4 5.8.4zM112 336h352v-81.6c6.3 1 12.8 1.6 19.4 1.6 5.6 0 10.9-.4 16.2-1.1h.1c4.2-.6 8.3-1.3 12.3-2.3V512H64V252.6c3.9 1 7.9 1.7 12 2.3h.1c5.3.7 10.7 1.1 16.3 1.1 6.7 0 13.3-.6 19.6-1.6zm352 48H112v80h352z" })
  }
), YQ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 0s-40 40-40 80c0 33.9 11 44.3 29.4 61.7 3.3 3.1 6.9 6.5 10.6 10.3s7.1 7.3 10.3 10.6C387.7 181 398.1 192 432 192c40 0 80-40 80-40s-29.5-36.8-74.3-39.8l2.2-2.2c21.5-21.5 48.2-52.2 62.1-84.5l-44.1-19c-10.1 23.7-31.4 49-51.9 69.5-2 2-4.1 4-6 5.9v-2c0-48-40-80-40-80zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6 0 59.2-62.9 144-224 144H48V336c0-161 84.9-224 144.2-224m0-48C96.2 64 0 160 0 336v176h176c176 0 272-96 272-192 0-32.8-12.5-65.5-37.5-90.5l-128-128c-24.9-24.9-57.6-37.4-90.3-37.5m-11.4 124.8c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6zm-24 88c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6m57.6 20.8s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6 9.6-35.2 9.6-35.2m46.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6zm-126.4-51.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6 9.6-35.2 9.6-35.2m38.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6m73.6-195.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6 9.6-35.2 9.6-35.2m38.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6zm73.6 20.8s-23.3-2.3-35.2 9.6-9.6 35.2-9.6 35.2 23.3 2.3 35.2-9.6 9.6-35.2 9.6-35.2" })
  }
), _Q = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-96a72 72 0 1 1 0 144 72 72 0 1 1 0-144m-32.6 280 4.7 42.7L235 384h42l6.8-61.3 4.7-42.7H320v-40c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v40zm108.1 48L320 432H192l-11.6-104H144v-88c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v88h-36.4zM55.3 419.2c-3.6 2.4-3.6 7.2 0 9.6 8.8 5.7 23.1 11.8 43 17.3C137.7 457 193.5 464 256 464s118.3-7 157.7-17.9c19.9-5.5 34.2-11.6 43-17.3 3.6-2.4 3.6-7.2 0-9.6-2.1-1.4-4.8-2.9-7.9-4.5-15.3-7.7-38.8-14.9-69-20.5l8.6-47.2c32.4 5.9 60.9 14.2 82 24.8 10.5 5.3 20.3 11.7 27.8 19.6 7.6 8.1 14 19.1 14 32.6 0 21.4-15.5 36.1-29.1 45-14.7 9.6-34.3 17.3-56.4 23.4C381.8 504.7 321.6 512 256 512s-125.8-7.3-170.4-19.6c-22.1-6.1-41.8-13.8-56.4-23.4C15.5 460.1 0 445.4 0 424c0-13.5 6.4-24.5 14-32.6 7.5-7.9 17.3-14.3 27.8-19.6 21-10.6 49.5-18.9 82-24.8l8.6 47.2c-30.2 5.5-53.7 12.8-69 20.5-3.2 1.6-5.8 3.1-7.9 4.5z" })
  }
), hZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M52.8 79.7 36.5 62.1 1.3 94.7l16.3 17.6 140.8 152 7.1 7.7H640v-48H186.5L52.8 79.7zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5l49.9-36.2 49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-12.4 0-24.1 3.5-33.9 9.7l-37.3-27.1 86-62.5h-81.6L368 336.9 322.8 304zM240 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0m224 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), cZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M145.5 138c4-21.5 17.9-37.4 41.7-47.4 24.7-10.4 59.4-13.7 99.9-7.5 12.8 2 52.4 9.5 64.9 12.8l23.2 6.1 12.1-46.4-23.3-6.2c-14.7-3.8-56.1-11.7-69.7-13.8-46.2-7.1-90.4-4.1-125.7 10.7-36.1 15.1-63.3 43.1-70.5 83.9-.1.4-.1.9-.2 1.3-2.8 23.4.5 44.2 9.8 62.2 9.2 17.8 23.2 31.2 38.8 41.5 2.4 1.6 5 3.2 7.5 4.7H0v48h512V240H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8-10.9-7.2-18.2-14.9-22.6-23.5-4.2-8.2-6.6-18.9-4.9-33.8M364 337.1c3.7 8.6 5.5 20.1 2.6 36.3-3.8 21.8-17.8 37.9-41.8 48-24.7 10.4-59.4 13.7-99.8 7.5-20.1-3.2-54.3-14.6-81.2-23.6-5.9-2-11.4-3.8-16.3-5.4l-22.8-7.4-15 45.5 22.8 7.4c4 1.3 8.8 2.9 14 4.7 26.6 8.9 66.4 22.2 90.9 26.2h.1c46.2 7.1 90.4 4.1 125.7-10.7 36.1-15.1 63.3-43.1 70.5-83.9 4-22.9 2.4-43.5-5-61.7h-57.1c5.7 5.3 9.7 11 12.3 17.1z" })
  }
), sZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m97.6-45.3 22.6 22.6 45.3-45.3-22.6-22.6-11.3-11.3 22.6-22.6 11.3 11.3 22.6 22.6 45.3-45.3-22.7-22.5-11.3-11.3L222 63.7 233.4 75 256 97.6 278.6 75l11.3-11.3 22.6 22.6-11.2 11.3-22.6 22.6 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6-11.3 11.3-22.6 22.6 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6-11.4 11.3-22.6 22.6 22.6 22.6 11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-22.6 22.6-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3-22.6 22.6-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3-22.6 22.7-11.3 11.3-22.6-22.7L75 278.6 97.6 256 75 233.4l-11.3-11.3 22.6-22.6 11.3 11.3zm90.5 0L142.9 256l45.3 45.3 45.2-45.3-45.3-45.3zm113.1-22.6L256 142.9l-45.3 45.3 45.3 45.2 45.3-45.3zm67.9 67.9-45.3-45.3-45.2 45.3 45.3 45.3zM256 278.6l-45.3 45.3 45.3 45.2 45.3-45.3z" })
  }
), vZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 64H0v48h51.2l96 144-96 144H0v48h76.8l7.2-10.7 92-138 92 138 7.1 10.7H352v-48h-51.2l-96-144 96-144H352V64h-76.8L268 74.7l-92 138-92-138L76.8 64H64zm384 224h-24v48h40v128h-40v48h128v-48h-40V288h-24z" })
  }
), eZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-12.9-10V32H70.5zm84 65.2H560v332l-48-37.3V336h-49.9l-61.8-48H512v-48H384v35.4zM32 432v48h455.4l-60.9-48H80V159l-48-37.8zm120-192h-24v48h115.7l-60.9-48zm136 96v48h77.5l-60.9-48zm-160 0v48h128v-48H152z" })
  }
), lZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v352h480V80zM0 32h576v448H0V80zm120 208h200v48H96v-48zm256 0h104v48H352v-48zm-256 96h104v48H96v-48zm160 0h200v48H256v-48z" })
  }
), tZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h256v96h128v384H0V96h128V24zm208 48H176v48h160zm24 96H144v288h224V144zm-264 0H48v288h48zm320 288h48V144h-48zM229.3 208h53.3v53.3h53.3v53.3h-53.2V368h-53.4v-53.3H176v-53.4h53.3z" })
  }
), wZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0H96v128H0v352h64v32h48v-32h160v32h48v-32h64V128h-96V0h-24zm120 128h-96V48h96zM48 176h288v256H48zm48 48v48h192v-48H120zm0 112v48h192v-48H120z" })
  }
), gZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h-24v96H0v384h512V96H384V0h-24zm184 96H176V48h160zm-184 48h216v288H144V144zm-104 0h48v288H48zm416 288h-48V144h48z" })
  }
), iZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24v88h-48V0h48zm157 84.9-45.3 45.3-17 17-33.9-33.9 17-17L403.1 75l17-17L454 92l-17 17zM108.9 75l45.3 45.3 17 17-33.9 33.9-17-17L75 108.9 58 92l34-34 17 17zM24 232h88v48H0v-48zm400 0h88v48H400v-48zM154.2 391.8 108.9 437 92 454l-34-34 17-17 45.3-45.3 17-17 33.9 33.9-17 17zm237.6-33.9 45.2 45.2 17 17-34 33.9-17-17-45.3-45.3-17-17 33.9-33.9 17 17zM280 424v88h-48V400h48zm40-168a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-176 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0" })
  }
), mZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M193.1 23.2 256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4 68.4 20.5 47 14.2-23.2 43.1-.8 1.5c-7.7-1.7-15.7-2.6-24-2.6-11 0-21.6 1.6-31.6 4.5l9.4-17.5-59-17.7-24.8-7.4-7.4-24.8L333 70.2l-54.2 29.2-22.8 12.2-22.8-12.2L179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2 12.2 22.8-12.2 22.8L70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2 22.7-12.3 22.8 12.3 9.2 5V448h93.2l-5.1 17.1L362 512l-43.1-23.2-62.9-33.9-62.9 33.9L150 512l-14.1-46.9-20.5-68.4-68.5-20.6L0 362l23.2-43.1L57.1 256l-33.9-62.9L0 150l46.9-14.1 68.4-20.5L135.8 47 150 0zM256 144c58.8 0 107 45.3 111.6 102.9-2.2 3.8-4.3 7.7-6.1 11.7-21.9 5.2-40.8 17.9-54 35.3 7.8-10.6 12.4-23.7 12.4-37.9 0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c20.7 0 39.1-9.8 50.8-25.1C295 310.8 288 330.6 288 352v11.4c-10.1 3-20.9 4.6-32 4.6-61.9 0-112-50.1-112-112s50.1-112 112-112m128 272h-64v-64c0-35.3 28.7-64 64-64h1.6c7.4-36.5 39.7-64 78.4-64 35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72v72h-72z" })
  }
), aZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M193.1 23.2 256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4-38.6 38.6-7.4-24.8L333 70.2l-54.2 29.2-22.8 12.2-22.8-12.2L179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2 12.2 22.8-12.2 22.8L70.2 333l59 17.7 24.8 7.4-38.6 38.6-68.5-20.6L0 362l23.2-43.1L57.1 256l-33.9-62.9L0 150l46.9-14.1 68.4-20.5L135.8 47 150 0zM256 144c30.9 0 58.9 12.5 79.2 32.8l-33.9 33.9C289.7 199.2 273.7 192 256 192c-35.3 0-64 28.7-64 64 0 17.7 7.2 33.7 18.7 45.3l-33.9 33.9C156.5 314.9 144 286.9 144 256c0-61.9 50.1-112 112-112m192 16a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-80 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-112-48a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-48-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), oZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257.1 23.2 320 57.1l62.9-33.9L426 0l14.1 46.9 20.5 68.4 68.4 20.5 47 14.2-23.2 43.1-33.9 62.9h-54.5l12.3-22.8 29.1-54.2-59-17.7-24.8-7.4-7.4-24.8L397 70.2l-54.2 29.2-22.8 12.2-22.8-12.2L243 70.2l-17.7 59-7.4 24.8-24.8 7.4-59 17.7 29.2 54.2 12.3 22.7h-54.5l-33.9-62.9L64 150l46.9-14.1 68.4-20.5L199.8 47 214 0zM432 256h-48c0-35.3-28.7-64-64-64s-64 28.7-64 64h-48c0-61.9 50.1-112 112-112s112 50.1 112 112m184 32h24v48H480v-48h24zm-208 0h24v48H64v-48h24zm168 88v48H0v-48h552zM88 464h136v48H64v-48zm208 0h344v48H272v-48z" })
  }
), nZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m202.2 58 21.1-3.3 49.8-7.8-7.8 49.8-3.3 21.1 17.2 12.6L320 160l-40.8 29.7-17.2 12.5 3.3 21.1 7.8 49.8-49.8-7.8-21.1-3.3-12.6 17.2L160 320l-29.7-40.8-12.5-17.2-21.1 3.3-49.8 7.8 7.8-49.8 3.3-21.1-17.2-12.5L0 160l40.8-29.7L58 117.8l-3.3-21.1-7.8-49.8 49.8 7.8 21.1 3.3 12.6-17.2L160 0l29.7 40.8zm-45.6 28.3L139.3 110l-29-4.6-5.8-.9.9 5.8 4.6 29-23.7 17.3-4.8 3.4 4.7 3.4 23.8 17.3-4.6 29-.9 5.8 5.8-.9 29-4.6 17.3 23.7 3.4 4.7 3.4-4.7 17.3-23.7 29 4.6 5.8.9-.9-5.8-4.6-29 23.7-17.3 4.7-3.4-4.7-3.4-23.7-17.3 4.6-29 .9-5.8-5.8.9-29 4.6-17.3-23.7-3.4-4.8-3.4 4.7zM536 144c-17.7 0-32 14.3-32 32v288h136v48H0v-48h456V272c0-17.7-14.3-32-32-32s-32 14.3-32 32v21.4c14.8 7.7 24 23.1 24 44.6 0 19.3-21.5 52.9-48 78-26.5-25-48-58.4-48-78 0-21.5 9.2-37 24-44.6V272c0-44.2 35.8-80 80-80 11.4 0 22.2 2.4 32 6.7V176c0-44.2 35.8-80 80-80s80 35.8 80 80v53.4c14.8 7.7 24 23.1 24 44.6 0 19.3-21.5 52.9-48 78-26.5-25-48-58.4-48-78 0-21.5 9.2-37 24-44.6V176c0-17.7-14.3-32-32-32m-408 16a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), rZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M193.1 23.2 256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4 68.4 20.5 47 14.2-23.2 43.1-33.9 62.9 33.9 62.9L512 362l-46.9 14.1-68.4 20.5-20.5 68.4-14.2 47-43.1-23.2-62.9-33.9-62.9 33.9L150 512l-14.1-46.9-20.5-68.4-68.5-20.6L0 362l23.2-43.1L57.1 256l-33.9-62.9L0 150l46.9-14.1 68.4-20.5L135.8 47 150 0zm85.7 76.1L256 111.6l-22.8-12.2L179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2 12.2 22.8-12.2 22.8L70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2 22.7-12.3 22.8 12.3 54.2 29.1 17.7-59 7.4-24.8 24.8-7.4 59-17.7-29.2-54.2-12.3-22.7 12.3-22.8 29.1-54.2-59-17.7-24.8-7.4-7.4-24.8L333 70.2l-54.2 29.2zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224m64 112a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), dZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m61 31.9 21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5-66.9-10c-8.4 34.3-15.4 59.6-22.4 84.6l-.3 1c-8.1 29-16.1 57.8-26.2 100.6H256v32h64v-32h207.3c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5L493.2 35l21.8-3.1 5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2.9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V480H320V368h-64v112H0V269.2l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM200 320H48v76zm168 0v76l152-76z" })
  }
), SZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m305 18.2-17-17-17 17L194.2 95l-17 17 33.9 33.9 17-17L264 93.1V224h48V93.1l35.8 35.9 17 17 33.9-34-17-17L305 18.2zm-17 262.9-62.9-33.9L182 224l-14.1 46.9-20.5 68.4-68.5 20.6L32 374l23.2 43.1L80.5 464H0v48h576v-48h-80.5l25.3-46.9L544 374l-46.9-14.1-68.4-20.5-20.5-68.4-14.2-47-43.1 23.2zM177.1 464H135l-3.6-6.8-29.2-54.2 59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2 22.7 12.3 22.8-12.3 54.2-29.1 17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2-3.7 6.7h-42.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96M288 416c29.8 0 54.9 20.4 62 48H226c7.1-27.6 32.2-48 62-48" })
  }
), zZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m305 217 80-80 17-17-34-33.9-17 17-39 39V0h-48v142.1l-39-39-17-17-33.9 33.9 17 17 80 80 17 17 17-17zm-17 64.1-62.9-33.9L182 224l-14.1 46.9-20.5 68.4-68.5 20.6L32 374l23.2 43.1L80.5 464H0v48h576v-48h-80.5l25.3-46.9L544 374l-46.9-14.1-68.4-20.5-20.5-68.4-14.2-47-43.1 23.2zM177.1 464H135l-3.6-6.8-29.2-54.2 59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2 22.7 12.3 22.8-12.3 54.2-29.1 17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2-3.7 6.7h-42.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96M288 416c29.8 0 54.9 20.4 62 48H226c7.1-27.6 32.2-48 62-48" })
  }
), pZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 0h-24v48h40v128h-40v48h128v-48h-40V0h-24zM24 64H0v48h51.2l96 144-96 144H0v48h76.8l7.2-10.7 92-138 92 138 7.1 10.7H352v-48h-51.2l-96-144 96-144H352V64h-76.8L268 74.7l-92 138-92-138L76.8 64H64z" })
  }
), MZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 207.7c-13.2 11.2-29 19.7-45 26.1-36 14.4-82.3 22.2-131 22.2s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1v147.9c.5.8 1.1 1.7 1.7 2.6 5.1 7.4 13.7 18 26.8 28.7 25.4 21 70.6 45.1 147.5 45.1s122.1-24.1 147.5-45.1c13.1-10.8 21.7-21.3 26.8-28.7.6-.9 1.2-1.8 1.8-2.6V207.7zM64 144c0 11.6 7.7 22.5 21.2 31.9l50.3-46.6 3-2.8 3.9-1.4 75.3-26.5-8.4-18.3C127.9 83.2 64 110.6 64 144m60.5 50.1c27.3 8.7 61.9 13.9 99.5 13.9 39.9 0 76.3-5.8 104.3-15.5l-73.7-27.6-7.7-2.9-3.4-7.5-8.9-19.4-74.9 26.4-35.2 32.6zM384 144c0-31.3-56.1-57.3-130.2-62.9l22.5 49.3 97.2 36.4c6.8-7.1 10.5-14.8 10.5-22.8M224 32c123.7 0 224 50.1 224 112v224s-48 112-224 112S0 368 0 368V144C0 82.1 100.3 32 224 32" })
  }
), xZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m576 352-21.3-127.6c-6.4-38.1-23.7-72.1-48.5-98.8L405.9 295.5zM393.5 66.1 282.2 254.4l92.7 30.8 107.2-181.6c-25.4-19.5-55.8-32.7-88.7-37.5zm-36-2.1H246.6L96.1 318.7l139.4-48.3zM21.3 224.4 0 352l32-11.1 1.5-.5 15.9-5.5L80 324.3l-30.6 10.6L209.5 64c-93.3.6-172.8 68.2-188.2 160.4M32 374.8v1.2c0 39.8 32.2 72 72 72 16.6 0 31.8-5.6 44-15 12.2 9.4 27.4 15 44 15 18.4 0 35.3-6.9 48-18.3 12.7 11.4 29.6 18.3 48 18.3s35.3-6.9 48-18.3c12.7 11.4 29.6 18.3 48 18.3 16.6 0 31.8-5.6 44-15 12.2 9.4 27.4 15 44 15 39.8 0 72-32.2 72-72v-.9l-48-15.9V376c0 13.3-10.7 24-24 24-5.6 0-10.6-1.8-14.6-5L428 372.3 398.6 395c-4.1 3.1-9.1 5-14.6 5-6.2 0-11.7-2.3-16-6.1l-32-28.7-32 28.7c-4.3 3.8-9.8 6.1-16 6.1s-11.7-2.3-16-6.1l-32-28.7-32 28.7c-4.3 3.8-9.8 6.1-16 6.1-5.6 0-10.6-1.8-14.6-5L148 372.3 118.6 395c-4.1 3.1-9.1 5-14.6 5-13.3 0-24-10.7-24-24v-17.9z" })
  }
), HZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m128 6.1 17 17 88 88 17 17-34 33.8-17-17-47-47V432h144V32h240v382.1l47-47 17-17 33.9 33.9-17 17-88 88-17 17-17-17-88-88-17-17 34.1-33.9 17 17 47 47V80H344v400H104V98l-47 47-17 17-33.9-34 17-17 88-88 17-17z" })
  }
), VZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 160H16v-40l7.5-8 71.7-76.8L128 0l32.8 35.2 71.7 76.8 7.5 8v40h-88v272h144V32h240v320h88v40l-7.5 8-71.7 76.8L512 512l-32.8-35.2-71.7-76.8-7.5-8v-40h88V80H344v400H104V160zm102.9-48L128 70.3 89.1 112h77.7zm384 288h-77.8l38.9 41.7z" })
  }
), CZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 400c0 61.9 50.1 112 112 112h400V288H385.9l79-79 17-17-17-17L337 47l-17-17-17 17-79 79V0H0v24zm209.9 64 128-128H464v128zm204.2-272L224 382.1V193.9l96-96zM112 464c-35.3 0-64-28.7-64-64v-96h128v96c0 35.3-28.7 64-64 64M48 256v-80h128v80zm0-128V48h128v80zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), LZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232.4 224 480 0l32 32-173.7 192zM129.9 478.1 96 512l-33.9-33.9-28.2-28.2L0 416l33.9-33.9L160 256h192l-48 48zm39.4-107.3 66.8-66.8h-56.2l-38.6 38.6 28.1 28.1zm-22.6 22.6-28.1-28.1L67.9 416 96 444.1l50.7-50.7z" })
  }
), BZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 0 230 226.2l55.8 55.8L512 32zM185 231l-17-17-33.9 34 17 17L0 416v48l32 32 16 16h48l151-151 17 17 33.9-34-17-17-96-96zm0 67.9 28.1 28.1-12.7 12.7-28.1-28.1zm-35.3 35.3 28.1 28.1-12.4 12.4-28.1-28.1zm-6.9 63.2L76.1 464h-8.2l-1.9-1.9-18-18v-8.2l66.6-66.6 28.1 28.1z" })
  }
), uZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m200.6 283.3-33.9-33.9L400 16l62.5-8.9L512 0l-7.1 49.5L496 112 262.6 345.4l-33.9-33.9 222-222.1 4.7-32.8-32.8 4.7zM0 416l32-32 32 16 56-56-56-88 32-32 192 192-32 32-88-56-56 56 16 32-32 32z" })
  }
), RZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m128 32 224 247.6V173.7L160 0zm512 384-33.9-33.9L432 208l-48-48v192l126.1 126.1L544 512l33.9-33.9L606 450zM432 275.9l66.7 66.7-28.1 28.1-38.6-38.6zM572.1 416 544 444.1l-50.7-50.7 28.1-28.1zM203.8 249.9 185 231l-17-17-33.9 34 17 17L0 416v48l32 32 16 16h48l151-151 17 17 33.9-34-17-17-18.8-18.8 36.3-40.1-51.6-57.1zm208.1-107.3L512 32 480 0 369.4 100.1l37.3 37.3 5.3 5.3zM185 298.9l28.1 28.1-12.7 12.7-28.1-28.1zm-7.2 63.4-12.4 12.4-28.1-28.1 12.4-12.4 28.1 28.1m-35 35L76.1 464h-8.2l-1.9-1.9-18-18v-8.2l66.6-66.6 28.1 28.1z" })
  }
), $Z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M339.3 367.4 54.5 82.6l-2.3-30.4 30.5 2.3 284.7 284.8 33.9-33.9L104 8 48.4 3.7 0 0l3.7 48.4L8 104l297.4 297.4 33.9-33.9zM408 456l56 56 48-48-56-56 24-72-32-32-144 144 32 32zM137.4 278.6 88 328l-24-24-32 32 24 72-56 56 48 48 56-56 72 24 32-32-24-24 49.4-49.4-33.9-33.9-49.4 49.4L122 362l49.4-49.4-33.9-33.9zm203.3-79.2 33.9 33.9L504 104l4.3-55.6L512 0l-48.4 3.7L408 8 278.6 137.4l33.9 33.9L429.4 54.5l30.5-2.3-2.3 30.5z" })
  }
), kZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0h200v48H0V0zm0 80h200v48h-88v96H88v-96H0V80zM512 2.7V176c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V61.3L352 83.7V208c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V44.3l19.3-3.9 160-32zM288 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0m222.7 3.2-17 17-153.5 153.6-17 17-33.9-33.9 17-17 153.5-153.7 17-17 33.9 33.9zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64M40 256h112v56.5c0 27-12.4 52.6-33.7 69.2l31.9 28.5 24-26.4 16.1-17.8 35.5 32.3-16.1 17.8-23.7 26.1 18.7 16.7 17.9 16-32 35.8-17.9-16-19-17-24 26.4-7.1 7.9H0v-40.7c0-35.7 15.9-69.5 43.3-92.3C25.9 362.4 16 339.4 16 315.3V256zm48.4 88.2c9.8-7.6 15.6-19.3 15.6-31.7V304H64v11.3c0 11.4 4.9 22.3 13.4 29.8l4.5 4 6.5-5zm-12.3 70c-15.8 12.1-25.7 30.2-27.7 49.8h53l16.6-18.2-38.4-34.3z" })
  }
), PZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 288v176h64v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V166.7L320 62 192 166.7zm-48-48v-96L320 0l176 144v96l14.1-14.1L544 192l33.9 33.9L640 288v224H0V288l62.1-62.1L96 192l33.9 33.9zm0 67.9-48-48-48 48V464h96zm352 0V464h96V307.9l-48-48zM341.3 155.1H384L362.7 192l21.3 36.9h-42.7l-21.3 37-21.3-36.9H256l21.4-37-21.4-36.9h42.7l21.3-37 21.3 36.9z" })
  }
), FZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m435.2 1.3-33.9 33.9 17 17 3.8 3.8L384 94.1 329 39l-17-17-33.9 34 17 17 72 72 72 72 17 17 33.8-34-17-17-55-55L456 89.9l3.8 3.8 17 17 33.9-33.9-17-17L473 39l-20.8-20.8-17-17zM271.4 94.6 71 295l-7 7v112.1l-45.8 45.7-17 17 33.9 33.9 17-17L97.9 448h112l7-7 200.5-200.4-1-1-33-33L190.1 400H112v-78.1l29.7-29.7 23 23 11.3 11.4 22.6-22.6-11.3-11.3-23-23 41.4-41.4 23 23 11.3 11.3 22.6-22.6-11.3-11.3-23-23 41.4-41.4 23 23 11.3 11.3 22.6-22.6-11.3-11.3-23-23 13.1-13.1-33-33-1-1z" })
  }
), TZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h168v400h48V80h168V32H192z" })
  }
), AZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 80v152h184V80zm-48 0H48v152h184zM48 280v152h184V280zm232 152h184V280H280zM0 32h512v448H0V80z" })
  }
), DZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 80v88h104V80zm-48 0H200v88h112zm-160 0H48v88h104zM48 216v80h104v-80zm0 128v88h104v-88zm152 88h112v-88H200zm160 0h104v-88H360zm104-136v-80H360v80zM0 32h512v448H0V80zm200 264h112v-80H200z" })
  }
), yZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432V160h184v272zm232 0V160h184v272zM48 32H0v448h512V32h-48z" })
  }
), bZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 80v80H48V80zM48 432V208h96v224zm144 0V208h272v224zM48 32H0v448h512V32h-48z" })
  }
), fZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 80v88h272V80zm-48 0H48v88h96zM48 216v80h96v-80zm0 128v88h96v-88zm144 88h272v-88H192zm272-136v-80H192v80zM0 32h512v448H0V80z" })
  }
), UZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64h384v48h-96.4l48.1 128H512v48H0v-48h112.3l48.1-128H64zm314.5 256h51.3l48.1 128h-51.3zM85.4 448H34.1l48.1-128h51.3zm126.2-336-48.1 128h185l-48.1-128z" })
  }
), GZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h128v128H0zm160 128V32h352v448H0V192h128v240h336V160zm208 32 48 48v16h-32v96h-96v32h-16l-48-48 48-48h16v32h64v-64h-32v-16z" })
  }
), qZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96m464 184v136c0 8.8-7.2 16-16 16H112V280zM448 80c8.8 0 16 7.2 16 16v136H112V80zm16 352H128V280h336zm0-200H128V80h336zM0 432v48h512V32H0v48z" })
  }
), WZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m304 480-25.3-25.3-34-34-32.7 35.2-19.4 20.9L160 512l-34-34-28-28-34-34 35.2-32.7 20.9-19.4 35.2-32.7-34-34L96 272V163.2l97.6-97.6c87.5-87.5 229.3-87.5 316.8 0 67.1 67.1 82.7 166.3 46.8 248.3-12.7-9.6-27.3-17-43.1-21.3 27.1-64 14.5-140.9-37.7-193.1-68.7-68.7-180.2-68.7-248.9 0l-47 47 195.2 195.3c-9.9 13.9-17.1 29.8-20.8 47.1L146.6 180.5l-2.6 2.6v69l45.2 45.2 35.2 35.2-36.5 33.9-54.8 50.8 25.6 25.6 50.8-54.8 33.9-36.5 35.2 35.2 45.3 45.3H353c2.2 17.3 7.8 33.5 16.1 48zm224-64a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0" })
  }
), EZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 160v272h416V160H128v80h64v32h-64v64h128v32H96V160zM0 32h512v448H0V80zm224 192h192v64H224zm192 96v64H288v-64z" })
  }
), OZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 264V160h184v104zm0 48h184v120H48zm232 120V312h184v120zm184-168H280V160h184zM48 32H0v448h512V32h-48z" })
  }
), IZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h352V48zM0 0h448v512H0V48zm224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), NZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 48v416H80V48zM80 0H32v48L0 64v96l32 16v16L0 208v96l32 16v16L0 352v96l32 16v48h384v-48l32-16v-96l-32-16v-16l32-16v-96l-32-16v-16l32-16V64l-32-16V0h-48z" })
  }
), XZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h352v-96H48zm0-144h352V48H48zM0 0h448v512H0V48zm224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), KZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 464h352v-96H48zm0-144h352V48H48zM0 0h448v512H0V48zm192 400h80v32h-96v-32z" })
  }
), QZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h352V48zM0 0h448v512H0V48zm192 400h80v32h-96v-32z" })
  }
), ZZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1l154.7 154.7c27.8-43.4 22.8-101.7-15.1-139.6zm-18.8 173.5L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136M160 240c-53.6 0-98.4 37.7-109.4 88h218.8c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88H50.6c11 50.3 55.8 88 109.4 88" })
  }
), JZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h544V112zM0 64h640v384H0V112zm368 80v96H80v-96zM80 336h288v32H80zm320 0h160v32H400zm-288-64v32H80v-32zm32 0h32v32h-32zm96 0v32h-32v-32zm32 0h32v32h-32zm96 0v32h-32v-32z" })
  }
), jZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m325.9 86.1 88.3-2.7 24.7 84.9L512 218l-22.2 61.8C437.5 207.2 352.3 160 256 160S74.5 207.2 22.2 279.8L0 218l73.1-49.7 24.7-84.9 88.3 2.7L256 32zM511.5 432c.3 5.3.5 10.6.5 16v32H0v-32c0-5.4.2-10.7.5-16C8.8 298.1 120 192 256 192s247.2 106.1 255.5 240m-462.9 0h414.8c-8.2-107.4-97.9-192-207.4-192S56.8 324.6 48.6 432zM184 304a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-64 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), YZ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 412.1-176-176V80h156.1l176 176zm190.1-190L224 32H0v224l190.1 190.1L224 480l33.9-33.9 156.2-156.2L448 256zM112 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), _Z = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m495.2 189.3 7 7V315.6l-7 7L337 481l-34-34 151.2-151.2v-79.6L303 65l34-34zM48 236.1l176 176 144-144v-24.2L204.1 80H48zM224 32l192 192v64L257.9 446.1 224 480l-33.9-33.9L0 256V32h48zM80 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), hJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 40v432h-48V40z" })
  }
), cJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 64V40h-48v432h48v-24zm128 0V40h-48v432h48v-24z" })
  }
), sJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 40v432h-48V40zm128 0v432h-48V40zm128 24v408h-48V40h48z" })
  }
), vJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 64V40h-48v432h48v-24zm128 0V40h-48v432h48v-24zm128-24h-48v432h48V64zm128 24V40h-48v432h48v-24z" })
  }
), eJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 40v246.7l80-26.7V40h48v204l80-26.7V40h48v161.4l80-26.7V40h48v118.7l64.4-21.5 22.8-7.6 15.2 45.5-22.8 7.6-79.6 26.6V472h-48V225.3L408 252v220h-48V268l-80 26.7V472h-48V310.6l-80 26.7V472h-48V353.3l-64.4 21.5-22.8 7.6-15.2-45.6 22.8-7.6 79.6-26.5V40z" })
  }
), lJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 48-24.6 160h-48.6L268 70.5c-1.9-1-3.9-2-6.1-3-4.8-2.2-10.4-4.5-16.9-6.7L229.2 208h-32.1l16.6-155.3c-11.1-2.1-23.7-3.6-37.7-4.3V208h-32V48.4c-14 .7-26.6 2.2-37.7 4.3L122.9 208H90.8L75 60.8c-6.4 2.2-12.1 4.5-16.9 6.7-2.2 1-4.2 2-6.1 3L73.2 208H24.6L0 48S48 0 160 0s160 48 160 48m-64 256h39.4L320 464s-48 48-160 48S0 464 0 464l24.6-160H64l-19.2 25.6L66.7 346 52 441.4c1.9 1 3.9 2 6.1 3 4.8 2.2 10.4 4.5 16.9 6.7l9.8-91.6 29.8 22.3-8.3 77.4c11.1 2.1 23.7 3.6 37.7 4.3V357.3l6.4-8.5L160 336l9.6 12.8 6.4 8.5v106.3c14-.7 26.6-2.2 37.7-4.3l-8.3-77.4 29.8-22.3 9.8 91.6c6.4-2.2 12.1-4.5 16.9-6.7 2.2-1 4.2-2 6.1-3L253.3 346l21.9-16.4zM24 240h288v32H192l28.8 38.4 9.6 12.8-25.6 19.2-9.6-12.8-35.2-46.9-35.2 46.9-9.6 12.8-25.6-19.2 9.6-12.8L128 272H8v-32z" })
  }
), tJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M206.4 32H0v448h448V32H241.6l9.4 14.8L272.1 80H400v222.4c-14.2-2.7-27.8-8.7-39.4-15.3-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-11.6 6.6-25.2 12.5-39.3 15.3V80h128L197 46.8zM48 351c25-3.1 47.1-13 63-22.1 6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 16 9.1 38.1 19 63.1 22.1v81H48zM213.8 80l-37.1 58.3c-5.7 8.9-8.7 19.3-8.7 29.9 0 30.8 25.2 55.8 56 55.8s56-25 56-55.8c0-10.6-3-21-8.7-29.9L234.2 80 224 64z" })
  }
), wJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352m138.6 352c52-41 85.4-104.6 85.4-176 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h352v-48h-24zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192" })
  }
), gJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 160c-35.3 0-64-26.9-64-60S288-8 288-8s64 74.9 64 108-28.7 60-64 60M48 128h149.5c7 19.8 20.3 36.6 37.5 48H48v288h368V352h112V176H341.1c17.2-11.4 30.5-28.2 37.5-48H576v256L448 512H0V128zm64 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), iJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112h480v176H416v112H48zm528 208V64H0v384h448zM112 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), mJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 128v80h120v-80zm0 128v120h144v48H80v56H32v-56H0V82.3l2.5-5.1C11 60.4 31 41.2 61.3 26.4 92.2 11.3 135.2 0 192 0c120.9 0 173.4 45.2 189.5 77.3l2.5 5.1V96h-48v32H216v80h45.6l-11.1 32.1h-1.8l-56.7-.4V256zM321.4 80C301.9 65.2 263.6 48 192 48c-50.4 0-86.1 10-109.7 21.6-7.1 3.5-13 7-17.9 10.4H192zM104 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48m264-160h128v32h56.9l5.7 15.9 34.3 96.1H640v240h-48v-64H272v64h-48V272h47.1l34.3-96.1 5.7-15.9H368zm207.4 192H272v80h320v-80h-16.5zm-33.5-48L519 208H344.9L322 272zM312 360a24 24 0 1 1 48 0 24 24 0 1 1-48 0m216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), aJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0H160v64h-57.3l-5.5 16.4L54.7 208H0v304h48v-80h416v80h48V208h-54.7L414.8 80.4 409.3 64H352zm22.7 112 32 96H105.3l32-96zM48 256h416v128H48zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), oJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80c0-17.7 14.3-32 32-32 14 0 25.9 9 30.3 21.5l7 20.1 20.7-4.5c16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1l20.8 4.5 7-20.1C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32 0 11.5-6.1 21.7-15.4 27.3l-15.1 9.2 4.4 17.2c1.3 5.3 2.1 11.3 2.1 18.3 0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9.8-13 2.1-18.3l4.4-17.2-15.1-9.2C150.1 101.7 144 91.5 144 80m32-80c-44.2 0-80 35.8-80 80 0 22.8 9.5 43.3 24.7 57.9-.3 2.6-.5 5.3-.6 8l-17.3 13.6-75.4 59.4-18.8 14.8 14.9 18.9 25.8 32.7C61.2 300.4 74.2 314 88 326.2l-60 10.1-22.7 3.9L8.2 363l16 128 2.6 21h522.4l2.6-21 16-128 2.8-22.8-22.6-3.9-60-10.2c13.9-12.2 26.8-25.8 38.7-40.9l25.8-32.7 14.9-18.9-18.9-14.9-75.4-59.4-17.3-13.6c-.1-2.7-.3-5.3-.6-8C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80-27.5 0-51.8 13.9-66.1 35-14.8-2.1-30.2-3-45.9-3s-31.1.9-45.9 3C227.8 13.9 203.5 0 176 0M58.7 379.8l51.9-8.8c.5 2.5.9 5.1 1.1 7.5l2.2 21.5H160v-80.6l-11-7.1c-22.9-14.8-44-33.7-62.1-56.8L76 241.7l37.7-29.7 10.9 13.9c83.3 105.7 243.5 105.7 326.8 0l10.9-13.9 37.7 29.7-10.9 13.9c-18.1 23-39.2 41.9-62.1 56.8l-11 7.1V400h46.1l2.2-21.5c.3-2.4.6-5 1.1-7.5l51.9 8.8-10.5 84.2H376v-81.9l-7-7-32-32-7-7h-83.9l-7 7-32 32-7 7V464H69.2zM248 464v-62.1l17.9-17.9H310l18 17.9V464zm8-320a16 16 0 1 0-32 0 16 16 0 1 0 32 0m80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24 14.3 24 32 24 32-10.7 32-24" })
  }
), nJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48v77.4C512.1 102.8 485.8 88 456 88c-15.2 0-29.5 3.9-42 10.7C397.9 77.6 372.5 64 344 64c-21.3 0-40.8 7.5-56 20.1C272.8 71.5 253.3 64 232 64c-28.5 0-53.9 13.6-70 34.7-12.5-6.8-26.8-10.7-42-10.7-29.8 0-56.1 14.8-72 37.4V48zm16 208h32V0H0v256h528zm-48-48h-80v-32c0-5.7 1.2-11.1 3.3-16 1.2-2.9 2.8-5.5 4.7-8 2.2-2.9 4.8-5.5 7.7-7.7 6.7-5.2 15.2-8.3 24.3-8.3 16.4 0 30.5 9.9 36.7 24 2.1 4.9 3.3 10.3 3.3 16zm-112 0h-80v-56c0-10.9 4.4-20.8 11.4-28 7.3-7.4 17.4-12 28.6-12 15.2 0 28.4 8.5 35.2 21 3.1 5.7 4.8 12.1 4.8 19v24zm-112 0h-80v-56c0-6.9 1.7-13.4 4.8-19 6.8-12.5 20-21 35.2-21 11.2 0 21.3 4.6 28.6 12 7.1 7.2 11.4 17.1 11.4 28v8zm-112 0H80v-32c0-5.7 1.2-11.1 3.3-16 6.2-14.1 20.3-24 36.7-24 9.2 0 17.6 3.1 24.3 8.3 2.9 2.2 5.5 4.8 7.7 7.7 1.8 2.5 3.4 5.1 4.7 8 2.1 4.9 3.3 10.3 3.3 16zM32 288H0v224h576V288H48zm496 122.6V464H48v-53.4c15.9 22.6 42.2 37.4 72 37.4 21.3 0 40.8-7.5 56-20.1 15.2 12.6 34.7 20.1 56 20.1s40.8-7.5 56-20.1c15.2 12.6 34.7 20.1 56 20.1s40.8-7.5 56-20.1c15.2 12.6 34.7 20.1 56 20.1 29.8 0 56.1-14.8 72-37.4M496 336v24c0 9-3 17.3-8 24-7.3 9.7-18.9 16-32 16-11.2 0-21.3-4.6-28.6-12-1.2-1.3-2.4-2.6-3.4-4-5-6.7-8-15-8-24v-24h48zm-112 0v24c0 9-3 17.3-8 24-1.1 1.4-2.2 2.8-3.4 4-7.3 7.4-17.4 12-28.6 12s-21.3-4.6-28.6-12c-1.2-1.3-2.4-2.6-3.5-4-5-6.7-8-15-8-24v-24h80zm-112 0v24c0 9-3 17.3-8 24-1.1 1.4-2.2 2.8-3.5 4-7.3 7.4-17.4 12-28.6 12s-21.3-4.6-28.6-12c-1.2-1.3-2.4-2.6-3.5-4-5-6.7-8-15-8-24v-24h80zm-112 0v24c0 9-3 17.3-8 24-1.1 1.4-2.2 2.8-3.5 4-7.3 7.4-17.4 12-28.6 12-13.1 0-24.7-6.3-32-16-5-6.7-8-15-8-24v-24h80z" })
  }
), rJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v93.4c15.9-22.6 42.2-37.4 72-37.4 15.2 0 29.5 3.9 42 10.7 16.1-21.1 41.4-34.7 70-34.7 21.3 0 40.8 7.5 56 20.1 15.2-12.6 34.7-20.1 56-20.1 31.1 0 58.5 16.2 74.1 40.5 11.5-5.5 24.3-8.5 37.9-8.5 29.8 0 56.1 14.8 72 37.4V80zm0 282.6V432h480v-69.4c-15.9 22.6-42.2 37.4-72 37.4-21.3 0-40.8-7.5-56-20.1-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1-29.8 0-56.1-14.8-72-37.4M0 32h576v448H0V80zm384 256h-80v24c0 9 3 17.3 8 24 1.1 1.4 2.2 2.8 3.5 4 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c1.2-1.3 2.4-2.6 3.4-4 5-6.7 8-15 8-24v-24zm112 0h-80v24c0 9 3 17.3 8 24 1.1 1.4 2.2 2.8 3.4 4 7.3 7.4 17.4 12 28.6 12 13.1 0 24.7-6.3 32-16 5-6.7 8-15 8-24zm-48-24h48v-32c0-5.7-1.2-11.1-3.3-16-6.2-14.1-20.3-24-36.7-24-9 0-17.3 3-24 8-5.5 4.1-9.9 9.6-12.7 16-2.1 4.9-3.3 10.3-3.3 16v32h16zm-144-64v56h80v-56c0-5.1-1-10-2.7-14.5C375.5 170.6 361 160 344 160c-11.2 0-21.3 4.6-28.6 12-7.1 7.2-11.4 17.1-11.4 28m-72-40c-15.2 0-28.4 8.5-35.2 21-3.1 5.7-4.8 12.1-4.8 19v56h80v-56c0-10.9-4.4-20.8-11.4-28-7.3-7.4-17.4-12-28.6-12zm-40 128v24c0 9 3 17.3 8 24 1.1 1.4 2.2 2.8 3.5 4 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c1.2-1.3 2.4-2.6 3.5-4 5-6.7 8-15 8-24v-24H208zm-32 0H80v24c0 9 3 17.3 8 24 7.3 9.7 18.9 16 32 16 11.2 0 21.3-4.6 28.6-12 1.2-1.3 2.4-2.6 3.5-4 5-6.7 8-15 8-24v-24zm-40-104c-16.4 0-30.5 9.9-36.7 24-2.1 4.9-3.3 10.3-3.3 16v32h80v-32c0-5.7-1.2-11.1-3.3-16-1.2-2.9-2.8-5.5-4.7-8-2.2-2.9-4.8-5.5-7.7-7.7-6.7-5.2-15.2-8.3-24.3-8.3z" })
  }
), dJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m458.5 232.4-80-138.6 48.9-28.2 80 138.6-48.9 28.2zM573 221.7l-24-41.6-80-138.5L445 0l-41.6 24-48.9 28.2-41.6 24 14 24.2L36.7 284.9l19.2 33.3L0 350.5l49.9 86.4 55.9-32.3 16.3 28.2 116-62.7L180.3 512h51.8l53.1-130.2c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2L375.9 512h51.8l-63.4-155.5c12.3-14 19.7-32.4 19.7-52.5 0-4.2-.3-8.2-.9-12.2l41.4-22.4 16.5 28.5 41.6-24 48.9-28.2 41.6-24zM140.4 368.4l-39.1-67.7 249.6-158.6 49.5 85.7-38.6 20.9C347.2 233.5 326.7 224 304 224c-44.2 0-80 35.8-80 80 0 6.2.7 12.3 2.1 18.1l-85.7 46.3zM304 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), SJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112 294.5-10.7 13.2C88 324.2 80 345.1 80 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L240 294.5V48H112v229.5zM240 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S32 447.5 32 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V256h32v66.7c18.6 6.6 32 24.4 32 45.3m224 123.9-17.8-19.8-72-80-16.1-17.8 35.7-32.1 16.1 17.8 30.1 33.5V32h48v361.5l30.2-33.5 16.1-17.8 35.7 32.1-16.1 17.8-72 80z" })
  }
), zJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112 294.5-10.7 13.2C88 324.2 80 345.1 80 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L240 294.5V48H112v229.5zM240 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S32 447.5 32 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96h32v226.7c18.6 6.6 32 24.4 32 45.3M448 20.1l17.8 19.8 72 80 16.1 17.8-35.7 32.1-16.1-17.8-30.1-33.5V480h-48V118.5L393.8 152l-16.1 17.8-35.7-32.1 16.1-17.8 72-80z" })
  }
), pJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M85.3 307.7 96 294.5V48h128v246.5l10.7 13.2C248 324.2 256 345.1 256 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3M272 0H48v277.5c-20 24.7-32 56.2-32 90.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), MJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 294.5-10.7 13.2C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5V48H96v229.5zM224 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96h32v226.8c18.6 6.6 32 24.4 32 45.3z" })
  }
), xJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 294.5-10.7 13.2C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5V48H96v229.5zM224 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V184h32v138.8c18.6 6.6 32 24.4 32 45.3z" })
  }
), HJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192M160 96v226.8c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96zM80 294.5l-10.7 13.2C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5V48H80v229.5zM208 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V0h48z" })
  }
), VJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m80 294.5-10.7 13.2C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5V48H80v229.5zM208 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V160h32v162.8c18.6 6.6 32 24.4 32 45.3zM320 32h192v48H320zm0 128h192v48H320zm32 128h160v48H352z" })
  }
), CJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192M160 256v66.8c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V256zm-80 38.5-10.7 13.2C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5V48H80v229.5zM208 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V0h48z" })
  }
), LJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 294.5-10.7 13.2C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5V48H96v229.5zM224 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V256h32v66.8c18.6 6.6 32 24.4 32 45.3z" })
  }
), BJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m357.3 307.7 10.7-13.2V48h128v246.5l10.7 13.2C520 324.2 528 345.1 528 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3M544 0H320v277.5c-20 24.7-32 56.2-32 90.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48zM432 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V256h-32v66.8c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zM288 96.9l-22.6-6.1-4.1 15.5-12.9 48.2-48.4 27.9v-55.8l35.3-35.3L246.6 80 224 57.4l-11.3 11.3L200 81.4V32h-48v49.4l-12.7-12.7L128 57.4 105.4 80l11.3 11.3 35.3 35.3v55.8l-48.3-27.9-13-48.2-4.1-15.5-30.9 8.3 4.1 15.5 4.6 17.3-15-8.7-20.8-12-24 41.6 20.8 12 15 8.7-17.3 4.6-15.4 4.2 8.3 30.9 15.4-4.2 48.2-12.9L128 224l-48.3 27.9L31.4 239 16 234.8l-8.3 30.9 15.5 4.1 17.3 4.6-15 8.7-20.8 12 24 41.6 20.8-12 15-8.7-4.6 17.3-4.1 15.5 30.9 8.3 4.1-15.5 12.9-48.2 48.3-27.8v55.8l-35.3 35.3-11.3 11.3 22.6 22.6 11.3-11.3 12.7-12.7V416h48v-49.4l12.7 12.7 11.3 11.3 22.6-22.6-11.3-11.3-35.3-35.3v-55.8l48.3 27.9 10.9 40.7c4.8-24.7 14.8-47.6 28.8-67.4v-19.1l-15.7 4.2L224 224l48.3-27.9 15.7 4.2v-68.7l-.5.3.5-1.8z" })
  }
), uJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 86.7-60.7 86.7 60.7.8-5c-4.9-16.1-7.5-33.3-7.5-51 0-37.7 11.8-72.6 32-101.2V105.3l-8-1.3L294.7 0 208 60.7 121.3 0zm104 168a64 64 0 1 0 0-128 64 64 0 1 0 0 128m0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192m181.3 195.7 10.7-13.2V48h128v246.5l10.7 13.2C552 324.2 560 345.1 560 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3M576 0H352v277.5c-20 24.7-32 56.2-32 90.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48zM464 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V96h-32v226.8c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z" })
  }
), RJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 294.5-10.7 13.2C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5V48H96v229.5zM224 0h48v277.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V0h48zm-16 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V136h32v186.8c18.6 6.6 32 24.4 32 45.3z" })
  }
), $J = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h384v48H0zm216 128h168v48H216v272h-48V208H0v-48h168z" })
  }
), kJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264c4.1 108.5 91.3 195.7 199.8 199.8m48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2s-48.3 73.2-49.3 115zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), PJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m231.9 153.9 18-15.9-31.9-35.9-17.9 15.9-32.1 28.6V0h-48v146.6l-32.1-28.5-17.9-16L38.1 138 56 153.9l72 64 16 14.2 15.9-14.2zM24 512h616v-48h-19.2L576 272 384 128 192 272l-44.8 192H0v48zm509.2-212.1L571.5 464H472l-64-128V206zM360 206v258H196.5l38.3-164.1z" })
  }
), FJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.9 52.8 101.2 72h378.4l-20.7-19.2-17.6-16.3 32.6-35.2 17.6 16.3 65.6 60.8 19.4 18-19.8 17.6-68.8 60.8-18 15.9-31.8-36 18-15.9 21.3-18.8h-374l21.3 18.8 18 15.9-31.8 36-18-15.9L24.1 114 4.2 96.4l19.4-18 65.7-60.8 17.6-16.3 32.6 35.2zM112.5 512H64l6.9-48L96 288l192-128 192 128 25.1 176 6.9 48h-48.5zM264 233.7 140.5 316l-21.2 148H264zm48 0V360l62.4 104h82.3l-21.2-148z" })
  }
), TJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.9 52.8 101.2 72H456c66.3 0 120 53.7 120 120v64h-48v-64c0-39.8-32.2-72-72-72H103.4l21.3 18.8 18 15.9-31.8 36-18-15.9L24.1 114 4.2 96.4l19.4-18 65.7-60.8 17.6-16.3 32.6 35.2zM112.5 512H64l6.9-48L96 288l192-128 192 128 25.1 176 6.9 48h-48.5zM264 233.7 140.5 316l-21.2 148H264zm48 0V360l62.4 104h82.3l-21.2-148z" })
  }
), AJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M217.9 138 200 153.9l-72 64-16 14.2-15.9-14.2-72-64-18-15.9L38 102.1 55.9 118 88 146.6V0h48v146.6l32.1-28.5 17.9-16zm352 0L552 153.9l-72 64-16 14.2-15.9-14.2-72-64-18-15.9 31.9-35.9 17.9 15.9 32.1 28.6V0h48v146.6l32.1-28.5 17.9-16zM112.5 512H64l6.9-48L96 288l192-128 192 128 25.1 176 6.9 48h-48.5zM264 233.7 140.5 316l-21.2 148H264zm48 0V360l62.4 104h82.3l-21.2-148z" })
  }
), DJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.2 512H0l4.4-48L32 160 288 0l23.3 16h.7v.5L544 176l27.4 288 4.6 48H48.2zm365.4-48h109.6l-24.9-261.1L312 74.7v204.6zM264 71.6 77.6 188.1 52.6 464H264V192z" })
  }
), yJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M591.5 352h-134l-6.9-48h134l-21.1-148L416 57.7l-143.9 95.9-30.4-20.2-12.9-8.6L416 0l192 128 25.1 176 6.9 48zm-543 160H0l6.9-48L32 288l192-128 192 128 25.1 176 6.9 48h-48.5zM200 233.7 76.5 316 55.3 464H200zm48 0V360l62.4 104h82.3l-21.2-148z" })
  }
), bJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14.3 80.2-1.9 62.5l35.4-32.4 16.2 17.7 176 192 14.9 16.2-14.9 16.2-176 192-16.2 17.7-35.4-32.4 16.2-17.7L175.4 256 14.3 80.2zM248 432h328v48H224v-48z" })
  }
), fJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v120h48V80h88v352H64v48h192v-48h-72V80h88v72h48V32h-24zm473 18.2-17-17-17 17-60.8 60.8-17 17 33.9 33.9 17-17 19.9-19.8v261.8L436.2 367l-17-17-33.9 34 17 17 60.7 60.8 17 17 17-17 60.8-60.8 17-17-33.9-33.9-17 17-19.9 19.8V125.1l19.8 19.9 17 17 33.9-34-17-17z" })
  }
), UJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v120h48V80h120v352H96v48h192v-48h-72V80h120v72h48V32h-24zm312 192h-24v96h48v-48h96v160h-56v48h160v-48h-56V272h88v48h48v-96h-24z" })
  }
), GJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-272-211.2L396.4 80h124.9l-16 64h49.5l20.5-82.2 7.4-29.8H165.3l-4.5 18.2-10.9 43.4L48.4 14.8zm142.9 111L202.7 80h143.8L308 216.4l-116.7-90.7zm57.6 299.7c-.6 2.2-.9 4.4-.9 6.5h-80v48h208v-48h-79.1l23.6-83.5-40.8-32.1z" })
  }
), qJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v104h48V80h152v160h-56v48h160v-48h-56V80h152v56h48V32h-24zm405.8 369 17-17-17-17-60.8-60.8-17-17-33.9 33.9 17 17 19.8 19.9H93.1l19.9-19.8 17-17-34-33.9-17 17L18.2 367l-17 17 17 17L79 461.8l17 17 33.9-33.9-17-17L93.1 408h261.7L335 427.8l-17 17 34 33.9 17-17z" })
  }
), WJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h448v120h-48V80H248v352h72v48H128v-48h72V80H48v72H0V56z" })
  }
), EJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M369.8 64.2c10.4-10.4 24.4-16.2 39-16.2 30.5 0 55.2 24.7 55.2 55.2 0 14.6-5.8 28.7-16.2 39L222.1 368H144v-78.1l29.7-29.7 31 31 11.3 11.4 22.6-22.6-11.3-11.3-31-31 41.4-41.4 31 31 11.3 11.3 22.6-22.6-11.3-11.3-31-31 41.4-41.4 31 31 11.3 11.3 22.6-22.6-11.3-11.3-31-31 45.5-45.5zM96 280v102.1l-77.8 77.7-17 17 33.9 33.9 17-17 77.8-77.7h112l7-7 232.9-232.8c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L103 263l-7 7z" })
  }
), OJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256M192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167 78.9 73 132.4 73 100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16m-72 216H96v48h192v-48h-24z" })
  }
), IJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M145.1 112h27.7l13.9-24c13.9-24 39.8-40 69.3-40s55.4 16 69.3 40l13.9 24H368c53 0 96 43 96 96s-43 96-96 96h-53.2l-14 13.7C289.2 329.1 273.5 336 256 336s-33.2-6.9-44.8-18.3l-14-13.7H144c-53 0-96-43-96-96s43-96 96-96zM256 0c-47.4 0-88.7 25.7-110.9 64H144C64.5 64 0 128.5 0 208s64.5 144 144 144h33.6c20.2 19.8 47.9 32 78.4 32s58.2-12.2 78.4-32H368c79.5 0 144-64.5 144-144S447.5 64 368 64h-1.1C344.7 25.7 303.4 0 256 0M104 472h80v-80h-80zM0 448v64h64v-64z" })
  }
), NJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 480h144v-57c0-30.3-5.9-59.8-16.9-87H512V208h-16v-64h-24V80h-24V32H252.6l-6 4-10.1 6.7L160 93.8v57.7l103.1-68.8 4-2.7H400v48h24v64h24v64h16v32H268.4l23.2 36.8c18.2 28.9 28.4 62.8 28.4 98.2v9h-48v-9c0-49.8-27.2-95.6-70.9-119.4l-4.6-2.5-18.6-10.1-5.4-2.9H160v48h.3l13.2 7.2 4.6 2.5c28.3 15.4 45.9 45 45.9 77.2v33zm-96-96V96H0v288z" })
  }
), XJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32h144v57c0 30.3-5.9 59.8-16.9 87H512v128h-16v64h-24v64h-24v48H252.6l-6-4-10.1-6.7-76.5-51v-57.7l103.1 68.8 4 2.7H400V384h24v-64h24v-64h16v-32H268.4l23.2-36.8C309.8 158.3 320 124.4 320 89v-9h-48v9c0 49.8-27.2 95.6-70.9 119.4l-4.6 2.5-18.6 10.1-5.4 2.9H160V176h.3l13.2-7.2 4.6-2.5C206.4 150.9 224 121.2 224 89V56zm-96 160v288H0V192z" })
  }
), KJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m264.6 218.2 17.9 13c18.8 13.8 32.7 32.1 41.9 49.6 5.1 9.7 8 17.7 9.7 23.2H216V192h-48v112H49.4c.2-1 .5-2.1.9-3.2 1.9-6.5 4.9-14.4 9.4-22.9 9-17 22.6-34.5 41.2-47.6l18.6-13 1.7-22.6L132.4 48h119.2L263 196.2l1.7 22zM216 352h168v-40c0-2.3-.2-4.9-.7-8-4.1-25.8-26-77.6-72.5-111.5L299.7 48H352V0H32v48h52.3l-11 143C26.1 224.1 4.2 275.6.6 304c-.4 2.9-.6 5.6-.6 8v40h168v160h48v-24z" })
  }
), QJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m40 108 24 144 24-144V80H40zm48-76h48v80l-32 192H24L-8 112V32h48z" })
  }
), ZJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112V64h640v144h-24c-26.5 0-48 21.5-48 48s21.5 48 48 48h24v144H0v-48zm48 288h544v-51c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93v-51H48zm384-256a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32M186.7 224 160 144h56l46.7 80H303c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.4 11.4-26.8 17.8-42.9 17.8h-40.2L216 368h-56l26.7-80H144l-24 32H88l16-64-16-64h32l24 32z" })
  }
), JJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112V64h576v144c-26.5 0-48 21.5-48 48s21.5 48 48 48v144H0V304c26.5 0 48-21.5 48-48s-21.5-48-48-48v-48zm48 60.8c28.7 16.6 48 47.6 48 83.2s-19.3 66.6-48 83.2V400h480v-60.8c-28.7-16.6-48-47.6-48-83.2s19.3-66.6 48-83.2V112H48z" })
  }
), jJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64v144c26.5 0 48 21.5 48 48s-21.5 48-48 48v144h576V304c-26.5 0-48-21.5-48-48s21.5-48 48-48V64H48zm96 192c0-35.5-19.3-66.6-48-83.2V112h480v60.8c-28.7 16.6-48 47.6-48 83.2s19.3 66.6 48 83.2V400H48v-60.8c28.7-16.6 48-47.6 48-83.2m80-48h224v96H176zm-48-48v192h320V160H176z" })
  }
), YJ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80h448v54.2c-24.1 15.7-40 42.9-40 73.8s15.9 58.1 40 73.8V336H144zm496 88V32H96v352h544V248c-22.1 0-40-17.9-40-40s17.9-40 40-40m-128-56a16 16 0 1 0-32 0 16 16 0 1 0 32 0m0 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0M264 96l26.7 80H248l-24-32h-32l16 64-16 64h32l24-32h42.7L264 320h56l46.7-80H407c16.1 0 31.5-6.4 42.8-17.7 7.9-7.9 7.9-20.7 0-28.5-11.4-11.4-26.8-17.8-42.9-17.8h-40.2L320 96zM48 120V96H0v384h544v-48H48z" })
  }
), _J = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128h147.1l7.2 8.5L323.1 336H400V168h48v216H300.9l-7.2-8.5L124.9 176H48v168H0V152z" })
  }
), hj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64v64h64V64zm64 112h-8v56h176v-56h-56V16h160v160h-56v56h162.3l-50.5-46.3-17.7-16.2 32.4-35.4 17.7 16.2 96 88 19.3 17.7-19.3 17.7-96 88-17.7 16.2-32.4-35.4 17.7-16.2 50.5-46.3H248v56h56v160H144V336h56v-56H0v-48h104v-56H48V16h160v160zm40 208h-8v64h64v-64h-8zM384 64h-64v64h64z" })
  }
), cj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64v64H96V64zm-8 112h56V16H48v160h56v56H0v48h296v56h-56v160h160V336h-56v-56h296v-48H536v-56h56V16H432v160h56v56H152zm192 208h8v64h-64v-64h8zM480 64h64v64h-64z" })
  }
), sj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-24v128h48V49.4C383.6 61.3 464 149.2 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-43.3 13.2-83.5 35.8-116.8l13.5-19.8-39.7-27-13.4 19.8C16.3 153.2 0 202.7 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0m-63 159-17-17-33.9 34 17 17 80 80 17 17 33.8-34-17-17-80-80z" })
  }
), vj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.7 385.6c15.5-29 24.3-62.2 24.3-97.6 0-114.9-93.1-208-208-208S48 173.1 48 288c0 35.4 8.8 68.5 24.3 97.6l14.3 26.9-18.3 24.4L48 464h416l-20.3-27.1-18.3-24.4zm42.4 22.6L512 448v64H0v-64l29.9-39.9C10.8 372.3 0 331.4 0 288 0 146.6 114.6 32 256 32s256 114.6 256 256c0 43.4-10.8 84.3-29.9 120.1zM376 288c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5v.9l39.2 12.8c.5-4.5.8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9v41.3c34.4-7 63.5-28.7 80.4-58.3L321 334.6zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3v-41.3zM136 288c0 4.6.3 9.2.8 13.6l39.2-12.7v-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288m120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8l22.6 31.2 1.6 2.2c8-2.7 16.6-4.2 25.6-4.2M88 288a168 168 0 1 1 336 0 168 168 0 1 1-336 0m200 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), ej = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0v54.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5 15 30.5 26.3 66.3 22 105.3-4 36.7-22.3 79.2-70.5 124.8H121.4C73.2 386.4 55 343.9 50.9 307.2c-4.3-39 7-74.8 22-105.3 7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5V0H64v54.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4-17.2 34.8-32.4 80.2-26.7 131.7 5.5 49.7 30 102.1 84.8 154.1V512h48v-32h48v32h48v-32h48v32h48v-32h48v32h48v-45.5c54.8-51.9 79.3-104.3 84.8-154.1 5.7-51.5-9.5-96.9-26.7-131.8-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5V0zM280 96h-48v160h48V120zm-48 192v48h48v-48z" })
  }
), lj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192.7 0H171l-2.2 21.6-1.9 19.3-15-12.3-16.8-13.7-15.4 15.3-89.5 89.5-15.3 15.4 13.8 16.8 12.3 15-19.3 1.9L0 171V341l21.6 2.2 19.3 1.9-12.3 15-13.7 16.8 15.4 15.4 89.5 89.5 15.4 15.4 16.8-13.8 15-12.3 1.9 19.3L171 512H341l2.2-21.6 1.9-19.3 15 12.3 16.8 13.8 15.4-15.4 89.5-89.5 15.4-15.4-13.8-16.8-12.3-15 19.3-1.9L512 341V171l-21.6-2.2-19.3-1.9 12.3-15 13.8-16.8-15.4-15.4-89.5-89.5-15.4-15.3-16.8 13.7-15 12.3-1.9-19.3L341 0h-21.7zm20.4 61.3 1.3-13.3h83.1l1.3 13.3 1.5 15.4 14.6 5c7.7 2.6 15.2 5.7 22.4 9.3l13.9 6.9 12-9.8 10.4-8.5 58.8 58.8-8.4 10.3-9.8 12 6.9 13.9c3.6 7.2 6.7 14.7 9.3 22.4l5 14.6 15.4 1.5 13.3 1.3v83.1l-13.3 1.3-15.4 1.5-5 14.6c-2.6 7.7-5.7 15.2-9.3 22.4l-6.9 13.9 9.8 12 8.5 10.4-58.8 58.8-10.4-8.4-12-9.8-13.8 6.8c-7.2 3.6-14.7 6.7-22.4 9.3l-14.6 5-1.5 15.4-1.4 13.3h-83.2l-1.3-13.3-1.5-15.4-14.6-5c-7.7-2.6-15.2-5.7-22.4-9.3l-13.9-6.9-12 9.8-10.4 8.5-58.8-58.7 8.5-10.4 9.8-12-6.8-13.8c-3.6-7.2-6.7-14.7-9.3-22.4l-5-14.6-15.4-1.5-13.3-1.4v-83.2l13.3-1.3 15.4-1.5 5-14.6c2.6-7.7 5.7-15.2 9.3-22.4l6.9-13.9-9.8-12-8.5-10.4 58.8-58.8 10.3 8.5 12 9.8 13.8-6.8c7.2-3.6 14.7-6.7 22.4-9.3l14.6-5 1.5-15.4zM384 256a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-152-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1-45.7-14.8m152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1-14.8-45.7zm-4.6 122.7a24 24 0 1 1-28.2-38.8 24 24 0 1 1 28.2 38.8m-79.3-5.3a24 24 0 1 1-38.8-28.2 24 24 0 1 1 38.8 28.2" })
  }
), tj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m336 .9 39.2 12.8c.5-4.5.8-9 .8-13.6 0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5v.9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9v41.3c34.4-7 63.5-28.7 80.4-58.3L321 302.6zM232 373.6v-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104 39.2-12.7v-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6.3 9.2.8 13.6m93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8l22.6 31.3 1.6 2.2zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0M256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336" })
  }
), wj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112H48v288h288zm48 336H0V64h576v384h-48zm0-336v288h144V112z" })
  }
), gj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 64H0v384h576zm-48 48v288H240V112z" })
  }
), ij = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 112v288H48V112zm48-48H0v384h576V112zM96 160v192h192V160z" })
  }
), mj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h480V112zM0 64h576v384H0V112zm480 96v192H288V160z" })
  }
), aj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M71 84.3C85.4 56.9 101.1 48 112 48h212.7c-3 4.5-5.7 9.3-8.2 14.1-18 34.5-28.5 80.4-28.5 129.9s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1H112c-10.9 0-26.6-8.9-41-36.3-13.8-26.4-23-64.4-23-107.7s9.2-81.3 23-107.7M400 48c10.9 0 26.6 8.9 41 36.3 13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48m64 303.1V464H208v-48h-48v96h352V192c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0H112C74.3 0 46 28.7 28.5 62.1 10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384h288c25.9 0 47.4-13.6 64-32.9M424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48 10.7 48 24 48 24-21.5 24-48" })
  }
), oj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M8 512h373.3l8.2-19.7c19-45.8 29.6-96.3 35.4-147.5 0-.2 0-.4.1-.5 5.9-51.4 6.9-103.4 6.9-152.2 0-76 26.2-138.3 59.4-143.6 1.5-.2 3.1-.4 4.6-.4 35.3 0 64 64.5 64 144s-28.7 144-64 144c-13.2 0-25.5-9-35.7-24.5-1.5 20-3.6 40.1-6.5 60.2 11.8 7.2 26 12.2 42.3 12.2 24.5 0 44.1-11.4 58-24.5 13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5 540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8.1V0H160c-53 0-96 86-96 192 0 88.5-3.8 187.7-36.1 272-.5 1.3-1 2.5-1.5 3.8zM419 48c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 93.9-4.4 191.6-34.9 272H78.9C109 374.7 112 275 112 192c0-47.2 9.7-87.5 23.1-114.3 6.7-13.4 13.4-21.6 18.6-26 2.5-2.1 4.3-3 5.2-3.4.5-.2.8-.3.9-.3H419zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48-24 21.5-24 48 10.7 48 24 48" })
  }
), nj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M60 512H8l18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192 64 86 107 0 160 0h332.2v.1c1.3-.1 2.6-.1 3.8-.1 24.5 0 44.1 11.4 58 24.5 13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1-13.9 13.2-33.5 24.5-58 24.5-16.3 0-30.5-5-42.2-12.3 2.9-20.1 5-40.2 6.5-60.2C470.5 327 482.8 336 496 336c35.3 0 64-64.5 64-144S531.3 48 496 48c-1.6 0-3.1.1-4.6.4C458.2 53.7 432 116 432 192c0 48.8-1.1 100.8-6.9 152.2l-.1.5c-5.9 51.2-16.5 101.7-35.4 147.5l-8.3 19.8zM160 48h-.3c-.2 0-.4.1-.9.3-.9.4-2.7 1.3-5.2 3.4-5.2 4.4-11.9 12.6-18.6 26-13.3 26.8-23 67.1-23 114.3 0 83-3 182.7-33.1 272h270.2c30.5-80.4 34.9-178.1 34.9-272 0-44.9 8-87.8 22.9-121.3 3.4-7.7 7.4-15.4 12.1-22.7zm360 144c0 26.5-10.7 48-24 48s-24-21.5-24-48 10.7-48 24-48 24 21.5 24 48m-204.7-4.7-72 72-11.3 11.3-11.3-11.3-40-40-11.3-11.3 22.6-22.6 11.3 11.3 28.7 28.7 60.7-60.7 11.3-11.3 22.6 22.6z" })
  }
), rj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m8 512 18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192c0-15 .9-29.6 2.5-43.6l45.6 35.9c-.1 2.5-.1 5.1-.1 7.7 0 83-3 182.7-33.1 272h270.2c9.1-24.1 15.9-49.8 21-76.4l42.1 33.1c-5.8 24.7-13.1 48.7-22.6 71.5l-8.3 19.8H60zm511.3-131.6 101.6 78.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 46.5 36.1C112 19.3 134.9 0 160 0h332.2v.1c1.3-.1 2.5-.1 3.8-.1 24.5 0 44.1 11.4 58 24.5 13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1-9.1 8.7-20.8 16.6-34.7 21zM462.1 336H496c35.3 0 64-64.5 64-144S531.3 48 496 48c-1.6 0-3.1.1-4.6.4C458.2 53.7 432 116 432 192c0 37.9-.7 77.8-3.7 117.8zm-79.8-61.9c1.3-27.3 1.6-54.9 1.6-82.1 0-44.9 8-87.8 22.9-121.3 3.5-7.7 7.5-15.4 12.2-22.7H159.7c-.2 0-.4.1-.9.3-.9.4-2.7 1.3-5.2 3.4-5.2 4.4-11.9 12.6-18.6 26-.5 1-1 2.1-1.5 3.2l248.9 193.2zM496 240c-13.3 0-24-21.5-24-48s10.7-48 24-48 24 21.5 24 48-10.7 48-24 48" })
  }
), dj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 512h48-352v-96h48v48h195.1zm48-87.6 44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L97.6 53C115.3 23.7 141.8 0 176 0h288c37.7 0 66 28.7 83.5 62.1 18 34.5 28.5 80.4 28.5 129.9zM135.9 82.7l222 172.4c-3.8-19.9-5.9-41.1-5.9-63.1 0-49.5 10.5-95.4 28.5-129.9 2.5-4.8 5.3-9.5 8.2-14.1H176c-10.7 0-26 8.5-40.1 34.7zM462 335.9c.7.1 1.4.1 2 .1 10.9 0 26.6-8.9 41-36.3 13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C490.6 56.9 474.9 48 464 48s-26.6 8.9-41 36.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c2.1 4.1 4.3 7.7 6.5 11zm44.6 34.6 21.4 16.7v-36.1c-6.4 7.5-13.6 14.1-21.4 19.4M64 192c0-14.9.9-29.4 2.8-43.4l45.3 35.7c-.1 2.5-.1 5.1-.1 7.7 0 43.3 9.2 81.3 23 107.7 14.4 27.5 30.1 36.3 41 36.3h128.6l60.9 48H176c-37.7 0-66-28.7-83.5-62.1C74.5 287.4 64 241.5 64 192m424 0c0 26.5-10.7 48-24 48s-24-21.5-24-48 10.7-48 24-48 24 21.5 24 48" })
  }
), Sj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 192c0 43.3 9.2 81.3 23 107.7 14.4 27.5 30.1 36.3 41 36.3h212.7c-3-4.5-5.7-9.3-8.2-14.1-18-34.5-28.5-80.4-28.5-129.9s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3-13.8 26.4-23 64.4-23 107.7M359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3M464 464V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0h288c37.7 0 66 28.7 83.5 62.1 18 34.5 28.5 80.4 28.5 129.9v320H160v-96h48v48zm-64-224c-13.3 0-24-21.5-24-48s10.7-48 24-48 24 21.5 24 48-10.7 48-24 48m-288-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), zj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 192c0 43.3 9.2 81.3 23 107.7 14.4 27.5 30.1 36.3 41 36.3h212.7c-3-4.5-5.7-9.3-8.2-14.1-18-34.5-28.5-80.4-28.5-129.9s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3-13.8 26.4-23 64.4-23 107.7M359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3M464 464V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0h288c37.7 0 66 28.7 83.5 62.1 18 34.5 28.5 80.4 28.5 129.9v320H160v-96h48v48zm-64-224c-13.3 0-24-21.5-24-48s10.7-48 24-48 24 21.5 24 48-10.7 48-24 48m-153.4-96-11.3 11.3-36.7 36.7 36.7 36.7 11.3 11.3-22.6 22.6-11.3-11.3-36.7-36.7-36.7 36.7-11.3 11.3-22.6-22.6 11.3-11.3 36.7-36.7-36.7-36.7-11.3-11.3 22.6-22.6 11.3 11.3 36.7 36.7 36.7-36.7 11.3-11.3z" })
  }
), pj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M60 512H8l18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192 64 86 107 0 160 0h332.2v.1c1.3-.1 2.6-.1 3.8-.1 24.5 0 44.1 11.4 58 24.5 13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1-13.9 13.2-33.5 24.5-58 24.5-16.3 0-30.5-5-42.2-12.3 2.9-20.1 5-40.2 6.5-60.2C470.5 327 482.8 336 496 336c35.3 0 64-64.5 64-144S531.3 48 496 48c-1.6 0-3.1.1-4.6.4C458.2 53.7 432 116 432 192c0 48.8-1.1 100.8-6.9 152.2l-.1.5c-5.9 51.2-16.5 101.7-35.4 147.5l-8.3 19.8zM160 48h-.3c-.2 0-.4.1-.9.3-.9.4-2.7 1.3-5.2 3.4-5.2 4.4-11.9 12.6-18.6 26-13.3 26.8-23 67.1-23 114.3 0 83-3 182.7-33.1 272h270.2c30.5-80.4 34.9-178.1 34.9-272 0-44.9 8-87.8 22.9-121.3 3.4-7.7 7.4-15.4 12.1-22.7zm360 144c0 26.5-10.7 48-24 48s-24-21.5-24-48 10.7-48 24-48 24 21.5 24 48m-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), Mj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0H0v512h48v-32h224v32h48V0h-24zm248 432H48V144h224v80h-48v96h48zM48 96V48h224v48z" })
  }
), xj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v48h448V0H24zm81.6 182.9-1.6.5V80H32v127.1l-.4.4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3.9.5 1.7 1.1 2.6 1.6L75.3 464 64 512h320l-11.3-48-13.7-58.1c.9-.5 1.7-1 2.6-1.6 45-28.1 78.4-75.6 78.4-148.3 0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80h-48v103.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9m51.9 243.2c31.3 10.3 63.4 13.9 90.5 13.9s59.2-3.6 90.5-13.9l8.9 37.9H124.6zm-21.7-62.5c-14.7-9.2-27.8-21.2-37.6-36.9 2.4.8 4.9 1.5 7.4 2.3 38 11 88.7 15 142.4 15s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3zM385.4 268c-6.1 5.1-16.5 10.4-32.2 15-31.5 9-76.8 13-129.2 13s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15-5.4-4.6-6.6-8.2-6.6-12s1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15 5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Hj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h256v512h-48v-32H48v32H0V24zm208 320h-48v-96h48v-80H48v288h160zm0-224V48H48v48zM320 0h256v512h-48v-32H368v32h-48V24zm208 320h-48v-96h48v-80H368v288h160zm0-224V48H368v48z" })
  }
), Vj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M235.4 1.4 250.6 20 232 35.2 250.6 20l.1.1.1.2.4.5c.3.4.8 1 1.3 1.7 1.1 1.4 2.5 3.4 4.3 6 3.4 5 8 12.2 12.5 21s9.3 19.5 12.8 31.7c82.8 7.3 142.4 46.8 142.4 46.8L368 144l16 48-128-48-128 48 16-48-56.5-16s60.3-39.9 143.7-46.9c-1.4-3.3-2.9-6.5-4.5-9.6-3.5-6.7-6.9-12.2-9.5-15.9-1.3-1.9-2.3-3.3-3-4.2-.3-.4-.6-.8-.7-.9l-.1-.2-15.2-18.5 37.2-30.4zM0 304c0-62.4 26.1-112.6 68.7-148.1l10.1 2.9 24.3 6.9-5.4 16.2-5.9 17.8C64.2 225.7 48 260.4 48 304c0 49.8 21.1 88 56.2 115 36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115 0-43.6-16.2-78.3-43.7-104.3l-5.9-17.8-5.4-16.2 24.3-6.9 10.1-2.8c42.5 35.4 68.6 85.6 68.6 148 0 130.9-114.6 208-256 208S0 434.9 0 304" })
  }
), Cj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 192v240h48V192C416 86 330 0 224 0S32 86 32 192v240h48V192c0-79.5 64.5-144 144-144s144 64.5 144 144M24 464H0v48h448v-48h-24z" })
  }
), Lj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 432V192c0-79.5-64.5-144-144-144S80 112.5 80 192v240H32V192C32 86 118 0 224 0s192 86 192 192v240zM0 464h448v48H0zm248-312v40h72v48h-72v144h-48V240h-72v-48h72v-64h48z" })
  }
), Bj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h256v96h48l80 80v272H0V208l80-80h48V56zM48 344v88h416v-88h-96v40h-48v-40H192v40h-48v-40zm416-48v-68.1L412.1 176H99.9L48 227.9V296h96v-40h48v40h128v-40h48v40zM336 80H176v48h160z" })
  }
), uj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 143.3c0 12.5 2.9 24.9 8.5 36.1l28.9 57.9 1.5 3 .6 3.2L139.8 432h1.9l35.1-126.4 4.9-17.6h84.5l4.9 17.6L306.2 432h1.9l36.3-188.5.6-3.2 1.5-3 26.9-53.8c6.9-13.9 10.6-29.2 10.6-44.8 0-32.4-26.3-58.7-58.7-58.7h-10.7c-16.6 0-32.6 5.9-45.2 16.7l-7 6 8.1 6 19.2 14.4-28.8 38.4-19.2-14.4-16.7-12.3-15.4-11.6-32-24-8-6C158.2 84.6 144.3 80 130 80h-2.7c-35 0-63.3 28.3-63.3 63.3m159-70 15.1-13C259.4 42 286.5 32 314.6 32h10.7C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2L391 255.7l-39.4 204.8-3.8 19.5h-78l-4.9-17.6L229.8 336h-11.6l-35.1 126.4-4.9 17.6h-78l-3.7-19.5-39.4-204.7-27.5-55C20.7 183 16 163.3 16 143.3 16 81.8 65.8 32 127.3 32h2.7c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z" })
  }
), Rj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 160c0-8.8 7.2-16 16-16h224c16.6 0 33.4-3.7 48.3-13.4 15-9.8 24.3-23.1 29.8-35.8 1-2.2 1.8-4.5 2.6-6.7 4.9 2.1 9.4 4.5 13.2 7.2 12 8.3 18 18.5 18 32.8 0 26.5-21.5 48-48 48H48zM376 39.5c-15.4-5-31.9-7.5-48-7.5 0 30.8-2.3 64-40 64H64c-35.3 0-64 28.7-64 64v64h352c53 0 96-43 96-96 0-46.4-32.5-75.7-72-88.5M80 280v-24H32v176H0v48h576v-48H400V256h-48v176h-32V256h-48v176h-32V256h-48v176h-32V256h-48v176H80z" })
  }
), $j = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 80h7.8l7.4-2.5L464 66.6V104l-32 24H80l-32-24V66.6l32.8 10.9 7.4 2.5H96zm-184 96v64H112v-64zM64 288v224h48V288h288v224h48V288h64v-48h-64v-64l64-48V0l-48 16-48 16H96L48 16 0 0v128l64 48v64H0v48h24zm336-48H280v-64h120z" })
  }
), kj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 45.6V48c.8 89.8 48.7 172.7 126.2 218.2l116.4 68.5c19.2 11.3 34.7 27.9 44.6 47.8 9.2 18.4 13.3 38.8 11.9 59.1-.3 3.8-.7 7.6-1.3 11.4l-9.8 59 56.1-44.9 52.2-41.8C429 399.2 448 359.7 448 317.9c0-29.8-9.7-58.7-27.5-82.6l-55.6-74.2c-8.4-11.1-12.9-24.6-12.9-38.5 0-17 6.8-33.4 18.8-45.4L400 48l16-16V0H0zM330.2 361c-11.2-22.5-27.5-42-47.3-57h116c.7 4.6 1.1 9.2 1.1 13.9 0 27.2-12.4 53-33.6 70l-21.6 17.2c-2.7-15.2-7.6-30.1-14.6-44zM203.5 256l-52.9-31.1c-22-12.9-41.1-29.6-56.6-48.9h223.5c2.6 4.8 5.6 9.5 8.9 13.9L376 256zM65 128c-10.7-24.9-16.7-52-17-80h284.4C314.2 68.5 304 95 304 122.6c0 1.8 0 3.6.1 5.4z" })
  }
), Pj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 128c0-38.2-8.9-74.3-24.8-106.3l43-21.3C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-43-21.3c15.9-32 24.8-68.1 24.8-106.3zm-480 0c0 38.2 8.9 74.3 24.8 106.3l-43 21.3C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7.5l43 21.3C56.9 53.7 48 89.8 48 128m64 0c0-28 6.5-54.5 18.2-77.9l43 21.3c-8.4 17-13.2 36.2-13.2 56.6s4.8 39.6 13.2 56.7l-43 21.3c-11.7-23.5-18.2-50-18.2-78m352 0c0 28-6.5 54.5-18.2 77.9l-43-21.3c8.5-17.1 13.2-36.3 13.2-56.7s-4.8-39.6-13.2-56.7l43-21.3C457.5 73.5 464 100 464 128m-112 0c0 26.9-16.5 49.9-40 59.3V512h-48V187.3c-23.5-9.5-40-32.5-40-59.3 0-35.3 28.7-64 64-64s64 28.7 64 64" })
  }
), Fj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 128c0-38.6 9.1-75.1 25.3-107.4L32 0 17.4 29.2C6.1 60 0 93.3 0 128s6.1 68 17.4 98.8L32 256l41.3-20.6C57.1 203.1 48 166.6 48 128m56 0c0 29.6 7 57.5 19.4 82.3l42.9-21.5c-9.2-18.3-14.3-39-14.3-60.8s5.2-42.5 14.3-60.8l-42.9-21.5C111 70.5 104 98.4 104 128m348.6-82.3-42.9 21.5c9.2 18.3 14.3 39 14.3 60.8s-5.2 42.5-14.3 60.8l42.9 21.5C465 185.5 472 157.6 472 128s-7-57.5-19.4-82.3M528 128c0 38.6-9.1 75.1-25.3 107.4L544 256l14.6-29.2C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0l-41.3 20.6C518.9 52.9 528 89.4 528 128m-32 384L336.9 169.3c9.4-11.1 15.1-25.6 15.1-41.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.7 5.7 30.2 15.1 41.3L80 512h52.9l37.1-80h235.9l37.1 80zM288 192c2.1 0 4.3-.1 6.4-.3l44.7 96.3H236.9l44.7-96.3c2.1.2 4.2.3 6.4.3m-95.7 192 23.7-50.9v2.9h145.4l22.3 48z" })
  }
), Tj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h128v48h-40v48h72v32h120.3l-9.3 30.9L387.5 304H416v48h-48v160h-48V352H128v160H80V352H32v-48h28.5L17 158.9 7.7 128H128V96h72V48h-40zm177.3 304 38.4-128H320v128zm-65.3 0V176h-96v128zm-144 0V176H72.3l38.4 128z" })
  }
), Aj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 .8 10 4.6 168 76.8 21.8 10-20 43.7-19.8-9.2V256h-45l34.7 208H512v48H0v-48h106.3L141 256H96V126.7l-19.8 9.1-20-43.7L78 82.2 246 5.4l10-4.6zm0 52.8-112 51.2V128h224v-23.2zM144 176v32h224v-32zm186.8 288L256 400.7 181.2 464zM185.9 278.5l70.1 59.3 70.1-59.3-3.8-22.5H189.7l-3.7 22.5zm-9.2 55.1-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6 55.9 47.3-13.8-83-42.1 35.6z" })
  }
), Dj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h208.2l6 15.1 58 144.9H480V82.3l2.5-5.1 16-32 10.7-21.5 42.9 21.5-10.6 21.5-13.5 27V160h112v123.7l-9.2 7.2-39.6 31.1c-16.2-10.1-35-16.4-55.1-17.7l55.9-44V208H296.9l37.5 37.5-28.4 28.4c2.2 4.6 4.1 9.3 5.8 14.1H352v48h94.4c-14.1 13.1-25 29.5-31.6 48h-103c-1.7 4.8-3.7 9.5-5.8 14.1l28.4 28.4-67.9 67.9-28.4-28.4c-4.6 2.2-9.3 4.1-14.1 5.8V512h-96v-40.2c-4.8-1.7-9.5-3.7-14.1-5.8l-28.4 28.4-67.9-67.9L46 398.1c-2.2-4.6-4.1-9.3-5.8-14.1H0v-96h40.2c1.7-4.8 3.7-9.5 5.8-14.1l-28.4-28.4 67.9-67.9L96 188.1V24zm175.8 48H144v112h172.6zM176 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160m352 48a40 40 0 1 0 0-80 40 40 0 1 0 0 80m0-128a88 88 0 1 1 0 176 88 88 0 1 1 0-176" })
  }
), yj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96h256v48H152v272h-48V144H0zm288 24V96h36.2l7.2 9.8L464 287.3l132.6-181.5 7.2-9.8H640v320h-48V193.5L483.4 342.2 464 368.7l-19.4-26.5L336 193.5V416h-48v-24z" })
  }
), bj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M223.9 0h64.2l6.1 15 182.7 449H512v48H0v-48h35.1L217.8 15zM386 368H126l-39.1 96h338.2l-39-96zm-19.5-48-45.6-112H191.1l-45.6 112zM210.6 160h90.8L256 48.4z" })
  }
), fj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v304c0 61.9 50.1 112 112 112s112-50.1 112-112V48zM0 0h320v352c0 88.4-71.6 160-160 160S0 440.4 0 352V48zm160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96m0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96m-16-168a16 16 0 1 0 32 0 16 16 0 1 0-32 0m64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), Uj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v304c0 61.9 50.1 112 112 112s112-50.1 112-112V48zM0 0h320v352c0 88.4-71.6 160-160 160S0 440.4 0 352V48zm144 376a16 16 0 1 0 32 0 16 16 0 1 0-32 0m64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0m0-120a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-64-120a16 16 0 1 0 32 0 16 16 0 1 0-32 0m64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), Gj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v304c0 61.9 50.1 112 112 112s112-50.1 112-112V48zM0 0h320v352c0 88.4-71.6 160-160 160S0 440.4 0 352V48zm144 376a16 16 0 1 0 32 0 16 16 0 1 0-32 0m64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-48-136a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96m0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96" })
  }
), qj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v304c0 61.9 50.1 112 112 112s112-50.1 112-112V48zM0 0h320v352c0 88.4-71.6 160-160 160S0 440.4 0 352V48zm160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96m48-168a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96" })
  }
), Wj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h560v304h80v48H288c0 53-43 96-96 96s-96-43-96-96H0V56zm108.8 304c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H512V80H48v256zM160 112v144h-48V112zm96 0v144h-48V112zm96 0v192h-48V112zm96 0v192h-48V112zM240 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Ej = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256v256H0V256C0 114.6 114.6 0 256 0s256 114.6 256 256v256h-48V256c0-114.9-93.1-208-208-208m-96 144v64h192v-64zm0 112v96h192v-96zm-48-160h288v304h-46.1l47 47 17 17h-67.8l-64-64h-60.2l-64 64H94.1l17-17 47-47H112V192zm64 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0m136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Oj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v160h152V48zm200 160h152V48H248zM48 256v144h352V256zM0 0h448v448h-62.1l47 47 17 17h-67.8l-64-64H129.9l-64 64H-1.9l17-17 47-47H0V48zm96 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ij = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392.9 32h-51l23 64H211.1l23-64h-51l-23 64H88v48h54.8L114 224H48v48h48.7l-28.8 80H8v48h42.7l-28.8 80h51l28.8-80h372.6l28.8 80h51l-28.8-80H568v-48h-59.9l-28.8-80H528v-48h-66l-28.8-80H488V96h-72.1zm-10.7 112 28.8 80H165l28.8-80zm46.1 128 28.8 80H118.9l28.8-80z" })
  }
), Nj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.3 0h321.4l6.7 5.6 48 40-30.8 36.8L367.3 48H248v48h136v352h-30.1l47 47 17 17h-67.8l-64-64H161.9l-64 64H30.1l17-17 47-47H64V96h136V48H80.7L39.4 82.4 8.6 45.6l48-40zM336 144H112v96h224zM112 400h224V288H112zm48-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Xj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208v256h48V256C512 114.6 397.4 0 256 0S0 114.6 0 256v256h48v-24zm304 0H160v-64h192zM160 400v-96h192v96zm0-256h-48v304h46l-47 47-17 17h67.9l64-64H286l64 64h67.9l-17-17-47-47H400V144h-48zm128 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Kj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v144h352V48zm0 192v160h352V240zM0 0h448v448h-62.1l47 47 17 17h-67.8l-64-64H129.9l-64 64H-1.9l17-17 47-47H0V48zm184 320a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), Qj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0H88v32H48v32h128V32h-40v-8zm160 0h-48v32h-40v32h128V32h-40v-8zM64 96H48v32h128V96h-16zm160 0h-16v32h128V96h-16zM24 160H0v48h32v256H0v48h384v-48h-32V208h32v-48H56zm56 304V208h224v256zm96-112-24 80h24l96-88v-24h-64l24-80h-24l-96 88v24z" })
  }
), Zj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0H0v128h48V81.9L78.1 112l-7 7-17 17L88 169.9l17-17 7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2V432h-40v48h40v32h48v-32h40v-48h-40v-17.8c77-11.6 136-78 136-158.2 0-35.5-11.6-68.3-31.2-94.9L464 81.9V128h48V0H384v48h46.1l-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7 17-17L136 54.1 119 71l-7 7-30.1-30H128zm128 368c-61.9 0-112-50.1-112-112 0-28.3 10.5-54.2 27.8-73.9l10.3-10.3c19.7-17.3 45.6-27.8 73.9-27.8s54.2 10.5 73.9 27.8l10.3 10.3c17.3 19.7 27.8 45.6 27.8 73.9 0 61.9-50.1 112-112 112" })
  }
), Jj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-12l-7.2 9.7-83.3 112L88 268.9l38.5 28.7 14.3-19.3 51.2-68.7V288h48V176h32v112h48v-78.4l51.1 68.7 14.3 19.3 38.6-28.7-14.3-19.3-83.3-112-7.2-9.7H204.9zM480 160l-16-32-16 32-32 16 32 16 16 32 16-32 32-16zM64 352l-16-32-16 32-32 16 32 16 16 32 16-32 32-16zm56 112H96v48h320v-48h-24zm56-144h-16v32h192v-32h-16zm0 64h-16v32h192v-32h-16z" })
  }
), jj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32 48 0 32 32 0 48l32 16 16 32 16-32 32-16zm416 320-16-32-16 32-32 16 32 16 16 32 16-32 32-16zM120 464H96v48h320v-48h-24zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-51.1 32h-12l-7.2 9.7-64.3 86.3H240v-48h32v48h118.5l-64.2-86.3-7.2-9.7H204.9zM112 256H96v32h320v-32h-16zm64 64h-16v32h192v-32h-16zm0 64h-16v32h192v-32h-16z" })
  }
), Yj = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 32 464 0l-16 32-32 16 32 16 16 32 16-32 32-16zM64 128 48 96l-16 32-32 16 32 16 16 32 16-32 32-16zm56 336H96v48h320v-48h-24zM304 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-128 80h-16v32h192v-32h-16zm-32 64h-16v32h256v-32h-16zm-32 64H96v32h320v-32h-16zm64 64h-16v32h192v-32h-16zm0 64h-16v32h192v-32h-16z" })
  }
), _j = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h80v32h-96V0zm0 64h80v32h-96V64zm-48 64h176v32H160v-32zm-32 64h240v32H128v-32zm-32 64h304v32H96v-32zm64 64h176v32H160v-32zm0 64h176v32H160v-32zm288-256 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM48 352l16 32 32 16-32 16-16 32-16-32-32-16 32-16zm48 112h320v48H96z" })
  }
), hY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m464 0 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM48 128l16 32 32 16-32 16-16 32-16-32-32-16 32-16zm48 336h320v48H96zM224 0h80v32h-96V0zm-48 128h176v32H160v-32zm-64 128h304v32H96v-32zm64 128h176v32H160v-32z" })
  }
), cY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 0 16 32 32 16-32 16-16 32-16-32L0 48l32-16zm416 352 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM96 464h320v48H96zM224 0h80v32h-96V0zM112 256h304v32H96v-32z" })
  }
), sY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m480 64-16-32-16 32-32 16 32 16 16 32 16-32 32-16zM64 288l-16-32-16 32-32 16 32 16 16 32 16-32 32-16zm56 176H96v48h320v-48h-24z" })
  }
), vY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 464h320v48H96z" })
  }
), eY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m464 0 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM48 64l16 32 32 16-32 16-16 32-16-32-32-16 32-16zm48 400h320v48H96zM208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-15.1 80H319.2l7.2 9.7 83.3 112 14.3 19.2-38.5 28.7-14.3-19.3-51.2-68.7V432h-48V320h-32v112h-48V209.6l-51.1 68.7-14.3 19.3L88 268.9l14.3-19.3 83.3-112 7.2-9.7zM240 272h32v-96h-32z" })
  }
), lY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h320l28.4-384H448V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM108.6 464 83.7 128h280.6l-24.9 336zm129.5-270.1L224 179.7l-14.1 14.1-64 64-14.2 14.2 28.3 28.3 14.1-14.1 29.9-29.9V404h40V256.3l29.9 29.9 14.1 14.1 28.3-28.3-14.1-14.1-64-64z" })
  }
), tY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm144-297.9-17 17-80 80-17 17 34 33.8 17-17 39-39V416h48V257.9l39 39 17 17 33.9-33.9-17-17-80-80-17-17z" })
  }
), wY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm257-223 17-17-34-33.9-17 17-111 111-47-47-17-17L94.1 288l17 17 64 64 17 17 17-17z" })
  }
), gY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h298.8c-18.3-12.9-34.1-29.2-46.3-48H80V128h288v76c15.1-5.9 31.2-9.8 48-11.3V128h32V80h-93.8L308 10.7 300.8 0H288zm128 266.8c9.1-12.9 19.9-24.5 32-34.6V176h-32v16zM296.5 80h-145l21.3-32h102.4zM160 192v-16h-32v240h32v-16zm80 0v-16h-32v240h32v-16zm336 176a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-128-80v64h48v32h-80v-96z" })
  }
), iY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M131.2 0H284.8l7.2 10.7L338.2 80H416v48h-32v384H32V128H0V80h77.8L124 10.7zm4.4 80h145l-21.4-32H156.8l-21.3 32zM80 128v336h256V128zm96 48v240h-32V176zm96 0v240h-32V176zm368-48v48H448v-48zm-32 128v48H448v-48zM448 384h96v48h-96z" })
  }
), mY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm120-64h48v-88h88v-48h-88v-88h-48v88h-88v48h88v64z" })
  }
), aY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.2 0H396.8l7.2 10.7L450.2 80H544v48h-32v246.7l108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 84 65.2H189.8L236 10.7zm-49 128L304 213.2V176h32v62.1l48 37.3V176h32v124.2l48 37.3V128zM128 196.9l48 37.8V464h288v-2.4l48 37.8V512H128V196.9zm96 75.6 32 25.2V416h-32v-16zm80 63 32 25.2V416h-32v-16zM247.5 80h145l-21.3-32H268.8z" })
  }
), oY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm161.9-254L210 174.1 192.1 190l-72 64-20.2 18 20.2 17.9 72 64 17.9 16 31.9-35.9-17.9-15.9-24.9-22.1H240c22.1 0 40 17.9 40 40v48h48v-48c0-48.6-39.4-88-88-88h-40.9l24.8-22.1z" })
  }
), nY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm241.9-240L288 190.1l-17 17-47 47-47-47-17-17-33.9 33.9 17 17 47 47-47 47-17 17 33.9 33.9 17-17 47-47 47 47 17 17 33.9-33.9-17-17-47-47 47-47z" })
  }
), rY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h32v384h384V128h32V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM80 464V128h288v336zm80-272v-16h-32v240h32v-16zm80 0v-16h-32v240h32v-16zm80 0v-16h-32v240h32v-16z" })
  }
), dY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h320l28.4-384H448V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM108.6 464 83.7 128h280.6l-24.9 336zm209.5-217.9 14.2-14.1-28.3-28.3-14.1 14.1-89.9 89.9-25.9-25.9-14.1-14.1-28.3 28.3 14.1 14.1 40 40 14.2 14.2 14.1-14.1 104-104z" })
  }
), SY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.2 0H300.8l7.2 10.7L354.2 80H448v48h-35.6l-4.9 65.7c-17.3 2.4-33.9 7.3-49.2 14.4l5.9-80.1h-33l-1.9 1.3-.9-1.3h-209l-.9 1.3-1.9-1.3h-33l24.9 336h176c12.3 18.8 28 35.1 46.3 48H64L35.6 128H0V80h93.8L140 10.7zm4.4 80h145l-21.4-32H172.8l-21.3 32zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m160-80h-32v96h80v-32h-48v-48z" })
  }
), zY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h288l28.4-384H416V80h-93.8L276 10.7 268.8 0H256zm104.5 80h-113l21.3-32h70.3l21.3 32zM108.6 464 83.7 128h212.8l.9 1.3 1.9-1.3h33l-24.9 336zM640 128H448v48h192zm-32 128H448v48h160zM448 384v48h96v-48z" })
  }
), pY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h320l28.4-384H448V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM108.6 464 83.7 128h280.6l-24.9 336zm95.3-67.9h40.2v-88h88v-40.2h-88v-88h-40.2v88h-88v40.2h88V376z" })
  }
), MY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.2 0H396.8l7.2 10.7L450.2 80H544v48h-35.6l-17 230.7 129.5 100.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 84 65.2h57.5L236 10.7zm-49 128 251.6 195.4L460.3 128zm243 312.4 45.5 35.8L480 512H160l-22.8-307.9 51.1 40.3L204.6 464h230.8l1.7-23.6zM247.5 80h145l-21.3-32H268.8z" })
  }
), xY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h320l28.4-384H448V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM108.6 464 83.7 128h280.6l-24.9 336zm135.6-254.3-26.6-29.9-14.9 13.3-72 64-16.8 14.9 16.8 14.9 72 64 14.9 13.3 26.6-29.9-14.9-13.3-32.7-29H240c24.3 0 44 19.7 44 44v44h40v-44c0-46.4-37.6-84-84-84h-43.4l32.7-29.1 14.9-13.3z" })
  }
), HY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h-12.8L140 10.7 93.8 80H0v48h35.6L64 512h320l28.4-384H448V80h-93.8L308 10.7 300.8 0H288zm136.5 80h-145l21.3-32h102.4zM108.6 464 83.7 128h280.6l-24.9 336zm207.7-240L288 195.7l-14.1 14.1-49.9 49.9-49.9-49.9-14.1-14.1-28.3 28.3 14.1 14.1 49.9 49.9-49.9 49.9-14.1 14.1 28.3 28.3 14.1-14.1 49.9-49.9 49.9 49.9 14.1 14.1 28.3-28.3-14.1-14.1-49.9-49.9 49.9-49.9z" })
  }
), VY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.2 0H300.8l7.2 10.7L354.2 80H448v48h-35.6L384 512H64L35.6 128H0V80h93.8L140 10.7zm4.4 80h145l-21.4-32H172.8l-21.3 32zm-67.9 48 24.9 336h230.8l24.9-336H83.7z" })
  }
), CY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 80h256v160h-64v-48H224v48h-64zM48 160c0-38.7 27.5-71 64-78.4V240H48zm0 272V288h64v144zm368 0H160V288h64v64h128v-64h64zm112 0h-64V288h64zm0-272v80h-64V81.6c36.5 7.4 64 39.7 64 78.4M128 32C57.3 32 0 89.3 0 160v320h576V160c0-70.7-57.3-128-128-128zm176 224v48h-32v-64h32z" })
  }
), LY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m144 81.3 53.3-28L224 0l26.7 53.3L304 80l-53.3 26.7L224 160l-26.7-53.3zM35.4 304l127.4-178.3 10.8 5.2 18.3 36.6L94.4 304h72.2l-45.9 73.4L66.6 464h314.8l-54.1-86.6-45.9-73.4h72.2l-97.5-136.5 18.5-36.9 10.4-5.2L412.6 304l11.4 16v32h-56l30 48 40 64 10 16v32H0v-32l10-16 40-64 30-48H24v-32zM176 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0m88 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), BY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0h-24v512h48V48h128v192h128v272h48V192h-48V96h-48v96h-32V0h-24zm56 80v64h64V80zm64 96h-64v64h64zm-64 96v64h64v-64zm192 0h-64v64h64zm-64 96v64h64v-64zM222 176c1-5 2-10 2-16 0-53-43-96-96-96-54 0-96 43-96 96 0 6 0 11 1 16-20 14-33 38-33 64v80h96v192h64V320h96v-80c0-26-14-50-34-64" })
  }
), uY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m185.9 103.6-5.5 23.5-23.4-5.6c-4.1-1-8.5-1.5-13-1.5-30.9 0-56 25.1-56 56 0 5.4.8 10.6 2.2 15.4l5.8 20.1-19.3 8.5c-17 7.4-28.7 24.4-28.7 44v72h184V128h48v208h184v-72c0-19.6-11.8-36.5-28.7-44l-19.2-8.4 5.8-20.1c1.4-4.9 2.2-10.1 2.2-15.4 0-30.9-25.1-56-56-56-4.5 0-8.8.5-13 1.5l-23.4 5.5-5.5-23.5C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6M232 384H0V264c0-32.3 16-60.9 40.4-78.3-.3-3.2-.4-6.4-.4-9.7 0-57.4 46.6-104 104-104h2c18.5-42.4 60.8-72 110-72s91.5 29.6 110 72h2c57.4 0 104 46.6 104 104 0 3.3-.2 6.5-.4 9.7 24.4 17.4 40.4 46 40.4 78.3v120H280v128h-48v-24z" })
  }
), RY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392 208.6V192l-14-16L255.9 36.4 224 0l-31.9 36.4L70 176l-14 16v32h48l-34.3 48-34.3 48L24 336v32h56l-34.3 48-34.3 48L0 480v32h448v-32l-11.4-16-34.3-48-34.3-48h56v-32l-11.4-16-34.3-48-34.3-48h48zM314.2 176h-63.5l54.2 75.9 48.7 68.1h-78.9l54.2 75.9 48.7 68.1H70.4l48.6-68.1 54.3-75.9H94.4l48.6-68.1 54.3-75.9h-63.5L224 72.9zM224 280a24 24 0 1 0-48 0 24 24 0 1 0 48 0m64 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), $Y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392 208.6V192l-14-16L255.9 36.4 224 0l-31.9 36.4L70 176l-14 16v32h48l-34.3 48-34.3 48L24 336v32h56l-34.3 48-34.3 48L0 480v32h448v-32l-11.4-16-34.3-48-34.3-48h56v-32l-11.4-16-34.3-48-34.3-48h48zM314.2 176h-63.5l54.2 75.9 48.7 68.1h-78.9l54.2 75.9 48.7 68.1H70.4l48.6-68.1 54.3-75.9H94.4l48.6-68.1 54.3-75.9h-63.5L224 72.9z" })
  }
), kY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 80 37.2 61.9c-4 3.5-8 7.2-12 11.2-79.3 79.2-56.6 169.7-22.7 203.7L236 219.3c2.7 10.6 4.8 23.2 6.1 38 4.3 49.9-1.7 123.4-33 223.6l-9.7 31.1H373.2l2.6-21c8.4-66.9 4.1-139.4-8.2-205.4-6.2-32.9-14.5-64.7-24.5-93.6h108.1l28.8-48 28.8 48H576c0-48-48-128-160-128-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0 48 0 0 80 0 128h67.2zm196 112c11.5 29.9 21.3 64.8 28.4 102.4 10.3 55 14.5 114.3 9.9 169.6h-66.2c24.9-89.5 30.3-159.2 25.8-210.9-2.1-24-6.3-44.4-11.9-61.1z" })
  }
), PY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392 188.1V176l-15.3-16L257.2 34.8 224 0l-33.2 34.8L71.3 160 56 176v32h48l-48 48-16 16-16 16v32h56l-40 48-26.7 32L0 416v32h200v64h48v-64h200v-32l-13.3-16-26.7-32-40-48h56v-32l-16-16-16-16-48-48h48zM248 400V192h-48v208H75.8l41.1-49.3 27.1-32.5V272h-36.1l30.1-30.1 38-38V160h-38.4L224 69.5l86.4 90.5H272v43.9l38.1 38.1 30 30H304v46.2l27.1 32.6 41.1 49.2z" })
  }
), FY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 168.7V160l-14.4-16-97.3-108.1L208 0l-32.3 35.9L78.4 144 64 160v32h32l-32 44-2.9 4-17.5 24L32 280v32h48l-36.9 48-30.8 40L0 416v32h184v64h48v-64h176v64h48v-64h184v-32l-12.3-16-30.8-40-36.9-48h48v-32l-11.6-16-17.5-24-2.9-4-32-44h32v-32l-14.4-16-97.3-108.1L432 0l-32.3 35.9-58.2 64.7 32.3 35.9L432 71.8l65 72.2h-17v41.6l25.2 34.6L537 264h-41v43.5l26 33.7 45.1 58.8H456V192h-48v208h-4.3l-30.8-40-36.9-48h48v-32l-11.6-16-17.5-24-2.9-4-32-44h32zM72.9 400l45.1-58.7 26-33.7V264h-41l31.8-43.8 25.2-34.6V144h-17l65-72.2 65 72.2h-17v41.6l25.2 34.6L313 264h-41v43.5l26 33.7 45.1 58.8H232V192h-48v208z" })
  }
), TY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M27.4 432 0 480h512l-27.4-48-201-351.6L256 32l-27.6 48.4L27.4 432zm401.9 0H82.7L256 128.7zM232 296v24h48V208h-48zm48 104v-48h-48v48z" })
  }
), AY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 24V0h-48v72l-4 6.6L28.8 464 0 512h576l-28.8-48-109.5-182.5-35 35L491.2 464H84.8L288 125.3l72.3 120.5-53.5 53.5c-5.9-2.1-12.2-3.2-18.8-3.2-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l45-45 35-35L537 137l17-17-34-33.9-17 17-107.7 107.7L316 78.6l-4-6.6z" })
  }
), DY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 512 30-48L291.7 45.3 320 0l28.3 45.3L610 464l30 48H56.6zM320 90.6 86.6 464h466.8L320 90.6m-8 85.4a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-26.1 65.1 40 16 5.6 2.3 2.7 5.4 27.6 55.3 52.1 31.3L432 320l64 112H368l30.2-52.8-56.7-34-85.7-51.4-14.4-8.6 9.3-14 16-24 7.2-10.8 12.1 4.8zm-33.8 91.6 60.3 37.7 7.5 4.7V432H288v-39.1l-37.9-23.7-31.2 62.8h-35.8l2.6-5.1 43.7-87.7 7.9-15.8 14.9 9.3z" })
  }
), yY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m0 480 27.4-48 201-351.6L256 32l27.6 48.4 201 351.6 27.4 48H55.3zm256-351.3L82.7 432h346.6z" })
  }
), bY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64h92.8l7.2 10.7 124.4 186.6c9.9-3.4 20.5-5.3 31.6-5.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-24.6 9.3-47 24.5-64L460 269.3l-48 72-7.2 10.7h-55.5l-2.6-.6L287 338c.7 4.6 1 9.3 1 14 0 53-43 96-96 96-17.5 0-33.9-4.7-48-12.8.6-.4 1.3-.8 1.9-1.1-14.5 8.9-31.6 14-49.9 14-53 0-96-43-96-96 0-28.4 12.3-53.9 31.9-71.4l-5.1-1.2-23.5-5.4 10.5-46.8 23.4 5.3L354.7 304h24.5l52-78-76-114H288zM184.6 314.9c4.8 11.4 7.4 23.9 7.4 37.1 0 16.9-4.3 32.7-12 46.5 3.8 1 7.8 1.5 12 1.5 26.5 0 48-21.5 48-48 0-9.7-2.9-18.8-7.9-26.4l-47.5-10.7zM71.5 89.8l7.3 22.9 19.7 61.4 98.1 19.1 23.6 4.6-9.2 47.1-23.6-4.6-112-21.9-13.9-2.7-4.3-13.5-24-74.9-7.3-22.9zM144 352a48 48 0 1 0-96 0 48 48 0 1 0 96 0m448 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), fY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 32h-24v48h112v21l-47.6 40.8-2.6 2.2h-10.6c-58.8 0-114 23.9-154.1 64.6L133.6 176H160v-48H32v48h45.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112 112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4 30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-2.4 0-4.8.1-7.2.2l-13.9-55.6 44.7-38.3 8.4-7.3V32h-24zm62.2 251.8 18.5 74 5.8 23.3 46.6-11.6-5.8-23.3-18.5-74c42 2.5 75.2 37.3 75.2 79.9 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), UY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m176.3 228.5-24.2 13.9-35.1 20.3c-19.6 11.4-37.2 38.7-50.4 72.3-2 5.1-3.8 10.2-5.4 15 5 1 10.3 2 15.7 2.8 35.7 5.4 68.2 3.8 87.8-7.5l35.1-20.3 24.2-13.9 24.2 13.9 35.1 20.3c19.7 11.4 52.1 12.9 87.8 7.5 5.4-.8 10.7-1.8 15.7-2.8-1.6-4.8-3.4-9.9-5.4-15-13.1-33.7-30.8-61-50.4-72.3l-35.1-20.3-24.2-13.9V160c0-22.7-14.8-51.6-37.4-79.8-3.4-4.3-6.9-8.4-10.3-12.2-3.4 3.8-6.8 7.9-10.3 12.2-22.6 28.2-37.4 57.1-37.4 79.8v40.6zM128 200.6V160c0-80 96-160 96-160s96 80 96 160v40.6l35.1 20.3c69.3 40 90.6 163.1 90.6 163.1s-117.3 43.1-186.6 3.1L224 366.9l-35.1 20.3C119.6 427.1 2.3 384 2.3 384s21.3-123.1 90.6-163.1zm-26.9-78.2C97.9 134.5 96 147.1 96 160v22.1l-19.1 11c-9.2 5.3-17.6 11.6-25.2 18.6C-5.5 163.3-4 120.5-4 120.5s35.7-22.3 105.1 1.9zM352 160c0-12.6-1.8-25-4.9-37 70.6-25.2 106.9-2.5 106.9-2.5s1.5 43.3-56.6 92.2c-7.9-7.4-16.6-14-26.2-19.5l-19.1-11V160zM204.9 414.9l19.1-11 19.1 11c9.6 5.6 19.8 9.8 30.2 13C258.5 493.7 224 512 224 512s-34.5-18.3-49.3-84.2c10.4-3.2 20.6-7.4 30.2-13zM224 216a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), GY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M325.1 372.3c-4.7 2.5-9.1 4.5-13.1 6.1V464h104v48H160v-48h104v-85.6c-4-1.6-8.4-3.6-13.1-6.1-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88V64h129.6c-.3-5.2-.5-10.6-.7-16-.6-15.3-.9-31.3-.9-48h320c0 16.7-.3 32.7-.9 48-.2 5.4-.4 10.8-.7 16H576v24c0 108.5-45.9 177.7-101.4 220.6-53.9 41.7-115.7 57.6-149.5 63.7m65.7-69.7c18.1-8 36.8-18.4 54.4-32 40.6-31.3 75.9-80.2 81.9-158.6h-84.4c-9.1 90.1-29.2 150.3-51.9 190.6M133.2 112H48.9c6 78.4 41.3 127.3 81.9 158.6 17.5 13.6 36.3 24 54.4 32-22.7-40.3-42.8-100.5-51.9-190.6zm111.7 193.3c14.7 17.7 28.1 25 36 28.2 3.1 1.2 5.6 1.9 7.2 2.3 1.6-.3 4.1-1 7.2-2.3 7.9-3.1 21.2-10.5 36-28.2 27.1-32.6 61.9-104.2 68-257.3H176.9c6.1 153.1 40.8 224.7 68 257.3m66.6-169.6 52.6 7.6-38 37.1 9 52.4L288 208l-47 24.7 9-52.4-38-37.1 52.6-7.6L288 88l23.5 47.6z" })
  }
), qY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 378.4c4-1.6 8.4-3.6 13.1-6.1 33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88V64H446.4c.3-5.2.5-10.6.7-16 .6-15.3.9-31.3.9-48H128c0 16.7.3 32.7.9 48 .2 5.4.4 10.8.7 16H0v24c0 108.5 45.9 177.7 101.5 220.6 53.9 41.7 115.7 57.6 149.5 63.7 4.7 2.5 9.1 4.5 13.1 6.1V464H160v48h256v-48H312zm133.2-107.8c-17.5 13.6-36.3 24-54.4 32 22.7-40.3 42.8-100.5 51.9-190.6h84.4c-6 78.4-41.3 127.3-81.9 158.6zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6-18.1-8-36.8-18.4-54.4-32-40.6-31.3-75.9-80.2-81.9-158.6zm128-64h222.2c-6.1 153.1-40.8 224.7-68 257.3-14.7 17.7-28.1 25-36 28.2-3.1 1.2-5.6 1.9-7.2 2.3-1.6-.3-4.1-1-7.2-2.3-7.9-3.1-21.2-10.5-36-28.2-27-32.6-61.7-104.2-67.8-257.3z" })
  }
), WY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 152v104h-48L0 128 208 0h48v104h88V80h168v96H344v-24zm32 184V224h224v288H0V336h240zm48 0h128v-64H336zm0 48h-80v80h208v-80zm-128 0H48v80h160z" })
  }
), EY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M409.9 198.1 376 232l-31-31-112 112 53.1 53.1L320 400l-33.9 33.9-6.1 6.1-226.9 58.4L0 512l13.6-53.1L72 232l6.1-6.1L112 192l33.9 33.9L199 279l112-112-31-31 33.9-33.9L382 34l34-34 33.9 33.9L478 62l34 34-33.9 33.9L410 198zm-33.9-34L444.1 96 416 67.9 347.9 136zm-125.8 234L113.9 261.8 66.7 445.3z" })
  }
), OY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V48zm432 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V0h416v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96m-64-272h142.1l-96-96H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M241 95l80 80 17 17-17 17-80 80-17 17-33.9-34 17-17 39-39H88v-48h158.1l-39-39-17-17L224 78.1l17 17z" })
  }
), IY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V48zm432 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V0h416v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96m78.1-272-96-96H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M112 211.2 246.4 96l-19.2 76.8H304L169.6 288l19.2-76.8z" })
  }
), NY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V48zm432 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V0h416v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96m-64-272h142.1l-96-96H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M96 192a112 112 0 1 1 224 0 112 112 0 1 1-224 0m128-64h-32v80h64v-32h-32v-32z" })
  }
), XY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 144h123.4l7.2 8.8 72 88 5.4 6.6V400h-32c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V168zm100.6 48H480v64h105zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), KY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h400v280h-48V80H48v232H0V56zm608 368c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V144h123.4l7.2 8.8 72 88 5.4 6.6V400zm-23-144-52.4-64H480v64zM136 136v152H88V112h48zm88 0v152h-48V112h48zm88 0v152h-48V112h48zm216 296a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), QY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V48zm432 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V0h416v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96m78.1-272-96-96H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M208 272c-39.8 0-72-29.6-72-66s72-126 72-126 72 89.5 72 126-32.2 66-72 66" })
  }
), ZY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 48H112v48h144v32H0V96h64V0h352v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96V288h48v44.8c14.1-8.2 30.5-12.8 48-12.8 35.5 0 66.6 19.3 83.2 48H368zm48 96v96h142.1l-96-96zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96M48 160h240v32H32v-32zm-32 64h240v32H0v-32z" })
  }
), JY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 80v256h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352V80zM16 336v-48H0V128h16V32h384v48h71.2l6.5 13.8L539 224h69v112h32v48h-64c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0v-48zm96 48a48 48 0 1 0 96 0 48 48 0 1 0-96 0m288-160h85.9l-45.2-96H400zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96M128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h32v80c0 26.5-21.5 48-48 48s-48-21.5-48-48v-80h32zm112-16h17.9l4.4 8.8 25.7 51.4V128h32v128h-33.9l-4.4-8.8-25.7-51.4V256h-32V128z" })
  }
), jY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 80v256H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64V80zM16 288v48H0v48h64c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h64v-48h-32V224h-69L477.7 93.8 471.2 80H400V32H16v96H0v160zm144 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96m325.9-112H400v-96h40.8l45.2 96zM528 384a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), YY = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 96h113.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0v-48h76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V120zm94.1 48H416v96h142.1zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), _Y = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v160h20.4l45.8-98.1 6.5-13.9h270.6l6.5 13.9 45.8 98.1H464V48zm0 208v144h416V256zM0 208V0h512v448h-32v64h-48v-64H80v64H32v-64H0V256zm121.4 0h269.2l-29.9-64H151.3zM96 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0m288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), h_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V48zm432 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V0h416v96h65.9l7 7L601 215l7 7v146h32v48h-64c0 53-43 96-96 96m78.1-272-96-96H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M176 80h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), c_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h171.8l7.2 9.4L482 112h126v118.3c6.1 5.1 12 10.6 17.5 16.4l14.5 15.4v3.9l-33 31.1-16.5-17.5C562.8 250.3 523.6 232 480 232c-53.3 0-100.3 27.5-127.4 69.1l-7.1 10.9h-51l-7.1-10.9C260.3 259.5 213.3 232 160 232c-43.6 0-82.8 18.3-110.5 47.7L33 297.1 0 266v-3.9l14.5-15.4c5.5-5.8 11.3-11.3 17.5-16.4V112h192V24zm48 112h149.4l-49.2-64H272zM80 200.6c24.5-10.7 51.6-16.6 80-16.6 65.5 0 123.5 31.5 160 80 36.5-48.5 94.6-80 160-80 28.4 0 55.5 5.9 80 16.6V160H80zm112 76c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H288v64h-20.6c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512h-64v-20.6c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.5-45.2-45.2 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H32v-64h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.5-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256h64v20.6zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96m352-155.4c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H608v64h-20.6c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512h-64v-20.6c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.6-45.3-45.3 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H352v-64h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.6-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256h64zM480 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), s_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80v246.7c9.8-4.3 20.6-6.7 32-6.7 26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V80zm160 400c-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80V32h480v112h75.4l7.2 8.8 72 88 5.4 6.6V400h-32c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80m324.6-288H480v64h105zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), v_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 32h-24v144H32v144H0v48h81.3c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96c0-5.5-.5-10.8-1.3-16h98.7c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96c0-5.5-.5-10.8-1.3-16H640v-48h-32V176H507.7L402.9 41.3l-7.2-9.3H384zm312 288h-24.4c-17.6-19.6-43.1-32-71.6-32s-54 12.4-71.6 32H247.6c-17.6-19.6-43.1-32-71.6-32s-54 12.4-71.6 32H80v-96h480zM446.9 176H272V80h100.3l74.7 96zM128 384a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), e_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-14.7 0-27.2 6.3-36.7 13.9-9.5 7.6-17.3 17.4-23.3 27.5-11.9 19.6-20 44.3-20 64.6v59.6L10.1 260.4 0 267.6v127l32.4-12.2L144 340.6V356l-54.4 40.8L80 404v108h43.6l3.4-1.1 97-29.8 32 9.8v-50.2l-24.9-7.7-7.1-2.2-7.1 2.2-88.9 27.4V428l54.4-40.8 9.6-7.2V271.4l-32.4 12.2L48 325.4v-33l133.9-94.8 10.1-7.2V106c0-9.6 4.6-25.8 13-39.7 4.1-6.7 8.4-11.8 12.3-14.9 3.9-3.1 6.1-3.3 6.7-3.3 2.4 0 10.1 3 19.2 18.1 5.9 9.8 9.8 20.8 11.6 29.9h48.6c-2-18-9.1-38.1-19-54.6C273.4 23.1 253.1 0 224 0m368 176v120.2l-2.5-7.4-16-48-10.9-32.8H365.4l-10.9 32.8-16 48-2.5 7.4V176zM336 416v-64h256v64H368zm272 48h32V128H288v336h32v48h48v-48h192v48h48zM384 304l16-48h128l16 48H434.6zm168 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), l_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h173.5l7 11.5 88 144c.9 1.5 1.6 3 2.2 4.5H480v144h32V199.6l5.3-6.6 64-80 15-18.7 37.5 30-15 18.7-58.8 73.4v143.2l58.7 73.4 15 18.7-37.5 30-15-18.7-63.2-79h-54c0 53-43 96-96 96s-96-43-96-96h-48c0 53-43 96-96 96s-96-43-96-96H0V192h128V56zm48 160h167L274.5 80H176zm35.2 144h73.7c16.6-28.7 47.6-48 83.2-48 24.6 0 47 9.2 64 24.4V240H48v90.9C65.2 305 94.6 288 128 288c35.5 0 66.6 19.3 83.2 48M176 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0m192 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), t_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0h288v48H400v312.3l26-6.7c17.6-38.7 56.7-65.6 102-65.6 61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.9 0-108.9-47.1-111.9-106.3L38 503.2l-23.2 6-12-46.5 23.2-6 326-84.1V24zm240 400a64 64 0 1 0-128 0 64 64 0 1 0 128 0M14.8 176.8l77.3-20.7 24.8 92.7 61.8-16.6-24.8-92.7 77.3-20.7 58 216.4-216.4 58-58-216.4z" })
  }
), w_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0h288v48H400v312.3l26-6.7c17.6-38.7 56.7-65.6 102-65.6 61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.9 0-108.9-47.1-111.9-106.3L38 503.2l-23.2 6-12-46.5 23.2-6 326-84.1V24zm240 400a64 64 0 1 0-128 0 64 64 0 1 0 128 0M294.5 209.2c8.7-2.3 17.4-2.1 25.5.2v125.4l-38.7 10.4-154.6 41.4L34 411.5l-20.7-77.3c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5-11 2.9-20.8 8-29.2 14.7z" })
  }
), g_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M376 0h-24v372.7L26 456.8l-23.2 6 12 46.5 23.2-6 378.2-97.5C419.1 464.9 468.1 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l-26 6.7V48h240V0h-24zm152 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), i_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32V0h96l213.3 240H384V96h139l7.2 8.3 104 120 5.8 6.7v185h-64c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H0V240h184L96 64v96c0 26.5-21.5 48-48 48S0 186.5 0 160v-32h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16zm179.2 336h153.6c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H592v-80H48v80h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48M145.8 56.3 237.7 240h71.4L145.8 56.3M584.2 240 501 144h-69v96zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), m_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 48v320H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48V48zm16 368c0 53 43 96 96 96s96-43 96-96h64v-48h-32V222.1l-7-7L489 103l-7-7h-66V0H0v416h64c0 53 43 96 96 96s96-43 96-96h120zm78.1-272 96 96H416v-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0m368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), a_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M595.4 48H640v384h-44.6l-7.1-10.4-.1-.2-.6-.9-2.7-3.6c-2.4-3.2-6-7.9-10.7-13.5-9.4-11.3-23.1-26.4-40-41.4-34.7-30.7-79.1-58-126.2-58h-8v112h8c30.9 0 56-25.1 56-56 0-3.1-.2-6.1-.7-9 15.9 8.2 31.5 19.2 46.2 31.9C499 429.3 457.6 464 408 464H168c-57.4 0-104-46.6-104-104 0-20.6 6-39.8 16.3-56H48v32H0V144h48v32h128v-32h48v32h40v-32h48v32h40v-32h48v32h8c47.1 0 91.5-27.3 126.1-57.9 16.9-15 30.6-30.1 40-41.4 4.7-5.7 8.3-10.3 10.7-13.5l2.7-3.6.6-.9.1-.2zM168 256h240c64.9 0 120.5 36.7 157.9 70.1 9.7 8.6 18.4 17.2 26.1 25.3V128.7c-7.6 8-16.4 16.7-26.1 25.3-37.4 33.3-93 70-157.9 70H48v32zm0 48c-30.9 0-56 25.1-56 56s25.1 56 56 56h8V304zm56 0v112h40V304zm88 0v112h40V304z" })
  }
), o_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m272.4 369.2 31.9 18.4 26-26 33.2-33.2 94.2 37.6-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336l-160-64-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32v32c0 247.4 200.6 448 448 448h32zM352 64h-64v64h64zm-64 96v64h64v-64zm160-96h-64v64h64zm32 0v64h64V64zm160 0h-64v64h64zm-64 96v64h64v-64zm-32 0H384v64h160z" })
  }
), n_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M322 253.2v-64.4c-42.3-17.2-89.7-17.2-132 0v64.4L32 288-8 152.6C22.8 112.4 118.7 32 256 32s233.2 80.4 264 120.6L480 288zm-180-64.4v-32.4l29.9-12.2c53.9-21.9 114.2-21.9 168.1 0l30 12.2V214.6l76.6 16.9 19.7-66.8C431 130.1 356.3 80 256 80S81 130.1 45.6 164.7l19.7 66.8 76.7-16.9zM32 320h64v64H32zm0 96h64v64H32zm160-96v64h-64v-64zm32 0h64v64h-64zm160 0v64h-64v-64zm32 0h64v64h-64zm64 96v64h-64v-64zm-352 0h256v64H128z" })
  }
), r_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h168v125.3L58.2 232.7l-23.3 5.8 11.6 46.6 23.3-5.8 98.2-24.6v46.5L58.2 328.7l-23.3 5.8 11.6 46.6 23.3-5.8 98.2-24.6V480h48V338.7l109.8-27.5 23.3-5.8-11.6-46.6-23.3 5.8-98.2 24.7v-46.6l109.8-27.5 23.3-5.8-11.6-46.6-23.3 5.8-98.2 24.7V80h168V32H192z" })
  }
), d_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M584 56c0 5.6-.8 11-2.3 16h2.3c30.9 0 56 25.1 56 56s-25.1 56-56 56c-20.3 0-38-10.8-47.9-26.9l-47.6 33.6c-30 21.2-46.5 55.8-63 90.3-8.7 18.2-17.3 36.4-28 52.5-6.2 9.4-13.9 18.1-23.2 25.6-48.1 38.9-118.6 31.5-157.5-16.6S185.3 223.9 233.4 185c24-19.5 53.7-27.3 82.2-24.3 15 1.6 30.7 3 45.8 2.1-27.1-12.4-52.9-18.8-73.4-18.8-40.6 0-101.6 24.8-154 71.7C82.5 262 48 322 48 384v80h480v-80c0-46.8-19.6-92.5-51.5-132 9-14.9 18.4-26.7 30.5-35.2l1.7-1.2C548.7 262.9 576 321 576 384v128H0V384C0 224 176 96 288 96c39.9 0 87.9 16.2 133.1 44.3L486.8 94C477.6 84 472 70.7 472 56c0-30.9 25.1-56 56-56s56 25.1 56 56" })
  }
), S_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 32v80.2l137.4-39.3 23.1-6.6 13.2 46.2-23.1 6.6-150.6 43v46.1l137.4-39.3 23.1-6.6 13.2 46.2-23.1 6.6-150.6 43V432h88c75.1 0 136-60.9 136-136v-40h48v40c0 101.6-82.4 184-184 184H64V271.8l-25.4 7.3-23.1 6.6-13.2-46.2 23.1-6.6 38.6-11v-46.1l-25.4 7.3-23.1 6.6-13.2-46.2 23.1-6.6 38.6-11V32z" })
  }
), z_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 264h256V80h48v232H160v68.1L67.9 288l92.1-92.1V216zm-126.1-9.9L0 288l33.9 33.9L160 448h48v-88h304V32H368v184H208v-88h-48L33.9 254.1" })
  }
), p_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 264H96V80H48v232h304v68.1l92.1-92.1-92.1-92.1V216zm126.1-9.9L512 288l-33.9 33.9L352 448h-48v-88H0V32h144v184h160v-88h48z" })
  }
), M_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 192v-48H0V0h264v304h88v48L225.9 478.1 192 512l-33.9-33.9L32 352v-48h88v-48zM99.9 352l92.1 92.1 92.1-92.1H216V48H48v48h120v256h-48z" })
  }
), x_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 320v48H0v144h264V208h88v-48L225.9 33.9 192 0l-33.9 33.9L32 160v48h88v48zM99.9 160 192 67.9l92.1 92.1H216v304H48v-48h120V160h-48z" })
  }
), H_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 80v352H48V80zM48 32H0v448h576V32h-48zm448 80h-48v169.9l-45.1 82.6-11.5 21.1 42.1 23 11.5-21.1 48-88 2.9-5.4V112zM368 256a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-176 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), V_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 240v-32c0-70.7-57.3-128-128-128S80 137.3 80 208v32zm48 0v48H32v-80c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 48c-5.5 0-10.9-.7-16-2v82H352v112H224V368h-32v112H64V368H0v-48h416V112h64c53 0 96 43 96 96v80zm-208 80v64h32v-64zm-160 0v64h32v-64zm384-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), C_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 48v320H48V48zM48 0H0v416h640V0h-48zm48 464v48h448v-48H120zM416 96V72.9L394.4 81l-128 48-10.4 3.9v124.9c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V128z" })
  }
), L_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m168 6.1 17 17 71 71 71-71 17-17L377.9 40 361 57l-39 39h190v416H0V96h190.1L151 57l-17-17 34-33.9zM48 144v320h416V144zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-24 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-40-112v224H96V192z" })
  }
), B_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v320h544V48zM0 0h640v416H0V48zm120 464h424v48H96v-48z" })
  }
), u_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 0H80v160h48V48h214.1L384 89.9V160h48V70.1l-7-7L369 7l-7-7h-10zM0 192v96h32v224h448V288h32v-96H352l-32 32H192l-32-32zm80 96h352v176H80zm48 96v48h256v-48zm40-64h-40v40h40zm32 0v40h40v-40zm112 0h-40v40h40zm32 0v40h40v-40z" })
  }
), R_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v256c0 79.5 64.5 144 144 144s144-64.5 144-144V32h48v256c0 106-86 192-192 192S0 394 0 288V32z" })
  }
), $_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m152.5 163.3-16.9 17c-4-4-6.5-9.2-7-14.9-.6-7-.8-14-.5-20.7-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2 10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7 10.4-9.2 12.6-16 12.6-20.2 0-5.7-4.5-16.7-26.2-30.1-13.7-8.4-31.9-16.3-53.9-23 .3 6.8.1 13.7-.5 20.7-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1l-.1.1-.3.3-.7.7c-.6.5-1.3 1.1-2.1 1.9-1.8 1.5-4.2 3.3-7.3 5.5-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9-3.1-2.2-5.6-4-7.3-5.5-.9-.7-1.6-1.4-2.1-1.9l-.7-.7-.3-.3-.1-.1 16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2 26.1 16.1 49 39.7 49 70.9 0 23-12.6 41.9-28.9 56.2-16.3 14.4-38.6 26.2-64.1 35.7-51 19-120 30.3-195 30.3s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6 18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6M117.5 362.7l-64 128-10.8 21.5-42.9-21.5 10.7-21.5 64-128 10.7-21.5 42.9 21.5-10.7 21.5zm384-21.5 64 128 10.7 21.5-42.9 21.5-10.7-21.5-64-128-10.7-21.5 42.9-21.5 10.7 21.5z" })
  }
), k_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5v.1l.1.1.3.3.7.7c.6.5 1.3 1.2 2.2 2.1 1.8 1.6 4.3 3.7 7.6 6.2 6.6 4.8 16.1 10.9 29.1 16.8 26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8 3.3-2.4 5.8-4.5 7.6-6.2.9-.8 1.6-1.5 2.2-2.1l.7-.7.3-.3.1-.1v-.1l-17.5-16.5 17.5 16.4c3.7-3.9 6-9 6.4-14.4.5-5.8.7-11.6.6-17.2 30 8.9 54.6 19.9 72.5 31.8 24.1 16.2 31.5 30.9 31.5 41.6 0 7.9-3.8 17.7-15.8 29.1-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6 17.9-12 42.4-23 72.5-31.8-.1 5.7.1 11.4.6 17.2.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9 17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9 18-17.1 30.7-38.7 30.7-63.9 0-34.3-23.4-61.7-52.8-81.4-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8-.8-69.9 55-122.6 120-122.6s120.8 52.7 120 122.6M96 312l32 32 32-32-32-32zm192 40 32 32 32-32-32-32zm224-72-32 32 32 32 32-32z" })
  }
), P_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M572.1 268.8c-.5 16.2-2.6 32.5-6.3 48.8L520.3 301l-77.6-28.3-227.8-82.8-80.9-29.5-45.6-16.5c7.6-14.9 16.5-28.7 26.6-41.5 66.5-84.6 182.2-121 288.8-82.2s171.8 141 168.4 248.6zM473 124.2c.4 35-4.5 69.8-14.5 103.3l65.5 23.8c-2.2-47-20.3-91.9-51-127.2zm-76.7-55.3c-3-1.2-5.9-2.4-9-3.5-1-.4-1.9-.7-2.9-1-18.2-5.9-38.3-.9-51.5 13.1-23.3 24.6-42.2 53.1-55.9 84L413.3 211c9.4-32.5 13.2-66.4 11.2-100.2-1.1-18.2-12-34.2-28.2-41.9M288.8 54.6C240.8 61 196.1 84.1 163 120l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM552 464h24v48H0v-48h216.7l76.9-211.4 45.1 16.4-71 195z" })
  }
), F_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0v33.1C394.1 43.7 486.5 129.2 507.5 240c3 15.5 4.5 31.6 4.5 48H0c0-16.4 1.5-32.5 4.5-48C25.5 129.2 117.9 43.7 232 33.1V0zm-24 80c-98.4 0-180.8 68.3-202.4 160h404.8C436.8 148.3 354.4 80 256 80m24 358.6c0 40.6-32.9 73.4-73.4 73.4-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7-10.7-21.5 42.9-21.5 10.7 21.5 2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1 14.1 0 25.4-11.4 25.4-25.4V320h48z" })
  }
), T_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0v48.9c124.7 9.7 227.7 94.4 256.2 207.1.4 1.4.7 2.8 1 4.2.8 3.3 1.5 6.7 2.2 10.1.5 2.7 1 5.5 1.5 8.3.4 2.4.7 4.9 1.1 7.4l2.3 18.1h-32l-4.8-5.3c-2.3-2.6-4.8-5.1-7.5-7.3-2.2-1.9-4.4-3.6-6.7-5.2-12.8-9.1-28.4-14.3-45.3-14.3-30.1 0-56.3 16.6-70 41.2-6.4 11.5-10 24.7-10 38.8h-32c0-14.1-3.6-27.3-10-38.8-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-6.4 11.5-10 24.7-10 38.8h-32c0-14.1-3.6-27.3-10-38.8-13.7-24.6-39.9-41.2-70-41.2-16.9 0-32.5 5.2-45.4 14.1-2.3 1.6-4.6 3.4-6.7 5.2-2.6 2.3-5.1 4.7-7.5 7.3l-4.8 5.4H-.2l2.3-18.1c.3-2.5.7-4.9 1.1-7.4.4-2.8.9-5.5 1.5-8.3.7-3.4 1.4-6.7 2.2-10.1.3-1.4.7-2.8 1-4.2C36.3 143.3 139.3 58.6 264 48.9V0zm72 267.3c23.5-26.6 57.8-43.3 96-43.3 9.1 0 18 1 26.5 2.8C469 150.3 386.2 96 288 96S107 150.3 69.5 226.8C78 224.9 86.9 224 96 224c38.2 0 72.5 16.8 96 43.3 23.5-26.6 57.8-43.3 96-43.3s72.5 16.8 96 43.3M288 304c8.7 0 16.9 2.3 24 6.4v128.2c0 40.6-32.9 73.4-73.4 73.4-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7-10.7-21.5 42.9-21.5 10.7 21.5 2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1 14.1 0 25.4-11.4 25.4-25.4V310.4c7.1-4.1 15.3-6.4 24-6.4" })
  }
), A_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 32h144v48h-48v144c0 61.9 50.1 112 112 112s112-50.1 112-112V80h-48V32h144v48h-48v144c0 88.4-71.6 160-160 160S64 312.4 64 224V80H16zM0 432h448v48H0z" })
  }
), D_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440 48h43.2l44.8 67.3v61.1l-42.7 19L457 167l-7-7h-42v46.5l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4 0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1V464h-48V326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6l-88-25.7-31.4-9.2.7 32.7v1.3c0 8-1.4 16-4.3 23.5l-15.7 42-2.7 7.3 2.1 7.5 17.5 63.4h-49.8l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9 0-35.5 28.8-64.2 64.2-64.2h158l2.6-21C343.2 87.7 387 48 440 48m111.5 16-10.7-16H560V0H440c-70.1 0-129.1 47.5-146.7 112H176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v88h48v-88c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-17.3 46.1-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h149.4l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2l51.8 15.2V512h144V327.8c19.8-22.6 32-52.3 32-85.5v-.3l10.7 10.7 15.1-6.7 72-32 14.3-6.3V101.3L640 80V64zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), y_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.4 0H254.6l6.7 13L320 127.1 378.7 13l6.7-13h137.2l6.8 12.4L637 208.1l3 5.4V448H496V250.5l-16-29.1V288h-48V128l45-11.6 64 116.4 3 5.4V400h48V225.8L494.2 48h-79.6l-73.3 142.5-50.1 97.5h-54L293 179.6 225.4 48h-79.6L48 225.8V400h48V238.1l3-5.4 64-116.4 45 11.7v160h-48v-66.6l-16 29.1V448H0V213.5l3-5.4L110.6 12.4zM432 384h48v128H160V384h48v80h224zm-256-64h304v32H349.9l47.4 71.1-26.6 17.8-50.7-76-50.7 76-26.6-17.8 47.4-71.1H160v-32z" })
  }
), b_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v256c0 79.5 64.5 144 144 144s144-64.5 144-144V32h48v256c0 106-86 192-192 192S0 394 0 288V32z" })
  }
), f_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m160.4-86.5 60 22.5h71.3l59.9-22.5 22.5-8.4 16.8 44.9-22.5 8.4-64 24-.4.2v53.5l30.8 92.3 7.6 22.8-45.5 15.2-7.6-22.8-26.6-79.6h-13.4l-26.5 79.6-7.6 22.8-45.5-15.2 7.6-22.8 30.7-92.3v-53.5l-.4-.2-64-24-22.5-8.4 16.9-44.9 22.5 8.4zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), U_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c-44.2 0-80 35.8-80 80v64h304v320H0V192h96v-64C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6l-45.7 14.8C289.8 71.2 259.6 48 224 48M48 240v224h352V240zm208 136h-88v-48h112v48z" })
  }
), G_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128c0-44.2 35.8-80 80-80 35.6 0 65.8 23.2 76.1 55.4l45.7-14.8C329.2 37.2 281 0 224 0 153.3 0 96 57.3 96 128v64H0v320h448V192H144zM48 464V240h352v224z" })
  }
), q_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 144V96l62.1-62.1L256 0l33.9 33.9L352 96v48h-72v88h88v-72h48l62.1 62.1L512 256l-33.9 33.9L416 352h-48v-72h-88v88h72v48l-62.1 62.1L256 512l-33.9-33.9L160 416v-48h72v-88h-88v72H96l-62.1-62.1L0 256l33.9-33.9L96 160h48v72h88v-88h-24zm124.1-48L256 67.9 227.9 96zM67.9 256 96 284.1v-56.2zm216.2 160h-56.2l28.1 28.1zm160-160L416 227.9v56.2z" })
  }
), W_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 224v-48h56v-48l-94.1-94.1L128 0 94.1 33.9 0 128v48h56v160H0v48l94.1 94.1L128 512l33.9-33.9L256 384v-48h-56v-48zm-11.9 160L128 444.1 67.9 384H104V128H67.9L128 67.9l60.1 60.1H152v256z" })
  }
), E_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 224v-48h76.1L224 67.9 115.9 176H192v128h64zm1.9-190.1L384 160v64h-80v128H144V224H64v-64L190.1 33.9 224 0zM48 344v120h352V320h48v192H0V320h48z" })
  }
), O_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 256v-48h76.1L224 99.9 115.9 208H192v128h64zm1.9-190.1L384 192v64h-80v128H144V256H64v-64L190.1 65.9 224 32zM64 416v64H0v-64zm96 0v64H96v-64zm32 64v-64h64v64zm160-64v64h-64v-64zm32 0h64v64h-64z" })
  }
), I_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256v-48h76.1L192 99.9 83.9 208H160v128h64zm1.9-190.1L352 192v64h-80v128H112V256H32v-64L158.1 65.9 192 32zM24 432h360v48H0v-48z" })
  }
), N_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m136 244.1 33.9 33.9L272 380.1l44.1-44.1-102-102.1-34-33.9 33.9-33.9 38.1-38.1H64v188.1l38.1-38.1zm-38.1 106L64 384l-33.9-33.9L16 336V80h256l14.1 14.1L320 128l-33.9 33.9-4.1 4.1-34 34 33.9 33.9L350 302l34 34-33.9 33.9L306 414l-34 34-33.9-33.9L170 346l-34-34-33.9 33.9L98 350z" })
  }
), X_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 160v304h64V160h60.1L160 67.9 67.9 160H80zm-1.9-126.1L160 0l33.9 33.9L320 160v48h-80v304H80V208H0v-48L126.1 33.9" })
  }
), K_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M265.9 150.1 294 122l34-34-6.1-6.1-27.8-27.8L288 48l33.9-33.9L336 0h176v176l-14.1 14.1L464 224l-6.1-6.1L430 190l-6-6-33.9 33.9L362 246l-34 34-33.9-33.9L266 218l-34-34zm96-96 34 33.9-33.9 33.9-62.1 62.1 28.1 28.1 62.1-62.1 33.9-33.9 33.9 33.9 6.1 6.1V48H355.9l6.1 6.1zM280 328l-33.9 33.9L218 390l-34 34 6.1 6.1L218 458l6 6-33.9 33.9L176 512H0V336l14.1-14.1L48 288l6.1 6.1L82 322l6 6 33.9-33.9L150 266l34-34 33.9 33.9L246 294zM150.1 457.9l-34-33.9 33.9-33.9 62.1-62.1-28.1-28.1-62.1 62.1L88 395.9l-33.9-34-6.1-6V464h108.1l-6.1-6.1z" })
  }
), Q_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M321.9 81.9 288 48l33.9-33.9L336 0h176v176l-14.1 14.1L464 224l-33.9-33.9L393 153 241 305l-17 17-33.9-34 17-17L359 119zM464 156.1V48H355.9zM0 32h224v48H48v384h384V288h48v224H0V56z" })
  }
), Z_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 244.1 214.1 278 112 380.1 67.9 336l102-102.1 34-33.9-33.9-33.9-38.1-38.1H320v188.1L281.9 278zM286.1 350l33.9 34 33.9-33.9L368 336V80H112L97.9 94.1 64 128l33.9 33.9 4.1 4.1 34 34-33.9 33.9-68.2 68.2L0 336l33.9 33.9L78 414l34 34 33.9-33.9L214 346l34-34 33.9 33.9 4.1 4.1z" })
  }
), J_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32v64H0V32zm96 0v64H96V32zm32 0h64v64h-64zm160 0v64h-64V32zm32 0h64v64h-64zM256 352v-48h76.1L224 195.9 115.9 304H192v128h64zm1.9-190.1L384 288v64h-80v128H144V352H64v-64l126.1-126.1L224 128z" })
  }
), j_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 352v-48h76.1L192 195.9 83.9 304H160v128h64zm1.9-190.1L352 288v64h-80v128H112V352H32v-64l126.1-126.1L192 128zM24 80H0V32h384v48h-24z" })
  }
), Y_ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 240v192h64V240h108.1L192 99.9 51.9 240H112zM48 288H0v-64L158.1 65.9 192 32l33.9 33.9L384 224v64H272v192H112V288H64z" })
  }
), __ = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 360v24h-48V97.9l-95 95-17 17L86.1 176l17-17L239 23l17-17 17 17 136 136 17 17-34 33.9-17-17-95-95zm32-8v-48h200v208H0V304h200v48H48v112h416V352zm72 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), h11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 144v224h352V144zM0 96h448v320H0V144zm640 32v256H480V128zm-56 56h-48v48h48zm-48 96v48h48v-48z" })
  }
), c11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 39.3-27.6 81.6-65.7 119-16.5 16.2-33.1 29.7-46.3 39.6-13.2-9.9-29.9-23.4-46.3-39.6-38.1-37.4-65.7-79.7-65.7-119M224 0C135.6 0 64 74.8 64 167c0 119.3 160 217 160 217l-9.8 16 9.8-16 9.8 16-9.8-16s160-97.7 160-217C384 74.8 312.4 0 224 0m-43.9 392.7c-13.5-10-31-23.7-49.2-40.7H48L14.4 464 0 512H448l-14.4-48L400 352h-82.9c-18.1 16.9-35.6 30.7-49.2 40.7-3.7 2.7-7.1 5.2-10.2 7.3h106.6l19.2 64h-319l19.2-64h106.6c-3.1-2.2-6.5-4.6-10.2-7.3zM208 224c0-30.9-25.1-56-56-56h-24v8c0 30.9 25.1 56 56 56h24zm88-56c-30.9 0-56 25.1-56 56v8h24c30.9 0 56-25.1 56-56v-8z" })
  }
), s11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 192a144 144 0 1 1 288 0 144 144 0 1 1-288 0m325.1-64C378.7 53.4 307.6 0 224 0S69.3 53.4 42.9 128H16v128h26.9c6.1 17.3 14.6 33.4 25.1 48H48L11.1 464 0 512h160v-64h32v64h256l-11.1-48L400 304h-20c10.5-14.6 19-30.7 25.1-48H432V128zM336 416H112v48H60.3l25.9-112h31.6c30.4 20.2 66.9 32 106.2 32s75.8-11.8 106.2-32h31.6l25.8 112H336zm-96-128c53 0 96-43 96-96v-32l-32-32H144l-32 32v32c0 53 43 96 96 96zm-48-128 16 32 32 16-32 16-16 32-16-32-32-16 32-16zm64 304a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), v11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M323 120c-13.6-42-53-72-99-72s-85.4 30-99 72zm5.5 36.4L248 171.5v95.9l9.9-1.7c8.4-48.3 43-79.4 71.5-95.4l-.9-13.8zm-209 0-.9 13.8c28.5 16 63.1 47.1 71.5 95.4l9.9 1.7v-95.8zM96 70c27.1-42.3 74.5-70 128-70 80.1 0 146.5 62.2 151.7 142.2l8.3 128.2 1.4 21.4-21.2 3.7-136 24c-2.8.5-5.6.5-8.3 0l-136-24-21.2-3.7 1.3-20.6V0h48v32H96zM64.5 464H160l64-48 64 48h95.5l-19.2-64H83.7zM48 352h352l33.6 112 14.4 48H0l14.4-48z" })
  }
), e11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0M65 464h318l-34.5-112h-249zm319-160 49.2 160 14.8 48H0l14.8-48L64 304h160zM224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m393 177L489 305l-17 17-17-17-64-64-17-17 34-33.9 17 17 47 47L583 143l17-17 33.9 34-17 17z" })
  }
), l11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 48c0 20.9-13.4 38.7-32 45.3V176c0 70.7-57.3 128-128 128S96 246.7 96 176V93.3C77.4 86.7 64 68.9 64 48c0-26.5 21.5-48 48-48 14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48m-80 128v-16H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80m48 144v32h48l33.6 112 14.4 48H0l14.4-48L48 352h48v-32l48 12 80 20 80-20zM64.5 464H128v-33.9l8.8-4.4 61.4-30.7-54.2-13.5V400H83.7zm95.5-14.1V464h223.5l-19.2-64H304v-18.5l-14.4 3.6zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), t11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160M99.5 352 65 464h283.5c12.3 18.8 28 35.1 46.3 48H0l14.8-48L64 304h268c-5.9 15.1-9.8 31.2-11.3 48zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0m256 240a144 144 0 1 1 288 0 144 144 0 1 1-288 0m160-80h-32v96h80v-32h-48v-48z" })
  }
), w11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M364.2 105.1c-7.7 3-16.2 5.9-25.6 8.6L288 0l-64 32-64-32-50.5 113.7c-9.4-2.7-17.9-5.6-25.6-8.6-32.4-12.7-49.4-27.2-55-34.7L.8 85.1c9.3 27.9 35 62.4 72.5 89.9 7.4 5.4 15.4 10.6 23.8 15.5-.7 5.6-1.1 11.5-1.1 17.5 0 70.7 57.3 128 128 128s128-57.3 128-128c0-6-.4-11.9-1.2-17.6 8.4-4.8 16.4-10 23.8-15.5 37.6-27.4 63.2-62 72.5-89.9l-28-14.7c-5.6 7.5-22.7 22-55 34.7zm-60.3 106.2c-1.7 42.6-36.8 76.7-79.9 76.7s-78.2-34.1-79.9-76.7c24.2 8 50.9 12.7 79.9 12.7s55.8-4.8 79.9-12.7M66.6 464l16-48h282.8l16 48H66.6zM48 368l-32 96-16 48H448l-16-48-32-96z" })
  }
), g11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 53.7V144c0 70.7 57.3 128 128 128s128-57.3 128-128V0l-48 24-16 8-64-32-64 32-16-8L96 0zm48 74.3h160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80zM99.5 352h249L383 464H65zM384 304H64L14.8 464 0 512h448l-14.8-48z" })
  }
), i11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v64l-48 48v32h352v-32l-48-48v-64C352 57.3 294.7 0 224 0M99.5 352H136v50.3c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V352h112v50c-27.6 7.1-48 32.2-48 62v48h56v-32h-24v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-24v32h56v-48c0-29.8-20.4-54.9-48-62v-50h36.5l49.2 160H448l-64-208H64L0 512h50.2zM128 456a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), m11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128c0-11.4-2.4-22.2-6.7-32H256l-16-16-32 32h-62.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144zm3.5 224L50.2 512H0l64-208h320l64 208h-50.2l-49.3-160H312v50c27.6 7.1 48 32.2 48 62v48h-56v-32h24v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h24v32h-56v-48c0-29.8 20.4-54.9 48-62v-50H168v50.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V352zM176 456a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), a11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 1-160 0 80 80 0 1 1 160 0M224 0a128 128 0 1 0 0 256 128 128 0 1 0 0-256M50.2 512l49.3-160H136v50.3c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V352h112v50c-27.6 7.1-48 32.2-48 62v48h56v-32h-24v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-24v32h56v-48c0-29.8-20.4-54.9-48-62v-50h36.5l49.2 160H448l-64-208H64L0 512zM152 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48M384 0v224h64v64l96-64h96V0z" })
  }
), o11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160m128-80a128 128 0 1 1-256 0 128 128 0 1 1 256 0M99.5 352 50.2 512H0l64-208h320l64 208h-50.2l-49.3-160H312v50c27.6 7.1 48 32.2 48 62v48h-56v-32h24v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h24v32h-56v-48c0-29.8 20.4-54.9 48-62v-50H168v50.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V352zM176 456a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), n11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160M99.5 352 65 464h277.8l24.1 41.7 37.1-21.4V512H0l14.8-48L64 304h241.4l-15.5 26.9 36.1 20.8-.5.3zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0m340 78.4h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497h-88v-42.2c-8-3.4-15.6-7.7-22.5-12.9L378.6 462l-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9v-42.2zm92.1 145.3a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0" })
  }
), r11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m224 0 184.1 39.5 32.7 7L448 48v32l-7.2 1.5-32.7 7L224 128 48 90.3V168l16 88H0l16-88V83.4l-8.8-1.9L0 80V48l7.2-1.5 32.7-7zm-35 456.9L105.4 368h-6.8l-32 96h129.1zm192.4 7.1-32-96h-6.8L259 456.9l-6.7 7.1zm-59.5-144H384l48 144 16 48H0l16-48 48-144h62.1l64.9 69 33 35 33-35zM96 160v-26.7l48 10.3V160c0 44.2 35.8 80 80 80s80-35.8 80-80v-16.4l48-10.3V160c0 70.7-57.3 128-128 128S96 230.7 96 160" })
  }
), d11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m96 0 48 24 16 8 64-32 64 32 16-8 48-24v144c0 70.7-57.3 128-128 128S96 214.7 96 144V53.7zm48 144c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144zM65 464h318l-34.5-112h-249zm-1-160h320l49.2 160 14.8 48H0l14.8-48zm576 208H481.5l-2.9-9.4L422.4 320H576zM432 256c-27.7 0-53-10.1-72.6-26.7C375 204.6 384 175.4 384 144V42.8c14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112s-50.1 112-112 112" })
  }
), S11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 136a56 56 0 1 1 112 0 56 56 0 1 1-112 0m160 0a104 104 0 1 0-208 0 104 104 0 1 0 208 0m216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192M98.6 336h122.8l32 96H66.6zM256 288H64L16 432 0 480H320l-16-48zm384 0H320l64 192h192z" })
  }
), z11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64 304-10.4 33.9-34.5 112-4.3 14.1L0 512h448l-14.8-48-4.3-14.1-34.5-112L384 304H99.5zm268.8 160H65l14.8-48 19.7-64h249l19.7 64 14.8 48zM352 128a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-208 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0m496 384-64-192H422.4l56.2 182.6 2.9 9.4zM432 256c61.9 0 112-50.1 112-112S493.9 32 432 32c-24.8 0-47.7 8.1-66.3 21.7C377.4 75.9 384 101.2 384 128c0 35.6-11.6 68.5-31.3 95.1C373 243.4 401 256 432 256" })
  }
), p11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H192l32-32 32 32h46.4c1 5.2 1.6 10.5 1.6 16M40 192h65.3c19 46.9 65 80 118.7 80s99.7-33.1 118.7-80H408V64h-73.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H40zm26.6 272 32-96h250.8l32 96H66.6zM64 320 16 464 0 512H448l-16-48-48-144z" })
  }
), M11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v64l-48 48v32h352v-32l-48-48v-64C352 57.3 294.7 0 224 0M66.6 464l32-96h250.8l32 96H66.6zM64 320 16 464 0 512H448l-16-48-48-144z" })
  }
), x11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128c0-5.5-.6-10.8-1.6-16H260l-7.2-9.6L224 64l-28.8 38.4-7.2 9.6h-42.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm47-16c.7 5.2 1 10.6 1 16v16c0 21.7-5.4 42.1-14.9 59.9L352 256l-32 16-24-16-8 32h-32l-16.9-16.9c-5 .6-10 .9-15.1.9s-10.2-.3-15.1-.9L192 288h-32l-8-32-24 16-32-16 14.9-52.1C101.4 186.1 96 165.7 96 144v-16c0-5.4.3-10.8 1-16h-9V64h25.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H360v48zM66.6 464h314.8l-32-96H98.6zM64 320h320l48 144 16 48H0l16-48z" })
  }
), H11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144v-16c0-11.4-2.4-22.2-6.7-32H256l-16-16-32 32h-62.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80M224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16C96 57.3 153.3 0 224 0M66.6 464h314.8l-32-96H98.6zM64 320h320l48 144 16 48H0l16-48z" })
  }
), V11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c-88.4 0-160 71.6-160 160v32H32v-32C32 86 118 0 224 0s192 86 192 192v128H176v-64h96v32h112v-96c0-88.4-71.6-160-160-160M14.4 464 48 352h352l33.6 112 14.4 48H0zM144 291.9c-29.3-23.5-48-59.5-48-99.9 0-70.7 57.3-128 128-128s128 57.3 128 128c0 23.3-6.2 45.2-17.1 64H304v-64c0-44.2-35.8-80-80-80s-80 35.8-80 80v32zM83.7 400l-19.2 64h319l-19.2-64H83.7z" })
  }
), C11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h-64v80l-28.4-56.9C125.6 43.5 99 82.6 96.2 128H72v48h304v-48h-24.2c-2.8-45.4-29.4-84.5-67.4-104.9L256 80zm-94 304c18.4 10.2 39.5 16 62 16s43.6-5.8 62-16c34.9-19.4 59.8-54.6 65-96h-48.6c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64H97c5.2 41.4 30.1 76.6 65 96m-11.4 48H48L14.4 464 0 512H448l-14.4-48L400 352H224zm-66.9 48h280.6l19.2 64h-319z" })
  }
), L11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208c-44.2 0-80-35.8-80-80h160c0 44.2-35.8 80-80 80M150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7.1L170.2 96zm113.9-37c14.5 8.5 26 21.5 32.8 37h-77.2l44.4-37zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256M65 464l31-100.8V464zm239 0h-42.7l-32-48H304zm32 0v-80H208l-21.3-32h161.8L383 464zm48-160H64L14.8 464 0 512h448l-14.8-48z" })
  }
), B11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 512h-48l-60.9-48H136l40-96h169.2l-60.9-48H144L84 464l-20 48h460zM382.2 273.9C430.6 250.7 464 201.3 464 144 464 64.5 399.5 0 320 0c-69.9 0-128.2 49.9-141.3 116L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7zm-45.5-35.4-112.4-87.1c-.2-2.4-.3-4.9-.3-7.4 0-53 43-96 96-96s96 43 96 96c0 47.4-34.3 86.7-79.4 94.6z" })
  }
), u11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-240 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0M72 464h368l-40-96H112zm8-144h352l60 144 20 48H0l20-48z" })
  }
), R11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128a80 80 0 1 1 160 0 80 80 0 1 1-160 0M65 464l34.5-112H384v-48H64L14.8 464 0 512h384v-48h-64zm159-208a128 128 0 1 0 0-256 128 128 0 1 0 0 256m304-16c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48h-32v192h224V320h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), $11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160M99.5 352h191.7c-2.1-10.3-3.2-21-3.2-32 0-5.4.3-10.7.8-16H64L14.8 464 0 512h448l-9.9-32.3c-21.4-1.3-41.6-6.8-59.9-15.7H65zM352 128a128 128 0 1 0-256 0 128 128 0 1 0 256 0m96 112.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9 0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z" })
  }
), k11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0M65 464h318l-34.5-112h-249zm319-160 49.2 160 14.8 48H0l14.8-48L64 304h160zM224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m248 200h168v48H448v-48z" })
  }
), P11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256M49.3 464H288c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-3.2.4-6.5 1-9.6 1.7-23.3-21.6-54.4-34.8-88.7-34.8h-91.4c-65.7 0-120.1 48.7-129 112M630 164.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3" })
  }
), F11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0c-49.6 0-92.6 28.2-113.8 69.4-3-5.8-6.8-11.3-11.7-16.1-25-25-67.9-22.6-67.9-22.6s-2.4 42.9 22.6 67.9c5.8 5.8 12.6 10.1 19.6 13.4-7 3.2-13.8 7.6-19.6 13.4-25 25-22.6 67.9-22.6 67.9s42.9 2.4 67.9-22.6c1.2-1.2 2.4-2.5 3.5-3.8 16.4 51.8 64.8 89.3 122 89.3zM160 96h144v32H144V96zm97.3 322.6.6-.6 66-66h24.7L383 464h-80.3zm35.5 93.4H448l-14.8-48L384 304h-80l-46.1 46.1L224 384l-33.9-33.9L144 304H64L14.8 464 0 512h50.2zm-57.9-48H65l34.5-112h23.4z" })
  }
), T11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 48v80h.3c-.2 2.6-.3 5.3-.3 8v88l-48 48v32h352v-32l-48-48v-88c0-2.7-.1-5.4-.3-8h.3V48L224 0zm48 128h64l32-32 16 16h48v16c0 44.2-35.8 80-80 80s-80-35.8-80-80m64-136h32v24h24v32h-24v24h-32V96h-24V64h24zm-19 416.9 6.7 7.1H68.5l29.1-80h22.8zm190.5 7.1H252.3l6.7-7.1 68.6-72.9h22.8l29.1 80zm4.5-128h-77.2L257 389l-33 35-33-35-49.9-53H64L17.5 464 0 512H448l-17.5-48z" })
  }
), A11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 48 224 0l128 48v80h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128S96 246.7 96 176v-40c0-2.7.1-5.4.3-8H96zm48 128c0 44.2 35.8 80 80 80s80-35.8 80-80v-16h-48l-16-16-32 32zm64-136v24h-24v32h24v24h32V96h24V64h-24V40zm-19 416.9L105.4 368h-6.8l-32 96h129.1zm192.4 7.1-32-96h-6.8L259 456.9l-6.7 7.1zm-59.5-144H384l48 144 16 48H0l16-48 48-144h62.1l64.9 69 33 35 33-35z" })
  }
), D11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128V48L224 0l128 48v80h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128S96 246.7 96 176v-40c0-2.7.1-5.4.3-8zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144zm64-136v24h-24v32h24v24h32V96h24V64h-24V40zm-19 416.9L105.4 368h-6.8l-32 96h129.1zm192.4 7.1-32-96h-6.8L259 456.9l-6.7 7.1zm-59.5-144H384l48 144 16 48H0l16-48 48-144h62.1l64.9 69 33 35 33-35z" })
  }
), y11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160M99.5 352 65 464h259.3l-6.9 48H0l14.8-48L64 304h320l14.2 46.2-38.4 38.4-11.3-36.6zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0m473 95.8 71 71-41.3 41.3-71-71zm-63.9 63.9 71 71L434.9 500 352 511.9l11.9-82.9 141.2-141.2z" })
  }
), b11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 99.2 48 80V48L224 0l176 48v32l-32 19.2V128c-16 10.7-67.2 32-144 32S96 138.7 80 128zm88.8-40.7-14.3 28.7 14.3 7.2 48 24 7.2 3.6 7.2-3.6 48-24 14.3-7.2-14.3-28.7-14.3 7.2L224 86.1l-40.8-20.4-14.3-7.2zM96 192c0-7.9.7-15.7 2.1-23.2 14 5.4 28.5 9.9 43.3 13.4-.4 3.2-.6 6.5-.6 9.8 0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8 14.8-3.6 29.3-8.1 43.3-13.4 1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192m112 224-32-64h96l-32 64 12.2 48.9.6-.9L320 352h80l33.6 112 14.4 48H0l14.4-48L48 352h80l67.2 112 .6.9zm175.5 48-19.2-64h-17.1l-38.4 64zm-282.7-64H83.7l-19.2 64h74.7l-38.4-64z" })
  }
), f11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48 80 32 19.2V128c16 10.7 67.2 32 144 32s128-21.3 144-32V99.2L400 80V48L224 0 48 48zm135.2-14.3L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6 14.3 7.2zM98.1 168.8c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-14 5.4-28.5 9.9-43.3 13.4.4 3.2.6 6.5.6 9.8 0 46-37.2 83.2-83.2 83.2S140.8 238 140.8 192c0-3.3.2-6.6.6-9.8-14.8-3.6-29.3-8.1-43.3-13.4zm97.1 285.6L208 464H64.5l19.2-64h39zm188.3 9.6H240l12.8-9.6 72.5-54.4h39zM400 352h-90.7L224 416l-85.3-64H48L14.4 464 0 512H448l-14.4-48z" })
  }
), U11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0M65 464h318l-34.5-112h-249zm319-160 49.2 160 14.8 48H0l14.8-48L64 304h160zM224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m280 336v-88h-88v-48h88v-88h48v88h88v48h-88v88z" })
  }
), G11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 99.2 48 80V48L224 0l176 48v32l-32 19.2V128c-16 10.7-67.2 32-144 32S96 138.7 80 128zm147-50.6-3-1.2-3 1.2-32 12.8-5 2v5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8v-5.4l-5-2zM96 192c0-7.9.7-15.7 2.1-23.2 14 5.4 28.5 9.9 43.3 13.4-.4 3.2-.6 6.5-.6 9.8 0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8 14.8-3.6 29.3-8.1 43.3-13.4 1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192m112 224-32-64h96l-32 64 12.2 48.9.6-.9L320 352h80l33.6 112 14.4 48H0l14.4-48L48 352h80l67.2 112 .6.9zm175.5 48-19.2-64h-17.1l-38.4 64zm-282.7-64H83.7l-19.2 64h74.7l-38.4-64z" })
  }
), q11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 99.2 48 80V48L224 0l176 48v32l-32 19.2V128c-16 10.7-67.2 32-144 32S96 138.7 80 128zm147-50.6-3-1.2-3 1.2-32 12.8-5 2v5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8v-5.4l-5-2zM96 192c0-7.9.7-15.7 2.1-23.2 14 5.4 28.5 9.9 43.3 13.4-.4 3.2-.6 6.5-.6 9.8 0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8 14.8-3.6 29.3-8.1 43.3-13.4 1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192m112 272-12.8-9.6-72.5-54.4h-39l-19.2 64zm145 0h30.5l-19.2-64h-39l-72.5 54.4L240 464h63l-8.3-6-12.1-8.7h34.7l6.1-18.8 4.6-14.2 4.6 14.2 6.1 18.8h34.7l-12.2 8.7-8.3 6zm-43.7-112H400l33.6 112 14.4 48H0l14.4-48L48 352h90.7l85.3 64z" })
  }
), W11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 16V0h-32v64H64v256h320V64H240zm96 96v160h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32V112zM83.7 400h280.6l19.2 64H304v-48h-32v48h-32v-48h-32v48h-32v-48h-32v48H64.5zM224 512h224l-14.4-48L400 352H48L14.4 464 0 512h160zM32 128H0v128h32zm416 0h-32v128h32zm-304 5.4L125.4 152l9.3 9.3 14.7 14.7-14.7 14.7-9.3 9.3 18.6 18.6 9.3-9.3 14.7-14.7 14.7 14.7 9.3 9.3 18.6-18.6-9.3-9.3-14.7-14.7 14.7-14.7 9.3-9.3-18.6-18.6-9.3 9.3-14.7 14.7-14.7-14.7zm121.3 9.3-9.3-9.3-18.6 18.6 9.3 9.3 14.7 14.7-14.7 14.7-9.3 9.3 18.6 18.6 9.3-9.3 14.7-14.7 14.7 14.7 9.3 9.3 18.6-18.6-9.3-9.3-14.7-14.7 14.7-14.7 9.3-9.3-18.6-18.6-9.3 9.3-14.7 14.7-14.7-14.7" })
  }
), E11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 16V0h-32v64H64v256h320V64H240zm96 96v160h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32V112zM83.7 400h280.6l19.2 64H304v-48h-32v48h-32v-48h-32v48h-32v-48h-32v48H64.5zM160 512h288l-14.4-48L400 352H48L14.4 464 0 512h50.1zM32 128H0v128h32zm416 0h-32v128h32zm-240 48a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), O11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.1 87.5 160 0l64 32 64-32 38.9 87.5C380.5 96 416 111 416 128c0 13.4-22.1 25.6-57.7 34.3 1.1 7.1 1.7 14.3 1.7 21.7 0 13.9-2.1 27.4-6 40h62l-17.5 48-5.8 16-17.5 48H416l2.9 15.9L439.3 464l8.7 48H0l8.7-48 20.4-112.1L32 336h40.7l-17.4-48-5.8-16L32 224h62c-3.9-12.6-6-26.1-6-40 0-7.4.6-14.6 1.7-21.7C54.1 153.6 32 141.4 32 128c0-17 35.5-32 89.1-40.5M268 464h122.5L376 384h-69.3l23.4-64.4 17.4-47.6h-19.8c-16.9 19.9-39.5 34.9-65.2 42.5L240 352zm-82.5-149.5c-25.7-7.6-48.3-22.6-65.2-42.5h-19.8l17.3 47.6 23.5 64.4H72l-14.5 80H180l28-112zM224 272c34.2 0 63.8-19.5 78.4-48H240l-8-32h-16l-8 32h-62.4c14.6 28.5 44.2 48 78.4 48" })
  }
), I11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V212h24v27.1c38.5-5.8 68-39 68-79.1v-32c0-44.2-35.8-80-80-80M96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v40l32 40v64h-98c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16H64v-64l32-40v-8zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-16 31 8.5 8.5c2 2 6 5.3 10.7 8.1 4.9 2.9 9.4 4.4 12.8 4.4h12v24h-12c-9.5 0-18.3-3.8-24.8-7.6-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204h-12v-24h12c2.1 0 12.9-1.9 23.5-12.5zm16 257c0 8.8-7.2 16-16 16s-16-7.2-16-16h-64l-48 32v-72.2L66.6 464H208c0-8.8 7.2-16 16-16s16 7.2 16 16h141.4L352 375.8V448l-48-32zm64-56-8-8H152l-8 8v8h160zm-192-40 16-16h192l16 16h48l48 144 16 48H0l16-48 48-144z" })
  }
), N11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160M99.5 352h226.4c-3.4-16.1-5.3-32.3-5.7-48H64L14.8 464 0 512h426.1c-19.2-13.7-35.7-30-49.5-48H65zM352 128a128 128 0 1 0-256 0 128 128 0 1 0 256 0m239.3 184.4c-5.2 61-38.8 121.7-95.3 148V275.5zM496 512c96-32 144-130.2 144-216v-16.2L496 224l-144 55.8V296c0 85.8 48 184 144 216" })
  }
), X11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 128c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 5.9 34.6 15.9 47.9l33.5 26c9.4 3.9 19.7 6 30.5 6 44.2 0 80-35.8 80-80zm-46.6 123.6 267.5 207.7 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7L192 126.3C192.9 56.4 249.9 0 320 0c70.7 0 128 57.3 128 128 0 59.1-40.1 108.9-94.6 123.6M324.9 352H195.5L161 464h306.1l60.9 48H96l14.8-48L160 304h104z" })
  }
), K11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160M99.5 352H320v-48H64L14.8 464 0 512h448l-8.3-27.1-72.5-72.5L383 464H65zM352 128a128 128 0 1 0-256 0 128 128 0 1 0 256 0m160 384 128-128-160-160h-96l-32 32v96zM408 304a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Q11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v64l-48 48v32h352v-32l-48-48v-64C352 57.3 294.7 0 224 0m-14.9 359.2-15.9 59.2L144 320H64L16 464 0 512h448l-16-48-48-144h-80l-49.2 98.4-15.9-59.2L272 304h-96zM381.4 464h-95.7l48-96h15.7zm-267.1-96 48 96H66.6l32-96z" })
  }
), Z11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144v-16c0-11.4-2.4-22.2-6.7-32H256l-16-16-32 32h-62.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80M224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16C96 57.3 153.3 0 224 0m-14.9 359.2L176 304h96l-33.1 55.2 15.9 59.2L304 320h80l48 144 16 48H0l16-48 48-144h80l49.2 98.4zM381.4 464l-32-96h-15.7l-48 96zm-267.1-96H98.6l-32 96h95.7l-48-96" })
  }
), J11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160m128-80a128 128 0 1 1-256 0 128 128 0 1 1 256 0M209.1 359.2 176 304h96l-33.1 55.2 15.9 59.2L304 320h80l48 144 16 48H0l16-48 48-144h80l49.2 98.4zM381.4 464l-32-96h-15.7l-48 96zm-267.1-96H98.6l-32 96h95.7l-48-96" })
  }
), j11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160M99.5 352 65 464h319v48H0l14.8-48L64 304h320v48h-64zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0m400 144v48h144v192H416V320h32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80h-48c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), Y11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208c26.2 0 49.4-12.6 64-32H160c14.6 19.4 37.8 32 64 32m0 48c-53.7 0-99.7-33.1-118.7-80H80V48h44.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H368v128h-25.3c-19 46.9-65 80-118.7 80M128 96v32h192V96H144zM65 464h318l-34.5-112h-249zm-1-160h320l49.2 160 14.8 48H0l14.8-48zm222.7 144-6.7-6.7 33.3-73.3 33.3 73.3-6.6 6.7-20-20z" })
  }
), _11 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v64l-48 48v32h352v-32l-48-48v-64C352 57.3 294.7 0 224 0m-38.4 444.8L200 464H66.6l32-96H128zM381.4 464H248l14.4-19.2L320 368h29.4zm2.6-144h-88l-42 56-30 40-30-40-42-56H64L16 464 0 512H448l-16-48z" })
  }
), h21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0m-39.2 451.7 8.7 12.3H66.6l32-96h27.1l59.1 83.7zM381.4 464H254.5l8.7-12.3 59.1-83.7h27.1l32 96zm2.6-144h-86.6l-44 62.4L224 424l-29.4-41.6-44-62.4H64L16 464 0 512H448l-16-48z" })
  }
), c21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160M96 128a128 128 0 1 0 256 0 128 128 0 1 0-256 0m88.1 330.6 3.6 5.4H65l34.5-112H113zm35.5 53.4H448l-14.8-48L384 304h-74.7l-56.5 84.7L224 432l-28.8-43.3-56.5-84.7H64L14.8 464 0 512H219.6zm40.7-48 3.6-5.4L335 352h13.5L383 464H260.4z" })
  }
), s21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0M65 464h318l-34.5-112h-249zm319-160 49.2 160 14.8 48H0l14.8-48L64 304h160zM224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m409.9 160-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), v21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0m-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0M65 464h318l-34.5-112h-249zm-1-160h320l49.2 160 14.8 48H0l14.8-48z" })
  }
), e21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h640v48H0zm0 464h640v48H0zm83.2-304a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 256h139.4l-7.8 20.8-28.2 75.2H32zm411.8 96-28.2-75.2-7.8-20.8H576l32 96zm-58.2-64 24 64 6 16 18 48h-288l18-48 6-16 22.4-59.7 1.6-4.3H416zm17.6-128a64 64 0 1 1 128 0 64 64 0 1 1-128 0M321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160m-74.7 272h149.4l-12-32H258.9l-12 32z" })
  }
), l21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80a80 80 0 1 0-160 0 80 80 0 1 0 160 0m368 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0M196 192H48L0 320h235.3c-26.6-23.5-43.3-57.8-43.3-96 0-11 1.4-21.8 4-32m418.1 59.1L592 192H444c2.6 10.2 4 21 4 32h128v49.1l14.8-8.6 23.3-13.5zM320 128c-53 0-96 43-96 96s43 96 96 96c19.9 0 38.3-6 53.7-16.4l15.8-27.3 16-27.7 6.3 3.7c2.7-8.9 4.2-18.4 4.2-28.2 0-53-43-96-96-96zm25.7 224H176l-33.6 112-14.4 48h273.1l-11.7-20.3-16-27.7H192.5l19.2-64h144.6l12.9-7.4L384 384l-14.9-8.6-27.7-16 4.3-7.4zM272 224a48 48 0 1 1 96 0 48 48 0 1 1-96 0m272 69.5V256h-64v37.5c-11.2 4-21.5 10-30.4 17.6l-32.5-18.7-32 55.4 32.5 18.7c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-32.5 18.7 32 55.4 32.5-18.7c8.9 7.6 19.2 13.6 30.4 17.6V512h64v-37.5c11.2-4 21.5-10 30.4-17.6l32.5 18.7 32-55.4-32.5-18.7c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l32.5-18.7-32-55.4-32.5 18.7c-8.9-7.6-19.1-13.6-30.4-17.6zM472 384a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), t21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M83.2 96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 192h160l10.7 32H203.4l-7.8 20.8-16.2 43.2H32zm399.8 96-16.2-43.2-7.8-20.8h-34.5l10.7-32h160l32 96zm-46.2-32 12 32 18 48 18 48h-288l18-48 18-48 12-32h192zm17.6-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM321.6 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160m-74.7 272h149.4l-12-32H258.9l-12 32zM24 432h616v48H0v-48z" })
  }
), w21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160m368 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160M48 192h148c-2.6 10.2-4 21-4 32 0 38.2 16.8 72.5 43.3 96H0zm592 128h-32v-32H480v32h-75.3c26.6-23.5 43.3-57.8 43.3-96 0-11-1.4-21.8-4-32h148zm-464 32h240v48H211.7l-19.2 64H416v16h64v32H128l14.4-48zm144-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192m192 192h64v64h64v64h-64v64h-64v-64h-64v-64h64z" })
  }
), g21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 6.1 6.1 40 23 57l56 56 17 17 33.9-34L113 79 57 23 40 6.1zm560 0L583 23l-56 56-17 17 34 33.9 17-17 56-56 17-17-34-33.8zM57 489l56-56 17-17-34-33.9L79 399l-56 56-17 17 34 33.9 17-17zm543 17 33.9-34-17-17-56-56-17-17-33.8 34 17 17 56 56 17 17zM260.1 288H224l-20 80-12 48h256l-12-48-20-80h-96zm1.4 48h117l8 32h-133zm13.3-96a72 72 0 1 0 90.5-112.1A72 72 0 1 0 274.7 240zm45.2-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48m200 96h-79l6.1 24.2L461 336h83zm-400 0-24 80h83l14-55.8 6-24.2zm55.8-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96M512 176a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), i21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h640v512H0V24zm48 48v416h544V48zm79.8 112a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-7.8 80h79l-6 24.2-14 55.8H96zm424 80h-83l-14-55.8-6-24.2h79zM416 160a48 48 0 1 1 96 0 48 48 0 1 1-96 0M253.5 352h133l-8-32h-117zM224 272h192l20 80 12 48H192l12-48zm120-104a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0" })
  }
), m21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M202.6 134.5C215.9 120.2 224 101.1 224 80c0-44.2-35.8-80-80-80-28.2 0-53.1 14.6-67.3 36.8l-28.3-22L29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L441.5 320H640l-48-128H444c2.6 10.2 4 21 4 32 0 30.1-10.4 57.7-27.7 79.5L395 283.9c13.1-16.4 21-37.2 21-59.9 0-53-43-96-96-96-31.3 0-59.1 15-76.6 38.2l-40.8-31.7zm78.7 61.1C290 183.7 304.1 176 320 176c26.5 0 48 21.5 48 48 0 11.6-4.1 22.2-10.9 30.5zM48 192 0 320h235.3c-20.6-18.2-35.3-42.8-40.8-70.8L121.8 192zm128 160-33.6 112-14.4 48H512l-5-16.5-65.6-51.7 6.1 20.2h-255l19.2-64h174.1l-60.9-48zm336-192a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), a21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v160h48V48h112V0H24zm640 0H480v48h112v112h48V24zM24 512h136v-48H48V352H0v160zm616 0V352h-48v112H480v48h136zM260.1 288H224l-20 80-12 48h256l-12-48-20-80h-96zm14.6-48a72 72 0 1 0 90.5-112.1A72 72 0 1 0 274.7 240zm-13.3 96h117l8 32h-133l8-32M320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48m200 96h-79l6.1 24.2L461 336h83zm-400 0-24 80h83l14-55.8 6-24.2zm55.8-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96M512 176a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), o21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160M48 192 0 320h235.3c-26.6-23.5-43.3-57.8-43.3-96 0-11 1.4-21.8 4-32zm592 128-48-128H444c2.6 10.2 4 21 4 32 0 38.2-16.8 72.5-43.3 96zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192m-108.3 80h216.6l19.2 64h-255zM464 352H176l-33.6 112-14.4 48H512l-14.4-48z" })
  }
), n21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 352v47.6l76.9 59.7 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1l19 14.7 66.7 51.8L122.5 0h48.3l-11.2 101.1 40.4 31.4V0h48v169.8l43.1 33.5c3.1-5.7 4.9-12.3 4.9-19.2v-14.8L280.2 26.7l-3-26.7h48.3l2.4 21.3 16 144 .1 1.3V184c0 18.1-5.4 34.9-14.8 48.8l54.8 42.6V176C384 57.1 460.4 14.5 496 3.3 503.5 1 509.2 0 512 0h32v304zM104 184v-6.1l144 113.5V512h-48V272h-8c-48.6 0-88-39.4-88-88m328-8v128h64V55.1c-7.1 3.6-14.9 8.5-22.6 15.2-19.7 17.1-41.4 48-41.4 105.7" })
  }
), r21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M8.1 165.3 26.5 0h48.3L56 169.3V184c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-14.7L184.1 26.7 181.2 0h48.3l2.4 21.3 16 144 .1 1.3V184c0 48.6-39.4 88-88 88h-8v240h-48V272h-8c-48.6 0-88-39.4-88-88v-17.3l.1-1.3zM104 24V0h48v192h-48v-24zm232 152v128h64V55.1c-7.1 3.6-14.9 8.5-22.6 15.2-19.7 17.1-41.4 48-41.4 105.7m64 176H288V176C288 57.1 364.4 14.5 400 3.3 407.5 1 413.2 0 416 0h32v512h-48v-24z" })
  }
), d21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v80H128V32H80v48H48V32H0v96h83.2L232 227.2V272H128v-48H80v48H48v-48H0v96h83.2L232 419.2V512h48v-92.8L428.8 320H512v-96h-48v48h-32v-48h-48v48H280v-44.8L428.8 128H512V32h-48v48h-32V32h-48v48H280zm91.2 104L280 188.8V128zM232 188.8 140.8 128H232zM371.2 320 280 380.8V320zM232 380.8 140.8 320H232z" })
  }
), S21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24V0h-48v80H128V32H80v48H48V32H0v96h83.2L232 227.2V512h48V227.2L428.8 128H512V32h-48v48h-32V32h-48v48H280zm91.2 104L280 188.8V128zM232 188.8 140.8 128H232z" })
  }
), z21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M329.3 32 192 389.1 54.7 32H3.3l166.3 432.6 5.9 15.4h33l5.9-15.4L380.7 32z" })
  }
), p21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m335-79c-43.6-43.6-114.4-43.6-158.1 0L143 143c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9L335 335c43.6-43.6 43.6-114.4 0-158.1zm-111 24.4 11.3 11.3 64 64 11.3 11.3-22.6 22.6-11.3-11.3-64-64-11.3-11.3zm-80 16 11.3 11.3 128 128 11.3 11.3-22.6 22.6-11.3-11.3-128-128-11.3-11.3zm-16 80 11.3 11.3 64 64 11.3 11.3-22.6 22.6-11.3-11.3-64-64-11.3-11.3z" })
  }
), M21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.4 48H528c35.3 0 64 28.7 64 64 0 30.7-21.7 56.5-50.6 62.6-33.6-29-77.5-46.6-125.4-46.6h-64v164c10.2-2.6 21-4 32-4 5.4 0 10.8.3 16 1V176h16c79.5 0 144 64.5 144 144v144h-57.3c-7.5 18.6-19.3 35-34 48H608V320c0-39.5-11.9-76.1-32.3-106.6 38-17.9 64.3-56.6 64.3-101.4C640 50.1 589.9 0 528 0H204.6l-4 19-43.7 205H206zm-44.2 208h-49.1l-27.2 128H64L0 448v64h224V384h-52.1l27.2-128zM384 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192M51.9 464l32-32H176v32H51.9zM400 416a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), x21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32v448H0V32zm287 111 17-17 33.9 34-17 17-79 79 79 79 17 17-33.9 33.9-17-17-79-79-79 79-17 17-33.9-33.9 17-17 79-79-79-79-17-17 33.9-33.9 17 17 79 79 79-79zm177-87v424h-48V32h48z" })
  }
), H21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v352h64c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h64V207.2l-5.7-6.7-136-160-7.2-8.5H200zm456 256c-35.5 0-66.6 19.3-83.2 48H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48v-96h544v96h-28.8c-16.6-28.7-47.6-48-83.2-48zM48 192V80h128v112zm176 0V80h112v112zm160 0V80h84.9l95.2 112zm48 192a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-272-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), V21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v384h480V48zM0 0h576v480h-64v32h-48v-32H112v32H64v-32H0V48zm320 240a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-240 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96m272-16c0 17.8-9.7 33.3-24 41.6V352h-48V217.6c-14.3-8.3-24-23.8-24-41.6 0-26.5 21.5-48 48-48s48 21.5 48 48" })
  }
), C21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 40v48h48V40zM192 0h128v49.6c67.8 21 121.4 74.5 142.4 142.4H512v128h-49.6c-21 67.8-74.5 121.4-142.4 142.4V512H192v-49.6c-67.8-21-121.4-74.6-142.4-142.4H0V192h49.6c21-67.8 74.6-121.4 142.4-142.4V40zm0 100.6c-41.3 17-74.3 50.1-91.4 91.4H128v128h-27.4c17 41.3 50.1 74.3 91.4 91.4V384h128v27.4c41.3-17 74.3-50.1 91.4-91.4H384V192h27.4c-17-41.3-50.1-74.3-91.4-91.4V128H192zM472 232h-48v48h48zM280 424h-48v48h48zM88 232H40v48h48z" })
  }
), L21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 72v48h-48V72zm-48-40h-40v40H128V32H0v128h40v192H0v128h128v-40h192v40h128V352h-74.4L352 316V196l21.6-36H448V32h-40zm-61.6 288 21.6 36v36H128v-40H88V160h40v-40h192v36l-21.6 36H224v128h40zM40 392h48v48H40zm320 0h48v48h-48zM40 72h48v48H40zm272 160v48h-48v-48z" })
  }
), B21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 72v48h-48V72zm-48-40h-40v40H128V32H0v128h40v192H0v128h128v-40h192v40h128V352h-40V160h40V32h-40zM88 352V160h40v-40h192v40h40v192h-40v40H128v-40zm-48 40h48v48H40zm320 0h48v48h-48zM40 72h48v48H40z" })
  }
), u21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 112v288H112V112zM112 64H64v96H0v192h64v96h512v-96h64V160h-64V64h-48zm72 80h-24v48h320v-48h-24zm0 88h-24v48h320v-48h-24zm0 88h-24v48h320v-48h-24z" })
  }
), R21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256m176-128c0 89.1-66.2 162.7-152 174.4V400h72v48h-72v64h-48v-64H96v-48h72v-49.6C82.2 338.7 16 265.1 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176m-24 142c10.9-11.7 20.5-24.6 28.5-38.6 21.2 15.5 47.3 24.6 75.5 24.6 70.7 0 128-57.3 128-128S518.7 48 448 48c-28.2 0-54.3 9.1-75.5 24.6-8-14-17.6-26.9-28.5-38.6 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 89.1-66.2 162.7-152 174.4V400h72v48h-72v64h-48v-64h-72v-48h72v-49.6c-29.7-4-57-15.5-80-32.4" })
  }
), $21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256m176-128c0 89.1-66.2 162.7-152 174.4V400h72v48h-72v64h-48v-64H80v-48h72v-49.6C66.2 338.7 0 265.1 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176m-80.1 184.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1.9-25.2 2.5-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48H480V0h160v160h-48V81.9l-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4" })
  }
), k21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0m152 174.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V400H96v48h72v64h48v-64h72v-48h-72z" })
  }
), P21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m178.4 81.1 28.9 95.4-25.1 82.8-64-211.3H96v158.6l-3.4 5.7L48 286.6V464h128v48H0V273.4l3.4-5.7L48 193.4V0H158.9l6 14.2.1.1c.2.4.7 1.2 1.4 2.3 1.5 2.2 4.1 5.4 8.3 8.8C182.6 31.9 197.5 40 224 40s41.4-8.1 49.3-14.6c4.1-3.4 6.8-6.6 8.3-8.8.7-1.1 1.2-1.9 1.4-2.3l.1-.1 6-14.2H400v193.4l44.6 74.3 3.4 5.7V512H208V284.4l1-3.4 60.6-200c-12.7 4.3-27.8 7-45.6 7s-32.9-2.7-45.6-6.9M329.8 48 256 291.6V464h144V286.6l-44.6-74.3-3.4-5.7V48zM288 288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56zm-180.7-27.3 12.7 12.7 12.7-12.7 11.3-11.3 22.6 22.6-11.3 11.3-12.7 12.7 12.7 12.7 11.3 11.3-22.6 22.6-11.3-11.3-12.7-12.7-12.7 12.7L96 342.6 73.4 320l11.3-11.3L97.4 296l-12.7-12.7L73.4 272 96 249.4zM72 400a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), F21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M143 0h15.9l6 14.2.1.1c.2.4.7 1.2 1.4 2.3 1.5 2.2 4.1 5.4 8.3 8.8C182.6 31.9 197.5 40 224 40s41.4-8.1 49.3-14.6c4.1-3.4 6.8-6.6 8.3-8.8.7-1.1 1.2-1.9 1.4-2.3l.1-.1 6-14.2H400v193.4l44.6 74.3 3.4 5.7V512H208V284.4l1-3.4 60.6-200c-12.7 4.3-27.8 7-45.6 7s-32.9-2.7-45.6-6.9l28.9 95.4-25.1 82.8-64-211.3H96v158.6l-3.4 5.7L48 286.6v111.5l55-55 17-17 33.9 33.9-17 17-87 87H176v48H0V273.4l3.4-5.7L48 193.4V0h88zm186.8 48L256 291.6V464h142.1l-87-87-17-17 33.9-33.9 17 17 55 55V286.6l-44.6-74.3-3.4-5.7V48z" })
  }
), T21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h256v48h-32v186.8c-20.2 28.6-32 63.5-32 101.2 0 25.2 5.3 49.1 14.8 70.8-17.3 24.9-46.2 41.2-78.8 41.2-53 0-96-43-96-96V80H0zm80 48v112h96V80zm0 160v144c0 26.5 21.5 48 48 48s48-21.5 48-48V240zm144 128a144 144 0 1 1 288 0 144 144 0 1 1-288 0m222.6-32L424 313.4l-11.3 11.3-60.7 60.7-28.7-28.7-11.3-11.3-22.6 22.6 11.3 11.3 40 40 11.3 11.3 11.3-11.3 72-72z" })
  }
), A21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32H0v48h32v304c0 53 43 96 96 96 22.6 0 43.3-7.8 59.7-20.8l-11-11 39.6-39.6.6-.6h-47.3c-8.3 14.3-23.8 24-41.6 24-26.5 0-48-21.5-48-48V240h96v16l16-16 .2.3 31.8-31.8V80h32V32H80zm48 160V80h96v112zm136 184c28.8 0 43.2 34.8 22.9 55.2l-17 17 17 17 17 17 17-17c20.4-20.4 55.2-5.9 55.2 22.9V512h48v-24.2c.1-28.7 34.9-43 55.2-22.7l17 17 17-17 17-17-17-17c-20.5-20.3-6.1-55.1 22.7-55.1h24v-48h-24.1c-28.8 0-43.2-34.8-22.8-55.2l17-17-17-17-17-17-17 17c-20.3 20.3-55.1 6-55.2-22.7V192H328v24c0 28.8-34.8 43.2-55.2 22.9l-17-17-17 17-17 17 17 17c20.4 20.4 6 55.2-22.8 55.2h-24v48h24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64m40 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), D21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m340.2 18.2-17-17-33.9 34 17 17 3.8 3.8L30.2 335.8C10.9 355.2 0 381.4 0 408.8 0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l3.8 3.8 17 17 33.9-33.9-17-17L473 151 361 39zM177.9 256 344 89.9l78.1 78.1-88 88z" })
  }
), y21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h224v48h-32v320c0 44.2-35.8 80-80 80s-80-35.8-80-80V80H0zm80 48v176h64V80zm208-48h224v48h-32v320c0 44.2-35.8 80-80 80s-80-35.8-80-80V80h-32zm80 48v176h64V80z" })
  }
), b21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112v288H48V112zM48 64H0v384h384V64h-48zm480 306.3-112-56V368l112 56 48 24V64l-48 24-112 56v53.7l112-56zM232 352h24v-48h-78.1L281 201l17-17-34-33.9-17 17-103 103V192H96v160h24z" })
  }
), f21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112v288H48V112zM48 64H0v384h384V64h-48zm480 306.3-112-56V368l112 56 48 24V64l-48 24-112 56v53.7l112-56zM152 160h-24v48h78.1L103 311l-17 17 34 33.9 17-17 103-103V320h48V160h-24z" })
  }
), U21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112v288H48V112zM48 64H0v384h384V64h-48zm480 306.3-112-56V368l112 56 48 24V64l-48 24-112 56v53.7l112-56zM216 184v-24h-48v72H96v48h72v72h48v-72h72v-48h-72z" })
  }
), G21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m29.4.1 19 14.7L111.8 64H416v236.2L560 412V141.7l-112 56V144l112-56 48-24v385.3l12.9 10 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4.1zM368 262.9V112H173.6zM416 440v8H32V121.2L80 159v241h288v-14.1l48 37.8z" })
  }
), q21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 112v288h288V112zM0 64h384v384H0V112zm416 250.3 112 56V141.7l-112 56V144l112-56 48-24v384l-48-24-112-56z" })
  }
), W21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M333.8 12.3 320 2.7l-13.8 9.6c-47.3 33.2-108.7 52.2-168.5 68.5l-9.7 2.7v49.8l22.3-6.1c3.2-.9 6.4-1.8 9.7-2.7v49.8c-31.3 29-70.1 48.9-112.1 57.3l-4.6.9-11.3 2.2V288h64v48.6c-22.8 28.7-53.9 49.7-89.1 60.3l-6.9 2V448h64v64h48v-64h184v64h48v-64h184v64h48v-64h64v-49.1l-6.9-2.1c-35.2-10.6-66.3-31.6-89.1-60.3V288h64V233.1l-3.7-.7-9.9-1.8c-42.7-7.8-82.3-27.4-114.4-56.5v-49.6c3.3.9 6.5 1.8 9.7 2.7l22.3 6.1V83.5l-9.7-2.6c-59.8-16.4-121.2-35.4-168.5-68.6zM496 288v32H144v-32h200zm-63.9-177.7c0 .6-.1 1.1-.1 1.7v48H208v-48c0-.6 0-1.2-.1-1.7 38.3-12.4 77.5-27.9 112.1-49.5 34.6 21.6 73.8 37.2 112.1 49.5zM487.9 240H153.1c14.6-9.3 28.4-20 41.1-32H445.9c13 12 27.1 22.7 42 32m19.8 128c9.5 11.7 20.1 22.4 31.6 32H100.7c11.5-9.6 22.1-20.3 31.6-32H344z" })
  }
), E21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M333.8 52.2 52.2 333.8l-17 17-33.9-34 17-17L299.8 18.2l17-17 33.9 33.9-17 17zM176 512l-48-48 27.6-22.1C138.2 416.3 128 385.3 128 352c0-50 22.9-94.6 58.8-123.9 10.5 7.5 23.3 11.9 37.2 11.9 35.3 0 64-28.7 64-64 0-1.6-.1-3.2-.2-4.8l.5-.5c41.7-41.7 108-44.7 157.4-10.3L583 23l17-17 33.9 34L617 57 479.7 194.3c34.4 49.3 31.3 115.7-10.3 157.4l-.5.5c-1.6-.1-3.2-.2-4.8-.2-35.3 0-64 28.7-64 64 0 13.9 4.4 26.7 11.9 37.2-29.4 35.9-74 58.8-124 58.8-33.3 0-64.3-10.2-89.9-27.6zm52.2-65.3c17.3 11 37.8 17.3 59.8 17.3 25.1 0 48.3-8.2 67-22.2-2-8.3-3-16.9-3-25.8 0-55.4 40.2-101.3 92.9-110.4 13.3-21.7 14.3-51.1 0-76.6l-84 84-17 17-33.8-34 17-17 84-84c-25.5-14.3-54.9-13.3-76.6 0-9.1 52.8-55 92.9-110.4 92.9-8.9 0-17.5-1-25.8-3-14 18.7-22.2 41.9-22.2 67 0 22 6.3 42.5 17.3 59.8L208 400l32 32zM448 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), O21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0h-24v48h40v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3 17-17-34-34-17 17-34 34-84.8-65.9L29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L472.4 344c11.2-19.3 18.8-41 21.9-64H528v40h48V192h-48v40h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3 17 17 33.9-33.9-17-17-56.5-56.6-17-17-33.9 34 17 17L450.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h40V0h-24zm154 314.2L235.4 160c22.6-19.9 52.2-32 84.6-32 70.7 0 128 57.3 128 128 0 21-5 40.7-14 58.2M145.6 232H112v-40H64v128h48v-40h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3-17-17-34 34 17 17 56.6 56.6 17 17 33.9-33.9-17-17-11.3-11.5 23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-40v48h128v-48h-40v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9c-12.1 3.7-24.9 5.7-38.2 5.7-70.7 0-128-57.3-128-128 0-2.9.1-5.7.3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5z" })
  }
), I21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0h-24v48h40v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3 17-17-34-34-17 17-56.5 56.6-17 17 33.9 33.9 17-17L92 125.9l23.8 23.8c-17.9 23.5-30 51.6-34.2 82.3H48v-40H0v128h48v-40h33.6c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1l-11.4-11.3-17-17-33.9 34 17 17 56.6 56.6 17 17 33.9-33.9-17-17-11.3-11.5 23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-40v48h128v-48h-40v-33.6c30.7-4.2 58.8-16.3 82.3-34.1l23.8 23.7-11.3 11.3-17 17 33.9 33.9 17-17 56.6-56.6 17-17-33.9-33.9-17 17-11.4 11.4-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3H464v40h48V192h-48v40h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3 17 17 33.9-33.9-17-17-56.5-56.6-17-17-33.9 34 17 17L386.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h40V0h-24zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), N21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L48.4 14.8z" })
  }
), X21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 468.5c0-49.9-60.3-74.9-95.6-39.6l-30.8 30.7-45.2-45.2 30.8-30.8c35.2-35.3 10.2-95.6-39.7-95.6H0v-64h43.5c49.9 0 74.8-60.3 39.6-95.6L52.4 97.6l45.2-45.2 30.8 30.8c35.3 35.2 95.6 10.2 95.6-39.7V0h64v43.5c0 49.9 60.3 74.8 95.6 39.6l30.8-30.8 45.3 45.3-30.8 30.8c-35.3 35.3-10.3 95.6 39.6 95.6H512v64h-43.5c-49.9 0-74.9 60.3-39.6 95.6l30.8 30.8-45.3 45.3-30.8-30.8c-35.3-35.3-95.6-10.3-95.6 39.6V512h-64zm32-56c23.3-36.4 68.4-55.1 110.6-45.8-9.3-42.2 9.4-87.3 45.8-110.6-36.4-23.3-55.1-68.4-45.8-110.6-21.2 4.7-43.1 2.3-62.6-5.8-19.4-8.1-36.4-21.8-48-40-23.3 36.4-68.4 55.1-110.6 45.8 9.3 42.2-9.4 87.3-45.8 110.6 36.4 23.3 55.1 68.4 45.8 110.6 42.2-9.3 87.3 9.4 110.6 45.8zM192 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0m88 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), K21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M345.6 216c-35.6 0-52.6 43.1-27.4 68.3l26.5 26.5-33.9 33.9-26.5-26.5C259 293 216 310 216 345.6V384h-48v-38.4c0-35.6-43.1-52.6-68.3-27.4l-26.5 26.5-33.9-33.9 26.5-26.5C91 259.1 74 216 38.4 216H0v-48h38.4c34.5 0 56.2-37.6 30-65.6-.8-.9-1.7-1.8-2.6-2.6L39.3 73.2l33.9-33.9 26.5 26.5C124.9 91 168 74 168 38.4V0h48v38.4c0 35.6 43.1 52.6 68.3 27.4l26.5-26.5 33.9 33.9-26.5 26.5C293 124.9 310 168 345.6 168H384v48zm-60.4-24c-17.8-17.3-27.3-41.9-26.5-66.7-11.2.4-22.3-1.4-32.8-5-12.7-4.5-24.4-11.7-33.9-21.5-16.7 17.2-40.4 26.7-64.4 26.6.7 13.2-1.8 26.4-7.4 38.9-5 10.9-12.1 20.5-20.8 28.3 17.4 17.2 26.7 41.6 25.9 66.1 24.8-.8 49.4 8.8 66.7 26.5 17.3-17.8 41.9-27.3 66.7-26.5-.8-24.8 8.8-49.4 26.5-66.7zM176 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48m48 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32m385.1 85.5-11.3 11.3C574.5 312.1 591 352 624 352h16v32h-16c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-22.6 22.6-11.3-11.3C551.9 446.5 512 463 512 496v16h-32v-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-22.6-22.6 11.3-11.3C417.5 423.9 401 384 368 384h-16v-32h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 22.6-22.6 11.3 11.3C440.1 289.5 480 273 480 240v-16h32v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3zM480 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Q21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192m107.3 192c22.8-25.5 36.7-59.1 36.7-96 0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144h352c79.5 0 144-64.5 144-144S575.5 96 496 96s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), Z21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31c11.2-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64h-48l-32 48h-32l-32-48zM48 458.2v5.8h416v-5.8L361.3 342.7 336 368h-32l-64-64h-54.9zM192 224h128l192 216v72H0v-72z" })
  }
), J21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m378.8 423.9-5.4-.7-181.8-23.5-5.1 52.4c21.7 7.7 45.1 11.9 69.5 11.9 45.9 0 88.4-14.9 122.8-40.1zm63.4-75c12.1-24.2 19.6-51 21.4-79.4L410 293.9l-6 2.7-6.6-.7-130.3-14.5-53.5 72.8 160 20.7 68.6-25.9zm18.4-130.8C448 149.7 401.9 93 340 65.7l2.1 5.1 70.5 169.1 47.9-21.8zM140.5 429l5.7-58.7.6-6.6 3.9-5.3 77.6-105.5-36.2-82.7-97.8 128.2-11.8 72.3c15.3 23.1 35.1 42.9 58.1 58.3zM49.2 278.3l3.3-4.3 111.2-145.6L121 97.8C76.3 135.9 48 192.7 48 256c0 7.6.4 15 1.2 22.3M163.9 69.5l48 34.3 5.4 3.8 2.6 6 52.6 120 89.8 10-62-148.9-56.9-46.3c-28.4 1.7-55.4 9.1-79.6 21.1zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), j21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M592 256c0 78.5-37.7 148.2-96 192l28.8 38.4C594.7 433.9 640 350.3 640 256.1v-.2c0-94.2-45.3-177.8-115.2-230.3L496 64c58.3 43.8 96 113.5 96 192M438.4 371.2l28.8 38.4c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2M400 256c0 15.7-7.5 29.6-19.2 38.4l28.8 38.4c23.3-17.5 38.4-45.4 38.4-76.8s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4m-240.1 60.1L146.2 304H48v-96h98.2l13.6-12.1L272 96.2v319.6zM0 352h128l144 128h48V32h-48L128 160H0v144z" })
  }
), Y21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M159.9 316.1 146.2 304H48v-96h98.2l13.6-12.1L272 96.2v319.6zM0 352h128l144 128h48V32h-48L128 160H0v144zm409.6-19.2c23.3-17.5 38.4-45.4 38.4-76.8s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4z" })
  }
), _21 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m146.2 304 13.6 12.1L272 415.8V96.2l-112.1 99.7-13.7 12.1H48v96h80zM48 352H0V160h128L272 32h48v448h-48L128 352z" })
  }
), h41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-95.1-73.8C557 351.3 576 305.9 576 256c0-62.8-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2 0 38.8-15.3 74-40.3 99.9l-38.2-29.7c18.8-17.5 30.5-42.5 30.5-70.2 0-31.4-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l5.9 7.9-66.7-51.8V32h-48l-108.8 96.7L48.4 14.8zm185.3 143.9L304 96.2v117l-70.3-54.6zM80 160H32v192h128l144 128h48V373.3l-48-37.8v80.3l-112.1-99.7-13.7-12.1H80v-96h62.1l-60.9-48z" })
  }
), c41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M159.9 316.1 146.2 304H48v-96h98.2l13.6-12.1L272 96.2v319.6zM0 352h128l144 128h48V32h-48L128 160H0v144zm441-169-17-17-33.9 34 17 17 39 39-39 39-17 17 33.9 33.9 17-17 39-39 39 39 17 17 33.9-33.9-17-17-39-39 39-39 17-17-33.9-33.9-17 17-39 39-39-39z" })
  }
), s41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M191.9 316.1 178.2 304H80v-96h98.2l13.6-12.1L304 96.2v319.6zM32 352h128l144 128h48V32h-48L160 160H32v144zm409.6-19.2c23.3-17.5 38.4-45.4 38.4-76.8s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4zm57.6 76.8c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2l28.8 38.4z" })
  }
), v41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M346.8 341.7 400 448h240V64H0v384h240l53.2-106.3.2-.3L304 320h32l10.7 21.3.2.3zM210.3 400H48V112h544v288H429.7l-50.8-101.5-13.2-26.5h-91.4L261 298.5zM224 240a64 64 0 1 0-128 0 64 64 0 1 0 128 0m256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), e41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M145.2 463.4 5.2 32h50.5l111.4 343.5L265 49.1l5.1-17.1h35.7l5.2 17.1 97.9 326.4L520.3 32h50.5l-140 431.4-5.4 16.6h-35.3l-5.1-17.1-97-323.4-97 323.4-5.1 17.1h-35.3z" })
  }
), l41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176-144v32h64V96h32v48h64V96h32v48h48v32h-48v64h48v32h-48v64h48v32h-48v48h-32v-48h-64v48h-32v-48h-64v48h-32v-48H96v-32h48v-64H96v-32h48v-64H96v-32h48V96h32zm0 128h64v-64h-64zm96 0h64v-64h-64zm0 32v64h64v-64zm-32 0h-64v64h64z" })
  }
), t41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m.2 1.3 33.2 2L248.7 16h142.6L606.6 3.6l33.2-1.9-8.6 32.1L567.3 272h8.7v48h-33.6c20.7 20.3 33.6 48.7 33.6 80 0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96h-66.2c-7.8 54.3-54.4 96-110.9 96-61.9 0-112-50.1-112-112 0-31.3 12.9-59.7 33.6-80H64v-48h8.7L8.8 33.4.2 1.3zM517.6 272l58.6-218.6L416 62.7V272zM272 272h96V64h-96zM63.8 53.1 122.4 272H224V62.6L63.8 53.1zM160 416h-46c5.8 22.5 23.5 40.2 46 46zm0-32v-46c-22.5 5.8-40.2 23.5-46 46zm32 78c22.5-5.8 40.2-23.5 46-46h-46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46m256 124v-46h-46c5.8 22.5 23.5 40.2 46 46m-46-78h46v-46c-22.5 5.8-40.2 23.5-46 46m124 32h-46v46c22.5-5.8 40.2-23.5 46-46m0-32c-5.8-22.5-23.5-40.2-46-46v46z" })
  }
), w41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M116.9 0H408v388.7c23.5 9.5 40 32.5 40 59.3 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V224H115L55.4 485.3l-5.3 23.4-46.8-10.6 5.3-23.4 104-456zm9.1 176h234V48H155.1l-29.2 128zm258 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), g41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0v96h48V64h64v32h32V64h64v32h64v225.9l-7 7-25 25V512H32V353.9L7 329l-7-7V96h64V0zM48 144v158.1l25 25 7 7V464h224V334.1l7-7 25-25V144H64zm88 48h136v48H112v-48zm0 80h136v48H112v-48z" })
  }
), i41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v448h512V128H96v48h368v256H48V80h432V32h-24zm360 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), m41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.7 42.7 256 0l21.3 42.7L320 64l-42.7 21.3L256 128l-21.3-42.7L192 64zM64 96l32-64 32 64 64 32-64 32-32 64-32-64-64-32zm384 192 32 64 64 32-64 32-32 64-32-64-64-32 64-32zM177.9 478.1 144 512l-33.9-33.9-44.2-44.2L32 400l33.9-33.9L398.1 33.9 432 0l33.9 33.9L510 78l34 34-33.9 33.9-332.2 332.2M357.1 231 313 186.9 99.9 400l44.1 44.1zm33.9-33.9 85.1-85.1L432 67.9 346.9 153z" })
  }
), a41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112 512 33.9-33.9 332.2-332.2L512 112l-33.9-33.9-44.2-44.2L400 0l-33.9 33.9L33.9 366.1 0 400l33.9 33.9L78 478zm247-314.9L314.9 153 400 67.9l44.1 44.1zM325.1 231 112 444.1 67.9 400 281 186.9z" })
  }
), o41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 476.1 112 512l-34-34-44-44-34-34 35.9-32L96 314.3V256h65.3L448 0l64 64-64 71.7V192h-50.3zM444.7 67.3 69.9 402l40.1 40.1L444.7 67.3M432 448l-24-56-56-24 56-24 24-56 24 56 56 24-56 24zM56 168 0 144l56-24 24-56 24 56 56 24-56 24-24 56zm152-72-16-32-32-16 32-16 16-32 16 32 32 16-32 16z" })
  }
), n41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m112 512 32-35.9L397.7 192H448v-56.3L512 64 448 0 161.3 256H96v58.3L35.9 368 0 400l34 34 44 44zm-2-69.9L69.9 402 444.7 67.3z" })
  }
), r41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 6.1 9 3.7 296 120 15 6.1V512h-48V168.2L320 57.9 48 168.2V512H0V135.8l15-6.1L311 9.8l9-3.7zM96 192h448v320h-48V240H144v272H96V216zm224 96v96H176v-96zm144 128v96H352v-96zm-288 0h144v96H176z" })
  }
), d41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 6.1 9 3.7 296 120 15 6.1V512h-48V168.2L320 57.9 48 168.2V512H0V135.8l15-6.1L311 9.8l9-3.7zM96 192h448v320H96V216zm48 272h352v-40H144zm0-88h352v-48H144zm0-96h352v-40H144z" })
  }
), S41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48v416h352V48zM0 0h448v512H0V48zm104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48m56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-16 152c32 0 56 16 80 32s48 32 80 32c3.6 0 7.1-.1 10.6-.3 3.5-9.9 5.4-20.6 5.4-31.7 0-53-43-96-96-96-42 0-77.6 26.9-90.7 64.4 3.6-.3 7.2-.4 10.7-.4zm80-112a144 144 0 1 1 0 288 144 144 0 1 1 0-288" })
  }
), z41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H64v64H0v384h64v64h256v-64h64V64h-64zm16 112v288H48V112zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-168a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-8 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0m120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), p41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H64v64H0v384h64v64h256v-64h64V64h-64zm16 112v288H48V112zm-40 48H88v64h208zM88 248v48h48v-48zm128 0h-48v48h48zm32 0v48h48v-48zm-112 64H88v48h48zm32 0v48h48v-48zm128 0h-48v48h48z" })
  }
), M41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H64v64H0v384h64v64h256v-64h64V64h-64zm16 112v288H48V112zM93.7 225.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4 11 10.2 10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8 0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9L192 193l-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8z" })
  }
), x41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h256v64h64v384h-64v64H64v-64H0V64h64zM48 112v288h288V112zm168 72v60.8l39.4 32.8 18.4 15.4-30.7 36.9-18.4-15.4-48-40-8.6-7.2V160h48v24z" })
  }
), H41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H64v112h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144h-1v112h256V400h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1zM48 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0m168-80v-24h-48v116.8l10.7 7.1 48 32 20 13.3 26.6-39.9-20-13.3-37.3-24.8z" })
  }
), V41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 0v161.7l47.9-43.5 17.8-16.1 32.3 35.5-17.8 16.1-88 80-16.2 14.7-16.1-14.7-88-80-17.8-16.1 32.3-35.5 17.8 16.1 47.8 43.5V0zM96 478.2c-4.7 3.3-10.4 7-16.9 10.7C59.7 499.8 31.5 512 0 512v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7zM79 360.9C59.7 371.8 31.5 384 0 384v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), C41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 256V89.5l47.9 43.5 17.8 16.1 32.3-35.5-17.9-16.2-88-80L288 2.8l-16.1 14.6-88 80-17.8 16.1 32.3 35.5 17.7-16L264 89.5V256zM96 478.2c4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1 6.5-3.7 12.2-7.4 16.9-10.7zM79 360.9c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.7 3.3 10.5 7 16.9 10.7 19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7 4.8 3.3 10.5 7 17 10.7 19.3 11 47.6 23.1 79.1 23.1v-48c-19.7 0-39.5-7.8-55.4-16.9-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7.6c-13 11.6-24.6 22-40 30.7-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4.4c-13 11.6-24.8 22.2-40.2 30.9C39.5 328.2 19.7 336 0 336v48c31.5 0 59.7-12.2 79-23.1" })
  }
), L41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 128c0-53 43-96 96-96s96 43 96 96v32h-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v96.2h208V128c0-53 43-96 96-96s96 43 96 96v32h-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v241c-2.4 1.3-4.8 2.5-7.3 3.7-13.1 6-27.7 10.3-40.7 10.3V272.2H176v109c-8.3-1.8-16.8-4.8-24.7-8.5-8.1-3.7-15.2-8.1-23.3-13.7V248.2zM79 456.9C59.7 467.8 31.5 480 0 480v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.8 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), B41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 126.2c-4.7 3.3-10.4 7-16.9 10.7C59.7 147.8 31.5 160 0 160v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7zm0 288c-4.7 3.3-10.4 7-16.9 10.7C59.7 435.8 31.5 448 0 448v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7zM79 280.9C59.7 291.8 31.5 304 0 304v-48c19.7 0 39.4-7.8 55.3-16.9 15.4-8.7 27.2-19.3 40.2-30.9l.4-.4.4.4c13 11.6 24.9 22.2 40.3 30.9 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6.7.6c13 11.6 24.6 22 40 30.7 15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.4 7-16.9 10.7" })
  }
), u41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 464c141.4 0 256-114.6 256-256 0-49.2-13.9-95.2-37.9-134.2L398.9 101c21 33.3 33.1 72.7 33.1 115 0 119.3-96.7 216-216 216-42.3 0-81.7-12.1-115-33.1l-27.2 27.2c39 24.1 85 37.9 134.2 37.9M35.2 396.8l28.1-28.1 33.9-33.9L334.8 97.2l33.9-33.9 28.1-28.1 34-34c11 11.8 21 24.5 30 37.9C493.1 87.4 512 145.5 512 208c0 167.9-136.1 304-304 304-62.5 0-120.6-18.9-168.9-51.2-13.4-9-26.1-19-37.9-30l34-34zM216 384c92.8 0 168-75.2 168-168 0-28.9-7.3-56.2-20.2-79.9l-22.6 22.6 6.1 6.1 11.3 11.2-22.6 22.6-11.3-11.3-6.1-6.1-57.4 57.4 6.1 6.1 11.3 11.3-22.6 22.6-11.3-11.3-6.1-6.1-57.4 57.4 6.1 6.1 11.3 11.3-22.6 22.6-11.3-11.3-6.1-6.1-22.6 22.6c23.8 12.9 51 20.2 79.9 20.2zm115.3-155.3 16 16 11.3 11.3-22.6 22.6-11.3-11.3-16-16-11.3-11.3 22.6-22.6 11.3 11.3zm-80 80 16 16 11.3 11.3-22.6 22.6-11.3-11.3-16-16-11.3-11.3 22.6-22.6z" })
  }
), R41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M291.8 0h55.5l4.1 18.9 69.2 318.2 37.2-90.3 6.1-14.9H640v48H496.1l-49.9 121.2-6.1 14.9H388.7l-4.1-18.9-62.8-288.7-66.1 383.7-3.5 19.9h-55.1l-4.4-18.4L141.1 280H0v-48h178.9l4.4 18.4 38.1 157.8 66.9-388.3z" })
  }
), $41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M47.3 245.6 24 240 .7 234.4V234.1l.1-.5c.1-.4.2-1 .4-1.7.4-1.4.9-3.4 1.6-5.9 1.4-5 3.6-12 6.5-20.4 5.8-16.7 14.9-39.1 27.8-61.7C62.3 100.2 106.5 48 176 48c54.7 0 90.4 29.6 114.9 68.8 23.2 37.2 37.9 85.7 51.5 130.3l.6 1.9c14.3 46.9 27.4 89.5 46.9 120.8 18.5 29.8 40.8 46.2 74.1 46.2 42.5 0 74.3-31.8 97.2-71.9 11.1-19.4 19-38.9 24.2-53.8 2.6-7.4 4.4-13.5 5.6-17.7.6-2.1 1-3.7 1.3-4.8l.3-1.2.1-.2L616 272l23.3 5.6V277.9l-.1.5c-.1.4-.2 1-.4 1.7-.4 1.4-.9 3.4-1.6 5.9-1.4 5-3.6 12-6.5 20.4-5.8 16.7-14.9 39.1-27.8 61.7C577.7 411.8 533.5 464 464 464c-54.7 0-90.4-29.6-114.9-68.8-23.2-37.2-37.9-85.7-51.5-130.3l-.6-1.9c-14.3-46.9-27.4-89.5-46.9-120.8C231.6 112.4 209.3 96 176 96c-42.5 0-74.3 31.8-97.2 71.9-11.1 19.4-19 38.9-24.2 53.8-2.6 7.4-4.4 13.5-5.6 17.7-.6 2.1-1 3.7-1.3 4.8l-.3 1.2-.1.2z" })
  }
), k41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 32h208v400h112V232h184v48H504v200H296V80H184v200H0v-48h136V56z" })
  }
), P41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176.1 15.1 195.5 42l268.6 373.1 132.5-181.3 38.8 28.3-152 208-19.5 26.7-19.4-26.8L175.9 96.9 43.4 278.2 4.6 249.8l152-208 19.5-26.7z" })
  }
), F41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 0v512h-48V0zm200 64v384h-48V64zM240 96v320h-48V96zm208 32v256h-48V128zm-304 64v128H96V192zm-96 32v64H0v-64zm592 0v64h-48v-64z" })
  }
), T41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M429 64h38.5l4.3 28.4L500.2 282l20.4-95 5.8-27h30.4l9.5 22.8L600 264h32v48h-64l-6.2-14.8-10.5-25.1L519.5 421l-5.8 27h-37.2l-4.3-28.4-25.4-170.1-39.1 234.4L403 512h-38.7l-4.1-28.6L320 201.7l-40.2 281.7-4.1 28.6H237l-4.7-28.1-39.1-234.4-25.5 170.1-4.2 28.4h-37.2l-5.8-27-31.9-148.9-10.4 25.1L72 312H8v-48h32l33.8-81.2 9.5-22.8h30.4l5.8 27 20.4 95 28.4-189.6 4.2-28.4H211l4.7 28.1 38.5 231 42-294.5L300.3 0h39.3l4.1 28.6 42.1 294.5 38.5-231z" })
  }
), A41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 128c0-44.2 35.8-80 80-80s80 35.8 80 80c0 10.7-2.1 20.8-5.8 30l44.5 18c6-14.9 9.3-31.1 9.3-48.1C416 57.3 358.7 0 288 0S160 57.3 160 128c0 37.1 15.8 70.5 41 93.9L129.7 336H128c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5L253.2 229l12.7-20.3-20.3-12.7C223 181.7 208 156.6 208 128m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5 0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48h1.7l82.8 132.5 12.7 20.4 20.4-12.8c12.3-7.7 26.8-12.1 42.4-12.1 44.2 0 80 35.8 80 80s-35.8 80-80 80c-22.2 0-42.2-9-56.8-23.6l-34.1 33.8c23.2 23.3 55.4 37.8 90.9 37.8 70.7 0 128-57.3 128-128s-57.3-128-128-128c-16.3 0-31.9 3.1-46.3 8.6zM112 384a16 16 0 1 1 32 0 16 16 0 1 1-32 0m320 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24H208v24c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-39.7 28.9-72.7 66.8-78.9l-7.8-47.4C46.3 267.7 0 320.4 0 384c0 70.7 57.3 128 128 128 62.5 0 114.5-44.8 125.8-104h152.6c8.3 14.3 23.8 24 41.6 24" })
  }
), D41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 88a40 40 0 1 1 80 0 40 40 0 1 1-80 0m118.4 40c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40H88L11 464 0 512h512l-11-48-77-336zM256 176h129.8l66 288H60.2l66-288z" })
  }
), y41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0m304 0c0-22.6-4.3-44.2-12-64h44v352H48V112h44c-7.7 19.8-12 41.4-12 64 0 97.2 78.8 176 176 176s176-78.8 176-176M391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H0v448h512V64h-48zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3 6.3-14.7L295.6 91l-6.3 14.7-33.6 78.3c-22 .1-39.7 18-39.7 40 0 22.1 17.9 40 40 40s40-17.9 40-40" })
  }
), b41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m160 0 24 104 104 24-80 80-83.8-12-8 11.6-35.3 51.5c-5.7 8.3-8 18.5-6.3 28.4C77.7 306.3 93.9 320 113 320h1c9.1 0 17.9-3.1 25-8.8l123.8-99.1c68.1-54.4 152.7-84.1 239.9-84.1H640v352H162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l35.6-35.6L92 164 80 80zm432 432V176h-89.3c-76.3 0-150.3 26-209.9 73.6L169 348.7c-15.6 12.5-35 19.3-55 19.3h-1c-24.3 0-46.5-10-62.5-26.5 11 51.7 56.9 90.5 111.9 90.5zM392 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), f41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m493.8 52.2 17-17-34-33.9-17 17-127.7 127.6c-.9-7.9-2.5-15.7-4.8-23.3l1.7-1.6 64-64 17-17-34-33.9L359 23l-55.4 55.4c-2.6-3.1-5.3-6.1-8.2-9l-33.9-33.9-33.9 33.9 22.7 49-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2-33.9 33.9 22.7 49-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2-33.8 34 22.7 49-22.8-49c-43.7 43.7-43.7 114.6 0 158.4l11.3 11.3-62.3 62.4-17 17 33.9 33.9 17-17 62.4-62.4 11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l-49-22.8 49 22.8 33.9-33.9-14.2-14.2c5.9-1.1 11.8-2.6 17.5-4.6-.9-7.2-1.4-14.5-1.4-21.9 0-8.1.5-16.1 1.6-23.9l-7.3-3.4 7.3 3.4c.4-3 .9-6 1.5-9-2.8 2.1-5.7 4-8.7 5.6L248.2 310c25.9-8.4 55.3-3.2 76.9 15.6 5.2-21 14.1-40.4 26.1-57.7-12.1-2.3-23.7-8.2-33.1-17.6L308 240.2c6.1-4.1 12.7-7.2 19.5-9.4l39 18.1-39-18.1c18.1-5.8 37.8-5.1 55.5 2.3 17-14.3 36.8-25.4 58.4-32.5L489 153l17-17-34-33.9-17 17-64 64-1.5 1.5c-7.6-2.3-15.4-3.9-23.3-4.8zM327.4 230.8 319 227l8.4 3.9zM248.2 310l-8.4-3.9zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.1c6.1-4.1 12.7-7.2 19.5-9.4zM169 389.2c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2zm0 0-8.4-3.9zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.2c6.1-4 12.7-7.2 19.5-9.4zm-46.3-46.3c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1C82.8 331.8 79 301 92 276.8zm0 0 4 8.5zm0 0L92 276.7c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2m79.2-79.2c-2.2 6.8-5.3 13.3-9.4 19.5L182.4 273c-20.4-20.4-24.2-51.2-11.2-75.4zm0 0 4 8.5zm0 0-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2zm79.1-79.2c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1c-20.4-20.4-24.2-51.2-11.2-75.4zm0 0 4 8.5zm0 0-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-64h-32v-32h32zm0-176v112h-32V272z" })
  }
), U41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L458 332.8l3.2-3.2-14.2-14.2c21.8-3.9 42.6-14.2 59.4-31l-49-22.8 49 22.8 33.9-33.9-33.9-33.9c-2.9-2.9-5.8-5.6-8.9-8.1L553 153l17-17-34-33.9-17 17-64 64-1.5 1.5c-7.6-2.3-15.4-3.9-23.3-4.8L557.8 52.2l17-17-34-33.9-17 17-127.6 127.6c-.9-7.9-2.5-15.7-4.8-23.3l1.6-1.6 64-64 17-17-34-33.9L423 23l-55.3 55.4c-2.6-3.1-5.3-6.1-8.2-9l-34-33.9-33.9 33.9 22.7 49-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2L216 145 48.4 14.8zM345 184.5c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1c-20.4-20.4-24.2-51.2-11.2-75.4zm0 0 4 8.5zm0 0-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.5 53.5 19.5 81.2zm46.3 46.3c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2l-66.1-30.7zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.1c6.1-4.1 12.7-7.2 19.5-9.4zm0 0L383 227l8.4 3.9zm-14.8 161.8L148.2 212.8l-15 15 22.7 49-22.8-49c-43.7 43.7-43.7 114.6 0 158.4l11.3 11.3-62.2 62.3-17 17 33.9 33.9 17-17 62.4-62.4 11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l-49-22.8 49 22.8 33.9-33.9-14.2-14.2c2.9-.5 5.8-1.1 8.6-1.9zM233 389.2c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2zm0 0-8.4-3.9zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.1c6.1-4 12.7-7.2 19.5-9.4zm-46.3-46.3c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1C146.8 331.8 143 301 156 276.8zm0 0 4 8.5zm0 0L156 276.7c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2" })
  }
), G41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m493.8 52.2 17-17-34-33.9-17 17-127.7 127.6c-.9-7.9-2.5-15.7-4.8-23.3l1.7-1.6 64-64 17-17-34-33.9L359 23l-55.4 55.4c-2.6-3.1-5.3-6.1-8.2-9l-33.9-33.9-33.9 33.9 22.7 49-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2-33.9 33.9 22.7 49-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2-33.8 34 22.7 49-22.8-49c-43.7 43.7-43.7 114.6 0 158.4l11.3 11.3-62.3 62.4-17 17 33.9 33.9 17-17 62.4-62.4 11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l-49-22.8 49 22.8 33.9-33.9-14.2-14.2c21.8-3.9 42.6-14.2 59.4-31l-49-22.8 49 22.8 33.9-33.9-14.1-14.1c21.8-3.9 42.6-14.2 59.4-31l-49-22.8 49 22.8 33.9-33.9-33.9-33.9c-2.9-2.9-5.8-5.6-8.9-8.1L489 153l17-17-34-33.9-17 17-64 64-1.5 1.5c-7.6-2.3-15.4-3.9-23.3-4.8zM327.4 230.8c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2L308 240.2c6.1-4.1 12.7-7.2 19.5-9.4zm0 0L319 227l8.4 3.9zM248.2 310c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2zm0 0-8.4-3.9zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.1c6.1-4.1 12.7-7.2 19.5-9.4zM169 389.2c27.6-8.9 59.2-2.4 81.1 19.5-4.6 4.6-9.6 8.3-15 11.2zm0 0-8.4-3.9zm0 0 66.1 30.7c-24.2 13-55 9.2-75.4-11.2l-10.1-10.2c6.1-4 12.7-7.2 19.5-9.4zm-46.3-46.3c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1C82.8 331.8 79 301 92 276.8zm0 0 4 8.5zm0 0L92 276.7c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2m79.2-79.2c-2.2 6.8-5.3 13.3-9.4 19.5L182.4 273c-20.4-20.4-24.2-51.2-11.2-75.4zm0 0 4 8.5zm0 0-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2zm79.1-79.2c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1c-20.4-20.4-24.2-51.2-11.2-75.4zm0 0 4 8.5zm0 0-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2z" })
  }
), q41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m385 144.5 5.7 12.3zm-30.7-66.1c2.9-5.4 6.6-10.5 11.2-15 21.9 22 28.4 53.5 19.5 81.2zm0 0-22.8-49c-16.8 16.8-27.2 37.7-31 59.4l-14.2-14.2-33.9 33.9 22.7 49-22.8-49c-12.7 12.7-21.7 27.7-27 43.6L48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7L458 332.8l9.3-9.3 33.9-33.9-9.1-9.1c15.8-4.2 30.7-12.5 43-24.9l11.3-11.3 33.9-33.9-33.9-33.9c-11.6-11.5-24.8-20.4-38.9-26.6 39.3-9 68.5-44 68.5-85.9V0h-64c-41.9 0-77 29.3-85.8 68.5-6.2-14.2-15.1-27.5-26.8-39.1L365.5-4.5l-33.9 33.9zm65.4 224.7-47.4-36.8c21.9-1.2 44.3 6.5 61 23.3L422 300.9c-.8.8-1.6 1.5-2.4 2.2zm-111.8-86.8-8.5-6.6-24.2-52.1c2.9-5.4 6.6-10.5 11.2-15 20 20 27.2 48 21.5 73.7m-8.5-6.6L267.7 185c.4-9.5 2.9-18.9 7.5-27.5l24.2 52zm55-131.2 30.6 66c-2.2 6.8-5.3 13.3-9.4 19.5l-10.1-10.1c-20.4-20.4-24.2-51.2-11.2-75.4zM173.3 346.1l11.3 11.3L82.2 459.8l-17 17 33.9 33.9 17-17 102.4-102.3 11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l-49-22.8c-24.2 13-55 9.2-75.4-11.2l-10.1-10.2c6.1-4 12.7-7.2 19.5-9.4l-8.4-3.9 8.4 3.9c15.5-5 32.2-5.1 47.7-.5l-90.2-71.1c.1 8.5-1.2 17-3.9 25.2l4 8.5-4-8.5c-2.2 6.8-5.3 13.3-9.4 19.5L207.2 312c-17.6-17.6-22.8-43-15.6-65.2L152.5 216c-21.4 42.1-14.5 94.8 20.7 129.9zm165.9 33.8L273 349.2l66.1 30.7zm0 0 49 22.8.5-.5-38.1-30c-3.6 3-7.4 5.6-11.3 7.8zm-112.5-77L206 258.3l20.7 44.5zm285.8-92.5-11.3 11.3c-18.7 18.7-49.1 18.7-67.9 0l-21.5-21.5c31-20.5 73.3-17.2 100.6 10.2zM512 48h16v16c0 22.1-17.9 40-40 40h-16V88c0-22.1 17.9-40 40-40" })
  }
), W41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M362.2 68.5C371.1 29.3 406.1 0 448 0h64v64c0 41.9-29.2 76.9-68.4 85.8 14.1 6.2 27.3 15.1 38.9 26.6l33.9 33.9-33.9 33.9-11.3 11.3c-12.4 12.4-27.3 20.7-43 24.9l9.1 9.1-33.9 33.9-11.4 11.4c-12.4 12.4-27.3 20.7-43 24.9l9.1 9.1-33.9 33.9-49-22.8c5.4-2.9 10.5-6.6 15-11.2-22-21.9-53.5-28.5-81.1-19.5l-8.4-3.9 8.4 3.9c-6.8 2.2-13.3 5.3-19.5 9.4l10.1 10.2c20.4 20.4 51.2 24.2 75.4 11.2l49 22.8c-43.7 43.7-114.6 43.7-158.4 0l-11.2-11.2L52.2 493.8l-17 17-33.9-34 17-17 102.3-102.3-11.3-11.3c-43.7-43.7-43.7-114.6 0-158.4l22.8 49c-13 24.2-9.2 55 11.2 75.4l10.1 10.1c4.1-6.1 7.2-12.7 9.4-19.5l4 8.5-4-8.5c8.9-27.6 2.4-59.2-19.5-81.2-4.6 4.6-8.3 9.6-11.2 15l-22.7-49 33.9-33.9 14.1 14.3c3.9-21.8 14.2-42.6 31-59.4l22.8 49c-13 24.2-9.2 55 11.2 75.4l10.1 10.1c4.1-6.1 7.2-12.7 9.4-19.5l4 8.5-4-8.5c8.9-27.6 2.4-59.2-19.5-81.2-4.6 4.6-8.3 9.6-11.2 15l-22.7-49 33.9-33.9 14.2 14.2c3.9-21.8 14.2-42.6 31-59.4l22.8 49c-13 24.2-9.2 55 11.2 75.4l10.1 10.3c4.1-6.1 7.2-12.7 9.4-19.5l5.7 12.3-5.7-12.3c8.9-27.6 2.4-59.2-19.5-81.2-4.6 4.6-8.3 9.6-11.2 15l-22.7-49 33.8-33.8 33.9 33.9C347.1 41 356 54.3 362.2 68.5m-71.8 9.9 30.7 66.1-30.8-66.1zm-79.2 79.2 30.7 66.1-30.7-66.1M132 236.7l30.7 66.1-30.7-66zm143.1 143.2L209 349.2zm94.2-90.4c-27.4-27.3-69.6-30.7-100.6-10.2l21.5 21.5c18.7 18.7 49.1 18.7 67.9 0l11.3-11.3zm79.2-79.2c-27.3-27.3-69.5-30.6-100.6-10.1l21.5 21.5c18.7 18.7 49.1 18.7 67.9 0l11.3-11.3zM448 48c-22.1 0-40 17.9-40 40v16h16c22.1 0 40-17.9 40-40V48z" })
  }
), E41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-131.1 4 13.3 6.3 152 72 30.8 14.6-24 24.1-71 71h156.7l-7.5 29.8-40 160-5.8 23.3-46.6-11.6 5.8-23.3L385.3 288h-78.6c8.6 19.6 13.3 41.2 13.3 64 0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160h3.7l67.1-67.1-35.7-16.9-60.3 46.9-18.9 14.7-29.6-37.8 18.9-14.7 72-56zm114 107.1-33.8-16-57.4 57.4c11.9 4.1 23.2 9.5 33.7 16.1L303 159zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224" })
  }
), O41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M48 352c0 61.9 50.1 112 112 112 42.8 0 80-24 98.9-59.3l42.3 22.6c-26.9 50.4-80 84.7-141.2 84.7C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7l16.9 44.9C78.1 263.2 48 304.1 48 352m163.3-227.9 4.3 23.6 5.1 28.3H368v48H229.5l13.4 73.4c.7 3.8 4 6.6 7.9 6.6H399.7l6.3 14.4 47.2 107.9 27.2-9.1 22.8-7.6 15.2 45.5-22.8 7.6-48 16-20.8 6.9-8.8-20L368.3 352H250.7c-27.1 0-50.3-19.4-55.1-46l-27.2-149.7-4.3-23.6 47.2-8.6z" })
  }
), I41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.6 432h300.8l18.2-127.7-22.1 22.1-56.6 56.6-33.9 33.9-33.9-33.9-56.6-56.6-33.9-33.9 33.9-33.9 56.6-56.6 33.9-34 33.9 33.9 56.6 56.6 25.1 25.1L456.7 80H55.3L88 308.6V176h170.7l-48 48H136v96h33.8l48 48H96.5zM448 480H64L6.9 80 0 32h512l-6.9 48zM312 235.9l-56.6 56.6L312 349l56.6-56.6z" })
  }
), N41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M91.9 336h328.2l-13.7 96H105.6zM41 318.8 64 480h384l23-161.2c.6-2.1 1-4.4 1-6.8l33.1-232 6.9-48H0l6.9 48L40 312c0 2.3.3 4.6 1 6.8M85.1 288 55.3 80h401.4l-29.8 208H85.1z" })
  }
), X41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M119 95.2C107.8 76.5 87.4 64 64 64 28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192 64.9 0 122.3-32.2 157-81.5L544 448l64.7-75.5L640 336l-38-29.4L352.2 113c-6.9-6.2-14.3-11.9-22-17-30.4-20.2-66.9-32-106.2-32-38.8 0-74.8 11.5-105 31.2m-50.5 48.2c-1.4.4-2.9.6-4.5.6-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16v1c-4 4.6-7.9 9.4-11.5 14.3zm254.3 7.6 68.3 52.9-10.3 13.7-14.4 19.2 38.4 28.8 14.4-19.2 9.8-13.1 141.7 109.8-38.8 45.2-129.4-64.7-36.9-18.5-23.8 33.7C315.6 375.9 272.6 400 224 400c-79.5 0-144-64.5-144-144s64.5-144 144-144c29.5 0 56.8 8.8 79.6 24L330 96.2 303.6 136c5.8 3.9 11.3 8.1 16.5 12.8l1.3 1.2 1.4 1.1zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), K41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 56V32h-48v304h48v-24zM1.2 155.9l32.4 35.4C96.1 134 175.8 95.3 264 83.7V35.3C163.3 47.2 72.3 90.8 1.2 155.9m118.2 130.5 32.5 35.3C183 293 221.4 272.2 264 262.3v-49c-55.2 10.6-104.9 36.5-144.6 73.1M376 213.3v49.1c42.6 9.8 81 30.6 112.1 59.3l32.5-35.3c-39.7-36.6-89.4-62.5-144.6-73.1zM264 424a56 56 0 1 0 112 0 56 56 0 1 0-112 0M376 56v27.7c88.2 11.6 167.9 50.3 230.3 107.6l32.4-35.4c-71-65.1-162-108.7-262.7-120.6z" })
  }
), Q41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.9 321.6C196.1 280.9 255.1 256 320 256s123.9 24.9 168.1 65.6l32.5-35.3C467.9 237.7 397.4 208 320 208s-147.9 29.7-200.6 78.4l32.5 35.3zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112" })
  }
), Z41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.4 14.8 29.4.1 0 38l19 14.7 572.5 444.5 19 14.7 29.4-37.9-19-14.7-256.8-199.4c47.4 8.5 90 30.4 124 61.7l32.5-35.3C467.9 237.7 397.4 208 320 208c-7.3 0-14.6.3-21.7.8l-130-100.9C215.4 89.9 266.6 80 320 80c110.4 0 210.9 42.2 286.3 111.3l32.4-35.4C554.8 79 442.9 32 320 32c-69.6 0-135.7 15.1-195.2 42.1L48.4 14.8zm28.5 141.8-39.2-30.9c-12.7 9.5-24.8 19.5-36.5 30.2l32.4 35.4c13.6-12.5 28.1-24.1 43.2-34.7zm149.4 117.7L184 241c-23.6 12.2-45.3 27.5-64.7 45.4l32.5 35.3c21.6-19.9 46.8-36.1 74.4-47.3zM376 424a56 56 0 1 0-112 0 56 56 0 1 0 112 0" })
  }
), J41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264 424a56 56 0 1 1 112 0 56 56 0 1 1-112 0" })
  }
), j41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M33.7 191.3C109.1 122.2 209.6 80 320 80s210.9 42.2 286.3 111.3l32.4-35.4C554.8 79 442.9 32 320 32S85.2 79 1.2 155.9l32.4 35.4zM320 256c64.9 0 123.9 24.9 168.1 65.6l32.5-35.3C467.9 237.7 397.4 208 320 208s-147.9 29.7-200.6 78.4l32.5 35.3C196.1 280.9 255.1 256 320 256m56 168a56 56 0 1 0-112 0 56 56 0 1 0 112 0" })
  }
), Y41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m340.8 425-23.7-222.2L415.4 2 234.8 133.7l-223 15.2 204.4 90.6zM232 192a24 24 0 1 1 48 0 24 24 0 1 1-48 0m48 199.9-48-71.4V464H128v48h256v-48H280z" })
  }
), _41 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 432c61.8 0 116.1-31.8 147.5-80h54.9c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208h-48.1C391.2 150.3 315.8 80 224 80c-97.2 0-176 78.8-176 176s78.8 176 176 176m320-208h-66c-2.1-16.5-5.7-32.6-10.8-48H544c26.5 0 48-21.5 48-48s-21.5-48-48-48h-64V32h64c53 0 96 43 96 96s-43 96-96 96m-96 256v-48h88c30.9 0 56-25.1 56-56s-25.1-56-56-56H320v-48h216c57.4 0 104 46.6 104 104s-46.6 104-104 104h-64zM248 128v160h-48V128zm-48 240v-48h48v48z" })
  }
), h31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0v48h68c24.3 0 44 19.7 44 44s-19.7 44-44 44H0v48h356c50.8 0 92-41.2 92-92S406.8 0 356 0h-44zm64 416h68c50.8 0 92-41.2 92-92s-41.2-92-92-92H0v48h420c24.3 0 44 19.7 44 44s-19.7 44-44 44h-68zm-232 96h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H0v48h164c24.3 0 44 19.7 44 44s-19.7 44-44 44H96v48z" })
  }
), c31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 32H0v448h512V160zM48 224h416v208H48zM384 96h64v64h-64zm-32 0v64h-64V96zm-160 0h64v64h-64z" })
  }
), s31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 240H280V48h152zm-200 0H80V48h152zM32 0v288h448V0H80zm-8 464H0v48h512v-48h-32V320h-48v144H80V320H32v144z" })
  }
), v31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 464h152V272H80zm-48 0V0h448v464h32v48H0v-48h24zm400 0V272H280v192zM80 224h152V48H80zm200 0h152V48H280z" })
  }
), e31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 432V224H48v208zm48-208v256H0V32h512v48z" })
  }
), l31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 432H0v48h512z" })
  }
), t31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 48H176v48h-48V0h384v384h-96v-48h48zM48 464h288V256H48zm0-336h336v384H0V128z" })
  }
), w31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32h512v448H0V160zm464 192H48v208h416zM128 96H64v64h64zm32 0v64h64V96zm160 0h-64v64h64z" })
  }
), g31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0v96h80V48l48 10 336 70v160l-336 70-48 10v-48H48v192H0V0zm0 144v128h80V144zm128-37v202l64-13.3V120.4zm112 23.3v155.3l80-16.6V147zM416 157v102l48-10v-82z" })
  }
), i31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M417.9 0H400l-25 25 10.7 10.7-1 1-83.6 83.6c-41.9-10.8-88.2.2-120.9 32.9L33.9 299.5 0 333.5l33.9 33.9 110.7 110.7 33.9 33.9 33.9-33.9 146.3-146.3c32.8-32.8 43.8-79.1 32.9-120.9l83.6-83.6 1-1L487 137l25-25V94.1zm-60.1 176.9-19.4 19.4 6.9 26.6c6.5 25 .4 52.4-18 72.4L216.7 184.7c20.1-18.4 47.4-24.4 72.4-18l26.6 6.9 19.4-19.4 83.6-83.6 22.6 22.6-83.6 83.6zM104.7 296.7l110.6 110.6-36.8 36.8L67.9 333.5z" })
  }
), m31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M75.8 48H168l-72 72 96 104-32-104 64-40-6.4-32h26.6l13.5 149c5.2 57.5-40 107-97.7 107S57.1 254.5 62.3 197zM136 0H32L14.5 192.7C7.4 270.1 61.9 337.8 136 350v114H48v48h224v-48h-88V350c74.1-12.2 128.6-80 121.5-157.4L288 0h-80z" })
  }
), a31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62.3 197c-5.2 57.5 40 107 97.7 107s102.9-49.5 97.7-107L244.2 48H75.8zm-47.8-4.3L32 0h256l17.5 192.7c7 77.4-47.4 145.2-121.5 157.4V464h88v48H48v-48h88V350C61.9 337.8 7.4 270.1 14.5 192.7" })
  }
), o31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.2 176h191.6l1.9 21c5.2 57.5-40 107-97.7 107S57.1 254.5 62.3 197zm4.4-48 7.3-80h168.3l7.3 80zM32 0 14.5 192.7C7.4 270.1 61.9 337.8 136 350v114H48v48h224v-48h-88V350c74.1-12.2 128.6-80 121.5-157.4L288 0z" })
  }
), n31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M68.2 240 11.5 32h49.7L118 240h67.1l43.5-189.4 4.3-18.6h46.2l4.3 18.6L326.9 240H394l56.8-208h49.8l-56.8 208H512v48h-81.3l-47.5 174.3-4.9 17.7H332.9l-4.3-18.6L288.7 288h-65.4l-39.9 173.4-4.3 18.6H133.7l-4.8-17.7L81.3 288H0v-48h24zm62.8 48 23.3 85.4L174 288zm103.2-48h43.4L256 145.7 234.3 240zM338 288l19.7 85.4 23.2-85.4z" })
  }
), r31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 192v176c0 35.3-28.7 64-64 64s-64-28.7-64-64v-48c0-53-43-96-96-96s-96 43-96 96v144h32V320c0-35.3 28.7-64 64-64s64 28.7 64 64v48c0 53 43 96 96 96s96-43 96-96V48h-96c-26.5 0-48 21.5-48 48s21.5 48 48 48h64zm-224-16c15.9 0 31.2 2.6 45.5 7.3 27.7 9.2 51.7 26.6 69 49.3 5.1 6.7 9.6 13.8 13.5 21.3 10.2 19.8 16 42.2 16 66V368c0 8.8 7.2 16 16 16s16-7.2 16-16V192h-16c-6.3 0-12.5-.6-18.5-1.8-27.6-5.4-51-22.6-64.7-46.2-8.2-14.1-12.8-30.5-12.8-48 0-53 43-96 96-96h144v368c0 79.5-64.5 144-144 144-55.7 0-104.1-31.7-128-78-10.2-19.8-16-42.2-16-66v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v192H32V320c0-79.5 64.5-144 144-144M376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), d31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m237.1 50.9-.7 11.8c-1.1 20.3-17.4 36.6-37.7 37.7l-11.8.7.7-11.8c1.1-20.3 17.4-36.6 37.7-37.7l11.8-.7zm2.7-48.2-17.2 1c-40.1 2.2-73 31.2-81.2 69.4-5.2-7.5-11.4-14.3-18.4-20.5-5.8-5.1-12.2-9.7-19.1-13.8l-.2-.1-20.7-12-32 55.4c-17.4 30.2-19.2 65.1-7.8 95.4-6.1-1-12.4-1.5-18.8-1.5H0v64c0 34.9 15.9 66 40.9 86.5-5.8 2.2-11.5 4.9-17.1 8.1l-.2.1-20.7 12 32 55.4c28.2 48.9 87.9 68.5 138.8 47.9 4.7-1.9 9.4-4.2 13.9-6.8l.3-.2 4.8-2.8c4.7 3.3 9.6 6.3 14.5 9.2l-33.9 17 21.5 42.9 58.9-29.3h132.6l58.9 29.5 21.5-42.9-64-32-5.1-2.5H320c-97.2 0-176-78.8-176-176 0-38.2 11.6-75.2 32.8-106.3l24.6-1.4c44.8-2.5 80.5-38.2 83-83l1-17.2L288 0zm223.4 147C484.4 180.8 496 217.8 496 256c0 62.5-32.6 117.3-81.6 148.6l17.9 9 30.4 15.2 18.4 9.2 39.1 19.5c34.3-3.7 66.4-23.2 85-55.4l32-55.4-20.7-12-.2-.1c-5.6-3.2-11.3-5.9-17.1-8.1C624.1 306 640 274.8 640 240v-64h-24.3c-6.4 0-12.7.5-18.8 1.5 11.4-30.3 9.6-65.2-7.8-95.4l-32-55.4-20.7 12-.2.1c-6.9 4-13.3 8.6-19.1 13.8-7 6.2-13.2 13.1-18.4 20.5-8.2-38.2-41-67.2-81.2-69.4l-17.2-1L352 0l2.7 48.2 1 17.2c2.5 44.8 38.2 80.5 83 83l24.6 1.4zm-48.5-98.1c20.3 1.1 36.6 17.4 37.7 37.7l.7 11.8-11.8-.7C421 99.3 404.7 83 403.6 62.7l-.7-11.8 11.8.7M96.3 302.3c-27.9-7-48.6-32.3-48.6-62.4v-12.3c28.3 9.9 48.6 36.8 48.6 68.4zm447.4-6.3c0-31.6 20.3-58.5 48.6-68.3V240c0 30.1-20.7 55.4-48.6 62.4v-6.3zM149.4 408c-27.7 7.9-58.2-3.7-73.3-29.7L70 367.6c29.4-5.6 60.4 7.5 76.3 34.9l3.2 5.5zm-43.1-229.2-3.2 5.5c-20.7-20.1-26-52.3-10.9-78.3l6.1-10.7c19.6 22.6 23.7 56.1 7.9 83.5zm430.6 5.5-3.2-5.5c-15.8-27.4-11.7-60.8 7.9-83.5l6.1 10.7c15 26.1 9.8 58.3-10.9 78.3zM490.6 408l3.2-5.5c15.8-27.4 46.9-40.5 76.3-34.9l-6.2 10.6c-15.1 26.1-45.6 37.6-73.3 29.7z" })
  }
), S31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192.9 51.8 224 78.2l31.1-26.4c2.8-2.4 6.3-3.8 10.3-3.8 6.9 0 12.9 4.4 15.1 10.7l15.2 43 43.7-13c1.4-.4 2.9-.7 4.6-.7 8.8 0 16 7.2 16 16 0 1.7-.2 3.2-.7 4.6l-13 43.7 43 15.2c6.3 2.2 10.7 8.2 10.7 15.1 0 4-1.4 7.5-3.8 10.3L369.8 224l26.4 31.1c2.4 2.8 3.8 6.3 3.8 10.3 0 6.9-4.4 12.9-10.7 15.1l-43 15.2 13 43.7c.4 1.4.7 2.9.7 4.6 0 5.9-3.2 11.1-8 13.9v49.6c31.6-3.9 56-30.9 56-63.5 0-6.3-.9-12.5-2.6-18.2 24.8-8.8 42.6-32.5 42.6-60.3 0-15.8-5.7-30.2-15.2-41.4 9.5-11.2 15.2-25.6 15.2-41.4 0-27.9-17.8-51.6-42.6-60.3 1.7-5.8 2.6-11.9 2.6-18.2 0-35.3-28.7-64-64-64-6.3 0-12.5.9-18.2 2.6C317 17.8 293.3 0 265.4 0c-15.8 0-30.2 5.7-41.4 15.2C212.8 5.7 198.4 0 182.6 0c-27.9 0-51.6 17.8-60.4 42.6-5.7-1.7-11.9-2.6-18.2-2.6-35.3 0-64 28.7-64 64 0 6.3.9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3-1.7 5.8-2.6 12-2.6 18.3 0 32.6 24.4 59.6 56 63.5v-49.6c-4.8-2.8-8-7.9-8-13.9 0-1.7.2-3.2.7-4.6l13-43.7-43-15.2c-6.3-2.2-10.7-8.2-10.7-15.1 0-4 1.4-7.5 3.8-10.3L78.2 224l-26.4-31.1c-2.4-2.8-3.8-6.3-3.8-10.3 0-6.9 4.4-12.9 10.7-15.1l43-15.2-13-43.7c-.4-1.4-.7-2.9-.7-4.6 0-8.8 7.2-16 16-16 1.7 0 3.2.2 4.6.7l43.7 13 15.2-43c2.2-6.3 8.2-10.7 15.1-10.7 4 0 7.5 1.4 10.3 3.8zM128 512l96-32 96 32V384l-96 32-96-32zm96-392-27 28.9-2.8 3-4.2-.1-39.5-1.3 1.3 39.5.1 4.2-3 2.8-28.9 27 28.9 27 3 2.8-.1 4.2-1.3 39.5 39.5-1.3 4.2-.1 2.8 3 27 28.9 27-28.9 2.8-3 4.2.1 39.5 1.3-1.3-39.5-.1-4.2 3-2.8 28.9-27-28.9-27-3-2.8.1-4.2 1.3-39.5-39.5 1.3-4.2.1-2.8-3zm9.7 80.6 14.2-.5-.5 14.2 10.4 9.7-10.4 9.7.5 14.2-14.2-.5-9.7 10.3-9.7-10.4-14.2.5.5-14.2-10.3-9.6 10.4-9.7-.5-14.2 14.2.5 9.7-10.4 9.7 10.4z" })
  }
), z31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m273.9 193.9 14.1-14V84.7c29.5 26.4 48 64.7 48 107.3 0 48.1-23.6 90.8-60 117l-20 14.4V512h48V348c48.5-34.9 80-91.7 80-156 0-71.1-38.6-133.1-96-166.3-14.9-8.6-31-15.3-48-19.7v154l-14.1 14.1L192 208l-33.9-33.9L144 160V6c-17 4.4-33.1 11-48 19.6C38.6 58.9 0 120.9 0 192c0 64.2 31.5 121.1 80 156v164h48V323.4L108 309c-36.5-26.2-60-68.9-60-117 0-42.6 18.5-81 48-107.3V179.9l14.1 14.1 48 48 33.9 33.9 33.9-33.9 48-48z" })
  }
), p31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m322.3 268-26.9-7.4-19.7 19.7L112 444.1 67.9 400l163.7-163.7 19.7-19.7-7.3-26.9c-2.6-9.4-4-19.3-4-29.7 0-60.5 48-109.9 108-111.9l-30 30-14 14V208h115.9l14.1-14.1 30-30c-2.1 60-51.4 108-111.9 108-10.3 0-20.3-1.4-29.7-4zM112 512l33.9-33.9 163.8-163.8c13.5 3.7 27.7 5.7 42.3 5.7 88.4 0 160-71.6 160-160 0-13.5-1.7-26.7-4.9-39.3-4.3-17-11.3-33-20.6-47.3l-35.1 35.1L400 160h-48v-48l51.5-51.5 35.1-35.1c-14.4-9.3-30.3-16.3-47.3-20.6C378.7 1.7 365.5 0 352 0c-88.4 0-160 71.6-160 160 0 14.7 2 28.9 5.7 42.3L33.9 366.1 0 400l33.9 33.9L78 478zm8-97.4 22.6-22.6-22.6-22.6L97.4 392z" })
  }
), M31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h32v352H0v48h512v-48h-32V80h32V32H56zm56 400V80h352v352zM272 96h-32v48h-80v32h80v32H128v32h112v54.6L181.3 272H128v57.6l42.7 54.4h170.6l42.7-54.4V272h-53.3L272 294.6V240h112v-32H272v-32h80v-32h-80v-32zm-64 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32m80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), x31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m3 32 159.5 224L3 480h59l130-182.6L322 480h58.9L221.5 256 380.9 32H322L192 214.6 62 32z" })
  }
), H31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m52.2 50.2-17-17-33.9 34 17 17L190.1 256 18.2 427.8l-17 17 33.9 33.9 17-17L224 289.9l171.8 171.9 17 17 33.9-33.9-17-17L257.9 256 429.8 84.2l17-17-34-33.9-17 17L224 222.1 52.2 50.2z" })
  }
), V31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 80v280h288V80zM96 360V32h384v328h24v48H72v-48zm-32-72v48H48v96h480v-96h-16v-48h64v192H0V288h48zm321.9-136-17 17-47 47 47 47 17 17-33.9 33.9-17-17-47-47-47 47-17 17-33.9-33.9 17-17 47-47-47-47-17-17 33.9-33.9 17 17 47 47 47-47 17-17z" })
  }
), C31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m345 137 17-17-34-33.9-17 17-119 119L73 103 56 86l-33.9 34 17 17 119 119L39 375l-17 17 34 33.9 17-17 119-119L311 409l17 17 33.9-34-17-17-119-119z" })
  }
), L31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32H0v48h640V32h-24zm0 400H0v48h640v-48h-24zm33-249-17-17-33.9 34 17 17 39 39L23 295 6 312l34 33.9 17-17 39-39 39 39 17 17 33.9-33.9-17-17-39-39 39-39 17-17-33.9-33.9-17 17-39 39zm224 0-17-17-33.9 34 17 17 39 39-39 39-17 17 33.9 33.9 17-17 39-39 39 39 17 17 33.9-33.9-17-17-39-39 39-39 17-17-33.9-33.9-17 17-39 39-39-39zm224 0-17-17-33.9 34 17 17 39 39-39 39-17 17 33.9 33.9 17-17 39-39 39 39 17 17 33.9-33.9-17-17-39-39 39-39 17-17-33.9-33.9-17 17-39 39-39-39z" })
  }
), B31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M1.1 32 168 295v185h48V295L382.9 32H326L192 243.2 58 32H1.1z" })
  }
), u31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m2.2 32 111.5 192H16v48h120v48H16v48h120v112h48V368h120v-48H184v-48h120v-48h-97.7L317.8 32h-55.5L160 208.2 57.7 32H2.2z" })
  }
), R31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 256c0-64.3-29.2-121.8-75-160 4.6 13.8 7 28.6 7 44 0 77.3-62.7 140-140 140-50.9 0-92.2 41.2-92.2 92s41.3 92 92.2 92c114.9 0 208-93.1 208-208M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m-133.2-96.2c-4.5-13.8-7-28.5-7-43.8 0-77.4 62.9-140 140.2-140 50.8 0 92-41.2 92-92s-41.2-92-92-92C141.1 48 48 141.1 48 256c0 64.2 29.1 121.6 74.8 159.8zM216 144l40-40 40 40-40 40zm40 184 40 40-40 40-40-40z" })
  }
), $31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32H0v48h308.5L5.6 440.6 0 447.3V480h384v-48H75.5L378.4 71.4l5.6-6.7z" })
  }
), k31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160v128c0 88.4-71.6 160-160 160S0 408.4 0 320zm160-96c-53 0-96 43-96 96v128c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96" })
  }
), P31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 32C64.5 32 0 96.5 0 176v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144M64 176c0-44.2 35.8-80 80-80s80 35.8 80 80v160c0 44.2-35.8 80-80 80s-80-35.8-80-80zM496 32c-79.5 0-144 64.5-144 144v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144m-80 144c0-44.2 35.8-80 80-80s80 35.8 80 80v160c0 44.2-35.8 80-80 80s-80-35.8-80-80z" })
  }
), F31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64z" })
  }
), T31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8l-30.9 30.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l30.9-30.8C67.5 47.3 104.4 32 142.9 32 223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l190.9-190.8c15.2-15.2 23.8-35.9 23.8-57.4 0-44.8-36.3-81.1-81.1-81.1" })
  }
), A31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h240c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136h-78.6C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64" })
  }
), D31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h64l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S51.9 256 64 256h16c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32h-5.5c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L22.6 420c18 18 42.4 28.1 67.9 28.1H96c53 0 96-43 96-96V304c0-47-29-87.3-70.1-103.9l63.7-84.9c7.3-9.7 8.4-22.7 3-33.5S172.1 64 160 64zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v224c0 44.2 35.8 80 80 80s80-35.8 80-80M288 160c0-17.7 14.3-32 32-32s32-14.3 32-32-14.3-32-32-32c-53 0-96 43-96 96v208c0 44.2 35.8 80 80 80s80-35.8 80-80v-96c0-44.2-35.8-80-80-80-5.5 0-10.8.6-16 1.6zm0 112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16z" })
  }
), y31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368h224v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H82.4z" })
  }
), b31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32.5 58.3C35.3 43.1 48.5 32 64 32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136h-83.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z" })
  }
), f31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4.1 315.2c0 1.4-.1 2.9-.1 4.3v.5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320a96 96 0 1 1-192 0 96 96 0 1 1 192 0" })
  }
), U31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h256c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64" })
  }
), G31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 160c0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89-31.5 23.3-52 60.8-52 103 0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128 0-42.2-20.5-79.7-52-103 22.3-23 36-54.4 36-89M176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64s28.7-64 64-64h48zm0-64H144c-35.3 0-64-28.7-64-64s28.7-64 64-64h32c35.3 0 64 28.7 64 64s-28.6 64-64 64z" })
  }
), q31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 192a96 96 0 1 0 192 0 96 96 0 1 0-192 0m87.5 159.8C67.1 347.4 0 277.5 0 192 0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z" })
  }
), W31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384h197.4l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8z" })
  }
), E31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96v112h-64v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96zm-96 32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h128zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-96v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h96zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64V96h64zM64 416V240h64v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32zm96-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-96zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h128v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-96h64v176h-64zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z" })
  }
), O31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M108.3 204.8 41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2" })
  }
), I31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M262.4 4.8c10.6 8 12.8 23 4.8 33.6l-4.8 6.4c-4.4 5.9-7.9 12.4-10.3 19.2H352c53 0 96 43 96 96 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-53 43-96 96-96h106.4c3.6-17.3 10.9-33.7 21.6-48l4.8-6.4c8-10.6 23-12.8 33.6-4.8zm-48.5 471.6C78.5 425.9 48 302.1 48 224h352c0 78.1-30.5 201.9-165.9 252.4-6.5 2.4-13.7 2.4-20.2 0" })
  }
), N31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm112 288h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80m-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0M512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16m16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), X31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm80 256h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80m-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0m256-32h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), K31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 128h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m176 128h-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7 15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7c-28.6 16.5-48 47.5-48 83.1 0 53 43 96 96 96s96-43 96-96zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32V256h-64z" })
  }
), Q31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 96H96c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h384c53 0 96 43 96 96v192c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32M265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S429 480.1 416 480.1H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z" })
  }
), Z31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2l-35.2 35.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM280 184v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V184c0-13.3 10.7-24 24-24s24 10.7 24 24z" })
  }
), J31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14.9 146.4C5.5 131.6 0 114 0 95.2 0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4l-145.1 121zm375.3 321c-37.4 28-83.9 44.6-134.2 44.6s-96.8-16.6-134.1-44.6l-35.3 35.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0 469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM288 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), j31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14.9 146.4C5.5 131.6 0 114 0 95.2 0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4l-145.1 121zm375.3 321c-37.4 28-83.9 44.6-134.2 44.6s-96.8-16.6-134.1-44.6l-35.3 35.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0 469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 176c-13.3 0-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24" })
  }
), Y31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2l-35.2 35.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4zM200 192h112c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240H200c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), _31 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4 6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z" })
  }
), h01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4 6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0m221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3M480 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), c01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24m16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h314.8a176.48 176.48 0 0 1-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9-101.6 0-184-60.9-184-136s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2 31.5-29.9 74.2-48.2 121-48.2 4.5 0 9 .2 13.4.5-2-5.9-5.2-11.5-9.4-16.3-9.1-10.3-22.2-16.2-36-16.2zm208 216c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24M40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24zm456 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), s01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24m16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h314.8a176.48 176.48 0 0 1-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9-101.6 0-184-60.9-184-136s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2 31.5-29.9 74.2-48.2 121-48.2 4.5 0 9 .2 13.4.5-2-5.9-5.2-11.5-9.4-16.3-9.1-10.3-22.2-16.2-36-16.2zm208 216c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24M40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24zm600 288a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-66.3 80.7C553.5 468.1 526.2 480 496 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7M448 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), v01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24m16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h352c24.2 0 44.6-18 47.6-42l32-256c1.7-13.7-2.5-27.4-11.6-37.7s-22.2-16.2-36-16.2H48zm392 184c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136 184 60.9 184 136m-184 32c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24M40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), e01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm384 160a160 160 0 1 0-320 0 160 160 0 1 0 320 0m-160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), l01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 160v80c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3.3 4.6.3 6.9 0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1h-33.7c-13.8 0-26-8.8-30.4-21.9l-17.4-52.4c-10.6-31.7-6.5-65.9 10-93.9 7.6-12.9 9.5-29.1 1.2-41.6l-28.3-42.3c-7.3-11-11.9-23.4-13.6-36.4-10 7.3-16.6 19.1-16.6 32.5v56c0 13.3-10.7 24-24 24S0 325.3 0 312v-56c0-44.6 33.2-81.5 76.3-87.2 13-21.4 35.2-36.5 61.1-40 3.8 15.3 9.2 29.8 16.5 43 11.3 20.4 27.4 37.7 49.9 49.8 6.3 3.4 13.1 6.4 20.3 8.8-16.5-11.4-28.9-26-38.2-42.7C163.8 147.9 160 96.1 160 48c0-5.9 3.2-11.3 8.5-14.1s11.5-2.5 16.4.8L320 124.8C321.7 55.6 378.4 0 448 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1-26.1 10.4-55.7-.9-68.3-26zm64-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), t01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h48c8.8 0 16 7.2 16 16v48h128V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v64h48c8.8 0 16 7.2 16 16v48h32v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-32H224v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-80h-48c-8.8 0-16-7.2-16-16v-80H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h32v-48c0-8.8 7.2-16 16-16h48V96h-48c-8.8 0-16-7.2-16-16zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), w01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0C100.3 0 0 100.3 0 224c0 135.3 148.8 247.7 194.7 279.2 8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224 448 100.3 347.7 0 224 0m32 306.3c0-45.4 36.8-82.3 82.3-82.3h32c7.6 0 13.7 6.1 13.7 13.7 0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7M109.7 224c45.4 0 82.3 36.8 82.3 82.3 0 7.6-6.1 13.7-13.7 13.7h-32c-45.5 0-82.3-36.8-82.3-82.3 0-7.6 6.1-13.7 13.7-13.7z" })
  }
), g01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32m96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32M0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m352-128c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32" })
  }
), i01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32m0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32M0 192c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m448 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32" })
  }
), m01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h224c17.7 0 32 14.3 32 32m0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32M0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m448 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32" })
  }
), a01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32m0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32M0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m448 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32" })
  }
), o01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7L318 224h194c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4l-81.6-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7 0 17.7 14.3 32 32 32zm324.9 256-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), n01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64c-9.7 0-18.9 4.4-25 12L176.6 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c9.7 0 18.9-4.4 25-12l246.4-308H608c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), r01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-48.9 0-92.5 28.8-121.6 53.8-15 12.9-27.3 25.7-35.8 35.3-2.3 2.6-4.3 4.9-6 6.9H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-28.5c-1.7-2.1-3.8-4.4-6-6.9-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0m96.9 96H159.1c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8M96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M64 448V256h384v192zm64-128a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), d01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.7 96h38c20.6 0 37.3 16.7 37.3 37.3 0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2 0-20.3 16.4-36.7 36.7-36.7zm56.6 150 42.2-31.6c25.5-19.1 40.5-49.2 40.5-81.1C320 77.4 274.6 32 218.7 32h-38C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3 32 432.2 79.8 480 138.7 480h74.5c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4 47.4 50.3c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1zm-51.5 38.6 82.4 87.4-15.1 22.6c-8.9 13.4-23.9 21.4-39.9 21.4h-74.5c-23.6 0-42.7-19.1-42.7-42.7 0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z" })
  }
), S01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), z01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), p01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), M01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8 0 15.9-.6 23.6-1.7-4.8-9-7.6-19.3-7.6-30.3v-33.3c-5.2.9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), x01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), H01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64v.2c0 .1-.1.3-.2.6-.3.6-.9 1.8-2.3 3.5s-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5 4.1-10 9.6-19.3 16.3-27.7-2.7-2-4.8-4-6.2-5.6-1.4-1.7-2-2.8-2.3-3.5-.1-.3-.2-.5-.2-.6v-.4c0-.1.1-.3.2-.6.3-.6.9-1.8 2.3-3.5 2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4 1.4 1.7 2 2.8 2.3 3.5.1.3.2.5.2.6v.2zm-16 80a80 80 0 1 0-160 0 80 80 0 1 0 160 0M120 464H49.7l37.9-75.8c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1 0-27.1 22-48.9 48.2-48.9 12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7zm133.8-202.2-73.6-73.6c-18-18-42.5-28.2-68-28.2-53.1 0-96.2 43.8-96.2 96.9 0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3h485.4c25 0 45.3-20.3 45.3-45.3 0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9-25.5 0-50 10.1-68 28.2l-73.6 73.6c-10.8-3.8-22.4-5.8-34.2-5.8s-23.4 2-34.2 5.8m126.8 51.4c-4.6-9.2-10.4-17.5-17.3-24.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1 26.1 0 48.2 21.8 48.2 48.9 0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8l37.9 75.8H456z" })
  }
), V01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm32 33.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6m115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z" })
  }
), C01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" })
  }
), L01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" })
  }
), B01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" })
  }
), u01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" })
  }
), R01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M252.6 78.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-192 384c-5 9.9-4.4 21.7 1.4 31.1S20.9 480 32 480h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H83.8L252.6 78.3zm-12.2 96-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9zM321.1 384h49c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3c13.3 24.2 23.3 50.5 29.5 78.3z" })
  }
), $01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7l137.4-137.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z" })
  }
), k01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" })
  }
), P01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160 160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" })
  }
), F01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M244 7c-11.7-9.3-28.3-9.3-40 0L44 135c-13.8 11-16 31.2-5 45s31.2 16 45 5L224 73l140 112c13.8 11 33.9 8.8 45-5s8.8-33.9-5-45zm160 370c13.8-11 16-31.2 5-45s-31.2-16-45-5L224 439 84 327c-13.8-11-33.9-8.8-45 5s-8.8 33.9 5 45l160 128c11.7 9.3 28.3 9.3 40 0z" })
  }
), T01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3l137.4 137.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3l137.4 137.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" })
  }
), A01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1-5.9 6.2-11.8 11.8-17.4 16.7-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128M160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-46.8c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0" })
  }
), D01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h208v-96c0-17.7 14.3-32 32-32s32 14.3 32 32v96h208c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-80V48c0-26.5-21.5-48-48-48zm192 320h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m144 80c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm-400-80H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m16 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm112-80h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16M384 80v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16M240 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm144 144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm112 112h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16M128 208c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm112 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16" })
  }
), y01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c4 0 7.9.1 11.9.3 11.3.5 17.5 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0l-67-115.9c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0M0 256c0-50.9 14.9-98.3 40.5-138.2 6.1-9.5 19.9-8.6 25.6 1.2l102.1 177c6.2 10.7-1.5 24-13.9 24H20.5c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256m193.7 236c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6 23.3 363.5 31 352 42.3 352h204.5c12.3 0 20 13.3 13.9 24zm62.3 20c-4 0-7.9-.1-11.9-.3-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512m256-256c0 50.9-14.9 98.3-40.5 138.2-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24h133.8c7.3 0 13.7 4.9 15.2 12.1 3.5 16.8 5.3 34.1 5.3 51.9M318.3 20c3.6-6.3 11.1-9.4 18-7.1C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6H265.2c-12.3 0-20-13.3-13.9-24l67-116z" })
  }
), b01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 352c66.3 0 120-53.7 120-120V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), f01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80zM30.5 167c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 19.3 0 36.1 5.4 50.3 14.7 8.6 5.6 7.3 17.9-.7 24.3-40 32.3-65.5 81.7-65.5 137 0 54.4 24.7 103 63.4 135.3 7 5.9 8.8 16.3 2.7 23.1-28.5 31.3-63.4 49.6-98.3 49.6-16.5 0-38.1-6.6-51.5-11.3-8.1-2.8-16.9-2.8-25 0-13.4 4.7-35 11.3-51.5 11.3-34.9 0-69.8-18.3-98.1-49.6-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137" })
  }
), U01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80zM0 288c0-76.3 35.7-160 112-160 27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 76.3 0 112 83.7 112 160 0 128-80 224-160 224-16.5 0-38.1-6.6-51.5-11.3-8.1-2.8-16.9-2.8-25 0-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288" })
  }
), G01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32h128V352c0-53 43-96 96-96s96 43 96 96v128h128c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32z" })
  }
), q01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V64c0-10.3-4.9-19.9-13.3-26M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4m258.3-173a32 32 0 1 1 27.4 57.9 32 32 0 1 1-27.4-57.9m-13.2 112.8-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z" })
  }
), W01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4m290.7-186c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16v-96c0-10.3-4.9-19.9-13.3-26M418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91m-13.2 112.8-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z" })
  }
), E01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32h128c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l73.4-73.3H352c-17.7 0-32-14.3-32-32m96-288c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3h-88.4l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32m-20.2 144h40.4L416 135.6z" })
  }
), O01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.4 41.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v306.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z" })
  }
), I01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4m160-112v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48m48-336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" })
  }
), N01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64C150 64 64 150 64 256c0 17.7-14.3 32-32 32S0 273.7 0 256C0 114.6 114.6 0 256 0s256 114.6 256 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-106-86-192-192-192M121.4 390.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l57.3 57.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112z" })
  }
), X01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64m96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64m128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64m128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-73.4 278.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z" })
  }
), K01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM32 96C14.3 96 0 81.7 0 64s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32z" })
  }
), Q01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L336 130.7V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L502.6 54.6zM80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L176 381.3V432c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32z" })
  }
), Z01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 384c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H141.3l201.3-201.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L96 306.7V160c0-17.7-14.3-32-32-32s-32 14.3-32 32z" })
  }
), J01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v370.7l-73.4-73.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z" })
  }
), j01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v146.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352H96c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), Y01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), _01 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4M320 80v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48m48 176c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z" })
  }
), h61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 72c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v112c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40zm123.1 231 80 128c6.2 9.9 6.5 22.3.9 32.5S507.6 480 496 480H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6.9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15" })
  }
), c61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c106 0 192-86 192-192 0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32c0 106 86 192 192 192m134.6-217.4-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l57.4 57.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z" })
  }
), s61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m374.6 214.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), v61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m374.6 214.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64m96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64m96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64m128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), e61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32zm182.6-137.4c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z" })
  }
), l61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v210.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), t61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM443.1 47l80 128c6.2 9.9 6.5 22.3.9 32.5S507.6 224 496 224H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6.9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15M320 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48z" })
  }
), w61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288h352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.3-41.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v114.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm320 128h-64v128c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), g61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m150.6 502.6 96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288h256v-16c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.2-41.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v114.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32S96 46.3 96 64v128zm128 128v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320zm240-80c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), i61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32z" })
  }
), m61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32h128c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32m96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3h-88.4l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zm-20.2 144h40.4L416 359.6z" })
  }
), a61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" })
  }
), o61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256c0-106-86-192-192-192-17.7 0-32-14.3-32-32s14.3-32 32-32c141.4 0 256 114.6 256 256S397.4 512 256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192M121.4 121.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3l57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112z" })
  }
), n61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32zM9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z" })
  }
), r61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96m137.4 137.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H237.3l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z" })
  }
), d61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z" })
  }
), S61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256c0-106 86-192 192-192 17.7 0 32-14.3 32-32S273.7 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192m217.4-134.6-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H269.3l57.4-57.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" })
  }
), z61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32S0 433.7 0 416zm137.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H237.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z" })
  }
), p61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" })
  }
), M61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 55.2V426c0 12.2 9.9 22 22 22 6.3 0 12.4-2.7 16.6-7.5l82.6-94.5 58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320h118.1c12.2 0 22.1-9.9 22.1-22.1 0-6.3-2.7-12.3-7.4-16.5L38.6 37.9c-4.3-3.8-9.7-5.9-15.4-5.9C10.4 32 0 42.4 0 55.2" })
  }
), x61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128M128 32C57.3 32 0 89.3 0 160s57.3 128 128 128h256c35.3 0 64 28.7 64 64 0 27.9-17.9 51.7-42.8 60.4-11.5-17.1-31-28.4-53.2-28.4-35.3 0-64 28.7-64 64s28.7 64 64 64c24.7 0 46.1-14 56.8-34.4C467.6 466.1 512 414.2 512 352c0-70.7-57.3-128-128-128H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h128v14.1c0 9.9 8 17.9 17.9 17.9 4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9L284.8 3.8c-3.1-2.4-7-3.8-11-3.8C264 0 256 8 256 17.9V32zm-8.6 384c-11.1-19.1-31.7-32-55.4-32-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H160v14.1c0 9.9 8 17.9 17.9 17.9 4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8-9.9 0-17.9 8-17.9 17.9V416z" })
  }
), H61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z" })
  }
), V61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256c0-106 86-192 192-192 17.7 0 32-14.3 32-32S273.7 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192m326.6-134.6c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l57.4 57.3H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112z" })
  }
), C61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96C43 32 0 75 0 128v256c0 53 43 96 96 96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32z" })
  }
), L61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32zm374.6 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h178.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" })
  }
), B61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l73.4-73.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h370.7l-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z" })
  }
), u61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h370.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" })
  }
), R61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256c0-106-86-192-192-192-17.7 0-32-14.3-32-32s14.3-32 32-32c141.4 0 256 114.6 256 256S397.4 512 256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192M230.6 121.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l57.4-57.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h210.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z" })
  }
), $61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 96h64c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96-43 96-96V128c0-53-43-96-96-96h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32m-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" })
  }
), k61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v144h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16M166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l25.4-25.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h114.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z" })
  }
), P61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h178.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" })
  }
), F61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" })
  }
), T61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2l17.6-17.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3-163.8-62.5-226.3 0z" })
  }
), A61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2l-17.6-17.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8 229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3 163.8-62.5 226.3 0z" })
  }
), D61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352z" })
  }
), y61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160z" })
  }
), b61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32v160c0 53-43 96-96 96H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H416c17.7 0 32-14.3 32-32z" })
  }
), f61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v160c0 53 43 96 96 96h306.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.3H96c-17.7 0-32-14.3-32-32z" })
  }
), U61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0h96c53 0 96 43 96 96v306.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.3 73.4V96c0-17.7-14.3-32-32-32z" })
  }
), G61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96-43 96-96V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.3-73.4V416c0 17.7-14.3 32-32 32z" })
  }
), q61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M450.7 38C459 44 464 53.7 464 64v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-51.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32m285.7 332.9a32 32 0 1 0-27.4-57.9 32 32 0 1 0 27.4 57.9M405 419.8c-35.4-11.4-61-44.6-61-83.8 0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z" })
  }
), W61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32m290.7 262c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-51.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9M405 203.8c-35.4-11.4-61-44.6-61-83.8 0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z" })
  }
), E61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S493 288 480 288H352c-17.7 0-32 14.3-32 32zm96-288c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32m-20.2 144 20.2-40.4 20.2 40.4z" })
  }
), O61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v306.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z" })
  }
), I61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32m160 336c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48zm48-336h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48" })
  }
), N61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c-106 0-192-86-192-192 0-17.7-14.3-32-32-32S0 238.3 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192M121.4 121.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.3-57.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112z" })
  }
), X61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32S0 334.3 0 352v64c0 53 43 96 96 96h256c53 0 96-43 96-96v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z" })
  }
), K61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), Q61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.3-25.4V320c0 17.7 14.3 32 32 32m-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0M192 192H48c-26.5 0-48 21.5-48 48v185c5.3-3.1 11.2-5.4 17.5-6.9 13.1-3.1 26.7-9.8 37.3-18.6 22.2-18.7 54.3-20.1 78.1-3.4 18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384v224.5c19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 6.3 1.5 12.1 3.8 17.5 6.9V240z" })
  }
), Z61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), J61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z" })
  }
), j61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0C85.5 0 64 21.5 64 48v208H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2 3.8-1.7 7.8-3.1 12-4.1 13.1-3.1 26.7-9.8 37.3-18.6 22.2-18.7 54.3-20.1 78.1-3.4 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 4.2 1 8.2 2.4 12 4.1 3.3-6.6 5.3-14.2 5.3-22.2v-96c0-26.5-21.5-48-48-48h-48V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.3-25.4V256H288V48c0-26.5-21.5-48-48-48zm194.5 421.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), Y61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0H32C14.3 0 0 14.3 0 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32v-82.7l233.4 233.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 64H192c17.7 0 32-14.3 32-32S209.7 0 192 0m133.3 67.1c-17.4-2.9-33.9 8.8-36.9 26.3s8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160-79.2 0-145.1-57.6-157.8-133.3-2.9-17.4-19.4-29.2-36.9-26.3S64.1 307.8 67 325.3C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224 0-111-80.7-203.1-186.7-220.9" })
  }
), _61 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32V205.3l201.4 201.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160H288c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), h81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z" })
  }
), c81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32S0 334.3 0 352v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3z" })
  }
), s81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zm416 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0M448 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m128 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-304-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-176 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96m432-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), v81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h320c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h112c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), e81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3V352c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), l81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h224c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), t81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32m160 48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48zm48 176h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48" })
  }
), w81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48m123.1 223c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5h160c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5z" })
  }
), g81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64c106 0 192 86 192 192 0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106 86-192 192-192m134.6 217.4-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" })
  }
), i81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-9.4 233.4-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" })
  }
), m81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32zm182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z" })
  }
), a81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM443.1 47c-5.8-9.3-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5h160c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5zM320 336v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48" })
  }
), o81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32m0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32m0-128h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32m0-128h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32" })
  }
), n81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S493 32 480 32H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128c-5.4-10.9-16.5-17.7-28.6-17.7m-20.2 144 20.2-40.4 20.2 40.4z" })
  }
), r81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2l105.4 105.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" })
  }
), d81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.4 32.7.1 45.2l146.7 146.8 45.3-45.3L54.6 41.4zM338.7 416H288c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7l-92.1-92.1-45.3 45.3zM288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z" })
  }
), S81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32m22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v210.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7V64c0-17.7-14.3-32-32-32S96 46.3 96 64v210.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z" })
  }
), z81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0c-13.3 0-24 10.7-24 24v118.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zm216 200a40 40 0 1 0-80 0 40 40 0 1 0 80 0m-176 96a40 40 0 1 0-80 0 40 40 0 1 0 80 0m312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80M200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l26.8-49.9V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-54.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.8-49.9V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-37.8 70.2c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z" })
  }
), p81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 384 287.9 384H256v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32M32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64m64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), M81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 384 287.9 384H256v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32M32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), x81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32m214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224h229.5l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.3H205.2l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), H81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m406.6 374.6 96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l41.4 41.4H109.2l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288h293.5l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" })
  }
), V81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L256 210.7 141.3 96H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32v-50.7L210.7 256 96 370.7V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L256 301.3 370.7 416H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7L301.3 256 416 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z" })
  }
), C81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 9.4c12.5-12.5 32.7-12.5 45.2 0L160 114.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zm448 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352H64c-17.7 0-32-14.3-32-32m256 0c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-50.7l105.3 105.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), L81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M21.9 254.4c-16.8-5.6-25.8-23.8-20.3-40.5C25.1 143.5 91 96 165.2 96h173.5l-41.3-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9S429 160 416 160H165.2c-46.7 0-88.1 29.9-102.8 74.1-5.6 16.8-23.7 25.8-40.5 20.2zm468.2 3.3c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416H173.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9S83.1 352 96.1 352h250.7c46.7 0 88.1-29.9 102.8-74.1 5.6-16.8 23.7-25.8 40.5-20.2zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5" })
  }
), B81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2c14.8-44.3 56.2-74.2 102.9-74.2h173.5l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H165.2C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2c-14.7 44.3-56.1 74.2-102.8 74.2H173.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416h173.5c74.2 0 140.1-47.5 163.6-117.9z" })
  }
), u81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 173.3V320c0 53 43 96 96 96h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32-14.3-32-32V173.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM336 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32 14.3 32 32v146.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L544 338.7V192c0-53-43-96-96-96z" })
  }
), R81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8 62.5-62.5 163.8-62.5 226.3 0l17.1 17.2H336c-17.7 0-32 14.3-32 32s14.3 32 32 32h127.9c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2l-17.5-17.6c-87.5-87.5-229.3-87.5-316.8 0-24.4 24.4-42 53.1-52.8 83.8-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2-4 4-6.7 8.8-8.1 14-.3 1.2-.6 2.5-.8 3.8-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32v-51.1l17.6 17.5c87.5 87.4 229.3 87.4 316.7 0 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.5 62.5-163.8 62.5-226.3 0l-.1-.1-17.1-17.1H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2.1-4.8.3s-3.1.5-4.6 1z" })
  }
), $81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h112c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5.8-32 2.3v64.9c10.3-2.1 21-3.2 32-3.2m-123.9 58.7 32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9.8 21.5 2.3 32h64.9c-2.1-10.3-3.2-21-3.2-32 0-38.4 13.5-73.7 36.1-101.3M477.7 224h-64.9c2.1 10.3 3.2 21 3.2 32 0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v112c0 8.8 7.2 16 16 16h112c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16v112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3v-64.9c-10.3 2.1-21 3.2-32 3.2" })
  }
), k81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-70.7 0-128-57.3-128-128 0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z" })
  }
), P81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 9.4c12.5-12.5 32.7-12.5 45.2 0L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2-1.6 3.7-3.8 7.3-6.9 10.3l-.1.1c-3.1 3-6.6 5.3-10.3 6.9-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-141.3 96H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96.1c8.8 0 16.7 3.6 22.5 9.3l.1.1c3 3.1 5.3 6.6 6.9 10.3 1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-18.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2v-.1zm109.3 256 105.3 105.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96.1c0-4.3.9-8.4 2.4-12.2 1.6-3.8 3.9-7.3 6.9-10.4 5.8-5.8 13.7-9.3 22.5-9.4h96.1c17.7 0 32 14.3 32 32s-14.3 32-32 32h-18.6z" })
  }
), F81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v32h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9S179.1 64 192.1 64h32V32c0-17.7 14.3-32 32-32zm-86.6 393.4 64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9S333 448.1 320 448.1h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448h-32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224h32v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S64 332.9 64 319.9V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), T81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 64 287.9 64H256zm-54.6 297.4-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64m64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), A81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M15 15c9.4-9.3 24.6-9.3 34 0l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h38.1L15 49c-9.3-9.4-9.3-24.6 0-34m118.5 228.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128M591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24v38.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-38.2L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0-63-63v38c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-38.1l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z" })
  }
), D81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 64 287.9 64H256zm-54.6 297.4-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), y81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.4H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32S0 273.7 0 256v-32C0 153.3 57.3 96 128 96h210.7l-41.3-41.4c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.4H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32S0 497.7 0 480v-32c0-53 43-96 96-96h146.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z" })
  }
), b81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96H416c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7-14.3-32-32-32H269.3l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256 80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l25.3-25.4H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32S0 497.7 0 480v-32c0-53 43-96 96-96h146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0M64 192a64 64 0 1 1 0-128 64 64 0 1 1 0 128" })
  }
), f81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224v114.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288h114.8l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z" })
  }
), U81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4v293.4l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z" })
  }
), G81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V237.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0l41.3-41.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V237.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z" })
  }
), q81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c17.7 0 32 14.3 32 32v135.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11l-111.6-67V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11l111.6 67V64c0-17.7 14.3-32 32-32" })
  }
), W81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v32c0 53-43 96-96 96-29.3 0-55.6-13.2-73.2-33.9-22.8 21-53.3 33.9-86.8 33.9-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1 5.7-5 13.1-8.1 21.3-8.1 17.7 0 32 14.3 32 32v112c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c0-106-86-192-192-192m64 192a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), E81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64 3.5-10.4 8-21.4 13.6-32.9 11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256c-49.2 82.1-60.3 161.1-21.1 200.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8m58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6 47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9 15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6 14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), O81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5 16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128 20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2 20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2 31.8 1.4 38.6-8.7 40.2-11.7 2.3-4.2 7-17.9-11.9-48.1-6.8 6.3-14 12.5-21.6 18.6m-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2 7.6 6.1 14.8 12.3 21.6 18.6 18.9-30.2 14.2-44 11.9-48.1-1.6-2.9-8.4-13-40.2-11.7zm-82.6-47.8C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5 11.8-5.1 23.4-9.7 34.9-13.5m-159 88.9c1.7-14.3 3.9-28 6.7-41.2-31.8-1.4-38.6 8.7-40.2 11.7-2.3 4.2-7 17.9 11.9 48.1 6.8-6.3 14-12.5 21.6-18.6m-21.7 116.2C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7-2.8-13.1-5-26.9-6.7-41.2-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0-160 0 80 80 0 1 0 160 0m-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), I81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zM336 238v-54c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96 0 35.3-19 66.1-47.4 82.8l-44.6-35c24.7-2 44.1-22.7 44.1-47.8 0-26.5-21.5-48-48-48H384v67.7zm151.4 242L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9h-82.3l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2V416c0 35.3 28.7 64 64 64zm-254-200.2-21.8-17.2-8.6 17.2h30.4" })
  }
), N81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm149.5 141.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9h-82.3l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96h-56c-13.3 0-24-10.7-24-24zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48z" })
  }
), X81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64l-13.3 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h24l-21.5 51.7c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2l31.8-76.3h197.4l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-90.7L253.5 51.7zM256 224h-64l32-76.8zm-90.7 64h117.4l13.3 32H152z" })
  }
), K81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1-10.2 51.9-34 104.5-66.3 136.7-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3C221 86 241.4 71 256.6 52.5 283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144 0 44.8-20.5 84.9-52.6 111.3m-176.2 91.9c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4-49.1 102.1-16.4 134.8 93 25.3 134.8-16.4z" })
  }
), Q81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.3 5.3c11.5-7 26-7 37.5 0l17.9 10.9c5.9 3.6 12.7 5.4 19.6 5.2l20.9-.5c13.5-.3 26 6.9 32.5 18.7l10 18.4c3.3 6.1 8.3 11 14.3 14.3l18.4 10c11.8 6.5 19.1 19 18.7 32.5l-.5 20.9c-.2 6.9 1.7 13.7 5.2 19.6l10.9 17.9c7 11.5 7 26 0 37.5l-10.9 17.9c-3.6 5.9-5.4 12.7-5.2 19.6l.5 20.9c.3 13.5-6.9 26-18.7 32.5l-18.4 10c-6.1 3.3-11 8.3-14.3 14.3l-10 18.4c-6.5 11.8-19 19.1-32.5 18.7l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9.5c-13.5.3-26-6.9-32.5-18.7l-10-18.3c-3.3-6.1-8.3-11-14.3-14.3l-18.4-10c-11.8-6.5-19.1-19-18.7-32.5l.5-20.9c.2-6.9-1.7-13.7-5.2-19.6l-11-18c-7-11.5-7-26 0-37.5l10.9-17.9c3.6-5.9 5.4-12.7 5.2-19.6l-.5-20.9c-.3-13.5 6.9-26 18.7-32.5L58 72.4c6.1-3.3 11-8.3 14.3-14.3l10-18.4c6.5-11.8 19-19.1 32.5-18.7l20.9.5c6.9.2 13.7-1.7 19.6-5.2l18-11zM272 192a80 80 0 1 0-160 0 80 80 0 1 0 160 0M64.4 492.4 88 390c8.9 3.7 18.6 5.6 28.6 5.4l20.7-.5c.2 0 .4.1.6.2l17.6 10.7c22.4 13.6 50.5 13.6 72.9 0l17.7-10.8c.2-.1.4-.2.6-.2l20.7.5c10 .2 19.7-1.7 28.6-5.4l23.6 102.4c1.3 5.5-.5 11.3-4.6 15.2s-10 5.3-15.4 3.8L192 480.6 84.4 511.4c-5.4 1.6-11.3.1-15.4-3.8s-5.8-9.7-4.6-15.2" })
  }
), Z81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7l19.3 9.7c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7l-9.7 19.3c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2.8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1.4 14.2-1.5 20.1-5.4zM272 192a80 80 0 1 0-160 0 80 80 0 1 0 160 0M1.3 441.8l43.1-102.5c.2.1.3.2.4.4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7.2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2l-32.2-49.3-56.1 8.3c-5.7.8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1.4-.2.7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2.2-.3.4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z" })
  }
), J81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M95.9 14v.1c0 .1.1.4.1.7.1.7.3 1.8.6 3.3.6 3 1.7 7.4 3.5 12.8 3.6 10.8 9.9 25.1 20.6 39.5 13.9 18.6 36 37.9 71.2 48.8v147.6c-29.9 11.1-50.9 29.3-65.6 47.3-11.9 14.6-19.7 29.3-24.5 40.3-2.4 5.5-4 10-5.1 13.1-.5 1.5-.9 2.7-1.1 3.5l-.2.8v.1c-1.5 5.8-6.1 10.3-11.9 11.7s-12-.7-15.8-5.3L80 368l-12.2 10.3-.1-.1-.2-.2-.6-.8c-.5-.7-1.3-1.6-2.3-2.9-1.9-2.5-4.6-6.1-7.7-10.6-6.3-9.2-14.7-22.4-23.1-38.9C17 291.9 0 245.3 0 192S17 92.1 33.7 59.3c8.4-16.5 16.8-29.7 23.1-38.9 3.2-4.6 5.8-8.2 7.7-10.6 1-1.2 1.7-2.2 2.3-2.9l.6-.8.2-.2.1-.1 12.2 10.3L67.8 5.7C71.9.8 78.5-1.1 84.6.7c6.1 1.8 10.5 7 11.3 13.3zM320 266.8V119.2c35.2-10.9 57.3-30.2 71.2-48.8C403.3 54.3 412.8 34 416.1 14c.8-6.3 5.3-11.5 11.3-13.3 6.1-1.8 12.8.3 16.9 5.2 13.3 16.3 24.4 34.8 33.9 53.4 12.4 24.5 25.1 56.6 30.7 93.4.5 3.5-1.4 7-4.7 8.4l-55.1 23.6c-6.5 2.8-6.5 11.9 0 14.7l55.2 23.6c3.3 1.4 5.3 4.8 4.7 8.4-8 53-31.3 105.5-64.5 146.6-3.9 4.6-10.3 7-16.1 5.6s-10.5-6-11.9-11.8c-5.9-21-17.2-40.9-30.9-57.7-14.7-18-35.7-36.2-65.6-47.3M288 64v416c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), j81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32 123.7 0 224-100.3 224-224 0-17.7-14.3-32-32-32h-82.7l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4zM448 316c45-11.6 80.4-47 92-92h32.8c-12.7 62.7-62.1 112.1-124.8 124.8zM244.1 206.6 9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l234.7-234.8-61.3-61.3z" })
  }
), Y81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h128c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64m-96 64h128c35.3 0 64 28.7 64 64s-28.7 64-64 64H64z" })
  }
), _81 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6-51.9-23.8-72.7-41.6-37.3-39-48.6-62.3S0 249.2 0 224h384zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96m240 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), h51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 88a72 72 0 1 1 144 0 72 72 0 1 1-144 0M39.7 144.5c13-17.9 38-21.8 55.9-8.8l36.2 26.3c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128v-36.3c-15.2-6.7-29.7-15.1-43.3-25l-36.2-26.4c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8 60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53 60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6l24.3-24.3-26-37.2z" })
  }
), c51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 48h64c4.4 0 8 3.6 8 8v40h-80V56c0-4.4 3.6-8 8-8m-56 8v40h-8C57.3 96 0 153.3 0 224v224c0 35.3 28.7 64 64 64V352c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v160c35.3 0 64-28.7 64-64V224c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56h-64c-30.9 0-56 25.1-56 56m216 456v-96H96v96zM144 176h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16m208 208v-32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v32z" })
  }
), s51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v118.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96v118.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96v320c0 12.4-7.2 23.7-18.4 29" })
  }
), v51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6z" })
  }
), e51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3v83.4zM256 352V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29z" })
  }
), l51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7l-34.9 17.5-28.5-28.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5c118.4-59.1 163.2-124.3 205.6-186l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9 33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1 27.5-24.3 63.4-45.2 117.3-60.6l.2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2c-44.4 64.7-96.7 140.8-229.9 207.4-12.3 6.2-27.2 3.7-36.9-6z" })
  }
), t51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304.9.7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9-7.3 1.7-14.3 3.5-21.1 5.5L226.5 23c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3l11.2 9c-1.8 2.8-3.5 5.7-5.1 8.5-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7.8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2.8-.4 1.5-.5 2.3-2.2 9.3-3.4 17.3-4.1 23.4-.4 3.1-.6 5.7-.8 7.8-.1 1.1-.1 2-.2 2.8l-.1 1.1V269.1s0 .1 29.1 1h-.1l-29.1-.8c-.1 3.1 0 6.1.2 9.1L13 282.7C3.5 285.4-2 295.4.7 304.9S13.4 320 23 317.3l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2.1 2.4.2 3.6.2 15.6.5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1 11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5c11.7.4 27.3.9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0m130.7 345c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3.6 16.8 0 25.2-1.9 7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8l5.5 8.3c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3l-11.2-9c1.8-2.8 3.5-5.7 5.1-8.5 6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8.4-1.5.5-2.3 2.2-9.3 3.4-17.3 4.1-23.4.4-3.1.6-5.7.8-7.8.1-1.1.1-2 .2-2.8l.1-1.1V242.9s0-.1-29.1-1h.1l29.1.9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7.3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6zM576 241.5c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), w51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9.5-29.9 2.8-12.1 2.8-23.7 5.9-34.9 9.4L302 30.6c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8l-6.6-9.9c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1-3.5 12.5-5.7 23.2-7.1 31.3-.7 4.1-1.2 7.5-1.6 10.3-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1.6v.4s0 .1 39.2 3.7l-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8.9 406.6s16.9 20.1 29.7 16.5l13.8-3.9C55 439.9 72 457 92.9 467.7L89 481.4c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-4-14.4c6.9-2.2 14.3-4.3 22.2-6.1 12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7S494.2 85.4 481.4 89l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zm-331 332.7L144 368zM112 320a48 48 0 1 1 96 0 48 48 0 1 1-96 0m128-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), g51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0m113 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), i51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0m20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6-15 8.9-27.7 24.4-27.6 46.9.1 21.5 12.6 35.1 26.3 43.4 11.9 7.2 27 11.7 39.1 15.4l1.9.6c13.9 4.2 24.4 7.6 31.7 12.2 6.1 3.8 7.5 6.8 7.6 11 .1 6.5-2.5 10.4-7.6 13.6-6 3.7-15.2 5.9-25.1 5.6-12.7-.4-24.6-4.4-39.7-9.6-2.6-.9-5.2-1.8-8-2.7-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2.7 4.5 1.5 6.8 2.3 9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20v-17.2c9.3-1.7 18.6-4.9 26.8-10.1 15.3-9.5 26.8-25.7 26.5-48.1-.3-21.6-12.4-35.6-26.3-44.3-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9-6.2-3.7-7-6.3-7-9.3 0-5.1 2.1-8.8 7.9-12.3 6.5-3.8 16-6 25-5.8 10.9.2 22.9 2.6 35.2 5.8 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4v-17.3z" })
  }
), m51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0m-64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-15-111c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z" })
  }
), a51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6.2c6.7-18.5 24.4-31.7 45.2-31.7 26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1 26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6.2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8l-20.1-35.2c-5.3 2-10.9 3.1-16.9 3.1-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48m-48 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), o51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9c16.1 30.4 48.1 51.1 84.9 51.1s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1c30.4-16.1 51.1-48.1 51.1-84.9s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9" })
  }
), n51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m164.6 389.3 16-37.3h118.1l16.9 101.3c2.6 15.4 15.9 26.7 31.6 26.7h31.1c19.8 0 34.8-17.8 31.6-37.3L393 342.1c27.9-29 80.6-70.8 144.1-90.8l16.1 25.8c3.1 5 10.4 5 13.6 0l22.8-36.5c12.9-2.1 25.2-7.4 34.4-16.6 10.2-10.2 16-24.1 16-38.6v-3.8c0-23.2-12.6-44.5-32.8-55.8l-81.9-45.5A128.94 128.94 0 0 0 462.5 64c-20.1 0-39.9 4.7-57.8 13.6L400 80c-21 10.5-44.2 16-67.8 16H128C57.3 96 0 153.3 0 224v32c0 17.7 14.3 32 32 32 5.4 0 10.6-1.4 15-3.7 9.1 17.1 22.1 31.9 37.7 43.3l-16.8 59c-2.5 8.8-2.5 18.2.2 27l13.1 43.7c4.1 13.5 16.5 22.8 30.7 22.8H141c21.4 0 36.8-20.7 30.7-41.2l-8.3-27.7c-2.2-7.2-1.7-14.9 1.2-21.8zM570 160h-51.4c.9 2.5 1.4 5.2 1.4 8 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8.5-5.5 1.4-8h-5.9c-23.2 0-46 6.3-65.9 18.2l-106.8 64.1c-14.9 9-32 13.7-49.4 13.7H192c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144h172.2c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6 13.8 0 27.4 3.5 39.5 10.2z" })
  }
), r51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3 40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64m-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-54.4 54.4-131.9 78.7-198.2 61.7-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84-3.7-14.3-5.5-29.2-5.5-44.2 0-54.2 23.4-110.5 66.9-154zM464 400c0-26.5 21.5-48 48-48s48 21.5 48 48v32h-96zm-15.3 91.4 13-43.4h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9zM496 496v-48h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16m48.7 4.6L528.9 448h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7z" })
  }
), d51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64 38.6 38.6c-4.2-4.2-6.6-10-6.6-16C32 10.1 42.1 0 54.6 0h402.8C469.9 0 480 10.1 480 22.6c0 6-2.4 11.8-6.6 16L448 64zm-8 32h400l10.6 42.5c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416H56l-10.6-42.5C36.5 338 32 301.5 32 264.8v-17.6c0-36.6 4.5-73.1 13.4-108.7zm8 352h384l25.4 25.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16zm80-288c-8.8 0-16 7.2-16 16 0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24v-40.3c58.1-4.1 104-52.6 104-111.7 0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160z" })
  }
), S51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160zm-48 48H48c-26.5 0-48 21.5-48 48v208c0 53 43 96 96 96h256c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48h-64v-48C336 50.1 285.9 0 224 0S112 50.1 112 112zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48m152 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), z51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 208c0 114.9-93.1 208-208 208-3.9 0-7.7-.1-11.5-.3 6.5-12.3 12-25.3 16.3-38.8 4.7-.7 9.3-2.5 13.3-5.3l20.9-14.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6l20.1-15.4c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6l-20.9-14.2c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6l-25.3.7c-13.2.4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0c114.9 0 208 93.1 208 208m-243.9-53c10.2-6.9 22.6-11 35.9-11 35.3 0 64 28.7 64 64 0 30.6-21.5 56.3-50.3 62.5-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0m256 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0M112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32m144 16a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16-176a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-176-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), p51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 96v64h96V96c0-26.5-21.5-48-48-48s-48 21.5-48 48m-48 64V96c0-53 43-96 96-96s96 43 96 96v64h64c35.3 0 64 28.7 64 64H240c-44.2 0-80 35.8-80 80v160c0 5.5.6 10.8 1.6 16H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm128 96h256c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V320c0-35.3 28.7-64 64-64m64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64z" })
  }
), M51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5l-84.5 56.3 70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 96l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.8-81.6L57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5z" })
  }
), x51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9.1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4-89.6 24.1c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0m0 156.2-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z" })
  }
), H51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0c-17.7 0-32 14.3-32 32v32H37.6C16.8 64 0 80.8 0 101.6V406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c61.9 0 112-50.1 112-112 0-40.1-21.1-75.3-52.7-95.1 13-18.3 20.7-40.7 20.7-64.9 0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32m-32 128v96H64v-96zm64 96v-96c26.5 0 48 21.5 48 48s-21.5 48-48 48m-64 64v96H64v-96zm64 96v-96h32c26.5 0 48 21.5 48 48s-21.5 48-48 48z" })
  }
), V51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160M208 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160m-16 104a80 80 0 1 0-160 0 80 80 0 1 0 160 0m128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160m288-80a80 80 0 1 0-160 0 80 80 0 1 0 160 0M432 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), C51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 86 86 0 192 0s192 86 192 192c0 102.6-102.8 194.9-143.6 227.5-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8 0 7.1-5.8 12.9-12.9 12.9H140.9c-7.1 0-12.9-5.8-12.9-12.9 0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192m96-16c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16" })
  }
), L51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160c0 92.5 87.2 174 117.7 199.7 5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L198 379.9c-3.5-6.9-1.6-15.3 4.4-20.3C232.8 334 320 252.5 320 160M144 96c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16m293.7 327.7c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160-53.7 0-101.2 26.4-130.2 67 1.4 9.5 2.2 19.2 2.2 29 0 37.2-11.5 71.8-27.3 101.9 18.5 76.2 86.8 139.7 113 161.8M416 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48" })
  }
), B51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 256c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 0h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16-240c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16m16 112h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16m-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), u51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m112 32c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16m16-272h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16 144c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16" })
  }
), R51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2l267.7 267.7C335.9 434.9 297.5 448 256 448m89-148.3 19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7v-18.6l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19-18.7 0-35.9 6.4-49.6 17.2l-61.6-61.7C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5l27.9-16.8c14 11.9 32.1 19 51.8 19 6.6 0 13-.8 19.2-2.3L175 265.5z" })
  }
), $51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M412.5 367.2 342.3 297c20.6-17.6 33.7-43.8 33.7-73 0-53-43-96-96-96h-72c-9.7 0-18.6 3.5-25.5 9.2l-37.7-37.7C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2m-45.3 45.3C335.9 434.9 297.5 448 256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2zm-70.6-161.1L237.3 192H280c17.7 0 32 14.3 32 32 0 11.6-6.2 21.7-15.4 27.4M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-88-250.7V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-26.7z" })
  }
), k51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m99.5 144.8 79.2 79.2 96 96 92.5 92.5C335.9 434.9 297.5 448 256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2M333.3 288l-32-32H384v32zm32 32H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m16-416c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s-7.2-16-16-16m-42.5 224-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16z" })
  }
), P51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M367.2 412.5 99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5m45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192-41.5 0-79.9 13.1-111.2 35.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), F51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 35.7-7.3 69.6-20.5 100.5 4.8 3 9.4 6.2 13.9 9.8l35.5 28.4 81-21.7c10.6-2.8 21.4-4.4 32.3-4.9 1.2-10.5 1.8-21.3 1.8-32.1 0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55 10.3 27.7 15.9 57.7 15.9 89m-26.6 135.2c-18.8-15-42.1-23.2-66.1-23.2-22.9 0-45.2 7.4-63.5 21.2l-42.2 31.6c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.2-31.6c10-7.5 22.2-11.6 34.7-11.6 10.5 0 20.8 2.9 29.7 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48h112c117.3 0 218.2-70.1 263.1-170.6l11.5-3.1c5.7-1.5 11.6-2.3 17.5-2.3 23.8 0 45.9 12.5 58.1 32.9l21.3 35.4c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-21.3-35.4C530.4 309.3 492.7 288 452 288c-3.8 0-7.5.2-11.3.6-5.5.5-10.9 1.5-16.3 2.8-.8.2-1.5.4-2.3.6l-96.7 25.8-48.1-38.5z" })
  }
), T51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-96zM448 96H192v320h256zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h96V96zm184 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48M248 304a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), A51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M36 32.2C18.4 30.1 2.4 42.5.2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v160c0 53 43 96 96 96h32c106 0 192-86 192-192v-32c0-53-43-96-96-96h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128h-32c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-31.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z" })
  }
), D51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-76.1 76.2c-20.6-13.9-44.3-23.4-70-27V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7v1.8c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6h1.9c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-3.7-25.7-13.1-49.5-27-70l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9zM192 208a112 112 0 1 1 0 224 112 112 0 1 1 0-224m-36.7 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z" })
  }
), y51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96 80h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24m160 0h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24m72 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm-144-24c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16m288-72c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8m472-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8" })
  }
), b51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 32c-13.3 0-24 10.7-24 24v136h64V56c0-13.3-10.7-24-24-24zM64 456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H64zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32zm64-8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm96 264c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm128 272c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16m64 408c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-352 0h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), f51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 32C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16m72 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm168 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24m-64-8v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16" })
  }
), U51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m64 160c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32m224 160c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32" })
  }
), G51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 160H320v-32h128zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm400 288v32H192v-32zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48z" })
  }
), q51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m0 160c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m192 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32 14.3 32 32" })
  }
), W51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m64 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32m384 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32" })
  }
), E51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32" })
  }
), O51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6l-73.1 115.8c-7.3 11.5-15.8 22.2-25.5 31.9l-37.3 37.2 51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0m88 432a80 80 0 1 0-160 0 80 80 0 1 0 160 0M15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), I51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62.7 223.4c-4.8.4-9.7.6-14.7.6-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8 222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7.7-11.5.7-17.3 0-16.5-1.9-32.6-5.6-47.9 1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6-15.4-3.6-31.4-5.6-47.9-5.6-5.8 0-11.6.2-17.3.7-8.8.7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6 15.6 0 30.8 2 45.2 5.9-16.5 111-104.4 198.9-215.4 215.3-3.9-14.4-5.9-29.6-5.9-45.2 0-4.9.2-9.8.6-14.7.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3 0 16.5 1.9 32.6 5.6 47.9-1.8 0-3.7.1-5.6.1C114.6 512 0 397.4 0 256c0-1.9 0-3.7.1-5.6 15.3 3.7 31.4 5.6 47.9 5.6 5.8 0 11.6-.2 17.3-.7 8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zm58.6-15.4c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5 3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7m277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9-45.2 20.8-81.7 57.2-102.5 102.5-3.7 8-.2 17.5 7.9 21.2s17.5.2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7 8-3.7 11.6-13.2 7.9-21.2z" })
  }
), N51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192h232.6L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32l-51.9 207.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.6l93.1-179.1c6.1-11.8 20.6-16.3 32.4-10.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48m312-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), X51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32l51.9 207.5C91 492 116.6 512 146 512h284c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-85.6L365.3 12.9c-6.1-11.7-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4L404.3 192H171.7l81.6-156.9zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16m96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16m128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), K51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M6.8 187C24.7 153.1 116.7 0 320 0s295.3 153.1 313.2 187c4.9 9.4 6.8 19.1 6.8 28v116.2c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288h-32.3l-7.2 50.3-22.9 160c-.9 6.1-5.2 11.2-11.1 13s-12.3.1-16.5-4.4L384.4 451l-52.8 56c-3 3.2-7.2 5-11.6 5s-8.6-1.8-11.6-5l-52.8-56-51.9 55.9c-4.2 4.5-10.6 6.2-16.5 4.4s-10.2-6.9-11.1-13l-22.9-160-7.1-50.3h-32.3l20.7 144.6L38 389.7c-23.1-10.3-38-33.2-38-58.5V214.9c0-8.9 1.8-18.6 6.8-28zm171.6 101 5.2 36.6 44-36.6zm99.3 0-.6.5 42.9 46.1 42.8-46.1-.6-.5h-84.4zm134.5 0 44 36.6 5.2-36.6h-49.1zM192 128c-17.7 0-32 14.3-32 32v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-17.7-14.3-32-32-32zm256 32v48H192v-48zm-60.5 149-45.7 49.2 42.7 46 51.6-54.7zm49.4 151.6 11-76.8-41.5 44 30.5 32.9zM320 381.7l-42.6 45.9 42.6 45.1 42.6-45.2zm-21.8-23.5L252.5 309l-48.7 40.5 51.6 54.7 42.7-46zm-64.6 69.5-41.5-44 11 76.8 30.5-32.9z" })
  }
), Q51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m86.6 64 85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64M64 86.6c-28.5 32.4-49 72-58.4 115.7C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1zM256 0c-7.3 0-14.6.3-21.8.9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124l61.4 61.4L425.4 64C380.2 24.2 320.9 0 256 0M48 240c-16.2 0-32-2-47.1-5.8A263 263 0 0 0 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240m463.1 37.8c.6-7.2.9-14.5.9-21.8 0-64.9-24.2-124.2-64-169.4L278.6 256l61.4 61.4c33.4-28.3 76.7-45.4 124-45.4 16.2 0 32 2 47.1 5.8m-4.7 31.9c-13.5-3.7-27.7-5.7-42.4-5.7-38.4 0-73.7 13.5-101.3 36.1l85.3 85.3c28.5-32.3 49.1-71.9 58.4-115.7zm-166.3 53C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4 43.7-9.4 83.3-29.9 115.7-58.4l-85.2-85.2zM317.4 340 256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64 7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124" })
  }
), Z51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m235.6 52.8 10.8 14.4c6 8.1 15.5 12.8 25.6 12.8h32c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8 5.8 0 10.8 4.1 11.8 9.8l19 101.4 71.8-34.2c16.2-7.7 35.5-3.6 47.1 10 49.2 57.4 76.3 130.6 76.3 206.2v37.6c0 9.7-10.2 16-18.9 11.7l-63.8-31.9c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1L381 380.9c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1l-64 31.9c-8.7 4.3-18.9-2-18.9-11.7v-37.6C0 265.6 27.1 192.4 76.3 135c11.6-13.6 30.9-17.7 47.1-10l71.8 34.2 19-101.4c1.1-5.7 6-9.8 11.8-9.8 3.8 0 7.4 1.8 9.6 4.8z" })
  }
), J51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16z" })
  }
), j51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h92.2c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h139.2l80-64zm384 256H324.8l-80 64H464c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80h-92.2c13 14.5 16.1 35.6 7.2 53.5l-5.3 10.5H464c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16M346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S169.2 272 176 272h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z" })
  }
), Y51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 160c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16zM0 176c0-44.2 35.8-80 80-80h384c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80z" })
  }
), _51 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96v64H80c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h118.7c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80zm256 320H345.3c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H336V96h128c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80M272 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24m-32 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), h71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80zm368 96H96v128h352z" })
  }
), c71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80zm208 96H96v128h192z" })
  }
), s71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80zm80 96H96v128h64z" })
  }
), v71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80zm112 96H96v128h96z" })
  }
), e71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c19.8-14.5 32.7-38 32.7-64.5v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM236.4 160H496c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16h-14.6l-245-192zm88.5 192H112c-8.8 0-16-7.2-16-16V176c0-1.4.2-2.7.5-4l-51.1-40.3C36.9 144.4 32 159.6 32 176v160c0 44.2 35.8 80 80 80h294.2L325 352z" })
  }
), l71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80zm272 96H96v128h256z" })
  }
), t71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h448v32c0 17.7 14.3 32 32 32s32-14.3 32-32V112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64zm448 224H256c-17.7 0-32 14.3-32 32v96H64V192h448zm-320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), w71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-53-43-96-96-96H64z" })
  }
), g71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v129.1c-14.5-8.4-30.7-14-48-16.1v-33c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v32h-32v-32c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v33c-17.3 2.2-33.6 7.8-48 16.1zM0 320c0-53 43-96 96-96h320c53 0 96 43 96 96v128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 465.7 0 448z" })
  }
), i71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M483.2 9.6 524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6l-24.1-32.1-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h136c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6.1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32l11.3-23.9H544c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 497.7 0 480V96c0-17.7 14.3-32 32-32s32 14.3 32 32v256h224V192c0-17.7 14.3-32 32-32m-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), m71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v256h224V160c0-17.7 14.3-32 32-32h224c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32m144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), a71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8c10.3-4.8 21.8-7.5 33.9-7.5s23.6 2.7 33.9 7.5l34.8-34.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-31.5 31.5C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112 0 61.9-53.6 104.9-112.9 111.2.6-5.1.9-10.2.9-15.2 0-16.8-2.4-33.1-6.8-48.5 35.2-3.6 54.8-27.9 54.8-47.5 0-21.3-22.9-48-64-48-34.8 0-56.6 19.2-62.4 38.1 28.6 26.3 46.4 64 46.4 105.9 0 83.8-103.6 179.7-129.9 202.8-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2C247.6 483.7 144 387.8 144 304c0-41.9 17.9-79.6 46.4-105.9-5.8-18.9-27.6-38.1-62.4-38.1-41.1 0-64 26.7-64 48 0 19.6 19.5 43.9 54.8 47.5-4.4 15.4-6.8 31.7-6.8 48.5 0 5 .3 10.1.9 15.2C53.6 312.9 0 269.9 0 208 0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9-.3-2.9-.5-5.9-.5-8.9 0-20.4 7.6-39 20.2-53.2l-31.5-31.5c-6.2-6.2-6.2-16.4 0-22.6zm52.8 384.1c12.8 16.4 26.5 31.3 38.5 43.4 12-12.1 25.7-27 38.5-43.4 1.2-1.6 2.5-3.2 3.7-4.8h-84.4c1.2 1.6 2.4 3.2 3.7 4.8M359.6 336c5.6-12.6 8.4-23.4 8.4-32H208c0 8.6 2.8 19.4 8.4 32zm-7.6-80c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32z" })
  }
), o71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32h51.2c42.4 0 76.8 34.4 76.8 76.8v102.1c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm352 247.6 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7v-102c0-7.1-5.7-12.8-12.8-12.8H384zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), n71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M267.7 133.3C253 149.7 231.7 160 208 160s-45-10.3-59.7-26.7c-6.9-7.7-21.4-8.6-29.6-2.3-10.7 8.1-24.1 13-38.7 13-35.3 0-64-28.7-64-64s28.7-64 64-64c14.6 0 28 4.9 38.7 13 8.2 6.3 22.7 5.4 29.6-2.3C163 10.3 184.3 0 208 0s45 10.3 59.7 26.7c6.9 7.7 21.4 8.6 29.6 2.3 10.7-8.1 24.1-13 38.7-13 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.6 0-28-4.9-38.7-13-8.2-6.3-22.7-5.4-29.6 2.3M32 448V163.2c14.1 8.1 30.5 12.8 48 12.8 18.7 0 36.2-5.4 51-14.7 20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7 19.6 0 37.9-5.9 53.1-16h46.1c42.4 0 76.8 34.4 76.8 76.8v102.1c0 30.3-17.9 57.9-45.6 70.2L384 445.7v2.3c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64m352-72.4 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7v-102c0-7.1-5.7-12.8-12.8-12.8H384zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), r71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368h448c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), d71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32m45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7M192 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0m56-184v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), S71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c-17.7 0-32 14.3-32 32v19.2C215 66 160 130.6 160 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32m45.3 493.3c12-12 18.7-28.3 18.7-45.3H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7M0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24m536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24zm61.5-154.7c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2M53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32c-11.9-6-26.3-1.2-32.3 10.7s-1.1 26.3 10.7 32.2z" })
  }
), z71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32m45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7M224 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-40c-13.3 0-24-10.7-24-24s10.7-24 24-24h40v-40c0-13.3 10.7-24 24-24" })
  }
), p71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22 0-26.5-21.5-48-48-48-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0c-60.8 0-115.4 26.1-153.5 67.6L38.8 5.1zM220 147.2c14-11.9 32.1-19.2 52-19.2 44.2 0 80 35.8 80 80 0 12.9-3.1 25.1-8.5 35.9l-26.1-20.4c1.7-4.9 2.6-10.1 2.6-15.5 0-26.5-21.5-48-48-48-9.5 0-18.4 2.8-25.9 7.6zm288.3 349.3L465.8 463c-3.2.7-6.4 1-9.8 1h-40v-40.2l-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48h280c19.3 0 37.3-5.7 52.3-15.5M373 389.9 71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208 36.7 0 71.1-9.5 101-26.1" })
  }
), M71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160m0 288a208 208 0 1 0 0-416 208 208 0 1 0 0 416m48-208a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 240c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48h280c43.4 0 80.1-28.8 92-68.3 16.6-7.6 28-24.3 28-43.7 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.5 7.3 29.2 18.7 38-8 15.4-24.1 26-42.7 26h-40v-64c-40.1 30.1-90 48-144 48" })
  }
), x71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7.7-3.5.7-5.4 0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v19.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8h289.4L160 222.1v20.7zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448" })
  }
), H71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32m45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7" })
  }
), V71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m230.8 245.5 18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9-230.5-83.9C10 311.7 2 301.5.6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6-64.1 42.2-93.3 124.2-65.7 199.5zm30.1-10.9c-26.1-71.3 10.5-150.2 81.9-176.2s150.4 10.8 176.5 82.1l18.7 51.2c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2zM480.8 480c-21.2 0-40-10.2-51.7-25.9l116.1-42.3c.1 1.3.1 2.6.1 3.9 0 35.5-28.9 64.3-64.5 64.3zM94.3 376.1l117.6 43.4c-11.6 17.1-31.2 28.4-53.5 28.4-35.6 0-64.5-28.8-64.5-64.3 0-2.5.1-5.1.4-7.5z" })
  }
), C71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M608 96c0 5.1-.4 10.2-1.2 15.1 20.1 14.6 33.2 38.2 33.2 64.9 0 44.2-35.8 80-80 80h-16v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V256h-16c-44.2 0-80-35.8-80-80 0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96s96 43 96 96M32 224c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm0 128h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), L71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296 136V88h48v48zm-8-104c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1 8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1 59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36 35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400v-4c0-26.5-21.5-48-48-48zM88 376h48v48H88zm416 48v-48h48v48z" })
  }
), B71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38c-4.5-6.3-11.8-10-19.5-10h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32zm146.6 271.7 32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9 39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4.1 5.1.2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48 50.7-101.3 72.9 101.2-.1.1H166.8zm90.6-128h108.4L317 274.8 257.4 192z" })
  }
), u71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80c-26.5 0-48 21.5-48 48v272c-17.7 0-32 14.3-32 32s14.3 32 32 32h256v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48zM320 352H96V96h96v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h128v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h96v256z" })
  }
), R71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0c-13.3 0-24 10.7-24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3-10.7-24-24-24zM32 192h320c0-26.5-10.7-50.5-28.1-67.9-1.1-1.1-2.1-2.1-3.2-3.1-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96m352 0h191.1c-1.2-9.7-4.6-18.7-9.6-26.5 6.4-9.5 10.1-21 10.1-33.3 0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v42.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6C365 115.1 384 151.3 384 192M32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l24.2 169c4.5 31.5 31.5 55 63.4 55h401c31.8 0 58.9-23.4 63.4-55l24-169c17.7 0 32-14.3 32-32s-14.3-32-32-32zm276.5 102.1-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4 15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2s-8.9 2.3-11.5 6.1zm-43.1 64.7-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7 0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16h-25.3c-22.4 0-40.6-18.2-40.6-40.6 0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7 7.6 4.8 9.8 14.9 4.8 22.4zm88.3 25.2h20.9c4.8 0 8.6-3.9 8.6-8.6 0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4 7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4 0 22.4-18.2 40.6-40.6 40.6h-20.9c-8.8 0-16-7.2-16-16s7.2-16 16-16z" })
  }
), $71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3 10.7-24 24-24M32 192c0-53 43-96 96-96h128c24.9 0 47.6 9.5 64.6 25 1.1 1 2.2 2 3.2 3.1 17.5 17.4 28.2 41.4 28.2 67.9zm352 0c0-40.7-19-76.9-48.6-100.4C340.6 86 346.9 81.3 354 78l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v42.1c5.6 1.3 11.1 3.2 16.4 5.7l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 12.3-3.7 23.8-10.1 33.3 5 7.8 8.4 16.9 9.6 26.5zM0 256c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24.2 169c-4.5 31.5-31.5 55-63.4 55h-401c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32" })
  }
), k71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64m32 64h512l-26.7 293.8c-3 33-30.6 58.2-63.7 58.2H122.4c-33.1 0-60.7-25.2-63.7-58.2zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6 11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3L222.5 221c-7.9 11.3-4.7 26.8 6.9 34.1 10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2 0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-49.6c-3.5 0-6.4-2.9-6.4-6.4 0-1.3.4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4 0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7 0 3.5-2.9 6.4-6.4 6.4H336c-13.3 0-24 10.7-24 24" })
  }
), P71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M322.7 6C331 12 336 21.7 336 32v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.6-1.7 28.9 4.3m-224 288c8.3 6 13.3 15.7 13.3 26v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-83.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0m0 64v96h64V64zm128 288c0-35.3 28.7-64 64-64h64c6.2 0 12.2.9 17.9 2.5-11.2 22.9-17.6 48.6-17.9 75.7V352h-64v96h83.2c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512h-64c-35.3 0-64-28.7-64-64zm128.7 32h-.7v-14.2c0 4.8.3 9.5.7 14.2m31.3-16a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), F71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M322.7 6c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V32c0-10.3-4.9-19.9-13.3-26m-224 288c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.8-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V320c0-10.3-4.9-19.9-13.3-26zM64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm0 64h64v96H64zm128 288v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64m128 0v96h-64v-96zm208-112c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), T71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376v-24c0-35.3-28.7-64-64-64h-48.3L298 208.3c13.5-11.7 22-29 22-48.3V64c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64v11L38.8 5.1zM192 125.2V64h64v96h-19.6zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16zm80 32v96c0 35.3 28.7 64 64 64h64c20.1 0 38.1-9.3 49.8-23.8l-51-40.2H384v-49.5l-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8" })
  }
), A71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 32v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.6-1.7 28.9 4.3S336 21.7 336 32M112 320v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-83.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128 0H64v96h64zm128 224h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64m0 64v96h64v-96z" })
  }
), D71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32h32c17.7 0 32 14.3 32 32v32H96V64c0-17.7 14.3-32 32-32m64 96v320c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-59.1c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216l7.5-60c2-16 15.6-28 31.8-28zm227.8 0c16.1 0 29.8 12 31.8 28l7.4 60c3.3 26.4 12.1 51.8 25.8 74.6 17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h-96zm-32 64v160h-64V128z" })
  }
), y71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.2 0c-1.8 0-3.5.7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73-22 2.4-43.8 9.1-64.2 20.5-34.5 19.3-59.1 48.9-72 82.5-.7 1.7-.5 3.7.5 5.2 2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6 1 1.6 2.6 2.7 4.5 3 36.5 5.9 75.2.1 109.7-19.2 20.4-11.4 37.4-26.5 50.5-43.8 13.1 17.3 30.1 32.4 50.5 43.8 34.5 19.3 73.3 25.2 109.7 19.2 1.9-.3 3.5-1.4 4.5-3 2.2-3.7.1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3 1-1.6 1.1-3.5.5-5.2-12.9-33.6-37.5-63.2-72.1-82.5a168.77 168.77 0 0 0-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118-1.3-1.3-3-2-4.8-2-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-58.3 145.6c6.3-11.8 9.8-25.1 8.6-39.8-19.5-18-34-41.4-41.2-67.8-12.5-8.1-26.2-11.8-40-12.4-9-.4-18.1.6-27.1 2.7 7.8 57.1 38.7 106.8 82.9 139.4 6.8-6.7 12.6-14.1 16.8-22.1M288 64c-28.8 0-56.3 5.9-81.2 16.5 2 8.3 5 16.2 9 23.5 6.8 12.4 16.7 23.1 30.1 30.3 13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3 4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64m138.9 246c-7.2 26.4-21.7 49.7-41.2 67.8-1.2 14.7 2.2 28.1 8.6 39.8 4.3 8 10 15.4 16.8 22.1 44.3-32.6 75.2-82.3 82.9-139.4-9-2.2-18.1-3.1-27.1-2.7-13.8.6-27.5 4.4-40 12.4z" })
  }
), b71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192v-3.6C0 172.7 12.7 160 28.4 160H224c17.7 0 32-14.3 32-32V96c0-53 43-96 96-96 47.5 0 86.9 34.5 94.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5V192c0 93.9-57.7 174.3-139.7 207.6l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3C249 415 236.6 416 224 416h-3l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9C68.5 380.5 0 294.3 0 192m376-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), f71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32v32h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9 31.7 19.8 52.7 55 52.7 95.1 0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-6.3C18.7 448 0 429.3 0 406.3V101.6C0 80.8 16.8 64 37.6 64H48zm16 192h112c26.5 0 48-21.5 48-48s-21.5-48-48-48H64zm112 64H64v96h144c26.5 0 48-21.5 48-48s-21.5-48-48-48z" })
  }
), U71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128v224c0 70.7 57.3 128 128 128h209.6c-16.5-18.6-29.6-40.3-38.1-64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h173.8c6.3-15.5 14.4-30.8 23.3-45.3 21.7-35.2 51.9-71.2 87.3-102.8 10-8.9 23-12.8 35.5-11.7v-.2c0-53-43-96-96-96H96C43 32 0 75 0 128m288 222.1c0-9.8 1.3-19.9 3.6-30.1H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h163c-2-11.1-3-22.4-3-33.9m165.5-186.3c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), G71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128v224c0 70.7 57.3 128 128 128h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h240c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h240c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128" })
  }
), q71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 352 196.8 52.3C194.2 24.2 216.3 0 244.6 0h289.5c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h123.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352zm-16 32h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48m144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64M147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4.2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8c7.9-8.5 20.1-10.3 29.8-4.3z" })
  }
), W71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h406.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h123.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64zm145.5 128L133.8 64H64v128zM144 384h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48m144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), E71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v194.7c13.6 4.8 24.4 15.6 29.3 29.3.1.3.2.7.4 1 1.5 4.7 2.4 9.7 2.4 15 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16 4.8-13.6 15.6-24.4 29.3-29.3V64H32C14.3 64 0 49.7 0 32m47.4 96H96v64H17.8C8 192 0 184 0 174.2c0-4 1.4-7.9 3.9-11.1L22.4 140c6.1-7.6 15.3-12 25-12m0 160h18.2c-1 5.2-1.6 10.5-1.6 16 0 18 6 34.6 16 48H17.8C8 352 0 344 0 334.2c0-4 1.4-7.9 3.9-11.1L22.4 300c6.1-7.6 15.3-12 25-12m446.9 64H208c10-13.4 16-30 16-48 0-5.5-.6-10.8-1.6-16h242.2c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8zm0-160H192v-64h272.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8zM17.8 512C8 512 0 504 0 494.2c0-4 1.4-7.9 3.9-11.1L22.4 460c6.1-7.6 15.3-12 25-12h417.2c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8H17.8" })
  }
), O71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32c0 11.9 6.5 22.2 16.1 27.8L1.2 100.6c-.8 2.2-1.2 4.6-1.2 7C0 118.9 9.1 128 20.4 128H128V64h32v64h331.6c11.3 0 20.4-9.1 20.4-20.4 0-2.4-.4-4.7-1.2-7l-14.9-40.8C505.5 54.2 512 43.9 512 32c0-17.7-14.3-32-32-32zm112 512c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V224h331.9c11.1 0 20.1-9 20.1-20.1 0-2.6-.5-5.1-1.4-7.5L496 160H160v64h-32v-64H16L1.4 196.4c-1 2.4-1.4 4.9-1.4 7.5C0 215 9 224 20.1 224H128v194.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48" })
  }
), I71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32c0 11.4 6 21.4 15 27.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128H128V64h32v64h331.4c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L497 59.1c9-5.7 15-15.7 15-27.1 0-17.7-14.3-32-32-32zm-8 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256h78.1c4.8-13.6 15.6-24.4 29.3-29.3V160zm120 160c-20.9 0-38.7-13.4-45.3-32H24L1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 288H189.3c-6.6 18.6-24.4 32-45.3 32m16-93.3c13.6 4.8 24.4 15.6 29.3 29.3h302.1c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 160H160zM20.6 512h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 416H24L1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z" })
  }
), N71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v80h256V32zm-32 80V32c-35.3 0-64 28.7-64 64v16zm-64 32v96h208v-96zm0 224h64v-96H32zm0 32v16c0 35.3 28.7 64 64 64h144v-80zm240 0v80h65.6c-20.2-22.6-35.1-50-43.1-80zm208-256h-.6l.6.6zm-208 0v96h54.9c20.6-32.8 48.5-66.2 81-96zM128 272v96h160.8c-.5-5.9-.8-11.9-.8-17.9 0-25.4 8.5-52.4 21-78.1zm352-160V96c0-35.3-28.7-64-64-64v80zm-26.5 51.8c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), X71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v80h256V32zm-32 80V32C28.7 32 0 60.7 0 96v16zM0 144v96h208v-96zm0 224h64v-96H0zm0 32v16c0 35.3 28.7 64 64 64h144v-80zm240 0v80h144c35.3 0 64-28.7 64-64v-16zm208-32v-96h-64v96zm-96 0v-96H96v96zm96-224H240v96h208zm0-32V96c0-35.3-28.7-64-64-64v80z" })
  }
), K71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm73.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L344 280.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0M144 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0m328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48M144 408a24 24 0 1 1 48 0 24 24 0 1 1-48 0m328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Q71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32zm128 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32 192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32M32 224c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32" })
  }
), Z71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm96 8a24 24 0 1 0-48 0 24 24 0 1 0 48 0m280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48M192 408a24 24 0 1 0-48 0 24 24 0 1 0 48 0m280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), J71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c0 17.7 14.3 32 32 32 123.7 0 224 100.3 224 224 0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32m0 96c0 17.7 14.3 32 32 32 70.7 0 128 57.3 128 128 0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192-17.7 0-32 14.3-32 32m-96 16c0-26.5-21.5-48-48-48S0 117.5 0 144v224c0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144h-16v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48z" })
  }
), j71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 176C512 78.8 433.2 0 336 0c-80.6 0-148.6 54.2-169.4 128.2 3.1-.1 6.3-.2 9.4-.2 114.9 0 208 93.1 208 208 0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176M176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352m0-304c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16M384 64v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), Y71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112c6.9 6 10.9 14.8 10.9 24s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480V326.5l-74.9 65.6c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3l74.9 65.6V32c0-12.6 7.3-24 18.8-29.1zM224 326.5v83l47.4-41.5zm0-141 47.4-41.5-47.4-41.5z" })
  }
), _71 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h192c70.7 0 128 57.3 128 128 0 31.3-11.3 60.1-30 82.3 37.1 22.4 62 63.1 62 109.7 0 70.7-57.3 128-128 128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H32C14.3 96 0 81.7 0 64m224 160c35.3 0 64-28.7 64-64s-28.7-64-64-64H112v128zm-112 64v128h144c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32z" })
  }
), h91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.5 22.9-8.9 35.4S18.7 288 32 288h111.5L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H240.5l76.9-179.5zM464 288c-12.1 0-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160c-5.4-10.9-16.5-17.7-28.6-17.7m-16.2 136 16.2-32.4 16.2 32.4z" })
  }
), c91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256 28.5 28c2-16 15.6-28 31.8-28h168.6c15 0 27.1 12.1 27.1 27.1 0 3.2-.6 6.5-1.7 9.5L208 160h139.3c20.2 0 36.7 16.4 36.7 36.7 0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5 0-2.3.3-4.6.9-6.9L176 288H32c-17.7 0-32-14.3-32-32" })
  }
), s91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-182.4-143 52.7-46.1c10-8.8 13.6-22.9 8.9-35.3S493.4 224 480 224H368.5l76.9-179.4c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7 38.8 5.1zm100.1 226.8c-10 8.8-13.6 22.9-8.9 35.3s16.6 20.7 30 20.7h83.7l-88.9-70-15.9 13.9zm55.7 235.5c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8L374.4 391l-109.9-86.6z" })
  }
), v91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288h111.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5l76.9-179.5z" })
  }
), e91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M459.1 52.4 442.6 6.5c-1.9-3.9-6.1-6.5-10.5-6.5s-8.5 2.6-10.4 6.5l-16.5 45.9-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4 0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2 0-4.6-3-8.9-7.2-10.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9c-22-8-45.8-12.3-70.5-12.3C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16z" })
  }
), l91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zm272 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM143.9 223.8C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80 0 35.8 23.5 66.1 55.9 76.3 4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8c32.5-10.3 56-40.6 56-76.4 0-44.2-35.8-80-80-80-26.1 0-49.3 12.5-63.9 31.8-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384l-25.7-128.6c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5z" })
  }
), t91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2h192c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80 0 30.4-17 56.9-42 70.4-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4 0 44.2-35.8 80-80 80-33.1 0-61.6-20.1-73.7-48.8-6.9-16.3-20.6-31.2-38.3-31.2H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80 0-30.4 17-56.9 42-70.4 3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6c-25-13.5-42-40-42-70.4 0-44.2 35.8-80 80-80 33.1 0 61.6 20.1 73.7 48.8" })
  }
), w91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 208.5c0 29.1-15.6 53.9-37.2 67.8-17.2 11.1-31.5 26.1-41.7 43.7h221.8c-10.2-17.6-24.5-32.6-41.7-43.7-21.6-13.9-37.2-38.7-37.2-67.8V64h-64zM288 64v144.5c0 5.7 3.1 10.9 7.9 14 11.2 7.2 21.5 15.5 30.9 24.8l39.3-39.3-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5 4.8-3.1 7.9-8.3 7.9-14V64c-17.7 0-32-14.3-32-32S78.3 0 96 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32" })
  }
), g91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V232h110.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H448V32c0-17.7-14.3-32-32-32h-32zm352 184v48H248c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), i91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64h-88V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384H96c-17.7 0-32 14.3-32 32" })
  }
), m91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m183.4-132.2c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9m0-163.8c23.2 14.2 39.9 38 44.5 65.9h-31.1c-1.4-24.7-6.1-47.5-13.4-65.9M368 192a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-222.7 16h31.1c1.4 24.7 6.1 47.5 13.4 65.9-23.2-14.2-39.9-38-44.5-65.9zm31.1-32h-31.1c4.7-27.9 21.4-51.7 44.5-65.9-7.3 18.3-12 41.1-13.4 65.9m56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7.5 7.4 4.2c3.8 3.7 8 10 11.8 18.9 6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9 3.8-8.9 8-15.2 11.8-18.9z" })
  }
), a91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-32zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32M208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), o91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-32zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), n91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h96v190.7c0 13.4 15.5 20.9 26 12.5l54-43.2 54 43.2c10.5 8.4 26 .9 26-12.5V0h64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32" })
  }
), r91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h298.8a177.02 177.02 0 0 1-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h224.7c-.5-5.3-.7-10.6-.7-16 0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32h-32zm544 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6" })
  }
), d91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h298.8a177.02 177.02 0 0 1-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h224.7c-.5-5.3-.7-10.6-.7-16 0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32h-32zm400 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288m-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0" })
  }
), S91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96H96c-53 0-96 43-96 96v224c0 53 43 96 96 96h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h81.1c-10.9-18.8-17.1-40.7-17.1-64zm160 320h224c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H288c-53 0-96 43-96 96v224c0 24.6 9.2 47 24.4 64 17.6 19.6 43.1 32 71.6 32zm-64-96c0-17.7 14.3-32 32-32h192v64H288c-17.7 0-32-14.3-32-32" })
  }
), z91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32M254.3 72.8C251.6 67.4 246 64 240 64s-11.6 3.4-14.3 8.8l-64 128-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l27.5-55.1h108.2l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-32-64-64-128zm-14.3 43 38.1 76.2h-76.2z" })
  }
), p91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m64-258.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4C221.1 102.5 205.5 96 189.3 96c-33.8 0-61.3 27.4-61.3 61.3" })
  }
), M91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m90.4-234.4-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6 0 .2 0 .5.1.8s.1.5.1.8l36.9 32.4c2.5 2.1 3.4 5.8 2.3 8.9-1.3 3-4.1 5.1-7.5 5.1-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2-2.2-.1-4.4-1.1-6-2.8-1.2-1.5-1.9-3.4-2-5.2.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5.1-.8s.1-.5.1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6-2.7-1.9-6.2 1.4-5 4.5 8.5 22.4 3.6 48-13 65.6-3.2 3.4-3.6 8.9-.9 12.7 9.8 14 12.7 31.9 7.5 48.5-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6.4 1.5.6 2.3.6 1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4l-8.6-14.3 18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2.9-2.9.1-4.1s-2-2-3.5-2h-.1c-.7.1-1.5.3-2.1.7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8.4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2.6-.5 1.4-.5 2 0 1.1.5 2.1 1.2 3 .8.6 1.8 1 2.8 1 .7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3-5.1-16.6-2.2-34.4 7.6-48.5 2.7-3.9 2.3-9.3-.9-12.7-16.6-17.5-21.6-43.1-13.1-65.5 1.2-3.1-2.3-6.4-5-4.5-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z" })
  }
), x91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m144-304v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), H91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 32v376L96 368V34.7c0-19.8 17.8-34.9 37.3-31.6zM89.7 405.1 320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4V28.8l25.7-5.1c19.8-4 38.3 11.1 38.3 31.3v366.8c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8V55c0-20.2 18.5-35.3 38.3-31.3L64 28.8v345c0 15.3 10.8 28.4 25.7 31.4zM336 408V32L506.7 3.1C526.2-.2 544 14.9 544 34.7V368z" })
  }
), V91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a96 96 0 1 1 192 0 96 96 0 1 1-192 0m80 152v264l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32h30.3c63.6 0 125.6 19.6 177.7 56m32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32v203c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3z" })
  }
), C91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32 93.5 32 46.3 45.3 18.1 56.1 6.8 60.5 0 71.7 0 83.8v370.3c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5m76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6 11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5" })
  }
), L91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0c53 0 96 43 96 96v320c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0h32zm0 384H96v64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32m-77.9-233.8-8.9 21.4-23.1 1.9c-5.7.5-8 7.5-3.7 11.2l17.6 15.1-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9l19.8-12.1 19.8 12.1c4.9 3 10.9-1.4 9.6-6.9l-5.4-22.6 17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128 25.6 0 49.5-7.5 69.5-20.5 3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8.7 19 1.9 3.8.8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7c-20-13-43.9-20.5-69.5-20.5-70.7 0-128 57.3-128 128" })
  }
), B91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m164.5-174.7 7.5 2c37.9 9.8 46.1 15 43.6 27.7-2.5 13.2-23.7 19.6-51.7 15.7-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9c-8.4-2.7-17.4 1.9-20.1 10.4-2.7 8.4 2 17.4 10.4 20.1l5.8 1.9c12 3.9 25.7 8.3 38.6 10.1 7 1 13.8 1.5 20.2 1.5 36.5 0 62.2-15.8 67.3-42.8 4.1-21.2-4-34.9-16.7-44.4 8.7-7.1 14.5-16.4 16.7-27.6 8.6-45.1-36.9-56.9-67-64.7l-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8 2.5-13.2 23.8-19.7 51.6-15.7 6.6.9 14.6 2.9 25.2 6.2 8.3 2.6 17.4-2.1 20-10.5 2.6-8.4-2.1-17.4-10.5-20-12.2-3.8-21.9-6.2-30.2-7.3-47.1-6.7-81.5 9.6-87.5 41.3-4.1 21.3 4.4 35.1 16.7 44.5-8.7 7.1-14.5 16.4-16.7 27.5-8.5 44.6 37.4 56.8 59.5 62.7zm-2.9-72.8c.9.2 10.3 2.7 10.3 2.7 37.9 9.8 46.1 15 43.6 27.7-2.2 11.3-16.5 14.9-25.2 16.1-3.6-1-17.7-4.7-17.7-4.7-36.5-9.7-38-16.5-36.2-25.8 2.2-11.3 16.5-14.9 25.2-16.1z" })
  }
), u91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m256-304c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-12.8c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-121.7 97.3c-8.1-3.5-17.5.3-21 8.4s.3 17.5 8.4 21l77.7 33.3-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6z" })
  }
), R91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-32zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32m168-184 16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 200l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 248l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 248l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7zM168.8 78.3c2.9-5.9 11.4-5.9 14.3 0L192 96l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 128l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 128l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 96z" })
  }
), $91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0c53 0 96 43 96 96v320c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0h32zm0 384H96v64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32M138.7 208l13.9 24h-27.7l13.9-24zm-13.9-24-27.7 48c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24h-55.4l-27.7-48c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24zm27.7 0 27.7-48h55.4l27.7 48-27.7 48h-55.3l-27.7-48zm0-48-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72 13.9 24h-27.8l13.9-24m-55.4 48L208 280l-13.9-24h27.7z" })
  }
), k91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32m240-288a64 64 0 1 0-128 0 64 64 0 1 0 128 0M128 304c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80" })
  }
), P91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-32zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32m32-240c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16m16 48h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), F91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v27L38.8 5.1zM128 487.7c0 13.4 10.9 24.3 24.3 24.3 5 0 9.9-1.5 14-4.4L320 400l153.7 107.6c4.1 2.9 9 4.4 14 4.4 9.9 0 18.4-5.9 22.2-14.3L128 196.9z" })
  }
), T91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48v439.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400l153.7 107.6c4.1 2.9 9 4.4 14 4.4 13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48" })
  }
), A91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 78.3 0 96 0h64c17.7 0 32 14.3 32 32v64H64zm0 384h128v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM224 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64H224zm0 96h128v256H224zm0 288h128v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm203.6-19.9L384 232.6v-89.8l100.4-26.9 66 247.4zM476.2 85 384 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6zm-40.4 342 122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1L491 510.8c-16.9 4.6-34.4-5.5-38.9-22.6zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-48H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), D91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h64c17.7 0 32 14.3 32 32v64H0zm0 96h128v256H0zm0 288h128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64H160zm0 96h128v256H160zm0 288h128v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm203.6-19.9L320 232.6v-89.8l100.4-26.9 66 247.4zM412.2 85 320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6zm-40.4 342 122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1L427 510.8c-16.9 4.6-34.4-5.5-38.9-22.6z" })
  }
), y91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 48h400c22.1 0 40 17.9 40 40v72H448c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32H80V88c0-22.1 17.9-40 40-40m488 120.6V88c0-48.6-39.4-88-88-88H120C71.4 0 32 39.4 32 88v80.6c-19.1 11-32 31.7-32 55.4v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V224c0-23.7-12.9-44.4-32-55.4M256 336a80 80 0 1 0-160 0 80 80 0 1 0 160 0m-192 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0m400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224" })
  }
), b91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0H63.3C46 0 32 14 32 31.3c0 1.8.1 3.9.6 6.2C34.6 47.1 56 154.3 56 232c0 33.2-12.8 93.5-19.7 123.2-2.7 11.8-4.3 24.1-4.3 36.6V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-15.1l125 34.7c10.5 2.9 21.3 4.4 32.1 4.4H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-34.3c0-27.3-15.4-52.2-39.8-64.4l-112.4-56.2a71.96 71.96 0 0 1-39.8-64.4V24c0-13.3-10.7-24-24-24H160v240c0 8.8-7.2 16-16 16s-16-7.2-16-16z" })
  }
), f91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H0zm0 425.4V448h512v9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16h-14.9c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4M0 416V128h320v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 296.5 512 334.9 512 379v37z" })
  }
), U91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v416c0 17.7 14.3 32 32 32s32-14.3 32-32V64h64V0zm448 64c0-35.3-28.7-64-64-64H192c-17.7 0-32 14.3-32 32v368c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48v80c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), G91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 96v128H256V96zm0 192v128H256V288zm-192-64H64V96h128zM64 288h128v128H64zm0-256C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z" })
  }
), q91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v336c0 8.8-7.2 16-16 16H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h336c44.2 0 80-35.8 80-80zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0M96 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0m96 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0M0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0m32 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64m0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64" })
  }
), W91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32m-64-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0M0 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m128 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0M448 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0M0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m32 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m64-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0M96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m64 192a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), E91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64m0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64m0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64m0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64m192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64M32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64m384-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64M32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64m192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64M32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), O91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-384 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m320-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m320 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0M384 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0M0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0m64 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0m224-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0m64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-64 384a32 32 0 1 0 64 0 32 32 0 1 0-64 0M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0M96 448a32 32 0 1 0 64 0 32 32 0 1 0-64 0m64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m32 192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z" })
  }
), I91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 448a32 32 0 1 1-64 0 32 32 0 1 1 64 0m96 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m0-384a32 32 0 1 1-64 0 32 32 0 1 1 64 0m160 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64m32-352a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 352a32 32 0 1 1-64 0 32 32 0 1 1 64 0m352-224a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0M0 256c0-17.7 14.3-32 32-32h160V64c0-17.7 14.3-32 32-32s32 14.3 32 32v160h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H32c-17.7 0-32-14.3-32-32" })
  }
), N91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32m96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), X91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64m96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-96 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64m384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64M32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64m192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64M32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64m384-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64M32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), K91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96v320h320V96zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64m128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0M224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), Q91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32m-96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64M32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64m0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64M32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64m192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Z91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32V112c0-8.8 7.2-16 16-16h336c17.7 0 32-14.3 32-32s-14.3-32-32-32H80C35.8 32 0 67.8 0 112zm160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m192 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m192 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64m0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), J91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64m64 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0M0 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0M64 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0m320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0M0 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0m448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-32-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0M96 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-64-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), j91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-17.7 0-32 14.3-32 32v264.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32M48 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80c-17.7 0-32 14.3-32 32v192c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32z" })
  }
), Y91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256v192c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8 13.3 0 24-10.7 24-24S237.3 0 224 0H104zm64 382c-26.5 0-48-20.1-48-45 0-16.8 22.1-48.1 36.3-66.4 6-7.8 17.5-7.8 23.5 0 14.1 18.3 36.2 49.6 36.2 66.4 0 24.9-21.5 45-48 45" })
  }
), _91 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0h80c13.3 0 24 10.7 24 24v40H96V24c0-13.3 10.7-24 24-24M32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5 0 14.4-7.5 27-18.9 34.1 11.5 8.8 18.9 22.6 18.9 38.2 0 16.7-8.5 31.4-21.5 40 12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40 0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48 0-16.7 8.5-31.4 21.5-40-13-8.6-21.5-23.3-21.5-40s8.5-31.4 21.5-40c-13-8.6-21.5-23.3-21.5-40s8.5-31.4 21.5-40c-13-8.6-21.5-23.3-21.5-40 0-15.6 7.4-29.4 18.9-38.2-11.4-7.1-18.9-19.7-18.9-34.1M96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16m16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), hh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1.3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35-247.2 247.1-50.8-12.7c-8.2-2-16.8.4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8 247.2-247 35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-458 85.5c-12.6-11.6-32.1-11.3-44.3.9-12.5 12.5-12.5 32.8 0 45.3L145.8 287l45.2-45.2-90.6-90.6c56.5-30.7 125.2-30.9 181.9-.7l46.8-46.8c-83.8-53.2-191.8-53-275.4.8zm307.8 125.3c30.2 56.7 30 125.4-.7 181.9L270.2 321 225 366.2l136.4 136.4c12.5 12.5 32.8 12.5 45.3 0 12.2-12.2 12.5-31.8.9-44.3 53.7-83.6 54-191.6.8-275.4l-46.8 46.8z" })
  }
), ch1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M13.1 93.6 128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v168h32V40c0-13.3 10.7-24 24-24s24 10.7 24 24v184h222.4c18.2 0 32.7 15.3 31.6 33.5-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5.9 239.3 15.4 224 33.6 224H128v-48H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140v-32L18.5 125.1c-9.7 1.5-18.5-6-18.5-15.8 0-7.7 5.5-14.3 13.1-15.7M488.4 176H288v-41l199.6-6.2c13.4-.5 24.4 10.2 24.4 23.6 0 13-10.6 23.6-23.6 23.6m3.9-124.9L288 83V42L484.4 5.2c14.3-2.7 27.6 8.3 27.6 22.9 0 11.5-8.4 21.2-19.7 23z" })
  }
), sh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m18.5 125.1 473.8-74c11.3-1.8 19.7-11.5 19.7-23 0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8M0 159.7c0 9 7.3 16.2 16.2 16.2h472.2c13 0 23.6-10.6 23.6-23.6 0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35h153.4c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7 1.1-18.2-13.4-33.5-31.6-33.5H33.6z" })
  }
), vh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192c0-35.3 28.7-64 64-64h1.6C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64h1.6c35.3 0 64 28.7 64 64 0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192m0 91.4C0 268.3 12.3 256 27.4 256h457.2c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1l-1.8 14.5c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4" })
  }
), eh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0c-13.3 0-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32v-8c0-13.3-10.7-24-24-24M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35h153.4c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7 1.1-18.2-13.4-33.5-31.6-33.5H33.6zM304 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32z" })
  }
), lh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24m24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24M56 176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24M0 283.4C0 268.3 12.3 256 27.4 256h457.2c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1l-1.8 14.5c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4M224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24m-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24m-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24m216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24m-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24m120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24m-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24m-96-72h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), th1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224h384c0-106-86-192-192-192S32 118 32 224m-16 32c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c9 72 70.3 126.1 142.9 126.1h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z" })
  }
), wh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 208c0 5.4.4 10.8 1.1 16h221.8c.7-5.2 1.1-10.6 1.1-16 0-61.9-50.1-112-112-112h-1.1c-38.7.4-72.7 20.4-92.6 50.6-11.6 17.6-18.3 38.7-18.3 61.4M0 208c0 5.4.4 10.8 1.1 16h191.8c-.6-5.3-.9-10.6-.9-16 0-22 4.9-42.8 13.7-61.4-13.9-21.2-34.9-37.4-59.6-45.3-10.7-3.4-22.2-5.3-34.1-5.3C50.1 96 0 146.1 0 208M325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1 24.3-30.1 60.5-50.1 101.4-53.1M16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c9 72 70.3 126.1 142.9 126.1h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z" })
  }
), gh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257.2 9.9c2.5-6 8.3-9.9 14.8-9.9h36.6C367.9 0 416 48.1 416 107.4c0 19.9-6.9 38.1-18.3 52.6H416c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h8.6c-5.4-9.4-8.6-20.3-8.6-32 0-35.3 28.7-64 64-64h94.1c9.9 0 17.9-8 17.9-17.9 0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4zM64 320h384c8.8 0 16 7.2 16 16v8c0 57.4-46.6 104-104 104h-30.1l20.4 40.8c1.1 2.3 1.7 4.7 1.7 7.2 0 2.9-.8 5.8-2.4 8.4-2.9 4.7-8.1 7.6-13.6 7.6H176c-5.5 0-10.7-2.9-13.6-7.6-1.6-2.6-2.4-5.5-2.4-8.4 0-2.4.6-4.9 1.7-7.2l20.4-40.8H152c-57.4 0-104-46.6-104-104v-8c0-8.8 7.2-16 16-16" })
  }
), ih1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 192C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H217.6c-15.4 37.3-56.9 64-105.6 64zM2 257.5C.9 239.3 15.4 224 33.6 224h444.8c18.2 0 32.7 15.3 31.6 33.5-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5" })
  }
), mh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64v1.1c0 7.4-1 14.8-3 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1h-83c-.5-2.7-1.1-5.4-1.8-8.1l-17.8-64.8c-2-7.2-2.9-14.6-2.9-22zm22.8 128h82.3c1 6.3 2.6 12.4 4.8 18.4L566 319.3c6.6 17.9 10 36.8 10 55.8 0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C536.9 504 525.1 512 512 512h-64c-13.1 0-24.9-8-29.7-20.1l-17.8-44.5c29.8-40 47.5-89.6 47.5-143.4 0-30.7-5.8-60.1-16.3-87.1l2.4-6.5c2.2-6 3.8-12.1 4.8-18.4zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0m224-132a28 28 0 1 0-56 0 28 28 0 1 0 56 0m-28 116a28 28 0 1 0 0-56 28 28 0 1 0 0 56m-44-68a28 28 0 1 0-56 0 28 28 0 1 0 56 0" })
  }
), ah1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), oh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H86.5c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64M82.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4 0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4c-5.5 10.9-16.6 17.7-28.7 17.7H96c-12.1 0-23.2-6.8-28.6-17.7l-15.7-31.4C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4zM384 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1h-83.1c-.5-2.7-1.1-5.4-1.8-8.1l-17.8-64.8c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64m-45.9 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l40 108.9c6.6 17.9 10 36.8 10 55.8 0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512h-64c-13.1 0-24.9-8-29.7-20.1L299.5 435c-7.6-19-11.5-39.4-11.5-59.9 0-19 3.4-37.9 10-55.8z" })
  }
), nh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32h448c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32m0 128h448v256c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm128 80c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16" })
  }
), rh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v192H128zM0 352h576v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm48-192h48v96h384v-96h48c26.5 0 48 21.5 48 48v112H0V208c0-26.5 21.5-48 48-48" })
  }
), dh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32M240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm337 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), Sh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32M240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240zM0 416V192h416v.7c-89.7 8.1-160 83.5-160 175.3 0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64m288-48a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), zh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32M240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm244 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V440c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V232z" })
  }
), ph1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32M240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm212.7 228.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3z" })
  }
), Mh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m508.9 64.9-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1.6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1s37.4 37 28.1 61.8zM576 338.3v83.4c0 14.7-10 27.5-24.2 31l-216.3 54.1c-10.2 2.6-20.9 2.6-31 0l-216.3-54C74 449.2 64 436.4 64 421.7v-83.4l127.6 36.5c27.8 8 57.6-3.8 72.5-28.6l55.9-93.3 55.9 93.2c14.9 24.8 44.6 36.6 72.5 28.6zM58.9 168.8c3-6.1 9.6-9.6 16.3-8.7L320 190.7l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 344c-13.9 4-28.8-1.9-36.2-14.3l-83.4-139-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 297.3c-19.3-5.5-28.8-27.2-19.8-45.1L59 168.8z" })
  }
), xh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1l-163.4 46.7c-13.9 4-28.8-1.9-36.2-14.3L320 64l-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1l41.6-83.4zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6l54.8-91.4h2.2z" })
  }
), Hh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50.7 58.5 0 160h160l32-128H93.7c-18.2 0-34.8 10.3-43 26.5M288 160h160L397.3 58.5c-8.2-16.2-24.8-26.5-43-26.5H256zm-128 32H0v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192H288v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32z" })
  }
), Vh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2c14.8 0 26.8 12 26.8 26.8 0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0M79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-13.5l25.6-64H464c26.5 0 48 21.5 48 48v112H0V272c0-26.5 21.5-48 48-48zM0 416h512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z" })
  }
), Ch1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M50.7 58.5 0 160h208V32H93.7c-18.2 0-34.8 10.3-43 26.5M240 160h208L397.3 58.5c-8.2-16.2-24.8-26.5-43-26.5H240zm208 32H0v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64z" })
  }
), Lh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3v-32c0-26.5-21.5-48-48-48H256zm315.3 299.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm352 80v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256zm-208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Bh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0h-40c-26.5 0-48 21.5-48 48v112c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16zM64 256c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-80zm288 256h160c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-80h-40c-15 0-28.8 5.1-39.7 13.8 4.9 10.4 7.7 22 7.7 34.2v160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512" })
  }
), uh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0h192c53 0 96 43 96 96v32h-32c-26.2 0-49.4 12.6-64 32H144c-21.2 0-34.3-5.3-41.8-9.7-3.8-2.3-6.3-4.4-7.7-5.8-.7-.7-1.1-1.2-1.3-1.5l-.1-.1c-5-7.1-14.7-9-22-4.2-7.4 4.9-9.3 14.8-4.4 22.2L80 152l-13.3 8.9.1.1.1.2.4.5c.3.4.6.8 1.1 1.4.9 1.1 2 2.4 3.6 4 3.1 3.1 7.6 6.9 13.8 10.7 12.5 7.5 31.4 14.2 58.2 14.2h129.6c-1 5.2-1.6 10.5-1.6 16 0 37.3 25.5 68.6 60 77.5 8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-20.7-5.3-36-24.1-36-46.5 0-26.5 21.5-48 48-48h32c35.3 0 64 28.7 64 64v24.2c0 25.5-10.1 49.9-28.1 67.9l-49.1 49.1c-12 12-18.7 28.3-18.7 45.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64v-88.4C12.4 342 0 316.4 0 288zm152.9 258.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l39.1-26.1 39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 380.8z" })
  }
), Rh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 128c0-53-43-96-96-96H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9l22.6 22.6-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96v-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3L201.4 188c-6-6-9.4-14.1-9.4-22.6V128z" })
  }
), $h1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-53 0-96-43-96-96v-37.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3L54.7 188c6-6 9.4-14.1 9.4-22.6V128z" })
  }
), kh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M37.4 46.2c-9.8 14.8-5.9 34.6 8.9 44.4C71.9 107.7 128 167 128 256S71.9 404.3 46.2 421.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4c-14.8-9.8-34.6-5.9-44.4 8.8" })
  }
), Ph1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z" })
  }
), Fh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96c0-35.3-28.7-64-64-64H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v320H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64z" })
  }
), Th1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64v320h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64z" })
  }
), Ah1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9l22.6 22.6-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96v-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3L521.4 188c-6-6-9.4-14.1-9.4-22.6V128c0-53-43-96-96-96m-256 0c-53 0-96 43-96 96v37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3L54.7 324c6 6 9.4 14.1 9.4 22.6V384c0 53 43 96 96 96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32v-37.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9V128c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Dh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M145.8 90.6c14.7-9.8 18.7-29.7 8.9-44.4s-29.7-18.7-44.4-8.9C71.9 62.9 0 140.2 0 256s71.9 193 110.2 218.6c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4m220.5 0C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449.1 512 371.8 512 256S440.1 62.9 401.8 37.4c-14.7-9.8-34.6-5.8-44.4 8.9s-5.8 34.6 8.9 44.4z" })
  }
), yh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32zM64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64v320h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64" })
  }
), bh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96m224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128M80 416a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m240 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0M64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128M224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128m128 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m240 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128m16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-96-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32m0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128m16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), fh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 56c0-30.9-25.1-56-56-56-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8-2.3 6.6-3.6 13.8-3.6 21.2 0 35.3 28.7 64 64 64 5.6 0 11.1-.7 16.3-2.1 2.9 28.2 26.8 50.1 55.7 50.1 30.9 0 56-25.1 56-56zm32 0v400c0 30.9 25.1 56 56 56 3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144h32v-16c0-4.9.8-9.8 2.2-14.3-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6 1.6-5.5 2.4-11.4 2.4-17.4 0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56m267.3 188.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v48h-64c-61.9 0-112 50.1-112 112 0 54.3 34.6 85.6 45 93.8 1.9 1.5 4.3 2.2 6.7 2.2 6.8 0 12.3-5.5 12.3-12.3V464c0-35.3 28.7-64 64-64h48v48c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6z" })
  }
), Uh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 56c0-30.9-25.1-56-56-56-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8-2.3 6.6-3.6 13.8-3.6 21.2 0 35.3 28.7 64 64 64 5.6 0 11.1-.7 16.3-2.1 2.9 28.2 26.8 50.1 55.7 50.1 30.9 0 56-25.1 56-56V272h-48c-8.8 0-16 7.2-16 16v34.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V288c0-26.5 21.5-48 48-48h48v-80h-34.7c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H240zm32 104v192h34.7c6.6-18.6 24.4-32 45.3-32 26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H272v72c0 30.9 25.1 56 56 56 28.9 0 52.7-21.9 55.7-50.1 5.2 1.4 10.7 2.1 16.3 2.1 35.3 0 64-28.7 64-64 0-7.4-1.3-14.6-3.6-21.2 30.2-11.4 51.6-40.6 51.6-74.8 0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6 1.6-5.5 2.4-11.4 2.4-17.4 0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56v72h48c26.5 0 48 21.5 48 48v2.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8-7.2-16-16-16zm-128-16a16 16 0 1 0 32 0 16 16 0 1 0-32 0m208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32M144 368a16 16 0 1 0 32 0 16 16 0 1 0-32 0m192 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0" })
  }
), Gh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0c30.9 0 56 25.1 56 56v400c0 30.9-25.1 56-56 56-28.9 0-52.7-21.9-55.7-50.1-5.2 1.4-10.7 2.1-16.3 2.1-35.3 0-64-28.7-64-64 0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1 3-28 26.8-49.9 55.7-49.9m144 0c28.9 0 52.6 21.9 55.7 49.9C411.5 56.9 432 82 432 112c0 6-.8 11.9-2.4 17.4 28.8 6.2 50.4 31.9 50.4 62.6 0 15-5.1 28.8-13.8 39.7 27.1 12.8 45.8 40.4 45.8 72.3 0 34.2-21.4 63.4-51.6 74.8 2.3 6.6 3.6 13.8 3.6 21.2 0 35.3-28.7 64-64 64-5.6 0-11.1-.7-16.3-2.1-3 28.2-26.8 50.1-55.7 50.1-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56" })
  }
), qh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0m248-104c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64M91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147c7.2 11.1 4 26-7.2 33.2s-26 4-33.2-7.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83c7.2-11.1 22-14.4 33.2-7.2s14.4 22 7.2 33.2zm498.2-26c32.1 49.9 50.7 109.3 50.7 173s-18.6 123.1-50.7 173c-7.2 11.1-22 14.4-33.2 7.2s-14.4-22-7.2-33.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147c-7.2-11.1-4-26 7.2-33.2s26-4 33.2 7.2" })
  }
), Wh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0c17.7 0 32 14.3 32 32v18.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9 0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-19.4c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9l23.5 15.6c10.8 7.2 23.4 11 36.3 11 27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8c-44.8-17.9-74.1-61.2-74.1-109.4 0-51.9 33.5-95.9 80-111.7V32c0-17.7 14.3-32 32-32M0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V288zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64z" })
  }
), Eh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64M397.4 34.9c-2-.9-4.1-1.9-6.2-2.8 3.1-.1 6-.2 8.8-.2 64 0 240 32 240 160 0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48h-96c10-13.4 16-30 16-48V282.5c37.3-13.2 64-48.7 64-90.5 0-82.2-57.6-130.7-114.6-157.1" })
  }
), Oh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64m182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z" })
  }
), Ih1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32" })
  }
), Nh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32zm424 64v64h-80V96zm-128 0v64h-80V96zm-128 0v64h-80V96zm408 272a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Xh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32zm424 64v64h-80V96zm-128 0v64h-80V96zm-128 0v64h-80V96zm264 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), Kh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32zm424 64v64h-80V96zm-128 0v64h-80V96zm-128 0v64h-80V96zm264 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), Qh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32h-40v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1-17.6-20-43.4-32.7-72.2-32.7-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-53-43-96-96-96V160h72V96H64c-17.7 0-32-14.3-32-32m376 32v64h80V96zm-48 64V96h-80v64zM152 96v64h80V96zm376 144c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), Zh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 8c9.1 0 17 5 21.1 12.5C184.2 81.6 249.7 120 320 120s135.8-38.4 170.9-99.5C495 13 502.9 8 512 8c8.8 0 16.5 4.7 20.7 11.8 13.1 21.2 26.6 42.2 42 59.8 15.5 17.7 31.7 30.6 49.4 36.9 12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5V256h64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32-35.3 0-64 28.7-64 64v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32v-32c0-53-43-96-96-96h-64c-53 0-96 43-96 96v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-35.3-28.7-64-64-64-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h64V117.1c-17.4 18.7-38.4 35.3-63.9 44.5-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9 15.4-17.6 29-38.6 42-59.8C111.5 12.7 119.2 8 128 8m352 100.1c-12.4 10.7-25.8 20.1-40 28.2V256h40zm-88 49c-15.5 4.8-31.6 8.1-48 9.8V256h48v-99zm-96 9.8c-16.4-1.6-32.5-4.9-48-9.8v99h48v-89.3zm-96-30.5c-14.2-8-27.6-17.5-40-28.2V256h40V136.3z" })
  }
), Jh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4-37.3 0-67.6 30.2-67.6 67.6v124.9c-12.9 0-25.8 3.9-36.8 11.7-18 12.4-40.1 20.3-59.2 20.3V256c0-53-43-96-96-96s-96 43-96 96v128.5c-19 0-41.2-7.9-59.1-20.3-11.1-7.8-24-11.7-36.9-11.7V227.6c0-37.4-30.2-67.6-67.6-67.6C12.7 160 0 147.3 0 131.6zm306.5 293.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), jh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h40v64H0v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32zm424 64v64h-80V96zm-128 0v64h-80V96zm-128 0v64h-80V96z" })
  }
), Yh1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8m-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56m169 135 80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h150.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), _h1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8m-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64z" })
  }
), hc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8m-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56m96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), cc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8m-56 8v40H64c-35.3 0-64 28.7-64 64v96h512v-96c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56m384 232H320v32c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-32H0v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64z" })
  }
), sc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-64 176a96 96 0 1 1 192 0 96 96 0 1 1-192 0m96 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m176-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-320 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0M96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m256 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m0-256a32 32 0 1 1 64 0 32 32 0 1 1-64 0M160 384a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), vc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80V32c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32m-64 176a96 96 0 1 1 192 0 96 96 0 1 1-192 0M0 256c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m432-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32s14.3-32 32-32M256 512c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32M73.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0zm288-333.3 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm77.3 333.3c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3m-333.3-288-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z" })
  }
), ec1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 448h224V224h-64v-64h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-64h64zm64-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64" })
  }
), lc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64h192c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h64v-64H64zm416 384h-96c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-64v64h64v128h-64zM224 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64z" })
  }
), tc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0 53 43 96 96 96h320c53 0 96-43 96-96 0-45.5-31.6-83.6-74.1-93.5 6.4-10 10.1-21.8 10.1-34.5 0-35.3-28.7-64-64-64-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64 0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256m192.2 234.3c5 12.8 17.1 21.7 30.9 21.7H289c13.8 0 25.9-8.9 30.9-21.7C337.5 445 359.5 408.2 376 384h-96l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384h-95.9c16.5 24.2 38.5 60.9 56.1 106.3" })
  }
), wc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6h-29L256 211.7v-29.1c0-12.5 10.1-22.6 22.6-22.6 6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5 118.5 118.5c3.7 42.7-11.7 85.2-42.3 115.8-27.4 27.4-64.6 42.8-103.3 42.8H22.1C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5l126.4-113.7c4.2-3.7-.4-10.4-5.4-7.9l-51.1 25.6c-6.1 3-13.2-1.4-13.2-8.2 0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), gc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18 156.7 156.5 18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8 16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2l107.3 107.2c6 6 14.1 9.3 22.6 9.3 11.6 0 22.3-6.3 27.9-16.4l95.1-171.1z" })
  }
), ic1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4 222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8c-22.3 22.3-34.8 52.5-34.8 84 0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9 0 502.1 9.9 512 22.1 512h173.3c38.8 0 75.9-15.4 103.4-42.8 30.6-30.6 45.9-73.1 42.3-115.8" })
  }
), mc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m384 0c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24" })
  }
), ac1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm120 72h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24m-56 24a32 32 0 1 1-64 0 32 32 0 1 1 64 0M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), oc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6l-20.7 51.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48v208H384V48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6l-20.7 51.7c-3.2 8-14.6 8-17.8 0zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64v-64h64c35.3 0 64-28.7 64-64v-32zm192 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), nc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8h-48v-8c0-57.4-46.6-104-104-104h-48C142.6 48 96 94.6 96 152M0 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1l-22.4 213c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32" })
  }
), rc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64.3c-1.1-14.1-5-27.5-11.1-39.5.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7.7-1.3 1.4-1.9 2.1-14.3-7.3-30.4-11.4-47.5-11.4H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4h135.2c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96M160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7z" })
  }
), dc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96M41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7.7 1.3 1.4 1.9 2.1 14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7.7-1.4 1.3-2.1 1.9 6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c0 24.6-5.5 47.8-15.4 68.6 2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v239.2c-34.5-3.4-65.8-17.8-90.3-39.6l-63 63c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.3c1.1-14.1 5-27.5 11.1-39.5-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z" })
  }
), Sc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m164.5 107.4 33.4-73.5c5.5-12.1.1-26.3-11.9-31.8S159.7 2 154.2 14L128 71.7l-26.1-57.6C96.4 2 82.1-3.3 70.1 2.1s-17.4 19.8-12 31.8l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7.5 124.7l8 40C10.7 175.9 20.6 184 32 184h32v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6c10.7 19.7 31.8 33.1 56 33.1s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9l-37.9-9.4V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8l-4.2 20.7h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6l-7.8 80.3c-12.3 1-24.2 5.6-34.1 13.3l-14.7-8.5 6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15L332.3 258c-3.7 10.8.8 22.8 10.7 28.5l27.7 16-11.7 20.2-37.5-10.7c-9.4-2.7-19.5.6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3l21.2-52.5c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9l27-30.7c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z" })
  }
), zc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v184.2c-39.1 32.3-64 81.1-64 135.8 0 49.5 20.4 94.2 53.3 126.2-8.8 10.9-22.2 17.8-37.3 17.8h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m96 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0m140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z" })
  }
), pc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m368 272a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Mc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m224 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), xc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m224 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), Hc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m243.4 2.6-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64v196.3c-.6.3-1.2.7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512h448c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384v192h-40V224h-64v192h-48V224h-64v192h-40zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Vc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M448 0c-17.7 0-32 14.3-32 32v480h64V192h144c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32" })
  }
), Cc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m192 144c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), Lc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16m136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16m-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z" })
  }
), Bc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v159l-42.4 17H272c-8.8 0-16 7.2-16 16v64c0 .9.1 1.7.2 2.6 2.3 58.1 24.1 144.8 98.7 201.5-5.8 2.5-12.2 3.9-18.9 3.9h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16M64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m167.1 113.7c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3zM527.4 312 432 273.8v187.9c68.2-33 91.5-99 95.4-149.7" })
  }
), uc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), Rc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1 0-46.9 25.8-87.8 64-109.2V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m304 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0M352 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1" })
  }
), $c1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m384 80v16c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80zm0 128c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80h16zm0 112c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80h16zm-128 64v16h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80m0-96h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80zm0-128v16h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80m16-240c13.3 0 24 10.7 24 24v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24m96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24M456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24" })
  }
), kc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16" })
  }
), Pc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm208 16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm112-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16M80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm144-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16M256 208v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16m144 16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z" })
  }
), Fc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 32c0-12.9-7.8-24.6-19.8-29.6S434.5.2 425.3 9.3L381.7 53c-48 48-113.1 75-181 75H64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352h8.7c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4zm-64 76.7v262.6C357.2 317.8 280.5 288 200.7 288H192v-96h8.7c79.8 0 156.5-29.8 215.3-83.3" })
  }
), Tc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M335.2 244.7c.5 3.7.8 7.5.8 11.3 0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80c3.8 0 7.6.3 11.3.8l31.2-31.2-4.8-28.6c-12-3.3-24.7-5-37.7-5-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1 0 106-86 192-192 192S64 362 64 256 150 64 256 64c10.9 0 21.6.9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1 50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80l-23-57.5c-4.3-10.7-18-13.5-26.2-5.4l-51.2 51.3c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7-92.1 92c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z" })
  }
), Ac1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256c0 3.9.1 7.8.4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9.2 7.8.4 11.7.4zm2.3-48 19.7-67c33.5-9.6 58-40.4 58-76.9 0-44.2-35.8-80-80-80-36.5 0-67.4 24.5-76.9 58L112 253.7c1.2-78.5 65.2-141.7 144-141.7 79.5 0 144 64.5 144 144 0 78.8-63.2 142.8-141.7 144M39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7" })
  }
), Dc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), yc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7 14.3-32 32-32s32 14.3 32 32v36.7c38 11.5 67.8 43.2 75.9 83.7l48.5 242.7c-.4.3-.9.6-1.3.9-18 12.4-40.1 20.3-59.2 20.3-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-19 0-41.2-7.9-59.2-20.3-.4-.3-.9-.6-1.3-.9l48.5-242.7c8.1-40.6 37.9-72.2 75.9-83.7V32zm32 96c-22 0-40.9 15.5-45.2 37l-24.6 123h139.6l-24.6-123c-4.3-21.5-23.2-37-45.2-37m18.5 293.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), bc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-17.7 0-32 14.3-32 32 0 15.3 10.8 28.1 25.1 31.3L133.8 320H96c-17.7 0-32 14.3-32 32v16c0 8.2.7 16.1 2 23.9 21-11.1 46.9-9.9 66.9 4.2 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 20-14.1 45.9-15.3 66.9-4.2 1.3-7.8 2-15.8 2-23.9v-16c0-17.7-14.3-32-32-32h-38.1L390.9 63.3c14.3-3.2 25.1-16 25.1-31.3 0-17.7-14.3-32-32-32zm133.8 64 9.8 49-47.6 55.5-47.6-55.5 9.8-49h75.5zm21.8 108.8 17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6-44.9 52.4 17-84.9 27.9 32.6zM221.3 320l66.7-77.8 66.7 77.8zm85.2 101.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), fc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 194.9C32 211 45 224 61.1 224h389.8c16.1 0 29.1-13 29.1-29.1 0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zm96-82.9a16 16 0 1 1 0 32 16 16 0 1 1 0-32m240 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0M256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32M32 400v16c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16m202-137.3c-6.5-4.4-14.2-6.7-22.1-6.7H64c-26.5 0-48 21.5-48 48s21.5 48 48 48h384c26.5 0 48-21.5 48-48s-21.5-48-48-48h-19.9c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0z" })
  }
), Uc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.2 1.7c-5-2.5-10.8-2.2-15.6.7S160 10.5 160 16V269.9c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zm-55.2 13-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2.9 2.3 1.2 3.4 2 6.3 6.7 15.9 18.7 24.3 3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6l-20.4-5.1c-5.3-1.3-10.8.1-14.8 3.8S-.7 93.4.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1zm343.5 13.2c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-18 4.5-19 107.8c2-.3 4-.6 6.1-.7 11-6.5 23.3-12.3 37.1-17.2l13.4-76.1zM276.3 337.2c-11.8-10.4-19.5-25.3-20.2-42.1-16.6 5.4-37.6 8.8-64.1 8.8-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7.2 3.4.6 5.1l57.5 237c3.4 14.4 16.3 24.5 31.1 24.5H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8m-8.5-82.9c.8-.6 1.6-1.1 2.4-1.7 4.1-6.6 9.4-14 16.1-21.6l.3-.9c.7-2.3 1.7-4.7 2.8-7l30.4-172.3c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8c-6.2 1.5-10.9 6.5-12 12.7l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6zm372.2 38c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5m-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0m96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16z" })
  }
), Gc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8-12.4-10.9-20.3-26.9-20.3-44.8 0-6.3 1-13.8 4.4-21.5 5.5-12.5 20.5-40.4 52.7-65.3 16.2-12.5 36.3-23.8 60.9-32l10-139.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0zm41.2 160-6.8-96h251.2l-6.9 96H73.2zM640 292.3c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5m-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0m96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16z" })
  }
), qc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 194.9C32 211 45 224 61.1 224h389.8c16.1 0 29.1-13 29.1-29.1 0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zm96-82.9a16 16 0 1 1 0 32 16 16 0 1 1 0-32m240 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0M256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32M32 400v16c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16m48-48c24.6 0 44.2-11.8 56.2-19 .9-.5 1.7-1 2.5-1.5 13.7-8.1 20.8-11.5 29.3-11.5 7.7 0 12.3 2.5 25.4 10.9l.2.1c13 8.3 32.6 21 62.4 21 29.7 0 48.6-12.6 61-20.9l.8-.5c11.6-7.7 16.6-10.6 26.2-10.6 10.5 0 17.9 3.7 30.2 11.3.9.5 1.8 1.1 2.8 1.7 11.4 7.1 30.3 19 55 19 21.5 0 38.4-5.4 50.3-11.4 5.9-3 10.5-6 13.9-8.5 1.7-1.3 3.1-2.4 4.1-3.3.5-.5 1-.9 1.4-1.2l.5-.5.2-.2.1-.1-22.6-22.6 22.6 22.6c12.5-12.5 12.5-32.8 0-45.3-12.3-12.3-32-12.5-44.5-.7l-.3.2c-.6.5-2 1.4-4.1 2.5-4.1 2-11.2 4.6-21.7 4.6-5.2 0-9.2-2-24.2-11.3-13.6-8.5-34.2-20.8-63.7-20.8-29.7 0-48.6 12.6-61 20.9l-.8.5c-11.6 7.7-16.5 10.6-26.2 10.6-10 0-16.1-3.2-28-10.9l-1.8-1.1c-11.9-7.7-30.8-20-58.3-20-27.7 0-48.4 12.3-61.6 20.2l-.5.3C90.7 285.6 85.6 288 80 288c-10.5 0-17.6-2.6-21.7-4.6-2.1-1-3.5-2-4.1-2.5l-.3-.2c-12.5-11.8-32.3-11.6-44.5.7-12.5 12.5-12.5 32.8 0 45.3l22.4-22.4-22.4 22.3.1.1.2.2.5.5c.4.4.8.8 1.4 1.2 1.1.9 2.4 2.1 4.1 3.3 3.4 2.5 8 5.6 13.9 8.5 12 6.2 28.9 11.6 50.4 11.6" })
  }
), Wc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h301.4c14-8.2 30.1-15.4 48.6-20.9 1.3-3.5 2-7.2 2-11.1 0-17.7-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0zM40 224l20.3 244c2.1 24.9 22.9 44 47.8 44H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8-12.4-10.9-20.3-26.9-20.3-44.8 0-6.3 1-13.8 4.4-21.5 4.2-9.5 13.8-27.8 32.2-47H40zm600 68.3c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5m-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32m64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0m96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16z" })
  }
), Ec1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M61.1 224C45 224 32 211 32 194.9c0-1.9.2-3.7.6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9.6 3.7.6 5.6 0 16.1-13 29.1-29.1 29.1H61.1zm82.9-96a16 16 0 1 0-32 0 16 16 0 1 0 32 0m240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32M272 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0M16 304c0-26.5 21.5-48 48-48h384c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48m16 96c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z" })
  }
), Oc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M251.4 52.6 33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3 5-16.3 7.7-33.7 7.7-51.7 0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9 11.4-1.9 23-2.9 34.9-2.9 53.6 0 102.5 20.3 139.4 53.6 12.8-14.2 20.6-33 20.6-53.6 0-11.4-2.4-22.2-6.7-32 4.3-9.8 6.7-20.6 6.7-32 0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7-9.8-4.3-20.6-6.7-32-6.7-20.6 0-39.4 7.8-53.6 20.6m193 240c-29.7-23-67-36.6-107.4-36.6-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32-.7 5.3-1.1 10.6-1.1 16 0 30.7 12.2 60.2 33.9 81.9L78 478c21.8 21.8 51.3 34 82 34s60.2-12.2 81.9-33.9z" })
  }
), Ic1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3-99.6 32.4C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4-52.9 100.6c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1l-52.9-100.6 103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-106.5-34.5 25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7-34.6-106.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z" })
  }
), Nc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c124.8 0 208 35.2 208 80v32h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-16v28.2c9.8 8.8 16 21.6 16 35.8v96c0 20.9-13.4 38.7-32 45.3V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-34.7c-18.6-6.6-32-24.4-32-45.3v-96c0-14.2 6.2-27 16-35.8V240H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16V80c0-44.8 83.2-80 208-80M112 160v64c0 17.7 14.3 32 32 32h96V128h-96c-17.7 0-32 14.3-32 32m160 96h96c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-96zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64m288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64M352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16" })
  }
), Xc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c124.8 0 224 35.2 224 80v336c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32V80C0 35.2 99.2 0 224 0M64 128v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m16 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64m288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Kc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0c134.4 0 224 35.2 224 80v48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H192v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32V256c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32V80c0-44.8 89.6-80 224-80M128 160v96c0 17.7 14.3 32 32 32h112V128H160c-17.7 0-32 14.3-32 32m176 128h112c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H304zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64m288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64M384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16" })
  }
), Qc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8m-56 8v40H64c-35.3 0-64 28.7-64 64v96h360.2c32.3-39.1 81.1-64 135.8-64 5.4 0 10.7.2 16 .7V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56m192 296h-96c-17.7 0-32-14.3-32-32v-32H0v128c0 35.3 28.7 64 64 64h296.2c-25.1-30.4-40.2-69.5-40.2-112 0-5.4.2-10.7.7-16zm320 16a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), Zc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c0-35.3 28.7-64 64-64h320v224H64zM32 320h576c17.7 0 32 14.3 32 32s-14.3 32-32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32s14.3-32 32-32M512 64c35.3 0 64 28.7 64 64v160h-96V64z" })
  }
), Jc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3 155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8 221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z" })
  }
), jc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M237.4 6c11.1-8 26.1-8 37.2 0L384 84.1V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v88.7l18.6 13.3c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224H32c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166zM32 280c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm24 72h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24m0 96h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24m264-168c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm24 168h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24m-24-72c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-64-216a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Yc1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v176H0zm0 208h448v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128-144v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32m0 256v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32" })
  }
), _c1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M160 56a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 288c0-35.3 28.7-64 64-64h136v-66.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4l-212.9 44V224h136c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z" })
  }
), hs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96c0-53 43-96 96-96s96 43 96 96v256h48c8.8 0 16-7.2 16-16v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112h-48v16c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V320h-48C50.1 320 0 269.9 0 208v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 8.8 7.2 16 16 16h48zm80 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), cs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M86.4 5.5 61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5m128 0-24.6 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5m103.4 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9 13.5 0 27.2-6.1 38.4-13.4 5.4-3.5 9.9-7.1 13-9.7 1.5-1.3 2.7-2.4 3.5-3.1.4-.4.7-.6.8-.8l.1-.1c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l.1.1.7.7c.7.7 1.7 1.7 3.1 3 2.8 2.6 6.8 6.1 11.8 9.5 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5 1.4-1.3 2.4-2.3 3.1-3l.7-.7.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1.1.7.7c.7.7 1.7 1.7 3.1 3 2.8 2.6 6.8 6.1 11.8 9.5 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5 1.4-1.3 2.4-2.3 3.1-3l.7-.7.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l.1.1.8.8c.8.7 1.9 1.8 3.5 3.1 3.1 2.6 7.5 6.2 13 9.7 11.2 7.3 24.9 13.4 38.4 13.4 10.7 0 20.5-3.9 28.8-9v-71c0-35.3-28.7-64-64-64v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48h-64zm320 218.6c-8.5 3.3-18.2 5.4-28.8 5.4-22.5 0-42.4-9.9-55.8-18.6-4.1-2.7-7.8-5.4-10.9-7.8-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2-2.7 2.3-5.9 4.7-9.4 7.2-12.8 8.9-32 18.9-54.6 18.9s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5-3.1 2.4-6.8 5.1-10.9 7.8-13.5 8.7-33.4 18.6-55.9 18.6-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32z" })
  }
), ss1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M276.2 38.9c5.6-4.4 12.6-6.9 19.8-6.9 44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256V415.5c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272c0-9.8 4.5-19.1 12.2-25.1l264-208zM448 288H64v48h384V311.8v.2V288.4zM64 416h384V373.8v.2V368H64z" })
  }
), vs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm288 0c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zm48 240h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48M0 336c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm19.3 252.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28.7-28.7 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), es1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 64h192c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32m32 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0M96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-32 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32m128-160a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), ls1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V264z" })
  }
), ts1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm248 232V321.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V424c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), ws1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm329 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), gs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32m128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144m176 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), is1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32m128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144m320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16" })
  }
), ms1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32m128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144m176 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), as1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32m128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144m320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), os1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144 0-97.2 78.8-176 176-176 5.4 0 10.7.2 16 .7zm128 176a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), ns1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16z" })
  }
), rs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), ds1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM192 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0m56-176v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Ss1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm112 125.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z" })
  }
), zs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM147.2 360.7c6.5-8.4 19.1-8.3 25.5.2L184 376l58.3-84.2c6.5-9.4 20.5-9.1 26.7.5l83.4 131.1c6.8 10.6-.9 24.6-13.5 24.6H112.5c-13.3 0-20.8-15.2-12.7-25.8l47.3-61.5zM128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), ps1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v43.6L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H48c-26.5 0-48-21.5-48-48zm120 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24zM96 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24m453.8-156.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), Ms1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM96 296c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24m24 72h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), xs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm312 184c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24z" })
  }
), Hs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm308.8 75c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 376.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3z" })
  }
), Vs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v32H80c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32m352 160H32v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zm-224 56c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56h-56c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-56c0-13.3 10.7-24 24-24" })
  }
), Cs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v32H80c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32m352 160H32v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zm-320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0m224 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64M224 288c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24m40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z" })
  }
), Ls1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0L223 298.7l-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z" })
  }
), Bs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32v32h-48c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H256V32c0-17.7-14.3-32-32-32s-32 14.3-32 32m55.4 480h145.2c-5.4-9.4-8.6-20.3-8.6-32 0-43.8 29.4-80.8 69.6-92.3-23-20.5-37.6-50.4-37.6-83.7 0-56.4 41.7-103.1 96-110.9V192H128v1.1c54.3 7.8 96 54.4 96 110.9 0 33.3-14.5 63.2-37.6 83.7 40.2 11.5 69.6 48.5 69.6 92.3 0 11.7-3.1 22.6-8.6 32M528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160m-48 32c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64zM192 304a80 80 0 1 0-160 0 80 80 0 1 0 160 0M0 480c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64" })
  }
), us1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z" })
  }
), Rs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32M32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm305 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47z" })
  }
), $s1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48z" })
  }
), ks1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c-17.7 0-32 14.3-32 32v32h-48c-26.5 0-48 21.5-48 48v48h416v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-96V32c0-17.7-14.3-32-32-32M96 192v176c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V192zm-48-8c0-13.3-10.7-24-24-24S0 170.7 0 184v208c0 66.3 53.7 120 120 120h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72z" })
  }
), Ps1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 96c-17.7 0-32 14.3-32 32v32h224c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-23.7 12.9-44.4 32-55.4V128c0-53 43-96 96-96h160c17.7 0 32 14.3 32 32s-14.3 32-32 32zm431.1 67.8c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64-14.2-9.5V238.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6M80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Fs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400H64v-16c0-17.7-14.3-32-32-32S0 366.3 0 384v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zm373.1 396.1c3.9 1.8 8.4 1.9 12.5.3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3-132.9 88.5 116.5 52.9z" })
  }
), Ts1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128m224 192H128C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66 21.8-39.4 63.8-66 112-66 70.7 0 128 57.3 128 128s-57.3 128-128 128m0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128m206.3 195.4c10.8 5.4 17.7 16.5 17.7 28.6v192c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448V320l12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3M64 288h288c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), As1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v150.3l53.3 79.9c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-54.3c0-12.6 3.7-25 10.7-35.5L64 246.3zm224 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128m160-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0M112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Ds1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M220.6 121.2 271.1 96H448v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64v-64h128c9.9 0 19.7-2.3 28.6-6.8M0 128v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64h-32V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v16C28.7 64 0 92.7 0 128m168 176a88 88 0 1 1 176 0 88 88 0 1 1-176 0" })
  }
), ys1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M213.1 64.8 202.7 96H128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16h-76.7c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3zm-256 64c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21 19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3-6.2 0-11.3-5.1-11.3-11.3z" })
  }
), bs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64h-74l59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512H96c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36l59-36.8H64c-35.3 0-64-28.7-64-64zm128 144a96 96 0 1 1 192 0 96 96 0 1 1-192 0m224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0" })
  }
), fs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8L202.7 96h-47.9L38.8 5.1zm246.6 193.3c10.7-4.1 22.4-6.4 34.6-6.4 53 0 96 43 96 96 0 4.1-.3 8.2-.8 12.2zM224 288c0-5 .4-9.9 1.1-14.6l-159.9-126c-.8 4.1-1.2 8.3-1.2 12.6v256c0 35.3 28.7 64 64 64h359.4l-131-103.2c-11.2 4.6-23.5 7.2-36.4 7.2-53 0-96-43-96-96" })
  }
), Us1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0m320 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24M48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24m464 0v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24M180 128l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h94.7c10 0 19 6.2 22.5 15.6L332 128h36c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zm140 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), Gs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135.2-106C525.9 324.9 544 276.6 544 224 544 100.3 443.7 0 320 0c-72 0-136.1 34-177 86.7L38.8 5.1zm154.5 121.1C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160 0 37.7-13 72.3-34.8 99.6L420 303.9c17.5-21.9 28-49.7 28-79.9 0-70.7-57.3-128-128-128-41.3 0-78.1 19.6-101.5 50l-25.2-19.7zm88.2 69.1-25.2-19.7C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3M507.7 496 359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9-88.4 0-160-71.6-160-160v-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512h320c11.6 0 22.1-6.2 27.7-16M324.8 351.9 194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1" })
  }
), qs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344.2 413.1C406.6 373.3 448 303.5 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512h320c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256m0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320m-48 160c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48" })
  }
), Ws1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M149.1 64.8 138.7 96H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8M256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), Es1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4-3.2 0-6.4 1.1-9 3.4-29.9 27-55.3 57.7-73.2 87.1-17.7 29-29.2 60.2-29.2 84.2 0 79.8 63.3 145.3 144 145.3 79.9 0 144-65.5 144-145.3 0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6-40.5 0-72.9-26.4-72.9-70.9 0-21.8 13.5-40.9 40.5-74.5 3.6 4.5 55.8 71.8 55.8 71.8l32.4-38.2c2.7 3.6 4.5 7.3 6.3 10.9 16.2 30 9 68.2-18 87.3M42.8 289.9c-16.6-5.9-35 2.7-40.9 19.4s2.7 35 19.4 40.9L160.9 400 21.2 449.9c-16.6 5.9-25.3 24.2-19.3 40.9s24.3 25.3 40.9 19.4L256 434l213.2 76.2c16.6 5.9 35-2.7 40.9-19.4s-2.7-35-19.4-40.9L351.1 400l139.6-49.9c16.6-5.9 25.3-24.3 19.4-40.9s-24.3-25.3-40.9-19.4L256 366 42.8 289.9" })
  }
), Os1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-39 48.8L249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4c-8 10-12.3 22.3-12.3 35V464c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-23.6c0-12.7-4.3-25.1-12.3-35L329 112zm-89 396H168.5L288 291.7 407.5 448z" })
  }
), Is1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M270.3 304.5c12.1-2.5 23.4-5.5 33.7-9V426c-2.8 1.6-6.6 3.6-11.8 5.7-22.4 9.2-57.8 16.3-100.2 16.3s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7V295.5c10.3 3.5 21.6 6.5 33.7 9 7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5m-100.1-40a32 32 0 1 1 43.5 46.9 32 32 0 1 1-43.5-46.9M16 72v368c0 39.8 78.8 72 176 72s176-32.2 176-72V72c0-39.8-78.8-72-176-72S16 32.2 16 72m288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24 112 10.7 112 24" })
  }
), Ns1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 192c-44.2 0-80-35.8-80-80 0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80m-32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64c17.7 0 32 14.3 32 32v208h52.1c-2.7-7.5-4.1-15.6-4.1-24 0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V256c0-17.7 14.3-32 32-32zm272 216a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Xs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 320h128v-96H0zm0 64c0 35.3 28.7 64 64 64h64v-96H0zm288 64v-96H160v96zm0-224H160v96h128zm0-160H160v128h128zm288 0H320v384h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64M44.2 192H128v-83.8c0-7.1-9-11.1-15-7.4-12 7.1-26 11.2-41 11.2-4 0-7.9-.3-11.7-.9-7-1-14.2 6.2-13.1 13.1.6 3.8.9 7.7.9 11.7 0 15-4.1 29-11.3 41-3.6 6.1.4 15 7.4 15z" })
  }
), Ks1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5 12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4l340.5-212.8c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23l-26.8 16.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zm-50.4-81.7c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9zm88.5 52.7 46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6m28.9 59.3 61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-103.2 64.4 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9z" })
  }
), Qs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440.6 256c9.8 25.6 19.6 49 28.7 67.2 3.3 6.7 6.2 12.4 9.3 17.7.5.8 1 1.7 1.4 2.4.5-.8 1-1.6 1.4-2.4 3.1-5.3 6-11 9.3-17.7 9-18.2 18.9-41.5 28.7-67.2zM480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 17.4-5.3 43.8-12.3 71.4-4.4-1-9.3-2.1-14.5-3.1-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-5.3 1.1-10.1 2.1-14.5 3.1-7-27.6-12.3-54-12.3-71.4 0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0M370.3 250.4c-11-30.8-21.3-62.9-29.6-92.1 3.8-.9 8-1.8 12.4-2.7 29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7c4.5.9 8.6 1.8 12.4 2.7-8.3 29.2-18.6 61.3-29.6 92.1-13.2 37.2-27.9 73.6-41.6 101.3-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3zM83 211.1c30.4-30.4 65.3-59.4 103.9-79 15-7.5 33.1-4.6 45 7.3 12 12 26.6 33.9 40.7 57.7-3.8 2.3-7.8 5-12.2 7.9-25.6 17.1-60.9 43.9-100.3 83.3S94 363 76.9 388.6c-2.9 4.3-5.5 8.4-7.9 12.2C45.2 386.6 23.3 372 11.3 360c-11.9-11.9-14.6-30.4-7.1-45.4 19.7-38.4 48.4-73.1 78.8-103.5m97 248.2c-28.8-13.7-58-28.7-83.9-43 2-3.2 4.3-6.7 6.7-10.4 16-24 41.6-57.7 79.4-95.5s71.5-63.4 95.5-79.4c3.7-2.5 7.2-4.7 10.4-6.7 14.4 25.9 29.4 55.1 43.1 83.9 16.5 34.8 31.5 70 41.1 98.5 9.3 27.9 21.7 67-2.6 91.2s-63.4 11.9-91.2 2.6c-28.5-9.6-63.7-24.6-98.5-41.1zm52.3-44.6c24.4 11 47.3 20.2 66.1 26.5 6.9 2.3 12.8 4.2 18.6 5.8.9.2 1.8.5 2.7.7-.2-.9-.4-1.7-.7-2.7-1.5-5.8-3.4-11.7-5.8-18.6-6.3-18.8-15.6-41.7-26.5-66.1l-54.4 54.4z" })
  }
), Zs1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M318.1 64c-24.5.2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3zm174.2 276.8c4.7-9.6 8.7-19.6 11.8-30l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1c-20.3-68.2-77.5-120.5-148.5-133.8l136.8 273.5zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zm-106.8 10.4L147.7 171.2c-4.7 9.6-8.7 19.6-11.8 30l-93.2-46.7c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6-29 11C6.2 237 0 246 0 256s6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4l93.3-46.5c20.3 68.2 77.5 120.6 148.5 133.9z" })
  }
), Js1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c5.3 0 10.3 2.7 13.3 7.1 15.8 23.5 36.7 63.7 49.2 109 7.2 26.4 11.8 55.2 10.4 84 11.5-8.8 23.7-16.7 35.8-23.6 41-23.3 84.4-36.9 112.2-42.5 5.2-1 10.7.6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7-9.1 15.9-19.9 31.7-32.4 46.3 27.8 6.6 52.4 17.3 67.2 25.5 5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-70.8l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6-28.9-6.6-54.6-17.6-69.8-26.1-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5-12.4-14.4-23.2-30.2-32.3-46.1-23.4-40.8-37.1-84-42.7-111.7-1.1-5.2.6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5 12.1 6.9 24.3 14.7 35.8 23.6-1.4-28.7 3.1-57.6 10.4-84 12.5-45.3 33.4-85.5 49.2-109 3-4.4 8-7.1 13.3-7.1z" })
  }
), js1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48v112H64zm-64 0v224c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8l128.5 187.3c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3c-35.5-51.8-105.4-64.3-156-28.1-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144m296.6 64.2c-16-23.3-10-55.3 11.9-71 21.2-15.1 50.5-10.3 66 12.2l67 97.6-79.9 56zM491 407.7c-.8.6-1.6 1.1-2.4 1.6l4-2.8c-.5.4-1 .8-1.6 1.2" })
  }
), Ys1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16" })
  }
), _s1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M74.8 96.3 39.6 196.8C16.4 206.4 0 229.3 0 256v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m288 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-65.7-168.8L281.9 192H336c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4l36.5-72.9H176c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9.5s7.4 12.8 4.1 19.4z" })
  }
), hv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v384c0 26.5 21.5 48 48 48h144V352c0-32.8 16.5-61.8 41.6-79.1l5.6-16.9H208c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.2 0 14.9 6.1 15.9 14l.5-1.4c10.5-31.6 34.2-56 63.7-68.2V48c0-26.5-21.5-48-48-48zm32 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m0-96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 288h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m282.6-64h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7M304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), cv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m145.1 120.6 147.3-39.4c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6-249.7 66.8 7-63.6c1.4-13.1 10.8-24 23.5-27.4M58 141.1l-10.2 93.1c-20.4 15.2-30.6 41.8-23.6 67.9l33.1 123.7 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5l-33.2-123.6c-7-26.1-29.1-44.1-54.4-47l-55.3-75.6c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1m58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1-16.6-61.8M372.5 242a32 32 0 1 1 61.8-16.6 32 32 0 1 1-61.8 16.6m212.3 270c19.5 0 34.7-17.7 25.8-35-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35z" })
  }
), sv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2C282.8 97 297.9 84.4 315 76.1c-.4-.6-.8-1.2-1.3-1.8-4.1-5.1-10.9-7.2-17.2-5.3l-76.2 23.1-29.4-74C188.4 12 182.6 8 176 8m191.7 153.5 135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1-12.4 46.4 24 24 0 1 1 12.4-46.4m217.9 83.2a24 24 0 1 1 46.3 12.4 24 24 0 1 1-46.4-12.4z" })
  }
), vv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 416h16v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h64v-64c0-32.8 16.5-61.8 41.6-79.1l16.3-48.9H208V96h88c13.3 0 24 10.7 24 24v16.4c13.2-5.4 27.7-8.4 42.6-8.4H384V74.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0h-30.2C123.7 0 71.2 12.4 23.7 36.2 9.2 43.4 0 58.2 0 74.5V384c0 17.7 14.3 32 32 32M88 96h88v128H88c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24m8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48m266.6-72h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7M304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), ev1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4zm-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l34.1 97.4C385.8 205.7 320 279.2 320 368c0 10.9 1 21.6 2.9 32H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288m47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9" })
  }
), lv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343.8 8.8C329 .4 310.9.4 296.2 8.8L24.1 164.2C8.8 173 3.5 192.5 12.2 207.9s28.3 20.7 43.7 11.9L320 68.9l264.1 150.9c15.3 8.8 34.9 3.4 43.7-11.9s3.4-34.9-11.9-43.7L343.8 8.8zm-94 215.2h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H215.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3c-20.1 8.5-34.2 28.4-34.2 51.6v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C454.1 181.3 424 160 390.2 160H249.8c-33.8 0-64 21.3-75.3 53.1M192 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), tv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H141.1l26.1-74.6zM32 224h8.6c-5.4 9.4-8.6 20.3-8.6 32v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256c0-11.7-3.1-22.6-8.6-32h8.6c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.5l-22.3-63.7C455.7 57.8 419.4 32 378.6 32H197.4c-40.8 0-77.1 25.8-90.6 64.3L84.5 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32m64 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), wv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24zm-94.2 200h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C62.1 300.9 48 320.8 48 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1M128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z" })
  }
), gv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M165.4 96h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4m-90.6.3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h256v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-56.6c19.1-11.1 32-31.7 32-55.4v-80c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3M208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-160 8c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24m360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), iv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M82.2 92.3 40.6 196.4C16.8 205.8 0 228.9 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-65.2-48.8-119-111.8-127l-100-125c-18.2-22.8-45.8-36-75-36H171.3C132 32 96.7 55.9 82.2 92.3zM480 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-365.3 32a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32m216.5-267.4c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6l33.4-55.8H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z" })
  }
), mv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96M272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84zm256.2 1-100-125c-18.2-22.8-45.8-36-75-36H171.3C132 32 96.7 55.9 82.2 92.3L40.6 196.4C16.8 205.8 0 228.9 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-65.2-48.8-119-111.8-127m-93.5 175a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), av1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m145.1 120.6 147.3-39.4c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6-249.7 66.8 7-63.6c1.4-13.1 10.8-24 23.5-27.4M58 141.1l-10.2 93.1c-20.4 15.2-30.6 41.8-23.6 67.9l33.1 123.7 6 22.2H48c-26.5 0-48 21.5-48 48v16h640v-16c0-26.5-21.5-48-48-48H162.6c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5l-33.2-123.6c-7-26.1-29.1-44.1-54.4-47l-55.3-75.6c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1m58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1-16.6-61.8M372.5 242a32 32 0 1 1 61.8-16.6 32 32 0 1 1-61.8 16.6" })
  }
), ov1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7h115.2c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6v112c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0m106.8 512c-6.6-5.9-10.8-14.4-10.8-24v-40H160v40c0 9.6-4.2 18.1-10.8 24zm-172-234.5L177 320h158l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5M168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48m200-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), nv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.8-6.7-21.6 0C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48m160 0c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48m208-48c0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48M153.8 224h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H119.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C30.1 300.9 16 320.8 16 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C358.1 181.3 328 160 294.2 160H153.8c-33.8 0-64 21.3-75.3 53.1zM96 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), rv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M468.9 104h-13.4c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1h31c10.8 0 18.4-10.6 12.5-19.6-3.6-5.5-7.8-10.5-12.5-14.9-4.2-3.9-8.8-7.4-13.8-10.3-1.8-1.2-3.7-2.2-5.7-3.2-10.5-5.1-22.4-8-34.9-8-29.1 0-54.5 15.5-68.5 38.7-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0 67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1-5 2.9-9.6 6.4-13.8 10.3-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56h31c.7 0 1.4.1 2.1.1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7.1-1.4.1-2.1.1H25.5c-10.8 0-18.5 10.6-12.6 19.6 3.6 5.5 7.8 10.5 12.5 14.9 4.2 3.9 8.8 7.4 13.8 10.3 1.9 1.1 3.8 2.2 5.8 3.1 10.6 5.1 22.4 8 34.9 8 29.1 0 54.5-15.5 68.5-38.7 3.3-5.4 8.9-9.3 15.3-9.3h184.5c6.4 0 12 3.8 15.3 9.3 14 23.2 39.5 38.7 68.5 38.7 12.5 0 24.4-2.9 34.9-8 2-1 3.9-2 5.8-3.1 5-2.9 9.6-6.4 13.8-10.3 4.7-4.4 9-9.4 12.5-14.9 5.9-9-1.7-19.6-12.5-19.6zM185.8 224h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C62.1 300.9 48 320.8 48 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1M128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), dv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4zm-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Sv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 32C35.8 32 0 67.8 0 112v224c0 44.2 35.8 80 80 80h16c0 53 43 96 96 96s96-43 96-96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V192c0-88.4-71.6-160-160-160zM64 160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32M144 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), zv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112c0-44.2 35.8-80 80-80h336c88.4 0 160 71.6 160 160v160h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80zm320 240h128v-96h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), pv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm130.1 144.3c-28.2 3-50.1 26.8-50.1 55.7 0 30.9 25.1 56 56 56 15.7 0 29.8-6.4 40-16.8V336h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32.8c10.2 10.4 24.3 16.8 40 16.8 30.9 0 56-25.1 56-56 0-28.9-21.9-52.7-50.1-55.7 1.4-5.2 2.1-10.7 2.1-16.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6.7 11.1 2.1 16.3" })
  }
), Mv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm180.7 84.7-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z" })
  }
), xv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 221.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 253.1 80 237.5 80 221.3" })
  }
), Hv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm111 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-40.8c-.3.3-.7.6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64z" })
  }
), Vv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4l192.8-111.4c26.6-15.4 35.8-49.4 20.4-76.1l-167-289.3C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zm431.6 302.1L324.1 499c9.7 8.1 22.2 13 35.9 13h224c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5.1-5.3.2l136.8 236.9c24.2 41.9 9.8 95.6-32.1 119.8z" })
  }
), Cv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zM197 159.6c-11.1-3-22.6 3.6-25.6 14.8l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4.2-.8.3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4.1.8.2 1.1.3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4zm262.4 261.3c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2h224c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1zm74.5-183.3 48.1-50c14-14.5 13.2-38.5-2.2-51.9-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0z" })
  }
), Lv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 191.9 288 191.9L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" })
  }
), Bv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" })
  }
), uv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S63.9 115 63.9 128v256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" })
  }
), Rv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 320.1 32 320.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" })
  }
), $v1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6M244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L125.5 212v.1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l60.4 60.3 100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136" })
  }
), kv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H105.7l17.7-53.1zm-87.3 59.5C14.8 144.7 0 166.6 0 192v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h136.5c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6h15.1l-24.5-73.3C342.4 22 311.8 0 277.4 0H138.6c-34.4 0-65 22-75.9 54.7zM56 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0m306.6 16h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7M304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48m232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Pv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360v102.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Fv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5H312V177.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V288h99.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Tv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Av1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320-288a144 144 0 1 0 0 288 144 144 0 1 0 0-288m-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0" })
  }
), Dv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m464-144a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7z" })
  }
), yv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), bv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m176-144a144 144 0 1 0 288 0 144 144 0 1 0-288 0m208 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16" })
  }
), fv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), Uv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v288c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16h197.4c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80c0-44.2-35.8-80-80-80zm192 32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm192 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32m32 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32z" })
  }
), Gv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h16c44.2 0 80 35.8 80 80v288c0 8.8 7.2 16 16 16h464c17.7 0 32 14.3 32 32s-14.3 32-32 32h-66.7c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32" })
  }
), qv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h16c44.2 0 80 35.8 80 80v288c0 8.8 7.2 16 16 16h464c17.7 0 32 14.3 32 32s-14.3 32-32 32h-66.7c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32m432 64V56c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v40zm-144 0V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56v264H288zm224 224V96h16c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48zM240 96h16v224h-16c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48" })
  }
), Wv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v288c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16h197.4c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80c0-44.2-35.8-80-80-80zm160 80v192c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96v144c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V32h-96c-26.5 0-48 21.5-48 48" })
  }
), Ev1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M280 132h112c11 0 20 9 20 20s-9 20-20 20H280c-11 0-20-9-20-20s9-20 20-20" })
  }
), Ov1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 24C0 10.7 10.7 0 24 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24m128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20v-44h44c11 0 20-9 20-20s-9-20-20-20h-44V96c0-11-9-20-20-20s-20 9-20 20v44h-44c-11 0-20 9-20 20" })
  }
), Iv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H263.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C640.6 57 621.4 32 595.1 32h-411C175 12.8 155.6 0 133.5 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M24 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), Nv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 24C0 10.7 10.7 0 24 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24m128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0m336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), Xv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96m336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M395.4 128.9 364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3l-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l31.1-31.1-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l31.1 31.1 31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z" })
  }
), Kv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C46.3 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1c-.7 4.7-1.1 9.5-1.1 14.3V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-69.6c0-4.8-.4-9.6-1.1-14.4l-22.7-149.6c-4.7-31.3-31.6-54.4-63.2-54.4H208v-32h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zm32 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16M64 432c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48m120-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48m168-104a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48m168-104a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48" })
  }
), Qv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v32h576V96c0-35.3-28.7-64-64-64zm512 128H0v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64zM192 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-128 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0m256-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32z" })
  }
), Zv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-28.9l-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1H174.2c-20 0-37.9 12.4-44.9 31.1L92.9 480H64c-35.3 0-64-28.7-64-64zm416.8 298.4 32.1 85.6H127.1l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4h227.6c6.7 0 12.6 4.1 15 10.4M341.5 192h-107c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32h107c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32m90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m-320 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), Jv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v32h576V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96m0 64v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V160zm467.9 224H416v-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80M160 349.3V384h-51.9C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160v34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3M256 224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32" })
  }
), jv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v208h64v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v288c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H48c-26.5 0-48-21.5-48-48V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h64V112z" })
  }
), Yv1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7M411.2 89.6l-29.4-39.2C401.1 38.7 423.8 32 448 32s46.9 6.7 66.2 18.4l-29.4 39.2c-3 4-7.8 6.4-12.8 6.4h-48c-5 0-9.8-2.4-12.8-6.4M480 316.8C553 302 608 237.4 608 160 608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1-54.9 8.1-102.2 39.5-131.6 83.8v-85.4c0-48.4-36.1-89.3-84.1-95.3l-7.9-1c-17.6-2.1-33.6 10.3-35.8 27.8s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8V416c0 53 43 96 96 96H336c17.7 0 32-14.3 32-32s-14.3-32-32-32h-56l136-108.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM400 160a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32M231.5 12.3c-2.6-7-12.4-7-15 0l-10.7 28.8c-.8 2.2-2.5 3.9-4.7 4.7l-28.8 10.7c-7 2.6-7 12.4 0 15l28.8 10.7c2.2.8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15l-28.8-10.7c-2.2-.8-3.9-2.5-4.7-4.7z" })
  }
), _v1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 192h17.1c22.1 38.3 63.5 64 110.9 64 11 0 21.8-1.4 32-4v228c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7S50.5 94 68 96.2l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8m160 26.5c-10 3.5-20.8 5.5-32 5.5-28.4 0-54-12.4-71.6-32-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128V10.7C352 4.8 356.7.1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2v.1l12.8 17 27.2 36.3L416 64h64l4.8-6.4L512 21.3l12.8-17v-.1c2-2.6 5.1-4.2 8.4-4.2h.2c5.9.1 10.6 4.8 10.6 10.7V128c0 17.3-4.6 33.6-12.6 47.6-11.3 19.8-29.6 35.2-51.4 42.9M432 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), he1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96M35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24v-58.1c20.1-26.1 32-58.1 32-95.5 0-37.3-16.5-77.4-35.1-110.4h3.1c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h3.1z" })
  }
), ce1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v34.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c30.9-5.2 59.2-17.7 83.2-35.8 14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6 14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8zm-64 100v248c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124" })
  }
), se1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v34.7c30.9 5.2 59.2 17.7 83.2 35.8 14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6 14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.7C101.2 430.1 32 351.1 32 256S101.2 81.9 192 66.7V32c0-17.7 14.3-32 32-32" })
  }
), ve1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M211 7.3C205 1 196-1.4 187.6.8s-14.9 8.9-17.1 17.3l-15.8 62.5-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62-62.5 15.9c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45-46.2 45c-6.3 6-8.7 15-6.5 23.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5-15.9-62.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3l-45 46.2-45-46.2z" })
  }
), ee1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h128c35.3 0 64 28.7 64 64v192H96V64c0-35.3 28.7-64 64-64M64 160v64c0 17.7-14.3 32-32 32S0 241.7 0 224v-64c0-17.7 14.3-32 32-32s32 14.3 32 32m384 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32M51.4 305.7C56.8 294.8 67.9 288 80 288h288c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1S395.1 384 384 384H256v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H64c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1z" })
  }
), le1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 48v208h48V58.7c23.9 13.8 40 39.7 40 69.3v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h256v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32c-5.4-10.9-16.5-17.7-28.6-17.7z" })
  }
), te1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384v-32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64H224v49.1C205.2 102.2 183.3 96 160 96zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192m-26.7 224h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3 0 411.7 59.7 352 133.3 352" })
  }
), we1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32c-35.3 0-64 28.7-64 64v288h64V96h384v288h64V96c0-35.3-28.7-64-64-64zm128 352v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416v-32c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32" })
  }
), ge1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C71.9 0 58.3 12 56.3 27.9L33.2 208c-8.3 65.4 34.1 124.4 94.8 140v100H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48V348c60.7-15.6 103.1-74.6 94.8-140l-23-180.1C261.7 12 248.1 0 232 0zm20 128 8.2-64h87.7l8.2 64z" })
  }
), ie1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.6 17.3C163 3 179.9-3.6 195 1.9l125 45.6L445 1.9c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6l31.4 86.2 41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41L547.9 484l-71.1 26c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1l-71-25.9-71.1-25.9c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2l78.7-152.9zm44 54.4-27.2 52.8 89.2 32.5 13.1-57.9zm240.9 0-75.1 27.4 13.1 57.9 89.2-32.5z" })
  }
), me1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C60.7 0 32 28.7 32 64v384c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3v-32c0-8.8-7.2-16-16-16h-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-16c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32c0-48.6-39.4-88-88-88h-16V64c0-35.3-28.7-64-64-64zm120.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z" })
  }
), ae1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm96 288h288c17.7 0 32-14.3 32-32v-68.2c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z" })
  }
), oe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32m96 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32m32 64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 96h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), ne1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264 32c13.3 0 24 10.7 24 24v8h176c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h192v-8c0-13.3 10.7-24 24-24m-104 96v32h80v-32zm128 0v32h160v-32zm48 256v-32h-80v32zm0 64H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-80v8c0 13.3-10.7 24-24 24s-24-10.7-24-24zm48-96v32h64v-32z" })
  }
), re1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm256-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32m-224-96c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16z" })
  }
), de1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32m128 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m128-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32m64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32m128-96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Se1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32m96 96c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32m96 64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32m160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), ze1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm217.4 57.4L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l73.4-73.3 57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41h110c13.3 0 24-10.7 24-24V185.9c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80c-12.5-12.5-32.8-12.5-45.3 0z" })
  }
), pe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm313.4 57.4L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6V80c0-8.8-7.2-16-16-16h-89.4C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16l18.7 18.7zm64 141.3-18.7 18.7-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h89.4c8.8 0 16-7.2 16-16v-89.4c0-12.5-10.1-22.6-22.6-22.6-6 0-11.8 2.4-16 6.6z" })
  }
), Me1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm375 215c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4-57.3 57.3-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.3 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80z" })
  }
), xe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l89.4-89.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" })
  }
), He1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8l-109.4 87.5-108.2-81.1c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6l140-112v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM192 224c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32M64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32m368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288m25.4-169.4a35.9 35.9 0 1 0-50.7 50.7 35.9 35.9 0 1 0 50.7-50.7M396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z" })
  }
), Ve1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8l-109.4 87.5-108.2-81.1c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6l140-112v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM192 224c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32M64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32m368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288m-23.9-173v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4-.4.7-.9 1.6-.8 3.6z" })
  }
), Ce1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6zM160 256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32M32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32m288-64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32m96-32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), Le1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2 36.1 0 69 13.3 94.3 35.2l82.1-60.2c-.2-2.3-.4-4.6-.4-7 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2 0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64v-1.1l-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112h-76.2c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32h76.1c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64m48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Be1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c4.6 0 9.3.2 13.8.5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240h103.2c31.5-29.8 74-48 120.8-48M320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368m320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-118.6 25.4a35.9 35.9 0 1 0-50.7-50.7 35.9 35.9 0 1 0 50.7 50.7m10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z" })
  }
), ue1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c4.6 0 9.3.2 13.8.5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240h103.2c31.5-29.8 74-48 120.8-48M320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368m320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-167.2-32.6c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z" })
  }
), Re1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M495.4 240H272V16.6c0-9 7-16.6 16-16.6 123.7 0 224 100.3 224 224 0 9-7.6 16-16.6 16M190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h221.3c18.5 0 33.3 15.7 29.5 33.8C451.9 430.5 355.5 512 240 512 107.5 512 0 404.6 0 272 0 156.5 81.5 60.1 190.2 37.2" })
  }
), $e1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 240V16.6c0-9 7-16.6 16-16.6 123.7 0 224 100.3 224 224 0 9-7.6 16-16.6 16zM32 272c0-121.3 90.1-221.7 207-237.7 9.2-1.3 17 6.1 17 15.4V288l156.5 156.5c6.7 6.7 6.2 17.7-1.5 23.1-39.2 28-87.2 44.4-139 44.4-132.5 0-240-107.4-240-240m526.4 16c9.3 0 16.6 7.8 15.4 17-7.7 55.9-34.6 105.6-73.9 142.3-6 5.6-15.4 5.2-21.2-.7L320 288z" })
  }
), ke1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0L163 160h186zM69.6 320h372.8l-74.7-128H144.3zM51 352l-39.6 67.8C-4.2 446.5 15.1 480 45.9 480h420.2c30.9 0 50.1-33.5 34.6-60.2L461 352z" })
  }
), Pe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72.5 252c-1.4 2.5-1.4 5.5 0 8l88.3 152.9c1.4 2.5 4.1 4 6.9 4h176.6c2.9 0 5.5-1.5 6.9-4L439.5 260l48.7 28.1-48.7-28.1c1.4-2.5 1.4-5.5 0-8L351.2 99.1c-1.4-2.5-4.1-4-6.9-4H167.7c-2.9 0-5.5 1.5-6.9 4zm-55.4 40a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm273.1-111.2 40.2 100.6C347.5 286 360 301.5 360 320c0 22.1-17.9 40-40 40-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2 0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2z" })
  }
), Fe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m256-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v209L43.5 423.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1L256 329.7l171.5 142.9c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Te1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32m96 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0m224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-160-48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), Ae1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16zm128 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0M160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), De1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 320c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48zM208 480c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48zm176-368V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48" })
  }
), ye1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48zM0 272c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM368 96h32c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48" })
  }
), be1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm0 240c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM304 32h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m-48 208c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zm48 112h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48" })
  }
), fe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H576V64H224v49.1C205.2 102.2 183.3 96 160 96zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0M0 485.3C0 411.7 59.7 352 133.3 352h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3" })
  }
), Ue1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32m128 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32m64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32m128 32v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Ge1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z" })
  }
), qe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v304H96zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48h16v128h448V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z" })
  }
), We1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z" })
  }
), Ee1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M451 93c37.7 37.7 61 89.7 61 147.2V256H0c0-5.4.7-10.7 2.1-15.8 3.8-13.7 12.4-25.8 24.5-33.9L96 160l23.2-15.4c7.8-5.2 18.4-2.3 25.5 3.8 8.4 7.2 19.3 11.6 31.3 11.6 26.5 0 48-21.5 48-48 0-5.2-.8-10.2-2.3-14.9-2.9-9-1.6-19.9 6.3-25.1l47-31.3c8.6-5.7 18.6-8.7 28.9-8.7 56 0 106.8 22.1 144.2 58 1 1 2 2 3 2.9zm-19 195h80v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288h304c8.8 0 15.7 7.4 18.6 15.7C329.1 322.5 347 336 368 336s38.9-13.5 45.4-32.3c2.9-8.4 9.8-15.7 18.6-15.7m-208 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Oe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7 115 0 208.2 93.2 208.2 208.2m0 47.8v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288z" })
  }
), Ie1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m288 24 14.1-19.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1v.2l-.1.9c-.1.9-.3 2.2-.6 4-.6 3.6-1.5 9-2.9 15.8-2.8 13.7-7.6 33.3-15.3 56.3-14 42-37.4 94.7-75.8 143.7-17.2-8.5-43-18-73.5-18 0 0-96 0-96 112 0 144 144 176 192 176s192-16 192-176c0-112-96-112-96-112-20.5 0-38.9 4.3-54 9.7 27.1-42.6 45-85.1 56.7-120.2 5.7-17 9.9-32.3 13-45.1 11.7 10.8 25.8 24.7 40.1 41.2 29.6 34.3 59.1 78.4 73.1 128.5-12-5.3-27-10.3-44.2-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9 36.5 17.4 73.8 23.1 94.1 23.1 48 0 192-16 192-176 0-112-96-112-96-112-32.3 0-59.2 10.6-76.3 19.6-14.2-67.6-52.5-124.7-87.5-165.3-19.9-23-39.2-41.3-53.6-53.9-7.2-6.3-13.2-11.2-17.5-14.5-2.1-1.7-3.8-3-5-3.9-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1L288.1 24z" })
  }
), Ne1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 32c-13.3 0-24 10.7-24 24 0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384h128l-13.7-96h5.7c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.3c12.7-7.5 26.3-21.7 26.3-48 0-22.5-5.7-42.4-13.9-59.5l-38.8 38.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l44.3-44.3c-7.4-10-15.2-18.2-21.9-24.6C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416z" })
  }
), Xe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32 0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400h192v-27.3c25.2-12.5 56-37.4 56-84.7 0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l106.1-106.1c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32zM48 432 6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512h274.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L272 432z" })
  }
), Ke1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 64v64h64V96h64v64h64V96h64v64h-64v64h64v64h-64v64h64v64h-64v-64h-64v64h-64v-64h-64v64H64v-64h64v-64H64v-64h64v-64H64V96zm64 128h64v-64h-64zm0 64v-64h-64v64zm64 0h-64v64h64zm0 0h64v-64h-64z" })
  }
), Qe1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 56c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v48h88c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32v-16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16h184V80h-32c-13.3 0-24-10.7-24-24m-96 248a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-52.7-59.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0M464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224m16-176v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), Ze1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v48H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-32v-16c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24m320 248a112 112 0 1 1-224 0 112 112 0 1 1 224 0m-52.7-59.3c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224m-16 48v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16" })
  }
), Je1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H60.2C49.1 96 40 105.1 40 116.2c0 2.5.5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384h136l-16-128h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3 0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416z" })
  }
), je1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v48h152c22.1 0 40 17.9 40 40 0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40h152v-48h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32M38.6 473.4 80 432h288l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z" })
  }
), Ye1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m57.6 102.4-6.9 6.9c-12 12-18.7 28.3-18.7 45.3v81.2c0 10.7 5.3 20.7 14.2 26.6l3.5 2.4c12.7 8.5 29.1 9.5 42.8 2.7 2.3-1.1 4.5-2.5 6.5-4l38.8-29.1c5.5-4.1 13.1-4.1 18.6 0 8.2 6.1 8.3 18.4.2 24.7L81 317c-20.8 16-33 40.7-33 67h224l26.9-107.6c3.4-13.6 5.1-27.5 5.1-41.5 0-94.4-76.5-171-171-171H47.8C39.1 64 32 71.1 32 79.8c0 6 3.4 11.5 8.7 14.2zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1-32 0M48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L272 416z" })
  }
), _e1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 48 82.7 61.3c-12 12-18.7 28.2-18.7 45.2v132.4c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0 10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400h320l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7zm24 68a20 20 0 1 1 40 0 20 20 0 1 1-40 0M22.6 473.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h370.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L384 432H64z" })
  }
), hl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 240c19.4-14.6 32-37.8 32-64 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384h128l-13.7-96h5.7c13.3 0 24-10.7 24-24s-10.7-24-24-24zM4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416H48L4.8 473.6z" })
  }
), cl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.5 224c29.2-18.4 48.5-50.9 48.5-88 0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32 0 16.5 12.5 30 28.5 31.8L80 400h160l-12.5-112.2c16-1.8 28.5-15.3 28.5-31.8 0-17.7-14.3-32-32-32zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h242.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L256 432H64z" })
  }
), sl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m125.9 100.9-41.5 67.5c11.2 2.1 19.6 11.8 19.6 23.6 0 13.3-10.7 24-24 24h-8l19.6 144H60.4L80 240h-8c-13.3 0-24-10.7-24-24 0-11.8 8.5-21.5 19.6-23.6l-41.5-67.5c-3.7-6-3-13.6 1.6-18.9s12.1-6.9 18.6-4.1c3 1.3 6.3 2.1 9.8 2.1 11.8 0 21.6-8.5 23.6-19.7 1.1-6.3 6-11.4 12.3-12.8s12.8 1.1 16.5 6.4C112.8 84 119.9 88 128 88s15.2-4 19.6-10.1c3.7-5.3 10.2-7.8 16.5-6.4s11.1 6.4 12.3 12.8c2 11.2 11.8 19.7 23.6 19.7 3.5 0 6.8-.7 9.8-2.1 6.4-2.9 13.9-1.2 18.6 4.1s5.3 13 1.6 18.9zM208 416l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4 0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24 0-5.2 1.7-10.2 4.8-14.4L48 416z" })
  }
), vl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112M134.1 143.8c3.3-13 15-23.8 30.2-23.8 12.3 0 22.6 7.2 27.7 17 12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17 15.3 0 27 10.8 30.2 23.8 7 27.8 32.2 48.3 62.1 48.3 10.8 0 21-2.7 29.8-7.4 8.4-4.4 18.9-4.5 27.6.9 13 8 17.1 25 9.2 38L399.7 400H112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38 8.7-5.3 19.2-5.3 27.6-.9 8.9 4.7 19 7.4 29.8 7.4 29.9 0 55.1-20.5 62.1-48.3M112 432h288l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16z" })
  }
), el1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M67.4 384 80 264l-30.6-30.6c-6-6-9.4-14.1-9.4-22.6V112c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v98.7c0 8.5-3.4 16.6-9.4 22.6L240 264l12.6 120zM136 280.9c0 3.9 3.2 7.1 7.1 7.1h33.8c3.9 0 7.1-3.2 7.1-7.1V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32.9zM20.8 473.6 64 416h192l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4 0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24 0-5.2 1.7-10.2 4.8-14.4z" })
  }
), ll1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v40c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v40c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v144c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80l16-144-51.2-38.4c-8.1-6-12.8-15.5-12.8-25.6m176 96h32c8.8 0 16-7.2 16-16v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16M22.6 473.4 64 432h320l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z" })
  }
), tl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H60.2C49.1 96 40 105.1 40 116.2c0 2.5.5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384h136l-16-128h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3 0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416zm288 0-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L464 416zm-32-208v51.9c0 7.8 2.8 15.3 8 21.1l27.2 31-2.2 72h125.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16h-24v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16h-24v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16m80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32h-32z" })
  }
), wl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c5.3 0 10.3 2.7 13.3 7.1 2.9 4.3 7.9 9.7 15.5 16.6 7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352H0c0-94 47.2-161.8 96.7-211.3 23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8 7.6-6.9 12.7-12.3 15.5-16.6 3-4.5 8-7.1 13.3-7.1zM4 384h440c-14.2 55.2-64.3 96-124 96H128c-59.6 0-109.8-40.8-124-96" })
  }
), gl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" })
  }
), il1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })
  }
), ml1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" })
  }
), al1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" })
  }
), ol1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7l169.4-169.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192zm192-384-192 192c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z" })
  }
), nl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" })
  }
), rl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192 192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" })
  }
), dl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3l169.4 169.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192zm192 384-192-192c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l169.4 169.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" })
  }
), Sl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-2.3-4.7c-3-5.9-9-9.6-15.6-9.6-9.6 0-17.4 7.8-17.4 17.4v285.2c0 9.6 7.8 17.4 17.4 17.4 6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6V113.4zM224 32c17.7 0 32 14.3 32 32v160h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V288h-96v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32m224 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v128h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), zl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-8 352V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5l12.9 20.5c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9h-12.3c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10l13-20.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32M448 0h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v100.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32v144c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-26.7l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16" })
  }
), pl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9c-3.4 10.4 4.3 21.1 15.2 21.1z" })
  }
), Ml1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6-12.6 0-24.9-2-36.6-5.8-.9-.3-1.8-.7-2.7-.9z" })
  }
), xl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10s-19.5-29.1-10.1-44l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6l39.9 63.4c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10l-21-33.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96z" })
  }
), Hl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M88 480v-80H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4-28.6 37.8c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8 31.1 93.4c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32v-80h-16v80c0 17.7-14.3 32-32 32s-32-14.3-32-32M480 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9l51.7 82.2c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10l-13-20.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96z" })
  }
), Vl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm32 128h96v128H32zm384 0v128H160V192zM288 352v128H32V352zm128 0v128h-96V352z" })
  }
), Cl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 0c-15.3 0-29 7.2-37.7 18.3L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.2 22.5-2.7L405.7 77.7C412.2 69.5 416 59.2 416 48c0-26.5-21.5-48-48-48M131.9 506.4c5.8 6.7 15.9 7.5 22.6 1.7l468.7-359.7c10.3-8.8 16.8-21.9 16.8-36.4 0-26.5-21.5-48-48-48-11.9 0-22.8 4.4-31.2 11.6L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z" })
  }
), Ll1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48v-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512z" })
  }
), Bl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96m-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), ul1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m268-124.8c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8" })
  }
), Rl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-33.3-327.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L244.7 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z" })
  }
), $l1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), kl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m223.6-126.8c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z" })
  }
), Pl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-384h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8 0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3 0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z" })
  }
), Fl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70c-24.6 21-38.8 51.8-38.8 84.2" })
  }
), Tl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h144c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2.5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z" })
  }
), Al1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m264-128h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72m-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z" })
  }
), Dl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96m-26 44.4-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70c24.6-21 38.8-51.8 38.8-84.2 0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4" })
  }
), yl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320H190.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272h82.3z" })
  }
), bl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-40-320.4c0 4.1 1.6 8.1 4.6 11l14.4 14.5 23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.3-5.9-13.2-13.2-13.2h-19.2c-8.6 0-15.6 7-15.6 15.6zm71 46.9-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4a79.997 79.997 0 0 1-62 29.4h-32.2c-36.7 0-66.5-29.8-66.5-66.5 0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45 0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2 0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9 0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z" })
  }
), fl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-94.1L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v160c0 13.3 10.7 24 24 24z" })
  }
), Ul1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-64 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 13.3-10.7 24-24 24z" })
  }
), Gl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512M127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24v182.1l71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0z" })
  }
), ql1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0M231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71 182.1.1c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9l71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), Wl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m281 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h182.1l-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9z" })
  }
), El1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24h-94.1L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24z" })
  }
), Ol1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24h160c13.3 0 24 10.7 24 24z" })
  }
), Il1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m129-281c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0z" })
  }
), Nl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-360c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H184c-13.3 0-24-10.7-24-24V256zm144 52c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28m-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84z" })
  }
), Xl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z" })
  }
), Kl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-176c-23.1 0-41 11.1-46.3 14.8-1.1.8-2.4 1.2-3.7 1.2-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5 10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5v160.8c0 3.3-2.7 5.9-5.9 5.9-1.3 0-2.6-.4-3.7-1.2-5.5-3.7-23.4-14.8-46.5-14.8m144 0c-23.1 0-41 11.1-46.3 14.8-1.1.8-2.4 1.2-3.7 1.2-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5 10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5v160.8c0 3.3-2.7 5.9-5.9 5.9-1.3 0-2.6-.4-3.7-1.2-5.5-3.7-23.4-14.8-46.5-14.8" })
  }
), Ql1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v192c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4z" })
  }
), Zl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-56.6-199.4c31.2 31.2 81.9 31.2 113.1 0 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z" })
  }
), Jl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M208 96c8.8 0 16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v32H128v-32c0-17.7 14.3-32 32-32h32v-16c0-8.8 7.2-16 16-16m-80 256V224h256v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32" })
  }
), jl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-60-352 6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm108 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), Yl1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m0 368c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4h208c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7" })
  }
), _l1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0m-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22v208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6" })
  }
), ht1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S208 369.5 208 360V152c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6" })
  }
), ct1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S369.5 304 360 304H152c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7" })
  }
), st1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), vt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512M135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0z" })
  }
), et1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0M271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), lt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m241 121c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9z" })
  }
), tt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m121-241c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0z" })
  }
), wt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-72c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24m72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48v160z" })
  }
), gt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5c-20.6 26.6-34.4 58.7-38.8 93.8H1.1zm137.2-127.7L92.7 58.8C131.3 26.9 179.3 6 232 1.1v64.4c-35.1 4.4-67.2 18.2-93.7 38.8M280 446.5c35.1-4.4 67.2-18.2 93.7-38.8l45.5 45.5c-38.5 31.9-86.5 52.8-139.2 57.7zm127.7-72.8c20.6-26.6 34.5-58.7 38.8-93.7h64.4c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zm-315 79.5 45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8v64.4c-52.7-4.9-100.7-25.8-139.3-57.7zm-33.9-33.9C26.9 380.7 6 332.7 1.1 280h64.4c4.4 35.1 18.2 67.2 38.8 93.7zM419.3 58.8l-45.5 45.5c-26.6-20.6-58.7-34.4-93.8-38.8V1.1C332.7 6 380.7 26.9 419.3 58.8zm-11.6 79.5 45.5-45.5c31.9 38.5 52.8 86.6 57.7 139.3h-64.4c-4.4-35.1-18.2-67.2-38.8-93.7z" })
  }
), it1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24m56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), mt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208 48 93.1 141.1 0 256 0s208 93.1 208 208c0 55.9-22 106.6-57.9 144-1 1-2 2.1-3 3.1a208.78 208.78 0 0 1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.7-4.3-1.5-6.4-2.1-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 6.9 29.8 9.1v6.3c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352h16c19.5 25.9 44 47.7 72.2 64H64v32h384v-32h-72.2c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48" })
  }
), at1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m20.8-378.4v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z" })
  }
), ot1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), nt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m-96-313.4V336c0 8.8 7.2 16 16 16h137.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7c-3.6-3.6-8.5-5.6-13.6-5.6s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6z" })
  }
), rt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m96 198.6V336c0 8.8-7.2 16-16 16H198.6c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6" })
  }
), dt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m120.9 294.6-107.1 99.9c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5l-107.1-99.9c-4.5-4.2-7.1-10.1-7.1-16.3 0-12.3 10-22.3 22.3-22.3H208v-96c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96h57.7c12.3 0 22.3 10 22.3 22.3 0 6.2-2.6 12.1-7.1 16.3" })
  }
), St1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v56h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24" })
  }
), zt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), pt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Mt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 192c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v9.3l-119.3 54.3c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3zm149.9 92.7L384 236.5V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-83.5l106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z" })
  }
), xt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 272h16c-.6-5-.9-10.1-.9-15.2 0-5.7.4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-95.1c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-81.6c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Ht1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M506.5 203 480 229.5l-18.7-18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l64 64c11.9 11.9 27.4 18.2 43 18.7-44.3 76.5-127 128-221.8 128C114.6 512 0 397.4 0 256S114.6 0 256 0c123.2 0 226.1 87 250.5 203M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64m369-175L497 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), Vt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-384c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Ct1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24" })
  }
), Lt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 70.7-57.3 128-128 128s-128-57.3-128-128 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80" })
  }
), Bt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m112-360v208c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H192v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v80h128v-80c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), ut1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256c0-106-86-192-192-192v384c106 0 192-86 192-192M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Rt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256s97.8 238.3 224.1 254c17.5 2.2 31.9-12.4 31.9-30z" })
  }
), $t1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4z" })
  }
), kt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v160h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Pt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ft1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m80-360v136c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Tt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m89.1-343.2L272 243.1l75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8l102.9-104.6c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5.3 33.9z" })
  }
), At1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-360v184h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Dt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0M217.4 376.9l-99.9-107.1c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1 12.3 0 22.3 10 22.3 22.3V208h96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-96v57.7c0 12.3-10 22.3-22.3 22.3-6.2 0-12.1-2.6-16.3-7.1" })
  }
), yt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m102.2-329.3-84 196c-3.5 8.1-11.4 13.3-20.2 13.3-1.4 0-2.9-.1-4.4-.4-10.2-2.1-17.6-11.2-17.6-21.6v-90h-90c-10.4 0-19.5-7.4-21.5-17.6-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7 6.4 6.3 8.2 15.9 4.7 24.2z" })
  }
), bt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-84.5-374.1L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2L275.4 310c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7.3 26.8 8.8z" })
  }
), ft1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M256 96c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48s48-21.5 48-48v-16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c0-26.5-21.5-48-48-48m-96 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16v-17c63.1-7.9 112-61.7 112-127v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96z" })
  }
), Ut1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-368c0-26.5 21.5-48 48-48s48 21.5 48 48v112c0 26.5-21.5 48-48 48s-48-21.5-48-48zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17c-63.1-7.9-112-61.7-112-127v-16c0-8.8 7.2-16 16-16" })
  }
), Gt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-280h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), qt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-52.3-373.7L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9s20.9.6 26.9 9.2z" })
  }
), Wt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80-43.4 0-78.7 34.5-80 77.5l-183.8 73.6C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6l145.6 127.4c-2.4 7.6-3.7 15.8-3.7 24.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zm-262.1 74.3c2.2-6.9 3.5-14.2 3.7-21.7L343.8 137c3.6 3.5 7.4 6.7 11.6 9.5l-37.8 207.6c-5.5 1.3-10.8 3.1-15.8 5.5z" })
  }
), Et1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z" })
  }
), Ot1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256a80 80 0 1 0 160 0 80 80 0 1 0-160 0m80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256" })
  }
), It1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88z" })
  }
), Nt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48zm48 64h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96" })
  }
), Xt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-32-320v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32m128 0v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Kt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2l24.6 20.2c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224 0-9-6-16.9-14.7-19.3z" })
  }
), Qt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m135.4-202c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4.2-26.7-8.5l-21.8-35.2c-4.8-7.8-3.4-17.5 3.4-23.8 84.9-78.6 222.6-78.6 307.5 0 6.8 6.3 8.2 16.1 3.4 23.8z" })
  }
), Zt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-69.3-383.3c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224 0-9 6-16.9 14.7-19.3z" })
  }
), Jt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m188.3-108.9c-7.6 4.2-12.3 12.3-12.3 20.9v176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z" })
  }
), jt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-24-168v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), Yt1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-80-256c0 44.2 35.8 80 80 80 13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37 0-44.2-35.8-80-80-80s-80 35.8-80 80m208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L328 361.8c-20.5 14-45.3 22.1-71.9 22.1-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z" })
  }
), _t1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256h160c17.7 0 32-14.3 32-32V64c106 0 192 86 192 192s-86 192-192 192S64 362 64 256m-64 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0" })
  }
), hw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 256c-17.7 0-32.2-14.4-30-31.9C16.4 108.2 108.2 16.4 224.1 2 241.6-.2 256 14.3 256 32v192c0 17.7-14.3 32-32 32z" })
  }
), cw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120.2 391.8 256 256l135.8 135.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), sw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), vw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h104c44.2 0 80 35.8 80 80 0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288h-44v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v64z" })
  }
), ew1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384m0 448a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-56-256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9-25.6 22.6-43.9 53.3-50.9 88.1-3.4 17.2 11.2 31.7 28.9 31.7zm28 48.5-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8 16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5m84-48.5h72c17.7 0 32.3-14.5 28.8-31.8-7-34.8-25.3-65.5-50.9-88.1-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), lw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m294.6-120.9 99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8l-99.9 107.1c-4.2 4.5-10.1 7.1-16.3 7.1-12.3 0-22.3-10-22.3-22.3V304h-96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h96v-57.7c0-12.3 10-22.3 22.3-22.3 6.2 0 12.1 2.6 16.3 7.1" })
  }
), tw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48.4-315.8c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7 12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z" })
  }
), ww1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0" })
  }
), gw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0M267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h192c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4zm0-310.6 96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0m46.1 91.3L256 134.6 198.6 192z" })
  }
), iw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m267.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96m0 310.6 96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0m46.1-91.3L256 377.4 198.6 320z" })
  }
), mw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m267.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96m-22.6 310.6c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4z" })
  }
), aw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-152c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2l72.4-38 72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6L338 282.7l58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z" })
  }
), ow1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40.3l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9 10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z" })
  }
), nw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-64-352h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32" })
  }
), rw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M152 144h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), dw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64v160c0 17.7 14.3 32 32 32h160c0-106-86-192-192-192M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Sw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256c0 141.4 114.6 256 256 256 130.6 0 238.3-97.8 254-224.1 2.2-17.5-12.4-31.9-30-31.9H256z" })
  }
), zw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-384h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7l11.3 11.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h192l-13.6 162.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3z" })
  }
), pw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-64-344v120c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v120c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Mw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-198.6V176c0-8.8 7.2-16 16-16h137.4c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.6 3.6-8.5 5.6-13.6 5.6s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6" })
  }
), xw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m96 313.4V176c0-8.8-7.2-16-16-16H198.6c-12.5 0-22.6 10.1-22.6 22.6 0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6" })
  }
), Hw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3 0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-96h-57.7c-12.3 0-22.3-10-22.3-22.3 0-6.2 2.6-12.1 7.1-16.3" })
  }
), Vw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M399 384.2c-22.1-38.4-63.6-64.2-111-64.2h-64c-47.4 0-88.9 25.8-111 64.2 35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144" })
  }
), Cw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-82.5-354.7 82.5 165 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z" })
  }
), Lw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 192c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm268.9 125.9L352 288v-64l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1" })
  }
), Bw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M150.9 168.7 192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-41-128.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z" })
  }
), uw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-368v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16m-128 32v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16m192 24v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16m-128 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16s16 7.2 16 16m192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), Rw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-69.7-375.5 69.7 82.3 69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l74.9-88.5-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8" })
  }
), $w1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), kw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-85.9-359.7 85.9 99.1 85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24v-79l-98.1-113.3c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z" })
  }
), Pw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96.1-361.8c9.8-8.9 25-8.2 33.9 1.6l62.2 68.5 62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v25c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h40v-32h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9" })
  }
), Fw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-72-384h144c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8l118-170.3H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Tw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), Aw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160 32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288m32 160c11.2 0 22.1-.8 32.8-2.4 40.6 41 96.9 66.4 159.2 66.4 123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1.8-32.8 2.4C342.6 25.4 286.3 0 224 0 100.3 0 0 100.3 0 224s100.3 224 224 224m192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160" })
  }
), Dw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391m116.3 32.9c9.6 2.7 18.8-4.9 18.8-14.9V264.5c0-6.2-4.3-11.5-10-14-5.9-2.6-13-2.1-17.6 2.5l-89.2 89.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c27.1 27.1 59.6 45.5 94 55.2zM250.5 166c2.5 5.7 7.8 10 14 10H409c10 0 17.6-9.1 14.9-18.8-9.7-34.2-27.9-66.6-54.8-93.6l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6m.6 50.5c-2 4.9-1.4 10.6 2.4 14.3l114 114c6.6 6.6 17.4 6.2 22.9-1.3 26.2-35.8 40.1-77.8 41.5-120.1.3-8.6-6.8-15.4-15.4-15.4H263c-5.3 0-9.8 3.7-11.8 8.5zm-34.6 34.6c-4.9 2-8.5 6.5-8.5 11.8v153.5c0 8.6 6.8 15.7 15.4 15.4 42.4-1.4 84.4-15.3 120.1-41.5 7.5-5.5 7.9-16.3 1.3-22.9l-114-114c-3.7-3.7-9.4-4.4-14.3-2.4z" })
  }
), yw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16h-80c-53 0-96 43-96 96v16c0 8.8 7.2 16 16 16m-48-32c0-23.1 6.1-44.7 16.8-63.4-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240 240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160h-80c-26.5 0-48-21.5-48-48z" })
  }
), bw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v48h-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64V24c0-13.3-10.7-24-24-24S64 10.7 64 24v72H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480zm96 320v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16m-336 48h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m-112-16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm432-144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-304-80v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16m-144-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm144 144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm-144 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m304-48v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16M400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm16 112v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16" })
  }
), fw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M453.8 32.3 327 159l-1 1h-92.1L361 33l1-1h86c2 0 3.9.1 5.8.3M393.9 160 498 56c8.8 11 14 24.9 14 40v64zm-192-128H294L167 159l-1 1H73.9L201 33l1-1zM134 32 7 159l-1 1H0V96c0-35.3 28.7-64 64-64h70.1zM0 192h512v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm216.5 65.9c-5.2 2.8-8.5 8.2-8.5 14.1v128c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z" })
  }
), Uw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32h-86.1l-1 1-127 127H326l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40L394 160zM294.1 32h-92.2l-1 1-127 127H166l1-1L294 32zM64 32C28.7 32 0 60.7 0 96v64h6.1l1-1 127-127zm448 160H0v224c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64z" })
  }
), Gw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 144c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v32h76.6c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V368c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L583.2 360c-7.9-5.3-17.1-8.1-26.6-8.1H108.3c-10.2 0-20.3-1.9-29.7-5.7l-68.5-27.3C4 316.4 0 310.5 0 304v-64c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7H256v-32h-16c-8.8 0-16-7.2-16-16m224 16h-64v32h64zm-96 0h-64v32h64zm-80 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), qw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.4 9.4c12.5-12.5 32.7-12.5 45.2 0l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448H384c-17.7 0-32-14.3-32-32v-50.7L210.7 224H160c-17.7 0-32-14.3-32-32v-50.7L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm0 224c12.5-12.5 32.8-12.5 45.3 0l64 64 96 96 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L210.7 448H128c-17.7 0-32-14.3-32-32v-82.7l-54.6-54.7c-12.5-12.5-12.5-32.8 0-45.3zm269.2-224 32 32 64 64 64 64 64 64 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L498.7 288H448c-17.7 0-32-14.3-32-32v-50.7L370.7 160H320c-17.7 0-32-14.3-32-32V77.3l-22.6-22.7c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z" })
  }
), Ww1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m113 209L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), Ew1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-4.7 132.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l20.7 20.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16m-16 80h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16M72 368a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Ow1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64M72 272a24 24 0 1 1 48 0 24 24 0 1 1-48 0m104-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16M72 368a24 24 0 1 1 48 0 24 24 0 1 1-48 0m88 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16" })
  }
), Iw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), Nw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-88 132h72c33.1 0 60 26.9 60 60 0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3l-31.6 29 31.7 29.7c8.1 7.6 8.5 20.2.9 28.3s-20.2 8.5-28.3.9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V216c0-11 9-20 20-20m72 80c11 0 20-9 20-20s-9-20-20-20h-52v40z" })
  }
), Xw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-86.2 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Kw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-64 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0M80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16" })
  }
), Qw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-80 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Zw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224a224 224 0 1 1 448 0 224 224 0 1 1-448 0M224 96c-13.3 0-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V120c0-13.3-10.7-24-24-24zm0 384c96.4 0 180.3-53.3 224-132v116c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V348c43.7 78.7 127.6 132 224 132" })
  }
), Jw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-24 392v-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256v136c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), jw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l85.3-56.8V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Yw1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-24 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3v136c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), _w1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" })
  }
), hg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120v-56.7l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23v136c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), cg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v128.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), sg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120v-91.2l58.7 39.2c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256v136c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), vg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v112c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), eg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v136c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), lg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3v136c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), tg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z" })
  }
), wg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M75 75 41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24h110.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75m181 53c-13.3 0-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z" })
  }
), gg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-24 392v-56.7l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z" })
  }
), ig1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v128.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), mg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120V256c0-13.3-10.7-24-24-24s-24 10.7-24 24v136c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), ag1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), og1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512m24-120V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l85.3 56.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), ng1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), rg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-24 392V256c0-13.3 10.7-24 24-24h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v112c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), dg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v136c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V120c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), Sg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-360v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), zg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), pg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m-24 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), Mg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m24-392v91.2l58.7-39.2c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), xg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), Hg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 448H64V224h64v-64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-64h-64zm-64-96h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64" })
  }
), Vg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zm197.8 155c26.6 1.2 50.4 13.3 67 31.9 6.1 6.8 7.6 16.2 4.7 24.3l-71.6-56.2zm94 73.7c10-42.3 48-73.8 93.4-73.8 28.4 0 54 12.4 71.5 32 8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16-26.5 0-48 21.5-48 48 0 5.4.9 10.5 2.5 15.4l-47.9-37.6zm89.4 70c1.3.1 2.7.2 4.1.2 14.2 0 27-6.1 35.8-16 8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4l-47.9-37.6zM32 121.2V416c0 35.3 28.7 64 64 64h391.4L295 328.4c-16.8 14.7-38.9 23.6-63 23.6-53 0-96-43-96-96 0-16 3.9-31.1 10.8-44.3zM232 304c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5 0 26.5 21.5 48 48 48" })
  }
), Cg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm200 112c14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48s21.5-48 48-48m144 48c0-26.5 21.5-48 48-48 14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48" })
  }
), Lg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.8 84.8C222.3 35 267.1 0 318.5 0h1.5c61.9 0 112 50.1 112 112v6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8 232.3 161.3C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74H74c-40.9 0-74-33.1-74-74 0-24.2 11.9-47 31.8-60.8l269.8-187.4.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3V112c0-26.5-21.5-48-48-48h-1.5c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255 68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2 0 5.5 4.5 10 10 10h492c5.5 0 10-4.5 10-10 0-3.3-1.6-6.4-4.3-8.2z" })
  }
), Bg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm79-167 80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v134.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z" })
  }
), ug1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z" })
  }
), Rg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm16-280v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40m40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8m88-16c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16m136-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8zM176 320c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16m96 24v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40m40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8m104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z" })
  }
), $g1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.4 79.9C380.6 33 427.1 0 481.2 0c3.7 0 7.3.2 10.9.5 7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1 0 48.1 39.4 87.4 88.4 87.4 5.2 0 10.3-.4 15.2-1.3 6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1h-2.4c-5.4-37.8-29.7-69.5-63-85.3-1.8-38.6-23.1-72.1-54.3-90.8zM447.8 272c0 44.2-35.8 80-80 80h-18.6c-6.8-19.2-24.9-32-45.2-32h-18.3l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6V160c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4C271.2 101.3 287 96 304 96c44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7zm-165.7-44.4c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1" })
  }
), kg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64m431.9 159.9c0 44.2-35.8 80-80 80h-18.6c3.5-10.1 3.7-21.3 0-31.8-6.8-19.2-24.9-32.1-45.3-32.1h-18.3l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4-37.9-12.8-65.2-48.7-65.2-90.9 0-47.6 34.6-87 80-94.6v-1.3c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7zm-165.8-76.3c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352H496c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1" })
  }
), Pg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2.2s22.8 38.6 12.8 58.8L333.7 320H416c53 0 96-43 96-96s-43-96-96-96h-1.6c1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0 114.1 0 64 50.1 64 112c0 7.1.7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224m330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S153.2 384 160 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z" })
  }
), Fg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm289-239c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), Tg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-8 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24m96 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24m168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24m-72-40v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24m168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24" })
  }
), Ag1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm176-320c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Dg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zM0 392c0-13.3 10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24m64 96c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24m208 0c0-13.3 10.7-24 24-24h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24" })
  }
), yg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6m120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6m232 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6m-107.4 31.6-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5M32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64m192 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), bg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M32 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), fg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40 2 0 3.9.1 5.8.3 11.8-14.8 29.9-24.3 50.2-24.3s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3 26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96h-1.6c1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0 114.1 0 64 50.1 64 112c0 7.1.7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224m288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1.1 3.1-.7-.8-1.4-1.6-2.1-2.3-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7.7 1.5 1.4 2.3 2.1-1-.1-2.1-.1-3.1-.1-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1-.8.7-1.6 1.3-2.3 2.1-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3-.1 1-.1 2.1-.1 3.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1.7.8 1.3 1.6 2.1 2.3 12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1 1 .1 2.1.1 3.1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1.1-3.1.1.8-.7 1.6-1.3 2.3-2.1 12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7.7-1.4 1.5-2.1 2.3.1-1 .1-2.1.1-3.1M48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96m416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Ug1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm104-216c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), Gg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1 23.2 11 42 29.7 53.1 52.7 4 .4 8.1.6 12.3.6 34.9 0 66.7-13.8 89.9-36.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9.8-10 1.3-15.2 1.3-49 0-88.4-39.3-88.4-87.4 0-32.6 18-61.1 44.9-76.1 6.1-3.4 9.3-10.5 7.8-17.4S499.1 1 492.1.4c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.6 0 53 43 96 96 96zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3m96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3m96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3m96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3" })
  }
), qg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M495.8 0c5.5 0 10.9.2 16.3.7 7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8 0 81 65.5 146.6 146.2 146.6 8.6 0 17-.7 25.1-2.1 6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4-9.3 0-18.4-.7-27.4-1.9-11.2-22.6-29.8-40.9-52.6-51.7-2.7-58.5-50.3-105.3-109.2-106.7-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0m-47.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z" })
  }
), Wg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm272-296c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V184z" })
  }
), Eg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm152-104c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), Og1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm89.8-282.7-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L308 261.6c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Ig1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zm124.9 64.6 35.1-64.6c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z" })
  }
), Ng1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 64.4C466.8 69.5 385.4 119 336.5 192h-.5c-19.7 0-38.3 5.1-54.4 14.1-5.5-6-11.5-11.4-18-16.4C319.9 81.4 430.9 6.1 560 .4c8.8-.4 16 6.8 16 15.6v32c0 8.8-7.2 16-16 16.4M424 234.7c-13.3-16.9-31.5-29.9-52.3-36.9 43.7-57.9 111.4-96.6 188.3-101.3 8.8-.5 16 6.7 16 15.5v32c0 8.8-7.2 15.9-16 16.7-55.3 4.6-104 32.6-136 74m23.4 57.2c-1-9.1-3-17.9-6.1-26.2 25.7-40.1 68.9-67.9 118.8-72.9 8.8-.9 16 6.4 16 15.2v32c0 8.8-7.2 15.9-15.9 17.3-31.4 5.2-57.7 25.8-70.9 53.7-12.5-8.7-26.6-15.3-41.8-19.1zM96 512c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96z" })
  }
), Xg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.9-19.3-12.7-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6m244.6 31.5-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5m-132.6-31.5c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6" })
  }
), Kg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64h1.6c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96m-83.4 292.3-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9m327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2m-215.8 32.9-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9m103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2m-49.9 162.5c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), Qg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm16 32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24m192 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24m-72 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24m168-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24" })
  }
), Zg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445c24.6-23.3 40-56.3 40-93 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3L38.8 5.1zm58.4 167.5C96.4 179 96 185.5 96 192c0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h343.4L97.2 172.6z" })
  }
), Jg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.9-19.3-12.7-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm272 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6M216 376v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24m256 0v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), jg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96zm-32 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24m192 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24m216-8v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Yg1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64m69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7m96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7m96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7m96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7m74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V192c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7" })
  }
), _g1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l84.7 14.1c5.4.9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2-23.3 0-45.1 6.2-64 17.1v-1.1c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.5-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0m495.9 223.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z" })
  }
), hi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336m512 32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16m-272-16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-112-48c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16m272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), ci1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), si1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336" })
  }
), vi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 160c0 11.5 1.2 22.7 3.5 33.4 53.7 8.2 96.5 49.8 106.4 103 14.2 5.5 27.2 13.4 38.5 23.2 3.7.3 7.4.4 11.2.4 43.2 0 82.5-17.3 111.2-45.3 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7-64.3 0-116.5-52.3-116.5-116.9 0-43.7 23.9-81.8 59.3-101.9 6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1.6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160M114.8 273.9c20.1-30.1 54.3-49.9 93.2-49.9 12.9 0 25.3 2.2 36.8 6.2 19.6-19.9 45.8-33.5 75-37.2v-.9c0-35.3-28.6-64-64-64-7.4 0-14.6 1.3-21.2 3.6-11.5-30.1-40.6-51.6-74.8-51.6-38.9 0-71.3 27.8-78.5 64.6-3.1-.4-6.3-.6-9.5-.6-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1zM64 431.9c0 44.2 35.8 80 80 80h271.9c53 0 96-43 96-96 0-47.6-34.6-87-80-94.6V320c0-53-43-96-96-96-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2-37.5 6.7-65.9 39.4-65.9 78.7" })
  }
), ei1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9-16.1-30.3-48.1-51-84.9-51-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14.1-84.7-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0m450.6 75c-18.9-35.1-56-59-98.7-59-12.9 0-25.3 2.2-36.8 6.2-23.2-23.6-55.4-38.2-91.1-38.2-16.7 0-32.6 3.2-47.3 9-.4-2.9-.6-5.9-.6-8.9 0-35.3 28.6-64 64-64 7.4 0 14.6 1.3 21.2 3.6 11.5-30.1 40.6-51.6 74.8-51.6 38.9 0 71.3 27.8 78.5 64.6 3.1-.4 6.3-.6 9.5-.6 39.8 0 72 32.2 72 72 0 30.4-18.8 56.3-45.4 66.9zm45.3 148.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z" })
  }
), li1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 160c-74.1 0-135.2 56-143.1 128H96c-53 0-96-43-96-96s43-96 96-96h1.1C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96 0 12.1-2.2 23.6-6.3 34.2-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160m-80 352c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96z" })
  }
), ti1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4.1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4h-4.8C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7 0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1 1.2.2 2.5.8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3 16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9 33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2.2-1.2.8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3 0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3H382c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34v-4.8C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32" })
  }
), wi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V448h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-75.3c23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1" })
  }
), gi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M141.2 141.2c-43.7 43.7-73 91.8-85.8 133.3-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5c-41.5 12.7-89.6 42.1-133.3 85.8M260.4 9.5C309.6-5.7 361.5-4.8 395.2 28.8l40.9 40.9c48.6 48.7 75.9 114.6 75.9 183.2C512 396 396 512 253 512c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.7 309.6 9.5 260.3c15.6-50.4 49.7-105 97.8-153.1S210 25 260.4 9.5m63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9 5.4-95.9 67.9-158.4 133.4-92.9 158.4-67.9m95.4 107.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-56 136c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32m-136 56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32" })
  }
), ii1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48m80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3v6.7c0 70.7-57.3 128-128 128h-96c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80m232 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0M80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), mi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160m156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h131.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32z" })
  }
), ai1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1S320 334.5 320 344v40h16c35.3 0 64-28.7 64-64V153.3c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128h-16zM456 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0M192 24c0-9.5 5.6-18.1 14.2-21.9S225-.2 232 6.2l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1S192 177.5 192 168v-40h-16c-35.3 0-64 28.7-64 64v166.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16zM56 432a24 24 0 1 0 48 0 24 24 0 1 0-48 0" })
  }
), oi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48m80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-38.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96h-48v70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288h-48c-53 0-96-43-96-96v-38.7C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80m208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48M248 432a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), ni1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48m32.4 97.2c28-12.4 47.6-40.5 47.6-73.2 0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3v205.4C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48 44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8M80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48m264-136a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), ri1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7l25.4-25.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80l-25.3-25.4c-12.5-12.5-12.5-32.8 0-45.3zM136 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 0c0 32.8-19.7 61-48 73.3v205.4c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C51.7 141 32 112.8 32 80c0-44.2 35.8-80 80-80s80 35.8 80 80m-80 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48m288 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0 56c-44.2 0-80-35.8-80-80 0-32.8 19.7-61 48-73.3V224c0-17.7 14.3-32 32-32s32 14.3 32 32v134.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80" })
  }
), di1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0m56 73.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3v205.4C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3zM56 432a24 24 0 1 1 48 0 24 24 0 1 1-48 0m312-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160m48-432a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Si1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M305.8 2.1C314.4 5.9 320 14.5 320 24v40h16c70.7 0 128 57.3 128 128v166.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64h-16v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0m8 73.3v205.4c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3M104 432a24 24 0 1 0-48 0 24 24 0 1 0 48 0m328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), zi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256zm146.7 0L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3z" })
  }
), pi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3l89.3 89.4-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3" })
  }
), Mi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M331.4 203.3c24.4-24.6 45.4-67.3 59.9-101.7 5.1-12.2 20.9-15.3 28.2-4.3 51.2 77.7 26.2 201.2-63.4 290.8-79.6 79.6-186 108.1-263.2 77.7-14.8-5.8-20-23.2-13.2-37.5.7-1.6 1.5-3.1 2.2-4.7 16.5-34.5 37.5-72.2 57.4-92.3 29.7-29.9 59.7-44.9 91.8-61l.5-.3c32-15.9 66.1-32.9 99.7-66.8zM53.1 409.7c-5.3 11-19.9 13.6-26.9 3.6-54-77.4-29.6-203.2 61.2-294 80.2-80.2 187.7-108.6 265.1-76.9 14 5.7 19.4 22 13.7 36-1.4 3.5-2.9 7.1-4.4 10.8-14.5 34.5-33.5 71.8-53.1 91.5-29.7 29.9-59.7 44.9-91.8 61l-.5.3c-32 15.9-66.1 32.9-99.7 66.8-24.1 24.3-47.1 66.6-63.6 101z" })
  }
), xi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M507.5 209.7c-3.4 12.3-19.1 11.8-25.4.7-5.4-9.5-11.3-18.5-17.6-26-27.6-32.6-60.8-44.5-90.1-55l-1-.3c-30-10.7-55.8-20.2-77.5-45.9-10.8-12.8-21.3-33.4-29.3-52-1.7-4-.6-8.7 3-11.2C320.9-16 401.3-2.6 458 54c45.7 45.7 63.2 106.7 49.5 155.6zm-279-131.4c3.4-12.3 19.1-11.8 25.4-.7 5.3 9.5 11.3 18.5 17.6 26 27.6 32.6 60.8 44.5 90.1 55l1 .3c30 10.7 55.8 20.2 77.5 45.9 10.8 12.8 21.3 33.4 29.3 52 1.7 4 .6 8.7-3 11.2-51.3 36-131.7 22.6-188.4-34-45.7-45.7-63.2-106.7-49.5-155.6zM75.5 206c11.2-6.3 22 5.2 18.5 17.6-2.9 10.5-5.2 21.2-6 31-3.6 42.8 11.6 74.9 25 103.2l.4.9c13.7 28.9 25.3 54.1 22.5 87.8-1.4 16.7-8.6 38.9-16.1 57.9-1.6 4.1-5.8 6.6-10.1 5.8C47.7 499.3 0 432.6 0 352c0-65 31-120.9 75.5-146m105 292c-11.2 6.3-22-5.2-18.5-17.6 2.9-10.5 5.2-21.2 6-31 3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8 1.4-16.7 8.6-38.9 16.1-57.9 1.6-4.1 5.8-6.6 10.1-5.8C208.3 204.7 256 271.4 256 352c0 65-31 120.9-75.5 146" })
  }
), Hi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2 9.9 10.2 23.9 14.8 38.1 14.8h260c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1l44.9-112.1c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32zm65 192c5.2-41.4 30.1-76.6 65-96h188c34.9 19.4 59.8 54.6 65 96z" })
  }
), Vi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m102.4 10.9-91 104a46.668 46.668 0 0 0-9.6 43.4l95.5 330.6c4 13.7 16.5 23.1 30.7 23.1h127.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9 0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9M216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v120c0 13.3-10.7 24-24 24s-24-10.7-24-24V208h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-40c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Ci1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m11.5 114.9 91-104c6-6.9 14.8-10.9 24-10.9h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6 0 4.4-.6 8.7-1.8 12.9l-95.6 330.5c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z" })
  }
), Li1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144S397.4 64 256 64 0 128.5 0 208m0 82.1V320c0 27.9 17.8 53.6 48 74.6V331c-18.3-11.5-34.8-25.2-48-40.9M80 413c27.1 12.8 59.8 22.7 96 28.7v-64.3c-35.1-6-67.6-15.9-96-29zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2v-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4v64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7v-64.7c-28.4 13.2-60.9 23-96 29v64.3zm128-47c30.2-21 48-46.8 48-74.6v-29.9c-13.2 15.6-29.7 29.3-48 40.9v63.7z" })
  }
), Bi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320m0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384m24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), ui1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256 64.5 0 144 0s144 114.6 144 256M184.2 425.4c11.4-12 20.1-27.7 26.8-44.4 13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64S99.3 74.5 87.8 86.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6M136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160 64 71.6 64 160-28.7 160-64 160m90.1 96c15.6-13.2 29.3-29.7 40.9-48h63.7c-21 30.2-46.8 48-74.6 48zM349 432h-64.7c13.2-28.4 23-60.9 29-96h64.3c-6 36.2-15.9 68.9-28.7 96zm32.8-128h-64.2c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48h64.1c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128h-64.4c-6-35.1-15.9-67.6-29-96H349c12.8 27.1 22.7 59.8 28.7 96m-47-128H267c-11.5-18.3-25.2-34.8-40.9-48H256c27.9 0 53.6 17.8 74.6 48z" })
  }
), Ri1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144-114.6 144-256 144M86.6 248.2c12 11.4 27.7 20.1 44.4 26.8 33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8 12.1-11.5 22.6-27.7 22.6-48.2s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2M96 200c0-35.3 71.6-64 160-64s160 28.7 160 64-71.6 64-160 64-160-28.7-160-64M0 290.1c13.2 15.6 29.7 29.3 48 40.9v63.7C17.8 373.6 0 347.9 0 320zM80 413v-64.7c28.4 13.2 60.9 23 96 29v64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8v-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4v64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1v-64.3c35.1-6 67.6-15.9 96-29v64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47V331c18.3-11.5 34.8-25.2 48-40.9V320c0 27.9-17.8 53.6-48 74.6z" })
  }
), $i1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 80c0 18-14.3 34.6-38.4 48-29.1 16.1-72.5 27.5-122.3 30.9-3.7-1.8-7.4-3.5-11.3-5-39.4-16.5-91.8-25.9-148-25.9-8.3 0-16.4.2-24.5.6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80s192 35.8 192 80m-351.3 81.1c10.2-.7 20.7-1.1 31.3-1.1 62.2 0 117.4 12.3 152.5 31.4 24.8 13.5 39.5 30.3 39.5 48.6 0 4-.7 7.9-2.1 11.7-4.6 13.2-17 25.3-35 35.5-.1.1-.3.1-.4.2-.3.2-.6.3-.9.5-35 19.4-90.8 32-153.6 32-59.6 0-112.9-11.3-148.2-29.1-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4 10.5-1.5 21.4-2.7 32.7-3.5M416 240c0-21.9-10.6-39.9-24.1-53.4 28.3-4.4 54.2-11.4 76.2-20.5 16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9-14.6 7.4-32.4 13.7-52.4 18.5.1-1.8.2-3.5.2-5.3zm-32 96c0 18-14.3 34.6-38.4 48-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9 6.1-3.4 11.8-7.2 17.2-11.2 1.5-1.1 2.9-2.3 4.3-3.4v9.1zm32 0v-57.9c19-4.2 36.5-9.5 52.1-16 16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9-16.3 16.3-45 29.7-81.3 38.4.1-1.7.2-3.5.2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9 16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448" })
  }
), ki1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2l-11.1 44.4C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2l-7.1 28.4c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7 14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2l-11.8 47.3c-9.3-2.7-18.8-4.6-28.6-5.9zm-91.8 103.5-45.9 183.5C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7m8.6 229.5 61.1-244.6c9.9.7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z" })
  }
), Pi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128m0 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), Fi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm128 64v320H64V96zm64 0h128v320H256zm320 0v320H448V96z" })
  }
), Ti1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M299.4 75.6 493.7.9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8l-74.7 194.3 29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512 90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2l58.5-30.7 58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z" })
  }
), Ai1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 350.4V349c0-33.7-27.3-61-61-61-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2c0 19.7 16.1 35.8 35.9 35.8 12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6" })
  }
), Di1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0s96 43 96 96v32h128V96c0-53 43-96 96-96s96 43 96 96-43 96-96 96h-32v128h32c53 0 96 43 96 96s-43 96-96 96-96-43-96-96v-32H192v32c0 53-43 96-96 96S0 469 0 416s43-96 96-96h32V192H96c-53 0-96-43-96-96m128 32V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32zm64 192h128V192H192zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32zm256 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32zm0-256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32z" })
  }
), yi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm24-296v118.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24s24 10.7 24 24z" })
  }
), bi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-56-288h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), fi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm24-120c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V328z" })
  }
), Ui1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM120 208h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24m224 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24m-224 80h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24m128 0h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Gi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm113-255L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), qi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-39-255-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), Wi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z" })
  }
), Ei1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Oi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Ii1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM144 205.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z" })
  }
), Ni1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1S401.1 320 392 320H120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6l20.6 24.6 77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z" })
  }
), Xi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM152 176h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24m0 96h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Ki1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-32-288c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), Qi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m188.3 103.3 44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z" })
  }
), Zi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m188.3 408.7 44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208 512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7" })
  }
), Ji1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-72-232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), ji1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm96-320v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z" })
  }
), Yi1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0M178.1 264.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), _i1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-24-120v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), hm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-86.2-298.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), cm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-96-304h48c17.7 0 32 14.3 32 32v87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24z" })
  }
), sm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-117.9-92.4C552.2 340.2 576 292.3 576 240c0-114.9-114.6-208-256-208-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240" })
  }
), vm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-64-304a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M150.5 270.1c9.9-8.8 25-8 33.9 1.9 17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-26.4 29.4-64.8 48-107.4 48s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z" })
  }
), em1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-53.1-271.2c6.5-2.2 13.7.1 17.9 5.6l35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2m173.1 38v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.2-.4-23.7-4.4-32.6-7.4-1.4-.5-2.7-.9-4-1.4-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7.6 3.3 1.1 4.9 1.6 9.1 3.1 15.6 5.3 22.6 5.5 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.4-17.7-14.7-17.7-29.4-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 10 .2 19.7 2.3 27.9 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9zm-272 0v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.3-.4-24.2-4.5-33.2-7.6-1.3-.4-2.5-.8-3.6-1.2-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4.5 2.8.9 4.1 1.4 9.5 3.2 16.5 5.6 23.7 5.8 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.3-17.7-14.6-17.8-29.3-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 9.5.1 22.2 2.1 31.1 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9z" })
  }
), lm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-72-288h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V208h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), tm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-81-289c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), wm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 240c0 114.9-114.6 208-256 208-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.8 3.4-17.4l.3-.3c.3-.3.7-.7 1.3-1.4 1.1-1.2 2.8-3.1 4.9-5.7 4.1-5 9.6-12.4 15.2-21.6 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208" })
  }
), gm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 176c0 97.2-93.1 176-208 176-38.2 0-73.9-8.7-104.7-23.9-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1S1 327.1 6.6 323l.2-.2c.2-.2.6-.4 1.1-.8 1-.8 2.5-2 4.3-3.7 3.6-3.3 8.5-8.1 13.3-14.3 5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4 3.5 9.4 8.7 17.7 14.2 24.7 4.8 6.2 9.7 11 13.3 14.3 1.8 1.6 3.3 2.9 4.3 3.7.5.4.9.7 1.1.8l.2.2c5.6 4.1 7.9 11.3 5.8 17.9-2.1 6.6-8.3 11.1-15.2 11.1-21.8 0-43.8-5.6-62.1-12.5-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129M228 72c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z" })
  }
), im1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4-3.5 9.4-8.7 17.7-14.2 24.7-4.8 6.2-9.7 11-13.3 14.3-1.8 1.6-3.3 2.9-4.3 3.7-.5.4-.9.7-1.1.8l-.2.2C1 327.2-1.4 334.4.8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5 9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352m240-176c0 112.3-99.1 196.9-216.5 207 24.3 74.4 104.9 129 200.5 129 38.2 0 73.9-8.7 104.7-23.9 7.5 4 16 7.9 25.2 11.4 18.3 6.9 40.3 12.5 62.1 12.5 6.9 0 13.1-4.5 15.2-11.1 2.1-6.6-.2-13.8-5.8-17.9l-.2-.2c-.2-.2-.6-.4-1.1-.8-1-.8-2.5-2-4.3-3.7-3.6-3.3-8.5-8.1-13.3-14.3-5.5-7-10.7-15.4-14.2-24.7 24.9-29 39.6-64.7 39.6-103.4 0-92.8-84.9-168.9-192.6-175.5.4 5.1.6 10.3.6 15.5zM180.2 77.3h48.5c29.1 0 52.6 23.6 52.6 52.6 0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6-11 0-20-9-20-20v-11.1c0-7.2 3.8-13.8 10-17.3l37-21.3c3.9-2.3 6.3-6.4 6.3-10.9 0-7-5.7-12.6-12.6-12.6h-48.5c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1c6.6-18.6 24.2-31.1 44-31.1zm27.8 160a26.7 26.7 0 1 1 0 53.3 26.7 26.7 0 1 1 0-53.3m358.1 88.8-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l25.9 25.9 65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z" })
  }
), mm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 176c0 97.2-93.1 176-208 176-38.2 0-73.9-8.7-104.7-23.9-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1S1 327.1 6.6 323l.2-.2c.2-.2.6-.4 1.1-.8 1-.8 2.5-2 4.3-3.7 3.6-3.3 8.5-8.1 13.3-14.3 5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4 3.5 9.4 8.7 17.7 14.2 24.7 4.8 6.2 9.7 11 13.3 14.3 1.8 1.6 3.3 2.9 4.3 3.7.5.4.9.7 1.1.8l.2.2c5.6 4.1 7.9 11.3 5.8 17.9-2.1 6.6-8.3 11.1-15.2 11.1-21.8 0-43.8-5.6-62.1-12.5-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129m-95.3-274.6-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6 0 4.5-2.4 8.7-6.3 10.9l-37 21.3c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20 10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6 0-29.1-23.6-52.6-52.6-52.6h-48.5c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0-53.3 0 26.7 26.7 0 1 0 53.3 0" })
  }
), am1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4-3.5 9.4-8.7 17.7-14.2 24.7-4.8 6.2-9.7 11-13.3 14.3-1.8 1.6-3.3 2.9-4.3 3.7-.5.4-.9.7-1.1.8l-.2.2C1 327.2-1.4 334.4.8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5 9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352m240-176c0 112.3-99.1 196.9-216.5 207 24.3 74.4 104.9 129 200.5 129 38.2 0 73.9-8.7 104.7-23.9 7.5 4 16 7.9 25.2 11.4 18.3 6.9 40.3 12.5 62.1 12.5 6.9 0 13.1-4.5 15.2-11.1 2.1-6.6-.2-13.8-5.8-17.9l-.2-.2c-.2-.2-.6-.4-1.1-.8-1-.8-2.5-2-4.3-3.7-3.6-3.3-8.5-8.1-13.3-14.3-5.5-7-10.7-15.4-14.2-24.7 24.9-29 39.6-64.7 39.6-103.4 0-92.8-84.9-168.9-192.6-175.5.4 5.1.6 10.3.6 15.5z" })
  }
), om1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-96-32a96 96 0 1 0 192 0 96 96 0 1 0-192 0m-64-16c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16" })
  }
), nm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 96c0 14.3-3.1 27.9-8.8 40.2l52.8 91.2c-23.7 25.3-54.2 44.1-88.5 53.6L256 192l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5 70.7 0 133.8-32.7 174.9-84 11.1-13.8 31.2-16 45-5s16 31.2 5 45c-52.9 65.8-134 108-225 108-35.4 0-69.4-6.4-100.7-18.1l-56.6 97.8c-4.7 8.1-11.7 14.7-20.1 18.9l-55.4 27.7c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496v-55.4c0-8.4 2.2-16.7 6.5-24.1l60-103.7c-12.8-11.2-24.7-23.5-35.3-36.8-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9C163.2 124 160 110.4 160 96c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6.7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), rm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256 576 114.6 461.4 0 320 0c-73.2 0-139.1 30.7-185.8 79.9L38.8 5.1zm231.5 181.4 143.3-55.1c19.4-7.5 38.5 11.6 31 31l-47.5 123.5zM320 512c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256" })
  }
), dm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m50.7-186.9-144.3 55.5c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31l-55.5 144.3c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Sm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96c0-17.7-14.3-32-32-32S96 78.3 96 96v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32zM32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zM416 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64zm-32 192c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), zm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64zm-32 256c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), pm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48v320c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm32 432v-32h384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32M96 64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48m144-24c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16" })
  }
), Mm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0C71.6 0 0 71.6 0 160v192c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V160C384 71.6 312.4 0 224 0zm64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), xm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192h176V0h-16C71.6 0 0 71.6 0 160zm0 32v128c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192zm384-32v-32C384 71.6 312.4 0 224 0h-16v192z" })
  }
), Hm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 432v-16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h176c-10-13.4-16-30-16-48M64 32C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h224v-64H64V96h224V80c0-18 6-34.6 16-48zm304 0c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm176 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0m64-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Vm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 96v224H64V96zM64 32C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h117.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-74.7l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm464 0c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16m32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Cm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v320c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32zm144 120v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24m112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24m112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24m112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Lm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.9 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32h-52.9l-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9-1.4 10.2-7.4 18.7-15.7 23.5V208c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.9l-192.8-25.6c-8.4 7.2-19.3 11.6-31.2 11.6-26.5 0-48-21.5-48-48 0-17.1 8.9-32 22.3-40.6l3.9-23.5H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h79zm-.9 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0m176 152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h32c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96s43-96 96-96v-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64v-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Bm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 78.3 0 96 0h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm320 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32zM0 416c0-53 43-96 96-96h448c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96m160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), um1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Rm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0h80v112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48M0 416c0-53 43-96 96-96h448c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96m160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), $m1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6-22.1-3.1-44.6.9-64.4 11.4l-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9-.9-5.3-5.3-9.3-10.6-10.1-51.5-8.2-92.8-47.1-104.5-97.4-1.8-7.6-8-13.4-15.7-14.6-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), km1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.2 17c-22.1-3.1-44.6.9-64.4 11.4l-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9l-60.2-58.3c-16.1-15.6-36.6-25.6-58.7-28.7zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Pm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48M48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48" })
  }
), Fm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-56.6-199.4c31.2 31.2 81.9 31.2 113.1 0 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z" })
  }
), Tm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 40c0 15-8.3 28.1-20.5 34.9 7.7 7.3 12.5 17.7 12.5 29.1 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 22.1-17.9 40-40 40-1.1 0-2.3 0-3.4-.1 2.2 4.9 3.4 10.4 3.4 16.1 0 13.6-6.8 25.7-17.3 32.9-47.7-29.7-103.6-41.1-157.5-34.2 6.9-53.9-4.5-109.8-34.2-157.5 7.3-10.4 19.4-17.2 33-17.2 5.7 0 11.2 1.2 16.1 3.4-.1-1.1-.1-2.2-.1-3.4 0-22.1 17.9-40 40-40 6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40M137.7 98c1.2-6.3 8.9-8.7 13.2-3.9 45.4 50.5 69.5 114 56.9 183.4-38.7 10.7-75.2 31.2-105.5 61.6l-77.4 77.4c-34.2-37.7-33.1-96 3.2-132.4l64-64c18.3-18.3 30.6-41.7 35.3-67.1zM92.1 483.9l-44.7-44.7 77.5-77.5c28.6-28.6 63.5-47.1 100.1-55.6 72.2-16.6 139.8 7.4 192.8 55 4.8 4.3 2.4 12.1-3.9 13.2L359 384.5c-25.4 4.7-48.8 17-67.1 35.3l-64 64c-37.5 37.5-98.3 37.5-135.8 0z" })
  }
), Am1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192c0-17.7 14.3-32 32-32h352c35.3 0 64 28.7 64 64v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32" })
  }
), Dm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 160c0-70.7 57.3-128 128-128h256c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128v-48c0-38.7-27.5-71-64-78.4zm480 112c0-20.9 13.4-38.7 32-45.3 5-1.8 10.4-2.7 16-2.7 26.5 0 48 21.5 48 48v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48 5.6 0 11 1 16 2.7 18.6 6.6 32 24.4 32 45.3v80h448v-32z" })
  }
), ym1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 224v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-88.2c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-16.9c5.3.6 10.6.9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-24.2c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21 22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4 31.8 0 57.6-25.8 57.6-57.6V184c0-24.3 12.1-45.8 30.5-58.9-4.2 10.8-6.5 22.6-6.5 34.9zm464 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0M166.6 166.6c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6h178.8c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L354 190c-21.8 21.8-51.3 34-82 34s-60.2-12.2-81.9-33.9l-23.4-23.4z" })
  }
), bm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 96h16V40c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v56h16c21.4 0 40.3 14.2 46.2 34.8l18.3 64C318.3 209.7 256 281.6 256 368c0 16.6 2.3 32.7 6.6 48H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96m173.5 369.6c-7.6 26.8-32.3 46.4-61.5 46.4-35.3 0-64-28.7-64-64h115.2c3.1 6.1 6.6 12 10.3 17.6M272 96V48h-96v48zm160 128a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z" })
  }
), fm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 96h16V40c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v56h16c21.4 0 40.3 14.2 46.2 34.8l64 224c4.1 14.5 1.2 30.1-7.8 42.1S415.1 416 400.1 416H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96m160 0V48h-96v48zm16 352c0 35.3-28.7 64-64 64s-64-28.7-64-64z" })
  }
), Um1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C60 0 4.4 53 .2 120v.5L0 128h8-8v33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253c-3.7 6-6.9 12.4-9.6 19H51.8l-28.6-14.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7H81c-.7 5.2-1 10.6-1 16v9.8l-21.1 7c-2.4.8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3 30.7 30.7-40.4 13.4c-2.4.8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.4-29.3 52-17.3 15.7 15.7-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-22.9l41.9-25.1h108.4l41.8 25.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-5.6-3-10.8-7.8-13.7l-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7V320c0-5.4-.3-10.8-1-16h33c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272h-37.5c-2.7-6.6-5.9-13-9.6-19l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4V128h-8 8l-.2-7.5v-.4C507.6 53 452 0 384 0h-44.7c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7H328c-4.4 0-8.1 3.6-7.5 8 3.9 31.6 30.9 56 63.5 56h80v33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-16.9-12.2-37-20.3-58.7-23v-49c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v49c-21.7 2.7-41.7 10.9-58.7 23l-71.4-32.9c-8.5-3.9-13.9-12.5-13.9-21.8V128h80c32.6 0 59.6-24.4 63.5-56 .5-4.4-3.1-8-7.5-8h-36.7c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7H128z" })
  }
), Gm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1 0 30.3-24.6 54.9-54.9 54.9-5 0-9.1-4.1-9.1-9.1M32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11 10.7 4.2 22.8 4.2 33.5 0 13.1-5.1 31.6-11 47.2-11 43.6 0 64 47.8 64 91.4 0 7-.4 13.9-1.2 20.6H33.2c-.8-6.7-1.2-13.5-1.2-20.6zM319 192c.7-6.7 1-13.6 1-20.6 0-26.1-6-55.1-20.3-78.6-2.7-4.4-5.7-8.7-9-12.7 15 .6 32.2 6.1 44.6 11 10.7 4.2 22.8 4.2 33.5 0 13.1-5.1 31.6-11 47.2-11 43.6 0 64 47.8 64 91.4 0 7-.4 13.9-1.2 20.6H319zM406.9 0c5 0 9.1 4.1 9.1 9.1 0 30.3-24.6 54.9-54.9 54.9-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0M0 272c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v80H0zm0 112h512v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm80-96a16 16 0 1 0-32 0 16 16 0 1 0 32 0M64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32m400-176a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), qm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 224c-26.5 0-48 21.5-48 48v80h512v-80c0-26.5-21.5-48-48-48zm464 160H0v80c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32M48 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0m400-176a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-16 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), Wm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm32 336c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16m128 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16" })
  }
), Em1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m128 0c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16M408 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24z" })
  }
), Om1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v32h576V96c0-35.3-28.7-64-64-64zm512 192H0v192c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16m112 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16" })
  }
), Im1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-135 135L409 231c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-23 23H240c-8.8 0-16-7.2-16-16V126.1l23-23c9.4-9.4 24.6-9.4 33.9 0l41.4 41.4 135-135C469.8-3 490.1-3 502.6 9.5zM352 432a80 80 0 1 1 160 0 80 80 0 1 1-160 0M16.1 334 192 158.1V272c0 26.5 21.5 48 48 48h113.9L178 495.9c-10 10-24.4 16.7-40.4 15.6-11.3-.8-28.6-2.8-46.4-8.2-17.3-5.1-37.1-14.2-52.2-30.3-16.2-15-25.2-34.9-30.4-52.2C3.2 403 1.2 385.7.5 374.4c-1.1-16 5.6-30.4 15.6-40.4z" })
  }
), Nm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2.5-28.6 1.4M233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7 11 19.1 36.4 22.2 53.9 8.6zM232.7 19c2 3 3.6 6.4 4.8 10-1.2-3.6-2.8-6.9-4.8-10m232.9 92.8L390 209l87.6 14.6c1.6.3 3.2.4 4.9.4 16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2-10.1-25.2-24.1-48.5-41.3-69-.9 1.4-1.9 2.7-2.9 4zM209 390l-97.1 75.6c-1.3 1-2.6 2-4 2.9 20.5 17.2 43.8 31.2 69 41.3 3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6 0-1.6-.1-3.3-.4-4.9zM19 232.7c2.3 1.5 4.7 2.8 7.3 3.8 1.2.5 2.5 1 3.8 1.3l199.7 59.9c11.3 3.4 23.5.3 31.8-8l28.1-28.1c8.3-8.3 11.4-20.5 8-31.8L237.8 30.1C232.5 12.2 216 0 197.4 0c-4.6 0-9.2.7-13.5 2.3C99.7 33 33 99.7 2.3 183.9.7 188.2 0 192.8 0 197.4c0 14.5 7.4 27.6 19 35.3" })
  }
), Xm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32v32H32C14.3 64 0 78.3 0 96s14.3 32 32 32h32v256c0 35.3 28.7 64 64 64h224v-64H128zm256 448c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V128c0-35.3-28.7-64-64-64H160v64h224z" })
  }
), Km1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 109.3 54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64H160v64h178.7L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32v32H32C14.3 64 0 78.3 0 96s14.3 32 32 32h32v256c0 35.3 28.7 64 64 64h224v-64H173.3L384 173.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V109.3z" })
  }
), Qm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80v208c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48h-80V48c0-26.5-21.5-48-48-48z" })
  }
), Zm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M445.3 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h61.3c-13.4 80.4-76.9 143.9-157.3 157.3V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v61.3C143.6 431.9 80.1 368.4 66.7 288H128c17.7 0 32-14.3 32-32s-14.3-32-32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V128c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7c80.4 13.4 143.9 76.9 157.3 157.3M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0" })
  }
), Jm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v10.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-10.4c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-10.4C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32M107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6c-12.5-58.3-58.3-104.1-116.6-116.6V128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-20.6c-58.3 12.5-104.1 58.3-116.6 116.6H128c17.7 0 32 14.3 32 32s-14.3 32-32 32zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), jm1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9l74.6-57.4h133.1l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384h44.1l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192v-72l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32h-50.1C507.7 12.5 483.3 0 456 0m0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Ym1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M309 106c11.4-7 19-19.7 19-34 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-57.3 114.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24 0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40h.7l45.7 251.4c5.5 30.4 32 52.6 63 52.6h277.2c30.9 0 57.4-22.1 63-52.6L535.3 176h.7c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7z" })
  }
), _m1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1l-24 107.6c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7.1-.1.1-.1 74.6-74.6-45.3-45.3-52.1 51.9-66.7-66.7 52.1-52.1-45.3-45.3-74.7 74.7zm22.6 67.9 66.7 66.7-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7z" })
  }
), ha1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m470.6 9.4 160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zm-176 178.8L404.1 78.6l45.3 45.3-52.1 52.1 66.7 66.7 52.1-52.1 45.3 45.3-74.6 74.6-.1.1-.1.1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8l-107.7 24c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1zm45.3 45.3c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6l12-12.3-66.7-66.7-12.2 12.2zM169.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-1.4 1.3 84.1 84.1-25.4 25.4c-6.7 6.7-12.6 14.1-17.6 22L168 101.3 101.3 168l122.4 122.4-10.1 45.5-17 17c-2.9-2.3-5.7-4.8-8.4-7.5L56 213.3l-1.4 1.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160zm242.3 393.1c9.3-2.1 18.3-5.2 26.9-9.2l64.1 64.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-90.2-90.2 44.5-9.9z" })
  }
), ca1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 256c0-88.4 71.6-160 160-160 41 0 78.3 15.4 106.7 40.7 13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57 13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V311.3c0-12.8 10.4-23.3 23.3-23.3 4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7-12.4 0-24.2 2.6-34.9 7.3-5.5-4.5-12.6-7.3-20.3-7.3-17.7 0-32 14.3-32 32v146.8C135.5 378 96 321.6 96 256" })
  }
), sa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 224c0 62.7-25.7 119.3-67.2 160H67.2C25.7 343.3 0 286.7 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224M152.5 84.3l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4c-2.6-7-12.4-7-15 0m159 48c-2.6-7-12.4-7-15 0l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4zm98.9 331.8c3.7 5.1 5.6 11.3 5.6 17.6 0 16.7-13.6 30.3-30.3 30.3H62.3C45.6 512 32 498.4 32 481.7c0-6.3 2-12.5 5.6-17.6L72 416h304z" })
  }
), va1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6c25.4 9.1 42.4 33.2 42.4 60.3v242.8c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66 82.3 128 256 190l173.7-62zm32 368.6 160-57.1v-188l-160 57.1z" })
  }
), ea1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32M82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32zm-192 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32M32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32z" })
  }
), la1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m290.8 48.6 78.4 29.7-81.2 31.2-81.2-31.2 78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5v112.2c-1.3.4-2.6.8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7v119.2c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4L308 3.7c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5m256 118.1-82.4 31.2v-89.2L392 121zm-237.2 40.3 78.4 29.7-81.2 31.1-81.2-31.1 78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8l82.4-31.6v95.9zm247.6-204.4c1.8-.7 3.8-.7 5.7 0l78.4 29.7-81.3 31.1-81.2-31.1 78.4-29.7zm102 170.3-77.6 34.1V354.8l82.4-31.6v90.7c0 3.2-1.9 6-4.8 7.3" })
  }
), ta1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3 12.6 10.3 31.1 9.6 42.9-2.2 11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4 11.7-11.7 12.5-30.3 2.2-42.9 43.6-50.3 41.5-126.5-6.3-174.3-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6l-89.5 89.5c-50 50-50 131 0 181M400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-96 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-184 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), wa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m194.8 43.2-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0h-30.7c-26 0-48.6 17.9-54.5 43.2M40 224l20.3 244c2.1 24.9 22.9 44 47.8 44h167.7c25 0 45.8-19.1 47.8-44L344 224zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6l-4.1 48.9c-20.8 3.1-35.2 8.2-45.8 13.9-17.2 9.3-26.9 21.2-39.9 37.2l-.7.8c-13.3 16.4-29.5 35.9-58.7 50.4-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1 19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z" })
  }
), ga1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24h-30.7c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h142.9l20-84.8C200.8 17.9 223.4 0 249.3 0m-189 468L40 224h304l-20.3 244c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44z" })
  }
), ia1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M55.2 17.7C60.6 6.8 71.7 0 83.8 0h280.4c12.1 0 23.2 6.8 28.6 17.7L416 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32l23.2-46.3zm19.5 436.1L48 160h352l-26.7 293.8c-3 33-30.6 58.2-63.7 58.2H138.4c-33.1 0-60.7-25.2-63.7-58.2m249.1-162.9c1.7-18.7-13.1-34.9-31.9-34.9H156c-18.8 0-33.6 16.2-31.9 34.9l8.7 96c1.5 16.5 15.3 29.1 31.9 29.1h118.5c16.6 0 30.4-12.6 31.9-29.1l8.7-96z" })
  }
), ma1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64H160c-35.3 0-64 28.7-64 64v.8c-3.3.5-6.6 1.4-9.9 2.4L50.9 143C20.5 153.2 0 181.6 0 213.6 0 254.7 33.3 288 74.4 288h299.2c41.1 0 74.4-33.3 74.4-74.4 0-32-20.5-60.4-50.9-70.6l-35.3-11.8c-4.1-1.4-8.2-2.3-12.5-2.8 1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0zm27.9 512 24-192H156.1l24 192zM64 320l25.3 151.9c3.9 23.1 23.9 40.1 47.4 40.1h11.2l-24-192zm236.1 192h11.2c23.5 0 43.5-17 47.3-40.1L384 320h-59.9z" })
  }
), aa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 128c0-17.7 14.3-32 32-32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-53 0-96 43-96 96v32c-35.3 0-64 28.7-64 64-53 0-96 43-96 96v16h576v-16c0-53-43-96-96-96 0-35.3-28.7-64-64-64H224zm352 240H0v16c0 53 43 96 96 96h384c53 0 96-43 96-96z" })
  }
), oa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M396.7 64c30 0 56 20.8 62.5 50.1l13.5 60.8c-21.8-7.5-49.2-14.9-72.7-14.9-26.4 0-45.8 9.4-62.2 17.2l-.7.3c-16.7 8-30.4 14.4-49.1 14.4s-32.3-6.4-49.1-14.4l-.7-.3c-16.4-7.8-35.8-17.2-62.2-17.2-23.5 0-50.9 7.4-72.6 14.9l13.5-60.8c6.5-29.3 32.4-50.1 62.4-50.1zM64.3 350.9l30.8-138.8c4.1-1.6 8.5-3.3 13.2-5 22-7.9 47.8-15.1 67.7-15.1 18.7 0 32.3 6.4 49.1 14.4l.7.3c16.4 7.9 35.8 17.2 62.2 17.2s45.8-9.4 62.2-17.2l.7-.3c16.7-8 30.4-14.4 49.1-14.4 19.8 0 45.6 7.2 67.7 15.1 4.7 1.7 9.2 3.4 13.2 5L512 352l-447.7-1.1M32 384h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), na1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h96c123.7 0 224 100.3 224 224S283.7 480 160 480H64c-35.3 0-64-28.7-64-64zm160 0H64v320h96c88.4 0 160-71.6 160-160S248.4 96 160 96" })
  }
), ra1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H48c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32h197.4c6.6 18.6 24.4 32 45.3 32 26.5 0 48-21.5 48-48s-21.5-48-48-48H224zm-96 192v190.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7V224H152z" })
  }
), da1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32" })
  }
), Sa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0s224 35.8 224 80m-54.8 134.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3M0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432z" })
  }
), za1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 30.9 25.1 56 56 56h40l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4 0 9.9 8 18 18 18h38l-9.6 32H106c-54.3 0-99.4 41.8-103.6 96L.1 302.2C-.9 315.4 9 327 22.2 328c13 1 24.4-8.6 25.7-21.5 2.4 3.3 5.2 6.5 8.1 9.5 9 9 9 23.5 2.4 34.4-17.4 28.6-21.5 63.9-10 96.3l15.5 44c4.5 12.7 16.6 21.3 30.2 21.3H128c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8 21 16.5 47.5 26.4 76.3 26.4H288v112c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V304l26.7-80h56c25 0 45.3-20.3 45.3-45.3 0-1.2 0-2.4-.1-3.6 2.6.5 5.4.8 8.1.8 22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7l-37.3-37.2c-.6-.6-1.1-1.1-1.7-1.6 18-9.4 30.3-28.1 30.3-49.8V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-69.4c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm128 128a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), pa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0c8.8 0 16 7.2 16 16v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 8.6-1.9 16.7-5.4 24H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 21.7-12.3 40.4-30.3 49.8.6.5 1.1 1.1 1.7 1.6l55.3 55.3c8.5 8.5 13.3 20 13.3 32 0 25-20.3 45.3-45.3 45.3h-56L384 304v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V368h-36.3c-28.8 0-55.3-9.8-76.3-26.4-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6H94.1c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3 6.6-10.9 6.6-25.4-2.4-34.4-3-3-5.7-6.1-8.1-9.5-1.3 12.9-12.7 22.5-25.7 21.5-13.3-1-23.1-12.5-22.1-25.7L2.4 272c4.2-54.2 49.3-96 103.7-96h196.3l9.6-32h-38c-9.9 0-18-8-18-18 0-8.2 5.6-15.4 13.6-17.4L320 96h-40c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16m160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Ma1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64zm-305 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), xa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h306.7c17 0 33.3 6.7 45.3 18.7l150.6 150.7c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), Ha1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8.7 5.2 2.1L128 45.7l45.8-43.6C175.2.7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7 2.4 6.5 6.2 18.4 6.2 27.3 0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H512c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3l75.9-94.8C78.1 67.4 64 53.2 64 32m384 320h96v128c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64H288v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V352h96zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zm107.2-2.9c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z" })
  }
), Va1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352v64h160v224H64V64h160V0zm248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v150.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z" })
  }
), Ca1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm448 64v224H64V64z" })
  }
), La1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m337.8 205.7 48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7.8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8.7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8.7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7.8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1.1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1.1zm-314.7-99.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4a159.52 159.52 0 0 1-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4m119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3m-65-156.9-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ba1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64zm-64 256v-64H64v64zm0 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64" })
  }
), ua1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96v208h64V96zm-48 0h-64v80h64zm-112 0h-64v208h64zm-112 0h-64v80h64zm-112 0H64v208h64zM64 352v64h232v-64zm280 64h232v-64H344zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm240 208v-80h-64v80zm224-80h-64v80h64z" })
  }
), Ra1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16v96c0 17.7 14.3 32 32 32h96v-16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-16h-96c-53 0-96-43-96-96v-96H48c-26.5 0-48-21.5-48-48z" })
  }
), $a1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41h46v-64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64zm-64 256v-64h-82.7l.4-.4c18.4-18.4 20.4-43.7 11-63.6H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h71.3c-9.4 19.9-7.4 45.2 11 63.6l.4.4H64v64h146.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7z" })
  }
), ka1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 416v-64H64v64zm0 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64M288 160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h304c44.2 0 80 35.8 80 80v16h38.1c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41h38.1v-16c0-8.8-7.2-16-16-16h-80v64z" })
  }
), Pa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 352H64v64h384zm0-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h168v-64h-46.1c-21.4 0-32.1-25.9-17-41l70.1-70c9.4-9.4 24.6-9.4 33.9 0l70.1 70c15.1 15.1 4.4 41-17 41h-46v64zm-82.3-127.6-70.1-70.1c-21.9-21.9-57.3-21.9-79.2 0l-70.1 70.1c-18.4 18.4-20.4 43.7-11 63.6H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-71.3c9.4-19.9 7.4-45.2-11-63.6" })
  }
), Fa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v16h192V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-16H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96c0-1.7.1-3.4.3-5L144 224H48c-26.5 0-48-21.5-48-48z" })
  }
), Ta1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H336l-86.4 115.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h176zM141.9 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H216.5l57.6 96H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-11.2 0-21.7-5.9-27.4-15.5z" })
  }
), Aa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160v96c0 17.7 14.3 32 32 32h32c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64h-32c-53 0-96-43-96-96v-96H64c-35.3 0-64-28.7-64-64zm448 256H288v64h160z" })
  }
), Da1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416v-64c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64M64 160V96h160v64zm224 0V96h80c8.8 0 16 7.2 16 16v16h-38.1c-21.4 0-32.1 25.9-17 41l70.1 70c9.4 9.4 24.6 9.4 33.9 0l70.1-70c15.1-15.1 4.4-41-17-41h-38v-16c0-44.2-35.8-80-80-80H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64" })
  }
), ya1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 412.8c-39.6-40.4-64-95.8-64-156.8s24.4-116.4 64-156.8c-10.3-2.1-21-3.2-32-3.2-88.4 0-160 71.6-160 160s71.6 160 160 160c11 0 21.7-1.1 32-3.2m64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224S539.7 480 416 480c-34.4 0-66.9-7.7-96-21.6zM370.7 192H269.3c-6.5 14.9-10.8 31.1-12.5 48h126.4c-1.7-16.9-6-33.1-12.5-48M269.3 320h101.4c6.5-14.9 10.8-31.1 12.5-48H256.8c1.7 16.9 6 33.1 12.5 48m18.7 32c9.1 12.1 19.9 22.9 32 32 12.1-9.1 22.9-19.9 32-32zm64-192c-9.1-12.1-19.9-22.9-32-32-12.1 9.1-22.9 19.9-32 32z" })
  }
), ba1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m.4 127.6c80.2 0 146.6 59 158.2 136H288.4c-13.3 0-24 10.7-24 24s10.7 24 24 24h158.2c-11.6 77-78 136-158.2 136-88.4 0-160-71.6-160-160s71.6-160 160-160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-.4 447.6c-80.2 0-146.6-59-158.2-136h158.2c13.3 0 24-10.7 24-24s-10.7-24-24-24H129.4c11.6-77 78-136 158.2-136 88.4 0 160 71.6 160 160s-71.6 160-160 160M512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ua1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m113.4 174.7c56.7 56.7 61.9 145.4 15.7 208L305.2 270.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l111.9 111.9c-62.6 46.2-151.3 41-208-15.7-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ga1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M174.6 400.5c-56.7-56.7-62-145.4-15.7-208l111.9 111.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L192.8 158.5c62.6-46.2 151.3-41 208 15.7 62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), qa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M128 287.2c0-80.2 59-146.6 136-158.2v158.2c0 13.3 10.7 24 24 24s24-10.7 24-24V129c77 11.6 136 78 136 158.2 0 88.4-71.6 160-160 160s-160-71.6-160-160m384 .8a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Wa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m112.9 401c-56.7 56.7-145.4 62-208 15.7l111.8-111.8c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L158.9 382.8c-46.2-62.6-41-151.3 15.7-208 62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ea1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160 288c0 80.2-59 146.6-136 158.2V288c0-13.3-10.7-24-24-24s-24 10.7-24 24v158.2c-77-11.6-136-78-136-158.2 0-88.4 71.6-160 160-160s160 71.6 160 160m64 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Oa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M175.1 174.2c56.7-56.7 145.4-62 208-15.7L271.3 270.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l111.9-111.9c46.2 62.6 41 151.3-15.7 208-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0M32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ia1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Na1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 78.5 433.5 256 256 433.5zm28.3-66.8c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z" })
  }
), Xa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7z" })
  }
), Ka1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56h-64c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z" })
  }
), Qa1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z" })
  }
), Za1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.7 16.3C212.4 8.3 206.4 0 198 0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237c-1.6 1.9-2.4 4.3-2.4 6.8 0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6l67.2-201.4zM8.7 288.2c-5.1 1.2-8.7 5.7-8.7 10.9 0 3.1 1.3 6.1 3.6 8.2l217.1 201.6c2.1 2 4.9 3.1 7.8 3.1 6.3 0 11.5-5.1 11.5-11.5V328.8c0-5.3-2.6-10.2-6.9-13.2l-78.7-54.5c-3.7-2.5-8.2-3.4-12.6-2.5L8.7 288.2M272 500.5c0 6.3 5.1 11.5 11.5 11.5 2.9 0 5.7-1.1 7.8-3.1l217.1-201.6c2.3-2.1 3.6-5.1 3.6-8.2 0-5.2-3.6-9.8-8.7-10.9l-133.1-29.5c-4.4-1-8.9-.1-12.6 2.5l-78.7 54.5c-4.3 3-6.9 7.9-6.9 13.2zm226.8-246.1c6.8 1.5 13.2-3.7 13.2-10.6 0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0c-8.5 0-14.4 8.3-11.7 16.3l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1zM246.6 6.8l-71.8 215.5c-2.2 6.7.2 14.2 6.1 18.2l66.1 45.7c5.5 3.8 12.7 3.8 18.2 0l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2l-72-215.5C264 2.7 260.3 0 256 0s-8 2.7-9.4 6.8z" })
  }
), Ja1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5l-136.8 48.8c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5l72-41.6c3.6-2.1 7.8-3.2 12-3.2h124.4zM149.9 490.4l-75.7-43.8c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12v-84.3c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481c2.2 7-5.3 13-11.6 9.3zM512 233.9v84.2c0 4.2-1.1 8.4-3.2 12l-62.2 107.7c-2.1 3.6-5.1 6.7-8.8 8.8L362 490.3c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1c5-5 13.7-1.5 13.7 5.7zM15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1v85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7zM454.6 88l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3v-85.7c0-6.8 4.3-12.8 10.6-15.1l152.8-54.6c7.3-2.6 15.4.4 19.2 7.1zM295.5 512h-79c-7 0-13.2-4.5-15.3-11.2l-49.8-159.6c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1l-49.8 159.6c-2.1 6.7-8.3 11.2-15.3 11.2z" })
  }
), ja1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m48.7 125.8 53.2 31.9c7.8 4.7 17.8 2 22.2-5.9l77.5-139.7c3-5.4-.9-12.1-7.1-12.1-1.6 0-3.2.5-4.6 1.4l-142 97.4c-9.6 6.6-9.2 20.9.8 26.9zM16 171.7v123.6c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158c-10.6-6.4-24.2 1.3-24.2 13.7M310.4 12.1 388 151.7c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3.8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4zm-49.3 246-160.6 18.9c-8.1.9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5 0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8v-52.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4 0 6.5 4 12.3 10.1 14.5l172.7 64c.8.3 1.6.4 2.4.4zM41.7 382.9l170.9 20.2c7.8.9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8-78.4-120c-6.5-10-21.4-9.6-27.3.8l-85.4 149.6c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11 78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zm-90-193.1h163.2c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z" })
  }
), Ya1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M228.8.7C235.5 2.8 240 9 240 16v480c0 6.3-3.7 12-9.4 14.6s-12.5 1.6-17.2-2.6L5.4 324c-6.1-5.4-7.2-14.5-2.5-21.2l208-296c4-5.7 11.3-8.2 17.9-6.1zm54.4 0c6.7-2.1 13.9.3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V16c0-7 4.5-13.2 11.2-15.3z" })
  }
), _a1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14v216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8.3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8.3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14z" })
  }
), ho1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 16c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-3.7 3.9-5.3 9.3-4.1 14.6s4.9 9.5 9.9 11.5l208 80c4.9 1.9 10.5 1.2 14.8-1.7s6.9-7.9 6.9-13.2V16zM34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8V384c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9v112c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20zM282 1.2c-6 2.4-10 8.3-10 14.8v296c0 5.3 2.6 10.2 6.9 13.2s9.9 3.6 14.8 1.7l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2z" })
  }
), co1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64M96 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), so1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m224-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), vo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), eo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), lo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), to1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm352 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), wo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8l138.8 138.8c28.1 28.1 73.7 28.1 101.8 0l138.8-138.8c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0M96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48m128 176a24 24 0 1 1 0-48 24 24 0 1 1 0 48m128-176a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-128-80a24 24 0 1 1 0-48 24 24 0 1 1 0 48m96 328c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8zm160-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), go1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M446.2 0h1.8c106 0 192 86 192 192v30.6c0 88-51.5 165.6-128 201.5V480c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-22c-15.3 3.9-31.4 6-48 6-6.8 0-13.5-.4-20.1-1-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9 0 15.1-12.2 27.3-27.3 27.3h-140C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8 22.1 0 40-17.9 40-40v-24c0-35.3-28.7-64-64-64h-64.3c-26.3 0-47.7-21.4-47.7-47.7v-4.7c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0M464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), io1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m302 59.7 18 20.6 18-20.6C353.4 42.1 375.6 32 399 32h1c44.2 0 80 35.8 80 80 0 11.4-2.4 22.2-6.7 32H544v32-32h.8c.4 0 .8 0 1.4.1 1 .1 2.3.1 3.8.3 3 .3 7 .9 11.6 2.1 9.2 2.3 21.3 6.9 33.4 15.9 25.9 19.3 45 53.8 45 109.6 0 47.5-13.7 81.1-32 104.1-18 22.6-38.5 32.6-49 36.6-7.3 2.8-14 3.3-19 3.3h-.5c-4.7 0-9.3-.5-13.9-1.5L384 383v81c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5v-81l-141.6 31.5c-4.6 1-9.2 1.5-13.9 1.5h-.5c-4.9 0-11.7-.5-19-3.3-10.5-4-31-14-49-36.6-18.3-23-32-56.6-32-104.1 0-55.8 19.1-90.3 44.8-109.6 12.1-9.1 24.3-13.6 33.4-15.9 4.6-1.2 8.6-1.8 11.6-2.1 1.5-.2 2.8-.3 3.8-.3.5 0 1 0 1.4-.1H95.8v32-32h70.7c-4.3-9.8-6.7-20.6-6.7-32 0-44.2 35.8-80 80-80h1c23.4 0 45.6 10.1 61 27.7zM240 144h54.4c6.9 0 10.5-8.1 6-13.3l-34.5-39.4A33.11 33.11 0 0 0 241 80h-1c-17.7 0-32 14.3-32 32s14.3 32 32 32m105.6 0H400c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1c-1.2 0-2.3.1-3.5.2-8.2.9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3zM256 208H96.6c-.5.1-1.5.2-2.9.5-2.8.7-6.7 2.1-10.6 5.1C76.9 218.3 64 231.8 64 272c0 34.5 9.6 53.7 18.1 64.3 7.2 9 14.9 13.5 19.2 15.6L256 317.4zm128 109.4 154.8 34.4c4.3-2 12-6.6 19.2-15.6 8.4-10.6 18.1-29.8 18.1-64.3 0-40.2-12.9-53.7-19.2-58.4-3.9-2.9-7.7-4.4-10.6-5.1-1.4-.3-2.4-.5-2.9-.5H384zm-440.2 0" })
  }
), mo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm192 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192 0a160 160 0 1 0-320 0 160 160 0 1 0 320 0" })
  }
), ao1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M236.4 61.4 227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9.1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5 0 15.8-6.4 30.9-17.7 42l-13.1 12.8C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3l30.8 24.7c10.5 8.4 23.6 13 37 13 32.7 0 59.3-26.5 59.3-59.3v-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3 0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4M160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), oo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352v64h160v288H64V64h160V0zm248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z" })
  }
), no1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v147.2c-19.5-10-41.1-16.4-64-18.5V64H64v288h256.7c-.5 5.3-.7 10.6-.7 16 0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2-.2-1.3-.3-2.6-.3-3.9v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24M352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7zm60.7 83.4 17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.3 17.4c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.4-17.3c21.6 13.2 49.1 13.2 70.7 0z" })
  }
), ro1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v147.2c-19.5-10-41.1-16.4-64-18.5V64H64v288h256.7c-.5 5.3-.7 10.6-.7 16 0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2-.2-1.3-.3-2.6-.3-3.9v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24M352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z" })
  }
), do1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64zm64 0v288h448V64zm312 32h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), So1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64zm64 0v288h448V64zm185 113-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), zo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64zm64 0v288h448V64zm192 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), po1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4zM113.9 64H544v288h-62.6L113.9 64zM32 352c0 35.3 28.7 64 64 64h176l-10.7 32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32 0-2.1-.2-4.1-.6-6.1L446.6 448h-67.9L368 416h38l-81.2-64H96V171.8l-64-50.4z" })
  }
), Mo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm448 64v288H64V64z" })
  }
), xo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 24C32 10.7 42.7 0 56 0s24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24zm128 120c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48zM456 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24" })
  }
), Ho1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 56c0-13.3 10.7-24 24-24h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56m96 152c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM24 432h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Vo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v2.3c0 3.8.3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64S0 60.7 0 96m192 0v2.3c0 3.8.3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L319 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64s-64 28.7-64 64" })
  }
), Co1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0m0 320a48 48 0 1 0-96 0 48 48 0 1 0 96 0m128-128c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), Lo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 0c17.7 0 32 14.3 32 32 0 59.8-30.3 107.5-69.4 146.6-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l-1.6 1c-6 4-11.9 7.9-17.8 11.9-20.9 14-40.8 27.7-59.3 41.5h118.7c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6 25 18.1 48.9 37.3 69.4 57.7 39 39.2 69.3 86.9 69.3 146.7 0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32S0 497.7 0 480c0-59.8 30.3-107.5 69.4-146.6 28-28 62.5-53.5 97.3-77.4-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32 0 14.3 14.3 0 32 0s32 14.3 32 32h320c0-17.7 14.3-32 32-32m-77.4 384H109.4c-10.1 10.6-18.6 21.3-25.5 32h280.2c-6.8-10.7-15.3-21.4-25.5-32M109.4 128h229.2c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5 20.9-14 40.8-27.7 59.3-41.5H164.7z" })
  }
), Bo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96 208h320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), uo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m122.7 4.1 160 144c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-160-144c-6.6-5.9-7.1-16-1.2-22.6s16-7.1 22.6-1.2zM144 192h112v191.3c-5.3.5-10.6.7-16 .7-28.8 0-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30zm176 172.8c-10.1 5.2-20.8 9.4-32 12.6V208.1L416 262v218c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32zM426.7 192l-6.2 37.2-114.6-48.3 26.8-161C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80h-48zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Ro1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m309.6 158.5 23.1-138.7C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80h-69.3l-5.1 30.5-112-64zM416 256.1V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h205.8zM464 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), $o1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v35.7c1.6.2 3.1.4 4.7.7.4.1.7.1 1.1.2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4 1.8 3.9 5.5 8.3 12.8 13.2 16.3 10.7 41.3 17.7 73.7 26.3l2.9.8c28.6 7.6 63.6 16.8 89.6 33.8 14.2 9.3 27.6 21.9 35.9 39.5 8.5 17.9 10.3 37.9 6.4 59.2-6.9 38-33.1 63.4-65.6 76.7-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.9c-.4-.1-.9-.1-1.3-.2h-.2c-24.4-3.8-64.5-14.3-91.5-26.3-16.1-7.2-23.4-26.1-16.2-42.2S44.9 353 61 360.2c20.9 9.3 55.3 18.5 75.2 21.6 31.9 4.7 58.2 2 76-5.3 16.9-6.9 24.6-16.9 26.8-28.9 1.9-10.6.4-16.7-1.3-20.4-1.9-4-5.6-8.4-13-13.3-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7c-28.5-7.6-63.5-16.9-89.5-33.9-14.2-9.3-27.5-22-35.8-39.6-8.4-17.9-10.1-37.9-6.1-59.2 7.2-38.2 35.8-63 68.3-75.9 13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32" })
  }
), ko1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h72.9L197 340.2c-22.5 17.6-37 45-37 75.8 0 53 43 96 96 96 52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-202 67.4c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0z" })
  }
), Po1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1.5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3-53 0-96-43-96-96 0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32m244.8 102.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8-19.9-60.9 45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3l-152.2 49.4c-16.8 5.5-34.9-3.7-40.3-20.5z" })
  }
), Fo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M477.3 24.9c3.5-5.3 3.6-12.2.1-17.6s-9.7-8.1-16-7.1c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3 306.5 12.8 258 0 206.5 0H176C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7l-21.5 12.9C7.8 217.2 0 231 0 245.8 0 269.1 18.9 288 42.2 288h161l92 61.3c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1v-48h6.6c31.7 0 57.4 25.7 57.4 57.4 0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6l28.4 56.8-28.4 56.8c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h4.7c35.9 0 69.2-17.1 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3 0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), To1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c-17.7 0-32 14.3-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8 5 11.1 16.2 18.8 29.2 18.8 17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32M128 288a64 64 0 1 1 128 0 64 64 0 1 1-128 0M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Ao1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160v31c-.7 10-4.3 19.5-10.5 27.4-6.2 8-14.7 14-24.4 17.1l-.3.1-.3.1c-13.1 4.9-24.4 13.8-32 25.5-9.4 13-22 23.3-36.5 30.1-14.7 6.8-30.8 9.6-46.9 8.3h-1.2c-17.7-.2-35.3 3.3-51.7 10.1h-.1c-16.4 7-34.1 10.5-51.9 10.3h-.3c-17.8.2-35.5-3.3-51.9-10.3h-.1c-16.4-6.8-34-10.2-51.7-10.1H151c-16.1 1.3-32.3-1.6-46.9-8.4-14.6-6.8-27.1-17.1-36.5-30.2-7.7-11.7-18.9-20.6-32-25.5l-.4-.1-.4-.1c-9.7-3.1-18.2-9.1-24.4-17.1C4.3 258.4.7 248.9 0 238.9zm0 92.7c7.4 5.7 15.7 10.1 24.6 13 6.7 2.6 12.4 7.2 16.3 13.2l.2.3.2.3c12.6 17.6 29.6 31.7 49.3 40.8 19.5 9 41 12.9 62.4 11.3 13.2-.1 26.3 2.5 38.5 7.6 20.4 8.6 42.4 13 64.5 12.8 22.1.2 44.1-4.2 64.5-12.8 12.2-5.1 25.3-7.6 38.5-7.6 21.4 1.7 42.9-2.2 62.3-11.2 19.7-9.1 36.7-23.1 49.3-40.7l.2-.3.2-.3c3.9-6 9.6-10.6 16.3-13.2 8.9-2.9 17.3-7.4 24.6-13v3.1c0 88.4-114.6 160-256 160S0 392.4 0 304zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32 28.7 32 64 32 64-14.3 64-32M283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32m224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32M64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z" })
  }
), Do1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v384h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm288 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), yo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1L100.3 46C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-32zm-64 224c0 17.7-10.7 32-24 32s-24-14.3-24-32 10.7-32 24-32 24 14.3 24 32m96-128h96v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V128c0-35.3-28.7-64-64-64h-96z" })
  }
), bo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160.8 96.5c14 17 31 30.9 49.5 42.2 25.9 15.8 53.7 25.9 77.7 31.6v-31.5c-22.2-30.3-38-67.3-39.4-110.8-.4-11.3-7.5-21.5-18.4-24.4-7.6-2-15.8-.2-21 5.8-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v64c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8.9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5l75.6-60.5H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8 0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), fo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m73.9 345.9 122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H288V160c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H97.9C79.2 288 64 303.2 64 321.9c0 9 3.6 17.6 9.9 24M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64m128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64m128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Uo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m41.9 345.9 122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H256V160c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H65.9C47.2 288 32 303.2 32 321.9c0 9 3.6 17.6 9.9 24M32 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32" })
  }
), Go1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39zM72 272h144c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2S62.3 272 72 272" })
  }
), qo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 432h240c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-72-72 134-134c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3l-41.4-41.4C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l-72-72c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z" })
  }
), Wo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26S305.5 320 296 320h-72V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v288H24c-9.6 0-18.2 5.7-22 14.5" })
  }
), Eo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l72-72-134-134C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3l41.4-41.4C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3l134.1 134.1 72-72c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z" })
  }
), Oo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.1 217.9 251.3 340.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L73.9 217.9c-6.4-6.4-9.9-15-9.9-24 0-18.7 15.2-33.9 33.9-33.9H160V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v128h62.1c18.7 0 33.9 15.2 33.9 33.9 0 9-3.6 17.6-9.9 24M64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Io1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 448a32 32 0 1 0 64 0 32 32 0 1 0-64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64M73.9 249.9l122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H288V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H97.9C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24z" })
  }
), No1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M342.1 249.9 219.3 372.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L41.9 249.9c-6.4-6.4-9.9-15-9.9-24 0-18.7 15.2-33.9 33.9-33.9H128V64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v128h62.1c18.7 0 33.9 15.2 33.9 33.9 0 9-3.6 17.6-9.9 24M32 416h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), Xo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9S19 255.9 32 255.9h96v-184c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v184h96c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z" })
  }
), Ko1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Qo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m352 124.5-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4-43.2-32.4c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0h160c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8 0 26.5-21.5 48-48 48h-21.5c-17 0-33.3-6.7-45.3-18.7L480 160h-32v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1 0 60.6-49.1 109.7-109.8 109.7H32.3c-3.3 0-6.6-.4-9.6-1.4-9.2-2.8-16.7-9.6-20.3-18.5C1 488.7.2 485.2 0 481.4c-.2-3.7.3-7.3 1.3-10.7 2.8-9.2 9.6-16.7 18.6-20.4 3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1 0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V124.5zm160-52.2v-.6zm-1.3 7.4-46.4-11.6c-.2 1.3-.3 2.6-.3 3.9 0 13.3 10.7 24 24 24 10.6 0 19.5-6.8 22.7-16.3m-379.8 36.8c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l69.4-59.6-152.6 23.5c-7 1.1-13.9-2.6-16.9-9S0 232.7 5.3 228z" })
  }
), Zo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7-9.6-23.5-32.6-40-59.4-40s-49.8 16.5-59.3 39.9C120.7 60.7 60.8 120.6 40 196.6 16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7 9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7 23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102 14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102 11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102" })
  }
), Jo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 151.4v209.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c0-.1.1-.2.1-.3l-4.5-7.9-32-56c-1.4.1-2.8.1-4.2.1-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2.1l32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2.2 63.7 28.7 63.7 64s-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96c0-35.3 28.7-64 64-64 23.7 0 44.4 12.9 55.4 32h209.2c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64s-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56z" })
  }
), jo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 151.4v209.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V151.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4c-5.6 9.7-13.7 17.8-23.4 23.4M119.4 448c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96c0-35.3 28.7-64 64-64 23.7 0 44.4 12.9 55.4 32h209.2c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v209.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32z" })
  }
), Yo1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7l-62.1-62C207.2 66 176.8 66 158 84.7l-57.4 57.4 237.3 237.2 57.4-57.4c18.7-18.7 18.7-49.1 0-67.9l-62-62zM315.3 401.9 78.1 164.7 18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64h146.7c17 0 33.3-6.7 45.3-18.7l59.3-59.3z" })
  }
), _o1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M155.7 112c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24zm220.3 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-76.3c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16zM96 192v64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4v5.3c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1 41.9 18.6c4.1 1.8 8.5 2.8 13 2.8h96c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1v5.2c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-27.9-9.7-54.9-27.5-76.4l56.5-25.2c11.6-5.1 19-16.6 19-29.2v-64h-64v43.2l-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7-17.8-8V192z" })
  }
), hn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m223 127.2-51.4-38.5C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64 0 27.1 16.9 50.3 40.7 59.6l38.5 51.4c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2m-49.6 2.8 39.8 29.9.1.1h85.3l.1-.1 39.8-29.9 29.7-22.3C370.3 92.1 383.8 80 400 80c17.7 0 32 14.3 32 32 0 16.2-12.1 29.7-27.8 31.7l-22.3 29.7-29.9 39.8-.1.1v85.3l.1.1 29.9 39.8 22.3 29.7c15.7 2.1 27.8 15.5 27.8 31.7 0 17.7-14.3 32-32 32-16.2 0-29.7-12.1-31.7-27.8l-29.7-22.3-39.8-29.9-.1-.1h-85.4l-.1.1-39.8 29.9-29.7 22.3c-2 15.8-15.5 27.9-31.7 27.9-17.7 0-32-14.3-32-32 0-16.2 12.1-29.7 27.8-31.7l22.3-29.7 29.9-39.8.1-.1v-85.4l-.1-.1-29.9-39.8-22.3-29.7C92.1 141.7 80 128.2 80 112c0-17.7 14.3-32 32-32 16.2 0 29.7 12.1 31.7 27.8l29.7 22.3zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2.3 15.2 1l-38.5 51.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64 27.1 0 50.3-16.9 59.6-40.7l51.4-38.5c.7 5 1 10.1 1 15.2m65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6 0-35.3-28.7-64-64-64-27.1 0-50.3 16.9-59.6 40.7zM288 400c0-5.2.3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7 35.3 0 64-28.7 64-64 0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1 61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112" })
  }
), cn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192m272-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0" })
  }
), sn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192m75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48m112 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), vn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192m185.2-141.3c4.4-16.1 6.8-33.1 6.8-50.7 0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7zM224 336c0 44.2 35.8 80 80 80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112 0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), en1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192M96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80" })
  }
), ln1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c159.1 0 288 48 288 128v192c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32m240 128c0-9.9-8-29.9-55-49.8-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4 0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5 47.1-19.9 55-39.9 55-49.8zm-178.8 77.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7M169 90.8c-25.2 5-47.4 11.6-66 19.4-47 19.9-55 39.9-55 49.8s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5 0-13.6-3.9-26.9-11.2-38.4zm56.3-8c-.8 4.2-1.3 8.7-1.3 13.2 0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z" })
  }
), tn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2S486 28.7 474.9 36l-104.7 68.5C335.8 98.7 297 96 256 96 114.6 96 0 128 0 208v160c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24v119.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24v103.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24v102.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zm-193.8 69.5-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5 38.8 15.1 44.4 30.7 44.4 41.3 0 .8-2.7 17.2-46 35.9-38.9 16.8-96 28.1-162 28.1s-123.1-11.3-162-28.1c-43.3-18.7-46-35.1-46-35.9 0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1.5 51.4 1.6" })
  }
), wn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2-4.6-1.2-9.4-1.8-14.4-1.8-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12 0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1 11.9-1.2 16.4-15.5 10.8-26-8.5-15.8-13.3-33.8-13.3-53 0-61.9 50.1-112 112-112 8 0 15.7.8 23.2 2.4 11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0c-97.2 0-176 78.8-176 176z" })
  }
), gn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M150.6 287.8c6-6 9.4-14.1 9.4-22.6V176C160 78.8 238.8 0 336 0s176 78.8 176 176-78.8 176-176 176h-89.2c-8.5 0-16.6 3.4-22.6 9.4l-26.8 26.8c-12.3 12.3-11.4 32.5-7.2 49.4 1.1 4.6 1.8 9.5 1.8 14.5 0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8.6 14.5 1.8 16.9 4.2 37.1 5.2 49.4-7.2l26.8-26.8z" })
  }
), in1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm160 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288M64 88a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-27.3 148.7c-6.2 6.2-6.2 16.4 0 22.6l20.7 20.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm102.6 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.7 20.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7z" })
  }
), mn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm368 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0M88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m128 216c0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.9c7.8-54.3 54.4-96 110.9-96 61.9 0 112 50.1 112 112" })
  }
), an1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400.7 224c-.4 0-.7.3-.7.7v24c0 6.6 2.8 12.8 7.2 17.7 20.4 22.7 32.8 52.7 32.8 85.6 0 70.7-57.3 128-128 128H196C87.8 480 0 392.2 0 284v-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7-21-19-34.1-46.5-34.1-77 0-57.4 46.6-104 104-104 53.8 0 98.1 40.9 103.5 93.3 0 .4.3.6.7.7 10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3 0 50.3-40.8 91.1-91.1 91.1h-20.4zM368 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-27.4 160.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1-40.3 10.1-80.5-4.6-103.7-33.5-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5 58-14.5 98.3-63.8 101.5-119.3z" })
  }
), on1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64H64c-17.7 0-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h32zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32h-32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32M416 224v64H224v-64z" })
  }
), nn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128zM272 160V32h-98.9l-25.6 128zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1 1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2-.1-.7-.3-1.4-.5-2.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l12.8 64.2c9.6 1 19 4.9 26.6 11.8 11.7 10.6 23 21.6 33.9 33.1 1.6-1.6 3.3-3.2 5-4.8zm-188.7 74.4c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h209.6c-31-34.7-49.6-80.6-49.6-129.9 0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.8 70.3 159.9 160 159.9 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), rn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128zM272 160V32h-98.9l-25.6 128zm32 0h124.5L402.9 32H304zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8zM32 192l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h320c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32z" })
  }
), dn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3 9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4-16.6-18.3-35.7-34.3-56.9-47.3-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1.2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4c-13.5 3-20.2 17.6-15 30.4l30.3 75.8c4.5 11.3 16.8 17.2 29 16 4.2-.4 8.4-.6 12.7-.6s8.6.2 12.7.6c12.1 1.2 24.4-4.7 29-16zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6 1.3-1.1 2.6-2.3 4-3.3 9.3-7.5 13.9-20.1 9.5-31.2l-30.7-76.2c-5.2-12.9-20.3-18.8-32.1-11.6-21.2 13-40.3 29-56.8 47.4m314 137.1c.9 3.3 1.7 6.6 2.3 10 2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24-2.5-27.2-9.3-53.2-19.7-77.3-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9.6-3.4 1.4-6.7 2.3-10 3.1-11.4-.2-24-10-30.5l-68.6-45.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24m304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 8.8 7.2 16 16 16s16-7.2 16-16zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), Sn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96h224c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), zn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m502.6 54.6-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3M240 128c-57.6 0-105.1 43.6-111.3 99.5-1.9 17.6-17.8 30.2-35.3 28.3S63.2 238 65.1 220.5C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176 0 46-17.7 87.9-46.6 119.3-12 13-17.4 24.8-17.4 34.7v6c0 61.9-50.1 112-112 112-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78 18.4-20 29.6-46.6 29.6-75.9 0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32" })
  }
), pn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3-7.9 15.8-1.5 34.9 14.2 42.9l.4.2c.4.2 1.1.6 2.1 1.2 2 1.2 5 3 8.7 5.6 7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7-13.9-15.1-27.8-26.1-38.2-33.3-5.3-3.7-9.7-6.4-13-8.3-1.6-1-3-1.7-4-2.2-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1h-.1l-14.3 28.6 14.2-28.7zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5 61.9 0 112 50.1 112 112 0 29.3-11.2 55.9-29.6 75.9-17 18.4-34.4 45.1-34.4 78v6.1c0 26.5-21.5 48-48 48-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176-90.6 0-165.2 68.5-174.9 156.5-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3M32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-150.6 9.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), Mn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c-78.2 0-143.3 56.1-157.2 130.2-6-1.4-12.3-2.2-18.8-2.2-17.7 0-34.1 5.8-47.4 15.6C105 91.5 201.8 0 320 0s215 91.5 223.4 207.6c-13.3-9.8-29.7-15.6-47.4-15.6-6.5 0-12.7.8-18.8 2.2C463.3 120.1 398.2 64 320 64M179.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48-22.1 0-40.8-15-46.3-35.4-5.5 2.2-11.5 3.4-17.7 3.4-26.5 0-48-21.5-48-48 0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3c-2.2-5.5-3.4-11.5-3.4-17.7 0-26.5 21.5-48 48-48 6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32m280.4 0c-7.6-8.5-12.2-19.7-12.2-32 0-26.5 21.5-48 48-48 22.1 0 40.8 15 46.3 35.4 5.5-2.2 11.4-3.4 17.7-3.4 26.5 0 48 21.5 48 48 0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7 0 26.5-21.5 48-48 48-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48 0-12.3 4.6-23.5 12.2-32-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32" })
  }
), xn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9-5.6 26.3-18.6 51.3-39 71.7-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368V192C0 86 86 0 192 0s192 86 192 192c0 56.9-24.8 108-64.1 143.2M128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v20.2c0 21.2 12 40.6 31 50.1l14 7c1.8.9 3 2.8 3 4.9 0 1.6-.7 3.2-2 4.2l-37.4 31.2c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2c12.3-10.2 19.3-25.2 19.3-41.1 0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2V192z" })
  }
), Hn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m177.8 63.2 10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4 6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6 6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5 0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32 10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4v-12.1c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26 0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4 5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13 3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Vn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m57.7 193 9.4 16.4c8.3 14.5 21.9 25.2 38 29.8l57.9 16.5c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6 16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5 4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5.3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3-92.8 0-171.5 60.9-198.2 145zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), Cn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m51.7 295.1 31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7 15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4L325 59.4C303.4 52.1 280.2 48 256 48 141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1m407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6m92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zm106.7-214.4c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l16-32c4-7.9.7-17.5-7.2-21.5" })
  }
), Ln1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m266.3 48.3-33.8 25.3c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3 2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8l-19.9 19.9a53.03 53.03 0 0 1-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4 0 3.7-1.5 7.3-4.1 10L202 182.1c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7 11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9 4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5 8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6 0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-20.7c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5c-3.6 3.8-5.6 8.7-5.6 13.8s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16h7.4c6.5-20.2 10-41.7 10-64 0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4h-20.9c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24 0 2.5.4 5 1.1 7.3 71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m187.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6" })
  }
), Bn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-47.4-154.7-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1 7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4 4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2l17.9 22.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26l-12 15.4c-8.3 10.6-21 16.8-34.4 16.8-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8 22.2 22.2c10.1 10.1 2.9 27.3-11.3 27.3h-29.9c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9M248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16m183.2-133.1 8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1m-19.9 80.4-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6" })
  }
), un1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8-12.4-4-25.6-6.2-39.4-6.2-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2 21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM256 160c7.6 0 15 .9 22.1 2.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6-53 0-96-43-96-96s43-96 96-96m208-80a176 176 0 1 1 0 352 176 176 0 1 1 0-352" })
  }
), Rn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7 27.5 7 52.8 23.2 71 47.8 42.1 56.8 30.2 137-26.6 179.1-17.8 13.2-37.9 21.1-58.4 24-37.2 5.2-84.5 32.7-103.3 65.2-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-160-8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72 8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40" })
  }
), $n1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 496C86 496 0 394 0 288 0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208m-37.2-362c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2" })
  }
), kn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16-26.5 0-48-21.5-48-48 0-5.8-4-10.7-9.4-12.6-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h142l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6 11.8 20 32.1 34.4 55.9 38.3 6.7 14 15.8 26.3 25.8 36.2s22.2 19.1 36.2 25.8c5 30.4 27.1 55.1 56.2 63.8-46.8 125.9-146.3 275.4-281 275.2-96.5-.1-175-80.7-176.4-176-1.6-113.5 83.4-154.7 169.9-196.7z" })
  }
), Pn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192c9-9.9 21.8-15.5 35.3-15.5M0 432c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48" })
  }
), Fn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 0c-61.9 0-112 50.1-112 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144 0-25.3 6.5-49.1 18-69.8-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248v19c0 12.4-1.2 24.7-3.7 36.9-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-70c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6v70c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V340.7c16.7 18.9 38.8 32.8 64 39.3v18.6c0 45 36.5 81.4 81.4 81.4 30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6-9.6 0-17.4-7.8-17.4-17.4V380c22.9-5.9 43.4-18 59.4-34.4 6.2-6.3 6.1-16.4-.2-22.6-6.3-6.2-16.3-6.1-22.5.1-1.3 1.3-2.6 2.6-4 3.9-1.5 1.4-3.1 2.7-4.6 4-8.3 6.7-17.8 12-28 15.6-10 3.5-20.8 5.5-32 5.5s-22-1.9-32-5.5c-7.5-2.6-14.6-6.2-21.1-10.5-9.1-6.1-17.2-13.7-23.7-22.4-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2C472.5 310 491.1 320 512 320c11.7 0 22.6-3.1 32-8.6V192c0-88.4-71.6-160-160-160h-1.6C362.2 12.2 334.5 0 304 0m160 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Tn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m132.7 4.7-64 64c-4.6 4.6-5.9 11.5-3.5 17.4S73.5 96 80 96h128c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96M80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm32-128a48 48 0 1 1 96 0 48 48 0 1 1-96 0m52.7-180.7c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4z" })
  }
), An1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48m0 96a72 72 0 1 1 0-144 72 72 0 1 1 0 144m24 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0m96 160a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0" })
  }
), Dn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48m0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144m-160 96a24 24 0 1 1 0-48 24 24 0 1 1 0 48m0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144m-136 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-96 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0" })
  }
), yn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112m0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112m56-104A56 56 0 1 0 8 96a56 56 0 1 0 112 0" })
  }
), bn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M8 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0m160 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0m216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), fn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m435.4 121.9 67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-67.1 67.2C352.8 48.6 306.3 32 256 32 132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6 123.7 0 224-100.3 224-224 0-50.3-16.6-96.8-44.6-134.1zm-91.2.7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160 32.6 0 62.9 9.8 88.2 26.5zm-176.5 267 221.8-221.8c16.7 25.3 26.5 55.6 26.5 88.2 0 88.4-71.6 160-160 160-32.6 0-62.9-9.8-88.2-26.5z" })
  }
), Un1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24h72v32H128c-17.7 0-32 14.3-32 32v56H48v-72c0-13.3-10.7-24-24-24S0 146.7 0 160v192c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328v-32zm144 112v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32m-240-36c11 0 20 9 20 20v88c0 11-9 20-20 20s-20-9-20-20v-88c0-11 9-20 20-20m-24 180a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), Gn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24h72v32H128c-17.7 0-32 14.3-32 32v56H48v-72c0-13.3-10.7-24-24-24S0 146.7 0 160v192c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328v-32zm144 112v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32m-256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), qn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48zm246.4 275.2a63.9 63.9 0 0 1-76.8 0L0 176v208c0 35.3 28.7 64 64 64h296.2c-25.1-30.4-40.2-69.5-40.2-112 0-5.6.3-11.1.8-16.6l-26.4 19.8zM640 336a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Wn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160M48 64h337.1c-.7 5.2-1.1 10.6-1.1 16 0 45.6 27.2 84.8 66.3 102.3L275.2 313.6a32.1 32.1 0 0 1-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112c0-26.5 21.5-48 48-48m246.4 275.2 196.4-147.3c1.7.1 3.4.1 5.2.1 5.4 0 10.8-.4 16-1.1V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176l217.6 163.2a63.9 63.9 0 0 0 76.8 0" })
  }
), En1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.4 96H96v177.4L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11l49.9 37H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4V96H296.6zM0 448V242.1l217.6 161.2c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64m276-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z" })
  }
), On1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.4 96H96v177.4L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11l49.9 37H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4V96H296.6zM0 448V242.1l217.6 161.2c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64m176-288h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), In1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 208.1 256 65.9l192 142.2v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0" })
  }
), Nn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0z" })
  }
), Xn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v192h96v-32c0-35.3 28.7-64 64-64h224V32c0-17.7-14.3-32-32-32zm128 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64v128h192c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M64 256c-17.7 0-32 14.3-32 32v13l155.1 114.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301v-13c0-17.7-14.3-32-32-32zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32z" })
  }
), Kn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316.7 249.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32H160c-32.2 0-58.8 23.7-63.3 54.7l220 163zm57.7 25.7c-11.1 8.3-24.6 12.7-38.4 12.7s-27.3-4.4-38.4-12.7L96 126v194c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V126zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), Qn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Zn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.7 57.4 57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9l130.7-130.6c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zm6.7 358.6H182.6l-80-80 124.7-124.7 137.4 137.4z" })
  }
), Jn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m197.9 127.8c11.6-10.2 26.6-15.8 42.1-15.8h96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-72L234.1 496.2C222.5 506.4 207.5 512 192 512H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h72zM320 192v16.4l-128 112V192c0-35.3 28.7-64 64-64s64 28.7 64 64" })
  }
), jn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224v192c0 17.7 14.3 32 32 32h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32" })
  }
), Yn1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3.1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-24c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8v-16c0-2.7.1-5.4.2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-24C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), _n1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v256c0 17.7 14.3 32 32 32s32-14.3 32-32zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), hr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 78.3 0 96v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zm32 256c0-17.7-14.3-32-32-32S0 302.3 0 320v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm128 256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32z" })
  }
), cr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zm32 320c0-17.7-14.3-32-32-32S0 334.3 0 352v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zm128 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32z" })
  }
), sr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87h-71.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64h-79.7l-75.5-52.2c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3l-62.3-103.8c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1.1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448h480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zM288 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24" })
  }
), vr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M341.6 29.2 240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.5-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4l120.7-120.7-133.3-133.3L55.4 323.3z" })
  }
), er1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.1 130.8 341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4zm-63.9 71.8 45.3 45.3-72.2 72.1h85.5l29.4-29.4 45.3 45.3-120.8 120.7c-15 15-35.4 23.4-56.6 23.4H89.7l-40 26.6c-12.7 8.5-29.6 6.8-40.4-4s-12.5-27.7-4-40.4L32 422.3v-42.4c0-21.2 8.4-41.6 23.4-56.6l120.7-120.7z" })
  }
), lr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M341.6 29.2 240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.5-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4l120.7-120.7-45.3-45.3-120.7 120.7c-3 3-7.1 4.7-11.3 4.7H96v-36.1c0-4.2 1.7-8.3 4.7-11.3l120.7-120.7-45.3-45.3L55.4 323.3z" })
  }
), tr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254.9 112.2c-10.7 2.8-21.1 6.3-30.9 10.4L114.4 76.1c-8.7-3.7-18.7-1-24.4 6.5s-5.5 17.9.4 25.2l57.3 70.8c-7 9-12.8 18.6-17.3 28.6L15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9l114.9 28.7c4.5 10.1 10.3 19.7 17.3 28.6l-57.3 70.9c-5.9 7.3-6.1 17.7-.4 25.2s15.7 10.2 24.4 6.5L224 389.4c9.8 4.1 20.1 7.6 30.9 10.4l42.7 97.6c3.9 8.9 12.7 14.7 22.4 14.7s18.5-5.8 22.4-14.7l42.7-97.6c10.7-2.8 21.1-6.3 30.9-10.4l109.7 46.5c8.7 3.7 18.7 1 24.4-6.5s5.5-17.9-.4-25.2l-57.3-70.8c7-9 12.8-18.6 17.3-28.6l114.9-28.7c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9l-115-28.9c-4.5-10.1-10.3-19.7-17.3-28.6l57.3-70.8c5.9-7.3 6.1-17.7.4-25.2s-15.7-10.2-24.4-6.5L416 122.6c-9.8-4.1-20.1-7.6-30.9-10.4l-42.7-97.5C338.5 5.8 329.7 0 320 0s-18.5 5.8-22.4 14.7l-42.7 97.6zM320 352c-53 0-96-43-96-96 0-19.7 6-38.1 16.2-53.3 16.6 9.6 35 16.2 54.7 19.3-3.9 9.4-6.8 20.8-6.8 34 0 31.5 16.5 52.7 23.8 60.6 2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6 0-13.2-2.9-24.6-6.8-34 19.6-3.1 38.1-9.8 54.7-19.3 10 15.2 16 33.6 16 53.3 0 53-43 96-96 96" })
  }
), wr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7 60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3zm223.1 298-363-286c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 3.1 0 6.1-.1 9.2-.2l-296.1-232c-1.8 6.8-1.3 14 1.4 20.5z" })
  }
), gr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm184.3 144.4c25.5-23.3 59.6-37.5 96.9-37.5 79.5 0 144 64.5 144 144 0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-94.3-74.3c-22.8 29.7-39.1 59.3-48.6 82.2-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 47.8 0 89.9-12.9 126.2-32.5z" })
  }
), ir1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32M144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" })
  }
), mr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 224c-11.1 0-21.6 2.8-30.7 7.8 4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3 3.1.5 6.4.7 9.6.7 35.3 0 64-28.7 64-64s-28.7-64-64-64m224-97.3c-5-9.1-10.5-17.6-16.6-25.7-30.6-40.8-75.3-69-127.4-69S79.2 60.2 48.6 101C18 141.8 0 196.7 0 256s18 114.2 48.6 155 75.3 69 127.4 69 96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7 5 9.1 10.5 17.6 16.6 25.7 30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155S516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7m54.4 224.6c3.1.5 6.4.7 9.6.7 35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8 4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z" })
  }
), ar1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96h224c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), or1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.6 3.5-48.4 9.9-70.9C29.6 125.8 6.5 50.1.3 19.1-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1 23.3 7 46 12.2 63 15.5C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c17-3.3 39.7-8.6 63-15.5 29.8-8.9 59.1-20.2 78.4-33.1 5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166 6.5 22.5 9.9 46.3 9.9 70.9zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), nr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m338.7 139.9c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), rr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-192c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80m-111.6-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16m141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), dr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8 7 9.2 18.1 24.6 27.7 40.7 4.8 8.1 9.6 17 13.2 25.7 3.4 8 7.1 19 7.1 30.5 0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512M79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5M208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16m159.6-160a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-12.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z" })
  }
), Sr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-208c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48m-111.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16m141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), zr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6-17.7 0-32-14.3-32-32 0-9.1 3.8-17.4 10-23.2-3.3-.5-6.6-.8-10-.8-35.3 0-64 28.7-64 64v10.3c0 16.4 13.3 29.7 29.7 29.7h68.6c16.4 0 29.7-13.3 29.7-29.7V184c0-8.3-1.6-16.3-4.5-23.6M384 176c-17.7 0-32-14.3-32-32 0-8.5 3.3-16.3 8.8-22-5.4-1.3-11-2-16.8-2-39.8 0-72 32.2-72 72v7.5c0 13.5 11 24.5 24.5 24.5h95.1c13.5 0 24.5-11 24.5-24.5V192c0-10.4-2.2-20.2-6.1-29.1-5.8 8-15.2 13.1-25.9 13.1zM245.5 447.8c2.7.1 5.4.2 8.1.2h4.9c55.1 0 105.1-26.1 137-67.5 15.7-20.5 27-44.6 32.4-71.3 2.2-11-6.2-21.2-17.4-21.2H101.6c-11.2 0-19.6 10.2-17.4 21.2 15.6 78.1 82.4 135 161.2 138.6zm-5.4-32.5c1.5-44.1 37.8-79.4 82.2-79.4 19.9 0 38.1 7 52.3 18.7C349 392.1 306.1 416 258.4 416h-4.9c-4.6 0-9.1-.2-13.5-.6z" })
  }
), pr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256m-294.4-43.2c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm-78.3 63.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Mr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-23.7 0-44.4 12.9-55.4 32H64C28.7 32 0 60.7 0 96s28.7 64 64 64h160c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0M72.1 192c-5.3 20.5-8.1 41.9-8.1 64 0 114.6 75.4 211.7 179.3 244.3-12.1-17-19.3-37.8-19.3-60.3 0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2 8.9-3.4 18.5-5.2 28.5-5.2 20 0 38.3 7.3 52.3 19.5 2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3 6.5 5.9 10.5 14.3 10.5 23.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64M336 368h-8c-39.8 0-72 32.2-72 72s32.2 72 72 72h240c39.8 0 72-32.2 72-72s-32.2-72-72-72h-.7c.4-2.6.7-5.3.7-8 0-26.5-21.5-48-48-48-13.9 0-26.4 5.9-35.1 15.3-14-23.5-39.6-39.3-68.9-39.3-44.2 0-80 35.8-80 80" })
  }
), xr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160 39.1 26.2 39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z" })
  }
), Hr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-84.9-116.4-1.1.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16h-11c-61.8 0-121.7 21-169.9 59.6M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Vr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0c9.1 0 17.9 4 26.1 10.7 7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8 33.6-10.5 63.6-25.2 88.5-43 2.5-1.8 5.4-2.8 8.4-2.8 8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8 24.9 17.8 54.9 32.5 88.5 43C148.6 64.9 179.2 0 216 0M48 304c0-37.9 10.1-73.4 27.8-104 48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104 0 114.9-93.1 208-208 208S48 418.9 48 304m299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8 20.2 40.6 62 68.5 110.2 68.5s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0m104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Cr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m116.4-192.6-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Lr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z" })
  }
), Br1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c141.4 0 256-114.6 256-256 0-16.4-1.5-32.5-4.5-48H440c0 50.1-38.4 91.2-87.3 95.6 9.6 7.9 15.3 19.7 15.3 32.4 0 15.9-9 30.4-23.1 37.5l19.6 24.5c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4.7-4.8 1.3-7.2 1.8V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.2c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6-23.7 29.9c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208H4.5c-3 15.5-4.5 31.6-4.5 48 0 141.4 114.6 256 256 256m61.9-245.5c7.9 3.5 16.8 5.5 26.1 5.5 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 2.5.1 4.9.4 7.3 5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1.6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c9.3 0 18.1-2 26.1-5.5.6-.3 1.5-.7 2.6-1.3l21.3-35.7c3.5-5.8 8.1-10.6 13.5-14.1.3-2.4.4-4.9.4-7.3zM12.7 176h64.8c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v16.3c4.4.4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1 7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2V96c0-8.8 7.2-16 16-16s16 7.2 16 16v19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3a97.52 97.52 0 0 1 25.4 38.5h64.7C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176M256 240c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4-39.7-66.3c-2.2-3.7-6.2-6-10.5-6m-112-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), ur1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128M100.7 132.7c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z" })
  }
), Rr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 3.1c13-2 26.4-3.1 40-3.1s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6S303.5 69.1 286 66.3c-9.7-1.5-19.7-2.3-30-2.3s-20.3.8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zm-65.8 52.8c10.4 14.3 7.2 34.3-7 44.7-16.3 11.9-30.7 26.2-42.5 42.5-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6 14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7 21.7 15.8 40.8 34.9 56.6 56.6 10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5-14.3-10.4-17.4-30.4-7-44.7zm110.5 133.4c17.5-2.7 33.8 9.2 36.6 26.6 2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6-1.5 9.8-2.3 19.8-2.3 30.1s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296c-2-13-3.1-26.4-3.1-40s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zm16.2 172.5c14.3-10.4 34.3-7.2 44.7 7 11.9 16.3 26.2 30.7 42.5 42.5 14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7-15.8 21.7-34.9 40.8-56.6 56.6-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5 10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6 9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64m160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64M184 328h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), $r1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M35.2 126.3c4.1 1.1 8.4 1.7 12.8 1.7 26.5 0 48-21 48-47 0-5-1.8-11.3-4.6-18.1l-.9-2.1C81.6 40.6 64 15.9 54.5 3.3c-3.2-4.4-9.6-4.4-12.8 0C28.6 20.6 0 61 0 81c0 21.7 14.9 39.8 35.2 45.3M256 0c-51.4 0-99.3 15.2-139.4 41.2 1.5 3.1 3 6.2 4.3 9.3 3.4 8 7.1 19 7.1 30.5 0 44.3-36.6 79-80 79-9.6 0-18.8-1.7-27.4-4.8C7.3 186.2 0 220.2 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0m-60.1 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16m208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), kr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c33.9 0 66.4-6.6 96-18.6V370.9c-9.7 6.4-20.3 12.2-32 16.9V448c0 8.8-7.2 16-16 16s-16-7.2-16-16v-50.9c-10.1 1.9-20.8 2.9-32 2.9-67 0-113.8-36.7-140.5-70-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5 12.8-12.3 31.2-22.5 55.3-22.5 8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5-8.2-7.8-19-13.6-33.4-13.6-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4 12.6 12 20.4 26.3 23.8 36.5 2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z" })
  }
), Pr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c55.8 0 107.4-17.9 149.5-48.2-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7c-13.5-4-22.8-16.5-22.8-30.6s9.3-26.6 22.8-30.6l42.2-12.7c5.3-30 31.5-52.7 63-52.7h2.1c13.2-14.7 32.3-24 53.7-24 2.7 0 5.4.2 8.1.5.1-2.8.1-5.6.1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256m-60.8-273.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80m287.4-5.5c.1-.8.1-1.7.1-2.5 0-22.1-17.9-40-39.9-40-16.9 0-31.4 10.5-37.2 25.4-3.3-.9-6.9-1.4-10.5-1.4-22.1 0-39.9 17.9-39.9 40l-56.1 14.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l56.9 14.2c-.5 2.5-.8 5.1-.8 7.8 0 22.1 17.9 40 39.9 40 4.9 0 9.6-.9 14-2.5 7.1 11.1 19.5 18.5 33.7 18.5 22.1 0 39.9-17.9 39.9-40 0-.8 0-1.7-.1-2.5 19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z" })
  }
), Fr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 196.5c0 7.9 2.5 15.4 7 21.6-14.5-6.6-31.5-5.6-45.3 3l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.8-8.6-30.8-9.6-45.3-3 4.5-6.2 7-13.7 7-21.6V192c0-17.7-14.3-32-32-32H120c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8 7.5-3.7 15.9-5.8 24.8-5.8 30.9 0 56 25.1 56 56s-25.1 56-56 56h-40c-17.7 0-32 14.3-32 32zM299 248c5.1-3 11.4-3 16.4 0 .1.1.2.1.3.2L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1l30.4-11.7v2.5c0 141.4-114.6 256-256 256S0 397.4 0 256v-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0l17.3 10.8c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1.2-.1.3-.2 5.1-3 11.4-3 16.4 0 .1.1.2.1.3.2l17.2 10.8c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1.2-.1.3-.2zm-90.6 88a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M192 437.3c0 5.9 4.8 10.7 10.7 10.7h106.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3h-21.4c-29.5 0-53.3 23.9-53.3 53.3" })
  }
), Tr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-176h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16m-32-128c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16m176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Ar1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M123.3 132.7l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0 36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80" })
  }
), Dr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-192c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80M96 224a64 64 0 1 1 128 0 64 64 0 1 1-128 0m256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-176-48c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0m160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), yr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m176 128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16m-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144m264-72a72 72 0 1 0-144 0 72 72 0 1 0 144 0m-288 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0m192 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), br1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8" })
  }
), fr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ur1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96.7-123.3c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Gr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-56h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-56h39.9c5.3 20.5 8.1 41.9 8.1 64M256 0c107.4 0 199.4 66.2 237.4 160h-34.8c-9-18.9-28.3-32-50.6-32h-80c-22.3 0-41.6 13.1-50.6 32h-42.8c-9-18.9-28.3-32-50.6-32h-80c-22.3 0-41.6 13.1-50.6 32H18.6C56.6 66.2 148.6 0 256 0M80 192v-8c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24zm61.5 147.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6M304 184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24zm-119.6 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), qr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m96-112h-8v-40h55.3c-3.8 22.7-23.6 40-47.3 40m47.3-56H344v-40h8c23.8 0 43.5 17.3 47.3 40m-71.3 0h-64v-40h64zm0 56h-64v-40h64zm-80-96v40h-64v-40zm0 56v40h-64v-40zm-80-16h-55.3c3.8-22.7 23.6-40 47.3-40h8zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168zm-23.6-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Wr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7-26.5 0-48-21-48-47 0-5 1.8-11.3 4.6-18.1l.9-2.1c9-20.2 26.5-44.9 36-57.5 3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3M256 0c51.4 0 99.3 15.2 139.4 41.2-1.5 3.1-3 6.2-4.3 9.3-3.4 8-7.1 19-7.1 30.5 0 44.3 36.6 79 80 79 9.6 0 18.8-1.7 27.4-4.8 13.3 30.9 20.6 65 20.6 100.8 0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0m127.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7 24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7m-166.2-89c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z" })
  }
), Er1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19m-170.5-84-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z" })
  }
), Or1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19M199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4C103 224 92.4 205.7 97.2 188s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6 4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z" })
  }
), Ir1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M426.8 14.2c19.2-19.2 50.7-18.8 70.3.7s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7-16.3 4.4-34.1 7.5-46.3 9.3-1.6.2-3.1.5-4.6.6-4.9.8-9.1-2.8-9.5-7.4-.1-.7 0-1.4.1-2.1 1.6-11.2 4.6-29.6 9-47 .3-1.3.7-2.6 1-3.9 4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3-4.8 18.9-8 38.5-9.7 50.3-4 26.8 18.9 49.7 45.7 45.8 11.9-1.6 31.5-4.8 50.4-9.7 4.7-1.2 9.5-2.5 14.3-4.1 55.5 97.7 41.5 224-41.7 307.2-83.2 83.2-209.5 97.2-307.2 41.8 1.5-4.8 2.8-9.6 4-14.3 4.8-18.9 8-38.5 9.7-50.3 4-26.8-18.9-49.7-45.7-45.8-11.9 1.6-31.5 4.8-50.4 9.7-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75c83.2-83.3 209.5-97.2 307.2-41.8zM51.5 410.1c18.5-5 38.8-8.3 50.9-10 .4-.1.7-.1 1-.1 5.1-.2 9.2 4.3 8.4 9.6-1.7 12.1-5 32.4-10 50.9-4.2 15.9-9.8 30.5-16.6 37.3-19.2 19.2-50.7 18.8-70.3-.7s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8.3-19 35.5-45 70.8-77.5 103.3s-67.8 58.5-103.3 77.4c-11.3 6-12.2 22.1-.3 26.8 57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3 6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3-6.3-6.3-17.2-3.6-19.8 4.9z" })
  }
), Nr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19M133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z" })
  }
), Xr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m407.4 75.5c5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5M160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z" })
  }
), Kr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M548.6 371.4C506.4 454.8 419.9 512 320 512S133.6 454.8 91.4 371.4c4.5-2.9 8.7-6.3 12.7-10.3 8.1-8.1 13.2-18.6 16.5-26.6 3.6-8.8 6.5-18.4 8.8-27.5 4.6-18.2 7.7-37 9.3-48.2 3.9-26.5-18.8-49.2-45.2-45.4-6.8.9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0s234.7 94.5 253.2 217.7c-10.3-2-19.8-3.5-26.6-4.4-26.5-3.9-49.2 18.8-45.2 45.4 1.6 11.3 4.6 30 9.3 48.2 2.3 9.1 5.2 18.8 8.8 27.5 3.3 8.1 8.4 18.5 16.5 26.6 3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4-.9 1-1.9 1.8-2.9 2.7-18.6 15.5-46.6 14.3-64.3-3.5-18.7-18.7-19.1-48.8-.7-67.2 8.6-8.6 30.1-15.1 50.5-19.6 13-2.8 25.5-4.8 33.9-6 5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2-.2-.2-.5-.4-.7-.7-14.1-14.1-22.5-62.9-25.5-84.4-.8-5.4 3.7-9.9 9-9 1 .1 2.2.3 3.3.5 8.2 1.2 19.2 3 30.6 5.5 20.4 4.4 41.9 10.9 50.5 19.6 18.4 18.4 18 48.5-.7 67.2-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5M281.6 228.8c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z" })
  }
), Qr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0 112.9 73.1 208.7 174.5 242.8C165.3 484 160 466.6 160 448v-47.3c-24-17.5-43.1-41.4-54.8-69.2-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256m116-114.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), Zr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M174.5 498.8C73.1 464.7 0 368.9 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448v-46.9c24.3-17.5 43.6-41.6 55.4-69.6 5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0M336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-16 130.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-45.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Jr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0 112.9 73.1 208.7 174.5 242.8C165.3 484 160 466.6 160 448v-47.3c-24-17.5-43.1-41.4-54.8-69.2-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256m176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M320 448v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), jr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19M208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64m128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64" })
  }
), Yr1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19m-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), _r1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), hd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256m-303.6-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), cd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M497.8 144.3c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0c-71.5 0-136.2 29.3-182.7 76.6 7.7 1.8 14.9 5.7 20.9 11.7 17.2 17.2 17.2 45 0 62.2l-1.5 1.5H232c22.1 0 40 17.9 40 40 0 2.6-.2 5.1-.7 7.5 10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4.7 4.9.7 7.5 0 22.1-17.9 40-40 40h-8v.9c0 22.1-17.9 40-40 40h-64.8c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2-5.4.7-10.8 1.1-16.3 1.1H456c-22.1 0-40-17.9-40-40V352h-8c-22.1 0-40-17.9-40-40 0-1.1 0-2.2.1-3.3-37-10.4-64.1-44.4-64.1-84.7 0-48.6 39.4-88 88-88 6.6 0 13 .7 19.2 2.1 11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2zM320 448c-35.3 0-64-21.5-64-48s28.7-48 64-48 64 21.5 64 48-28.7 48-64 48m90.3-208c3.8-4.2 6.1-9.9 6.1-16 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0l-61.1 61.2-.8.8c-36.4 37.2-36.1 96.9.8 133.8 17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16h-14c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H248c8.8 0 16-7.2 16-16s-7.2-16-16-16h-78.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H232c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9 0 7.4-6 13.4-13.4 13.4l-74.6.1c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4h-68c-8.8 0-16 7.2-16 16s7.2 16 16 16h67.5c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9 36.9-36.9 37.2-96.6.8-133.8l-.8-.8-45.1-45.2c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19-2.8.3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7" })
  }
), sd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336.9 498.9C438.7 465.1 512 369.1 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4-9.8-18-15.3-38.6-15.3-60.5v-86.5c0-28.7 23.3-52 52-52 1.8 0 3.6.1 5.3.3 15.5-32.4 48.5-54.7 86.7-54.7 28.7 0 54.5 12.6 72.1 32.6 14.8-2.4 30.4 2 41.8 13.4 12.2 12.2 16.5 29.4 12.8 45 1.1.9 2.2 1.9 3.2 3 18.1 18.1 18.7 47.1 1.8 65.9 16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM204.5 102c5.5 6.9 4.4 17-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5M310 124.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5zm-10.7 152.2c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.6c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z" })
  }
), vd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2-8.2 2-15.3 7.1-19.7 14.3-15.9 25.7-27.8 54-35 84.1-2.4 10.2.3 20.9 7.2 28.7-2.5 2.8-4.9 5.6-7.3 8.5C3 231.7.4 238.6.1 245.8c0 3.4-.1 6.8-.1 10.2 0 31.4 5 61.7 14.4 90.1 3.8 11.6 13.9 20 26 21.7 5.6.8 11.2 0 16.3-2C97.8 452.2 185.9 512 288 512c141.4 0 256-114.6 256-256 0-9.5-.5-18.8-1.5-28 6.1-1.1 11.9-3.9 16.5-8.3 8.3-7.9 11.8-19.6 9.2-30.7-7.2-30.1-19.1-58.4-34.9-84.1-3.3-5.3-8-9.5-13.5-12.1-.6-6-2.9-11.9-6.9-16.8-21.2-26.5-47-49.1-76.2-66.8-6.1-3.7-13.4-5.2-20.5-4.4-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0m-68.8 98.5c22.7-1.7 45.7-2.5 68.8-2.5 40 0 79.3 2.5 118 7.4l6.6.9c31.7 4.3 62.9 10.1 93.5 17.5.1.2.2.3.3.5 7.3 11.9 13.7 24.4 19 37.5 4.8 11.8 8.7 24.1 11.7 36.7-11.9-3.6-23.9-6.9-36-10-59.4-15.1-121.2-24-184.8-26h-.8c-9.1-.3-18.3-.4-27.5-.4-17.1 0-34.1.5-51 1.5-48.2 2.8-95.4 9.6-141.2 20-7 1.6-13.9 3.3-20.9 5-12.1 3.1-24.1 6.4-36 10l1.5-6c2.8-10.5 6.2-20.8 10.2-30.7 5.4-13.3 11.8-26 19.3-38 23.2-5.6 46.8-10.3 70.7-14.1.8-.1 1.6-.3 2.5-.4 25-3.9 50.4-6.9 76.1-8.7zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1-40.6 29.4-77 64.4-108 103.7-8.5 10.7-16.5 21.7-24.2 33.1-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1.2-9.1 5.9-7 12-13.8 18.2-20.5zm126 13.6c13.5-10.8 27.6-20.9 42.1-30.4 12.7 4.2 21.9 16.2 21.9 30.4 0 17.7-14.3 32-32 32s-32-14.3-32-32M476.2 82.4c-56.9-11.3-115.6-17.5-175.6-18.3 38.3-13 78.3-22.2 119.5-27.4 13.7 8.3 26.6 17.9 38.5 28.5 6.1 5.5 11.9 11.2 17.5 17.2zm-103 315.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3-8.4 2.7-17.4-2-20.1-10.5s2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8 44.2 0 77.2 18.3 98.8 37.9 6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), ed1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m344.5 111.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c17.2 19.8 47.3 41.5 90.1 41.5s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6M240 272v-32c0-41.5-31.5-75.6-72-79.6 10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9 1 8.1 7.9 14 15.9 14-10 13.4-16 30-16 48s6 34.6 16 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.7c9.8 4.3 20.6 6.7 32 6.7 18 0 34.6-6 48-16 0 8.8 7.2 16 16 16s16-7.2 16-16v-16zm144 41.3v6.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14 1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8-40.4 4-72 38.1-72 79.6 0 44.2 35.8 80 80 80 11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4m224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32" })
  }
), ld1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-79.6-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8.3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9zm-64 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), td1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 8.3-.4 16.6-1.2 24.7 0 .5-.1 1.1-.1 1.6l-14.8 200c-1.2 16.8-15.1 29.7-31.9 29.7s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9c-4.5 12.8-16.6 21.4-30.2 21.4-11.5 0-21.9-6.1-27.5-15.7-27.6 10.2-57.4 15.7-88.5 15.7-69.4 0-132.3-27.6-178.4-72.4-5.7 5.3-13.3 8.4-21.6 8.4-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256M56 415.8v.2zl20-120.2c2.1-12.3-7.4-23.6-20-23.6s-22.1 11.3-20.1 23.7zM344 400l28 80 28-80v-40h-56zm55.3-56c-3.8-22.7-23.6-40-47.3-40h-8v40zm-71.3 0v-40h-64v40zm0 56v-40h-64v40l32 48zm-80-96h-64v40h64zm0 56h-64v40h64zm-80-16v-40h-8c-23.8 0-43.5 17.3-47.3 40zm0 56v-40h-55.3c3.8 22.7 23.6 40 47.3 40zm40.4-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M464 480l21.8-232.1c1.2-12.8-8.9-23.9-21.8-23.9s-23 11.1-21.8 23.9z" })
  }
), wd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z" })
  }
), gd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0" })
  }
), id1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c35.4 0 69.1-7.2 99.7-20.2-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1 37.2-10.4 73.8 10.1 87.5 44 12.7-1.6 25.1.4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64m194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z" })
  }
), md1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), ad1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1m120.8-101.3-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z" })
  }
), od1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1m36.7-199.4 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z" })
  }
), nd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1M144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z" })
  }
), rd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1M144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), dd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M494 350.5c-4.5 1-9.2 1.5-14 1.5H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c108 0 200.4-66.9 238-161.5M144.4 176a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0M188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c17.5-23.3 45.4-38.4 76.8-38.4 13.6 0 26.6 2.8 38.4 8 8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3-20.9 0-39.5 10-51.2 25.6z" })
  }
), Sd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M410.5 281.7 541.8 222C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222l131.3 59.7c8-15.3 24.1-25.7 42.5-25.7h160c18.4 0 34.5 10.4 42.5 25.7m5.5 32.6V384h93.8c21.8-37.6 34.2-81.3 34.2-127.9zM413.3 416c-6.6 18.6-24.4 32-45.3 32H208c-20.9 0-38.7-13.4-45.3-32H88.1c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96zM160 384v-69.7L32 256.1c0 46.6 12.5 90.3 34.2 127.9zm-4.7-180.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3M336 176c-8.8 0-16-7.2-16-16s7.2-16 16-16c55.4 0 93.6 23 107.3 36.7 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176M208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), zd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m208.4-48a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), pd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M160 336h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Md1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2h1.2c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h12.9c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256 64 114.6 178.6 0 320 0s256 114.6 256 256c0 16.7-1.6 33-4.6 48.8m-324.2-84.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0-16.6 61.8zM441 238.7a32 32 0 1 0-61.8-16.6 32 32 0 1 0 61.8 16.6m-227.8 60.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z" })
  }
), xd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M427.2 446.3C381.9 487.2 321.8 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 62.8-22.6 120.3-60.1 164.9-2.5-8.6-3.9-17.7-3.9-26.9V224c0-61.9-50.1-112-112-112s-112 50.1-112 112 50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1-160 0m-79.6-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64M144 352c0 8.8 7.2 16 16 16 14.3 0 37.9 2.9 60.6 11.7 22.8 8.8 42.7 22.7 53.1 43.4 4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59-27-10.3-54.6-13.8-72.3-13.8-8.8 0-16 7.2-16 16M305.2 89.9c8-6.4 18-9.9 28.2-9.9 8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-8.6-5.7c-12.7-8.5-27.6-13-42.8-13-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5z" })
  }
), Hd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-12.3-84.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3 7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3h-99.2c-4.6 22.8-18.9 42-38.4 53.3-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8" })
  }
), Vd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M498.2 339.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8 4.9-1.5 9.9-2.4 15-2.7 1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c23.3-23.3 60.1-24.9 85.3-4.7l51-30.6c30-18 64.1 16.1 46.1 46.1l-30.6 51c20.2 25.1 18.6 62-4.7 85.3-1.3 1.3-2.6 2.5-4 3.7-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4-1.6-5.1-2.6-10.5-2.9-15.8-1.4-1.2-2.7-2.4-4-3.7-23.3-23.3-24.9-60.1-4.7-85.3l-30.6-51c-18-30 16.1-64.1 46.1-46.1l51 30.6c25.1-20.2 62-18.6 85.3 4.7 1.3 1.3 2.5 2.6 3.7 4 5.5.3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9-5.4-.3-10.8.7-15.7 3.1-1-5.2-3.3-10.1-6.9-14.4-.6-.7-1.2-1.4-1.8-2-12-12-31.2-12.5-43.8-1.4-.5.5-1 .9-1.5 1.4-3.7 3.7-6.3 8.1-7.8 12.8L332.8 323c-2.8-1.8-6.5-1.4-8.8 1l-.2.2c-.3.2-.6.5-.7.8-1.6 2.3-1.7 5.3-.1 7.7l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8-4.7 4.7-7.6 10.4-8.8 16.4-.5 2.4-.7 4.8-.6 7.2.2 7.9 3.4 15.7 9.4 21.7.7.7 1.3 1.3 2 1.9 4.2 3.6 9.2 5.9 14.4 6.9-1.5 3.2-2.5 6.7-2.9 10.1-.2 1.8-.3 3.7-.2 5.6 0 .7.1 1.4.2 2 .8 6.9 3.9 13.5 9.1 18.8 12.5 12.5 32.8 12.5 45.3 0 2.1-2.1 3.8-4.3 5.2-6.7 18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2 12.5-12.5 12.5-32.8 0-45.3-4.3-4.3-9.5-7.1-15-8.5zM142.4 485.5c.4-1.8.7-3.6.8-5.4.3-5.4-.7-10.8-3.1-15.7 5.2-1 10.1-3.3 14.4-6.9.7-.6 1.4-1.2 2-1.8 1.5-1.5 2.8-3.1 4-4.8 8-11.9 7.1-27.9-2.5-38.9-.5-.5-.9-1-1.4-1.5-3.6-3.6-7.9-6.2-12.5-7.7L189 333c1.8-2.8 1.4-6.5-.9-8.8-2.3-2.3-5.9-2.7-8.7-1L108 367.5c0-.2-.1-.3-.1-.5-1.5-4.8-4.1-9.4-8-13.2-.2-.2-.4-.4-.7-.6-.3-.3-.6-.5-.8-.8-12.6-11.1-31.7-10.6-43.8 1.4-.7.7-1.3 1.3-1.9 2-3.6 4.3-5.9 9.2-6.9 14.4-4.9-2.4-10.3-3.4-15.7-3.1-1.5.1-3.1.3-4.6.6-5.9 1.2-11.6 4.1-16.2 8.7-12.5 12.5-12.5 32.8 0 45.3 2.1 2.1 4.3 3.8 6.7 5.2-14.3 18.7-13 45.8 4.3 63s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7 12.5 12.5 32.8 12.5 45.3 0 4.4-4.4 7.2-9.8 8.5-15.4zM112 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m192 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16zm95.2-133.1c2.8 8.4-1.7 17.4-10.1 20.2-35.5 11.8-64.4 34.8-73.7 44.1-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c12-12 45-38.1 86.3-51.9 8.4-2.8 17.4 1.7 20.2 10.1zm-286.4 0c2.8-8.4 11.9-12.9 20.2-10.1 41.3 13.8 74.2 39.9 86.3 51.9 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1-8.4-2.8-12.9-11.9-10.1-20.2z" })
  }
), Cd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M531.7 400C485.6 467.6 408 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0c113.4 0 209.7 73.8 243.3 176H560c-44.2 0-80 35.8-80 80 0 18 6 34.6 16 48h-80c-1 0-2 0-3 .1-1.2-2.3-2.7-4.4-4.3-6.4-4.3-5.2-10.1-9.7-16.7-13.4-13.3-7.4-30.6-12.3-48-12.3-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3 6.6-3.7 12.5-8.2 16.7-13.4 1.6-2 3.1-4.1 4.3-6.4 1 .1 2 .1 3 .1h115.8zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM512 256c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-26.5 0-48-21.5-48-48M51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8c-35.5 30.7-63.5 69.9-80.7 114.4zm3.8-140C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9s10.8-6 16.7-4.1z" })
  }
), Ld1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-48-128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m179.2-113.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2m-59.1-55.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-23 11.4c-7.9 4-17.5.7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z" })
  }
), Bd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zm-167.2 87.4 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5" })
  }
), ud1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m302.7 171.9c6.6-5.9 7.1-16 1.2-22.6-9.2-10.2-25.2-21.3-47.9-21.3s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6 10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9 1 8.1 7.9 14 15.9 14-10 13.4-16 30-16 48 0 44.2 35.8 80 80 80s80-35.8 80-80m192 0c0-18-6-34.6-16-48 8 0 14.9-5.9 15.9-14 1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8-40.4 4-72 38.1-72 79.6 0 44.2 35.8 80 80 80s80-35.8 80-80zm-304-8c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4m224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32" })
  }
), Rd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m161.3 126.1c-5.4 12.3 8.7 21.6 21.1 16.4 22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1M176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), $d1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m208.4-16a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64M144 352c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16m184.8-210.2c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), kd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-68.7-155.3c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm199.9-118.3c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2m82.4-163.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.7 20.3c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-7.6-11.6c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z" })
  }
), Pd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-64-144h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16m32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4m128 64c-35.3 0-64-28.7-64-64 0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4 0 35.3-28.7 64-64 64" })
  }
), Fd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v189.8C51.5 433.5 0 350.8 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0m121.6 0c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), Td1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8 7 9.2 18.1 24.6 27.7 40.7 4.8 8.1 9.6 17 13.2 25.7 3.4 8 7.1 19 7.1 30.5 0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512M79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5m291.3 7.4c-6.6 5.9-16.7 5.4-22.6-1.2-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16-17.9 44.1-37.3 83.8-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-12.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z" })
  }
), Ad1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0m240 80c0-8.8 7.2-16 16-16 45 0 85.6 20.5 115.7 53.1 6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47 0-20 28.6-60.4 41.6-77.7 3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47m207.6-208a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Dd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M258.1 58.5c14.5-9.8 18.4-29.4 8.8-44-.1-.1-.2-.3-.3-.4-9.9-14.7-29.8-18.5-44.4-8.6l-187.1 127c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5 4.4-.9 8.8-2.1 13.1-3.8.3-.1.7-.3 1-.4l1.5-.6c5.6-2.3 10.9-5.4 16-9l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7-4.8-6.7-11.8-10.9-19.3-12.5-3.5-.7-7.2-.9-10.8-.4-5.1.7-10.1 2.6-14.6 5.8L128 185.8v-39l27.3-18.5 13.1-8.9 89.7-60.9zM352 0c-18.4 0-36.3 1.9-53.5 5.6 12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2 8.6 11.9 12.6 25.7 12.2 39.3 4.8-2.8 10.4-4.5 16.3-4.5 17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0m-94.6 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), yd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6 20.6-2.5 41.7 3.5 57.8 16.9 57.5 48 87.8 118 98 187 30.2 12.6 63.3 19.5 98.1 19.5s68-6.9 98.2-19.5c10.2-69 40.4-139 98-187 16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48m-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7 62.8-54.7 90.1-39.8 31.1 56.9 8.7 93.7m183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7 67.6 2.9 90.1 39.8 18.6 78.8-8.7 93.7m-353.3 47.3C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3 26.4 40 43.6 75.3 43.2 125.7H192c-7-68.4-34.8-137-88.7-181.9zm485.1-3.1c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512h109.8c-.4-50.5 16.7-85.7 43.2-125.7 13.1-19.8 7.6-46.3-12.4-59.3z" })
  }
), bd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0 103.8 61.8 193.1 150.5 233.3-4.2-10.3-6.5-21.5-6.5-33.3v-48c0-37.3 23.2-69.2 56-82v-50.1c-14.8-6.9-26.6-15.9-35.3-24.6-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9 4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6v58.3c17.9 11.7 31.3 29.7 37 50.9 16-3.2 33.3.6 46.9 11.9 18.4 15.3 24.5 39.9 17.1 61.3 60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256M176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h48zm-56 160c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h65.5c21.4 0 41.6-9.5 55.3-25.9l25.6-30.7c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6h-10L224 419.5z" })
  }
), fd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0-46.6-12.5-90.3-34.2-128H432c-19.4 0-36.9-11.7-44.3-29.6-7.1-17.1-3.7-36.7 8.6-50.4-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256M272 96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L310.6 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L297.4 96zm-56 288a40 40 0 1 1 80 0 40 40 0 1 1-80 0m171.2-145.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2M416 16c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4S425.5 96 432 96h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0h-64c-8.8 0-16 7.2-16 16" })
  }
), Ud1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.1 477.1c-37.9 22.2-82 34.9-129.1 34.9C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 37-7.8 72.1-22 103.9-7.4-6.2-15.1-11.8-22.7-16.7C429.6 318.7 383.6 304 352 304c-15.3 0-28.5 10.9-31.4 25.9s5.3 30.1 19.5 35.8c21 8.4 31.6 23.5 37.4 41.7 6.3 19.4 6.5 40.3 6.5 56.6 0 4.5.4 8.9 1.1 13.1M176 389.5c-6.8 11.1 6 20.7 18.3 16.4 18.9-6.5 39.8-10.1 61.8-10.1s42.9 3.6 61.8 10.1c12.3 4.2 25.1-5.3 18.3-16.4C321 364.8 290.8 348 256 348s-64.9 16.8-80.1 41.5zm140.8-143.1c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2M512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128 48 0 160 48 160 128" })
  }
), Gd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6m53.5-96.7-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z" })
  }
), qd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80 114.6 0 256 0s256 35.8 256 80m-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32 192-14.3 192-32M16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272m148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5m53.5-56.7c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z" })
  }
), Wd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448.2 34.3c-1.3 19.7 5.5 39.8 20.5 54.9l55.5 55.8c9.2 9.3 21.1 14.2 33.2 14.9 12 29.7 18.6 62.1 18.6 96.1 0 37.4-8 73-22.5 105.1-27-15.2-61.9-11.3-84.8 11.8-25.8 26-27.5 67.1-4.9 94.9-41 27.9-90.5 44.2-143.8 44.2-61.3 0-117.6-21.6-161.7-57.6l13.1-13.1c27.6-27.7 27.6-72.6 0-100.4-24.8-25-63.6-27.6-91.3-7.7-1.7-1.2-3.5-2.4-5.2-3.4C67.8 306.5 64 281.7 64 256 64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.3M205.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6m-.7-90.3c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2m230.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0M573.7 11.5c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 25.3zm54.9 384c15.2 15.3 15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0l13.7 13.8 13.7-13.8c15.2-15.3 39.8-15.3 54.9 0m-534.9-32c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L80 377.3z" })
  }
), Ed1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 512c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256m-91.9-162.5C246 370.2 276.6 392 320 392s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6m44.3-77.5c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6L187 239.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2S291.3 274 283 271.2l-10.9-3.6c.2 1.5.3 2.9.3 4.4zm128 32c-17.7 0-32-14.3-32-32 0-1.6.1-3.2.3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8 0 17.7-14.3 32-32 32z" })
  }
), Od1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 0c-13.3 0-24 10.7-24 24v48h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V24c0-13.3-10.7-24-24-24M224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448m-79.6-304a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6c-26.4 29.8-65 48.7-108 48.7s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z" })
  }
), Id1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6m47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0" })
  }
), Nd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5 8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5-5.8-6.7-15.9-7.4-22.6-1.6M352 416c26.5 0 48-21 48-47 0-20-28.6-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47M208.4 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Xd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c61.5 0 118-21.7 162.1-57.9-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3 1.5.4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zm-132.8 67.3 55.7 33.1c22.6 13.4 51.8 5.8 65-17 13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6zm-153-160.5-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z" })
  }
), Kd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512m91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6M367.6 304a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), Qd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z" })
  }
), Zd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Jd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M411.1 495.3c-17-21.6-27.1-48.9-27.1-78.5V386c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14v30.8c0 29.6-10.1 56.9-27.1 78.5 28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7M320 0C183.1 0 71.3 107.5 64.3 242.6c16.8-5.8 36.2-2 49.6 11.4l47.1 47.1c9.4-13.7 25.1-22.7 43-22.7 28.7 0 52 23.3 52 52v19.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4v-19.2c0-28.7 23.3-52 52-52 17.9 0 33.6 9 43 22.7l47.1-47.1c13.4-13.4 32.8-17.2 49.6-11.4C568.7 107.5 456.9 0 320 0m-38.4 228.8-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zM68.7 299.3l51.3 51.3c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-67.3-67.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-51.3-51.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-19.3-19.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2v-86.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm502.6 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.6c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4z" })
  }
), jd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m96-48c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32h-64c-8.8 0-16 7.2-16 16m279.8 130.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h112.6c35.2 0 65.2-25.4 71-60.2zM288 208c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32h-64c-8.8 0-16 7.2-16 16" })
  }
), Yd1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m56.9-137.1 14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5-46.9 1.9-82.2 45-78.1 84.3v.6c2 40.2 40.8 70.7 76.2 66.7h.6c36.3-2 62.1-35.7 58.4-64.5v-.6c-2.1-29.8-31.3-51-56-47.5h-.6c-25.7 2.2-42 26.2-38.9 44.5l.1.4v.4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1h.3c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2-.9-.5-1.8-.9-2.6-1.2 1.7 1.9 2.8 4.2 3 6.9 1 11.1-8.8 15.8-14.1 16.4-6.6.8-13.4-2.2-17.6-8.5-5-6.8-4.4-15.6-1.8-21.8 2.9-7 8.9-13.2 17.8-16 9.2-3.3 19.4-1.3 27.5 3.3 8.3 4.9 15.5 13.4 17.9 24.8 5.8 22.8-11.9 49.5-39.5 53.6-27.7 5.3-59.8-16.2-63.6-49.2-5.4-33 21.9-68.7 60.3-72.1 38.2-5.2 79.6 25.8 82.9 69.3 5.4 43.3-31.5 88.2-80.6 91.2-48.8 5.3-99.6-35.2-102.5-89.1-5.5-53.8 41.1-108.1 101-110.5 6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3v-.6c-2-40.2-40.8-70.7-76.2-66.7h-.6c-36.3 2-62.1 35.7-58.4 64.5v.6c2.1 29.8 31.3 51 56 47.5h.6c25.7-2.2 42-26.2 38.9-44.5l-.1-.4v-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3.1h-.3c-15.2 2.1-21.9 16.3-19.9 24l.1.4.1.4c.9 4.3 3.4 7.4 6.5 9.2.9.5 1.8.9 2.6 1.2-1.7-1.9-2.8-4.2-3-6.9-1-11.1 8.8-15.8 14.1-16.4 6.6-.8 13.4 2.2 17.6 8.5 5 6.8 4.4 15.6 1.8 21.8-2.9 7-8.9 13.2-17.8 16-9.2 3.3-19.4 1.3-27.5-3.3-8.3-4.9-15.5-13.4-17.9-24.8-5.8-22.8 11.9-49.5 39.5-53.6 27.7-5.3 59.8 16.2 63.6 49.2 5.4 33-21.9 68.7-60.3 72.1-38.2 5.2-79.6-25.8-82.9-69.3-5.4-43.3 31.5-88.2 80.6-91.2 48.8-5.3 99.6 35.2 102.5 89.1 5.5 53.8-41.1 108.1-101 110.5-6.6.3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z" })
  }
), _d1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c141.4 0 256-114.6 256-256 0-16.6-1.6-32.8-4.6-48.5l2.6-15.7c7.9-47.6-20.5-91.8-63.3-106.6C399.8 32.9 331.8 0 256 0S112.2 32.9 65.3 85.2C22.4 100-6 144.2 2 191.8l2.6 15.7C1.6 223.2 0 239.4 0 256c0 141.4 114.6 256 256 256m-72.7-240h-78.6c-23.5 0-43.5-17-47.3-40.1l-8-48C44.4 154.6 67 128 96.7 128h94.7c14.4 0 27.1 6.2 35.8 16H285c8.7-9.8 21.4-16 35.8-16h94.7c29.7 0 52.2 26.6 47.3 55.9l-8 48c-4 23.1-24 40.1-47.5 40.1h-78.6c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9h-33.4c0 2.6-.2 5.2-.7 7.9l-8 48c-3.8 23.1-23.8 40.1-47.3 40.1m-19.2 69.5C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6z" })
  }
), hS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), cS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0C178.6 0 64 114.6 64 256h512C576 114.6 461.4 0 320 0m-79.6 224c-17.7 0-32-14.3-32-32 0-8.8 3.6-16.8 9.3-22.6L187 159.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2S291.3 194 283 191.2l-10.9-3.6c.2 1.5.3 2.9.3 4.4 0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6.1-3.2.3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM48 288c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm352 96h-16v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16m-80 0v32h32v-32zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7M448 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0m104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48M208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m-24 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-56-120v1.8c4.6.8 8.7 1.7 12.1 2.6 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9-4.1.5-6.3 1.4-7.4 2.2-.6.4-1.2.9-1.5 2.9-.2 1-.1 1.6-.1 1.8.1.1.5.6 1.5 1.3 3.7 2.5 9.6 4.4 19.2 7.3l.7.2c8 2.4 19.1 5.8 27.6 11.9 4.7 3.4 9.3 8.2 12.1 14.7 2.9 6.6 3.4 13.8 2.2 21.1-2 11.5-7.9 20.5-17 25.9-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5.5-.3 1.4-.9 2-4 .2-1.2.2-1.9.2-2.3 0-.4-.1-.6-.1-.6 0-.1-.3-.6-1.6-1.6-3.5-2.5-9.3-4.6-18.7-7.4l-1.5-.4c-7.7-2.3-18.3-5.5-26.4-11-4.7-3.2-9.4-7.7-12.4-14.1-3.1-6.5-3.7-13.7-2.5-20.9 1.8-10.2 7-18.1 14.5-23.5 5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm-31.9 39.4a.1.1 0 1 0 .1-.1.1.1 0 1 0-.1.1" })
  }
), sS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0c112 0 207.2 72 242 172.2-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4-55.1 0-93.8 27.9-116.1 53.5-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6 5.2-4.5 6.8-11.6 4.5-17.7l9.4-9-24.8-24.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.1 25.1 15.3-14.8-25.4-25.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.7 25.7 15.3-14.8-26-26c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.3 26.3 15.2-14.7-26.6-26.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.9 26.9 12.5-12c.1 3.2.2 6.4.2 9.6zm-303.6-48a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), vS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 141.4-114.6 256-256 256-10.6 0-21.1-.6-31.4-1.9 4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1-1.3-24.4-16.5-46.1-39.2-55.6l-122.6-51.6c-8.1-3.4-17.5.4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256m-303.6-80a32 32 0 1 0-64 0 32 32 0 1 0 64 0m128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64M143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3c-30.9-26.5-75-30.6-110.2-10.5l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), eS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.3-183.3c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4 6.2 11.7 10.3 24.4 10.3 35.9 0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7C315 397.2 286.4 392 257.6 392h-3.2c-28.8 0-57.3 5.2-84.3 15.3l-20.5 7.7c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9 6.3-12 15.3-24.3 26.4-35.4zm-31.2-182 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z" })
  }
), lS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 141.4-114.6 256-256 256-11.5 0-22.9-.8-34-2.2.6-1.9 1-3.9 1.4-5.9l18.4-110.2 5.4 3.6c5.4 3.6 12.4 3.6 17.8 0l39-26.1 39.1 26.1c4.8 3.2 10.9 3.6 16 1l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-23.7 11.8-40.3-26.8c-5.4-3.6-12.4-3.6-17.8 0l-39 26.2-8.5-5.7 7.9-47.2c2.5-15.3-2.4-30.9-13.4-41.8s-26.5-16-41.8-13.4l-192 32c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256M133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5 0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6 0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5 0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6zM219.3 292.7c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5-84.2 21.1c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3.8 13.9 4.5z" })
  }
), tS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0 108.6 67.7 201.5 163.1 238.6-12-17.8-19.1-39.4-19.1-62.6v-10.5c-22.4-20.1-39-46.1-47.2-75.4-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1-8.2 29.4-24.9 55.4-47.2 75.4V432c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256m192-152v9.8c4.6.8 8.7 1.8 12.1 2.7 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2-4 .4-6.1 1.4-7.1 2.1-2.6 1.9-2.6 5.6-.2 7.2 6.9 4.8 15 6.9 23.3 9.1 8.3 2.2 16.7 4.4 23.9 9.4 4.8 3.3 9.5 8 12.4 14.6 3 6.6 3.5 13.9 2.2 21.2-2 11.5-7.9 20.4-17 25.9-4.6 2.8-9.5 4.4-14.4 5.2v9.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c-8.4-1.9-16-4.4-21.1-6-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5 2.8-1.7 3.2-6.2.6-8-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2-4.8-3.3-9.5-8-12.4-14.6-3-6.6-3.5-13.9-2.2-21.2 1.8-10.2 6.9-18.2 14.4-23.6 5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16s16 7.2 16 16zm144-16c8.8 0 16 7.2 16 16v9.8c4.6.8 8.7 1.8 12.1 2.7 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2-4 .4-6.1 1.4-7.1 2.1-2.6 1.9-2.6 5.6-.2 7.2 6.9 4.8 15 6.9 23.3 9.1 8.3 2.2 16.7 4.4 23.9 9.4 4.8 3.3 9.5 8 12.4 14.6 3 6.6 3.5 13.9 2.2 21.2-2 11.5-7.9 20.4-17 25.9-4.6 2.8-9.5 4.4-14.4 5.2v9.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c-8.4-1.9-16-4.4-21.1-6-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5 2.8-1.7 3.2-6.2.6-8-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2-4.8-3.3-9.5-8-12.4-14.6-3-6.6-3.5-13.9-2.2-21.2 1.8-10.2 6.9-18.2 14.4-23.6 5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm0 264H176v80c0 44.2 35.8 80 80 80s80-35.8 80-80zm-80 16c5.9 0 10.7 4.9 10.7 10.9v6.7c3 .6 5.8 1.2 8.1 1.8 5.7 1.6 9.1 7.5 7.6 13.3s-7.4 9.3-13 7.7c-5.5-1.5-12.6-2.8-18-2.2-2.7.3-4.1.9-4.7 1.4-1.7 1.3-1.7 3.8-.2 4.9 4.6 3.3 10 4.7 15.5 6.2 5.6 1.5 11.2 3 15.9 6.4 3.2 2.3 6.3 5.5 8.3 9.9 2 4.5 2.3 9.4 1.5 14.4-1.3 7.8-5.3 13.9-11.3 17.7-3.1 1.9-6.4 3-9.6 3.6v6.1c0 6-4.8 10.9-10.7 10.9s-10.7-4.9-10.7-10.9v-7.3c-5.6-1.3-10.7-3-14-4.1-5.6-1.9-8.6-8.1-6.8-13.8s7.9-8.8 13.5-6.9c6.3 2.1 14.6 4.7 21.3 4.8 3.3.1 5.1-.5 5.9-1 1.8-1.1 2.1-4.3.4-5.5-2.3-1.7-6.2-2.9-12.6-4.8l-.8-.2c-5.2-1.5-12.6-3.7-18.1-7.6-3.2-2.3-6.3-5.5-8.3-9.9-2-4.5-2.3-9.4-1.5-14.4 1.2-6.9 4.6-12.4 9.6-16.1 3.6-2.6 7.5-4.1 11.3-4.9v-6.4c0-6 4.8-10.9 10.7-10.9z" })
  }
), wS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448v-31.3c10.2-7.2 16-15.7 16-24.7 0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V448c0 18.6 5.3 36 14.5 50.8-41.3-13.9-78-38-106.9-69.4C116.9 415 128 393.5 128 369c0-11.4-3.8-22.4-7.1-30.5-3.7-8.7-8.4-17.6-13.2-25.7-9.6-16.1-20.7-31.5-27.7-40.7-11.6-15.6-31.7-19.9-48-12.8V256C32 114.6 146.6 0 288 0s256 114.6 256 256M96 369c0 14.2-6.4 26.9-16.5 35.5C71 411.7 60 416 48 416c-26.5 0-48-21-48-47 0-17.3 21.4-50 35.7-69.7 2.2-3 4.2-5.8 5.9-8.1 3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369m239.6-97a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm3.3 231.3V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-45.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z" })
  }
), gS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16m176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16" })
  }
), iS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0m320 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24M48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24m464 0v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24M96 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0m128-40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-142.1 52.5c-6.4 6.1-6.6 16.2-.5 22.6C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9c6.1-6.4 5.9-16.5-.5-22.6s-16.5-5.9-22.6.5c-16 16.6-38.5 27-63.5 27s-47.5-10.4-63.5-27.1c-6.1-6.4-16.2-6.6-22.6-.5z" })
  }
), mS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9 16.7-12.6 26.4-27.7 26.4-44 0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256 32 114.6 146.6 0 288 0s256 114.6 256 256M148 141.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6 0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5 0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6 0-9-9.6-14.7-17.5-10.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64m480 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-320-51.9v-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7v57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6 0 10.3-8.3 18.6-18.6 18.6H114.6c-10.3 0-18.6-8.3-18.6-18.6 0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32m-48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), aS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-91.3-183.3c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4 6.2 11.7 10.3 24.4 10.3 35.9 0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7C315 397.2 286.4 392 257.6 392h-3.2c-28.8 0-57.3 5.2-84.3 15.3l-20.5 7.7c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9 6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z" })
  }
), oS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m155.3-164.7L372 386.6a73.114 73.114 0 0 1-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1l-14.2-8.9a67.216 67.216 0 0 0-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7a67.53 67.53 0 0 0 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2 10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2-28 42-69.6 64.1-88.3 70.3-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7 4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6M336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64" })
  }
), nS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zm-38-142.5a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M192 160c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z" })
  }
), rS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5-11.5-15.8-18.4-35.4-18.4-56.5v-39.8c-10.4-6.2-20.1-13.7-28.9-22.2-10.2-9.9-6.6-26.3 5.7-33.4l238.3-137.7c12.3-7.1 28.3-2 31.8 11.8 15.2 59.4-5.9 124.1-55 165V448c0 15.4-3.6 30-10.1 42.9 8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128m112-8a72 72 0 1 1 144 0 72 72 0 1 1-144 0m96.1 296v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64M152 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0m144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), dS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M492.4 354.4C505 324.1 512 290.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c50.3 0 97.2-14.5 136.7-39.5-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0M144 336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16m48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16m48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m98.2 132.4c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5l29.1 58.1zm62.3-36.9c4.7 4.7 4.7 12.3 0 17l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0" })
  }
), SS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M166.6 162.5c5.9 7.1 8 16.7 5.7 25.7-.3 1.3-.6 2.6-.7 3.9 17.2.6 33.9 8.6 45.1 22.8 28.3.2 52.1 20.3 58.1 47.4 4.8 2.4 9.2 5.4 13.1 8.8 3.9-3.4 8.3-6.4 13.1-8.8 6-27.1 29.8-47.1 58.1-47.4 17.3-21.9 47.4-29.2 72.8-17 1.5-.7 3-1.4 4.5-1.9.1-2.6-.2-5.2-.9-7.8-2.3-9-.1-18.6 5.7-25.7 8.8-10.7 8.8-26.3 0-37-5.9-7.1-8-16.7-5.7-25.7 3.4-13.5-3.2-27.6-15.7-33.3-8.3-3.8-14.3-11.5-16.1-20.6-2.7-13.7-14.6-23.5-28.3-23.1-9.1.3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0-12.2-6.4-27.1-2.9-35.3 8.2-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37zm48.8 84.4c-3.6.1-7.2-.5-10.5-1.8-5-1.9-9.4-5.2-12.7-9.6-8.2-11.2-23.2-14.6-35.3-8.2-8.1 4.3-17.7 4.3-25.8 0-12.2-6.4-27.1-2.9-35.3 8.2-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37 5.9 7.1 8 16.7 5.7 25.7-3.4 13.5 3.2 27.6 15.7 33.3 8.3 3.8 14.3 11.5 16.1 20.6 2.7 13.7 14.6 23.5 28.3 23.1 9.1-.3 17.8 4 23.2 11.4 8.2 11.2 23.2 14.6 35.3 8.2 8.1-4.3 17.7-4.3 25.8 0 12.2 6.4 27.1 2.9 35.3-8.2 5.5-7.4 14.1-11.7 23.2-11.4 13.7.4 25.7-9.4 28.3-23.1 1.8-9.1 7.8-16.8 16.1-20.6 4.1-1.9 7.6-4.7 10.3-8.1-3.1-10.1-3.7-21-1.2-31.7-17.3-22.1-17.3-53.3 0-75.4-2.4-10.7-1.9-21.7 1.2-31.7-2.7-3.4-6.2-6.2-10.3-8.1-8.3-3.8-14.3-11.5-16.1-20.6-.2-1-.5-2-.8-3-3.7-12.1-14.9-20.4-27.6-20.1zM224 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0M80 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m453.4-42.6c4.1-4.1 7-9.2 8.7-14.9 0-.2.1-.3.1-.5 7-25-7.6-62.8-38.6-93.7-23.3-23.3-50.5-37.4-73.1-39.9-2-.2-3.9-.4-5.8-.4-9.6-.2-18.3 1.8-25.1 6.4 0 0-.1 0-.1.1-1.6 1.1-3.1 2.3-4.5 3.6l-.5.5c-19.2 19.2-11.4 59 16.6 94.3 4 5 8.4 10 13.2 14.8 38.4 38.4 87.2 51.7 109.1 29.8zM508.6 412c-26-7.1-52.6-23.3-74.9-45.7s-38.6-48.9-45.7-74.9c-5.3-19.6-6.4-43.3 4.2-63.6-3.2 1.9-6.1 4.4-8.4 7.6-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37 5.9 7.1 8 16.7 5.7 25.7-3.4 13.5 3.2 27.6 15.7 33.3 8.3 3.8 14.3 11.5 16.1 20.6 2.7 13.7 14.6 23.5 28.3 23.1 9.1-.3 17.8 4 23.2 11.4 8.2 11.2 23.2 14.6 35.3 8.2 8.1-4.3 17.7-4.3 25.8 0 12.2 6.4 27.1 2.9 35.3-8.2 5.5-7.4 14.1-11.7 23.2-11.4 13.7.4 25.7-9.4 28.3-23.1 1.8-9.1 7.8-16.8 16.1-20.6 12.5-5.7 19.2-19.8 15.7-33.3l-.1-.6c-18.1 6.4-38 5-54.9.4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32m16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), zS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-15.7 160h31.4c11.8 0 23 3.2 32.6 8.9-.2 2.3-.3 4.7-.3 7.1 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48v-80H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.5 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-2.4-.1-4.8-.3-7.1 9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80" })
  }
), pS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-22.4 160h44.8c9.2 0 18.1 1.6 26.4 4.5-.5 3.8-.8 7.6-.8 11.5 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160M368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.5 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-3.9-.3-7.8-.8-11.5 8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80" })
  }
), MS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-22.4 160h44.8c9.2 0 18.1 1.6 26.4 4.5-.5 3.8-.8 7.6-.8 11.5 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160M368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.6 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-2.4-.1-4.7-.3-7.1 9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80" })
  }
), xS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 413.6C355.7 398.2 432 312 432 208 432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6V448H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96zM184.9 68.5l39.4 97.5c18.5-25.3 50-39.8 83.3-35.1 48.1 6.8 81.7 51.3 74.9 99.4-1.2 8.8-9.3 14.8-18.1 13.6l-104.2-14.7c12.6 28.7 9.5 63.2-11.2 89.7-29.9 38.3-85.2 45.1-123.5 15.2-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5-18.2-45.1 3.6-96.3 48.7-114.5 8.2-3.3 17.5.6 20.8 8.8M224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), HS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M258.6 0c-1.7 0-3.4.1-5.1.5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224h-2.6C13.2 224 0 237.2 0 253.4c0 1.7.1 3.4.5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4 1.7 0 3.4-.1 5.1-.5 85.5-16.5 137.9-101.8 123-188.8-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4 0-1.7-.1-3.4-.5-5.1-16.5-85.5-101.8-137.9-188.8-123-17 2.9-32.9 8.4-47.4 15.9L288 32v-2.6C288 13.2 274.8 0 258.6 0M256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), VS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96C0 43 43 0 96 0s96 43 96 96zm181.4 32-48.6 118c-3.2 7.7-4.8 16-4.8 24.4V480c0 11.7 3.1 22.6 8.6 32H48c-26.5 0-48-21.5-48-48V128zM160 480V270.3c0-4.2.8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7l127.1-60.2c8.7-4.1 18.7-4.1 27.4 0l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2V480c0 17.7-14.3 32-32 32H432v-64c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v64H192c-17.7 0-32-14.3-32-32m160-232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24" })
  }
), CS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v12l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96-12-31-3.9-1-.1-1 .1-31 3.9-96 12c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32M0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192v-43.8l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160 0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s-14.3-32-32-32h-36.1c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32zm436.8 199.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4z" })
  }
), LS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32M32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h100.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32 0-88.4-71.6-160-160-160h-32l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256v-43.8l-32-4-32 4V224h-18.7c-8.5 0-16.6 3.4-22.6 9.4L128 256z" })
  }
), BS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64v96h64V64h194.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64M0 160v320c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m480 32H128v288c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32m-224 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), uS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.5 215.6 23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5 44.8 12.2 114.5 13.9 182.5-31.2 12.2-8.1 5.8-25.4-8.8-25.4h-16.1c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1 4.4-6.4 8.6-12.9 12.6-19.6 6.2-10.3-1.5-23-13.5-23H377c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3 29.1-73.4 42.4-150.3 46.5-199.6.8-9.9-3-19.6-10-26.6S485.2-.6 475.3.2C391.5 7 228.5 40.5 137.4 131.6c-80.1 80.1-80.7 170.7-66.1 224.8 2.1 7.9 12 9.6 17.8 3.8l164.5-164.4c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8z" })
  }
), RS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.5 215.6 23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41 11.1-7.2 5.5-23-7.8-23-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3H377c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7 10.8-21 16.4-44.5 16.4-68.6 0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149c-48 48-75 113.1-75 181v55.3l189.6-189.5c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8z" })
  }
), $S1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M76.8 38.4c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32h32v-64h-32V224h32v-64h-32v-42.7c0-6.9-2.2-13.7-6.4-19.2zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-44.8 59.7c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32h32v-64h-32V224h32v-64h-32v-42.7c0-6.9-2.2-13.7-6.4-19.2zM448 32c-5 0-9.8 2.4-12.8 6.4l-44.8 59.7c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2l-44.8-59.7c-3-4-7.8-6.4-12.8-6.4" })
  }
), kS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9 6.3-3.1 13.4-4.8 20.9-4.8 26.5 0 48 21.5 48 48 0 7.5-1.7 14.6-4.8 20.9 15.1 22.9 26 48.7 31.9 76.4 21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4 3.1 6.3 4.8 13.4 4.8 20.9 0 25.6-20 46.4-45.1 47.9l-38.5-80c4.6-5.1 10.3-9.2 16.6-12 17.2-21.5 29-47.5 33.2-75.9h-81.9c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24h81.9c-3.9-26.3-14.3-50.4-29.4-70.9L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l57.9-57.9c-20.5-15.1-44.6-25.4-70.9-29.4v81.9c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7V97.8c-26.3 4-50.4 14.3-70.9 29.4l57.9 57.9c-14.5 7.6-26.4 19.5-33.9 33.9l-57.9-57.9c-15.1 20.5-25.4 44.6-29.4 70.9h81.9c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H97.8c4.3 28.5 16.1 54.4 33.2 75.9 6.4 2.8 12.1 6.9 16.7 12l-38.5 80C84 446.4 64 425.6 64 400c0-7.5 1.7-14.6 4.8-20.9-15.1-22.9-26.1-48.7-31.9-76.4-21.2-5-36.9-24-36.9-46.7s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4-3.1-6.3-4.8-13.4-4.8-20.9 0-26.5 21.5-48 48-48 7.5 0 14.6 1.7 20.9 4.8 22.9-15.1 48.7-26.1 76.4-31.9 5-21.2 24-36.9 46.7-36.9s41.7 15.7 46.7 36.9M304 256c0 11.6-4.1 22.3-11 30.6l88.8 191.3c3.4 7.4 2.9 16.1-1.5 23s-12 11.1-20.2 11.1H152c-8.2 0-15.8-4.2-20.2-11.1s-5-15.6-1.5-23L219 286.6c-6.9-8.3-11-19-11-30.6 0-26.5 21.5-48 48-48s48 21.5 48 48" })
  }
), PS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h128c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32M96 128h384c17.7 0 32 14.3 32 32v123.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5-15.5 10.7-34 18-51 19.9h-16.6c-17.1-1.8-35-9-50.8-19.9-22.1-15.5-51.6-15.5-73.7 0-14.8 10.2-32.5 18-50.6 19.9h-16.6c-17-1.8-35.6-9.2-51-19.9-1.8-1.3-3.7-2.4-5.6-3.5l-51.4-71.9C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32m32 64v96h320v-96zm178.5 229.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.3-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), FS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8l-52.2 75.5-79.9-53.3 53.1-76.8c15.1-21.8 45-27.3 66.8-12.2zM353.1 123.9l79.9 53.3-192 277.7c-24.6 35.5-64.9 56.8-108.1 56.9C59.5 512 .1 452.3.6 378.9v-2.2c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5c14.5-22.2 44.2-28.4 66.4-13.9s28.4 44.2 13.9 66.4l-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6v2.2c-.1 20 16 36.2 36 36.1 11.7 0 22.7-5.8 29.4-15.5l191.2-276.3zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), TS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-40 232v102.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z" })
  }
), AS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-40 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z" })
  }
), DS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22c28-16.8 46.6-47.4 46.6-82.3s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8v128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5m51 34.9c6.6-5.9 16.7-5.3 22.6 1.3 10.1 11.2 16.3 26.2 16.3 42.6s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z" })
  }
), yS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM112 256h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48m-16 48v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m144-48h32c8.8 0 16 7.2 16 16v112h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-96h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), bS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H221.3c1.8-5.1 2.7-10.5 2.7-16v-80c1.3-.5 2.5-1 3.8-1.5 6.8-3 14.3-7.8 20.6-15.5 6.4-7.9 10.1-17.2 11.4-27.1.5-3.6.8-5.7 1.1-7.1 1.1-.9 2.8-2.3 5.6-4.5 19.9-15.4 27.1-42.2 17.5-65.5-1.4-3.3-2.1-5.4-2.6-6.7.5-1.4 1.2-3.4 2.6-6.7 9.5-23.3 2.4-50.1-17.5-65.5-2.8-2.2-4.5-3.6-5.6-4.5-.3-1.4-.6-3.6-1.1-7.1-3.4-24.9-23-44.6-47.9-47.9-3.6-.5-5.7-.8-7.1-1.1-.9-1.1-2.3-2.8-4.5-5.6-15.4-19.9-42.2-27.1-65.5-17.5-2.6 1.1-5.1 2.3-6.6 3l-.1.1V64zm384 64H384V0zm-402.8 33.6L125 168c1.9.8 4.1.8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1l-6.4 16c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6l-15.7 2V496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4.8S64 501.9 64 496V390.2l-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9.8-4.1 0-6.1l-6.4-15.7c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3L81 169.2c6.6-8.5 18.1-11.6 28.1-7.5zM192 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), fS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-40 248v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24s24 10.7 24 24m88 64v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24m-176 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), US1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm40 320h-88c-8.8 0-16-7.2-16-16v-88c0-8.8 7.2-16.1 16-14.9 53.5 7.1 95.9 49.5 103 103 1.2 8.8-6.1 16-14.9 16zm-136-90v106c0 8.8 7.2 16 16 16h106c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120 0-51.2 32.1-94.9 77.2-112.2 9.5-3.6 18.8 4 18.8 14.1z" })
  }
), GS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), qS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm-96 240a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), WS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16" })
  }
), ES1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16" })
  }
), OS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm-96 240a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16" })
  }
), IS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z" })
  }
), NS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z" })
  }
), XS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z" })
  }
), KS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), QS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349z" })
  }
), ZS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64zm384 64H256V0zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40m133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16h-34.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66 10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z" })
  }
), JS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v96H128zm0 304h384v80c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64zm384-240H384V0zM56 288h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24m224 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m192 0h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), jS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64zm384 64H256V0zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16m16 128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16zm264-128h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40m-168 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" })
  }
), YS1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM155.7 250.2l36.3 51.9 36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4l46.3-66.2-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z" })
  }
), _S1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-64 192c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), hz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v128H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h168v112c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm384 272v-48h110.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0z" })
  }
), cz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM80 301.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 333.1 80 317.5 80 301.3" })
  }
), sz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5S310 448 304 448H80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z" })
  }
), vz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336h174.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm384-160H384V0z" })
  }
), ez1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3-8.4-.1-17.4 1.8-23.6 5.5-5.7 3.4-8.1 7.3-8.1 12.8 0 3.7 1.3 6.5 7.3 10.1 6.9 4.1 16.6 7.1 29.2 10.9l.5.1c11.3 3.4 25.3 7.6 36.3 14.6 12.1 7.6 22.4 19.7 22.7 38.2.3 19.3-9.6 33.3-22.9 41.6-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.8c-11.2-2.1-21.7-5.7-30.9-8.9-2.1-.7-4.2-1.4-6.2-2.1-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5.8 4.8 1.6 7.1 2.4 13.6 4.6 24.6 8.4 36.3 8.7 9.1.3 17.9-1.7 23.7-5.3 5.1-3.2 7.9-7.3 7.8-14-.1-4.6-1.8-7.8-7.7-11.6-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5c-11-3.3-24.3-7.3-34.8-13.7-12-7.2-22.6-18.9-22.7-37.3-.1-19.4 10.8-32.8 23.8-40.5 7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z" })
  }
), lz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m16 96h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m0 32v64h192v-64zm144 160h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), tz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM112 256h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), wz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v33.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4v128c0 11.4 3 22.2 8.3 31.5-2.7.3-5.5.5-8.3.5H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm80 112c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), gz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm16 304c0 17.8-4.9 34.5-13.3 48.9l38.3 38.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4c-14.3 8.5-30.9 13.3-48.7 13.3-53 0-96-43-96-96s43-96 96-96 96 43 96 96m-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), iz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), mz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM120 304h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), az1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm32 224v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V416c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V272c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z" })
  }
), oz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64zm384 64H256V0zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56h-16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16m32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v48zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16m32 128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64z" })
  }
), nz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v125.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm165.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), rz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-48 208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16m-80 176h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), dz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-64 240c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-48c0-13.3 10.7-24 24-24" })
  }
), Sz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM136 240h68c42 0 76 34 76 76s-34 76-76 76h-44v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V264c0-13.3 10.7-24 24-24m68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28h-44v56z" })
  }
), zz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM104 196h72c33.1 0 60 26.9 60 60 0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3l-31.6 29 31.7 29.7c8.1 7.6 8.5 20.2.9 28.3s-20.2 8.5-28.3.9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V216c0-11 9-20 20-20m72 80c11 0 20-9 20-20s-9-20-20-20h-52v40z" })
  }
), pz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52 0 56.6 18.9 148 94.2 208.3-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3zM527.4 312 432 273.8v187.9c68.2-33 91.5-99 95.4-149.7" })
  }
), Mz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-19.3c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4-.9.1-1.8.2-2.7.2h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l94.8-94.8V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm293.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71z" })
  }
), xz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V160H384c-17.7 0-32-14.3-32-32V0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zM128 196.9V448c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8L128 196.9zM512 128 384 0v128z" })
  }
), Hz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM88 224h208c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H88c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32m0 112h48v-48H88zm80 0h48v-48h-48zm80 0h48v-48h-48zm0 32v48h48v-48zm-32 0h-48v48h48zm-80 0H88v48h48z" })
  }
), Vz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM128 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0M80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16" })
  }
), Cz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm236.9 109.9L256 368v-64l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1" })
  }
), Lz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C60.7 0 32 28.7 32 64v224h112c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l27.6 55.2H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32v128c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0zm192 0v128h128z" })
  }
), Bz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3 26.6-89.2c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z" })
  }
), uz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), Rz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H240c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64zm384 64H256V0zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6.7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16m144 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16m32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z" })
  }
), $z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16m0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16m0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16m-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4 0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5.7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), kz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm384 64H256V0z" })
  }
), Pz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h160v96c0 17.7 14.3 32 32 32h96v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64m256 64 32 32h-96V0l32 32zM24 96c13.3 0 24 10.7 24 24v256c0 48.6 39.4 88 88 88h192c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24m216 80v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), Fz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H160c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V128h-96c-17.7 0-32-14.3-32-32zm128 96-32-32-32-32-32-32v96h50.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h192c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), Tz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.4 9.4c12.5-12.5 32.7-12.5 45.2 0L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0l151.4 151.5c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l92.1-92.1-81.3-81.4c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3l-92.1 92.1c-4.2 4.2-7 9.3-8.4 14.6h319.2l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64" })
  }
), Az1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3l81.3 81.3-92.1 92.1c-37.5 37.5-37.5 98.3 0 135.8l117.5 117.5c37.5 37.5 98.3 37.5 135.8 0l190.4-190.5c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-53.1 53L86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0l151.4 151.4c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6z" })
  }
), Dz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32v352c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c0-17.7-14.3-32-32-32zm224 128v288h128c17.7 0 32-14.3 32-32v-32c0-17.7 14.3-32 32-32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm56 40h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm-80 144h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16" })
  }
), yz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h256v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16" })
  }
), bz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM224 150.3V128c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-65.9zM487.4 480l-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5H256c-17.7 0-32-14.3-32-32v-64c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32c.9 0 1.9.1 2.8.2L64 146.4V416c0 35.3 28.7 64 64 64zM112 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm352-128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16-144h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16" })
  }
), fz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm48 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16m368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM48 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16m368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM48 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16m368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-256 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32m32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32z" })
  }
), Uz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm8 48h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16m304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm-304 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16m304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm-304 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16m304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zM288 80h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m-32 176c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), Gz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M3.9 22.9C10.5 8.9 24.5 0 40 0h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z" })
  }
), qz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M3.9 22.9C10.5 8.9 24.5 0 40 0h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z" })
  }
), Wz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 64C24.2 64 9.9 73.3 3.5 87.7s-3.8 31.3 6.8 43L112 243.8V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S240 428.1 240 416V243.8l101.7-113c10.6-11.7 13.2-28.6 6.8-43S327.8 64 312 64zm312 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32-128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32m96-192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Ez1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32H104c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S384 460.1 384 448v-49.5L256 297.7z" })
  }
), Oz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M3.9 54.9C10.5 40.9 24.5 32 40 32h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" })
  }
), Iz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 32c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L352 261.5V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S480 428.1 480 416V261.5L629.4 99.1c10.7-11.7 13.6-28.6 7.2-43.2S615.9 32 600 32zM40 96c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L160 325.5V400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S288 460.1 288 448V325.5l32-34.8V274L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7H40z" })
  }
), Nz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6-15.2 5-18.7 23.7-8.3 35.9 7.1 8.3 18.8 10.8 29.4 7.9 10.6-2.9 21.8-4.4 33.4-4.4 70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3-1.7 14.6 9.4 27.8 24.2 27.8 11.8 0 21.9-8.6 23.3-20.3 3.3-27.4 5-55 5-82.7v-25c0-97.2-78.8-176-176-176zm-105.3 68.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9-3.4 15.6 7.9 31.2 23.9 31.2 10.5 0 19.9-7 22.2-17.3 6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1 7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1-3.8 14.3 6.7 29 21.5 29 9.5 0 17.9-6.2 20.4-15.4 10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9-2.7 13.9 7.7 27.2 21.8 27.2 10.2 0 19-7 21-17 7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3A536.19 536.19 0 0 0 280 280.9z" })
  }
), Xz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15M32 288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32v64h448v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm288 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Kz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32c-12.2-2.4-21.7-11.6-24.7-23.3h-65v34.8c37.8 18 64 56.5 64 101.2v144H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5-5.8 11.9-20.2 16.9-32.1 11.1s-16.9-20.2-11.1-32.1C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v24h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64h-96c-35.3 0-64-28.7-64-64v-32zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Qz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m153.6 29.9 16-21.3c4-5.4 10.4-8.6 17.1-8.6C198.4 0 208 9.6 208 21.3v22.2c0 13.1 5.4 25.7 14.9 34.7l84.7 80.8c48.8 46.6 76.4 111.2 76.4 178.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7 0-27.7 9-54.8 25.6-76.9z" })
  }
), Zz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m372.5 256.5-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6 0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1M281.7 306a73.3 73.3 0 0 1 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z" })
  }
), Jz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m372.5 256.5-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6 0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1M188.8 148.3c2-2.7 5.2-4.3 8.5-4.3 5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7 6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44 24.2 0 43.9-19.6 43.9-43.8 0-11.6-4.6-22.8-12.8-31L190 253.9c-14-14-21.9-33.1-21.9-53 0-16.2 5.3-32 15-44.9l5.8-7.8z" })
  }
), jz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32v4c45 11.6 80.4 47 92 92h12c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h12c11.6-45 47-80.4 92-92v-4c0-17.7 14.3-32 32-32s32 14.3 32 32M32 488c0-13.3 10.7-24 24-24h8v-64H48c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16v-64h256v64h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-16v64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24m160-88a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), Yz1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M283.7 0c-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 30 8.2 58.3 22.7 82.4 4.6 2.6 9 5.4 13.3 8.5 13.7-16.8 30.7-30.8 50.1-40.9-3.9-9.4-6-20.2-6-32.1 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 11.3 20.7 12.3 44.9 4.2 65.2 19.3 10.1 36.2 24 49.9 40.8 4.2-3 8.5-5.8 12.9-8.3 14.6-24.1 23-52.4 23-82.5 0-20.2-9.6-50.9-24.2-79-14.7-28.5-35.6-58.5-60.3-81.2-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7-2.8-2.5-6.3-3.7-9.8-3.8zM0 400c0 61.9 50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288 50.1 288 0 338.1 0 400" })
  }
), _z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M159.3 5.4c7.8-7.3 19.9-7.2 27.7.1 27.6 25.9 53.5 53.8 77.7 84 11-14.4 23.5-30.1 37-42.9 7.9-7.4 20.1-7.4 28 .1 34.6 33 63.9 76.6 84.5 118 20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512 98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21 42.1-29.4 53.4-88.2 28.1-134.4-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5-16.5-21-46-58.5-62.8-79.8-6.3-8-18.3-8.1-24.7-.1-33.8 42.5-50.8 69.3-50.8 99.4.1 68.5 50.7 109.1 113.8 109.1" })
  }
), hp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v32c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32m608 96H32v352c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160v160h96c17.7 0 32-14.3 32-32zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7-2.6 0-5.2.9-7.3 2.7-24.2 21.6-44.7 46.1-59.2 69.7-14.3 23.2-23.6 48.2-23.6 67.4 0 63.8 51.1 116.3 116.4 116.3 64.5 0 116.4-52.4 116.4-116.3 0-14.7-7-37-17.6-57.4-10.7-20.7-25.9-42.5-43.9-59-4.1-3.7-10.4-3.8-14.5 0-7 6.4-13.5 14.3-19.2 21.5-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9-32.7 0-58.9-21.1-58.9-56.7 0-17.5 10.9-32.7 32.7-59.6 2.9 3.6 45.1 57.5 45.1 57.5l26.2-30.6c2.2 2.9 3.6 5.8 5.1 8.7 13.1 24 7.3 54.5-14.5 69.8z" })
  }
), cp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M87.1 148.2c5.6 4.6 8.9 11.4 8.9 18.7V232h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h40V130.9c0-16.9 17.1-28.4 31.8-20 16 9.1 30.6 19.7 43.7 30.7 39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8-13.1 11-27.7 21.6-43.7 30.7-14.7 8.4-31.8-3.1-31.8-20V280h-40v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72h-48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72h-48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72H96v65.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1.1s-11.5-19.2-6.6-29.3l52.5-106.9c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1.1l48 38.9z" })
  }
), sp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c120 0 256 128 256 192S440 448 320 448c-74.8 0-155.9-49.8-206.3-102.8-6-6.3-15.8-7.2-22.5-1.7l-65.1 52.9c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4l30-120.2c.6-2.5.6-5.2 0-7.8L.5 131.9c-1.6-6.5.9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64m-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6" })
  }
), vp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5-15.3 11.5-29 23.9-40.7 36.3l-93.1-54.3c-12.5-7.3-28.4-5.3-38.7 4.9s-12.4 26-5.2 38.6L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3 15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8 39.2-29.4 67.2-64.7 81.6-89.5 5.8-9.9 5.8-22.2 0-32.1-14.4-24.8-42.5-60.1-81.6-89.5-35.8-26.8-82.3-49.8-137.2-53.8zM384 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), ep1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1l-89.7 52.2c-12.5 7.3-28.4 5.3-38.7-4.9s-12.4-26-5.2-38.6L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), lp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M295.9 48c-3 0-6 .4-8.8 1.2l-77.3 22.1C137.7 91.9 88 157.8 88 232.8V288h8c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8v-55.2c0-96.4 63.9-181.2 156.7-207.7l77.1-22C281 1 288.4 0 295.9 0 340.1 0 376 35.9 376 80.1V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V80.1c0-17.7-14.4-32.1-32.1-32.1M256 344c0-71.6 55.6-127.8 89-148.1 4.3-2.6 9.6-2.6 14 0 33.5 20.3 89 76.6 89 148.1 0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3v1.4c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112m128-32a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), tp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0c17.7 0 32 14.3 32 32v16l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0m32 187.1 64-13.9v65.5l-64 13.9V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3v-63.8l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1v-64c13.6.4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4v-69.7l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6l-25.3 5.5V98l-64 16zm256 148.6c16.8 1.5 33.9-.7 50-6.8l14-5.2v-71.8l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4v-70.9c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z" })
  }
), wp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352l369-138.4c9-3.4 15-12 15-21.6s-6-18.2-15-21.6z" })
  }
), gp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h360c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L352 192l91.2-121.6c3.1-4.2 4.8-9.2 4.8-14.4 0-13.3-10.7-24-24-24H64z" })
  }
), ip1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0c17.7 0 32 14.3 32 32v16l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.1v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0m80 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0m32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0m32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), mp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L64 48z" })
  }
), ap1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 416h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32h-32zM544 97.7C449.1 107.9 384 160 384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h336s65.1 52.1 160 62.3V97.7M224 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32" })
  }
), op1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6 0 480.9 31.1 512 69.4 512h309.2c10.6 0 20.7-2.4 29.7-6.6-2.8-6.2-4.2-12.9-4.2-19.7v-.9c-17.6 9.7-41.5 8.1-57.2-8.7-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3l-.2-.2h-207l54.1-88.1c12.4-20.2 19-43.4 19-67.1V64h64v132.8c0 23.7 6.6 46.9 19 67.1l29 47.1c.1-4 .8-8.1 2-12.2 4-12.9 9.4-25.5 16.4-37.6 4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32S337.7 0 320 0zm148 218.2v17.4c0 7.9-4.9 15-11.7 18.9-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2 3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6 6.9 3.9 11.7 11 11.7 18.9v17.4c0 7 4.5 13.3 11.3 14.8 10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8v-17.9c0-7.8 4.8-14.8 11.6-18.7 6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4 7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6-6.8-3.9-11.6-10.9-11.6-18.7v-17.5c0-7-4.5-13.3-11.3-14.8-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c-6.8 1.5-11.3 7.8-11.3 14.8zm-4.1 133.5a48.1 48.1 0 1 1 96.1 0 48.1 48.1 0 1 1-96.1 0" })
  }
), np1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4V64c17.7 0 32-14.3 32-32S337.7 0 320 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9M300 376.6c-7.1 5.2-12 13-12 21.8v9.6c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-9.6c0-8.8-4.9-16.7-12-21.8-22.1-16.1-36-39.1-36-64.6 0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6M184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48m104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), rp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64h64v93.7c0 30.4 16.9 56.1 40.3 69.7 43 25 71.6 71.4 71.7 124.4-58.6-1.7-85.4-12.6-109.9-22.6-22-9-42.2-17.2-82.1-17.2-42.3 0-73.4 9.2-94.5 18.8 6.5-44.1 33-81.7 70.2-103.4 23.4-13.6 40.3-39.3 40.3-69.7V64zm128 93.7V64c17.7 0 32-14.3 32-32S337.7 0 320 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4" })
  }
), dp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175 389.4c-9.8 16-15 34.3-15 53.1-10 3.5-20.8 5.5-32 5.5-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32v245.9l-49 79.6zM96 64v96h64V64zM352 0h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v150.9l117.7 191.3a69.54 69.54 0 0 1 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4 0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32 64v160c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64z" })
  }
), Sp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6 0 480.9 31.1 512 69.4 512h309.2c38.3 0 69.4-31.1 69.4-69.4 0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32S337.7 0 320 0zm-96 196.8V64h64v132.8c0 23.7 6.6 46.9 19 67.1l34.5 56.1h-171l34.5-56.1c12.4-20.2 19-43.4 19-67.1z" })
  }
), zp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1l-46.9 49.8c-4.6 4.9-10.5 8.2-17.1 9.5l-67.1 13.3c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2l-42.8 53.3c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120 27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6.8-13.3-.5-19.2-3.7zM159.3 313.5l122.2-122.2c-14.1-9.7-31.1-15.3-49.5-15.3-48.6 0-88 39.4-88 88 0 18.4 5.6 35.4 15.3 49.5M482.8 73.1c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272 0-64.7-24.9-121.2-61.2-166.9M256 432a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-48-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), pp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m107.3-340.7-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0m160 182.6-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6" })
  }
), Mp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-17.6-21.4-30.3-46.9-36.3-75-10.2 6.9-22.6 11-35.9 11-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7.2 16 .7v-19.4c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm512 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6" })
  }
), xp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-17.6-21.4-30.3-46.9-36.3-75-10.2 6.9-22.6 11-35.9 11-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7.2 16 .7v-19.4c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm368 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6" })
  }
), Hp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h194.5l14-55.9c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6v-62.3c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm160 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128m325.8-52.2c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6zM311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71z" })
  }
), Vp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm160 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), Cp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 56c0-30.9 25.1-56 56-56h218.7c14.9 0 29.1 5.9 39.6 16.4l85.3 85.3c10.5 10.5 16.4 24.7 16.4 39.6V360c0 30.9-25.1 56-56 56H152c-30.9 0-56-25.1-56-56zm96 8c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm176 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0M48 120v256c0 48.6 39.4 88 88 88h256c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Lp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h37.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Bp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 281.3c9.8 4.3 20.6 6.7 32 6.7 44.2 0 80-35.8 80-80 0-26.2-12.6-49.4-32-64 19.4-14.6 32-37.8 32-64 0-44.2-35.8-80-80-80-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32-44.2 0-80 35.8-80 80 0 26.2 12.6 49.4 32 64-19.4 14.6-32 37.8-32 64 0 44.2 35.8 80 80 80 11.4 0 22.2-2.4 32-6.7v113.5C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5 0 439.3 72.7 512 162.5 512h187c89.8 0 162.5-72.7 162.5-162.5 0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8zM208 144a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), up1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 44v84c0 70.7 57.3 128 128 128v138.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5 0 439.3 72.7 512 162.5 512h187c89.8 0 162.5-72.7 162.5-162.5 0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V256c70.7 0 128-57.3 128-128V44c0-6.6-5.4-12-12-12-2.6 0-5.1.8-7.2 2.4L336 80 268.8 5.3c-3-3.4-7.4-5.3-11.9-5.3h-1.7c-4.5 0-8.9 1.9-11.9 5.3L176 80l-60.8-45.6c-2.1-1.6-4.6-2.4-7.2-2.4-6.6 0-12 5.4-12 12" })
  }
), Rp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 480c38.2 0 72.5-16.8 96-43.3 23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128 0-38.2-16.8-72.5-43.3-96 26.6-23.5 43.3-57.8 43.3-96 0-70.7-57.3-128-128-128-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32 57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128m96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), $p1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 160h48v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48m544 192H128V160h464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48m-272-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), kp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm148.7 141.3-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l49 49c1.8-6.6 2.7-13.6 2.7-20.7 0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zm35.3 45.4c-23.9 13.8-40 39.7-40 69.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3V352c0 22.1-17.9 40-40 40s-40-17.9-40-40zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0 7.2.9 14.1 2.7 20.7l49-49c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-160-88.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l91.3 91.3V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-89.4l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4z" })
  }
), Pp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M119.7 456.3c-25.2-25.2-29.6-66.7-16.5-114.9 3.2 9.5 8.4 18.5 16.2 26.3 15.6 15.6 36 20.7 55 20.5 18.8-.1 38.8-5.3 58.2-13.3 39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2.1-19-5-39.5-20.5-55-7.8-7.8-16.8-13-26.3-16.2 48.2-13 89.8-8.6 114.9 16.6 55.3 55.3 10.5 189.8-100.2 300.5S175 511.6 119.7 456.3zm211.4-189.2C257.4 340.9 172.7 375.8 142 345s4.1-115.4 77.9-189.2S378.3 47.2 409 77.9s-4.1 115.4-77.9 189.2" })
  }
), Fp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z" })
  }
), Tp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zm-232-40V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), Ap1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M288 176v160c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16" })
  }
), Dp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V192h512v224c0 35.3-28.7 64-64 64m64-320H0V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64" })
  }
), yp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), bp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24" })
  }
), fp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z" })
  }
), Up1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M176 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0m120 0c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 416 120 416h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7" })
  }
), Gp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M336 272c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l38.3 38.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), qp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M224 208v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), Wp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), Ep1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V224z" })
  }
), Op1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88.7 223.8 0 375.8V96c0-35.3 28.7-64 64-64h117.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1c5.8-9.9 16.3-15.9 27.7-15.9h400c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2.1-32.1l112-192z" })
  }
), Ip1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zm-280-40c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), Np1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v352c0 35.3 28.7 64 64 64h192v-64H64V160h192V96H64zm224 160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-98.7c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm0 288c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32h-98.7c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z" })
  }
), Xp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64zM320 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0M144 405.3c0 5.9 4.8 10.7 10.7 10.7h202.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3H197.3c-29.5 0-53.3 23.9-53.3 53.3" })
  }
), Kp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64M175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), Qp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8l-19.2-25.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64" })
  }
), Zp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7l-26.5-26.6c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), Jp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m319 39.8-24 96c-2.9 11.5-11.6 20-22.2 23l-8.3 33.2h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zM381.9 160l-21.3 32h-38.5l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM32 224h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16 7.2 16 16 16 16-7.2 16-16v-48h320c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 52.3-25.1 98.8-64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-3.2c-10.3 2.1-21 3.2-32 3.2H160c-11 0-21.7-1.1-32-3.2v3.2c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32C25.1 418.8 0 372.3 0 320v-64c0-17.7 14.3-32 32-32" })
  }
), jp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 48v336c-63.1 22.5-82.3 32-119.5 32-62.8 0-86.6-32-149.3-32-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2 62.7 0 86.5 32 149.3 32 20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3-62.8 0-86.6-32-149.3-32-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32s32 14.3 32 32v12.7c40.3-8 64.4-28.7 115.2-28.7 62.7 0 86.5 32 149.3 32 37.1 0 56.4-9.5 119.5-32" })
  }
), Yp1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368h159.6l34.2 91.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304H120.2L176 155.1zM608 160c-13 0-24.1 7.7-29.2 18.8-19.4-11.9-42.3-18.8-66.8-18.8-70.7 0-128 57.3-128 128v64c0 70.7 57.3 128 128 128 24.5 0 47.4-6.9 66.8-18.8 5 11.1 16.2 18.8 29.2 18.8 17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32m-32 128v64c0 35.3-28.7 64-64 64s-64-28.7-64-64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64" })
  }
), _p1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48h159.6l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-25.8L254 52.8zM279.8 304H168.2L224 155.1z" })
  }
), hM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488.1 194.9c4.5 17.1-8.2 33.1-25.7 35.3l-122.1 15.3 14 74.5H464c26.5 0 48 21.5 48 48v82.4c0 25.2-20.4 45.6-45.6 45.6h-17c-54.9 0-102-39.1-112.1-93.1l-9.6-50.9H288l9.2 18.3c4.5 9 6.8 18.9 6.8 28.9 0 35.7-29 64.7-64.7 64.7h-1.7c-9 0-17.9-1.8-26.1-5.4l-93.4-40c-4-1.7-8.3-2.6-12.6-2.6h-14c-9.1 0-17.9-3.8-23.5-10.9-32.6-40.9-52-92.7-52-149C16 123.5 123.5 16 256 16c111.4 0 205.1 75.9 232.1 178.9m-207.1 58c-14.3 1.8-25.1 14-25.1 28.4 0 4.4 1 8.8 3 12.8l13 26h49.7l-13.2-70.6-27.4 3.4zm79.3 99.1 6 32H480v-16c0-8.8-7.2-16-16-16zM480 416H374.7c13.1 28.7 42 48 74.7 48h17c7.5 0 13.6-6.1 13.6-13.6zm-304-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), cM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7-66 24.5-112.2 66.5-142.9 116.5-18.3 29.8-30.9 62.3-39.2 95.4l237.7 237.6c13.5-3.3 26.4-7.2 38.6-11.7 66-24.5 112.2-66.5 142.9-116.5 18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zm247.7 179.9c6.1-56.8 1.4-112.2-7.7-156.4-2.7-12.9-13-22.9-26.1-25.1-58.2-9.7-109.9-12-155.6-7.9zM206.1 496 16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4 2.7 12.9 13 22.9 26.1 25.1 58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6m-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6" })
  }
), sM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M475.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S462-1.9 455.1 2.7l-106.5 71c-27.8 18.6-44.6 49.9-44.6 83.4 0 19.3 5.5 37.9 15.7 53.9L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L365 256.3c16 10.2 34.7 15.7 53.9 15.7 33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L457.4 192c-5.2 5.2-13.6 5.2-18.8 0-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L402.1 138c-5.3 4.6-13.2 4.3-18.1-.6-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3zM52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4 6.5 6.4 13.3 13 20.3 19.9 1.9 1.8 3.8 3.5 5.9 5.1l110.3-110.3L52.5 7.3zm404.9 495.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3z" })
  }
), vM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M412.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L320 118.6c-5.2 5.2-5.2 13.6 0 18.8 4.9 4.9 12.8 5.2 18.1.6l99.4-86.1c6.3-5.5 15.9-5.2 21.8.8s6.3 15.4.8 21.8L374 173.9c-4.6 5.3-4.3 13.2.6 18.1 5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6-19.3 0-37.9-5.5-53.9-15.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L255.7 211c-10.2-16-15.7-34.7-15.7-53.9 0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z" })
  }
), eM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 160h48V48c0-26.5 21.5-48 48-48h148.7c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1v85.7c19.6 17.6 32 43.1 32 71.6 0 53-43 96-96 96s-96-43-96-96h-64c0 53-43 96-96 96s-96-43-96-96V208c0-26.5 21.5-48 48-48m208 96h94L281.4 64H160v96zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96M544 32v352h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), lM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 16C0 7.2 7.2 0 16 0h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144h128V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v160c0 20.9-13.4 38.7-32 45.3V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H80c-26.5 0-48-21.5-48-48V221.3C13.4 214.7 0 196.9 0 176V96z" })
  }
), tM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v118.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96v118.3L52.5 71.4C43 63.5 29.7 61.7 18.4 67S0 83.6 0 96v320c0 12.4 7.2 23.7 18.4 29" })
  }
), wM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6z" })
  }
), gM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4L224 214.3v83.4zM256 352V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4S256 428.4 256 416v-64z" })
  }
), iM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 128c0-17.7-14.3-32-32-32h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H128V64c0-17.7-14.3-32-32-32S64 46.3 64 64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h192v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V160h32c17.7 0 32-14.3 32-32M128 352V160h192v192z" })
  }
), mM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 32c-17.7 0-32 14.3-32 32v256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-64h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96h176c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), aM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.2 1.7c-5-2.5-10.8-2.2-15.6.7S160 10.5 160 16V269.9c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zm-55.2 13-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2.9 2.3 1.2 3.4 2 6.3 6.7 15.9 18.7 24.3 3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6l-20.4-5.1c-5.3-1.3-10.8.1-14.8 3.8S-.7 93.4.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1zm343.5 13.2c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-18 4.5-19 107.8c2.8-.5 5.7-.8 8.8-.8h26.6c1.6 0 3.2.1 4.7.2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8c-6.2 1.5-10.9 6.5-12 12.7l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6 12-8.4 16.7-18 18.7-24.3.7-2.3 1.7-4.7 2.8-7l30.5-172.3zM.6 250.5l57.5 237c3.4 14.4 16.3 24.5 31.1 24.5h205.6c14.8 0 27.6-10.1 31.1-24.5l57.5-237c.4-1.7.6-3.3.6-5.1 0-11.8-9.6-21.4-21.4-21.4H336c-8.8 0-16.3 7.2-18.9 15.7C309.7 263 283.7 304 192 304S74.3 263 66.9 239.7C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7.2 3.4.6 5.1z" })
  }
), oM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9 0 21.8-11.7 41.9-30.7 52.7l-144.6 82.1 92.5 92.5H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7-40.6-40.6-106.3-40.6-146.9-.1l-73.6 70c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6.6l73.8-70.2.1-.1.1-.1c3.5-3.5 7.3-6.6 11.3-9.2 27.9-18.5 65.9-15.4 90.5 9.2 24.7 24.7 27.7 62.9 9 90.9-2.6 3.8-5.6 7.5-9 10.9l-37 37H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5 296.2 60.2 328.8 32 368 32m0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), nM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32v96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v127.5c0 48.4-36.1 89.3-84.1 95.3l-7.9 1C18.4 481.9 2.4 469.5.2 452s10.2-33.5 27.8-35.7l7.9-1c16-2 28-15.6 28-31.8V256H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm266.7 81.7c-27 40.7-42.7 89.6-42.7 142.3s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9c33.8 50.9 53.4 112 53.4 177.6s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3zm-134.7 63.7 33.4 33.3 33.4-33.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L477.3 320l33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L432 365.3l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l33.4-33.4-33.4-33.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z" })
  }
), rM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m417.3 360.1-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6c-15.7 4.2-32.2 6.4-49.2 6.4s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6l60.7-38.2c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L107 134.8c21-25.6 48.3-45.8 79.7-57.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z" })
  }
), dM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h144c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57 13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96" })
  }
), SM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h11.5C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1 19.9-7 41.3-10.8 63.5-10.8 106 0 192 86 192 192v11.5c0 11.3-9.2 20.5-20.5 20.5-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3 7 19.9 10.8 41.3 10.8 63.5 0 106-86 192-192 192h-11.4c-11.3 0-20.5-9.2-20.5-20.5 0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192v-11.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0m-64 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), zM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 64v224H64V64zM64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM0 448v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32m192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32z" })
  }
), pM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 0v160h160V96zm0 160H64v160h160z" })
  }
), MM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm144 0v80h80V96zm0 160v-80H64v80zm80 0h-80v80H64v80h80v-80h80v80h80v-80h80v-80h-80v-80h80V96h-80v80h-80zm0 0h80v80h-80z" })
  }
), xM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 0c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm32 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zm144 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m152-216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-24v72c0 13.3-10.7 24-24 24h-24V200z" })
  }
), HM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v352c0 53-43 96-96 96H96c-53 0-96-43-96-96zm96 16v112c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16m136 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48m88-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-224-8v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16" })
  }
), VM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384h208l3.6 14.3c12 48 55.1 81.7 104.6 81.7 59.5 0 107.8-48.3 107.8-107.8v-2.8c0-6.3-.5-12.5-1.6-18.7l-32.7-190.9c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32S170.5 42.9 124.7 54.3c-49.5 12.3-81.8 55.3-90.4 105.5L1.6 350.7C.5 356.9 0 363.1 0 369.4M432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80m24-56a40 40 0 1 1 80 0 40 40 0 1 1-80 0m-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), CM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64C86 64 0 150 0 256s86 192 192 192h256c106 0 192-86 192-192S554 64 448 64zm304 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80M392 304a40 40 0 1 1 80 0 40 40 0 1 1-80 0M168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32z" })
  }
), LM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24m254.3-194.6L242.2 328h155.6l-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4H261.8c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335l20.1-57.5c7.9-22.5 29.1-37.5 52.9-37.5h116.3c23.8 0 45 15.1 52.9 37.5l20 57.5c17.2 9.5 28.9 27.9 28.9 49v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H224v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-21.1 11.7-39.5 28.9-49m51.1 89a24 24 0 1 0 0-48 24 24 0 1 0 0 48m184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), BM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 171.3V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v264c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3M194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h192v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-21.1-11.7-39.5-28.9-49l-5.2-15H395l2.8 8H242.2l2.8-8zm45.9 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48m136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m136-176H128v64h384z" })
  }
), uM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 171.3V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v264c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3M128 224v96h384v-96zm0 128v160h384V352zm128 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16" })
  }
), RM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M83.4 169.1C42.3 200.5 0 232.7 0 288c0 104.6 85.5 123.7 116.7 127.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5 5.9-15.6 13.6-28.6 20.7-40.5.8-1.4 1.7-2.8 2.5-4.2 7.8-13.2 15.1-26.2 20.5-43.3 1.2-3.7 2.3-7.7 3.3-11.9-11.7 10.9-25.1 21.1-38.7 31.5zM384 416s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64V48c0-26.5-21.5-48-48-48h-16v80c0 30.2 4.7 51.9 11.4 69s15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 4.9 19 25.8 39.4 53.5 39.4 106.3 0 49.2-21.5 87.3-53.7 112zM256 80V0h-48c-26.5 0-48 21.5-48 48v32c0 33.4-4.2 58.5-10.8 79.2-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5-5.3 13.9-9 31-9 55.2 0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7v-.1c-1.1-1.5-2.2-3.1-3.4-4.6-10.2-13.9-21.2-29.8-29.5-50.9-8.2-21.2-13.5-46.9-13.5-80.7M136 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40z" })
  }
), $M1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-72.2-56.6c10.9-14.6 17.4-32.8 17.4-52.5V154.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32v64c0 29.8 20.4 54.9 48 62v138c0 8.5-2.7 16.4-7.2 22.9L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM96 171.6V448c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32v-49.5z" })
  }
), kM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C32 28.7 60.7 0 96 0h160c35.3 0 64 28.7 64 64v192h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96l-32-32c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V376c0 39.8-32.2 72-72 72s-72-32.2-72-72v-32c0-22.1-17.9-40-40-40h-8v144c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm64 16v96c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16" })
  }
), PM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176M320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3M144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288m47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z" })
  }
), FM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176M320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3M144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0m304 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-64 0c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16" })
  }
), TM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176M320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3M144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), AM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 320c35.3 0 64-28.7 64-64 0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3.2-31.6 12.3L257.9 288H256c-35.3 0-64 28.7-64 64s28.7 64 64 64zm-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0M96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64m352-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), DM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 320c35.3 0 64-28.7 64-64s-28.7-64-64-64h-1.9L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64M128 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), yM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 320c35.3 0 64-28.7 64-64 0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8l-117.6 72.8c-10.6-7.8-23.7-12.4-37.8-12.4-35.3 0-64 28.7-64 64s28.7 64 64 64m-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0M96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64m304-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), bM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 320c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4l-117.6-72.8c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8 0 35.3 28.7 64 64 64zm-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0m240 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), fM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-15.9-5.8-30.4-15.3-41.6L381.3 163c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2l-76.6 147.5c-2-.2-4-.3-6.1-.3-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64" })
  }
), UM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-35.3-28.7-64-64-64-2.1 0-4.1.1-6.1.3l-76.6-147.4c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4c-9.5 11.1-15.3 25.6-15.3 41.5 0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), GM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8l-117.6 72.8c-10.6-7.8-23.7-12.4-37.8-12.4-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64" })
  }
), qM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-35.3-28.7-64-64-64-14.1 0-27.2 4.6-37.8 12.4l-117.6-72.8c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8 0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), WM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v204.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), EM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v204.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64M144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), OM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4 106.8 106.7-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4 58.8-58.7-45.3-45.3-58.7 58.7-1.4-1.4z" })
  }
), IM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zm-100.4 64.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40" })
  }
), NM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1.6 266.1 0 256 0c-11.1 0-22.1.7-32.8 2.1-10.3 1.3-18 9.7-19.3 20L201 45.2c-.8 6.4-5.4 11.6-11.5 13.7-9.6 3.2-19 7.2-27.9 11.7-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4-16.6 13-31.5 28-44.4 44.7-6.3 8.2-5.9 19.6.5 27.8L68 145.5c4 5.1 4.4 12 1.5 17.8-4.4 8.8-8.2 17.9-11.3 27.4-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6.6 21.1 1.9 31.4 1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4.8 11.7 5.4 13.7 11.6 3.1 9.5 6.9 18.7 11.3 27.5 2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8 12.9 16.7 27.8 31.7 44.4 44.7 8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5 9 4.6 18.3 8.5 27.9 11.7 6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20 10.7 1.4 21.7 2.1 32.8 2.1 10.1 0 20.1-.6 29.9-1.7 10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8 10-3.2 19.7-7.2 29-11.8 5.8-2.9 12.7-2.4 17.8 1.5l18.1 14.2c8.2 6.4 19.6 6.8 27.8.5 2.8-2.2 5.5-4.4 8.2-6.7l30.7-30.7 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18 4.8-9.4 9-19.3 12.3-29.5 2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4.2-1.7.4-3.5.6-5.2v-52c-.2-1.7-.4-3.5-.6-5.2-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6-3.4-10.2-7.5-20.1-12.3-29.5-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7.4-27.9l-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7-8.2-6.4-19.6-5.9-27.8.5l-18.3 14.2c-5.1 4-12.1 4.4-17.8 1.5-9.3-4.6-19-8.6-29-11.8-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zm-17.6 140.8-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zm-100.5 64.7L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6 40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0" })
  }
), XM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1.6 266.1 0 256 0c-11.1 0-22.1.7-32.8 2.1-10.3 1.3-18 9.7-19.3 20L201 45.2c-.8 6.4-5.4 11.6-11.5 13.7-9.6 3.2-19 7.2-27.9 11.7-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4-16.6 13-31.5 28-44.4 44.7-6.3 8.2-5.9 19.6.5 27.8L68 145.5c4 5.1 4.4 12 1.5 17.8-4.4 8.8-8.2 17.9-11.3 27.4-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6.6 21.1 1.9 31.4 1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4.8 11.7 5.4 13.7 11.6 3.1 9.5 6.9 18.7 11.3 27.5 2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8 12.9 16.7 27.8 31.7 44.4 44.7 8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5 9 4.6 18.3 8.5 27.9 11.7 6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20 10.7 1.4 21.7 2.1 32.8 2.1 10.1 0 20.1-.6 29.9-1.7 10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8 10-3.2 19.7-7.2 29-11.8 5.8-2.9 12.7-2.4 17.8 1.5l18.1 14.2c8.2 6.4 19.6 6.8 27.8.5 2.8-2.2 5.5-4.4 8.2-6.7l30.7-30.7 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18 4.8-9.4 9-19.3 12.3-29.5 2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4.2-1.7.4-3.5.6-5.2v-52c-.2-1.7-.4-3.5-.6-5.2-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6-3.4-10.2-7.5-20.1-12.3-29.5-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7.4-27.9l-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7-8.2-6.4-19.6-5.9-27.8.5l-18.3 14.2c-5.1 4-12.1 4.4-17.8 1.5-9.3-4.6-19-8.6-29-11.8-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), KM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), QM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25-2.3-5.3-4.8-10.5-7.6-15.5l-3.1-5.4c-3-5-6.3-9.9-9.8-14.6-5.7-7.6-15.7-10.1-24.7-7.1L241.3 77c-10.7-8.8-23-16-36.2-20.9l-6.1-29c-1.9-9.3-9.1-16.7-18.5-17.8-6.6-.9-13.3-1.3-20.1-1.3h-.7c-6.8 0-13.5.4-20.1 1.2-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9l-28.3-9.2c-9-3-19-.5-24.7 7.1-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6-3.7 8.7-.9 18.6 6.2 25l22.2 19.8c-1.1 6.7-1.7 13.7-1.7 20.8s.6 14.1 1.7 20.9l-22.2 19.8c-7.1 6.3-9.9 16.2-6.2 25 2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6 5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8 6.7.8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1 3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5 3.7-8.7.9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0m392.7 324.5c6.3 7.1 16.2 9.9 25 6.2 5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8 7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2L613 391c9.3-1.9 16.7-9.1 17.8-18.5.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5l-29.1-6.2c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1.6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2l-29.1 6c-9.3 1.9-16.7 9.1-17.8 18.5-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7 4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6 8.7 3.7 18.6.9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), ZM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8h240c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1.3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16h1.3l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8l-147.1-12.2 57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2l-90.1-97.6c-2.8-3-7.4-3.4-10.7-1z" })
  }
), JM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224m0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352" })
  }
), jM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m40.1 467.1-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0s192 86 192 192v270.2c0 9.8-8 17.8-17.8 17.8-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9l-30.5 35c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-30.5-35c-11.3-12.9-30.7-14.6-44.1-3.9M160 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), YM1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm296 64c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m56 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-32h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88c-13.3 0-24 10.7-24 24m-224 72c0-26.5 21.5-48 48-48 8 0 15.4 1.9 22 5.3 11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8 7-4.4 11.2-12.1 11.2-20.3V264c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v13.1c-5.3 1.9-10.6 2.9-16 2.9-26.5 0-48-21.5-48-48" })
  }
), _M1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.5 68.8c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40s-17.9 40-40 40h-73.3zm-131 0 34.8 59.2H184c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8m89.6-24.3-24.1 41-24.1-41C247.7 16.9 218.1 0 186.2 0H184c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-41.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4zM512 384v64H64v-64zm0-64H64V192h166.1l-40.5 48.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l61.5-73.8 61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L345.9 192H512z" })
  }
), hx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m190.5 68.8 34.8 59.2H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8M64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-41.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152c-48.6 0-88 39.4-88 88m336 0c0 22.1-17.9 40-40 40h-73.3l34.8-59.2c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40M32 288v176c0 26.5 21.5 48 48 48h144V288zm256 224h144c26.5 0 48-21.5 48-48V288H288z" })
  }
), cx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16l-10.7 30.2-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h152.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62 1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96h-22.2l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3l-25.4 18.5zm162.9 153.5 29.6 38.5H344c-13.3 0-24-10.7-24-24 0-13.1 10.8-24 24.2-24 7.6 0 14.7 3.5 19.3 9.5M272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80h192v-96h32v96h192v-80c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24 0-39.9-32.5-72-72.2-72-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2-39.7 0-72.2 32.1-72.2 72zm-48 264c0 26.5 21.5 48 48 48h144V384H224zm224 48h144c26.5 0 48-21.5 48-48v-80H448zm96-312c0 13.3-10.7 24-24 24h-49.1l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5 13.4 0 24.2 10.9 24.2 24" })
  }
), sx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5H368c35.3 0 64 28.7 64 64s-28.7 64-64 64h-20.9c-19 0-29.4 22.2-17.2 36.7l55.3 66.3c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7H80c-35.3 0-64-28.7-64-64s28.7-64 64-64h64.4c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5M192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-48 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), vx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 144c0-44.2-35.8-80-80-80-26.2 0-49.4 12.6-64 32h-71.8C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144 0 78.4-62.6 142.1-140.5 144l6.5-64.6c39.5-4.9 70-38.6 70-79.4m-198.7 80-.1 1.3-.9-1.3zm-241-85.5C14.3 131.8 23 128 32 128h288c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7l-29.1 291.2c-3.2 32.7-30.8 57.6-63.7 57.6H93c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192l6.4 64h204.4l6.4-64z" })
  }
), ex1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M8.6 10.2C14.6 3.7 23.1 0 32 0h320c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1l-28.8 403.4c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64l26.3 369.1c.6 8.4 7.6 14.9 16 14.9h166.6c8.4 0 15.4-6.5 16-14.9L317.6 64z" })
  }
), lx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0zm45.8 224L66.4 64h251.2l-11.4 160H77.8z" })
  }
), tx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0zm51 297.5L66.4 64h251.2L301 297.5l-13 6.5c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0-43.9 10.1-64 0zM256 196c0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60" })
  }
), wx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0zm41 156.5L66.4 64h251.2l-6.6 92.5-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0a74.556 74.556 0 0 0-66.4 0c-19.4 9.7-42.2 9.7-61.6 0z" })
  }
), gx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0zm38.9 128-4.5-64h251.2l-4.6 64z" })
  }
), ix1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80h56c21.3-47.2 68.8-80 124-80 26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4.1 1.9.1 3.8.1 5.6 0 75.1-60.9 136-136 136-72.4 0-131.6-56.6-135.8-128h-32.4c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8.1-5.6-.1-.8-.1-1.6-.1-2.4v-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8M136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144m376-72a72 72 0 1 0-144 0 72 72 0 1 0 144 0" })
  }
), mx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3 32.3 0 61.8 6.9 82.8 13.5 10.6 3.3 19.3 6.7 25.4 9.2 3.1 1.3 5.5 2.4 7.3 3.2.9.4 1.6.7 2.1 1l.6.3.2.1h.1l-6.3 12.7 6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7-6.3-12.7h.1l.2-.1.6-.3c.5-.2 1.2-.6 2.1-1 1.8-.8 4.2-1.9 7.3-3.2 6.1-2.6 14.8-5.9 25.4-9.2 21-6.6 50.4-13.5 82.8-13.5 30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1.3 1.9.5 3.8.5 5.7v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8M64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5-17.2-5.4-39.9-10.5-63.6-10.5-23.7 0-46.2 5.1-63.2 10.5-3.1 1-5.9 1.9-8.5 2.9zM512 368v-42.6c-2.6-.9-5.5-1.9-8.5-2.9-17-5.4-39.5-10.5-63.2-10.5-23.7 0-46.4 5.1-63.6 10.5-2.7.8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z" })
  }
), ax1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 256c0 22.2-1.2 43.6-3.3 64h-66.9l12.6-42.8c10.7-36.4-23.1-70.3-59.6-59.6l-74.6 21.9c.4-16.3 1.5-32.2 3.1-47.5h185.4c2.2 20.4 3.3 41.8 3.3 64M20.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C.8 279.2 0 267.7 0 256c0-22.1 2.8-43.5 8.1-64h123.1c-1.9 18.4-2.9 37.4-3.1 57L20.4 280.6zm211 211 41-139.6h71.9c-6.1 36.4-15.5 68.6-27 94.6-10.5 23.6-22.2 40.7-33.5 51.5-11.2 10.7-20.5 13.9-27.8 13.9-7.2 0-16.3-3.1-27.3-13.4 1-2.2 1.9-4.6 2.7-7.1zM380.8 192h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64m112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6 78.3 20.7 142 77.5 171.9 151.6zm-325.7 0c6.1-36.4 15.5-68.6 27-94.7 10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5 11.6 26 20.9 58.2 27 94.7zm-32.4 0H18.6c30-74.1 93.6-130.9 172-151.6-25.5 34.2-45.3 87.7-55.3 151.6zm358.1 192c-30 74.1-93.6 130.9-171.9 151.6 25.5-34.2 45.2-87.7 55.3-151.6zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7" })
  }
), ox1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 224c0 62.7-25.7 119.3-67.2 160H256v-32h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v32H67.2C25.7 343.3 0 286.7 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224M256 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0m80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32M96 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0M20.3 474.2 61.1 416h325.8l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8s-12.4 13-21.3 13H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z" })
  }
), nx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-33.3c49.1-5.3 96.8-26.7 134.4-64.3 81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-34.6 34.5c-9.4 9.4-9.4 24.6 0 33.9 68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0zm193-15a144 144 0 1 0 0-288 144 144 0 1 0 0 288" })
  }
), rx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64h185.4c2.2 20.4 3.3 41.8 3.3 64m28.8-64h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64m112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6 78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7 10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5 11.6 26 20.9 58.2 27 94.7zm-209 0H18.6c30-74.1 93.6-130.9 172-151.6-25.5 34.2-45.3 87.7-55.3 151.6zM8.1 192h123.1c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zm186.6 254.6c-11.6-26-20.9-58.2-27-94.6h176.6c-6.1 36.4-15.5 68.6-27 94.6-10.5 23.6-22.2 40.7-33.5 51.5-11.2 10.7-20.5 13.9-27.8 13.9s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6-78.4-20.7-142-77.5-172-151.6zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6 25.5-34.2 45.2-87.7 55.3-151.6z" })
  }
), dx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-53-43-96-96-96H96C43 32 0 75 0 128v320c0 17.7 14.3 32 32 32s32-14.3 32-32zm112 0c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16m80 256h-64v-64h64zm96 0h-64v-64h64zm96 0h-64v-64h64zm0-96h-64v-64h64zm-96 0h-64v-64h64zm-96 0h-64v-64h64z" })
  }
), Sx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192 0 86 86 0 192 0s192 86 192 192m-141.9 64.6c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4 0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16c0-8.8-7.2-16-16-16h-16c-17.7 0-32-14.3-32-32" })
  }
), zx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5v-.5L42.1 318C21.4 311.1 0 326.6 0 348.4V376h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v8c0 17.7 14.3 32 32 32h223.3c12 .3 23.6-6.3 29.3-17.7l224-448z" })
  }
), px1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24v208c0 1.3.1 2.7.3 4-.2 1.3-.3 2.6-.3 4v92.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8v-78l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM288 416c0 17.7-28.7 32-64 32s-64-14.3-64-32 28.7-32 64-32 64 14.3 64 32" })
  }
), Mx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0c13.3 0 24 10.7 24 24v8h40v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v104c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-64V352h-32V224h-32v-96h-32v96h32v128h32v160h-80v-48c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h-80V352h32V224h32v-96h-32v96h-32v128H96v160H32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32v-96c0-17.7 14.3-32 32-32v-64c0-17.7 14.3-32 32-32V24c0-13.3 10.7-24 24-24m136 272c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-32-80v32h64v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), xx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9V320c0 28.4-10.8 57.7-22.3 80.8-6.5 13-13.9 25.8-22.5 37.6-3.2 4.3-4.1 9.9-2.3 15s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7.3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7-3.2-14.2-7.5-28.7-13.5-42v-24.6c0-30.2 10.2-58.7 27.9-81.5 12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5.8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1l280.6-101c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1c-7.6-2.7-15.6-4.1-23.7-4.1M128 408c0 35.3 86 72 192 72s192-36.7 192-72l-15.3-145.4L354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6l-142.2-51.4z" })
  }
), Hx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M127 0c10.5-.4 20 6 23.6 15.9v.1l.3.7c.3.7.7 1.7 1.3 3.2 1.2 2.9 3.2 7.3 6 12.8 5.7 11.1 14.8 27 28.2 45.1 26.9 36.2 71.4 81.5 141.3 116.8 17.3 8.7 31.6 22.9 40.1 40.4 5.4 10.9 8.2 23 8.2 35v.6c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h110c18.7 0 33.9-15.1 34-33.7-.1-5.4-1.5-10.7-4.1-15.6-3.1-4.9-7.7-7.8-12.4-8.6-44.1-7.3-133.1-7.9-241.4 69.4-.3.2-.7.5-1 .7-2.7 1.8-5.6 2.9-8.7 3.5-3.2.6-6.6.6-10-.2-1.2-.3-2.4-.7-3.6-1.1-.5-.2-1-.5-1.5-.7-.9-.4-1.7-.9-2.5-1.5-1.2-.8-2.2-1.6-3.2-2.6-1.4-1.3-2.5-2.7-3.6-4.2-1.8-2.8-3-5.8-3.6-8.9-.6-3.1-.5-6.4.2-9.6.1-.3.2-.7.3-1l71.9-272C107.5 7.7 116.5.4 127 0M32 416c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), Vx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6M304 152a56 56 0 1 0-112 0 56 56 0 1 0 112 0m-192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112m32 80a56 56 0 1 0-112 0 56 56 0 1 0 112 0m-32 144a56 56 0 1 0-112 0 56 56 0 1 0 112 0m144-32a56 56 0 1 0-112 0 56 56 0 1 0 112 0m80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112m-56-168a56 56 0 1 0-112 0 56 56 0 1 0 112 0m80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112" })
  }
), Cx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v66.2c-15.1 4.3-28.2 14.6-35.8 28.8l-75.3 141.2A144.61 144.61 0 0 0 320 400c0 29.6 8.9 57.1 24.2 80H64c-35.3 0-64-28.7-64-64V256zm96 0H64v128h32zM64 416h32V288H64zm128 0V288h-32v128zm96 0V288h-32v128zm96-320h-32v128h32zm-128 0v128h32V96zm-96 0v128h32V96zm280.5 110.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z" })
  }
), Lx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H128zm0 64h32v128H64zm0 192h32v128H64zm96 128V288h32v128zm96 0V288h32v128zm96 0V288h32v128zm32-192h-32V96h32zM288 96v128h-32V96zm-96 0v128h-32V96z" })
  }
), Bx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M52.1 93.7c-16.4-6.6-24.4-25.2-17.8-41.6s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), ux1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z" })
  }
), Rx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48M288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24" })
  }
), $x1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm64-256v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48m192 256c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z" })
  }
), kx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 103.4h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16M0 406.4c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM119.5 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16zm16 103.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6zM254.9 32h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16m0 119.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16m-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7zm16 103.5h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16zM358.4 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16zm0 119.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16zm16 103.5H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6z" })
  }
), Px1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M0 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM208 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80-368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM400 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16" })
  }
), Fx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 24C0 10.7 10.7 0 24 0h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24m64 72h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m0 288h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m128-256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m128-256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32M24 288h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), Tx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 168c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm0 160c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40m128 160c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40m128 160c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40z" })
  }
), Ax1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192m0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192m352-352a96 96 0 1 1-192 0 96 96 0 1 1 192 0m-96 144c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24" })
  }
), Dx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192m0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192m160-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0m96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192" })
  }
), yx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6m0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6m44.8 74.7a44.8 44.8 0 1 1-89.6-.1 44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6M209.1 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0m-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6m44.8 74.7a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0M164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6M328.5 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0m-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6m44.8 74.7a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0M283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6M448 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0m-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6m44.8 74.6a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0M403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6" })
  }
), bx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m0 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0M32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64M160 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64M352 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64m32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64" })
  }
), fx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0m0 160a64 64 0 1 1-128 0 64 64 0 1 1 128 0M64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128M288 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0m-64 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128m64 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0m96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128m64 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0m-64 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128" })
  }
), Ux1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40zm0 160c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40zm128 160v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40m32-320c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40zm128 160v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40M160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40zM448 72v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40M320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40zm128 160v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40" })
  }
), Gx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 24.1-3.8 47.3-10.9 69.1-8.5-8.6-17.2-17-26.2-25.1-17.7-16-44.7-16-62.5-.1-35.4 31.6-65.6 67.7-87.3 102.8-15 24.3-27.7 51-33.6 77.3h-3.6c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96zm96 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48m293.5-276.2c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 56.7 24.2 76.9-.1 87.9-71.4 162-160.1 162-89.7 0-160-74.2-160-161.9 0-26.4 12.7-58.6 32.4-90.6 20-32.4 48.1-66.1 81.4-95.8 5.6-5 14.2-5 19.8 0zM466 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), qx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4v2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24M0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32 0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8.3 10.1.8l7.5-17.5C46.6 337.3 0 270.1 0 192m155.3 232h151.2l-18.3-42.7c-10.5 1.8-21.2 2.7-32.2 2.7h-64c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14M96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48M256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4v2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Wx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 89.8-52.9 167.3-129.2 203L382 446.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96zm151.8 296h144.4l-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Ex1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0m112-272a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-48 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), Ox1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 176a48 48 0 1 0 96 0 48 48 0 1 0-96 0m-160 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0M64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96m272 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0m-112 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96M16 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0" })
  }
), Ix1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), Nx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Xx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 352h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40m192 0h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40M40 320c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zm192-128h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40M40 160c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zM232 32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40" })
  }
), Kx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 136c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40m128 192c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40m128 192c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40z" })
  }
), Qx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5a255.9 255.9 0 0 0-60.6 27C114.3 34 105.4 32 96 32c-35.3 0-64 28.7-64 64 0 9.4 2 18.3 5.6 26.3-11.5 18.7-20.6 39-27 60.6-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4 2 .2 4.1.3 6.1.3 35.3 0 64-28.7 64-64 0-2.1-.1-4.1-.3-6.1 12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9-.2 2-.3 4.1-.3 6.1 0 35.3 28.7 64 64 64 2.1 0 4.1-.1 6.2-.3 7.5 12.9 13.6 26.8 17.9 41.4 5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8a255.9 255.9 0 0 0-27-60.6c3.6-8 5.6-16.9 5.6-26.3 0-35.3-28.7-64-64-64-9.4 0-18.3 2-26.3 5.6-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8a255.9 255.9 0 0 0 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64 9.4 0 18.3-2 26.3-5.6 18.7 11.5 39 20.6 60.6 27 16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9.2-2 .3-4.1.3-6.2 0-35.3-28.7-64-64-64-2.1 0-4.1.1-6.2.3-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8S445 294 440 310.9c-4.3 14.6-10.4 28.5-17.9 41.4-2-.2-4.1-.3-6.2-.3-35.3 0-64 28.7-64 64 0 2.1.1 4.1.3 6.2-12.9 7.5-26.8 13.6-41.4 17.9-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5a255.9 255.9 0 0 0 60.6-27c8 3.6 16.9 5.6 26.3 5.6 35.3 0 64-28.7 64-64 0-9.4-2-18.3-5.6-26.3 11.5-18.7 20.6-39 27-60.6zm-308.5-72.4c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4v-60.4c0-5.7-4.7-10.4-10.4-10.4h-60.5c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1 0 43.6 24.9 81.3 61.1 99.8 11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57 0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1 0-43.6-24.9-81.3-61.1-99.8-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z" })
  }
), Zx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-17.7 0-32 14.3-32 32v34.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c90.8-15.2 160-94.2 160-189.3 0-17.7-14.3-32-32-32H224v-92c22.1 5.7 41.8 17.1 57.6 32.6 12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32m-32 132v248c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124m64 248v-92h92c-11.6 45-47 80.4-92 92" })
  }
), Jx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 81.1v33.6L243.8 223c-14.6-26.1-5.5-50.4 3.2-64.7 4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5-1.2 2.6-2.3 5.1-3.5 7.6-3.5 7.3-8.9 15.7-17.1 24-24.7 25-64.7 40.2-89.6 47.7-14.5 4.4-28.1 11.7-38.7 22.4-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0 10.7-10.8 17.9-24.5 22.2-39.2 7.5-25.2 22.5-65.6 47.2-90.6 10-10.1 20-16 28.3-19.3l1.1-.5c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7L461.3 96h2.7c26.5 0 48-21.5 48-48S490.5 0 464 0h-1.1c-9.7 0-19.2 2.9-27.3 8.3l-69.4 46.2c-8.9 5.9-14.2 15.9-14.2 26.6M195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0m-64 64 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0" })
  }
), jx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6-11 11-18 24.6-21.4 39.6-3.7 16.6-19.1 30.7-36.1 31.6-25.6 1.3-49.3 10.7-67.3 28.6-44.8 44.9-36.4 125.9 18.7 181s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3.9-17 15-32.3 31.6-36.1 15-3.4 28.6-10.5 39.6-21.4 31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), Yx1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M104 0h48c13.3 0 24 10.7 24 24v52.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7V178c50.3 8.6 88 43.8 88 86 0 14-4.2 27.3-11.6 39.1-8.2 13-7.5 32 2.9 43.4 5.9 6.5 10.9 13.7 14.8 21.3-2.3 4.9-4.7 9.6-7 13.9-8.8 16.3-15 35.6-15 56.5 0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512 57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5 10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86v-44.3L84.2 94.1C81.4 88.6 80 82.4 80 76.2V24c0-13.3 10.7-24 24-24m24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80m232-195.4-21.4-24.5c-6.6-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8v4.6c0 12.4-6.4 23.3-16 29.7v164.8c27.9-4.2 39.6-19.4 44.5-31.3 3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16v29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1 0 33.5 17 70.9 28.8 92.9 6.9 12.7 11.2 26.9 11.2 41.3 0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3 11.8-22 28.8-59.4 28.8-92.9 0-11.2-2-20.5-4.5-27.8l-2.7-7.5c-4.3-11.8-8.8-23.8-8.8-36.2V192c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c3.9 16.4 14.9 40.5 45.8 46.7zM336 320c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16" })
  }
), _x1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8l20.6-57.8H464c8.5 0 16.6-3.4 22.6-9.4l22.7-22.6H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM195.6 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H236.4l-40.8-32zm142.9 112h43.4l-9.5 26.6zm-13.6 112L264 304h-3l.5-2L32 121.2V208c0 17.7 14.3 32 32 32h10c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h96c14.7 0 27.5-10 31-24.2L249 352z" })
  }
), hH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 56c0-13.3-10.7-24-24-24S80 42.7 80 56v9.3C34.6 72.9 0 112.4 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h104c14.7 0 27.5-10 31-24.2l20-79.8h53v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-41l18-72h199c41.8 0 77.4-26.7 90.5-64H552c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-13.5c-13.1-37.3-48.7-64-90.5-64H128zm-32 72h352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), cH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96v112c0 17.7 14.3 32 32 32h10c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352h104.4c23.7 0 44.8-14.9 52.7-37.2l26.8-74.8H432c8.5 0 16.6-3.4 22.6-9.4l22.7-22.6H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-16zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128h384c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), sH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V256z" })
  }
), vH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32z" })
  }
), eH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4h4.4c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448h208c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z" })
  }
), lH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64zm336-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h114.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56h-64.6c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120 0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z" })
  }
), tH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M479 103.8 441 256h135V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32v128h192V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64v128c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32" })
  }
), wH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64zm368-32c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4.4 19.3 6.5 26.8S390.4 280 400 280h124c28.7 0 52 23.3 52 52s-23.3 52-52 52h-67.6c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116h-84.6L458 128h118c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), gH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m537 116-35.3 44.1c76.9 3 138.3 66.3 138.3 143.9 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45M416 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0M32 64c17.7 0 32 14.3 32 32v128h192V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64v128c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32" })
  }
), iH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m283.9 378.6 18.3-60.1c18-4.1 34.2-16 43.1-33.8l64-128c10.5-21.1 8.4-45.2-3.7-63.6l52.7-76.6c3.7-5.4 10.4-8 16.7-6.5s11.2 6.7 12.3 13.1l16.2 104.1 105.1-7.4c6.5-.5 12.7 3.1 15.5 9s1.8 12.9-2.6 17.8L550.1 224l71.3 77.5c4.4 4.8 5.5 11.9 2.6 17.8s-9 9.5-15.5 9l-105.1-7.4L487.3 425c-1 6.5-5.9 11.7-12.3 13.1s-13-1.1-16.7-6.5l-59.7-86.7-91.4 52.2c-5.7 3.3-12.8 2.7-17.9-1.4s-7.2-10.9-5.3-17.2zm28.3-101.7c-9.3 10.9-25.2 14.4-38.6 7.7l-65.9-32.9-85.7-42.9-104.3-52.2c-15.8-7.9-22.2-27.1-14.3-42.9l40-80C48.8 22.8 59.9 16 72 16h120c5 0 9.9 1.2 14.3 3.4l78.2 39.1 81.8 40.9c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-1.2 2.4-2.7 4.6-4.4 6.6zm-204.6-39.5 85.9 42.9L90.9 485.5C79 509.2 50.2 518.8 26.5 507s-33.3-40.8-21.4-64.5z" })
  }
), mH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c17.7 0 32 14.3 32 32v18.8l123.3-18.4c9.2-1.4 18.6 1.3 25.6 7.4S384 54.7 384 64v192c0 9.3-4.1 18.2-11.1 24.2s-16.4 8.8-25.6 7.4l-150.6-22.5c-3.1-.5-6.3-.5-9.5 0L36.7 287.6c-9.2 1.4-18.6-1.3-25.6-7.4S0 265.3 0 256V64c0-9.3 4.1-18.2 11.1-24.2s16.4-8.8 25.6-7.4L160 50.8V32c0-17.7 14.3-32 32-32m0 296.7 32 4.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.5z" })
  }
), aH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4L295.4 174c-15-15-23.4-35.2-23.4-56.4v-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8zM27.4 377.1l233.5-194.5c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6C120.4 502 98.9 512 76.3 512 34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z" })
  }
), oH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40v132c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40v164c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40v200c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6 0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288m221.4 0c-38.4 0-76.8 35.8-90.6 50.2-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8c13.8 14.4 52.2 50.2 90.6 50.2s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288m0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), nH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0c-26.5 0-48 21.5-48 48v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-26.7l-9 7.5C40.4 169 32 187 32 206v38c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V144c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0" })
  }
), rH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 512c-22.1 0-40-17.9-40-40V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v55.7c-2-1.4-3.9-3-5.8-4.5l-19.2-16C24.4 215 16 197 16 178v-38c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0H288c70.7 0 128 57.3 128 128v96c0 26.5-21.5 48-48 48-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2V472c0 22.1-17.9 40-40 40" })
  }
), dH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 168c0-22.1 17.9-40 40-40h280c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.7c1.4-2 3-3.9 4.5-5.8l16-19.2C297 56.4 315 48 334 48h38c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128h-96c-26.5 0-48-21.5-48-48 0-12.4 4.7-23.6 12.3-32.1C227.5 366 208 345.3 208 320c0-12.4 4.7-23.6 12.3-32.1C195.5 286 176 265.3 176 240c0-12.3 4.6-23.5 12.2-32H40c-22.1 0-40-17.9-40-40" })
  }
), SH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 128H43.8c-6.5 0-11.8-5.3-11.8-11.8 0-3.9 1.9-7.5 5.1-9.7L75.6 80 37.1 53.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 37.3 37.3 32 43.8 32h69c3.7-18.3 19.8-32 39.2-32 22.1 0 40 17.9 40 40v88h-16zm0 112v-80h80v28.2c8.5-7.6 19.7-12.2 32-12.2 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48v96c0 70.7-57.3 128-128 128H185.9c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372v-38c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5V320c0 8.8 7.2 16 16 16s16-7.2 16-16v-73z" })
  }
), zH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 168c0-22.1-17.9-40-40-40H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h55.7c-1.4-2-3-3.9-4.5-5.8l-16-19.2C215 56.4 197 48 178 48h-38c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9V320c0 70.7 57.3 128 128 128h96c26.5 0 48-21.5 48-48 0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32H472c22.1 0 40-17.9 40-40" })
  }
), pH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 0c-22.1 0-40 17.9-40 40v280c0 8.8-7.2 16-16 16s-16-7.2-16-16v-55.7c-2 1.4-3.9 3-5.8 4.5l-19.2 16C24.4 297 16 315 16 334v38c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H288c70.7 0 128-57.3 128-128V288c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40" })
  }
), MH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v272c0 1.5 0 3.1.1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-48 304a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48-16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), xH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m93 18.5 17.3 37.2L75 131.3 35 45.5c-7.5-16-.5-35.1 15.5-42.5S85.6 2.5 93 18.5M150.6 272h1.4c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h51.3zm41.4-19.9c-8-5.4-17.2-9.2-27-11l16-34.1 11 23.7v21.5zM130.2 240H59.6L163 18.5c7.5-16 26.5-22.9 42.5-15.5s22.9 26.5 15.5 42.5zm93.8-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), HH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c17.7 0 32 14.3 32 32v112h-64V32c0-17.7 14.3-32 32-32M64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-78.4c-17.3-7.9-33.2-18.8-46.9-32.5l-11.6-11.6c-24-24-37.5-56.6-37.5-90.5v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72" })
  }
), VH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32v208c0 97.2-78.8 176-176 176h-19.2c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32m-48 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6 0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5-8.1-12.2-21.7-19.5-36.4-19.5h-1.1c-23.5 0-42.6 19.1-42.6 42.6z" })
  }
), CH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 121.7c0 3.5 2.8 6.3 6.3 6.3 1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1.8 3.5 0 6.3-2.8 6.3-6.3V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80zm344.2 214.6c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), LH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), BH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6l66.3 96.4c11.2 16.3 17.2 35.6 17.2 55.3v1.7c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3l66.3-96.4zm292.7 329.7c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), uH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9l126.6-93.3C166.2 41.3 194.5 32 223.5 32H544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-36.8l-44.9 36c-22.7 18.2-50.9 28-80 28H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160h.9zm185.8 144.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 352h-.9.9" })
  }
), RH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4zm404.3 199.4c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), $H1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 80c0 8.8 7.2 16 16 16h80c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-44.2 0-80-35.8-80-80s35.8-80 80-80h112c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h64c35.3 0 64-28.7 64-64s-28.7-64-64-64H208c-8.8 0-16 7.2-16 16m376.2 256.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), kH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 24v56h-56c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56h56c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-56V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24m335.7 368.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H193.7c-29.1 0-57.3 9.9-80 28l-44.9 36H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h320.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2h.9-.9" })
  }
), PH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 14.5c0-8 6.5-14.5 14.5-14.5H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-14.5C161.1 160 96 94.9 96 14.5m384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5m88.2 321.7c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.4c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9" })
  }
), FH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M371.6 232.2c-6 3.8-9.4 10.8-8 17.7l4.1 20.6c.2.9.3 1.9.3 2.9 0 8-6.5 14.6-14.6 14.6H222.6c-8 0-14.6-6.5-14.6-14.6 0-1 .1-1.9.3-2.9l4.1-20.6c1.4-7-2-13.9-8-17.7C167.8 209 144 171 144 128 144 57.3 208.5 0 288 0s144 57.3 144 128c0 43-23.8 81-60.4 104.2M240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m200.2 192.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5M193.6 384h-.9.9" })
  }
), TH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H193.7c-29.1 0-57.3 9.9-80 28l-44.9 36H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h320.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5.5 0 1 1-.9.1.5.5 0 1 1 .9-.1" })
  }
), AH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C32 14.3 46.3 0 64 0s32 14.3 32 32v208H32zm192 160c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m160-32c0-17.7 14.3-32 32-32s32 14.3 32 32v256c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 35.3 0 64-28.7 64-64v-64z" })
  }
), DH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112c0-26.5 21.5-48 48-48h238.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v76c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-13.8L273.9 352H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h128c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48-21.5-48-48" })
  }
), yH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c17.7 0 32 14.3 32 32v256c0 35.3 28.7 64 64 64 19.1 0 36.3-8.4 48-21.7 11.7 13.3 28.9 21.7 48 21.7 35.3 0 64-28.7 64-64V96c0-17.7 14.3-32 32-32s32 14.3 32 32v240c0 97.2-78.8 176-176 176h-19.2c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V32c0-17.7 14.3-32 32-32zm64 192c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32zm128 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32" })
  }
), bH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 0c-22.1 0-40 17.9-40 40v164.2c-8.5-7.6-19.7-12.2-32-12.2-26.5 0-48 21.5-48 48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-55.7c-2 1.4-3.9 3-5.8 4.5l-19.2 16C40.4 297 32 315 32 334v38c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V288c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40" })
  }
), fH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v208h-64V32c0-17.7 14.3-32 32-32m96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zM93.3 51.2 175.9 240h-69.8L34.7 76.8c-7.1-16.2.3-35 16.5-42.1s35.1.3 42.1 16.5zm27 221.3-.2-.5H216c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363v-27c0-32.7 24.6-59.7 56.3-63.5z" })
  }
), UH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32zm192-160c0 17.7 14.3 32 32 32s32-14.3 32-32v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-64 64c17.7 0 32-14.3 32-32v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32m160-96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-96-88v.6c9.4-5.4 20.3-8.6 32-8.6 13.2 0 25.4 4 35.6 10.8 8.7-24.9 32.5-42.8 60.4-42.8 11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0h-61.7C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72" })
  }
), GH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h208V96zm160 192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-64-64c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32m96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zm88-96h-.6c5.4 9.4 8.6 20.3 8.6 32 0 13.2-4 25.4-10.8 35.6 24.9 8.7 42.8 32.5 42.8 60.4 0 11.7-3.1 22.6-8.6 32h8.6c88.4 0 160-71.6 160-160v-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64h-27c-35.3 0-64 28.7-64 64v88c0 22.1 17.9 40 40 40s40-17.9 40-40v-56c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 39.8-32.2 72-72 72" })
  }
), qH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H11.8C5.3 128 0 122.7 0 116.2c0-3.9 1.9-7.5 5.1-9.7L43.6 80 5.1 53.5C1.9 51.3 0 47.7 0 43.8 0 37.3 5.3 32 11.8 32zm0 208v-80h64v80zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6c-24-24-37.5-56.6-37.5-90.5v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72" })
  }
), WH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H272V96zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm64-64c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32s14.3-32 32-32h48c17.7 0 32 14.3 32 32m-96 160c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-88-96h.6c-5.4 9.4-8.6 20.3-8.6 32 0 13.2 4 25.4 10.8 35.6-24.9 8.7-42.8 32.5-42.8 60.4 0 11.7 3.1 22.6 8.6 32H160C71.6 448 0 376.4 0 288v-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64h27c35.3 0 64 28.7 64 64v88c0 22.1-17.9 40-40 40s-40-17.9-40-40v-56c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 39.8 32.2 72 72 72" })
  }
), EH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C32 14.3 46.3 0 64 0s32 14.3 32 32v208H32zm192 160c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72" })
  }
), OH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40v148.2c8.5-7.6 19.7-12.2 32-12.2 20.6 0 38.2 13 45 31.2 8.8-9.3 21.2-15.2 35-15.2 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48v112c0 70.7-57.3 128-128 128h-85.3c-5 0-9.9-.3-14.7-1-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7zm112 264c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16m80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), IH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40h180.2c-7.6 8.5-12.2 19.7-12.2 32 0 25.3 19.5 46 44.3 47.9-7.7 8.5-12.3 19.8-12.3 32.1 0 26.5 21.5 48 48 48h96c70.7 0 128-57.3 128-128V206.9c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64H336c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9v.1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208z" })
  }
), NH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c17.7 0 32 14.3 32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32v195.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-31.2 8.9c-18.3 5.3-30.9 22-30.9 41 0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512h-19.2c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32m-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120l13.8-48.3C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7zm480 288 48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7z" })
  }
), XH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.9 23.7c-4.6-17.1-22.1-27.2-39.2-22.6s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2-6.4 0-12-4.2-13.9-10.3l-43.5-143c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64h19.1c.1 0 .1-.1.1-.1 0-.1.1-.1.1-.1 58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6l-37.7 128.2c-1.6 5.3-6.4 8.9-12 8.9-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7l-37.6 177.7c-2.6 12.2-13.3 20.9-25.8 20.9-11.9 0-22.4-8-25.4-19.5l-57-212.8z" })
  }
), KH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m352.2 82.3-1.2-8.5c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3.2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7v-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40v176.4c0 60.2-27.9 116.9-75.5 153.7-50.9 39.3-115.6 49.7-173.6 32.7-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9.1.1 46.6 46.7c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7zM13.7 352.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2C34 441.7 6.3 414 1.3 378.8l-1.1-8.5c-1.2-8.7 4.8-16.9 13.6-18.1z" })
  }
), QH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v272c0 1.5 0 3.1.1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16z" })
  }
), ZH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-48 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9-.4-1.6-.5-3.3-.5-5.1v-16c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32m0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192m192-96c0-25.9-5.1-50.5-14.4-73.1 16.9-32.9 44.8-59.1 78.9-73.9-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160-62 0-115.8-35.3-142.4-86.9 9.3-22.5 14.4-47.2 14.4-73.1m224 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0M368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), JH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7v9.3c0 70.7 57.3 128 128 128h80v-.3c35.2-2.7 65.4-22.8 82.1-51.7 8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20 8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5l-100.8 27.5 81.6-68c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1L133.6 92.3zm326.8 419.4c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128h-80v.3c-35.2 2.7-65.4 22.8-82.1 51.7-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20 22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L445 387.4l-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z" })
  }
), jH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32v181.9c0 14.2 5.1 27.9 14.3 38.7l85.3 99.4H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h384c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v112.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V352h-64v-93.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96zm64 448v32h128v-32h64v32h128v-32h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H128c-13.3 0-24 10.7-24 24s10.7 24 24 24z" })
  }
), YH1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64M160 464a48 48 0 1 0-96 0 48 48 0 1 0 96 0M32 160l.1 72.6c.1 52.2 24 101 64 133.1-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32m300.1-71.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27 .9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9.8 17.6 2.2 26.1 35.4 8.2 61.8 40 61.8 77.9 0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512h176c13.3 0 24-10.7 24-24s-10.7-24-24-24h-92c-6.6 0-12-5.4-12-12s5.4-12 12-12h124c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12h156c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12h124c13.3 0 24-10.7 24-24s-10.7-24-24-24H258.8l46.2-28.9c15-9.4 19.5-29.1 10.2-44.1z" })
  }
), _H1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16m-98.7 7.1 32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0l123.8 123.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32v153.6c0 57.1-30 110-78.9 139.4-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zm298.1 365.9c-24.2 14.5-50.9 22.1-77.7 23.1 48.1-39.6 76.6-99 76.6-162.4v-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32v153.6c0 57.1-30 110-78.9 139.4zm-8.2-466.2c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z" })
  }
), hV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80m44.7 164.3 11.1 88.7c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8-19.8 16.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6c18.9-16 42.9-24.8 67.6-24.8s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40m560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z" })
  }
), cV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256M40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40m560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z" })
  }
), sV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m297.4 9.4-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v221.5c0 25.5 10.1 49.9 28.1 67.9l99.9 99.9c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48v-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8-9.7 6.5-22.7 5.2-31-3.1l-51.2-51.1c-12-12-18.7-28.3-18.7-45.3V144zm480 0v160.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V104c0-22.1-17.9-40-40-40s-40 17.9-40 40z" })
  }
), vV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-5.9-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40m560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z" })
  }
), eV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M195.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40m560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z" })
  }
), lV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v221.5c0 25.5 10.1 49.9 28.1 67.9l99.9 99.9c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48v-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8-9.7 6.5-22.7 5.2-31-3.1l-51.2-51.1c-12-12-18.7-28.3-18.7-45.3V144zm480 0v160.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V104c0-22.1-17.9-40-40-40s-40 17.9-40 40z" })
  }
), tV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M351.2 4.8c3.2-2 6.6-3.3 10-4.1 4.7-1 9.6-.9 14.1.1 7.7 1.8 14.8 6.5 19.4 13.6l119.9 179.8c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5l-168.8-45c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-84.9c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3-1-4.7-1-9.6.1-14.1 1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9 1.1 4.6 1.2 9.4.1 14.1-.7 3.2-1.9 6.3-3.6 9.3l-86.3 151.2c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-17.7 14.3-32 32-32s32 14.3 32 32v118.3c0 58-39 108.7-95 123.7L40.3 511c-9.6 2.6-19.9.5-27.7-5.5S0 490 0 480v-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2v-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6 4.6-1.1 9.4-1.2 14.1-.1 3.5.8 6.9 2.1 10 4.1z" })
  }
), wV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m544 160-.1 72.6c-.1 52.2-24 101-64 133.1.1-1.9.1-3.8.1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4l-45.9-79.5c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 43.3 75 .1-49.3c0-17.7 14.4-32 32-32s32 14.4 32 32M243.9 88.5l24.6 42.5c-13.9 4.5-26.4 13.7-34.7 27-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7 26.8 46.4c.6 6 2.1 11.8 4.3 17.4H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm63.4 22.8c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h124c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h156c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h229.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z" })
  }
), gV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2l-78.1-78c-21.9-21.9-57.3-21.9-79.2 0l-40.1 40.1c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64h-.4v120c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h160c44.2 0 80 35.8 80 80zm-208-56v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2l-16.5 57.6-73.2 73.2c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8.1 2.7.1h160c26.5 0 48-21.5 48-48 0-5.6-1-11-2.7-16h2.7c26.5 0 48-21.5 48-48 0-12.8-5-24.4-13.2-33 25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8H336z" })
  }
), iV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zm374.8 416.8L41.2 128.5C17.9 131.8 0 151.8 0 176v128c0 26.5 21.5 48 48 48h108.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9.8-.8 1.5-1.7 2.2-2.6z" })
  }
), mV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m323.4 85.2-96.8 78.4c-16.1 13-19.2 36.4-7 53.1 12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5L373 188.8 550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2zm22.8 124.4-51.7 40.2c-31.5 24.6-77.2 18.2-100.8-14.2-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h108.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9 4.5-4.9 7.8-10.6 9.9-16.5 19.4 13 45.8 10.3 62.1-7.5 17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z" })
  }
), aV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zm374.8 416.8L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9.8-.8 1.5-1.7 2.2-2.6zM96 171.6 40.6 128H16c-8.8 0-16 7.2-16 16v208c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32m496-192v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16zm32 208a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), oV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m323.4 85.2-96.8 78.4c-16.1 13-19.2 36.4-7 53.1 12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5L373 188.8l139 128V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2zm22.8 124.4-51.7 40.2c-31.5 24.6-77.2 18.2-100.8-14.2-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48v224h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9 4.5-4.9 7.8-10.6 9.9-16.5 19.4 13 45.8 10.3 62.1-7.5 17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16v208c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128zm32 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32m496-192v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16zm32 208a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), nV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3m-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104m82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3M216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104m178.2-52.7C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3M440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104m82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3M584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104m-472 56c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m160 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16m-176-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v176H96c-17.7 0-32-14.3-32-32v-96c0-17.7-14.3-32-32-32S0 174.3 0 192v96c0 53 43 96 96 96h192v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H352v-64h192c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352z" })
  }
), rV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v184.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4zm64 192h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64m256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), dV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-9.8 58.8h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8l-9.7 58.8H416c17.7 0 32 14.3 32 32v1.1c-24.1 3.5-45.8 14.6-62.4 30.9h-38.5l-21.3 128h2.8c-5.4 9.4-8.6 20.3-8.6 32v32h-4.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7h-95.2l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.7-58.9H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zm5.8 159.6-21.3 128h95.1l21.3-128zM464 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), SV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-9.8 58.8h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8l-9.7 58.8H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-68.9l-21.3 128H384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-68.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7h-95.2l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.7-58.9H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zm5.8 159.6-21.3 128h95.1l21.3-128z" })
  }
), zV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 448c176.7 0 320-57.3 320-128 0-19.3-11.8-36.7-29.7-43.9L574.9 262c.7 4.2 1.1 8.5 1.1 12.8 0 42.7-34.6 77.3-77.3 77.3-12.2 0-24.1-2.9-34.7-8.3-10.7 5.4-22.6 8.3-34.7 8.3-38.6 0-70.6-28.3-76.3-65.4-10.6.9-21.6 1.4-32.9 1.4-88.4 0-160-28.7-160-64l-130.4 52C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128m32-242.7c0-42.7 34.6-77.3 77.3-77.3 7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2c6.2 28.8 71.6 51.5 151.5 51.5 11.7 0 23-.5 34-1.4-1.3-5.6-2-11.5-2-17.3zM473.1 168c-5.5 3.8-12.7 3.8-18.2 0-7.5-5.2-16.4-8-25.7-8-25 0-45.3 20.3-45.3 45.3 0 9.2 2.8 18.2 8 25.7 3.8 5.5 3.8 12.7 0 18.2-5.2 7.5-8 16.4-8 25.7 0 25 20.3 45.3 45.3 45.3 9.2 0 18.2-2.8 25.7-8 5.5-3.8 12.7-3.8 18.2 0 7.5 5.2 16.4 8 25.7 8 25 0 45.3-20.3 45.3-45.3 0-9.2-2.8-18.2-8-25.7-3.8-5.5-3.8-12.7 0-18.2 5.2-7.5 8-16.4 8-25.7 0-25-20.3-45.3-45.3-45.3-9.2 0-18.2 2.8-25.7 8m-9.1 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), pV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M153.6 51.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12.1 36-19.2 57.6-19.2 7.1 0 14.4.8 21.6 2.5C482 44.7 512 84.3 512 128c0 7.1-.8 14.4-2.5 21.6C496 224 448 320 448 320h-74.4l26.2-157.4c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2L341.1 320H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v160h-69.1l-27.1-162.6c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4L138.4 320H64S16 224 2.5 149.6C.8 142.4 0 135.1 0 128c0-43.7 30-83.3 74.4-93.5C81.6 32.8 88.9 32 96 32c21.6 0 41.6 7.1 57.6 19.2M448 448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-96h384z" })
  }
), MV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m152.7 135.9-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7l278.8 195.1 35.1 24.6c24.4-6 42.5-28.1 42.5-54.4 0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1.7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4M0 384c0 35.3 28.7 64 64 64h480L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9h-10.6c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2z" })
  }
), xV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9-42.1 18.2-99 34.1-169.9 34.1s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64M111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7 7.9-7.9 20.2-9.2 29.6-3.3 9.5 5.9 13.5 17.9 9.9 28.5-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2c-27.7-28.4-52.6-63-66.1-100.7-3.6-10.6.4-22.6 9.9-28.5 9.5-5.9 21.7-4.5 29.6 3.3 20.4 19.4 45.3 34.8 70.1 47.7z" })
  }
), HV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M149.7 137.8 64 352h384l-62.9-141.4c-.8-1.7-1.1-3.5-1.1-5.4 0-7.3 5.9-13.2 13.2-13.2h.8c1.4 0 2.7.2 4 .6l55.3 16.6c2.1-3.2 4.5-6.1 7.2-8.8 0-14.3 5.5-28.7 16.4-39.6 2.2-2.2 4.6-4.2 7.1-6l-53.6-63.2c-32-37.8-79-59.6-128.5-59.6-68.8 0-130.7 41.9-156.3 105.8zM584 182.2c-1-12.4-11.3-22.2-24-22.2s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6c-12.5 1-22.3 11.3-22.3 24s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48" })
  }
), VV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M279.9 22.2C279 9.8 268.7 0 256 0s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m216.4-304.4c-14.2 0-28.4-5.4-39.3-16.1-62.7 27.1-98.6 85.4-118.9 139.6 4.2 1.6 8.9 1.4 13-.6l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.1 2 8.8 2.2 13 .6-20.3-54.2-56.2-112.5-118.9-139.6-10.9 10.7-25.1 16.1-39.3 16.1-10.2 10.1-24.2 16.4-39.7 16.4s-29.5-6.3-39.6-16.4zM48.1 329.5C34.3 377.5 32 416 32 416h448s-2.3-38.5-16.1-86.5a47.52 47.52 0 0 1-37.3-2.4l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.8c-11.7 5.8-25.2 6.6-37.3 2.4z" })
  }
), CV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200.7 181.4 112 384h112v-48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v48h112l-77.3-177.9c-1.8-4-2.7-8.4-2.7-12.8v-.8c0-5.6 1.5-11 4.2-15.9l18.6-32.5c5.7-10 16.3-16.1 27.8-16.1H455c14.7 0 27.5 10 31 24.2l6.2 24.6c2.2 8.9 10.2 15.1 19.4 15.1 9.5 0 17.7-6.7 19.6-16.1l12.2-60.8c.4-2.1.6-4.2.6-6.3v-6.8c0-9-3.8-17.5-10.4-23.6L457.2 8.4C451.3 3 443.6 0 435.6 0h-2.2c-6.1 0-12.1 1.8-17.3 5l-143 91.6c-32 20.5-57.2 50-72.4 84.8zM320 384v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512h256c77.4 0 134.1-41.7 153.1-57.8 4.6-3.9 6.9-9.6 6.9-15.6 0-12.5-10.1-22.6-22.6-22.6H22.6z" })
  }
), LV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m64 416 104.6-235.3c15.3-34.4 40.3-63.5 72-83.7L387.5 3c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5l-59.8 149.2c-1.9 4.7-2.8 9.7-2.8 14.7 0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4c-2.2-6.4-8.3-10.8-15.2-10.8s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5c-6.5 2.2-10.9 8.3-10.9 15.2s4.4 13 10.9 15.2l40.4 13.5 11.8 35.3zm215.6-274.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7zM32 448h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), BV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2M285.3 208H336c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7.1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2-26.5 0-48 21.5-48 48-26.5 0-48 21.5-48 48 0 20.9 13.4 38.7 32.1 45.3 0 .9-.1 1.8-.1 2.7 0 26.5 21.5 48 48 48 5.6 0 11-1 16-2.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32v-18.7c5 1.8 10.4 2.7 16 2.7 26.5 0 48-21.5 48-48 0-5.6-1-11-2.7-16M160 176v2.7h-.1c0-.9.1-1.8.1-2.7" })
  }
), uV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m448 325.8 44 34.5c8.1 1.4 14.8 6.8 18 14.1l42.9 33.6c10.6.4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1 11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l50.8 39.8C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448zM0 224.2c0-38.7 9.8-75.1 27.1-106.9l314.7 248-2.5.3c-11 1.4-19.2 10.7-19.2 21.8 0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9c-6.4 19.1-24.5 32.9-45.7 32.9h-80v8c0 13.3-10.7 24-24 24H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2M616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), RV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v32l-108.8 13.6c-11 1.4-19.2 10.7-19.2 21.8 0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48h-80v8c0 13.3-10.7 24-24 24H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2m352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64m112 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0m152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-24 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-40-168a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m-40 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), $V1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2m336.6-28.3c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), kV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M45.9 128C75.3 53.1 148.3 0 233.7 0H256c39.3 0 75.8 11.8 106.2 32H304c-61.9 0-112 50.1-112 112 0 17.2 3.9 33.5 10.8 48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zM304 256h203.1c3.2 6.2 4.9 13.1 4.9 20.2 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4-23.5-30.3-40.2-67.8-45-105.4h192.1c20.2 19.8 47.9 32 78.4 32m0-192h112v160H304c-44.2 0-80-35.8-80-80s35.8-80 80-80m176 160h-32V64h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32" })
  }
), PV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c95.2 0 174.2 69.3 189.4 160.1 2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2 0 122.8 67.4 36.9 160 9.3v77.3c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9-10-7.2-17.4-18.2-17.4-30.5V0zm-16 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), FV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2m112-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z" })
  }
), TV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 224.2c0-22.2 3.2-43.6 9.2-63.9l221 160.7c-4 9.5-6.2 20-6.2 31v160H128c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2m248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6M336 304h208l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h146.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h126.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4 8.5-7.8 19.9-12.6 32.4-12.6m48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), AV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2M192 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), DV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2M224 64c-8.8 0-16 7.2-16 16 0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16m-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), yV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2m352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), bV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v112h224V96h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v320h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112v144h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H32C14.3 96 0 81.7 0 64" })
  }
), fV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80C141.1 80 48 173.1 48 288v104c0 13.3-10.7 24-24 24S0 405.3 0 392V288C0 146.6 114.6 32 256 32s256 114.6 256 256v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208M80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-16c-35.3 0-64-28.7-64-64zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-16c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32z" })
  }
), UV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6 26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48-44.2 0-80-35.8-80-80V288C0 146.6 114.6 32 256 32s256 114.6 256 256v112c0 44.2-35.8 80-80 80-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48 10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80" })
  }
), GV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24S0 309.3 0 296v-40C0 114.6 114.6 0 256 0s256 114.6 256 256v144.1c0 48.6-39.4 88-88.1 88l-110.3-.1c-8.3 14.3-23.8 24-41.6 24h-32c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4.1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208M144 208h16c17.7 0 32 14.3 32 32v112c0 17.7-14.3 32-32 32h-16c-35.3 0-64-28.7-64-64v-48c0-35.3 28.7-64 64-64m224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64h-16c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32z" })
  }
), qV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z" })
  }
), WV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0" })
  }
), EV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), OV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16" })
  }
), IV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), NV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6" })
  }
), XV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5.3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8l-22.8-63.4c28.5-16.7 62.4-23.2 95.7-17.6 69 11.4 119.5 71 119.5 140.9v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z" })
  }
), KV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 186.5v220.9l164.7-153.8a85.66 85.66 0 0 0 27.3-62.7v-5.8c0-38.6-27.9-71.5-66-77.9-25.1-4.2-50.8 4-68.8 22l-12 12zM119.4 44.1C165 36.5 211.3 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9 68.9 11.5 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141" })
  }
), QV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 96-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5l180.7 168.7c7.5 7 17.4 10.9 27.7 10.9V163.9z" })
  }
), ZV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M228.3 469.1 47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3l42.4-84.9 1.7 3.4c9.5 19 28.9 31 50.1 31h104.5c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9M503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8-51-113.9c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1-5.7-16-8.7-33-8.7-50.3v-5.8c0-69.9 50.5-129.5 119.4-141 45.6-7.6 92 7.3 124.6 39.9l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9 68.9 11.5 119.4 71.1 119.4 141v5.8c0 16.9-2.8 33.5-8.3 49.1" })
  }
), JV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5" })
  }
), jV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32M32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C15.7 255.6 0 208.5 0 160v-32c0-17.7 14.3-32 32-32m320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160v-32c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), YV1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M445.3 224H510C495.6 108.2 403.8 16.4 288 2v64.7c80.4 13.4 143.9 76.9 157.3 157.3m64.7 64h-64.7c-13.4 80.4-76.9 143.9-157.3 157.4V510c115.8-14.4 207.6-106.2 222-222M2 288c14.4 115.8 106.2 207.6 222 222v-64.6c-80.4-13.5-143.9-77-157.3-157.4zm0-64h64.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224m206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-96z" })
  }
), _V1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128h208V64H160c-17.7 0-32-14.3-32-32m256 288h128v-32c0-53-43-96-96-96h-32zm246.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h280.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z" })
  }
), hC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256h2.2c17.1 0 31.3-13.2 32.5-30.2L80 17.1zM320 352v136c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1-17-59.8-31.1-123.2-31.1-185.4 0-85-89.1-149.2-153.1-189-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5V267.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6 0-10.3 8.3-18.6 18.6-18.6h218.7c10.3 0 18.6 8.3 18.6 18.6 0 8-5.1 15.1-12.7 17.6L331 252.3c-6.5 2.2-10.9 8.3-10.9 15.2V352zM509.6.2c-8.3 1.2-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2h2.2c16.8 0 30.4-13.6 30.4-30.4 0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2z" })
  }
), cC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c-17.7 0-32 14.3-32 32V165.9c0 5.6-4.5 10.1-10.1 10.1-3.6 0-7-1.9-8.8-5.1l-48-83.9C83 123.5 32 199.8 32 288v64h512v-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1-5.6 0-10.1-4.5-10.1-10.1V64c0-17.7-14.3-32-32-32zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9 0-9.2-7.4-16.6-16.6-16.6H16.6z" })
  }
), sC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M479.5 224C471.2 98.9 367.2 0 240 0 107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384h127.2l128.6 121.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-86.5l-1.5-1.5V288h112c17.7 0 32-14.3 32-32s-14.3-32-32-32zM320 417.2l-78-73.7 32.4-55.5H320zm-34.7-314.1 34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), vC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), eC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24zm120 120a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), lC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), tC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.5a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7a72.1 72.1 0 0 0-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4l38.9 40.6 71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8H167.7c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), wC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), gC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), iC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M260.9 495.5a71.814 71.814 0 0 1-72 0L36 407.2c-22.3-12.8-36-36.6-36-62.3V168.3a72.1 72.1 0 0 1 36-62.4l152.9-88.2c22.3-12.9 49.7-12.9 72 0L413.8 106c22.3 12.9 36 36.6 36 62.4v176.5a72.1 72.1 0 0 1-36 62.4zm11.1-372c0-5.7-3.1-11-8.1-13.9l-47.8-27.3c-2-1.2-4.3-2-6.8-2.2-.5 0-1-.1-1.4-.1h-.1c-3.3 0-6.3 1-8.8 2.6-1.5 1-2.9 2.2-4 3.7-1.2 1.5-2.1 3.3-2.6 5.2-.4 1.6-.6 3.1-.6 4.7v304.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-117l24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6v174.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-156l16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zm-144.2-22.3c-8.8 0-16 7.2-16 16V270L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-61.4l32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8v-224c0-8.8-7.2-16-16-16z" })
  }
), mC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M260.9 495.5a71.814 71.814 0 0 1-72 0L36 407.2c-22.3-12.8-36-36.6-36-62.3V168.3a72.1 72.1 0 0 1 36-62.4l152.9-88.2c22.3-12.9 49.7-12.9 72 0L413.8 106c22.3 12.9 36 36.6 36 62.4v176.5a72.1 72.1 0 0 1-36 62.4zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-76.8l33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7v-160c0-8.8-7.2-16-16-16s-16 7.2-16 16v76.9zm97.1 5.9v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144h16c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), aC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), oC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.6a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.6a72.1 72.1 0 0 0-62.4 36L17.1 220z" })
  }
), nC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm304 88v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24m80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96zm-224-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-64z" })
  }
), rC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M229 229 444 70.6l29.3 29.3L315 315zm-101 91-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5l201.3-273.1c5.5-7.4 8.4-16.4 8.4-25.6 0-11.4-4.5-22.4-12.6-30.5l-54.8-54.7C468.5 4.5 457.6 0 446.2 0 437 0 428 2.9 420.6 8.4L147.5 209.6c-12.3 9-19.5 23.4-19.5 38.6zm-57.9 83.3-63 63c-4.5 4.5-7 10.6-7 17v4.7c0 13.3 10.7 24 24 24h68.6c6.4 0 12.5-2.5 17-7l31-31zM224 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h328c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), dC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m315 315 158.4-215-29.3-29.4L229 229zm-187 5v-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5 0 9.2-2.9 18.2-8.4 25.6l-201.3 273c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z" })
  }
), SC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8 34.4-34.4 34.4-90.1 0-124.4-27.8-27.8-69.5-33.1-102.6-16-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3 15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7c22.4-14.2 37.2-39.1 37.2-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6l310.3 310.3zM480 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64M68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80h316.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87" })
  }
), zC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m252.4 103.8 27 48c2.8 5 8.2 8.2 13.9 8.2h53.3c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2h-53.2c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80h316.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zm435.9 316.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9v-53.3c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), pC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-12.9 13c7.6 12.2 12 26.7 12 42.1 0 10.2 7.4 18.8 16.7 23 27.9 12.5 47.3 40.5 47.3 73 0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-64v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-17.6c-11.8-2.4-22.7-7.4-32-14.4-1.5-1.1-2.9-2.3-4.3-3.5-17-14.7-27.7-36.4-27.7-60.5 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-76c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1l-18.1 40.6c-5.4 12.1-19.6 17.6-31.7 12.2s-17.5-19.5-12.1-31.6L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h64c41.7 0 83.4 12.1 117.2 25.7 1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0-48 0 24 24 0 1 0 48 0m88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-88-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), MC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 240C0 111 64 0 224 0s224 111 224 240c0 192-48 272-224 272S0 432 0 240m160-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48m88 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-72 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48m40-264a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-40 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0M128 272c35.3 0 64-28.7 64-64 0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64m256-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64s64-28.7 64-64" })
  }
), xC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 256C114.6 256 0 213 0 160s114.6-96 256-96 256 43 256 96-114.6 96-256 96m192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6 50.8 19 118.8 30.1 192.3 30.1s141.5-11.1 192.3-30.2" })
  }
), HC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H96V352h156.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32h32v160H32c-17.7 0-32-14.3-32-32zm416 32h192c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32" })
  }
), VC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m220.6 17.7 82.3 164.6-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zm152.2 304.4 15 29.9H544v160H435.8c-24.2 0-46.4-13.7-57.2-35.4l-41.5-83 35.8-71.6zM576 352h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-32zM462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H96V352h156.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32h32v160H32c-17.7 0-32-14.3-32-32z" })
  }
), CC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m100.8 191.8c1 .1 2.1.2 3.2.2 39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5l-5.3-19.5c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7 4.2 9.7 5.8 20.8 3.7 32.3l-6.3 34.9c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32c0 34.6-28.1 62.7-62.7 62.7-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6L11 471.4c-4.8 18 11.6 34.4 29.5 29.6l19.5-5.4c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7 16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5l-19.5 5.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), LC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32C25.1 125.2 0 171.7 0 224c0 138.8 79.6 217.9 113.3 245.1 9.3 7.5 21.1 10.9 33.1 10.9h155.2c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-52.3-25.1-98.8-64-128 17.7 0 32-14.3 32-32s-14.3-32-32-32H176v104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM64 224h320c0 53.7-14.7 96.1-32.9 128H96.9C78.7 320.1 64 277.7 64 224" })
  }
), BC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 0H288c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7-7 14.1-14 24.5-19 31.1-2.5 3.3-4.5 5.7-5.7 7.1-.6.7-1.1 1.2-1.3 1.4l-.2.2c-9 9.1-11.7 22.8-6.8 34.7C7.4 504.2 19 512 32 512h96V320c0-88.4 71.6-160 160-160s160 71.6 160 160v192h96c12.9 0 24.6-7.8 29.6-19.8 4.9-11.9 2.2-25.6-6.8-34.7l-.1-.1c-.2-.2-.7-.7-1.3-1.4-1.3-1.4-3.2-3.8-5.7-7.1-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0m-16 512V320c0-70.7-57.3-128-128-128s-128 57.3-128 128v192z" })
  }
), uC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32" })
  }
), RC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3l169.7-60.1c21.4-7.6 43.8 8.3 43.8 30.9 0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4h-.1c-6.3 0-12.5-.5-18.6-1.5-3.6-.6-7.2-1.4-10.7-2.3-28.9-7.8-53.1-26.8-67.8-52.2-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4 0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48m328-240a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), $C1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-70.7 0-128 57.3-128 128v32c0 41.8-26.7 77.4-64 90.5v78.6l51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7zM224 320v-64c-53 0-96-43-96-96v-29.4c-21.8 5.5-40.3 19.5-51.7 38.2C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l.3.1zm64-160v-32H160v32c0 35.3 28.7 64 64 64s64-28.7 64-64m208-96a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), kC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-70.7 0-128 57.3-128 128H148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), PC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4 14.5-10.1 34.4-6.6 44.6 7.9s6.6 34.4-7.9 44.6C424.8 495 374.3 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0s256 114.6 256 256v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8 0 8.8-7.2 16-16 16H520c-8.8 0-16-7.2-16-16 0-8.1 6-14.7 13.7-15.8L506.3 400H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-96c0-106-86-192-192-192m-96 192a96 96 0 1 0 192 0 96 96 0 1 0-192 0m96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320m-64-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), FC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.3l80.2-11.5c1.1 7.8 7.7 13.8 15.8 13.8 8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM64 176c0-44.2 35.8-80 80-80h112V32H144C64.5 32 0 96.5 0 176s64.5 144 144 144h272c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-44.2 0-80-35.8-80-80M32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), TC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v208h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48h217.9c-6.3-10.2-9.9-22.2-9.9-35.1 0-46.9 25.8-87.8 64-109.2V48c0-26.5-21.5-48-48-48zm104 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24h-24c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16m360 208a80 80 0 1 0-160 0 80 80 0 1 0 160 0M288 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1" })
  }
), AC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v464h-80v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80h-80zM48 96h112v416H48c-26.5 0-48-21.5-48-48V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v-48c0-26.5 21.5-48 48-48m544 0c26.5 0 48 21.5 48 48v48h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v144c0 26.5-21.5 48-48 48H480V96zM312 64c-8.8 0-16 7.2-16 16v24h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24V80c0-8.8-7.2-16-16-16z" })
  }
), DC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 0c-26.5 0-48 21.5-48 48v16c35.3 0 64 28.7 64 64v352c0 11.7-3.1 22.6-8.6 32H528c26.5 0 48-21.5 48-48v-80H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h112v-64H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V48c0-26.5-21.5-48-48-48zm104 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24h-24c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24zM0 144v240h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v48c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48m120 48c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24H96c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24z" })
  }
), yC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24v-13.2c0-34-14.4-66.4-39.7-89.2l-16.4-14.8C280.7 69.1 272 49.7 272 29.2zM0 320v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16m80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16m112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16m80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16M360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24v-13.2c0-34-14.4-66.4-39.7-89.2l-16.4-14.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24M64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128" })
  }
), bC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zm-45.3 69.3c-6.2-6.2-16.4-6.2-22.6 0-12.5 12.5-23.8 15.1-37.5 17.6l-2.5.4c-13.8 2.5-31.6 5.6-48 22-16.7 16.7-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1-9.2 9.2-18 10.8-32.7 13.4l-.9.2c-15.6 2.8-34.9 6.9-54.4 26.4-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22 16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1 9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4 6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17c10.9-10.9 25.6-17 41-17s30.1 6.1 41 17l15.8 15.8-288 288z" })
  }
), fC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h448c17.7 0 32 14.3 32 32s-14.3 32-32 32v384c17.7 0 32 14.3 32 32s-14.3 32-32 32H304v-48c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32m96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m-240 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-40 192c13.3 0 24.3-10.9 21-23.8-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8z" })
  }
), UC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h298.8c-45.2-31.9-74.8-84.5-74.8-144 0-27.2 6.2-53 17.2-76l-36-36 67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32S369.7 0 352 0H64zm64 75V64h192v11c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53m480 293a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), GC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm64 75V64h192v11c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75" })
  }
), qC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm64 75V64h192v11c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53m16 309c3.5-5.3 7.6-10.3 12.1-14.9l67.9-67.8 67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z" })
  }
), WC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm256 437v11H96v-11c0-25.5 10.1-49.9 28.1-67.9l67.9-67.8 67.9 67.9c18 18 28.1 42.4 28.1 67.9z" })
  }
), EC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-11c0-42.4 16.9-83.1 46.9-113.1l67.8-67.9-67.8-67.9C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32m96 32v11c0 25.5 10.1 49.9 28.1 67.9l67.9 67.8 67.9-67.9c18-18 28.1-42.4 28.1-67.9V64zm0 384h192v-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z" })
  }
), OC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24" })
  }
), IC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 0c-26.5 0-48 21.5-48 48v105.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-18.8c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16v112c0 18-6 34.6-16 48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm144 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM0 277.1V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1M144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24z" })
  }
), NC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z" })
  }
), XC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9l-117.8-92.6c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5l31.4 52.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24z" })
  }
), KC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM237.3 208c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z" })
  }
), QC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16z" })
  }
), ZC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128M176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16" })
  }
), JC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24z" })
  }
), jC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v88c0 22.1 17.9 40 40 40h56.5c1.4 0 2.8 0 4.2-.1 1.1.1 2.2.1 3.3.1h16c22.1 0 40-17.9 40-40v-16.2c.3-2.6.5-5.3.5-8.1l-.7-160.2h32z" })
  }
), YC1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), _C1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), hL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), cL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h102.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4.4 24.9L288 448l38.4 64h122.1c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z" })
  }
), sL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M174.2 8.3c-2.8-5.1-8.2-8.4-14.1-8.4S148.8 3.1 146 8.3l-27.6 51.2-55.6-16.6c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7-51.3 27.6c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6-16.7 55.7c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 14.7 27.2 57.4-53c-9.4 3.9-19.7 6-30.5 6-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3l64.7-59.8-35.3-19 16.7-55.7c1.7-5.6.1-11.7-4-15.9s-10.3-5.7-15.9-4l-55.7 16.6-27.6-51.2zM112 160a48 48 0 1 1 96 0 48 48 0 1 1-96 0m309.7-55.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32v112c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16z" })
  }
), vL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 350.1v1.9h-32c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l137.9 121.1c-12.3-1-25 3-34.8 11.7-35.4 31.6-65.6 67.7-87.3 102.8-20.9 33.9-37.2 72.3-37.2 107.5m165.5-186.3c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), eL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 0c-17.7 0-32 14.3-32 32v480h64V192h112c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32m-64 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288h32v192c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.9-1V159z" })
  }
), lL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 144a144 144 0 1 0-288 0 144 144 0 1 0 288 0M140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3 11.8-3.6 23-9.4 33-16.2 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.4 78.1 3.4 2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128c-11.2-8.1-26.4-8.1-37.6 0L301 64.4c12.1 23.9 19 50.9 19 79.6m18.5 165.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.6 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1m0 112c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.6 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), tL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M306.8 6.1c-11.2-8.1-26.4-8.1-37.6 0l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zm-37.3 303.8C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0M384 448c-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26" })
  }
), wL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM176 269.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z" })
  }
), gL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64v128H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2zM352 304v144h192V304zm-48-16c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32v160h32c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h32z" })
  }
), iL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c0 11.7 3.1 22.6 8.6 32h-.6c-22.1 0-40-17.9-40-40v-88c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l181.3 159.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4zm144-240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), mL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16m32 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), aL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16m176-144a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16" })
  }
), oL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16m176-144a144 144 0 1 1 0 288 144 144 0 1 1 0-288m22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z" })
  }
), nL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 0c17.7 0 32 14.3 32 32h112c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H512v320h-64V32c0-17.7 14.3-32 32-32M276.8 39.7 416 159v353h1H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), rL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), dL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2 5.2-5.6-1-14-8.6-13.2-2.9.3-5.9.4-9 .4-48.6 0-88-39.4-88-88 0-29.7 14.7-55.9 37.2-71.9zm138.3-3.8c-2.6-7-12.4-7-15 0l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3zm158.2 92.2c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32v112c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zM88.5 332.3l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z" })
  }
), SL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l117.8 108.7c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81 15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16M528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-84.3 200.5-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14 44.6 0 84.8 26.8 101.9 67.9l15.3 36.9 21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9.8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l59.4-59.3z" })
  }
), zL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l127.2 117.4c-19 14.8-34.4 34.5-44.1 57.7l-10.7 25.8-10.7 5.4c-31.6 15.8-44.4 54.3-28.6 85.9 15.4 30.9 52.5 43.8 83.6 29.7l-6.8 7.5c-9 9.8-15.4 21.7-18.6 34.7L342 416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m84.3 200.5c-1-.4-1.9-.8-2.9-1.2l16.9 63.5c5.6 21.1.1 43.6-14.7 59.7l-70.7 77.1-22 88.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l23-92.1c1.9-7.8 5.8-14.9 11.2-20.8l49.5-54-19.3-65.5-9.6 23c-4.4 10.6-12.5 19.3-22.8 24.5l-26.7 13.3c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l21.5-10.7 15.3-36.8c17.1-41.1 57.3-67.9 101.9-67.9 22.8 0 45.3 4.8 66.1 14l8 3.5c32.9 14.6 58.1 42.4 69.4 76.5l2.6 7.8c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-2.6-7.8c-5.7-17.1-18.3-30.9-34.7-38.2l-8-3.5zm30 135.1 25 62.4 59.4 59.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L523.7 441c-4.6-4.6-8.2-10.1-10.6-16.1l-14.5-36.2 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z" })
  }
), pL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34 87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184 0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232m8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64M0 376c0 13.3 10.7 24 24 24 48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136-13.3 0-24 10.7-24 24" })
  }
), ML1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S557 192.1 544 192.1h-29.4L601 300c7.7 9.6 9.2 22.8 3.9 33.9S588.3 352 576 352h-29.4L633 460c7.7 9.6 9.2 22.8 3.9 33.9S620.3 512 608 512H400c10-13.4 16-30 16-48V277.1c0-22.4-9.4-43.8-25.9-59l-107.2-98.2L393.4 9.4zM0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24" })
  }
), xL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7 16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0 95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1 13.4 3.8 27.5 5.9 42.2 5.9.7 0 1.4 0 2.1-.1 1.8 0 3.7.1 5.5.1 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.4 15.5-49.9 26.1-77.4 26.1h-.1c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88 13.5 0 26.1 3 37.5 8.3 16 7.5 35.1.6 42.5-15.5s.6-35.1-15.5-42.5c-19.6-9.2-41.5-14.3-64.5-14.3-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6v121c1.6 1 3.3 2 4.8 3.1 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 5.8 1.4 11.2 3.4 16.2 6.2.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72a31.95 31.95 0 0 0-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26" })
  }
), HL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48m168-192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zM24 0C10.7 0 0 10.7 0 24v173.5c0 17 6.7 33.3 18.7 45.3L64 288v176c0 26.5 21.5 48 48 48h128c-10-13.4-16-30-16-48V277.1c0-22.4 9.4-43.8 25.9-59L352 124.6V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v72h-32V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v72H96V24C96 10.7 85.3 0 72 0zm152 160c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-24c0-22.1 17.9-40 40-40" })
  }
), VL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24M352 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-96 96c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80z" })
  }
), CL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V393c21.3-12.2 48.1-11.4 68.8 3.1 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 20.7-14.6 47.7-15.4 69.1-3l-.5-105.6h32zM224 216c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24zm82.5 205.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), LL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM248 192h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24" })
  }
), BL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40h-16c-1.1 0-2.2 0-3.3-.1-1.4.1-2.8.1-4.2.1H392c-22.1 0-40-17.9-40-40v-88c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24" })
  }
), uL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121.9 116.2c16.4-13.1 36.8-20.2 57.7-20.2H223c27.1 0 49 21.9 49 49 0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h123.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h20.3c-2.8 9.9-4.3 20.4-4.3 31 0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3l5.9-4.7c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49 0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-20.3c2.8-10 4.3-20.4 4.3-31 0-62.4-50.6-113-113-113h-43.4c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z" })
  }
), RL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163 101.8c5-39.9 38.9-69.8 79-69.8 47.9 0 85 42 79 89.5l-12 96.7c-5 39.8-38.9 69.8-79 69.8-47.9 0-85-42-79-89.5zm79-5.8c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6 7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6M135.7 68l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284l24-167.5-19.7 8.7c-16.2 7.2-35.1 0-42-16.1S3.2 74 19.4 66.8l72-32c10.6-4.7 22.9-3.4 32.1 3.5s13.8 18.2 12.2 29.7m376 247.5c2.5 17.5-9.7 33.7-27.2 36.2l-448 64C19 418.2 2.8 406 .3 388.5s9.7-33.7 27.2-36.2l448-64c17.5-2.5 33.7 9.7 36.2 27.2m0 96c2.5 17.5-9.7 33.7-27.2 36.2l-224 32c-17.5 2.5-33.7-9.7-36.2-27.2s9.7-33.7 27.2-36.2l224-32c17.5-2.5 33.7 9.7 36.2 27.2M427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6-46.9 0-83.7-40.3-79.5-87l7.3-80.4c3.7-41.1 38.2-72.6 79.5-72.6M412 110.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2 8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2-8.2 0-15 6.2-15.7 14.4z" })
  }
), $L1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208C0 104.4 75.7 18.5 174.9 2.6c9.1-1.4 17.1 6 17.1 15.3v63.3c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4-9.2 1.5-17.1-5.9-17.1-15.2v-63.4c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208m288 48a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), kL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32" })
  }
), PL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9 21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7c-33.2-2.8-58.7-30.5-58.7-63.8V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-95.7c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3.1l-8 .7c-34.1 2.8-64.1 18.9-85.3 42.9-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7.1 29.3z" })
  }
), FL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h96v320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z" })
  }
), TL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M367.1 160c.6-5.3.9-10.6.9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4.3 10.7.9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h288c26.5 0 48-21.5 48-48s-21.5-48-48-48zM96 288l104.8 209.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288z" })
  }
), AL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V132.2c0-21.4 14.2-40.3 34.8-46.2L256 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 232.5 512 270.9 512 315zm40 72c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72v-48h48v48h240v-48h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24" })
  }
), DL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M75.8 304.8 1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0h454.2C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9l-77 461.6c-1.5 9.2-9.5 15.9-18.8 15.9-9.2 0-17.1-6.6-18.7-15.6L336 160l-28.8 143.9c-1.9 9.3-10.1 16.1-19.6 16.1-9.2 0-17.2-6.2-19.4-15.1L240 192l-29.4 176.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192l-28.1 112.3c-2.3 9.2-10.6 15.7-20.1 15.7-9.3 0-17.5-6.2-20-15.2z" })
  }
), yL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v144c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V71l-96 19.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2l11.9 17.8H240c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM192 408a48 48 0 1 0-96 0 48 48 0 1 0 96 0m286.7-129.7L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9.9s-8.2-12.4-5.3-19.2l38.3-89.8H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0l-96.8-99.9c-28-29-26.5-76.9 5-103.9 27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5 31 27 32.5 74.9 4.5 103.9l-96.4 99.9z" })
  }
), bL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm96 320h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80m-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0m16-160h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), fL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32M64 64h128v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64h128c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64m112 373.3c0 5.9 4.8 10.7 10.7 10.7h202.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3M288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), UL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96h576c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96m0 32v288c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128zm64 277.3c0-29.5 23.9-53.3 53.3-53.3h117.4c29.5 0 53.3 23.9 53.3 53.3 0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128m176 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16m0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16m0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16" })
  }
), GL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5.6 32 1.8M352 160V39.1C424.9 55.7 487.2 99.8 527.5 160zM29.9 192H96v128H0c0-46 10.8-89.4 29.9-128zM192 320h-64V192h320v128h-64v32h192v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H48c-26.5 0-48-21.5-48-48v-80h192zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128z" })
  }
), qL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm328 64c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S142.8 384 152 384h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7m-168 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), WL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 32v192c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m96 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), EL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm32 64h256c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32m152 64c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8S106 320 112 320h224c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zm-120 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), OL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0M80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6" })
  }
), IL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2 26.5 0 48 21.5 48 48 0 2-.1 4-.4 6zm169.3 132.7 20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5l111.7 163.6zm-106.4 40.6c.3-.4.6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64h359.4l-81.2-64H152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6z" })
  }
), NL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm128 160a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-48 164.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4" })
  }
), XL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm323.8 106.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6-26.5-33.1c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S78.8 416 88 416h336c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), KL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64m240 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-66.3 160h132.6c25.2 0 45.7 20.5 45.7 45.7 0 10.1-8.2 18.3-18.3 18.3H242.3c-10.1 0-18.3-8.2-18.3-18.3 0-25.2 20.5-45.7 45.7-45.7M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), QL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm236 106.7 96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84c4.5-6.6 12-10.6 20-10.6s15.5 4 20 10.7M192 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-144-8c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), ZL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M58.9 80.5C66 52 91.6 32 121 32h270c29.4 0 55 20 62.1 48.5l57 227.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-92.1c0-5.2.6-10.4 1.9-15.5l57-227.9zM391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439zm-215 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m-32 80h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), JL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32v178.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.3 41.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32M48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48" })
  }
), jL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48" })
  }
), YL1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M121 32c-29.4 0-55 20-62.1 48.5l-57 227.9C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32zm0 64h270l48 192h-51.2c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73z" })
  }
), _L1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m117.7 64-38.4 96h45c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.4c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7h45l-38.4-96H117.7zM60.3 35.2C68.8 13.9 89.4 0 112.2 0h287.6c22.9 0 43.5 13.9 52 35.2L508 175.8c2.6 6.6 4 13.7 4 20.8V264c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56v-67.4c0-7.1 1.4-14.2 4-20.8L60.3 35.2zM48 352h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48" })
  }
), hB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64m192 128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32m32 96h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32M0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m127.8-179.4-102 79.3c-10.5 8.2-25.8.7-25.8-12.6V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z" })
  }
), cB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32h-56.2c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32h-35.6c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4l-224-160c-11.3-8-16.1-22.5-11.9-35.8S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h153.3C173 115.7 144.8 96 112 96H32C14.3 96 0 81.7 0 64" })
  }
), sB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v151.4L316.6 131c16-8.6 35.4 3 35.4 21.1v63.2L508.6 131c16-8.6 35.4 3 35.4 21.1V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V304zm232 248c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm-144 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16m272-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z" })
  }
), vB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32v368c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4v-63.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32z" })
  }
), eB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5l72.3 72.2 72.2-72.2C419.5 111.3 456.4 96 494.9 96 575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2c-27.3 27.2-64.2 42.5-102.7 42.5C65 416 0 351 0 270.9zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8-44.8 0-81.1 36.3-81.1 81.1v29.7c0 44.8 36.3 81.1 81.1 81.1 21.5 0 42.2-8.5 57.4-23.8zm90.5 0 72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8 44.8 0 81.1-36.3 81.1-81.1v-29.8c0-44.8-36.3-81.1-81.1-81.1-21.5 0-42.2 8.5-57.4 23.8L365.3 256z" })
  }
), lB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0M0 224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v224h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V256H32c-17.7 0-32-14.3-32-32" })
  }
), tB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-14 51.8L533.2 248l42-153.7c1.7-6.2.8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zm104.3 272.8c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8H232c-22.1 0-40 17.9-40 40v176c0 22.1 17.9 40 40 40h224c18 0 33.8-12.1 38.6-29.5zM64 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64M64 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), wB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 128v256H64V128zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm40 120c0 13.3 10.7 24 24 24h8v96h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V184c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24m190.6 30.4c5.7-8 17.5-8.6 24-1.2 5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-33.2l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z" })
  }
), gB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128v256h512V128zm-64 0c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm144 56v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), iB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128v256h512V128zm-64 0c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7h-75.4l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3m0 83.1L167.6 280h32.8zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60 0 9.2-2.1 17.9-5.8 25.7 13.3 11 21.8 27.6 21.8 46.3 0 33.1-26.9 60-60 60h-68c-13.3 0-24-10.7-24-24V192zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12h-44z" })
  }
), mB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 64c-13.3 0-24 10.7-24 24v336c0 48.6-39.4 88-88 88s-88-39.4-88-88v-8c0-17.7 14.3-32 32-32s32 14.3 32 32v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 17.7-14.3 32-32 32s-32-14.3-32-32v-8c0-13.3-10.7-24-24-24" })
  }
), aB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 96c-35.3 0-64 28.7-64 64 0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2v1.4c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4l18.6-12c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64zm-24 344a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), oB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 480c17.7 0 32-14.3 32-32V224c0-70.7 57.3-128 128-128s128 57.3 128 128v224c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-106-86-192-192-192S0 118 0 224v224c0 17.7 14.3 32 32 32" })
  }
), nB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2 2.2 8.6-5 15.8-13.8 15.8h-44.7c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3h-79.1c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32 0-70.7 57.3-128 128-128h64c29.7-79.3 29.4-150.9 22.8-194l-87.6 87.6c-6.2 6.2-16.5 6.2-21-1.4-18.5-31.6-22.5-90.9 32.3-145.7 1.4-1.4 2.8-2.7 4.1-4-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24z" })
  }
), rB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32h-58.7L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h58.7L224 96h-64c-17.7 0-32-14.3-32-32" })
  }
), dB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c17.7 0 32 14.3 32 32v256c0 88.4-71.6 160-160 160S0 408.4 0 320v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32" })
  }
), SB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.6 103.9c16.9-5.1 34.8-7.9 53.4-7.9 22.8 0 44.7 4.2 64.8 11.7-.6-2-.8-4.1-.8-6.3v-66c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5 5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1 9.6-11.4 20.6-21.7 32.7-30.5l-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320s68.1 192 152 192c19.3 0 37.8-4.5 54.7-12.8 8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8 83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8l-1.8.3zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-64c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1 32 48c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-64c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5c-21.8 6.5-48.2 10.5-80 10.5s-58.2-4-80-10.5V416c0-8.8-7.2-16-16-16h-16c-8.6 0-15.7 6.9-16 15.4-36.9-24.7-49.9-56.7-54.1-71.4-1.4-5 .3-10.2 4-13.8 5.8-5.8 15.1-6.6 22.2-2.4 18 10.6 55.5 29.1 107.9 36.8V384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c77.6 0 132.8-26.6 155.9-40.2 7.1-4.2 16.4-3.4 22.2 2.4 3.7 3.7 5.4 8.8 4 13.8-4.2 14.7-17.3 46.8-54.1 71.4-.3-8.6-7.3-15.4-16-15.4h-16c-8.8 0-16 7.2-16 16z" })
  }
), zB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C32 14.3 46.3 0 64 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32M0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224h75.6c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7m48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320h75.6c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7M112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h21.8c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7" })
  }
), pB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C32 14.3 46.3 0 64 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32M0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z" })
  }
), MB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m246 315.7-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7.7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-37.6 7.7c-2.2.4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1.2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48-4.6-13 10.2-30 21.4-22 53.5 38 92.7 94.8 107.8 160.7.5 2.1-.2 4.3-1.7 5.9L522.9 213c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6 .1 3.3.2 6.6.2 10 0 17.5-1.7 34.7-4.8 51.3-.2 1.2-.9 2.4-1.7 3.3L506.9 341c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9h14.5c5.7 0 8.6-6.9 4.5-10.9l-46.4-46.5c-.9-.9-1.5-2-1.7-3.3-3.2-16.6-4.9-33.8-4.9-51.3 0-3.3.1-6.7.2-10 .1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9l-28.4-28.5c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22-5.3 15-8.2 31.2-8.2 48 0 46.3 21.9 87.5 55.8 113.9 7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l21.2-31.9c1.3-1.9.2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z" })
  }
), xB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7l-44.1 102.9c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24S0 266.7 0 280v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h144v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16v-16c0-4.6-2-9-5.5-12L320 416.7V384h144v8c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z" })
  }
), HB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16l104 144h116.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6l-102.1 38.3c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320h-32l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h18.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24M80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), VB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-29.7-11.8-58.2-32.8-79.2l-21-21c-27-27-42.2-63.6-42.2-101.8zm128 224c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8zM229.8 360c-4.7-2.3-10-2.7-15.2-2-37.8 5.6-75.2 14.3-106.9 22.8-26.4 7.2-49.4 14.3-65.7 19.6-8.2 2.7-14.7 4.9-19.2 6.5-2.3.8-4 1.4-5.2 1.8l-1.3.5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3.5c1.2.4 3 1.1 5.2 1.8 4.5 1.6 11 3.8 19.2 6.5 16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8M445 512h70.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352h-70.4c-4.1 0-6.2 5.1-3.5 8.3l102.4 122.9c15.2 18.3 37.7 28.8 61.5 28.8m-3.9-151.7 102.4 122.9c14.6 17.5 35.9 27.9 58.6 28.7 21.1-1.1 37.9-18.6 37.9-39.9v-80c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z" })
  }
), CB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 112c0 50.7-33.7 93.6-80 107.4V320h-64V219.4c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112M200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48M64 352c0-17.7 14.3-32 32-32s32 14.3 32 32h256c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-32c0-35.3 28.7-64 64-64" })
  }
), LB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120 0c-13.3 0-24 10.7-24 24v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24zm8 128C57.3 128 0 185.3 0 256v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128zm160 96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32M472 64c-13.3 0-24 10.7-24 24v40h128V88c0-13.3-10.7-24-24-24zm-55.6 328.4c-.1.1-.2.1-.4.2V448c0 16.9-4.3 32.7-12 46.5 11.5 10.9 27 17.5 44 17.5h128c35.3 0 64-28.7 64-64 0-24.1-13.3-45.1-33-56 19.7-10.9 33-31.9 33-56 0-23.5-12.6-44-31.5-55.1 18.7-10.1 31.5-29.9 31.5-52.7 0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8h-90.6c-12.1 0-24.1 2.7-35.1 7.8l-13.2 6.2c-6.9 3.2-13 7.7-18 13 10 20.9 15.6 44.3 15.6 69v135.4c.3.2.7.4 1 .6-.2.1-.4.2-.6.4" })
  }
), BB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zM0 256c0-70.7 57.3-128 128-128h128c70.7 0 128 57.3 128 128v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), uB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32m240 168c0-13.3-10.7-24-24-24-10.3 0-19.1 6.5-22.5 15.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9zm-89.3-63.3 11.8 15.1C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72 0 29.2-17.4 54.3-42.3 65.6 6.8 15.8 10.3 32.9 10.3 50.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V283.9c0-28.5 9.5-56.1 27-78.6l78.3-100.7c2.1-2.6 3.7-5.6 4.8-8.7h163.8c1.1 3.1 2.7 6 4.8 8.7zM128 288c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32z" })
  }
), RB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2.7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z" })
  }
), $B1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m60 120 228 71.2L516 120 288 48.8zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v37.2l-283.2 88.5c-3.1 1-6.4 1-9.5 0L0 149.2V112c0-14 9.1-26.4 22.5-30.5zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l43.3-13.5V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2v-46.4l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20m352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z" })
  }
), kB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M514 128h94c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-94c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224c-3 0-6-.4-9-1.3l-192-56c-13.6-4-23-16.5-23-30.7v-80c0-14.2 9.4-26.7 23-30.7l192-56c2.9-.8 5.9-1.3 9-1.3h158c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16m30 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-116.7-43.3 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L448 278.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l20.7-20.7-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z" })
  }
), PB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M454.3 23.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l240-480zM60.6 113.7c-7.9-15.8-27.1-22.2-42.9-14.3s-22.2 27.1-14.3 42.9l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L160 312.4 60.6 113.7zm320 284.6 23.2-46.3h152.4l23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-128-256C503.2 102.8 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3zM480 199.6l44.2 88.4h-88.4z" })
  }
), FB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0m64 0c0 70.7-57.3 128-128 128-59.6 0-109.8-40.8-124-96h-68v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h196c14.2-55.2 64.4-96 124-96 70.7 0 128 57.3 128 128M64 384a64 64 0 1 0 128 0 64 64 0 1 0-128 0m-64 0c0-70.7 57.3-128 128-128 59.6 0 109.8 40.8 124 96h68v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32H252c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384" })
  }
), TB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160m0 224c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z" })
  }
), AB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24v-40h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3m40-256a40 40 0 1 1 0 80 40 40 0 1 1 0-80" })
  }
), DB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m352-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-416-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), yB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m224-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32zm320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), bB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16M64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m272 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM176 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM153.8 366.8c-3.7 9-1.7 19.3 5.2 26.2l112 112c9.4 9.4 24.6 9.4 33.9 0L417 393c6.9-6.9 8.9-17.2 5.2-26.2S409.7 352 400 352H176c-9.7 0-18.5 5.8-22.2 14.8" })
  }
), fB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16zm112-208h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M113.2 153.8c-9-3.7-19.3-1.7-26.2 5.2L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V176c0-9.7-5.8-18.5-14.8-22.2z" })
  }
), UB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm112-208h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16" })
  }
), GB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 72h14.4c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48S330.5 0 304 0h-64c-17.8 0-33.3 9.7-41.6 24H184c-48.6 0-88 39.4-88 88v48H80c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-5-1.2-9.9-3.4-14.3l-48-96c-5.4-10.9-16.5-17.7-28.6-17.7H144v-48c0-22.1 17.9-40 40-40m-24 376c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64h-64v64z" })
  }
), qB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l-.1.1-.3.6c-.3.5-.7 1.3-1.2 2.3-1 2-2.6 5-4.4 8.6-.5.9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9 1.8 3.7 3.3 6.6 4.4 8.6.5 1 .9 1.8 1.2 2.3l.3.6.1.1c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130 0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80l7.2-14.3h.1l.3.2 1 .5c.8.4 2 1.1 3.5 1.9 2.9 1.7 7 4.1 11.8 7.3 9.6 6.4 22.5 16.1 35.4 29 25.7 25.7 52.7 65.6 52.7 119.3 0 53.1-26.4 100.5-51.2 133.6-12.6 16.7-25.1 30.3-34.5 39.7-4.7 4.7-8.7 8.4-11.5 10.9-1.4 1.3-2.5 2.2-3.3 2.9l-.9.8-.3.2-.1.1-10.2-12.3 10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7v-28.2l-40.3 27.7c-1.9 11.5-11.8 20.2-23.7 20.2-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4.3 6.5.9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9-2.8-2.5-6.7-6.2-11.5-10.9-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3 12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5.3-.2h.1l7.2 14.3-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2 34.5 23.8v-19.1l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l.1-.1.3-.6c.3-.5.7-1.3 1.2-2.3 1-2 2.6-5 4.4-8.6.5-.9.9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9-1.8-3.7-3.3-6.6-4.4-8.6-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1c-3.6-6.7-2-15 3.8-19.9l48-40zm-25.6 119.2c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1m71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z" })
  }
), WB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1 7.1 48 48.8 80.9 95.3 80.9 58.4 0 104-50.4 98.2-108.5l-4.1-41.2c-2-20.1 4.5-40.1 17.9-55.1l18.2-20.5c15.2-17.1 23.5-39.1 23.5-61.9 0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3c-16.7-11.1-36.1-17-56-17zm336 0h-3.2c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l18.2 20.5c13.4 15.1 19.9 35.1 17.9 55.1l-4.1 41.2c-5.8 58.2 39.8 108.6 98.2 108.6 46.5 0 88.2-32.9 95.3-80.9 3.6-24.4 7.1-54.2 7.1-79.1 0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0M228.2 231.1l1.9 18.8 21.5 10.7c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-34.8-17.4-.1.1c-7.5 8.4-11.1 19.5-10 30.7zm173.6-30.7-.1-.1-34.7 17.4c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l21.5-10.7 1.9-18.8c1.1-11.2-2.5-22.3-10-30.7z" })
  }
), EB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64v160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6l171.2 146.7c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z" })
  }
), OB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h32V32zm64 0v448h320V32zm384 448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-32v448zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), IB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0m44.4 32c-14.5 64.1-71.9 112-140.4 112C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16h104c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128m256 160c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24M288 464V352h224v112c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48M48 320h128c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-80c0-8.8 7.2-16 16-16m128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v32zM24 464h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), NB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 0c-14.9 0-27.8 10.3-31.2 24.8l-80 344c-.4 1.7-.7 3.5-.8 5.2l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6-8.6 0-15.6-7-15.6-15.6v-88.6l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6 16.9 0 33-6.7 45-18.6l85.4-85.5c1.8-.1 3.5-.4 5.2-.8l344-80c14.5-3.4 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c22.1 0 40 17.9 40 40v68l-53.3-26.6c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9V339c0 7.2 5.8 13 12.9 13 2 0 4-.5 5.8-1.4L72 324l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4h.5c3.5.1 7 .7 10.4 1.9 1.2.4 2.3.9 3.4 1.5l9.7 4.8 53.3 26.6c1.8.9 3.8 1.4 5.8 1.4 7.1 0 12.9-5.8 12.9-12.9v-70.2c0-7.1-5.8-12.9-12.9-12.9-2 0-4 .5-5.8 1.4L120 284v-68c0-48.6-39.4-88-88-88zm403.3-43.3 52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 160l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 182.6 363.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 160l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z" })
  }
), XB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1S576 471 576 464V224c0-70.7-57.3-128-128-128h-55.7c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32 86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-46c15.3 3.9 31.4 6 48 6 5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-50.9c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), KB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176 100.3 32 224 32s224 64.5 224 144M224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16M64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-24c0-8.8-7.2-16-16-16M139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16m192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6m-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24 25.1 24 56 24 56-10.7 56-24m-56 304C102.4 480 3.4 383.1.1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480" })
  }
), QB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488 0c9.4 0 18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-31 17.2-104.4-104.3-11.3-11.3L463 10.3C469.7 3.7 478.6 0 488 0m-56 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0M262 211.4l11.3 11.3 126 126c6.2 6.2 6.2 16.4 0 22.6C321.4 449.2 235.3 512 112 512c-25.6 0-50.9-4.2-69.5-8.4-9.4-2.1-17.2-4.2-22.7-5.7-2.8-.8-4.9-1.4-6.5-1.9-.8-.2-1.4-.4-1.8-.6l-.5-.2h-.1L16 480l-5.1 15.2c-5.3-1.8-9.2-6.1-10.5-11.5s.3-11.1 4.3-15l246-246z" })
  }
), ZB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m217.5 249.3 242-242c4.7-4.7 11-7.3 17.6-7.3 11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 83.3-48.2 130.5-128.9 209.4-6.5 6.4-13.3 13-20.3 19.9-12.1 11.9-28.4 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-14.6-14.6-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192 16-16 .1-.1z" })
  }
), JB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c17.7 0 32 14.3 32 32v352h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32" })
  }
), jB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h.3c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1v.3c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8-34.7 0-62.8-28.1-62.8-62.8 0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64m0-64c-61.6 0-115.8 40.9-132.7 100.1l-3.3 11.6c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2 0 23.4 6.3 45.3 17.4 64.1l-136 136C-3 469.9-3 490.2 9.5 502.7s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4 28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3c59.1-17.1 100-71.3 100-132.9v-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0zm160 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), YB1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64h.3c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1v.3c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8-34.7 0-62.8-28.1-62.8-62.8 0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64m0-64c-61.6 0-115.8 40.9-132.7 100.1l-3.3 11.6c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2 0 23.4 6.3 45.3 17.4 64.1l-136 136C-3 469.9-3 490.2 9.5 502.7s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4 28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3c59.1-17.1 100-71.3 100-132.9v-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0z" })
  }
), _B1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h108.2l16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1.1 42.3-16l116.4-258.6 121 242c10.8 21.7 33 35.4 57.2 35.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-44.2L197.5 67.4c-10.9-21.7-33-35.4-57.3-35.4z" })
  }
), hu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V173.3l-92.6 92.6L209 448h143c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h111L97 263.8c-2.7-10.9.5-22.4 8.4-30.4L218.7 120l-7.4-7.4C198.9 100.2 192 83.4 192 65.9M432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6 0 26.5-21.5 48-48 48z" })
  }
), cu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M194.3 20.1C199.1 8 210.9 0 224 0h192c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8S490.6 224 480 224H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM288 256h64v192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64z" })
  }
), su1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 176c0-61.9 50.1-112 112-112 57.4 0 104.7 43.2 111.2 98.8-80.1 13.8-143.2 77.1-156.6 157.3-2.9 17.5 11.7 31.9 29.4 31.9h320c17.7 0 32.3-14.4 29.4-31.9-13.5-80.6-77.2-144.2-157.9-157.6C344.6 71.6 268.7 0 176 0 78.8 0 0 78.8 0 176v304c0 17.7 14.3 32 32 32s32-14.3 32-32zm256 272c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64" })
  }
), vu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M82.5 19.7C87.4 7.8 99.1 0 112 0h224c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1S426.7 256 416 256H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 288h128v32s64 50.5 64 112c0 24.4-8.3 44.6-16.4 58.7-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-61.5 64-112 64-112z" })
  }
), eu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 24v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24M192 320c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32H192zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5h324.7c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72" })
  }
), lu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M248 0h16c13.3 0 24 10.7 24 24v10.7c80.4 13.4 143.9 76.9 157.3 157.3h2.7c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24M64 288h64v128h40V288h64v128h48V288h64v128h40V288h64v132.3c.6.3 1.2.7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z" })
  }
), tu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0h80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-80v32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h192V16c0-8.8 7.2-16 16-16zM64 224h64v192h40V224h64v192h48V224h64v192h40V224h64v196.3c.6.3 1.2.7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z" })
  }
), wu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1 4.3 1.7v.9l47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9v-.9l4.4-1.6L240.1 4.2zM64 224h64v192h40V224h64v192h48V224h64v192h40V224h64v196.3c.6.3 1.2.7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z" })
  }
), gu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm320 0v256h256V128zm-141.7 47.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1.1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2l19 42.8h-38zM448 164c11 0 20 9 20 20v4h60c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4.9.6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9L467 333.8c-4.5-2.7-8.8-5.5-13.1-8.5-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8L410 286.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6.5.5c12.4-13.1 22.5-28.3 29.8-45H376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z" })
  }
), iu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c-35.3 0-64 28.7-64 64v256h64V96h128V32zm384 64v256h64V96c0-35.3-28.7-64-64-64H384v64zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2zM344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V56z" })
  }
), mu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2M200 128h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-32c0-22.1 17.9-40 40-40m-8 40v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8m112-40h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c-8.8 0-16-7.2-16-16s7.2-16 16-16m80 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40zm40-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8zM192 272h16c8.8 0 16 7.2 16 16v64h-32v-48c-8.8 0-16-7.2-16-16s7.2-16 16-16m256 16v64h-32v-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16m-80 24v40h-32v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-32v-40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40" })
  }
), au1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2M281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), ou1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C92.7 0 64 28.7 64 64v224H19.2C8.6 288 0 296.6 0 307.2 0 349.6 34.4 384 76.8 384H320v-96H128V64h320v32h64V64c0-35.3-28.7-64-64-64zm384 128H400c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V256h-96c-17.7 0-32-14.3-32-32zm32 0v96h96z" })
  }
), nu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2M288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), ru1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C92.7 0 64 28.7 64 64v224H19.2C8.6 288 0 296.6 0 307.2 0 349.6 34.4 384 76.8 384H352v-96H128V64h320v32h64V64c0-35.3-28.7-64-64-64zm320 448V192h128v256zm-64-272v288c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48" })
  }
), du1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-14-10.9c14.3-13.9 23.2-33.4 23.2-55 0-10.6-8.6-19.2-19.2-19.2h-98.6L154.8 96H512v256h64V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM128 197l-64-50.4V352h64zm359.2 283-121.9-96H19.2C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480z" })
  }
), Su1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c-35.3 0-64 28.7-64 64v256h64V96h384v256h64V96c0-35.3-28.7-64-64-64zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2z" })
  }
), zu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 32c17.7 0 32 14.3 32 32v32.7c5.3-.4 10.6-.7 16-.7s10.7.2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2 3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3v68c0 17.7-14.3 32-32 32s-32-14.3-32-32v-95c-5.2-.7-10.6-1-16-1s-10.8.3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32v-67.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32" })
  }
), pu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.7 0H288C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2.4 46.8 23.4c19.3 9.7 31.5 29.4 31.5 51 0 31.5-25.5 57-57 57H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h71c66.8 0 121-54.2 121-121 0-14.1-2.4-27.8-7-40.6 12.8 1.1 25.8 1.6 39 1.6 159.1 0 288-78.8 288-176 0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2 41.2 20.3 66.8 48.6 66.8 79.8 0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6 3.8-15.2 14.8-27.9 29.9-33.4l26-9.6zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4l-14.7 39.9L266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.9-14.7L351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8-39.9 14.8c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8 39.9-14.8c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7-14.8-39.9c-2.3-6.3-8.3-10.4-15-10.4" })
  }
), Mu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 176c0 97.2-128.9 176-288 176-13.2 0-26.3-.5-39-1.6 4.6 12.8 7 26.5 7 40.6 0 66.8-54.2 121-121 121H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h71c31.5 0 57-25.5 57-57 0-21.6-12.2-41.3-31.5-51l-46.8-23.4.2-.4C44.7 284.1 0 233.2 0 176 0 78.8 128.9 0 288 0s288 78.8 288 176M288 288c123.7 0 224-50.1 224-112S411.7 64 288 64 64 114.1 64 176s100.3 112 224 112" })
  }
), xu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l218.6-101zm212.4 204.4 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2a88.1 88.1 0 0 0 73.8 0l152-70.2zm-152 198.2 152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2a88.1 88.1 0 0 0 73.8 0" })
  }
), Hu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 56c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-96.5 77.2c-14.9-6.9-32.1-6.9-47 0l-218.6 101C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8zm13.4 274.7a88.1 88.1 0 0 1-73.8 0l-152-70.2-53.2 24.5C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z" })
  }
), Vu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 0c-13.3 0-24 10.7-24 24v32h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24c0-13.3-10.7-24-24-24M311.5 133.2c-14.9-6.9-32.1-6.9-47 0l-218.6 101C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8zm13.4 274.7a88.1 88.1 0 0 1-73.8 0l-152-70.2-53.2 24.5C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z" })
  }
), Cu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 96h104c42.7 0 79.9-23.9 98.8-59.1 3.5-6.5 13.6-6.8 16.2.1 13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16c0 13.3-10.7 24-24 24S0 469.3 0 456v-16c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96m-82.3 146.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z" })
  }
), Lu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m339.8 7.5 15.8 31.6c7.1 14.2 23.6 21.1 38.7 16l67.6-22.5c1.4-.5 2.9-.7 4.4-.7 7.6 0 13.8 6.2 13.8 13.8 0 1.5-.2 2.9-.7 4.4l-22.5 67.6c-5 15.1 1.8 31.6 16 38.7l31.6 15.8c4.6 2.3 7.5 7 7.5 12.2 0 4.7-2.4 9.1-6.4 11.6l-97.9 61.2c-6.8 4.3-3.8 14.8 4.2 14.8h38.3c7.6 0 13.8 6.2 13.8 13.8 0 1.5-.2 2.9-.7 4.4l-8.5 25.5c-4.1 12.3-.3 25.9 9.5 34.4l34.3 29.4c3.4 2.9 5.4 7.2 5.4 11.7 0 5.5-3 10.6-7.8 13.4l-28.9 16.5c-11.6 6.6-17.9 19.8-15.7 33l4.2 25.1c.1.6.2 1.3.2 1.9 0 7.6-7.2 13.2-14.6 11.2l-155-40.4c-8.2-2.1-16.6 2.4-19.2 10.4l-8.5 25.4c-1.7 5-6.3 8.4-11.6 8.4-4.4 0-8.5-2.4-10.7-6.3l-53-95.3L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l200.2-200.3c3.6-6.1 2.7-14.1-2.5-19.4-6.2-6.2-16.4-6.2-22.6 0l-84 84-107.9-59.9c-3.9-2.2-6.3-6.2-6.3-10.7 0-5.3 3.4-9.9 8.4-11.6l25.4-8.5c8-2.7 12.5-11.1 10.4-19.2L19.8 70.6C17.9 63.2 23.4 56 31 56c.6 0 1.3.1 1.9.2L58 60.3c13.2 2.2 26.4-4.1 33-15.7l16.5-28.9c2.8-4.7 7.9-7.7 13.4-7.7 4.5 0 8.8 2 11.7 5.4L162 47.7c8.5 9.9 22.1 13.6 34.4 9.5l25.5-8.5c1.4-.5 2.9-.7 4.4-.7 7.6 0 13.8 6.2 13.8 13.8v38.3c0 8 10.5 11.1 14.8 4.2L316 6.4c2.5-4 6.9-6.4 11.6-6.4 5.2 0 9.9 2.9 12.2 7.5z" })
  }
), Bu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m429.7 268.6 40.9-10.2c24.4-6.1 41.4-28 41.4-53.1 0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9S419.4 35.2 399 40.3l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4l-10.2 40.9c-1.5 6-9 8.1-13.4 3.7l-22-22c-17.7-17.7-46.3-17.7-64 0-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4-20.8-13.9-48.5-11.2-66.2 6.5L62 194c-17.9 17.9-22.3 45.2-11 67.8L66.5 293c8.9 17.7 13.5 37.3 13.5 57.2v35.2l149.6-149.6c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l73-73h15.8c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c22.6 11.3 49.9 6.9 67.8-11l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2-3.1-4.7.8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8 17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4z" })
  }
), uu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 96c-78.6 0-145.1 51.5-167.7 122.5 33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88c-16.6 0-32.7 1.9-48.2 5.4-25.9 5.9-50 16.4-71.4 30.7C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448h1c132.1-.7 239-130.9 239-291.4 0-42.6-7.5-83.1-21.1-119.6-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96z" })
  }
), Ru1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M97.9 28.4C92 34.4 87 40.8 83 47.7c-13 21.9-32.4 42.2-52.1 58.2-2.3 1.8-4.4 3.8-6.5 5.9-25.8 25.8-31.2 64.4-15.9 95.4 5.7 11.7 11 24.1 11 37.1V280c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2v12.9c0 2.9.2 5.8.7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6v-45.6c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27 4.4-12.9 10.8-24.8 18.9-35.5-38-36.5-98.4-36-135.8 1.5zm469.6 201.5c-3.1-29.1-2.3-61.5 5-89.9 2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5-28.4 7.3-60.8 8.1-89.9 5-3.3-.3-6.7-.5-10.1-.5-42.1 0-77.9 27.1-90.8 64.9-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v45.7c0 17-6.7 33.3-18.7 45.3l-36.1 35.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.9-35.9c12-12 28.3-18.7 45.3-18.7h45.7c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3 37.5-13.2 64.6-49 64.6-91.1 0-3.4-.2-6.8-.5-10.1m-92.2-129.2c6.2 6.2 6.2 16.4 0 22.6L390.6 208H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.4l-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.3-43.3V192c0-8.8 7.2-16 16-16s16 7.2 16 16v57.4l36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), $u1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M134.1 406.1 11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3l122.8-122.8c6.4-6.4 15-9.9 24-9.9 18.7 0 33.9 15.2 33.9 33.9V192h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v62.1c0 18.7-15.2 33.9-33.9 33.9-9 0-17.6-3.6-24-9.9M384 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32" })
  }
), ku1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96m279.5 313.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22v-72h288c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H320v-72c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4z" })
  }
), Pu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22v72h288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v72c0 9.6-5.7 18.2-14.5 22" })
  }
), Fu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4S352 142.5 352 152v56H160v-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22v-56h192v56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z" })
  }
), Tu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M230.1 406.1 107.3 283.3C100.1 276.1 96 266.2 96 256s4.1-20.1 11.3-27.3l122.8-122.8c6.4-6.4 15-9.9 24-9.9 18.7 0 33.9 15.2 33.9 33.9V192h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288v62.1c0 18.7-15.2 33.9-33.9 33.9-9 0-17.6-3.6-24-9.9M64 96v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Au1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9S224.1 83 224.1 96v96h184c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-184v96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z" })
  }
), Du1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64-6.6 0-13 1-19 2.9-22.5 7-48.1 14.9-71 9-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64 6.6 0 13-1 19.1-2.9 22.5-7 48.1-14.9 71-9 75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71 1.9-6 2.9-12.4 2.9-19.1zm-235.5 31.4c-54.6 16-101.1 62.5-117.1 117.1-2.5 8.5-11.4 13.3-19.9 10.9S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9 8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9" })
  }
), yu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), bu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256l262.7 131.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z" })
  }
), fu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7.8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5M157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), Uu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v130c115.8 14.4 207.6 106.3 222 222.1 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9C16.4 268.2 108.2 176.4 224 162V32c0-17.7 14.3-32 32-32m0 512c-35.3 0-64-28.7-64-64h128c0 35.3-28.7 64-64 64" })
  }
), Gu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7S31.6 68.6 42.7 76l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3zm528 40c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24zM320 32c-88.4 0-160 71.6-160 160v160h320V192c0-88.4-71.6-160-160-160m-80 160c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112 8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80M96 416v32c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32" })
  }
), qu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160v160H64zm160-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80M32 384h384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32" })
  }
), Wu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64zm96-96h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64m32 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32m-32 352c-17.7 0-32-14.3-32-32v-96h128v96c0 17.7-14.3 32-32 32z" })
  }
), Eu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm96 96h64c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64m32-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-32-320c-17.7 0-32 14.3-32 32v96h128v-96c0-17.7-14.3-32-32-32z" })
  }
), Ou1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm96 96h64c35.3 0 64 28.7 64 64v80H96v-80c0-35.3 28.7-64 64-64m128 176v80c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-80zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32m0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Iu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M351 24.2c4.3 17.1-6.1 34.5-23.3 38.8l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32C329.3-3.4 346.7 7 351 24.2zM455.8 127l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zm23.2 57.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3M256 384v-78l48-12v90h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c0 17.7-14.3 32-32 32s-32-14.3-32-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32m199.8-65-64 16-7.8 2v47h-48v-80h.2c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zm560 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3M24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24M101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3m464-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7" })
  }
), Nu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M167.8 63c17.1-4.3 27.6-21.7 23.3-38.8S169.4-3.3 152.2 1l-128 32C7.1 37.2-3.3 54.6 1 71.8S22.6 99.3 39.8 95zM319 88.2c-4.3-17.1-21.7-27.6-38.8-23.3l-256 64C7.1 133.2-3.3 150.6 1 167.8s21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8zM295.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C7.1 229.2-3.3 246.6 1 263.8s21.7 27.6 38.8 23.3l256-64zM64 416v32c0 17.7 14.3 32 32 32h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-80v-90l-48 12v78c-17.7 0-32 14.3-32 32m255-135.8c-4.3-17.1-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27h-.2V384h48v-47l7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8z" })
  }
), Xu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80m20-424v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z" })
  }
), Ku1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m69.3 4 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4m528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3M24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24M117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3m432-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7m-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16h160zM344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Qu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80m0-448c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), Zu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M262.1 352.2c-11 7-19.1 18.6-21.4 31.8H112c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3-17.8 7.7-28 25.6-28 43.3v.9c-17.6-9.7-41.5-8.2-57.2 8.7-9.2 9.9-17.4 20.9-24.4 33S246 285.9 242 298.8c-6.7 21.6 3.4 42.7 20 53.3zM112 416h133.6c3.5 9.2 7.7 18.3 12.8 27 2.9 5 6 9.9 9.4 14.6-10.7 31.6-40.6 54.4-75.8 54.4-44.2 0-80-35.8-80-80zm0-240c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16m260 42.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7 6.8 3.9 15.1 4.5 21.8.6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8.6-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-17.6c0-7.9-4.9-14.9-11.7-18.9-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6 6.9-3.9 11.7-11 11.7-18.9v-17.2zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0" })
  }
), Ju1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m69.3 4 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4m528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3M24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24M117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3m432-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7m-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16h160zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80" })
  }
), ju1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0c-70.3 0-130.9 41.2-159.2 100.8L38.8 5.1zm174.5 136.8C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6zm-60.9 87.9c5.4 16.8 13.2 32.4 23 46.6 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h108.1zM240 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1l-11.3-8.9z" })
  }
), Yu1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80m-80-336c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112 8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80" })
  }
), _u1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m33.5 1.9 112 48c12.2 5.2 17.8 19.3 12.6 31.5S138.8 99.2 126.6 94l-112-48C2.4 40.8-3.3 26.7 1.9 14.6S21.3-3.3 33.5 1.9zm112 204.1-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5M303.9 4.4c10-5.8 22.3-5.8 32.2 0l96 56c15.3 8.9 20.4 28.5 11.5 43.8C437.7 114.3 427 120 416 120v40c17.7 0 32 14.3 32 32 0 13.3-8.1 24.7-19.7 29.5L473.6 448h6.4c17.7 0 32 14.3 32 32s-14.3 32-32 32H352v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h6.4l45.3-226.5c-11.6-4.8-19.7-16.2-19.7-29.5 0-17.7 14.3-32 32-32v-40c-11 0-21.7-5.7-27.6-15.9-8.9-15.3-3.7-34.9 11.5-43.8l96-56zM352 87.7l-32-18.6-32 18.6V160h64zm286.1-73.1c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6zM482 174.6c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5" })
  }
), hR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9l.4.3c.5.3 1.3.8 2.5 1.5 2.4 1.4 6.3 3.6 11.7 6.3 10.7 5.4 27.3 12.8 49.8 20.3C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3 5.4-2.7 9.3-4.9 11.7-6.3 1.2-.7 2.1-1.2 2.5-1.5l.4-.2h.1c14.7-9.7 34.5-5.8 44.3 8.9 9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6h-.1l-.2.1-.4.3c-.3.2-.7.5-1.2.8-1 .6-2.4 1.5-4.2 2.5-3.6 2.1-8.7 4.9-15.3 8.2-13.3 6.6-32.7 15.2-58.2 23.7C495 175.4 419.6 192 320 192s-175-16.6-226.1-33.6c-25.5-8.5-44.9-17.1-58.2-23.7-6.6-3.3-11.7-6.1-15.3-8.2-1.8-1-3.2-1.9-4.2-2.5-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1h-.1l17.7-26.6-17.9 26.4C-.5 112.8-4.4 93 5.4 78.2m517.8 120.5 9.4 25.8c30.8 1.9 59 21.7 70.2 52.5 16.4 45.1-8.8 139.4-31.4 147.6s-102.5-47.8-119-92.9c-11.2-30.8-2.3-64.1 20-85.3l-12.3-33.8c23.2-4 44.2-8.7 63.1-13.8zM320 224c10.9 0 21.6-.2 32-.6v39.2c28.3 12.3 48 40.5 48 73.3 0 48-56 128-80 128s-80-80-80-128c0-32.8 19.7-61 48-73.3v-39.2c10.4.4 21.1.6 32 .6m-140.1-11.5-12.3 33.8c22.3 21.3 31.2 54.5 20 85.3-16.4 45.1-96.4 101.1-119 92.9S20.8 322.1 37.3 277c11.2-30.8 39.4-50.6 70.2-52.5l9.4-25.8c18.8 5.1 39.9 9.9 63.1 13.8z" })
  }
), cR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h160c17.7 0 32-14.3 32-32m0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32M0 320c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m224 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32m64-384c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32m224 128c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32M288 320c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32m224 128c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32" })
  }
), sR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4v229.4l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V141.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32 192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-17.7 0-32 14.3-32 32" })
  }
), vR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8M352 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32" })
  }
), eR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.7-44.4c39.6-25.8 65.9-70.5 65.9-121.3 0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9.3c38.9 6.5 67.4 40.1 67.4 79.5 0 36.6-24.4 67.6-57.9 77.4l-102.9-80.6c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64H144.6c-9.4 0-18.5.9-27.4 2.6L38.8 5.1zM195.6 128h107.8c44.5 0 80.6 36.1 80.6 80.6 0 19.7-7.1 38-19.1 52.1zm251.2 320-81.2-64h-29c-44.5 0-80.6-36.1-80.6-80.6 0-1.9.1-3.7.2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9.3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1z" })
  }
), lR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9.3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6h158.8c44.5 0 80.6 36.1 80.6 80.6 0 39.4-28.5 73-67.4 79.5l-1.9.3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64zm350.8 384c79.9 0 144.6-64.7 144.6-144.6 0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9.3c38.9 6.5 67.4 40.1 67.4 79.5 0 44.5-36.1 80.6-80.6 80.6H336.6c-44.5 0-80.6-36.1-80.6-80.6 0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9.3C243.1 172.4 192 232.7 192 303.4c0 79.9 64.7 144.6 144.6 144.6z" })
  }
), tR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136 0-88.4-71.6-160-160-160h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96 0 43.3-28.6 79.8-67.9 91.8L399.7 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-97.9l-81.7-64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4l-50.3-39.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-53 0-96-43-96-96 0-24.9 9.5-47.6 25-64.6" })
  }
), wR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64C71.6 416 0 344.4 0 256m576 0c0 88.4-71.6 160-160 160h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160m-384-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), gR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6 31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25c24.3-53.8 13.5-118.3-29.6-161.4-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3 20 20 27.5 48.3 21.7 74.5zm167.6 254.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110 38.9 38.9 94.4 51 143.6 36.3zm-290-228.5-56.4 56.4c-56.5 56.5-56.5 148 0 204.5 50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z" })
  }
), iR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6 31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5 50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l112.2-112.3c31.5-31.5 82.5-31.5 114 0 27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0z" })
  }
), mR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 101.3c3-2.4 6.2-4.8 9.7-7.3 17.8-12.7 46.8-30 78.3-30 20.3 0 42.8 9.3 61.4 19.2 20 10.6 41.1 24.7 60.2 39.5s37.1 31.2 50.8 46.5c6.8 7.6 13.1 15.7 17.9 23.7 4.3 7.2 9.7 18.3 9.7 31 0 9.2-2.6 19.1-5.3 27.5-3 9.1-7.4 19.4-12.8 30.3-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448h-64c-84.7 0-148.8-47.1-190.2-95.1-20.9-24.1-36.8-49.4-47.7-71.1-5.4-10.8-9.7-21.1-12.8-30.3C2.6 243.1 0 233.2 0 224c0-12.8 5.5-23.8 9.7-31 4.8-8.1 11.1-16.1 17.9-23.7 13.6-15.3 31.7-31.7 50.8-46.5 19.1-14.9 40.2-29 60.2-39.5C157.2 73.3 179.7 64 200 64c31.5 0 60.6 17.2 78.3 30 3.4 2.5 6.7 4.9 9.7 7.3M64 224c0 7.9 80 96 224 96s224-88.1 224-96c0-7.7-46.3-31.1-138.8-32-3.4 0-6.9.5-10.1 1.5C350 197.6 313.7 208 288 208s-62-10.4-75.1-14.4c-3.3-1-6.7-1.6-10.1-1.5C110.3 192.9 64 216.3 64 224" })
  }
), aR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 160.4c0-35.5 28.8-64.4 64.4-64.4 6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h14c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v-32h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H112z" })
  }
), oR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113c-9.3-9.4-9.3-24.6 0-34s24.6-9.4 33.9 0L63 101.1l55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L63 261.2l55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32m0 160c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32m-64 160c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32M48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), nR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm384 160v224H64V192zm-11.3-96c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.7c-5-5-1.5-13.7 5.7-13.7h73.4zM128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), rR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M498.7 6C507 12 512 21.7 512 32v64c0 13.8-8.8 26-21.9 30.4L416 151.1V432c0 44.2-50.1 80-112 80s-112-35.8-112-80 50.1-80 112-80c17.2 0 33.5 2.8 48 7.7V64c0-13.8 8.8-26 21.9-30.4l96-32c9.7-3.2 20.5-1.6 28.8 4.4M32 64h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), dR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v120h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V80h-8c-13.3 0-24-10.7-24-24m62.7 285.2c-6.5-7.4-18.3-6.9-24 1.2l-11.2 15.5c-7.7 10.8-22.7 13.3-33.5 5.6S4.7 340.8 12.4 330l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9 21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6.3-20.5zM224 64h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 160h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 160h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), SR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128m128-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zM40 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0m88 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0M64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), zR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 96a48 48 0 1 1 96 0 48 48 0 1 1-96 0m48 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96M191.5 54.4c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6l38.4-28.8zm-38.4 188.8 38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6zm0 160 38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6" })
  }
), pR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24v240c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H72v-88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24zm136 48c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32m128 160c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32m0 160c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32" })
  }
), MR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96m128-80c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48-208a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), xR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40 48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24zm152 16c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32zM16 232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24m24 136c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24z" })
  }
), HR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64v149.6l-40.8 11.6c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22l23.2-6.7V448c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3z" })
  }
), VR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32zm0 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32zM0 256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM75 75c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75C107.7 62.5 87.5 62.5 75 75m316.8 271.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l45.3 45.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3zm271.5-316.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l45.2-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3z" })
  }
), CR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7.3 67.4 0 64 0 28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64h.7l41.8 27.9c19.7 13.1 42.9 20.1 66.6 20.1H192v16h-48.9c-7.5 0-14.8-1.7-21.5-5.1l-34.4-17.2c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H192v16h-69.6c-5.2 0-10.3-.8-15.2-2.5l-38.1-12.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H192v16h-16.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1H192l21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8 0 3.9 3.2 7.1 7.1 7.1h177.8c3.9 0 7.1-3.2 7.1-7.1 0-30.2-23.6-55-53.4-56.8l21.4-64h16.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H320v-16h69.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H320V288h48.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H320v-16h18.9c23.7 0 46.9-7 66.6-20.2l41.8-27.8h.7c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64-3.4 0-6.7.3-9.9.8-3.6.6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8l-20.2-26.9c-3.7-4.9-11.2-3.9-12.3 2.1-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5a71.6 71.6 0 0 1-40 12.2h-24.7c-2.7-7.3-6.2-14-10.2-20.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7V138c-3.1-2.3-6.2-4.4-9-6.1-4.3-2.6-9.7-2.6-13.9 0-2.8 1.7-5.9 3.8-9 6.1V80.7c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v91.1c-4 6.2-7.5 13-10.2 20.2h-24.7c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2z" })
  }
), LR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8S32.7 256 48 256h176v176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z" })
  }
), BR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM305 145 177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), uR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c12.1-20.1 20.6-42.6 24.6-66.6H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-34.7C495.9 143.6 432.4 80.1 352 66.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v34.7c-39.9 6.7-75.6 25.7-103.1 52.9L38.8 5.1zm197 154.4c22.5-19.6 52-31.5 84.2-31.5 70.7 0 128 57.3 128 128 0 21.2-5.1 41.1-14.2 58.7l-38.9-30.5c3.3-8.8 5.1-18.3 5.1-28.2 0-44.2-35.8-80-80-80-16.8 0-32.4 5.2-45.3 14l-38.9-30.5zm179.1 263.4-56.8-44.7c-12 3.8-24.8 5.8-38.1 5.8-70.7 0-128-57.3-128-128 0-2.9.1-5.7.3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h34.7C144.2 368.5 207.6 432 288 445.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c22.6-3.8 43.8-11.5 62.9-22.4z" })
  }
), RR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v34.7c80.4 13.4 143.9 76.9 157.3 157.3H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-34.7c-13.4 80.4-76.9 143.9-157.3 157.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.7C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h34.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32M128 256a128 128 0 1 0 256 0 128 128 0 1 0-256 0m128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), $R1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm219 171.7c6.8-28 32.1-48.8 62.2-48.8 35.3 0 64 28.7 64 64 0 24.7-13.9 46-34.4 56.7l-91.8-72zm85.9 322.4c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0z" })
  }
), kR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), PR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), FR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM120 168h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), TR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0M114.1 216.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), AR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0 86 0 0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128m208 112c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), DR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm304.9 494.1c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0z" })
  }
), yR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 192c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192" })
  }
), bR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM168 280v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), fR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3C113.7 111 134.9 96 158.6 96h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), UR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z" })
  }
), GR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9" })
  }
), qR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c44.2 0 80 35.8 80 80v48H144v-48c0-44.2 35.8-80 80-80M80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-16v-48C368 64.5 303.5 0 224 0S80 64.5 80 144m49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3 1.4-1.5 3.1-2.6 5-3.4 2.1-.9 4.2-1.3 6.4-1.3s4.3.4 6.4 1.3c1.8.8 3.5 1.9 5 3.4 1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L270.1 400h-92.2l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zm64.2-56.8h60.2L224 307.8z" })
  }
), WR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 144v48h160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80m-64 48v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64zm96 48c-8.8 0-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-64v-32c0-8.8-7.2-16-16-16m16 144v-64h64v64z" })
  }
), ER1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 64c-44.2 0-80 35.8-80 80v48h32c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h224v-48C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-44.2-35.8-80-80-80M256 384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), OR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c44.2 0 80 35.8 80 80v48H144v-48c0-44.2 35.8-80 80-80M80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-16v-48C368 64.5 303.5 0 224 0S80 64.5 80 144m176 176v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), IR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32v-48C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-32z" })
  }
), NR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 144v48h160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80m-64 48v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64z" })
  }
), XR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4-9-3.5-18.8-5.4-29-5.4h-64.2L390 142.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l51.7-70.2h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7V280c0-137-111-248-248-248zm50.5 168 17.1 40H333zm-87.7 38.1-1.4 1.9h-48.3l32.7-41.5 16.9 39.5zm-186 1.9C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4l77.8-97.2zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), KR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8c-57.4 0-104-46.6-104-104 0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8M0 192c0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5l154.2 154.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192 384 86 298 0 192 0S0 86 0 192" })
  }
), QR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 160c0-70.7 57.3-128 128-128h128c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128v-48c0-38.7-27.5-71-64-78.4zm352 112c0-20.9 13.4-38.7 32-45.3 5-1.8 10.4-2.7 16-2.7 26.5 0 48 21.5 48 48v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48 5.6 0 11 1 16 2.7 18.6 6.6 32 24.4 32 45.3v80h320v-32z" })
  }
), ZR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0C100.3 0 0 100.3 0 224v96c0 106 86 192 192 192h64c106 0 192-86 192-192v-96C448 100.3 347.7 0 224 0m-96 384c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32m-32 0c0-33.2 25.2-60.5 57.6-63.7-1-3.7-1.6-7.6-1.6-11.6 0-7.3 1.8-14.4 5.3-20.7H144c-44.2 0-80-35.8-80-80 0-26.5 21.5-48 48-48h32c44.2 0 80 35.8 80 80 0-44.2 35.8-80 80-80h32c26.5 0 48 21.5 48 48 0 44.2-35.8 80-80 80h-13.3c3.4 6.3 5.3 13.4 5.3 20.7 0 4-.6 7.9-1.6 11.6 32.3 3.2 57.6 30.5 57.6 63.7 0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64m156.7-64h.2c6.1 0 11.1-5 11.1-11.1v-.2c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3c-3.8-3.8-8.7-5.8-13.8-5.8s-10 2-13.7 5.7L200 288l-.4.4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8v.2c0 6.1 5 11.1 11.1 11.1h57.5zM112 192c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16-7.2 16-16 0-26.5-21.5-48-48-48zm240 16c0-8.8-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48" })
  }
), JR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c17.7 0 32 14.3 32 32v124.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32m124.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1v-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9 14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9-1.1-1.1-1.4-2-1.5-2.5-.1-.8-.1-1.8.4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8 26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6.4-1.4 1.5-2.5 18.7-18.7 18.7-49.1 0-67.9zm-22.7 226.3c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6m-238.5 69.4-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1-18.7 18.7-18.7 49.1 0 67.9 1.1 1.1 1.4 2 1.5 2.5.1.8.1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5.3-1.3.8-2.9.8-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4.4 2.9.8.6.4 1.3 1.2 1.8 2.3s.5 2.2.4 2.9c-.1.6-.4 1.4-1.5 2.5-18.7 18.7-18.7 49.1 0 67.9 10.7 10.7 25.3 15.3 39.2 13.8-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48m72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), jR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c17.7 0 32 14.3 32 32v132.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2v-45.5C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398v-73l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6h-.1c-7.4 4.8-9.6 14.6-4.8 22.1 4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8 38.4 0 69.4 31 69.4 69.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32" })
  }
), YR1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9l165.4 248L389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-14.1 9.2-26.5 22.7-30.6" })
  }
), _R1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m244.8 95 28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1c-2.2 6.5-8.3 10.9-15.2 10.9s-13-4.4-15.2-10.9l-28-84.1c-9.8-3.3-19-7.6-27.7-12.9L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l162.6-162.4c-5.3-8.6-9.6-17.9-12.9-27.7l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), h$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 160v96c0 123.7 100.3 224 224 224s224-100.3 224-224v-96H320v96c0 53-43 96-96 96s-96-43-96-96v-96zm0-32h128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64zm320 0h128V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32z" })
  }
), c$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-175-89c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h118.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z" })
  }
), s$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24m80-96v160c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24m80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), v$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208M228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z" })
  }
), e$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-128-32c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0 22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), l$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-280-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), t$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-232 88c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), w$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208M208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288" })
  }
), g$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 16c-29.8 0-54.9 20.4-62 48h-92.8c45.2 31.9 74.8 84.5 74.8 144v176c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-42.6-18.5-81-48-107.3V80c0-35.3-28.7-64-64-64zm0 208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16M0 208v176c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208m64 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16" })
  }
), i$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 208v176c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208m64 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m256 0v176c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H245.2c45.2 31.9 74.8 84.5 74.8 144m64 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16" })
  }
), m$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c-17.7 0-32 14.3-32 32v34.7C69.2 113.9 0 192.9 0 288v160c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124v284c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124v160c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32" })
  }
), a$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4L388 169.2l-65.9 65.9C323.7 322.4 311.5 512 176 512 78.8 512 0 433.2 0 336c0-135.5 189.6-147.7 276.9-146.2l65.9-65.8 18.1-66.3c1.6-5.8 5.3-10.8 10.4-14l64-40zM208 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), o$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 0h96c39.8 0 72 32.2 72 72 0 13.3-10.7 24-24 24h-40c-33.4 0-62.8-17-80-42.9v49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224-144 0-244.1-43.3-244.1-43.3-33.6-11.1-51.8-47.3-40.6-80.8C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8 20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96V24c0-13.3 10.7-24 24-24m88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128" })
  }
), n$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m281.4-140.6c5.8-7.5 14.5-14.7 23.6-11.8 64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8 5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32m80-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-32 64a16 16 0 1 0 32 0 16 16 0 1 0-32 0m32 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32" })
  }
), r$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M408 120c0 54.6-73.1 151.9-105.2 192-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120 168 53.7 221.7 0 288 0s120 53.7 120 120m8 80.4c3.5-6.9 6.7-13.8 9.6-20.6.5-1.2 1-2.5 1.5-3.7l116-46.4c15.8-6.3 32.9 5.3 32.9 22.3v270.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zm-278.4-62.1c2.4 14.1 7.2 28.3 12.8 41.5 2.9 6.8 6.1 13.7 9.6 20.6v251.4L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77v249.3l-192-54.9V255c20.5 31.3 42.3 59.6 56.2 77 20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), d$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M302.8 312C334.9 271.9 408 174.6 408 120 408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192 7.7 9.6 22 9.6 29.6 0M416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7-2.9 6.8-6.1 13.7-9.6 20.6zM15.1 187.3C6 191 0 199.8 0 209.6v270.8c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6-5.6-13.2-10.4-27.4-12.8-41.5L15 187.3zM384 255c-20.5 31.3-42.3 59.6-56.2 77-20.5 25.6-59.1 25.6-79.6 0-13.9-17.4-35.7-45.7-56.2-77v194.4l192 54.9z" })
  }
), S$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64m-32 400V317.1a177.984 177.984 0 0 0 64 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32" })
  }
), z$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m384 476.1-192-54.9V35.9l192 54.9zm32-1.2V88.4l127.1-50.9c15.8-6.3 32.9 5.3 32.9 22.3v334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1 160 37.2v386.4L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z" })
  }
), p$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M481 31c-35.9-35.8-94.1-35.8-130 0l-15 15-13.1-13c-28.1-28.1-73.7-28.1-101.8 0L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l86.1-86c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7l130 130L481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3l-130-130-64.2 64.2c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1z" })
  }
), M$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504 0c-9.7 0-18.5 5.8-22.2 14.8S480.1 34.1 487 41l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160 0 80.2 59.1 146.7 136.1 158.2 0 .6-.1 1.2-.1 1.8V407.8h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24V487.7h24-24c0 13.3 10.7 24 24 24s24-10.7 24-24h-24 24V484.7v.3V483.9v.1V473.9v.1V469.6v.4V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V387.8v.2V384c0-.6 0-1.2-.1-1.8 77-11.6 136.1-78 136.1-158.2 0-31.4-9-60.7-24.7-85.4l24.7-24.7 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192M190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2l-60.1 18.3-29.4-74" })
  }
), x$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M337.8 14.8C341.5 5.8 350.3 0 360 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2 0 .6.1 1.2.1 1.8V407.8h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24V487.7h-48V484.7v.3V483.9v.1V473.9v.1V469.6v.4V456h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V387.8v.2V384c0-.6 0-1.2.1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160 39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2M256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24zm96-264a96 96 0 1 0-192 0 96 96 0 1 0 192 0" })
  }
), H$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 32c-9.7 0-18.5 5.8-22.2 14.8S288.1 66.1 295 73l33.4 33.4-52.6 52.6c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2S448 177.7 448 168V56c0-13.3-10.7-24-24-24zM64 304a112 112 0 1 1 224 0 112 112 0 1 1-224 0m304 176c97.2 0 176-78.8 176-176 0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2S640 177.7 640 168V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8-1.2 2.9-1.8 6-1.8 9v.4c0 6.2 2.5 12.2 7 16.8l33.4 33.4-40.4 40.3V168c0 22.6-13.6 43.1-34.6 51.7-.8.3-1.7.7-2.5 1 22.8 20.5 37.1 50.2 37.1 83.3 0 61.9-50.1 112-112 112-5.4 0-10.8-.4-16-1.1-12.9 20.4-29.1 38.3-48.1 53.1 19.8 7.8 41.4 12 64 12z" })
  }
), V$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224m174.4-88c-11.7 85.8-85.3 152-174.4 152-97.2 0-176-78.8-176-176S110.8 80 208 80c89.1 0 162.7 66.2 174.4 152H416v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32v-56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2S496 345.6 496 335.9V280h-32v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56z" })
  }
), C$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4S230.5 96 224 96h-40v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v24c0 .6 0 1.2-.1 1.8 77 11.6 136.1 78 136.1 158.2 0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2 0-.6-.1-1.2-.1-1.8v-24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352a96 96 0 1 0-192 0 96 96 0 1 0 192 0" })
  }
), L$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M376 0c-9.7 0-18.5 5.8-22.2 14.8S352.1 34.1 359 41l33.4 33.4-22.1 22L345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4-28.7 28.7c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2S512 145.7 512 136V24c0-13.3-10.7-24-24-24zM96 304a112 112 0 1 1 224 0 112 112 0 1 1-224 0" })
  }
), B$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4-52.6 52.6c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2M176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224" })
  }
), u$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48h-52.6C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8c3.7-9 12.5-14.8 22.2-14.8h368c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2L232 346v118h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z" })
  }
), R$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C19.1 0 7.4 7.8 2.4 19.8S.2 45.5 9.3 54.7L224 269.3V448h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0zm224 210.7L109.3 64h293.4z" })
  }
), $$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C19.1 0 7.4 7.8 2.4 19.8S.2 45.5 9.3 54.7L224 269.3V448h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0zm141.3 128-64-64h293.4l-64 64z" })
  }
), k$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8a96.2 96.2 0 0 1-53.3 16.1H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56h-97.2c-19 0-37.5-5.6-53.3-16.1l-37.1-24.8C373.8 72 347.2 64 320 64M132.3 346.3l-29.8-7.4c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h40v48c0 45.1 13.4 87.2 36.3 122.3m405.1-7.4-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3v-48h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16m16 48h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16m16 80c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16" })
  }
), P$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 32c-17.7 0-32 14.3-32 32v96h64V64c0-17.7-14.3-32-32-32m-32 335.4c0 44.5-36.1 80.6-80.6 80.6-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9C300.4 460.9 360.7 512 431.4 512c79.9 0 144.6-64.7 144.6-144.6V192h-64zM64 64C28.7 64 0 92.7 0 128v96c0 35.3 28.7 64 64 64h79.7c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4H384c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64z" })
  }
), F$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M159.1 176c-19.7 43.2-31.1 88.7-31.1 124.8 0 15.9 2.2 31.4 6.3 46l-31.8-7.9c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6v-76.5c-19.7-16.4-32-40.3-32-66.9 0-49.5 43-134.4 96-134.4 52.5 0 96 84.9 96 134.4 0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96m295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1 0-36.1-11.6-81.6-31.3-124.8zM288 320v192h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), T$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64C64 64 0 160 0 272s80 176 176 176h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4h8.4c96 0 176-64 176-176S512 64 288 64M96 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0m320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), A$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7 6.1-.9 12.1-2.5 18-4.5-9.2-12.3-17.3-24.4-24.2-35.4-21.9-35-28.8-75.2-25.9-113.6-20.6 4.1-39.2 13-54.7 25.4-6.5 5.2-16.3 1.3-14.8-7 6.4-33.5 33-60.9 68.2-66.3 2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9 18.6-14.3 50.9-30.5 103.6-35.3l-2.4-2.1c-20.2-15.6-72.4-41.6-185.1-24.5S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8l24.2 164.3c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3.1.5.2 1.1.3 1.6 3.2 21.8-11.6 42-33.1 45.3S99.8 192 96.6 170.3c-.1-.5-.1-1.1-.2-1.6-.6-5.4 5.2-8.4 10.3-6.7 9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8.6-19.9-5.1-27.9-14.8-20.9-57.3-61.2-170-78.3s-164.8 8.9-185 24.5c-7.8 6-11.5 15.4-12.9 25.2l-24.2 164.3c-5.5 37.3-.4 75.8 19.6 107.7zm142.9-154.7c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7.1-.5.1-1.1.2-1.6 3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1.5-.2 1.1-.3 1.6-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7.1-.5.1-1.1.2-1.6 3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1.5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7 23.9 20.8 53.6 35.3 87 40.3s66.1.1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z" })
  }
), D$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h192zm32 384h288c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z" })
  }
), y$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 32H56c-13.3 0-24 10.7-24 24v144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79-40-40c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312v144c0 13.3 10.7 24 24 24h144c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2S302.3 480 312 480h144c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2S480 209.7 480 200V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8S288.1 66.1 295 73l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32" })
  }
), b$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M243.6 19.6c40.1-40 128.3-16.8 196.9 51.9s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384h-58.2c-7.1 0-13.9 2.8-18.9 7.8-10.3 10.3-9.7 26.9-5 40.7 2.1 6.1 3.2 12.7 3.2 19.5 0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12-33.1 0-60-26.9-60-60s26.9-60 60-60c6.8 0 13.4 1.1 19.5 3.2 13.8 4.7 30.4 5.3 40.7-5 5-5 7.8-11.8 7.8-18.9v-58c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2-113.3-66.4-142.2-37.4-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5 20.4 34.9 11.5 43.8-28.5 3.7-43.8-11.5" })
  }
), f$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M4.1 38.2C1.4 34.2 0 29.4 0 24.6 0 11 11 0 24.6 0h109.3c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9l68.5-114.1C356.5 5.9 366.9 0 378.1 0h109.3C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0 176 176 0 1 1-352 0m184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1l-50.2 7.3c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z" })
  }
), U$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32M64 190.3 480 64v384l-131.1-39.8C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96 0-11 1.9-21.7 5.3-31.5L64 321.7c-.9 16.9-14.9 30.3-32 30.3-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32 17.1 0 31.1 13.4 32 30.3m239 203.9-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6 0 26.5 21.5 48 48 48 23 0 42.2-16.2 46.9-37.8" })
  }
), G$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391m279-263c0 106-86 192-192 192-11.4 0-22.5-1-33.3-2.9-5.4-.9-11 .6-14.8 4.5l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6l4 4c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7.3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0l-20.6 20.4c-3.9 3.9-5.4 9.4-4.5 14.8 1.9 10.8 2.9 22 2.9 33.3z" })
  }
), q$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c-38.5 0-75-8.5-107.7-23.7 67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256M74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108 14.6-51.2 49.6-110.2 102.7-163.3S277.6 77.4 328.8 62.8c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9l-.5-.5m-51-73.1C8.5 331 0 294.5 0 256 0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7-67.1 5.8-149.8 48.2-220.8 119.2S29.5 296.7 23.7 363.7z" })
  }
), W$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm208 48a144 144 0 1 1 288 0 144 144 0 1 1-288 0m188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0" })
  }
), E$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm352-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16" })
  }
), O$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64v32h448V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64m0 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128zm96 96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16m0 96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16m0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16" })
  }
), I$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), N$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320h576v-71.4c0-6.8-4.4-12.6-10.1-16.3-13.2-8.6-21.9-23.4-21.9-40.3s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64zm512 288H0v64c0 17.7 14.3 32 32 32h48v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32m128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32m128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), X$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4l18.1 42.3c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64v-1.2c0-4.5.9-8.9 2.7-13.1L20.8 7.4zm96 0c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM308.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3m77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM500.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3m77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32v128c0 17.7 14.3 32 32 32h192V160c0-17.7 14.3-32 32-32s32 14.3 32 32v160h192c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 53-43 96-96 96H352v64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h128v-64H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32m96 0c17.7 0 32 14.3 32 32v128H96V160c0-17.7 14.3-32 32-32m96 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32m192 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32m96 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32" })
  }
), K$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-25.6C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9-9.8-7.6-18.6-16.4-26.4-26.1-11.1-13.8-8.8-33.9 5-45M80 224a112 112 0 1 0 224 0 112 112 0 1 0-224 0" })
  }
), Q$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h97.2c9.7 0 18.9 4.4 25 12L247 256l-92.8 116c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.2c29.2 0 56.7-13.3 75-36l99.2-124H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S384 179.2 384 192.2v32h-80.6L204.2 100c-18.2-22.8-45.8-36-75-36z" })
  }
), Z$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z" })
  }
), J$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24z" })
  }
), j$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm280 232V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), Y$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-35.3 0-64 28.7-64 64v112H59.7c-5.5-9.6-15.9-16-27.7-16-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96v144c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16 17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64zm0 128c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), _$1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm120 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-224 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), hk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), ck1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z" })
  }
), sk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm276 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z" })
  }
), vk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm128 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), ek1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm256 16c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), lk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm144 109.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z" })
  }
), tk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm176 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m120 0c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 320 120 320h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7" })
  }
), wk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), gk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm224 64v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), ik1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343.5 96H448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h104.5l75.2-90.2c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8z" })
  }
), mk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343.5 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h104.5l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8z" })
  }
), ak1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm184 120c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), ok1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm352 32c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V128z" })
  }
), nk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3z" })
  }
), rk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm232 232c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), dk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm169.8 53.3-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 181.6c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), Sk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm160 48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V144c0-17.7-14.3-32-32-32zm224 80v-48c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71z" })
  }
), zk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128c-23.6 0-44.2 12.7-55.3 31.7L38.8 5.1zM64 352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8L64 146.4z" })
  }
), pk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm192 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64m128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-169.5 62.1c-9.9 8.8-10.7 24-1.9 33.9 26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z" })
  }
), Mk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm202.9 80.8c-6.5 2.2-10.9 8.3-10.9 15.2v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-48l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-6.9-4.4-13-10.9-15.2s-13.7.1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6m173.1 38c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.1.1 12.9 1.4 20.1 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4-9.3-.1-20.4 1.9-29.7 7.4-9.9 5.9-18.6 16.4-18.5 31.6.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7-.2-13.5-2.4-22.6-5.5-1.5-.5-3.2-1.1-4.9-1.6-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2.4 2.6.9 4 1.4 8.8 3 20.4 7 32.6 7.4 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4zm-272 0c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.6.1 16.7 1.6 23.3 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7.2-.2-14.2-2.6-23.7-5.8-1.3-.4-2.7-.9-4.1-1.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1.4 2.4.8 3.6 1.2 9 3.1 20.9 7.2 33.2 7.6 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4z" })
  }
), xk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v136c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88z" })
  }
), Hk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), Vk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z" })
  }
), Ck1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64zm256 288h96c53 0 96-43 96-96V128h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64zM228 56c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V264c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V56z" })
  }
), Lk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64zm256 288h96c53 0 96-43 96-96V128h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64zM136.2 92.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6 0 4.5-2.4 8.7-6.3 10.9l-37 21.3c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20 10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6 0-29.1-23.6-52.6-52.6-52.6h-48.5c-19.8 0-37.4 12.4-44 31.1zM234.7 248a26.7 26.7 0 1 0-53.3 0 26.7 26.7 0 1 0 53.3 0" })
  }
), Bk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v192c0 35.3 28.7 64 64 64h32v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l81.1-60.8H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm288 352h-96v32c0 35.3 28.7 64 64 64h117.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3v-48h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v128c0 53-43 96-96 96" })
  }
), uk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M493.7.9 299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3l102.1-176.4c6.5-11.1-2.2-25-15.1-24l-29.3 2.3 74.7-194.3c.6-1.5.9-3.2.9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3.3-4.8.9M192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Rk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256m-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m218.1 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S425.2 384 432 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z" })
  }
), $k1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c53.7 0 103.5-16.5 144.6-44.7-10.6-20.1-16.6-43-16.6-67.3 0-23.6 5.8-46.9 16.9-67.8L476.2 191c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256m-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m120.5 46.1-75.3 141.2c-8.7 16.2-13.2 34.3-13.2 52.7 0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7l-75.3-141.2c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1" })
  }
), kk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512c33.6 0 65.7-6.5 95.1-18.3-39-35.9-63.1-87.5-63.1-143.7 0-35.2 16.3-73.6 37.2-107.4 4.4-7.1 9.1-14.2 14.1-21.3-11.4-4.8-19.3-16.1-19.3-29.3v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v7.4c9-9.4 18.5-18.6 28.5-27.5 17.7-15.9 44.8-15.9 62.5.1 5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256m-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m165.5 3.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), Pk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32m96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Fk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2l-9.9-22.5h-63l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272h35.1zM336 176c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16" })
  }
), Tk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56zm-16 104h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32m192 32H160v192h192z" })
  }
), Ak1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256h-57.1l-34.5-27c2.9-3.1 7-5 11.6-5h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407-43.1-33.9c-12.1 3.8-24.9 5.8-38.2 5.8-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c20.4-2.8 39.7-9.1 57.3-18.2z" })
  }
), Dk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96v160c0 53 43 96 96 96s96-43 96-96h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96m224 144v16c0 70.7-57.3 128-128 128S64 326.7 64 256v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24z" })
  }
), yk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9c-12.1 3.7-24.9 5.7-38.2 5.7-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z" })
  }
), bk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M479.2 32.8c-43.7-43.7-114.7-43.7-158.4 0l-4.7 4.7 158.4 158.4 4.7-4.7c43.7-43.7 43.7-114.7 0-158.4zM293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89l101.8 101.8c31.8 2.8 64.6-8 89-32.4l4.7-4.7L293.5 60.1zm-64.4 111.6L215.8 187 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6l139-120.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32V328.2l37-32 15.3-13.3z" })
  }
), fk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-53 0-96 43-96 96v160c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96M64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128S64 326.7 64 256z" })
  }
), Uk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32 17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32 0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32M32 448h288c70.7 0 128-57.3 128-128s-57.3-128-128-128v-64c106 0 192 86 192 192 0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m80-64h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Gk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64 0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64zm96 56v176c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24m400-40c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16" })
  }
), qk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5-20.3-20.7-48.7-33.6-80-33.6-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60c5.3 10.3 16 17.3 28.4 17.3 17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6 26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z" })
  }
), Wk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40 73.3-73.3C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2S465.7 224 456 224m0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.7 3.5-8.6 5.5-13.7 5.5s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2S288 465.7 288 456V312c0-13.3 10.7-24 24-24zm-256 0c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40-73.3 73.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369l-40-40c-6.9-6.9-8.9-17.2-5.2-26.2S46.3 288 56 288zM56 224c-9.7 0-18.5-5.8-22.2-14.8S32.1 189.9 39 183l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2S224 46.3 224 56v144c0 13.3-10.7 24-24 24z" })
  }
), Ek1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h352c17.7 0 32 14.3 32 32" })
  }
), Ok1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v94.1l-98 98-74.7 14.3C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75 50.5 0 94.3-33.5 108.1-81.2 7.2 10.4 19.3 17.2 32.9 17.2 22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2 64.1-64.2v72.4c14.7 13.2 24 32.3 24 53.7 0 39.8-32.2 72-72 72-7.2 0-14.2-1.1-20.8-3-2.1 8.4-3.2 17.1-3.2 25.9v9.1c0 53 43 96 96 96s96-43 96-96v-9.1c0-25.1-9-49.4-25.3-68.4L312 284v-98.1l64.1 64.1 14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75 0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), Ik1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3 0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1c12.6-14.4 30.7-22.6 49.8-22.6h2.8c34.9 0 63.3 28.3 63.3 63.3 0 15.9-6 31.2-16.8 42.9zM32 448c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32z" })
  }
), Nk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 0C44.7 0 16 28.7 16 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm112 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Xk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64v16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V64h32c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM96 0C51.8 0 16 35.8 16 80v352c0 44.2 35.8 80 80 80h192c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80zm32 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16" })
  }
), Kk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 96v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m16 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0m56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48m24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0M128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Qk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64zm208 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0m80-384H80v320h224z" })
  }
), Zk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64zm128 384c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16M304 64H80v320h224z" })
  }
), Jk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64h160V0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V288h-64v160H64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184 0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0m8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-32-136c0 13.3 10.7 24 24 24 48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136-13.3 0-24 10.7-24 24" })
  }
), jk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64h224v251.7c18.3-21.2 39.9-39.5 64-54V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h160v-24c0-13.6 1-27 3-40H64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm344-128c-128.1 0-232 103.9-232 232 0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184 13.3 0 24-10.7 24-24s-10.7-24-24-24m-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32-136c0-13.3-10.7-24-24-24-75.1 0-136 60.9-136 136 0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88 13.3 0 24-10.7 24-24" })
  }
), Yk1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 0C44.7 0 16 28.7 16 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), _k1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5M128 416H64v-64c35.3 0 64 28.7 64 64M64 224v-64h64c0 35.3-28.7 64-64 64m384 128c0-35.3 28.7-64 64-64v64zm64-192c-35.3 0-64-28.7-64-64h64zm-128 96c0 61.9-43 112-96 112s-96-50.1-96-112 43-112 96-112 96 50.1 96 112m-132-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h48c11 0 20-9 20-20s-9-20-20-20h-4v-68c0-11-9-20-20-20h-16c-11 0-20 9-20 20" })
  }
), hP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm64 320H64v-64c35.3 0 64 28.7 64 64M64 192v-64h64c0 35.3-28.7 64-64 64m384 192c0-35.3 28.7-64 64-64v64zm64-192c-35.3 0-64-28.7-64-64h64zm-336 64a112 112 0 1 1 224 0 112 112 0 1 1-224 0m76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h48c11 0 20-9 20-20s-9-20-20-20h-4v-68c0-11-9-20-20-20h-16c-11 0-20 9-20 20" })
  }
), cP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5M288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96" })
  }
), sP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), vP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64m64 64H96v64c35.3 0 64-28.7 64-64m384 192c-35.3 0-64 28.7-64 64h64zm-224 32a96 96 0 1 0 0-192 96 96 0 1 0 0 192" })
  }
), eP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2V128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-18.7L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1l-91.2 78.2c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c8.8 0 16.8 3.6 22.6 9.3l.1.1zM0 304c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm48 112v48h48c0-26.5-21.5-48-48-48m48-112H48v48c26.5 0 48-21.5 48-48m368 112c-26.5 0-48 21.5-48 48h48zm-48-112c0 26.5 21.5 48 48 48v-48zm-96 80a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), lP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5M288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96m-224 0c35.3 0 64 28.7 64 64H64zm64-208c0 35.3-28.7 64-64 64v-64zm384 160v64h-64c0-35.3 28.7-64 64-64M448 96h64v64c-35.3 0-64-28.7-64-64" })
  }
), tP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16M56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24M24 88h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24M272 16c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80M400 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16m80 144c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16m-128-16c8.8 0 16 7.2 16 16 0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80m-96 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16M0 304c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm48 112v48h48c0-26.5-21.5-48-48-48m48-112H48v48c26.5 0 48-21.5 48-48m368 112c-26.5 0-48 21.5-48 48h48zm-48-112c0 26.5 21.5 48 48 48v-48zm-96 80a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), wP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm64 320H64v-64c35.3 0 64 28.7 64 64M64 192v-64h64c0 35.3-28.7 64-64 64m384 192c0-35.3 28.7-64 64-64v64zm64-192c-35.3 0-64-28.7-64-64h64zm-224-32a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), gP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64m192 112a80 80 0 1 1 160 0 80 80 0 1 1-160 0M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72z" })
  }
), iP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64m64 160c35.3 0 64 28.7 64 64h-64zm64-160c0 35.3-28.7 64-64 64V96zm352 160v64h-64c0-35.3 28.7-64 64-64M512 96h64v64c-35.3 0-64-28.7-64-64M288 208a80 80 0 1 1 160 0 80 80 0 1 1-160 0M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72z" })
  }
), mP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9H64c-35.3 0-64-28.7-64-64zm256 176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-128-52.1c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.7-4.3-1.5-6.4-2.1-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 6.9 29.8 9.1v6.3c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V160c0-11.1-9-20.1-20.1-20.1zm469.8 95.8 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), aP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm208 128h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16m-92-152v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20" })
  }
), oP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h266.5l6-23.9c2.8-11.3 8.6-21.5 16.8-29.7l181.3-181.3c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64zm48 224h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16-80c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16m517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71z" })
  }
), nP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm48 160h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16M96 336c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16m280-176h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24" })
  }
), rP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96v64c0 17.7-14.3 32-32 32S0 177.7 0 160V96C0 43 43 0 96 0h448c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m64 0h384v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64zm128 352c0-35.3-28.7-64-64-64v64zm192-64c-35.3 0-64 28.7-64 64h64zm-128-32c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80" })
  }
), dP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96v64c0 17.7-14.3 32-32 32S0 177.7 0 160V96C0 43 43 0 96 0h448c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m64 0h384v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64zm192 256c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80" })
  }
), SP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm16 64h416c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16m16 160h96c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l27.6 55.2H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288H96v96h384V128H96z" })
  }
), zP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3l81.8 78c31.6 30.2 49.5 72 49.5 115.7v1.3c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 512 0 440.4 0 352V110.1C0 49.3 49.3 0 110.1 0h10.4c57.2 0 102.8 47.8 100.1 104.9-2.3 48.2-38.6 88-86.4 94.6l-1.9.3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2 1-20.6-15.5-37.9-36.2-37.9h-10.3C84.7 64 64 84.7 64 110.1V352c0 53 43 96 96 96zm256-160c-29.3 0-55.9-12.2-74.8-31.7-9-9.3-16.2-20.2-21.3-32.3-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48 0 20.8 13.2 38.4 31.6 45.1 4.7 1.7 8.4 5.9 8.4 10.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9 18.5-6.7 31.6-24.4 31.6-45.1 0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), pP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24zM32 448h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), MP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M479.5 32c-118.2 0-214.9 92-223 208.3C310 244.7 352 289.4 352 344c0 27.9-11 53.3-29 72 40.3 39.6 95.5 64 156.4 64 60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.2-.5-12.6-.8-19-.8zM64 416h184c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64H64c-35.3 0-64 28.7-64 64s28.7 64 64 64z" })
  }
), xP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391l-19.9 107.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-258 0c0-63.1 51.6-114 115-114 3.3 0 6.5.1 9.7.4 7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8 0 41 33.6 74.5 75.4 74.5 4.4 0 8.8-.4 13-1.1 6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2-63.4 0-115-50.9-115-114z" })
  }
), HP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m284.8 99.2 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6zM191.8 128C85.8 128 0 214.1 0 320.2s85.8 192.2 191.8 192.2c52 0 99.1-20.7 133.6-54.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2-80.7 0-146.2-65.6-146.2-146.6 0-54.8 30-102.6 74.4-127.8 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z" })
  }
), VP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M223.5 32C100 32 0 132.3 0 256s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" })
  }
), CP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4h8.4c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5 29.6 85.3c4-.3 8-.4 12-.4 43.7 0 83.3 17.5 112.1 45.8 9.5 9.3 9.6 24.5.3 33.9s-24.5 9.6-33.9.3c-20.3-19.8-47.9-32-78.5-32-55.1 0-101 39.8-110.3 92.3-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32v-32c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h77.3c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24M128 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32m32 336c26.5 0 48-21.5 48-48h-96c0 26.5 21.5 48 48 48m352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96m0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), LP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M504.3 11.1c-11-12.7-29.8-14.8-43.3-4.9L252.3 160h145L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2-11.1 13.9-19.4 30.3-23.9 48.1-4.4 17.1 10.3 31.7 28 31.7h192c17.7 0 32.4-14.6 28.1-31.7-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), BP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0c5 0 9.8 2.4 12.8 6.4 34.7 46.3 78.1 74.9 133.5 111.5 5.2 3.4 10.5 7 16 10.6 28.9 19.2 45.7 51.7 45.7 86.1 0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4 0-34.4 16.7-66.9 45.7-86.1 5.4-3.6 10.8-7.1 16-10.6 55.4-36.6 98.8-65.2 133.5-111.5 3-4 7.8-6.4 12.8-6.4zM288 512v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-48c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h416c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-48v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64v-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58zM70.4 5.2a15.9 15.9 0 0 1 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160h160v136.6c-19.1 11.1-32 31.7-32 55.4v128c0 9.6 2.1 18.6 5.8 26.8-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176z" })
  }
), uP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5l30.4-60.6V336c0-4.2 1.7-8.3 4.7-11.3l59.3-59.3v-23.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2.9 12.2l-12.5 37.6 45.2 38v-22.6c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8-12.6-37.7c-1.3-4-1-8.4.9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2.1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4-2.7 2.6-5.2 5.4-7.3 8.6-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5-21.7 0-40 14.3-45.9 34.1-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2 0 16.7 8.5 31.4 21.5 40-4 2.6-7.5 5.9-10.6 9.5l-43-43v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32V384c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16m16 112h48v-48h-48zm0 80h48v-48h-48zm-80-128v48h48v-48zm0 80v48h48v-48z" })
  }
), RP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49v-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3v-.3l133.4 121.8c57 59.8 154.6 17.4 154.6-67.2 0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8l-23.8-41.7 38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2l22.7 39.4-50.2 50.3v-38.2c0-14.9-10.2-27.4-24-31V63.9c0-4.4-3.6-8-8-8s-8 3.6-8 8v57.2c-13.8 3.6-24 16.1-24 31v38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1L211.4 90l-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266v.3l-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1v54.7l-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1v-55.4l24.3-31.6v63.1c0 17.7 14.3 32 32 32s32-14.3 32-32v-63.1l24.3 31.6v55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z" })
  }
), $P1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160 0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32 0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6l-55.1-102H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-20.4c-7.5 0-14.7 2.6-20.5 7.4l-47.4 39.5-14-26c-7-12.9-20.5-21-35.2-21H280zm182.7 279.2 28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8M187.3 376c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4c-11.2-59.2-63.2-104-125.7-104C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104zm-59.3 8a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), kP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48z" })
  }
), PP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3-.4.8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-24v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-40V48c0-26.5-21.5-48-48-48zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16m-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16M224 188.9l59.8 99.1H223l-48 64-24.6-41.2zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512h379c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3z" })
  }
), FP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160M55.9 512h523c33.8 0 61.1-27.4 61.1-61.1 0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1 0 487 25 512 55.9 512z" })
  }
), TP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c12.5 0 24.1 6.4 30.8 17l216.6 345.4c5.6 8.9 8.6 19.2 8.6 29.7 0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17m65 192-65-103.6-79.1 126.1 18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z" })
  }
), AP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M381.1 480H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79c4-6.6 11.2-10.7 19-10.7s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8 0 33.8-27.4 61.1-61.1 61.1H381.1z" })
  }
), DP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M396.4 112.9c2.4-7.9 3.6-16.3 3.6-24.9 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h310.6c18.5 0 33.4-15 33.4-33.4 0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2h102.8c16.1 0 29.1-13 29.1-29.1 0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1-40 0M312 48c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16h-24c-22.1 0-40-17.9-40-40s17.9-40 40-40" })
  }
), yP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192M96 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32z" })
  }
), bP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.2 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24M32 192c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112h-48zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.2 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24" })
  }
), fP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3 0 5.5.9 10.9 2.6 16H32V64c0-17.7 14.3-32 32-32zm5.7 93.7c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200zM0 192c0-17.7 14.3-32 32-32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h240c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16c0 53-43 96-96 96H96c-53 0-96-43-96-96zm384 32v96h16c26.5 0 48-21.5 48-48s-21.5-48-48-48z" })
  }
), UP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64c0-17.7 14.3-32 32-32h384c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32c0 53-43 96-96 96H192c-53 0-96-43-96-96zm384 160h32c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32zM32 416h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), GP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 82.7V32h-80c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h192c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128S582.7 32 512 32H240v50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-66.7c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6zM480 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), qP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 64v50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V64H448c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32zm272 192h32c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32z" })
  }
), WP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c-17.7 0-32 14.3-32 32v256c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h32c70.7 0 128-57.3 128-128S518.7 64 448 64h-64zm352 64h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32z" })
  }
), EP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H85.9C51.7 320 24 292.3 24 258.1m387.5-96.7c-3.7-.9-7.5-1.4-11.5-1.4-26.5 0-48 21.5-48 48s21.5 48 48 48c15.9 0 30-7.7 38.7-19.6-3.3-27.4-12.9-52.9-27.2-75zm-265.6-47.8c8 35.7 39.9 62.4 78.1 62.4 44.2 0 80-35.8 80-80 0-3.8-.3-7.5-.8-11.2-13.2-3.1-27.1-4.8-41.3-4.8h-11.8c-38.9 0-74.9 12.5-104.2 33.6M191 352h130l22 88.2c2.4 9.6.2 19.7-5.8 27.5S321.8 480 312 480H200c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5zm-31-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), OP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64v161.5L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L384 275.7V153l103.8-26c14.2-3.5 24.2-16.3 24.2-31zM272 352c-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80v-20.8L317.8 359c-14-4.5-29.5-7-45.8-7" })
  }
), IP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64v295.7c-14.5-4.9-30.8-7.7-48-7.7-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80V153l103.8-26c14.2-3.5 24.2-16.3 24.2-31z" })
  }
), NP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-71.5-56c10.5-12.9 16.7-28.4 16.7-45.1V32c0-10.1-4.8-19.6-12.9-25.7s-18.6-7.9-28.3-5l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9L38.8 5.1zm261.9 205.3L512 147v145.6c-10-2.9-20.8-4.6-32-4.6-22.2 0-42.6 6.3-58.8 16.8zM192 247.3v109.3c-10-3-20.8-4.6-32-4.6-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V297.7l-64-50.4z" })
  }
), XP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v336c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6V147l-256 76.8V432c0 44.2-43 80-96 80S0 476.2 0 432s43-80 96-80c11.2 0 22 1.6 32 4.6V128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z" })
  }
), KP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.9 148.4c21.4-23.2 51.5-36.4 83.1-36.4 33 0 64.4 14.4 85.9 39.5l3.1 3.6 3.1-3.6C344.6 126.4 376 112 409 112c31.6 0 61.7 13.2 83.1 36.4l2 2.1c27.6 29.9 74.6 30.9 103.4 2.1l1.5-1.6c2.5-2.5 5.5-4.4 8.6-5.5 2.6-1 5.4-1.5 8.4-1.5 5.7 0 10.9 2 15 5.2 1.3 1.1 2.6 2.3 3.6 3.6.4.5.7 1 1.1 1.4.3.4.5.8.7 1.1.3.5.6.9.8 1.4 1.8 3.3 2.7 7.1 2.7 11.2v39.4C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5.4c-35.1 30.8-80.2 47.7-126.9 47.7C86.2 400 0 313.8 0 207.4V168c0-4.2 1.1-8.1 2.9-11.5.6-1 1.2-2.1 2-3 1.2-1.6 2.6-3 4.1-4.2 1.5-1.2 3.1-2.2 4.8-3 3.1-1.5 6.5-2.3 10.2-2.3 2.9 0 5.8.5 8.4 1.5 3.1 1.2 6.1 3 8.6 5.5l1.6 1.6c28.8 28.8 75.8 27.9 103.4-2.1l2-2.1z" })
  }
), QP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 13.5-8.4 25.5-21.1 30.1s-26.9.7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-13.5 8.4-25.5 21.1-30.1" })
  }
), ZP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320h100.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v192h-57.5L122.6 46.3zM305.1 320H320v22.3zm-119.6-64H128v-86.3z" })
  }
), JP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6l-93.5 160.4c-16.9-5.4-34.9-8.3-53.6-8.3-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4v-81.3l29.9-20.9c21.4-15 34.1-39.4 34.1-65.5V112c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112v54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1V352c0 88.4 71.6 160 160 160h240c97.2 0 176-78.8 176-176 0-51.4-22.3-97.7-57.8-129.9l57-185.4zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), jP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c61.9 0 112 50.1 112 112v112H80V112C80 50.1 130.1 0 192 0m-8.7 64.9c-11.7 15.1-28.7 26-48.2 29.7-4 .8-7.2 4.2-6.8 8.2 1.5 14 7.6 27.7 18.4 38.5 25 25 65.5 25 90.5 0 10.8-10.8 16.9-24.4 18.4-38.5.4-4.1-2.7-7.5-6.8-8.2-19.5-3.7-36.5-14.6-48.2-29.7-4.1-5.3-13.2-5.3-17.3 0m452.2 409.2c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13-4.1-8-3.4-17.6 1.8-24.9l.2-.3c.2-.3.6-.8 1-1.5.9-1.4 2.3-3.5 4-6.3 3.4-5.6 7.9-13.8 12.5-23.8 9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1 4.6 10 9.1 18.2 12.5 23.8 1.7 2.8 3.1 5 4 6.3.5.7.8 1.2 1 1.5l.2.3zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6 1.7 17.9 9.4 35.3 23.1 49 31.2 31.2 81.9 31.2 113.1 0 13.7-13.7 21.4-31.1 23.1-49 .4-4.3-3.3-7.6-7.6-7.6-25.8 0-48.7-12.2-63.3-31.1-4.1-5.3-13.2-5.3-17.3 0zM296 360v8c0 21-6.8 42.7-15 60.8-4 8.7-7.9 15.8-10.8 20.6-1.4 2.4-2.6 4.1-3.2 5.2-.3.5-.6.9-.7 1v.1c-11.7 16.6-13.5 38.1-4.9 56.3H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4 2.7-5.3 8.1-8.6 14-8.6h280.2c-22.6 28.6-36.1 64.7-36.1 104" })
  }
), YP1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64h128v64H256zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v-32h256v32h-48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352v-32h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM96 448v-64h128v64zm320-64h128v64H416z" })
  }
), _P1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 176a112 112 0 1 1 224 0 112 112 0 1 1-224 0m144 173.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), hF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96c0-35.3 28.7-64 64-64h288c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32v272c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 24v80c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24m208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16m0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16m-208 96c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16m0 96c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16" })
  }
), cF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v65.1c-24.9 3.6-47.2 15.3-64 32.5V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v152.6c-19.1 11.1-32 31.7-32 55.4v32H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h208v64H64c-35.3 0-64-28.7-64-64zm464 144c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), sF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v64c-22.8 0-44.4 4.8-64 13.3V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48c-38.9 29.2-64 75.7-64 128 0 22.8 4.8 44.4 13.3 64H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h208c21.6 28.8 52.7 50 88.6 59.1-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64zm448 304.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z" })
  }
), vF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v139.6l-64 64V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v187.6L299.6 384H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h163.1c-1 2.6-1.9 5.3-2.6 8.1l-14 55.9H64c-35.3 0-64-28.7-64-64zm549.8 139.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), eF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v131c-22.4 3.4-43.8 9.6-64 18.3V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v117.7c-47.2 28.4-84.8 71.2-106.7 122.3H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h121.9c-5.8 20.4-9.2 41.9-9.8 64H64c-35.3 0-64-28.7-64-64zm488 160c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232m-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64m32-72c0 13.3-10.7 24-24 24-48.6 0-88 39.4-88 88 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136 13.3 0 24 10.7 24 24" })
  }
), lF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zm134.7 105.6c8.7-9 21-14.7 34.5-14.7h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-3.3 0-6.4 1-8.9 2.7l-25.6-20.1zm128.6 100.8c.6-.3 1.3-.5 1.9-.7V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48v206.9l-32-25.1V144c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3 0 2.3-.2 4.6-.5 6.8L302 211.5zm184.8 268.1L406.2 416H208c-26.5 0-48-21.5-48-48V222.1l-64-50.5V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4M208 384h157.5L192 247.3V368c0 8.8 7.2 16 16 16" })
  }
), tF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.9 471.8c10.3 9.3 25.4 10.8 37.4 3.9C461.6 432.1 512 348.8 512 256S461.7 79.9 386.3 36.3c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2c-13.2-11.8-33.4-10.7-45.2 2.4s-10.7 33.4 2.4 45.2l178.3 160zM163.1 40.2c-10.3-9.3-25.4-10.8-37.4-3.9C50.3 79.9 0 163.2 0 256s50.3 176.1 125.7 219.7c15.3 8.8 34.9 3.6 43.7-11.7s3.6-34.9-11.7-43.7C101.9 388 64 325.7 64 256c0-61.4 29.5-117.2 74.8-151.7l159.8 143.5c13.2 11.8 33.4 10.7 45.2-2.4s10.7-33.4-2.4-45.2l-178.3-160" })
  }
), wF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400c-5.6 0-11 1-16 2.7V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c16.4 0 30.9-8.2 39.6-20.8l6.1 84.8H64c-35.3 0-64-28.7-64-64zm449.7 104.8c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8l11.6 23.2H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zm-35.8 281.5L400 288h224l-13.9 194.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z" })
  }
), gF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48" })
  }
), iF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M324.2 231.9 421 338.3c17.4 19.1 27 44 27 69.9 0 57.3-46.5 103.8-103.9 103.8h-9.4c-32.3 0-63.6-11.3-88.4-32l-6.4-5.3c-20.7-17.2-46.7-26.7-73.6-26.7-21.2 0-38.3 17.2-38.3 38.3v5.7c0 1.7.1 3.4.3 5.1.8 7.1-4 14.9-11.2 14.9H112C50.8 512 1.1 462.9 0 401.9 1 345.3 44.3 298 100.9 292.4l44.7-4.5c8.8-.9 15.2-8.7 14.3-17.5s-8.7-15.2-17.5-14.3l-44.7 4.5c-7.1.7-14 1.9-20.7 3.6-6.4 1.6-13-3-13-9.7V32C64 14.3 78.3 0 96 0h61.6c11.4 0 21.9 6 27.6 15.9l75.6 129.6c18.1 30.9 39.3 59.9 63.4 86.4z" })
  }
), mF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4l41.6-62.2H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h105.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h212.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z" })
  }
), aF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 390.3 153.5 256 64 121.7zm38.5 57.7h179L192 313.7zm128-192L320 390.3V121.7zm51-192h-179L192 198.3zM0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z" })
  }
), oF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v224H336c-26.5 0-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64zm402.7 256H448l-32 32-64 64-32 32V368c0-8.8 7.2-16 16-16zM192 144v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), nF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h224V368c0-26.5 21.5-48 48-48h112V96c0-35.3-28.7-64-64-64zm384 320H336c-8.8 0-16 7.2-16 16v112l32-32 64-64z" })
  }
), rF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v224H336c-26.5 0-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64zm402.7 256H448l-32 32-64 64-32 32V368c0-8.8 7.2-16 16-16zM112 376a24 24 0 1 0-48 0 24 24 0 1 0 48 0M88 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48m24 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), dF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56c0 26.5 21.5 48 48 48h80V0h-80C85.5 0 64 21.5 64 48M432 0H224v512h208c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48" })
  }
), SF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 352V96c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64m176-224c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24v224c0 48.6 39.4 88 88 88z" })
  }
), zF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h179.2c4.3 0 8.6-.4 12.8-1.3V320c0-17.7 14.3-32 32-32h94.7c.9-4.2 1.3-8.5 1.3-12.8V96c0-35.3-28.7-64-64-64zm224 320v64l96-96h-96zm-88 112H136c-48.6 0-88-39.4-88-88V152c0-13.3-10.7-24-24-24S0 138.7 0 152v224c0 75.1 60.9 136 136 136h160c13.3 0 24-10.7 24-24s-10.7-24-24-24" })
  }
), pF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320m224 160a224 224 0 1 1-448 0 224 224 0 1 1 448 0" })
  }
), MF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96H64c-35.3 0-64-28.7-64-64zm320 128H192v128h128z" })
  }
), xF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32h337.2c11-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v273.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4v273.2c9.7 5.6 17.8 13.7 23.4 23.4h337.2c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm128 160h32c35.3 0 64-28.7 64-64v-32h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32z" })
  }
), HF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64v96h-64c-35.3 0-64 28.7-64 64v64H64V64zM64 352h96v96c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64m384-128v224H224v-96h64c35.3 0 64-28.7 64-64v-64z" })
  }
), VF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64zM288 288V64H64v224z" })
  }
), CF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32h209.2c11-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v113.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4v113.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zm192 384c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v113.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32z" })
  }
), LF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-96V64c0-35.3-28.7-64-64-64z" })
  }
), BF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 512h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24m40-176c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48h-64C85.5 0 64 21.5 64 48zm224 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48z" })
  }
), uF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-13.3 0-24 10.7-24 24v40H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h152v64h-88c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h88v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h88c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-88v-64h152c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H280V24c0-13.3-10.7-24-24-24" })
  }
), RF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v152h64v-88c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v88c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-88h-64v152c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40z" })
  }
), $F1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24C48 10.7 37.3 0 24 0S0 10.7 0 24m176 40c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm0 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48z" })
  }
), kF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24M336 64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm0 224c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48z" })
  }
), PF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0m40 176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48zm224 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48z" })
  }
), FF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32C21.5 32 0 53.5 0 80v160c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm256 192c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM0 400v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48M304 32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" })
  }
), TF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), AF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24zm120 120a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), DF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), yF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), bF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), fF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), UF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M191.5.1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6A71.983 71.983 0 0 0 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9l119.4 119.4c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1l119.4-119.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2A71.983 71.983 0 0 0 320.5.1h-129z" })
  }
), GF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 96c0 17.7-14.3 32-32 32h-32v32h80.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48v-21.3l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48h176v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32 14.3 32 32M48 208v64.8l48 21.3V208zm544 240c-26.5 0-48-21.5-48-48 0-21 20.6-62.6 34.9-88.8 5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48" })
  }
), qF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48h259.1c18.4 0 35.8-7.9 48-21.7l182.4-206.6c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288v-32zM96 208v86.1l-48-21.3V208z" })
  }
), WF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V128zm144 272v-1.2c21.9-3.2 43.7-12.6 61.5-24.9 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1 12.6-18.1 20-40.2 20-63.9m-208 64c-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 17.8 12.3 39.6 21.7 61.4 24.9v1.2c0 23.8 7.4 45.8 20 63.9-1.3 0-2.7.1-4 .1zm192 80c26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0 22.5 15.5 50 26.1 77.5 26.1" })
  }
), EF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6l-15.4 4.1C397.8 13.4 387.7 31 392.3 48l24.5 91.4-108.3 28.1-6.3-18.1c-4.5-12.8-16.6-21.4-30.2-21.4s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v264H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1 27.5 78.4h-66.6l26.3-75-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32h111.4l11.2 32z" })
  }
), OF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1l-134.5 63.3C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16v-16c0-61.4 34.5-114.6 85.2-141.5-44.8-11.7-73.9-38.7-82.5-47.6C.9 65 0 62.6 0 60s.9-5 2.7-6.9M480 320c0 106-64.5 192-144 192s-144-86-144-192 64.5-192 144-192 144 86 144 192m-14.3 151.8c29.2-40.5 46.3-94 46.3-151.8 0-59.3-18-114.2-48.6-155-10.5-14-22.7-26.5-36.2-36.9 48.2 1.6 101.3 25.8 144.2 70.3 75 77.8 90.2 188.1 33.9 246.4-34.1 35.4-86.8 43.5-139.6 27z" })
  }
), IF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 480C71.6 480 0 408.4 0 320 0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280m127.1-287.1c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8-69.6-40.1-87.8-21.9-8.4 57.5 21.9 87.8" })
  }
), NF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6 26.5 0 48 21.5 48 48s-21.5 48-48 48h-34.2c-7.6 0-13.8 6.2-13.8 13.8 0 1.5.2 2.9.7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H160c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8-9.9-10.8-16.6-21.6-20.9-29.7-2.1-4-3.6-7.3-4.5-9.6-.5-1.1-.8-2-1-2.5l-.2-.5v-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8.1 370l15.9-2-15.9 2v.1l.1.4c0 .3.1.8.2 1.3.2 1.1.4 2.7.8 4.6.8 3.9 2 9.4 3.9 15.9 3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128 0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4h5.5c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32-25.7 0-41.4-12.5-51.2-25.6-5-6.7-8.4-13.4-10.5-18.6-1.1-2.5-1.8-4.6-2.2-6-.2-.7-.4-1.2-.5-1.5l-.1-.3c-1.9-7.3-8.6-12.4-16.2-12.1-7.6.3-13.9 5.9-15.1 13.4L336 368l-15.8-2.6v.1l-.1.3c0 .3-.1.6-.2 1.1-.1.9-.3 2.1-.4 3.6-.3 3-.6 7.3-.6 12.4 0 10.1 1.1 23.9 5.8 38.1 4.8 14.3 13.4 29.3 28.6 40.7 15.4 11.6 36 18.3 62.7 18.3 53 0 96-43 96-96v-96c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4h-48.3c6.9-14.5 10.8-30.8 10.8-48 0-61.9-50.1-112-112-112-25.2 0-48.5 8.3-67.2 22.4-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4M280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80l-14.3 7.2v.1l.1.2.4.7c.3.6.8 1.4 1.4 2.4 1.2 2 2.9 4.8 5.1 8.2 4.4 6.7 11.1 15.5 20 24.4 17.7 17.9 45.6 36.8 83.3 36.8 31.2 0 56.6-10.4 73.9-20.2 8.7-5 15.6-9.9 20.4-13.8 2.4-1.9 4.3-3.6 5.7-4.9.7-.6 1.3-1.2 1.7-1.6l.6-.5.2-.2.1-.1L448 96.1l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3-12.4-12.4-32.6-12.5-45.1-.2-.1.1-.2.2-.5.4-.5.5-1.5 1.3-2.8 2.4-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6-8.4-3.7-15.4-7.5-20.3-10.3-2.4-1.4-4.3-2.5-5.6-3.3-.6-.4-1.1-.7-1.4-.9z" })
  }
), XF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96c-88.4 0-160 71.6-160 160 0 56.4 29.1 106 73.3 134.5 13.3 8.6 22.7 23.7 22.7 41.2 0 26.7-21.6 48.3-48.3 48.3H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h35.2C25.8 375.4 0 318.7 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-79.7c-26.7 0-48.3-21.6-48.3-48.3 0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160" })
  }
), KF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m216.8 17.7-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126 49 163.7 0 203.5 0 288c0 80.4 58 135.2 131.9 160.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l11.8-35.6c7.1 1.2 14.2 2.1 21.4 2.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-25.3c7.2-.7 14.3-1.6 21.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8 271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0zM97 186.2l.4-.9c.4-.8.8-1.5 1.2-2.2 2.5-3.8 6.6-6.4 11.3-6.9 1.9-.2 3.8-.1 5.6.3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2.3 1.9.2 3.9-.3 5.9-.3 1.3-.8 2.5-1.3 3.6l-.3.7c-.3.6-.8 1.6-1.4 2.9-1.2 2.6-2.9 6.4-4.9 11.2-4 9.6-9 23-13.3 38.2-8.8 31.3-13.5 67.1-3.4 94 3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4c-13.9-37-6.6-81.3 2.6-114 4.7-16.7 10.2-31.4 14.5-41.8 2.2-5.2 4-9.4 5.4-12.3.7-1.5 1.2-2.6 1.6-3.4zm112-63.7c.3-.9.8-1.8 1.3-2.7 1.2-2.1 2.9-3.8 4.8-5 3.4-2.3 7.7-3.3 11.9-2.5 1.9.4 3.7 1 5.2 2 2 1.2 3.7 2.9 5 4.8s2.2 4.1 2.6 6.4c.3 1.8.3 3.7-.1 5.5-.2 1.1-.5 2.2-1 3.3v.1l-.5 1.3c-.4 1.1-1.1 2.8-1.9 5-1.6 4.4-4 10.9-6.6 18.9-5.4 16.2-12.2 38.7-18.1 64-11.9 51.7-18.9 111.9-4.4 155.3 2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-17.5-52.5-8.5-120.3 3.6-172.7 6.1-26.6 13.3-50.1 18.9-67 2.8-8.4 5.2-15.2 7-19.9.9-2.4 1.6-4.2 2.1-5.4l.6-1.5.1-.1zm79 37.5c0-8.8 7.2-16 16-16H304.6c5.8-.2 11.6 2.7 14.6 8.2l-1 .6 1-.5v.1l.2.3.6 1.1c.5.9 1.2 2.2 2.1 3.9 1.8 3.4 4.2 8.3 7.1 14.3 5.7 12.1 13.1 29.2 19.8 48.9 13.1 38.7 24.5 90.6 11.7 135.5-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5-6.2-18.3-13.1-34.2-18.4-45.6-2.7-5.7-4.9-10.2-6.5-13.2l-.1-.1c-3.5-2.9-5.7-7.3-5.7-12.2z" })
  }
), QF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 448c-9.7 0-18.9-4.4-25-12L176.6 128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c9.7 0 18.9 4.4 25 12l246.4 308H608c17.7 0 32 14.3 32 32s-14.3 32-32 32zm0-320c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32z" })
  }
), ZF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m55.4 64c5.4-9.4 8.6-20.3 8.6-32 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7c-29.1 16.8-53.5 41.2-70.3 70.3h332.6c-16.9-29.1-41.2-53.5-70.3-70.3V128c0-17.7-14.3-32-32-32zM0 320c0 22.4 3.8 44 10.9 64h362.2c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64H10.9C3.8 276 0 297.6 0 320m25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96H25.7z" })
  }
), JF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m181.5 197.1 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5 23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6 6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2-11.9-7.9c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h160v-64c0-23.7 12.9-44.4 32-55.4 9.4-5.4 20.3-8.6 32-8.6v-16c0-26.5 21.5-48 48-48 8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4c89 17.8 153 95.9 153 186.6v1.1c0 123.7-100.3 224-224 224H255.4C132 480 32 380 32 256.6V216.8c-10.1-14.6-16-32.3-16-51.4V142.6C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8c18-37.8 56.5-64 101.2-64h64c44.7 0 83.2 26.2 101.2 64h2.8c13.3 0 24 10.7 24 24 0 10.5-6.7 19.3-16 22.6V165.4c0 1.4 0 2.8-.1 4.3 12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64h-32c-42.3 0-78.2-27.4-91-65.3-5.1.9-10.3 1.3-15.6 1.3-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32m112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), jF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64m192 128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32m32 96h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32M0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m.2-179.4c-8.2-6.4-8.2-18.9 0-25.3L102.1 164c10.5-8.2 25.8-.7 25.8 12.6v158.7c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z" })
  }
), YF1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm0 224c0-61.1 30.8-99.1 49.7-116.6 8.8-8.2 20.7-11.4 32.6-11.4h155.3c12 0 23.9 3.3 32.6 11.4 19 17.5 49.8 55.5 49.8 116.6s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256m96-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-8.8-7.2-16-16-16m128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-8.8-7.2-16-16-16m-64 96c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-16c0-13.3-10.7-24-24-24" })
  }
), _F1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96v64h448V96c0-53-43-96-96-96H96C43 0 0 43 0 96m56-16a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48m16 200v192H64V256zM64 192H0v256c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192h-64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), hT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352m112 176a112 112 0 1 1-224 0 112 112 0 1 1 224 0" })
  }
), cT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32S0 465.7 0 448V320zm64 192h96c53 0 96-43 96-96s-43-96-96-96H64z" })
  }
), sT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2h139.6c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z" })
  }
), vT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z" })
  }
), eT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 512h256c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64" })
  }
), lT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 32v64c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32m16 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), tT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm160 288c0-17.7 14.3-32 32-32v-16c0-44.2 35.8-80 80-80h144c17.7 0 32-14.3 32-32V69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32z" })
  }
), wT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1.1c2.5 9.3 3.8 19 3.8 29 0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4-.4-3.8-.6-7.7-.6-11.6 0-61.9 50.1-112 112-112 10 0 19.8 1.3 29 3.8z" })
  }
), gT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L227.7 269.1l79.2 79.2zM205 291.8c-9.3-2.5-19-3.8-29-3.8-61.9 0-112 50.1-112 112 0 3.9.2 7.8.6 11.6 1.8 17.5-10.2 36.4-27.8 36.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1.1zm93.4-138.7L164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256h2.5c6.2 0 12.4.4 18.4 1.2l104.1-104.1zM320 402.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c8.4 2.4 17.4.1 23.6-6.1s8.5-15.2 6.1-23.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2L423 277.5 318.8 381.6c.8 6 1.2 12.2 1.2 18.4z" })
  }
), iT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2s-42.9-17.3-61.5-3.3L262.4 187.2c-24 18-38.2 46.1-38.4 76.1zm-19.6 25.4-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9.2 7.8.6 11.6 1.8 17.5-10.2 36.4-27.8 36.4H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-2.5-.1-5-.2-7.5z" })
  }
), mT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256v2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48 0 3.4.4 6.7 1 9.9 2.1 10.2 6.5 20 10.8 29.9 6.1 13.8 12.1 27.5 12.1 42 0 31.8-21.6 60.7-53.4 62-3.5.1-7 .2-10.6.2C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256m-384 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), aT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0h80v112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48M0 352c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H32c-17.7 0-32-14.3-32-32m128 96h160v-64H128zm224 0h160v-64H352z" })
  }
), oT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 78.3 0 96 0h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm320 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32zM0 352c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H32c-17.7 0-32-14.3-32-32m128 96h160v-64H128zm224 0h160v-64H352z" })
  }
), nT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zm96 64h160v64H128zm224 0h160v64H352z" })
  }
), rT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-448c37.2 0 69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2C250.7 90.3 282.8 64 320 64m-89.9 121.9c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0M296 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0m120 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-188.7-75.3c2.1 2.1 3.5 4.6 4.2 7.3.4 1.7.8 3.4 1.1 5.1 1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56v-26.6c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9-1.7-.3-3.5-.7-5.1-1.1-2.7-.7-5.2-2.1-7.3-4.2-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm228.5-100.5c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1-10.9 8.7-24.5 13.5-38.5 13.5h-4.1c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4l79.6-79.6zM24 160c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m616 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), dT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9c15.4 11.7 24.7 29.6 24.7 50.5 0 35.3-28.7 64-64 64-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3C326.3 429.4 277.3 448 224 448 100.3 448 0 347.7 0 224S100.3 0 224 0s224 100.3 224 224m-128.1-70c-21.2-5.4-50.6-22.6-65.8-38.4-24.5-25.5-65-26.3-90.5-1.8-11.6 11.2-18.1 25.6-19.4 40.5-2.2 24.7-9.2 56.2-21.5 77.6-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6 10.2-1.4 20.3-5.4 29.2-12 28.4-21.1 34.3-61.1 13.3-89.5a63.69 63.69 0 0 0-35.5-23.9zM528 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0M224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), ST1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 192c0-17.7 14.3-31.9 32-32.6C396.6 155 480 128.3 480 96c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37 13.2 5.3 22.7 17.6 22.7 31.8V272c0 17.7 14.3 32 32 32s32-14.3 32-32V171.7c0-9.5 8.1-16.8 17.5-15.7 8.1.9 14.5 7.6 14.5 15.7V224c0 17.7 14.3 32 32 32s32-14.3 32-32zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16M14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9v-48.1c0-.1-.1-.2-.2-.4-.4-.5-1.2-1.3-2.4-1.8-14.7-5.9-28.7-13.4-39.6-22.9-2.3-2-4.6-4.3-6.8-6.8zm271.2 106.5C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27-4 4.5-8.5 8.4-12.7 11.5-13.4 10-30.9 17.8-49.8 24-38 12.5-89.1 20.5-145.3 22.8-.5 0-.9.2-1.2.5-.1.1-.1.2-.1.2v32c0 5.3-.7 10.5-1.9 15.5M7.2 221.1C2.5 227.2 0 233.5 0 240c0 21 25.8 40 68 54.3-2.6-6.9-4-14.5-4-22.3v-25.3c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80 0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26-47.8 14.9-111.2 24-180.2 24.8-11.3 10-26.1 16.1-42.4 16.1-11.8 0-22.9-3.2-32.4-8.8-1.6 14.1-7.8 26.9-17 36.7 25.6 2.7 52.9 4.1 81.4 4.1zm256 0c0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80m0 80c0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80" })
  }
), zT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v224h16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-26.5-21.5-48-48-48H0v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm48 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m-192 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16m16 128h64c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32" })
  }
), pT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7-9.9 8.9-19.4 18.1-28.5 27.5V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h241.5c-4.4 6.2-8.5 12.5-12.3 18.7-10.9 17.6-20.5 36.4-27.2 55.4-3-1.4-6.4-2.1-9.9-2.1-13.3 0-24 10.7-24 24s10.7 24 24 24h.2c-.1 2-.2 4.1-.2 6.1 0 49.3 18.6 95.2 49.6 129.9H64c-35.3 0-64-28.7-64-64zm120 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m261.5-180.4c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79 0 87.8-71.3 159.8-160 159.8-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15" })
  }
), MT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M45.6 32C20.4 32 0 52.4 0 77.6v356.8C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4 25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4c-4.8-1.6-9.7-2.4-14.8-2.4M96 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4.4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2l69.4-86.7c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z" })
  }
), xT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5l69.3 128.7c4.4 8.3 12.6 13.8 21.9 15l176 22c3.4.4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7l441.9-191.5c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z" })
  }
), HT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480v-83.6c0-4 1.5-7.8 4.2-10.7l167.6-182.9c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8l-88.3-44.2C7.1 311.3.3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z" })
  }
), VT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128v192c0 44.2-35.8 80-80 80s-80-35.8-80-80V160c0-17.7 14.3-32 32-32s32 14.3 32 32v160c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v208c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 97.2-78.8 176-176 176S32 433.2 32 336z" })
  }
), CT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z" })
  }
), LT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M383.5 192c.3-5.3.5-10.6.5-16 0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4.2 10.7.5 16H240v128h-32c-7 0-13.7 1.5-19.7 4.2L68.2 192h28.3c-.3-5.3-.5-10.6-.5-16 0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6 1.5 183.1 9 192 18.9 192h6l140.3 154.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4-14.4-51-57.8-124.3-148.9-156.9C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2h-32V192z" })
  }
), BT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c17.7 0 32-14.3 32-32S337.7 0 320 0H144C82.1 0 32 50.1 32 112s50.1 112 112 112h16v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64h32v224c0 17.7 14.3 32 32 32s32-14.3 32-32zM128 384v-46.4c0-9.7-7.9-17.6-17.6-17.6-4.2 0-8.2 1.5-11.3 4.2l-93 78.7c-3.9 3.2-6.1 8-6.1 13.1s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2 9.7 0 17.6-7.9 17.6-17.6V448h224c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), uT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V96h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-32c-88.4 0-160-71.6-160-160S103.6 32 192 32" })
  }
), RT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224C0 100.3 100.3 0 224 0c35.3 0 68.9 8.2 98.7 22.8 19.2 9.5 29.3 28.9 29.3 47.9 0 14.5-5.7 28.3-16 38.5L109.2 336c-10.2 10.3-24.1 16-38.5 16-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224M480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64M96 480a32 32 0 1 1-64 0 32 32 0 1 1 64 0m263-313c9.4-9.4 24.6-9.4 33.9 0l8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3c13.2 1.5 22.7 13.3 21.2 26.5s-13.3 22.7-26.5 21.2l-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201c-9.4-9.4-9.4-24.6 0-33.9zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4c1.5 13.2-8 25-21.2 26.5s-25-8-26.5-21.2l-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm302.5 147.3c-10.1 8.6-25.3 7.3-33.8-2.8l-8.5-10a79.026 79.026 0 0 1-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8.2-7.6-2.4-15-7.3-20.7l-8.5-10c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l8.5 10c12.5 14.8 19.1 33.7 18.6 53-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8-.2 7.6 2.4 15 7.3 20.7l8.5 10c8.6 10.1 7.3 25.3-2.8 33.8" })
  }
), $T1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m416 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64M167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7.1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zm192 158 8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5a79.026 79.026 0 0 1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6 16.6.4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2 7.6.2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM150.6 201.4l160 160c7.7 7.7 11 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20s21.7 1 29.4 8.6zM48.2 345.6l22.6-60.2 155.8 155.8-60.2 22.6zm-12.3 32.9 97.6 97.6L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3z" })
  }
), kT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm183 214.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8m41.3 9.2h-.6c-2.4-3.5-5.7-8.9-9.1-16.5-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8 27.9 13.2 48.4 39.4 53.7 70.8zm-55.9-80h.6c2.4 3.5 5.7 8.9 9.1 16.5 6 13.6 12.4 34.3 14.2 63.5h-47.1c1.8-29.2 8.1-49.9 14.2-63.5 3.4-7.6 6.7-13 9.1-16.5zm-40.7 9.2c-6.8 17.1-12.9 40.4-14.6 70.8h-39.1c5.3-31.4 25.8-57.6 53.7-70.8M352 192a128 128 0 1 0-256 0 128 128 0 1 0 256 0M112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), PT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80v320c0 26.5 21.5 48 48 48h144V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48h-56.6c-11-19.1-31.7-32-55.4-32m112 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V256h-96c-17.7 0-32-14.3-32-32v-96h-64zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48m256 88v96h96z" })
  }
), FT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 64C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm192 0c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48z" })
  }
), TT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M178.1 15.3c4.9-5.4 13.9-1.9 13.9 5.4v50.5c18.3 9.8 34.3 28.9 42.5 53.6 14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.2 0-25.7 9.6-50.6 26.9-69.6l39.2-43.1zm132 206.3c-32.3-10.6-46.9-53.9-32.6-96.8 8.2-24.7 24.2-43.8 42.5-53.6V20.7c0-7.3 9-10.8 13.9-5.4l39.2 43.1c17.3 19 26.9 43.9 26.9 69.6.2 11.3-1.5 23.2-5.5 35.1-14.3 42.9-52.1 69.1-84.4 58.5zm-209.7 8.9c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240v-3.2c0-13.5 4.3-26.7 12.2-37.6l37.3-51.3c4.6-6.3 14.5-3 14.5 4.7v44.2c13.9 6.1 27.1 17.8 36.4 33.7zM69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7v-1.6c0-10.4 1.6-20.7 5.2-30.5m352.6-118.5c-24.5-14-29.1-51.7-10.2-84.1 9.3-15.9 22.4-27.6 36.4-33.7v-44.3c0-7.7 9.9-11 14.5-4.7l37.3 51.3c8 10.9 12.2 24.1 12.2 37.6v3.2c.1 13.3-3.7 27.8-11.6 41.4-18.9 32.4-54 47.3-78.5 33.3z" })
  }
), AT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0m1.7 206c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2 38.3 14 65.7 50.8 65.7 94 0 55.2-44.8 100-100 100-21.2 0-40.8-6.6-56.9-17.8-17.4-12-52.8-12-70.1 0-16.2 11.2-35.8 17.8-57 17.8-55.2 0-100-44.8-100-100 0-43.2 27.4-80 65.7-94M304 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96m48 160a48 48 0 1 1 96 0 48 48 0 1 1-96 0M48 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), DT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5.3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.4-70.1 10.1-84.1 59.7.9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7v-1.6c0-10.4 1.6-20.8 5.2-30.5m352.6-118.5c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3 29.1 51.7 10.2 84.1-54 47.3-78.5 33.3m-111.7-93c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5" })
  }
), yT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7M89.2 351.1 224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5v121.8c35.7-6 68.1-21.9 94.3-44.7m40.6-49.5c16-28 25.2-60.5 25.2-95.1 0-95.1-69.2-174.1-160-189.3v174.1l134.7 110.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" })
  }
), bT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24h24c53 0 96 43 96 96 0-53 43-96 96-96h24c13.3 0 24 10.7 24 24 0 22.6-8.5 43.2-22.5 58.8C366.6 81 355.4 80 344 80m-176 32c17.8 0 34.9 2.8 50.9 7.9 63 20 109.9 76.2 116.3 144.2.8 8.8 7.9 16 16.8 16s16.1-7.2 15.4-16c-4.6-58.2-34.2-109.5-78-143 .8-.2 1.5-.5 2.3-.7 16.5-5.4 34-8.3 52.3-8.3 92.8 0 168 75.2 168 168 0 136.2-199.3 214.6-240.6 229.4-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280c0-92.8 75.2-168 168-168" })
  }
), fT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 0h-68c-20.1 0-39.2 4-56.7 11.2-17.4 7.2-33.7 17.8-47.8 32l-.4.4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8-17.5 7.2-33.9 17.9-48.1 32.1-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5l1.7-1.7c13.8-14 24.2-30.1 31.3-47.2 4-9.5 6.9-19.6 8.8-30 4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8 17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148V80c0-44.2-35.8-80-80-80m-35.2 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0m83.2-19.2a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4m0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4" })
  }
), UT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m299.2 38.9 22.6 50.7c-3.6 10.8-6.5 22.2-8.8 31.5-1.2 4.6-2.2 8.8-3.1 12.1-4.2 14.8-8.7 24.6-16.3 32.2s-17.4 12.1-32.2 16.3c-3.4 1-7.5 2-12.1 3.1-12.5 3.1-28.5 7.1-42 12.7-21.3 8.8-41.2 21.9-58.4 39.1C114.3 271.1 96 315.4 96 364v68c0 27.8 10.2 53.3 27 72.9l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2l-22.7-50.9C3.8 407.2.4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6 6-15.4 14.7-28.9 25.4-40.1 5.8-6.1 12.3-11.7 19.5-16.6 16.7-11.8 32.5-25.8 39.8-44.9s5-40.1.4-60c-2.1-8.4-3.2-17-3.4-25.4-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9s23.6-20.6 38.7-27.3l50.9-22.6c33.1-14.7 71.8.1 86.6 33.2zM492 0h68c44.2 0 80 35.8 80 80v68c0 40.6-16.4 77.4-42.9 104.2l-.9.9c-14.1 14-30.3 24.6-47.6 31.7-9.5 4-19.6 6.9-30 8.8-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30-7.1 17.1-17.5 33.2-31.3 47.2l-1.7 1.7C353.1 495.8 316.5 512 276 512h-68c-44.2 0-80-35.8-80-80v-68c0-20.1 4-39.2 11.2-56.7 7.2-17.5 17.9-33.8 32.1-48 14.2-14.2 30.6-24.9 48.1-32.1 9.5-4 19.6-6.9 30-8.8 24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30 7.2-17.4 17.8-33.6 31.9-47.8l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0m52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4m83.2-19.2a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0m0-64a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0" })
  }
), GT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 0h-48C186.2 0 0 186.2 0 416v48c0 26.5 21.5 48 48 48h48c229.8 0 416-186.2 416-416V48c0-26.5-21.5-48-48-48M256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112M88 368a56 56 0 1 1 112 0 56 56 0 1 1-112 0M368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), qT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 7c9.4 9.4 9.4 24.6 0 33.9l-47.1 47.2c14 20.5 22.1 45.3 22.1 71.9 0 30.7-10.8 58.9-28.9 81-29.9 36.5-61.4 81.8-73.3 127.4-8.3 32-25 62.3-50.1 87.3-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1 45.7-11.8 90.9-43.4 127.4-73.3 22.1-18 50.3-28.9 81-28.9 26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM320 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128" })
  }
), WT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C60.7 0 32 28.7 32 64v352h384V64c0-35.3-28.7-64-64-64zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48m184 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), ET1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-69.6 0-126.3 55.6-128 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8S160 42.1 160 48c0 48.1 3.8 99.9 26 139.8 9.2 16.6 21.7 31.3 38.2 42.7-7.2-2.5-14-5.4-20.3-8.8-22.5-12.1-38.6-29.4-49.9-49.8-7.3-13.2-12.7-27.8-16.5-43-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), OT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m101.8-372.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0M151.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), IT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l55-55 17-17-1-1-16-16-96-96-17-17-13-13c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6L38.8 5.1zm191.7 150.3 40.5-40.5c9.4-9.4 24.6-9.4 33.9 0l13.2 13.1-53.8 53.8-33.7-26.4zm-67 127.1c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-145.4-114.5-32.3 32.3zM517.3 19.3c-25-25-65.5-25-90.5 0l-52.2 52.1 17 17 96 96 16 16 1 1 52.1-52.1c25-25 25-65.5 0-90.5l-39.4-39.5z" })
  }
), NT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m453.3 19.3 39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1-1-1-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17-171.5 171.4c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128z" })
  }
), XT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L387.9 278.7l161-140.2c17.2-15 27.1-36.7 27.1-59.6 0-43.6-35.4-79-79-79-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7 38.8 5.1zM318 346.5l-107-84.2-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-95.3 95.5L266 460.5c16.9-4.7 29.9-18.3 33.8-35.4z" })
  }
), KT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79 0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64-10.4-10.4L373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6.7 5.4 1.1 8.3 1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 2.9.4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z" })
  }
), QT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M601.9 16C583.1-2.8 552.7-2.7 534 16l-39.6 39.7 89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4.4-68.2zM328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15l145.1-142.1-89.1-89.1zM80 128c-44.2 0-80 35.8-80 80v224c0 44.2 35.8 80 80 80h416c44.2 0 80-35.8 80-80V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h192c17.7 0 32-14.3 32-32s-14.3-32-32-32zm80 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), ZT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m453.3 19.3 39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4-130-129.9 48.4-48.4c25-25 65.5-25 90.5 0zM58.6 323.5 291.7 90.3l130 130-233.2 233.1c-10.4 10.4-23.3 18-37.4 22.2L30.8 511c-8.4 2.5-17.5.2-23.7-6.1s-8.6-15.2-6.1-23.7l35.4-120.3c4.2-14.1 11.8-27 22.2-37.4zM248 464h304c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), JT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.3 327.6l28.3-94.4 2.8-9.2L352 94.6l-9.2 2.8-134.7 40.4L38.8 5.1zm29 440.7c-3.8 11.3-1 23.9 7.3 32.4l153.6-153.5c-3-6.3-4.7-13.3-4.7-20.7 0-9.4 2.7-18.2 7.4-25.7l-85-67zM272 352c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6M432.4 18.3l-55.7 55.8 125.2 125.2 55.7-55.7c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0z" })
  }
), jT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m368.4 18.3-55.7 55.8 125.2 125.2 55.7-55.7c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8-144.1 43.2c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4l153.6-153.5c-3-6.3-4.7-13.3-4.7-20.7 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2z" })
  }
), YT1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m95.6 16.4 130.7 130.7-79.2 79.2L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0zM400 512c-53.6 0-98.5-37.7-109.4-88.1l133.3-133.3c50.3 11 88.1 55.8 88.1 109.4 0 3.9-.2 7.8-.6 11.6-1.8 17.5 10.2 36.4 27.8 36.4h4.8c17.7 0 32 14.3 32 32s-14.3 32-32 32zM501.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4-114-113.9 56.4-56.4c25-25 65.5-25 90.5 0zM76.9 353.2 331.7 98.3l114 114-254.9 254.8c-6.7 6.7-15.1 11.6-24.2 14.2L62.6 511c-8.4 2.4-17.4.1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2z" })
  }
), _T1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m469.3 19.3 23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4-114-113.9 56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2 299.7 98.3l114 114-254.9 254.8c-6.7 6.7-15.1 11.6-24.2 14.2L30.6 511c-8.4 2.4-17.4.1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zm204.5-249.8-146 146L16 161.9C-2.7 143.2-2.7 112.8 16 94l78.1-78c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3.3-.7.6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3.6-.7.9-1l45.1 45.1zm159.2 159.2 45.1 45.1c-.3.3-.7.6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3.6-.7.9-1l19.8 19.9c18.7 18.7 18.7 49.1 0 67.9l-78.1 78c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4z" })
  }
), hA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l75.7-75.7-129.9-130-91.5 91.5L38.8 5.1zm78 324.1c-6.6 6.6-11.5 14.8-14.1 23.8L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L223 473.3c9-2.6 17.2-7.5 23.8-14.1l94.4-94.4-145.4-114.5-79 79zM426.7 19.3l-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0z" })
  }
), cA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M347.8 17C319.3 6 288.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192S150 64 256 64c14.1 0 27.8 1.5 41 4.4zm-37.2 332.4c-5.4 5.3-11.4 9.8-17.8 13.6-1.7 2.7-3 5.7-3.8 9-4.4 17.1 5.9 34.6 23 39 12.8 3.3 26.2 5 40 5 88.4 0 160-71.6 160-160 0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9 0 53-43 96-96 96-8.3 0-16.4-1.1-24-3-5.9-1.5-11.9-1.3-17.4.4M473.9 16C455.1-2.8 424.7-2.7 406 16l-39.6 39.7 89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4.4-68.2zM200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15l145.1-142.1-89.1-89.1z" })
  }
), sA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5l167.3-167.4-98-98zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), vA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z" })
  }
), eA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3l-30.1 30.1 80 80 30.1-30.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zm-233 76.3c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2c-5.8 5.8-10 12.9-12.2 20.8l-27.8 97.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7 97.4-27.8c7.8-2.2 15-6.4 20.8-12.2l251.9-251.9c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3l-57.4-57.4C372.1 68.1 362.2 64 352 64s-20.1 4.1-27.3 11.3L317 83l-29.4-29.3c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM89.1 422.9l17.3-60.5 43.2 43.2z" })
  }
), lA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.6 295.8l42.1-42.1 22.6-22.7 11.3-11.3-33.9-33.9-62.1-62.1-33.9-33.9-11.3 11.3-22.6 22.6-57.8 57.8L38.8 5.1zm267.4 209.6 50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8-25.4-19.9zM195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM426.7 18.7l-14.4 14.5-22.6 22.6-11.4 11.3 33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5l-39.3-39.4c-25-25-65.5-25-90.5 0z" })
  }
), tA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m410.3 231 11.3-11.3-33.9-33.9-62.1-62.1-33.9-33.9-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l199.2-199.2zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.2 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7l-14.4 14.5-22.6 22.6-11.4 11.3 33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5l-39.3-39.4c-25-25-65.5-25-90.5 0zm-47.4 168-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), wA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0M25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2l47.6 47.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0m-16.4 136.4c-2.3-2.3-4.9-4.4-7.5-6.3 14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-72.8l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96v-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2S368 377.6 368 367.9V336h-96v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z" })
  }
), gA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320c-12-12-18.8-28.3-18.8-45.3v-88.1c0-32.4 26.2-58.6 58.6-58.6 24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v76.2l10.1-5 47.4-71.2c13.3-20 35.8-32 59.9-32 32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51v-65.1l-19 28.5c-4.6 7-11 12.6-18.5 16.3L399 316.3c-2.4 1.3-4.9 2.2-7.6 2.8-2.6.6-5.3.9-7.9.8H256.7c-2.5.1-5-.2-7.5-.7-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1l47.8-119.5 49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.1-17.8-41.5zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m77.9 348.6 47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z" })
  }
), iA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.9-27.5-33-46.4-61.5-46.4zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4z" })
  }
), mA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9c-3.4 10.4 4.3 21.1 15.2 21.1zM528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), aA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M72 88a56 56 0 1 1 112 0 56 56 0 1 1-112 0m-8 157.7c-10 11.2-16 26.1-16 42.3s6 31.1 16 42.3zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-26.8C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416v-21.5c20-24.7 32-56.2 32-90.5 0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112 0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32m8-328a56 56 0 1 1 112 0 56 56 0 1 1-112 0m120 157.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-80 272c0 16.2 6 31 16 42.3v-84.6c-10 11.3-16 26.1-16 42.3m144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zm64 42.3c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-42.8c-37.8-18-64-56.5-64-101.2 0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112" })
  }
), oA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M360 72a40 40 0 1 0-80 0 40 40 0 1 0 80 0M144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32zm464-208a40 40 0 1 0 0-80 40 40 0 1 0 0 80M200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l26.8-49.9V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-54.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.8-49.9V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-37.8 70.2c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32z" })
  }
), nA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4z" })
  }
), rA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l28.6-47.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.6c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), dA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-16 32c-35.3 0-64 28.7-64 64v128c0 17.7 14.3 32 32 32 9.8 0 18.5-4.4 24.4-11.2l24 144.5c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2L174 215l116.3 53.8c.5.3 1.1.5 1.6.7 8.6 3.6 18 3.1 25.9-.7 3.4-1.6 6.6-3.9 9.3-6.7 3.1-3.2 5.5-7 7.1-11.4.1-.3.2-.7.3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5a128.9 128.9 0 0 0-58.1 51.6l-130.2-60.2c-12.6-5.9-26.4-8.9-40.3-8.9zm400-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96M349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z" })
  }
), SA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6l8.7-34.9c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 32c-35.3 0-64 28.7-64 64v288c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-30.4l-37.4-58.9C157.6 142 132.1 128 104.7 128z" })
  }
), zA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m335.5 4 288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-176 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80m312 40a40 40 0 1 1 80 0 40 40 0 1 1-80 0M226.9 491.4 200 441.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-38.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-38.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-54.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z" })
  }
), pA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.9-27.5-33-46.4-61.5-46.4z" })
  }
), MA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32M528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), xA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110 26.7 28.6 42.9 66.9 42.9 109 0 18.5-3.1 36.3-8.9 52.8-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24v-80c0-13.3-10.7-24-24-24h-17.1c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2 5.5-18.2 3.7-38.4-6-55.8l-4.8-8.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5 264 160h40v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z" })
  }
), HA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M252.6 11.7C245.8.3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c-5.6-2-11.5-3.5-17.4-4.4l-1.1-.2c-8.1-1.2-16.4-1.3-24.9-.3-4 .5-7.9 1.2-11.9 2.2-51.4 12.9-74.7 65-61.9 116.4L152 363.4c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2-13.6-2.8-28-2.6-42.4 1-51.4 12.9-82.7 65-69.8 116.5l56 224c12.9 51.4 65 82.7 116.4 69.8 7-1.7 13.6-4.2 19.8-7.3 5.6-2.8 12.3-2.8 17.9 0 3 1.5 6 2.8 9.2 4 10.7 4 22.2 6.2 34 6.2 11.6 0 22.9-2.1 33.5-6.1 3.2-1.2 6.4-2.6 9.4-4.1 5.6-2.8 12.3-2.8 17.9 0 6.2 3.1 12.8 5.6 19.8 7.3 51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4-23.2-5.8-46.5-2.6-66.3 7.3-5.6 2.8-12.3 2.8-17.9 0-6.2-3.1-12.8-5.6-19.8-7.3-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7z" })
  }
), VA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0m256 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), CA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), LA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 352v-96h16v96zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5zM464 64v242.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), BA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 352v-96h16v96zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5zm478.6-326.6-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.4-25.4V384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" })
  }
), uA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-20.8 112-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6l60.5 38.4V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-238.8 6.7 102.4-76.8c7.2-5.4 8.5-15.7 2.9-22.8l-14.9-18.7c-21.6-27-60.7-32-88.4-11.2l-65.2 48.9c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8zM120 256c-12.1 0-22.1 8.9-23.8 20.6-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.4 11.2c-8.6 8.6-9.3 21.9-2.3 31.3-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.7 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.7-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.8-3.7-14.1-6.8-21.7-9-1.7-11.7-11.7-20.6-23.8-20.6zm8 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128m352.2-43.4c-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3-3.7 6.9-6.8 14.1-9 21.8-11.8 1.6-20.7 11.6-20.7 23.7v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.8-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.9-3.7-14.1-6.8-21.8-9-1.6-11.7-11.6-20.6-23.7-20.6h-16c-12.1 0-22.1 8.9-23.8 20.6M448 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), RA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m27.2 64-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6l60.5 38.4V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM56 384a72 72 0 1 1 144 0 72 72 0 1 1-144 0m200 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0m184 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0m200 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0" })
  }
), $A1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v160h64zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32zM224 512c17.7 0 32-14.3 32-32V320h-64v160c0 17.7 14.3 32 32 32M320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6-30.9 154.6c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM112 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m0 261.3v-72l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32h-66.7l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-96l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-58.7c0-10.4-3.4-20.5-9.6-28.8z" })
  }
), kA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160m212.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6.1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7-4.9-2.8-9.2-6.4-12.6-10.6-4.6-5.4-7.8-11.7-9.6-18.4-3.3-12-1.9-25.2 4.8-36.6.6-1.1 1.3-2.2 2-3.2l67.1-100.7C102.3 216 147.3 192 195.4 192h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4 2.9 6.7 4.3 13.8 4 20.8-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0-88 0 44 44 0 1 0 88 0" })
  }
), PA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32M190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74z" })
  }
), FA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-8 187.3 47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1L287 162.6c-18.2-22-45.3-34.7-73.9-34.7h-36c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8v112c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), TA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m16 210.7v-65l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v96h-30.9l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-69.5z" })
  }
), AA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V192h136c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V64h192v192H384v-32h-64v48c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32" })
  }
), DA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm136 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), yA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16" })
  }
), bA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm136 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0m224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16" })
  }
), fA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z" })
  }
), UA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z" })
  }
), GA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288m59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z" })
  }
), qA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 64a48 48 0 1 1 96 0 48 48 0 1 1-96 0M9.8 214.8c5.1-12.2 19.1-18 31.4-12.9l19.5 8.1 22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2.4 32.2S555.5 512 544 512H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8 112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-74.9l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.3-40.4l48-144 11-33 32 13.7z" })
  }
), WA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m16 210.7v-65l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7 0 35.3 28.7 64 64 64 32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-134.5 33.6c-10-13.7-25.3-23.3-42.8-25.7l-49.6-198.4c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l6.5 26.2h-46.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-69.5zM272 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), EA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.4-85.9L18.7 320C6.7 308 0 291.7 0 274.7v-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64h46.1l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1l-134.3 33.6C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64 0-21.3 10.4-40.1 26.3-51.7l-27-108.3h-70.7c-16 0-31-8-39.9-21.4zM0 480V346.5l64 64V480c0 17.7-14.3 32-32 32S0 497.7 0 480m288-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m69.4-87.8c-17.1 4.3-34.5-6.1-38.8-23.3l-22.9-91.5c-4.3-17.1 6.1-34.5 23.3-38.8l91.5-22.9c17.1-4.3 34.5 6.1 38.8 23.3l22.9 91.5c4.3 17.1-6.1 34.5-23.3 38.8z" })
  }
), OA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 176a88 88 0 1 0 0-176 88 88 0 1 0 0 176M78.7 372.9c15-12.5 50-34.4 97.3-50.1V432h224V322.7c47.3 15.8 82.3 37.7 97.3 50.1 20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35-8.4 14.3-23.9 23.9-41.6 23.9-26.5 0-48-21.5-48-48 0-4.3.6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9v2.1c0 26.5-21.5 48-48 48-11.8 0-22.7-4.3-31-11.4-13.1 8.1-23.7 15.9-31.7 22.5-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24zm200-184a24 24 0 1 1 48 0 24 24 0 1 1-48 0m104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48M96 240a16 16 0 1 0-32 0 16 16 0 1 0 32 0m368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), IA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1M190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74z" })
  }
), NA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-15.7 160h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384v80c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-80h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4-21.5 12.1-38 32.3-45.2 57.3l-39 136.7c-10.7 37.5 14.2 74.8 51.1 80.7v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32m496 448c-41.2 0-79.7-12-112-32.7v-32.1c36.9-6 61.8-43.3 51.1-80.7L428 197.6c-7.1-24.9-23.7-45.1-45.2-57.3C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32z" })
  }
), XA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0M50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v80c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-80H42.4c-21.3 0-36.6-20.3-30.8-40.8z" })
  }
), KA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.4c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), QA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1l-105 23.8c-41 9.3-83.7 7.5-123.7-5.2-50.2-16-84.3-62.6-84.3-115.3zm128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-13.5 197.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), ZA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128m-22.4 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7-37.4 15.7-64.6 51.2-68.2 94l-4.1 49.3c-3 36.2 14.4 69 42.1 87.7v79.6C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32m496 448c-41.2 0-79.7-12-112-32.7v-79.6c27.8-18.7 45.1-51.5 42.1-87.7l-4.1-49.3c-3.6-42.7-30.8-78.2-68.2-94C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32z" })
  }
), JA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-73.8c0-10 1.6-19.8 4.5-29l160.6 248.2c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H304l38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6c-9.1-12.1-23.3-19.2-38.4-19.2h-71.5l-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6v-9.8zM96 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0m368 206.1 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7.1.3.1.6.2.8H312c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9-1.2 17.8 36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6z" })
  }
), jA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0c17.7 0 32 14.3 32 32v9.8c0 54.6-27.9 104.6-72.5 133.6l.2.3 56.8 80.3H392c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320h-97.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-73.8c0-65.1 39.6-123.7 100.1-147.9 36.2-14.5 59.9-49.5 59.9-88.5V32c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), YA1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M154.2 352c3.8-29.6 5.8-62.1 5.8-96 0-18.3-.6-36.1-1.7-53.4 12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5 1.9 0 3.8.1 5.6.3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C282.6 97.8 271 96 259.3 96c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1-.1.1C141 63.1 112.8 0 80 0 35.8 0 0 114.6 0 256s35.8 256 80 256c25.3 0 47.8-37.5 62.5-96h55.1c19 0 36.2-11.2 43.9-28.5l11.5-25.9-9.5-6a95.394 95.394 0 0 1-37.9-44.9L187.2 352zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), _A1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3v352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H70.2c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.4c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9z" })
  }
), hD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M59.4 304.5 88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1L255 162.6c-18.2-22-45.3-34.7-73.9-34.7h-36c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-16 104v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l28.3-56.2 54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3 36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56M288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-56c-8.8 0-16 7.2-16 16m-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z" })
  }
), cD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4 19 4.8 35.6 16.4 46.4 32.7l28.4 42.6H336v-24c0-13.3 10.7-24 24-24s24 10.7 24 24v304c0 13.3-10.7 24-24 24s-24-10.7-24-24V272h-39.4c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9 117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9-26.4 100.3c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346-35.2 140.6c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z" })
  }
), sD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25h151c8.8 0 16-7.2 16-16V17.4c0-9.4-8-16.7-17.3-16zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16M72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40h152v89.4l162.8-162.9c-13.3-4.3-27.3-6.5-41.6-6.5H240zm345.7 20.9L246.6 416H416v-46.3l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8l-76.2-128.8c-11.2-18.9-26.6-34.5-44.6-45.9M224 448v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32z" })
  }
), vD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25m17.6 57h156.8c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16m228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9l94.9-164.2c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6.9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2m-24-192a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), eD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M71 12.5c-8.6 1-15 8.2-15 16.8 0 9.3 7.5 16.8 16.7 16.9h111.4c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9zm118.5 65.6h-123C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9M32 256v32c0 17.7 14.3 32 32 32h128c1.8 0 3.5-.1 5.2-.4L53 208.6c-12.9 11.7-21 28.6-21 47.4m190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5v-32c0-35.3-28.7-64-64-64H96c-3.7 0-7.4.3-10.9.9zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zm72.2-18.2c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9V456h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88v-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z" })
  }
), lD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m64 193.7v65.1l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7L18.7 320C6.7 308 0 291.7 0 274.7v-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c12.9 0 24.1 7.7 29.1 18.7l295-49.2L515.3 95c-2.2-6.5-3.3-13.4-3.3-20.2V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V288h-39.4c-16 0-31-8-39.9-21.4zM0 480V346.5l64 64V480c0 17.7-14.3 32-32 32S0 497.7 0 480m280-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), tD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4l-48.6 92.5c-20.2 38.5-9.4 85.9 25.6 111.8l53.2 39.3H72c-22.1 0-40 17.9-40 40s17.9 40 40 40h208c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354z" })
  }
), wD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-72 383c-13.8-3.6-24-16.1-24-31v-55.1l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6 4.1-.6 8.2-1 12.5-1H192c1.4 0 2.8.1 4.1.3 35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32h-56v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), gD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zM7 7c9.4-9.3 24.6-9.3 34 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41c-9.3-9.4-9.3-24.6 0-34m464 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0" })
  }
), iD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.2-128.8c24.5-41.4 69-66.8 117.1-66.8zM160 80a80 80 0 1 1 160 0 80 80 0 1 1-160 0M448 0c8.8 0 16 7.2 16 16v116.3c9.6 5.5 16 15.9 16 27.7v109.3l16-5.3v-56c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-44l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16v-96h-16c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32v-32c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16z" })
  }
), mD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-21.3c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3-31 82.4 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM16 95.8h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16m-16 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16m16 48h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), aD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5 1.9 0 3.8.1 5.6.3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1H384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C186.6 97.8 175 96 163.3 96c-31 0-60.8 12.3-82.7 34.3l-23.2 23.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5l11.5-25.9-9.5-6a95.394 95.394 0 0 1-37.9-44.9z" })
  }
), oD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96m89 160-8-32h63c17.7 0 32-14.3 32-32s-14.3-32-32-32h-79.2c-6.6-19-24.5-32-44.9-32-30.9 0-53.6 29.1-46.1 59l21.1 84.5C178 332 203.6 352 233 352h85.8c6.7 0 12.6 4.1 15 10.4l36.2 96.8c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H265zM95.5 154.1c-3.3-17.4-20-28.8-37.3-25.6s-28.8 20-25.6 37.3l33.3 177.8C77.2 404.1 130.1 448 191.7 448H272c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80.3c-30.8 0-57.2-21.9-62.9-52.2z" })
  }
), nD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96m48 160v-32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-66.7c-6.6-18.6-24.4-32-45.3-32-26.5 0-48 21.5-48 48v80c0 35.3 28.7 64 64 64h85.6c8.1 0 14.9 6 15.9 14l10.7 86c2 16 15.6 28 31.8 28h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.8l-7.2-57.9c-5-40-39-70.1-79.4-70.1zM64 160c0-17.7-14.3-32-32-32S0 142.3 0 160v160c0 70.7 57.3 128 128 128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-35.3 0-64-28.7-64-64z" })
  }
), rD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160v320c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9l192 109.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80m-8 280v-88h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.9-49.9V488c0 13.3 10.7 24 24 24s24-10.7 24-24" })
  }
), dD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7-59.7-21.8c-12.5-4.5-26.2 1.9-30.8 14.3l-38.3 105.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-15.4 42.4-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4l-29-32.8c-18.2-20.5-44.3-32.2-71.8-32.2h-27.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h20.2l27.8 55.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-72.4c0-9.9-2.3-19.7-6.8-28.6L216 312.4v-77.2l.3.3c13.8 15.6 31.2 27.5 50.7 34.8l29.3 11-7.3 20.2c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3l38.3-105.4c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM192 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), SD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0M25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z" })
  }
), zD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-224 80c0-17.7 14.3-32 32-32h159.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32v-66.7l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zm-268.7 29.8-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z" })
  }
), pD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-224 80c0-17.7 14.3-32 32-32h144.5c46 0 65.7 58.4 29 86.2l-103.4 78.6-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6l-38.5 102.7 254.2-131.5c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3c-11.7 6.1-26.2 1.5-32.3-10.3S1.2 472.7 13 466.7l111.2-57.5c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8l57.1-66.6H160c-17.7 0-32-14.3-32-32" })
  }
), MD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 0c8.8 0 16 7.2 16 16v182.3l-32 8.5V16c0-8.8 7.2-16 16-16M64 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0m36.4 138c-14.2-30.8 8.3-66 42.2-66 18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6v122.1L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24s24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L256 412.2V297.7l-66.7 17.8c-22.6 6-46.2-5.1-56-26.3zm-54.7-28.4 65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5L170 393c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32s26.3-.7 32 11.3z" })
  }
), xD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-108.8 64c1.9 0 3.8.1 5.6.3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-23.3 81.6h-88.5l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zm-105.8 38.6c.4.4.8.8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h480c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24h-69.4l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7 0-17.7-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C250.6 97.8 239 96 227.3 96c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4-27.1 176h-44.5l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1z" })
  }
), HD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0M2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2l197.6 102.6 46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6.3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7l-383.5-199c-11.7-6.1-16.3-20.6-10.2-32.4zM118.9 65.6l18.1 8.6 8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2-153.5-73.5-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z" })
  }
), VD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96M35.1 226.7c-11.8-6.1-26.3-1.5-32.4 10.2s-1.5 26.3 10.2 32.4l383.5 199.1c27.3 14.2 59.7 14.4 87.2.7l15.2-7.6c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3l-41.7-21.6c4.5-5.5 7.2-12.5 7.2-20.2V304c0-26.5-21.5-48-48-48h-34.7l59.7-59.7c25.2-25.2 7.4-68.3-28.3-68.3H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h84l-59.2 40.3c-23.6 16.1-26 44.8-13.8 64.9L35.1 226.7zM320 320v54.6L214.7 320z" })
  }
), CD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24h-28.2c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9-5.6-16.8 3.5-34.9 20.2-40.5l74.2-24.9v-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1 298 411c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44v18.8c0 20.7-13.2 39-32.8 45.5zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), LD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m133.5-10.7c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7-8 10.5h-56l-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4h-.9c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4H99.8c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2 4-.6 8.1-.9 12.3-.9H272c26.2 0 49.4 12.6 64 32h114l36 48h-46c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33H546l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3v-77.8c0-6.1-3.4-11.6-8.8-14.3l-147.4-73.7zm-75 170.7H312l-24 32h-24l-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48h224c26.5 0 48-21.5 48-48s-21.5-48-48-48z" })
  }
), BD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m309.5 178.4 138.4 118.7c-1.6.9-3.2 2-4.8 3-18 12.4-40.1 20.3-59.2 20.3-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-26.9 0-52.3 6.6-74.5 18.4M160 160a64 64 0 1 1-128 0 64 64 0 1 1 128 0m146.5 165.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), uD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64h224v9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2V384H64zm288 0h224v320h-67.7l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3h-71.1l-41-63.1c-.3-.5-.6-1-1-1.4 44.7-29 72.5-79 72.5-133.6v-9.8zm73 320h-45.8l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v352c0 26.5 21.5 48 48 48h260.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336h74.6l40 48zm-159.5 0H192v-73.8c0-10.2 1.6-20.1 4.7-29.5zM192 128a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), RD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-21.3c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3-31 82.4 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM384 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V320c35.3 0 64-28.7 64-64s-28.7-64-64-64z" })
  }
), $D1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c3.6 8.7 10.9 15.2 19.6 18.1C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5-34.6-3.6-64.9-25.9-78.5-58.5l-5.1-12.3-31 82.3 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3z" })
  }
), kD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160S568.4 64 480 64H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c53 0 96 43 96 96s-43 96-96 96h-18.7l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3z" })
  }
), PD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm456.9-182.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l25.4 25.3H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z" })
  }
), FD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm456.9-182.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l25.4 25.3H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24m24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 168c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-13.3-10.7-24-24-24m24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24z" })
  }
), TD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4-54.4-31.4c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8l43.8-75.7c4.4-7.7 1.8-17.4-5.9-21.9z" })
  }
), AD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-8.4 32c-36.4 0-69.6 20.5-85.9 53.1l-46.3 92.6c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l35.4-70.7v43.2c0 17 6.7 33.3 18.7 45.3l77.3 77.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.7-5.1-24.9-14.1-33.9l-49.9-50v-93.4l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-76.8-102.4C250.7 142.2 222.2 128 192 128zm-39.3 218.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zm322.5 158.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3-5 3.8-10.5 6.4-16.2 7.9z" })
  }
), DD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-33.5 151.3c-1 .4-1.9.8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2S12 246.5 17.6 229.7l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14 44.6 0 84.8 26.8 101.9 67.9l15.4 36.9 21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z" })
  }
), yD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352z" })
  }
), bD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32v96c-17.7 0-32 14.3-32 32s14.3 32 32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h96c77.4 0 142-55 156.8-128h3.2c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32zm218.5 128H96V96h96c41.8 0 77.4 26.7 90.5 64M96 224h186.5c-13.2 37.3-48.7 64-90.5 64H96z" })
  }
), fD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3.7-10.6.7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.2C303.7 71 244.4 32 176 32zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32M96 192h190.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96v-32z" })
  }
), UD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 41 370 176h46c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24" })
  }
), GD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h118.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), qD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M295 183 430 48h-46c-13.3 0-24-10.7-24-24s10.7-24 24-24h104c13.3 0 24 10.7 24 24v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z" })
  }
), WD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6l40.4 49.3c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z" })
  }
), ED1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m11.7 266.3 41.9 94.3c6.1 13.7 20.8 21.3 35.5 18.4l109.2-21.8c15-3 25.7-16.1 25.7-31.4V240c62.3-20.8 129.7-20.8 192 0v85.8c0 15.3 10.8 28.4 25.7 31.4L550.9 379c14.7 2.9 29.4-4.7 35.5-18.4l41.9-94.3c7.2-16.2 5.1-35.1-7.4-47.7C570.8 168.1 464.2 96 320 96S69.2 168.1 19.1 218.6c-12.5 12.6-14.6 31.5-7.4 47.7z" })
  }
), OD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32h32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m112 64c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64zm160 272a48 48 0 1 0-96 0 48 48 0 1 0 96 0m48-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 128v96c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32" })
  }
), ID1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7c13.6 13.7 32.1 21.3 51.3 21.3s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2S96 145.6 96 135.9V24c0-13.3 10.7-24 24-24zM51.4 489.9l-35.4-62c-9.7-16.9-8.3-38.1 5.5-51.7C72.6 325.9 178.1 256 320 256s247.4 69.9 298.5 120.2c13.9 13.6 15.2 34.8 5.5 51.7l-35.4 62c-7.4 12.9-22.7 19.1-37 14.8l-112.8-33.9c-13.5-4.1-22.8-16.5-22.8-30.6V384c-62.3-20.8-129.7-20.8-192 0v56.2c0 14.1-9.3 26.6-22.8 30.6L88.4 504.7c-14.3 4.3-29.6-1.8-37-14.8" })
  }
), ND1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H256v352c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64zm256 96c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32zm32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64m160-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m-32 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64m-96-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), XD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M456 200v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24M181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512 264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24z" })
  }
), KD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32h-42.3c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32zM32 432v-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177c11.5-19.9 32.7-32.2 55.6-32.2h117.8c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48m296-120a72 72 0 1 0-144 0 72 72 0 1 0 144 0" })
  }
), QD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z" })
  }
), ZD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 0c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24m8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32-72c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z" })
  }
), JD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512 264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24zM399 15c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L399 49c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), jD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z" })
  }
), YD1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64v64H256c-35.3 0-64-28.7-64-64zm127.5 340.6c-13.8 10.3-25.2 25.2-29.6 43.4H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96v264c0 17.7 14.3 32 32 32h150.2c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0M56 168v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM56 360v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16m574-195.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3" })
  }
), _D1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0h320c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64m220 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S270.8 288 280 288h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0M64 128h96v288c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32h160v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64m8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16" })
  }
), hy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h64v156c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284V128h128v238.6c0 45 36.5 81.4 81.4 81.4 30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6-9.6 0-17.4-7.8-17.4-17.4V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), cy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm448 160v160h-80v-68.3c9.6-5.5 16-15.9 16-27.7v-64zM400 384h-96v-68.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7zm-128 0h-96v-68.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7zm-128 0H64V224h64v64c0 11.8 6.4 22.2 16 27.7z" })
  }
), sy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V327.6c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0H192C86 0 0 86 0 192m416 160h32v96H64v-96h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), vy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m462.4 373.5-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3-1.2-2.9-3-7.2-5.5-12.7-5-11-12.6-26.7-23.1-45.3-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1-5.5-2.5-9.8-4.3-12.7-5.5-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1c-6.2-2.3-10.4-8.2-10.5-14.8s3.9-12.6 10-15.1C169.5 7 204 0 240 0c59.6 0 114.7 19.2 159.5 51.6l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4C492.8 157.3 512 212.4 512 272c0 36-7 70.5-19.8 102-2.5 6.1-8.5 10.1-15.1 10s-12.5-4.3-14.8-10.5zM9.4 502.6c-12.4-12.3-12.5-32.2-.5-44.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4z" })
  }
), ey1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M250.4 28c37.5-37.4 98.4-37.4 136 0l113.5 113.3c29.2 29.2 35.7 72.4 19.4 107.8-24.9-15.8-54.4-25-86.1-25-72 0-133 47.3-153.3 112.5L155.7 212.8c-6.3-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L273 374.9c-.2 3-.3 6.1-.3 9.1 0 27.8 7.1 53.8 19.6 76.6-9.3.5-18.7-1-27.6-4.7L208 432.7c-23.9-9.8-51.4-4.3-69.6 13.9l-54 53.7c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l53.5-53.4c18.4-18.3 23.8-45.8 13.9-69.8l-24-57.8c-10-23.9-4.5-51.4 13.9-69.7zM304 384a128 128 0 1 1 256 0 128 128 0 1 1-256 0m32-16a16 16 0 1 0 32 0 16 16 0 1 0-32 0m80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32m0-64a16 16 0 1 0 32 0 16 16 0 1 0-32 0m96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m-80-80a16 16 0 1 0 32 0 16 16 0 1 0-32 0" })
  }
), ly1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M544 240c-7.6 0-14.3-4.9-17-12-37-95.9-130-164-239-164S86 132.1 49 228c-2.7 7.1-9.4 12-17 12-17.7 0-32 14.3-32 32 0 17.2 13.6 31.3 30.7 32 17.7-.5 35-7 48.7-14.2 7-3.6 12.7-7.3 16.7-10 2-1.4 3.5-2.5 4.5-3.2.5-.4.9-.7 1.1-.8l.2-.2 20.7.4.2.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l.1.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l.2.2c.2.2.6.5 1.1.8 1 .7 2.5 1.9 4.5 3.2 4 2.7 9.7 6.4 16.7 10C510 297 527.4 303.5 545 304c17.1-.7 30.7-14.7 30.7-32 0-17.7-14.3-32-32-32zm-421.4 36c-5.9-5.2-14.6-5.4-20.7-.4l20.7.4M81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8h291.8c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2-7-3.7-12.9-7.3-17.5-10.3-4.5 3.1-10.3 6.7-17.4 10.4C429.8 327 405.2 336 376 336s-53.8-9-70.8-17.8c-6.9-3.6-12.7-7.2-17.2-10.2-4.5 3-10.2 6.6-17.2 10.2-17 8.8-41.6 17.8-70.8 17.8s-53.8-9-70.8-17.8c-7.1-3.6-12.9-7.3-17.4-10.4-4.6 3-10.5 6.7-17.5 10.3-10 5.2-22.7 10.7-36.8 14.2l24 71.9zm124.9-253-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5m192-14.3 16 32c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2M304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), ty1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M513.5 32c8 0 14.5 6.5 14.5 14.5V78c0 19.7-9 37.8-23.6 49.7 6.4 4.9 12.7 10.1 18.6 15.7 17.6-15.9 28.5-38.6 29-63.3h40c8.8 0 16 7.2 16 16v16c0 32.8-24.6 59.8-56.3 63.5l6.8 9c11.5 15.4 26.5 27.9 43.7 36.5l5.8 2.9h8c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24h-43.5c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5c-3.9 13.7-16.4 23.2-30.7 23.2h-33c-17.7 0-32-14.3-32-32v-32H272v32c0 17.7-14.3 32-32 32h-33c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256v-16H47.4C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-8.2 2c-6.9 1.7-11.7 7.9-11.7 15 0 8.5 6.9 15.4 15.4 15.4h35.8C98 135 162.6 80 240 80h122.4c14.5 0 28.8 1.3 42.7 3.9 8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40" })
  }
), wy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 96v.7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6-.1-2-.2-4-.2-6 0-53 43-96 96-96s96 43 96 96m-16 32c3.5 0 7 .1 10.4.3 4.2.3 8.4.7 12.6 1.3 17.6-20.5 43.8-33.6 73-33.6h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-32c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H256v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24h-4c-11 0-20 9-20 20s9 20 20 20h31.2c12.1-59.8 57.7-107.5 116.3-122.8 12.9-3.4 26.5-5.2 40.5-5.2h128zm64 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), gy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 96c-26.5 0-48 21.5-48 48v112h96V144c0-26.5-21.5-48-48-48M0 144C0 82.1 50.1 32 112 32s112 50.1 112 112v224c0 61.9-50.1 112-112 112S0 429.9 0 368zm554.9 255.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160 0 28.9-7.7 56-21.1 79.4m-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160 0-28.9 7.7-56 21.1-79.4 7.1-12.3 23.7-13.1 33.8-3.1l187.6 187.6c10 10 9.3 26.7-3.1 33.8z" })
  }
), iy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 318.1v-63.4l25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2l76.9-38.4H432c44.2 0 80 35.8 80 80v13.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7zm0 35.8 2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6v50.5l-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7H224c-3.2 0-6.2.9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0l-17.7 8.8-24-12zm37.3-119.2L34.4 190.6c-21-11-34.4-32.8-34.4-56.8V128c0-35.3 28.7-64 64-64h112V32c0-17.7 14.3-32 32-32s32 14.3 32 32v166.1l-71.4 35.7c-6 3-13.1 3.4-19.3.9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32zm288-2.7 7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32zM200 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), my1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192m22.1 254.4c14.9 4.8 30.7-1.8 37.9-15 7.4-13.5 4.2-30.8-8.4-40.6l-246-208.3C117 180.4 56.4 185.7 22.4 226.3S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7zM64 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), ay1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M431.5 12.1c-1.1-4.5-4.2-8.4-8.4-10.5s-9.1-2.2-13.4-.4c-15.9 6.9-26.7 19.6-31.6 34.2l-14.8-14.7c-6.2-6.2-16.4-6.2-22.6 0-15.4 15.4-23.6 35.3-24.5 55.5-18.9-8-39.3-12.2-60.2-12.2-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l101.3-101.5c29-29 45.3-68.3 45.3-109.3 0-20.9-4.2-41.3-12.2-60.2 20.2-.9 40.1-9.1 55.5-24.5 6.2-6.2 6.2-16.4 0-22.6L476.6 134c14.6-4.9 27.3-15.8 34.1-31.6 1.8-4.3 1.7-9.2-.4-13.4s-5.9-7.3-10.5-8.4L485.5 77c6.9-12 10.5-25.6 10.5-39.5V32c0-8.8-7.2-16-16-16h-5.5c-13.9 0-27.5 3.6-39.4 10.4l-3.6-14.3zM164.7 212.7c6.2-6.2 16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6m182.6 0 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM164.7 395.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0z" })
  }
), oy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32S0 401.7 0 384V128c0-17.7 14.3-32 32-32m448 0c17.7 0 32 14.3 32 32v64.7c-5.3-.5-10.6-.7-16-.7-16.6 0-32.7 2.3-48 6.6V128c0-17.7 14.3-32 32-32M320 368c0 5.4.2 10.7.7 16H96V128h320v83.2c-57 29.1-96 88.4-96 156.8m32 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), ny1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6c-38.1 22.5-82.5 35.4-130 35.4s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130l-16.7-16.7c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32m192 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320M80 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0M448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 368a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), ry1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32m576 0c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32m-64 32H96v256h448z" })
  }
), dy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M575.2 64c-32.1 0-62.1 16-79.9 42.7l-61.8 92.7c-3.9-4.8-8.6-9.1-14-12.7l-24-16c-4.7-3.2-9.7-5.6-14.9-7.4L442 71.2C471.7 26.7 521.7 0 575.2 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32zM333.4 206.2c9.8-14.7 29.7-18.7 44.4-8.9l24 16c14.7 9.8 18.7 29.7 8.9 44.4L287.8 442.1c-29.2 43.7-78.2 69.9-130.7 69.9C70.3 512 0 441.7 0 354.9V272c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v50.3l77.4-116.1z" })
  }
), Sy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v12l-96-12c-17.7 0-32 14.3-32 32s14.3 32 32 32l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12zm0 84.2-32-4-32 4V192H96v256h320V192H288zM32 160c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32m480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), zy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0" })
  }
), py1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169.7.9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80h1.6c176.7 0 320 143.3 320 320v1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7.9zm230.1 409.3c.1-3.4.2-6.8.2-10.2 0-159.1-128.9-288-288-288-3.4 0-6.8.1-10.2.2L.5 491.9c-1.5 5.5.1 11.4 4.1 15.4s9.9 5.6 15.4 4.1zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0M96 384a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), My1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M385.2 419c10.4-8.2 25.5-8.4 34.9 1s9.4 24.7-.8 33.1C375 489.9 318.1 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c62.1 0 119 22.1 163.3 58.8 10.2 8.5 10.1 23.8.8 33.1s-24.5 9.2-34.9 1C349.7 64.8 304.8 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208c48.8 0 93.7-16.8 129.2-45m-16-49.9c6.2 6.2 6.3 16.5-.5 22.1-69.1 57.7-172.2 54.1-237.1-10.8-68.7-68.7-68.7-180.2 0-248.9 64.9-64.9 167.9-68.5 237-10.7 6.8 5.7 6.7 15.9.5 22.1L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6l101.8 101.8zM192 264a24 24 0 1 0-48 0 24 24 0 1 0 48 0m24-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m72 200a24 24 0 1 0-48 0 24 24 0 1 0 48 0m155.4-219.4c6.7-6.7 17.7-6.2 23 1.7 39.5 59 39.5 136.5 0 195.5-5.2 7.8-16.3 8.3-23 1.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6l24.2-24.2c3.6 2.2 7.9 3.5 12.5 3.5 13.3 0 24-10.7 24-24 0-4.6-1.3-8.9-3.5-12.5l30.9-30.9zM472 280a24 24 0 1 0-48 0 24 24 0 1 0 48 0m22.4 126.4c-8.9-8.9-9.4-23.1-2.3-33.5C514.8 339.6 528 299.3 528 256s-13.2-83.6-35.9-116.9c-7.1-10.4-6.6-24.6 2.3-33.5 9.9-9.9 26.2-9.4 34.3 2C558.5 149.5 576 200.7 576 256s-17.5 106.5-47.4 148.4c-8.1 11.4-24.4 11.9-34.3 2z" })
  }
), xy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 109.3v108.3L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6l-75.3-75.4c-6.2-6.2-16.4-6.2-22.6 0l-75.3 75.3c-6 6-9.4 14.1-9.4 22.6zm-199.1 221C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3M592 512c26.5 0 48-21.5 48-48v-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512z" })
  }
), Hy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.3 166.9 0 68c0-10.3 9.5-17.9 19.5-15.7l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6-41.5-145.2C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2-41.2 15.6-86.2 18.1-128.8 7l-298.3-77.6c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m96-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Vy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0m384 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" })
  }
), Cy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0m240 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), Ly1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0m240 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), By1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M381 114.9 186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240l-58.2-25.9c-8.7-3.9-18.8-3.7-27.3.6l-32.2 16.1c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2h137.7c5 0 9.9-1.2 14.3-3.4l272.9-136.4c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48h-57.4c-20.2 0-40.2 4.8-58.2 14zM0 480c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32" })
  }
), uy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 256c0-35-59.5-64-93.7-64H365.7l-37.2-65.1C342 123.1 352 110.7 352 96c0-17.7-14.3-32-32-32h-27.4l-27.4-47.9C259.5 6.2 248.9 0 237.4 0h-56.2c-10.6 0-18.3 10.2-15.4 20.4l49 171.6H112l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H14c-7.8 0-14 6.3-14 14 0 1.3.2 2.6.5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9 0 7.8 6.3 14 14 14h42c5 0 9.8-2.4 12.8-6.4L112 320h102.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4h56.2c11.5 0 22.1-6.2 27.8-16.1l27.3-47.9H320c17.7 0 32-14.3 32-32 0-14.7-10-27.1-23.5-30.9l37.2-65.1h116.6c34.2 0 93.7-28 93.7-64" })
  }
), Ry1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2c-3.8 11.1-5.8 23.1-5.8 35.5v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14-1.3 0-2.6-.2-3.9-.5L256 480l-110.1 31.5c-1.3.4-2.6.5-3.9.5-7.8 0-14-6.3-14-14v-42c0-5 2.4-9.8 6.4-12.8L192 400v-70.9l-171.6 49c-10.2 3-20.4-4.7-20.4-15.3v-65.5c0-5.7 3.1-11 8.1-13.9L192 178.3zM528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), $y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m240 384-8.3-66.4-110-11-7.9 63.4c-1 8-7.8 14-15.9 14H62.1c-8.1 0-14.9-6-15.9-14L36 287.8c-1.3.2-2.6.2-4 .2-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7.1 4 .2L46.2 142c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14l7.9 63.4 110-11L240 128h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h24l6.2-50c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14l6.2 50h40V48c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32l8 64h138.3c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64H344l-8 64h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-40l-6.2 50c-1 8-7.8 14-15.9 14h-35.8c-8.1 0-14.9-6-15.9-14l-6.2-50h-24c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), ky1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M514.3 192c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64h-73.7l190.2 149.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l199.3 156.2-40.3-140.9C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192zM41.5 128.7l321 252.9-65.3 114.3c-5.7 10-16.3 16.1-27.8 16.1h-56.2c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14 0-1.3.2-2.6.5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9 0-6.2 4-11.4 9.5-13.3" })
  }
), Py1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M61.5 308.8.8 39C-3.7 19 11.5 0 32 0h76.9a64 64 0 0 1 46 19.5L384 256h128v256H267.7c-10.7 0-21.2-1.9-31.2-5.7L40.4 431.9C16.1 422.7 0 399.4 0 373.4c0-28.2 18.8-52.8 45.9-60.3l15.5-4.3zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), Fy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L482.4 352.8l72.5 24.2c10.4 3.5 21.1-4.3 21.1-15.2v-56.7c0-10.7-5.3-20.7-14.2-26.6L384 160V93.7C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7V160l-10.6 7.1L38.8 5.1zm122.5 218-83.1 55.4c-8.9 5.9-14.2 15.9-14.2 26.6v56.7c0 10.9 10.7 18.6 21.1 15.2L256 320v80l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3.4 2.6.5 3.9.5 7.8 0 14-6.3 14-14v-42.7c0-2.8-.7-5.6-2.1-8z" })
  }
), Ty1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7V160l177.8 118.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14-1.3 0-2.6-.2-3.9-.5L256 480l-110.1 31.5c-1.3.4-2.6.5-3.9.5-7.8 0-14-6.3-14-14v-42c0-5 2.4-9.8 6.4-12.8L192 400v-80L21.1 377C10.7 380.4 0 372.7 0 361.8v-56.7c0-10.7 5.3-20.7 14.2-26.6L192 160z" })
  }
), Ay1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M482.3 192c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64H365.7L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1h-56.2c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H112l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H14c-7.8 0-14-6.3-14-14 0-1.3.2-2.6.5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9 0-7.8 6.3-14 14-14h42c5 0 9.8 2.4 12.8 6.4L112 192h102.9l-49-171.6c-3-10.2 4.7-20.4 15.3-20.4h56.2c11.5 0 22.1 6.2 27.8 16.1L365.7 192h116.6z" })
  }
), Dy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128M0 288a224 224 0 1 1 448 0 224 224 0 1 1-448 0m236.2-175.6c-4-.3-8.1-.4-12.2-.4-76.2 0-141.1 48.4-165.6 116.2-5.1 14.1 6.3 27.8 21.3 27.8h28.4c12.7 0 24.9 5.1 33.9 14.1l43 42.9c4.5 4.5 7 10.6 7 17v22c0 9.2 3.9 17.6 10.2 23.4l1.9 1.8c9.3 8.6 19.9 18.4 19.9 30.8v23c0 13.8 11.2 25 25 25 9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3V320c0-17.7-14.3-32-32-32h-65.8c-9 0-17.7-3.6-24.1-10-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5v-13.5c0-11.6-8.3-21.7-19.8-22.5" })
  }
), yy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.7 319.7C456.6 182.8 539.1 43.3 503.9 8.1c-22.2-22.1-85.6 2.3-163.7 57.6C314.4 54.3 286 48 256 48 141.1 48 48 141.1 48 256c0 30 6.3 58.4 17.7 84.2C10.4 418.3-14 481.7 8.1 503.9c35.2 35.2 174.7-47.3 311.6-184.2zM256 464c114.9 0 208-93.1 208-208 0-16.1-1.8-31.8-5.3-46.9-31.8 42.6-71.4 88.2-116.4 133.2s-90.6 84.6-133.2 116.4c15.1 3.5 30.7 5.3 46.9 5.3z" })
  }
), by1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-35.6-18.7-60.2-48-70.1v-13C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8c-16.7-8.8-35.8-13.8-56-13.8-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-35.6-18.7-60.2-48-70.1v-13c0-30.9 25.1-56 56-56s56 25.1 56 56v232c0 17.7 14.3 32 32 32s32-14.3 32-32V248z" })
  }
), fy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152h17.4L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152h17.3L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6 0 39.9-32.2 72.2-72 72.5V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V240c-39.8-.3-72-32.6-72-72.5 0-5.6.6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1 11.5 0 20.9 9.3 20.9 20.9V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H544c-17.7 0-32-14.3-32-32V160c0-100.8 84.2-136.8 101.1-143M221.2 143.6l-16.3-69.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5-7 18.8-11.3 40.5-11.3 65.5v26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2v-117c8.5-2.8 16.6-6.7 24-11.4v.6c0 88.4 71.6 160 160 160 68.1 0 126.2-42.5 149.3-102.4 9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480M208 256a128 128 0 1 1 256 0 128 128 0 1 1-256 0" })
  }
), Uy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16M56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24m-32 72h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24M272 48c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80zm128-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16m80 160v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16m-128-16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80m-96 16v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16M3.5 347.6C1.6 332.9 13 320 27.8 320h456.4c14.8 0 26.2 12.9 24.4 27.6-6.3 50.2-44.4 89.4-92.6 98.4v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4" })
  }
), Gy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96v320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6zM448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), qy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80v352c0 17.4 9.4 33.4 24.5 41.9S58.2 482 73 473l288-176c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41z" })
  }
), Wy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288m47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z" })
  }
), Ey1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm544 208a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0" })
  }
), Oy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), Iy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm544 208a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16" })
  }
), Ny1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), Xy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288m59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6" })
  }
), Ky1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32m192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2C297 398 352 333.4 352 256v-32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), Qy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H288z" })
  }
), Zy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v112H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h112v112c0 17.7 14.3 32 32 32s32-14.3 32-32V208h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zM0 480c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32" })
  }
), Jy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z" })
  }
), jy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.4 372c48.5-31.3 80.6-85.9 80.6-148 0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148 1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57m-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2-5.8-9.7-13.5-17-21.9-22.4 19.5-17.6 31.8-43 31.8-71.3 0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3-8.4 5.4-16.1 12.7-21.9 22.4-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8 0 33-12.9 104.1-20.6 132.9-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4C172.8 460.2 160 389 160 355.9c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), Yy1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M168 72c-22.1 0-40 17.9-40 40v32h296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-32c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-17.8 0-33.3-9.7-41.6-24zM73.7 455.1 48 224h352l-25.7 231.1c-3.6 32.4-31 56.9-63.6 56.9H137.3c-32.6 0-60-24.5-63.6-56.9zm157.6-178.3c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.5c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8.8-9.5 9.5-4.5 14.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0l42 24.3c6 3.5 13.1-1.9 11.8-8.9l-9.5-49c-.5-2.8.4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3l-47.8-6c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.5z" })
  }
), _y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48S314.5 0 288 0h-64c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H128v-32c0-22.1 17.9-40 40-40zM48 224l25.7 231.1c3.6 32.4 31 56.9 63.6 56.9h173.4c32.6 0 60-24.5 63.6-56.9L400 224z" })
  }
), hb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c8.8 0 16 7.2 16 16v16h80c17.7 0 32 14.3 32 32 17.7 0 32 14.3 32 32v368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32 0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16M96 136v24h32v-32h-24c-4.4 0-8 3.6-8 8m0 40v24c0 4.4 3.6 8 8 8h24v-32zm72-48h-24v32h32v-24c0-4.4-3.6-8-8-8m-24 48v32h24c4.4 0 8-3.6 8-8v-24zm72-48c-4.4 0-8 3.6-8 8v24h32v-32zm24 48h-32v24c0 4.4 3.6 8 8 8h24zm16-48v32h32v-24c0-4.4-3.6-8-8-8zm32 48h-32v32h24c4.4 0 8-3.6 8-8zM96 256v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16" })
  }
), cb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m448 80h-96V96h96zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm304 384H352v-32h224zm-304-96c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48zM64 128c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64zm64 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-64 80c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64z" })
  }
), sb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M460.3 172c-46.2-33.2-117-14.1-165.1 44.3-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4 121.4 87 296.3 27.7 381.8-98.6 46.2-68.4 36.4-158.5-22.6-200.2z" })
  }
), vb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M236.9.2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1 0 21.7-8.5 37.2-21.9 47.6-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64 0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2.2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1 3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88 0-43.6-31.7-79.8-73.3-86.8 5.9-9.7 9.3-21.1 9.3-33.2 0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6 0-48.7-36.1-88.9-83.1-95.2zM282 227.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7H182l-52.3 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z" })
  }
), eb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M268.9.9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1 0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64 0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72 0 23.2 11 43.8 28 57-34.1 5.7-60 35.3-60 71 0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.7-25.9-65.3-60-71 17-13.2 28-33.8 28-57 0-39.8-32.2-72-72-72h-13.7c13.3-11.7 21.7-28.9 21.7-48 0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32 0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m64 108.3c0 2.4-.7 4.8-2.2 6.7-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7 0-6.8 5.5-12.3 12.3-12.3h167.4c6.8 0 12.3 5.5 12.3 12.3" })
  }
), lb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m384-64a128 128 0 1 0-256 0 128 128 0 1 0 256 0m-80-48c0 11.5-4 22-10.7 30.2 11.5 10.3 18.7 25.2 18.7 41.8 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48m-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), tb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32h5.5c35.3 0 64 28.7 64 64 0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72 0 23.2-11 43.8-28 57 34.1 5.7 60 35.3 60 71 0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72 0-35.7 25.9-65.3 60-71-17-13.2-28-33.8-28-57 0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80 0-9.2-1.5-17.9-4.3-26.1-1.8-5.2-.8-11.1 2.8-15.4z" })
  }
), wb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32.2 160c-.1-1.3-.2-2.7-.2-4 0-20.9 14.5-38.3 34-42.9-1.3-4.2-2-8.6-2-13.1 0-24.3 19.7-44 44-44 1.9 0 3.7.1 5.6.3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6 20.3 0 37.3 13.7 42.4 32.3 1.8-.2 3.7-.3 5.6-.3 24.3 0 44 19.7 44 44 0 4.6-.7 9-2 13.1 19.5 4.5 34 22 34 42.9 0 1.3-.1 2.7-.2 4h-296zm-4 32h69.6l30.3 257.9c1 8.8 9 15.1 17.8 14s15.1-9 14-17.8L130 192h78v256c0 8.8 7.2 16 16 16s16-7.2 16-16V192h78l-29.9 254.1c-1 8.8 5.2 16.7 14 17.8s16.7-5.2 17.8-14L350.2 192h69.6c15.6 0 28.2 12.6 28.2 28.2 0 2.5-.3 5.1-1 7.5l-69.2 249.1c-5.8 20.8-24.7 35.2-46.3 35.2h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192z" })
  }
), gb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0C71.6 0 0 71.6 0 160v176c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V160C320 71.6 248.4 0 160 0m32 480v-64h-64v64c0 17.7 14.3 32 32 32s32-14.3 32-32" })
  }
), ib1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4.4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24 64 10.7 74.7 0 88 0s24 10.7 24 24m112 0c0 26.5 10.5 38.7 25.9 56.1l.4.4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24m208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80M77.7 320H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h17.9c-.2-17.5 14-32 31.7-32h444.8c17.7 0 31.9 14.5 31.7 32H592c17.7 0 32 14.3 32 32s-14.3 32-32 32h-29.7c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35H243.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320z" })
  }
), mb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M466.3 249.2C494.4 222.9 512 185.5 512 144 512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3-27.4 27.5-61 52.7-95.1 71.3-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266 16.2 292.1 0 328.2 0 368c0 79.5 64.5 144 144 144 30.3 0 58.4-9.3 81.5-25.3 28.1-19.3 60.2-35.3 92.5-46.2 44.1-14.9 80.1-50.9 93.1-99.2 9.2-34.2 29.4-67.9 55.2-92.1zM384 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-192 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-56 216a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), ab1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32zm-144.5 88.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4 0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z" })
  }
), ob1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 96h320v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm128 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), nb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 96h320v83.2c-57 29.1-96 88.4-96 156.8 0 54.5 24.8 103.3 63.8 135.6-9.4 5.4-20.2 8.4-31.8 8.4H96c-35.3 0-64-28.7-64-64v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32zm272.8 172.5c6.7-12.6 23.6-13.5 33.7-3.4l164.4 164.4c10.1 10.1 9.2 27-3.4 33.7-20.1 10.7-43.1 16.8-67.5 16.8-79.5 0-144-64.5-144-144 0-24.4 6.1-47.4 16.8-67.5m254.5 135c-6.7 12.6-23.6 13.5-33.7 3.4L361.1 274.5c-10.1-10.1-9.2-27 3.4-33.7 20.1-10.7 43.1-16.8 67.5-16.8 79.5 0 144 64.5 144 144 0 24.4-6.1 47.4-16.8 67.5z" })
  }
), rb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 96h320v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32z" })
  }
), db1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h50.7l128 128-105.3 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112 288 50.1 237.9 0 176 0zm144 160H64V64h112c26.5 0 48 21.5 48 48s-21.5 48-48 48" })
  }
), Sb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v224c0 35.3 28.7 64 64 64h160v34.7l-70.6 70.6c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.3-57.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L320 386.7V352h160c35.3 0 64-28.7 64-64V64c17.7 0 32-14.3 32-32S561.7 0 544 0H64zm64 64h384v224H96z" })
  }
), zb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M138.6 32C62.1 32 0 94.1 0 170.6 0 253.3 40.9 326.5 103.7 371l-32.4 46c-12.7 18-8.4 43 9.7 55.7s43 8.4 55.7-9.7l40-56.8c21.8 6.4 44.9 9.8 68.7 9.8h21.2c23.9 0 46.9-3.4 68.7-9.8l40 56.8c12.7 18.1 37.7 22.4 55.7 9.7s22.4-37.7 9.7-55.7l-32.4-46C471.1 326.5 512 253.3 512 170.6 512 94.1 449.9 32 373.4 32H364c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32zM216 180v7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6h9.4c37.6 0 68 30.4 68 68m40 113.5 29.2 41.5c-6.1.7-12.3 1-18.6 1h-21.2c-6.3 0-12.5-.3-18.6-1zm53.7-62.6c-8.9-12.7-13.7-27.9-13.7-43.5V180c0-37.6 30.4-68 68-68h9.4c32.4 0 58.6 26.2 58.6 58.6 0 55.7-27.5 105-69.7 134.9l-52.5-74.7z" })
  }
), pb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0h226.7c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3V160h-64V93.3L418.7 64H192v96h-64V64c0-35.3 28.7-64 64-64m-64 192h224c-38.9 29.2-64 75.7-64 128 0 11 1.1 21.7 3.2 32H192v96h160c26.7 20.1 60 32 96 32 17.5 0 34.4-2.8 50.2-8l6.3 6.3c-10.8 20.1-32 33.8-56.4 33.8H192c-35.3 0-64-28.7-64-64V384H96c-17.7 0-32-14.3-32-32v-96c0-35.3 28.7-64 64-64m320 208.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z" })
  }
), Mb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L522.2 384H544c17.7 0 32-14.3 32-32v-96c0-35.3-28.7-64-64-64H277.2L192 125.2V64h226.7L448 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zm459 483.1-51-40.2H192v-96h132.9L122.2 192.3C89.6 195.2 64 222.6 64 256v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8zM496 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), xb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C92.7 0 64 28.7 64 64v96h64V64h226.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0zm256 352v96H128v-96zm64 32h32c17.7 0 32-14.3 32-32v-96c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64zm-16-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Hb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zm304 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 119h-64c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512h14c14.7 0 27.5-10 31-24.2l10-39.8h160c26.7 20.1 60 32 96 32 24.4 0 47.5-5.5 68.2-15.2l5.7 23c3.6 14.2 16.4 24.2 31 24.2h14c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64m-160 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192M64 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Vb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v96h128V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-33.9-33.9c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32m-10.6 128c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512h186.4c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Cb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32v96h128V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-33.9-33.9c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32m-10.6 128c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512h186.4c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9 3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1c13.9 17 50.9 65.4 50.9 97.9" })
  }
), Lb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32S337.7 0 320 0H160c-17.7 0-32 14.3-32 32M32 176c-17.7 0-32 14.3-32 32v176c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-17.7-14.3-32-32-32m128 48H96v160h224V96H160zm271.9-117.3L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3v219.4c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7M448 208c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16m0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16m0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16" })
  }
), Bb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.6 103.9c16.9-5.1 34.8-7.9 53.4-7.9 22.8 0 44.7 4.2 64.8 11.7-.6-2-.8-4.1-.8-6.3v-66c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5 5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1 9.6-11.4 20.6-21.7 32.7-30.5l-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320s68.1 192 152 192c19.3 0 37.8-4.5 54.7-12.8 8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8 83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8l-1.8.3z" })
  }
), ub1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M264.8 64c12.8 0 23.2 10.4 23.2 23.2 0 9.2-5.8 17.3-13.2 22.8-11.6 8.7-18.8 20.7-18.8 34 0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34-7.4-5.5-13.2-13.6-13.2-22.8 0-12.8 10.4-23.2 23.2-23.2H464c26.5 0 48 21.5 48 48v88.8c0 12.8 10.4 23.2 23.2 23.2 9.2 0 17.3-5.8 22.8-13.2 8.7-11.6 20.7-18.8 34-18.8 26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8-5.5-7.4-13.6-13.2-22.8-13.2-12.8 0-23.2 10.4-23.2 23.2V400c0 26.5-21.5 48-48 48h-88.8c-12.8 0-23.2-10.4-23.2-23.2 0-9.2 5.8-17.3 13.2-22.8 11.6-8.7 18.8-20.7 18.8-34 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34 7.4 5.5 13.2 13.6 13.2 22.8 0 12.8-10.4 23.2-23.2 23.2H176c-26.5 0-48-21.5-48-48v-88.8c0-12.8-10.4-23.2-23.2-23.2-9.2 0-17.3 5.8-22.8 13.2-8.7 11.6-20.7 18.8-34 18.8-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8 5.5 7.4 13.6 13.2 22.8 13.2 12.8 0 23.2-10.4 23.2-23.2V112c0-26.5 21.5-48 48-48z" })
  }
), Rb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 104.8c0-9.2-5.8-17.3-13.2-22.8-11.6-8.7-18.8-20.7-18.8-34 0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34-7.4 5.5-13.2 13.6-13.2 22.8 0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2 9.2 0 17.3-5.8 22.8-13.2 8.7-11.6 20.7-18.8 34-18.8 26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8-5.5-7.4-13.6-13.2-22.8-13.2-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48h-56.8c-12.8 0-23.2-10.4-23.2-23.2 0-9.2 5.8-17.3 13.2-22.8 11.6-8.7 18.8-20.7 18.8-34 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34 7.4 5.5 13.2 13.6 13.2 22.8 0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2 8.7 11.6 20.7 18.8 34 18.8 26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8-5.5 7.4-13.6 13.2-22.8 13.2C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48h120.8c12.8 0 23.2-10.4 23.2-23.2" })
  }
), $b1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0h128c35.3 0 64 28.7 64 64v128c0 8.8-7.2 16-16 16h-52c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12h-36c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16M0 256V128c0-35.3 28.7-64 64-64h128c8.8 0 16 7.2 16 16v36c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16m0 192V320c0-8.8 7.2-16 16-16h176c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H64c-35.3 0-64-28.7-64-64m240-128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v128c0 35.3-28.7 64-64 64H256c-8.8 0-16-7.2-16-16z" })
  }
), kb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256c0 88.4 71.6 160 160 160 28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1c20.4-26.8 32.5-60.3 32.5-96.6 0-88.4-71.6-160-160-160S64 167.6 64 256m280.9 188.6C310 467 268.5 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z" })
  }
), Pb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm64 16v64h64V96zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm64 16v64h64v-64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m80 64h-64v64h64zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s-7.2-16-16-16-16 7.2-16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32m64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32" })
  }
), Fb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1a87.983 87.983 0 0 0-40.4 74v1.5c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32m80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), Tb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-64z" })
  }
), Ab1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8h-64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v64zm-256 0c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v64z" })
  }
), Db1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M88 0C39.4 0 0 39.4 0 88v104c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H64v-8c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32S113.7 0 96 0zm176 0c-48.6 0-88 39.4-88 88v104c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48h-32v-8c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32S289.7 0 272 0zm312 424V320c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c48.6 0 88-39.4 88-88m-264 88c48.6 0 88-39.4 88-88V320c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), yb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v352c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3l102.5 146.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6l-84.2-120.2C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144zm112 224H64V96h112c44.2 0 80 35.8 80 80s-35.8 80-80 80" })
  }
), bb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m460.7 39.3-2.2-2.1c-4.7-4.6-11.5-6.4-17.9-4.7s-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6 24.3 20.6 42.9 47.8 53.3 78.8-8.2-1.9-16.5-2.9-25-2.9h-1.7c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6-10.8 6.2-15.6 19.5-11.2 31.1 14.9 39.5 44.3 71.4 81.4 89.7-3.7 6.6-6.4 14-7.6 21.8l-105.2-60c-30.9-17.6-65.9-26.9-101.5-26.9-32.3 0-62.2 16.8-78.9 44.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1 4.9 17.2 14.5 33.1 28.4 45.9l142.2 130.4C269 442 284.4 448 300.4 448H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1v15.7l56-32.4 6.4-3.7h101.3c33.3 0 60.3-27 60.3-60.3 0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10 8.4-49.3-7.8-100-43.9-135.5zm-318.5 382c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9l46-30.7-48.6-44.5-32.9 22zM480 240a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), fb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M321.4 128c4.8 0 9.6.3 14.3.9 1.1-24-2.6-47.9-10.9-70.1 7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8 9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4 5.5 3.1 10.7 6.6 15.6 10.6l34.8 28.1c14 11.4 22.2 28.6 22.2 46.7 0 33.3-27 60.3-60.3 60.3H352v25.8l61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6-49.3 54.7H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-28.5 0-52.6-18.6-60.9-44.2C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7v-49.3c0-10.9 2.7-21.2 7.4-30.2-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4 3.1-.5 6.3-.7 9.6-.7zm46.6 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), Ub1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 32c20.5 0 39.9 9.2 52.8 25.1l28.9 35.6-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 28.9-35.6C296.1 41.2 315.5 32 336 32m-39.3 173.3c-5.6-3.7-11.4-7-17.5-10l39.9-21.8c6.9-3.8 12.6-9.1 16.8-15.3 4.2 6.3 9.9 11.6 16.8 15.3l39.9 21.8c-6 2.9-11.9 6.2-17.5 10L360 215.4c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-15.3-10.2zm187.5-81.4-20.3-25 13.8-41.5c1.5-4.4 2.2-9.1 2.2-13.8C480 19.5 460.5 0 436.5 0h-1.3c-3.3 0-6.5.4-9.7 1.1l-44.1 9.8C367.5 3.8 352 0 336 0s-31.5 3.8-45.3 10.9l-44.1-9.8c-3.2-.7-6.5-1.1-9.7-1.1h-1.3C211.5 0 192 19.5 192 43.5c0 4.7.8 9.3 2.2 13.8L208 98.8l-20.3 25c-7.6 9.3-11.7 21-11.7 33 0 23.1 15.2 43.5 37.3 50.2l35.8 10.7c10.6 3.2 20.6 7.9 29.8 14l18.8 12.6C309.1 252 322.4 256 336 256s26.9-4 38.2-11.6l18.8-12.5c9.2-6.1 19.2-10.9 29.8-14l35.8-10.7c22.2-6.6 37.3-27 37.3-50.2 0-12-4.1-23.7-11.7-33zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32m80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0M185.1 229.3C131.2 266.9 96 329.4 96 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.4 1.7-32.5 4.8-48H0v48c0 61.9 50.1 112 112 112h208v-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80 35.8 80 80v16h128v-16.4c-.2-26.3-21.6-47.6-48-47.6h-16v-72l-6.4 4.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l38.1-28.5c12.3-9.2 19.5-23.7 19.5-39.1 0-14.9-6.8-29-18.5-38.3-6.6 2.2-12.9 5.3-18.7 9.2L392 271.1c-16.6 11-36 16.9-55.9 16.9s-39.4-5.9-55.9-16.9l-18.8-12.6c-6.6-4.4-13.7-7.7-21.3-10l-35.8-10.7c-6.8-2-13.2-4.9-19.1-8.4zM0 128h128V96c0-35.3-28.7-64-64-64S0 60.7 0 96zm0 32v64h128v-64zm0 160h77.7c8.2-23.2 19.8-44.7 34.3-64H0zm480-24-.3-.9c0 .4-.1.9-.1 1.3l.5-.4zm-162.3 80.2c-4.5 7.6-14.4 10-22 5.5l-80-48c-7.6-4.5-10-14.4-5.5-22s14.4-10 22-5.5l80 48c7.6 4.5 10 14.4 5.5 21.9z" })
  }
), Gb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3 40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64m-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-54.4 54.4-131.9 78.7-198.2 61.7-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84-3.7-14.3-5.5-29.2-5.5-44.2 0-54.2 23.4-110.5 66.9-154z" })
  }
), qb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3-53 0-96 43-96 96s43 96 96 96 96-43 96-96h64c0 73.5-49.6 135.5-117.2 154.2-8-15.5-24.1-26.2-42.8-26.2s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6 14.4-8.3 24.1-23.8 24.1-41.7 0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64c-92.9 0-170.3 65.9-188.1 153.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4 19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256h64c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25 0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z" })
  }
), Wb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 186.7c-23.9 13.8-40 39.7-40 69.3H32c-17.7 0-32.2-14.4-30-31.9C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80H336c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10 53.6 40.7 90.6 102 99.4 172.1 2.2 17.5-12.4 31.9-30 31.9zm-224-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), Eb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5zM320 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0M80 336h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16M64 224c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32" })
  }
), Ob1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160M80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16m-16 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16" })
  }
), Ib1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32S0 465.7 0 448v-96C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-141.4-114.6-256-256-256m0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-35.3-28.7-64-64-64m-160 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-88.4-71.6-160-160-160s-160 71.6-160 160" })
  }
), Nb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M102.4 133.6c-4.2 8.6-6.4 18-6.4 27.6 0 34.7 28.1 62.8 62.8 62.8h2.4c34.7 0 62.8-28.1 62.8-62.8 0-9.6-2.2-19-6.4-27.6l-46.1-94.4c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4zm-96 192c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416h2.4c34.7 0 62.8-28.1 62.8-62.8 0-9.6-2.2-19-6.4-27.6l-46.1-94.4c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6zm301.4-190.8L210 294.2c-11.8 19.2-18 41.3-18 63.8 0 67.4 54.6 122 122 122h12c67.4 0 122-54.6 122-122 0-22.5-6.2-44.6-18-63.8l-97.8-159.4c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z" })
  }
), Xb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8.5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64m-27.5 110.1c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c26.9 0 49.9-16.5 59.3-40H464c-61.9 0-112-50.1-112-112v-32.6c-18.7-2.7-35.5-14.8-43.5-33.4zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), Kb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 48C32 21.5 53.5 0 80 0h288c26.5 0 48 21.5 48 48v392.4l-64-128V64H96v248.4l-64 128zm372.4 440.8c.8 1.5 1.2 3 1.5 4.6 1.5 9.3-5.6 18.6-15.8 18.6H57.9c-10.2 0-17.4-9.2-15.8-18.6.3-1.5.7-3.1 1.5-4.6L96 384l32-64h192l32 64z" })
  }
), Qb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.8 54.1 330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0l-23.6 47.8-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32zM32 320c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32zm416 96v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32" })
  }
), Zb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v240c0 13.3-10.7 24-24 24s-24-10.7-24-24v-.4l-99.4 198.7c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9L120.2 288H112C50.1 288 0 237.9 0 176c0-44.7 26.2-83.2 64-101.2V24.6C64 11 75 0 88.6 0c4.8 0 9.6 1.4 13.6 4.1zm200 0c13.3 0 24 10.7 24 24v56h60.9l77.1-30.9c4.9-2 10.5-1.4 14.9 1.6s7 7.9 7 13.2v96c0 5.3-2.6 10.3-7 13.2s-10 3.6-14.9 1.6L476.9 208H416v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24M136 176a24 24 0 1 0-48 0 24 24 0 1 0 48 0m72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Jb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14 2.2c8.5-3.9 18.5-2.5 25.6 3.6L80 40.4l40.4-34.6c9-7.7 22.3-7.7 31.2 0L192 40.4l40.4-34.6c9-7.7 22.3-7.7 31.2 0L304 40.4l40.4-34.6c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8v464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6l-40.4 34.6c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16zM80 352c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16m16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), jb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192m0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256m0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), Yb1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm165.5 141.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-5.4-10.8h-90.4l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7 186.8 280h42.3zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48m24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v144c0 13.3-10.7 24-24 24-6.6 0-12.6-2.7-17-7-9.4 4.5-19.9 7-31 7-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1" })
  }
), _b1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm56 96c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m56 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16zm88-16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m88 24c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24zm112-24c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16" })
  }
), hf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9l60.1 54.2-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-60.2-54 60.2-54.2z" })
  }
), cf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 368c0 59.5 29.5 112.1 74.8 144H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-97.2 0-176 78.8-176 176M440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm104 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z" })
  }
), sf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 368c0 59.5 29.5 112.1 74.8 144H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-97.2 0-176 78.8-176 176M440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-40 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3M544 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), vf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 224c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM440 80H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h368c13.3 0 24-10.7 24-24s-10.7-24-24-24M392 0H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24S405.3 0 392 0" })
  }
), ef1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), lf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm40 128h56c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24m56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88v-16c0-48.6 39.4-88 88-88m-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40v-16c0-22.1-17.9-40-40-40s-40 17.9-40 40" })
  }
), tf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), wf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM96 72v368c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3-10.7-24-24-24S96 58.7 96 72M0 120v272c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24S0 106.7 0 120" })
  }
), gf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0z" })
  }
), if1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z" })
  }
), mf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm111 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), af1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z" })
  }
), of1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm384 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48zM112 304h176c26.5 0 48 21.5 48 48v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-80c0-26.5 21.5-48 48-48" })
  }
), nf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zm254.8 206.8c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32h96.2c17.6 0 31.9-14.4 31.8-32 0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4m-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17l23.4 87.3c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3-51.5 82.4c-3.1 5-4.8 10.8-4.8 16.7-.1 17.6 14.2 32 31.8 32H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H95.8C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z" })
  }
), rf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v24c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V64H32C14.3 64 0 49.7 0 32m0 448c0-17.7 14.3-32 32-32h32v-24c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v24h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m80-336h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), df1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v64h288v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V96c0-53-43-96-96-96zm288 192h-64v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H0v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64z" })
  }
), Sf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-96-360c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80 0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1.1 26.3-11.9 31.8s-26.3.1-31.8-11.9l-37.2-82H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64z" })
  }
), zf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64h160V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S320 172.9 320 159.9V128H160c-53 0-96 43-96 96 0 17.7-14.3 32-32 32m448 0c17.7 0 32 14.3 32 32 0 88.4-71.6 160-160 160H192v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h160c53 0 96-43 96-96 0-17.7 14.3-32 32-32zm-192-40v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5" })
  }
), pf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96h160v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32v32H160C71.6 64 0 135.6 0 224m512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192v-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448h160c88.4 0 160-71.6 160-160" })
  }
), Mf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6l141.7 134.6c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3.9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-64h32c53 0 96 43 96 96 0 30.4-12.8 47.9-22.2 56.7-5.5 5.1-9.8 12-9.8 19.5 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176h-48z" })
  }
), xf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V80c0-8.8-7.2-16-16-16m0 256c5.1 0 10.2-.2 15.2-.6.5 5.5.8 11 .8 16.6 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 257.7 0 249.1 0 240s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h96.7c8.1 89.7 83.5 160 175.3 160" })
  }
), Hf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M205 34.8c11.5 5.1 19 16.6 19 29.2v64h112c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z" })
  }
), Vf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 192C0 103.6 71.6 32 160 32h224c88.4 0 160 71.6 160 160v64H0zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4L397.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4L253.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4L109.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160h416v112c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80v-48h-32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288z" })
  }
), Cf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0M25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-13.3 0-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24m192 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H448v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4z" })
  }
), Lf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zM320 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24m144 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-24 432v-96h-17.8c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2c13.2-42.3 52.4-71.2 96.8-71.2s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32" })
  }
), Bf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9S19.1 192 32.1 192h32v128c0 53 43 96 96 96zm32-320c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32 14.3 32 32v128h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S556.9 320 543.9 320h-32V192c0-53-43-96-96-96z" })
  }
), uf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z" })
  }
), Rf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m333.2 322.8-133.9-146-53.3-58.2c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65v-29.5c0-19-5.6-37.5-16.1-53.3l-40.1-60.2C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 83.3 95.6 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4zm-128 87.8L121.9 315 27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z" })
  }
), $f1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m377.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H192c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9M160 96H96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32" })
  }
), kf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m313.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L313.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H128c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9M64 96v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Pf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184.4 512c-19 0-37.2-7.5-50.6-21L15 372.3C5.4 362.7 0 349.6 0 336s5.4-26.7 15-36.3L133.8 181c13.4-13.4 31.6-21 50.6-21 37 0 67.4 28 71.2 64H432c8.8 0 16 7.2 16 16v40.4c0 4.2 3.4 7.6 7.6 7.6 2 0 3.9-.8 5.4-2.2L570.7 176 461 66.2c-1.4-1.4-3.4-2.2-5.4-2.2-4.2 0-7.6 3.4-7.6 7.6V112c0 8.8-7.2 16-16 16H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.4c3.8-36 34.2-64 71.2-64 19 0 37.2 7.5 50.6 21L625 139.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L506.2 331c-13.4 13.4-31.6 21-50.6 21-37 0-67.4-28-71.2-64H208c-8.8 0-16-7.2-16-16v-40.4c0-4.2-3.4-7.6-7.6-7.6-2 0-3.9.8-5.4 2.2L69.3 336 179 445.8c1.4 1.4 3.4 2.2 5.4 2.2 4.2 0 7.6-3.4 7.6-7.6V400c0-8.8 7.2-16 16-16h112c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64.4c-3.8 36-34.2 64-71.2 64z" })
  }
), Ff1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96h320V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9S352 236.8 352 223.8V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m448 256c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v64h320z" })
  }
), Tf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32M360.5 409.4c-7 6.6-17.2 8.4-26 4.6S320 401.5 320 392v-72H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h288v-72c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4z" })
  }
), Af1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6S320 110.5 320 120v72H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h288v72c0 9.6 5.7 18.2 14.5 22" })
  }
), Df1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m217.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9M352 416h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96 43 96 96v256c0 53-43 96-96 96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), yf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m217.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9M384 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32" })
  }
), bf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9S223.9 429 223.9 416v-96H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h184V96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z" })
  }
), ff1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M122.5 13.3C126.6 5.1 134.9 0 144 0h96c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C329.9 164.4 384 235.9 384 320c0 106-86 192-192 192S0 426 0 320c0-84.1 54.1-155.6 129.4-181.6L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48zM192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256" })
  }
), Uf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3c12.7-11.6 17.1-22.5 17.1-30.3 0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208m192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248M0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8-45.8 22.9-107 36.2-172.7 36.2s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304z" })
  }
), Gf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M113.7 8.8C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 52.3-22.8 99.2-59 131.5-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5-34.9 19-58.6 56-58.6 98.5 0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9-5-26.2-14.8-50.7-28.6-72.4 89.8 8 160.2 83.4 160.2 175.3 0 97.2-78.8 176-176 176-55.3 0-104.7-25.5-137-65.5-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32zM176 160c-61.9 0-112 50.1-112 112 0 58.7 45.1 106.8 102.5 111.6-4.2-15.1-6.5-31.1-6.5-47.6 0-64.4 34.5-120.7 86.1-151.3-19.2-15.5-43.6-24.7-70.1-24.7" })
  }
), qf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32m373.2 64h-74.4l-5.4 10.7L234.8 288h74.3l5.4-10.7zm-42.4 192h74.3l5.4-10.7L533.2 96h-74.4l-5.4 10.7zm-160-192-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96zm288 192H576v160c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7z" })
  }
), Wf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0h256c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32m128 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24m24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24M32 96h256v64h-40v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-53-43-96-96-96v-96h72v-64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32m168 64h-80v64h80z" })
  }
), Ef1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32M352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), Of1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32M496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16" })
  }
), If1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32M496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288m22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z" })
  }
), Nf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32h-74.8c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2 0 30.1 24.5 54.6 54.6 54.6H288v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5l-30.4-85.9C478 49.1 453.9 32 426.8 32H352v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32m176 16c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), Xf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9l129.5 194.3c14.2 21.3-1.1 49.7-26.6 49.7H64V116.8zM32 384h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), Kf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32h-74.8c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2c-2 5.8-3.1 12-3.1 18.2C0 455.5 24.5 480 54.6 480H256v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h201.4c30.2 0 54.6-24.5 54.6-54.6 0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Qf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c70.7 0 128 57.3 128 128v32H128v-32C128 57.3 185.3 0 256 0m0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32M48 240c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v158.3c0 8.7 2.4 17.2 6.8 24.7l38.9 64.8c3 4.9 3 11.1.2 16.1s-8.2 8.1-13.9 8.1h-96c-8.8 0-16-7.2-16-16V384l-45.3 45.3c-12 12-28.3 18.7-45.3 18.7h-75c-17 0-33.3-6.7-45.3-18.7L128 384v112c0 8.8-7.2 16-16 16H16c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1L41.2 423c4.5-7.5 6.8-16 6.8-24.7zm160 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), Zf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c17.7 0 32 14.3 32 32v64h120c39.8 0 72 32.2 72 72v272c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h120V32c0-17.7 14.3-32 32-32M208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16zM264 256a40 40 0 1 0-80 0 40 40 0 1 0 80 0m152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80M48 224h16v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48m544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16V224z" })
  }
), Jf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.8 128H207C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8 13.8 74.4 9 197-122.7 276.9v89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1.2S224 496.7 224 488V373.3c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zm306.2 0a40 40 0 1 0-80 0 40 40 0 1 0 80 0M166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5m-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3-.5 8 5.9 14.3 13.9 13.9 12.8-.7 31.2-3.7 41.3-13.7z" })
  }
), jf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M156.6 384.9 125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2 3-8.9 7-20.5 11.8-33.8H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3H200c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8 13.4 72.9 9.3 194.8-111.4 276.7-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1.2S224 496.7 224 488V380.8c-14.1 4.9-26.4 8.9-35.7 11.9-11.2 3.6-23.4.5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), Yf1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 190.1c0-31.8 15.8-60 40-77V456c0 13.3 10.7 24 24 24s24-10.7 24-24V96.2c2-.1 4-.2 6.1-.2 14.8 0 29.1 3.5 41.9 9.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V154.7l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V292.9l20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-78.4c13.6 4.2 28 6.4 42.6 6.4h5.4v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-77.6c14.4-4.2 27.8-10.5 40-18.6V448c0 17.7 14.3 32 32 32s32-14.3 32-32V248h-.2c.1-2.6.2-5.3.2-8 0-79.5-64.5-144-144-144h-4c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3v-74.2l7.3-3.9c12.7-6.8 26.5-11 40.7-12.5V264c0 13.3 10.7 24 24 24s24-10.7 24-24v-97.3c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80h-13.4c-26.2 0-50.8-12.8-65.7-34.4l-129-185.7C258.4 57.4 209.9 32 158.1 32 70.8 32 0 102.8 0 190.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V190.1z" })
  }
), _f1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m74.9 192-28.8-13.8c-7.6 15.9-.9 35 15 42.7s35 .9 42.7-15v-.1l.2-.3.7-1.5c.6-1.3 1.6-3.2 2.8-5.6 2.5-4.8 5.9-11.4 10-18.5 8.7-15.3 18.2-29.8 25.3-36.9 62.5-62.5 163.8-62.5 226.3 0l17.2 17H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2l-17.6-17.6c-87.5-87.5-229.3-87.5-316.8 0-13.8 13.8-27 35.2-35.7 50.6-4.6 8.2-8.6 15.6-11.3 21-1.4 2.7-2.5 4.9-3.3 6.5l-.9 1.8-.2.5-.1.2L75 192zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64M48 464c17.7 0 32-14.3 32-32v-35.2l17.6 17.6c87.5 87.5 229.3 87.5 316.8 0 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.5 62.5-163.8 62.5-226.3 0L125.7 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32v112c0 17.7 14.3 32 32 32" })
  }
), hU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2S50.1 48.1 57 55l41.6 41.6c87.6-86.5 228.7-86.2 315.8 1 87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2S177.7 224 168 224z" })
  }
), cU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M463.5 224h8.5c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224z" })
  }
), sU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224h128c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-24.4 24.4-42 53.1-52.8 83.8-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v128c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2S177.7 288 168 288H40c-13.3 0-24 10.7-24 24" })
  }
), vU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.8 159.1 32 177 32 195.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c9 4.5 19.6 4.5 28.6 0l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6 0-18.2 4.2-36.2 12.4-52.5l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4.7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM96 192h256v3.2c0 23.1 4.4 45.9 13 67.3l14.3 35.7c3.2 7.9 4.8 16.3 4.8 24.8 0 25.3-14.3 48.4-36.9 59.7L224 444.2l-123.1-61.5C78.3 371.4 64 348.3 64 323c0-8.5 1.6-16.9 4.8-24.8L83 262.6c8.6-21.4 13-44.3 13-67.3v-3.2z" })
  }
), eU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M85.3 192h341c-.8 44.3-7.9 81.8-21.9 114.4-23.4 54.1-68.5 99.1-149 138.5-81.5-36.2-126.1-80.9-149-135.4-14-33.3-20.6-72-21-117.4zM276.9 7.3c-12.8-7.8-29-7.8-41.8 0-27.5 16.8-50.2 26-73.4 30-23.3 4-49.2 3.2-83.7-3.2C55.9 30 34.4 45 31.1 67.7 16 170.4 15.9 259.5 47.3 334.2c32.1 76.4 94.6 132.5 193 173.9 10.4 4.4 22.3 4.1 32.5-.6 95.7-44.8 157.8-100.7 190.3-175.7 32-73.9 32.9-161.2 17.8-264.1-3.3-22.6-24.8-37.7-46.9-33.6-34.4 6.3-60.3 7.2-83.7 3.2-23.2-4-45.9-13.2-73.4-30z" })
  }
), lU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96c0 50.2-59.1 125.1-84.6 155-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8 6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96 0-53 43-96 96-96s96 43 96 96M117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9-10.7 14.7-21.7 28-30.8 38.5l-.6.7zM128 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288-224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), tU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 48c58.8 0 112.5 21.8 153.4 57.9 9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9s23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48m24 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H376zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m116.5-229.3C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8s23.5 11.9 33.8 3.5z" })
  }
), wU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32 229.8 0 416 186.2 416 416 0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96 14.3 96 0 81.7 0 64m0 352a64 64 0 1 1 128 0 64 64 0 1 1-128 0m32-256c159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), gU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32c-17.7 0-32 14.3-32 32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H128v-32h112c79.5 0 144-64.5 144-144S319.5 32 240 32zm144 224H128V96h112c44.2 0 80 35.8 80 80s-35.8 80-80 80" })
  }
), iU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 64h56v384H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-40h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-40h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24m88 0h416v384H112zm528 24c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56V64h56c13.3 0 24 10.7 24 24" })
  }
), mU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 16c13.4 0 26.4 2.1 38.5 5.9-21.1 1.8-44.5 8.7-69 19.5-53.4 23.5-114.8 66.9-172.1 124.1S64.9 284.1 41.4 337.6c-10.8 24.5-17.7 47.9-19.5 69-3.8-12.2-5.9-25.2-5.9-38.6v-32C16 159.3 159.3 16 336 16zm122.1 89.5c3.8 12.2 5.9 25.1 5.9 38.5v32c0 176.7-143.3 320-320 320h-32c-13.4 0-26.4-2.1-38.5-5.9 21.1-1.8 44.5-8.7 69-19.5 53.4-23.5 114.8-66.9 172.1-124.1s100.6-118.6 124.1-172.1c10.8-24.5 17.7-47.9 19.5-69zM63.7 448.3c-6.7-6.7-10.9-17.8-10.2-34.8.7-17.1 6.3-38.5 17.1-63 21.5-49 62.3-107.1 117.5-162.3S301.5 92.3 350.4 70.7c24.5-10.8 45.9-16.4 63-17.1 17.1-.7 28.1 3.5 34.8 10.2s10.9 17.8 10.2 34.8c-.7 17.1-6.3 38.5-17.1 63-21.5 49-62.3 107.1-117.5 162.3s-113.4 95.9-162.3 117.5c-24.5 10.8-45.9 16.4-63 17.1-17.1.7-28.1-3.4-34.8-10.2z" })
  }
), aU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.2 468.9C2.7 493.1 23.1 512 48 512h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 1.7.1 3.3.2 4.9" })
  }
), oU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 336c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H48c-26.5 0-48 21.5-48 48z" })
  }
), nU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v416c0 35.3 28.7 64 64 64h416c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.5-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4c-6-6-14.2-9.4-22.7-9.4H32C14.3 0 0 14.3 0 32m128 224 128 128H128z" })
  }
), rU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h160c26.5 0 48 21.5 48 48v48h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z" })
  }
), dU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0l-92.1-92.2c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48L333.9 18C352.6-.7 383-.7 401.8 18l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9l-316 316.1z" })
  }
), SU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V288zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64zm256.5 16.4c-.9 6 0 8.7.4 9.8.4 1.1 1.4 2.6 4.2 4.9 7.2 5.7 18.7 10 37.9 16.8l1.3.5c16 5.6 38.7 13.6 55.7 28.1 9.5 8.1 17.9 18.6 23.1 32.3 5.1 13.7 6.1 28.5 3.8 44-4.2 28.1-20.5 49.3-43.8 60.9-22.1 11-48.1 12.5-73.2 8h-.2c-9.3-1.8-20.5-5.7-29.3-9-6-2.3-12.6-4.9-17.7-6.9-2.5-1-4.6-1.8-6.3-2.5-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1 4.8 1.9 9.8 3.9 15.4 6 8.8 3.3 15.3 5.4 18.7 6 15.7 2.8 26.7.8 32.9-2.3 5-2.5 8-6 9.1-13 1-6.9.2-10.5-.5-12.3-.6-1.7-1.8-3.6-4.5-5.9-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9-9.5-7.5-18.3-17.6-23.7-31-5.5-13.4-6.6-28-4.4-43.2 8.4-57.1 67-78 116.9-68.9 6.9 1.3 27.3 5.8 35.4 8.4 16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5-14.6-2.7-25.8-.4-32.6 3.2-6.3 3.3-8.9 7.6-9.5 12z" })
  }
), zU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V288zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112h-48v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32m80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48h-48v96z" })
  }
), pU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16h128c53 0 96 43 96 96 0 17.7-14.3 32-32 32H384v256H254.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H96l-77.3-77.3C6.7 326.7 0 310.5 0 293.5V96c0-35.3 28.7-64 64-64h160zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm96 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-80-48V192h100.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V384c0 17.7-14.3 32-32 32h-33.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80zm162.1-128-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48z" })
  }
), MU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4 2.8 6.3 7.9 12.4 16.7 18.6 19.2 13.4 48.3 22.1 84.9 32.5 1 .3 1.9.6 2.9.8 32.7 9.3 72 20.6 100.9 40.7 15.7 10.9 29.9 25.5 38.6 45.1 8.8 19.8 10.8 42 6.6 66.3-7.3 42.5-35.3 71.7-71.8 87.3-35.4 15.2-79.1 17.9-123.7 10.9h-.2c-24-3.9-62.7-17.1-87.6-25.6-4.8-1.7-9.2-3.1-12.8-4.3-16.6-5.7-25.6-23.8-20.1-40.6s23.7-25.8 40.5-20.3C47 387.2 52.3 389 58 391c25.4 8.6 56.4 19.2 74.4 22.1 36.8 5.7 67.5 2.5 88.5-6.5 20.1-8.6 30.8-21.8 33.9-39.4 2.4-14.1.7-23.2-2-29.4-2.8-6.3-7.9-12.4-16.7-18.6-19.2-13.4-48.3-22.1-84.9-32.5-1-.3-1.9-.6-2.9-.8-32.7-9.3-72-20.6-100.9-40.7-15.7-10.9-29.9-25.5-38.6-45.1-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5-31.6-5.4c7.3-42.5 35.3-71.7 71.8-87.3 35.4-15.2 79.1-17.9 123.7-10.9 13 2 52.4 9.6 66.6 13.4 17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z" })
  }
), xU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96H192l-47.4-71.1c-7.1-10.7.5-24.9 13.3-24.9h196.2c12.8 0 20.4 14.2 13.3 24.9zm-128 32h128c3.8 2.5 8.1 5.3 13 8.4 56.7 36.3 179 114.5 179 279.6 0 53-43 96-96 96H96c-53 0-96-43-96-96 0-165.1 122.3-243.3 179-279.6 4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z" })
  }
), HU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96h128l47.4-71.1c7.1-10.7-.5-24.9-13.3-24.9H157.9c-12.8 0-20.4 14.2-13.3 24.9zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-165.1-122.3-243.3-179-279.6-4.8-3.1-9.2-5.9-13-8.4zm-30.1 208 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), VU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96h128l47.4-71.1c7.1-10.7-.5-24.9-13.3-24.9H157.9c-12.8 0-20.4 14.2-13.3 24.9zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-165.1-122.3-243.3-179-279.6-4.8-3.1-9.2-5.9-13-8.4z" })
  }
), CU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 16c0-7 4.5-13.2 11.2-15.3s13.9.4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6S502 352 496 352H272c-8.8 0-16-7.2-16-16zm-43.9 80.5c7 1.9 11.9 8.2 11.9 15.5v224c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384h533.8c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133c-57.4 0-107.7-38.1-123.3-93.3l-4-14.3z" })
  }
), LU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 96c2.6 0 5.2.1 7.8.2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4-53 0-96 43-96 96s43 96 96 96h73.4l-84.7-84.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16v144h52c-2.6-10.2-4-21-4-32 0-70.7 57.3-128 128-128M27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28h231.5c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4H27.4M512 224c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32h181c3.5-10 5.5-20.8 5.5-32" })
  }
), BU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.4 448H64.6l36.6-256h181.6l36.6 256zM59.8 512h264.4c33 0 59.8-26.8 59.8-59.8 0-2.8-.2-5.7-.6-8.5l-45.3-317C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L.6 443.8c-.4 2.8-.6 5.6-.6 8.5 0 33 26.8 59.8 59.8 59.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-64 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0m112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), uU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm303.9 286.6c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h180.8c7.4 0 14.6 2 20.9 5.7l70.2 40.9zM32 304c-17.7 0-32-14.3-32-32s14.3-32 32-32c7.2 0 15.8-3.7 35.4-13 16.6-7.8 40.6-19 68.6-19 30.6 0 53 10.2 70.1 18l1.9.9c17.2 7.8 29.7 13.1 48.1 13.1s30.9-5.3 48.1-13.1l1.9-.9c17-7.8 39.4-18 70.1-18 28 0 52.1 11.3 68.6 19 19.6 9.2 28.2 13 35.4 13 17.7 0 32 14.3 32 32s-14.3 32-32 32c-22.7 0-44.3-10.3-58.8-17.2-1.3-.6-2.6-1.2-3.8-1.8-17.4-8.2-29.4-13-41.4-13-16.2 0-27.5 5-45.4 13.1h-.1c-18 8.2-41.4 18.9-74.5 18.9s-56.6-10.7-74.5-18.9h-.1C163.5 277 152.2 272 136 272c-12 0-23.9 4.7-41.4 13-1.2.6-2.5 1.2-3.8 1.8C76.3 293.7 54.7 304 32 304" })
  }
), RU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c0-17.7 14.3-32 32-32 159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32M60.6 220.6l104.1 104.1 28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4 104.1 104.1c14.5 14.5 11.8 38.8-7.3 46.3-23.6 9.2-49.2 14.3-76.1 14.3C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1 7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), $U1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5c-24.7-11.4-52.1-17.8-81-17.8-31.7 0-61.5 7.7-87.8 21.2-9 4.7-10.3 16.7-3.1 23.8l107.6 107.7-16.4 16.4c-2.6-.7-5.4-1.1-8.3-1.1-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4 107.6 107.6c7.2 7.2 19.2 5.9 23.8-3.1 13.6-26.3 21.3-56.1 21.3-87.8 0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55zm159 351-72.4-72.4 62.1-62.1 72.4 72.5-62.1 62.1zM226.3 192.4 153.9 120 216 57.9l72.4 72.4-62.1 62.1z" })
  }
), kU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 160c0-42 26.9-77.7 64.5-90.7l-15.3-41.9c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0h55.2C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7l-15.3 41.9C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352-42 0-77.7-26.9-90.7-64.5l-41.9 15.3c-2.2.8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6v-55.2C0 377.1 9.1 368 20.4 368c2.4 0 4.7.4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160m80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240" })
  }
), PU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M102.6 0c-2.5 0-5 .9-7 2.6-23.3 20.8-43 44.4-57 67.1C24.9 92 16 116 16 134.5c0 14.6 2.8 28.6 7.9 41.5h55.6c-4.8-8-7.5-17.8-7.5-29 0-16.8 10.5-31.5 31.5-57.4 2.8 3.5 43.4 55.3 43.4 55.3l25.2-29.4c2.1 2.8 3.5 5.6 4.9 8.4 9.1 16.7 8.7 36.7-.2 52.1H232c5.1-12.9 8-26.9 8-41.5 0-14.1-6.7-35.7-16.9-55.3-10.3-19.9-25-40.9-42.3-56.8-3.9-3.6-10.1-3.6-14 0-6.7 6.1-13 13.7-18.5 20.7-12.1-14.5-25-28-38.8-40.4-2-1.8-4.4-2.7-6.9-2.7m68.8 338.1 47.5-82.1H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h-7.1L4.4 309.4c-2.9 12.4-4.4 25-4.4 37.7v3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4l245.8-310.5c6.1-7.7 15.3-12.1 25.1-12.1h64.2c9 0 16.3-7.3 16.3-16.3 0-4.9-2.2-9.5-5.9-12.6l-24.3-20.3c-11.5-9.6-26-14.8-41-14.8h-30.3c-17 0-33.3 6.7-45.3 18.7L449 127l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L401 175l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L353 223l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8-112.5 112.5c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6v-2.6c0-4.4 1.2-8.8 3.4-12.6zM144 280a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-56 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), FU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m246.7 176-75.3 130.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6 6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6 0 9-7.3 16.3-16.3 16.3h-64.2c-9.8 0-19 4.5-25.1 12.1L288.6 418.6c-30.7 38.8-77.4 61.4-126.8 61.4C72.4 480 0 407.6 0 318.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h240c13.3 0 24 10.7 24 24s-10.7 24-24 24zM120 320a24 24 0 1 0-48 0 24 24 0 1 0 48 0m8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), TU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288h144.8L512 195.8zm72.4 96c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L631.3 305c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416M126.8 195.8 54.4 320h144.9zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L246.2 305c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1" })
  }
), AU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80 0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2l-135.4-45.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288 128 163.8 55.6 288zM128 384c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L247.3 273c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384m382.8-92.2L438.4 416h144.9zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L630.1 401c5.7 9.8 9.3 21.1 6.7 32.1z" })
  }
), DU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80 0 3 .2 5.9.5 8.8l-122.6 40.8c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288 512 163.8 584.4 288zm72.4 96c62.9 0 115.2-34 126-78.9 2.6-11-1-22.3-6.7-32.1l-95.2-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8l-95.2 163.3c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384m-382.8-92.2L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1l-95.3-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z" })
  }
), yU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3h132.6c14.1 0 27.6-6.2 36.7-17l125.1-148.4c11.4-13.5 17.6-30.5 17.6-48.1v-4c0-39-31.6-70.6-70.6-70.6M164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4S9.5 512 16 512c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336v-16H169.4l-4.7 4.7zM304 480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16m64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), bU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320H288v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7z" })
  }
), fU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256H304c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm328 0c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-24 184v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24m24 200c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24zm-24-272c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16m16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-16 80c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16" })
  }
), UU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M79.1 35.8c-15.6-8.3-35-2.4-43.3 13.2S33.4 84 49 92.3L416 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-76.8c0-23.6-13-45.3-33.9-56.5L79.1 35.8zM64 384a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), GU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24m160 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24m-88 16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h-32zM400 0c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16m48 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zM0 160c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 24v16c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24m0 120v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm112-80v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z" })
  }
), qU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M152 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24M0 160c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 16v256c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16M288 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v40h-64zM240 0c8.8 0 16 7.2 16 16v48h-32V16c0-8.8 7.2-16 16-16m144 16c0-8.8 7.2-16 16-16s16 7.2 16 16v256c0 8.8-7.2 16-16 16s-16-7.2-16-16zm88-16h16c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24" })
  }
), WU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 96c0 11.2-1.9 22-5.5 32H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-73c-10.1 0-17.7 9.2-15.7 19.1l24.3 121.7c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3.9L287.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-4.9 2.8-11 2.8-15.9 0L175.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1l24.3-121.7c2-9.9-5.6-19.1-15.7-19.1H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l7.6-11.4-19.9-15c-4-3-6.4-7.8-6.4-12.8s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4S26.1 128 32 128h101.5c-3.5-10-5.5-20.8-5.5-32 0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-64 368v-52.2l12.2 6.9c12.3 7 27.4 7 39.7 0l12.2-6.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), EU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 168.8c0 22.8-7 44.9-19.9 63.4L278.6 114.7l15.1-15.1C283.1 97.5 270.3 96 256 96s-27.1 1.5-37.8 3.6l37.8 37.8L374.6 256l9.4 9.4 11.3 11.3 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L384 310.6 358.6 336l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6 310.6 384l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0h69.1c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2zM4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48 112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48 112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6" })
  }
), OU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16m320 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7z" })
  }
), IU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16m176 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), NU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16m176 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288m22.6-144 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" })
  }
), XU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0h112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-79.3l89.6 64H512c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h101.7L256 95.5V32c0-17.7 14.3-32 32-32m48 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0M80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16M80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z" })
  }
), KU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0l136 90.6H592c26.5 0 48 21.5 48 48v128c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4h-64c-35.3 0-64 28.7-64 64v96h64H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h118.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16m0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16m240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176m16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16m192 96c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32m-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z" })
  }
), QU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16m400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM232 176a88 88 0 1 1 176 0 88 88 0 1 1-176 0m88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16" })
  }
), ZU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m256 192-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6-28.3-28.3-74.1-28.3-102.4 0zm22.6 150.6 118.2 118.2c28.3 28.3 74.1 28.3 102.4 0 7.1-7.1 7.1-18.5 0-25.6L342.6 278.6zM64 112a48 48 0 1 1 96 0 48 48 0 1 1-96 0m48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), JU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C60.7 0 32 28.7 32 64v184.4C49 233.2 71.4 224 96 224V64h448v160c24.6 0 47 9.2 64 24.4V64c0-35.3-28.7-64-64-64zm64 320a64 64 0 1 0-128 0 64 64 0 1 0 128 0M0 480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64m384-160a64 64 0 1 0-128 0 64 64 0 1 0 128 0M224 480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64m320-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-32 32c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64z" })
  }
), jU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96H64v99c-13-2-26.4-3-40-3H0V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H288v-24c0-13.6-1-27-3-40h227zM24 224c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24m8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64M0 344c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24" })
  }
), YU1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M78.6 5c-9.5-7.4-23-6.5-31.6 2L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4H158l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3L192 158v-54c0-7.5-3.5-14.5-9.4-19zM19.9 396.1C7.2 408.8 0 426.1 0 444.1 0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l117.8-117.8c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16v-57.5c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0c-79.5 0-144 64.5-144 144v.8l85.3 85.3c36-9.1 75.8.5 104 28.7l15.7 15.7c49-23 83-72.8 83-130.5M56 432a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), _U1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19V158l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8l85.6-85.5H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z" })
  }
), hG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M170 23.3C186.5 8.3 208 0 230.3 0h1.1C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4 0 13.5 11 24.5 24.6 24.5 6.5 0 12.8-2.6 17.4-7.2l222.8-222.9c16.6-16.6 39.1-25.9 62.6-25.9 48.9 0 88.6 39.7 88.6 88.6 0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4 0 26 21.1 47.1 47 47.1 6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9l-16.8 8.5c-14.5 7.2-30.4 11-46.6 11-61.4 0-111-49.9-111-111.1 0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4 0-13.6-11-24.6-24.6-24.6-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9-48.9 0-88.6-39.7-88.6-88.6 0-23.5 9.3-46 25.9-62.6l190.9-190.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64h-1.1c-6.4 0-12.6 2.4-17.3 6.7l-159.5 145c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z" })
  }
), cG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32c26.5 0 48 21.5 48 48v80H32c-17.7 0-32-14.3-32-32V80c0-26.5 21.5-48 48-48m80 48c0-18-6-34.6-16-48h272c51.4 0 93.4 40.5 95.9 91.3-.4 3.5-2 6.9-4.6 9.4l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3v18.7c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V320H314.7c-32.4 0-58.7 26.3-58.7 58.7v5.3c0 35.3-28.7 64-64 64s-64-28.7-64-64V262.6c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3V80zm448 288c0 61.9-50.1 112-112 112H192c53 0 96-43 96-96v-5.3c0-14.7 11.9-26.7 26.7-26.7h30.7c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7H560c8.8 0 16 7.2 16 16" })
  }
), sG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32M512 32H128v448h384zm80-32c-26.5 0-48 14.3-48 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32M196 313.7c0-3.2.9-6.4 2.5-9.2l28.2-48.5-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2 0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3 0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2 0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9C334 392.2 327.3 396 320 396s-13.9-3.8-17.6-10.1L271 332h-56.7c-10.1 0-18.3-8.2-18.3-18.3m124 54.7 21.2-36.4h-42.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52h-70.4zm144.9 23.8L383 308h32.8l-16.4-28.2zm16.4-75.8H383l16.4 28.2zM320 143.6 298.8 180h42.4zM224.2 204l16.4 28.2L257 204zM257 308l-16.4-28.2-16.4 28.2z" })
  }
), vG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80v48c0 17.7 14.3 32 32 32h64V80c0-26.5-21.5-48-48-48S0 53.5 0 80m112-48c10 13.4 16 30 16 48v304c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96zm352 448c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7v5.3c0 53-43 96-96 96h176z" })
  }
), eG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), lG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M614.7.7c5.6 1.2 10.5 3.8 14.5 7.3 8.4 7.4 12.6 19 10.1 30.7l-4.8 22.6-56.9 265.4-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l26-121.3H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h104.4L569 61.3l7.7-36L582.1 0H608c2.2 0 4.5.2 6.7.7M352 0h197.4l-4 18.6L508.3 192H12.7c-7 0-12.7-5.7-12.7-12.7 0-2.1.5-4.1 1.6-6C15 151.1 114.8 0 352 0" })
  }
), tG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64M160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24m80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24m80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), wG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 0H237.3c-17 0-33.3 6.7-45.3 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3V352c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64M280 64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24m80 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), gG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48h-64.9L290 493.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48v-64.9l-45.6-45.6c-18.7-18.7-18.7-49.1 0-67.9L64 176v-64c0-26.5 21.5-48 48-48h64zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), iG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48h-64.9L290 493.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48v-64.9l-45.6-45.6c-18.7-18.7-18.7-49.1 0-67.9L64 176v-64c0-26.5 21.5-48 48-48h64zm-52.3 147.4-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 229.6c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), mG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M289.9 18.4C271.2-.3 240.8-.3 222 18.4L176.5 64H112c-26.5 0-48 21.5-48 48v64.5l-45.6 45.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.5V400c0 26.5 21.5 48 48 48h64.5l45.6 45.6c18.7 18.7 49.1 18.7 67.9 0l45.5-45.6H400c26.5 0 48-21.5 48-48v-64.5l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5V112c0-26.5-21.5-48-48-48h-64.5z" })
  }
), aG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v111.6c0 15.2 3.1 30.2 9.1 44.1L82 357.8c15.1 35.3 49.8 58.2 88.2 58.2H216v48h-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-48h96c15.1 0 29.3-7.1 38.4-19.2l43.2-57.6c7.3-9.7 8.4-22.7 3-33.5S428.1 288 416 288H121.7L108 256h212c17.7 0 32-14.3 32-32s-14.3-32-32-32H80.5l-12.6-29.5c-2.6-6-3.9-12.4-3.9-18.9z" })
  }
), oG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64.9 96c2.2-11.6 8.8-19.8 21.1-25.4 13.8-6.2 34.8-8.9 61.2-4.5 8.8 1.4 36.1 7.1 44.1 9.3 17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8-34.7-5.6-69.4-3.5-98 9.4C29.9 25.8 7.5 50.9 1.6 86.5c-.1.5-.2 1.1-.2 1.6-2.2 19.7.3 37.9 8.1 54.1 7.7 16.1 19.4 28 32 36.9.6.5 1.3.9 2 1.4-21.2 13.7-37 34.6-41.8 62.5-.1.6-.2 1.1-.2 1.7-2.3 19.3.4 37.1 8.4 53 7.9 15.6 19.8 27 32.3 35.5 22.4 15.2 51.9 24 75.4 31l3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8 5.5 4 8.2 7.6 9.5 10.9 1.3 3.2 2.6 8.6.9 18.1-1.7 10.1-7.7 18-20.7 23.5-14 6-35.4 8.5-62 4.4-12.8-2.1-35.1-9.7-54.1-16.2-4.3-1.5-8.5-2.9-12.3-4.2-16.7-5.6-34.8 3.5-40.4 20.2s3.5 34.9 20.3 40.5c2.6.8 5.7 1.9 9.2 3.1 18.6 6.3 48.5 16.6 67.3 19.6h.2c34.5 5.4 68.8 3.4 97.2-8.7 29.4-12.6 52.5-36.5 58.5-71.5 3.3-19.3 1.9-37.4-5-53.9-6.3-15-16.4-26.4-27.6-35.2 16.5-13.9 28.5-33.2 32.6-58.2 3.2-19.8 1.9-38.3-4.8-55.1-6.7-16.8-17.8-29.4-30.2-39-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25-6.1-4.4-9.5-8.5-11.4-12.4-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8-6.2-4.2-9.3-7.9-11-11.3-1.5-3-2.9-7.7-2.1-15.7 1.9-9.7 7.9-17.3 20.5-22.7 14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5 5.5 4.2 8.4 8.2 10 12.2 1.6 4 2.8 10.4 1.1 20.9-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z" })
  }
), nG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 32c0 113.6-84.6 207.5-194.2 222-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32M0 96c0-17.7 14.3-32 32-32h32c123.7 0 224 100.3 224 224v192c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96" })
  }
), rG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128m54.8 319L83.7 492.8C76.4 504.7 63.5 512 49.5 512 24 512 5 488.5 10.4 463.6L37.5 337c6.1-28.6 31.4-49 60.6-49 34.2 0 61.9 28.1 61.9 62.3 0 11.5-3.2 22.9-9.2 32.7" })
  }
), dG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64v128H64V64zM64 0C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm512 320v128H448V320zm-128-64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64zm-288 32v64c0 35.3 28.7 64 64 64h128v-96c0-53 43-96 96-96h32v-64c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96z" })
  }
), SG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96h128V64c0-35.3-28.7-64-64-64zm160 224h224v224H224zm-64 0v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64" })
  }
), zG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h170.8c-6.9-14.5-10.8-30.8-10.8-48 0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m128 392h224c44.2 0 80-35.8 80-80 0-39-27.9-71.5-64.8-78.6.5-3.1.8-6.2.8-9.4 0-30.9-25.1-56-56-56-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2-37.5 6.7-65.9 39.4-65.9 78.8 0 44.2 35.8 80 80 80" })
  }
), pG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h273.6c-31-34.7-49.6-80.6-49.6-129.9 0-35.2 16.3-73.6 37.2-107.4 21.7-35.2 51.9-71.2 87.3-102.8 10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m245.5 43.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96" })
  }
), MG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm88 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24m96 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24m413.3 12-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM536 232h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m13.3 140 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7" })
  }
), xG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h161c-.6-4-1-8.1-1-12.3 0-13.2 3.4-26.2 9.9-37.7l150.4-265c13-22.9 37.3-37.1 63.7-37.1V96c0-35.3-28.7-64-64-64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m53.8 325.8c-3.8 6.7-5.8 14.2-5.8 21.9 0 24.5 19.8 44.3 44.3 44.3h295.4c24.5 0 44.3-19.8 44.3-44.3 0-7.7-2-15.2-5.8-21.9l-150.4-265c-7.3-12.8-21-20.8-35.8-20.8s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16v-88c0-8.8 7.2-16 16-16s16 7.2 16 16m-16 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), HG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), VG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m48 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), CG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2h192c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312v144c0 22.1 17.9 40 40 40h144c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40M128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256" })
  }
), LG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M366.6 39.5c9.1-9.6 24.3-10 33.9-.9l141.7 134.6c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8.9-33.9L509.2 208 367.5 73.4c-9.6-9.1-10-24.3-.9-33.9zM224 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2v-64h-32c-53 0-96 43-96 96 0 30.4 12.8 47.9 22.2 56.7 5.5 5.1 9.8 12 9.8 19.5 0 10.9-8.8 19.7-19.7 19.7-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48z" })
  }
), BG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 224h-46.5c-45 0-81.5 36.5-81.5 81.5 0 22.3 10.3 34.3 19.2 40.5 6.8 4.7 12.8 12 12.8 20.3 0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9l138.2 124.4c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32zM80 96c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112c0-44.2 35.8-80 80-80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32z" })
  }
), uG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 224c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9.7-7.8.7-11.9s-.2-8-.7-11.9l94.1-47c17.2 16.7 40.7 26.9 66.6 26.9" })
  }
), RG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4z" })
  }
), $G1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4l-47.9 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-160 31.4c-18.7-2.7-35.5-14.8-43.5-33.4-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c35.3 0 64-28.7 64-64 0-2.7-.2-5.4-.5-8H464c-61.9 0-112-50.1-112-112z" })
  }
), kG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 448c0 35.3 28.7 64 64 64h160V384c0-17.7 14.3-32 32-32h128V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6m96 32-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6M384 384H256v128z" })
  }
), PG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V96h128c35.3 0 64 28.7 64 64v160c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128zm288 448c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v288c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32z" })
  }
), FG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32h512c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64zm0 192h512v192H64z" })
  }
), TG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0c17.7 0 32 14.3 32 32v128h512V32c0-17.7 14.3-32 32-32s32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0m32 416h512V224H64zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32" })
  }
), AG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32m96-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), DG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209 241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), yG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 66.8l32 13.6V128c0 17.7 14.3 32 32 32h111.3c-1.2 19.6-4.2 41.4-9.4 64H320c-17.7 0-32 14.3-32 32v170.8c-10 6.5-20.7 12.5-32 18-11.3-5.5-22-11.5-32-18V256c0-17.7-14.3-32-32-32H90.1c-5.2-22.6-8.1-44.4-9.4-64H192c17.7 0 32-14.3 32-32V80.3l32-13.6z" })
  }
), bG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8 35.3 0 64-28.7 64-64v-64h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80h-48v50.7c0 7.3-5.9 13.3-13.3 13.3-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4 0-2.8.6-5.5 1.9-8zM160 160h48v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-8.8 7.2-16 16-16m128 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), fG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), UG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0m0 66.8v378C394 378 431.1 230.1 432 141.4z" })
  }
), GG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z" })
  }
), qG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24v-69.4c-18.9-9-32-28.3-32-50.6 0-30.9 25.1-56 56-56s56 25.1 56 56z" })
  }
), WG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), EG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), OG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4l176-74.6V224H90.1c-6.9-30-9.8-58.5-10.1-82.6m176 303.4V224h166c-18.5 80.5-65.5 172.2-166 220.8z" })
  }
), IG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.3 58.7-14.7 146.2-62.1 225l132.9 104.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0M80.6 159.5l356.9 281.2c-25.2 24-55.3 45.4-91.1 62.5-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5" })
  }
), NG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16 0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16m-24 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48m72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), XG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), KG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0" })
  }
), QG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v128l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-16.2 0-34.7-5.7-50.9-15.1L40 308.7c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48zm-32 186.7 107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160zm146.5 203.2c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), ZG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M157 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-2.7.7-5.3 2-7.7l46-83.7v315c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V133.1l46 83.7c1.3 2.4 2 5 2 7.7V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3h-48c-8.8 0-15.9 7.2-17.3 15.9C407.1 61.4 367.6 96 320 96s-87.1-34.6-94.7-80.1C223.9 7.2 216.8 0 208 0h-48c-1 0-2 .1-3 .3" })
  }
), JG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 0c17.7 0 32 14.3 32 32v48c0 44.2 35.8 80 80 80s80-35.8 80-80V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 33.3 2.6 61.5 6.5 85.2L0 393.8V282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64V32C48 14.3 62.3 0 80 0M3.8 469.8 360.4 215c3 7.5 6 13.8 8.9 19 8 15 14.7 31.5 14.7 48.4V448c0 35.3-28.7 64-64 64H64c-27.7 0-51.3-17.6-60.2-42.2" })
  }
), jG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 32c0-17.7-14.3-32-32-32S48 14.3 48 32v32c0 91-19.2 143.6-33.3 170.1-8 15-14.7 31.4-14.7 48.4V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V282.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80z" })
  }
), YG1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3l126.2 105.1c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z" })
  }
), _G1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0-8.5 8.5-11.3 20.7-8.1 31.7 3.2 10.9 5.6 24.2 4.5 38-1.1 14-5.9 30.3-19.1 43.4L346.2 211 301 165.8l24.4-24.4c.2-.3.5-1.3.6-3.2.3-3.8-.3-9.1-2.1-15.2-9.5-32.5-1.5-69.2 24.3-94.9 37.5-37.5 98.3-37.5 135.8 0 31.4 31.4 36.5 79.2 15.3 115.9-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c7.1-12.2 5.3-28.2-5.1-38.6zM61.8 405l45.2 45.2-52.4 52.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm263.5-263.5a.1.1 0 1 0-.1-.2.1.1 0 1 0 .1.2M233 143l136 136c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L151 225c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM87 255c9.4-9.4 24.6-9.4 33.9 0L257 391c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L39 337c-9.4-9.4-9.4-24.6 0-33.9l48-48z" })
  }
), hq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 0c-63.7 0-160 32-160 32v128c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0M128 96c0 35.3 28.7 64 64 64h32V32h-32c-35.3 0-64 28.7-64 64m160 416c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32v128s96.3 32 160 32M0 416c0 35.3 28.7 64 64 64h32V352H64c-35.3 0-64 28.7-64 64" })
  }
), cq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M36.8 192h412.8c20.2-19.8 47.9-32 78.4-32 30.5 0 58.1 12.2 78.3 31.9 18.9-1.6 33.7-17.4 33.7-36.7 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192M384 224h-64v160H128V224H64v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V352zm144 16c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), sq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224h-64v152L384 275.7V224h-64v1.5L277.2 192h326c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4l-7.7 11.4L38.8 5.1zm-2 186.9h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192M320 384H128V224H64v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-65.5l-64-50.4z" })
  }
), vq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M36.8 192h566.4c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192M64 224v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V224h-64v160H128V224zm448 0v256c0 17.7 14.3 32 32 32s32-14.3 32-32V224z" })
  }
), eq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4a80.607 80.607 0 0 1-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5 47 47c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168c-6.6-6.3-10-15.4-9.3-24.7s5.3-17.8 12.7-23.3l160-120c12.7-9.6 30.6-8.3 41.8 3l47 47 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4 0-21.4 8.5-41.9 23.6-57zm17 50.9-14.5 14.5c-6.1 6.1-9.5 14.4-9.5 23 0 18 14.6 32.6 32.6 32.6 8.6 0 16.9-3.4 23-9.5l14.5-14.5zM203.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z" })
  }
), lq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32v-93.9c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97c-6.7-13.3-10.4-28.4-10.4-44.3 0-26.5 10.5-51.9 29.3-70.6l44.1-44.1zM384 77.3l-21.5 21.4c-6.7 6.7-10.5 15.9-10.5 25.4 0 19.8 16.1 35.9 35.9 35.9 9.5 0 18.6-3.8 25.4-10.5l21.4-21.5z" })
  }
), tq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c17.7 0 32 14.3 32 32v3.2C297 50 352 114.6 352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32c0-77.4 55-142 128-156.8V32c0-17.7 14.3-32 32-32m52.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4zm-82.2-85.6 18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zm146.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1L53 295.3z" })
  }
), wq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9l-16.3-16.2C151.8 42.5 126.4 32 99.9 32 44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64m64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), gq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-35.3 28.7-64 64-64h226.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-96c0-35.3 28.7-64 64-64zm320 29.3L354.7 64H128v128h256zM432 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48M40 416h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24z" })
  }
), iq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h400c8.8 0 16-7.2 16-16s-7.2-16-16-16zm160 424c0 13.3 10.7 24 24 24h72v-72.2l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456m128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111 0-12.3-1.3-24.3-3.7-35.9l-125.5 87c.8 3.4 1.2 7 1.2 10.6 0 4.6-.7 9-1.9 13.1zM336 128h-16v192h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128m-168 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), mq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.8 384 191.8V160h-32c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6M164 282.7l40 53.3-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c10.1 0 19.6-4.7 25.6-12.8zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9S383.9 461 383.9 448v-32H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c30.2 0 58.7 14.2 76.8 38.4l153.6 204.8c6 8.1 15.5 12.8 25.6 12.8h32v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z" })
  }
), aq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32zM20.6 224h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 128H24L1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5C0 214.8 9.2 224 20.6 224m470.8 128c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 256H24L1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5C0 342.8 9.2 352 20.6 352zM20.6 480h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 384H24L1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5C0 470.8 9.2 480 20.6 480z" })
  }
), oq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M130 480c40.6 0 80.4-11 115.2-31.9L352 384H128v96zm222-352L245.2 63.9C210.4 43 170.6 32 130 32h-2v96zm-256 0V32H80c-26.5 0-48 21.5-48 48v48h8c-22.1 0-40 17.9-40 40v176c0 22.1 17.9 40 40 40h-8v48c0 26.5 21.5 48 48 48h16v-96h8c26.2 0 49.4-12.6 64-32h288c69.3 0 135-22.7 179.2-81.6 6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32zm416 115.6v24.9c0 19.6-15.9 35.6-35.6 35.6-2.5 0-4.4-2-4.4-4.4v-87.3c0-2.5 2-4.4 4.4-4.4 19.6 0 35.6 15.9 35.6 35.6" })
  }
), nq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c0 8.8-7.2 16-16 16-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9 46.2-146.3c3.2-10 12.4-16.8 22.9-16.8h104c13.3 0 24 10.7 24 24v104c0 10.5-6.8 19.7-16.8 22.9l-146.4 46.2L197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4 0-8.8 7.2-16 16-16h8c13.3 0 24 10.7 24 24v51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7l-28.8 28.8-144-144 28.8-28.8a65.2 65.2 0 0 0 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0H296c13.3 0 24 10.7 24 24zM36.7 331.3l144 144-6.9 6.9a101.8 101.8 0 0 1-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72z" })
  }
), rq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M212.7 340.7 181 309c-33.9-33.9-53-80-53-128C128 81 209 0 309 0h11c90.1 0 165.8 62.1 186.4 145.8 1.8 7.3-4 14.2-11.5 14.2-3.9 0-7.5-1.9-9.9-4.9-26.1-32.2-65.5-51.1-107.2-51.1-76.1 0-137.8 61.7-137.8 137.8v9.8c0 20.7 5.2 39.7 12.2 58.6 2.2 6 .9 12.8-3.7 17.3l-13.2 13.2c-6.2 6.2-16.4 6.2-22.6 0zM121 311l24 24 32 32 24 24c9.4 9.4 9.4 24.6 0 33.9l-16 16c-9.4 9.4-24.6 9.4-33.9 0l-7-7L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l71-71-7-7c-9.4-9.4-9.4-24.6 0-33.9l16-16c9.4-9.4 24.6-9.4 33.9 0z" })
  }
), dq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zm-224 0v320H64V96zm136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm24 120c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24m-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z" })
  }
), Sq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 0v320h224V96zM88 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24zM64 216c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24m24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), zq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M2.4 51.8C7.4 39.8 19.1 32 32 32h288c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H109.3l137.3 137.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416H320v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 35.3-28.7 64-64 64H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6c-9.2-9.1-11.9-22.9-7-34.8z" })
  }
), pq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0c17.7 0 32 14.3 32 32v32h352c17.7 0 32 14.3 32 32s-14.3 32-32 32H128v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V32C64 14.3 78.3 0 96 0m96 160h256c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32" })
  }
), Mq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 256c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48M80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48" })
  }
), xq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48M192 304v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48M32 432v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), Hq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V48c0-26.5-21.5-48-48-48s-48 21.5-48 48v328l-64-50.2V176c0-26.5-21.5-48-48-48s-48 21.5-48 48v74.6L38.8 5.1zM288 322.9l-74.7-58.8c-12.8 8.6-21.3 23.3-21.3 39.9v160c0 26.5 21.5 48 48 48s48-21.5 48-48zM448 464v-15l-96-75.6V464c0 26.5 21.5 48 48 48s48-21.5 48-48M80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48" })
  }
), Vq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48z" })
  }
), Cq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M560 0c-26.5 0-48 21.5-48 48v416c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48M352 176v288c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48m-112 80c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48M80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48" })
  }
), Lq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), Bq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 192c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32m-128 96c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32M96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), uq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v369.1l-64-50.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v172.8l-64-50.2V224c0-17.7-14.3-32-32-32-10.7 0-20.1 5.2-25.9 13.2L38.8 5.1zM576 512h-.3.6-.3zm-96-32v-5.8l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32M352 373.3l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM192 288c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32M96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), Rq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140 0 36.4-8.7 70.8-24.1 101.1l-38.7-30.4c9.5-21.7 14.8-45.6 14.8-70.8 0-45.1-17-86.2-44.8-117.3-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7 0 10.1-1.3 19.9-3.8 29.2l-53.6-42c-5.8-24.7-28-43.2-54.5-43.2h-.5L38.8 5.1zm84.7 188.2c-7.4 19.5-11.5 40.6-11.5 62.7 0 45.1 17 86.2 44.8 117.3 11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7 0-6.8.6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 68.1 23.7 130.7 63.2 180 11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5z" })
  }
), $q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M108.2 71c13.8 11.1 16 31.2 5 45C82.4 154.4 64 203 64 256s18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256S23.7 125.3 63.2 76c11.1-13.8 31.2-16 45-5m359.7 0c13.8-11.1 33.9-8.8 45 5 39.4 49.3 63.1 111.9 63.1 180s-23.7 130.7-63.2 180c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45c30.7-38.4 49.1-87 49.1-140s-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45zM232 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0m-27.5-74.7c-17.8 19.8-28.5 46-28.5 74.7s10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256s17-86.2 44.8-117.3c11.8-13.2 32-14.3 45.2-2.5s14.3 32 2.5 45.2zm214.7-42.7C447 169.8 464 210.9 464 256s-17 86.2-44.8 117.3c-11.8 13.2-32 14.3-45.2 2.5s-14.3-32-2.5-45.2c17.8-19.8 28.5-46 28.5-74.7s-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5z" })
  }
), kq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32v352c0 17.7 14.3 32 32 32s32-14.3 32-32zm-128 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32zm-160 64c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32M96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), Pq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32" })
  }
), Fq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32M448 96c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32m-96 128v256c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32m-160 64c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32M96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), Tq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.5 25.4C27.8 255.8 0 293.2 0 335.6v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272c0-5.4.4-10.8 1.1-16h-52.7l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32zm113.9 240c-6.7 16.3-14.2 32.3-22.3 48H384v-48zM86.8 305l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.8 24.2c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-71.9c0-14.1 9.3-26.6 22.8-30.7zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), Aq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-83.6l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96-37 0-69.1 20.9-85.1 51.6L38.8 5.1zm153.3 120.2C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32v7.8c0 12.8-.5 25.6-1.5 38.3l-62.4-48.9zm163.2 127.9 42.8-12.8-12.3 36.8-30.5-23.9zm-190.9-9.5c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9l-107.3-84.7zm67.4 46.6c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-72c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.3c-.2-2.8-.3-5.6-.3-8.5V368z" })
  }
), Dq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-83.6l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32zm-9.2 177 49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-72c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.3c-.2-2.8-.3-5.6-.3-8.5V368zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48z" })
  }
), yq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h377.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zm256 224c0-17.7-14.3-32-32-32H288v-32h-64v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32zM288 480v-96h-64v96c0 17.7 14.3 32 32 32s32-14.3 32-32" })
  }
), bq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h178.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0m32 192c-17.7 0-32 14.3-32 32v32h64v-64zM64 352h256v-64H64zm256-128c0-17.7-14.3-32-32-32h-32v64h64zm-160-32v64h64v-64zm128 256c17.7 0 32-14.3 32-32v-32h-64v64zm-128-64v64h64v-64zm-96 32c0 17.7 14.3 32 32 32h32v-64H64z" })
  }
), fq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V141.3c0-17-6.7-33.3-18.7-45.3L352 18.7C340 6.7 323.7 0 306.7 0zm48 144v48h-48v-16c0-17.7 14.3-32 32-32zm-48 80h224v48H160zm224-32h-48v-48h16c17.7 0 32 14.3 32 32zm-80-48v48h-64v-48zm80 160v16c0 17.7-14.3 32-32 32h-16v-48zm-80 48h-64v-48h64zm-96 0h-16c-17.7 0-32-14.3-32-32v-16h48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88z" })
  }
), Uq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32 14.3 32 32 32 32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96v192h-64v-24c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-24c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56c-30.9 0-56 25.1-56 56v24h-64zm192 320v-32H32v32c0 53 43 96 96 96h256c53 0 96-43 96-96" })
  }
), Gq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m69.3 36 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7m528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3M24 192h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24m528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24M144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-22.2 178zm-48 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z" })
  }
), qq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M73 152.1 48 352h57.9l22.2-178c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-21.8 174H400l-25-199.9C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1M32 384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32z" })
  }
), Wq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40h152c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-32c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-40H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-32c0-30.9 25.1-56 56-56h152v-40h-8c-26.5 0-48-21.5-48-48z" })
  }
), Eq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-27.8c-33.5 0-65.7 17.6-82.1 48.9C150.5 165.8 96 282.2 96 384v17c0 43.6 35.4 79 79 79 15.1 0 30.1-2.7 44.2-8l67.1-25.2c.6-.2 1.1-.4 1.7-.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-33.8c.6.2 1.1.4 1.7.6l67.1 25.2c14.1 5.3 29.1 8 44.2 8 43.6 0 79-35.4 79-79v-17c0-101.8-54.5-218.2-82.2-271.1-16.3-31.3-48.5-48.9-82-48.9H352zm-64 96v38.3l-72.7 16.2c7-15.2 13.8-28.7 19.6-40 4.5-8.6 13.9-14.5 25.3-14.5zM186 254.6l102-22.7v39.7l-116.8 31.8c4.1-16.5 9.2-32.9 14.7-48.8zm-25.7 118.1L288 337.9v42c-8.2 1.7-16.3 4-24.2 7l-67.1 25.2c-7 2.6-14.3 3.9-21.7 3.9-8.3 0-15-6.7-15-15v-17c0-3.7.1-7.5.3-11.3zm191.7 7.2V339l118.8 35.6c3 .9 6.1 1.3 9.1 1.4.1 2.7.1 5.3.1 8v17c0 8.3-6.7 15-15 15-7.4 0-14.8-1.3-21.7-3.9l-67.1-25.2c-7.9-3-16-5.3-24.2-7zm117.8-72.4L352 272.2v-40.3l102 22.7c6 17.2 11.4 35.1 15.7 53zm-45-125L352 166.3V128h27.8c11.4 0 20.8 5.9 25.3 14.5 5.9 11.3 12.6 24.8 19.6 40zM0 144v336c0 17.7 14.3 32 32 32s32-14.3 32-32V240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2c16.1-12.1 25.6-31.1 25.6-51.2 0-35.3-28.7-64-64-64S0 108.7 0 144m576-64c-35.3 0-64 28.7-64 64 0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6v240c0 17.7 14.3 32 32 32s32-14.3 32-32V144c0-35.3-28.7-64-64-64" })
  }
), Oq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v64c0 .8 0 1.6-.1 2.3l67.6-29c8.3-3.5 17.2-5.4 26.1-5.4 36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3l-25.9-25.7c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4 9 0 17.9 1.8 26.1 5.4l67.6 29c-.1-.8-.1-1.5-.1-2.3V320h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h192v-32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h128V32c0-17.7 14.3-32 32-32m-72 440a24 24 0 1 0-48 0 24 24 0 1 0 48 0m192 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), Iq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M390.3.6c17.3 3.5 28.6 20.3 25.1 37.7l-6.4 32-11.6 57.7H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h55l-9.6 48H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.2l78.7 34.7c11.6 5.1 19.1 16.6 19.1 29.3v80c0 17.7-14.3 32-32 32H120c-9.6 0-18.7-4.3-24.7-11.7s-8.5-17.2-6.6-26.6l24.7-123.6c2.9-.5 6.1-1.2 9.5-2.1 15.6-3.9 36.4-11.6 58.3-26.9 42.4-29.7 86.4-86.4 104.5-193.1h65.7l1.3-6.3C356.1 8.4 372.9-2.8 390.3.6zM162.8 198.9c-15.8 11-30.8 17.2-42.6 20.7l32.4-161.9c3-15 16.1-25.7 31.4-25.7h69.2c-17.4 96-56.7 143.3-90.4 166.9zM640 416c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h512c17.7 0 32-14.3 32-32s14.3-32 32-32 32 14.3 32 32" })
  }
), Nq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M383.4 38c3.3-17.4-8-34.1-25.4-37.5s-34.1 8-37.5 25.4l-1.2 6h-73.6c-22.1 130.8-76 201.3-127.2 238.9-26.2 19.3-51.2 29.5-69.9 35-6.3 1.8-11.8 3.1-16.5 4L.6 474c-1.8 9.4.7 19.1 6.8 26.4S22.5 512 32 512h448c17.7 0 32-14.3 32-32s-14.3-32-32-32v-72c0-12.3-7-23.4-18-28.8L340 288h-68c-8.8 0-16-7.2-16-16s7.2-16 16-16h69.5l12.3-64H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h72l17.3-90 6.2-32zM38.8 275.4l.9-.3c15.6-4.6 37.1-13.3 59.9-30 43-31.6 92.3-92.9 113.7-213.1H112c-15.3 0-28.5 10.9-31.4 26z" })
  }
), Xq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5 0 166.1 57.2 224 128 224v-96h-23c-28.7 0-52.7-21.7-55.6-50.3-.8-7.8.1-15.8 2.6-23.2zM240 96c-44.2 0-80 35.8-80 80v112c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4h53c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288V176c0-44.2-35.8-80-80-80zm-16 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M584.4 1.9c-6.8 3.7-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2-2.9 28.6-26.9 50.3-55.6 50.3h-23v96c70.8 0 128-57.9 128-128.5 0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1z" })
  }
), Kq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-21.6c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128m-200 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64m144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0M3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6c-15.8-7.9-22.2-27.1-14.3-42.9z" })
  }
), Qq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9V464c0 26.5 21.5 48 48 48h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48v-64zM96 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0m256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), Zq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z" })
  }
), Jq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9s-20.7-28.3-11.9-43.7l256-448C269 .8 288.5-4.6 303.9 4.2z" })
  }
), jq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2z" })
  }
), Yq1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v160c0 53 43 96 96 96v32h64v-32h192v32h64v-32c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7h-9zm608 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h488c48.6 0 88-39.4 88-88z" })
  }
), _q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 160v192h-32V160zm-32-64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64c0-35.3-28.7-64-64-64zM0 256c0 17.7 14.3 32 32 32h192v-64H32c-17.7 0-32 14.3-32 32" })
  }
), hW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64m90.5 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H186.5c-13.2 37.3-48.7 64-90.5 64-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64M384 160a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-58.5-32c13.2-37.3 48.7-64 90.5-64 53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), cW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0c17.7 0 32 14.3 32 32v54.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V233.3C35.7 221 16 192.8 16 160s19.7-61 48-73.3V32C64 14.3 78.3 0 96 0m0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m80-32c0 32.8-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-54.7c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v246.7c28.3 12.3 48 40.5 48 73.3m112-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V265.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3" })
  }
), sW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416c0 17.7 14.3 32 32 32h54.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H233.3c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48H32c-17.7 0-32 14.3-32 32m128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32-80c-32.8 0-61 19.7-73.3 48H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h246.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-54.7c-12.3-28.3-40.5-48-73.3-48m-160-48a32 32 0 1 1 0-64 32 32 0 1 1 0 64m73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48H32C14.3 64 0 78.3 0 96s14.3 32 32 32h86.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), vW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0C92.7 0 64 28.7 64 64h384c0-35.3-28.7-64-64-64zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64h400c53 0 96-43 96-96V211.8c9.8-8.8 16-21.6 16-35.8 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8V416c0 17.7-14.3 32-32 32h-80v-32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zm-8 104c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6S76.8 314.8 82 302.6l33.6-78.6H80c-13.3 0-24-10.7-24-24m168-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l33.6-78.6H224c-13.3 0-24-10.7-24-24s10.7-24 24-24m120 24c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l33.6-78.6H368c-13.3 0-24-10.7-24-24" })
  }
), eW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 144c0 79.5 64.5 144 144 144h123.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112S557.9 64 496 64c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0 96.5 0 32 64.5 32 144m584 224H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24m-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24m-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24m-136-72c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c13.3 0 24-10.7 24-24" })
  }
), lW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128 32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8-11.5 7.3-22 16-31.2 25.9-22.5-11.9-48-18.7-75.2-18.7-66.5 0-123.5 40.6-147.7 98.3m276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30 22.4-37.1 63.1-62 109.7-62 70.7 0 128 57.3 128 128 0 42.2-20.4 79.6-51.9 102.9-25-42.4-71.2-70.9-124.1-70.9-5.2 0-10.3.3-15.4.8M144 512C64.5 512 0 447.5 0 368s64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3 22.7-20.1 52.5-32.3 85.1-32.3 49.1 0 91.8 27.7 113.2 68.3 9.8-2.8 20.1-4.3 30.8-4.3 61.9 0 112 50.1 112 112s-50.1 112-112 112z" })
  }
), tW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 32v11c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32v-11c0-12.7-5.1-24.9-14.1-33.9l-21-21c-39-39-60.9-92-60.9-147.1V32c0-17.7 14.3-32 32-32s32 14.3 32 32m128 224v-11c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32v11c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32M0 416c0-35.3 28.7-64 64-64h352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64zm224 0v32h160v-32zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32m96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32" })
  }
), wW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m483.4 65.7-79.8-39.9c-30.8-15.4-68-9.4-92.3 15L288 64H176C96.5 64 32 128.5 32 208s64.5 144 144 144h144c17.7 0 32 14.3 32 32s-14.3 32-32 32H111.6c-10.3 0-20.6 1.7-30.4 4.9l-66 22C6.1 446 0 454.4 0 464s6.1 18 15.2 21.1l66 22c9.8 3.3 20 4.9 30.4 4.9H320c70.7 0 128-57.3 128-128s-57.3-128-128-128H176c-26.5 0-48-21.5-48-48s21.5-48 48-48h112l23.2 23.2c24.3 24.3 61.5 30.4 92.3 15l79.8-39.9c17.5-8.8 28.6-26.7 28.6-46.3s-11.1-37.5-28.6-46.3zM352 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), gW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S179.9 192 192 192h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S300.1 0 288 0zm128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S307.9 416 320 416h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S428.1 224 416 224zM32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h91.7L7.4 459.5C-.5 469-2.3 482.3 3 493.6S19.6 512 32 512h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-91.7l116.3-139.5c7.9-9.5 9.7-22.8 4.4-34.1S204.4 256 192 256H32z" })
  }
), iW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 48h32c53 0 96 43 96 96s-43 96-96 96H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32M176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6S329 243.3 320.5 241l-48.2-12.9L224 256l48.3 27.9 48.3-12.9c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2-48.4-27.9v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25.4l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l35.3-35.3v-55.8l-48.3 27.9-13 48.2c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7c-11.4 6.6-26 2.7-32.7-8.8s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6S23 268.7 31.5 271l48.2 12.9L128 256l-48.3-27.9L31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2 48.3 27.9v-55.8l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l12.7 12.7V88c0-13.3 10.7-24 24-24m304 368c0-17.7 14.3-32 32-32h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h120c53 0 96 43 96 96s-43 96-96 96h-24c-17.7 0-32-14.3-32-32" })
  }
), mW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L431 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.4-35.9V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-22.9 13.2-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 60.9-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.8v-70.4L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zm199.1 418.1 47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5 0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512S0 483 0 447.7c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z" })
  }
), aW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L335 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.3-35.8V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-23.8 13.7c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 61-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.7v-70.4L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z" })
  }
), oW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L335 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.3-35.8V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-23.8 13.7c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 61-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.7v-70.4L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zm263 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), nW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v96H64zm266.2 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-25.7c16.3 28.2 25.7 61 25.7 96 0 59.8-27.4 113.3-70.3 148.5-9.7 8-22.3 11.5-34.9 11.5H137.2c-12.6 0-25.1-3.5-34.9-11.5C59.4 465.3 32 411.8 32 352c0-35 9.3-67.8 25.7-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.8zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48m168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0M219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7 0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7z" })
  }
), rW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12 7 8.5 12.9 18.1 17.2 28.4l48.5-20.8V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3 2.9-2.8 4-6.9 2.8-10.8-2.7-8.7-4.3-17.9-4.8-27.3l-73.6-31.5-56-24c-12.1-5.3-17.8-19.4-12.6-31.6s19.3-17.8 31.5-12.6l22.6 9.7V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2l48.6 20.8c4.3-10.3 10.1-19.9 17.2-28.4 2.8-3.4 3.3-8.1 1.2-12-7-13.4-11-28.5-11-44.6 0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6M224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32m16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0m16-256a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-48 24v3.2c0 3.2.8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16" })
  }
), dW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m298.9 64 68.6 160H256l-64-64V64zm146.2 178.7-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48v112H96c-17.7 0-32 14.3-32 32v106.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V235.2l57-71.2c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288h-64v-31.3c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48zm-224 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0m216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-56-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), SW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m112 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128m96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0m0 160c0 27.6-11.7 52.5-30.4 70.1 36.5 13.6 62.4 48.7 62.4 89.9 0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96v128c0 53 43 96 96 96h320c53 0 96-43 96-96V288c0-53-43-96-96-96m-256 96c-35.3 0-64 28.7-64 64s28.7 64 64 64h192c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32z" })
  }
), zW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6 0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128v144c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2zM128 64h160V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0h-96c-26.5 0-48 21.5-48 48zm192 32v144c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96zm192-32V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v16z" })
  }
), pW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C208 56 200 64 190.1 64H128c-35.3 0-64 28.7-64 64 0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64s-28.7-64-64-64h-2.3c11.5-14.4 18.3-32.7 18.3-52.6C320 48.1 271.9 0 212.6 0zM48 320v32c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h134.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-32z" })
  }
), MW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M122.2 0C91.7 0 65.5 21.5 59.5 51.4l-51.2 256C.4 347 30.6 384 71 384h217v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64h217c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zm138.7 64h118.2l10.4 104h-139zm-58.6 104H101.4l20.8-104h90.4zM91.8 216h105.7l-10.4 104H71zm153.9 0h148.6l10.4 104H235.3zm196.8 0h105.7L569 320H453zm96-48H437.7L427.3 64h90.4l31.4-6.3-31.3 6.3 20.8 104z" })
  }
), xW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 256c0 41.9-13.4 80.6-36.2 112.2-24.5 2.1-43.8 22.7-43.8 47.8 0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256 512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4 18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192M256 448c-106 0-192-86-192-192 0-41.9 13.4-80.6 36.2-112.2 24.5-2.1 43.8-22.7 43.8-47.8 0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2.3 6.4.9 9.4C18.2 147.7 0 199.7 0 256c0 141.4 114.6 256 256 256 42.1 0 81.7-10.1 116.8-28.1-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448m133.2-265.3c1.8-4.6 2.8-9.5 2.8-14.7 0-22.1-17.9-40-40-40-4 0-7.8.6-11.5 1.7-24.1-16.2-53.2-25.7-84.5-25.7-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3M312 168.4c.2 20.6 16 37.6 36.2 39.5 7.5 14.4 11.8 30.8 11.8 48.2 0 57.4-46.6 104-104 104s-104-46.6-104-104 46.6-104 104-104c20.6 0 39.8 6 56 16.4zm8 87.6a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), HW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" })
  }
), VW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 224.1 32 224.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" })
  }
), CW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S301 224.1 288 224.1H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19.1 288 32.1 288H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z" })
  }
), LW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5 7 9.9 13.4 20.3 19.1 31 5.7-10.8 12.1-21.1 19.1-31 22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1 0 148-119.9 267.9-267.9 267.9h-40.2C119.9 480 0 360.1 0 212.1 0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3M301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6-38 21.6-71.4 50.8-97.9 85.6-26.5-34.8-59.9-63.9-97.9-85.6 23.2-92.8 68.6-147.7 84.4-164.6 3.5-3.7 8.4-5.6 13.5-5.6s10 1.9 13.5 5.6z" })
  }
), BW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 7.8-.3 15.5-1 23.1-72.2 25.6-159.8 40.9-255 40.9S73.2 304.7 1 279.1c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0c57.8 0 111.1 19.1 153.9 51.4 3.9 2.9 6.1 7.5 6.1 12.4V80c0 8.8-7.2 16-16 16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16 7.2 16 16v32c0 8.8 7.2 16 16 16h31.9c8.1 0 14.9 6 15.5 14.1.4 5.9.6 11.9.6 17.9M256 512C134.9 512 33.4 427.9 6.8 314.8 79.4 338.4 164.7 352 256 352c44.3 0 87.3-3.2 128-9.2V368c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16v19.3c0 3.9-1.4 7.7-4.1 10.5C397.2 480.4 330.3 512 256 512m-96-352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), uW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 256c0 7.8-.3 15.5-1 23.1-72.2 25.6-159.8 40.9-255 40.9S73.2 304.7 1 279.1c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0s256 114.6 256 256M256 512C134.9 512 33.4 427.9 6.8 314.8 79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512m-96-352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0" })
  }
), RW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278 12.5C265.7.8 246.3.8 234 12.5l-66 62.6L40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-73.4l8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1z" })
  }
), $W1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5l15.6-31.2c-10-11.2-16-26.1-16-42.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4 7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4 10.7 11.7 16.1 13.4 19.4 13.4 2.5 0 4.3-.6 7.1-3.3 3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7 9.7-9.3 22.9-16.7 40.4-16.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3.6-7.1 3.3-3.7 3.5-7.1 8.8-12.5 17.4l-.6.9c-4.6 7.4-11 17.6-19.4 25.7-9.7 9.3-22.9 16.7-40.4 16.7-18.5 0-32.9-8.5-44.3-18.6-3.1 4-6.6 8.3-10.5 12.7 1.4 4.3 2.8 8.5 4 12.5.9 3 1.8 5.8 2.6 8.6 3 9.8 5.5 18.2 8.6 25.9 3.9 9.8 7.4 15.4 10.8 18.5 2.6 2.4 5.9 4.3 12.8 4.3 8.7 0 16.9-4.2 33.7-13.2 15-8 35.7-18.8 62.3-18.8 13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2-11.1-10.3-17.9-23.7-22.7-36-3.6-9-6.7-19.1-9.5-28.5-16.4 12.3-36.1 23.6-58.9 31.3 3.6 10.8 8.4 23.5 14.4 36.2 7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8-14.5-15.4-25.7-34.9-34.2-53-8-17-14.1-33.8-18.3-46.9-5.2.4-10.6.6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7 9.5-10.1 18.3-24.6 25.8-40.5 5.9-12.6 10.7-25.4 14.4-36.2-22.8-7.7-42.5-19-58.9-31.3-2.9 9.4-6 19.5-9.5 28.5-4.8 12.2-11.6 25.6-22.7 36-12 11.1-27.2 17.2-45.6 17.2-21.4 0-39.9-10-53.1-17.1-1.1-.6-2.2-1.2-3.2-1.7-15-8-26.3-13.2-39.7-13.2-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8 16.8 9 25 13.2 33.7 13.2 6.8 0 10.2-1.9 12.8-4.3 3.4-3.2 7-8.8 10.8-18.5 3-7.7 5.6-16.1 8.6-25.9.8-2.7 1.7-5.6 2.6-8.6 1.2-4 2.6-8.2 4-12.5-3.9-4.5-7.4-8.8-10.5-12.7-11.4 10-25.8 18.5-44.3 18.5-17.5 0-30.7-7.4-40.4-16.7-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4-2.8-2.7-4.6-3.3-7.1-3.3-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7 8.4 8.1 14.8 18.3 19.4 25.7l.6.9c5.4 8.6 8.8 13.9 12.5 17.4 2.8 2.7 4.6 3.3 7.1 3.3 3.3 0 8.7-1.7 19.4-13.4 5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24 13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7.1-3.4.2-5.1.2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64zm208 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), kW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9l-59.5 128.8-128.8 59.5C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-128.8-59.5-59.5-128.8z" })
  }
), PW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-52.8 114L9.3 240c-5.7 2.6-9.3 8.3-9.3 14.6s3.6 11.9 9.3 14.5l114.1 52.7 52.6 114c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1L371.8 269c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-114-52.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5z" })
  }
), FW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm304 272a112 112 0 1 0-224 0 112 112 0 1 0 224 0m-112-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128m0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), TW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0h216.4C265.2 17 256 39.4 256 64v193.6c-20.3-20.7-48.7-33.6-80-33.6-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V448c0 24.6 9.2 47 24.4 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0m256 503.4c-19.1-11.1-32-31.7-32-55.4V64c0-23.7 12.9-44.4 32-55.4 9.4-5.5 20.3-8.6 32-8.6h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H352c-11.7 0-22.6-3.1-32-8.6M352 336a112 112 0 1 0 224 0 112 112 0 1 0-224 0m-176-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128m0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96m224 176a64 64 0 1 1 128 0 64 64 0 1 1-128 0m112-224a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), AW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2l5.2-12.3h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0m18.7 160H93.3l18.7-44.8zM256 32v192c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80 0-23.1-9.8-43.8-25.4-58.4 6-11.2 9.4-24 9.4-37.6 0-44.2-35.8-80-80-80h-64c-17.7 0-32 14.3-32 32m96 64h-32V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16m-32 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48zm246.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z" })
  }
), DW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5l48.3 48.4V160c0-31.8 18.6-59.3 45.5-72.2 9.1-4.4 18.5 3.3 18.5 13.4V112c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.8c0-10.1 9.4-17.7 18.5-13.4 26.9 12.9 45.5 40.4 45.5 72.2v14.1l48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5l-32.5-84.7c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8l32.5 84.6c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4-80.4 26.8c-2.4.8-4.3 2.7-5.1 5.1l-18.9 56.8C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4l60.6-20.2-60.5-20.2c-16.7-5.6-29.8-18.7-35.4-35.4l-19-56.8C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8-57.5-57.4C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm73.8 305.6L240 336l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2 0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12 0-2.6-.8-5.1-2.4-7.2L272 336l21.6-28.8c1.6-2.1 2.4-4.6 2.4-7.2 0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12 0 2.6.8 5.1 2.4 7.2z" })
  }
), yW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2c-11.6-30.7-28.2-59.3-49.2-84.5l-45.2-54.3c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zm33.3 70.6-9.8 26.2c-13.7 36.6-33.5 70.6-58.5 100.6L88.4 232H133c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7zm42.1-23.1 21.4 37.4c37.7 9.5 77.2 9.5 114.9 0l21.4-37.4-14.7 2.8c-42.4 7.9-85.9 7.9-128.3 0l-14.7-2.8zm199.7 23.1-22.2 38.8 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h44.6l-10.3-12.4c-25-30-44.8-64-58.5-100.6L409 92.8zM487.6 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 21.6 37.9 9.8-26.2c13.7-36.6 33.5-70.6 58.5-100.6zM366.8 442.3l-19.5-34.2c-37.9-11.7-78.3-12.8-116.7-3.2l-21.3 37.4 14.7-2.8c42.4-7.9 85.9-7.9 128.3 0l14.7 2.8zm-199.7-23.1 22.2-38.8-2.5-7a298.12 298.12 0 0 0-53.7-93.4H88.4l10.3 12.4c25 30 44.8 64 58.5 100.6l9.8 26.2zM193.2 280c10.1 15 18.9 30.7 26.5 47.1l26.9-47.1zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1l-27.4-48zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7h-53.7l27.3 47.7zm26.2-95.7c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0l26.6 46.6zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1" })
  }
), bW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4-80.4-26.8c-2.4-.8-4.3-2.7-5.1-5.1l-18.9-56.8C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4l60.6 20.2-60.5 20.2c-16.7 5.6-29.8 18.7-35.4 35.4l-19 56.8C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8-57.5 57.4C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l32.3-32.4c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l32.5-84.5c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4.8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7l-32.4-84.6c-4.8-12.4-18.6-18.6-31-13.8s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c0-10.1-9.4-17.7-18.5-13.4-26.9 12.9-45.5 40.4-45.5 72.2v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z" })
  }
), fW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c0-17.7 14.3-32 32-32 141.4 0 256 114.6 256 256 0 46.6-12.5 90.4-34.3 128-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96 0-106-86-192-192-192-17.7 0-32-14.3-32-32" })
  }
), UW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0m0 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0M48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96m464-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M142.9 437A48 48 0 1 0 75 369.1a48 48 0 1 0 67.9 67.9zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437a48 48 0 1 0 67.9-67.9 48 48 0 1 0-67.9 67.9" })
  }
), GW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.8 384 191.8V160h-37.5c-8.5 0-16.6 3.4-22.6 9.4L237.3 256l86.6 86.6c6 6 14.1 9.4 22.6 9.4H384v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 460.8 384 447.8V416h-37.5c-25.5 0-49.9-10.1-67.9-28.1L178.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h146.7l99.9-99.9c18-18 42.4-28.1 67.9-28.1H384V64c0-12.9 7.8-24.6 19.8-29.6" })
  }
), qW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m208.5 62.3 28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2 0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2-15.8-7.9-33.7-10.4-51-7.3l-82.8 15.1C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1 0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z" })
  }
), WW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96 0 96-80 192-160.2 192-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z" })
  }
), EW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m487.6 48.9-.3-1.5-122 121.9c34.8 30.2 79 49.8 127.6 53.9 9.3-63 4.7-125.5-5.4-174.3zm-22.8-24.3c-1.1-.3-2.2-.5-3.3-.7-65.6-11-122.9-12.5-172.8-6 3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6C432 249.5 382 226.7 342.7 192l-64 64 139.8 139.9c10.3-11.8 19.4-24.4 27.4-37.5zm-126-189c-35-39.7-57.9-90.3-63-146.1-17 3.6-33 8.3-48.1 13.9-37 13.7-67.8 33-93.1 56L256 233.4zM233.4 256l-140-139.9c-10.2 11.8-19.3 24.4-27.4 37.5-19.8 32.3-33 67.7-41.1 103.6C80 262.5 130 285.3 169.3 320l64-64zM192 342.6c35 39.7 58 90.3 63 146.1 17-3.6 33-8.3 48.1-13.9 37-13.7 67.8-33 93.1-56L256 278.6zm-45.3.1c-34.8-30.2-79-49.8-127.6-53.9-9.3 63-4.7 125.5 5.4 174.3l.3 1.5zm22.6 22.6L47.2 487.4c1.1.3 2.2.5 3.3.7 65.6 11 122.9 12.5 172.8 6-3.9-49.1-23.6-93.7-54-128.8z" })
  }
), OW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32v96h128V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32m0 128c-53 0-96 43-96 96v208c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160M384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L320 64l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L352 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6m76.4 45.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 64zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 224zM448 144c0-1.4-1-3-2.2-3.6L416 128l-12.4-29.8C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6" })
  }
), IW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32M0 256c0-53 43-96 96-96h128c53 0 96 43 96 96v208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm240 80a80 80 0 1 0-160 0 80 80 0 1 0 160 0m16-272a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-64-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), NW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0v96c0 15.3 10.8 28.4 25.7 31.4L128 147.8V82.6L64 69.8V0zm256 82.6v65.3l102.3-20.5c15-3 25.7-16.1 25.7-31.4V0h-64v69.8zM160 344a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-48 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m248-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0m-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-32 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0m88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48M224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64z" })
  }
), XW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48M0 128a24 24 0 1 1 48 0 24 24 0 1 1-48 0m0 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0M64 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0m24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48m40-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0m360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48m24-80a24 24 0 1 1-48 0 24 24 0 1 1 48 0M488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-40 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0m-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-40-32a24 24 0 1 1-48 0 24 24 0 1 1 48 0M256 64c17.7 0 32 14.3 32 32v160h100.2c15.3 0 27.8 12.4 27.8 27.8 0 7.8-3.3 15.2-9 20.5L320 384v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96l-87-79.7c-5.7-5.3-9-12.7-9-20.5 0-15.3 12.4-27.8 27.8-27.8H224V96c0-17.7 14.3-32 32-32" })
  }
), KW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96m-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48" })
  }
), QW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8" })
  }
), ZW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm126.7 152.7-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z" })
  }
), JW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H152c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), jW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z" })
  }
), YW1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm112 96h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8 0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3 0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z" })
  }
), _W1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96m-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70c-24.6 21-38.8 51.8-38.8 84.2" })
  }
), hE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h144c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2.5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z" })
  }
), cE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm232 32h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72m-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z" })
  }
), sE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 176a48 48 0 1 1 0-96 48 48 0 1 1 0 96m-26 44.4-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70c24.6-21 38.8-51.8 38.8-84.2 0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4" })
  }
), vE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h256v-96c-9.1 0-17.7-5.2-21.8-13.9l-12-26.1H161.8l-12 26.1c-5.6 12-19.8 17.3-31.8 11.7S100.7 362 106.3 350l96-208c3.9-8.5 12.4-13.9 21.8-13.9s17.9 5.4 21.8 13.9l82.4 178.6c5.6-10 13.9-18.3 23.8-24V272c0-56.4 41.7-103.1 96-110.9V96c0-35.3-28.7-64-64-64zm160 177.3L184 296h80zM464 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), eE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3z" })
  }
), lE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm120 159.6c0 4.1 1.6 8.1 4.6 11l14.4 14.5 23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.3-5.9-13.2-13.2-13.2h-19.2c-8.6 0-15.6 7-15.6 15.6m71 46.9-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4a79.997 79.997 0 0 1-62 29.4h-32.2c-36.7 0-66.5-29.8-66.5-66.5 0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45 0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2 0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9 0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z" })
  }
), tE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64zm224-112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-94.1L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v160c0 13.3 10.7 24 24 24z" })
  }
), wE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 13.3-10.7 24-24 24z" })
  }
), gE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64zm177-87 112-112c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), iE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm87-177 112-112c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71 182.1.1c13.3 0 24 10.7 24 24s-10.7 24-24 24H161.9l71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), mE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zm-87 177L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h182.1l-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z" })
  }
), aE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm224 112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-94.1L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24z" })
  }
), oE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24z" })
  }
), nE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm177 87 112 112c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119c9.4-9.4 24.6-9.4 33.9 0z" })
  }
), rE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256zm144 52c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28m-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84z" })
  }
), dE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1" })
  }
), SE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm103.4 167.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z" })
  }
), zE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4h208c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z" })
  }
), pE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm128-160c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22v208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z" })
  }
), ME1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S160 369.5 160 360V152c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6" })
  }
), xE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 128c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S337.5 320 328 320H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7" })
  }
), HE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm273 177L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), VE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zM207 345 103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z" })
  }
), CE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm135-177 104-104c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), LE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zM313 273 209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z" })
  }
), BE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm177 135 104 104c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z" })
  }
), uE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9l60.1 54.2-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-60.2-54 60.2-54.2z" })
  }
), RE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-72c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24m24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48z" })
  }
), $E1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32C43 32 0 75 0 128v32h64v-32c0-17.7 14.3-32 32-32h32V32zM0 192v128h64V192zm64 160H0v32c0 53 43 96 96 96h32v-64H96c-17.7 0-32-14.3-32-32zm320-224v70.6c15.3-4.3 31.4-6.6 48-6.6 5.4 0 10.7.2 16 .7V128c0-53-43-96-96-96h-32v64h32c17.7 0 32 14.3 32 32M160 480h136.2c-15.3-18.5-26.9-40.2-33.6-64H160zm0-384h128V32H160zm272 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288m16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), kE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32h32v64H96c-17.7 0-32 14.3-32 32v32H0v-32c0-53 43-96 96-96M0 192h64v128H0zm384 0h64v128h-64zm64-32h-64v-32c0-17.7-14.3-32-32-32h-32V32h32c53 0 96 43 96 96zm0 192v32c0 53-43 96-96 96h-32v-64h32c17.7 0 32-14.3 32-32v-32zm-384 0v32c0 17.7 14.3 32 32 32h32v64H96c-53 0-96-43-96-96v-32zm96 128v-64h128v64zm0-384V32h128v64z" })
  }
), PE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24m56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), FE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm180.8 101.6v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z" })
  }
), TE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64zm64-281.4V336c0 8.8 7.2 16 16 16h137.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7c-3.6-3.6-8.5-5.6-13.6-5.6s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6z" })
  }
), AE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zm-64-281.4V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6z" })
  }
), DE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64zm39.1-185.4 107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3 0-12.3-10-22.3-22.3-22.3H272v-96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v96h-57.7C106 256 96 266 96 278.3c0 6.2 2.6 12.1 7.1 16.3" })
  }
), yE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v56h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24" })
  }
), bE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zM256 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-160 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0" })
  }
), UE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm154 239.7L64.2 172.4C66 156.4 79.5 144 96 144h256c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8m29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z" })
  }
), GE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm160 96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), qE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24" })
  }
), WE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 86.3C128 106 138 96 150.3 96H176l32 64-32 32 80 64-32-64 48-32-32-64h57.7c12.3 0 22.3 10 22.3 22.3V208c0 47.6-34.6 87.1-80 94.7V384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-81.3c-45.4-7.6-80-47.1-80-94.7z" })
  }
), EE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 0h512v512H0z" })
  }
), OE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm80 224c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 70.7-57.3 128-128 128S96 326.7 96 256s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80" })
  }
), IE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm272 120v208c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H160v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v80h128v-80c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), NE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm35.9 248.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4z" })
  }
), XE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v160h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), KE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm120 304h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), QE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm240 120v136c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), ZE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm249.1 136.8-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8l102.9-104.6c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5.3 33.9z" })
  }
), JE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zm-64-96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v192c0 17.7-14.3 32-32 32m-64-160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm-128 96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 17.7-14.3 32-32 32" })
  }
), jE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm112 120v184h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), YE1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm185.4 39.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1 12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-96v-57.7c0-12.3-10-22.3-22.3-22.3-6.2 0-12.1 2.6-16.3 7.1z" })
  }
), _E1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm96 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64m32-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0M96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64m96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), hO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2L243.4 310c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7.3 26.8 8.8z" })
  }
), cO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 200h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), sO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm90.3 104.5 133.7 158V152c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 10.1-6.3 19.1-15.7 22.5s-20.1.7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7" })
  }
), vO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm75.7 64.6C68.8 162.5 64 168.8 64 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16m160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), eO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm80 224a80 80 0 1 0 160 0 80 80 0 1 0-160 0m80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256" })
  }
), lO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88z" })
  }
), tO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zM227 152.7c6-14.5 20.3-24.7 37-24.7h72c53 0 96 43 96 96 0 26.3-10.6 50.2-27.8 67.5l-51.4-40.3c9.1-5.6 15.2-15.7 15.2-27.2 0-17.7-14.3-32-32-32h-48v8.4l-61-47.8zM224 288v-15.5L96 171.6V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4L288 322.9V352c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), wO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm128 224h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48zm48 64h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96" })
  }
), gO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm261.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0M119.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" })
  }
), iO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1-96 0m80 104c0-30.9 25.1-56 56-56s56 25.1 56 56v102.1c0 36.4-29.5 65.9-65.9 65.9-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9l41.2 41.3z" })
  }
), mO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2l24.6 20.2c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224 0-9-6-16.9-14.7-19.3z" })
  }
), aO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm295.4 278c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4.2-26.7-8.5l-21.8-35.2c-4.8-7.8-3.4-17.5 3.5-23.8 84.9-78.6 222.6-78.6 307.5 0 6.8 6.3 8.2 16.1 3.4 23.8z" })
  }
), oO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384 196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3z" })
  }
), nO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm136 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), rO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zm-192 64c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32m64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32zM192 352c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32" })
  }
), dO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32m64-64c0-17.7 14.3-32 32-32s32 14.3 32 32v192c0 17.7-14.3 32-32 32s-32-14.3-32-32zm128 128c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32" })
  }
), SO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm80 224c0 44.2 35.8 80 80 80 13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37 0-44.2-35.8-80-80-80s-80 35.8-80 80m208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L296 361.8c-20.5 14-45.3 22.1-71.9 22.1-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z" })
  }
), zO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 0 160 160L384 96zm0 320h320L224 256z" })
  }
), pO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), MO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 128h48c17.7 0 32 14.3 32 32v87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32m224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24z" })
  }
), xO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 96h104c44.2 0 80 35.8 80 80 0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288h-44v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24m80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v64z" })
  }
), HO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64zm-185.4 39.1 99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8l-99.9 107.1c-4.2 4.5-10.1 7.1-16.3 7.1-12.3 0-22.3-10-22.3-22.3V304h-96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h96v-57.7c0-12.3 10-22.3 22.3-22.3 6.2 0 12.1 2.6 16.3 7.1" })
  }
), VO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 224a96 96 0 1 0 192 0 96 96 0 1 0-192 0m96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320" })
  }
), CO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M282.6 78.1c8-27.3 33-46.1 61.4-46.1h200c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h45.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8 84.5-289.5zm110.8 155.3c12.5-12.5 32.8-12.5 45.3 0l41.3 41.3 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.4-41.4-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z" })
  }
), LO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M282.6 78.1c8-27.3 33-46.1 61.4-46.1h200c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h45.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8 84.5-289.5z" })
  }
), BO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm32 104c0-13.3 10.7-24 24-24 137 0 248 111 248 248 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200-13.3 0-24-10.7-24-24m0 96c0-13.3 10.7-24 24-24 83.9 0 152 68.1 152 152 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104-13.3 0-24-10.7-24-24m0 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), uO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm111.6 164.2c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23.1 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23.1-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7 12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z" })
  }
), RO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm320 128c0 35.3-28.7 64-64 64-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-2.5.1-4.9.4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64" })
  }
), $O1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm144 0c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v160c0 17.7 14.3 32 32 32s32-14.3 32-32V224h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16v-32c0-17.7-14.3-32-32-32m192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v160h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16z" })
  }
), kO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zm0-144c0 17.7-14.3 32-32 32h-32v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h160v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h32c17.7 0 32 14.3 32 32m-32-192c17.7 0 32 14.3 32 32s-14.3 32-32 32H192v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16z" })
  }
), PO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z" })
  }
), FO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2l72.4-38 72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z" })
  }
), TO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm56 112h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), AO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), DO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm16 352h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m185.4-192c-9.6 0-17.4-7.8-17.4-17.4 0-4.3 1.6-8.4 4.4-11.6l54.3-61c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6 0 9.6-7.8 17.4-17.4 17.4H352V304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192zm-192 0c-9.6 0-17.4-7.8-17.4-17.4 0-4.3 1.6-8.4 4.4-11.6l54.3-61c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6 0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192z" })
  }
), yO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm96 136v120c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v120c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), bO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm64 281.4V176c0-8.8 7.2-16 16-16h137.4c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.6 3.6-8.5 5.6-13.6 5.6s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6" })
  }
), fO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm-64 281.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6 0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6" })
  }
), UO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm39.1 185.4 107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3 0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-96h-57.7C106 256 96 246 96 233.7c0-6.2 2.6-12.1 7.1-16.3z" })
  }
), GO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M81.1 416h285.8c-7.8-54.3-54.4-96-110.9-96h-64c-56.4 0-103.1 41.7-110.9 96M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144" })
  }
), qO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm77.5 125.3 82.5 165 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z" })
  }
), WO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm159.8 61.7c13.3 0 24 10.7 24 24 0 29.3 35.4 43.9 56.1 23.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1 13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2 0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64m88 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), EO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-41-128.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z" })
  }
), OO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm90.3 104.5 69.7 82.3 69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l74.9-88.5-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z" })
  }
), IO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), NO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm74.1 120.3 85.9 99.1 85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24v-79l-98.1-113.3c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z" })
  }
), XO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm72 96h176c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), KO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z" })
  }
), QO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M276 .3c-5.3-1.1-10.8.6-14.6 4.5s-5.4 9.4-4.2 14.7l13.1 58.9c-71.9 46.2-103.4 101.8-110.6 148.4L146 213l-2.3-2.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5.1l-2.8 2.8c-34 34-33.3 87.7-1.9 121l-14.4 14.4c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6 5.7 5.7c9.3 9.4 9.3 24.5 0 33.9-9.3 9.3-24.4 9.4-33.8.2l-16.5-16.6c-19.1-19.1-50.2-18.7-68.7.9L4.4 261c-6.1 6.4-5.8 16.5.6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6.1.2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2-10.9 0-19.7-8.8-19.7-19.7V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v12.3c0 28.5 23.2 51.7 51.7 51.7 11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8 0 28.6 23.2 51.7 51.7 51.7h12.3c8.8 0 16-7.2 16-16s-7.2-16-16-16h-12.3c-10.9 0-19.7-8.8-19.7-19.7 0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1.1 22.4 22.3.1.1 9.9 9.8c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.3-9.3-9.3-24.4 0-33.8l.1-.1.1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0l14.2-14.3c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3.1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.3c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16c46.6-7.2 102.2-38.7 148.4-110.6l58.9 13.1c5.3 1.2 10.8-.4 14.7-4.2s5.6-9.3 4.5-14.6l-23.4-116.6c9.2-30.2 17.2-64 23.4-101.5.9-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3.2C456.7 6.5 423 14.4 392.7 23.6L276 .3zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1-32 0m64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), ZO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 296.2c0 2-.7 3.9-2 5.4-18.7 22.3-30 51-30 82.3 0 70.7 57.3 128 128 128h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16c10-13.4 16-30 16-48 0-26.2-12.6-49.4-32-64-13.4-10-30-16-48-16-9.4 0-18.3 1.6-26.7 4.5-8.3 2.9-17.5-1.4-20.4-9.8s1.4-17.5 9.8-20.4c11.7-4.1 24.3-6.4 37.3-6.4 17.2 0 33.5 3.9 48 10.8V240h21.2c26.7 0 51.7-13.4 66.6-35.6L512 192c0-53-43-96-96-96V75.2c0-6.2-5-11.2-11.2-11.2-15.2 0-28.7 7.6-36.8 19.2-8.1-11.6-21.6-19.2-36.8-19.2-6.2 0-11.2 5-11.2 11.2V96c0 54.4-10.5 108.1-30.7 158-.9-2-1.3-4.2-1.3-6.4V144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2 4.9-.2 9.1 3.5 9.1 8.4M416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), JO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m222.6 43.2-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96h-40v-80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-68l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96h-16v-80h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-43l-3.1 99.5-1.4 43.5v1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16v-1l-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32h-19c-53 0-96-43-96-96 0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128h-41.4c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56s25.1-56 56-56h105.5l-.1-4.8L161 32v-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30V32zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), jO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M284.2 44.2C297.8 17.1 325.5 0 355.8 0H432c44.2 0 80 35.8 80 80v103.9c0 35.7-23.7 67.1-58 76.9l-3.9 1.1c-4 1.2-7.5 3.9-9.5 7.5l-19 33.6c-4.3 7.7-14.1 10.4-21.8 6.1L367 290.6c-3.7-2.1-8.1-2.6-12.3-1.5l-85.5 24.4c-2.6.7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l77.3-77.3c3-3 4.7-7.1 4.7-11.3V304c0-8.8 7.2-16 16-16h37.5c4.2 0 8.3-1.7 11.3-4.7l39.4-39.4c9.6-9.6 21.5-16.6 34.6-20.4L404.4 175c6.9-2 11.6-8.2 11.6-15.4V112c0-8.8-7.2-16-16-16h-28.2c-3.7 0-7.2 2.1-8.8 5.5-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z" })
  }
), YO1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-96c0-17.7 14.3-32 32-32h96v-96c0-17.7 14.3-32 32-32h96z" })
  }
), _O1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8 10.7 13.8 19.9 29.6 19.9 47 0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-50.7c18.6-6.6 32-24.4 32-45.3 0-61.9-50.1-112-112-112h-33.8c-29.9 0-54.2-24.3-54.2-54.2M416 416v32H96v-32z" })
  }
), hI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm304 88v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24m48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32zm-184.9.1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1.7 21.1 3.4 25.7 4.4 12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1-18.9-2.5-38.9-3.1-56 2.5-18.8 6.1-33.9 19.7-38.5 42.3-.1.4-.1.8-.2 1.2-1.7 11.4-.2 22.4 5 32.3 5.1 9.6 12.9 16.1 20.5 20.7 13.7 8.2 31.5 12.3 45.1 15.5l1.7.4c16 3.7 27.1 6.5 34.1 10.7 3 1.8 3.8 3 3.9 3.3.1.1.7 1.2.2 4.7-.4 2.7-1.2 3.8-1.7 4.3-.7.7-2.3 2-5.8 3.1-7.7 2.4-20.1 2.9-36.9.6-7.4-1-20.3-4.8-31.4-8-2.5-.7-5-1.4-7.2-2.1-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5.4 3.3.9 5.3 1.5 10.8 3.2 28.4 8.3 39.4 9.9h.1c18.9 2.5 39.2 3.1 56.4-2.3 8.9-2.8 17.8-7.5 24.9-15.2 7.3-7.8 11.8-17.6 13.4-28.5 1.7-11.4.2-22.4-5-32.3-5.1-9.6-12.9-16.1-20.5-20.7-13.7-8.2-31.5-12.3-45.1-15.5l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7-3-1.8-3.8-3-3.9-3.3-.1-.1-.6-1.1-.3-4.1.9-4 2.8-6.2 8.3-8z" })
  }
), cI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 299.3V432c0 26.5-21.5 48-48 48H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h384v-48H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4l326.2 163.1c32.6 16.2 53.1 49.5 53.1 85.8M448 304v-16l-320-57.1V304z" })
  }
), sI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7 7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5 7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512 114.6 512 0 397.4 0 256m375.4-118.6c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z" })
  }
), vI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M15.5 275.9 192 320l44.1 176.5c2.3 9.1 10.5 15.5 19.9 15.5s17.6-6.4 19.9-15.5L320 320l176.5-44.1c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L320 192 275.9 15.5C273.6 6.4 265.4 0 256 0s-17.6 6.4-19.9 15.5L192 192 15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9M71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zm370 0c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9m0 336-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9M71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z" })
  }
), eI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3l-128.3-68.5-128.3 68.5c-10.8 5.7-23.9 4.8-33.8-2.3s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zm-.1 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), lI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320 376.4.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6-42.8-87.8-.1.3zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3l-128.3-68.5-128.3 68.5c-10.8 5.7-23.9 4.8-33.8-2.3s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329z" })
  }
), tI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0c-12.2.1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8zm141.9 512c1.1.1 2.1.1 3.2 0z" })
  }
), wI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M404.2 309.5 383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88h122.8zm65.7 0 53.4 87c3.6 5.9 5.5 12.7 5.5 19.6 0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5c-7.7 12.8-21.6 20.5-36.5 20.5s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87-53.4-87c-3.6-5.9-5.5-12.7-5.5-19.6 0-20.6 16.8-37.4 37.4-37.4h109.9l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5l56.1 91.5h109.9c20.7 0 37.4 16.8 37.4 37.4 0 6.9-1.9 13.7-5.5 19.6zm-54-88 21.1 34.5 21.2-34.5zM283 112l-27-44-27 44zm-154.1 56H86.6l21.1 34.5zm-21.1 141.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44z" })
  }
), gI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v140.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7l-122-70.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7c8.8-15.4 28.4-20.6 43.7-11.8l122 70.4z" })
  }
), iI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m56 230.4-14.7-11.5c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176h158.5l44.1-138.8.1-.3 1.3-4 5.2-16.2C268.3 6.8 277.6 0 288 0s19.7 6.8 22.9 16.7l5.1 16.2 1.3 4 .1.3L361.6 176H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-2 1.5-.1.1-114 88.7 44.4 139.5.1.4 1.4 4.5 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1-3.7-2.9-.3-.3L288 406.4l-112.2 87.3-.3.3-3.7 2.9-13 10.1c-8.3 6.5-19.8 6.8-28.5.7s-12.3-16.9-9.1-27l5-15.7 1.4-4.5.1-.4 44.4-139.5-114-88.6-.1-.1-2-1.5zm232 105.1 34.4 26.7 47.9 37.2-19.7-61.8-11.8-37.2 30.8-24 57.1-44.4H320.6l-12.4-39-20.2-63.5z" })
  }
), mI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M254.4 50.4 214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4L172 320.7l-40 126-1.1 3.5-4.8 14.8-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l-4.6 14.3-1 3.2z" })
  }
), aI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7l130.8 101.8-51 160c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4l129.3 100.5c8.3 6.5 19.8 6.8 28.5.7s12.3-16.9 9.1-27l-51-159.9 130.8-101.8c8.1-6.3 11.3-17 8-26.7S530.3 176 520 176H361.5L310.9 16.7z" })
  }
), oI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m313 41-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM170.4 157.4c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3L192 460.4l-92.7 48.8c-17.6 9.3-38.2-5.7-34.8-25.3l17.7-103.3-75-73.2C-7 293.5.9 269.3 20.5 266.5L124 251.4l46.3-94zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zm0-158L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), nI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2z" })
  }
), rI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M148.8 7.7c13.4 11.5 15 31.7 3.5 45.1L64 155.8v61.8l107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6v-69.1l-87.5-94.8c-12-13-11.2-33.2 1.8-45.2s33.2-11.2 45.2 1.8l87.5 94.8c10.9 11.8 17 27.3 17 43.4v200.3c0 14.5-4.9 28.6-14 40L537 500c-11 13.8-31.2 16-45 5s-16-31.2-5-45l89-111.2v-54.4l-107.6 21.5C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4v61.8l88.3 103c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-88.3-103C5.5 386.2 0 371.4 0 356.2V155.8c0-15.3 5.5-30.1 15.4-41.7l88.3-103c11.5-13.4 31.7-15 45.1-3.5zm155.2 343V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4m-62.3-39 23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5h-32.7c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240H258c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6m39-62.3 23.1 23.1c5.1-3 10.6-5.3 16.5-6.8v-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zm111.3 156.6-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4m22.6-22.6c8.2-11.6 14-25 16.4-39.6H382c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5m-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zm-32.8 100.8c5.7-5.8 9.2-13.7 9.2-22.5 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2z" })
  }
), dI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v147.2l75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1l75.6 15.1V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.8l-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32m240 318.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4m-62.3-39 23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5h-32.7c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240H226c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6m39-62.3 23.1 23.1c5.1-3 10.6-5.3 16.5-6.8v-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zm111.3 156.6-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4m22.6-22.6c8.2-11.6 14-25 16.4-39.6H350c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5m-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zm-32.8 100.8c5.7-5.8 9.2-13.7 9.2-22.5 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2z" })
  }
), SI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M353.8 14 384 256v208c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V256l30.2-242c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14zM288 256v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32M48 72c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v184h56v-32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-9.6L72 444v4c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24m544 0c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v280c0 13.3-10.7 24-24 24s-24-10.7-24-24v-4l-88 26.4v9.6c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24" })
  }
), zI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56l-48.3 13.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94-103.5 15.1C.9 269.3-7 293.5 7.2 307.4l74.9 73.2-17.6 103.3c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3l-17.7-103.3 74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9l-103.5-15.1-46.3-94zm215.4 85.8 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z" })
  }
), pI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8V208c0 8.8-7.2 16-16 16H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h128c8.8 0 16 7.2 16 16v42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c4.1 7.1 6.5 15.3 6.5 24.1 0 26.5-21.5 48-48 48h-80c-11.5 0-21.6-6.1-27.3-15.2C292.2 474.9 258.2 480 224 480m0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96m0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160M80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32m48-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0m-16 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), MI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128m0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384m32-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-291.1-50.6L137 160h71c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32.1l65.5 57.3-2.2.4C109.1 221.4 96 237.4 96 256s13.1 34.6 31.4 38.3l2.2.4L64.1 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h176c17.7 0 32-14.3 32-32s-14.3-32-32-32h-71l51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z" })
  }
), xI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80 33.9 42.4 57.5 99.6 57.5 160 0 83.9-55.1 152.8-113.4 196.2-60.5 45-140.9 75.8-222.6 75.8-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1 19.6-15.8 41.4-26.8 63.3-37.8 27.3-13.8 54.6-27.6 77.7-50.7 13.8-13.8 19.7-27.9 30-52.9 3.2-7.7 6.8-16.5 11.2-26.6 7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17 6.9-15.7 13.3-27.1 21.5-34.7 7.5-7 17.5-11.7 33.9-11.7 25.4 0 53.3 16.2 75.5 44 22 27.5 36.5 64.1 36.5 100 0 40.8-28.3 84.6-74.7 119.2-46 34.2-106.8 56.8-165.4 56.8-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9 5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8 28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3-2.9 6.6-5.6 13.2-8.3 19.8-11.4 27.8-22.8 55.7-46.4 79.3-41.4 41.4-78.6 57.1-107 69l-1.1.5-.7.3c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360c0 39.3 33.9 60.8 66.8 72.1C165.1 443.9 207 448 240 448c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120-25.8-32.2-61.9-56-100.5-56-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), HI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 358.9v86.5c-80.4-13.5-143.9-77-157.3-157.4h102.2zm64 0 55.1-70.9h102.2c-13.4 80.4-76.9 143.9-157.3 157.3zM352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H66.7C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160zm-96 288a256 256 0 1 0 0-512 256 256 0 1 0 0 512" })
  }
), VI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 160.4c0-35.5 28.8-64.4 64.4-64.4 6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c14.9-24.9 22.8-53.4 22.8-82.4V288h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H112z" })
  }
), CI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7c26.1 8.7 43.7 33.1 43.7 60.7V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112v-70.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), LI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C78.3 0 64 14.3 64 32v32c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zm0 128v110.9c0 10.7-5.3 20.7-14.2 26.6l-26.1 17.4C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128z" })
  }
), BI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 70.7 57.3 128 128 128v64c0 35.3-28.7 64-64 64h-64C57.3 352 0 409.3 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-26.5 21.5-48 48-48 24.6 0 36 9.5 58.2 28.2 1.7 1.4 3.4 2.9 5.3 4.4 12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208v-80c0-70.7-57.3-128-128-128-47.4 0-88.7 25.7-110.9 64H256c-35.3 0-64-28.7-64-64zm253.1 300.7c-7.2 1.9-14.6 3.3-21.1 3.3-16.8.2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9.1-17.1 2.1-25.6 4.6 1.1-6.7 1.6-13.6 1.6-20.6v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 9.8-1 19.4-2.9 28.7" })
  }
), uI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z" })
  }
), RI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32S289.7 0 272 0zm112 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52v-96c0-28.7 23.3-52 52-52m-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12v-96c0-6.6-5.4-12-12-12s-12 5.4-12 12m-116.5-12c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9 29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20h-64c-11 0-20-9-20-20v-15.6c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z" })
  }
), $I1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32S289.7 0 272 0h-48zm72 192v128c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), kI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m547.6 103.8-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 26.1 0 49.3-11.4 65.2-29 15.9 17.6 39.1 29 65.2 29s49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 5 5.5 10.6 10.3 16.8 14.4 20.1-29.8 54.2-49.4 92.9-49.4 10.4 0 20.5 1.4 30.1 4.1 4.4-19.8 1.5-41.5-10.4-60.3zM128 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h264.6c-5.4-9.4-8.6-20.3-8.6-32v-96zm400-144c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), PI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V252.6c-4 1-8 1.8-12.3 2.3h-.1c-5.3.7-10.7 1.1-16.2 1.1-12.4 0-24.3-1.9-35.4-5.3v100.2L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7 15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 16 17.6 39.1 29 65.2 29 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.5-90.7C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1L95 49.1l-56.2-44zm73.4 218.1c4 .5 8.1.8 12.1.8 11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7M160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1h-.1c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c12.9 0 24.8-3.8 34.9-10.3L365.5 384z" })
  }
), FI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m547.6 103.8-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 26.1 0 49.3-11.4 65.2-29 15.9 17.6 39.1 29 65.2 29s49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 16 17.6 39.1 29 65.2 29 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4zm-47.9 151.1h-.1c-5.3.7-10.7 1.1-16.2 1.1-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V252.6c-4 1-8 1.8-12.3 2.3z" })
  }
), TI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5-13.4 31.2-36.9 59-56.3 78.7 32.8 1.8 57.4 18 68.2 26.6 4 3.2 6 8.1 6 13.2s-2 10-6 13.3c-11 9.2-36.3 26.8-66 26.8-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66 3.3-4 8.2-6 13.3-6s10 2 13.2 6c9.1 11.4 26.8 38.3 26.8 74v2.1c.7-.7 1.4-1.3 2-2 18.2-18.2 37.7-41.7 47.9-65.5C455.1 2.4 469.2-3.2 481.4 2zM0 336C0 160 96.2 64 192.2 64c32.7.1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5 0 96-96 192-272 192C48 512 0 464 0 336m172.8-163.2c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7m72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3m-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3m-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3m87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7m32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7m72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3m-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3m-40.7 130.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7" })
  }
), AI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-48c0-35.3-28.7-64-64-64zm-91.7 234.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45 14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4 13.7-8.9 29.1-23.6 29.1-45 0-13.5-6.4-24.5-14-32.6-7.5-7.9-17.3-14.3-27.8-19.6-21-10.6-49.5-18.9-82-24.8-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5 3.2 1.6 5.8 3.1 7.9 4.5 3.6 2.4 3.6 7.2 0 9.6-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3-3.6-2.4-3.6-7.2 0-9.6 2.1-1.4 4.8-2.9 7.9-4.5 15.3-7.7 38.8-14.9 69-20.5z" })
  }
), DI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M83 79.2C64.9 59.8 34.5 58.9 15.2 77s-20.3 48.5-2.2 67.8l110.5 117.9c15.1 16.1 36.3 25.3 58.4 25.3H592c26.5 0 48-21.5 48-48s-21.5-48-48-48H188.8zM240 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80 0c0-5.3-.7-10.5-1.9-15.5l49.9-36.3 49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 64-46.5h-81.6L368 336.9 344.8 320h-81.6l64 46.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), yI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M161.3 144c3.2-17.2 14-30.1 33.7-38.6 21.1-9 51.8-12.3 88.6-6.5 11.9 1.9 48.8 9.1 60.1 12 17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4-44.7-7-88.3-4.2-123.7 10.9-36.5 15.6-64.4 44.8-71.8 87.3-.1.6-.2 1.1-.2 1.7-2.8 23.9.5 45.6 10.1 64.6 4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1-9.3-6.3-15-12.6-18.2-19.1-3.1-6.1-5.2-14.6-3.8-27.4zm187.6 193.2c2.7 6.5 4.4 15.8 1.9 30.1-3 17.6-13.8 30.8-33.9 39.4-21.1 9-51.7 12.3-88.5 6.5-18-2.9-49.1-13.5-74.4-22.1-5.6-1.9-11-3.7-15.9-5.4-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3 24.9 8.5 63.6 21.7 87.6 25.6h.2c44.7 7 88.3 4.2 123.7-10.9 36.5-15.6 64.4-44.8 71.8-87.3 3.6-21 2.7-40.4-3.1-58.1h-75.7c7 5.6 11.4 11.2 13.9 17.2z" })
  }
), bI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0l-34 33.9-33.9-33.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3-33.9-34c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 34-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3 45.2 45.3-45.3 45.3zm67.9 67.9 45.2-45.3 45.3 45.3-45.3 45.2-45.3-45.3zm67.8-67.9 45.3-45.3 45.2 45.3-45.3 45.3zm22.6-67.9L256 233.4l-45.3-45.3 45.3-45.2 45.3 45.3z" })
  }
), fI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h15.3l89.6 128-89.6 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-15.3l-89.6-128 89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64zm448 256c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), UI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zm355 278.2-1.2-.9c-5.3-4.4-8.6-11-8.6-18.4 0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-5.3 0-10.2-1.7-14.2-4.6zM461 336h27c13.3 0 24 10.7 24 24 0 4.8-1.4 9.3-3.8 13zm26.4 144-121.9-96H312c-13.3 0-24-10.7-24-24 0-11.1 7.5-20.4 17.7-23.2l-62-48.8H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h30.8L32 121.2V416c0 35.3 28.7 64 64 64zM152 336h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), GI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm56 208h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24m256 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m-256 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m160 0h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), qI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8m-56 8v424h256V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56M96 96H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h32zm320 384h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-32zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48z" })
  }
), WI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72h-96zm176 72h-32V56c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56v72H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64 0 17.7 14.3 32 32 32s32-14.3 32-32h128c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64m-208 96h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), EI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8m-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v424H128V128zm-64 0h32v384H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64m384 384h-32V96h32c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64" })
  }
), OI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24m0 400c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24m232-120c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24zm-376-24c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24m325-147.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9M403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0M256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224" })
  }
), II1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2l-20.1 29.1C481 193 472.6 192 464 192c-32.9 0-62.4 14.2-82.9 36.7C368.6 171.1 317.3 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1 11.3 38.8 46.5 67.5 88.7 69l-9.4 51c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 1.9-.1 3.7-.2 5.5-35.6 12.6-61.5 45.6-63.7 85-10.1 3.6-20.9 5.5-32.2 5.5-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm32 160c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.6c7.4-36.5 39.7-64 78.4-64 35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72s-32.2 72-72 72z" })
  }
), NI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M371.1 13.1 391 121l-44.5 44.5C323.3 142.3 291.3 128 256 128c-70.7 0-128 57.3-128 128 0 35.3 14.3 67.3 37.5 90.5L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9zM256 160c26.5 0 50.5 10.7 67.9 28.1L188.1 323.9C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96m192 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-80 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0m112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64m128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-112-48a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-48-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), XI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256H448c0-70.7-57.3-128-128-128s-128 57.3-128 128h-62.9l-62.3-90.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96H224c0-53 43-96 96-96m296 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 488c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24m208 0c0-13.3 10.7-24 24-24h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24" })
  }
), KI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 0c-6.3 0-12 3.7-14.6 9.5l-24.8 55.4-56.7-21.7c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17L65 120.5 9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8-21.7 56.7c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6.8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9.8-12.6-3.6-17s-11.1-5.9-17-3.6l-56.6 21.6-24.8-55.4C172 3.7 166.3 0 160 0m0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128m32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V272z" })
  }
), QI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391l-19.9 107.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1-192 0m224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0" })
  }
), ZI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3 32.3 0 61.8 6.9 82.8 13.5 10.6 3.3 19.3 6.7 25.4 9.2 3.1 1.3 5.5 2.4 7.3 3.2.9.4 1.6.7 2.1 1l.6.3.2.1h.1l-6.3 12.7 6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7-6.3-12.7h.1l.2-.1.6-.3c.5-.2 1.2-.6 2.1-1 1.8-.8 4.2-1.9 7.3-3.2 6.1-2.6 14.8-5.9 25.4-9.2 21-6.6 50.4-13.5 82.8-13.5 30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1.3 1.9.5 3.8.5 5.7v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8M64 325.4V368l105.6-52.8c-10.7-1.9-22.2-3.2-33.9-3.2-23.7 0-46.2 5.1-63.2 10.5-3.1 1-5.9 1.9-8.5 2.9zm409.8-10.3c-10.5-1.9-21.9-3.1-33.4-3.1-23.7 0-46.4 5.1-63.6 10.5-2.7.8-5.2 1.7-7.5 2.5l2.3 41.2 102.3-51.1z" })
  }
), JI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M354.5 135.7 320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm39.1 89.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L512 432H406.7c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H64l-29.2-42.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6l90.4 62.3 90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM0 488c0-13.3 10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24" })
  }
), jI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M354.5 104.3 320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v103.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm48.7 132.8c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L64 432h105.3c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80H512l29.2-42.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345l-19.9-107.9zM0 488c0 13.3 10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24" })
  }
), YI1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h15.3l89.6 128-89.6 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-15.3l-89.6-128 89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64z" })
  }
), _I1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 368V144c0-61.9-100.3-112-224-112S0 82.1 0 144v224c0 61.9 100.3 112 224 112s224-50.1 224-112M308.2 198.4c-24.5 6.1-53.3 9.6-84.2 9.6-40.7 0-77.8-6.1-106-16.1 14.8-14.8 32.8-26.7 51.4-36.1 20.5-10.3 40.9-17 56.9-20.8 18.2 27.3 46.6 49.9 82 63.4zm-103.1-118c.8 6 2.1 11.9 3.8 17.7-17.3 4.7-37.4 11.8-57.5 21.9-24.5 12.3-49.9 29.4-70.3 52.7C70.2 164.1 64 154.4 64 144c0-32.8 61.7-59.8 141.1-63.6m40.7.2c78 4.3 138.2 31 138.2 63.4 0 9.8-5.5 19.1-15.4 27.4-69.5-5.5-113.5-48.4-122.8-90.8" })
  }
), hN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m479.7 320-73.8-24.5 100.4-169.9c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6l-7-2.3zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2 323.1 268c-14.6-4.9-30-7-45.2-6.4zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.8c-22.4 6.6-44.5-12.5-40.6-36l12.4-74.4zM32 384v-15c8.5.7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1V384c0 35.3-28.7 64-64 64-19.1 0-36.3-8.4-48-21.7-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.8 13.3-29 21.7-48.1 21.7-35.3 0-64-28.7-64-64" })
  }
), cN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M105.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 109.3V352c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128v242.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.3 41.4V160c0-35.3-28.7-64-64-64s-64 28.7-64 64v192c0 70.7-57.3 128-128 128S96 422.7 96 352V109.3l-41.4 41.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z" })
  }
), sN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M237 141.6c-5.3 11.2-16.6 18.4-29 18.4h-48v192c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128v192h48c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1l-80 96c-6.1 7.3-15.1 11.5-24.6 11.5s-18.5-4.2-24.6-11.5l-80-96c-7.9-9.5-9.7-22.8-4.4-34.1s16.6-18.4 29-18.4h48V160c0-35.3-28.7-64-64-64s-64 28.7-64 64v192c0 70.7-57.3 128-128 128S96 422.7 96 352V160H48c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1l80-96C109.5 4.2 118.5 0 128 0s18.5 4.2 24.6 11.5l80 96c7.9 9.5 9.7 22.8 4.4 34.1" })
  }
), vN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32C0 14.3 14.3 0 32 0h128c17.7 0 32 14.3 32 32v384c0 53-43 96-96 96S0 469 0 416zm223.6 393.9c.3-3.3.4-6.6.4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3zM182.8 512l192-192H480c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32zM128 64H64v64h64zM64 192v64h64v-64zm32 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), eN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232h105.1L505.7 40.2zM189.3 256c-12.7 0-24.9 5.1-33.9 14.1l-49 49 27.3 27.3 32 32 27.3 27.3 122.3-122.4c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H189.3zm-7.6 161L160 395.3 54.3 501l3.5 3.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5zM43 489.7 148.7 384 128 363.3 22.3 469zm-32-32L116.7 352 95 330.3 7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l3.5 3.5z" })
  }
), lN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 7c9.1 9.1 9.4 23.7.7 33.2L285.2 281.3l-54.4-54.4 241-220.6c9.5-8.7 24.1-8.3 33.2.7zM195.3 236.7l80 80c6.2 6.2 6.2 16.4 0 22.6-6.1 6.1-15.8 6.2-22.1.5l-81-81c-5.8-6.3-5.6-16 .5-22.1 6.2-6.2 16.4-6.2 22.6 0zm-57.7 57.7 23.7-23.7 80 80-23.7 23.7-80-80m-11.3 11.3 80 80-20.7 20.7-80-80 20.7-20.7M87 330.3l94.7 94.7-2.3 2.3-74.4 74.4c-6.7 6.6-15.6 10.3-25 10.3s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l74.3-74.3 2.3-2.3z" })
  }
), tN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511.8 18.6c.8-5.1-.8-10.3-4.5-13.9S498.5-.6 493.4.2l-75.8 12.6c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l102.7 102.7 207.5-207.6c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1l-39.6 39.6c-2.1 2.1-5.3 2.9-8.2 1.9l-33.9-11.3c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z" })
  }
), wN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135 7c-9.1 9.1-9.4 23.7-.7 33.2L360 286.9V181.8L168.2 6.3c-9.5-8.7-24.1-8.4-33.2.7m263 349.7 49 49 27.3-27.3 32-32 27.4-27.4-122.4-122.3c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v114.7c0 12.7 5.1 24.9 14.1 33.9zm125.3-4.7L629 457.7l3.5-3.5c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3zM512 363.3 491.3 384 597 489.7l20.7-20.7zm-32 32L458.3 417l87.5 87.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5zM247.6 211.4 222.9 234c-1.6-3.9-4.7-7.2-8.7-8.8-6-2.5-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l115.9-115.7c9-9 14.1-21.2 14.1-33.9v-6.6l74.3-81.2-50.7-55.5zm142.8-45.2 115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5zM152 344a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), gN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M4.7 4.7C8.5.9 13.9-.7 19.1.3l70.5 14.1c9.3 1.9 17.8 6.4 24.5 13.1l279.3 279.2-86.6 86.6L27.5 114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3 19.1c-1-5.2.6-10.6 4.4-14.4zm454.6 304 16 16c4.7 4.7 6 11.8 3.3 17.8l-27.5 62 56.2 56.2c6.2 6.2 6.2 16.4 0 22.6l-24 24c-6.2 6.2-16.4 6.2-22.6 0l-56.2-56.2-62 27.5c-6.1 2.7-13.1 1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0M96 329.4l50.7-50.7 86.6 86.6-50.7 50.7 20.7 20.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-4.7 4.7-11.8 6-17.8 3.3l-62-27.5-56.2 56.2c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1 3.3-17.8l16-16c6.2-6.2 16.4-6.2 22.6 0zm388.5-215.2L365.3 233.4l-86.6-86.6L397.8 27.5c6.7-6.7 15.2-11.3 24.5-13.1L492.9.3c5.2-1 10.7.6 14.5 4.4s5.4 9.2 4.4 14.5l-14.2 70.4c-1.9 9.3-6.4 17.8-13.1 24.5z" })
  }
), iN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v144c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V71l-96 19.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM32 0h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32S14.3 0 32 0m470.6 342.6-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3M0 128c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H32c-17.7 0-32-14.3-32-32m288 200a40 40 0 1 1 80 0 40 40 0 1 1-80 0m184 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80m-336.4-58 10.3 10.8 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L190 431.3l25.2 26.7c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512 34.6 512 0 477.4 0 434.7v-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320c0-39.8 32.2-72 72-72s72 32.2 72 72c0 21.5-9.4 40.8-24.4 54zm-68 50.3c-2.4 2.6-3.7 6-3.7 9.5v.9c0 7.3 5.9 13.3 13.3 13.3 3.5 0 6.9-1.4 9.4-3.9l14-14-19.5-20.6-13.4 14.8zM104 320a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), mN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8c18.2 15.2 28.7 37.7 28.7 61.5v346H352v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H160V166c0-23.7 10.5-46.3 28.8-61.5l121-100.8zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3zm199-120.2c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1l16.4 27.8-16.4 27.8c-3.2 5.4.7 12.1 7 12.1l32.3-.3 15.8 28.1c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3.3c6.2.1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3.3z" })
  }
), aN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m441 7 32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15-38.2 38.1 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3.3.6.7 1 1l16 16 56 56 56 56 16 16 1 1-191 191a55.924 55.924 0 0 1-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57v-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z" })
  }
), oN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h128v352c0 17.7 14.3 32 32 32s32-14.3 32-32V96h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192z" })
  }
), nN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96v128H288V96zm0 192v128H288V288zm-224-64H64V96h160zM64 288h160v128H64zm0-256C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z" })
  }
), rN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm88 64v64H64V96zm56 0h88v64h-88zm240 0v64h-88V96zM64 224h88v64H64zm232 0v64h-88v-64zm64 0h88v64h-88zM152 352v64H64v-64zm56 0h88v64h-88zm240 0v64h-88v-64z" })
  }
), dN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 64v256h160V160zm384 0H288v256h160z" })
  }
), SN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm384 64v64H64V96zM64 224h64v192H64zm384 0v192H192V224z" })
  }
), zN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 0v64h64V96zm384 0H192v64h256zM64 224v64h64v-64zm384 0H192v64h256zM64 352v64h64v-64zm384 0H192v64h256z" })
  }
), pN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.3 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h48.7l-38.4 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-74.3l-38.4-96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96.8zm124.8 256h-69l43.2 107.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6zm-307.2 0h-69l-33.6 84.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8zm38.4-96 38.4-96h84.7l38.4 96z" })
  }
), MN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h64v128H0zm448 64H160V32h288c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192h128v224h320zm-33.2 86.1c-2.5 6-8.3 9.9-14.8 9.9h-16v48c0 26.5-21.5 48-48 48h-48v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16v-48h-16c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4" })
  }
), xN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128 0v128h320V96zm320 192H128v128h320z" })
  }
), HN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0 67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288M113.3 151.9l240.8 240.8c-1.4 7.5-2.1 15.3-2.1 23.3 0 23.2 6.2 44.9 16.9 63.7-3 .2-6.1.3-9.2.3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), VN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm384 128v256H64V160h32v160c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16v-50.7c5 1.8 10.4 2.7 16 2.7h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16-7.2-16-16v-64zm-224 80v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16m80 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z" })
  }
), CN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256v-96h160v96zm0 64h160v96H64zm224 96v-96h160v96zm160-160H288v-96h160zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z" })
  }
), LN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm160 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), BN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 176 8.8 164.4c-5.4-2.7-8.8-8.2-8.8-14.3V73.9c0-6.1 3.4-11.6 8.8-14.3l25.5-12.8C41.8 19.8 66.6 0 96 0h256c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3V150c0 6.1-3.4 11.6-8.8 14.3L416 176v16l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 320v16l23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8H96c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4c-5.4-2.7-8.8-8.2-8.8-14.3v-76.2c0-6.1 3.4-11.6 8.8-14.3L32 336v-16L8.8 308.4c-5.4-2.7-8.8-8.2-8.8-14.3v-76.2c0-6.1 3.4-11.6 8.8-14.3L32 192zm80-112c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z" })
  }
), uN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm256 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0M384 64H64v320h320z" })
  }
), RN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm160 384c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16M384 64H64v320h320z" })
  }
), $N1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm112 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), kN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7-7.9 5.2-8.5 16.2-1.8 22.9l200.2 200.2c6.7 6.7 17.8 6.2 22.9-1.8M567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8-16.3 25-25.7 54.9-25.7 87 0 88.4 71.6 160 160 160 32.1 0 61.9-9.4 87-25.7M301.5 368h-283c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5m0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5z" })
  }
), PN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm32 64h224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32M64 368c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16m320 0c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16M80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), FN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m274.8 38.4 44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8l46 31.2c11.6 7.9 16.3 22.5 11.6 35.7l-17.1 47.7C441.1 209.2 354.3 160 256 160S70.9 209.2 18.9 284.4L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8l15.6-53.5c3.9-13.4 16.4-22.5 30.4-22.1l55.7 1.8c7.1.2 14.1-2 19.7-6.4l44.1-34.2c11-8.6 26.5-8.6 37.5 0zM512 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-141.4 114.6-256 256-256s256 114.6 256 256m-400-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), TN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80v149.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80m112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), AN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m345 39.1 127.8 129.3c52.4 53 52.4 138.2 0 191.2l-112 113.3c-9.3 9.4-24.5 9.5-33.9.2s-9.5-24.5-.2-33.9l111.9-113.3c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6.2-33.9s24.6-9.2 33.9.2zM0 229.5V80c0-26.5 21.5-48 48-48h149.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5M144 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), DN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32" })
  }
), yN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), bN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32m128 0c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32m160 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), fN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32zm96-32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32m160 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), UN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 32c17.7 0 32 14.3 32 32v211.6l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v168.9l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v126.3l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v83.6l53.9-18c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L544 215.1V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V236.4l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V279.1l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V321.7L160 343v105c0 17.7-14.3 32-32 32s-32-14.3-32-32v-83.6l-53.9 18c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L96 296.9V64c0-17.7 14.3-32 32-32" })
  }
), GN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1 12.7 8.5 23.1 20.4 20.3 36.9L296.4 208H236.2L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L220.1 208H168V64c0-4.4-3.6-8-8-8s-8 3.6-8 8v144H99.9L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L83.8 208H23.6L.4 69.3c-2.7-16.5 7.7-28.5 20.4-36.9 6.3-4.2 15.3-9.3 27.4-14.1zM24 240h272c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16m128 208c0 4.4 3.6 8 8 8s8-3.6 8-8V346.7c13.4 17.9 35.9 26.5 57.4 18.1l6.6 76c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7l-7.3-84.1c14.2-13.2 18.9-33.4 12.6-51.2h43.1l23.1 138.7c1.7 10.2-1.6 20.6-8.9 27.9-10.6 10.5-25.1 17.6-38.7 23-24.2 9.7-60.3 18.3-111.9 18.3s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23-7.3-7.3-10.6-17.7-8.9-27.9L23.6 304h43.1c-6.3 17.7-1.6 38 12.6 51.2L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l6.6-76c21.5 8.4 44-.2 57.4-18.1z" })
  }
), qN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m285.9 96-22-40.3L251 32h133c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h133l-12.9 23.7-22 40.3H64v201.9c8.3-3 16.2-6.8 23.3-10.8 6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 18.9 12.7 15.8 9 35.5 16.8 55.2 16.9h.4c19.6 0 39.3-7.9 55.2-16.9 6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 19 12.8 7.1 4 15 7.9 23.4 10.8V96zM175 139.2 212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7l37.2 68.2c4.6 8.4 7 17.9 7 27.5v1.3c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5z" })
  }
), WN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M380.8 416c41.5-40.7 67.2-97.3 67.2-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h320c17.7 0 32-14.3 32-32s-14.3-32-32-32zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192m64 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), EN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 160c-35.3 0-64-26.9-64-60 0-24 33.7-70.1 52.2-93.5 6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60M64 128h133.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64v160H448c-17.7 0-32 14.3-32 32v128H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64m384 384V384h128zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), ON1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h352V320c0-17.7 14.3-32 32-32h128zM448 448l128-128H448zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), IN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 416H32c-17.7 0-32-14.3-32-32V74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0h30.3c53.2 0 105.6 12.4 153.2 36.2 14.4 7.2 23.6 22 23.6 38.3V96c-21.9 0-40.4 14.7-46.2 34.8-6.1 1.4-12.1 3.3-17.8 5.6V120c0-13.3-10.7-24-24-24h-88v128h41.9l-16.3 48.9C208.5 290.2 192 319.2 192 352v64h-64v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32zm16-296v80c0 13.3 10.7 24 24 24h88V96H88c-13.3 0-24 10.7-24 24m56 200a24 24 0 1 0-48 0 24 24 0 1 0 48 0m248-168c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8h5.4c34.4 0 65 22 75.9 54.7l26.6 79.7c21.3 10.3 36.1 32.2 36.1 57.6v128c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32v-32H304v32c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32V352c0-25.4 14.8-47.3 36.1-57.6l26.6-79.7c10.9-32.7 41.5-54.7 75.9-54.7h5.4zm-20.6 82.9L329.7 288h204.6l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zM328 368a24 24 0 1 0-48 0 24 24 0 1 0 48 0m232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), NN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c-17.7 0-32 14.3-32 32v32.2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-26.7-16.4-49.6-39.6-59.2l-35.2-100.5c-12.9-36.8-46.6-62-85.2-64.1V32c0-17.7-14.3-32-32-32zm-26.6 128h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4M96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64m288 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), XN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M154.7 103.7C138.7 93.9 128 76.2 128 56c0-30.9 25.1-56 56-56 24.2 0 44.7 15.3 52.6 36.7 15.9-3.2 33.2-4.7 51.4-4.7s35.5 1.5 51.4 4.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56 0 20.2-10.7 37.9-26.7 47.7 1.8 7.4 2.7 15.5 2.7 24.3 0 70.7-60.9 128-136 128s-136-57.3-136-128c0-8.8.9-16.8 2.7-24.3M240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32m112-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0m0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48 28.7 48 64 48 64-21.5 64-48m-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24 14.3-24 32-24 32 10.7 32 24M50.3 178.3c20.8-16.4 51-12.8 67.4 8l25.8 32.7c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4L508 278.4c-17.7 22.4-37.9 41.3-59.9 56.7V400h16.6c3.9-27.1 27.2-48 55.4-48 30.9 0 56 25.1 56 56 0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6v.1H64v-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8 0-30.9 25.1-56 56-56 28.2 0 51.6 20.9 55.4 48H128v-64.9c-22-15.4-42.3-34.3-59.9-56.7l-25.8-32.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64h192c0-35.3-28.7-64-64-64z" })
  }
), KN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-53-43-96-96-96zm128 64c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-56c0-26.5 21.5-48 48-48m80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24v-24c0-26.5 21.5-48 48-48m336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zM96 480h384c53 0 96-43 96-96v-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96m0-64c-26.5 0-48-21.5-48-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48m80-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48m176 48c-26.5 0-48-21.5-48-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48m80-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48" })
  }
), QN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-53 43-96 96-96h384c53 0 96 43 96 96v256c0 53-43 96-96 96H96c-53 0-96-43-96-96zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56c0-26.5-21.5-48-48-48s-48 21.5-48 48m176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56c0-26.5-21.5-48-48-48M48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-24c0-26.5-21.5-48-48-48s-48 21.5-48 48m48 176c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48m80-48c0 26.5 21.5 48 48 48s48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm176 48c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48m80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-24c0-26.5-21.5-48-48-48s-48 21.5-48 48m48 176c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48" })
  }
), ZN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8zM11.8 343.6c-11.4 6.7-15.4 21.3-8.7 32.8L29 421.3c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5.8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4-44.1 108.1c-5 12.3.9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6 369.8 497c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3l-67.9-166.4 86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9-44.2 25.4z" })
  }
), JN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5zM176 0C114.1 0 64 50.1 64 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48m336-64h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v288h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9S524.8 352 511.8 352z" })
  }
), jN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5zM176 0C114.1 0 64 50.1 64 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48m304-256h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v288c0 17.7 14.3 32 32 32s32-14.3 32-32V160z" })
  }
), YN1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5zM160 0C98.1 0 48 50.2 48 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0m0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), _N1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48M48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16v210.7c18.6 6.6 32 24.4 32 45.3" })
  }
), hX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48M48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16v114.7c18.6 6.6 32 24.4 32 45.3" })
  }
), cX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.7 15.3-25.3 15.3-42.6zM144 0C82.1 0 32 50.2 32 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48" })
  }
), sX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.7 15.3-25.3 15.3-42.6zM144 0C82.1 0 32 50.2 32 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v146.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48M352 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32 160c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32m64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), vX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-128 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0M144 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48M32 112C32 50.2 82.1 0 144 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3" })
  }
), eX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48M48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3" })
  }
), lX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5zM432 0c-61.9 0-112 50.1-112 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8-18.9 24.4-30.1 55-30.1 88.1 0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C544 50.1 493.9 0 432 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48M288 131.6l-88 50.8v-55.8l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v25.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l35.3 35.3v55.8l-48.3-27.9-13-48.2c-2.2-8.6-11-13.6-19.5-11.3s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6S23 211.3 31.5 209l48.2-12.9L128 224l-48.3 27.9L31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2 48.3-27.9v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l12.7-12.7V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-25.4l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4v-55.8l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9V261l-64-37 64-37z" })
  }
), tX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m320.6 98.5-2.7-.5-14.1-84.6c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l70.8-49.6 70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6.7-.3 1.5-.7 2.1-1.1-5.4-16.9-8.3-34.9-8.3-53.7 0-37.7 11.8-72.6 32-101.2V112c0-4.5.2-9 .6-13.5M208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128m0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192m208 0c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5zM464 0c-61.9 0-112 50.2-112 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8-18.9 24.4-30.1 55-30.1 88.1 0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C576 50.2 525.9 0 464 0m0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48" })
  }
), wX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48M48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16v178.7c18.6 6.6 32 24.4 32 45.3" })
  }
), gX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64m0 128c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32" })
  }
), iX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M.2 245.1c-.1 3.6-.2 7.2-.2 10.9 0 141.4 114.6 256 256 256 3.7 0 7.3-.1 10.9-.2-3.8-10.7-6.6-21.8-8.4-33.1-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4 39.7-38.2 64.5-50.1 52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9.2-3.6.2-7.2.2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3.1-10.9.2 10.7 30.5 13.7 63.4 8.2 95.6-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8c22.2 9.2 46.4 13.2 70.6 11.4 34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zm238.6 288.7c-22.2.4-44 5.5-64 15.1s-37.7 23.3-52 40.3-24.6 36.9-30.5 58.3-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6 101.9-19.8 182.2-100.2 202.1-202.1-19.6-8.1-40.6-12.1-61.9-11.8z" })
  }
), mX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24v122.1l39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5.2 31.6 14.4 31.6 32 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h127.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7zM384 448h76.8L384 320z" })
  }
), aX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72h-403L120 41.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.6-33.9-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120h402.9l-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8S573 82.8 568 78.3l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z" })
  }
), oX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9s-24.1-10.6-34-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120H456c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c0-66.3-53.7-120-120-120H86.5L120 41.8zm187.3 124.7c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z" })
  }
), nX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24S88 10.7 88 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm-254.4 54.6c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z" })
  }
), rX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.4 6c11.1-8 26.1-8 37.2 0l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288v224H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5z" })
  }
), dX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M396.6 6.5 235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z" })
  }
), SX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M9.4 86.6c-12.5-12.5-12.5-32.7 0-45.2s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416h288c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), zX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128V96h64v320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V96h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32m438.6-86.6c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S556.9 352 543.9 352H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z" })
  }
), pX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128V96h96v320h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V96h96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32m320 176v-16h64v128h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V288h64v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v32c0 17.7 14.3 32 32 32s32-14.3 32-32" })
  }
), MX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503l-6 24.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1c7.5-30.3-15.4-59.6-46.6-59.6h-319c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3.2-.7.3-1L217 96h116.7l-32.4 114.8-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-42.2l17.6-62.1-54.5-42.9z" })
  }
), xX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128V96h128v128h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V96h128v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32M9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6v-32H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 307.1 320 320.1v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z" })
  }
), HX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96v32c0 17.7-14.3 32-32 32S0 145.7 0 128V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256v320h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V96z" })
  }
), VX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 382.1v-88.8c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0 465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6a55.924 55.924 0 0 1-39.6 16.4h-88.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z" })
  }
), CX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256M192 16C135.8 16 87.1 45.7 53.5 89.4 19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16m-64 208c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), LX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8 15.4 32.4 48.4 54.8 86.7 54.8s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8 70.7 0 128-57.3 128-128S454.7 80 384 80c-3.1 0-6.1.1-9.2.3M144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96M32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), BX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2h144c26.5 0 48-21.5 48-48 0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1 4.4-7.3 6.9-15.8 6.9-24.9 0-21.3-13.9-39.4-33.1-45.6.7-3.3 1.1-6.8 1.1-10.4 0-26.5-21.5-48-48-48h-97.5c-19 0-37.5 5.6-53.3 16.1l-38.5 25.7C176 91.6 160 121.6 160 153.7V264.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32" })
  }
), uX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2h144c26.5 0 48 21.5 48 48 0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1 4.4 7.3 6.9 15.8 6.9 24.9 0 21.3-13.9 39.4-33.1 45.6.7 3.3 1.1 6.8 1.1 10.4 0 26.5-21.5 48-48 48h-97.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32" })
  }
), RX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C32 14.3 46.3 0 64 0h256c17.7 0 32 14.3 32 32s-14.3 32-32 32h-29.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8S362.3 352 352 352H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64c-17.7 0-32-14.3-32-32m128 352h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z" })
  }
), $X1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4l-25.5 146.8C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z" })
  }
), kX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64v-48c0-8.8-7.3-15.8-15.8-18-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18v-48c0-35.3-28.7-64-64-64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32M176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L256 224h46.9c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.3 11.4-26.7 17.8-42.8 17.8H256l-49.1 84.1a23.93 23.93 0 0 1-20.7 11.9h-31.1c-5.5 0-9.3-5.4-7.6-10.5L176 288h-56l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H74.2c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9H88c5 0 9.8 2.4 12.8 6.4L120 224z" })
  }
), PX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192z" })
  }
), FX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6v-64c0-35.3-28.7-64-64-64zm64 112v160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16m-32-16c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z" })
  }
), TX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64v-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64m416 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0m16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32m-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0M265.3 106.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9l39.7 68.1h40.3c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.4 11.4-26.8 17.7-42.8 17.7h-40.3L324.7 308a23.93 23.93 0 0 1-20.7 11.9h-31.1c-5.5 0-9.3-5.3-7.6-10.5l23.1-69.4h-42.6l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4l19.2 25.6h42.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72z" })
  }
), AX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M99.9 192C80.1 192 64 208.1 64 227.9V320c0 17.7-14.3 32-32 32S0 337.7 0 320v-92.1C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3l152.2 152.2c6.7 6.7 15.9 10.5 25.4 10.5 19.8 0 35.9-16.1 35.9-35.9V192c0-17.7 14.3-32 32-32s32 14.3 32 32v92.1c0 55.2-44.7 99.9-99.9 99.9-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5" })
  }
), DX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m32 97.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160v54.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288h274.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l41.4 41.3H384v-54.7c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160zM328 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0M224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), yX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48m32 97.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256v54.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-54.7c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160zM488 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0M320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), bX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7c90.8 15.2 160 94.2 160 189.3 0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1 12.6-12.4 12.8-32.6.5-45.3s-32.6-12.8-45.3-.5C29.5 119.6 0 184.4 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0m-63 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z" })
  }
), fX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32C114.6 32 0 146.6 0 288c0 47.3 12.8 91.7 35.2 129.7C14.9 423.3 0 441.9 0 464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48 0-22.1-14.9-40.7-35.2-46.3 22.4-38 35.2-82.4 35.2-129.7 0-141.4-114.6-256-256-256m96 384c-2.1 1.6-4.3 3.2-6.6 4.7-25.5 17.2-56.3 27.3-89.4 27.3-36 0-69.3-11.9-96-32-38.9-29.2-64-75.7-64-128 0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128m-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64m16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6v65zm109.7-102.8c1.5-7.8 2.3-15.9 2.3-24.2 0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zm-128 64c0 8.3.8 16.3 2.3 24.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288m12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4v-65c-15.8-4.1-29.3-14.1-37.9-27.5z" })
  }
), UX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32v22.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4 17.5 35.6 33.4 82.6 27.5 136.2-5.3 48.6-28.1 99-76.8 148.7v34c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-34C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2 7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5V32C64 14.3 78.3 0 96 0s32 14.3 32 32v22.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5-14.7 29.7-25.3 64-21.3 100.9 3.7 34 20.4 74.1 65.7 117.7h246.9c45.3-43.6 62-83.7 65.7-117.7 4.1-36.9-6.6-71.1-21.3-100.9-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5zm-104 88v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24m-24 168a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), GX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v17.3c-14.9 4.4-29.2 10.4-42.6 17.7l-.9-.9-11.3-11.4c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9L58 148.5l.9.9c-7.3 13.4-13.2 27.7-17.7 42.6H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h17.3c4.4 14.9 10.4 29.2 17.7 42.6l-.9.9-11.4 11.3c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0l11.3-11.3.9-.9c13.4 7.3 27.7 13.2 42.6 17.7v17.3c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V470.7c14.9-4.4 29.2-10.4 42.6-17.7l.9.9 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9L454 363.5l-.9-.9c7.3-13.4 13.2-27.7 17.7-42.6h17.3c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24H470.7c-4.4-14.9-10.4-29.2-17.7-42.6l.9-.9 11.3-11.3c9.4-9.4 9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0L363.5 58l-.9.9c-13.4-7.3-27.7-13.2-42.6-17.7v-1.3zm-64 104a128 128 0 1 1 0 256 128 128 0 1 1 0-256m0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-61.1 2.9a24 24 0 1 0-14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0-45.7 14.8m-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0-38.8 28.2m-51.1-33.5a24 24 0 1 0-28.2 38.8 24 24 0 1 0 28.2-38.8" })
  }
), qX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-256a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-16.1 62v65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58 61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2 0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4zm-40.2-63.5 38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zm-111.3-33.8C143.5 186.1 128 219.2 128 256c0 8.3.8 16.3 2.3 24.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zM202 290.4l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4v-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320" })
  }
), WX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256m0 64h192c106 0 192-86 192-192S490 64 384 64H192C86 64 0 150 0 256s86 192 192 192m143.1-64c30.4-34 48.9-78.8 48.9-128s-18.5-94-48.9-128H384c70.7 0 128 57.3 128 128s-57.3 128-128 128z" })
  }
), EX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256" })
  }
), OX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128zm192 128c0-106-86-192-192-192H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192m-384 96a96 96 0 1 0 0-192 96 96 0 1 0 0 192" })
  }
), IX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 64C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192" })
  }
), NX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M348.2 0H96C43 0 0 86 0 192s43 192 96 192h252.2c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9 35.5 0 66.6-38.6 83.2-96 8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9M416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64M160 464c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V343.1c-19.1 37.8-51.2 72.9-96 72.9H160z" })
  }
), XX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 192c0-65.5 13.2-142.4 60.2-192H160c-53 0-96 86-96 192 0 101.5-11.7 170.8-23 213.9-5.1 19.4-10.7 39.9-20.5 57.7-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512h237.9c22.3 0 45.4-12.1 55.4-36.1C356.7 439 384 350.8 384 192m224 0C608 86 565 0 512 0s-96 86-96 192 43 192 96 192 96-86 96-192m-64 0c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64" })
  }
), KX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M444.2 0c-47 49.6-60.2 126.5-60.2 192 0 158.8-27.3 247-42.7 283.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3.4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192 64 86 107 0 160 0zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192-43 192-96 192m0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64m-220.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 225.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0z" })
  }
), QX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192 608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6 0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zm328.5 380.3-300.8-237C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9-5.1 19.4-10.7 39.9-20.5 57.7-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512h237.9c22.3 0 45.4-12.1 55.4-36.1 7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64" })
  }
), ZX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43v-83c-9.9 19.5-23.2 38.2-39.9 51.8L510 374.4c22.6-14.8 41.4-46 53.1-86.4 8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9-37.3 26.4-64 97.5-64 181.1 0 33.8 4.4 65.5 12 93.1l-39.3-30.8c-3.1-19.9-4.7-40.8-4.7-62.3 0-56.9 11.5-110 31.5-150.1 7.5-15 17.1-29.7 28.7-41.9H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM528 512l-121.8-96H224v48c0 26.5 21.5 48 48 48zh.3zM64 192c0 106 43 192 96 192h205.5l-299-235.6C64.9 162.4 64 177 64 192m416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64" })
  }
), JX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h252.2c-11.6 12.2-21.2 26.9-28.7 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96c-53 0-96-86-96-192S43 0 96 0m224 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192 0 35-4.7 67.8-12.8 96-16.6 57.4-47.6 96-83.2 96-11.2 0-22-3.8-32-10.9-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64-14.3-64-32-64-32 28.7-32 64M160 416h256c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48zM64 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0m64 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), jX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h252.2c-11.6 12.2-21.2 26.9-28.7 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96c-53 0-96-86-96-192S43 0 96 0m224 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192 0 35-4.7 67.8-12.8 96-16.6 57.4-47.6 96-83.2 96-11.2 0-22-3.8-32-10.9-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64-14.3-64-32-64-32 28.7-32 64M160 416h256c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48zm51.3-283.3c-6.2-6.2-16.4-6.2-22.6 0L152 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L174.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z" })
  }
), YX1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M444.2 0c-47 49.6-60.2 126.5-60.2 192 0 158.8-27.3 247-42.7 283.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3.4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192 64 86 107 0 160 0zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192-43 192-96 192m0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64m-368-48a16 16 0 1 0-32 0 16 16 0 1 0 32 0m64 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), _X1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v32h320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32m24 64H0v392c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h224v8c0 13.3 10.7 24 24 24s24-10.7 24-24V96h-24zm232 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), hK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h8v148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5 14.2 17.7 31.1 31.3 48.5 41.8l-19.9 59.6c-3.3 9.8-1.6 20.5 4.4 28.8S85.7 512 96 512h256c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8 22.7-28.4 37-65.5 37-112.5 0-23.1-10.9-41.5-26.4-54.6-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24zm360 256.3c0 1-.3 2.6-3.8 5.6-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4-3.5-3-3.8-4.6-3.8-5.6v-.4c0-1 0-2.5 3.8-5.8 4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4 3.8 3.2 3.8 4.8 3.8 5.8v.4zM328.2 384l-.2.5v-.5zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), cK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 0h192c17.7 0 32 14.3 32 32v32H0V32C0 14.3 14.3 0 32 0M0 96h256v392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24S0 501.3 0 488V120zm192 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16M352 0h192c17.7 0 32 14.3 32 32v32H320V32c0-17.7 14.3-32 32-32m-32 96h256v392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120zm192 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16" })
  }
), sK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m241 7-17 17zl.1.1.2.2.5.5c.4.4 1 1 1.7 1.8 1.4 1.5 3.2 3.6 5.4 6.3 4.4 5.4 10.1 13.1 15.8 22.8 6.6 11.2 13.4 25.5 18 42.1 45.7 3.1 88.5 14.2 125.1 32.8 6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3h-34.6l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4l-105.7 45.3c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4-4-7.9-.9-17.5 7-21.5l.8-.4c37.2-18.7 80.6-29.8 127-32.6-2.6-6.4-5.6-12.3-8.7-17.6-4.3-7.3-8.6-13-11.7-16.9-1.6-1.9-2.8-3.4-3.6-4.3-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5.1-33.9 9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5-.6 11.8 3.1 23.7 11 33.2 13.6 16.3 36.3 21.8 55.8 13.4l93.1-39.9 93.1 39.9c19.5 8.4 42.2 2.9 55.8-13.4 7.9-9.5 11.7-21.5 11-33.2 10.3-3.5 19.1-10.4 25-19.5 44 35.5 71.1 86.4 71.1 150 0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150" })
  }
), vK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0C118 0 32 86 32 192v224h384V192C416 86 330 0 224 0M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), eK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 192C32 86 118 0 224 0s192 86 192 192v224H32zM0 480c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32m248-360c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v120c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z" })
  }
), lK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 88v40h160V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8m-48 40V88c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0v-76.1C0 215.2 5.1 203 14.1 194L66 142.1c9-9 21.2-14.1 33.9-14.1zM0 416v-80h128v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h128v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h128v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64" })
  }
), tK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M186.1 52.1c-16.8-13-37.4-20.1-58.6-20.1C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8L267 74.5c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z" })
  }
), wK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64h224c31.2 0 38.2-22.7 39.6-48 .5-8.8 7.6-16.1 16.4-15.2 52.4 5.3 104 36.7 104 95.2 0 53-43 96-96 96zm-8 32c13.3 0 24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h144c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V280c0-13.3 10.7-24 24-24" })
  }
), gK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80c0 26.5 21.5 48 48 48h16v64h64v-64h96v64h64v-64h96v64h64v-64h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4.3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4zm64 208v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), iK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 32v13.6c0 17.1 1.7 34 5 50.4h352.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32m352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1m-226 138.2 116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1 0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2M288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4 5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z" })
  }
), mK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44m474.8-24C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7s-24.3-25.3-17.7-41.7c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84c-6.6-16.4 1.3-35 17.7-41.7s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4 0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1S119 221 112 204.8c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2.3-35.1 16.5-42.1S457 35 464 51.2z" })
  }
), aK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20 7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7s24.3-25.3 17.7-41.7C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44c10.5 25.9 16.3 54.2 16.3 84s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108c-6.7-16.4-25.3-24.3-41.7-17.7zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2l-137 301.6c-7.3 16.1-.2 35.1 15.9 42.4s35.1.2 42.4-15.9l20.5-45.3h220.6l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4zM369.2 384H206.8l14.5-32h133.4zM288 205.3l37.6 82.7h-75.2zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3.2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6c-7.3-16.6-11.3-35-11.3-54.4s4-37.8 11.3-54.4m293.4-19.2c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6c7.3 16.6 11.3 35 11.3 54.4s-4 37.8-11.3 54.4c-5.3 12.1.2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z" })
  }
), oK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v48h-40c-17.7 0-32 14.3-32 32H42.6C16 128-3.2 153.4 4.1 179l40.4 141.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32h32v96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32v-96h32c17.7 0 32-14.3 32-32 0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51H320c0-17.7-14.3-32-32-32h-40V48h16c13.3 0 24-10.7 24-24S277.3 0 264 0h-40zm-56 192v128h-17c-.1-.3-.1-.5-.2-.8L74.4 192zm48 128V192h96v128zm144-128h53.6l-36.4 127.2-.1.3-.1.5h-17z" })
  }
), nK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32v-80c-11.7 0-23-6.5-28.6-17.7-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448 256 399.2 197.5 448zM197.8 256l-4.7 28.3 62.9 52.5 62.9-52.5-4.7-28.3zm-13.9 83.2-11.2 67 45.8-38.2zM293.5 368l45.8 38.1-11.2-67zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), rK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 64c0-35.3 28.7-64 64-64h106.3c26.2 0 49.7 15.9 59.4 40.2l48 119.8H480v-33.8c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2-39.3 0-74.1 18.9-96 48h-80c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8v8.2c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0l-22.6-22.7c-12.5-12.5-12.5-32.8 0-45.3L46 398c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V64zm170.3 0H160v96h144.7zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160m352 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48m0 64c-48.6 0-88-39.4-88-88 0-29.8 14.8-56.1 37.4-72 14.3-10.1 31.8-16 50.6-16 2.7 0 5.3.1 7.9.3 44.9 4 80.1 41.7 80.1 87.7 0 48.6-39.4 88-88 88" })
  }
), dK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128v256c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224v160c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5.1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32h64v224c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32" })
  }
), SK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M173.7 128 216 20.3C220.8 8.1 232.7 0 245.8 0h20.4c13.2 0 25 8.1 29.8 20.3L338.3 128zm-25.1 64h214.8l37.7 96H110.9l37.7-96zM48 448l37.7-96h340.6l37.7 96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })
  }
), zK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96m0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48m0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96m-24-176a24 24 0 1 0 48 0 24 24 0 1 0-48 0m72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), pK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0-48 0m72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0m0-128a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-72-128a24 24 0 1 0 48 0 24 24 0 1 0-48 0m72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), MK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0-48 0m72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-48-152a24 24 0 1 0 0 48 24 24 0 1 0 0-48m0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96m0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96" })
  }
), xK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96m48-176a48 48 0 1 1-96 0 48 48 0 1 1 96 0m-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96" })
  }
), HK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32C21.5 32 0 53.5 0 80v256c0 26.5 21.5 48 48 48h17.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V80c0-26.5-21.5-48-48-48zm32 64c8.8 0 16 7.2 16 16v131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16m96 128c-5.4 0-10.7.2-16 .7V112c0-8.8 7.2-16 16-16s16 7.2 16 16v112.7c-5.3-.5-10.6-.7-16-.7m80 19.2V112c0-8.8 7.2-16 16-16s16 7.2 16 16v152.2c-9.8-8.1-20.6-15.2-32-21M368 96c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16m112 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16M176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), VK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h41.4l64.3-64.3c-32.4-3.2-57.7-30.5-57.7-63.7V192c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192c0 33.2-25.3 60.5-57.7 63.7l64.3 64.3H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0m105.4 512-64-64h-82.8l-64 64zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-24zm88 24v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24m-88 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48m168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), CK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v256c0 48 35.2 87.7 81.1 94.9l-46 46c-7 7-2 19.1 7.9 19.1h39.7c8.5 0 16.6-3.4 22.6-9.4L160 448h128l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm208-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-80c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32M64 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), LK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L147.6 96H112c-17.7 0-32 14.3-32 32s14.3 32 32 32h14.3L105 224H72c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.6l-21.3 64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h8.9l-7.3 21.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l14-42.1h359.3l14 42.1c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5l-7.2-21.9h8.9c17.7 0 32-14.3 32-32s-14.3-32-32-32h-30.3l-21.3-64H504c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32.9l-21.3-64H464c17.7 0 32-14.3 32-32s-14.3-32-32-32h-35.6l-14-42.1c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l7.2 21.8H215.1zM193.7 160h188.6l21.3 64H172.4l21.3-64zm252.6 192H129.7l21.3-64h273.9l21.3 64z" })
  }
), BK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0h274.4c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7l-12.7-16c-7.6-9.5-19.1-15-31.2-15H248v48h40c53 0 96 43 96 96v160c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5C420 500 415 512 405 512h-39.7c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32zm32 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), uK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h41.4l64.3-64.3c-32.4-3.2-57.7-30.5-57.7-63.7V192c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192c0 33.2-25.3 60.5-57.7 63.7l64.3 64.3H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0m105.4 512-64-64h-82.8l-64 64zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm104 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), RK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v256c0 48 35.2 87.7 81.1 94.9l-46 46c-7 7-2 19.1 7.9 19.1h39.7c8.5 0 16.6-3.4 22.6-9.4L160 448h128l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96zM64 96c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm160 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), $K1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M136 24v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24m160 0v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24M48 112c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16m160 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16M0 192c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c-17.7 0-32-14.3-32-32m232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8.3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4h-57.8l25-74.9c2.3-6.8-.3-14.3-6.3-18.3z" })
  }
), kK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4S393.5.1 400 .1h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8c19.5 26.5 31.1 59.3 31.1 94.8 0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-17.8c-77-11.6-136-78-136-158.2 0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7-19.8-19.7-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0zm240 256a96 96 0 1 0-192 0 96 96 0 1 0 192 0" })
  }
), PK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96M128 512c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H216zm255.7-224c-9.3-.1-18.5-4.2-24.7-12l-31-38.7V288H184v-50.7L153 276c-6.3 7.8-15.4 11.9-24.7 12h-.3c-7 0-14.1-2.3-20-7-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36l57.8 72c11 13.8 8.8 33.9-5 45-5.9 4.7-13 7-20 7zm-327 38.6L64 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 384l-25.4-7.3C2.7 375.6 0 372.1 0 368s2.7-7.6 6.6-8.7L32 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM176 320h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), FK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4c1.1 3.9 4.6 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 64l25.4-7.3c3.9-1.1 6.6-4.6 6.6-8.7s-2.7-7.6-6.6-8.7L64 32 56.7 6.6zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M128 512h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32m271.4-288-48.1-60c-18.2-22.7-45.8-36-74.9-36h-40.7c-29.1 0-56.7 13.2-74.9 36l-48.1 60zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7zm-368-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), TK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96M128 512h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32M56.7 102.6C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128l-25.4 7.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zM480 32l-7.3-25.4C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7zm-304 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), AK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16m-48 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m-32 64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16m-32 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m64 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m304-224 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM56.7 358.6 64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416l-25.4-7.3C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 480c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32" })
  }
), DK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m480 32 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM56.7 134.6 64 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 192l-25.4-7.3C2.7 183.6 0 180.1 0 176s2.7-7.6 6.6-8.7L32 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM384 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16m-48 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16m-64 128h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m64 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), yK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M56.7 6.6 64 32l25.4 7.3c3.9 1.1 6.6 4.6 6.6 8.7s-2.7 7.6-6.6 8.7L64 64l-7.3 25.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32l7.3-25.4C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6M384 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32m96-128 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16M112 256h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), bK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472.7 38.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288l-25.4 7.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7zm232 224h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88z" })
  }
), fK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88z" })
  }
), UK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m40 272v96h-64V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36l57.8 72c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416h-64v-96zm-32 192h-88c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32h-88zM64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128l-25.4-7.3C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM472.7 6.6 480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6z" })
  }
), GK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z" })
  }
), qK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z" })
  }
), WK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm305 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), EK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v64.7c-29.3 2.6-56.6 12.5-80 27.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v39.2c-29.8 31.5-48 74-48 120.8 0 59.5 29.6 112.1 74.8 144H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m64 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16" })
  }
), OK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80l-7.2-14.3C291.4 6.8 280.3 0 268.2 0zM384 128H32v336c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48zm-224 80v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16m128 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16m192-80c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32 160c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32" })
  }
), IK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm168 280c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), NK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128H195.6l-40.8-32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32h-96c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM304 213v-5c0-8.8 7.2-16 16-16s16 7.2 16 16v30zm96 75.2V208c0-8.8 7.2-16 16-16s16 7.2 16 16v105.3zM128 448c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8L431.5 436c-1.8 6.9-8 12-15.5 12-8.8 0-16-7.2-16-16v-20.8l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96.5l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V259.9l-80-63z" })
  }
), XK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64zm-198.2 71.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40c0-22.1-17.9-40-40-40h-57.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z" })
  }
), KK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm111 111c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), QK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" })
  }
), ZK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45zm305 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0z" })
  }
), JK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h229.7c-45.2-31.9-74.8-84.5-74.8-144 0-90.4 68.2-164.9 155.9-174.9zm160 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0m-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), jK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M147.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L304 32h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h80l7.2-14.3C124.6 6.8 135.7 0 147.8 0M32 128h352l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45zm448 0h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32m0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32m-32 160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32" })
  }
), YK1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45zm168 280c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z" })
  }
), _K1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.2 364.4 512 128H195.6l-40.8-32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32h-96c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM149.2 467c1.6 25.3 22.6 45 47.9 45h245.8c20.6 0 38.3-13 45.1-31.5L132.5 200.4z" })
  }
), hQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h245.8c25.3 0 46.3-19.7 47.9-45zm-198.2 71.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40c0-22.1-17.9-40-40-40h-57.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z" })
  }
), cQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0M32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45zm111 111c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), sQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h245.8c25.3 0 46.3-19.7 47.9-45z" })
  }
), vQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 160v96h128V32C57.3 32 0 89.3 0 160m0 272c0 26.5 21.5 48 48 48h80V288H0zm416-144h-64v32c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-32h-64v192h256zm112 192c26.5 0 48-21.5 48-48V288H448v192zm48-320c0-70.7-57.3-128-128-128v224h128zm-160 96V32H160v224h64v-32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32zm-112-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16z" })
  }
), eQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m150.2 71 47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7-17.7 47.1c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9M263 165l11.8-31.5 144 180c3.4 4.2 5.2 9.4 5.2 14.8 0 13.1-10.6 23.7-23.7 23.7H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2 0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H47.7C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8l144-180L185 165c6.1 16.2 21.6 27 39 27s32.9-10.8 39-27m-79 123a24 24 0 1 0-48 0 24 24 0 1 0 48 0m104 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), lQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v144h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16m176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16M224 160c0 6-1 11-2 16 20 14 34 38 34 64 0 45-36 80-80 80h-16v160c0 18-15 32-32 32-18 0-32-14-32-32V320H80c-45 0-80-35-80-80 0-26 13-50 33-64-1-5-1-10-1-16 0-53 42-96 96-96 53 0 96 43 96 96" })
  }
), tQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8c-9.9-4.4-20.9-6.8-32.4-6.8-44.2 0-80 35.8-80 80 0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288c0 53 43 96 96 96h128v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h128c53 0 96-43 96-96 0-39.7-24.1-73.8-58.5-88.4 6.7-11.7 10.5-25.2 10.5-39.6 0-44.2-35.8-80-80-80" })
  }
), wQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.6 5.9 62 169.4c-3.9 4.2-6 9.8-6 15.5 0 12.8 10.3 23.1 23.1 23.1H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1 0 13.3 10.8 24.2 24.2 24.2H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512h398.2c13.7 0 24.9-11.1 24.9-24.9 0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2 0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1 0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9M160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48m72-104a24 24 0 1 1 48 0 24 24 0 1 1-48 0m56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), gQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62 169.4 210.6 5.9C214 2.1 218.9 0 224 0s10 2.1 13.4 5.9L386 169.4c3.9 4.2 6 9.8 6 15.5 0 12.7-10.3 23.1-23.1 23.1H344l75.5 105.7c2.9 4.1 4.5 9 4.5 14.1 0 13.4-10.9 24.2-24.2 24.2H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2 0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H48.2C34.8 352 24 341.1 24 327.8c0-5 1.6-10 4.5-14.1L104 208H79.1C66.3 208 56 197.7 56 184.9c0-5.7 2.1-11.3 6-15.5" })
  }
), iQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m102.9 91.4 30.3 50.5c-4 3.5-8 7.2-12 11.2-71 71-60.2 151-32.7 191.3 5 7.3 15.2 7.3 21.4 1l138.5-138.5c4 10.8 7.8 26.2 9.7 47.2 4.2 46.5-1.6 116.8-32.7 216.4-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13h64c16.1 0 29.8-12 31.8-28 12.4-99-2.3-207.2-31.7-292h126.6c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0 59.6 0 10.7 64.2 1.6 112.1-.1 120.8 7.2 128 16 128h46.7c2.8 0 5.4-1.5 6.9-3.9l19.5-32.7c3.1-5.2 10.6-5.2 13.7 0z" })
  }
), mQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M210.6 5.9 62 169.4c-3.9 4.2-6 9.8-6 15.5 0 12.8 10.3 23.1 23.1 23.1H104l-73.4 73.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6H80L5.4 409.5c-3.5 4.2-5.4 9.5-5.4 15 0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h168.5c13 0 23.5-10.5 23.5-23.5 0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1 0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9" })
  }
), aQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M70.2 121.4 178.5 5.8C182 2.1 186.9 0 192 0s10 2.1 13.5 5.8l108.3 115.6c4 4.3 6.2 9.9 6.2 15.7 0 12.7-10.3 22.9-22.9 22.9H272l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H304l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H224v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64H23.5C10.5 416 0 405.5 0 392.5c0-5.5 1.9-10.8 5.4-15L80 288H55.5c-13 0-23.5-10.5-23.5-23.5 0-5.5 1.9-10.8 5.4-15L112 160H86.9C74.3 160 64 149.7 64 137.1c0-5.8 2.2-11.4 6.2-15.7zM341.6 105l92.9-99.2C438 2.1 442.9 0 448 0s10 2.1 13.5 5.8l108.3 115.6c4 4.3 6.2 9.9 6.2 15.7 0 12.7-10.3 22.9-22.9 22.9H528l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H560l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H480v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-88c-.1-12.8-4.7-25.2-12.9-35l-40.6-48.7c13-10.2 21.4-26 21.4-43.8 0-13-4.6-25.6-12.9-35.5l-40.4-48.5c12.9-10 21.3-25.8 21.3-43.4 0-11.6-3.7-22.8-10.4-32.1z" })
  }
), oQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32m0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), nQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v37.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94h324c51.9 0 94-42.1 94-94 0-17.8-5-35.2-14.5-50.2L448.2 239l-46.4 46.4 73.6 116.5c3 4.8 4.6 10.4 4.6 16 0 16.6-13.5 30-30 30H126c-16.6 0-30-13.5-30-30 0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9-51.2 51.2c-5.9-2.1-12.2-3.2-18.8-3.2-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l43.5-43.5 46.4-46.4L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6-40.4-63.7C353.6 89.2 338 76.7 320 69.9z" })
  }
), rQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480h432c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-23.2l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7 19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1.2 16.1s-8.2 8.1-13.9 8.1h-96c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8 22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), dQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480h432c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z" })
  }
), SQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h31.4c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3a29.6 29.6 0 0 1-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6.9C9.1 305.4 0 327.6 0 352c0 53 43 96 96 96 18.2 0 35.3-5.1 49.8-13.9-.6.4-1.2.7-1.8 1.1 14.1 8.2 30.5 12.8 48 12.8 53 0 96-43 96-96 0-4.1-.3-8.2-.8-12.2l55.1 10.7c4.9 1 9.9 1.4 14.9 1.4 24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L389.2 87.8C378.7 72.9 361.6 64 343.4 64zm-88.5 263.4c5.3 6.8 8.5 15.3 8.5 24.6 0 22.1-17.9 40-40 40-2.9 0-5.6-.3-8.3-.9 5.3-12 8.3-25.2 8.3-39.1 0-11.2-1.9-21.9-5.4-31.8zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80m448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80M94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3z" })
  }
), zQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4 0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8.7-1.6 1.4-2.3 2.2h-10.9c-58.8 0-114 23.9-154.1 64.6L133.6 176h2.4c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h21.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112 112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4 30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-2.4 0-4.8.1-7.2.2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4c0-34.5-27.9-62.4-62.4-62.4zm64.2 260 16.5 65.9c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7 0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112" })
  }
), pQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 160c0-64.1 61.6-128.2 86.1-151.1 5.6-5.3 14.1-5.3 19.8 0 24.5 23 86.1 87 86.1 151.1 0 15.7-3.7 30.4-10.4 43.5 16.2 0 32.6 4.2 47.7 12.9 55.5 32 80.2 117.4 87.8 150.2 1.8 7.5-2.5 14.9-9.9 17.1-32.1 9.7-118.4 31.1-173.9-1-16.6-9.6-29.2-23.3-37.4-39.2-8.1 15.9-20.8 29.6-37.4 39.2-55.5 32-141.8 10.7-173.9 1-7.4-2.2-11.6-9.6-9.9-17.1 7.6-32.7 32.3-118.1 87.8-150.2 15.1-8.7 31.6-12.9 47.8-12.9-6.6-13.1-10.3-27.8-10.3-43.5m136 80a40 40 0 1 0-80 0 40 40 0 1 0 80 0m88-80c0-12.5-1.8-24.8-4.8-36.6 38.6-12.8 68.2-11.9 83-10 14.9 1.9 23.7 17.1 17.9 31-5.6 13.3-19 38.4-47.7 64.6-8.1-7.7-17.1-14.6-27-20.3-7.3-4.2-14.9-7.6-22.6-10.3.9-6 1.3-12.1 1.3-18.4zm-251.2-36.6c-3 11.8-4.8 24.1-4.8 36.6 0 6.2.4 12.3 1.3 18.3-7.8 2.7-15.4 6.1-22.7 10.3-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31 14.7-1.9 44.4-2.8 83 10zm73.3 299.4c9.8-3.1 19.4-7.2 28.5-12.5 7.8-4.5 14.9-9.7 21.4-15.4 6.5 5.8 13.6 11 21.4 15.4 9.2 5.3 18.8 9.4 28.6 12.5-8.2 36.1-22.6 61.6-31 74.2-9.1 13.7-28.8 13.7-37.9 0-8.3-12.6-22.8-38.2-31-74.3z" })
  }
), MQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 0h224c26.5 0 48.1 21.8 47.1 48.2-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24 0 92.6-33.5 157-78.5 200.7-44.3 43.1-98.3 64.8-138.2 75.8-23.4 6.5-39.4 26-39.4 45.6 0 20.9 17 37.9 37.9 37.9H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h26.1c20.9 0 37.9-17 37.9-37.9 0-19.6-15.9-39.2-39.4-45.6-39.9-11-93.9-32.7-138.1-75.8C33.5 245 0 180.6 0 88c0-13.3 10.7-24 24-24h105.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0m-42.8 112H48.9c5.1 66.3 31.1 111.2 63 142.3 22.4 21.8 48.3 37.3 73.2 48.3-22.7-40.3-42.8-100.5-51.9-190.6zm257.6 190.6c24.9-11 50.8-26.5 73.2-48.3 32-31.1 58-76 63-142.3h-84.3c-9.1 90.1-29.2 150.3-51.9 190.6M295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4l-43 6.2c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4l38.4-20c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4l-7.3-42.8c-.4-2.6.4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4z" })
  }
), xQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2.2 5.3.4 10.6.7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7 44.3 43.1 98.3 64.8 138.1 75.8 23.4 6.5 39.4 26 39.4 45.6 0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-26.1c-20.9 0-37.9-17-37.9-37.9 0-19.6 15.9-39.2 39.4-45.6 39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2.5-10.4.7-15.8C448.1 21.8 426.5 0 400 0M48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6-24.9-11-50.8-26.5-73.2-48.3-32-31.1-58-76-63-142.3zm415.2 142.3c-22.4 21.8-48.3 37.3-73.2 48.3 22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z" })
  }
), HQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48h-88c-14.9 0-27.4-10.2-31-24h-89v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32m192 0h256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32" })
  }
), VQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343.9 213.4 245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8.5-32.2-7.9s-11.5-20.9-7.9-32.2l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4.5 30.3 8.4l65.3 65.3 98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5.3z" })
  }
), CQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48zm416 208h128v-18.7L466.7 160H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h166.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9z" })
  }
), LQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48zm368 160h50.7l77.3 77.3V256H416zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0m368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M270.3 87.2 233.9 160H288c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4l36.5-72.9H128c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9.5s7.4 12.8 4.1 19.4z" })
  }
), BQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48zm416 208h128v-18.7L466.7 160H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M320 176a112 112 0 1 0-224 0 112 112 0 1 0 224 0M208 96c8.8 0 16 7.2 16 16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16" })
  }
), uQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M456 144c-13.3 0-24 10.7-24 24v152H32c-17.7 0-32 14.3-32 32v48c0 44.2 35.8 80 80 80 26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h1.6c17.7 0 32-14.3 32-32v-90.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zm129 112H480v-64h48.8c2.4 0 4.7 1.1 6.2 2.9zm-57 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-352 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), RQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 32h304c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48m32 48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16m144 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16m-64-16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16m144 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16m128 72c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5l58.9 71.9c5.8 7.1 9 16.1 9 25.3V352c0 17.7-14.3 32-32 32h-1.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H286.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80v-48c0-17.7 14.3-32 32-32h400v-64zm48 88h105l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480zm80 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-96-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), $Q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48zm416 208h128v-18.7L466.7 160H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M208 272c39.8 0 72-29.6 72-66 0-27-39.4-82.9-59.9-110.3-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66" })
  }
), kQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0C85.5 0 64 21.5 64 48v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48zm432 237.3V256H416v-96h50.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96m272 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0" })
  }
), PQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32c-35.3 0-64 28.7-64 64v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32v-32c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38h-51.8c-11-19.1-31.7-32-55.4-32zm288 96h43.2l42.7 96H384zM112 384a48 48 0 1 1 96 0 48 48 0 1 1-96 0m368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96M253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), FQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 96c0-35.3 28.7-64 64-64h224c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1.9 2.1 1.3 3.2h4.2c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm352 128h85.9l-42.7-96H384zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), TQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M608 416h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h56.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H352V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32M416 160v96h128v-18.7L466.7 160zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), AQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 80C0 35.8 35.8 0 80 0h352c44.2 0 80 35.8 80 80v288c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-48c-19.4-14.6-32-37.8-32-64zm129.9 72.2L112 224h288l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), DQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48zm416 208h128v-18.7L466.7 160H416zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96m368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0M176 80v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), yQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 64v64h128l-48-64zm131.2-38.4L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64h-64c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h160V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6M152 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.7 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3 3.7 6.8 6.8 14.1 9 21.7C279 353.9 288 363.9 288 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.8 3.7-14.1 6.8-21.7 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.4-11.3c-8.6-8.6-9.3-21.9-2.3-31.3-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9 1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m288.2-155.4C449.9 265 459.9 256 472 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.8 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3 3.7 6.8 6.8 14.1 9 21.7C599 353.9 608 363.9 608 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.9 3.7-14.1 6.8-21.8 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3-3.7-6.9-6.8-14.1-9-21.8-11.8-1.7-20.7-11.7-20.7-23.8v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0" })
  }
), bQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v304c0 44.2 35.8 80 80 80 26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h1.6c17.7 0 32-14.3 32-32v-90.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64zm521 224H480v-64h48.8c2.4 0 4.7 1.1 6.2 2.9zm-57 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-352 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), fQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m368.6 96 76.8 96H288V96zM224 80v112H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32h33.1c-.7 5.2-1.1 10.6-1.1 16 0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16 0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h33c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c0-17.7-14.3-32-32-32h-48.6L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48m0 288a48 48 0 1 1-96 0 48 48 0 1 1 96 0m288 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0" })
  }
), UQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M200 0c-30.6 0-56 54.7-56 86.1v106.4L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2l91.1-30.3 90.4 30.1c-1.6-4.7-2.4-9.8-2.4-15v-32.6c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V86.1C256 54.7 231.5 0 200 0m88 176v224c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-40h160v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-42.7c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48m79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7h151.4c9.2 0 17.2 6 20.5 14.7L576 304H352zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), GQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96v96h135.5l-57.6-96zm-64 96V80c0-26.5 21.5-48 48-48h93.9c22.5 0 43.3 11.8 54.9 31.1L402.1 192H448c17.7 0 32 14.3 32 32v64h32V176c0-7.3 2.5-14.3 7-20l64-80c11-13.8 31.2-16 45-5s16 31.2 5 45l-57 71.2V356.8l57 71.2c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-64-80c-4.5-5.7-7-12.7-7-20v-16h-37.5c3.5 10 5.5 20.8 5.5 32 0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H224c-1.9 0-3.8-.2-5.6-.5 3.7 10.2 5.6 21.1 5.6 32.5 0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm32 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0m256 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), qQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 0v400c0 61.9-50.1 112-112 112-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64zm-64 400a48 48 0 1 0-96 0 48 48 0 1 0 96 0M23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2l-154.6 41.5c-17.1 4.6-34.6-5.6-39.2-22.6z" })
  }
), WQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 0v400c0 61.9-50.1 112-112 112-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64zm-64 400a48 48 0 1 0-96 0 48 48 0 1 0 96 0M294.5 209.2c8.7-2.3 17.4-2.1 25.5.2v125.4l-38.7 10.4-154.6 41.4-61.8 16.6c-17.1 4.6-34.6-5.6-39.2-22.6l-12.4-46.4c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5-11 2.9-20.8 8-29.2 14.7z" })
  }
), EQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M640 400V0H416c-35.3 0-64 28.7-64 64v289.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416 402.7c1.5 60.6 51 109.3 112 109.3 61.9 0 112-50.1 112-112m-112-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), OQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0h49.6c9.1 0 17.8 3.9 23.9 10.7L384 252V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V376c0 22.1-17.9 40-40 40h-24c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h144L96 64v112c0 26.5-21.5 48-48 48S0 202.5 0 176v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 14.3 78.3 0 96 0m480 256v-18.7L498.7 160H448v96zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0m272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), IQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 0C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48zm368 160h50.7l77.3 77.3V256H416zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0m368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96" })
  }
), NQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M628.7 64.7C635.4 66.8 640 73 640 80v288c0 7-4.6 13.2-11.3 15.3s-14-.4-17.9-6.2l-.1-.2-.7-.9c-.6-.8-1.5-2.1-2.8-3.8-2.5-3.3-6.2-8.1-11-13.9-9.6-11.6-23.6-26.9-40.8-42.3-35-31.1-81.3-60-131.4-60h-24v126c27.6-7.1 48-32.2 48-62v-29.2c22 5 43.7 16.4 64 31.2-1.1 69.8-58 126-128 126H192c-70.7 0-128-57.3-128-128 0-23.3 6.2-45.2 17.1-64H46.6c-3.3 9.3-12.2 16-22.6 16-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24 10.4 0 19.3 6.7 22.6 16H176v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h24c50.1 0 96.4-28.8 131.4-60 17.3-15.3 31.2-30.7 40.8-42.3 4.8-5.8 8.5-10.6 11-13.9 1.2-1.7 2.2-2.9 2.8-3.8l.7-.9.1-.2c4-5.8 11.2-8.3 17.9-6.2zM312 384h40V256h-40zm-88-128v128h40V256zm-96 64c0 29.8 20.4 54.9 48 62V258c-27.6 7.1-48 32.2-48 62" })
  }
), XQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16m0 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-208 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16z" })
  }
), KQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m38.3 241.3-23.2-40.7c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4l-81.2 26.6c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m-304 16c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z" })
  }
), QQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h128v103L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 265v30L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 361v87c0 17.7 14.3 32 32 32s32-14.3 32-32V345l103.8-26c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 279v-30l103.8-26c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 183V96h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192z" })
  }
), ZQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96 176 96 0 224 0 384c0 128 160 128 288 128s288 0 288-128c0-63-27.3-121.1-67.3-168.3-.4.2-.7.4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3-61.8 50-152.5 40.5-202.5-21.4-13.9-17.2-23.2-36.6-28.1-56.7-2.3-9.4 5.3-17.9 15-17.9 8 0 14.6 5.8 16.9 13.5 4 14.5 10.9 28.5 21 41 21.3 26.3 52.1 40.5 83.5 41.5 25.9.8 52.2-7.3 74-24.9 18.6-15 31.1-34.8 37.2-56.2l.6-2c9.6-33.7 20.1-70.5 48.7-90.6l25.8-18.2 2.5-1.8c18.3-12.9 43.3-10.4 67.4-8 9.4.9 18.6 1.8 27.3 1.8 30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2 1.1-4.4 1.7-9 1.7-13.8 0-30.9-25.1-56-56-56s-56 25.1-56 56z" })
  }
), JQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 32c17.7 0 32 14.3 32 32v35.3l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6v-29.5l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32" })
  }
), jQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22v88h192c17.7 0 32-14.3 32-32V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v144c0 70.7-57.3 128-128 128H192v88c0 9.6-5.7 18.2-14.5 22" })
  }
), YQ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6S320 142.5 320 152v88H128c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v144c0 70.7 57.3 128 128 128h192v88c0 9.6 5.7 18.2 14.5 22" })
  }
), _Q1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26S46.5 320 56 320h88V128c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0h80c70.7 0 128 57.3 128 128v192h88c9.6 0 18.2 5.7 22 14.5" })
  }
), hZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S46.5 192 56 192h88v192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h80c70.7 0 128-57.3 128-128V192h88c9.6 0 18.2-5.7 22-14.5" })
  }
), cZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm384 160a160 160 0 1 0-320 0 160 160 0 1 0 320 0m128-144c0-8.8-7.2-16-16-16s-16 7.2-16 16v160.4c0 2.5-.6 4.9-1.7 7.2l-16.2 32.5c-11 .7-21.4 7-26.7 17.6l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c5.3-10.6 4.2-22.7-1.9-31.9l16.2-32.4c3.3-6.7 5.1-14 5.1-21.5zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), sZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 249.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 38.8c-2 0-4-.1-5.9-.3-16.3 53.3-64.3 92.7-122.1 96V440c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-56h-32v56c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-56H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h312c39.8 0 72-32.2 72-72v-72c0-35.3 28.7-64 64-64 53 0 96 43 96 96v16c0 35.3-28.7 64-64 64zm16-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), vZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 64v288H64V64zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 480c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32m320-368c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v97.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32v-68.9l96-36v42.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V112z" })
  }
), eZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H80C35.8 96 0 131.8 0 176v256c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H321.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87zm255 225a24 24 0 1 1 48 0 24 24 0 1 1-48 0m24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48M64 224c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64z" })
  }
), lZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64v288h512V64zM0 64C0 28.7 28.7 0 64 0h512c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128 384h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), tZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64c0-35.3 28.7-64 64-64h226.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v160c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32zm320 64h-32c-17.7 0-32-14.3-32-32V64H128v128h18.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4h101.5c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H384zM160 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32m64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m-320 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32m64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32m64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0m48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32m80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), wZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v224c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 106-86 192-192 192S0 394 0 288V64c0-17.7 14.3-32 32-32" })
  }
), gZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M184 152s24 40 104 40 104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104m-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4M120 208a24 24 0 1 0-48 0 24 24 0 1 0 48 0m360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-168 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0M74.3 325.7l4.2-8.9c14.3 5.6 29.7 10.6 46 15l-6.8 14.5-72 152c-5.7 12-20 17.1-32 11.4s-17.1-20-11.4-32l72-152m384 20.6-6.8-14.5c16.3-4.4 31.7-9.4 46-15l4.2 8.9 72 152c5.7 12 .6 26.3-11.4 32s-26.3.6-32-11.4l-72-152z" })
  }
), iZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 112c59.2 0 109.6 37.9 128.3 90.7 5 14.2 7.7 29.4 7.7 45.3 0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3 18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64m0 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48m-216-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0m408-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), mZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m346.3 271.8-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4 6.5-78.5-23.9-155.5-80.8-208.5 2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4-.9-.4-1.9-.7-2.8-1.1-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zm-354.8 13.8c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2-79.6 2.5-154.7 42.2-201.2 108z" })
  }
), aZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v2c115.8 14.4 207.6 106.2 222 222.1 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9C16.4 140.2 108.2 48.4 224 34v-2c0-17.7 14.3-32 32-32m32 430.6c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4V320h64z" })
  }
), oZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 0c17.7 0 32 14.3 32 32v17.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7-14-15.6-41.3-26.6-66.1-26.6-38.7 0-71 27.5-78.4 64.1-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7-10.5 11.7-29.8 2.8-27.8-12.8C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32m0 304c12.3 0 23.5 4.6 32 12.2v114.4c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2" })
  }
), nZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v128c0 53 43 96 96 96s96-43 96-96V96h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v128c0 88.4-71.6 160-160 160S64 312.4 64 224V96H48c-17.7 0-32-14.3-32-32M0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32" })
  }
), rZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M448 160v80c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3.3 4.6.3 6.9 0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1h-33.7c-13.8 0-26-8.8-30.4-21.9l-17.4-52.4c-10.6-31.7-6.5-65.9 10-93.9 7.6-12.9 9.5-29.1 1.2-41.6l-28.3-42.3c-7.3-11-11.9-23.4-13.6-36.4-10 7.3-16.6 19.1-16.6 32.5v56c0 13.3-10.7 24-24 24S0 325.3 0 312v-56c0-44.6 33.2-81.5 76.3-87.2 14.9-24.4 41.8-40.8 72.5-40.8H320C320 57.3 377.3 0 448 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1-26.1 10.4-55.7-.9-68.3-26zm64-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0" })
  }
), dZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M180 0h37.6c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288H144V133.1l-46 83.6c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h20zm209.1 20.6C393.8 8.2 405.7 0 419 0h61c1 0 2 .1 3 .3 32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7L496 133v155H287.2l52.7-138.3 49.2-129.1zM320 320h176v32H349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l47.4-71.1H144v-32h120zm-103.9 85.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3l24-36.2 24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384H496v64c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64v-64h86.3l-14.2 21.4z" })
  }
), SZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c17.7 0 32 14.3 32 32v224c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 106-86 192-192 192S0 394 0 288V64c0-17.7 14.3-32 32-32" })
  }
), zZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0m161.5-86.1c-12.2-5.2-26.3.4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6v-50c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6l-12 5c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80" })
  }
), pZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 64c-44.2 0-80 35.8-80 80v48h240c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h16v-48C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3 7.6 16 .8 35.1-15.2 42.6s-35.1.8-42.6-15.2C283.4 82.6 255.9 64 224 64m32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32z" })
  }
), MZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 144c0-44.2 35.8-80 80-80 31.9 0 59.4 18.6 72.3 45.7 7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0 144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144z" })
  }
), xZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96h-96V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S332.9 384 319.9 384H288v-96h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S384 179.1 384 192.1v32h-96V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z" })
  }
), HZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160h56v192H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9S241.5 352 232 352h-56V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z" })
  }
), VZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M73.9 134.1 196.7 11.3C203.9 4.1 213.8 0 224 0s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V192H97.9C79.2 192 64 176.8 64 158.1c0-9 3.6-17.6 9.9-24M64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32" })
  }
), CZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M73.9 166.1 196.7 43.3C203.9 36.1 213.8 32 224 32s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V224H97.9C79.2 224 64 208.8 64 190.1c0-9 3.6-17.6 9.9-24M32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), LZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41.9 166.1 164.7 43.3C171.9 36.1 181.8 32 192 32s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H256v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V224H65.9C47.2 224 32 208.8 32 190.1c0-9 3.6-17.6 9.9-24M32 416h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), BZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 80h240c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-72 72 134 134c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l-72 72c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z" })
  }
), uZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192h72v288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h72c9.6 0 18.2-5.7 22-14.5" })
  }
), RZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M344 0h144c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0M168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z" })
  }
), $Z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h320c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h112c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), kZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l72 72-134 134C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3l134.1-134.1 72 72c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z" })
  }
), PZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64m128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0m64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64m96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64M73.9 262.1l122.8-122.8c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V320H97.9C79.2 320 64 304.8 64 286.1c0-9 3.6-17.6 9.9-24z" })
  }
), FZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M342.1 262.1 219.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L41.9 262.1c-6.4 6.4-9.9 15-9.9 24 0 18.7 15.2 33.9 33.9 33.9H128v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320h62.1c18.7 0 33.9-15.2 33.9-33.9 0-9-3.6-17.6-9.9-24M32 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32" })
  }
), TZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9S365 256.1 352 256.1h-96V440c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V256H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l160-160z" })
  }
), AZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM64 352h128c0 35.3 28.7 64 64 64s64-28.7 64-64h128c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-32c0-35.3 28.7-64 64-64m368 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), DZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zm544 32H480v256h128c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32m-48 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48m24 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0" })
  }
), yZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167m244.6 9c-37.9 0-68.6 30.7-68.6 68.6 0 6.3 5.1 11.4 11.4 11.4h16c37.9 0 68.6-30.7 68.6-68.6 0-6.3-5.1-11.4-11.4-11.4zM208 244.6c0-37.9-30.7-68.6-68.6-68.6h-16c-6.3 0-11.4 5.1-11.4 11.4 0 37.9 30.7 68.6 68.6 68.6h16c6.3 0 11.4-5.1 11.4-11.4M0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1 12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4" })
  }
), bZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9 24.6 56.6 81 96.1 146.7 96.1s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9v-64c0-16.8-12.9-30.5-29.3-31.9M336 144v16c0 53-43 96-96 96h-32c-53 0-96-43-96-96v-16c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48m-146.7 18.7-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3.9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3zm-76.6 153.8C46.7 342.6 0 407 0 482.3 0 498.7 13.3 512 29.7 512H128v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h98.3c16.4 0 29.7-13.3 29.7-29.7 0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5M176 448c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16m96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), fZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M323 120c-13.6-42-53-72-99-72s-85.4 30-99 72zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9v-98.4zM96 70c27.1-42.3 74.5-70 128-70 80.1 0 146.5 62.2 151.7 142.2l7.3 114.3c1.3 20-12.4 37.9-32.1 41.8l-100.8 20.1c-5.2 1-10.4 1.6-15.7 1.6h-20.9c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6-1-3.4-1.6-7-1.6-10.7V16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm38.4 282h179.2c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352m37.1 103.4c-3.7 2.8-1.7 8.6 2.9 8.6h99.2c4.6 0 6.6-5.9 2.9-8.6l-47.7-35.8c-2.8-2.1-6.8-2.1-9.6 0z" })
  }
), UZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M625 177 497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
  }
), GZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M384 48c0 20.9-13.4 38.7-32 45.3V176c0 70.7-57.3 128-128 128S96 246.7 96 176V93.3C77.4 86.7 64 68.9 64 48c0-26.5 21.5-48 48-48 14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48m-80 128v-16H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80M178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3c-24.3 9.7-40.2 33.2-40.2 59.4V512H25.6C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127 3.3-1.2 5.7-4.3 5.7-7.8v-21.4c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512H128v-79.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4v18.6c0 3.5 2.3 6.6 5.7 7.8 52.6 18.2 90.3 68.2 90.3 127 0 14.1-11.5 25.6-25.6 25.6zm-128-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0m80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), qZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m-45.7 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304M352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16" })
  }
), WZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4-27.6 9.6-67 17.6-120 17.6s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9 4.8 3.3 8.8 6.1 15.5 6.1M8.6 97.8c7-3.6 15.5-1.7 20.2 4.6 5.6 7.5 22.7 22 55 34.7 32 12.5 78 22.9 140.2 22.9s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7 4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9-7.1 5.2-14.7 10.1-22.7 14.8v2.3c0 70.7-57.3 128-128 128S96 294.7 96 224v-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4.8-15.6 7.8-19.2zM100.7 384h246.6c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36H36.2C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z" })
  }
), EZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 128v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm0-108.8c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2.6-.4.8-.6l3-2.4 15.7-12.6c2.8-2.3 6.4-3.5 10-3.5h2.4c8.8 0 16 7.2 16 16v128c0 70.7-57.3 128-128 128S96 214.7 96 144V16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3.2.6.4.8.6l.1.1zM0 472c0-92.8 75.2-168 168-168h112c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z" })
  }
), OZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5zm192 192v42c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-40c0-29.8-20.4-54.9-48-62v-38.6c73.1 15.3 128 80.2 128 157.8 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-77.7 54.9-142.5 128-157.8v46.9c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V320h126.7zM120 424a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), IZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16h31.8c28.9 0 55.8-15.2 70.6-40l5.3 5.3C265 89 280.8 95.7 297.3 96c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0m64 320H160v50.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-46.9C54.9 338.8 0 403.6 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-77.7-54.9-142.5-128-157.8V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62zM168 424a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), NZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3c0-81 54-149.4 128-171.1v59.1c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7v-65.4c6-.6 12.1-.9 18.3-.9h91.4c6.2 0 12.3.3 18.3.9V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-40c0-29.8-20.4-54.9-48-62v-50.8c74 21.7 128 90.1 128 171.1 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M120 424a24 24 0 1 1 48 0 24 24 0 1 1-48 0M432 0h160c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-48l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4.8s-4.4-4.1-4.4-7.2v-56h-16c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48" })
  }
), XZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-96 55.2C54 332.9 0 401.3 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62v-57.1c-6-.6-12.1-.9-18.3-.9h-91.4c-6.2 0-12.3.3-18.3.9v65.4c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), KZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m-45.7 304h91.4c11.8 0 23.4 1.2 34.5 3.3-2.1 18.5 7.4 35.6 21.8 44.8-16.6 10.6-26.7 31.6-20 53.3 4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304M436 218.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4L546.3 442c-6.9 5.1-14.3 9.4-22.3 12.8v30.6c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-30.6c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9v-30.4zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0" })
  }
), QZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M219.3.5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128S96 230.7 96 160v-57.1l-48-9.6v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3S52.8 256 48 256H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64c0-11.4 8.1-21.3 19.3-23.5zM111.9 327.7c10.5-3.4 21.8.4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5 65 20.9 112 81.7 112 153.6 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z" })
  }
), ZZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 144v-16h160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80m-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5c-2.9-2.3-6.4-3.5-10-3.5H112c-8.8 0-16 7.2-16 16v128c0 70.7 57.3 128 128 128s128-57.3 128-128V16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3.2-.6.4-.8.6l-.1.1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4l-30.2 17.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168zm264-48c61.9 0 112-50.1 112-112S493.9 32 432 32c-17.2 0-33.5 3.9-48 10.8V144c0 5.4-.3 10.7-.8 16-2.4 24.3-10.3 47.1-22.4 67-.5.8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256m39.4 256h137.9c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3h-61.4c-2.4 0-4.8.1-7.1.2C452.9 356.8 480 411.3 480 472v8c0 11.7-3.1 22.6-8.6 32" })
  }
), JZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208m320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208M0 416c0-70.7 57.3-128 128-128h64c70.7 0 128 57.3 128 128v16c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm448 64c-38.3 0-72.7-16.8-96.1-43.5.1-1.5.1-3 .1-4.5v-16c0-34.9-11.2-67.1-30.1-93.4 5.8-20 24.2-34.6 46.1-34.6h224c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128z" })
  }
), jZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8 2.4-.1 4.7-.2 7.1-.2h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7M432 256c-31 0-59-12.6-79.3-32.9 19.7-26.6 31.3-59.5 31.3-95.1 0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112" })
  }
), YZ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16M84 192c7 0 13.7-1.6 19.6-4.6 17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6 24.3 0 44-19.7 44-44v-40c0-24.3-19.7-44-44-44-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8c-7.1-4.9-15.7-7.8-25-7.8-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44m77.3 128C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3z" })
  }
), _Z1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5zm65.3 192h125.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3 0 392.2 72.2 320 161.3 320" })
  }
), hJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128v16c0 18-6 34.6-16 48-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32c-10-13.4-16-30-16-48v-16c0-5.7.6-11.3 1.7-16.6 30.6-3.1 58.5-17.9 78.3-40.6 19.8 22.7 47.6 37.5 78.3 40.6 1.1 5.4 1.7 10.9 1.7 16.6m-66.6 143.3L255 289c5.5 5.5 13.2 8 20.8 6.7s14.2-6.1 17.6-13l6.1-12.2 19.5 7.8c9.3 3.7 19.8 1.3 26.6-6s8.3-18.1 3.8-27c-8.5-17-11-22.3-12.2-27.1-.7-2.9-1.1-5.9-1.2-12.3 10.2-18.4 16-39.5 16-61.9v-16c0-7.1-.6-14-1.7-20.7 5.9-4.4 9.7-11.4 9.7-19.3 0-13.3-10.7-24-24-24h-1.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H112c-13.3 0-24 10.7-24 24 0 7.9 3.8 14.9 9.7 19.3C96.6 114 96 120.9 96 128v16c0 22.4 5.8 43.5 15.9 61.8-.1 6.4-.5 9.4-1.2 12.3-1.2 4.8-3.7 10.1-12.2 27.1-4.5 8.9-2.9 19.7 3.8 27s17.3 9.7 26.6 6l19.5-7.8 6.1 12.2c3.5 6.9 10 11.7 17.6 13s15.4-1.3 20.8-6.7l17.7-17.7c4.4.5 8.9.7 13.4.7s9-.2 13.4-.7zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3z" })
  }
), cJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32m-208 0v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128m65.3 192C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3z" })
  }
), sJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 32c-88.4 0-160 71.6-160 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16C32 86 118 0 224 0s192 86 192 192v16c0 61.9-50.1 112-112 112h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80v-16c0-88.4-71.6-160-160-160M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8-8.3 14.5-23.9 24.2-41.7 24.2h-8.6c-11.1-19.1-31.7-32-55.4-32h-32c-35.3 0-64 28.7-64 64 0 1.4 0 2.7.1 4C114.8 268.6 96 232.5 96 192m128 160h89.6c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352H208z" })
  }
), vJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M216 0c-13.3 0-24 10.7-24 24v56l-28.4-56.9C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2c-2.8-45.4-29.4-84.5-67.4-104.9L256 80V24c0-13.3-10.7-24-24-24zm8 320c65.3 0 119.1-48.9 127-112H97c7.9 63.1 61.7 112 127 112m-89.6 32C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4z" })
  }
), eJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M240 80h102.7c-7.9-19.5-20.4-36.5-36.2-49.9zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2M224 256c70.7 0 128-57.3 128-128 0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16 0 70.7 57.3 128 128 128m-100 56.4c-9.7 3.1-19.1 7-28 11.7V512h147.7l-62.2-103.8zm33-7.2 47.3 78.8H272c44.2 0 80 35.8 80 80 0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4c-7.2 0-14.3.4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3M320 464c0-26.5-21.5-48-48-48h-48.5l57.1 95.2c22.4-4 39.4-23.6 39.4-47.2" })
  }
), lJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0c-69.6 0-127.6 49.3-141.1 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.6z" })
  }
), tJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 288a144 144 0 1 0 0-288 144 144 0 1 0 0 288m-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h450.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3z" })
  }
), wJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h362.9c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1.1-4.2.3-6.3-31-26-71-41.7-114.6-41.7zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32m-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80" })
  }
), gJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7V480c-88.4 0-160-71.6-160-160 0-5.1.2-10.1.7-15-6.2-.7-12.6-1-19-1zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1l79.1 79.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9 0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z" })
  }
), iJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M472 200h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24" })
  }
), mJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256m-45.7 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-18 2.5-34.8 9.1-48.5 19.4-17.6 13.2-31.5 34-31.5 59.5 0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304M630 164.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3" })
  }
), aJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256c-57.2 0-105.6-37.5-122-89.3-1.1 1.3-2.2 2.6-3.5 3.8-15.8 15.8-38.8 20.7-53.6 22.1-8.1.8-14.6-5.7-13.8-13.8 1.4-14.7 6.3-37.8 22.1-53.6 5.8-5.8 12.6-10.1 19.6-13.4-7-3.2-13.8-7.6-19.6-13.4-15.8-15.7-20.6-38.7-22.1-53.5-.8-8.1 5.7-14.6 13.8-13.8 14.7 1.4 37.8 6.3 53.6 22.1 4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128M0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2.9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), oJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v35c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-35c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2M304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80h32c29.8 0 55.9-16.3 69.6-40.5 11.7 14.9 29.9 24.5 50.4 24.5zM151.4 346.8c-6.4-6.8-15.4-10.6-24.6-9.3C55.1 347.7 0 409.4 0 483.8 0 499.4 12.6 512 28.2 512h391.6c15.6 0 28.2-12.6 28.2-28.2 0-74.5-55.1-136.1-126.7-146.3-9.2-1.3-18.3 2.5-24.6 9.3l-61 64.8c-6.3 6.7-17 6.7-23.3 0l-61-64.8zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96h-16c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16z" })
  }
), nJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v40c0 70.7 57.3 128 128 128s128-57.3 128-128v-40c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2M304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80h32c29.8 0 55.9-16.3 69.6-40.5 11.7 14.9 29.9 24.5 50.4 24.5zM141.3 336.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-71.8-47-132.7-111.9-153.6-10.5-3.4-21.8.4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96h-16c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16z" })
  }
), rJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128v-40c0-2.7.1-5.4.3-8zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144zm-32.1 151.7c10.5-3.4 21.8.4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5 65 20.9 112 81.7 112 153.6 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-16V48c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8" })
  }
), dJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h293.1c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1h-91.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71z" })
  }
), SJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zm-68.4 72c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2m89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4l-62.8 104.6L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zM320 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16" })
  }
), zJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zm-68.4 72c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2m116.3 240-72.3-54.2c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4-2.8 0-5.5.9-7.7 2.6l-72.3 54.2a15.9 15.9 0 0 1-19.2 0zM336 416h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), pJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M504 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24" })
  }
), MJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4 0 17.2-7 46.1-36.9 58.6-2 .8-4.2.8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM98.1 168.8c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2m89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4l-62.8 104.6L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zm172 38.4 5.4 16.6h17.4c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5H339l5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5" })
  }
), xJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m230.1.8 152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24c-9.8-4.4-15.1-14.5-15.1-25.2v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6S57.3 43 65.9 40.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4 0 17.2 7 46.1 36.9 58.6 2 .8 4.2.8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192c0-7.9.7-15.7 2.1-23.2M134.4 352c2.8 0 5.5.9 7.7 2.6l72.3 54.2a15.9 15.9 0 0 0 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6 74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352M352 408c-3.5 0-6.5 2.2-7.6 5.5l-5.4 16.7h-17.4c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l14.1 10.1-5.4 16.6c-1.1 3.3.1 6.9 2.9 9s6.6 2 9.4 0l14.1-10.3 14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9l-5.4-16.6 14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5H365l-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5" })
  }
), HJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c8.8 0 16 7.2 16 16v48h64c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16M16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16M160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32m48 16a16 16 0 1 0 32 0 16 16 0 1 0-32 0m80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32M96 352h256c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32h-64v-64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32v-32c0-53 43-96 96-96m80 112v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16m48-16c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16m80 16v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16M119.5 119.5c-4.7 4.7-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0m145 0c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143z" })
  }
), VJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0c8.8 0 16 7.2 16 16v48h64c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16M16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16m-256 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-160 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32m48 16a16 16 0 1 0 32 0 16 16 0 1 0-32 0m80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32M96 352h256c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32h-64v-64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32v-32c0-53 43-96 96-96m80 112v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16m48-16c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16m80 16v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16" })
  }
), CJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4-47.3 8.7-78 22.8-78 38.6 0 14.3 25 27.1 64.6 35.9-.4 4-.6 8-.6 12.1 0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7.3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-58.5-28.2-110.4-71.7-143l38.7-96.9c.6-1.6 1-3.3 1-5 0-7.4-6-13.4-13.4-13.4h-59.9c6-14.8 9.3-31 9.3-48 0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9-4.8 3.3-8.8 6.1-15.5 6.1m56 208h-12.4c-16.5 0-31.1-10.6-36.3-26.2-2.3-7-12.2-7-14.5 0-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40v-14.4c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40m-88 96 16 32-32 128-48-192zm128-32-48 192-32-128 16-32z" })
  }
), LJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1v-32c0-44.2-35.8-80-80-80M96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30l11.1 13.8c6.7 8.4 10.4 18.8 10.4 29.6 0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16h-50.6C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32m48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0m-7.5 39.5c2 2 6 5.3 10.7 8.1 4.9 2.9 9.4 4.4 12.8 4.4 6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5 4.7-4.7 12.3-4.7 17 0M272 304c23.9 0 45.8 8.8 62.6 23.2 65.7 20.4 113.4 81.7 113.4 154 0 17-13.8 30.7-30.7 30.7H240c0-8.8-7.2-16-16-16s-16 7.2-16 16H30.7C13.8 512 0 498.2 0 481.3c0-72.4 47.7-133.6 113.4-154 16.8-14.5 38.7-23.3 62.6-23.3zm-64 144a16 16 0 1 0 32 0 16 16 0 1 0-32 0m-80-48c26.4-10.6 54.6-16 83.1-16h25.8c28.5 0 56.7 5.4 83.1 16 0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48" })
  }
), BJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c1.8 0 3.5-.2 5.3-.5-76.3-55.1-99.8-141-103.1-200.2-16.1-4.8-33.1-7.3-50.7-7.3zm308.8-78.3-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2 5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8z" })
  }
), uJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128 448 57.3 390.7 0 320 0c-69.8 0-126.5 55.8-128 125.2L38.8 5.1zm225.5 299.2C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7h388.6c3.9 0 7.6-.7 11-2.1l-261-205.6z" })
  }
), RJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3l107.4 107.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7zm24 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), $J1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-11C352 57.3 294.7 0 224 0m55.7 510.9c1.8.7 3.8 1.1 5.8 1.1h131.8c17 0 30.7-13.8 30.7-30.7 0-75.5-51.9-138.9-121.9-156.4-8.1-2-15.9 3.3-17.9 11.3l-36 146.9-33.3-123.9 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2h-39.5c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-33.4 123.9-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7h131.8c2.1 0 4-.4 5.8-1.1l-.3 1.1h112z" })
  }
), kJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0m55.7 510.9c1.8.7 3.8 1.1 5.8 1.1h131.8c17 0 30.7-13.8 30.7-30.7 0-75.5-51.9-138.9-121.9-156.4-8.1-2-15.9 3.3-17.9 11.3l-36 146.9-33.3-123.9 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2h-39.5c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-33.4 123.9-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7h131.8c2.1 0 4-.4 5.8-1.1l-.3 1.1h112z" })
  }
), PJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256m-14.9 103.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3 70.1 17.6 121.9 81 121.9 156.4 0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8.7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4 8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z" })
  }
), FJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v128c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3M496 272v48h112c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80h-48c0-17.7-14.3-32-32-32s-32 14.3-32 32" })
  }
), TJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M343 175.2c-18.8 47.3-65 80.8-119 80.8s-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3m348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5-1.1-35.3-11.3-65.6-30.1-90.2-1.2-2-4.6-1.9-6.1-.1-19.9 23-31.9 53-35.8 89.5-.3 3.5 3.7 5.5 6.5 3.5 1.8-1.4 4.1-3.4 6.6-5.6 9.2-8.1 22.3-19.5 31.7-19.5 2.3 2 7.6 7.8 19.9 25zM144 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16z" })
  }
), AJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5zm61.3 199.1 53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2 80.7 8.8 143.6 77.3 143.6 160.4 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3 0 398.2 62.9 329.7 143.7 321c5.3-.6 10.5 1.9 13.7 6.2z" })
  }
), DJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32m-208 0v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128m61.3 199.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-83.1-62.9-151.5-143.7-160.3-5.3-.6-10.5 1.9-13.7 6.2L236.7 399c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z" })
  }
), yJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 0a128 128 0 1 0 0 256 128 128 0 1 0 0-256m-66.7 327.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-83.1-62.9-151.5-143.7-160.3-5.3-.6-10.5 1.9-13.7 6.2L236.7 399c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z" })
  }
), bJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" })
  }
), fJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3z" })
  }
), UJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 24C0 10.7 10.7 0 24 0h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24m0 464c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24m83.2-328a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32m461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4 9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32zm-102.4-61.6c32.1 7.4 58.1 30.9 68.9 61.6 3.5 10 5.5 20.8 5.5 32 0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32 0-11.2 1.9-22 5.5-32 10.5-29.7 35.3-52.8 66.1-60.9 7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7.8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), GJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160M0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7M320 320c24 0 45.9-8.8 62.7-23.3 2.5-3.7 5.2-7.3 8-10.7 2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96 43 96 96 96m65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.5c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 17.4-3.5 33.9-9.7 49 2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6 7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7 2.3 2.8 4.5 5.8 6.6 8.7-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l18.2-10.2c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1-80 0" })
  }
), qJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M211.2 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0M32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64m461.6 32H576c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-96c-11.7 0-22.7 3.1-32.1 8.6 38.1 14.8 67.4 47.3 77.7 87.4zm-102.4-61.6c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1-30.8 8.1-55.6 31.1-66.1 60.9-3.5 10-5.5 20.8-5.5 32 0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32 0-11.2-1.9-22-5.5-32-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-241.6 96a80 80 0 1 0 0-160 80 80 0 1 0 0 160M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), WJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160M0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7M405.3 320h77.4c6.6-18.6 24.4-32 45.3-32h32c20.9 0 38.7 13.4 45.3 32h13.4c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 38.2-16.8 72.5-43.3 96h.7zm10.7 80c0-14.6 6.5-27.7 16.9-36.5-16.6-7.4-34.9-11.5-54.2-11.5H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h328c-1.8-5-2.7-10.4-2.7-16v-16h-16c-26.5 0-48-21.5-48-48zm0-176a96 96 0 1 0-192 0 96 96 0 1 0 192 0m96 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16" })
  }
), EJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41 7C31.6-2.3 16.4-2.3 7 7s-9.3 24.6 0 34l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zm558 0-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9S608.3-2.4 599 7zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128m-107.9 80c-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24-.5-1.4-1-2.7-1.6-4-9.4-22.3-29.8-38.9-54.3-43-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-.8.1-1.7.3-2.5.5-24.9 5.1-45.1 23-53.4 46.5m-36.3-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-26.5 32c-29.4 0-53.3 23.9-53.3 53.3 0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4zm368 80c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), OJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h448c53 0 96-43 96-96V96c0-53-43-96-96-96zM64 96c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm159.8 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0M96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4c-29.4 0-53.3 23.9-53.3 53.3M461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6M372 289c-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-26 4.4-47.3 22.7-55.9 47-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24-8.6-24.3-29.9-42.6-55.9-47m140-113a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-192 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), IJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h178.1c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 30.2-10.5 58-28 79.9l-25.2-19.7c13.3-16.5 21.2-37.4 21.2-60.2 0-53-43-96-96-96-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9 0-44.2-35.8-80-80-80-27.7 0-52.1 14.1-66.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7 0 310.4 9.6 320 21.3 320h214.1c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192zm154.6 160C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c10.5 0 19.5-6 23.9-14.8L324.9 352zM512 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160" })
  }
), NJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M48 48h88c13.3 0 24-10.7 24-24S149.3 0 136 0H32C14.3 0 0 14.3 0 32v104c0 13.3 10.7 24 24 24s24-10.7 24-24zm127.8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-26.5 32c-29.4 0-53.3 23.9-53.3 53.3 0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4zm368 80c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-26 4.4-47.3 22.7-55.9 47-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24M464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-80-32a64 64 0 1 0-128 0 64 64 0 1 0 128 0M504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24M48 464v-88c0-13.3-10.7-24-24-24S0 362.7 0 376v104c0 17.7 14.3 32 32 32h104c13.3 0 24-10.7 24-24s-10.7-24-24-24zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88z" })
  }
), XJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160m368 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160M0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7-1.3 7.2-1.9 14.7-1.9 22.3 0 38.2 16.8 72.5 43.3 96H21.3C9.6 320 0 310.4 0 298.7M405.3 320h-.7c26.6-23.5 43.3-57.8 43.3-96 0-7.6-.7-15-1.9-22.3 13.6-6.3 28.7-9.7 44.6-9.7h42.7c58.9 0 106.7 47.8 106.7 106.7 0 11.8-9.6 21.3-21.3 21.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0m-96 261.3c0-73.6 59.7-133.3 133.3-133.3h117.4c73.6 0 133.3 59.7 133.3 133.3 0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" })
  }
), KJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V32c0-17.7-14.3-32-32-32-16 0-128 32-128 176v99.7l-77.6-60.8c8.6-13.6 13.6-29.7 13.6-47 0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16v134.2c0 5.4-4.4 9.8-9.8 9.8-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3-22.7-17.8V16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 38.8 5.1zM176 255.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V285.1L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9" })
  }
), QJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M416 0c-16 0-128 32-128 176v112c0 35.3 28.7 64 64 64h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32M64 16C64 7.8 57.9 1 49.7.1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7 0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16v134.2c0 5.4-4.4 9.8-9.8 9.8-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0S96.8 6.3 96.1 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152h-.6l.3-.7z" })
  }
), ZJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v32h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 221.9V256h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 413.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-66.1L83.2 320H32c-17.7 0-32-14.3-32-32v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96v-34.1L83.2 128H32c-17.7 0-32-14.3-32-32V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32M140.8 128l83.2 55.4V128zM288 183.4l83.2-55.4H288zM140.8 320l83.2 55.4V320zM288 375.4l83.2-55.4H288z" })
  }
), JJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 0c17.7 0 32 14.3 32 32v32h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 221.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V221.9L83.2 128H32c-17.7 0-32-14.3-32-32V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32M140.8 128l83.2 55.4V128zM288 183.4l83.2-55.4H288z" })
  }
), jJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7l-160-384c-6.8-16.3.9-35 17.2-41.8z" })
  }
), YJ1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m100.7-155.3c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm-144-144c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64" })
  }
), _J1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.6 64H512c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.8 52.8-34.4-32.7-81-52.8-132.2-52.8-35.3 0-64 28.7-64 64v100c10.2-2.6 21-4 32-4 70.7 0 128 57.3 128 128 0 38.2-16.8 72.5-43.3 96H544c35.3 0 64-28.7 64-64V320c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128 640 57.3 582.7 0 512 0H301.6c-60.3 0-112.5 42.2-125.2 101.2L150.1 224h65.5L239 114.6c6.4-29.5 32.4-50.6 62.6-50.6m-92.9 192h-65.4L109 416H83.8c-33.8 0-64.7 18.9-80 49-2.4 4.5-3.8 9.6-3.8 15 0 17.7 14.3 32 32 32h144c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.6zM480 416a96 96 0 1 0-192 0 96 96 0 1 0 192 0m-128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), hj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32m150.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.3-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32z" })
  }
), cj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8m482 88-80.9-96H384v96zm-226 0V96h-96v96zm272 192h-16c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104c0-39.8 32.2-72 72-72h393.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48m-64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0m-368 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96" })
  }
), sj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C28.7 0 0 28.7 0 64v352c0 35.3 28.7 64 64 64h16l16 32h64l16-32h224l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm160 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160m0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320m256 141.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3 0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3" })
  }
), vj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v9.3c72.2 21.5 129.2 78.5 150.7 150.7h9.3c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-9.3c-21.5 72.2-78.5 129.2-150.7 150.7v9.3c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-9.3C119.8 449.2 62.8 392.2 41.3 320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h9.3C62.8 119.8 119.8 62.8 192 41.3zm211.7 162.4c-16.2-38.9-47.3-70-86.2-86.2-4.8 11.7-16.2 19.8-29.5 19.8h-64c-13.3 0-24.7-8.1-29.6-19.7-38.9 16.2-70 47.3-86.2 86.2 11.6 4.8 19.7 16.2 19.7 29.6v64c0 13.3-8.1 24.7-19.7 29.6 16.2 38.9 47.3 70 86.2 86.2 4.8-11.6 16.2-19.7 29.6-19.7h64c13.3 0 24.7 8.1 29.6 19.7 38.9-16.2 70-47.3 86.2-86.2-11.7-5-19.8-16.4-19.8-29.7v-64c0-13.3 8.1-24.7 19.7-29.6M240 48v32h32V48zm32 384h-32v32h32zm160-192v32h32v-32zm-352 0H48v32h32z" })
  }
), ej1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h192c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-31.7l-4.5 7.9-28.4 49.7c.4 2.1.6 4.2.6 6.4v64c0 2.2-.2 4.3-.6 6.4l28.4 49.7 4.5 7.9H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32H128c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32V160c-17.7 0-32-14.3-32-32zm322.2 308.3L292.3 320H256c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.3l29.9-52.3c-1.4-3.6-2.2-7.5-2.2-11.7H128c0 17.7-14.3 32-32 32v192c17.7 0 32 14.3 32 32h192c0-4.1.8-8.1 2.2-11.7M48 80v32h32V80zm320 0v32h32V80zM80 400H48v32h32zm288 0v32h32v-32zm-64-160h-32v32h32z" })
  }
), lj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M368 80h32v32h-32zm-16-48c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32v192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32h192c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM96 160c17.7 0 32-14.3 32-32h192c0 17.7 14.3 32 32 32v192c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32zM48 400h32v32H48zm320 32v-32h32v32zM48 112V80h32v32z" })
  }
), tj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v32h32c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-32v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-32H32c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h32zm120 16c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24z" })
  }
), wj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224m176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C78.1 334.1 16 262.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176m-24 142c14.6-15.6 26.8-33.4 36-53 18.8 14.4 42.4 23 68 23 61.9 0 112-50.1 112-112S509.9 64 448 64c-25.6 0-49.1 8.6-68 23-9.3-19.5-21.5-37.4-36-53 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9c-26.6-4.9-51.1-15.7-72-31.1" })
  }
), gj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224m176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C62.1 334.1 0 262.3 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176m-80.1 184.6c19.3-10.1 36.9-23.1 52.1-38.4 20 18.5 46.7 29.8 76.1 29.8 61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3.7-21.1 2-4.9-21.5-13-41.7-24-60.2 14.3-3.8 29.4-5.8 45-5.8 37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4-20.6 20.6c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4" })
  }
), ij1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M80 176a112 112 0 1 1 224 0 112 112 0 1 1-224 0m144 173.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32z" })
  }
), mj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m151.2 69.7 55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9-7.7 5.1-16.8 8.1-26.7 8.1H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6L56 172.1c5.3-7.9 8.1-17.1 8.1-26.6V48C64 21.5 85.5 0 112 0h6.3c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0h6.3c26.5 0 48 21.5 48 48v97.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2.8-10.3 2.5-15.2l70.3-210.9C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3M96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80M63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288l-15.5 15.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271l-15.5-15.5c-4.7-4.7-12.3-4.7-17 0M304 280v40c0 8.8 7.2 16 16 16h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24" })
  }
), aj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M207.1 237.4 151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3l-70.3 210.9c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6L392 172.1c-5.3-7.9-8.1-17.1-8.1-26.6V48c0-26.5-21.5-48-48-48h-6.3c-18.6 0-33.9 9.7-43.9 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0H112C85.5 0 64 21.5 64 48v97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48h128c9.9 0 19-3 26.7-8.1-6.8-11.7-10.7-25.4-10.7-39.9V295.8c0-8.6 1.4-17.1 4.1-25.3zm140.2 119.3 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0m-294.6 48 48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z" })
  }
), oj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32v170.8c-20.2 28.6-32 63.5-32 101.2 0 25.2 5.3 49.1 14.8 70.8-17.3 24.9-46.2 41.2-78.8 41.2-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64m96 32v96h64V96zm128 272a144 144 0 1 1 288 0 144 144 0 1 1-288 0m211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6" })
  }
), nj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v288c0 53 43 96 96 96 28.6 0 54.2-12.5 71.8-32.3.1-14.2 5.6-28.3 16.4-39.1.2-.2.1-.6-.2-.6-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4.2-.6-21.9-21.9-21.9-57.3 0-79.2 2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zm64 160V96h64v96zm120 184c28.8 0 43.2 34.8 22.9 55.2-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.3-20.4-5.9-55.2 22.9-55.2 13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.4 20.3-55.2 5.9-55.2-22.9 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2-13.3 0-24 10.7-24 24s10.7 24 24 24m104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64m40 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0" })
  }
), rj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5v5.5c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256 352 109.3l50.7 50.7-96 96z" })
  }
), dj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v304c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64m136 32H88v160h48zm152-32c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v304c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32m136 32h-48v160h48z" })
  }
), Sj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z" })
  }
), zj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384zm-424 32h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z" })
  }
), pj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384zm-360 56v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-48c0-13.3 10.7-24 24-24s24 10.7 24 24" })
  }
), Mj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6S608 395.8 608 384V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v150.9l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7 32.3 121.5c-.2 2.1-.3 4.3-.3 6.5v256c0 35.3 28.7 64 64 64h256c23.4 0 43.9-12.6 55-31.3" })
  }
), xj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm559.1-28.2c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64-14.2-9.5V174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" })
  }
), Hj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m281 22 24.8-17.3c1.3-.9 2.7-1.8 4.1-2.4C313.1.7 316.6 0 320 0s6.9.7 10.1 2.2c1.4.7 2.8 1.5 4.1 2.4L359 22c34 23.8 71.8 41.5 111.8 52.4l23 6.3c1.8.5 3.6 1.1 5.2 2 3.2 1.7 5.9 4 8.1 6.8 3.8 4.9 5.6 11.3 4.7 17.8-.4 2.8-1.2 5.4-2.5 7.8-1.7 3.2-4 5.9-6.8 8.1-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6.5 3.2 1.2 4.6 2 3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7.6 5.5.1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6.3-3.3.4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24h-40v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H24c-13.3 0-24-10.7-24-24 0-11.4 8-21 18.6-23.4 30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6.1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V128h-7.5c-5.5.1-10.8-1.7-15.1-4.9-2.8-2.1-5.1-4.8-6.8-8.1-1.2-2.4-2.1-5-2.5-7.8-.9-6.5.9-12.8 4.7-17.8 2.1-2.8 4.8-5.1 8.1-6.8 1.6-.8 3.4-1.5 5.2-2l23-6.3c40.2-10.8 78-28.5 112-52.3m135 106H224v64h192zM160 288v64h320v-64H296z" })
  }
), Vj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M630.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L417 177.7c-19-11.2-41.3-17.7-65-17.7-20.8 0-40.4 5-57.8 13.8-6.7 3.4-9.1 11.4-7.7 18.8 1 5 1.5 10.2 1.5 15.4 0 44.2-35.8 80-80 80-11.6 0-22.7-2.5-32.7-7-7.4-3.3-16.6-2.4-21.3 4.3-16.4 23.4-26 51.9-26 82.7 0 15 2.3 29.5 6.6 43.1l44.6-33.5c19.1-14.3 45.9-12.4 62.7 4.5l16 16c16.9 16.9 18.8 43.6 4.5 62.7l-33.5 44.6c13.6 4.3 28.1 6.6 43.1 6.6 30.8 0 59.3-9.6 82.6-26.1 6.7-4.7 7.6-13.8 4.3-21.3-4.5-10-7-21-7-32.7 0-44.2 35.8-80 80-80 5.3 0 10.5.5 15.4 1.5 7.4 1.4 15.4-1 18.8-7.7 8.8-17.4 13.8-37 13.8-57.8 0-23.7-6.5-46-17.7-65L630.6 54.6zM520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48m-175-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm127 55a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0m48-48a24 24 0 1 0-48 0 24 24 0 1 0 48 0M198.4 403.2l-64 48c-3.7 2.8-6 7-6.4 11.7s1.4 9.2 4.6 12.4l32 32c3.3 3.3 7.8 5 12.4 4.6s8.9-2.6 11.7-6.4l48-64c4.8-6.4 4.1-15.3-1.5-20.9l-16-16c-5.6-5.6-14.5-6.3-20.9-1.5z" })
  }
), Cj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h16c13.3 0 24-10.7 24-24S373.3 0 360 0h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33.2 33L38.8 5.1zm110.4 208.4c-1.5 6-2.7 12.2-3.5 18.5H112v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-33.6c20.4-2.8 39.7-9.1 57.3-18.2z" })
  }
), Lj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92l-11.3-11.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-33.6c-4.2 30.7-16.3 58.8-34.1 82.3l23.7 23.8 11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l11.4-11.4-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-56.6-56.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8c-17.9-23.5-30-51.6-34.2-82.3H48v16c0 13.3-10.7 24-24 24S0 309.3 0 296v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v16h33.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9l-11.4 11.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48h-16c-13.3 0-24-10.7-24-24m48 200a48 48 0 1 0-96 0 48 48 0 1 0 96 0m64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48" })
  }
), Bj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1c-12.5-12.5-32.8-12.5-45.3 0-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1 26.5 0 48 21.5 48 48 0 4.4-.6 8.7-1.7 12.7zM402 412.7 144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-31.2 23.6-52.7 50-55.7z" })
  }
), uj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2c35.2 35.2 10.2 95.5-39.7 95.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.1 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5zM176 224a48 48 0 1 1 96 0 48 48 0 1 1-96 0m128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), Rj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 0c13.3 0 24 10.7 24 24v13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5c-25.2 25.2-7.3 68.3 28.3 68.3H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-13.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5c-25.2-25.2-68.3-7.3-68.3 28.3V360c0 13.3-10.7 24-24 24s-24-10.7-24-24v-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h13.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24m48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32m-48-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0m320 80c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16m0 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0" })
  }
), $j1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160m119.8 0c15.3-22.9 24.2-50.4 24.2-80 0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144h352c79.5 0 144-64.5 144-144S575.5 96 496 96s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160" })
  }
), kj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31c11.2-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144m-16 208 48.4-24.2c10.2-5.1 21.6-7.8 33-7.8 19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9 11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1h-41.7c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2H277c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7 0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z" })
  }
), Pj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1C440 177.2 399.3 78.3 327.6 10.1 434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4m-3.9 34.7c-5.8 32-17.6 62-34.2 88.7-97.5 48.5-217.7 42.6-311.9-24.5 23.7-36.2 55.4-67.7 94.5-91.8 79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5C269.4 155.7 230.8 73.9 170 14.9 196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9.1 90.8 60.2 145.7 167.2 134.7 282.3-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9 2.5 297.4 0 277 0 256 0 157.2 56 71.5 138 28.8m69.6 90.5c19.5 38.6 31 81.9 32.3 127.7-77.4 47.6-129 121.9-149.7 204-24.2-20.6-44.6-45.6-59.8-73.8 6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2 5.6-27 14.8-53.1 27.4-77.7 86.6 60.5 192.5 74.7 287.4 46.9-46 44-108.3 71-177 71" })
  }
), Fj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8c54.2-44 88.7-111 88.7-186.2s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z" })
  }
), Tj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm111.5 146.7c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z" })
  }
), Aj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8l134.9 119.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448z" })
  }
), Dj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.7-82.9C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6 0-30.1-13.9-56.9-35.4-74.5-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3l-100.9 89.7L38.8 5.1zM352 373.3l-269.1-212C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8l134.9 119.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448z" })
  }
), yj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" })
  }
), bj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M333.1 34.8C344.6 40 352 51.4 352 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z" })
  }
), fj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M576 64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h120.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64M96 240a64 64 0 1 1 128 0 64 64 0 1 1-128 0m384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128" })
  }
), Uj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2c-6.2-16.5 2.2-35 18.8-41.2" })
  }
), Gj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0M160 80c-8.8 0-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-64V96c0-8.8-7.2-16-16-16m16 256v-64h64v64zm96 0v-64h64v64zm64-160v64h-64v-64zm-96 0v64h-64v-64z" })
  }
), qj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14c16.8 1.1 29.9 15.1 29.9 31.9V224H64L4.5 57.4zM288 16h64c17.7 0 32 14.3 32 32v176H256V48c0-17.7 14.3-32 32-32M64 288c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32h-1.6c20.7 20.3 33.6 48.7 33.6 80 0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96h-66.2c-7.8 54.3-54.4 96-110.9 96-61.9 0-112-50.1-112-112 0-31.3 12.9-59.7 33.6-80H96c-17.7 0-32-14.3-32-32m96 128h-46c5.8 22.5 23.5 40.2 46 46zm0-32v-46c-22.5 5.8-40.2 23.5-46 46zm32 78c22.5-5.8 40.2-23.5 46-46h-46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46m256 124v-46h-46c5.8 22.5 23.5 40.2 46 46m-46-78h46v-46c-22.5 5.8-40.2 23.5-46 46m124 32h-46v46c22.5-5.8 40.2-23.5 46-46m0-32c-5.8-22.5-23.5-40.2-46-46v46zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224H416V45.9c0-16.8 13.1-30.8 29.9-31.9L595.2 4z" })
  }
), Wj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M194 64h126c17.7 0 32 14.3 32 32v64H145l17.9-71.8C166.5 74 179.3 64 194 64m158 160v168.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V96c0-53-43-96-96-96H194c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3L129 224zm32 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32" })
  }
), Ej1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24v72H48c-26.5 0-48 21.5-48 48v156.1C0 312.8 5.1 325 14.1 334l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48v-92.1c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-48zm0 136h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16" })
  }
), Oj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h368c17.7 0 32-14.3 32-32s-14.3-32-32-32zm352 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), Ij1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M234.7 42.7 197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1 14.1 37.7c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2l-37.7-14.1L263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0l381.3-381.4c18.7-18.7 18.7-49.1 0-67.9l-34.6-34.5c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L64 96zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352z" })
  }
), Nj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0l-34.5-34.6zm333.5-275.7 105-105-23.2-23.3-105 105 23.3 23.3z" })
  }
), Xj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5.9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16h-15.8c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8M87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6.9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z" })
  }
), Kj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8 9.5 0 18.5-4 24.8-11.1l271.7-303.7c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16v-21.4c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33z" })
  }
), Qj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24m376-104h112c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24M128 248c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm24 136h144c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24" })
  }
), Zj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24m488 24H152c-13.3 0-24-10.7-24-24v-56h384v56c0 13.3-10.7 24-24 24M128 400v-64h384v64zm0-96v-80h384v80z" })
  }
), Jj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm368 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0M88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48m120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0m16 328c-61.9 0-112-50.1-112-112 0-16.5 3.6-32.2 10-46.3 7.4-1.1 14.8-1.7 22-1.7 32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416" })
  }
), jj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48m16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80zm112 133.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3M213.3 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m74.7-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0m-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0m224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64M112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48" })
  }
), Yj1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48m16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80zm0 64h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m32 128a24 24 0 1 1-48 0 24 24 0 1 1 48 0m80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48m128-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0M88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48m128-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0m80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48M112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48" })
  }
), _j1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48zm0 416h256c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48M0 160c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v192c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80zm141.3 0c-33.9 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z" })
  }
), hY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48m16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80zm136 80v86.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17v-96c0-13.3 10.7-24 24-24s24 10.7 24 24zM112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48" })
  }
), cY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M112 0h160c26.5 0 48 21.5 48 48v24.2C283.7 46.8 239.6 32 192 32S100.3 46.8 64 72.2V48c0-26.5 21.5-48 48-48M64 464v-24.2c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48M0 256a192 192 0 1 1 384 0 192 192 0 1 1-384 0m192-104c-13.3 0-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176c0-13.3-10.7-24-24-24" })
  }
), sY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M354.5 104.3 320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v103.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm-85 189.6C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0m37 128c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1" })
  }
), vY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M354.5 135.7 320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm-85 158.2c11.1-7.9 25.9-7.9 37 0 22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1m37 128c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), eY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 127.7c0-52.8 42.9-95.7 95.7-95.7 48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.7 14.2-31.7 31.7V224h192v-96.3c0-52.8 42.9-95.7 95.7-95.7 48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1-18 12.4-40.1 20.3-59.2 20.3V288H192v96.5c-19 0-41.2-7.9-59.1-20.3-1.6-1.1-3.2-2.2-4.9-3.1V127.7zm178.5 262.2c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0" })
  }
), lY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18-4.3 36.2-13.4 50.5-25.3 11.1-9.5 27.3-10.1 39.2-1.7C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1m37 288c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0m0-144c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z" })
  }
), tY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391m22.3-22.3c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7.3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4zm245.4-220c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6m-80 80c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-168 72c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6m88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6z" })
  }
), wY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8l-55.2 110.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4l-61.4-225.1-68.4 319.4c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h103.9c28.6 0 53.7 18.9 61.5 46.4l22.2 77.6 69.1-322.7C291.8 10.9 304.4.4 319.1 0" })
  }
), gY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M63.4 230.3v-.1l.2-1c.2-.9.5-2.4 1-4.3 1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4c20.2-36.6 47.8-63.4 86-63.4 29 0 49.1 14.4 67 44.4 19 31.8 31.9 75.4 46.3 124.5.2.8.5 1.6.7 2.4 13.5 46.2 28.4 97.5 52 137 25.1 42 63 75.6 122 75.6 73.8 0 118.2-53.2 142-96.6 12.3-22.4 20.6-44.5 25.7-60.8 2.6-8.2 4.5-15.1 5.7-20 .6-2.5 1.1-4.4 1.4-5.9.2-.7.3-1.3.4-1.7l.1-.5V294.1l-31.4-6.3 31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1v.1l-.2 1c-.2.9-.5 2.4-1 4.3-1 3.8-2.5 9.4-4.6 16.2-4.3 13.7-11.1 31.6-20.8 49.2-20.1 36.6-47.8 63.4-86 63.4-29 0-49.1-14.4-67-44.4-19-31.8-31.9-75.4-46.3-124.5-.2-.8-.5-1.6-.7-2.4-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32c-73.8 0-118.2 53.2-142 96.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20-.6 2.5-1.1 4.4-1.4 5.9-.2.7-.3 1.3-.4 1.7l-.1.5V217.7L32 224 .6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1" })
  }
), iY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 64c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v352h96V256c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v160c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96h-96v160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96z" })
  }
), mY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7l118.4-157.9c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z" })
  }
), aY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32zm192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32zm-288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32zm-288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32zM0 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0m576 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0" })
  }
), oY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4 38.5-240.9c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6L500 281.9l20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9l26.7 87.1H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6l-25.6-179.1-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6l-40.2 291.7c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5-25.5 179.1c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4c-3.2 10-12.5 16.9-23 16.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6 28.1-197.3c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0" })
  }
), nY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M306 50c-43.1-9.9-86 16.9-95.9 60-7.9 34.1 7.4 68.2 35.5 85.9 5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1l-82.9 132.5c3.6 6.7 5.6 14.4 5.6 22.5 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h1.7L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7 15.9-68.9 84.6-111.8 153.5-95.9 65.9 15.2 108 78.7 97.7 144.4-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4c6.4-41.1-20-80.8-61.1-90.3m-16.3 126H288c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48c0 8.1-2 15.8-5.6 22.5l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9 50 50 50 131 0 181-43 43-109 49-158.4 18-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3 31.2-31.2 31.2-81.9 0-113.1-26.8-26.8-68.1-30.6-99-11.3-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7zM448 432c-17.8 0-33.3-9.7-41.6-24H253.8c-9.2 48.3-46 88.9-97 100.7-68.9 15.9-137.6-27-153.5-95.9-14.3-61.8 18.8-123.4 75.4-147 12.2-5.1 26.3.7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8 9.9 43.1 52.9 69.9 95.9 60 37-8.5 62.1-41.5 62-77.9 0-6.4 2.5-12.5 7-17s10.6-7 17-7h174.4c8.3-14.3 23.8-24 41.6-24 26.5 0 48 21.5 48 48s-21.5 48-48 48" })
  }
), rY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M224 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0m122.5 32c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512h416c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128z" })
  }
), dY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M128 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0M391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5.3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40 0 22.1 17.9 40 40 40s40-17.9 40-40" })
  }
), SY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4a80.057 80.057 0 0 0-22.4 69.7l7.9 47.4-49.9 49.9C15.7 240.3 0 278.2 0 317.6 0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V272.1c0-79.6-64.5-144.1-144.1-144.1-82.5 0-162.4 29.5-225 83.2l-114.5 98.2c-8 6.8-18.1 10.6-28.6 10.6h-1.1c-18.3 0-34.5-11.7-40.3-29-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9l-84.8-14.3-14.1-84.7zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), zY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27v-3.1c0-33.1 9.1-64.1 25-90.6-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2 27.5-34 67.3-57.5 112.6-63.8-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16" })
  }
), pY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3l-11.2-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z" })
  }
), MY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L373.4 299c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.4c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3z" })
  }
), xY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5 12.4-43.3 1.5-91.8-32.5-125.9l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16z" })
  }
), HY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M472 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L373.4 299c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.4c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5 12.4-43.3 1.5-91.8-32.5-125.9z" })
  }
), VY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0m-115.5 73.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4l-28.2 140.9c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288h-70.3c8.6 19.6 13.3 41.2 13.3 64 0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192" })
  }
), CY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96m-71.5 151.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160 61.2 0 114.3-34.3 141.2-84.7 6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464c-61.9 0-112-50.1-112-112 0-47.9 30.1-88.8 72.5-104.8M259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h100.5c6.7 0 12.6 4.1 15 10.4l36.3 96.9c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9h-68.5l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32h-76.2z" })
  }
), LY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32zm385 251.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L356.3 417c-9.6 9.6-22.7 15-36.3 15s-26.7-5.4-36.3-15l-49-49H160c-35.3 0-64-28.7-64-64v-22.9L69 96h374l-27.2 186.5zM160 208c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h50.6a50.6 50.6 0 0 1-2.6-16c0-13.6 5.4-26.7 15-36.3l33-33V240c0-17.7-14.3-32-32-32zm85.7 98.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l60.7 60.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l60.7-60.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-60.7-60.7c-3.8-3.6-8.7-5.6-13.8-5.6s-10 2-13.7 5.7l-60.7 60.7z" })
  }
), BY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32zm55.7 192L69 96h374l-18.7 128H87.7z" })
  }
), uY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M44.1 188.8C18.5 180.5 0 156.4 0 128c0-35.3 28.7-64 64-64 23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c51 0 97.4 19.9 131.8 52.4 1.1.5 2.2 1.2 3.2 2l62.4 48.3c5.1 4 7.3 10.6 5.6 16.9l-5.7 21.1c-3.2 11.7 1.1 24.2 10.8 31.5 9.6 7.2 22.7 7.9 33 1.7l17.7-10.6c5.7-3.4 12.8-3 18 1.1L629.4 328c6.7 5 10.6 13 10.6 21.4 0 6.8-2.5 13.4-7.1 18.4l-63.4 69.7a32.05 32.05 0 0 1-23.7 10.5h-2c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81-106 0-192-86-192-192 0-23.6 4.3-46.3 12.1-67.2M288 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0M64 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32" })
  }
), RY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32m-78.7 52.5c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3zm157.4 0-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1 12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C564.9 94.1 480.6 51 386.8 37c8.6 13.7 13.1 30.1 11.9 47.6zM129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1c-45.2 11.3-86.2 33.4-120.1 63.3m260.9-63.3-4.6 65.1c30.8 9.4 58.8 25.4 82.4 46.2 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3zM384 416a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), $Y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M320 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128m0-160c-70.2 0-137.9 25.6-190.5 72-13.2 11.7-14.5 31.9-2.8 45.2 11.8 13.3 32 14.5 45.2 2.8 40.9-36.1 93.5-56 148.1-56s107.3 19.9 148.1 56c6.1 5.4 13.7 8 21.2 8 8.8 0 17.7-3.7 24-10.8 11.7-13.2 10.4-33.5-2.8-45.2-52.6-46.4-120.2-72-190.5-72zM171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128" })
  }
), kY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5.9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9 12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1l-89.3-70zm54.8 164.7-51.9-40.9c-11 8.8-21.7 18.1-31.9 27.8C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9c12.4-11.9 25.6-23 39.5-33.1M228 275.7l-55-43.4c-15.5 9.2-30.1 19.8-43.5 31.7-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zm92 76.3c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-7-1.1-13.7-3.2-20l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2" })
  }
), PY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0" })
  }
), FY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9zM320 256c56.8 0 108.6 21.1 148.2 56 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0-128 0 64 64 0 1 0 128 0" })
  }
), TY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4.1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5l-194.1 5.4c-17.4.4-21.6 24.4-5.4 30.8l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5zm-91.7-88V464h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72v-33.2zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), AY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H384c-35.3 0-64 28.7-64 64s28.7 64 64 64zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64m248 48c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h152c53 0 96 43 96 96s-43 96-96 96h-32c-17.7 0-32-14.3-32-32m72-192h-64.5c-1.4-22.2-5.6-43.7-12.3-64H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c53 0 96 43 96 96s-43 96-96 96" })
  }
), DY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c53 0 96-43 96-96S405 0 352 0h-32c-17.7 0-32 14.3-32 32m64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32M128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32" })
  }
), yY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64m-128-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0m-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64" })
  }
), bY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M480 224V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v224h448zm-64 0H280V64h136zm-184 0H96V64h136zM96 448V320H32v128c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32V320h-64v128z" })
  }
), fY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 256V64C32 28.7 60.7 0 96 0h320c35.3 0 64 28.7 64 64v384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm384 32H280v160h136zm-184 0H96v160h136zm48-64h136V64H280zM232 64H96v160h136z" })
  }
), UY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm32 64h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32" })
  }
), GY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32z" })
  }
), qY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M432 64H208c-8.8 0-16 7.2-16 16v16h-64V80c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80h-16v-64h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16M0 192c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64 32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32" })
  }
), WY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64" })
  }
), EY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h64v8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6V64.7L166.5 56C146.6 51.9 128 67 128 87.3V96H64zm64 112v128H64V144zm144-66v260l96-20V98zm214.5 215.3c14.8-3.1 25.5-16.2 25.5-31.3V154c0-15.2-10.6-28.2-25.5-31.3L432 111.3v193.4z" })
  }
), OY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6 9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l161.4-161.5c31.9-31.9 76.6-43.1 117.5-33.8 12.6 2.9 26.4.5 35.5-8.6L382 62.1l9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0l-97.4 97.4c-6.2 6.2-6.2 16.4 0 22.6z" })
  }
), IY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0h-22.1c-11.9 0-19.6 12.5-14.3 23.2l14.2 28.5c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L140.7 7.1c-3-4.5-8-7.1-13.3-7.1H64z" })
  }
), NY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0zm17.9 203.1L93.4 64h133.2l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9" })
  }
), XY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32.1 29.3C33.5 12.8 47.4 0 64 0h192c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48v-99.6C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7h143.8l-5.3-64H93.4l-5.3 64z" })
  }
), KY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M62.4 53.9c-5.6-16.8-23.8-25.8-40.5-20.3S-3.9 57.4 1.6 74.1l50 149.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46l42 167.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.6l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6zM249 224l7-28.1 7 28.1zm96 64h26.6l-15.2 45.6z" })
  }
), QY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V376c0 75.1-60.9 136-136 136s-136-60.9-136-136v-80c0-22.1-17.9-40-40-40s-40 17.9-40 40v168c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192h-32c-53 0-96-43-96-96m144-8a24 24 0 1 0-48 0 24 24 0 1 0 48 0" })
  }
), ZY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M144 112C144 50.1 194.1 0 256 0h16c8.8 0 16 7.2 16 16v16c0 60.2-47.5 109.3-107 111.9-23.9 32.2-37 71.5-37 112.1 0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5c-32.2-16.1-67.7-24.5-103.7-24.5h-23.2c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2-5.6-3.2-11-6.7-16.3-10.3-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9 13.8-8 28.4-13.1 43.3-15.5-40.5-21.4-68-64-68-113v-16c0-8.8 7.2-16 16-16 15.9 0 31.1 2.9 45.2 8.2-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9 26.2 15.2 45 38.3 55.2 64.5zm315 31.9C399.5 141.3 352 92.2 352 32V16c0-8.8 7.2-16 16-16h16c61.9 0 112 50.1 112 112v1c10.2-26.2 29-49.2 55.3-64.4 7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9 14.1-5.3 29.3-8.2 45.2-8.2 8.8 0 16 7.2 16 16v16c0 49-27.5 91.6-68 113.1 14.8 2.4 29.5 7.5 43.3 15.5 7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-24.2 42-68.7 65.1-114 64a56.04 56.04 0 0 0-18.1-14.4l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1-10.4-4.8-21-9-31.8-12.6-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-40.6-13.1-79.9-37-112.1" })
  }
), JY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M122.2 42.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6 5.8-1.7 11.9-2.6 18.2-2.6 35.3 0 64 28.7 64 64 0 6.3-.9 12.5-2.6 18.2 24.8 8.8 42.6 32.5 42.6 60.3 0 15.8-5.7 30.2-15.2 41.4 9.5 11.2 15.2 25.6 15.2 41.4 0 27.9-17.8 51.6-42.6 60.3 1.7 5.8 2.6 11.9 2.6 18.2 0 32.6-24.4 59.6-56 63.5v-3.7c0-28.6-23.2-51.8-51.8-51.8-7.2 0-14.4 1.5-21 4.5L224 381l-55.2-24.5c-6.6-2.9-13.8-4.5-21-4.5-28.6 0-51.8 23.2-51.8 51.8v3.7c-31.6-3.9-56-30.9-56-63.5 0-6.3.9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3-1.7-5.8-2.6-12-2.6-18.3 0-35.3 28.7-64 64-64 6.3 0 12.5.9 18.2 2.6m80.8 99.8c-5.7 6-13.6 9.4-21.9 9.1-16.6-.6-30.2 13-29.6 29.6.3 8.3-3 16.3-9.1 21.9-12.1 11.3-12.1 30.6 0 41.9 6 5.7 9.4 13.6 9.1 21.9-.6 16.6 13 30.2 29.6 29.6 8.3-.3 16.3 3 21.9 9.1 11.3 12.1 30.6 12.1 41.9 0 5.7-6 13.6-9.4 21.9-9.1 16.6.6 30.2-13 29.6-29.6-.3-8.3 3-16.3 9.1-21.9 12.1-11.3 12.1-30.6 0-41.9-6-5.7-9.4-13.6-9.1-21.9.6-16.6-13-30.2-29.6-29.6-8.3.3-16.3-3-21.9-9.1-11.3-12.1-30.6-12.1-41.9 0m-75 261.4c0-10.9 8.9-19.8 19.8-19.8 2.8 0 5.5.6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7 10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7-10.9 0-19.8-8.9-19.8-19.8z" })
  }
), jY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "m132.7 164.7 48 48c6.2 6.2 16.4 6.2 22.6 0l48-48c3-3 4.7-7.1 4.7-11.3V17.6c0-11 10.9-18.7 20.8-13.8C340.3 35 384 100.4 384 176c0 71.1-38.6 133.1-96 166.3V464c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V342.3C38.6 309.1 0 247.1 0 176 0 100.4 43.7 35 107.2 3.7c9.9-4.9 20.8 2.8 20.8 13.9v135.8c0 4.2 1.7 8.3 4.7 11.3z" })
  }
), YY1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M352 320c88.4 0 160-71.6 160-160 0-15.3-2.2-30.1-6.2-44.2-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16v-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0c-88.4 0-160 71.6-160 160 0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1 0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l181.6-181.6c17 6.2 35.4 9.5 54.5 9.5M80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48" })
  }
), _Y1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32v320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64m256 32c-8.8 0-16 7.2-16 16v32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h112v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8 0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6h120.8c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4 0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H272v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-32c0-8.8-7.2-16-16-16m-48 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32m80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0" })
  }
), h_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5c-11.3-13.6-31.5-15.4-45.1-4.1S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306l135.4 162.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256z" })
  }
), c_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256l169.3 169.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6c-12.5-12.5-12.5-32.7 0-45.2s32.8-12.5 45.3 0L224 210.7 393.4 41.4z" })
  }
), s_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M96 80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v304H96zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47zM0 336c0-26.5 21.5-48 48-48h16v128h448V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z" })
  }
), v_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256z" })
  }
), e_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zm258 0c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zm190 0c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z" })
  }
), l_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6l154 215.7V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-7-44.6 7.4L192 232.9 58 45.4z" })
  }
), t_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-32h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.2l94.8-142.3c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z" })
  }
), w_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M256 64c53 0 96 43 96 96s-43 96-96 96-96 43-96 96 43 96 96 96c-106 0-192-86-192-192S150 64 256 64m0 448a256 256 0 1 0 0-512 256 256 0 1 0 0 512m32-352a32 32 0 1 0-64 0 32 32 0 1 0 64 0m-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })
  }
), g_1 = (c) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    ...c,
    children: /* @__PURE__ */ h("path", { d: "M0 64c0-17.7 14.3-32 32-32h320c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64" })
  }
);
export {
  w as BrandsAccessibleIcon,
  g as BrandsAccusoft,
  i as BrandsAdn,
  m as BrandsAdversal,
  a as BrandsAffiliatetheme,
  o as BrandsAirbnb,
  n as BrandsAlgolia,
  r as BrandsAlipay,
  S as BrandsAmazon,
  d as BrandsAmazonPay,
  z as BrandsAmilia,
  p as BrandsAndroid,
  M as BrandsAngellist,
  x as BrandsAngrycreative,
  H as BrandsAngular,
  C as BrandsAppStore,
  V as BrandsAppStoreIos,
  L as BrandsApper,
  u as BrandsApple,
  B as BrandsApplePay,
  R as BrandsArtstation,
  $ as BrandsAsymmetrik,
  k as BrandsAtlassian,
  P as BrandsAudible,
  F as BrandsAutoprefixer,
  T as BrandsAvianex,
  A as BrandsAviato,
  D as BrandsAws,
  y as BrandsBandcamp,
  b as BrandsBattleNet,
  f as BrandsBehance,
  U as BrandsBilibili,
  G as BrandsBimobject,
  q as BrandsBitbucket,
  W as BrandsBitcoin,
  E as BrandsBity,
  O as BrandsBlackTie,
  I as BrandsBlackberry,
  X as BrandsBlogger,
  N as BrandsBloggerB,
  Q as BrandsBluetooth,
  K as BrandsBluetoothB,
  Z as BrandsBootstrap,
  J as BrandsBots,
  j as BrandsBtc,
  Y as BrandsBuffer,
  _ as BrandsBuromobelexperte,
  h1 as BrandsBuyNLarge,
  c1 as BrandsBuysellads,
  s1 as BrandsCanadianMapleLeaf,
  v1 as BrandsCcAmazonPay,
  e1 as BrandsCcAmex,
  l1 as BrandsCcApplePay,
  t1 as BrandsCcDinersClub,
  w1 as BrandsCcDiscover,
  g1 as BrandsCcJcb,
  i1 as BrandsCcMastercard,
  m1 as BrandsCcPaypal,
  a1 as BrandsCcStripe,
  o1 as BrandsCcVisa,
  n1 as BrandsCentercode,
  r1 as BrandsCentos,
  d1 as BrandsChrome,
  S1 as BrandsChromecast,
  z1 as BrandsCloudflare,
  p1 as BrandsCloudscale,
  M1 as BrandsCloudsmith,
  x1 as BrandsCloudversify,
  H1 as BrandsCmplid,
  V1 as BrandsCodepen,
  C1 as BrandsCodiepie,
  L1 as BrandsConfluence,
  B1 as BrandsConnectdevelop,
  u1 as BrandsContao,
  R1 as BrandsCottonBureau,
  $1 as BrandsCpanel,
  E1 as BrandsCreativeCommons,
  k1 as BrandsCreativeCommonsBy,
  T1 as BrandsCreativeCommonsNc,
  P1 as BrandsCreativeCommonsNcEu,
  F1 as BrandsCreativeCommonsNcJp,
  A1 as BrandsCreativeCommonsNd,
  y1 as BrandsCreativeCommonsPd,
  D1 as BrandsCreativeCommonsPdAlt,
  b1 as BrandsCreativeCommonsRemix,
  f1 as BrandsCreativeCommonsSa,
  G1 as BrandsCreativeCommonsSampling,
  U1 as BrandsCreativeCommonsSamplingPlus,
  q1 as BrandsCreativeCommonsShare,
  W1 as BrandsCreativeCommonsZero,
  O1 as BrandsCriticalRole,
  N1 as BrandsCss3,
  I1 as BrandsCss3Alt,
  X1 as BrandsCuttlefish,
  Q1 as BrandsDAndD,
  K1 as BrandsDAndDBeyond,
  Z1 as BrandsDailymotion,
  J1 as BrandsDashcube,
  j1 as BrandsDebian,
  Y1 as BrandsDeezer,
  _1 as BrandsDelicious,
  h2 as BrandsDeploydog,
  c2 as BrandsDeskpro,
  s2 as BrandsDev,
  v2 as BrandsDeviantart,
  e2 as BrandsDhl,
  l2 as BrandsDiaspora,
  t2 as BrandsDigg,
  w2 as BrandsDigitalOcean,
  g2 as BrandsDiscord,
  i2 as BrandsDiscourse,
  m2 as BrandsDochub,
  a2 as BrandsDocker,
  o2 as BrandsDraft2Digital,
  n2 as BrandsDribbble,
  r2 as BrandsDropbox,
  d2 as BrandsDrupal,
  S2 as BrandsDyalog,
  z2 as BrandsEarlybirds,
  p2 as BrandsEbay,
  x2 as BrandsEdge,
  M2 as BrandsEdgeLegacy,
  H2 as BrandsElementor,
  V2 as BrandsEllo,
  C2 as BrandsEmber,
  L2 as BrandsEmpire,
  B2 as BrandsEnvira,
  u2 as BrandsErlang,
  R2 as BrandsEthereum,
  $2 as BrandsEtsy,
  k2 as BrandsEvernote,
  P2 as BrandsExpeditedssl,
  A2 as BrandsFacebook,
  F2 as BrandsFacebookF,
  T2 as BrandsFacebookMessenger,
  D2 as BrandsFantasyFlightGames,
  y2 as BrandsFedex,
  b2 as BrandsFedora,
  f2 as BrandsFigma,
  G2 as BrandsFirefox,
  U2 as BrandsFirefoxBrowser,
  W2 as BrandsFirstOrder,
  q2 as BrandsFirstOrderAlt,
  E2 as BrandsFirstdraft,
  O2 as BrandsFlickr,
  I2 as BrandsFlipboard,
  N2 as BrandsFly,
  X2 as BrandsFontAwesome,
  Q2 as BrandsFonticons,
  K2 as BrandsFonticonsFi,
  J2 as BrandsFortAwesome,
  Z2 as BrandsFortAwesomeAlt,
  j2 as BrandsForumbee,
  Y2 as BrandsFoursquare,
  _2 as BrandsFreeCodeCamp,
  h4 as BrandsFreebsd,
  c4 as BrandsFulcrum,
  s4 as BrandsGalacticRepublic,
  v4 as BrandsGalacticSenate,
  e4 as BrandsGetPocket,
  t4 as BrandsGg,
  l4 as BrandsGgCircle,
  g4 as BrandsGit,
  w4 as BrandsGitAlt,
  m4 as BrandsGithub,
  i4 as BrandsGithubAlt,
  a4 as BrandsGitkraken,
  o4 as BrandsGitlab,
  n4 as BrandsGitter,
  d4 as BrandsGlide,
  r4 as BrandsGlideG,
  S4 as BrandsGofore,
  z4 as BrandsGolang,
  M4 as BrandsGoodreads,
  p4 as BrandsGoodreadsG,
  u4 as BrandsGoogle,
  x4 as BrandsGoogleDrive,
  H4 as BrandsGooglePay,
  V4 as BrandsGooglePlay,
  L4 as BrandsGooglePlus,
  C4 as BrandsGooglePlusG,
  B4 as BrandsGoogleWallet,
  R4 as BrandsGratipay,
  $4 as BrandsGrav,
  k4 as BrandsGripfire,
  P4 as BrandsGrunt,
  F4 as BrandsGuilded,
  T4 as BrandsGulp,
  A4 as BrandsHackerNews,
  D4 as BrandsHackerrank,
  y4 as BrandsHashnode,
  b4 as BrandsHips,
  f4 as BrandsHireAHelper,
  U4 as BrandsHive,
  G4 as BrandsHooli,
  q4 as BrandsHornbill,
  W4 as BrandsHotjar,
  E4 as BrandsHouzz,
  O4 as BrandsHtml5,
  I4 as BrandsHubspot,
  N4 as BrandsIdeal,
  X4 as BrandsImdb,
  K4 as BrandsInstagram,
  Q4 as BrandsInstalod,
  Z4 as BrandsIntercom,
  J4 as BrandsInternetExplorer,
  j4 as BrandsInvision,
  Y4 as BrandsIoxhost,
  _4 as BrandsItchIo,
  c3 as BrandsItunes,
  h3 as BrandsItunesNote,
  s3 as BrandsJava,
  v3 as BrandsJediOrder,
  e3 as BrandsJenkins,
  l3 as BrandsJira,
  t3 as BrandsJoget,
  w3 as BrandsJoomla,
  g3 as BrandsJs,
  i3 as BrandsJsfiddle,
  m3 as BrandsKaggle,
  a3 as BrandsKeybase,
  o3 as BrandsKeycdn,
  r3 as BrandsKickstarter,
  n3 as BrandsKickstarterK,
  d3 as BrandsKorvue,
  S3 as BrandsLaravel,
  z3 as BrandsLastfm,
  p3 as BrandsLeanpub,
  M3 as BrandsLess,
  x3 as BrandsLine,
  V3 as BrandsLinkedin,
  H3 as BrandsLinkedinIn,
  C3 as BrandsLinode,
  L3 as BrandsLinux,
  B3 as BrandsLyft,
  u3 as BrandsMagento,
  R3 as BrandsMailchimp,
  $3 as BrandsMandalorian,
  k3 as BrandsMarkdown,
  P3 as BrandsMastodon,
  F3 as BrandsMaxcdn,
  T3 as BrandsMdb,
  A3 as BrandsMedapps,
  D3 as BrandsMedium,
  y3 as BrandsMedrt,
  b3 as BrandsMeetup,
  f3 as BrandsMegaport,
  U3 as BrandsMendeley,
  G3 as BrandsMeta,
  q3 as BrandsMicroblog,
  W3 as BrandsMicrosoft,
  E3 as BrandsMix,
  O3 as BrandsMixcloud,
  I3 as BrandsMixer,
  N3 as BrandsMizuni,
  X3 as BrandsModx,
  K3 as BrandsMonero,
  Q3 as BrandsNapster,
  Z3 as BrandsNeos,
  J3 as BrandsNfcDirectional,
  j3 as BrandsNfcSymbol,
  Y3 as BrandsNimblr,
  h0 as BrandsNode,
  _3 as BrandsNodeJs,
  c0 as BrandsNpm,
  s0 as BrandsNs8,
  v0 as BrandsNutritionix,
  e0 as BrandsOctopusDeploy,
  l0 as BrandsOdnoklassniki,
  t0 as BrandsOdysee,
  w0 as BrandsOldRepublic,
  g0 as BrandsOpencart,
  i0 as BrandsOpenid,
  m0 as BrandsOpera,
  a0 as BrandsOptinMonster,
  o0 as BrandsOrcid,
  n0 as BrandsOsi,
  r0 as BrandsPadlet,
  d0 as BrandsPage4,
  S0 as BrandsPagelines,
  z0 as BrandsPalfed,
  p0 as BrandsPatreon,
  M0 as BrandsPaypal,
  x0 as BrandsPerbyte,
  H0 as BrandsPeriscope,
  V0 as BrandsPhabricator,
  C0 as BrandsPhoenixFramework,
  L0 as BrandsPhoenixSquadron,
  B0 as BrandsPhp,
  k0 as BrandsPiedPiper,
  u0 as BrandsPiedPiperAlt,
  R0 as BrandsPiedPiperHat,
  $0 as BrandsPiedPiperPp,
  F0 as BrandsPinterest,
  P0 as BrandsPinterestP,
  T0 as BrandsPix,
  A0 as BrandsPlaystation,
  D0 as BrandsProductHunt,
  y0 as BrandsPushed,
  b0 as BrandsPython,
  f0 as BrandsQq,
  U0 as BrandsQuinscape,
  G0 as BrandsQuora,
  q0 as BrandsRProject,
  W0 as BrandsRaspberryPi,
  E0 as BrandsRavelry,
  O0 as BrandsReact,
  I0 as BrandsReacteurope,
  N0 as BrandsReadme,
  X0 as BrandsRebel,
  K0 as BrandsRedRiver,
  Z0 as BrandsReddit,
  Q0 as BrandsRedditAlien,
  J0 as BrandsRedhat,
  j0 as BrandsRenren,
  Y0 as BrandsReplyd,
  _0 as BrandsResearchgate,
  h6 as BrandsResolving,
  c6 as BrandsRev,
  s6 as BrandsRocketchat,
  v6 as BrandsRockrms,
  e6 as BrandsRust,
  l6 as BrandsSafari,
  t6 as BrandsSalesforce,
  w6 as BrandsSass,
  g6 as BrandsSchlix,
  i6 as BrandsScreenpal,
  m6 as BrandsScribd,
  a6 as BrandsSearchengin,
  o6 as BrandsSellcast,
  n6 as BrandsSellsy,
  r6 as BrandsServicestack,
  d6 as BrandsShirtsinbulk,
  S6 as BrandsShoelace,
  z6 as BrandsShopify,
  p6 as BrandsShopware,
  M6 as BrandsSimplybuilt,
  x6 as BrandsSistrix,
  H6 as BrandsSith,
  V6 as BrandsSitrox,
  C6 as BrandsSketch,
  L6 as BrandsSkyatlas,
  B6 as BrandsSkype,
  u6 as BrandsSlack,
  R6 as BrandsSlideshare,
  $6 as BrandsSnapchat,
  k6 as BrandsSoundcloud,
  P6 as BrandsSourcetree,
  F6 as BrandsSpaceAwesome,
  T6 as BrandsSpeakap,
  A6 as BrandsSpeakerDeck,
  D6 as BrandsSpotify,
  y6 as BrandsSquareBehance,
  b6 as BrandsSquareDribbble,
  f6 as BrandsSquareFacebook,
  G6 as BrandsSquareFontAwesome,
  U6 as BrandsSquareFontAwesomeStroke,
  q6 as BrandsSquareGit,
  W6 as BrandsSquareGithub,
  E6 as BrandsSquareGitlab,
  O6 as BrandsSquareGooglePlus,
  I6 as BrandsSquareHackerNews,
  N6 as BrandsSquareInstagram,
  X6 as BrandsSquareJs,
  K6 as BrandsSquareLastfm,
  Q6 as BrandsSquareOdnoklassniki,
  Z6 as BrandsSquarePiedPiper,
  J6 as BrandsSquarePinterest,
  j6 as BrandsSquareReddit,
  Y6 as BrandsSquareSnapchat,
  _6 as BrandsSquareSteam,
  h8 as BrandsSquareThreads,
  c8 as BrandsSquareTumblr,
  s8 as BrandsSquareTwitter,
  v8 as BrandsSquareViadeo,
  e8 as BrandsSquareVimeo,
  l8 as BrandsSquareWhatsapp,
  t8 as BrandsSquareXTwitter,
  w8 as BrandsSquareXing,
  g8 as BrandsSquareYoutube,
  i8 as BrandsSquarespace,
  m8 as BrandsStackExchange,
  a8 as BrandsStackOverflow,
  o8 as BrandsStackpath,
  n8 as BrandsStaylinked,
  d8 as BrandsSteam,
  r8 as BrandsSteamSymbol,
  S8 as BrandsStickerMule,
  z8 as BrandsStrava,
  M8 as BrandsStripe,
  p8 as BrandsStripeS,
  x8 as BrandsStubber,
  H8 as BrandsStudiovinari,
  C8 as BrandsStumbleupon,
  V8 as BrandsStumbleuponCircle,
  L8 as BrandsSuperpowers,
  B8 as BrandsSupple,
  u8 as BrandsSuse,
  l as BrandsSvg42Group,
  t as BrandsSvg500Px,
  R8 as BrandsSwift,
  $8 as BrandsSymfony,
  k8 as BrandsTeamspeak,
  P8 as BrandsTelegram,
  F8 as BrandsTencentWeibo,
  T8 as BrandsTheRedYeti,
  A8 as BrandsThemeco,
  D8 as BrandsThemeisle,
  y8 as BrandsThinkPeaks,
  b8 as BrandsThreads,
  f8 as BrandsTiktok,
  U8 as BrandsTradeFederation,
  G8 as BrandsTrello,
  q8 as BrandsTumblr,
  W8 as BrandsTwitch,
  E8 as BrandsTwitter,
  O8 as BrandsTypo3,
  I8 as BrandsUber,
  N8 as BrandsUbuntu,
  X8 as BrandsUikit,
  K8 as BrandsUmbraco,
  Q8 as BrandsUncharted,
  Z8 as BrandsUniregistry,
  J8 as BrandsUnity,
  j8 as BrandsUnsplash,
  Y8 as BrandsUntappd,
  _8 as BrandsUps,
  h5 as BrandsUsb,
  c5 as BrandsUsps,
  s5 as BrandsUssunnah,
  v5 as BrandsVaadin,
  e5 as BrandsViacoin,
  l5 as BrandsViadeo,
  t5 as BrandsViber,
  g5 as BrandsVimeo,
  w5 as BrandsVimeoV,
  i5 as BrandsVine,
  m5 as BrandsVk,
  a5 as BrandsVnv,
  o5 as BrandsVuejs,
  n5 as BrandsWatchmanMonitoring,
  r5 as BrandsWaze,
  d5 as BrandsWeebly,
  S5 as BrandsWeibo,
  z5 as BrandsWeixin,
  p5 as BrandsWhatsapp,
  M5 as BrandsWhmcs,
  x5 as BrandsWikipediaW,
  H5 as BrandsWindows,
  V5 as BrandsWirsindhandwerk,
  C5 as BrandsWix,
  L5 as BrandsWizardsOfTheCoast,
  B5 as BrandsWodu,
  u5 as BrandsWolfPackBattalion,
  $5 as BrandsWordpress,
  R5 as BrandsWordpressSimple,
  k5 as BrandsWpbeginner,
  P5 as BrandsWpexplorer,
  F5 as BrandsWpforms,
  T5 as BrandsWpressr,
  A5 as BrandsXTwitter,
  D5 as BrandsXbox,
  y5 as BrandsXing,
  b5 as BrandsYCombinator,
  f5 as BrandsYahoo,
  U5 as BrandsYammer,
  q5 as BrandsYandex,
  G5 as BrandsYandexInternational,
  W5 as BrandsYarn,
  E5 as BrandsYelp,
  O5 as BrandsYoast,
  I5 as BrandsYoutube,
  N5 as BrandsZhihu,
  e as RealforceRealforceAdvertising,
  e7 as SRegularA,
  l7 as SRegularAbacus,
  t7 as SRegularAccentGrave,
  w7 as SRegularAcorn,
  g7 as SRegularAddressBook,
  i7 as SRegularAddressCard,
  m7 as SRegularAirConditioner,
  a7 as SRegularAirplay,
  o7 as SRegularAlarmClock,
  n7 as SRegularAlarmExclamation,
  r7 as SRegularAlarmPlus,
  d7 as SRegularAlarmSnooze,
  H7 as SRegularAlbum,
  S7 as SRegularAlbumCirclePlus,
  z7 as SRegularAlbumCircleUser,
  x7 as SRegularAlbumCollection,
  p7 as SRegularAlbumCollectionCirclePlus,
  M7 as SRegularAlbumCollectionCircleUser,
  V7 as SRegularAlicorn,
  L7 as SRegularAlien,
  C7 as SRegularAlien8Bit,
  B7 as SRegularAlignCenter,
  u7 as SRegularAlignJustify,
  R7 as SRegularAlignLeft,
  $7 as SRegularAlignRight,
  k7 as SRegularAlignSlash,
  P7 as SRegularAlt,
  F7 as SRegularAmpGuitar,
  T7 as SRegularAmpersand,
  f7 as SRegularAnchor,
  A7 as SRegularAnchorCircleCheck,
  D7 as SRegularAnchorCircleExclamation,
  y7 as SRegularAnchorCircleXmark,
  b7 as SRegularAnchorLock,
  U7 as SRegularAngel,
  I7 as SRegularAngle,
  G7 as SRegularAngle90,
  q7 as SRegularAngleDown,
  W7 as SRegularAngleLeft,
  E7 as SRegularAngleRight,
  O7 as SRegularAngleUp,
  N7 as SRegularAnglesDown,
  X7 as SRegularAnglesLeft,
  K7 as SRegularAnglesRight,
  Z7 as SRegularAnglesUp,
  Q7 as SRegularAnglesUpDown,
  J7 as SRegularAnkh,
  j7 as SRegularApartment,
  Y7 as SRegularAperture,
  _7 as SRegularApostrophe,
  h9 as SRegularAppleCore,
  c9 as SRegularAppleWhole,
  s9 as SRegularArchway,
  $9 as SRegularArrowDown,
  v9 as SRegularArrowDown19,
  e9 as SRegularArrowDown91,
  l9 as SRegularArrowDownAZ,
  t9 as SRegularArrowDownArrowUp,
  w9 as SRegularArrowDownBigSmall,
  g9 as SRegularArrowDownFromArc,
  i9 as SRegularArrowDownFromDottedLine,
  m9 as SRegularArrowDownFromLine,
  o9 as SRegularArrowDownLeft,
  a9 as SRegularArrowDownLeftAndArrowUpRightToCenter,
  n9 as SRegularArrowDownLong,
  r9 as SRegularArrowDownRight,
  d9 as SRegularArrowDownShortWide,
  S9 as SRegularArrowDownSmallBig,
  z9 as SRegularArrowDownSquareTriangle,
  p9 as SRegularArrowDownToArc,
  M9 as SRegularArrowDownToBracket,
  x9 as SRegularArrowDownToDottedLine,
  H9 as SRegularArrowDownToLine,
  V9 as SRegularArrowDownToSquare,
  C9 as SRegularArrowDownTriangleSquare,
  L9 as SRegularArrowDownUpAcrossLine,
  B9 as SRegularArrowDownUpLock,
  u9 as SRegularArrowDownWideShort,
  R9 as SRegularArrowDownZA,
  y9 as SRegularArrowLeft,
  k9 as SRegularArrowLeftFromArc,
  P9 as SRegularArrowLeftFromLine,
  T9 as SRegularArrowLeftLong,
  F9 as SRegularArrowLeftLongToLine,
  A9 as SRegularArrowLeftToArc,
  D9 as SRegularArrowLeftToLine,
  b9 as SRegularArrowPointer,
  f9 as SRegularArrowProgress,
  Q9 as SRegularArrowRight,
  U9 as SRegularArrowRightArrowLeft,
  G9 as SRegularArrowRightFromArc,
  q9 as SRegularArrowRightFromBracket,
  W9 as SRegularArrowRightFromLine,
  O9 as SRegularArrowRightLong,
  E9 as SRegularArrowRightLongToLine,
  I9 as SRegularArrowRightToArc,
  N9 as SRegularArrowRightToBracket,
  X9 as SRegularArrowRightToCity,
  K9 as SRegularArrowRightToLine,
  Z9 as SRegularArrowRotateLeft,
  J9 as SRegularArrowRotateRight,
  j9 as SRegularArrowTrendDown,
  Y9 as SRegularArrowTrendUp,
  ch as SRegularArrowTurnDown,
  _9 as SRegularArrowTurnDownLeft,
  hh as SRegularArrowTurnDownRight,
  sh as SRegularArrowTurnUp,
  Fh as SRegularArrowUp,
  vh as SRegularArrowUp19,
  eh as SRegularArrowUp91,
  lh as SRegularArrowUpAZ,
  th as SRegularArrowUpArrowDown,
  wh as SRegularArrowUpBigSmall,
  gh as SRegularArrowUpFromArc,
  ih as SRegularArrowUpFromBracket,
  mh as SRegularArrowUpFromDottedLine,
  ah as SRegularArrowUpFromGroundWater,
  oh as SRegularArrowUpFromLine,
  nh as SRegularArrowUpFromSquare,
  rh as SRegularArrowUpFromWaterPump,
  Sh as SRegularArrowUpLeft,
  dh as SRegularArrowUpLeftFromCircle,
  zh as SRegularArrowUpLong,
  Hh as SRegularArrowUpRight,
  ph as SRegularArrowUpRightAndArrowDownLeftFromCenter,
  Mh as SRegularArrowUpRightDots,
  xh as SRegularArrowUpRightFromSquare,
  Vh as SRegularArrowUpShortWide,
  Ch as SRegularArrowUpSmallBig,
  Lh as SRegularArrowUpSquareTriangle,
  Bh as SRegularArrowUpToArc,
  uh as SRegularArrowUpToDottedLine,
  Rh as SRegularArrowUpToLine,
  $h as SRegularArrowUpTriangleSquare,
  kh as SRegularArrowUpWideShort,
  Ph as SRegularArrowUpZA,
  Th as SRegularArrowsCross,
  Ah as SRegularArrowsDownToLine,
  Dh as SRegularArrowsDownToPeople,
  yh as SRegularArrowsFromDottedLine,
  bh as SRegularArrowsFromLine,
  Uh as SRegularArrowsLeftRight,
  fh as SRegularArrowsLeftRightToLine,
  Gh as SRegularArrowsMaximize,
  qh as SRegularArrowsMinimize,
  Eh as SRegularArrowsRepeat,
  Wh as SRegularArrowsRepeat1,
  Oh as SRegularArrowsRetweet,
  Ih as SRegularArrowsRotate,
  Nh as SRegularArrowsSpin,
  Xh as SRegularArrowsSplitUpAndLeft,
  Kh as SRegularArrowsToCircle,
  Qh as SRegularArrowsToDot,
  Zh as SRegularArrowsToDottedLine,
  Jh as SRegularArrowsToEye,
  jh as SRegularArrowsToLine,
  Yh as SRegularArrowsTurnRight,
  _h as SRegularArrowsTurnToDots,
  cc as SRegularArrowsUpDown,
  hc as SRegularArrowsUpDownLeftRight,
  sc as SRegularArrowsUpToLine,
  vc as SRegularAsterisk,
  ec as SRegularAt,
  tc as SRegularAtom,
  lc as SRegularAtomSimple,
  gc as SRegularAudioDescription,
  wc as SRegularAudioDescriptionSlash,
  ic as SRegularAustralSign,
  mc as SRegularAvocado,
  oc as SRegularAward,
  ac as SRegularAwardSimple,
  rc as SRegularAxe,
  nc as SRegularAxeBattle,
  dc as SRegularB,
  zc as SRegularBaby,
  Sc as SRegularBabyCarriage,
  pc as SRegularBackpack,
  Hc as SRegularBackward,
  Mc as SRegularBackwardFast,
  xc as SRegularBackwardStep,
  Vc as SRegularBacon,
  Cc as SRegularBacteria,
  Lc as SRegularBacterium,
  kc as SRegularBadge,
  Bc as SRegularBadgeCheck,
  uc as SRegularBadgeDollar,
  Rc as SRegularBadgePercent,
  $c as SRegularBadgeSheriff,
  Pc as SRegularBadgerHoney,
  Fc as SRegularBadminton,
  Tc as SRegularBagSeedling,
  Ac as SRegularBagShopping,
  Dc as SRegularBagel,
  yc as SRegularBagsShopping,
  bc as SRegularBaguette,
  fc as SRegularBahai,
  Uc as SRegularBahtSign,
  Gc as SRegularBallPile,
  qc as SRegularBalloon,
  Wc as SRegularBalloons,
  Oc as SRegularBallot,
  Ec as SRegularBallotCheck,
  Kc as SRegularBan,
  Ic as SRegularBanBug,
  Nc as SRegularBanParking,
  Xc as SRegularBanSmoking,
  Qc as SRegularBanana,
  Zc as SRegularBandage,
  Jc as SRegularBangladeshiTakaSign,
  jc as SRegularBanjo,
  hs as SRegularBarcode,
  Yc as SRegularBarcodeRead,
  _c as SRegularBarcodeScan,
  ls as SRegularBars,
  cs as SRegularBarsFilter,
  ss as SRegularBarsProgress,
  vs as SRegularBarsSort,
  es as SRegularBarsStaggered,
  ws as SRegularBaseball,
  ts as SRegularBaseballBatBall,
  is as SRegularBasketShopping,
  gs as SRegularBasketShoppingSimple,
  as as SRegularBasketball,
  ms as SRegularBasketballHoop,
  os as SRegularBat,
  ns as SRegularBath,
  rs as SRegularBatteryBolt,
  ds as SRegularBatteryEmpty,
  Ss as SRegularBatteryExclamation,
  zs as SRegularBatteryFull,
  ps as SRegularBatteryHalf,
  Ms as SRegularBatteryLow,
  xs as SRegularBatteryQuarter,
  Hs as SRegularBatterySlash,
  Vs as SRegularBatteryThreeQuarters,
  Rs as SRegularBed,
  Cs as SRegularBedBunk,
  Ls as SRegularBedEmpty,
  Bs as SRegularBedFront,
  us as SRegularBedPulse,
  $s as SRegularBee,
  Ps as SRegularBeerMug,
  ks as SRegularBeerMugEmpty,
  Us as SRegularBell,
  Fs as SRegularBellConcierge,
  Ts as SRegularBellExclamation,
  As as SRegularBellOn,
  Ds as SRegularBellPlus,
  bs as SRegularBellSchool,
  ys as SRegularBellSchoolSlash,
  fs as SRegularBellSlash,
  Gs as SRegularBells,
  qs as SRegularBenchTree,
  Ws as SRegularBezierCurve,
  Es as SRegularBicycle,
  Os as SRegularBillboard,
  Ns as SRegularBinBottles,
  Is as SRegularBinBottlesRecycle,
  Xs as SRegularBinRecycle,
  Js as SRegularBinary,
  Ks as SRegularBinaryCircleCheck,
  Qs as SRegularBinaryLock,
  Zs as SRegularBinarySlash,
  js as SRegularBinoculars,
  Ys as SRegularBiohazard,
  _s as SRegularBird,
  hv as SRegularBitcoinSign,
  sv as SRegularBlanket,
  cv as SRegularBlanketFire,
  ev as SRegularBlender,
  vv as SRegularBlenderPhone,
  wv as SRegularBlinds,
  lv as SRegularBlindsOpen,
  tv as SRegularBlindsRaised,
  ov as SRegularBlock,
  iv as SRegularBlockBrick,
  gv as SRegularBlockBrickFire,
  mv as SRegularBlockQuestion,
  av as SRegularBlockQuote,
  nv as SRegularBlog,
  rv as SRegularBlueberries,
  dv as SRegularBluetooth,
  Sv as SRegularBold,
  xv as SRegularBolt,
  zv as SRegularBoltAuto,
  pv as SRegularBoltLightning,
  Mv as SRegularBoltSlash,
  Hv as SRegularBomb,
  Cv as SRegularBone,
  Vv as SRegularBoneBreak,
  Lv as SRegularBong,
  Kv as SRegularBook,
  Bv as SRegularBookArrowRight,
  uv as SRegularBookArrowUp,
  Rv as SRegularBookAtlas,
  $v as SRegularBookBible,
  kv as SRegularBookBlank,
  Pv as SRegularBookBookmark,
  Fv as SRegularBookCircleArrowRight,
  Tv as SRegularBookCircleArrowUp,
  Av as SRegularBookCopy,
  Dv as SRegularBookFont,
  yv as SRegularBookHeart,
  bv as SRegularBookJournalWhills,
  fv as SRegularBookMedical,
  qv as SRegularBookOpen,
  Uv as SRegularBookOpenCover,
  Gv as SRegularBookOpenReader,
  Wv as SRegularBookQuran,
  Ev as SRegularBookSection,
  Ov as SRegularBookSkull,
  Iv as SRegularBookSparkles,
  Nv as SRegularBookTanakh,
  Xv as SRegularBookUser,
  Zv as SRegularBookmark,
  Qv as SRegularBookmarkSlash,
  jv as SRegularBooks,
  Jv as SRegularBooksMedical,
  Yv as SRegularBoombox,
  he as SRegularBoot,
  _v as SRegularBootHeeled,
  ce as SRegularBoothCurtain,
  se as SRegularBorderAll,
  ee as SRegularBorderBottom,
  ve as SRegularBorderBottomRight,
  le as SRegularBorderCenterH,
  te as SRegularBorderCenterV,
  we as SRegularBorderInner,
  ge as SRegularBorderLeft,
  ie as SRegularBorderNone,
  me as SRegularBorderOuter,
  ae as SRegularBorderRight,
  ne as SRegularBorderTop,
  oe as SRegularBorderTopLeft,
  re as SRegularBoreHole,
  de as SRegularBottleDroplet,
  Se as SRegularBottleWater,
  ze as SRegularBowArrow,
  Me as SRegularBowlChopsticks,
  pe as SRegularBowlChopsticksNoodles,
  xe as SRegularBowlFood,
  He as SRegularBowlHot,
  Ve as SRegularBowlRice,
  Ce as SRegularBowlScoop,
  Le as SRegularBowlScoops,
  Be as SRegularBowlSoftServe,
  ue as SRegularBowlSpoon,
  $e as SRegularBowlingBall,
  Re as SRegularBowlingBallPin,
  ke as SRegularBowlingPins,
  qe as SRegularBox,
  Pe as SRegularBoxArchive,
  Fe as SRegularBoxBallot,
  Te as SRegularBoxCheck,
  Ae as SRegularBoxCircleCheck,
  De as SRegularBoxDollar,
  ye as SRegularBoxHeart,
  fe as SRegularBoxOpen,
  be as SRegularBoxOpenFull,
  Ue as SRegularBoxTaped,
  Ge as SRegularBoxTissue,
  We as SRegularBoxesPacking,
  Ee as SRegularBoxesStacked,
  Oe as SRegularBoxingGlove,
  Ne as SRegularBracketCurly,
  Ie as SRegularBracketCurlyRight,
  Ke as SRegularBracketRound,
  Xe as SRegularBracketRoundRight,
  Ze as SRegularBracketSquare,
  Qe as SRegularBracketSquareRight,
  Je as SRegularBracketsCurly,
  je as SRegularBracketsRound,
  Ye as SRegularBracketsSquare,
  _e as SRegularBraille,
  sl as SRegularBrain,
  hl as SRegularBrainArrowCurvedRight,
  cl as SRegularBrainCircuit,
  vl as SRegularBrakeWarning,
  el as SRegularBrazilianRealSign,
  ll as SRegularBreadLoaf,
  wl as SRegularBreadSlice,
  tl as SRegularBreadSliceButter,
  rl as SRegularBridge,
  gl as SRegularBridgeCircleCheck,
  il as SRegularBridgeCircleExclamation,
  ml as SRegularBridgeCircleXmark,
  al as SRegularBridgeLock,
  ol as SRegularBridgeSuspension,
  nl as SRegularBridgeWater,
  pl as SRegularBriefcase,
  dl as SRegularBriefcaseArrowRight,
  Sl as SRegularBriefcaseBlank,
  zl as SRegularBriefcaseMedical,
  xl as SRegularBrightness,
  Ml as SRegularBrightnessLow,
  Hl as SRegularBringForward,
  Vl as SRegularBringFront,
  Cl as SRegularBroccoli,
  ul as SRegularBroom,
  Ll as SRegularBroomBall,
  Bl as SRegularBroomWide,
  Rl as SRegularBrowser,
  $l as SRegularBrowsers,
  kl as SRegularBrush,
  Pl as SRegularBucket,
  Tl as SRegularBug,
  Fl as SRegularBugSlash,
  Al as SRegularBugs,
  Xl as SRegularBuilding,
  Dl as SRegularBuildingCircleArrowRight,
  yl as SRegularBuildingCircleCheck,
  bl as SRegularBuildingCircleExclamation,
  fl as SRegularBuildingCircleXmark,
  Ul as SRegularBuildingColumns,
  Gl as SRegularBuildingFlag,
  ql as SRegularBuildingLock,
  Wl as SRegularBuildingNgo,
  El as SRegularBuildingShield,
  Ol as SRegularBuildingUn,
  Il as SRegularBuildingUser,
  Nl as SRegularBuildingWheat,
  Kl as SRegularBuildings,
  Ql as SRegularBullhorn,
  jl as SRegularBullseye,
  Zl as SRegularBullseyeArrow,
  Jl as SRegularBullseyePointer,
  _l as SRegularBuoy,
  Yl as SRegularBuoyMooring,
  lt as SRegularBurger,
  ht as SRegularBurgerCheese,
  ct as SRegularBurgerFries,
  st as SRegularBurgerGlass,
  vt as SRegularBurgerLettuce,
  et as SRegularBurgerSoda,
  tt as SRegularBurrito,
  wt as SRegularBurst,
  mt as SRegularBus,
  gt as SRegularBusSchool,
  it as SRegularBusSimple,
  at as SRegularBusinessTime,
  ot as SRegularButter,
  nt as SRegularC,
  rt as SRegularCabin,
  dt as SRegularCabinetFiling,
  St as SRegularCableCar,
  zt as SRegularCactus,
  pt as SRegularCakeCandles,
  Mt as SRegularCakeSlice,
  Ht as SRegularCalculator,
  xt as SRegularCalculatorSimple,
  Nt as SRegularCalendar,
  Vt as SRegularCalendarArrowDown,
  Ct as SRegularCalendarArrowUp,
  Lt as SRegularCalendarCheck,
  Bt as SRegularCalendarCircleExclamation,
  ut as SRegularCalendarCircleMinus,
  Rt as SRegularCalendarCirclePlus,
  $t as SRegularCalendarCircleUser,
  kt as SRegularCalendarClock,
  Pt as SRegularCalendarDay,
  Ft as SRegularCalendarDays,
  Tt as SRegularCalendarExclamation,
  At as SRegularCalendarHeart,
  Dt as SRegularCalendarImage,
  bt as SRegularCalendarLines,
  yt as SRegularCalendarLinesPen,
  ft as SRegularCalendarMinus,
  Ut as SRegularCalendarPen,
  Gt as SRegularCalendarPlus,
  qt as SRegularCalendarRange,
  Wt as SRegularCalendarStar,
  Et as SRegularCalendarUsers,
  Ot as SRegularCalendarWeek,
  It as SRegularCalendarXmark,
  Xt as SRegularCalendars,
  Kt as SRegularCamcorder,
  ew as SRegularCamera,
  Qt as SRegularCameraCctv,
  Zt as SRegularCameraMovie,
  Jt as SRegularCameraPolaroid,
  jt as SRegularCameraRetro,
  Yt as SRegularCameraRotate,
  _t as SRegularCameraSecurity,
  hw as SRegularCameraSlash,
  cw as SRegularCameraViewfinder,
  vw as SRegularCameraWeb,
  sw as SRegularCameraWebSlash,
  lw as SRegularCampfire,
  tw as SRegularCampground,
  ww as SRegularCanFood,
  gw as SRegularCandleHolder,
  ow as SRegularCandy,
  iw as SRegularCandyBar,
  mw as SRegularCandyCane,
  aw as SRegularCandyCorn,
  nw as SRegularCannabis,
  rw as SRegularCapsules,
  Tw as SRegularCar,
  dw as SRegularCarBattery,
  Sw as SRegularCarBolt,
  zw as SRegularCarBuilding,
  pw as SRegularCarBump,
  Mw as SRegularCarBurst,
  xw as SRegularCarBus,
  Hw as SRegularCarCircleBolt,
  Vw as SRegularCarGarage,
  Cw as SRegularCarMirrors,
  Lw as SRegularCarOn,
  Bw as SRegularCarRear,
  Rw as SRegularCarSide,
  uw as SRegularCarSideBolt,
  $w as SRegularCarTilt,
  kw as SRegularCarTunnel,
  Pw as SRegularCarWash,
  Fw as SRegularCarWrench,
  Dw as SRegularCaravan,
  Aw as SRegularCaravanSimple,
  yw as SRegularCardClub,
  bw as SRegularCardDiamond,
  fw as SRegularCardHeart,
  Uw as SRegularCardSpade,
  qw as SRegularCards,
  Gw as SRegularCardsBlank,
  Ww as SRegularCaretDown,
  Ew as SRegularCaretLeft,
  Ow as SRegularCaretRight,
  Iw as SRegularCaretUp,
  Nw as SRegularCarrot,
  Xw as SRegularCars,
  Kw as SRegularCartArrowDown,
  Qw as SRegularCartArrowUp,
  Zw as SRegularCartCircleArrowDown,
  Jw as SRegularCartCircleArrowUp,
  jw as SRegularCartCircleCheck,
  Yw as SRegularCartCircleExclamation,
  _w as SRegularCartCirclePlus,
  hg as SRegularCartCircleXmark,
  eg as SRegularCartFlatbed,
  cg as SRegularCartFlatbedBoxes,
  sg as SRegularCartFlatbedEmpty,
  vg as SRegularCartFlatbedSuitcase,
  lg as SRegularCartMinus,
  tg as SRegularCartPlus,
  gg as SRegularCartShopping,
  wg as SRegularCartShoppingFast,
  ig as SRegularCartXmark,
  mg as SRegularCashRegister,
  ag as SRegularCassetteBetamax,
  og as SRegularCassetteTape,
  ng as SRegularCassetteVhs,
  rg as SRegularCastle,
  Sg as SRegularCat,
  dg as SRegularCatSpace,
  zg as SRegularCauldron,
  pg as SRegularCediSign,
  Mg as SRegularCentSign,
  xg as SRegularCertificate,
  Vg as SRegularChair,
  Hg as SRegularChairOffice,
  Lg as SRegularChalkboard,
  Cg as SRegularChalkboardUser,
  Bg as SRegularChampagneGlass,
  ug as SRegularChampagneGlasses,
  Rg as SRegularChargingStation,
  $g as SRegularChartArea,
  kg as SRegularChartBar,
  Pg as SRegularChartBullet,
  Fg as SRegularChartCandlestick,
  Tg as SRegularChartColumn,
  Ag as SRegularChartGantt,
  fg as SRegularChartLine,
  Dg as SRegularChartLineDown,
  bg as SRegularChartLineUp,
  yg as SRegularChartLineUpDown,
  qg as SRegularChartMixed,
  Ug as SRegularChartMixedUpCircleCurrency,
  Gg as SRegularChartMixedUpCircleDollar,
  Wg as SRegularChartNetwork,
  Ng as SRegularChartPie,
  Ig as SRegularChartPieSimple,
  Eg as SRegularChartPieSimpleCircleCurrency,
  Og as SRegularChartPieSimpleCircleDollar,
  Xg as SRegularChartPyramid,
  Kg as SRegularChartRadar,
  Jg as SRegularChartScatter,
  Qg as SRegularChartScatter3D,
  Zg as SRegularChartScatterBubble,
  Yg as SRegularChartSimple,
  jg as SRegularChartSimpleHorizontal,
  _g as SRegularChartTreeMap,
  hi as SRegularChartUser,
  ci as SRegularChartWaterfall,
  ei as SRegularCheck,
  si as SRegularCheckDouble,
  vi as SRegularCheckToSlot,
  ti as SRegularCheese,
  li as SRegularCheeseSwiss,
  wi as SRegularCherries,
  Ci as SRegularChess,
  ii as SRegularChessBishop,
  gi as SRegularChessBishopPiece,
  mi as SRegularChessBoard,
  oi as SRegularChessClock,
  ai as SRegularChessClockFlip,
  ri as SRegularChessKing,
  ni as SRegularChessKingPiece,
  Si as SRegularChessKnight,
  di as SRegularChessKnightPiece,
  pi as SRegularChessPawn,
  zi as SRegularChessPawnPiece,
  xi as SRegularChessQueen,
  Mi as SRegularChessQueenPiece,
  Vi as SRegularChessRook,
  Hi as SRegularChessRookPiece,
  Li as SRegularChestnut,
  Bi as SRegularChevronDown,
  ui as SRegularChevronLeft,
  Ri as SRegularChevronRight,
  $i as SRegularChevronUp,
  ki as SRegularChevronsDown,
  Pi as SRegularChevronsLeft,
  Fi as SRegularChevronsRight,
  Ti as SRegularChevronsUp,
  Ai as SRegularChfSign,
  fi as SRegularChild,
  Di as SRegularChildCombatant,
  yi as SRegularChildDress,
  bi as SRegularChildReaching,
  Ui as SRegularChildren,
  Gi as SRegularChimney,
  qi as SRegularChopsticks,
  Wi as SRegularChurch,
  Za as SRegularCircle,
  Ei as SRegularCircle0,
  Oi as SRegularCircle1,
  Ii as SRegularCircle2,
  Ni as SRegularCircle3,
  Xi as SRegularCircle4,
  Ki as SRegularCircle5,
  Qi as SRegularCircle6,
  Zi as SRegularCircle7,
  Ji as SRegularCircle8,
  ji as SRegularCircle9,
  Yi as SRegularCircleA,
  _i as SRegularCircleAmpersand,
  sm as SRegularCircleArrowDown,
  hm as SRegularCircleArrowDownLeft,
  cm as SRegularCircleArrowDownRight,
  vm as SRegularCircleArrowLeft,
  em as SRegularCircleArrowRight,
  wm as SRegularCircleArrowUp,
  lm as SRegularCircleArrowUpLeft,
  tm as SRegularCircleArrowUpRight,
  gm as SRegularCircleB,
  im as SRegularCircleBolt,
  mm as SRegularCircleBookOpen,
  am as SRegularCircleBookmark,
  om as SRegularCircleC,
  nm as SRegularCircleCalendar,
  rm as SRegularCircleCamera,
  dm as SRegularCircleCaretDown,
  Sm as SRegularCircleCaretLeft,
  zm as SRegularCircleCaretRight,
  pm as SRegularCircleCaretUp,
  Mm as SRegularCircleCheck,
  xm as SRegularCircleChevronDown,
  Hm as SRegularCircleChevronLeft,
  Vm as SRegularCircleChevronRight,
  Cm as SRegularCircleChevronUp,
  Lm as SRegularCircleD,
  Bm as SRegularCircleDashed,
  um as SRegularCircleDivide,
  $m as SRegularCircleDollar,
  Rm as SRegularCircleDollarToSlot,
  km as SRegularCircleDot,
  Tm as SRegularCircleDown,
  Pm as SRegularCircleDownLeft,
  Fm as SRegularCircleDownRight,
  Am as SRegularCircleE,
  ym as SRegularCircleEllipsis,
  Dm as SRegularCircleEllipsisVertical,
  bm as SRegularCircleEnvelope,
  fm as SRegularCircleEuro,
  Gm as SRegularCircleExclamation,
  Um as SRegularCircleExclamationCheck,
  qm as SRegularCircleF,
  Wm as SRegularCircleG,
  Em as SRegularCircleH,
  Im as SRegularCircleHalf,
  Om as SRegularCircleHalfStroke,
  Nm as SRegularCircleHeart,
  Xm as SRegularCircleI,
  Km as SRegularCircleInfo,
  Qm as SRegularCircleJ,
  Zm as SRegularCircleK,
  Jm as SRegularCircleL,
  jm as SRegularCircleLeft,
  Ym as SRegularCircleLocationArrow,
  _m as SRegularCircleM,
  ca as SRegularCircleMicrophone,
  ha as SRegularCircleMicrophoneLines,
  sa as SRegularCircleMinus,
  va as SRegularCircleN,
  ea as SRegularCircleNodes,
  la as SRegularCircleNotch,
  ta as SRegularCircleO,
  wa as SRegularCircleP,
  ga as SRegularCircleParking,
  ia as SRegularCirclePause,
  oa as SRegularCirclePhone,
  ma as SRegularCirclePhoneFlip,
  aa as SRegularCirclePhoneHangup,
  na as SRegularCirclePlay,
  ra as SRegularCirclePlus,
  da as SRegularCircleQ,
  za as SRegularCircleQuarter,
  Sa as SRegularCircleQuarterStroke,
  pa as SRegularCircleQuarters,
  Ma as SRegularCircleQuestion,
  xa as SRegularCircleR,
  Ha as SRegularCircleRadiation,
  Va as SRegularCircleRight,
  Ca as SRegularCircleS,
  La as SRegularCircleSmall,
  Ra as SRegularCircleSort,
  Ba as SRegularCircleSortDown,
  ua as SRegularCircleSortUp,
  $a as SRegularCircleStar,
  ka as SRegularCircleSterling,
  Pa as SRegularCircleStop,
  Fa as SRegularCircleT,
  Aa as SRegularCircleThreeQuarters,
  Ta as SRegularCircleThreeQuartersStroke,
  Da as SRegularCircleTrash,
  ya as SRegularCircleU,
  Ua as SRegularCircleUp,
  ba as SRegularCircleUpLeft,
  fa as SRegularCircleUpRight,
  Ga as SRegularCircleUser,
  qa as SRegularCircleV,
  Wa as SRegularCircleVideo,
  Ea as SRegularCircleW,
  Oa as SRegularCircleWaveformLines,
  Ia as SRegularCircleX,
  Na as SRegularCircleXmark,
  Xa as SRegularCircleY,
  Ka as SRegularCircleYen,
  Qa as SRegularCircleZ,
  Ja as SRegularCirclesOverlap,
  Ya as SRegularCitrus,
  ja as SRegularCitrusSlice,
  _a as SRegularCity,
  co as SRegularClapperboard,
  ho as SRegularClapperboardPlay,
  so as SRegularClarinet,
  vo as SRegularClawMarks,
  ao as SRegularClipboard,
  eo as SRegularClipboardCheck,
  to as SRegularClipboardList,
  lo as SRegularClipboardListCheck,
  wo as SRegularClipboardMedical,
  go as SRegularClipboardPrescription,
  io as SRegularClipboardQuestion,
  mo as SRegularClipboardUser,
  Uo as SRegularClock,
  oo as SRegularClockDesk,
  ro as SRegularClockEight,
  no as SRegularClockEightThirty,
  zo as SRegularClockEleven,
  So as SRegularClockElevenThirty,
  Mo as SRegularClockFive,
  po as SRegularClockFiveThirty,
  xo as SRegularClockFourThirty,
  Vo as SRegularClockNine,
  Ho as SRegularClockNineThirty,
  Lo as SRegularClockOne,
  Co as SRegularClockOneThirty,
  Bo as SRegularClockRotateLeft,
  Ro as SRegularClockSeven,
  uo as SRegularClockSevenThirty,
  ko as SRegularClockSix,
  $o as SRegularClockSixThirty,
  Fo as SRegularClockTen,
  Po as SRegularClockTenThirty,
  Ao as SRegularClockThree,
  To as SRegularClockThreeThirty,
  yo as SRegularClockTwelve,
  Do as SRegularClockTwelveThirty,
  fo as SRegularClockTwo,
  bo as SRegularClockTwoThirty,
  Go as SRegularClone,
  Wo as SRegularClosedCaptioning,
  qo as SRegularClosedCaptioningSlash,
  Eo as SRegularClothesHanger,
  Hn as SRegularCloud,
  Oo as SRegularCloudArrowDown,
  Io as SRegularCloudArrowUp,
  No as SRegularCloudBinary,
  Qo as SRegularCloudBolt,
  Xo as SRegularCloudBoltMoon,
  Ko as SRegularCloudBoltSun,
  Zo as SRegularCloudCheck,
  Jo as SRegularCloudDrizzle,
  jo as SRegularCloudExclamation,
  Yo as SRegularCloudFog,
  hn as SRegularCloudHail,
  _o as SRegularCloudHailMixed,
  cn as SRegularCloudMeatball,
  sn as SRegularCloudMinus,
  en as SRegularCloudMoon,
  vn as SRegularCloudMoonRain,
  ln as SRegularCloudMusic,
  tn as SRegularCloudPlus,
  wn as SRegularCloudQuestion,
  gn as SRegularCloudRain,
  mn as SRegularCloudRainbow,
  nn as SRegularCloudShowers,
  an as SRegularCloudShowersHeavy,
  on as SRegularCloudShowersWater,
  rn as SRegularCloudSlash,
  dn as SRegularCloudSleet,
  Sn as SRegularCloudSnow,
  pn as SRegularCloudSun,
  zn as SRegularCloudSunRain,
  Mn as SRegularCloudWord,
  xn as SRegularCloudXmark,
  Ln as SRegularClouds,
  Vn as SRegularCloudsMoon,
  Cn as SRegularCloudsSun,
  Bn as SRegularClover,
  un as SRegularClub,
  Rn as SRegularCoconut,
  fn as SRegularCode,
  $n as SRegularCodeBranch,
  kn as SRegularCodeCommit,
  Pn as SRegularCodeCompare,
  Fn as SRegularCodeFork,
  Tn as SRegularCodeMerge,
  yn as SRegularCodePullRequest,
  An as SRegularCodePullRequestClosed,
  Dn as SRegularCodePullRequestDraft,
  bn as SRegularCodeSimple,
  Un as SRegularCoffeeBean,
  Gn as SRegularCoffeeBeans,
  qn as SRegularCoffeePot,
  En as SRegularCoffin,
  Wn as SRegularCoffinCross,
  Xn as SRegularCoin,
  On as SRegularCoinBlank,
  In as SRegularCoinFront,
  Nn as SRegularCoinVertical,
  Kn as SRegularCoins,
  Zn as SRegularColon,
  Qn as SRegularColonSign,
  Jn as SRegularColumns3,
  jn as SRegularComet,
  Yn as SRegularComma,
  _n as SRegularCommand,
  ur as SRegularComment,
  hr as SRegularCommentArrowDown,
  sr as SRegularCommentArrowUp,
  cr as SRegularCommentArrowUpRight,
  vr as SRegularCommentCaptions,
  er as SRegularCommentCheck,
  lr as SRegularCommentCode,
  tr as SRegularCommentDollar,
  wr as SRegularCommentDots,
  gr as SRegularCommentExclamation,
  ir as SRegularCommentHeart,
  mr as SRegularCommentImage,
  ar as SRegularCommentLines,
  or as SRegularCommentMedical,
  rr as SRegularCommentMiddle,
  nr as SRegularCommentMiddleTop,
  dr as SRegularCommentMinus,
  Sr as SRegularCommentMusic,
  zr as SRegularCommentPen,
  pr as SRegularCommentPlus,
  Mr as SRegularCommentQuestion,
  xr as SRegularCommentQuote,
  Hr as SRegularCommentSlash,
  Vr as SRegularCommentSmile,
  Cr as SRegularCommentSms,
  Lr as SRegularCommentText,
  Br as SRegularCommentXmark,
  Pr as SRegularComments,
  Rr as SRegularCommentsDollar,
  kr as SRegularCommentsQuestion,
  $r as SRegularCommentsQuestionCheck,
  Fr as SRegularCompactDisc,
  Dr as SRegularCompass,
  Tr as SRegularCompassDrafting,
  Ar as SRegularCompassSlash,
  br as SRegularCompress,
  yr as SRegularCompressWide,
  Wr as SRegularComputer,
  fr as SRegularComputerClassic,
  Gr as SRegularComputerMouse,
  Ur as SRegularComputerMouseScrollwheel,
  qr as SRegularComputerSpeaker,
  Er as SRegularContainerStorage,
  Xr as SRegularConveyorBelt,
  Or as SRegularConveyorBeltArm,
  Ir as SRegularConveyorBeltBoxes,
  Nr as SRegularConveyorBeltEmpty,
  Qr as SRegularCookie,
  Kr as SRegularCookieBite,
  Zr as SRegularCopy,
  Jr as SRegularCopyright,
  jr as SRegularCorn,
  Yr as SRegularCorner,
  _r as SRegularCouch,
  hd as SRegularCow,
  sd as SRegularCowbell,
  cd as SRegularCowbellCirclePlus,
  vd as SRegularCrab,
  ed as SRegularCrateApple,
  ld as SRegularCrateEmpty,
  gd as SRegularCreditCard,
  td as SRegularCreditCardBlank,
  wd as SRegularCreditCardFront,
  id as SRegularCricketBatBall,
  md as SRegularCroissant,
  od as SRegularCrop,
  ad as SRegularCropSimple,
  nd as SRegularCross,
  dd as SRegularCrosshairs,
  rd as SRegularCrosshairsSimple,
  Sd as SRegularCrow,
  zd as SRegularCrown,
  pd as SRegularCrutch,
  Md as SRegularCrutches,
  xd as SRegularCruzeiroSign,
  Hd as SRegularCrystalBall,
  Vd as SRegularCube,
  Ld as SRegularCubes,
  Cd as SRegularCubesStacked,
  Bd as SRegularCucumber,
  Rd as SRegularCupStraw,
  ud as SRegularCupStrawSwoosh,
  $d as SRegularCupTogo,
  kd as SRegularCupcake,
  Pd as SRegularCurlingStone,
  Fd as SRegularCustard,
  Td as SRegularD,
  Ad as SRegularDagger,
  Dd as SRegularDash,
  yd as SRegularDatabase,
  fd as SRegularDeer,
  bd as SRegularDeerRudolph,
  Ud as SRegularDeleteLeft,
  Gd as SRegularDeleteRight,
  qd as SRegularDemocrat,
  Ed as SRegularDesktop,
  Wd as SRegularDesktopArrowDown,
  Od as SRegularDharmachakra,
  Id as SRegularDiagramCells,
  Nd as SRegularDiagramLeanCanvas,
  Xd as SRegularDiagramNested,
  Kd as SRegularDiagramNext,
  Qd as SRegularDiagramPredecessor,
  Zd as SRegularDiagramPrevious,
  Jd as SRegularDiagramProject,
  jd as SRegularDiagramSankey,
  Yd as SRegularDiagramSubtask,
  _d as SRegularDiagramSuccessor,
  hS as SRegularDiagramVenn,
  gS as SRegularDial,
  cS as SRegularDialHigh,
  sS as SRegularDialLow,
  vS as SRegularDialMax,
  lS as SRegularDialMed,
  eS as SRegularDialMedLow,
  tS as SRegularDialMin,
  wS as SRegularDialOff,
  nS as SRegularDiamond,
  iS as SRegularDiamondExclamation,
  aS as SRegularDiamondHalf,
  mS as SRegularDiamondHalfStroke,
  oS as SRegularDiamondTurnRight,
  uS as SRegularDice,
  rS as SRegularDiceD10,
  dS as SRegularDiceD12,
  SS as SRegularDiceD20,
  zS as SRegularDiceD4,
  pS as SRegularDiceD6,
  MS as SRegularDiceD8,
  xS as SRegularDiceFive,
  HS as SRegularDiceFour,
  VS as SRegularDiceOne,
  CS as SRegularDiceSix,
  LS as SRegularDiceThree,
  BS as SRegularDiceTwo,
  RS as SRegularDinosaur,
  $S as SRegularDiploma,
  kS as SRegularDiscDrive,
  PS as SRegularDisease,
  US as SRegularDisplay,
  FS as SRegularDisplayArrowDown,
  DS as SRegularDisplayChartUp,
  TS as SRegularDisplayChartUpCircleCurrency,
  AS as SRegularDisplayChartUpCircleDollar,
  yS as SRegularDisplayCode,
  bS as SRegularDisplayMedical,
  fS as SRegularDisplaySlash,
  GS as SRegularDistributeSpacingHorizontal,
  qS as SRegularDistributeSpacingVertical,
  WS as SRegularDitto,
  ES as SRegularDivide,
  OS as SRegularDna,
  IS as SRegularDoNotEnter,
  XS as SRegularDog,
  NS as SRegularDogLeashed,
  KS as SRegularDollarSign,
  ZS as SRegularDolly,
  QS as SRegularDollyEmpty,
  JS as SRegularDolphin,
  jS as SRegularDongSign,
  YS as SRegularDonut,
  _S as SRegularDoorClosed,
  hz as SRegularDoorOpen,
  cz as SRegularDove,
  az as SRegularDown,
  sz as SRegularDownFromDottedLine,
  vz as SRegularDownFromLine,
  lz as SRegularDownLeft,
  ez as SRegularDownLeftAndUpRightToCenter,
  tz as SRegularDownLong,
  wz as SRegularDownRight,
  gz as SRegularDownToBracket,
  iz as SRegularDownToDottedLine,
  mz as SRegularDownToLine,
  oz as SRegularDownload,
  nz as SRegularDragon,
  rz as SRegularDrawCircle,
  dz as SRegularDrawPolygon,
  Sz as SRegularDrawSquare,
  zz as SRegularDreidel,
  Mz as SRegularDrone,
  pz as SRegularDroneFront,
  Cz as SRegularDroplet,
  xz as SRegularDropletDegree,
  Hz as SRegularDropletPercent,
  Vz as SRegularDropletSlash,
  Bz as SRegularDrum,
  Lz as SRegularDrumSteelpan,
  Rz as SRegularDrumstick,
  uz as SRegularDrumstickBite,
  kz as SRegularDryer,
  $z as SRegularDryerHeat,
  Pz as SRegularDuck,
  Fz as SRegularDumbbell,
  Az as SRegularDumpster,
  Tz as SRegularDumpsterFire,
  Dz as SRegularDungeon,
  yz as SRegularE,
  Gz as SRegularEar,
  bz as SRegularEarDeaf,
  fz as SRegularEarListen,
  Uz as SRegularEarMuffs,
  qz as SRegularEarthAfrica,
  Wz as SRegularEarthAmericas,
  Ez as SRegularEarthAsia,
  Oz as SRegularEarthEurope,
  Iz as SRegularEarthOceania,
  Nz as SRegularEclipse,
  Kz as SRegularEgg,
  Xz as SRegularEggFried,
  Qz as SRegularEggplant,
  Zz as SRegularEject,
  Jz as SRegularElephant,
  jz as SRegularElevator,
  cp as SRegularEllipsis,
  _z as SRegularEllipsisStroke,
  Yz as SRegularEllipsisStrokeVertical,
  hp as SRegularEllipsisVertical,
  sp as SRegularEmptySet,
  ep as SRegularEngine,
  vp as SRegularEngineWarning,
  mp as SRegularEnvelope,
  lp as SRegularEnvelopeCircleCheck,
  tp as SRegularEnvelopeDot,
  ip as SRegularEnvelopeOpen,
  wp as SRegularEnvelopeOpenDollar,
  gp as SRegularEnvelopeOpenText,
  op as SRegularEnvelopes,
  ap as SRegularEnvelopesBulk,
  np as SRegularEquals,
  rp as SRegularEraser,
  dp as SRegularEscalator,
  Sp as SRegularEthernet,
  zp as SRegularEuroSign,
  pp as SRegularExclamation,
  xp as SRegularExpand,
  Mp as SRegularExpandWide,
  Hp as SRegularExplosion,
  $p as SRegularEye,
  Lp as SRegularEyeDropper,
  Vp as SRegularEyeDropperFull,
  Cp as SRegularEyeDropperHalf,
  Bp as SRegularEyeEvil,
  up as SRegularEyeLowVision,
  Rp as SRegularEyeSlash,
  kp as SRegularEyes,
  Pp as SRegularF,
  Tp as SRegularFaceAngry,
  Fp as SRegularFaceAngryHorns,
  Ap as SRegularFaceAnguished,
  Dp as SRegularFaceAnxiousSweat,
  yp as SRegularFaceAstonished,
  bp as SRegularFaceAwesome,
  fp as SRegularFaceBeamHandOverMouth,
  Up as SRegularFaceClouds,
  Gp as SRegularFaceConfounded,
  qp as SRegularFaceConfused,
  Wp as SRegularFaceCowboyHat,
  Ep as SRegularFaceDiagonalMouth,
  Op as SRegularFaceDisappointed,
  Ip as SRegularFaceDisguise,
  Np as SRegularFaceDizzy,
  Xp as SRegularFaceDotted,
  Kp as SRegularFaceDowncastSweat,
  Qp as SRegularFaceDrooling,
  Zp as SRegularFaceExhaling,
  Jp as SRegularFaceExplode,
  jp as SRegularFaceExpressionless,
  Yp as SRegularFaceEyesXmarks,
  _p as SRegularFaceFearful,
  hM as SRegularFaceFlushed,
  vM as SRegularFaceFrown,
  cM as SRegularFaceFrownOpen,
  sM as SRegularFaceFrownSlight,
  eM as SRegularFaceGlasses,
  lM as SRegularFaceGrimace,
  pM as SRegularFaceGrin,
  wM as SRegularFaceGrinBeam,
  tM as SRegularFaceGrinBeamSweat,
  gM as SRegularFaceGrinHearts,
  mM as SRegularFaceGrinSquint,
  iM as SRegularFaceGrinSquintTears,
  aM as SRegularFaceGrinStars,
  oM as SRegularFaceGrinTears,
  dM as SRegularFaceGrinTongue,
  nM as SRegularFaceGrinTongueSquint,
  rM as SRegularFaceGrinTongueWink,
  SM as SRegularFaceGrinWide,
  zM as SRegularFaceGrinWink,
  MM as SRegularFaceHandOverMouth,
  xM as SRegularFaceHandPeeking,
  HM as SRegularFaceHandYawn,
  VM as SRegularFaceHeadBandage,
  CM as SRegularFaceHoldingBackTears,
  LM as SRegularFaceHushed,
  BM as SRegularFaceIcicles,
  kM as SRegularFaceKiss,
  uM as SRegularFaceKissBeam,
  RM as SRegularFaceKissClosedEyes,
  $M as SRegularFaceKissWinkHeart,
  AM as SRegularFaceLaugh,
  PM as SRegularFaceLaughBeam,
  FM as SRegularFaceLaughSquint,
  TM as SRegularFaceLaughWink,
  DM as SRegularFaceLying,
  yM as SRegularFaceMask,
  fM as SRegularFaceMeh,
  bM as SRegularFaceMehBlank,
  UM as SRegularFaceMelting,
  GM as SRegularFaceMonocle,
  qM as SRegularFaceNauseated,
  WM as SRegularFaceNoseSteam,
  EM as SRegularFaceParty,
  OM as SRegularFacePensive,
  IM as SRegularFacePersevering,
  NM as SRegularFacePleading,
  XM as SRegularFacePouting,
  KM as SRegularFaceRaisedEyebrow,
  QM as SRegularFaceRelieved,
  ZM as SRegularFaceRollingEyes,
  JM as SRegularFaceSadCry,
  jM as SRegularFaceSadSweat,
  YM as SRegularFaceSadTear,
  _M as SRegularFaceSaluting,
  hx as SRegularFaceScream,
  cx as SRegularFaceShush,
  sx as SRegularFaceSleeping,
  vx as SRegularFaceSleepy,
  rx as SRegularFaceSmile,
  ex as SRegularFaceSmileBeam,
  lx as SRegularFaceSmileHalo,
  tx as SRegularFaceSmileHearts,
  wx as SRegularFaceSmileHorns,
  gx as SRegularFaceSmilePlus,
  ix as SRegularFaceSmileRelaxed,
  mx as SRegularFaceSmileTear,
  ax as SRegularFaceSmileTongue,
  ox as SRegularFaceSmileUpsideDown,
  nx as SRegularFaceSmileWink,
  dx as SRegularFaceSmilingHands,
  Sx as SRegularFaceSmirking,
  zx as SRegularFaceSpiralEyes,
  px as SRegularFaceSunglasses,
  Mx as SRegularFaceSurprise,
  xx as SRegularFaceSwear,
  Hx as SRegularFaceThermometer,
  Vx as SRegularFaceThinking,
  Cx as SRegularFaceTired,
  Lx as SRegularFaceTissue,
  Bx as SRegularFaceTongueMoney,
  ux as SRegularFaceTongueSweat,
  Rx as SRegularFaceUnamused,
  $x as SRegularFaceViewfinder,
  kx as SRegularFaceVomit,
  Px as SRegularFaceWeary,
  Fx as SRegularFaceWoozy,
  Tx as SRegularFaceWorried,
  Ax as SRegularFaceZany,
  Dx as SRegularFaceZipper,
  yx as SRegularFalafel,
  Ux as SRegularFamily,
  bx as SRegularFamilyDress,
  fx as SRegularFamilyPants,
  qx as SRegularFan,
  Gx as SRegularFanTable,
  Wx as SRegularFarm,
  Ox as SRegularFaucet,
  Ex as SRegularFaucetDrip,
  Ix as SRegularFax,
  Xx as SRegularFeather,
  Nx as SRegularFeatherPointed,
  Kx as SRegularFence,
  Qx as SRegularFerrisWheel,
  Zx as SRegularFerry,
  Jx as SRegularFieldHockeyStickBall,
  QH as SRegularFile,
  jx as SRegularFileArrowDown,
  Yx as SRegularFileArrowUp,
  _x as SRegularFileAudio,
  hH as SRegularFileBinary,
  cH as SRegularFileCertificate,
  sH as SRegularFileChartColumn,
  vH as SRegularFileChartPie,
  eH as SRegularFileCheck,
  lH as SRegularFileCircleCheck,
  tH as SRegularFileCircleExclamation,
  wH as SRegularFileCircleInfo,
  gH as SRegularFileCircleMinus,
  iH as SRegularFileCirclePlus,
  mH as SRegularFileCircleQuestion,
  aH as SRegularFileCircleXmark,
  oH as SRegularFileCode,
  nH as SRegularFileContract,
  rH as SRegularFileCsv,
  dH as SRegularFileDashedLine,
  SH as SRegularFileDoc,
  zH as SRegularFileExcel,
  pH as SRegularFileExclamation,
  MH as SRegularFileExport,
  xH as SRegularFileHeart,
  HH as SRegularFileImage,
  VH as SRegularFileImport,
  LH as SRegularFileInvoice,
  CH as SRegularFileInvoiceDollar,
  BH as SRegularFileLines,
  uH as SRegularFileLock,
  RH as SRegularFileMagnifyingGlass,
  $H as SRegularFileMedical,
  kH as SRegularFileMinus,
  PH as SRegularFileMusic,
  FH as SRegularFilePdf,
  TH as SRegularFilePen,
  DH as SRegularFilePlus,
  AH as SRegularFilePlusMinus,
  yH as SRegularFilePowerpoint,
  bH as SRegularFilePrescription,
  fH as SRegularFileShield,
  UH as SRegularFileSignature,
  GH as SRegularFileSlash,
  qH as SRegularFileSpreadsheet,
  WH as SRegularFileUser,
  EH as SRegularFileVideo,
  OH as SRegularFileWaveform,
  IH as SRegularFileWord,
  NH as SRegularFileXmark,
  XH as SRegularFileZip,
  KH as SRegularFileZipper,
  JH as SRegularFiles,
  ZH as SRegularFilesMedical,
  YH as SRegularFill,
  jH as SRegularFillDrip,
  sV as SRegularFilm,
  _H as SRegularFilmCanister,
  hV as SRegularFilmSimple,
  cV as SRegularFilmSlash,
  vV as SRegularFilms,
  gV as SRegularFilter,
  eV as SRegularFilterCircleDollar,
  lV as SRegularFilterCircleXmark,
  tV as SRegularFilterList,
  wV as SRegularFilterSlash,
  iV as SRegularFilters,
  mV as SRegularFingerprint,
  pV as SRegularFire,
  aV as SRegularFireBurner,
  oV as SRegularFireExtinguisher,
  dV as SRegularFireFlame,
  nV as SRegularFireFlameCurved,
  rV as SRegularFireFlameSimple,
  SV as SRegularFireHydrant,
  zV as SRegularFireSmoke,
  MV as SRegularFireplace,
  CV as SRegularFish,
  xV as SRegularFishBones,
  HV as SRegularFishCooked,
  VV as SRegularFishFins,
  LV as SRegularFishingRod,
  kV as SRegularFlag,
  BV as SRegularFlagCheckered,
  uV as SRegularFlagPennant,
  RV as SRegularFlagSwallowtail,
  $V as SRegularFlagUsa,
  PV as SRegularFlashlight,
  yV as SRegularFlask,
  FV as SRegularFlaskGear,
  TV as SRegularFlaskRoundPoison,
  AV as SRegularFlaskRoundPotion,
  DV as SRegularFlaskVial,
  fV as SRegularFlatbread,
  bV as SRegularFlatbreadStuffed,
  WV as SRegularFloppyDisk,
  UV as SRegularFloppyDiskCircleArrowRight,
  GV as SRegularFloppyDiskCircleXmark,
  qV as SRegularFloppyDiskPen,
  EV as SRegularFloppyDisks,
  OV as SRegularFlorinSign,
  XV as SRegularFlower,
  IV as SRegularFlowerDaffodil,
  NV as SRegularFlowerTulip,
  KV as SRegularFlute,
  QV as SRegularFluxCapacitor,
  ZV as SRegularFlyingDisc,
  nC as SRegularFolder,
  JV as SRegularFolderArrowDown,
  jV as SRegularFolderArrowUp,
  YV as SRegularFolderBookmark,
  _V as SRegularFolderClosed,
  hC as SRegularFolderGear,
  cC as SRegularFolderGrid,
  sC as SRegularFolderHeart,
  vC as SRegularFolderImage,
  eC as SRegularFolderMagnifyingGlass,
  lC as SRegularFolderMedical,
  tC as SRegularFolderMinus,
  wC as SRegularFolderMusic,
  gC as SRegularFolderOpen,
  iC as SRegularFolderPlus,
  mC as SRegularFolderTree,
  aC as SRegularFolderUser,
  oC as SRegularFolderXmark,
  rC as SRegularFolders,
  dC as SRegularFonduePot,
  pC as SRegularFont,
  SC as SRegularFontAwesome,
  zC as SRegularFontCase,
  xC as SRegularFootball,
  MC as SRegularFootballHelmet,
  VC as SRegularFork,
  HC as SRegularForkKnife,
  CC as SRegularForklift,
  LC as SRegularFort,
  RC as SRegularForward,
  BC as SRegularForwardFast,
  uC as SRegularForwardStep,
  $C as SRegularFrame,
  kC as SRegularFrancSign,
  PC as SRegularFrenchFries,
  FC as SRegularFrog,
  TC as SRegularFunction,
  AC as SRegularFutbol,
  DC as SRegularG,
  yC as SRegularGalaxy,
  bC as SRegularGalleryThumbnails,
  UC as SRegularGameBoard,
  fC as SRegularGameBoardSimple,
  qC as SRegularGameConsoleHandheld,
  GC as SRegularGameConsoleHandheldCrank,
  EC as SRegularGamepad,
  WC as SRegularGamepadModern,
  NC as SRegularGarage,
  OC as SRegularGarageCar,
  IC as SRegularGarageOpen,
  XC as SRegularGarlic,
  QC as SRegularGasPump,
  KC as SRegularGasPumpSlash,
  wL as SRegularGauge,
  ZC as SRegularGaugeCircleBolt,
  JC as SRegularGaugeCircleMinus,
  jC as SRegularGaugeCirclePlus,
  YC as SRegularGaugeHigh,
  _C as SRegularGaugeLow,
  hL as SRegularGaugeMax,
  cL as SRegularGaugeMin,
  tL as SRegularGaugeSimple,
  sL as SRegularGaugeSimpleHigh,
  vL as SRegularGaugeSimpleLow,
  eL as SRegularGaugeSimpleMax,
  lL as SRegularGaugeSimpleMin,
  gL as SRegularGavel,
  oL as SRegularGear,
  iL as SRegularGearCode,
  aL as SRegularGearComplex,
  mL as SRegularGearComplexCode,
  nL as SRegularGears,
  rL as SRegularGem,
  dL as SRegularGenderless,
  SL as SRegularGhost,
  zL as SRegularGif,
  ML as SRegularGift,
  pL as SRegularGiftCard,
  xL as SRegularGifts,
  HL as SRegularGingerbreadMan,
  RL as SRegularGlass,
  VL as SRegularGlassCitrus,
  CL as SRegularGlassEmpty,
  LL as SRegularGlassHalf,
  uL as SRegularGlassWater,
  BL as SRegularGlassWaterDroplet,
  kL as SRegularGlasses,
  $L as SRegularGlassesRound,
  AL as SRegularGlobe,
  PL as SRegularGlobePointer,
  FL as SRegularGlobeSnow,
  TL as SRegularGlobeStand,
  DL as SRegularGoalNet,
  yL as SRegularGolfBallTee,
  bL as SRegularGolfClub,
  fL as SRegularGolfFlagHole,
  UL as SRegularGopuram,
  GL as SRegularGraduationCap,
  qL as SRegularGramophone,
  WL as SRegularGrapes,
  OL as SRegularGrate,
  EL as SRegularGrateDroplet,
  NL as SRegularGreaterThan,
  IL as SRegularGreaterThanEqual,
  vB as SRegularGrid,
  KL as SRegularGrid2,
  XL as SRegularGrid2Plus,
  QL as SRegularGrid4,
  ZL as SRegularGrid5,
  JL as SRegularGridDividers,
  jL as SRegularGridHorizontal,
  sB as SRegularGridRound,
  _L as SRegularGridRound2,
  YL as SRegularGridRound2Plus,
  hB as SRegularGridRound4,
  cB as SRegularGridRound5,
  tB as SRegularGrill,
  eB as SRegularGrillFire,
  lB as SRegularGrillHot,
  oB as SRegularGrip,
  gB as SRegularGripDots,
  wB as SRegularGripDotsVertical,
  mB as SRegularGripLines,
  iB as SRegularGripLinesVertical,
  aB as SRegularGripVertical,
  nB as SRegularGroupArrowsRotate,
  rB as SRegularGuaraniSign,
  SB as SRegularGuitar,
  dB as SRegularGuitarElectric,
  zB as SRegularGuitars,
  xB as SRegularGun,
  pB as SRegularGunSlash,
  MB as SRegularGunSquirt,
  HB as SRegularH,
  VB as SRegularH1,
  CB as SRegularH2,
  LB as SRegularH3,
  BB as SRegularH4,
  uB as SRegularH5,
  RB as SRegularH6,
  PB as SRegularHammer,
  $B as SRegularHammerCrash,
  kB as SRegularHammerWar,
  FB as SRegularHamsa,
  nu as SRegularHand,
  TB as SRegularHandBackFist,
  AB as SRegularHandBackPointDown,
  DB as SRegularHandBackPointLeft,
  yB as SRegularHandBackPointRibbon,
  bB as SRegularHandBackPointRight,
  fB as SRegularHandBackPointUp,
  UB as SRegularHandDots,
  GB as SRegularHandFingersCrossed,
  qB as SRegularHandFist,
  WB as SRegularHandHeart,
  jB as SRegularHandHolding,
  EB as SRegularHandHoldingBox,
  OB as SRegularHandHoldingDollar,
  IB as SRegularHandHoldingDroplet,
  NB as SRegularHandHoldingHand,
  XB as SRegularHandHoldingHeart,
  KB as SRegularHandHoldingMagic,
  QB as SRegularHandHoldingMedical,
  ZB as SRegularHandHoldingSeedling,
  JB as SRegularHandHoldingSkull,
  YB as SRegularHandHorns,
  _B as SRegularHandLizard,
  hu as SRegularHandLove,
  cu as SRegularHandMiddleFinger,
  su as SRegularHandPeace,
  vu as SRegularHandPointDown,
  eu as SRegularHandPointLeft,
  lu as SRegularHandPointRibbon,
  tu as SRegularHandPointRight,
  wu as SRegularHandPointUp,
  gu as SRegularHandPointer,
  iu as SRegularHandScissors,
  mu as SRegularHandSparkles,
  au as SRegularHandSpock,
  ou as SRegularHandWave,
  ru as SRegularHandcuffs,
  uu as SRegularHands,
  du as SRegularHandsAslInterpreting,
  Su as SRegularHandsBound,
  zu as SRegularHandsBubbles,
  pu as SRegularHandsClapping,
  Lu as SRegularHandsHolding,
  Mu as SRegularHandsHoldingChild,
  xu as SRegularHandsHoldingCircle,
  Hu as SRegularHandsHoldingDiamond,
  Vu as SRegularHandsHoldingDollar,
  Cu as SRegularHandsHoldingHeart,
  Bu as SRegularHandsPraying,
  Fu as SRegularHandshake,
  Ru as SRegularHandshakeAngle,
  ku as SRegularHandshakeSimple,
  $u as SRegularHandshakeSimpleSlash,
  Pu as SRegularHandshakeSlash,
  Tu as SRegularHanukiah,
  Au as SRegularHardDrive,
  yu as SRegularHashtag,
  Du as SRegularHashtagLock,
  bu as SRegularHatBeach,
  fu as SRegularHatChef,
  Gu as SRegularHatCowboy,
  Uu as SRegularHatCowboySide,
  qu as SRegularHatSanta,
  Wu as SRegularHatWinter,
  Eu as SRegularHatWitch,
  Ou as SRegularHatWizard,
  hR as SRegularHeadSide,
  Iu as SRegularHeadSideBrain,
  Xu as SRegularHeadSideCough,
  Nu as SRegularHeadSideCoughSlash,
  Ku as SRegularHeadSideGear,
  Qu as SRegularHeadSideGoggles,
  Zu as SRegularHeadSideHeadphones,
  Ju as SRegularHeadSideHeart,
  ju as SRegularHeadSideMask,
  Yu as SRegularHeadSideMedical,
  _u as SRegularHeadSideVirus,
  cR as SRegularHeading,
  vR as SRegularHeadphones,
  sR as SRegularHeadphonesSimple,
  eR as SRegularHeadset,
  dR as SRegularHeart,
  lR as SRegularHeartCircleBolt,
  tR as SRegularHeartCircleCheck,
  wR as SRegularHeartCircleExclamation,
  gR as SRegularHeartCircleMinus,
  iR as SRegularHeartCirclePlus,
  mR as SRegularHeartCircleXmark,
  aR as SRegularHeartCrack,
  nR as SRegularHeartHalf,
  oR as SRegularHeartHalfStroke,
  rR as SRegularHeartPulse,
  SR as SRegularHeat,
  pR as SRegularHelicopter,
  zR as SRegularHelicopterSymbol,
  MR as SRegularHelmetBattle,
  xR as SRegularHelmetSafety,
  HR as SRegularHelmetUn,
  FR as SRegularHexagon,
  VR as SRegularHexagonCheck,
  CR as SRegularHexagonDivide,
  LR as SRegularHexagonExclamation,
  BR as SRegularHexagonImage,
  uR as SRegularHexagonMinus,
  RR as SRegularHexagonPlus,
  kR as SRegularHexagonVerticalNft,
  $R as SRegularHexagonVerticalNftSlanted,
  PR as SRegularHexagonXmark,
  TR as SRegularHighDefinition,
  DR as SRegularHighlighter,
  AR as SRegularHighlighterLine,
  yR as SRegularHillAvalanche,
  bR as SRegularHillRockslide,
  fR as SRegularHippo,
  UR as SRegularHockeyMask,
  GR as SRegularHockeyPuck,
  qR as SRegularHockeyStickPuck,
  WR as SRegularHockeySticks,
  ER as SRegularHollyBerry,
  OR as SRegularHoneyPot,
  IR as SRegularHoodCloak,
  NR as SRegularHorizontalRule,
  QR as SRegularHorse,
  XR as SRegularHorseHead,
  KR as SRegularHorseSaddle,
  JR as SRegularHose,
  ZR as SRegularHoseReel,
  YR as SRegularHospital,
  jR as SRegularHospitalUser,
  _R as SRegularHospitals,
  h$ as SRegularHotTubPerson,
  c$ as SRegularHotdog,
  s$ as SRegularHotel,
  w$ as SRegularHourglass,
  v$ as SRegularHourglassClock,
  e$ as SRegularHourglassEnd,
  l$ as SRegularHourglassHalf,
  t$ as SRegularHourglassStart,
  I$ as SRegularHouse,
  g$ as SRegularHouseBlank,
  i$ as SRegularHouseBuilding,
  S$ as SRegularHouseChimney,
  m$ as SRegularHouseChimneyBlank,
  a$ as SRegularHouseChimneyCrack,
  o$ as SRegularHouseChimneyHeart,
  n$ as SRegularHouseChimneyMedical,
  r$ as SRegularHouseChimneyUser,
  d$ as SRegularHouseChimneyWindow,
  z$ as SRegularHouseCircleCheck,
  p$ as SRegularHouseCircleExclamation,
  M$ as SRegularHouseCircleXmark,
  x$ as SRegularHouseCrack,
  H$ as SRegularHouseDay,
  V$ as SRegularHouseFire,
  C$ as SRegularHouseFlag,
  B$ as SRegularHouseFloodWater,
  L$ as SRegularHouseFloodWaterCircleArrowRight,
  u$ as SRegularHouseHeart,
  R$ as SRegularHouseLaptop,
  $$ as SRegularHouseLock,
  A$ as SRegularHouseMedical,
  k$ as SRegularHouseMedicalCircleCheck,
  P$ as SRegularHouseMedicalCircleExclamation,
  F$ as SRegularHouseMedicalCircleXmark,
  T$ as SRegularHouseMedicalFlag,
  D$ as SRegularHouseNight,
  y$ as SRegularHousePersonLeave,
  b$ as SRegularHousePersonReturn,
  f$ as SRegularHouseSignal,
  U$ as SRegularHouseTree,
  G$ as SRegularHouseTsunami,
  q$ as SRegularHouseTurret,
  W$ as SRegularHouseUser,
  E$ as SRegularHouseWater,
  O$ as SRegularHouseWindow,
  N$ as SRegularHryvniaSign,
  X$ as SRegularHundredPoints,
  K$ as SRegularHurricane,
  Q$ as SRegularHyphen,
  J$ as SRegularI,
  Z$ as SRegularICursor,
  j$ as SRegularIceCream,
  Y$ as SRegularIceSkate,
  _$ as SRegularIcicles,
  hk as SRegularIcons,
  ck as SRegularIdBadge,
  vk as SRegularIdCard,
  sk as SRegularIdCardClip,
  ek as SRegularIgloo,
  ak as SRegularImage,
  lk as SRegularImageLandscape,
  wk as SRegularImagePolaroid,
  tk as SRegularImagePolaroidUser,
  gk as SRegularImagePortrait,
  ik as SRegularImageSlash,
  mk as SRegularImageUser,
  nk as SRegularImages,
  ok as SRegularImagesUser,
  zk as SRegularInbox,
  rk as SRegularInboxFull,
  dk as SRegularInboxIn,
  Sk as SRegularInboxOut,
  pk as SRegularInboxes,
  Mk as SRegularIndent,
  xk as SRegularIndianRupeeSign,
  Vk as SRegularIndustry,
  Hk as SRegularIndustryWindows,
  Ck as SRegularInfinity,
  Lk as SRegularInfo,
  Bk as SRegularInhaler,
  uk as SRegularInputNumeric,
  Rk as SRegularInputPipe,
  $k as SRegularInputText,
  kk as SRegularIntegral,
  Pk as SRegularInterrobang,
  Fk as SRegularIntersection,
  Tk as SRegularIslandTropical,
  Ak as SRegularItalic,
  Dk as SRegularJ,
  yk as SRegularJackOLantern,
  fk as SRegularJar,
  bk as SRegularJarWheat,
  Uk as SRegularJedi,
  qk as SRegularJetFighter,
  Gk as SRegularJetFighterUp,
  Wk as SRegularJoint,
  Ek as SRegularJoystick,
  Nk as SRegularJug,
  Ok as SRegularJugBottle,
  Ik as SRegularJugDetergent,
  Xk as SRegularK,
  Kk as SRegularKaaba,
  Qk as SRegularKazoo,
  Zk as SRegularKerning,
  Yk as SRegularKey,
  jk as SRegularKeySkeleton,
  Jk as SRegularKeySkeletonLeftRight,
  vP as SRegularKeyboard,
  hP as SRegularKeyboardBrightness,
  _k as SRegularKeyboardBrightnessLow,
  cP as SRegularKeyboardDown,
  sP as SRegularKeyboardLeft,
  eP as SRegularKeynote,
  lP as SRegularKhanda,
  tP as SRegularKidneys,
  wP as SRegularKipSign,
  gP as SRegularKitMedical,
  iP as SRegularKitchenSet,
  mP as SRegularKite,
  aP as SRegularKiwiBird,
  oP as SRegularKiwiFruit,
  rP as SRegularKnife,
  nP as SRegularKnifeKitchen,
  dP as SRegularL,
  zP as SRegularLacrosseStick,
  SP as SRegularLacrosseStickBall,
  pP as SRegularLambda,
  VP as SRegularLamp,
  MP as SRegularLampDesk,
  xP as SRegularLampFloor,
  HP as SRegularLampStreet,
  CP as SRegularLandMineOn,
  uP as SRegularLandmark,
  LP as SRegularLandmarkDome,
  BP as SRegularLandmarkFlag,
  RP as SRegularLanguage,
  yP as SRegularLaptop,
  $P as SRegularLaptopArrowDown,
  kP as SRegularLaptopBinary,
  PP as SRegularLaptopCode,
  FP as SRegularLaptopFile,
  TP as SRegularLaptopMedical,
  AP as SRegularLaptopMobile,
  DP as SRegularLaptopSlash,
  bP as SRegularLariSign,
  UP as SRegularLasso,
  fP as SRegularLassoSparkles,
  GP as SRegularLayerGroup,
  qP as SRegularLayerMinus,
  WP as SRegularLayerPlus,
  NP as SRegularLeaf,
  EP as SRegularLeafHeart,
  OP as SRegularLeafMaple,
  IP as SRegularLeafOak,
  XP as SRegularLeafyGreen,
  YP as SRegularLeft,
  KP as SRegularLeftFromLine,
  ZP as SRegularLeftLong,
  QP as SRegularLeftLongToLine,
  JP as SRegularLeftRight,
  jP as SRegularLeftToLine,
  _P as SRegularLemon,
  cF as SRegularLessThan,
  hF as SRegularLessThanEqual,
  sF as SRegularLifeRing,
  vF as SRegularLightCeiling,
  lF as SRegularLightEmergency,
  eF as SRegularLightEmergencyOn,
  gF as SRegularLightSwitch,
  tF as SRegularLightSwitchOff,
  wF as SRegularLightSwitchOn,
  zF as SRegularLightbulb,
  mF as SRegularLightbulbCfl,
  iF as SRegularLightbulbCflOn,
  aF as SRegularLightbulbDollar,
  nF as SRegularLightbulbExclamation,
  oF as SRegularLightbulbExclamationOn,
  rF as SRegularLightbulbGear,
  dF as SRegularLightbulbOn,
  SF as SRegularLightbulbSlash,
  pF as SRegularLighthouse,
  MF as SRegularLightsHoliday,
  xF as SRegularLineColumns,
  HF as SRegularLineHeight,
  VF as SRegularLinesLeaning,
  $F as SRegularLink,
  LF as SRegularLinkHorizontal,
  CF as SRegularLinkHorizontalSlash,
  uF as SRegularLinkSimple,
  BF as SRegularLinkSimpleSlash,
  RF as SRegularLinkSlash,
  kF as SRegularLips,
  PF as SRegularLiraSign,
  GF as SRegularList,
  FF as SRegularListCheck,
  TF as SRegularListDropdown,
  AF as SRegularListMusic,
  DF as SRegularListOl,
  yF as SRegularListRadio,
  bF as SRegularListTimeline,
  fF as SRegularListTree,
  UF as SRegularListUl,
  qF as SRegularLitecoinSign,
  WF as SRegularLoader,
  EF as SRegularLobster,
  OF as SRegularLocationArrow,
  IF as SRegularLocationCheck,
  XF as SRegularLocationCrosshairs,
  NF as SRegularLocationCrosshairsSlash,
  QF as SRegularLocationDot,
  KF as SRegularLocationDotSlash,
  ZF as SRegularLocationExclamation,
  JF as SRegularLocationMinus,
  jF as SRegularLocationPen,
  hT as SRegularLocationPin,
  YF as SRegularLocationPinLock,
  _F as SRegularLocationPinSlash,
  cT as SRegularLocationPlus,
  sT as SRegularLocationQuestion,
  vT as SRegularLocationSmile,
  eT as SRegularLocationXmark,
  mT as SRegularLock,
  lT as SRegularLockA,
  tT as SRegularLockHashtag,
  gT as SRegularLockKeyhole,
  wT as SRegularLockKeyholeOpen,
  iT as SRegularLockOpen,
  aT as SRegularLocust,
  oT as SRegularLollipop,
  nT as SRegularLoveseat,
  rT as SRegularLuchadorMask,
  ST as SRegularLungs,
  dT as SRegularLungsVirus,
  zT as SRegularM,
  pT as SRegularMace,
  MT as SRegularMagnet,
  uT as SRegularMagnifyingGlass,
  xT as SRegularMagnifyingGlassArrowRight,
  HT as SRegularMagnifyingGlassChart,
  VT as SRegularMagnifyingGlassDollar,
  CT as SRegularMagnifyingGlassLocation,
  LT as SRegularMagnifyingGlassMinus,
  BT as SRegularMagnifyingGlassPlus,
  $T as SRegularMailbox,
  RT as SRegularMailboxFlagUp,
  kT as SRegularManatSign,
  PT as SRegularMandolin,
  FT as SRegularMango,
  TT as SRegularManhole,
  bT as SRegularMap,
  DT as SRegularMapLocation,
  AT as SRegularMapLocationDot,
  yT as SRegularMapPin,
  fT as SRegularMarker,
  IT as SRegularMars,
  GT as SRegularMarsAndVenus,
  UT as SRegularMarsAndVenusBurst,
  qT as SRegularMarsDouble,
  OT as SRegularMarsStroke,
  WT as SRegularMarsStrokeRight,
  ET as SRegularMarsStrokeUp,
  KT as SRegularMartiniGlass,
  NT as SRegularMartiniGlassCitrus,
  XT as SRegularMartiniGlassEmpty,
  jT as SRegularMask,
  QT as SRegularMaskFace,
  ZT as SRegularMaskSnorkel,
  JT as SRegularMaskVentilator,
  YT as SRegularMasksTheater,
  _T as SRegularMattressPillow,
  hA as SRegularMaximize,
  cA as SRegularMeat,
  sA as SRegularMedal,
  vA as SRegularMegaphone,
  lA as SRegularMelon,
  eA as SRegularMelonSlice,
  iA as SRegularMemo,
  tA as SRegularMemoCircleCheck,
  wA as SRegularMemoCircleInfo,
  gA as SRegularMemoPad,
  mA as SRegularMemory,
  aA as SRegularMenorah,
  oA as SRegularMercury,
  nA as SRegularMerge,
  WA as SRegularMessage,
  rA as SRegularMessageArrowDown,
  SA as SRegularMessageArrowUp,
  dA as SRegularMessageArrowUpRight,
  zA as SRegularMessageBot,
  pA as SRegularMessageCaptions,
  MA as SRegularMessageCheck,
  xA as SRegularMessageCode,
  HA as SRegularMessageDollar,
  VA as SRegularMessageDots,
  CA as SRegularMessageExclamation,
  LA as SRegularMessageHeart,
  BA as SRegularMessageImage,
  uA as SRegularMessageLines,
  RA as SRegularMessageMedical,
  kA as SRegularMessageMiddle,
  $A as SRegularMessageMiddleTop,
  PA as SRegularMessageMinus,
  FA as SRegularMessageMusic,
  TA as SRegularMessagePen,
  AA as SRegularMessagePlus,
  DA as SRegularMessageQuestion,
  yA as SRegularMessageQuote,
  bA as SRegularMessageSlash,
  fA as SRegularMessageSmile,
  UA as SRegularMessageSms,
  GA as SRegularMessageText,
  qA as SRegularMessageXmark,
  IA as SRegularMessages,
  EA as SRegularMessagesDollar,
  OA as SRegularMessagesQuestion,
  NA as SRegularMeteor,
  ZA as SRegularMeter,
  XA as SRegularMeterBolt,
  KA as SRegularMeterDroplet,
  QA as SRegularMeterFire,
  jA as SRegularMicrochip,
  JA as SRegularMicrochipAi,
  sD as SRegularMicrophone,
  _A as SRegularMicrophoneLines,
  YA as SRegularMicrophoneLinesSlash,
  hD as SRegularMicrophoneSlash,
  cD as SRegularMicrophoneStand,
  vD as SRegularMicroscope,
  eD as SRegularMicrowave,
  lD as SRegularMillSign,
  tD as SRegularMinimize,
  wD as SRegularMinus,
  gD as SRegularMistletoe,
  iD as SRegularMitten,
  zD as SRegularMobile,
  mD as SRegularMobileButton,
  aD as SRegularMobileNotch,
  oD as SRegularMobileRetro,
  rD as SRegularMobileScreen,
  nD as SRegularMobileScreenButton,
  SD as SRegularMobileSignal,
  dD as SRegularMobileSignalOut,
  uD as SRegularMoneyBill,
  MD as SRegularMoneyBill1,
  pD as SRegularMoneyBill1Wave,
  HD as SRegularMoneyBillSimple,
  xD as SRegularMoneyBillSimpleWave,
  VD as SRegularMoneyBillTransfer,
  CD as SRegularMoneyBillTrendUp,
  LD as SRegularMoneyBillWave,
  BD as SRegularMoneyBillWheat,
  $D as SRegularMoneyBills,
  RD as SRegularMoneyBillsSimple,
  TD as SRegularMoneyCheck,
  PD as SRegularMoneyCheckDollar,
  kD as SRegularMoneyCheckDollarPen,
  FD as SRegularMoneyCheckPen,
  AD as SRegularMoneyFromBracket,
  DD as SRegularMoneySimpleFromBracket,
  yD as SRegularMonitorWaveform,
  bD as SRegularMonkey,
  fD as SRegularMonument,
  WD as SRegularMoon,
  UD as SRegularMoonCloud,
  GD as SRegularMoonOverSun,
  qD as SRegularMoonStars,
  ED as SRegularMoped,
  OD as SRegularMortarPestle,
  ID as SRegularMosque,
  XD as SRegularMosquito,
  ND as SRegularMosquitoNet,
  KD as SRegularMotorcycle,
  QD as SRegularMound,
  jD as SRegularMountain,
  ZD as SRegularMountainCity,
  JD as SRegularMountainSun,
  YD as SRegularMountains,
  _D as SRegularMouseField,
  hy as SRegularMp3Player,
  ty as SRegularMug,
  cy as SRegularMugHot,
  sy as SRegularMugMarshmallows,
  vy as SRegularMugSaucer,
  ly as SRegularMugTea,
  ey as SRegularMugTeaSaucer,
  wy as SRegularMushroom,
  ay as SRegularMusic,
  iy as SRegularMusicNote,
  gy as SRegularMusicNoteSlash,
  my as SRegularMusicSlash,
  oy as SRegularMustache,
  ny as SRegularN,
  ry as SRegularNairaSign,
  dy as SRegularNarwhal,
  Sy as SRegularNestingDolls,
  zy as SRegularNetworkWired,
  py as SRegularNeuter,
  My as SRegularNewspaper,
  Ry as SRegularNfc,
  xy as SRegularNfcLock,
  Hy as SRegularNfcMagnifyingGlass,
  Vy as SRegularNfcPen,
  Cy as SRegularNfcSignal,
  Ly as SRegularNfcSlash,
  By as SRegularNfcSymbol,
  uy as SRegularNfcTrash,
  $y as SRegularNose,
  ky as SRegularNotEqual,
  Py as SRegularNotdef,
  Ay as SRegularNote,
  Fy as SRegularNoteMedical,
  Ty as SRegularNoteSticky,
  Dy as SRegularNotebook,
  by as SRegularNotes,
  yy as SRegularNotesMedical,
  fy as SRegularO,
  Uy as SRegularObjectExclude,
  Gy as SRegularObjectGroup,
  qy as SRegularObjectIntersect,
  Wy as SRegularObjectSubtract,
  Ey as SRegularObjectUngroup,
  Oy as SRegularObjectUnion,
  Iy as SRegularObjectsAlignBottom,
  Ny as SRegularObjectsAlignCenterHorizontal,
  Xy as SRegularObjectsAlignCenterVertical,
  Ky as SRegularObjectsAlignLeft,
  Qy as SRegularObjectsAlignRight,
  Zy as SRegularObjectsAlignTop,
  Jy as SRegularObjectsColumn,
  vb as SRegularOctagon,
  jy as SRegularOctagonCheck,
  Yy as SRegularOctagonDivide,
  _y as SRegularOctagonExclamation,
  hb as SRegularOctagonMinus,
  cb as SRegularOctagonPlus,
  sb as SRegularOctagonXmark,
  lb as SRegularOilCan,
  eb as SRegularOilCanDrip,
  tb as SRegularOilTemperature,
  wb as SRegularOilWell,
  ib as SRegularOlive,
  gb as SRegularOliveBranch,
  mb as SRegularOm,
  ab as SRegularOmega,
  ob as SRegularOnion,
  nb as SRegularOption,
  rb as SRegularOrnament,
  db as SRegularOtter,
  Sb as SRegularOutdent,
  zb as SRegularOutlet,
  pb as SRegularOven,
  Mb as SRegularOverline,
  xb as SRegularP,
  Cb as SRegularPage,
  Hb as SRegularPageCaretDown,
  Vb as SRegularPageCaretUp,
  Lb as SRegularPager,
  Bb as SRegularPaintRoller,
  $b as SRegularPaintbrush,
  ub as SRegularPaintbrushFine,
  Rb as SRegularPaintbrushPencil,
  kb as SRegularPalette,
  Tb as SRegularPallet,
  Pb as SRegularPalletBox,
  Fb as SRegularPalletBoxes,
  Ab as SRegularPanFood,
  Db as SRegularPanFrying,
  yb as SRegularPancakes,
  bb as SRegularPanelEws,
  fb as SRegularPanelFire,
  Ub as SRegularPanorama,
  qb as SRegularPaperPlane,
  Gb as SRegularPaperPlaneTop,
  Eb as SRegularPaperclip,
  Wb as SRegularPaperclipVertical,
  Ob as SRegularParachuteBox,
  Nb as SRegularParagraph,
  Ib as SRegularParagraphLeft,
  Xb as SRegularPartyBell,
  Kb as SRegularPartyHorn,
  Qb as SRegularPassport,
  Zb as SRegularPaste,
  Jb as SRegularPause,
  _b as SRegularPaw,
  jb as SRegularPawClaws,
  Yb as SRegularPawSimple,
  hf as SRegularPeace,
  cf as SRegularPeach,
  sf as SRegularPeanut,
  vf as SRegularPeanuts,
  ef as SRegularPeapod,
  lf as SRegularPear,
  tf as SRegularPedestal,
  wf as SRegularPegasus,
  Cf as SRegularPen,
  gf as SRegularPenCircle,
  af as SRegularPenClip,
  mf as SRegularPenClipSlash,
  nf as SRegularPenFancy,
  of as SRegularPenFancySlash,
  rf as SRegularPenField,
  df as SRegularPenLine,
  zf as SRegularPenNib,
  Sf as SRegularPenNibSlash,
  pf as SRegularPenPaintbrush,
  Mf as SRegularPenRuler,
  xf as SRegularPenSlash,
  Hf as SRegularPenSwirl,
  Vf as SRegularPenToSquare,
  uf as SRegularPencil,
  Lf as SRegularPencilMechanical,
  Bf as SRegularPencilSlash,
  Gf as SRegularPeople,
  Rf as SRegularPeopleArrows,
  $f as SRegularPeopleCarryBox,
  Pf as SRegularPeopleDress,
  kf as SRegularPeopleDressSimple,
  Ff as SRegularPeopleGroup,
  Tf as SRegularPeopleLine,
  Df as SRegularPeoplePants,
  Af as SRegularPeoplePantsSimple,
  yf as SRegularPeoplePulling,
  bf as SRegularPeopleRobbery,
  ff as SRegularPeopleRoof,
  Uf as SRegularPeopleSimple,
  Wf as SRegularPepper,
  qf as SRegularPepperHot,
  Ef as SRegularPercent,
  Of as SRegularPeriod,
  cG as SRegularPerson,
  If as SRegularPersonArrowDownToLine,
  Nf as SRegularPersonArrowUpFromLine,
  Kf as SRegularPersonBiking,
  Xf as SRegularPersonBikingMountain,
  Qf as SRegularPersonBooth,
  Zf as SRegularPersonBreastfeeding,
  Jf as SRegularPersonBurst,
  jf as SRegularPersonCane,
  Yf as SRegularPersonCarryBox,
  _f as SRegularPersonChalkboard,
  hU as SRegularPersonCircleCheck,
  cU as SRegularPersonCircleExclamation,
  sU as SRegularPersonCircleMinus,
  vU as SRegularPersonCirclePlus,
  eU as SRegularPersonCircleQuestion,
  lU as SRegularPersonCircleXmark,
  tU as SRegularPersonDigging,
  gU as SRegularPersonDolly,
  wU as SRegularPersonDollyEmpty,
  iU as SRegularPersonDotsFromLine,
  nU as SRegularPersonDress,
  mU as SRegularPersonDressBurst,
  aU as SRegularPersonDressFairy,
  oU as SRegularPersonDressSimple,
  rU as SRegularPersonDrowning,
  dU as SRegularPersonFairy,
  zU as SRegularPersonFalling,
  SU as SRegularPersonFallingBurst,
  pU as SRegularPersonFromPortal,
  MU as SRegularPersonHalfDress,
  xU as SRegularPersonHarassing,
  HU as SRegularPersonHiking,
  VU as SRegularPersonMilitaryPointing,
  CU as SRegularPersonMilitaryRifle,
  LU as SRegularPersonMilitaryToPerson,
  BU as SRegularPersonPinball,
  uU as SRegularPersonPraying,
  RU as SRegularPersonPregnant,
  $U as SRegularPersonRays,
  kU as SRegularPersonRifle,
  FU as SRegularPersonRunning,
  PU as SRegularPersonRunningFast,
  AU as SRegularPersonSeat,
  TU as SRegularPersonSeatReclined,
  DU as SRegularPersonShelter,
  yU as SRegularPersonSign,
  bU as SRegularPersonSimple,
  fU as SRegularPersonSkating,
  UU as SRegularPersonSkiJumping,
  GU as SRegularPersonSkiLift,
  WU as SRegularPersonSkiing,
  qU as SRegularPersonSkiingNordic,
  EU as SRegularPersonSledding,
  OU as SRegularPersonSnowboarding,
  IU as SRegularPersonSnowmobiling,
  NU as SRegularPersonSwimming,
  XU as SRegularPersonThroughWindow,
  KU as SRegularPersonToDoor,
  QU as SRegularPersonToPortal,
  hG as SRegularPersonWalking,
  ZU as SRegularPersonWalkingArrowLoopLeft,
  JU as SRegularPersonWalkingArrowRight,
  jU as SRegularPersonWalkingDashedLineArrowRight,
  YU as SRegularPersonWalkingLuggage,
  _U as SRegularPersonWalkingWithCane,
  sG as SRegularPesetaSign,
  vG as SRegularPesoSign,
  zG as SRegularPhone,
  eG as SRegularPhoneArrowDownLeft,
  lG as SRegularPhoneArrowRight,
  tG as SRegularPhoneArrowUpRight,
  wG as SRegularPhoneFlip,
  gG as SRegularPhoneHangup,
  iG as SRegularPhoneIntercom,
  mG as SRegularPhoneMissed,
  aG as SRegularPhoneOffice,
  oG as SRegularPhonePlus,
  nG as SRegularPhoneRotary,
  rG as SRegularPhoneSlash,
  dG as SRegularPhoneVolume,
  SG as SRegularPhoneXmark,
  MG as SRegularPhotoFilm,
  pG as SRegularPhotoFilmMusic,
  xG as SRegularPi,
  VG as SRegularPiano,
  HG as SRegularPianoKeyboard,
  CG as SRegularPickaxe,
  LG as SRegularPickleball,
  BG as SRegularPie,
  uG as SRegularPig,
  RG as SRegularPiggyBank,
  $G as SRegularPills,
  kG as SRegularPinata,
  PG as SRegularPinball,
  FG as SRegularPineapple,
  fG as SRegularPipe,
  TG as SRegularPipeCircleCheck,
  AG as SRegularPipeCollar,
  DG as SRegularPipeSection,
  yG as SRegularPipeSmoking,
  bG as SRegularPipeValve,
  GG as SRegularPizza,
  UG as SRegularPizzaSlice,
  qG as SRegularPlaceOfWorship,
  _G as SRegularPlane,
  WG as SRegularPlaneArrival,
  EG as SRegularPlaneCircleCheck,
  OG as SRegularPlaneCircleExclamation,
  IG as SRegularPlaneCircleXmark,
  NG as SRegularPlaneDeparture,
  XG as SRegularPlaneEngines,
  KG as SRegularPlaneLock,
  QG as SRegularPlaneProp,
  ZG as SRegularPlaneSlash,
  JG as SRegularPlaneTail,
  YG as SRegularPlaneUp,
  jG as SRegularPlaneUpSlash,
  hq as SRegularPlanetMoon,
  cq as SRegularPlanetRinged,
  sq as SRegularPlantWilt,
  vq as SRegularPlateUtensils,
  eq as SRegularPlateWheat,
  tq as SRegularPlay,
  lq as SRegularPlayPause,
  nq as SRegularPlug,
  wq as SRegularPlugCircleBolt,
  gq as SRegularPlugCircleCheck,
  iq as SRegularPlugCircleExclamation,
  mq as SRegularPlugCircleMinus,
  aq as SRegularPlugCirclePlus,
  oq as SRegularPlugCircleXmark,
  Sq as SRegularPlus,
  rq as SRegularPlusLarge,
  dq as SRegularPlusMinus,
  zq as SRegularPodcast,
  Mq as SRegularPodium,
  pq as SRegularPodiumStar,
  xq as SRegularPoliceBox,
  Hq as SRegularPollPeople,
  Vq as SRegularPompebled,
  Lq as SRegularPoo,
  Cq as SRegularPooStorm,
  Bq as SRegularPool8Ball,
  uq as SRegularPoop,
  Rq as SRegularPopcorn,
  $q as SRegularPopsicle,
  kq as SRegularPotFood,
  Pq as SRegularPotato,
  Fq as SRegularPowerOff,
  yq as SRegularPrescription,
  Dq as SRegularPrescriptionBottle,
  Tq as SRegularPrescriptionBottleMedical,
  Aq as SRegularPrescriptionBottlePill,
  bq as SRegularPresentationScreen,
  fq as SRegularPretzel,
  qq as SRegularPrint,
  Uq as SRegularPrintMagnifyingGlass,
  Gq as SRegularPrintSlash,
  Wq as SRegularProjector,
  Iq as SRegularPump,
  Eq as SRegularPumpMedical,
  Oq as SRegularPumpSoap,
  Nq as SRegularPumpkin,
  Qq as SRegularPuzzle,
  Kq as SRegularPuzzlePiece,
  Xq as SRegularPuzzlePieceSimple,
  Zq as SRegularQ,
  Jq as SRegularQrcode,
  jq as SRegularQuestion,
  Yq as SRegularQuoteLeft,
  _q as SRegularQuoteRight,
  hW as SRegularQuotes,
  cW as SRegularR,
  vW as SRegularRabbit,
  sW as SRegularRabbitRunning,
  eW as SRegularRaccoon,
  lW as SRegularRacquet,
  tW as SRegularRadar,
  wW as SRegularRadiation,
  iW as SRegularRadio,
  gW as SRegularRadioTuner,
  mW as SRegularRainbow,
  aW as SRegularRaindrops,
  oW as SRegularRam,
  nW as SRegularRampLoading,
  rW as SRegularRankingStar,
  dW as SRegularRaygun,
  SW as SRegularReceipt,
  zW as SRegularRecordVinyl,
  FW as SRegularRectangle,
  pW as SRegularRectangleAd,
  MW as SRegularRectangleBarcode,
  xW as SRegularRectangleCode,
  CW as SRegularRectangleHistory,
  HW as SRegularRectangleHistoryCirclePlus,
  VW as SRegularRectangleHistoryCircleUser,
  LW as SRegularRectangleList,
  BW as SRegularRectanglePro,
  uW as SRegularRectangleTerminal,
  $W as SRegularRectangleVertical,
  RW as SRegularRectangleVerticalHistory,
  kW as SRegularRectangleWide,
  PW as SRegularRectangleXmark,
  TW as SRegularRectanglesMixed,
  AW as SRegularRecycle,
  DW as SRegularReel,
  yW as SRegularRefrigerator,
  bW as SRegularRegistered,
  UW as SRegularRepeat,
  fW as SRegularRepeat1,
  WW as SRegularReply,
  GW as SRegularReplyAll,
  qW as SRegularReplyClock,
  EW as SRegularRepublican,
  IW as SRegularRestroom,
  OW as SRegularRestroomSimple,
  NW as SRegularRetweet,
  XW as SRegularRhombus,
  KW as SRegularRibbon,
  sE as SRegularRight,
  QW as SRegularRightFromBracket,
  ZW as SRegularRightFromLine,
  jW as SRegularRightLeft,
  JW as SRegularRightLeftLarge,
  _W as SRegularRightLong,
  YW as SRegularRightLongToLine,
  hE as SRegularRightToBracket,
  cE as SRegularRightToLine,
  eE as SRegularRing,
  vE as SRegularRingDiamond,
  lE as SRegularRingsWedding,
  nE as SRegularRoad,
  tE as SRegularRoadBarrier,
  wE as SRegularRoadBridge,
  gE as SRegularRoadCircleCheck,
  iE as SRegularRoadCircleExclamation,
  mE as SRegularRoadCircleXmark,
  aE as SRegularRoadLock,
  oE as SRegularRoadSpikes,
  dE as SRegularRobot,
  rE as SRegularRobotAstromech,
  zE as SRegularRocket,
  SE as SRegularRocketLaunch,
  pE as SRegularRollerCoaster,
  VE as SRegularRotate,
  ME as SRegularRotateExclamation,
  xE as SRegularRotateLeft,
  HE as SRegularRotateRight,
  BE as SRegularRoute,
  CE as SRegularRouteHighway,
  LE as SRegularRouteInterstate,
  uE as SRegularRouter,
  RE as SRegularRss,
  $E as SRegularRubleSign,
  kE as SRegularRug,
  PE as SRegularRugbyBall,
  yE as SRegularRuler,
  FE as SRegularRulerCombined,
  TE as SRegularRulerHorizontal,
  AE as SRegularRulerTriangle,
  DE as SRegularRulerVertical,
  bE as SRegularRupeeSign,
  fE as SRegularRupiahSign,
  UE as SRegularRv,
  GE as SRegularS,
  EE as SRegularSack,
  qE as SRegularSackDollar,
  WE as SRegularSackXmark,
  OE as SRegularSailboat,
  IE as SRegularSalad,
  NE as SRegularSaltShaker,
  XE as SRegularSandwich,
  QE as SRegularSatellite,
  KE as SRegularSatelliteDish,
  ZE as SRegularSausage,
  jE as SRegularSaxophone,
  JE as SRegularSaxophoneFire,
  YE as SRegularScaleBalanced,
  hO as SRegularScaleUnbalanced,
  _E as SRegularScaleUnbalancedFlip,
  sO as SRegularScalpel,
  cO as SRegularScalpelLineDashed,
  vO as SRegularScannerGun,
  eO as SRegularScannerImage,
  lO as SRegularScannerKeyboard,
  tO as SRegularScannerTouchscreen,
  wO as SRegularScarecrow,
  gO as SRegularScarf,
  rO as SRegularSchool,
  iO as SRegularSchoolCircleCheck,
  mO as SRegularSchoolCircleExclamation,
  aO as SRegularSchoolCircleXmark,
  oO as SRegularSchoolFlag,
  nO as SRegularSchoolLock,
  dO as SRegularScissors,
  SO as SRegularScreenUsers,
  zO as SRegularScreencast,
  MO as SRegularScrewdriver,
  pO as SRegularScrewdriverWrench,
  xO as SRegularScribble,
  CO as SRegularScroll,
  HO as SRegularScrollOld,
  VO as SRegularScrollTorah,
  LO as SRegularScrubber,
  BO as SRegularScythe,
  uO as SRegularSdCard,
  RO as SRegularSdCards,
  PO as SRegularSeal,
  $O as SRegularSealExclamation,
  kO as SRegularSealQuestion,
  FO as SRegularSeatAirline,
  TO as SRegularSection,
  AO as SRegularSeedling,
  DO as SRegularSemicolon,
  yO as SRegularSendBack,
  bO as SRegularSendBackward,
  WO as SRegularSensor,
  fO as SRegularSensorCloud,
  UO as SRegularSensorFire,
  GO as SRegularSensorOn,
  qO as SRegularSensorTriangleExclamation,
  EO as SRegularServer,
  OO as SRegularShapes,
  KO as SRegularShare,
  IO as SRegularShareAll,
  NO as SRegularShareFromSquare,
  XO as SRegularShareNodes,
  QO as SRegularSheep,
  ZO as SRegularSheetPlastic,
  JO as SRegularShekelSign,
  YO as SRegularShelves,
  jO as SRegularShelvesEmpty,
  nI as SRegularShield,
  _O as SRegularShieldCat,
  hI as SRegularShieldCheck,
  cI as SRegularShieldCross,
  sI as SRegularShieldDog,
  vI as SRegularShieldExclamation,
  eI as SRegularShieldHalved,
  lI as SRegularShieldHeart,
  tI as SRegularShieldKeyhole,
  wI as SRegularShieldMinus,
  gI as SRegularShieldPlus,
  iI as SRegularShieldQuartered,
  mI as SRegularShieldSlash,
  aI as SRegularShieldVirus,
  oI as SRegularShieldXmark,
  rI as SRegularShip,
  pI as SRegularShirt,
  dI as SRegularShirtLongSleeve,
  SI as SRegularShirtRunning,
  zI as SRegularShirtTankTop,
  MI as SRegularShishKebab,
  xI as SRegularShoePrints,
  CI as SRegularShop,
  HI as SRegularShopLock,
  VI as SRegularShopSlash,
  BI as SRegularShovel,
  LI as SRegularShovelSnow,
  RI as SRegularShower,
  uI as SRegularShowerDown,
  $I as SRegularShredder,
  kI as SRegularShrimp,
  PI as SRegularShuffle,
  FI as SRegularShutters,
  TI as SRegularShuttleSpace,
  AI as SRegularShuttlecock,
  DI as SRegularSickle,
  bI as SRegularSidebar,
  yI as SRegularSidebarFlip,
  fI as SRegularSigma,
  UI as SRegularSignHanging,
  jI as SRegularSignal,
  OI as SRegularSignalBars,
  GI as SRegularSignalBarsFair,
  qI as SRegularSignalBarsGood,
  WI as SRegularSignalBarsSlash,
  EI as SRegularSignalBarsWeak,
  II as SRegularSignalFair,
  NI as SRegularSignalGood,
  XI as SRegularSignalSlash,
  QI as SRegularSignalStream,
  KI as SRegularSignalStreamSlash,
  ZI as SRegularSignalStrong,
  JI as SRegularSignalWeak,
  hN as SRegularSignature,
  YI as SRegularSignatureLock,
  _I as SRegularSignatureSlash,
  cN as SRegularSignsPost,
  sN as SRegularSimCard,
  vN as SRegularSimCards,
  eN as SRegularSink,
  tN as SRegularSiren,
  lN as SRegularSirenOn,
  wN as SRegularSitemap,
  iN as SRegularSkeleton,
  gN as SRegularSkeletonRibs,
  aN as SRegularSkiBoot,
  mN as SRegularSkiBootSki,
  rN as SRegularSkull,
  oN as SRegularSkullCow,
  nN as SRegularSkullCrossbones,
  zN as SRegularSlash,
  dN as SRegularSlashBack,
  SN as SRegularSlashForward,
  pN as SRegularSleigh,
  MN as SRegularSlider,
  VN as SRegularSliders,
  xN as SRegularSlidersSimple,
  HN as SRegularSlidersUp,
  CN as SRegularSlotMachine,
  LN as SRegularSmog,
  BN as SRegularSmoke,
  uN as SRegularSmoking,
  RN as SRegularSnake,
  $N as SRegularSnooze,
  kN as SRegularSnowBlowing,
  FN as SRegularSnowflake,
  PN as SRegularSnowflakeDroplets,
  TN as SRegularSnowflakes,
  DN as SRegularSnowman,
  AN as SRegularSnowmanHead,
  yN as SRegularSnowplow,
  bN as SRegularSoap,
  fN as SRegularSocks,
  UN as SRegularSoftServe,
  GN as SRegularSolarPanel,
  qN as SRegularSolarSystem,
  ON as SRegularSort,
  WN as SRegularSortDown,
  EN as SRegularSortUp,
  IN as SRegularSpa,
  XN as SRegularSpaceStationMoon,
  NN as SRegularSpaceStationMoonConstruction,
  KN as SRegularSpade,
  QN as SRegularSpaghettiMonsterFlying,
  ZN as SRegularSparkle,
  JN as SRegularSparkles,
  jN as SRegularSpeaker,
  YN as SRegularSpeakers,
  _N as SRegularSpellCheck,
  sX as SRegularSpider,
  hX as SRegularSpiderBlackWidow,
  cX as SRegularSpiderWeb,
  eX as SRegularSpinner,
  vX as SRegularSpinnerThird,
  lX as SRegularSplit,
  tX as SRegularSplotch,
  wX as SRegularSpoon,
  gX as SRegularSportsball,
  mX as SRegularSprayCan,
  iX as SRegularSprayCanSparkles,
  oX as SRegularSprinkler,
  aX as SRegularSprinklerCeiling,
  nQ as SRegularSquare,
  nX as SRegularSquare0,
  rX as SRegularSquare1,
  dX as SRegularSquare2,
  SX as SRegularSquare3,
  zX as SRegularSquare4,
  pX as SRegularSquare5,
  MX as SRegularSquare6,
  xX as SRegularSquare7,
  HX as SRegularSquare8,
  VX as SRegularSquare9,
  LX as SRegularSquareA,
  CX as SRegularSquareALock,
  BX as SRegularSquareAmpersand,
  $X as SRegularSquareArrowDown,
  uX as SRegularSquareArrowDownLeft,
  RX as SRegularSquareArrowDownRight,
  kX as SRegularSquareArrowLeft,
  PX as SRegularSquareArrowRight,
  AX as SRegularSquareArrowUp,
  FX as SRegularSquareArrowUpLeft,
  TX as SRegularSquareArrowUpRight,
  DX as SRegularSquareB,
  yX as SRegularSquareBolt,
  bX as SRegularSquareC,
  fX as SRegularSquareCaretDown,
  UX as SRegularSquareCaretLeft,
  GX as SRegularSquareCaretRight,
  qX as SRegularSquareCaretUp,
  WX as SRegularSquareCheck,
  EX as SRegularSquareChevronDown,
  OX as SRegularSquareChevronLeft,
  IX as SRegularSquareChevronRight,
  NX as SRegularSquareChevronUp,
  XX as SRegularSquareCode,
  KX as SRegularSquareD,
  ZX as SRegularSquareDashed,
  QX as SRegularSquareDashedCirclePlus,
  JX as SRegularSquareDivide,
  jX as SRegularSquareDollar,
  hK as SRegularSquareDown,
  YX as SRegularSquareDownLeft,
  _X as SRegularSquareDownRight,
  cK as SRegularSquareE,
  vK as SRegularSquareEllipsis,
  sK as SRegularSquareEllipsisVertical,
  eK as SRegularSquareEnvelope,
  lK as SRegularSquareExclamation,
  tK as SRegularSquareF,
  wK as SRegularSquareFragile,
  gK as SRegularSquareFull,
  iK as SRegularSquareG,
  mK as SRegularSquareH,
  aK as SRegularSquareHeart,
  oK as SRegularSquareI,
  nK as SRegularSquareInfo,
  rK as SRegularSquareJ,
  dK as SRegularSquareK,
  SK as SRegularSquareKanban,
  zK as SRegularSquareL,
  pK as SRegularSquareLeft,
  MK as SRegularSquareList,
  xK as SRegularSquareM,
  HK as SRegularSquareMinus,
  VK as SRegularSquareN,
  CK as SRegularSquareNfi,
  LK as SRegularSquareO,
  BK as SRegularSquareP,
  RK as SRegularSquareParking,
  uK as SRegularSquareParkingSlash,
  $K as SRegularSquarePen,
  kK as SRegularSquarePersonConfined,
  TK as SRegularSquarePhone,
  PK as SRegularSquarePhoneFlip,
  FK as SRegularSquarePhoneHangup,
  AK as SRegularSquarePlus,
  DK as SRegularSquarePollHorizontal,
  yK as SRegularSquarePollVertical,
  bK as SRegularSquareQ,
  fK as SRegularSquareQuarters,
  UK as SRegularSquareQuestion,
  GK as SRegularSquareQuote,
  qK as SRegularSquareR,
  WK as SRegularSquareRight,
  EK as SRegularSquareRing,
  IK as SRegularSquareRoot,
  OK as SRegularSquareRootVariable,
  NK as SRegularSquareRss,
  XK as SRegularSquareS,
  KK as SRegularSquareShareNodes,
  ZK as SRegularSquareSliders,
  QK as SRegularSquareSlidersVertical,
  JK as SRegularSquareSmall,
  jK as SRegularSquareStar,
  YK as SRegularSquareT,
  _K as SRegularSquareTerminal,
  hQ as SRegularSquareThisWayUp,
  cQ as SRegularSquareU,
  eQ as SRegularSquareUp,
  sQ as SRegularSquareUpLeft,
  vQ as SRegularSquareUpRight,
  lQ as SRegularSquareUser,
  tQ as SRegularSquareV,
  wQ as SRegularSquareVirus,
  gQ as SRegularSquareW,
  iQ as SRegularSquareX,
  mQ as SRegularSquareXmark,
  aQ as SRegularSquareY,
  oQ as SRegularSquareZ,
  rQ as SRegularSquid,
  dQ as SRegularSquirrel,
  zQ as SRegularStaff,
  SQ as SRegularStaffSnake,
  pQ as SRegularStairs,
  MQ as SRegularStamp,
  xQ as SRegularStandardDefinition,
  HQ as SRegularStapler,
  AQ as SRegularStar,
  VQ as SRegularStarAndCrescent,
  CQ as SRegularStarChristmas,
  LQ as SRegularStarExclamation,
  uQ as SRegularStarHalf,
  BQ as SRegularStarHalfStroke,
  RQ as SRegularStarOfDavid,
  $Q as SRegularStarOfLife,
  FQ as SRegularStarSharp,
  PQ as SRegularStarSharpHalf,
  kQ as SRegularStarSharpHalfStroke,
  TQ as SRegularStarShooting,
  bQ as SRegularStarfighter,
  yQ as SRegularStarfighterTwinIonEngine,
  DQ as SRegularStarfighterTwinIonEngineAdvanced,
  fQ as SRegularStars,
  GQ as SRegularStarship,
  UQ as SRegularStarshipFreighter,
  qQ as SRegularSteak,
  WQ as SRegularSteeringWheel,
  EQ as SRegularSterlingSign,
  OQ as SRegularStethoscope,
  IQ as SRegularStocking,
  NQ as SRegularStomach,
  XQ as SRegularStop,
  QQ as SRegularStopwatch,
  KQ as SRegularStopwatch20,
  jQ as SRegularStore,
  ZQ as SRegularStoreLock,
  JQ as SRegularStoreSlash,
  YQ as SRegularStrawberry,
  _Q as SRegularStreetView,
  hZ as SRegularStretcher,
  cZ as SRegularStrikethrough,
  sZ as SRegularStroopwafel,
  vZ as SRegularSubscript,
  lZ as SRegularSubtitles,
  eZ as SRegularSubtitlesSlash,
  gZ as SRegularSuitcase,
  tZ as SRegularSuitcaseMedical,
  wZ as SRegularSuitcaseRolling,
  rZ as SRegularSun,
  iZ as SRegularSunBright,
  mZ as SRegularSunCloud,
  aZ as SRegularSunDust,
  oZ as SRegularSunHaze,
  nZ as SRegularSunPlantWilt,
  dZ as SRegularSunglasses,
  SZ as SRegularSunrise,
  zZ as SRegularSunset,
  pZ as SRegularSuperscript,
  xZ as SRegularSushi,
  MZ as SRegularSushiRoll,
  X5 as SRegularSvg0,
  K5 as SRegularSvg00,
  Q5 as SRegularSvg1,
  Z5 as SRegularSvg2,
  J5 as SRegularSvg3,
  j5 as SRegularSvg360Degrees,
  Y5 as SRegularSvg4,
  _5 as SRegularSvg5,
  h7 as SRegularSvg6,
  c7 as SRegularSvg7,
  s7 as SRegularSvg8,
  v7 as SRegularSvg9,
  VZ as SRegularSwap,
  HZ as SRegularSwapArrows,
  CZ as SRegularSwatchbook,
  uZ as SRegularSword,
  BZ as SRegularSwordLaser,
  LZ as SRegularSwordLaserAlt,
  $Z as SRegularSwords,
  RZ as SRegularSwordsLaser,
  kZ as SRegularSymbols,
  PZ as SRegularSynagogue,
  FZ as SRegularSyringe,
  TZ as SRegularT,
  OZ as SRegularTable,
  DZ as SRegularTableCells,
  AZ as SRegularTableCellsLarge,
  yZ as SRegularTableColumns,
  bZ as SRegularTableLayout,
  fZ as SRegularTableList,
  UZ as SRegularTablePicnic,
  GZ as SRegularTablePivot,
  qZ as SRegularTableRows,
  WZ as SRegularTableTennisPaddleBall,
  EZ as SRegularTableTree,
  QZ as SRegularTablet,
  IZ as SRegularTabletButton,
  NZ as SRegularTabletRugged,
  KZ as SRegularTabletScreen,
  XZ as SRegularTabletScreenButton,
  ZZ as SRegularTablets,
  JZ as SRegularTachographDigital,
  jZ as SRegularTaco,
  YZ as SRegularTag,
  _Z as SRegularTags,
  eJ as SRegularTally,
  hJ as SRegularTally1,
  cJ as SRegularTally2,
  sJ as SRegularTally3,
  vJ as SRegularTally4,
  lJ as SRegularTamale,
  tJ as SRegularTankWater,
  wJ as SRegularTape,
  iJ as SRegularTarp,
  gJ as SRegularTarpDroplet,
  aJ as SRegularTaxi,
  mJ as SRegularTaxiBus,
  oJ as SRegularTeddyBear,
  rJ as SRegularTeeth,
  nJ as SRegularTeethOpen,
  dJ as SRegularTelescope,
  SJ as SRegularTemperatureArrowDown,
  zJ as SRegularTemperatureArrowUp,
  pJ as SRegularTemperatureEmpty,
  MJ as SRegularTemperatureFull,
  xJ as SRegularTemperatureHalf,
  HJ as SRegularTemperatureHigh,
  VJ as SRegularTemperatureList,
  CJ as SRegularTemperatureLow,
  LJ as SRegularTemperatureQuarter,
  BJ as SRegularTemperatureSnow,
  uJ as SRegularTemperatureSun,
  RJ as SRegularTemperatureThreeQuarters,
  $J as SRegularTengeSign,
  kJ as SRegularTennisBall,
  DJ as SRegularTent,
  PJ as SRegularTentArrowDownToLine,
  FJ as SRegularTentArrowLeftRight,
  TJ as SRegularTentArrowTurnLeft,
  AJ as SRegularTentArrowsDown,
  yJ as SRegularTents,
  bJ as SRegularTerminal,
  WJ as SRegularText,
  fJ as SRegularTextHeight,
  UJ as SRegularTextSize,
  GJ as SRegularTextSlash,
  qJ as SRegularTextWidth,
  EJ as SRegularThermometer,
  OJ as SRegularTheta,
  IJ as SRegularThoughtBubble,
  NJ as SRegularThumbsDown,
  XJ as SRegularThumbsUp,
  KJ as SRegularThumbtack,
  QJ as SRegularTick,
  jJ as SRegularTicket,
  ZJ as SRegularTicketAirline,
  JJ as SRegularTicketSimple,
  YJ as SRegularTicketsAirline,
  _J as SRegularTilde,
  cj as SRegularTimeline,
  hj as SRegularTimelineArrow,
  sj as SRegularTimer,
  tj as SRegularTire,
  vj as SRegularTireFlat,
  ej as SRegularTirePressureWarning,
  lj as SRegularTireRugged,
  wj as SRegularToggleLargeOff,
  gj as SRegularToggleLargeOn,
  ij as SRegularToggleOff,
  mj as SRegularToggleOn,
  xj as SRegularToilet,
  pj as SRegularToiletPaper,
  oj as SRegularToiletPaperBlank,
  aj as SRegularToiletPaperBlankUnder,
  nj as SRegularToiletPaperCheck,
  rj as SRegularToiletPaperSlash,
  Sj as SRegularToiletPaperUnder,
  dj as SRegularToiletPaperUnderSlash,
  zj as SRegularToiletPaperXmark,
  Mj as SRegularToiletPortable,
  Hj as SRegularToiletsPortable,
  Vj as SRegularTomato,
  Lj as SRegularTombstone,
  Cj as SRegularTombstoneBlank,
  Bj as SRegularToolbox,
  uj as SRegularTooth,
  Rj as SRegularToothbrush,
  $j as SRegularToriiGate,
  kj as SRegularTornado,
  Pj as SRegularTowerBroadcast,
  Fj as SRegularTowerCell,
  Tj as SRegularTowerControl,
  Aj as SRegularTowerObservation,
  Dj as SRegularTractor,
  yj as SRegularTrademark,
  bj as SRegularTrafficCone,
  qj as SRegularTrafficLight,
  fj as SRegularTrafficLightGo,
  Uj as SRegularTrafficLightSlow,
  Gj as SRegularTrafficLightStop,
  Wj as SRegularTrailer,
  Kj as SRegularTrain,
  Oj as SRegularTrainSubway,
  Ej as SRegularTrainSubwayTunnel,
  Ij as SRegularTrainTrack,
  Nj as SRegularTrainTram,
  Xj as SRegularTrainTunnel,
  Qj as SRegularTransformerBolt,
  Zj as SRegularTransgender,
  eY as SRegularTransporter,
  Jj as SRegularTransporter1,
  jj as SRegularTransporter2,
  Yj as SRegularTransporter3,
  _j as SRegularTransporter4,
  hY as SRegularTransporter5,
  cY as SRegularTransporter6,
  sY as SRegularTransporter7,
  vY as SRegularTransporterEmpty,
  VY as SRegularTrash,
  lY as SRegularTrashArrowUp,
  rY as SRegularTrashCan,
  tY as SRegularTrashCanArrowUp,
  wY as SRegularTrashCanCheck,
  gY as SRegularTrashCanClock,
  iY as SRegularTrashCanList,
  mY as SRegularTrashCanPlus,
  aY as SRegularTrashCanSlash,
  oY as SRegularTrashCanUndo,
  nY as SRegularTrashCanXmark,
  dY as SRegularTrashCheck,
  SY as SRegularTrashClock,
  zY as SRegularTrashList,
  pY as SRegularTrashPlus,
  MY as SRegularTrashSlash,
  xY as SRegularTrashUndo,
  HY as SRegularTrashXmark,
  CY as SRegularTreasureChest,
  PY as SRegularTree,
  LY as SRegularTreeChristmas,
  BY as SRegularTreeCity,
  uY as SRegularTreeDeciduous,
  RY as SRegularTreeDecorated,
  $Y as SRegularTreeLarge,
  kY as SRegularTreePalm,
  FY as SRegularTrees,
  yY as SRegularTriangle,
  TY as SRegularTriangleExclamation,
  AY as SRegularTriangleInstrument,
  DY as SRegularTrianglePersonDigging,
  fY as SRegularTricycle,
  bY as SRegularTricycleAdult,
  UY as SRegularTrillium,
  qY as SRegularTrophy,
  GY as SRegularTrophyStar,
  EY as SRegularTrowel,
  WY as SRegularTrowelBricks,
  m_ as SRegularTruck,
  OY as SRegularTruckArrowRight,
  IY as SRegularTruckBolt,
  NY as SRegularTruckClock,
  KY as SRegularTruckContainer,
  XY as SRegularTruckContainerEmpty,
  QY as SRegularTruckDroplet,
  ZY as SRegularTruckFast,
  jY as SRegularTruckField,
  JY as SRegularTruckFieldUn,
  YY as SRegularTruckFlatbed,
  _Y as SRegularTruckFront,
  h_ as SRegularTruckMedical,
  c_ as SRegularTruckMonster,
  s_ as SRegularTruckMoving,
  v_ as SRegularTruckPickup,
  e_ as SRegularTruckPlane,
  l_ as SRegularTruckPlow,
  g_ as SRegularTruckRamp,
  t_ as SRegularTruckRampBox,
  w_ as SRegularTruckRampCouch,
  i_ as SRegularTruckTow,
  a_ as SRegularTrumpet,
  n_ as SRegularTty,
  o_ as SRegularTtyAnswer,
  r_ as SRegularTugrikSign,
  d_ as SRegularTurkey,
  S_ as SRegularTurkishLiraSign,
  M_ as SRegularTurnDown,
  z_ as SRegularTurnDownLeft,
  p_ as SRegularTurnDownRight,
  x_ as SRegularTurnUp,
  H_ as SRegularTurntable,
  V_ as SRegularTurtle,
  B_ as SRegularTv,
  C_ as SRegularTvMusic,
  L_ as SRegularTvRetro,
  u_ as SRegularTypewriter,
  R_ as SRegularU,
  k_ as SRegularUfo,
  $_ as SRegularUfoBeam,
  T_ as SRegularUmbrella,
  P_ as SRegularUmbrellaBeach,
  F_ as SRegularUmbrellaSimple,
  A_ as SRegularUnderline,
  D_ as SRegularUnicorn,
  y_ as SRegularUniformMartialArts,
  b_ as SRegularUnion,
  f_ as SRegularUniversalAccess,
  G_ as SRegularUnlock,
  U_ as SRegularUnlockKeyhole,
  Y_ as SRegularUp,
  W_ as SRegularUpDown,
  q_ as SRegularUpDownLeftRight,
  E_ as SRegularUpFromBracket,
  O_ as SRegularUpFromDottedLine,
  I_ as SRegularUpFromLine,
  N_ as SRegularUpLeft,
  X_ as SRegularUpLong,
  Z_ as SRegularUpRight,
  K_ as SRegularUpRightAndDownLeftFromCenter,
  Q_ as SRegularUpRightFromSquare,
  J_ as SRegularUpToDottedLine,
  j_ as SRegularUpToLine,
  __ as SRegularUpload,
  h11 as SRegularUsbDrive,
  v21 as SRegularUser,
  c11 as SRegularUserAlien,
  s11 as SRegularUserAstronaut,
  v11 as SRegularUserBountyHunter,
  e11 as SRegularUserCheck,
  l11 as SRegularUserChef,
  t11 as SRegularUserClock,
  w11 as SRegularUserCowboy,
  g11 as SRegularUserCrown,
  o11 as SRegularUserDoctor,
  m11 as SRegularUserDoctorHair,
  i11 as SRegularUserDoctorHairLong,
  a11 as SRegularUserDoctorMessage,
  n11 as SRegularUserGear,
  r11 as SRegularUserGraduate,
  z11 as SRegularUserGroup,
  d11 as SRegularUserGroupCrown,
  S11 as SRegularUserGroupSimple,
  H11 as SRegularUserHair,
  p11 as SRegularUserHairBuns,
  M11 as SRegularUserHairLong,
  x11 as SRegularUserHairMullet,
  V11 as SRegularUserHeadset,
  C11 as SRegularUserHelmetSafety,
  L11 as SRegularUserInjured,
  u11 as SRegularUserLarge,
  B11 as SRegularUserLargeSlash,
  R11 as SRegularUserLock,
  $11 as SRegularUserMagnifyingGlass,
  k11 as SRegularUserMinus,
  P11 as SRegularUserMusic,
  F11 as SRegularUserNinja,
  D11 as SRegularUserNurse,
  A11 as SRegularUserNurseHair,
  T11 as SRegularUserNurseHairLong,
  y11 as SRegularUserPen,
  f11 as SRegularUserPilot,
  b11 as SRegularUserPilotTie,
  U11 as SRegularUserPlus,
  q11 as SRegularUserPolice,
  G11 as SRegularUserPoliceTie,
  E11 as SRegularUserRobot,
  W11 as SRegularUserRobotXmarks,
  O11 as SRegularUserSecret,
  I11 as SRegularUserShakespeare,
  N11 as SRegularUserShield,
  X11 as SRegularUserSlash,
  K11 as SRegularUserTag,
  J11 as SRegularUserTie,
  Z11 as SRegularUserTieHair,
  Q11 as SRegularUserTieHairLong,
  j11 as SRegularUserUnlock,
  Y11 as SRegularUserVisor,
  c21 as SRegularUserVneck,
  h21 as SRegularUserVneckHair,
  _11 as SRegularUserVneckHairLong,
  s21 as SRegularUserXmark,
  o21 as SRegularUsers,
  e21 as SRegularUsersBetweenLines,
  l21 as SRegularUsersGear,
  t21 as SRegularUsersLine,
  w21 as SRegularUsersMedical,
  g21 as SRegularUsersRays,
  i21 as SRegularUsersRectangle,
  m21 as SRegularUsersSlash,
  a21 as SRegularUsersViewfinder,
  r21 as SRegularUtensils,
  n21 as SRegularUtensilsSlash,
  S21 as SRegularUtilityPole,
  d21 as SRegularUtilityPoleDouble,
  z21 as SRegularV,
  M21 as SRegularVacuum,
  p21 as SRegularVacuumRobot,
  x21 as SRegularValueAbsolute,
  H21 as SRegularVanShuttle,
  V21 as SRegularVault,
  C21 as SRegularVectorCircle,
  L21 as SRegularVectorPolygon,
  B21 as SRegularVectorSquare,
  u21 as SRegularVentDamper,
  k21 as SRegularVenus,
  R21 as SRegularVenusDouble,
  $21 as SRegularVenusMars,
  F21 as SRegularVest,
  P21 as SRegularVestPatches,
  D21 as SRegularVial,
  T21 as SRegularVialCircleCheck,
  A21 as SRegularVialVirus,
  y21 as SRegularVials,
  q21 as SRegularVideo,
  b21 as SRegularVideoArrowDownLeft,
  f21 as SRegularVideoArrowUpRight,
  U21 as SRegularVideoPlus,
  G21 as SRegularVideoSlash,
  W21 as SRegularVihara,
  E21 as SRegularViolin,
  X21 as SRegularVirus,
  I21 as SRegularVirusCovid,
  O21 as SRegularVirusCovidSlash,
  N21 as SRegularVirusSlash,
  K21 as SRegularViruses,
  Q21 as SRegularVoicemail,
  Z21 as SRegularVolcano,
  J21 as SRegularVolleyball,
  s41 as SRegularVolume,
  j21 as SRegularVolumeHigh,
  Y21 as SRegularVolumeLow,
  _21 as SRegularVolumeOff,
  h41 as SRegularVolumeSlash,
  c41 as SRegularVolumeXmark,
  v41 as SRegularVrCardboard,
  e41 as SRegularW,
  l41 as SRegularWaffle,
  t41 as SRegularWagonCovered,
  w41 as SRegularWalker,
  g41 as SRegularWalkieTalkie,
  i41 as SRegularWallet,
  n41 as SRegularWand,
  a41 as SRegularWandMagic,
  m41 as SRegularWandMagicSparkles,
  o41 as SRegularWandSparkles,
  d41 as SRegularWarehouse,
  r41 as SRegularWarehouseFull,
  S41 as SRegularWashingMachine,
  H41 as SRegularWatch,
  z41 as SRegularWatchApple,
  p41 as SRegularWatchCalculator,
  M41 as SRegularWatchFitness,
  x41 as SRegularWatchSmart,
  B41 as SRegularWater,
  V41 as SRegularWaterArrowDown,
  C41 as SRegularWaterArrowUp,
  L41 as SRegularWaterLadder,
  u41 as SRegularWatermelonSlice,
  R41 as SRegularWavePulse,
  $41 as SRegularWaveSine,
  k41 as SRegularWaveSquare,
  P41 as SRegularWaveTriangle,
  T41 as SRegularWaveform,
  F41 as SRegularWaveformLines,
  A41 as SRegularWebhook,
  D41 as SRegularWeightHanging,
  y41 as SRegularWeightScale,
  b41 as SRegularWhale,
  W41 as SRegularWheat,
  G41 as SRegularWheatAwn,
  f41 as SRegularWheatAwnCircleExclamation,
  U41 as SRegularWheatAwnSlash,
  q41 as SRegularWheatSlash,
  O41 as SRegularWheelchair,
  E41 as SRegularWheelchairMove,
  N41 as SRegularWhiskeyGlass,
  I41 as SRegularWhiskeyGlassIce,
  X41 as SRegularWhistle,
  j41 as SRegularWifi,
  K41 as SRegularWifiExclamation,
  Q41 as SRegularWifiFair,
  Z41 as SRegularWifiSlash,
  J41 as SRegularWifiWeak,
  h31 as SRegularWind,
  Y41 as SRegularWindTurbine,
  _41 as SRegularWindWarning,
  w31 as SRegularWindow,
  c31 as SRegularWindowFlip,
  v31 as SRegularWindowFrame,
  s31 as SRegularWindowFrameOpen,
  e31 as SRegularWindowMaximize,
  l31 as SRegularWindowMinimize,
  t31 as SRegularWindowRestore,
  g31 as SRegularWindsock,
  i31 as SRegularWineBottle,
  o31 as SRegularWineGlass,
  m31 as SRegularWineGlassCrack,
  a31 as SRegularWineGlassEmpty,
  n31 as SRegularWonSign,
  r31 as SRegularWorm,
  S31 as SRegularWreath,
  d31 as SRegularWreathLaurel,
  p31 as SRegularWrench,
  z31 as SRegularWrenchSimple,
  x31 as SRegularX,
  M31 as SRegularXRay,
  C31 as SRegularXmark,
  H31 as SRegularXmarkLarge,
  V31 as SRegularXmarkToSlot,
  L31 as SRegularXmarksLines,
  B31 as SRegularY,
  u31 as SRegularYenSign,
  R31 as SRegularYinYang,
  $31 as SRegularZ,
  W31 as SolidA,
  E31 as SolidAbacus,
  O31 as SolidAccentGrave,
  I31 as SolidAcorn,
  N31 as SolidAddressBook,
  X31 as SolidAddressCard,
  K31 as SolidAirConditioner,
  Q31 as SolidAirplay,
  Z31 as SolidAlarmClock,
  J31 as SolidAlarmExclamation,
  j31 as SolidAlarmPlus,
  Y31 as SolidAlarmSnooze,
  e01 as SolidAlbum,
  _31 as SolidAlbumCirclePlus,
  h01 as SolidAlbumCircleUser,
  v01 as SolidAlbumCollection,
  c01 as SolidAlbumCollectionCirclePlus,
  s01 as SolidAlbumCollectionCircleUser,
  l01 as SolidAlicorn,
  w01 as SolidAlien,
  t01 as SolidAlien8Bit,
  g01 as SolidAlignCenter,
  i01 as SolidAlignJustify,
  m01 as SolidAlignLeft,
  a01 as SolidAlignRight,
  o01 as SolidAlignSlash,
  n01 as SolidAlt,
  r01 as SolidAmpGuitar,
  d01 as SolidAmpersand,
  x01 as SolidAnchor,
  S01 as SolidAnchorCircleCheck,
  z01 as SolidAnchorCircleExclamation,
  p01 as SolidAnchorCircleXmark,
  M01 as SolidAnchorLock,
  H01 as SolidAngel,
  R01 as SolidAngle,
  V01 as SolidAngle90,
  C01 as SolidAngleDown,
  L01 as SolidAngleLeft,
  B01 as SolidAngleRight,
  u01 as SolidAngleUp,
  $01 as SolidAnglesDown,
  k01 as SolidAnglesLeft,
  P01 as SolidAnglesRight,
  T01 as SolidAnglesUp,
  F01 as SolidAnglesUpDown,
  A01 as SolidAnkh,
  D01 as SolidApartment,
  y01 as SolidAperture,
  b01 as SolidApostrophe,
  f01 as SolidAppleCore,
  U01 as SolidAppleWhole,
  G01 as SolidArchway,
  a61 as SolidArrowDown,
  q01 as SolidArrowDown19,
  W01 as SolidArrowDown91,
  E01 as SolidArrowDownAZ,
  O01 as SolidArrowDownArrowUp,
  I01 as SolidArrowDownBigSmall,
  N01 as SolidArrowDownFromArc,
  X01 as SolidArrowDownFromDottedLine,
  K01 as SolidArrowDownFromLine,
  Z01 as SolidArrowDownLeft,
  Q01 as SolidArrowDownLeftAndArrowUpRightToCenter,
  J01 as SolidArrowDownLong,
  j01 as SolidArrowDownRight,
  Y01 as SolidArrowDownShortWide,
  _01 as SolidArrowDownSmallBig,
  h61 as SolidArrowDownSquareTriangle,
  c61 as SolidArrowDownToArc,
  s61 as SolidArrowDownToBracket,
  v61 as SolidArrowDownToDottedLine,
  e61 as SolidArrowDownToLine,
  l61 as SolidArrowDownToSquare,
  t61 as SolidArrowDownTriangleSquare,
  w61 as SolidArrowDownUpAcrossLine,
  g61 as SolidArrowDownUpLock,
  i61 as SolidArrowDownWideShort,
  m61 as SolidArrowDownZA,
  p61 as SolidArrowLeft,
  o61 as SolidArrowLeftFromArc,
  n61 as SolidArrowLeftFromLine,
  d61 as SolidArrowLeftLong,
  r61 as SolidArrowLeftLongToLine,
  S61 as SolidArrowLeftToArc,
  z61 as SolidArrowLeftToLine,
  M61 as SolidArrowPointer,
  x61 as SolidArrowProgress,
  F61 as SolidArrowRight,
  H61 as SolidArrowRightArrowLeft,
  V61 as SolidArrowRightFromArc,
  C61 as SolidArrowRightFromBracket,
  L61 as SolidArrowRightFromLine,
  u61 as SolidArrowRightLong,
  B61 as SolidArrowRightLongToLine,
  R61 as SolidArrowRightToArc,
  $61 as SolidArrowRightToBracket,
  k61 as SolidArrowRightToCity,
  P61 as SolidArrowRightToLine,
  T61 as SolidArrowRotateLeft,
  A61 as SolidArrowRotateRight,
  D61 as SolidArrowTrendDown,
  y61 as SolidArrowTrendUp,
  U61 as SolidArrowTurnDown,
  b61 as SolidArrowTurnDownLeft,
  f61 as SolidArrowTurnDownRight,
  G61 as SolidArrowTurnUp,
  r81 as SolidArrowUp,
  q61 as SolidArrowUp19,
  W61 as SolidArrowUp91,
  E61 as SolidArrowUpAZ,
  O61 as SolidArrowUpArrowDown,
  I61 as SolidArrowUpBigSmall,
  N61 as SolidArrowUpFromArc,
  X61 as SolidArrowUpFromBracket,
  K61 as SolidArrowUpFromDottedLine,
  Q61 as SolidArrowUpFromGroundWater,
  Z61 as SolidArrowUpFromLine,
  J61 as SolidArrowUpFromSquare,
  j61 as SolidArrowUpFromWaterPump,
  _61 as SolidArrowUpLeft,
  Y61 as SolidArrowUpLeftFromCircle,
  h81 as SolidArrowUpLong,
  e81 as SolidArrowUpRight,
  c81 as SolidArrowUpRightAndArrowDownLeftFromCenter,
  s81 as SolidArrowUpRightDots,
  v81 as SolidArrowUpRightFromSquare,
  l81 as SolidArrowUpShortWide,
  t81 as SolidArrowUpSmallBig,
  w81 as SolidArrowUpSquareTriangle,
  g81 as SolidArrowUpToArc,
  i81 as SolidArrowUpToDottedLine,
  m81 as SolidArrowUpToLine,
  a81 as SolidArrowUpTriangleSquare,
  o81 as SolidArrowUpWideShort,
  n81 as SolidArrowUpZA,
  d81 as SolidArrowsCross,
  S81 as SolidArrowsDownToLine,
  z81 as SolidArrowsDownToPeople,
  p81 as SolidArrowsFromDottedLine,
  M81 as SolidArrowsFromLine,
  H81 as SolidArrowsLeftRight,
  x81 as SolidArrowsLeftRightToLine,
  V81 as SolidArrowsMaximize,
  C81 as SolidArrowsMinimize,
  B81 as SolidArrowsRepeat,
  L81 as SolidArrowsRepeat1,
  u81 as SolidArrowsRetweet,
  R81 as SolidArrowsRotate,
  $81 as SolidArrowsSpin,
  k81 as SolidArrowsSplitUpAndLeft,
  P81 as SolidArrowsToCircle,
  F81 as SolidArrowsToDot,
  T81 as SolidArrowsToDottedLine,
  A81 as SolidArrowsToEye,
  D81 as SolidArrowsToLine,
  y81 as SolidArrowsTurnRight,
  b81 as SolidArrowsTurnToDots,
  U81 as SolidArrowsUpDown,
  f81 as SolidArrowsUpDownLeftRight,
  G81 as SolidArrowsUpToLine,
  q81 as SolidAsterisk,
  W81 as SolidAt,
  O81 as SolidAtom,
  E81 as SolidAtomSimple,
  N81 as SolidAudioDescription,
  I81 as SolidAudioDescriptionSlash,
  X81 as SolidAustralSign,
  K81 as SolidAvocado,
  Z81 as SolidAward,
  Q81 as SolidAwardSimple,
  j81 as SolidAxe,
  J81 as SolidAxeBattle,
  Y81 as SolidB,
  h51 as SolidBaby,
  _81 as SolidBabyCarriage,
  c51 as SolidBackpack,
  e51 as SolidBackward,
  s51 as SolidBackwardFast,
  v51 as SolidBackwardStep,
  l51 as SolidBacon,
  t51 as SolidBacteria,
  w51 as SolidBacterium,
  o51 as SolidBadge,
  g51 as SolidBadgeCheck,
  i51 as SolidBadgeDollar,
  m51 as SolidBadgePercent,
  a51 as SolidBadgeSheriff,
  n51 as SolidBadgerHoney,
  r51 as SolidBadminton,
  d51 as SolidBagSeedling,
  S51 as SolidBagShopping,
  z51 as SolidBagel,
  p51 as SolidBagsShopping,
  M51 as SolidBaguette,
  x51 as SolidBahai,
  H51 as SolidBahtSign,
  V51 as SolidBallPile,
  C51 as SolidBalloon,
  L51 as SolidBalloons,
  u51 as SolidBallot,
  B51 as SolidBallotCheck,
  P51 as SolidBan,
  R51 as SolidBanBug,
  $51 as SolidBanParking,
  k51 as SolidBanSmoking,
  F51 as SolidBanana,
  T51 as SolidBandage,
  A51 as SolidBangladeshiTakaSign,
  D51 as SolidBanjo,
  f51 as SolidBarcode,
  y51 as SolidBarcodeRead,
  b51 as SolidBarcodeScan,
  E51 as SolidBars,
  U51 as SolidBarsFilter,
  G51 as SolidBarsProgress,
  q51 as SolidBarsSort,
  W51 as SolidBarsStaggered,
  I51 as SolidBaseball,
  O51 as SolidBaseballBatBall,
  X51 as SolidBasketShopping,
  N51 as SolidBasketShoppingSimple,
  Q51 as SolidBasketball,
  K51 as SolidBasketballHoop,
  Z51 as SolidBat,
  J51 as SolidBath,
  j51 as SolidBatteryBolt,
  Y51 as SolidBatteryEmpty,
  _51 as SolidBatteryExclamation,
  h71 as SolidBatteryFull,
  c71 as SolidBatteryHalf,
  s71 as SolidBatteryLow,
  v71 as SolidBatteryQuarter,
  e71 as SolidBatterySlash,
  l71 as SolidBatteryThreeQuarters,
  m71 as SolidBed,
  t71 as SolidBedBunk,
  w71 as SolidBedEmpty,
  g71 as SolidBedFront,
  i71 as SolidBedPulse,
  a71 as SolidBee,
  n71 as SolidBeerMug,
  o71 as SolidBeerMugEmpty,
  H71 as SolidBell,
  r71 as SolidBellConcierge,
  d71 as SolidBellExclamation,
  S71 as SolidBellOn,
  z71 as SolidBellPlus,
  M71 as SolidBellSchool,
  p71 as SolidBellSchoolSlash,
  x71 as SolidBellSlash,
  V71 as SolidBells,
  C71 as SolidBenchTree,
  L71 as SolidBezierCurve,
  B71 as SolidBicycle,
  u71 as SolidBillboard,
  $71 as SolidBinBottles,
  R71 as SolidBinBottlesRecycle,
  k71 as SolidBinRecycle,
  A71 as SolidBinary,
  P71 as SolidBinaryCircleCheck,
  F71 as SolidBinaryLock,
  T71 as SolidBinarySlash,
  D71 as SolidBinoculars,
  y71 as SolidBiohazard,
  b71 as SolidBird,
  f71 as SolidBitcoinSign,
  G71 as SolidBlanket,
  U71 as SolidBlanketFire,
  W71 as SolidBlender,
  q71 as SolidBlenderPhone,
  I71 as SolidBlinds,
  E71 as SolidBlindsOpen,
  O71 as SolidBlindsRaised,
  Z71 as SolidBlock,
  X71 as SolidBlockBrick,
  N71 as SolidBlockBrickFire,
  K71 as SolidBlockQuestion,
  Q71 as SolidBlockQuote,
  J71 as SolidBlog,
  j71 as SolidBlueberries,
  Y71 as SolidBluetooth,
  _71 as SolidBold,
  v91 as SolidBolt,
  h91 as SolidBoltAuto,
  c91 as SolidBoltLightning,
  s91 as SolidBoltSlash,
  e91 as SolidBomb,
  t91 as SolidBone,
  l91 as SolidBoneBreak,
  w91 as SolidBong,
  P91 as SolidBook,
  g91 as SolidBookArrowRight,
  i91 as SolidBookArrowUp,
  m91 as SolidBookAtlas,
  a91 as SolidBookBible,
  o91 as SolidBookBlank,
  n91 as SolidBookBookmark,
  r91 as SolidBookCircleArrowRight,
  d91 as SolidBookCircleArrowUp,
  S91 as SolidBookCopy,
  z91 as SolidBookFont,
  p91 as SolidBookHeart,
  M91 as SolidBookJournalWhills,
  x91 as SolidBookMedical,
  C91 as SolidBookOpen,
  H91 as SolidBookOpenCover,
  V91 as SolidBookOpenReader,
  L91 as SolidBookQuran,
  B91 as SolidBookSection,
  u91 as SolidBookSkull,
  R91 as SolidBookSparkles,
  $91 as SolidBookTanakh,
  k91 as SolidBookUser,
  T91 as SolidBookmark,
  F91 as SolidBookmarkSlash,
  D91 as SolidBooks,
  A91 as SolidBooksMedical,
  y91 as SolidBoombox,
  f91 as SolidBoot,
  b91 as SolidBootHeeled,
  U91 as SolidBoothCurtain,
  G91 as SolidBorderAll,
  W91 as SolidBorderBottom,
  q91 as SolidBorderBottomRight,
  E91 as SolidBorderCenterH,
  O91 as SolidBorderCenterV,
  I91 as SolidBorderInner,
  N91 as SolidBorderLeft,
  X91 as SolidBorderNone,
  K91 as SolidBorderOuter,
  Q91 as SolidBorderRight,
  J91 as SolidBorderTop,
  Z91 as SolidBorderTopLeft,
  j91 as SolidBoreHole,
  Y91 as SolidBottleDroplet,
  _91 as SolidBottleWater,
  hh1 as SolidBowArrow,
  sh1 as SolidBowlChopsticks,
  ch1 as SolidBowlChopsticksNoodles,
  vh1 as SolidBowlFood,
  eh1 as SolidBowlHot,
  lh1 as SolidBowlRice,
  th1 as SolidBowlScoop,
  wh1 as SolidBowlScoops,
  gh1 as SolidBowlSoftServe,
  ih1 as SolidBowlSpoon,
  ah1 as SolidBowlingBall,
  mh1 as SolidBowlingBallPin,
  oh1 as SolidBowlingPins,
  Ch1 as SolidBox,
  nh1 as SolidBoxArchive,
  rh1 as SolidBoxBallot,
  dh1 as SolidBoxCheck,
  Sh1 as SolidBoxCircleCheck,
  zh1 as SolidBoxDollar,
  ph1 as SolidBoxHeart,
  xh1 as SolidBoxOpen,
  Mh1 as SolidBoxOpenFull,
  Hh1 as SolidBoxTaped,
  Vh1 as SolidBoxTissue,
  Lh1 as SolidBoxesPacking,
  Bh1 as SolidBoxesStacked,
  uh1 as SolidBoxingGlove,
  $h1 as SolidBracketCurly,
  Rh1 as SolidBracketCurlyRight,
  Ph1 as SolidBracketRound,
  kh1 as SolidBracketRoundRight,
  Th1 as SolidBracketSquare,
  Fh1 as SolidBracketSquareRight,
  Ah1 as SolidBracketsCurly,
  Dh1 as SolidBracketsRound,
  yh1 as SolidBracketsSquare,
  bh1 as SolidBraille,
  Gh1 as SolidBrain,
  fh1 as SolidBrainArrowCurvedRight,
  Uh1 as SolidBrainCircuit,
  qh1 as SolidBrakeWarning,
  Wh1 as SolidBrazilianRealSign,
  Eh1 as SolidBreadLoaf,
  Ih1 as SolidBreadSlice,
  Oh1 as SolidBreadSliceButter,
  jh1 as SolidBridge,
  Nh1 as SolidBridgeCircleCheck,
  Xh1 as SolidBridgeCircleExclamation,
  Kh1 as SolidBridgeCircleXmark,
  Qh1 as SolidBridgeLock,
  Zh1 as SolidBridgeSuspension,
  Jh1 as SolidBridgeWater,
  cc1 as SolidBriefcase,
  Yh1 as SolidBriefcaseArrowRight,
  _h1 as SolidBriefcaseBlank,
  hc1 as SolidBriefcaseMedical,
  vc1 as SolidBrightness,
  sc1 as SolidBrightnessLow,
  ec1 as SolidBringForward,
  lc1 as SolidBringFront,
  tc1 as SolidBroccoli,
  ic1 as SolidBroom,
  wc1 as SolidBroomBall,
  gc1 as SolidBroomWide,
  mc1 as SolidBrowser,
  ac1 as SolidBrowsers,
  oc1 as SolidBrush,
  nc1 as SolidBucket,
  dc1 as SolidBug,
  rc1 as SolidBugSlash,
  Sc1 as SolidBugs,
  kc1 as SolidBuilding,
  zc1 as SolidBuildingCircleArrowRight,
  pc1 as SolidBuildingCircleCheck,
  Mc1 as SolidBuildingCircleExclamation,
  xc1 as SolidBuildingCircleXmark,
  Hc1 as SolidBuildingColumns,
  Vc1 as SolidBuildingFlag,
  Cc1 as SolidBuildingLock,
  Lc1 as SolidBuildingNgo,
  Bc1 as SolidBuildingShield,
  uc1 as SolidBuildingUn,
  Rc1 as SolidBuildingUser,
  $c1 as SolidBuildingWheat,
  Pc1 as SolidBuildings,
  Fc1 as SolidBullhorn,
  Dc1 as SolidBullseye,
  Tc1 as SolidBullseyeArrow,
  Ac1 as SolidBullseyePointer,
  bc1 as SolidBuoy,
  yc1 as SolidBuoyMooring,
  Ec1 as SolidBurger,
  fc1 as SolidBurgerCheese,
  Uc1 as SolidBurgerFries,
  Gc1 as SolidBurgerGlass,
  qc1 as SolidBurgerLettuce,
  Wc1 as SolidBurgerSoda,
  Oc1 as SolidBurrito,
  Ic1 as SolidBurst,
  Kc1 as SolidBus,
  Nc1 as SolidBusSchool,
  Xc1 as SolidBusSimple,
  Qc1 as SolidBusinessTime,
  Zc1 as SolidButter,
  Jc1 as SolidC,
  jc1 as SolidCabin,
  Yc1 as SolidCabinetFiling,
  _c1 as SolidCableCar,
  hs1 as SolidCactus,
  cs1 as SolidCakeCandles,
  ss1 as SolidCakeSlice,
  es1 as SolidCalculator,
  vs1 as SolidCalculatorSimple,
  $s1 as SolidCalendar,
  ls1 as SolidCalendarArrowDown,
  ts1 as SolidCalendarArrowUp,
  ws1 as SolidCalendarCheck,
  gs1 as SolidCalendarCircleExclamation,
  is1 as SolidCalendarCircleMinus,
  ms1 as SolidCalendarCirclePlus,
  as1 as SolidCalendarCircleUser,
  os1 as SolidCalendarClock,
  ns1 as SolidCalendarDay,
  rs1 as SolidCalendarDays,
  ds1 as SolidCalendarExclamation,
  Ss1 as SolidCalendarHeart,
  zs1 as SolidCalendarImage,
  Ms1 as SolidCalendarLines,
  ps1 as SolidCalendarLinesPen,
  xs1 as SolidCalendarMinus,
  Hs1 as SolidCalendarPen,
  Vs1 as SolidCalendarPlus,
  Cs1 as SolidCalendarRange,
  Ls1 as SolidCalendarStar,
  Bs1 as SolidCalendarUsers,
  us1 as SolidCalendarWeek,
  Rs1 as SolidCalendarXmark,
  ks1 as SolidCalendars,
  Ps1 as SolidCamcorder,
  Ws1 as SolidCamera,
  Fs1 as SolidCameraCctv,
  Ts1 as SolidCameraMovie,
  As1 as SolidCameraPolaroid,
  Ds1 as SolidCameraRetro,
  ys1 as SolidCameraRotate,
  bs1 as SolidCameraSecurity,
  fs1 as SolidCameraSlash,
  Us1 as SolidCameraViewfinder,
  qs1 as SolidCameraWeb,
  Gs1 as SolidCameraWebSlash,
  Es1 as SolidCampfire,
  Os1 as SolidCampground,
  Is1 as SolidCanFood,
  Ns1 as SolidCandleHolder,
  Zs1 as SolidCandy,
  Xs1 as SolidCandyBar,
  Ks1 as SolidCandyCane,
  Qs1 as SolidCandyCorn,
  Js1 as SolidCannabis,
  js1 as SolidCapsules,
  dv1 as SolidCar,
  Ys1 as SolidCarBattery,
  _s1 as SolidCarBolt,
  hv1 as SolidCarBuilding,
  cv1 as SolidCarBump,
  sv1 as SolidCarBurst,
  vv1 as SolidCarBus,
  ev1 as SolidCarCircleBolt,
  lv1 as SolidCarGarage,
  tv1 as SolidCarMirrors,
  wv1 as SolidCarOn,
  gv1 as SolidCarRear,
  mv1 as SolidCarSide,
  iv1 as SolidCarSideBolt,
  av1 as SolidCarTilt,
  ov1 as SolidCarTunnel,
  nv1 as SolidCarWash,
  rv1 as SolidCarWrench,
  zv1 as SolidCaravan,
  Sv1 as SolidCaravanSimple,
  pv1 as SolidCardClub,
  Mv1 as SolidCardDiamond,
  xv1 as SolidCardHeart,
  Hv1 as SolidCardSpade,
  Cv1 as SolidCards,
  Vv1 as SolidCardsBlank,
  Lv1 as SolidCaretDown,
  Bv1 as SolidCaretLeft,
  uv1 as SolidCaretRight,
  Rv1 as SolidCaretUp,
  $v1 as SolidCarrot,
  kv1 as SolidCars,
  Pv1 as SolidCartArrowDown,
  Fv1 as SolidCartArrowUp,
  Tv1 as SolidCartCircleArrowDown,
  Av1 as SolidCartCircleArrowUp,
  Dv1 as SolidCartCircleCheck,
  yv1 as SolidCartCircleExclamation,
  bv1 as SolidCartCirclePlus,
  fv1 as SolidCartCircleXmark,
  Wv1 as SolidCartFlatbed,
  Uv1 as SolidCartFlatbedBoxes,
  Gv1 as SolidCartFlatbedEmpty,
  qv1 as SolidCartFlatbedSuitcase,
  Ev1 as SolidCartMinus,
  Ov1 as SolidCartPlus,
  Nv1 as SolidCartShopping,
  Iv1 as SolidCartShoppingFast,
  Xv1 as SolidCartXmark,
  Kv1 as SolidCashRegister,
  Qv1 as SolidCassetteBetamax,
  Zv1 as SolidCassetteTape,
  Jv1 as SolidCassetteVhs,
  jv1 as SolidCastle,
  _v1 as SolidCat,
  Yv1 as SolidCatSpace,
  he1 as SolidCauldron,
  ce1 as SolidCediSign,
  se1 as SolidCentSign,
  ve1 as SolidCertificate,
  le1 as SolidChair,
  ee1 as SolidChairOffice,
  we1 as SolidChalkboard,
  te1 as SolidChalkboardUser,
  ge1 as SolidChampagneGlass,
  ie1 as SolidChampagneGlasses,
  me1 as SolidChargingStation,
  ae1 as SolidChartArea,
  oe1 as SolidChartBar,
  ne1 as SolidChartBullet,
  re1 as SolidChartCandlestick,
  de1 as SolidChartColumn,
  Se1 as SolidChartGantt,
  xe1 as SolidChartLine,
  ze1 as SolidChartLineDown,
  Me1 as SolidChartLineUp,
  pe1 as SolidChartLineUpDown,
  Ce1 as SolidChartMixed,
  He1 as SolidChartMixedUpCircleCurrency,
  Ve1 as SolidChartMixedUpCircleDollar,
  Le1 as SolidChartNetwork,
  $e1 as SolidChartPie,
  Re1 as SolidChartPieSimple,
  Be1 as SolidChartPieSimpleCircleCurrency,
  ue1 as SolidChartPieSimpleCircleDollar,
  ke1 as SolidChartPyramid,
  Pe1 as SolidChartRadar,
  Ae1 as SolidChartScatter,
  Fe1 as SolidChartScatter3D,
  Te1 as SolidChartScatterBubble,
  ye1 as SolidChartSimple,
  De1 as SolidChartSimpleHorizontal,
  be1 as SolidChartTreeMap,
  fe1 as SolidChartUser,
  Ue1 as SolidChartWaterfall,
  We1 as SolidCheck,
  Ge1 as SolidCheckDouble,
  qe1 as SolidCheckToSlot,
  Oe1 as SolidCheese,
  Ee1 as SolidCheeseSwiss,
  Ie1 as SolidCherries,
  tl1 as SolidChess,
  Xe1 as SolidChessBishop,
  Ne1 as SolidChessBishopPiece,
  Ke1 as SolidChessBoard,
  Ze1 as SolidChessClock,
  Qe1 as SolidChessClockFlip,
  je1 as SolidChessKing,
  Je1 as SolidChessKingPiece,
  _e1 as SolidChessKnight,
  Ye1 as SolidChessKnightPiece,
  cl1 as SolidChessPawn,
  hl1 as SolidChessPawnPiece,
  vl1 as SolidChessQueen,
  sl1 as SolidChessQueenPiece,
  ll1 as SolidChessRook,
  el1 as SolidChessRookPiece,
  wl1 as SolidChestnut,
  gl1 as SolidChevronDown,
  il1 as SolidChevronLeft,
  ml1 as SolidChevronRight,
  al1 as SolidChevronUp,
  ol1 as SolidChevronsDown,
  nl1 as SolidChevronsLeft,
  rl1 as SolidChevronsRight,
  dl1 as SolidChevronsUp,
  Sl1 as SolidChfSign,
  xl1 as SolidChild,
  zl1 as SolidChildCombatant,
  pl1 as SolidChildDress,
  Ml1 as SolidChildReaching,
  Hl1 as SolidChildren,
  Vl1 as SolidChimney,
  Cl1 as SolidChopsticks,
  Ll1 as SolidChurch,
  Tw1 as SolidCircle,
  Bl1 as SolidCircle0,
  ul1 as SolidCircle1,
  Rl1 as SolidCircle2,
  $l1 as SolidCircle3,
  kl1 as SolidCircle4,
  Pl1 as SolidCircle5,
  Fl1 as SolidCircle6,
  Tl1 as SolidCircle7,
  Al1 as SolidCircle8,
  Dl1 as SolidCircle9,
  yl1 as SolidCircleA,
  bl1 as SolidCircleAmpersand,
  Gl1 as SolidCircleArrowDown,
  fl1 as SolidCircleArrowDownLeft,
  Ul1 as SolidCircleArrowDownRight,
  ql1 as SolidCircleArrowLeft,
  Wl1 as SolidCircleArrowRight,
  Il1 as SolidCircleArrowUp,
  El1 as SolidCircleArrowUpLeft,
  Ol1 as SolidCircleArrowUpRight,
  Nl1 as SolidCircleB,
  Xl1 as SolidCircleBolt,
  Kl1 as SolidCircleBookOpen,
  Ql1 as SolidCircleBookmark,
  Zl1 as SolidCircleC,
  Jl1 as SolidCircleCalendar,
  jl1 as SolidCircleCamera,
  Yl1 as SolidCircleCaretDown,
  _l1 as SolidCircleCaretLeft,
  ht1 as SolidCircleCaretRight,
  ct1 as SolidCircleCaretUp,
  st1 as SolidCircleCheck,
  vt1 as SolidCircleChevronDown,
  et1 as SolidCircleChevronLeft,
  lt1 as SolidCircleChevronRight,
  tt1 as SolidCircleChevronUp,
  wt1 as SolidCircleD,
  gt1 as SolidCircleDashed,
  it1 as SolidCircleDivide,
  at1 as SolidCircleDollar,
  mt1 as SolidCircleDollarToSlot,
  ot1 as SolidCircleDot,
  dt1 as SolidCircleDown,
  nt1 as SolidCircleDownLeft,
  rt1 as SolidCircleDownRight,
  St1 as SolidCircleE,
  pt1 as SolidCircleEllipsis,
  zt1 as SolidCircleEllipsisVertical,
  Mt1 as SolidCircleEnvelope,
  xt1 as SolidCircleEuro,
  Vt1 as SolidCircleExclamation,
  Ht1 as SolidCircleExclamationCheck,
  Ct1 as SolidCircleF,
  Lt1 as SolidCircleG,
  Bt1 as SolidCircleH,
  Rt1 as SolidCircleHalf,
  ut1 as SolidCircleHalfStroke,
  $t1 as SolidCircleHeart,
  kt1 as SolidCircleI,
  Pt1 as SolidCircleInfo,
  Ft1 as SolidCircleJ,
  Tt1 as SolidCircleK,
  At1 as SolidCircleL,
  Dt1 as SolidCircleLeft,
  yt1 as SolidCircleLocationArrow,
  bt1 as SolidCircleM,
  Ut1 as SolidCircleMicrophone,
  ft1 as SolidCircleMicrophoneLines,
  Gt1 as SolidCircleMinus,
  qt1 as SolidCircleN,
  Wt1 as SolidCircleNodes,
  Et1 as SolidCircleNotch,
  Ot1 as SolidCircleO,
  It1 as SolidCircleP,
  Nt1 as SolidCircleParking,
  Xt1 as SolidCirclePause,
  Zt1 as SolidCirclePhone,
  Kt1 as SolidCirclePhoneFlip,
  Qt1 as SolidCirclePhoneHangup,
  Jt1 as SolidCirclePlay,
  jt1 as SolidCirclePlus,
  Yt1 as SolidCircleQ,
  hw1 as SolidCircleQuarter,
  _t1 as SolidCircleQuarterStroke,
  cw1 as SolidCircleQuarters,
  sw1 as SolidCircleQuestion,
  vw1 as SolidCircleR,
  ew1 as SolidCircleRadiation,
  lw1 as SolidCircleRight,
  tw1 as SolidCircleS,
  ww1 as SolidCircleSmall,
  mw1 as SolidCircleSort,
  gw1 as SolidCircleSortDown,
  iw1 as SolidCircleSortUp,
  aw1 as SolidCircleStar,
  ow1 as SolidCircleSterling,
  nw1 as SolidCircleStop,
  rw1 as SolidCircleT,
  Sw1 as SolidCircleThreeQuarters,
  dw1 as SolidCircleThreeQuartersStroke,
  zw1 as SolidCircleTrash,
  pw1 as SolidCircleU,
  Hw1 as SolidCircleUp,
  Mw1 as SolidCircleUpLeft,
  xw1 as SolidCircleUpRight,
  Vw1 as SolidCircleUser,
  Cw1 as SolidCircleV,
  Lw1 as SolidCircleVideo,
  Bw1 as SolidCircleW,
  uw1 as SolidCircleWaveformLines,
  Rw1 as SolidCircleX,
  $w1 as SolidCircleXmark,
  kw1 as SolidCircleY,
  Pw1 as SolidCircleYen,
  Fw1 as SolidCircleZ,
  Aw1 as SolidCirclesOverlap,
  yw1 as SolidCitrus,
  Dw1 as SolidCitrusSlice,
  bw1 as SolidCity,
  Uw1 as SolidClapperboard,
  fw1 as SolidClapperboardPlay,
  Gw1 as SolidClarinet,
  qw1 as SolidClawMarks,
  Qw1 as SolidClipboard,
  Ww1 as SolidClipboardCheck,
  Ow1 as SolidClipboardList,
  Ew1 as SolidClipboardListCheck,
  Iw1 as SolidClipboardMedical,
  Nw1 as SolidClipboardPrescription,
  Xw1 as SolidClipboardQuestion,
  Kw1 as SolidClipboardUser,
  xg1 as SolidClock,
  Zw1 as SolidClockDesk,
  jw1 as SolidClockEight,
  Jw1 as SolidClockEightThirty,
  _w1 as SolidClockEleven,
  Yw1 as SolidClockElevenThirty,
  cg1 as SolidClockFive,
  hg1 as SolidClockFiveThirty,
  sg1 as SolidClockFourThirty,
  eg1 as SolidClockNine,
  vg1 as SolidClockNineThirty,
  tg1 as SolidClockOne,
  lg1 as SolidClockOneThirty,
  wg1 as SolidClockRotateLeft,
  ig1 as SolidClockSeven,
  gg1 as SolidClockSevenThirty,
  ag1 as SolidClockSix,
  mg1 as SolidClockSixThirty,
  ng1 as SolidClockTen,
  og1 as SolidClockTenThirty,
  dg1 as SolidClockThree,
  rg1 as SolidClockThreeThirty,
  zg1 as SolidClockTwelve,
  Sg1 as SolidClockTwelveThirty,
  Mg1 as SolidClockTwo,
  pg1 as SolidClockTwoThirty,
  Hg1 as SolidClone,
  Cg1 as SolidClosedCaptioning,
  Vg1 as SolidClosedCaptioningSlash,
  Lg1 as SolidClothesHanger,
  si1 as SolidCloud,
  Bg1 as SolidCloudArrowDown,
  ug1 as SolidCloudArrowUp,
  Rg1 as SolidCloudBinary,
  Pg1 as SolidCloudBolt,
  $g1 as SolidCloudBoltMoon,
  kg1 as SolidCloudBoltSun,
  Fg1 as SolidCloudCheck,
  Tg1 as SolidCloudDrizzle,
  Ag1 as SolidCloudExclamation,
  Dg1 as SolidCloudFog,
  bg1 as SolidCloudHail,
  yg1 as SolidCloudHailMixed,
  fg1 as SolidCloudMeatball,
  Ug1 as SolidCloudMinus,
  qg1 as SolidCloudMoon,
  Gg1 as SolidCloudMoonRain,
  Wg1 as SolidCloudMusic,
  Eg1 as SolidCloudPlus,
  Og1 as SolidCloudQuestion,
  Ig1 as SolidCloudRain,
  Ng1 as SolidCloudRainbow,
  Qg1 as SolidCloudShowers,
  Xg1 as SolidCloudShowersHeavy,
  Kg1 as SolidCloudShowersWater,
  Zg1 as SolidCloudSlash,
  Jg1 as SolidCloudSleet,
  jg1 as SolidCloudSnow,
  _g1 as SolidCloudSun,
  Yg1 as SolidCloudSunRain,
  hi1 as SolidCloudWord,
  ci1 as SolidCloudXmark,
  li1 as SolidClouds,
  vi1 as SolidCloudsMoon,
  ei1 as SolidCloudsSun,
  ti1 as SolidClover,
  wi1 as SolidClub,
  gi1 as SolidCoconut,
  pi1 as SolidCode,
  ii1 as SolidCodeBranch,
  mi1 as SolidCodeCommit,
  ai1 as SolidCodeCompare,
  oi1 as SolidCodeFork,
  ni1 as SolidCodeMerge,
  Si1 as SolidCodePullRequest,
  ri1 as SolidCodePullRequestClosed,
  di1 as SolidCodePullRequestDraft,
  zi1 as SolidCodeSimple,
  Mi1 as SolidCoffeeBean,
  xi1 as SolidCoffeeBeans,
  Hi1 as SolidCoffeePot,
  Ci1 as SolidCoffin,
  Vi1 as SolidCoffinCross,
  Ri1 as SolidCoin,
  Li1 as SolidCoinBlank,
  Bi1 as SolidCoinFront,
  ui1 as SolidCoinVertical,
  $i1 as SolidCoins,
  Pi1 as SolidColon,
  ki1 as SolidColonSign,
  Fi1 as SolidColumns3,
  Ti1 as SolidComet,
  Ai1 as SolidComma,
  Di1 as SolidCommand,
  wm1 as SolidComment,
  yi1 as SolidCommentArrowDown,
  fi1 as SolidCommentArrowUp,
  bi1 as SolidCommentArrowUpRight,
  Ui1 as SolidCommentCaptions,
  Gi1 as SolidCommentCheck,
  qi1 as SolidCommentCode,
  Wi1 as SolidCommentDollar,
  Ei1 as SolidCommentDots,
  Oi1 as SolidCommentExclamation,
  Ii1 as SolidCommentHeart,
  Ni1 as SolidCommentImage,
  Xi1 as SolidCommentLines,
  Ki1 as SolidCommentMedical,
  Zi1 as SolidCommentMiddle,
  Qi1 as SolidCommentMiddleTop,
  Ji1 as SolidCommentMinus,
  ji1 as SolidCommentMusic,
  Yi1 as SolidCommentPen,
  _i1 as SolidCommentPlus,
  hm1 as SolidCommentQuestion,
  cm1 as SolidCommentQuote,
  sm1 as SolidCommentSlash,
  vm1 as SolidCommentSmile,
  em1 as SolidCommentSms,
  lm1 as SolidCommentText,
  tm1 as SolidCommentXmark,
  am1 as SolidComments,
  gm1 as SolidCommentsDollar,
  mm1 as SolidCommentsQuestion,
  im1 as SolidCommentsQuestionCheck,
  om1 as SolidCompactDisc,
  dm1 as SolidCompass,
  nm1 as SolidCompassDrafting,
  rm1 as SolidCompassSlash,
  zm1 as SolidCompress,
  Sm1 as SolidCompressWide,
  Vm1 as SolidComputer,
  pm1 as SolidComputerClassic,
  xm1 as SolidComputerMouse,
  Mm1 as SolidComputerMouseScrollwheel,
  Hm1 as SolidComputerSpeaker,
  Cm1 as SolidContainerStorage,
  Rm1 as SolidConveyorBelt,
  Lm1 as SolidConveyorBeltArm,
  Bm1 as SolidConveyorBeltBoxes,
  um1 as SolidConveyorBeltEmpty,
  km1 as SolidCookie,
  $m1 as SolidCookieBite,
  Pm1 as SolidCopy,
  Fm1 as SolidCopyright,
  Tm1 as SolidCorn,
  Am1 as SolidCorner,
  Dm1 as SolidCouch,
  ym1 as SolidCow,
  fm1 as SolidCowbell,
  bm1 as SolidCowbellCirclePlus,
  Um1 as SolidCrab,
  Gm1 as SolidCrateApple,
  qm1 as SolidCrateEmpty,
  Om1 as SolidCreditCard,
  Wm1 as SolidCreditCardBlank,
  Em1 as SolidCreditCardFront,
  Im1 as SolidCricketBatBall,
  Nm1 as SolidCroissant,
  Km1 as SolidCrop,
  Xm1 as SolidCropSimple,
  Qm1 as SolidCross,
  Jm1 as SolidCrosshairs,
  Zm1 as SolidCrosshairsSimple,
  jm1 as SolidCrow,
  Ym1 as SolidCrown,
  _m1 as SolidCrutch,
  ha1 as SolidCrutches,
  ca1 as SolidCruzeiroSign,
  sa1 as SolidCrystalBall,
  va1 as SolidCube,
  la1 as SolidCubes,
  ea1 as SolidCubesStacked,
  ta1 as SolidCucumber,
  ga1 as SolidCupStraw,
  wa1 as SolidCupStrawSwoosh,
  ia1 as SolidCupTogo,
  ma1 as SolidCupcake,
  aa1 as SolidCurlingStone,
  oa1 as SolidCustard,
  na1 as SolidD,
  ra1 as SolidDagger,
  da1 as SolidDash,
  Sa1 as SolidDatabase,
  pa1 as SolidDeer,
  za1 as SolidDeerRudolph,
  Ma1 as SolidDeleteLeft,
  xa1 as SolidDeleteRight,
  Ha1 as SolidDemocrat,
  Ca1 as SolidDesktop,
  Va1 as SolidDesktopArrowDown,
  La1 as SolidDharmachakra,
  Ba1 as SolidDiagramCells,
  ua1 as SolidDiagramLeanCanvas,
  Ra1 as SolidDiagramNested,
  $a1 as SolidDiagramNext,
  ka1 as SolidDiagramPredecessor,
  Pa1 as SolidDiagramPrevious,
  Fa1 as SolidDiagramProject,
  Ta1 as SolidDiagramSankey,
  Aa1 as SolidDiagramSubtask,
  Da1 as SolidDiagramSuccessor,
  ya1 as SolidDiagramVenn,
  Oa1 as SolidDial,
  ba1 as SolidDialHigh,
  fa1 as SolidDialLow,
  Ua1 as SolidDialMax,
  qa1 as SolidDialMed,
  Ga1 as SolidDialMedLow,
  Wa1 as SolidDialMin,
  Ea1 as SolidDialOff,
  Qa1 as SolidDiamond,
  Ia1 as SolidDiamondExclamation,
  Xa1 as SolidDiamondHalf,
  Na1 as SolidDiamondHalfStroke,
  Ka1 as SolidDiamondTurnRight,
  wo1 as SolidDice,
  Za1 as SolidDiceD10,
  Ja1 as SolidDiceD12,
  ja1 as SolidDiceD20,
  Ya1 as SolidDiceD4,
  _a1 as SolidDiceD6,
  ho1 as SolidDiceD8,
  co1 as SolidDiceFive,
  so1 as SolidDiceFour,
  vo1 as SolidDiceOne,
  eo1 as SolidDiceSix,
  lo1 as SolidDiceThree,
  to1 as SolidDiceTwo,
  go1 as SolidDinosaur,
  io1 as SolidDiploma,
  mo1 as SolidDiscDrive,
  ao1 as SolidDisease,
  Mo1 as SolidDisplay,
  oo1 as SolidDisplayArrowDown,
  do1 as SolidDisplayChartUp,
  no1 as SolidDisplayChartUpCircleCurrency,
  ro1 as SolidDisplayChartUpCircleDollar,
  So1 as SolidDisplayCode,
  zo1 as SolidDisplayMedical,
  po1 as SolidDisplaySlash,
  xo1 as SolidDistributeSpacingHorizontal,
  Ho1 as SolidDistributeSpacingVertical,
  Vo1 as SolidDitto,
  Co1 as SolidDivide,
  Lo1 as SolidDna,
  Bo1 as SolidDoNotEnter,
  Ro1 as SolidDog,
  uo1 as SolidDogLeashed,
  $o1 as SolidDollarSign,
  Po1 as SolidDolly,
  ko1 as SolidDollyEmpty,
  Fo1 as SolidDolphin,
  To1 as SolidDongSign,
  Ao1 as SolidDonut,
  Do1 as SolidDoorClosed,
  yo1 as SolidDoorOpen,
  bo1 as SolidDove,
  Xo1 as SolidDown,
  fo1 as SolidDownFromDottedLine,
  Uo1 as SolidDownFromLine,
  qo1 as SolidDownLeft,
  Go1 as SolidDownLeftAndUpRightToCenter,
  Wo1 as SolidDownLong,
  Eo1 as SolidDownRight,
  Oo1 as SolidDownToBracket,
  Io1 as SolidDownToDottedLine,
  No1 as SolidDownToLine,
  Ko1 as SolidDownload,
  Qo1 as SolidDragon,
  Zo1 as SolidDrawCircle,
  Jo1 as SolidDrawPolygon,
  jo1 as SolidDrawSquare,
  Yo1 as SolidDreidel,
  hn1 as SolidDrone,
  _o1 as SolidDroneFront,
  en1 as SolidDroplet,
  cn1 as SolidDropletDegree,
  sn1 as SolidDropletPercent,
  vn1 as SolidDropletSlash,
  tn1 as SolidDrum,
  ln1 as SolidDrumSteelpan,
  gn1 as SolidDrumstick,
  wn1 as SolidDrumstickBite,
  mn1 as SolidDryer,
  in1 as SolidDryerHeat,
  an1 as SolidDuck,
  on1 as SolidDumbbell,
  rn1 as SolidDumpster,
  nn1 as SolidDumpsterFire,
  dn1 as SolidDungeon,
  Sn1 as SolidE,
  xn1 as SolidEar,
  zn1 as SolidEarDeaf,
  pn1 as SolidEarListen,
  Mn1 as SolidEarMuffs,
  Hn1 as SolidEarthAfrica,
  Vn1 as SolidEarthAmericas,
  Cn1 as SolidEarthAsia,
  Ln1 as SolidEarthEurope,
  Bn1 as SolidEarthOceania,
  un1 as SolidEclipse,
  $n1 as SolidEgg,
  Rn1 as SolidEggFried,
  kn1 as SolidEggplant,
  Pn1 as SolidEject,
  Fn1 as SolidElephant,
  Tn1 as SolidElevator,
  bn1 as SolidEllipsis,
  Dn1 as SolidEllipsisStroke,
  An1 as SolidEllipsisStrokeVertical,
  yn1 as SolidEllipsisVertical,
  fn1 as SolidEmptySet,
  Gn1 as SolidEngine,
  Un1 as SolidEngineWarning,
  Nn1 as SolidEnvelope,
  qn1 as SolidEnvelopeCircleCheck,
  Wn1 as SolidEnvelopeDot,
  In1 as SolidEnvelopeOpen,
  En1 as SolidEnvelopeOpenDollar,
  On1 as SolidEnvelopeOpenText,
  Kn1 as SolidEnvelopes,
  Xn1 as SolidEnvelopesBulk,
  Qn1 as SolidEquals,
  Zn1 as SolidEraser,
  Jn1 as SolidEscalator,
  jn1 as SolidEthernet,
  Yn1 as SolidEuroSign,
  _n1 as SolidExclamation,
  cr1 as SolidExpand,
  hr1 as SolidExpandWide,
  sr1 as SolidExplosion,
  ir1 as SolidEye,
  lr1 as SolidEyeDropper,
  vr1 as SolidEyeDropperFull,
  er1 as SolidEyeDropperHalf,
  tr1 as SolidEyeEvil,
  wr1 as SolidEyeLowVision,
  gr1 as SolidEyeSlash,
  mr1 as SolidEyes,
  ar1 as SolidF,
  nr1 as SolidFaceAngry,
  or1 as SolidFaceAngryHorns,
  rr1 as SolidFaceAnguished,
  dr1 as SolidFaceAnxiousSweat,
  Sr1 as SolidFaceAstonished,
  zr1 as SolidFaceAwesome,
  pr1 as SolidFaceBeamHandOverMouth,
  Mr1 as SolidFaceClouds,
  xr1 as SolidFaceConfounded,
  Hr1 as SolidFaceConfused,
  Vr1 as SolidFaceCowboyHat,
  Cr1 as SolidFaceDiagonalMouth,
  Lr1 as SolidFaceDisappointed,
  Br1 as SolidFaceDisguise,
  ur1 as SolidFaceDizzy,
  Rr1 as SolidFaceDotted,
  $r1 as SolidFaceDowncastSweat,
  kr1 as SolidFaceDrooling,
  Pr1 as SolidFaceExhaling,
  Fr1 as SolidFaceExplode,
  Tr1 as SolidFaceExpressionless,
  Ar1 as SolidFaceEyesXmarks,
  Dr1 as SolidFaceFearful,
  yr1 as SolidFaceFlushed,
  Ur1 as SolidFaceFrown,
  br1 as SolidFaceFrownOpen,
  fr1 as SolidFaceFrownSlight,
  Gr1 as SolidFaceGlasses,
  qr1 as SolidFaceGrimace,
  _r1 as SolidFaceGrin,
  Er1 as SolidFaceGrinBeam,
  Wr1 as SolidFaceGrinBeamSweat,
  Or1 as SolidFaceGrinHearts,
  Nr1 as SolidFaceGrinSquint,
  Ir1 as SolidFaceGrinSquintTears,
  Xr1 as SolidFaceGrinStars,
  Kr1 as SolidFaceGrinTears,
  Jr1 as SolidFaceGrinTongue,
  Qr1 as SolidFaceGrinTongueSquint,
  Zr1 as SolidFaceGrinTongueWink,
  jr1 as SolidFaceGrinWide,
  Yr1 as SolidFaceGrinWink,
  hd1 as SolidFaceHandOverMouth,
  cd1 as SolidFaceHandPeeking,
  sd1 as SolidFaceHandYawn,
  vd1 as SolidFaceHeadBandage,
  ed1 as SolidFaceHoldingBackTears,
  ld1 as SolidFaceHushed,
  td1 as SolidFaceIcicles,
  md1 as SolidFaceKiss,
  wd1 as SolidFaceKissBeam,
  gd1 as SolidFaceKissClosedEyes,
  id1 as SolidFaceKissWinkHeart,
  rd1 as SolidFaceLaugh,
  ad1 as SolidFaceLaughBeam,
  od1 as SolidFaceLaughSquint,
  nd1 as SolidFaceLaughWink,
  dd1 as SolidFaceLying,
  Sd1 as SolidFaceMask,
  pd1 as SolidFaceMeh,
  zd1 as SolidFaceMehBlank,
  Md1 as SolidFaceMelting,
  xd1 as SolidFaceMonocle,
  Hd1 as SolidFaceNauseated,
  Vd1 as SolidFaceNoseSteam,
  Cd1 as SolidFaceParty,
  Ld1 as SolidFacePensive,
  Bd1 as SolidFacePersevering,
  ud1 as SolidFacePleading,
  Rd1 as SolidFacePouting,
  $d1 as SolidFaceRaisedEyebrow,
  kd1 as SolidFaceRelieved,
  Pd1 as SolidFaceRollingEyes,
  Fd1 as SolidFaceSadCry,
  Td1 as SolidFaceSadSweat,
  Ad1 as SolidFaceSadTear,
  Dd1 as SolidFaceSaluting,
  yd1 as SolidFaceScream,
  bd1 as SolidFaceShush,
  fd1 as SolidFaceSleeping,
  Ud1 as SolidFaceSleepy,
  Zd1 as SolidFaceSmile,
  Gd1 as SolidFaceSmileBeam,
  qd1 as SolidFaceSmileHalo,
  Wd1 as SolidFaceSmileHearts,
  Ed1 as SolidFaceSmileHorns,
  Od1 as SolidFaceSmilePlus,
  Id1 as SolidFaceSmileRelaxed,
  Nd1 as SolidFaceSmileTear,
  Xd1 as SolidFaceSmileTongue,
  Kd1 as SolidFaceSmileUpsideDown,
  Qd1 as SolidFaceSmileWink,
  Jd1 as SolidFaceSmilingHands,
  jd1 as SolidFaceSmirking,
  Yd1 as SolidFaceSpiralEyes,
  _d1 as SolidFaceSunglasses,
  hS1 as SolidFaceSurprise,
  cS1 as SolidFaceSwear,
  sS1 as SolidFaceThermometer,
  vS1 as SolidFaceThinking,
  eS1 as SolidFaceTired,
  lS1 as SolidFaceTissue,
  tS1 as SolidFaceTongueMoney,
  wS1 as SolidFaceTongueSweat,
  gS1 as SolidFaceUnamused,
  iS1 as SolidFaceViewfinder,
  mS1 as SolidFaceVomit,
  aS1 as SolidFaceWeary,
  oS1 as SolidFaceWoozy,
  nS1 as SolidFaceWorried,
  rS1 as SolidFaceZany,
  dS1 as SolidFaceZipper,
  SS1 as SolidFalafel,
  MS1 as SolidFamily,
  zS1 as SolidFamilyDress,
  pS1 as SolidFamilyPants,
  HS1 as SolidFan,
  xS1 as SolidFanTable,
  VS1 as SolidFarm,
  LS1 as SolidFaucet,
  CS1 as SolidFaucetDrip,
  BS1 as SolidFax,
  RS1 as SolidFeather,
  uS1 as SolidFeatherPointed,
  $S1 as SolidFence,
  kS1 as SolidFerrisWheel,
  PS1 as SolidFerry,
  FS1 as SolidFieldHockeyStickBall,
  kz1 as SolidFile,
  TS1 as SolidFileArrowDown,
  AS1 as SolidFileArrowUp,
  DS1 as SolidFileAudio,
  yS1 as SolidFileBinary,
  bS1 as SolidFileCertificate,
  fS1 as SolidFileChartColumn,
  US1 as SolidFileChartPie,
  GS1 as SolidFileCheck,
  qS1 as SolidFileCircleCheck,
  WS1 as SolidFileCircleExclamation,
  ES1 as SolidFileCircleInfo,
  OS1 as SolidFileCircleMinus,
  IS1 as SolidFileCirclePlus,
  NS1 as SolidFileCircleQuestion,
  XS1 as SolidFileCircleXmark,
  KS1 as SolidFileCode,
  QS1 as SolidFileContract,
  ZS1 as SolidFileCsv,
  JS1 as SolidFileDashedLine,
  jS1 as SolidFileDoc,
  YS1 as SolidFileExcel,
  _S1 as SolidFileExclamation,
  hz1 as SolidFileExport,
  cz1 as SolidFileHeart,
  sz1 as SolidFileImage,
  vz1 as SolidFileImport,
  lz1 as SolidFileInvoice,
  ez1 as SolidFileInvoiceDollar,
  tz1 as SolidFileLines,
  wz1 as SolidFileLock,
  gz1 as SolidFileMagnifyingGlass,
  iz1 as SolidFileMedical,
  mz1 as SolidFileMinus,
  az1 as SolidFileMusic,
  oz1 as SolidFilePdf,
  nz1 as SolidFilePen,
  dz1 as SolidFilePlus,
  rz1 as SolidFilePlusMinus,
  Sz1 as SolidFilePowerpoint,
  zz1 as SolidFilePrescription,
  pz1 as SolidFileShield,
  Mz1 as SolidFileSignature,
  xz1 as SolidFileSlash,
  Hz1 as SolidFileSpreadsheet,
  Vz1 as SolidFileUser,
  Cz1 as SolidFileVideo,
  Lz1 as SolidFileWaveform,
  Bz1 as SolidFileWord,
  uz1 as SolidFileXmark,
  Rz1 as SolidFileZip,
  $z1 as SolidFileZipper,
  Fz1 as SolidFiles,
  Pz1 as SolidFilesMedical,
  Az1 as SolidFill,
  Tz1 as SolidFillDrip,
  fz1 as SolidFilm,
  Dz1 as SolidFilmCanister,
  yz1 as SolidFilmSimple,
  bz1 as SolidFilmSlash,
  Uz1 as SolidFilms,
  Oz1 as SolidFilter,
  Gz1 as SolidFilterCircleDollar,
  qz1 as SolidFilterCircleXmark,
  Wz1 as SolidFilterList,
  Ez1 as SolidFilterSlash,
  Iz1 as SolidFilters,
  Nz1 as SolidFingerprint,
  _z1 as SolidFire,
  Xz1 as SolidFireBurner,
  Kz1 as SolidFireExtinguisher,
  Jz1 as SolidFireFlame,
  Qz1 as SolidFireFlameCurved,
  Zz1 as SolidFireFlameSimple,
  jz1 as SolidFireHydrant,
  Yz1 as SolidFireSmoke,
  hp1 as SolidFireplace,
  ep1 as SolidFish,
  cp1 as SolidFishBones,
  sp1 as SolidFishCooked,
  vp1 as SolidFishFins,
  lp1 as SolidFishingRod,
  mp1 as SolidFlag,
  tp1 as SolidFlagCheckered,
  wp1 as SolidFlagPennant,
  gp1 as SolidFlagSwallowtail,
  ip1 as SolidFlagUsa,
  ap1 as SolidFlashlight,
  Sp1 as SolidFlask,
  op1 as SolidFlaskGear,
  np1 as SolidFlaskRoundPoison,
  rp1 as SolidFlaskRoundPotion,
  dp1 as SolidFlaskVial,
  pp1 as SolidFlatbread,
  zp1 as SolidFlatbreadStuffed,
  Vp1 as SolidFloppyDisk,
  Mp1 as SolidFloppyDiskCircleArrowRight,
  xp1 as SolidFloppyDiskCircleXmark,
  Hp1 as SolidFloppyDiskPen,
  Cp1 as SolidFloppyDisks,
  Lp1 as SolidFlorinSign,
  Rp1 as SolidFlower,
  Bp1 as SolidFlowerDaffodil,
  up1 as SolidFlowerTulip,
  $p1 as SolidFlute,
  kp1 as SolidFluxCapacitor,
  Pp1 as SolidFlyingDisc,
  Qp1 as SolidFolder,
  Fp1 as SolidFolderArrowDown,
  Tp1 as SolidFolderArrowUp,
  Ap1 as SolidFolderBookmark,
  Dp1 as SolidFolderClosed,
  yp1 as SolidFolderGear,
  bp1 as SolidFolderGrid,
  fp1 as SolidFolderHeart,
  Up1 as SolidFolderImage,
  Gp1 as SolidFolderMagnifyingGlass,
  qp1 as SolidFolderMedical,
  Wp1 as SolidFolderMinus,
  Ep1 as SolidFolderMusic,
  Op1 as SolidFolderOpen,
  Ip1 as SolidFolderPlus,
  Np1 as SolidFolderTree,
  Xp1 as SolidFolderUser,
  Kp1 as SolidFolderXmark,
  Zp1 as SolidFolders,
  Jp1 as SolidFonduePot,
  _p1 as SolidFont,
  jp1 as SolidFontAwesome,
  Yp1 as SolidFontCase,
  cM1 as SolidFootball,
  hM1 as SolidFootballHelmet,
  vM1 as SolidFork,
  sM1 as SolidForkKnife,
  eM1 as SolidForklift,
  lM1 as SolidFort,
  gM1 as SolidForward,
  tM1 as SolidForwardFast,
  wM1 as SolidForwardStep,
  iM1 as SolidFrame,
  mM1 as SolidFrancSign,
  aM1 as SolidFrenchFries,
  oM1 as SolidFrog,
  nM1 as SolidFunction,
  rM1 as SolidFutbol,
  dM1 as SolidG,
  SM1 as SolidGalaxy,
  zM1 as SolidGalleryThumbnails,
  MM1 as SolidGameBoard,
  pM1 as SolidGameBoardSimple,
  HM1 as SolidGameConsoleHandheld,
  xM1 as SolidGameConsoleHandheldCrank,
  CM1 as SolidGamepad,
  VM1 as SolidGamepadModern,
  uM1 as SolidGarage,
  LM1 as SolidGarageCar,
  BM1 as SolidGarageOpen,
  RM1 as SolidGarlic,
  kM1 as SolidGasPump,
  $M1 as SolidGasPumpSlash,
  EM1 as SolidGauge,
  PM1 as SolidGaugeCircleBolt,
  FM1 as SolidGaugeCircleMinus,
  TM1 as SolidGaugeCirclePlus,
  AM1 as SolidGaugeHigh,
  DM1 as SolidGaugeLow,
  yM1 as SolidGaugeMax,
  bM1 as SolidGaugeMin,
  WM1 as SolidGaugeSimple,
  fM1 as SolidGaugeSimpleHigh,
  UM1 as SolidGaugeSimpleLow,
  GM1 as SolidGaugeSimpleMax,
  qM1 as SolidGaugeSimpleMin,
  OM1 as SolidGavel,
  KM1 as SolidGear,
  IM1 as SolidGearCode,
  XM1 as SolidGearComplex,
  NM1 as SolidGearComplexCode,
  QM1 as SolidGears,
  ZM1 as SolidGem,
  JM1 as SolidGenderless,
  jM1 as SolidGhost,
  YM1 as SolidGif,
  hx1 as SolidGift,
  _M1 as SolidGiftCard,
  cx1 as SolidGifts,
  sx1 as SolidGingerbreadMan,
  gx1 as SolidGlass,
  vx1 as SolidGlassCitrus,
  ex1 as SolidGlassEmpty,
  lx1 as SolidGlassHalf,
  wx1 as SolidGlassWater,
  tx1 as SolidGlassWaterDroplet,
  mx1 as SolidGlasses,
  ix1 as SolidGlassesRound,
  rx1 as SolidGlobe,
  ax1 as SolidGlobePointer,
  ox1 as SolidGlobeSnow,
  nx1 as SolidGlobeStand,
  dx1 as SolidGoalNet,
  Sx1 as SolidGolfBallTee,
  zx1 as SolidGolfClub,
  px1 as SolidGolfFlagHole,
  Mx1 as SolidGopuram,
  xx1 as SolidGraduationCap,
  Hx1 as SolidGramophone,
  Vx1 as SolidGrapes,
  Lx1 as SolidGrate,
  Cx1 as SolidGrateDroplet,
  ux1 as SolidGreaterThan,
  Bx1 as SolidGreaterThanEqual,
  Ux1 as SolidGrid,
  $x1 as SolidGrid2,
  Rx1 as SolidGrid2Plus,
  kx1 as SolidGrid4,
  Px1 as SolidGrid5,
  Fx1 as SolidGridDividers,
  Tx1 as SolidGridHorizontal,
  fx1 as SolidGridRound,
  Dx1 as SolidGridRound2,
  Ax1 as SolidGridRound2Plus,
  yx1 as SolidGridRound4,
  bx1 as SolidGridRound5,
  Wx1 as SolidGrill,
  Gx1 as SolidGrillFire,
  qx1 as SolidGrillHot,
  Kx1 as SolidGrip,
  Ox1 as SolidGripDots,
  Ex1 as SolidGripDotsVertical,
  Nx1 as SolidGripLines,
  Ix1 as SolidGripLinesVertical,
  Xx1 as SolidGripVertical,
  Qx1 as SolidGroupArrowsRotate,
  Zx1 as SolidGuaraniSign,
  jx1 as SolidGuitar,
  Jx1 as SolidGuitarElectric,
  Yx1 as SolidGuitars,
  cH1 as SolidGun,
  _x1 as SolidGunSlash,
  hH1 as SolidGunSquirt,
  sH1 as SolidH,
  vH1 as SolidH1,
  eH1 as SolidH2,
  lH1 as SolidH3,
  tH1 as SolidH4,
  wH1 as SolidH5,
  gH1 as SolidH6,
  aH1 as SolidHammer,
  iH1 as SolidHammerCrash,
  mH1 as SolidHammerWar,
  oH1 as SolidHamsa,
  QH1 as SolidHand,
  nH1 as SolidHandBackFist,
  rH1 as SolidHandBackPointDown,
  dH1 as SolidHandBackPointLeft,
  SH1 as SolidHandBackPointRibbon,
  zH1 as SolidHandBackPointRight,
  pH1 as SolidHandBackPointUp,
  MH1 as SolidHandDots,
  xH1 as SolidHandFingersCrossed,
  HH1 as SolidHandFist,
  VH1 as SolidHandHeart,
  TH1 as SolidHandHolding,
  CH1 as SolidHandHoldingBox,
  LH1 as SolidHandHoldingDollar,
  BH1 as SolidHandHoldingDroplet,
  uH1 as SolidHandHoldingHand,
  RH1 as SolidHandHoldingHeart,
  $H1 as SolidHandHoldingMagic,
  kH1 as SolidHandHoldingMedical,
  PH1 as SolidHandHoldingSeedling,
  FH1 as SolidHandHoldingSkull,
  AH1 as SolidHandHorns,
  DH1 as SolidHandLizard,
  yH1 as SolidHandLove,
  bH1 as SolidHandMiddleFinger,
  fH1 as SolidHandPeace,
  UH1 as SolidHandPointDown,
  GH1 as SolidHandPointLeft,
  qH1 as SolidHandPointRibbon,
  WH1 as SolidHandPointRight,
  EH1 as SolidHandPointUp,
  OH1 as SolidHandPointer,
  IH1 as SolidHandScissors,
  NH1 as SolidHandSparkles,
  XH1 as SolidHandSpock,
  KH1 as SolidHandWave,
  ZH1 as SolidHandcuffs,
  wV1 as SolidHands,
  JH1 as SolidHandsAslInterpreting,
  jH1 as SolidHandsBound,
  YH1 as SolidHandsBubbles,
  _H1 as SolidHandsClapping,
  lV1 as SolidHandsHolding,
  hV1 as SolidHandsHoldingChild,
  cV1 as SolidHandsHoldingCircle,
  sV1 as SolidHandsHoldingDiamond,
  vV1 as SolidHandsHoldingDollar,
  eV1 as SolidHandsHoldingHeart,
  tV1 as SolidHandsPraying,
  oV1 as SolidHandshake,
  gV1 as SolidHandshakeAngle,
  mV1 as SolidHandshakeSimple,
  iV1 as SolidHandshakeSimpleSlash,
  aV1 as SolidHandshakeSlash,
  nV1 as SolidHanukiah,
  rV1 as SolidHardDrive,
  SV1 as SolidHashtag,
  dV1 as SolidHashtagLock,
  zV1 as SolidHatBeach,
  pV1 as SolidHatChef,
  xV1 as SolidHatCowboy,
  MV1 as SolidHatCowboySide,
  HV1 as SolidHatSanta,
  VV1 as SolidHatWinter,
  CV1 as SolidHatWitch,
  LV1 as SolidHatWizard,
  yV1 as SolidHeadSide,
  BV1 as SolidHeadSideBrain,
  RV1 as SolidHeadSideCough,
  uV1 as SolidHeadSideCoughSlash,
  $V1 as SolidHeadSideGear,
  kV1 as SolidHeadSideGoggles,
  PV1 as SolidHeadSideHeadphones,
  FV1 as SolidHeadSideHeart,
  TV1 as SolidHeadSideMask,
  AV1 as SolidHeadSideMedical,
  DV1 as SolidHeadSideVirus,
  bV1 as SolidHeading,
  UV1 as SolidHeadphones,
  fV1 as SolidHeadphonesSimple,
  GV1 as SolidHeadset,
  JV1 as SolidHeart,
  qV1 as SolidHeartCircleBolt,
  WV1 as SolidHeartCircleCheck,
  EV1 as SolidHeartCircleExclamation,
  OV1 as SolidHeartCircleMinus,
  IV1 as SolidHeartCirclePlus,
  NV1 as SolidHeartCircleXmark,
  XV1 as SolidHeartCrack,
  QV1 as SolidHeartHalf,
  KV1 as SolidHeartHalfStroke,
  ZV1 as SolidHeartPulse,
  jV1 as SolidHeat,
  _V1 as SolidHelicopter,
  YV1 as SolidHelicopterSymbol,
  hC1 as SolidHelmetBattle,
  cC1 as SolidHelmetSafety,
  sC1 as SolidHelmetUn,
  oC1 as SolidHexagon,
  vC1 as SolidHexagonCheck,
  eC1 as SolidHexagonDivide,
  lC1 as SolidHexagonExclamation,
  tC1 as SolidHexagonImage,
  wC1 as SolidHexagonMinus,
  gC1 as SolidHexagonPlus,
  mC1 as SolidHexagonVerticalNft,
  iC1 as SolidHexagonVerticalNftSlanted,
  aC1 as SolidHexagonXmark,
  nC1 as SolidHighDefinition,
  dC1 as SolidHighlighter,
  rC1 as SolidHighlighterLine,
  SC1 as SolidHillAvalanche,
  zC1 as SolidHillRockslide,
  pC1 as SolidHippo,
  MC1 as SolidHockeyMask,
  xC1 as SolidHockeyPuck,
  HC1 as SolidHockeyStickPuck,
  VC1 as SolidHockeySticks,
  CC1 as SolidHollyBerry,
  LC1 as SolidHoneyPot,
  BC1 as SolidHoodCloak,
  uC1 as SolidHorizontalRule,
  kC1 as SolidHorse,
  RC1 as SolidHorseHead,
  $C1 as SolidHorseSaddle,
  FC1 as SolidHose,
  PC1 as SolidHoseReel,
  AC1 as SolidHospital,
  TC1 as SolidHospitalUser,
  DC1 as SolidHospitals,
  yC1 as SolidHotTubPerson,
  bC1 as SolidHotdog,
  fC1 as SolidHotel,
  EC1 as SolidHourglass,
  UC1 as SolidHourglassClock,
  GC1 as SolidHourglassEnd,
  qC1 as SolidHourglassHalf,
  WC1 as SolidHourglassStart,
  BL1 as SolidHouse,
  OC1 as SolidHouseBlank,
  IC1 as SolidHouseBuilding,
  jC1 as SolidHouseChimney,
  NC1 as SolidHouseChimneyBlank,
  XC1 as SolidHouseChimneyCrack,
  KC1 as SolidHouseChimneyHeart,
  QC1 as SolidHouseChimneyMedical,
  ZC1 as SolidHouseChimneyUser,
  JC1 as SolidHouseChimneyWindow,
  YC1 as SolidHouseCircleCheck,
  _C1 as SolidHouseCircleExclamation,
  hL1 as SolidHouseCircleXmark,
  cL1 as SolidHouseCrack,
  sL1 as SolidHouseDay,
  vL1 as SolidHouseFire,
  eL1 as SolidHouseFlag,
  tL1 as SolidHouseFloodWater,
  lL1 as SolidHouseFloodWaterCircleArrowRight,
  wL1 as SolidHouseHeart,
  gL1 as SolidHouseLaptop,
  iL1 as SolidHouseLock,
  rL1 as SolidHouseMedical,
  mL1 as SolidHouseMedicalCircleCheck,
  aL1 as SolidHouseMedicalCircleExclamation,
  oL1 as SolidHouseMedicalCircleXmark,
  nL1 as SolidHouseMedicalFlag,
  dL1 as SolidHouseNight,
  SL1 as SolidHousePersonLeave,
  zL1 as SolidHousePersonReturn,
  pL1 as SolidHouseSignal,
  ML1 as SolidHouseTree,
  xL1 as SolidHouseTsunami,
  HL1 as SolidHouseTurret,
  VL1 as SolidHouseUser,
  CL1 as SolidHouseWater,
  LL1 as SolidHouseWindow,
  uL1 as SolidHryvniaSign,
  RL1 as SolidHundredPoints,
  $L1 as SolidHurricane,
  kL1 as SolidHyphen,
  FL1 as SolidI,
  PL1 as SolidICursor,
  TL1 as SolidIceCream,
  AL1 as SolidIceSkate,
  DL1 as SolidIcicles,
  yL1 as SolidIcons,
  bL1 as SolidIdBadge,
  UL1 as SolidIdCard,
  fL1 as SolidIdCardClip,
  GL1 as SolidIgloo,
  XL1 as SolidImage,
  qL1 as SolidImageLandscape,
  EL1 as SolidImagePolaroid,
  WL1 as SolidImagePolaroidUser,
  OL1 as SolidImagePortrait,
  IL1 as SolidImageSlash,
  NL1 as SolidImageUser,
  QL1 as SolidImages,
  KL1 as SolidImagesUser,
  YL1 as SolidInbox,
  ZL1 as SolidInboxFull,
  JL1 as SolidInboxIn,
  jL1 as SolidInboxOut,
  _L1 as SolidInboxes,
  hB1 as SolidIndent,
  cB1 as SolidIndianRupeeSign,
  vB1 as SolidIndustry,
  sB1 as SolidIndustryWindows,
  eB1 as SolidInfinity,
  lB1 as SolidInfo,
  tB1 as SolidInhaler,
  wB1 as SolidInputNumeric,
  gB1 as SolidInputPipe,
  iB1 as SolidInputText,
  mB1 as SolidIntegral,
  aB1 as SolidInterrobang,
  oB1 as SolidIntersection,
  nB1 as SolidIslandTropical,
  rB1 as SolidItalic,
  dB1 as SolidJ,
  SB1 as SolidJackOLantern,
  pB1 as SolidJar,
  zB1 as SolidJarWheat,
  MB1 as SolidJedi,
  HB1 as SolidJetFighter,
  xB1 as SolidJetFighterUp,
  VB1 as SolidJoint,
  CB1 as SolidJoystick,
  uB1 as SolidJug,
  LB1 as SolidJugBottle,
  BB1 as SolidJugDetergent,
  RB1 as SolidK,
  $B1 as SolidKaaba,
  kB1 as SolidKazoo,
  PB1 as SolidKerning,
  AB1 as SolidKey,
  TB1 as SolidKeySkeleton,
  FB1 as SolidKeySkeletonLeftRight,
  UB1 as SolidKeyboard,
  yB1 as SolidKeyboardBrightness,
  DB1 as SolidKeyboardBrightnessLow,
  bB1 as SolidKeyboardDown,
  fB1 as SolidKeyboardLeft,
  GB1 as SolidKeynote,
  qB1 as SolidKhanda,
  WB1 as SolidKidneys,
  EB1 as SolidKipSign,
  OB1 as SolidKitMedical,
  IB1 as SolidKitchenSet,
  NB1 as SolidKite,
  XB1 as SolidKiwiBird,
  KB1 as SolidKiwiFruit,
  ZB1 as SolidKnife,
  QB1 as SolidKnifeKitchen,
  JB1 as SolidL,
  YB1 as SolidLacrosseStick,
  jB1 as SolidLacrosseStickBall,
  _B1 as SolidLambda,
  vu1 as SolidLamp,
  hu1 as SolidLampDesk,
  cu1 as SolidLampFloor,
  su1 as SolidLampStreet,
  eu1 as SolidLandMineOn,
  wu1 as SolidLandmark,
  lu1 as SolidLandmarkDome,
  tu1 as SolidLandmarkFlag,
  gu1 as SolidLanguage,
  Su1 as SolidLaptop,
  iu1 as SolidLaptopArrowDown,
  mu1 as SolidLaptopBinary,
  au1 as SolidLaptopCode,
  ou1 as SolidLaptopFile,
  nu1 as SolidLaptopMedical,
  ru1 as SolidLaptopMobile,
  du1 as SolidLaptopSlash,
  zu1 as SolidLariSign,
  Mu1 as SolidLasso,
  pu1 as SolidLassoSparkles,
  xu1 as SolidLayerGroup,
  Hu1 as SolidLayerMinus,
  Vu1 as SolidLayerPlus,
  uu1 as SolidLeaf,
  Cu1 as SolidLeafHeart,
  Lu1 as SolidLeafMaple,
  Bu1 as SolidLeafOak,
  Ru1 as SolidLeafyGreen,
  Au1 as SolidLeft,
  $u1 as SolidLeftFromLine,
  Pu1 as SolidLeftLong,
  ku1 as SolidLeftLongToLine,
  Fu1 as SolidLeftRight,
  Tu1 as SolidLeftToLine,
  Du1 as SolidLemon,
  bu1 as SolidLessThan,
  yu1 as SolidLessThanEqual,
  fu1 as SolidLifeRing,
  Uu1 as SolidLightCeiling,
  qu1 as SolidLightEmergency,
  Gu1 as SolidLightEmergencyOn,
  Ou1 as SolidLightSwitch,
  Wu1 as SolidLightSwitchOff,
  Eu1 as SolidLightSwitchOn,
  Yu1 as SolidLightbulb,
  Nu1 as SolidLightbulbCfl,
  Iu1 as SolidLightbulbCflOn,
  Xu1 as SolidLightbulbDollar,
  Qu1 as SolidLightbulbExclamation,
  Ku1 as SolidLightbulbExclamationOn,
  Zu1 as SolidLightbulbGear,
  Ju1 as SolidLightbulbOn,
  ju1 as SolidLightbulbSlash,
  _u1 as SolidLighthouse,
  hR1 as SolidLightsHoliday,
  cR1 as SolidLineColumns,
  sR1 as SolidLineHeight,
  vR1 as SolidLinesLeaning,
  iR1 as SolidLink,
  lR1 as SolidLinkHorizontal,
  eR1 as SolidLinkHorizontalSlash,
  wR1 as SolidLinkSimple,
  tR1 as SolidLinkSimpleSlash,
  gR1 as SolidLinkSlash,
  mR1 as SolidLips,
  aR1 as SolidLiraSign,
  xR1 as SolidList,
  oR1 as SolidListCheck,
  nR1 as SolidListDropdown,
  rR1 as SolidListMusic,
  dR1 as SolidListOl,
  SR1 as SolidListRadio,
  zR1 as SolidListTimeline,
  pR1 as SolidListTree,
  MR1 as SolidListUl,
  HR1 as SolidLitecoinSign,
  VR1 as SolidLoader,
  CR1 as SolidLobster,
  LR1 as SolidLocationArrow,
  BR1 as SolidLocationCheck,
  RR1 as SolidLocationCrosshairs,
  uR1 as SolidLocationCrosshairsSlash,
  kR1 as SolidLocationDot,
  $R1 as SolidLocationDotSlash,
  PR1 as SolidLocationExclamation,
  FR1 as SolidLocationMinus,
  TR1 as SolidLocationPen,
  yR1 as SolidLocationPin,
  AR1 as SolidLocationPinLock,
  DR1 as SolidLocationPinSlash,
  bR1 as SolidLocationPlus,
  fR1 as SolidLocationQuestion,
  UR1 as SolidLocationSmile,
  GR1 as SolidLocationXmark,
  NR1 as SolidLock,
  qR1 as SolidLockA,
  WR1 as SolidLockHashtag,
  OR1 as SolidLockKeyhole,
  ER1 as SolidLockKeyholeOpen,
  IR1 as SolidLockOpen,
  XR1 as SolidLocust,
  KR1 as SolidLollipop,
  QR1 as SolidLoveseat,
  ZR1 as SolidLuchadorMask,
  jR1 as SolidLungs,
  JR1 as SolidLungsVirus,
  YR1 as SolidM,
  _R1 as SolidMace,
  h$1 as SolidMagnet,
  w$1 as SolidMagnifyingGlass,
  c$1 as SolidMagnifyingGlassArrowRight,
  s$1 as SolidMagnifyingGlassChart,
  v$1 as SolidMagnifyingGlassDollar,
  e$1 as SolidMagnifyingGlassLocation,
  l$1 as SolidMagnifyingGlassMinus,
  t$1 as SolidMagnifyingGlassPlus,
  i$1 as SolidMailbox,
  g$1 as SolidMailboxFlagUp,
  m$1 as SolidManatSign,
  a$1 as SolidMandolin,
  o$1 as SolidMango,
  n$1 as SolidManhole,
  z$1 as SolidMap,
  d$1 as SolidMapLocation,
  r$1 as SolidMapLocationDot,
  S$1 as SolidMapPin,
  p$1 as SolidMarker,
  B$1 as SolidMars,
  x$1 as SolidMarsAndVenus,
  M$1 as SolidMarsAndVenusBurst,
  H$1 as SolidMarsDouble,
  L$1 as SolidMarsStroke,
  V$1 as SolidMarsStrokeRight,
  C$1 as SolidMarsStrokeUp,
  $$1 as SolidMartiniGlass,
  u$1 as SolidMartiniGlassCitrus,
  R$1 as SolidMartiniGlassEmpty,
  T$1 as SolidMask,
  k$1 as SolidMaskFace,
  P$1 as SolidMaskSnorkel,
  F$1 as SolidMaskVentilator,
  A$1 as SolidMasksTheater,
  D$1 as SolidMattressPillow,
  y$1 as SolidMaximize,
  b$1 as SolidMeat,
  f$1 as SolidMedal,
  U$1 as SolidMegaphone,
  q$1 as SolidMelon,
  G$1 as SolidMelonSlice,
  I$1 as SolidMemo,
  W$1 as SolidMemoCircleCheck,
  E$1 as SolidMemoCircleInfo,
  O$1 as SolidMemoPad,
  N$1 as SolidMemory,
  X$1 as SolidMenorah,
  K$1 as SolidMercury,
  Q$1 as SolidMerge,
  Vk1 as SolidMessage,
  Z$1 as SolidMessageArrowDown,
  j$1 as SolidMessageArrowUp,
  J$1 as SolidMessageArrowUpRight,
  Y$1 as SolidMessageBot,
  _$1 as SolidMessageCaptions,
  hk1 as SolidMessageCheck,
  ck1 as SolidMessageCode,
  sk1 as SolidMessageDollar,
  vk1 as SolidMessageDots,
  ek1 as SolidMessageExclamation,
  lk1 as SolidMessageHeart,
  tk1 as SolidMessageImage,
  wk1 as SolidMessageLines,
  gk1 as SolidMessageMedical,
  mk1 as SolidMessageMiddle,
  ik1 as SolidMessageMiddleTop,
  ak1 as SolidMessageMinus,
  ok1 as SolidMessageMusic,
  nk1 as SolidMessagePen,
  rk1 as SolidMessagePlus,
  dk1 as SolidMessageQuestion,
  Sk1 as SolidMessageQuote,
  zk1 as SolidMessageSlash,
  pk1 as SolidMessageSmile,
  Mk1 as SolidMessageSms,
  xk1 as SolidMessageText,
  Hk1 as SolidMessageXmark,
  Bk1 as SolidMessages,
  Ck1 as SolidMessagesDollar,
  Lk1 as SolidMessagesQuestion,
  uk1 as SolidMeteor,
  Pk1 as SolidMeter,
  Rk1 as SolidMeterBolt,
  $k1 as SolidMeterDroplet,
  kk1 as SolidMeterFire,
  Tk1 as SolidMicrochip,
  Fk1 as SolidMicrochipAi,
  fk1 as SolidMicrophone,
  Dk1 as SolidMicrophoneLines,
  Ak1 as SolidMicrophoneLinesSlash,
  yk1 as SolidMicrophoneSlash,
  bk1 as SolidMicrophoneStand,
  Uk1 as SolidMicroscope,
  Gk1 as SolidMicrowave,
  qk1 as SolidMillSign,
  Wk1 as SolidMinimize,
  Ek1 as SolidMinus,
  Ok1 as SolidMistletoe,
  Ik1 as SolidMitten,
  Yk1 as SolidMobile,
  Nk1 as SolidMobileButton,
  Xk1 as SolidMobileNotch,
  Kk1 as SolidMobileRetro,
  Zk1 as SolidMobileScreen,
  Qk1 as SolidMobileScreenButton,
  jk1 as SolidMobileSignal,
  Jk1 as SolidMobileSignalOut,
  wP1 as SolidMoneyBill,
  hP1 as SolidMoneyBill1,
  _k1 as SolidMoneyBill1Wave,
  sP1 as SolidMoneyBillSimple,
  cP1 as SolidMoneyBillSimpleWave,
  vP1 as SolidMoneyBillTransfer,
  eP1 as SolidMoneyBillTrendUp,
  lP1 as SolidMoneyBillWave,
  tP1 as SolidMoneyBillWheat,
  iP1 as SolidMoneyBills,
  gP1 as SolidMoneyBillsSimple,
  nP1 as SolidMoneyCheck,
  aP1 as SolidMoneyCheckDollar,
  mP1 as SolidMoneyCheckDollarPen,
  oP1 as SolidMoneyCheckPen,
  rP1 as SolidMoneyFromBracket,
  dP1 as SolidMoneySimpleFromBracket,
  SP1 as SolidMonitorWaveform,
  zP1 as SolidMonkey,
  pP1 as SolidMonument,
  VP1 as SolidMoon,
  MP1 as SolidMoonCloud,
  xP1 as SolidMoonOverSun,
  HP1 as SolidMoonStars,
  CP1 as SolidMoped,
  LP1 as SolidMortarPestle,
  BP1 as SolidMosque,
  RP1 as SolidMosquito,
  uP1 as SolidMosquitoNet,
  $P1 as SolidMotorcycle,
  kP1 as SolidMound,
  TP1 as SolidMountain,
  PP1 as SolidMountainCity,
  FP1 as SolidMountainSun,
  AP1 as SolidMountains,
  DP1 as SolidMouseField,
  yP1 as SolidMp3Player,
  WP1 as SolidMug,
  bP1 as SolidMugHot,
  fP1 as SolidMugMarshmallows,
  UP1 as SolidMugSaucer,
  qP1 as SolidMugTea,
  GP1 as SolidMugTeaSaucer,
  EP1 as SolidMushroom,
  XP1 as SolidMusic,
  IP1 as SolidMusicNote,
  OP1 as SolidMusicNoteSlash,
  NP1 as SolidMusicSlash,
  KP1 as SolidMustache,
  QP1 as SolidN,
  ZP1 as SolidNairaSign,
  JP1 as SolidNarwhal,
  jP1 as SolidNestingDolls,
  YP1 as SolidNetworkWired,
  _P1 as SolidNeuter,
  hF1 as SolidNewspaper,
  gF1 as SolidNfc,
  cF1 as SolidNfcLock,
  sF1 as SolidNfcMagnifyingGlass,
  vF1 as SolidNfcPen,
  eF1 as SolidNfcSignal,
  lF1 as SolidNfcSlash,
  tF1 as SolidNfcSymbol,
  wF1 as SolidNfcTrash,
  iF1 as SolidNose,
  mF1 as SolidNotEqual,
  aF1 as SolidNotdef,
  rF1 as SolidNote,
  oF1 as SolidNoteMedical,
  nF1 as SolidNoteSticky,
  dF1 as SolidNotebook,
  zF1 as SolidNotes,
  SF1 as SolidNotesMedical,
  pF1 as SolidO,
  MF1 as SolidObjectExclude,
  xF1 as SolidObjectGroup,
  HF1 as SolidObjectIntersect,
  VF1 as SolidObjectSubtract,
  CF1 as SolidObjectUngroup,
  LF1 as SolidObjectUnion,
  BF1 as SolidObjectsAlignBottom,
  uF1 as SolidObjectsAlignCenterHorizontal,
  RF1 as SolidObjectsAlignCenterVertical,
  $F1 as SolidObjectsAlignLeft,
  kF1 as SolidObjectsAlignRight,
  PF1 as SolidObjectsAlignTop,
  FF1 as SolidObjectsColumn,
  UF1 as SolidOctagon,
  TF1 as SolidOctagonCheck,
  AF1 as SolidOctagonDivide,
  DF1 as SolidOctagonExclamation,
  yF1 as SolidOctagonMinus,
  bF1 as SolidOctagonPlus,
  fF1 as SolidOctagonXmark,
  qF1 as SolidOilCan,
  GF1 as SolidOilCanDrip,
  WF1 as SolidOilTemperature,
  EF1 as SolidOilWell,
  IF1 as SolidOlive,
  OF1 as SolidOliveBranch,
  NF1 as SolidOm,
  XF1 as SolidOmega,
  KF1 as SolidOnion,
  QF1 as SolidOption,
  ZF1 as SolidOrnament,
  JF1 as SolidOtter,
  jF1 as SolidOutdent,
  YF1 as SolidOutlet,
  _F1 as SolidOven,
  hT1 as SolidOverline,
  cT1 as SolidP,
  eT1 as SolidPage,
  sT1 as SolidPageCaretDown,
  vT1 as SolidPageCaretUp,
  lT1 as SolidPager,
  tT1 as SolidPaintRoller,
  iT1 as SolidPaintbrush,
  wT1 as SolidPaintbrushFine,
  gT1 as SolidPaintbrushPencil,
  mT1 as SolidPalette,
  nT1 as SolidPallet,
  aT1 as SolidPalletBox,
  oT1 as SolidPalletBoxes,
  rT1 as SolidPanFood,
  dT1 as SolidPanFrying,
  ST1 as SolidPancakes,
  zT1 as SolidPanelEws,
  pT1 as SolidPanelFire,
  MT1 as SolidPanorama,
  HT1 as SolidPaperPlane,
  xT1 as SolidPaperPlaneTop,
  CT1 as SolidPaperclip,
  VT1 as SolidPaperclipVertical,
  LT1 as SolidParachuteBox,
  uT1 as SolidParagraph,
  BT1 as SolidParagraphLeft,
  RT1 as SolidPartyBell,
  $T1 as SolidPartyHorn,
  kT1 as SolidPassport,
  PT1 as SolidPaste,
  FT1 as SolidPause,
  DT1 as SolidPaw,
  TT1 as SolidPawClaws,
  AT1 as SolidPawSimple,
  yT1 as SolidPeace,
  bT1 as SolidPeach,
  fT1 as SolidPeanut,
  UT1 as SolidPeanuts,
  GT1 as SolidPeapod,
  qT1 as SolidPear,
  WT1 as SolidPedestal,
  ET1 as SolidPegasus,
  vA1 as SolidPen,
  OT1 as SolidPenCircle,
  NT1 as SolidPenClip,
  IT1 as SolidPenClipSlash,
  KT1 as SolidPenFancy,
  XT1 as SolidPenFancySlash,
  QT1 as SolidPenField,
  ZT1 as SolidPenLine,
  jT1 as SolidPenNib,
  JT1 as SolidPenNibSlash,
  YT1 as SolidPenPaintbrush,
  _T1 as SolidPenRuler,
  hA1 as SolidPenSlash,
  cA1 as SolidPenSwirl,
  sA1 as SolidPenToSquare,
  tA1 as SolidPencil,
  eA1 as SolidPencilMechanical,
  lA1 as SolidPencilSlash,
  MA1 as SolidPeople,
  wA1 as SolidPeopleArrows,
  gA1 as SolidPeopleCarryBox,
  mA1 as SolidPeopleDress,
  iA1 as SolidPeopleDressSimple,
  aA1 as SolidPeopleGroup,
  oA1 as SolidPeopleLine,
  rA1 as SolidPeoplePants,
  nA1 as SolidPeoplePantsSimple,
  dA1 as SolidPeoplePulling,
  SA1 as SolidPeopleRobbery,
  zA1 as SolidPeopleRoof,
  pA1 as SolidPeopleSimple,
  HA1 as SolidPepper,
  xA1 as SolidPepperHot,
  VA1 as SolidPercent,
  CA1 as SolidPeriod,
  yD1 as SolidPerson,
  LA1 as SolidPersonArrowDownToLine,
  BA1 as SolidPersonArrowUpFromLine,
  RA1 as SolidPersonBiking,
  uA1 as SolidPersonBikingMountain,
  $A1 as SolidPersonBooth,
  kA1 as SolidPersonBreastfeeding,
  PA1 as SolidPersonBurst,
  FA1 as SolidPersonCane,
  TA1 as SolidPersonCarryBox,
  AA1 as SolidPersonChalkboard,
  DA1 as SolidPersonCircleCheck,
  yA1 as SolidPersonCircleExclamation,
  bA1 as SolidPersonCircleMinus,
  fA1 as SolidPersonCirclePlus,
  UA1 as SolidPersonCircleQuestion,
  GA1 as SolidPersonCircleXmark,
  qA1 as SolidPersonDigging,
  EA1 as SolidPersonDolly,
  WA1 as SolidPersonDollyEmpty,
  OA1 as SolidPersonDotsFromLine,
  KA1 as SolidPersonDress,
  IA1 as SolidPersonDressBurst,
  NA1 as SolidPersonDressFairy,
  XA1 as SolidPersonDressSimple,
  QA1 as SolidPersonDrowning,
  ZA1 as SolidPersonFairy,
  jA1 as SolidPersonFalling,
  JA1 as SolidPersonFallingBurst,
  YA1 as SolidPersonFromPortal,
  _A1 as SolidPersonHalfDress,
  hD1 as SolidPersonHarassing,
  cD1 as SolidPersonHiking,
  sD1 as SolidPersonMilitaryPointing,
  vD1 as SolidPersonMilitaryRifle,
  eD1 as SolidPersonMilitaryToPerson,
  lD1 as SolidPersonPinball,
  tD1 as SolidPersonPraying,
  wD1 as SolidPersonPregnant,
  gD1 as SolidPersonRays,
  iD1 as SolidPersonRifle,
  aD1 as SolidPersonRunning,
  mD1 as SolidPersonRunningFast,
  nD1 as SolidPersonSeat,
  oD1 as SolidPersonSeatReclined,
  rD1 as SolidPersonShelter,
  dD1 as SolidPersonSign,
  SD1 as SolidPersonSimple,
  zD1 as SolidPersonSkating,
  pD1 as SolidPersonSkiJumping,
  MD1 as SolidPersonSkiLift,
  HD1 as SolidPersonSkiing,
  xD1 as SolidPersonSkiingNordic,
  VD1 as SolidPersonSledding,
  CD1 as SolidPersonSnowboarding,
  LD1 as SolidPersonSnowmobiling,
  BD1 as SolidPersonSwimming,
  uD1 as SolidPersonThroughWindow,
  RD1 as SolidPersonToDoor,
  $D1 as SolidPersonToPortal,
  DD1 as SolidPersonWalking,
  kD1 as SolidPersonWalkingArrowLoopLeft,
  PD1 as SolidPersonWalkingArrowRight,
  FD1 as SolidPersonWalkingDashedLineArrowRight,
  TD1 as SolidPersonWalkingLuggage,
  AD1 as SolidPersonWalkingWithCane,
  bD1 as SolidPesetaSign,
  fD1 as SolidPesoSign,
  jD1 as SolidPhone,
  UD1 as SolidPhoneArrowDownLeft,
  GD1 as SolidPhoneArrowRight,
  qD1 as SolidPhoneArrowUpRight,
  WD1 as SolidPhoneFlip,
  ED1 as SolidPhoneHangup,
  OD1 as SolidPhoneIntercom,
  ID1 as SolidPhoneMissed,
  ND1 as SolidPhoneOffice,
  XD1 as SolidPhonePlus,
  KD1 as SolidPhoneRotary,
  QD1 as SolidPhoneSlash,
  ZD1 as SolidPhoneVolume,
  JD1 as SolidPhoneXmark,
  _D1 as SolidPhotoFilm,
  YD1 as SolidPhotoFilmMusic,
  hy1 as SolidPi,
  sy1 as SolidPiano,
  cy1 as SolidPianoKeyboard,
  vy1 as SolidPickaxe,
  ey1 as SolidPickleball,
  ly1 as SolidPie,
  ty1 as SolidPig,
  wy1 as SolidPiggyBank,
  gy1 as SolidPills,
  iy1 as SolidPinata,
  my1 as SolidPinball,
  ay1 as SolidPineapple,
  zy1 as SolidPipe,
  oy1 as SolidPipeCircleCheck,
  ny1 as SolidPipeCollar,
  ry1 as SolidPipeSection,
  dy1 as SolidPipeSmoking,
  Sy1 as SolidPipeValve,
  My1 as SolidPizza,
  py1 as SolidPizzaSlice,
  xy1 as SolidPlaceOfWorship,
  Ay1 as SolidPlane,
  Hy1 as SolidPlaneArrival,
  Vy1 as SolidPlaneCircleCheck,
  Cy1 as SolidPlaneCircleExclamation,
  Ly1 as SolidPlaneCircleXmark,
  By1 as SolidPlaneDeparture,
  uy1 as SolidPlaneEngines,
  Ry1 as SolidPlaneLock,
  $y1 as SolidPlaneProp,
  ky1 as SolidPlaneSlash,
  Py1 as SolidPlaneTail,
  Ty1 as SolidPlaneUp,
  Fy1 as SolidPlaneUpSlash,
  Dy1 as SolidPlanetMoon,
  yy1 as SolidPlanetRinged,
  by1 as SolidPlantWilt,
  fy1 as SolidPlateUtensils,
  Uy1 as SolidPlateWheat,
  qy1 as SolidPlay,
  Gy1 as SolidPlayPause,
  Ky1 as SolidPlug,
  Wy1 as SolidPlugCircleBolt,
  Ey1 as SolidPlugCircleCheck,
  Oy1 as SolidPlugCircleExclamation,
  Iy1 as SolidPlugCircleMinus,
  Ny1 as SolidPlugCirclePlus,
  Xy1 as SolidPlugCircleXmark,
  Jy1 as SolidPlus,
  Qy1 as SolidPlusLarge,
  Zy1 as SolidPlusMinus,
  jy1 as SolidPodcast,
  _y1 as SolidPodium,
  Yy1 as SolidPodiumStar,
  hb1 as SolidPoliceBox,
  cb1 as SolidPollPeople,
  sb1 as SolidPompebled,
  eb1 as SolidPoo,
  vb1 as SolidPooStorm,
  lb1 as SolidPool8Ball,
  tb1 as SolidPoop,
  wb1 as SolidPopcorn,
  gb1 as SolidPopsicle,
  ib1 as SolidPotFood,
  mb1 as SolidPotato,
  ab1 as SolidPowerOff,
  db1 as SolidPrescription,
  rb1 as SolidPrescriptionBottle,
  ob1 as SolidPrescriptionBottleMedical,
  nb1 as SolidPrescriptionBottlePill,
  Sb1 as SolidPresentationScreen,
  zb1 as SolidPretzel,
  xb1 as SolidPrint,
  pb1 as SolidPrintMagnifyingGlass,
  Mb1 as SolidPrintSlash,
  Hb1 as SolidProjector,
  Lb1 as SolidPump,
  Vb1 as SolidPumpMedical,
  Cb1 as SolidPumpSoap,
  Bb1 as SolidPumpkin,
  $b1 as SolidPuzzle,
  Rb1 as SolidPuzzlePiece,
  ub1 as SolidPuzzlePieceSimple,
  kb1 as SolidQ,
  Pb1 as SolidQrcode,
  Fb1 as SolidQuestion,
  Tb1 as SolidQuoteLeft,
  Ab1 as SolidQuoteRight,
  Db1 as SolidQuotes,
  yb1 as SolidR,
  fb1 as SolidRabbit,
  bb1 as SolidRabbitRunning,
  Ub1 as SolidRaccoon,
  Gb1 as SolidRacquet,
  qb1 as SolidRadar,
  Wb1 as SolidRadiation,
  Ob1 as SolidRadio,
  Eb1 as SolidRadioTuner,
  Ib1 as SolidRainbow,
  Nb1 as SolidRaindrops,
  Xb1 as SolidRam,
  Kb1 as SolidRampLoading,
  Qb1 as SolidRankingStar,
  Zb1 as SolidRaygun,
  Jb1 as SolidReceipt,
  jb1 as SolidRecordVinyl,
  af1 as SolidRectangle,
  Yb1 as SolidRectangleAd,
  _b1 as SolidRectangleBarcode,
  hf1 as SolidRectangleCode,
  vf1 as SolidRectangleHistory,
  cf1 as SolidRectangleHistoryCirclePlus,
  sf1 as SolidRectangleHistoryCircleUser,
  ef1 as SolidRectangleList,
  lf1 as SolidRectanglePro,
  tf1 as SolidRectangleTerminal,
  gf1 as SolidRectangleVertical,
  wf1 as SolidRectangleVerticalHistory,
  if1 as SolidRectangleWide,
  mf1 as SolidRectangleXmark,
  of1 as SolidRectanglesMixed,
  nf1 as SolidRecycle,
  rf1 as SolidReel,
  df1 as SolidRefrigerator,
  Sf1 as SolidRegistered,
  pf1 as SolidRepeat,
  zf1 as SolidRepeat1,
  Hf1 as SolidReply,
  Mf1 as SolidReplyAll,
  xf1 as SolidReplyClock,
  Vf1 as SolidRepublican,
  Lf1 as SolidRestroom,
  Cf1 as SolidRestroomSimple,
  Bf1 as SolidRetweet,
  uf1 as SolidRhombus,
  Rf1 as SolidRibbon,
  bf1 as SolidRight,
  $f1 as SolidRightFromBracket,
  kf1 as SolidRightFromLine,
  Ff1 as SolidRightLeft,
  Pf1 as SolidRightLeftLarge,
  Af1 as SolidRightLong,
  Tf1 as SolidRightLongToLine,
  Df1 as SolidRightToBracket,
  yf1 as SolidRightToLine,
  Uf1 as SolidRing,
  ff1 as SolidRingDiamond,
  Gf1 as SolidRingsWedding,
  Kf1 as SolidRoad,
  qf1 as SolidRoadBarrier,
  Wf1 as SolidRoadBridge,
  Ef1 as SolidRoadCircleCheck,
  Of1 as SolidRoadCircleExclamation,
  If1 as SolidRoadCircleXmark,
  Nf1 as SolidRoadLock,
  Xf1 as SolidRoadSpikes,
  Zf1 as SolidRobot,
  Qf1 as SolidRobotAstromech,
  jf1 as SolidRocket,
  Jf1 as SolidRocketLaunch,
  Yf1 as SolidRollerCoaster,
  sU1 as SolidRotate,
  _f1 as SolidRotateExclamation,
  hU1 as SolidRotateLeft,
  cU1 as SolidRotateRight,
  lU1 as SolidRoute,
  vU1 as SolidRouteHighway,
  eU1 as SolidRouteInterstate,
  tU1 as SolidRouter,
  wU1 as SolidRss,
  gU1 as SolidRubleSign,
  iU1 as SolidRug,
  mU1 as SolidRugbyBall,
  dU1 as SolidRuler,
  aU1 as SolidRulerCombined,
  oU1 as SolidRulerHorizontal,
  nU1 as SolidRulerTriangle,
  rU1 as SolidRulerVertical,
  SU1 as SolidRupeeSign,
  zU1 as SolidRupiahSign,
  pU1 as SolidRv,
  MU1 as SolidS,
  VU1 as SolidSack,
  xU1 as SolidSackDollar,
  HU1 as SolidSackXmark,
  CU1 as SolidSailboat,
  LU1 as SolidSalad,
  BU1 as SolidSaltShaker,
  uU1 as SolidSandwich,
  $U1 as SolidSatellite,
  RU1 as SolidSatelliteDish,
  kU1 as SolidSausage,
  FU1 as SolidSaxophone,
  PU1 as SolidSaxophoneFire,
  TU1 as SolidScaleBalanced,
  DU1 as SolidScaleUnbalanced,
  AU1 as SolidScaleUnbalancedFlip,
  bU1 as SolidScalpel,
  yU1 as SolidScalpelLineDashed,
  fU1 as SolidScannerGun,
  UU1 as SolidScannerImage,
  GU1 as SolidScannerKeyboard,
  qU1 as SolidScannerTouchscreen,
  WU1 as SolidScarecrow,
  EU1 as SolidScarf,
  QU1 as SolidSchool,
  OU1 as SolidSchoolCircleCheck,
  IU1 as SolidSchoolCircleExclamation,
  NU1 as SolidSchoolCircleXmark,
  XU1 as SolidSchoolFlag,
  KU1 as SolidSchoolLock,
  ZU1 as SolidScissors,
  JU1 as SolidScreenUsers,
  jU1 as SolidScreencast,
  _U1 as SolidScrewdriver,
  YU1 as SolidScrewdriverWrench,
  hG1 as SolidScribble,
  vG1 as SolidScroll,
  cG1 as SolidScrollOld,
  sG1 as SolidScrollTorah,
  eG1 as SolidScrubber,
  lG1 as SolidScythe,
  tG1 as SolidSdCard,
  wG1 as SolidSdCards,
  mG1 as SolidSeal,
  gG1 as SolidSealExclamation,
  iG1 as SolidSealQuestion,
  aG1 as SolidSeatAirline,
  oG1 as SolidSection,
  nG1 as SolidSeedling,
  rG1 as SolidSemicolon,
  dG1 as SolidSendBack,
  SG1 as SolidSendBackward,
  HG1 as SolidSensor,
  zG1 as SolidSensorCloud,
  pG1 as SolidSensorFire,
  MG1 as SolidSensorOn,
  xG1 as SolidSensorTriangleExclamation,
  VG1 as SolidServer,
  CG1 as SolidShapes,
  RG1 as SolidShare,
  LG1 as SolidShareAll,
  BG1 as SolidShareFromSquare,
  uG1 as SolidShareNodes,
  $G1 as SolidSheep,
  kG1 as SolidSheetPlastic,
  PG1 as SolidShekelSign,
  TG1 as SolidShelves,
  FG1 as SolidShelvesEmpty,
  KG1 as SolidShield,
  AG1 as SolidShieldCat,
  DG1 as SolidShieldCheck,
  yG1 as SolidShieldCross,
  bG1 as SolidShieldDog,
  fG1 as SolidShieldExclamation,
  UG1 as SolidShieldHalved,
  GG1 as SolidShieldHeart,
  qG1 as SolidShieldKeyhole,
  WG1 as SolidShieldMinus,
  EG1 as SolidShieldPlus,
  OG1 as SolidShieldQuartered,
  IG1 as SolidShieldSlash,
  NG1 as SolidShieldVirus,
  XG1 as SolidShieldXmark,
  QG1 as SolidShip,
  YG1 as SolidShirt,
  ZG1 as SolidShirtLongSleeve,
  JG1 as SolidShirtRunning,
  jG1 as SolidShirtTankTop,
  _G1 as SolidShishKebab,
  hq1 as SolidShoePrints,
  vq1 as SolidShop,
  cq1 as SolidShopLock,
  sq1 as SolidShopSlash,
  lq1 as SolidShovel,
  eq1 as SolidShovelSnow,
  wq1 as SolidShower,
  tq1 as SolidShowerDown,
  gq1 as SolidShredder,
  iq1 as SolidShrimp,
  mq1 as SolidShuffle,
  aq1 as SolidShutters,
  oq1 as SolidShuttleSpace,
  nq1 as SolidShuttlecock,
  rq1 as SolidSickle,
  Sq1 as SolidSidebar,
  dq1 as SolidSidebarFlip,
  zq1 as SolidSigma,
  pq1 as SolidSignHanging,
  Fq1 as SolidSignal,
  Cq1 as SolidSignalBars,
  Mq1 as SolidSignalBarsFair,
  xq1 as SolidSignalBarsGood,
  Hq1 as SolidSignalBarsSlash,
  Vq1 as SolidSignalBarsWeak,
  Lq1 as SolidSignalFair,
  Bq1 as SolidSignalGood,
  uq1 as SolidSignalSlash,
  $q1 as SolidSignalStream,
  Rq1 as SolidSignalStreamSlash,
  kq1 as SolidSignalStrong,
  Pq1 as SolidSignalWeak,
  Dq1 as SolidSignature,
  Tq1 as SolidSignatureLock,
  Aq1 as SolidSignatureSlash,
  yq1 as SolidSignsPost,
  bq1 as SolidSimCard,
  fq1 as SolidSimCards,
  Uq1 as SolidSink,
  qq1 as SolidSiren,
  Gq1 as SolidSirenOn,
  Wq1 as SolidSitemap,
  Oq1 as SolidSkeleton,
  Eq1 as SolidSkeletonRibs,
  Nq1 as SolidSkiBoot,
  Iq1 as SolidSkiBootSki,
  Qq1 as SolidSkull,
  Xq1 as SolidSkullCow,
  Kq1 as SolidSkullCrossbones,
  jq1 as SolidSlash,
  Zq1 as SolidSlashBack,
  Jq1 as SolidSlashForward,
  Yq1 as SolidSleigh,
  _q1 as SolidSlider,
  sW1 as SolidSliders,
  hW1 as SolidSlidersSimple,
  cW1 as SolidSlidersUp,
  vW1 as SolidSlotMachine,
  eW1 as SolidSmog,
  lW1 as SolidSmoke,
  tW1 as SolidSmoking,
  wW1 as SolidSnake,
  gW1 as SolidSnooze,
  iW1 as SolidSnowBlowing,
  aW1 as SolidSnowflake,
  mW1 as SolidSnowflakeDroplets,
  oW1 as SolidSnowflakes,
  rW1 as SolidSnowman,
  nW1 as SolidSnowmanHead,
  dW1 as SolidSnowplow,
  SW1 as SolidSoap,
  zW1 as SolidSocks,
  pW1 as SolidSoftServe,
  MW1 as SolidSolarPanel,
  xW1 as SolidSolarSystem,
  CW1 as SolidSort,
  HW1 as SolidSortDown,
  VW1 as SolidSortUp,
  LW1 as SolidSpa,
  uW1 as SolidSpaceStationMoon,
  BW1 as SolidSpaceStationMoonConstruction,
  RW1 as SolidSpade,
  $W1 as SolidSpaghettiMonsterFlying,
  kW1 as SolidSparkle,
  PW1 as SolidSparkles,
  FW1 as SolidSpeaker,
  TW1 as SolidSpeakers,
  AW1 as SolidSpellCheck,
  bW1 as SolidSpider,
  DW1 as SolidSpiderBlackWidow,
  yW1 as SolidSpiderWeb,
  UW1 as SolidSpinner,
  fW1 as SolidSpinnerThird,
  GW1 as SolidSplit,
  qW1 as SolidSplotch,
  WW1 as SolidSpoon,
  EW1 as SolidSportsball,
  IW1 as SolidSprayCan,
  OW1 as SolidSprayCanSparkles,
  XW1 as SolidSprinkler,
  NW1 as SolidSprinklerCeiling,
  KO1 as SolidSquare,
  KW1 as SolidSquare0,
  QW1 as SolidSquare1,
  ZW1 as SolidSquare2,
  JW1 as SolidSquare3,
  jW1 as SolidSquare4,
  YW1 as SolidSquare5,
  _W1 as SolidSquare6,
  hE1 as SolidSquare7,
  cE1 as SolidSquare8,
  sE1 as SolidSquare9,
  eE1 as SolidSquareA,
  vE1 as SolidSquareALock,
  lE1 as SolidSquareAmpersand,
  gE1 as SolidSquareArrowDown,
  tE1 as SolidSquareArrowDownLeft,
  wE1 as SolidSquareArrowDownRight,
  iE1 as SolidSquareArrowLeft,
  mE1 as SolidSquareArrowRight,
  nE1 as SolidSquareArrowUp,
  aE1 as SolidSquareArrowUpLeft,
  oE1 as SolidSquareArrowUpRight,
  rE1 as SolidSquareB,
  dE1 as SolidSquareBolt,
  SE1 as SolidSquareC,
  zE1 as SolidSquareCaretDown,
  pE1 as SolidSquareCaretLeft,
  ME1 as SolidSquareCaretRight,
  xE1 as SolidSquareCaretUp,
  HE1 as SolidSquareCheck,
  VE1 as SolidSquareChevronDown,
  CE1 as SolidSquareChevronLeft,
  LE1 as SolidSquareChevronRight,
  BE1 as SolidSquareChevronUp,
  uE1 as SolidSquareCode,
  RE1 as SolidSquareD,
  kE1 as SolidSquareDashed,
  $E1 as SolidSquareDashedCirclePlus,
  PE1 as SolidSquareDivide,
  FE1 as SolidSquareDollar,
  DE1 as SolidSquareDown,
  TE1 as SolidSquareDownLeft,
  AE1 as SolidSquareDownRight,
  yE1 as SolidSquareE,
  fE1 as SolidSquareEllipsis,
  bE1 as SolidSquareEllipsisVertical,
  UE1 as SolidSquareEnvelope,
  GE1 as SolidSquareExclamation,
  qE1 as SolidSquareF,
  WE1 as SolidSquareFragile,
  EE1 as SolidSquareFull,
  OE1 as SolidSquareG,
  IE1 as SolidSquareH,
  NE1 as SolidSquareHeart,
  XE1 as SolidSquareI,
  KE1 as SolidSquareInfo,
  QE1 as SolidSquareJ,
  ZE1 as SolidSquareK,
  JE1 as SolidSquareKanban,
  jE1 as SolidSquareL,
  YE1 as SolidSquareLeft,
  _E1 as SolidSquareList,
  hO1 as SolidSquareM,
  cO1 as SolidSquareMinus,
  sO1 as SolidSquareN,
  vO1 as SolidSquareNfi,
  eO1 as SolidSquareO,
  lO1 as SolidSquareP,
  wO1 as SolidSquareParking,
  tO1 as SolidSquareParkingSlash,
  gO1 as SolidSquarePen,
  iO1 as SolidSquarePersonConfined,
  oO1 as SolidSquarePhone,
  mO1 as SolidSquarePhoneFlip,
  aO1 as SolidSquarePhoneHangup,
  nO1 as SolidSquarePlus,
  rO1 as SolidSquarePollHorizontal,
  dO1 as SolidSquarePollVertical,
  SO1 as SolidSquareQ,
  zO1 as SolidSquareQuarters,
  pO1 as SolidSquareQuestion,
  MO1 as SolidSquareQuote,
  xO1 as SolidSquareR,
  HO1 as SolidSquareRight,
  VO1 as SolidSquareRing,
  LO1 as SolidSquareRoot,
  CO1 as SolidSquareRootVariable,
  BO1 as SolidSquareRss,
  uO1 as SolidSquareS,
  RO1 as SolidSquareShareNodes,
  kO1 as SolidSquareSliders,
  $O1 as SolidSquareSlidersVertical,
  PO1 as SolidSquareSmall,
  FO1 as SolidSquareStar,
  TO1 as SolidSquareT,
  AO1 as SolidSquareTerminal,
  DO1 as SolidSquareThisWayUp,
  yO1 as SolidSquareU,
  UO1 as SolidSquareUp,
  bO1 as SolidSquareUpLeft,
  fO1 as SolidSquareUpRight,
  GO1 as SolidSquareUser,
  qO1 as SolidSquareV,
  WO1 as SolidSquareVirus,
  EO1 as SolidSquareW,
  OO1 as SolidSquareX,
  IO1 as SolidSquareXmark,
  NO1 as SolidSquareY,
  XO1 as SolidSquareZ,
  QO1 as SolidSquid,
  ZO1 as SolidSquirrel,
  jO1 as SolidStaff,
  JO1 as SolidStaffSnake,
  YO1 as SolidStairs,
  _O1 as SolidStamp,
  hI1 as SolidStandardDefinition,
  cI1 as SolidStapler,
  nI1 as SolidStar,
  sI1 as SolidStarAndCrescent,
  vI1 as SolidStarChristmas,
  eI1 as SolidStarExclamation,
  tI1 as SolidStarHalf,
  lI1 as SolidStarHalfStroke,
  wI1 as SolidStarOfDavid,
  gI1 as SolidStarOfLife,
  aI1 as SolidStarSharp,
  mI1 as SolidStarSharpHalf,
  iI1 as SolidStarSharpHalfStroke,
  oI1 as SolidStarShooting,
  SI1 as SolidStarfighter,
  dI1 as SolidStarfighterTwinIonEngine,
  rI1 as SolidStarfighterTwinIonEngineAdvanced,
  zI1 as SolidStars,
  MI1 as SolidStarship,
  pI1 as SolidStarshipFreighter,
  xI1 as SolidSteak,
  HI1 as SolidSteeringWheel,
  VI1 as SolidSterlingSign,
  CI1 as SolidStethoscope,
  LI1 as SolidStocking,
  BI1 as SolidStomach,
  uI1 as SolidStop,
  $I1 as SolidStopwatch,
  RI1 as SolidStopwatch20,
  FI1 as SolidStore,
  kI1 as SolidStoreLock,
  PI1 as SolidStoreSlash,
  TI1 as SolidStrawberry,
  AI1 as SolidStreetView,
  DI1 as SolidStretcher,
  yI1 as SolidStrikethrough,
  bI1 as SolidStroopwafel,
  fI1 as SolidSubscript,
  GI1 as SolidSubtitles,
  UI1 as SolidSubtitlesSlash,
  EI1 as SolidSuitcase,
  qI1 as SolidSuitcaseMedical,
  WI1 as SolidSuitcaseRolling,
  QI1 as SolidSun,
  OI1 as SolidSunBright,
  II1 as SolidSunCloud,
  NI1 as SolidSunDust,
  XI1 as SolidSunHaze,
  KI1 as SolidSunPlantWilt,
  ZI1 as SolidSunglasses,
  JI1 as SolidSunrise,
  jI1 as SolidSunset,
  YI1 as SolidSuperscript,
  hN1 as SolidSushi,
  _I1 as SolidSushiRoll,
  k31 as SolidSvg0,
  P31 as SolidSvg00,
  F31 as SolidSvg1,
  T31 as SolidSvg2,
  A31 as SolidSvg3,
  D31 as SolidSvg360Degrees,
  y31 as SolidSvg4,
  b31 as SolidSvg5,
  f31 as SolidSvg6,
  U31 as SolidSvg7,
  G31 as SolidSvg8,
  q31 as SolidSvg9,
  sN1 as SolidSwap,
  cN1 as SolidSwapArrows,
  vN1 as SolidSwatchbook,
  tN1 as SolidSword,
  lN1 as SolidSwordLaser,
  eN1 as SolidSwordLaserAlt,
  gN1 as SolidSwords,
  wN1 as SolidSwordsLaser,
  iN1 as SolidSymbols,
  mN1 as SolidSynagogue,
  aN1 as SolidSyringe,
  oN1 as SolidT,
  CN1 as SolidTable,
  rN1 as SolidTableCells,
  nN1 as SolidTableCellsLarge,
  dN1 as SolidTableColumns,
  SN1 as SolidTableLayout,
  zN1 as SolidTableList,
  pN1 as SolidTablePicnic,
  MN1 as SolidTablePivot,
  xN1 as SolidTableRows,
  HN1 as SolidTableTennisPaddleBall,
  VN1 as SolidTableTree,
  $N1 as SolidTablet,
  LN1 as SolidTabletButton,
  BN1 as SolidTabletRugged,
  RN1 as SolidTabletScreen,
  uN1 as SolidTabletScreenButton,
  kN1 as SolidTablets,
  PN1 as SolidTachographDigital,
  FN1 as SolidTaco,
  TN1 as SolidTag,
  AN1 as SolidTags,
  UN1 as SolidTally,
  DN1 as SolidTally1,
  yN1 as SolidTally2,
  bN1 as SolidTally3,
  fN1 as SolidTally4,
  GN1 as SolidTamale,
  qN1 as SolidTankWater,
  WN1 as SolidTape,
  ON1 as SolidTarp,
  EN1 as SolidTarpDroplet,
  NN1 as SolidTaxi,
  IN1 as SolidTaxiBus,
  XN1 as SolidTeddyBear,
  QN1 as SolidTeeth,
  KN1 as SolidTeethOpen,
  ZN1 as SolidTelescope,
  JN1 as SolidTemperatureArrowDown,
  jN1 as SolidTemperatureArrowUp,
  YN1 as SolidTemperatureEmpty,
  _N1 as SolidTemperatureFull,
  hX1 as SolidTemperatureHalf,
  cX1 as SolidTemperatureHigh,
  sX1 as SolidTemperatureList,
  vX1 as SolidTemperatureLow,
  eX1 as SolidTemperatureQuarter,
  lX1 as SolidTemperatureSnow,
  tX1 as SolidTemperatureSun,
  wX1 as SolidTemperatureThreeQuarters,
  gX1 as SolidTengeSign,
  iX1 as SolidTennisBall,
  rX1 as SolidTent,
  mX1 as SolidTentArrowDownToLine,
  aX1 as SolidTentArrowLeftRight,
  oX1 as SolidTentArrowTurnLeft,
  nX1 as SolidTentArrowsDown,
  dX1 as SolidTents,
  SX1 as SolidTerminal,
  HX1 as SolidText,
  zX1 as SolidTextHeight,
  pX1 as SolidTextSize,
  MX1 as SolidTextSlash,
  xX1 as SolidTextWidth,
  VX1 as SolidThermometer,
  CX1 as SolidTheta,
  LX1 as SolidThoughtBubble,
  BX1 as SolidThumbsDown,
  uX1 as SolidThumbsUp,
  RX1 as SolidThumbtack,
  $X1 as SolidTick,
  FX1 as SolidTicket,
  kX1 as SolidTicketAirline,
  PX1 as SolidTicketSimple,
  TX1 as SolidTicketsAirline,
  AX1 as SolidTilde,
  yX1 as SolidTimeline,
  DX1 as SolidTimelineArrow,
  bX1 as SolidTimer,
  qX1 as SolidTire,
  fX1 as SolidTireFlat,
  UX1 as SolidTirePressureWarning,
  GX1 as SolidTireRugged,
  WX1 as SolidToggleLargeOff,
  EX1 as SolidToggleLargeOn,
  OX1 as SolidToggleOff,
  IX1 as SolidToggleOn,
  hK1 as SolidToilet,
  YX1 as SolidToiletPaper,
  XX1 as SolidToiletPaperBlank,
  NX1 as SolidToiletPaperBlankUnder,
  KX1 as SolidToiletPaperCheck,
  QX1 as SolidToiletPaperSlash,
  JX1 as SolidToiletPaperUnder,
  ZX1 as SolidToiletPaperUnderSlash,
  jX1 as SolidToiletPaperXmark,
  _X1 as SolidToiletPortable,
  cK1 as SolidToiletsPortable,
  sK1 as SolidTomato,
  eK1 as SolidTombstone,
  vK1 as SolidTombstoneBlank,
  lK1 as SolidToolbox,
  tK1 as SolidTooth,
  wK1 as SolidToothbrush,
  gK1 as SolidToriiGate,
  iK1 as SolidTornado,
  mK1 as SolidTowerBroadcast,
  aK1 as SolidTowerCell,
  oK1 as SolidTowerControl,
  nK1 as SolidTowerObservation,
  rK1 as SolidTractor,
  dK1 as SolidTrademark,
  SK1 as SolidTrafficCone,
  xK1 as SolidTrafficLight,
  zK1 as SolidTrafficLightGo,
  pK1 as SolidTrafficLightSlow,
  MK1 as SolidTrafficLightStop,
  HK1 as SolidTrailer,
  RK1 as SolidTrain,
  CK1 as SolidTrainSubway,
  VK1 as SolidTrainSubwayTunnel,
  LK1 as SolidTrainTrack,
  BK1 as SolidTrainTram,
  uK1 as SolidTrainTunnel,
  $K1 as SolidTransformerBolt,
  kK1 as SolidTransgender,
  UK1 as SolidTransporter,
  PK1 as SolidTransporter1,
  FK1 as SolidTransporter2,
  TK1 as SolidTransporter3,
  AK1 as SolidTransporter4,
  DK1 as SolidTransporter5,
  yK1 as SolidTransporter6,
  bK1 as SolidTransporter7,
  fK1 as SolidTransporterEmpty,
  sQ1 as SolidTrash,
  GK1 as SolidTrashArrowUp,
  QK1 as SolidTrashCan,
  qK1 as SolidTrashCanArrowUp,
  WK1 as SolidTrashCanCheck,
  EK1 as SolidTrashCanClock,
  OK1 as SolidTrashCanList,
  IK1 as SolidTrashCanPlus,
  NK1 as SolidTrashCanSlash,
  XK1 as SolidTrashCanUndo,
  KK1 as SolidTrashCanXmark,
  ZK1 as SolidTrashCheck,
  JK1 as SolidTrashClock,
  jK1 as SolidTrashList,
  YK1 as SolidTrashPlus,
  _K1 as SolidTrashSlash,
  hQ1 as SolidTrashUndo,
  cQ1 as SolidTrashXmark,
  vQ1 as SolidTreasureChest,
  mQ1 as SolidTree,
  eQ1 as SolidTreeChristmas,
  lQ1 as SolidTreeCity,
  tQ1 as SolidTreeDeciduous,
  wQ1 as SolidTreeDecorated,
  gQ1 as SolidTreeLarge,
  iQ1 as SolidTreePalm,
  aQ1 as SolidTrees,
  dQ1 as SolidTriangle,
  oQ1 as SolidTriangleExclamation,
  nQ1 as SolidTriangleInstrument,
  rQ1 as SolidTrianglePersonDigging,
  zQ1 as SolidTricycle,
  SQ1 as SolidTricycleAdult,
  pQ1 as SolidTrillium,
  xQ1 as SolidTrophy,
  MQ1 as SolidTrophyStar,
  VQ1 as SolidTrowel,
  HQ1 as SolidTrowelBricks,
  IQ1 as SolidTruck,
  CQ1 as SolidTruckArrowRight,
  LQ1 as SolidTruckBolt,
  BQ1 as SolidTruckClock,
  RQ1 as SolidTruckContainer,
  uQ1 as SolidTruckContainerEmpty,
  $Q1 as SolidTruckDroplet,
  kQ1 as SolidTruckFast,
  FQ1 as SolidTruckField,
  PQ1 as SolidTruckFieldUn,
  TQ1 as SolidTruckFlatbed,
  AQ1 as SolidTruckFront,
  DQ1 as SolidTruckMedical,
  yQ1 as SolidTruckMonster,
  bQ1 as SolidTruckMoving,
  fQ1 as SolidTruckPickup,
  UQ1 as SolidTruckPlane,
  GQ1 as SolidTruckPlow,
  EQ1 as SolidTruckRamp,
  qQ1 as SolidTruckRampBox,
  WQ1 as SolidTruckRampCouch,
  OQ1 as SolidTruckTow,
  NQ1 as SolidTrumpet,
  KQ1 as SolidTty,
  XQ1 as SolidTtyAnswer,
  QQ1 as SolidTugrikSign,
  ZQ1 as SolidTurkey,
  JQ1 as SolidTurkishLiraSign,
  _Q1 as SolidTurnDown,
  jQ1 as SolidTurnDownLeft,
  YQ1 as SolidTurnDownRight,
  hZ1 as SolidTurnUp,
  cZ1 as SolidTurntable,
  sZ1 as SolidTurtle,
  lZ1 as SolidTv,
  vZ1 as SolidTvMusic,
  eZ1 as SolidTvRetro,
  tZ1 as SolidTypewriter,
  wZ1 as SolidU,
  iZ1 as SolidUfo,
  gZ1 as SolidUfoBeam,
  oZ1 as SolidUmbrella,
  mZ1 as SolidUmbrellaBeach,
  aZ1 as SolidUmbrellaSimple,
  nZ1 as SolidUnderline,
  rZ1 as SolidUnicorn,
  dZ1 as SolidUniformMartialArts,
  SZ1 as SolidUnion,
  zZ1 as SolidUniversalAccess,
  MZ1 as SolidUnlock,
  pZ1 as SolidUnlockKeyhole,
  TZ1 as SolidUp,
  HZ1 as SolidUpDown,
  xZ1 as SolidUpDownLeftRight,
  VZ1 as SolidUpFromBracket,
  CZ1 as SolidUpFromDottedLine,
  LZ1 as SolidUpFromLine,
  BZ1 as SolidUpLeft,
  uZ1 as SolidUpLong,
  kZ1 as SolidUpRight,
  RZ1 as SolidUpRightAndDownLeftFromCenter,
  $Z1 as SolidUpRightFromSquare,
  PZ1 as SolidUpToDottedLine,
  FZ1 as SolidUpToLine,
  AZ1 as SolidUpload,
  DZ1 as SolidUsbDrive,
  fJ1 as SolidUser,
  yZ1 as SolidUserAlien,
  bZ1 as SolidUserAstronaut,
  fZ1 as SolidUserBountyHunter,
  UZ1 as SolidUserCheck,
  GZ1 as SolidUserChef,
  qZ1 as SolidUserClock,
  WZ1 as SolidUserCowboy,
  EZ1 as SolidUserCrown,
  XZ1 as SolidUserDoctor,
  IZ1 as SolidUserDoctorHair,
  OZ1 as SolidUserDoctorHairLong,
  NZ1 as SolidUserDoctorMessage,
  KZ1 as SolidUserGear,
  QZ1 as SolidUserGraduate,
  jZ1 as SolidUserGroup,
  ZZ1 as SolidUserGroupCrown,
  JZ1 as SolidUserGroupSimple,
  cJ1 as SolidUserHair,
  YZ1 as SolidUserHairBuns,
  _Z1 as SolidUserHairLong,
  hJ1 as SolidUserHairMullet,
  sJ1 as SolidUserHeadset,
  vJ1 as SolidUserHelmetSafety,
  eJ1 as SolidUserInjured,
  tJ1 as SolidUserLarge,
  lJ1 as SolidUserLargeSlash,
  wJ1 as SolidUserLock,
  gJ1 as SolidUserMagnifyingGlass,
  iJ1 as SolidUserMinus,
  mJ1 as SolidUserMusic,
  aJ1 as SolidUserNinja,
  rJ1 as SolidUserNurse,
  nJ1 as SolidUserNurseHair,
  oJ1 as SolidUserNurseHairLong,
  dJ1 as SolidUserPen,
  zJ1 as SolidUserPilot,
  SJ1 as SolidUserPilotTie,
  pJ1 as SolidUserPlus,
  xJ1 as SolidUserPolice,
  MJ1 as SolidUserPoliceTie,
  VJ1 as SolidUserRobot,
  HJ1 as SolidUserRobotXmarks,
  CJ1 as SolidUserSecret,
  LJ1 as SolidUserShakespeare,
  BJ1 as SolidUserShield,
  uJ1 as SolidUserSlash,
  RJ1 as SolidUserTag,
  PJ1 as SolidUserTie,
  kJ1 as SolidUserTieHair,
  $J1 as SolidUserTieHairLong,
  FJ1 as SolidUserUnlock,
  TJ1 as SolidUserVisor,
  yJ1 as SolidUserVneck,
  DJ1 as SolidUserVneckHair,
  AJ1 as SolidUserVneckHairLong,
  bJ1 as SolidUserXmark,
  XJ1 as SolidUsers,
  UJ1 as SolidUsersBetweenLines,
  GJ1 as SolidUsersGear,
  qJ1 as SolidUsersLine,
  WJ1 as SolidUsersMedical,
  EJ1 as SolidUsersRays,
  OJ1 as SolidUsersRectangle,
  IJ1 as SolidUsersSlash,
  NJ1 as SolidUsersViewfinder,
  QJ1 as SolidUtensils,
  KJ1 as SolidUtensilsSlash,
  JJ1 as SolidUtilityPole,
  ZJ1 as SolidUtilityPoleDouble,
  jJ1 as SolidV,
  _J1 as SolidVacuum,
  YJ1 as SolidVacuumRobot,
  hj1 as SolidValueAbsolute,
  cj1 as SolidVanShuttle,
  sj1 as SolidVault,
  vj1 as SolidVectorCircle,
  ej1 as SolidVectorPolygon,
  lj1 as SolidVectorSquare,
  tj1 as SolidVentDamper,
  ij1 as SolidVenus,
  wj1 as SolidVenusDouble,
  gj1 as SolidVenusMars,
  aj1 as SolidVest,
  mj1 as SolidVestPatches,
  rj1 as SolidVial,
  oj1 as SolidVialCircleCheck,
  nj1 as SolidVialVirus,
  dj1 as SolidVials,
  xj1 as SolidVideo,
  Sj1 as SolidVideoArrowDownLeft,
  zj1 as SolidVideoArrowUpRight,
  pj1 as SolidVideoPlus,
  Mj1 as SolidVideoSlash,
  Hj1 as SolidVihara,
  Vj1 as SolidViolin,
  uj1 as SolidVirus,
  Lj1 as SolidVirusCovid,
  Cj1 as SolidVirusCovidSlash,
  Bj1 as SolidVirusSlash,
  Rj1 as SolidViruses,
  $j1 as SolidVoicemail,
  kj1 as SolidVolcano,
  Pj1 as SolidVolleyball,
  bj1 as SolidVolume,
  Fj1 as SolidVolumeHigh,
  Tj1 as SolidVolumeLow,
  Aj1 as SolidVolumeOff,
  Dj1 as SolidVolumeSlash,
  yj1 as SolidVolumeXmark,
  fj1 as SolidVrCardboard,
  Uj1 as SolidW,
  Gj1 as SolidWaffle,
  qj1 as SolidWagonCovered,
  Wj1 as SolidWalker,
  Ej1 as SolidWalkieTalkie,
  Oj1 as SolidWallet,
  Kj1 as SolidWand,
  Nj1 as SolidWandMagic,
  Ij1 as SolidWandMagicSparkles,
  Xj1 as SolidWandSparkles,
  Zj1 as SolidWarehouse,
  Qj1 as SolidWarehouseFull,
  Jj1 as SolidWashingMachine,
  cY1 as SolidWatch,
  jj1 as SolidWatchApple,
  Yj1 as SolidWatchCalculator,
  _j1 as SolidWatchFitness,
  hY1 as SolidWatchSmart,
  lY1 as SolidWater,
  sY1 as SolidWaterArrowDown,
  vY1 as SolidWaterArrowUp,
  eY1 as SolidWaterLadder,
  tY1 as SolidWatermelonSlice,
  wY1 as SolidWavePulse,
  gY1 as SolidWaveSine,
  iY1 as SolidWaveSquare,
  mY1 as SolidWaveTriangle,
  oY1 as SolidWaveform,
  aY1 as SolidWaveformLines,
  nY1 as SolidWebhook,
  rY1 as SolidWeightHanging,
  dY1 as SolidWeightScale,
  SY1 as SolidWhale,
  HY1 as SolidWheat,
  MY1 as SolidWheatAwn,
  zY1 as SolidWheatAwnCircleExclamation,
  pY1 as SolidWheatAwnSlash,
  xY1 as SolidWheatSlash,
  CY1 as SolidWheelchair,
  VY1 as SolidWheelchairMove,
  BY1 as SolidWhiskeyGlass,
  LY1 as SolidWhiskeyGlassIce,
  uY1 as SolidWhistle,
  FY1 as SolidWifi,
  RY1 as SolidWifiExclamation,
  $Y1 as SolidWifiFair,
  kY1 as SolidWifiSlash,
  PY1 as SolidWifiWeak,
  DY1 as SolidWind,
  TY1 as SolidWindTurbine,
  AY1 as SolidWindWarning,
  WY1 as SolidWindow,
  yY1 as SolidWindowFlip,
  fY1 as SolidWindowFrame,
  bY1 as SolidWindowFrameOpen,
  UY1 as SolidWindowMaximize,
  GY1 as SolidWindowMinimize,
  qY1 as SolidWindowRestore,
  EY1 as SolidWindsock,
  OY1 as SolidWineBottle,
  XY1 as SolidWineGlass,
  IY1 as SolidWineGlassCrack,
  NY1 as SolidWineGlassEmpty,
  KY1 as SolidWonSign,
  QY1 as SolidWorm,
  JY1 as SolidWreath,
  ZY1 as SolidWreathLaurel,
  YY1 as SolidWrench,
  jY1 as SolidWrenchSimple,
  h_1 as SolidX,
  _Y1 as SolidXRay,
  v_1 as SolidXmark,
  c_1 as SolidXmarkLarge,
  s_1 as SolidXmarkToSlot,
  e_1 as SolidXmarksLines,
  l_1 as SolidY,
  t_1 as SolidYenSign,
  w_1 as SolidYinYang,
  g_1 as SolidZ
};
